/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type { paths } from "../schema";
import type { DeepReadonly, InvalidateQueryFilters, MutationFiltersByMutationKey, MutationFiltersByParameters, MutationVariables, OperationError, OperationInfiniteData, PartialParameters, QueryFiltersByParameters, QueryFiltersByQueryKey, QueryFnOptionsByParameters, QueryFnOptionsByQueryKey, RequestFnResponse, ServiceOperationEnsureInfiniteQueryDataOptions, ServiceOperationEnsureQueryDataOptions, ServiceOperationFetchInfiniteQueryOptions, ServiceOperationFetchQueryOptions, ServiceOperationInfiniteQueryKey, ServiceOperationMutationFnOptions, ServiceOperationMutationKey, ServiceOperationQueryKey, ServiceOperationUseMutationOptions, UseQueryOptionsForUseQueries, UseQueryOptionsForUseSuspenseQuery, WithOptional, QraftServiceOperationsToken } from "@openapi-qraft/tanstack-query-react-types";
import type { CancelOptions, DefinedInitialDataInfiniteOptions, DefinedInitialDataOptions, DefinedUseInfiniteQueryResult, DefinedUseQueryResult, InfiniteQueryPageParamsOptions, InvalidateOptions, Mutation, MutationCache, MutationState, NoInfer, QueryState, RefetchOptions, ResetOptions, SetDataOptions, UndefinedInitialDataInfiniteOptions, UndefinedInitialDataOptions, Updater, UseInfiniteQueryResult, UseMutationResult, UseQueryResult, UseSuspenseInfiniteQueryOptions, UseSuspenseInfiniteQueryResult, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
export interface V3Service {
    /** @summary Login */
    loginV3AuthLoginPost: {
        /** @summary Login */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostParameters, TMeta, TSignal>, client?: (schema: LoginV3AuthLoginPostSchema, options: ServiceOperationMutationFnOptions<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<LoginV3AuthLoginPostData, LoginV3AuthLoginPostError>>): Promise<RequestFnResponse<LoginV3AuthLoginPostData, LoginV3AuthLoginPostError>>;
        /** @summary Login */
        getMutationKey(parameters: DeepReadonly<LoginV3AuthLoginPostParameters> | void): ServiceOperationMutationKey<LoginV3AuthLoginPostSchema, LoginV3AuthLoginPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Login
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.loginV3AuthLoginPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.loginV3AuthLoginPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends LoginV3AuthLoginPostBody, TContext = unknown>(parameters: DeepReadonly<LoginV3AuthLoginPostParameters>, options?: ServiceOperationUseMutationOptions<LoginV3AuthLoginPostSchema, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, TVariables, OperationError<LoginV3AuthLoginPostError>, TContext>): UseMutationResult<LoginV3AuthLoginPostData, OperationError<LoginV3AuthLoginPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Login
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.loginV3AuthLoginPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.loginV3AuthLoginPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<LoginV3AuthLoginPostSchema, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, TVariables, OperationError<LoginV3AuthLoginPostError>, TContext>): UseMutationResult<LoginV3AuthLoginPostData, OperationError<LoginV3AuthLoginPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Login
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const loginV3AuthLoginPostTotal = qraft.v3Service.loginV3AuthLoginPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const loginV3AuthLoginPostTotal = qraft.v3Service.loginV3AuthLoginPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginV3AuthLoginPostSchema, LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Login
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const loginV3AuthLoginPostPendingMutationVariables = qraft.v3Service.loginV3AuthLoginPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const loginV3AuthLoginPostMutationData = qraft.v3Service.loginV3AuthLoginPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<LoginV3AuthLoginPostData, OperationError<LoginV3AuthLoginPostError>, MutationVariables<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginV3AuthLoginPostSchema, LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext>;
            select?: (mutation: Mutation<LoginV3AuthLoginPostData, OperationError<LoginV3AuthLoginPostError>, MutationVariables<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Login */
        isMutating<TContext>(filters?: MutationFiltersByParameters<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginV3AuthLoginPostSchema, LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Login
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.loginV3AuthLoginPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.loginV3AuthLoginPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginV3AuthLoginPostSchema, LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext>): Mutation<LoginV3AuthLoginPostData, LoginV3AuthLoginPostError, MutationVariables<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginV3AuthLoginPostSchema, LoginV3AuthLoginPostBody, LoginV3AuthLoginPostData, LoginV3AuthLoginPostParameters, OperationError<LoginV3AuthLoginPostError>, TContext>): Array<Mutation<LoginV3AuthLoginPostData, LoginV3AuthLoginPostError, MutationVariables<LoginV3AuthLoginPostBody, LoginV3AuthLoginPostParameters>, TContext>>;
        };
        schema: LoginV3AuthLoginPostSchema;
        types: {
            parameters: LoginV3AuthLoginPostParameters;
            data: LoginV3AuthLoginPostData;
            error: LoginV3AuthLoginPostError;
            body: LoginV3AuthLoginPostBody;
        };
    };
    /** @summary Register User */
    registerUserV3AuthRegisterPost: {
        /** @summary Register User */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostParameters, TMeta, TSignal>, client?: (schema: RegisterUserV3AuthRegisterPostSchema, options: ServiceOperationMutationFnOptions<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostError>>): Promise<RequestFnResponse<RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostError>>;
        /** @summary Register User */
        getMutationKey(parameters: DeepReadonly<RegisterUserV3AuthRegisterPostParameters> | void): ServiceOperationMutationKey<RegisterUserV3AuthRegisterPostSchema, RegisterUserV3AuthRegisterPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register User
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.registerUserV3AuthRegisterPost.useMutation({
         *     query: {
         *         connect_token: connectToken
         *     },
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.registerUserV3AuthRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     query: {
         *         connect_token: connectToken
         *     },
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RegisterUserV3AuthRegisterPostBody, TContext = unknown>(parameters: DeepReadonly<RegisterUserV3AuthRegisterPostParameters>, options?: ServiceOperationUseMutationOptions<RegisterUserV3AuthRegisterPostSchema, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, TVariables, OperationError<RegisterUserV3AuthRegisterPostError>, TContext>): UseMutationResult<RegisterUserV3AuthRegisterPostData, OperationError<RegisterUserV3AuthRegisterPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register User
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.registerUserV3AuthRegisterPost.useMutation({
         *     query: {
         *         connect_token: connectToken
         *     },
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.registerUserV3AuthRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     query: {
         *         connect_token: connectToken
         *     },
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RegisterUserV3AuthRegisterPostSchema, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, TVariables, OperationError<RegisterUserV3AuthRegisterPostError>, TContext>): UseMutationResult<RegisterUserV3AuthRegisterPostData, OperationError<RegisterUserV3AuthRegisterPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Register User
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const registerUserV3AuthRegisterPostTotal = qraft.v3Service.registerUserV3AuthRegisterPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const registerUserV3AuthRegisterPostTotal = qraft.v3Service.registerUserV3AuthRegisterPost.useIsMutating({
         *     parameters: {
         *         query: {
         *             connect_token: connectToken
         *         },
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserV3AuthRegisterPostSchema, RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Register User
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const registerUserV3AuthRegisterPostPendingMutationVariables = qraft.v3Service.registerUserV3AuthRegisterPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const registerUserV3AuthRegisterPostMutationData = qraft.v3Service.registerUserV3AuthRegisterPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             query: {
         *                 connect_token: connectToken
         *             },
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RegisterUserV3AuthRegisterPostData, OperationError<RegisterUserV3AuthRegisterPostError>, MutationVariables<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserV3AuthRegisterPostSchema, RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext>;
            select?: (mutation: Mutation<RegisterUserV3AuthRegisterPostData, OperationError<RegisterUserV3AuthRegisterPostError>, MutationVariables<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Register User */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserV3AuthRegisterPostSchema, RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Register User
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.registerUserV3AuthRegisterPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         query: {
         *             connect_token: connectToken
         *         },
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.registerUserV3AuthRegisterPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserV3AuthRegisterPostSchema, RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext>): Mutation<RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostError, MutationVariables<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserV3AuthRegisterPostSchema, RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostParameters, OperationError<RegisterUserV3AuthRegisterPostError>, TContext>): Array<Mutation<RegisterUserV3AuthRegisterPostData, RegisterUserV3AuthRegisterPostError, MutationVariables<RegisterUserV3AuthRegisterPostBody, RegisterUserV3AuthRegisterPostParameters>, TContext>>;
        };
        schema: RegisterUserV3AuthRegisterPostSchema;
        types: {
            parameters: RegisterUserV3AuthRegisterPostParameters;
            data: RegisterUserV3AuthRegisterPostData;
            error: RegisterUserV3AuthRegisterPostError;
            body: RegisterUserV3AuthRegisterPostBody;
        };
    };
    /**
     * @summary Request Password Reset
     * @description Email a password-reset link to `email`.
     *
     * A missing account is answered with `email_not_found`, which reveals whether an
     * account exists. The fullapp endpoint already does the same; revisit both together.
     * There is no rate limit.
     *
     * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
     */
    requestPasswordReset: {
        /**
         * @summary Request Password Reset
         * @description Email a password-reset link to `email`.
         *
         * A missing account is answered with `email_not_found`, which reveals whether an
         * account exists. The fullapp endpoint already does the same; revisit both together.
         * There is no rate limit.
         *
         * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RequestPasswordResetBody, RequestPasswordResetParameters, TMeta, TSignal>, client?: (schema: RequestPasswordResetSchema, options: ServiceOperationMutationFnOptions<RequestPasswordResetBody, RequestPasswordResetParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RequestPasswordResetData, RequestPasswordResetError>>): Promise<RequestFnResponse<RequestPasswordResetData, RequestPasswordResetError>>;
        /**
         * @summary Request Password Reset
         * @description Email a password-reset link to `email`.
         *
         * A missing account is answered with `email_not_found`, which reveals whether an
         * account exists. The fullapp endpoint already does the same; revisit both together.
         * There is no rate limit.
         *
         * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
         */
        getMutationKey(parameters: DeepReadonly<RequestPasswordResetParameters> | void): ServiceOperationMutationKey<RequestPasswordResetSchema, RequestPasswordResetParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Request Password Reset
         * @description Email a password-reset link to `email`.
         *
         * A missing account is answered with `email_not_found`, which reveals whether an
         * account exists. The fullapp endpoint already does the same; revisit both together.
         * There is no rate limit.
         *
         * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.requestPasswordReset.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.requestPasswordReset.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RequestPasswordResetBody, TContext = unknown>(parameters: DeepReadonly<RequestPasswordResetParameters>, options?: ServiceOperationUseMutationOptions<RequestPasswordResetSchema, RequestPasswordResetData, RequestPasswordResetParameters, TVariables, OperationError<RequestPasswordResetError>, TContext>): UseMutationResult<RequestPasswordResetData, OperationError<RequestPasswordResetError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Request Password Reset
         * @description Email a password-reset link to `email`.
         *
         * A missing account is answered with `email_not_found`, which reveals whether an
         * account exists. The fullapp endpoint already does the same; revisit both together.
         * There is no rate limit.
         *
         * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.requestPasswordReset.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.requestPasswordReset.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RequestPasswordResetBody, RequestPasswordResetParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RequestPasswordResetSchema, RequestPasswordResetData, RequestPasswordResetParameters, TVariables, OperationError<RequestPasswordResetError>, TContext>): UseMutationResult<RequestPasswordResetData, OperationError<RequestPasswordResetError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Request Password Reset
         * @description Email a password-reset link to `email`.
         *
         * A missing account is answered with `email_not_found`, which reveals whether an
         * account exists. The fullapp endpoint already does the same; revisit both together.
         * There is no rate limit.
         *
         * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const requestPasswordResetTotal = qraft.v3Service.requestPasswordReset.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const requestPasswordResetTotal = qraft.v3Service.requestPasswordReset.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext> | MutationFiltersByMutationKey<RequestPasswordResetSchema, RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Request Password Reset
         * @description Email a password-reset link to `email`.
         *
         * A missing account is answered with `email_not_found`, which reveals whether an
         * account exists. The fullapp endpoint already does the same; revisit both together.
         * There is no rate limit.
         *
         * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const requestPasswordResetPendingMutationVariables = qraft.v3Service.requestPasswordReset.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const requestPasswordResetMutationData = qraft.v3Service.requestPasswordReset.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RequestPasswordResetData, OperationError<RequestPasswordResetError>, MutationVariables<RequestPasswordResetBody, RequestPasswordResetParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext> | MutationFiltersByMutationKey<RequestPasswordResetSchema, RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext>;
            select?: (mutation: Mutation<RequestPasswordResetData, OperationError<RequestPasswordResetError>, MutationVariables<RequestPasswordResetBody, RequestPasswordResetParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Request Password Reset
         * @description Email a password-reset link to `email`.
         *
         * A missing account is answered with `email_not_found`, which reveals whether an
         * account exists. The fullapp endpoint already does the same; revisit both together.
         * There is no rate limit.
         *
         * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext> | MutationFiltersByMutationKey<RequestPasswordResetSchema, RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Request Password Reset
         * @description Email a password-reset link to `email`.
         *
         * A missing account is answered with `email_not_found`, which reveals whether an
         * account exists. The fullapp endpoint already does the same; revisit both together.
         * There is no rate limit.
         *
         * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.requestPasswordReset.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.requestPasswordReset.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext> | MutationFiltersByMutationKey<RequestPasswordResetSchema, RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext>): Mutation<RequestPasswordResetData, RequestPasswordResetError, MutationVariables<RequestPasswordResetBody, RequestPasswordResetParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext> | MutationFiltersByMutationKey<RequestPasswordResetSchema, RequestPasswordResetBody, RequestPasswordResetData, RequestPasswordResetParameters, OperationError<RequestPasswordResetError>, TContext>): Array<Mutation<RequestPasswordResetData, RequestPasswordResetError, MutationVariables<RequestPasswordResetBody, RequestPasswordResetParameters>, TContext>>;
        };
        schema: RequestPasswordResetSchema;
        types: {
            parameters: RequestPasswordResetParameters;
            data: RequestPasswordResetData;
            error: RequestPasswordResetError;
            body: RequestPasswordResetBody;
        };
    };
    /**
     * @summary Check Password Reset Key
     * @description Whether a reset link is still good, before asking for a new password.
     *
     * POST rather than GET so the key stays out of access logs and referrers.
     *
     * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
     */
    checkPasswordResetKey: {
        /**
         * @summary Check Password Reset Key
         * @description Whether a reset link is still good, before asking for a new password.
         *
         * POST rather than GET so the key stays out of access logs and referrers.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CheckPasswordResetKeyBody, CheckPasswordResetKeyParameters, TMeta, TSignal>, client?: (schema: CheckPasswordResetKeySchema, options: ServiceOperationMutationFnOptions<CheckPasswordResetKeyBody, CheckPasswordResetKeyParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CheckPasswordResetKeyData, CheckPasswordResetKeyError>>): Promise<RequestFnResponse<CheckPasswordResetKeyData, CheckPasswordResetKeyError>>;
        /**
         * @summary Check Password Reset Key
         * @description Whether a reset link is still good, before asking for a new password.
         *
         * POST rather than GET so the key stays out of access logs and referrers.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
         */
        getMutationKey(parameters: DeepReadonly<CheckPasswordResetKeyParameters> | void): ServiceOperationMutationKey<CheckPasswordResetKeySchema, CheckPasswordResetKeyParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Check Password Reset Key
         * @description Whether a reset link is still good, before asking for a new password.
         *
         * POST rather than GET so the key stays out of access logs and referrers.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.checkPasswordResetKey.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.checkPasswordResetKey.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends CheckPasswordResetKeyBody, TContext = unknown>(parameters: DeepReadonly<CheckPasswordResetKeyParameters>, options?: ServiceOperationUseMutationOptions<CheckPasswordResetKeySchema, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, TVariables, OperationError<CheckPasswordResetKeyError>, TContext>): UseMutationResult<CheckPasswordResetKeyData, OperationError<CheckPasswordResetKeyError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Check Password Reset Key
         * @description Whether a reset link is still good, before asking for a new password.
         *
         * POST rather than GET so the key stays out of access logs and referrers.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.checkPasswordResetKey.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.checkPasswordResetKey.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CheckPasswordResetKeyBody, CheckPasswordResetKeyParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CheckPasswordResetKeySchema, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, TVariables, OperationError<CheckPasswordResetKeyError>, TContext>): UseMutationResult<CheckPasswordResetKeyData, OperationError<CheckPasswordResetKeyError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Check Password Reset Key
         * @description Whether a reset link is still good, before asking for a new password.
         *
         * POST rather than GET so the key stays out of access logs and referrers.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const checkPasswordResetKeyTotal = qraft.v3Service.checkPasswordResetKey.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const checkPasswordResetKeyTotal = qraft.v3Service.checkPasswordResetKey.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext> | MutationFiltersByMutationKey<CheckPasswordResetKeySchema, CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Check Password Reset Key
         * @description Whether a reset link is still good, before asking for a new password.
         *
         * POST rather than GET so the key stays out of access logs and referrers.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const checkPasswordResetKeyPendingMutationVariables = qraft.v3Service.checkPasswordResetKey.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const checkPasswordResetKeyMutationData = qraft.v3Service.checkPasswordResetKey.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CheckPasswordResetKeyData, OperationError<CheckPasswordResetKeyError>, MutationVariables<CheckPasswordResetKeyBody, CheckPasswordResetKeyParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext> | MutationFiltersByMutationKey<CheckPasswordResetKeySchema, CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext>;
            select?: (mutation: Mutation<CheckPasswordResetKeyData, OperationError<CheckPasswordResetKeyError>, MutationVariables<CheckPasswordResetKeyBody, CheckPasswordResetKeyParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Check Password Reset Key
         * @description Whether a reset link is still good, before asking for a new password.
         *
         * POST rather than GET so the key stays out of access logs and referrers.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext> | MutationFiltersByMutationKey<CheckPasswordResetKeySchema, CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Check Password Reset Key
         * @description Whether a reset link is still good, before asking for a new password.
         *
         * POST rather than GET so the key stays out of access logs and referrers.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.checkPasswordResetKey.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.checkPasswordResetKey.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext> | MutationFiltersByMutationKey<CheckPasswordResetKeySchema, CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext>): Mutation<CheckPasswordResetKeyData, CheckPasswordResetKeyError, MutationVariables<CheckPasswordResetKeyBody, CheckPasswordResetKeyParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext> | MutationFiltersByMutationKey<CheckPasswordResetKeySchema, CheckPasswordResetKeyBody, CheckPasswordResetKeyData, CheckPasswordResetKeyParameters, OperationError<CheckPasswordResetKeyError>, TContext>): Array<Mutation<CheckPasswordResetKeyData, CheckPasswordResetKeyError, MutationVariables<CheckPasswordResetKeyBody, CheckPasswordResetKeyParameters>, TContext>>;
        };
        schema: CheckPasswordResetKeySchema;
        types: {
            parameters: CheckPasswordResetKeyParameters;
            data: CheckPasswordResetKeyData;
            error: CheckPasswordResetKeyError;
            body: CheckPasswordResetKeyBody;
        };
    };
    /**
     * @summary Reset Password
     * @description Spend a reset key and set a new password.
     *
     * The key is checked before the passwords. There is no strength rule beyond non-blank
     * and matching.
     *
     * The caller is not logged in afterwards: every existing session has been ended (see
     * `apply_new_password`), and they are sent back to the login screen.
     *
     * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
     * `password_mismatch`.
     */
    resetPassword: {
        /**
         * @summary Reset Password
         * @description Spend a reset key and set a new password.
         *
         * The key is checked before the passwords. There is no strength rule beyond non-blank
         * and matching.
         *
         * The caller is not logged in afterwards: every existing session has been ended (see
         * `apply_new_password`), and they are sent back to the login screen.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
         * `password_mismatch`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ResetPasswordBody, ResetPasswordParameters, TMeta, TSignal>, client?: (schema: ResetPasswordSchema, options: ServiceOperationMutationFnOptions<ResetPasswordBody, ResetPasswordParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ResetPasswordData, ResetPasswordError>>): Promise<RequestFnResponse<ResetPasswordData, ResetPasswordError>>;
        /**
         * @summary Reset Password
         * @description Spend a reset key and set a new password.
         *
         * The key is checked before the passwords. There is no strength rule beyond non-blank
         * and matching.
         *
         * The caller is not logged in afterwards: every existing session has been ended (see
         * `apply_new_password`), and they are sent back to the login screen.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
         * `password_mismatch`.
         */
        getMutationKey(parameters: DeepReadonly<ResetPasswordParameters> | void): ServiceOperationMutationKey<ResetPasswordSchema, ResetPasswordParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reset Password
         * @description Spend a reset key and set a new password.
         *
         * The key is checked before the passwords. There is no strength rule beyond non-blank
         * and matching.
         *
         * The caller is not logged in afterwards: every existing session has been ended (see
         * `apply_new_password`), and they are sent back to the login screen.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
         * `password_mismatch`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.resetPassword.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.resetPassword.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ResetPasswordBody, TContext = unknown>(parameters: DeepReadonly<ResetPasswordParameters>, options?: ServiceOperationUseMutationOptions<ResetPasswordSchema, ResetPasswordData, ResetPasswordParameters, TVariables, OperationError<ResetPasswordError>, TContext>): UseMutationResult<ResetPasswordData, OperationError<ResetPasswordError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reset Password
         * @description Spend a reset key and set a new password.
         *
         * The key is checked before the passwords. There is no strength rule beyond non-blank
         * and matching.
         *
         * The caller is not logged in afterwards: every existing session has been ended (see
         * `apply_new_password`), and they are sent back to the login screen.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
         * `password_mismatch`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.resetPassword.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.resetPassword.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ResetPasswordBody, ResetPasswordParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ResetPasswordSchema, ResetPasswordData, ResetPasswordParameters, TVariables, OperationError<ResetPasswordError>, TContext>): UseMutationResult<ResetPasswordData, OperationError<ResetPasswordError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Reset Password
         * @description Spend a reset key and set a new password.
         *
         * The key is checked before the passwords. There is no strength rule beyond non-blank
         * and matching.
         *
         * The caller is not logged in afterwards: every existing session has been ended (see
         * `apply_new_password`), and they are sent back to the login screen.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
         * `password_mismatch`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const resetPasswordTotal = qraft.v3Service.resetPassword.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const resetPasswordTotal = qraft.v3Service.resetPassword.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext> | MutationFiltersByMutationKey<ResetPasswordSchema, ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Reset Password
         * @description Spend a reset key and set a new password.
         *
         * The key is checked before the passwords. There is no strength rule beyond non-blank
         * and matching.
         *
         * The caller is not logged in afterwards: every existing session has been ended (see
         * `apply_new_password`), and they are sent back to the login screen.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
         * `password_mismatch`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const resetPasswordPendingMutationVariables = qraft.v3Service.resetPassword.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const resetPasswordMutationData = qraft.v3Service.resetPassword.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ResetPasswordData, OperationError<ResetPasswordError>, MutationVariables<ResetPasswordBody, ResetPasswordParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext> | MutationFiltersByMutationKey<ResetPasswordSchema, ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext>;
            select?: (mutation: Mutation<ResetPasswordData, OperationError<ResetPasswordError>, MutationVariables<ResetPasswordBody, ResetPasswordParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Reset Password
         * @description Spend a reset key and set a new password.
         *
         * The key is checked before the passwords. There is no strength rule beyond non-blank
         * and matching.
         *
         * The caller is not logged in afterwards: every existing session has been ended (see
         * `apply_new_password`), and they are sent back to the login screen.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
         * `password_mismatch`.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext> | MutationFiltersByMutationKey<ResetPasswordSchema, ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Reset Password
         * @description Spend a reset key and set a new password.
         *
         * The key is checked before the passwords. There is no strength rule beyond non-blank
         * and matching.
         *
         * The caller is not logged in afterwards: every existing session has been ended (see
         * `apply_new_password`), and they are sent back to the login screen.
         *
         * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
         * `password_mismatch`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.resetPassword.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.resetPassword.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext> | MutationFiltersByMutationKey<ResetPasswordSchema, ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext>): Mutation<ResetPasswordData, ResetPasswordError, MutationVariables<ResetPasswordBody, ResetPasswordParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext> | MutationFiltersByMutationKey<ResetPasswordSchema, ResetPasswordBody, ResetPasswordData, ResetPasswordParameters, OperationError<ResetPasswordError>, TContext>): Array<Mutation<ResetPasswordData, ResetPasswordError, MutationVariables<ResetPasswordBody, ResetPasswordParameters>, TContext>>;
        };
        schema: ResetPasswordSchema;
        types: {
            parameters: ResetPasswordParameters;
            data: ResetPasswordData;
            error: ResetPasswordError;
            body: ResetPasswordBody;
        };
    };
    /** @summary Logout */
    logout: {
        /** @summary Logout */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<LogoutBody, LogoutParameters, TMeta, TSignal>, client?: (schema: LogoutSchema, options: ServiceOperationMutationFnOptions<LogoutBody, LogoutParameters, TMeta, TSignal>) => Promise<RequestFnResponse<LogoutData, LogoutError>>): Promise<RequestFnResponse<LogoutData, LogoutError>>;
        /** @summary Logout */
        getMutationKey(parameters: DeepReadonly<LogoutParameters> | void): ServiceOperationMutationKey<LogoutSchema, LogoutParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.logout.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.logout.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends LogoutBody, TContext = unknown>(parameters: DeepReadonly<LogoutParameters>, options?: ServiceOperationUseMutationOptions<LogoutSchema, LogoutData, LogoutParameters, TVariables, OperationError<LogoutError>, TContext>): UseMutationResult<LogoutData, OperationError<LogoutError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.logout.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.logout.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<LogoutBody, LogoutParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<LogoutSchema, LogoutData, LogoutParameters, TVariables, OperationError<LogoutError>, TContext>): UseMutationResult<LogoutData, OperationError<LogoutError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const logoutTotal = qraft.v3Service.logout.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const logoutTotal = qraft.v3Service.logout.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext> | MutationFiltersByMutationKey<LogoutSchema, LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const logoutPendingMutationVariables = qraft.v3Service.logout.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const logoutMutationData = qraft.v3Service.logout.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<LogoutData, OperationError<LogoutError>, MutationVariables<LogoutBody, LogoutParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext> | MutationFiltersByMutationKey<LogoutSchema, LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext>;
            select?: (mutation: Mutation<LogoutData, OperationError<LogoutError>, MutationVariables<LogoutBody, LogoutParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Logout */
        isMutating<TContext>(filters?: MutationFiltersByParameters<LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext> | MutationFiltersByMutationKey<LogoutSchema, LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.logout.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.logout.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext> | MutationFiltersByMutationKey<LogoutSchema, LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext>): Mutation<LogoutData, LogoutError, MutationVariables<LogoutBody, LogoutParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext> | MutationFiltersByMutationKey<LogoutSchema, LogoutBody, LogoutData, LogoutParameters, OperationError<LogoutError>, TContext>): Array<Mutation<LogoutData, LogoutError, MutationVariables<LogoutBody, LogoutParameters>, TContext>>;
        };
        schema: LogoutSchema;
        types: {
            parameters: LogoutParameters;
            data: LogoutData;
            error: LogoutError;
            body: LogoutBody;
        };
    };
    /**
     * @summary Create Switch Token
     * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
     * the caller's alias family. Redeemed by `switch_account` from the same session.
     *
     * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
     */
    createSwitchToken: {
        /**
         * @summary Create Switch Token
         * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
         * the caller's alias family. Redeemed by `switch_account` from the same session.
         *
         * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateSwitchTokenBody, CreateSwitchTokenParameters, TMeta, TSignal>, client?: (schema: CreateSwitchTokenSchema, options: ServiceOperationMutationFnOptions<CreateSwitchTokenBody, CreateSwitchTokenParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateSwitchTokenData, CreateSwitchTokenError>>): Promise<RequestFnResponse<CreateSwitchTokenData, CreateSwitchTokenError>>;
        /**
         * @summary Create Switch Token
         * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
         * the caller's alias family. Redeemed by `switch_account` from the same session.
         *
         * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
         */
        getMutationKey(parameters: DeepReadonly<CreateSwitchTokenParameters> | void): ServiceOperationMutationKey<CreateSwitchTokenSchema, CreateSwitchTokenParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Switch Token
         * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
         * the caller's alias family. Redeemed by `switch_account` from the same session.
         *
         * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createSwitchToken.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createSwitchToken.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateSwitchTokenBody, TContext = unknown>(parameters: DeepReadonly<CreateSwitchTokenParameters>, options?: ServiceOperationUseMutationOptions<CreateSwitchTokenSchema, CreateSwitchTokenData, CreateSwitchTokenParameters, TVariables, OperationError<CreateSwitchTokenError>, TContext>): UseMutationResult<CreateSwitchTokenData, OperationError<CreateSwitchTokenError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Switch Token
         * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
         * the caller's alias family. Redeemed by `switch_account` from the same session.
         *
         * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createSwitchToken.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createSwitchToken.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateSwitchTokenBody, CreateSwitchTokenParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateSwitchTokenSchema, CreateSwitchTokenData, CreateSwitchTokenParameters, TVariables, OperationError<CreateSwitchTokenError>, TContext>): UseMutationResult<CreateSwitchTokenData, OperationError<CreateSwitchTokenError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Switch Token
         * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
         * the caller's alias family. Redeemed by `switch_account` from the same session.
         *
         * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createSwitchTokenTotal = qraft.v3Service.createSwitchToken.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createSwitchTokenTotal = qraft.v3Service.createSwitchToken.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext> | MutationFiltersByMutationKey<CreateSwitchTokenSchema, CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Switch Token
         * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
         * the caller's alias family. Redeemed by `switch_account` from the same session.
         *
         * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createSwitchTokenPendingMutationVariables = qraft.v3Service.createSwitchToken.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createSwitchTokenMutationData = qraft.v3Service.createSwitchToken.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateSwitchTokenData, OperationError<CreateSwitchTokenError>, MutationVariables<CreateSwitchTokenBody, CreateSwitchTokenParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext> | MutationFiltersByMutationKey<CreateSwitchTokenSchema, CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext>;
            select?: (mutation: Mutation<CreateSwitchTokenData, OperationError<CreateSwitchTokenError>, MutationVariables<CreateSwitchTokenBody, CreateSwitchTokenParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Switch Token
         * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
         * the caller's alias family. Redeemed by `switch_account` from the same session.
         *
         * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext> | MutationFiltersByMutationKey<CreateSwitchTokenSchema, CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Switch Token
         * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
         * the caller's alias family. Redeemed by `switch_account` from the same session.
         *
         * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createSwitchToken.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createSwitchToken.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext> | MutationFiltersByMutationKey<CreateSwitchTokenSchema, CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext>): Mutation<CreateSwitchTokenData, CreateSwitchTokenError, MutationVariables<CreateSwitchTokenBody, CreateSwitchTokenParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext> | MutationFiltersByMutationKey<CreateSwitchTokenSchema, CreateSwitchTokenBody, CreateSwitchTokenData, CreateSwitchTokenParameters, OperationError<CreateSwitchTokenError>, TContext>): Array<Mutation<CreateSwitchTokenData, CreateSwitchTokenError, MutationVariables<CreateSwitchTokenBody, CreateSwitchTokenParameters>, TContext>>;
        };
        schema: CreateSwitchTokenSchema;
        types: {
            parameters: CreateSwitchTokenParameters;
            data: CreateSwitchTokenData;
            error: CreateSwitchTokenError;
            body: CreateSwitchTokenBody;
        };
    };
    /**
     * @summary Switch Account
     * @description Redeem a switch token: destroy this session and become the target.
     *
     * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
     */
    switchAccount: {
        /**
         * @summary Switch Account
         * @description Redeem a switch token: destroy this session and become the target.
         *
         * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SwitchAccountBody, SwitchAccountParameters, TMeta, TSignal>, client?: (schema: SwitchAccountSchema, options: ServiceOperationMutationFnOptions<SwitchAccountBody, SwitchAccountParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SwitchAccountData, SwitchAccountError>>): Promise<RequestFnResponse<SwitchAccountData, SwitchAccountError>>;
        /**
         * @summary Switch Account
         * @description Redeem a switch token: destroy this session and become the target.
         *
         * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
         */
        getMutationKey(parameters: DeepReadonly<SwitchAccountParameters> | void): ServiceOperationMutationKey<SwitchAccountSchema, SwitchAccountParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Switch Account
         * @description Redeem a switch token: destroy this session and become the target.
         *
         * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.switchAccount.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.switchAccount.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SwitchAccountBody, TContext = unknown>(parameters: DeepReadonly<SwitchAccountParameters>, options?: ServiceOperationUseMutationOptions<SwitchAccountSchema, SwitchAccountData, SwitchAccountParameters, TVariables, OperationError<SwitchAccountError>, TContext>): UseMutationResult<SwitchAccountData, OperationError<SwitchAccountError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Switch Account
         * @description Redeem a switch token: destroy this session and become the target.
         *
         * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.switchAccount.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.switchAccount.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SwitchAccountBody, SwitchAccountParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SwitchAccountSchema, SwitchAccountData, SwitchAccountParameters, TVariables, OperationError<SwitchAccountError>, TContext>): UseMutationResult<SwitchAccountData, OperationError<SwitchAccountError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Switch Account
         * @description Redeem a switch token: destroy this session and become the target.
         *
         * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const switchAccountTotal = qraft.v3Service.switchAccount.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const switchAccountTotal = qraft.v3Service.switchAccount.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext> | MutationFiltersByMutationKey<SwitchAccountSchema, SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Switch Account
         * @description Redeem a switch token: destroy this session and become the target.
         *
         * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const switchAccountPendingMutationVariables = qraft.v3Service.switchAccount.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const switchAccountMutationData = qraft.v3Service.switchAccount.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SwitchAccountData, OperationError<SwitchAccountError>, MutationVariables<SwitchAccountBody, SwitchAccountParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext> | MutationFiltersByMutationKey<SwitchAccountSchema, SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext>;
            select?: (mutation: Mutation<SwitchAccountData, OperationError<SwitchAccountError>, MutationVariables<SwitchAccountBody, SwitchAccountParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Switch Account
         * @description Redeem a switch token: destroy this session and become the target.
         *
         * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext> | MutationFiltersByMutationKey<SwitchAccountSchema, SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Switch Account
         * @description Redeem a switch token: destroy this session and become the target.
         *
         * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.switchAccount.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.switchAccount.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext> | MutationFiltersByMutationKey<SwitchAccountSchema, SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext>): Mutation<SwitchAccountData, SwitchAccountError, MutationVariables<SwitchAccountBody, SwitchAccountParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext> | MutationFiltersByMutationKey<SwitchAccountSchema, SwitchAccountBody, SwitchAccountData, SwitchAccountParameters, OperationError<SwitchAccountError>, TContext>): Array<Mutation<SwitchAccountData, SwitchAccountError, MutationVariables<SwitchAccountBody, SwitchAccountParameters>, TContext>>;
        };
        schema: SwitchAccountSchema;
        types: {
            parameters: SwitchAccountParameters;
            data: SwitchAccountData;
            error: SwitchAccountError;
            body: SwitchAccountBody;
        };
    };
    /**
     * @summary List Student News
     * @description The student news archive, newest first.
     *
     * `language` is required and there is no English fallback: a language with no
     * articles is an empty page, which is what the live site serves.
     *
     * Page size follows the platform default of 10, which is also legacy's
     * configured `posts_per_page`.
     */
    listStudentNews: {
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentNewsSchema, ListStudentNewsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentNewsParameters, TMeta, TSignal>), client?: (schema: ListStudentNewsSchema, options: {
            parameters: ListStudentNewsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentNewsData, ListStudentNewsError>>): Promise<RequestFnResponse<ListStudentNewsData, ListStudentNewsError>>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentNewsParameters>): ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentNews.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentNewsData>(parameters: ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentNewsData, ListStudentNewsError, TData, ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentNewsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentNews.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentNewsData>(parameters: ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>), options: Omit<DefinedInitialDataOptions<ListStudentNewsData, ListStudentNewsError, TData, ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentNewsError>>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentNewsParameters>): ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentNews.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentNewsParameters, TQueryFnData = ListStudentNewsData, TData = OperationInfiniteData<TQueryFnData, ListStudentNewsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentNewsError, TData, ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentNewsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentNews.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentNewsParameters, TQueryFnData = ListStudentNewsData, TData = OperationInfiniteData<TQueryFnData, ListStudentNewsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentNewsError, TData, ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentNewsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentNewsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentNewsTotal = qraft.v3Service.listStudentNews.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentNewsByParametersTotal = qraft.v3Service.listStudentNews.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError> | QueryFiltersByQueryKey<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentNewsResults = qraft.v3Service.listStudentNews.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentNewsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentNewsCombinedResults = qraft.v3Service.listStudentNews.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentNewsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentNewsSchema, ListStudentNewsParameters, ListStudentNewsData, ListStudentNewsError>>, TCombinedResult = Array<UseQueryResult<ListStudentNewsData, ListStudentNewsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentNewsData, ListStudentNewsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentNews.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentNewsData>(parameters: ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentNewsData, ListStudentNewsError, TData, ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentNewsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentNews.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentNewsParameters, TData = ListStudentNewsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentNewsData, ListStudentNewsError, OperationInfiniteData<TData, ListStudentNewsParameters>, ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentNewsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentNewsParameters>, OperationError<ListStudentNewsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentNewsData = qraft.v3Service.listStudentNews.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentNewsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentNewsCombinedData = qraft.v3Service.listStudentNews.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentNewsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentNewsSchema, ListStudentNewsParameters, ListStudentNewsData, ListStudentNewsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentNewsData, ListStudentNewsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentNewsData, ListStudentNewsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentNewsSchema, ListStudentNewsData, ListStudentNewsParameters, ListStudentNewsError>): Promise<ListStudentNewsData>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentNewsSchema, ListStudentNewsData, ListStudentNewsParameters, ListStudentNewsError>): Promise<void>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentNewsSchema, ListStudentNewsData, ListStudentNewsParameters, ListStudentNewsError>): Promise<ListStudentNewsData>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentNewsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentNewsSchema, ListStudentNewsData, ListStudentNewsParameters, DeepReadonly<TPageParam>, ListStudentNewsError>): Promise<OperationInfiniteData<ListStudentNewsData, ListStudentNewsParameters>>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentNewsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentNewsSchema, ListStudentNewsData, ListStudentNewsParameters, DeepReadonly<TPageParam>, ListStudentNewsError>): Promise<void>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentNewsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentNewsSchema, ListStudentNewsData, ListStudentNewsParameters, DeepReadonly<TPageParam>, ListStudentNewsError>): Promise<OperationInfiniteData<ListStudentNewsData, ListStudentNewsParameters>>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>)): ListStudentNewsData | undefined;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>)): OperationInfiniteData<ListStudentNewsData, ListStudentNewsParameters> | undefined;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError> | QueryFiltersByQueryKey<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentNewsData, ListStudentNewsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>,
            data: ListStudentNewsData | undefined
        ]>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters> | (DeepReadonly<ListStudentNewsParameters>)): QueryState<ListStudentNewsData, ListStudentNewsError> | undefined;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentNewsParameters> | ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>): QueryState<OperationInfiniteData<ListStudentNewsData, ListStudentNewsParameters>, ListStudentNewsError> | undefined;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentNewsParameters>) | ServiceOperationQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>, updater: Updater<NoInfer<ListStudentNewsData> | undefined, NoInfer<DeepReadonly<ListStudentNewsData>> | undefined>, options?: SetDataOptions): ListStudentNewsData | undefined;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentNewsParameters>) | ServiceOperationInfiniteQueryKey<ListStudentNewsSchema, ListStudentNewsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentNewsData, ListStudentNewsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentNewsData, ListStudentNewsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentNewsData, ListStudentNewsParameters> | undefined;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError> | QueryFiltersByQueryKey<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>, updater: Updater<NoInfer<ListStudentNewsData> | undefined, NoInfer<ListStudentNewsData> | undefined>, options?: SetDataOptions): Array<ListStudentNewsData | undefined>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError> | QueryFiltersByQueryKey<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError> | QueryFiltersByQueryKey<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError> | QueryFiltersByQueryKey<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>): void;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError> | QueryFiltersByQueryKey<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student News
         * @description The student news archive, newest first.
         *
         * `language` is required and there is no English fallback: a language with no
         * articles is an empty page, which is what the live site serves.
         *
         * Page size follows the platform default of 10, which is also legacy's
         * configured `posts_per_page`.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError> | QueryFiltersByQueryKey<ListStudentNewsSchema, ListStudentNewsData, TInfinite, ListStudentNewsParameters, ListStudentNewsError>): number;
        schema: ListStudentNewsSchema;
        types: {
            parameters: ListStudentNewsParameters;
            data: ListStudentNewsData;
            error: ListStudentNewsError;
        };
    };
    /**
     * @summary Get Student News Post
     * @description One student news article by its permalink slug.
     *
     * 404s for an unknown slug and for a slug that belongs to a post of another
     * kind — the slug column is shared across all five kinds and is not unique.
     */
    getStudentNewsPost: {
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentNewsPostParameters, TMeta, TSignal>), client?: (schema: GetStudentNewsPostSchema, options: {
            parameters: GetStudentNewsPostParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentNewsPostData, GetStudentNewsPostError>>): Promise<RequestFnResponse<GetStudentNewsPostData, GetStudentNewsPostError>>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentNewsPostParameters>): ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentNewsPost.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentNewsPostData>(parameters: ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentNewsPostData, GetStudentNewsPostError, TData, ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentNewsPostError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentNewsPost.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentNewsPostData>(parameters: ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>), options: Omit<DefinedInitialDataOptions<GetStudentNewsPostData, GetStudentNewsPostError, TData, ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentNewsPostError>>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentNewsPostParameters>): ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentNewsPost.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentNewsPostParameters, TQueryFnData = GetStudentNewsPostData, TData = OperationInfiniteData<TQueryFnData, GetStudentNewsPostParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentNewsPostError, TData, ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentNewsPostError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentNewsPost.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentNewsPostParameters, TQueryFnData = GetStudentNewsPostData, TData = OperationInfiniteData<TQueryFnData, GetStudentNewsPostParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentNewsPostError, TData, ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentNewsPostData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentNewsPostError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentNewsPostTotal = qraft.v3Service.getStudentNewsPost.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentNewsPostByParametersTotal = qraft.v3Service.getStudentNewsPost.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError> | QueryFiltersByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentNewsPostResults = qraft.v3Service.getStudentNewsPost.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentNewsPostResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentNewsPostCombinedResults = qraft.v3Service.getStudentNewsPost.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentNewsPostCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentNewsPostSchema, GetStudentNewsPostParameters, GetStudentNewsPostData, GetStudentNewsPostError>>, TCombinedResult = Array<UseQueryResult<GetStudentNewsPostData, GetStudentNewsPostError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentNewsPostData, GetStudentNewsPostError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentNewsPost.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentNewsPostData>(parameters: ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentNewsPostData, GetStudentNewsPostError, TData, ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentNewsPostError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentNewsPost.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentNewsPostParameters, TData = GetStudentNewsPostData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentNewsPostData, GetStudentNewsPostError, OperationInfiniteData<TData, GetStudentNewsPostParameters>, ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentNewsPostData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentNewsPostParameters>, OperationError<GetStudentNewsPostError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentNewsPostData = qraft.v3Service.getStudentNewsPost.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentNewsPostResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentNewsPostCombinedData = qraft.v3Service.getStudentNewsPost.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentNewsPostCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentNewsPostSchema, GetStudentNewsPostParameters, GetStudentNewsPostData, GetStudentNewsPostError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentNewsPostData, GetStudentNewsPostError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentNewsPostData, GetStudentNewsPostError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentNewsPostSchema, GetStudentNewsPostData, GetStudentNewsPostParameters, GetStudentNewsPostError>): Promise<GetStudentNewsPostData>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentNewsPostSchema, GetStudentNewsPostData, GetStudentNewsPostParameters, GetStudentNewsPostError>): Promise<void>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentNewsPostSchema, GetStudentNewsPostData, GetStudentNewsPostParameters, GetStudentNewsPostError>): Promise<GetStudentNewsPostData>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentNewsPostParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentNewsPostSchema, GetStudentNewsPostData, GetStudentNewsPostParameters, DeepReadonly<TPageParam>, GetStudentNewsPostError>): Promise<OperationInfiniteData<GetStudentNewsPostData, GetStudentNewsPostParameters>>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentNewsPostParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentNewsPostSchema, GetStudentNewsPostData, GetStudentNewsPostParameters, DeepReadonly<TPageParam>, GetStudentNewsPostError>): Promise<void>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentNewsPostParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentNewsPostSchema, GetStudentNewsPostData, GetStudentNewsPostParameters, DeepReadonly<TPageParam>, GetStudentNewsPostError>): Promise<OperationInfiniteData<GetStudentNewsPostData, GetStudentNewsPostParameters>>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>)): GetStudentNewsPostData | undefined;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>)): OperationInfiniteData<GetStudentNewsPostData, GetStudentNewsPostParameters> | undefined;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError> | QueryFiltersByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentNewsPostData, GetStudentNewsPostParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>,
            data: GetStudentNewsPostData | undefined
        ]>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters> | (DeepReadonly<GetStudentNewsPostParameters>)): QueryState<GetStudentNewsPostData, GetStudentNewsPostError> | undefined;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentNewsPostParameters> | ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>): QueryState<OperationInfiniteData<GetStudentNewsPostData, GetStudentNewsPostParameters>, GetStudentNewsPostError> | undefined;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentNewsPostParameters>) | ServiceOperationQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>, updater: Updater<NoInfer<GetStudentNewsPostData> | undefined, NoInfer<DeepReadonly<GetStudentNewsPostData>> | undefined>, options?: SetDataOptions): GetStudentNewsPostData | undefined;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentNewsPostParameters>) | ServiceOperationInfiniteQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentNewsPostData, GetStudentNewsPostParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentNewsPostData, GetStudentNewsPostParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentNewsPostData, GetStudentNewsPostParameters> | undefined;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError> | QueryFiltersByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>, updater: Updater<NoInfer<GetStudentNewsPostData> | undefined, NoInfer<GetStudentNewsPostData> | undefined>, options?: SetDataOptions): Array<GetStudentNewsPostData | undefined>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError> | QueryFiltersByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError> | QueryFiltersByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError> | QueryFiltersByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>): void;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError> | QueryFiltersByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student News Post
         * @description One student news article by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of another
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError> | QueryFiltersByQueryKey<GetStudentNewsPostSchema, GetStudentNewsPostData, TInfinite, GetStudentNewsPostParameters, GetStudentNewsPostError>): number;
        schema: GetStudentNewsPostSchema;
        types: {
            parameters: GetStudentNewsPostParameters;
            data: GetStudentNewsPostData;
            error: GetStudentNewsPostError;
        };
    };
    /**
     * @summary List Study Helper News
     * @description The study helper news archive, newest first.
     */
    listStudyHelperNews: {
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudyHelperNewsParameters, TMeta, TSignal>), client?: (schema: ListStudyHelperNewsSchema, options: {
            parameters: ListStudyHelperNewsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudyHelperNewsData, ListStudyHelperNewsError>>): Promise<RequestFnResponse<ListStudyHelperNewsData, ListStudyHelperNewsError>>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        getQueryKey(parameters: DeepReadonly<ListStudyHelperNewsParameters>): ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudyHelperNews.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudyHelperNewsData>(parameters: ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudyHelperNewsData, ListStudyHelperNewsError, TData, ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudyHelperNewsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudyHelperNews.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudyHelperNewsData>(parameters: ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>), options: Omit<DefinedInitialDataOptions<ListStudyHelperNewsData, ListStudyHelperNewsError, TData, ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudyHelperNewsError>>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudyHelperNewsParameters>): ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudyHelperNews.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudyHelperNewsParameters, TQueryFnData = ListStudyHelperNewsData, TData = OperationInfiniteData<TQueryFnData, ListStudyHelperNewsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudyHelperNewsError, TData, ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudyHelperNewsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudyHelperNews.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudyHelperNewsParameters, TQueryFnData = ListStudyHelperNewsData, TData = OperationInfiniteData<TQueryFnData, ListStudyHelperNewsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudyHelperNewsError, TData, ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudyHelperNewsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudyHelperNewsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudyHelperNewsTotal = qraft.v3Service.listStudyHelperNews.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudyHelperNewsByParametersTotal = qraft.v3Service.listStudyHelperNews.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError> | QueryFiltersByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudyHelperNewsResults = qraft.v3Service.listStudyHelperNews.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudyHelperNewsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudyHelperNewsCombinedResults = qraft.v3Service.listStudyHelperNews.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudyHelperNewsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters, ListStudyHelperNewsData, ListStudyHelperNewsError>>, TCombinedResult = Array<UseQueryResult<ListStudyHelperNewsData, ListStudyHelperNewsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudyHelperNewsData, ListStudyHelperNewsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudyHelperNews.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudyHelperNewsData>(parameters: ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudyHelperNewsData, ListStudyHelperNewsError, TData, ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudyHelperNewsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudyHelperNews.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudyHelperNewsParameters, TData = ListStudyHelperNewsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudyHelperNewsData, ListStudyHelperNewsError, OperationInfiniteData<TData, ListStudyHelperNewsParameters>, ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudyHelperNewsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudyHelperNewsParameters>, OperationError<ListStudyHelperNewsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudyHelperNewsData = qraft.v3Service.listStudyHelperNews.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudyHelperNewsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudyHelperNewsCombinedData = qraft.v3Service.listStudyHelperNews.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudyHelperNewsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters, ListStudyHelperNewsData, ListStudyHelperNewsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudyHelperNewsData, ListStudyHelperNewsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudyHelperNewsData, ListStudyHelperNewsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudyHelperNewsSchema, ListStudyHelperNewsData, ListStudyHelperNewsParameters, ListStudyHelperNewsError>): Promise<ListStudyHelperNewsData>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudyHelperNewsSchema, ListStudyHelperNewsData, ListStudyHelperNewsParameters, ListStudyHelperNewsError>): Promise<void>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudyHelperNewsSchema, ListStudyHelperNewsData, ListStudyHelperNewsParameters, ListStudyHelperNewsError>): Promise<ListStudyHelperNewsData>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        fetchInfiniteQuery<TPageParam extends ListStudyHelperNewsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudyHelperNewsSchema, ListStudyHelperNewsData, ListStudyHelperNewsParameters, DeepReadonly<TPageParam>, ListStudyHelperNewsError>): Promise<OperationInfiniteData<ListStudyHelperNewsData, ListStudyHelperNewsParameters>>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudyHelperNewsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudyHelperNewsSchema, ListStudyHelperNewsData, ListStudyHelperNewsParameters, DeepReadonly<TPageParam>, ListStudyHelperNewsError>): Promise<void>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudyHelperNewsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudyHelperNewsSchema, ListStudyHelperNewsData, ListStudyHelperNewsParameters, DeepReadonly<TPageParam>, ListStudyHelperNewsError>): Promise<OperationInfiniteData<ListStudyHelperNewsData, ListStudyHelperNewsParameters>>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>)): ListStudyHelperNewsData | undefined;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>)): OperationInfiniteData<ListStudyHelperNewsData, ListStudyHelperNewsParameters> | undefined;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError> | QueryFiltersByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudyHelperNewsData, ListStudyHelperNewsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>,
            data: ListStudyHelperNewsData | undefined
        ]>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters> | (DeepReadonly<ListStudyHelperNewsParameters>)): QueryState<ListStudyHelperNewsData, ListStudyHelperNewsError> | undefined;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudyHelperNewsParameters> | ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>): QueryState<OperationInfiniteData<ListStudyHelperNewsData, ListStudyHelperNewsParameters>, ListStudyHelperNewsError> | undefined;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        setQueryData(parameters: (DeepReadonly<ListStudyHelperNewsParameters>) | ServiceOperationQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>, updater: Updater<NoInfer<ListStudyHelperNewsData> | undefined, NoInfer<DeepReadonly<ListStudyHelperNewsData>> | undefined>, options?: SetDataOptions): ListStudyHelperNewsData | undefined;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudyHelperNewsParameters>) | ServiceOperationInfiniteQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudyHelperNewsData, ListStudyHelperNewsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudyHelperNewsData, ListStudyHelperNewsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudyHelperNewsData, ListStudyHelperNewsParameters> | undefined;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError> | QueryFiltersByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>, updater: Updater<NoInfer<ListStudyHelperNewsData> | undefined, NoInfer<ListStudyHelperNewsData> | undefined>, options?: SetDataOptions): Array<ListStudyHelperNewsData | undefined>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError> | QueryFiltersByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError> | QueryFiltersByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError> | QueryFiltersByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>): void;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError> | QueryFiltersByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Study Helper News
         * @description The study helper news archive, newest first.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError> | QueryFiltersByQueryKey<ListStudyHelperNewsSchema, ListStudyHelperNewsData, TInfinite, ListStudyHelperNewsParameters, ListStudyHelperNewsError>): number;
        schema: ListStudyHelperNewsSchema;
        types: {
            parameters: ListStudyHelperNewsParameters;
            data: ListStudyHelperNewsData;
            error: ListStudyHelperNewsError;
        };
    };
    /**
     * @summary Get Study Helper News Post
     * @description One study helper news article by its permalink slug.
     */
    getStudyHelperNewsPost: {
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudyHelperNewsPostParameters, TMeta, TSignal>), client?: (schema: GetStudyHelperNewsPostSchema, options: {
            parameters: GetStudyHelperNewsPostParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError>>): Promise<RequestFnResponse<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError>>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        getQueryKey(parameters: DeepReadonly<GetStudyHelperNewsPostParameters>): ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelperNewsPost.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelperNewsPostData>(parameters: ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError, TData, ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudyHelperNewsPostError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelperNewsPost.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelperNewsPostData>(parameters: ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>), options: Omit<DefinedInitialDataOptions<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError, TData, ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudyHelperNewsPostError>>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudyHelperNewsPostParameters>): ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperNewsPost.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelperNewsPostParameters, TQueryFnData = GetStudyHelperNewsPostData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelperNewsPostParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelperNewsPostError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudyHelperNewsPostError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperNewsPost.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelperNewsPostParameters, TQueryFnData = GetStudyHelperNewsPostData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelperNewsPostParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelperNewsPostError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelperNewsPostData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudyHelperNewsPostError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudyHelperNewsPostTotal = qraft.v3Service.getStudyHelperNewsPost.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudyHelperNewsPostByParametersTotal = qraft.v3Service.getStudyHelperNewsPost.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError> | QueryFiltersByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudyHelperNewsPostResults = qraft.v3Service.getStudyHelperNewsPost.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperNewsPostResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudyHelperNewsPostCombinedResults = qraft.v3Service.getStudyHelperNewsPost.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperNewsPostCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostData, GetStudyHelperNewsPostError>>, TCombinedResult = Array<UseQueryResult<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudyHelperNewsPost.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudyHelperNewsPostData>(parameters: ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError, TData, ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudyHelperNewsPostError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperNewsPost.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudyHelperNewsPostParameters, TData = GetStudyHelperNewsPostData>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError, OperationInfiniteData<TData, GetStudyHelperNewsPostParameters>, ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelperNewsPostData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudyHelperNewsPostParameters>, OperationError<GetStudyHelperNewsPostError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudyHelperNewsPostData = qraft.v3Service.getStudyHelperNewsPost.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperNewsPostResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudyHelperNewsPostCombinedData = qraft.v3Service.getStudyHelperNewsPost.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperNewsPostCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostData, GetStudyHelperNewsPostError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>): Promise<GetStudyHelperNewsPostData>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>): Promise<void>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>): Promise<GetStudyHelperNewsPostData>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        fetchInfiniteQuery<TPageParam extends GetStudyHelperNewsPostParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters, DeepReadonly<TPageParam>, GetStudyHelperNewsPostError>): Promise<OperationInfiniteData<GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters>>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudyHelperNewsPostParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters, DeepReadonly<TPageParam>, GetStudyHelperNewsPostError>): Promise<void>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudyHelperNewsPostParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters, DeepReadonly<TPageParam>, GetStudyHelperNewsPostError>): Promise<OperationInfiniteData<GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters>>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>)): GetStudyHelperNewsPostData | undefined;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>)): OperationInfiniteData<GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters> | undefined;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError> | QueryFiltersByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>,
            data: NoInfer<OperationInfiniteData<GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>,
            data: GetStudyHelperNewsPostData | undefined
        ]>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters> | (DeepReadonly<GetStudyHelperNewsPostParameters>)): QueryState<GetStudyHelperNewsPostData, GetStudyHelperNewsPostError> | undefined;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudyHelperNewsPostParameters> | ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>): QueryState<OperationInfiniteData<GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters>, GetStudyHelperNewsPostError> | undefined;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        setQueryData(parameters: (DeepReadonly<GetStudyHelperNewsPostParameters>) | ServiceOperationQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>, updater: Updater<NoInfer<GetStudyHelperNewsPostData> | undefined, NoInfer<DeepReadonly<GetStudyHelperNewsPostData>> | undefined>, options?: SetDataOptions): GetStudyHelperNewsPostData | undefined;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudyHelperNewsPostParameters>) | ServiceOperationInfiniteQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudyHelperNewsPostData, GetStudyHelperNewsPostParameters> | undefined;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError> | QueryFiltersByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>, updater: Updater<NoInfer<GetStudyHelperNewsPostData> | undefined, NoInfer<GetStudyHelperNewsPostData> | undefined>, options?: SetDataOptions): Array<GetStudyHelperNewsPostData | undefined>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError> | QueryFiltersByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError> | QueryFiltersByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError> | QueryFiltersByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>): void;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError> | QueryFiltersByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Study Helper News Post
         * @description One study helper news article by its permalink slug.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError> | QueryFiltersByQueryKey<GetStudyHelperNewsPostSchema, GetStudyHelperNewsPostData, TInfinite, GetStudyHelperNewsPostParameters, GetStudyHelperNewsPostError>): number;
        schema: GetStudyHelperNewsPostSchema;
        types: {
            parameters: GetStudyHelperNewsPostParameters;
            data: GetStudyHelperNewsPostData;
            error: GetStudyHelperNewsPostError;
        };
    };
    /**
     * @summary List Student Tutorials
     * @description The student tutorials archive, oldest first.
     *
     * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
     * of the mobile list). `search` matches the title or the body, case-insensitively;
     * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
     * a `%`.
     */
    listStudentTutorials: {
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentTutorialsParameters, TMeta, TSignal>), client?: (schema: ListStudentTutorialsSchema, options: {
            parameters: ListStudentTutorialsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentTutorialsData, ListStudentTutorialsError>>): Promise<RequestFnResponse<ListStudentTutorialsData, ListStudentTutorialsError>>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentTutorialsParameters>): ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentTutorials.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentTutorialsData>(parameters: ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentTutorialsData, ListStudentTutorialsError, TData, ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentTutorialsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentTutorials.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentTutorialsData>(parameters: ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>), options: Omit<DefinedInitialDataOptions<ListStudentTutorialsData, ListStudentTutorialsError, TData, ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentTutorialsError>>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentTutorialsParameters>): ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentTutorials.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentTutorialsParameters, TQueryFnData = ListStudentTutorialsData, TData = OperationInfiniteData<TQueryFnData, ListStudentTutorialsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentTutorialsError, TData, ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentTutorialsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentTutorials.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentTutorialsParameters, TQueryFnData = ListStudentTutorialsData, TData = OperationInfiniteData<TQueryFnData, ListStudentTutorialsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentTutorialsError, TData, ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentTutorialsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentTutorialsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentTutorialsTotal = qraft.v3Service.listStudentTutorials.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentTutorialsByParametersTotal = qraft.v3Service.listStudentTutorials.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError> | QueryFiltersByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentTutorialsResults = qraft.v3Service.listStudentTutorials.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentTutorialsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentTutorialsCombinedResults = qraft.v3Service.listStudentTutorials.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentTutorialsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentTutorialsSchema, ListStudentTutorialsParameters, ListStudentTutorialsData, ListStudentTutorialsError>>, TCombinedResult = Array<UseQueryResult<ListStudentTutorialsData, ListStudentTutorialsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentTutorialsData, ListStudentTutorialsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentTutorials.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentTutorialsData>(parameters: ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentTutorialsData, ListStudentTutorialsError, TData, ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentTutorialsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentTutorials.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentTutorialsParameters, TData = ListStudentTutorialsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentTutorialsData, ListStudentTutorialsError, OperationInfiniteData<TData, ListStudentTutorialsParameters>, ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentTutorialsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentTutorialsParameters>, OperationError<ListStudentTutorialsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentTutorialsData = qraft.v3Service.listStudentTutorials.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentTutorialsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentTutorialsCombinedData = qraft.v3Service.listStudentTutorials.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentTutorialsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentTutorialsSchema, ListStudentTutorialsParameters, ListStudentTutorialsData, ListStudentTutorialsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentTutorialsData, ListStudentTutorialsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentTutorialsData, ListStudentTutorialsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentTutorialsSchema, ListStudentTutorialsData, ListStudentTutorialsParameters, ListStudentTutorialsError>): Promise<ListStudentTutorialsData>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentTutorialsSchema, ListStudentTutorialsData, ListStudentTutorialsParameters, ListStudentTutorialsError>): Promise<void>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentTutorialsSchema, ListStudentTutorialsData, ListStudentTutorialsParameters, ListStudentTutorialsError>): Promise<ListStudentTutorialsData>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentTutorialsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentTutorialsSchema, ListStudentTutorialsData, ListStudentTutorialsParameters, DeepReadonly<TPageParam>, ListStudentTutorialsError>): Promise<OperationInfiniteData<ListStudentTutorialsData, ListStudentTutorialsParameters>>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentTutorialsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentTutorialsSchema, ListStudentTutorialsData, ListStudentTutorialsParameters, DeepReadonly<TPageParam>, ListStudentTutorialsError>): Promise<void>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentTutorialsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentTutorialsSchema, ListStudentTutorialsData, ListStudentTutorialsParameters, DeepReadonly<TPageParam>, ListStudentTutorialsError>): Promise<OperationInfiniteData<ListStudentTutorialsData, ListStudentTutorialsParameters>>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>)): ListStudentTutorialsData | undefined;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>)): OperationInfiniteData<ListStudentTutorialsData, ListStudentTutorialsParameters> | undefined;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError> | QueryFiltersByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentTutorialsData, ListStudentTutorialsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>,
            data: ListStudentTutorialsData | undefined
        ]>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters> | (DeepReadonly<ListStudentTutorialsParameters>)): QueryState<ListStudentTutorialsData, ListStudentTutorialsError> | undefined;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentTutorialsParameters> | ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>): QueryState<OperationInfiniteData<ListStudentTutorialsData, ListStudentTutorialsParameters>, ListStudentTutorialsError> | undefined;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentTutorialsParameters>) | ServiceOperationQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>, updater: Updater<NoInfer<ListStudentTutorialsData> | undefined, NoInfer<DeepReadonly<ListStudentTutorialsData>> | undefined>, options?: SetDataOptions): ListStudentTutorialsData | undefined;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentTutorialsParameters>) | ServiceOperationInfiniteQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentTutorialsData, ListStudentTutorialsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentTutorialsData, ListStudentTutorialsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentTutorialsData, ListStudentTutorialsParameters> | undefined;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError> | QueryFiltersByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>, updater: Updater<NoInfer<ListStudentTutorialsData> | undefined, NoInfer<ListStudentTutorialsData> | undefined>, options?: SetDataOptions): Array<ListStudentTutorialsData | undefined>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError> | QueryFiltersByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError> | QueryFiltersByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError> | QueryFiltersByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>): void;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError> | QueryFiltersByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Tutorials
         * @description The student tutorials archive, oldest first.
         *
         * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
         * of the mobile list). `search` matches the title or the body, case-insensitively;
         * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
         * a `%`.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError> | QueryFiltersByQueryKey<ListStudentTutorialsSchema, ListStudentTutorialsData, TInfinite, ListStudentTutorialsParameters, ListStudentTutorialsError>): number;
        schema: ListStudentTutorialsSchema;
        types: {
            parameters: ListStudentTutorialsParameters;
            data: ListStudentTutorialsData;
            error: ListStudentTutorialsError;
        };
    };
    /**
     * @summary Get Student Tutorial
     * @description One student tutorial by its permalink slug.
     */
    getStudentTutorial: {
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentTutorialParameters, TMeta, TSignal>), client?: (schema: GetStudentTutorialSchema, options: {
            parameters: GetStudentTutorialParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentTutorialData, GetStudentTutorialError>>): Promise<RequestFnResponse<GetStudentTutorialData, GetStudentTutorialError>>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentTutorialParameters>): ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentTutorial.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentTutorialData>(parameters: ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentTutorialData, GetStudentTutorialError, TData, ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentTutorialError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentTutorial.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentTutorialData>(parameters: ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>), options: Omit<DefinedInitialDataOptions<GetStudentTutorialData, GetStudentTutorialError, TData, ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentTutorialError>>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentTutorialParameters>): ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentTutorial.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentTutorialParameters, TQueryFnData = GetStudentTutorialData, TData = OperationInfiniteData<TQueryFnData, GetStudentTutorialParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentTutorialError, TData, ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentTutorialError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentTutorial.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentTutorialParameters, TQueryFnData = GetStudentTutorialData, TData = OperationInfiniteData<TQueryFnData, GetStudentTutorialParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentTutorialError, TData, ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentTutorialData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentTutorialError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentTutorialTotal = qraft.v3Service.getStudentTutorial.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentTutorialByParametersTotal = qraft.v3Service.getStudentTutorial.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError> | QueryFiltersByQueryKey<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentTutorialResults = qraft.v3Service.getStudentTutorial.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentTutorialResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentTutorialCombinedResults = qraft.v3Service.getStudentTutorial.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentTutorialCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentTutorialSchema, GetStudentTutorialParameters, GetStudentTutorialData, GetStudentTutorialError>>, TCombinedResult = Array<UseQueryResult<GetStudentTutorialData, GetStudentTutorialError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentTutorialData, GetStudentTutorialError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentTutorial.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentTutorialData>(parameters: ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentTutorialData, GetStudentTutorialError, TData, ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentTutorialError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentTutorial.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentTutorialParameters, TData = GetStudentTutorialData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentTutorialData, GetStudentTutorialError, OperationInfiniteData<TData, GetStudentTutorialParameters>, ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentTutorialData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentTutorialParameters>, OperationError<GetStudentTutorialError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentTutorialData = qraft.v3Service.getStudentTutorial.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentTutorialResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentTutorialCombinedData = qraft.v3Service.getStudentTutorial.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentTutorialCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentTutorialSchema, GetStudentTutorialParameters, GetStudentTutorialData, GetStudentTutorialError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentTutorialData, GetStudentTutorialError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentTutorialData, GetStudentTutorialError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentTutorialSchema, GetStudentTutorialData, GetStudentTutorialParameters, GetStudentTutorialError>): Promise<GetStudentTutorialData>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentTutorialSchema, GetStudentTutorialData, GetStudentTutorialParameters, GetStudentTutorialError>): Promise<void>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentTutorialSchema, GetStudentTutorialData, GetStudentTutorialParameters, GetStudentTutorialError>): Promise<GetStudentTutorialData>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentTutorialParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentTutorialSchema, GetStudentTutorialData, GetStudentTutorialParameters, DeepReadonly<TPageParam>, GetStudentTutorialError>): Promise<OperationInfiniteData<GetStudentTutorialData, GetStudentTutorialParameters>>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentTutorialParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentTutorialSchema, GetStudentTutorialData, GetStudentTutorialParameters, DeepReadonly<TPageParam>, GetStudentTutorialError>): Promise<void>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentTutorialParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentTutorialSchema, GetStudentTutorialData, GetStudentTutorialParameters, DeepReadonly<TPageParam>, GetStudentTutorialError>): Promise<OperationInfiniteData<GetStudentTutorialData, GetStudentTutorialParameters>>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>)): GetStudentTutorialData | undefined;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>)): OperationInfiniteData<GetStudentTutorialData, GetStudentTutorialParameters> | undefined;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError> | QueryFiltersByQueryKey<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentTutorialData, GetStudentTutorialParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>,
            data: GetStudentTutorialData | undefined
        ]>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters> | (DeepReadonly<GetStudentTutorialParameters>)): QueryState<GetStudentTutorialData, GetStudentTutorialError> | undefined;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentTutorialParameters> | ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>): QueryState<OperationInfiniteData<GetStudentTutorialData, GetStudentTutorialParameters>, GetStudentTutorialError> | undefined;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentTutorialParameters>) | ServiceOperationQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>, updater: Updater<NoInfer<GetStudentTutorialData> | undefined, NoInfer<DeepReadonly<GetStudentTutorialData>> | undefined>, options?: SetDataOptions): GetStudentTutorialData | undefined;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentTutorialParameters>) | ServiceOperationInfiniteQueryKey<GetStudentTutorialSchema, GetStudentTutorialParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentTutorialData, GetStudentTutorialParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentTutorialData, GetStudentTutorialParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentTutorialData, GetStudentTutorialParameters> | undefined;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError> | QueryFiltersByQueryKey<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>, updater: Updater<NoInfer<GetStudentTutorialData> | undefined, NoInfer<GetStudentTutorialData> | undefined>, options?: SetDataOptions): Array<GetStudentTutorialData | undefined>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError> | QueryFiltersByQueryKey<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError> | QueryFiltersByQueryKey<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError> | QueryFiltersByQueryKey<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>): void;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError> | QueryFiltersByQueryKey<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Tutorial
         * @description One student tutorial by its permalink slug.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError> | QueryFiltersByQueryKey<GetStudentTutorialSchema, GetStudentTutorialData, TInfinite, GetStudentTutorialParameters, GetStudentTutorialError>): number;
        schema: GetStudentTutorialSchema;
        types: {
            parameters: GetStudentTutorialParameters;
            data: GetStudentTutorialData;
            error: GetStudentTutorialError;
        };
    };
    /**
     * @summary List Study Helper Tutorials
     * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
     *
     * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
     * part of the contract.
     */
    listStudyHelperTutorials: {
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudyHelperTutorialsParameters, TMeta, TSignal>), client?: (schema: ListStudyHelperTutorialsSchema, options: {
            parameters: ListStudyHelperTutorialsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError>>): Promise<RequestFnResponse<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError>>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        getQueryKey(parameters: DeepReadonly<ListStudyHelperTutorialsParameters>): ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudyHelperTutorials.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudyHelperTutorialsData>(parameters: ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError, TData, ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudyHelperTutorialsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudyHelperTutorials.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudyHelperTutorialsData>(parameters: ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>), options: Omit<DefinedInitialDataOptions<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError, TData, ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudyHelperTutorialsError>>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudyHelperTutorialsParameters>): ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudyHelperTutorials.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudyHelperTutorialsParameters, TQueryFnData = ListStudyHelperTutorialsData, TData = OperationInfiniteData<TQueryFnData, ListStudyHelperTutorialsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudyHelperTutorialsError, TData, ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudyHelperTutorialsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudyHelperTutorials.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudyHelperTutorialsParameters, TQueryFnData = ListStudyHelperTutorialsData, TData = OperationInfiniteData<TQueryFnData, ListStudyHelperTutorialsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudyHelperTutorialsError, TData, ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudyHelperTutorialsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudyHelperTutorialsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudyHelperTutorialsTotal = qraft.v3Service.listStudyHelperTutorials.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudyHelperTutorialsByParametersTotal = qraft.v3Service.listStudyHelperTutorials.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError> | QueryFiltersByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudyHelperTutorialsResults = qraft.v3Service.listStudyHelperTutorials.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudyHelperTutorialsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudyHelperTutorialsCombinedResults = qraft.v3Service.listStudyHelperTutorials.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudyHelperTutorialsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsData, ListStudyHelperTutorialsError>>, TCombinedResult = Array<UseQueryResult<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudyHelperTutorials.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudyHelperTutorialsData>(parameters: ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError, TData, ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudyHelperTutorialsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudyHelperTutorials.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudyHelperTutorialsParameters, TData = ListStudyHelperTutorialsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError, OperationInfiniteData<TData, ListStudyHelperTutorialsParameters>, ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudyHelperTutorialsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudyHelperTutorialsParameters>, OperationError<ListStudyHelperTutorialsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudyHelperTutorialsData = qraft.v3Service.listStudyHelperTutorials.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudyHelperTutorialsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudyHelperTutorialsCombinedData = qraft.v3Service.listStudyHelperTutorials.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudyHelperTutorialsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsData, ListStudyHelperTutorialsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>): Promise<ListStudyHelperTutorialsData>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>): Promise<void>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>): Promise<ListStudyHelperTutorialsData>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        fetchInfiniteQuery<TPageParam extends ListStudyHelperTutorialsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters, DeepReadonly<TPageParam>, ListStudyHelperTutorialsError>): Promise<OperationInfiniteData<ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters>>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudyHelperTutorialsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters, DeepReadonly<TPageParam>, ListStudyHelperTutorialsError>): Promise<void>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudyHelperTutorialsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters, DeepReadonly<TPageParam>, ListStudyHelperTutorialsError>): Promise<OperationInfiniteData<ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters>>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>)): ListStudyHelperTutorialsData | undefined;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>)): OperationInfiniteData<ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters> | undefined;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError> | QueryFiltersByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>,
            data: ListStudyHelperTutorialsData | undefined
        ]>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters> | (DeepReadonly<ListStudyHelperTutorialsParameters>)): QueryState<ListStudyHelperTutorialsData, ListStudyHelperTutorialsError> | undefined;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudyHelperTutorialsParameters> | ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>): QueryState<OperationInfiniteData<ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters>, ListStudyHelperTutorialsError> | undefined;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        setQueryData(parameters: (DeepReadonly<ListStudyHelperTutorialsParameters>) | ServiceOperationQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>, updater: Updater<NoInfer<ListStudyHelperTutorialsData> | undefined, NoInfer<DeepReadonly<ListStudyHelperTutorialsData>> | undefined>, options?: SetDataOptions): ListStudyHelperTutorialsData | undefined;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudyHelperTutorialsParameters>) | ServiceOperationInfiniteQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudyHelperTutorialsData, ListStudyHelperTutorialsParameters> | undefined;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError> | QueryFiltersByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>, updater: Updater<NoInfer<ListStudyHelperTutorialsData> | undefined, NoInfer<ListStudyHelperTutorialsData> | undefined>, options?: SetDataOptions): Array<ListStudyHelperTutorialsData | undefined>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError> | QueryFiltersByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError> | QueryFiltersByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError> | QueryFiltersByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>): void;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError> | QueryFiltersByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Study Helper Tutorials
         * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
         *
         * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
         * part of the contract.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError> | QueryFiltersByQueryKey<ListStudyHelperTutorialsSchema, ListStudyHelperTutorialsData, TInfinite, ListStudyHelperTutorialsParameters, ListStudyHelperTutorialsError>): number;
        schema: ListStudyHelperTutorialsSchema;
        types: {
            parameters: ListStudyHelperTutorialsParameters;
            data: ListStudyHelperTutorialsData;
            error: ListStudyHelperTutorialsError;
        };
    };
    /**
     * @summary Get Study Helper Tutorial
     * @description One study helper tutorial by its permalink slug.
     */
    getStudyHelperTutorial: {
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudyHelperTutorialParameters, TMeta, TSignal>), client?: (schema: GetStudyHelperTutorialSchema, options: {
            parameters: GetStudyHelperTutorialParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudyHelperTutorialData, GetStudyHelperTutorialError>>): Promise<RequestFnResponse<GetStudyHelperTutorialData, GetStudyHelperTutorialError>>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        getQueryKey(parameters: DeepReadonly<GetStudyHelperTutorialParameters>): ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelperTutorial.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelperTutorialData>(parameters: ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudyHelperTutorialData, GetStudyHelperTutorialError, TData, ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudyHelperTutorialError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelperTutorial.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelperTutorialData>(parameters: ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>), options: Omit<DefinedInitialDataOptions<GetStudyHelperTutorialData, GetStudyHelperTutorialError, TData, ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudyHelperTutorialError>>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudyHelperTutorialParameters>): ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperTutorial.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelperTutorialParameters, TQueryFnData = GetStudyHelperTutorialData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelperTutorialParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelperTutorialError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudyHelperTutorialError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperTutorial.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelperTutorialParameters, TQueryFnData = GetStudyHelperTutorialData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelperTutorialParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelperTutorialError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelperTutorialData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudyHelperTutorialError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudyHelperTutorialTotal = qraft.v3Service.getStudyHelperTutorial.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudyHelperTutorialByParametersTotal = qraft.v3Service.getStudyHelperTutorial.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError> | QueryFiltersByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudyHelperTutorialResults = qraft.v3Service.getStudyHelperTutorial.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperTutorialResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudyHelperTutorialCombinedResults = qraft.v3Service.getStudyHelperTutorial.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperTutorialCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters, GetStudyHelperTutorialData, GetStudyHelperTutorialError>>, TCombinedResult = Array<UseQueryResult<GetStudyHelperTutorialData, GetStudyHelperTutorialError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudyHelperTutorialData, GetStudyHelperTutorialError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudyHelperTutorial.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudyHelperTutorialData>(parameters: ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudyHelperTutorialData, GetStudyHelperTutorialError, TData, ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudyHelperTutorialError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperTutorial.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudyHelperTutorialParameters, TData = GetStudyHelperTutorialData>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudyHelperTutorialData, GetStudyHelperTutorialError, OperationInfiniteData<TData, GetStudyHelperTutorialParameters>, ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelperTutorialData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudyHelperTutorialParameters>, OperationError<GetStudyHelperTutorialError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudyHelperTutorialData = qraft.v3Service.getStudyHelperTutorial.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperTutorialResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudyHelperTutorialCombinedData = qraft.v3Service.getStudyHelperTutorial.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperTutorialCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters, GetStudyHelperTutorialData, GetStudyHelperTutorialError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudyHelperTutorialData, GetStudyHelperTutorialError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudyHelperTutorialData, GetStudyHelperTutorialError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>): Promise<GetStudyHelperTutorialData>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>): Promise<void>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>): Promise<GetStudyHelperTutorialData>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        fetchInfiniteQuery<TPageParam extends GetStudyHelperTutorialParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, GetStudyHelperTutorialParameters, DeepReadonly<TPageParam>, GetStudyHelperTutorialError>): Promise<OperationInfiniteData<GetStudyHelperTutorialData, GetStudyHelperTutorialParameters>>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudyHelperTutorialParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, GetStudyHelperTutorialParameters, DeepReadonly<TPageParam>, GetStudyHelperTutorialError>): Promise<void>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudyHelperTutorialParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, GetStudyHelperTutorialParameters, DeepReadonly<TPageParam>, GetStudyHelperTutorialError>): Promise<OperationInfiniteData<GetStudyHelperTutorialData, GetStudyHelperTutorialParameters>>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>)): GetStudyHelperTutorialData | undefined;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>)): OperationInfiniteData<GetStudyHelperTutorialData, GetStudyHelperTutorialParameters> | undefined;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError> | QueryFiltersByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>,
            data: NoInfer<OperationInfiniteData<GetStudyHelperTutorialData, GetStudyHelperTutorialParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>,
            data: GetStudyHelperTutorialData | undefined
        ]>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters> | (DeepReadonly<GetStudyHelperTutorialParameters>)): QueryState<GetStudyHelperTutorialData, GetStudyHelperTutorialError> | undefined;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudyHelperTutorialParameters> | ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>): QueryState<OperationInfiniteData<GetStudyHelperTutorialData, GetStudyHelperTutorialParameters>, GetStudyHelperTutorialError> | undefined;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        setQueryData(parameters: (DeepReadonly<GetStudyHelperTutorialParameters>) | ServiceOperationQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>, updater: Updater<NoInfer<GetStudyHelperTutorialData> | undefined, NoInfer<DeepReadonly<GetStudyHelperTutorialData>> | undefined>, options?: SetDataOptions): GetStudyHelperTutorialData | undefined;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudyHelperTutorialParameters>) | ServiceOperationInfiniteQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudyHelperTutorialData, GetStudyHelperTutorialParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudyHelperTutorialData, GetStudyHelperTutorialParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudyHelperTutorialData, GetStudyHelperTutorialParameters> | undefined;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError> | QueryFiltersByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>, updater: Updater<NoInfer<GetStudyHelperTutorialData> | undefined, NoInfer<GetStudyHelperTutorialData> | undefined>, options?: SetDataOptions): Array<GetStudyHelperTutorialData | undefined>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError> | QueryFiltersByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError> | QueryFiltersByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError> | QueryFiltersByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>): void;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError> | QueryFiltersByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Study Helper Tutorial
         * @description One study helper tutorial by its permalink slug.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError> | QueryFiltersByQueryKey<GetStudyHelperTutorialSchema, GetStudyHelperTutorialData, TInfinite, GetStudyHelperTutorialParameters, GetStudyHelperTutorialError>): number;
        schema: GetStudyHelperTutorialSchema;
        types: {
            parameters: GetStudyHelperTutorialParameters;
            data: GetStudyHelperTutorialData;
            error: GetStudyHelperTutorialError;
        };
    };
    /**
     * @summary List Follow Up Tutorials
     * @description The follow-up tutorials archive, oldest first.
     *
     * Takes no `language`: it serves every row of its kind whatever the reader's interface
     * language.
     *
     * `search` matches the title or the body, case-insensitively. Whitespace-separated
     * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
     */
    listFollowUpTutorials: {
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpTutorialsParameters, TMeta, TSignal> | void), client?: (schema: ListFollowUpTutorialsSchema, options: {
            parameters: ListFollowUpTutorialsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpTutorialsData, ListFollowUpTutorialsError>>): Promise<RequestFnResponse<ListFollowUpTutorialsData, ListFollowUpTutorialsError>>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpTutorialsParameters> | void): ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpTutorials.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpTutorials.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpTutorialsData>(parameters: ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListFollowUpTutorialsData, ListFollowUpTutorialsError, TData, ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpTutorialsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpTutorials.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpTutorials.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpTutorialsData>(parameters: ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void), options: Omit<DefinedInitialDataOptions<ListFollowUpTutorialsData, ListFollowUpTutorialsError, TData, ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpTutorialsError>>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpTutorialsParameters> | void): ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpTutorials.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpTutorialsParameters, TQueryFnData = ListFollowUpTutorialsData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpTutorialsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpTutorialsError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpTutorialsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpTutorials.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpTutorialsParameters, TQueryFnData = ListFollowUpTutorialsData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpTutorialsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpTutorialsError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpTutorialsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpTutorialsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpTutorialsTotal = qraft.v3Service.listFollowUpTutorials.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpTutorialsByParametersTotal = qraft.v3Service.listFollowUpTutorials.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             search: search
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | QueryFiltersByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpTutorialsResults = qraft.v3Service.listFollowUpTutorials.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpTutorialsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpTutorialsCombinedResults = qraft.v3Service.listFollowUpTutorials.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpTutorialsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters, ListFollowUpTutorialsData, ListFollowUpTutorialsError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpTutorialsData, ListFollowUpTutorialsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpTutorialsData, ListFollowUpTutorialsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpTutorials.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpTutorials.useSuspenseQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpTutorialsData>(parameters: ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListFollowUpTutorialsData, ListFollowUpTutorialsError, TData, ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpTutorialsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpTutorials.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpTutorialsParameters, TData = ListFollowUpTutorialsData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpTutorialsData, ListFollowUpTutorialsError, OperationInfiniteData<TData, ListFollowUpTutorialsParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpTutorialsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpTutorialsParameters>, OperationError<ListFollowUpTutorialsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpTutorialsData = qraft.v3Service.listFollowUpTutorials.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpTutorialsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpTutorialsCombinedData = qraft.v3Service.listFollowUpTutorials.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpTutorialsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters, ListFollowUpTutorialsData, ListFollowUpTutorialsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpTutorialsData, ListFollowUpTutorialsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpTutorialsData, ListFollowUpTutorialsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | void): Promise<ListFollowUpTutorialsData>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | void): Promise<void>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | void): Promise<ListFollowUpTutorialsData>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpTutorialsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, ListFollowUpTutorialsParameters, DeepReadonly<TPageParam>, ListFollowUpTutorialsError> | void): Promise<OperationInfiniteData<ListFollowUpTutorialsData, ListFollowUpTutorialsParameters>>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpTutorialsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, ListFollowUpTutorialsParameters, DeepReadonly<TPageParam>, ListFollowUpTutorialsError> | void): Promise<void>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpTutorialsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, ListFollowUpTutorialsParameters, DeepReadonly<TPageParam>, ListFollowUpTutorialsError> | void): Promise<OperationInfiniteData<ListFollowUpTutorialsData, ListFollowUpTutorialsParameters>>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void)): ListFollowUpTutorialsData | undefined;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void)): OperationInfiniteData<ListFollowUpTutorialsData, ListFollowUpTutorialsParameters> | undefined;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | QueryFiltersByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpTutorialsData, ListFollowUpTutorialsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>,
            data: ListFollowUpTutorialsData | undefined
        ]>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | (DeepReadonly<ListFollowUpTutorialsParameters> | void)): QueryState<ListFollowUpTutorialsData, ListFollowUpTutorialsError> | undefined;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpTutorialsParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters> | void): QueryState<OperationInfiniteData<ListFollowUpTutorialsData, ListFollowUpTutorialsParameters>, ListFollowUpTutorialsError> | undefined;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpTutorialsParameters> | undefined) | ServiceOperationQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>, updater: Updater<NoInfer<ListFollowUpTutorialsData> | undefined, NoInfer<DeepReadonly<ListFollowUpTutorialsData>> | undefined>, options?: SetDataOptions): ListFollowUpTutorialsData | undefined;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpTutorialsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpTutorialsData, ListFollowUpTutorialsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpTutorialsData, ListFollowUpTutorialsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpTutorialsData, ListFollowUpTutorialsParameters> | undefined;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | QueryFiltersByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>, updater: Updater<NoInfer<ListFollowUpTutorialsData> | undefined, NoInfer<ListFollowUpTutorialsData> | undefined>, options?: SetDataOptions): Array<ListFollowUpTutorialsData | undefined>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | QueryFiltersByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | QueryFiltersByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | QueryFiltersByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>): void;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | QueryFiltersByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Tutorials
         * @description The follow-up tutorials archive, oldest first.
         *
         * Takes no `language`: it serves every row of its kind whatever the reader's interface
         * language.
         *
         * `search` matches the title or the body, case-insensitively. Whitespace-separated
         * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError> | QueryFiltersByQueryKey<ListFollowUpTutorialsSchema, ListFollowUpTutorialsData, TInfinite, ListFollowUpTutorialsParameters, ListFollowUpTutorialsError>): number;
        schema: ListFollowUpTutorialsSchema;
        types: {
            parameters: ListFollowUpTutorialsParameters;
            data: ListFollowUpTutorialsData;
            error: ListFollowUpTutorialsError;
        };
    };
    /**
     * @summary Get Follow Up Tutorial
     * @description One follow-up tutorial by its permalink slug.
     *
     * 404s for an unknown slug and for a slug that belongs to a post of any other
     * kind — the slug column is shared across all five kinds and is not unique.
     */
    getFollowUpTutorial: {
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetFollowUpTutorialParameters, TMeta, TSignal>), client?: (schema: GetFollowUpTutorialSchema, options: {
            parameters: GetFollowUpTutorialParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetFollowUpTutorialData, GetFollowUpTutorialError>>): Promise<RequestFnResponse<GetFollowUpTutorialData, GetFollowUpTutorialError>>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getQueryKey(parameters: DeepReadonly<GetFollowUpTutorialParameters>): ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpTutorial.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpTutorialData>(parameters: ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>), options?: Omit<UndefinedInitialDataOptions<GetFollowUpTutorialData, GetFollowUpTutorialError, TData, ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetFollowUpTutorialError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpTutorial.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpTutorialData>(parameters: ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>), options: Omit<DefinedInitialDataOptions<GetFollowUpTutorialData, GetFollowUpTutorialError, TData, ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetFollowUpTutorialError>>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetFollowUpTutorialParameters>): ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpTutorial.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpTutorialParameters, TQueryFnData = GetFollowUpTutorialData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpTutorialParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpTutorialError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetFollowUpTutorialError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpTutorial.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpTutorialParameters, TQueryFnData = GetFollowUpTutorialData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpTutorialParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpTutorialError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpTutorialData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetFollowUpTutorialError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getFollowUpTutorialTotal = qraft.v3Service.getFollowUpTutorial.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getFollowUpTutorialByParametersTotal = qraft.v3Service.getFollowUpTutorial.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError> | QueryFiltersByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getFollowUpTutorialResults = qraft.v3Service.getFollowUpTutorial.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpTutorialResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getFollowUpTutorialCombinedResults = qraft.v3Service.getFollowUpTutorial.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpTutorialCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters, GetFollowUpTutorialData, GetFollowUpTutorialError>>, TCombinedResult = Array<UseQueryResult<GetFollowUpTutorialData, GetFollowUpTutorialError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetFollowUpTutorialData, GetFollowUpTutorialError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getFollowUpTutorial.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetFollowUpTutorialData>(parameters: ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>), options?: Omit<UseSuspenseQueryOptions<GetFollowUpTutorialData, GetFollowUpTutorialError, TData, ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetFollowUpTutorialError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpTutorial.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetFollowUpTutorialParameters, TData = GetFollowUpTutorialData>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetFollowUpTutorialData, GetFollowUpTutorialError, OperationInfiniteData<TData, GetFollowUpTutorialParameters>, ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpTutorialData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetFollowUpTutorialParameters>, OperationError<GetFollowUpTutorialError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getFollowUpTutorialData = qraft.v3Service.getFollowUpTutorial.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpTutorialResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getFollowUpTutorialCombinedData = qraft.v3Service.getFollowUpTutorial.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpTutorialCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters, GetFollowUpTutorialData, GetFollowUpTutorialError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetFollowUpTutorialData, GetFollowUpTutorialError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetFollowUpTutorialData, GetFollowUpTutorialError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpTutorialSchema, GetFollowUpTutorialData, GetFollowUpTutorialParameters, GetFollowUpTutorialError>): Promise<GetFollowUpTutorialData>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpTutorialSchema, GetFollowUpTutorialData, GetFollowUpTutorialParameters, GetFollowUpTutorialError>): Promise<void>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetFollowUpTutorialSchema, GetFollowUpTutorialData, GetFollowUpTutorialParameters, GetFollowUpTutorialError>): Promise<GetFollowUpTutorialData>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        fetchInfiniteQuery<TPageParam extends GetFollowUpTutorialParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpTutorialSchema, GetFollowUpTutorialData, GetFollowUpTutorialParameters, DeepReadonly<TPageParam>, GetFollowUpTutorialError>): Promise<OperationInfiniteData<GetFollowUpTutorialData, GetFollowUpTutorialParameters>>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        prefetchInfiniteQuery<TPageParam extends GetFollowUpTutorialParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpTutorialSchema, GetFollowUpTutorialData, GetFollowUpTutorialParameters, DeepReadonly<TPageParam>, GetFollowUpTutorialError>): Promise<void>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        ensureInfiniteQueryData<TPageParam extends GetFollowUpTutorialParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetFollowUpTutorialSchema, GetFollowUpTutorialData, GetFollowUpTutorialParameters, DeepReadonly<TPageParam>, GetFollowUpTutorialError>): Promise<OperationInfiniteData<GetFollowUpTutorialData, GetFollowUpTutorialParameters>>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>)): GetFollowUpTutorialData | undefined;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>)): OperationInfiniteData<GetFollowUpTutorialData, GetFollowUpTutorialParameters> | undefined;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError> | QueryFiltersByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>,
            data: NoInfer<OperationInfiniteData<GetFollowUpTutorialData, GetFollowUpTutorialParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>,
            data: GetFollowUpTutorialData | undefined
        ]>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters> | (DeepReadonly<GetFollowUpTutorialParameters>)): QueryState<GetFollowUpTutorialData, GetFollowUpTutorialError> | undefined;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetFollowUpTutorialParameters> | ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>): QueryState<OperationInfiniteData<GetFollowUpTutorialData, GetFollowUpTutorialParameters>, GetFollowUpTutorialError> | undefined;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        setQueryData(parameters: (DeepReadonly<GetFollowUpTutorialParameters>) | ServiceOperationQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>, updater: Updater<NoInfer<GetFollowUpTutorialData> | undefined, NoInfer<DeepReadonly<GetFollowUpTutorialData>> | undefined>, options?: SetDataOptions): GetFollowUpTutorialData | undefined;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetFollowUpTutorialParameters>) | ServiceOperationInfiniteQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetFollowUpTutorialData, GetFollowUpTutorialParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetFollowUpTutorialData, GetFollowUpTutorialParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetFollowUpTutorialData, GetFollowUpTutorialParameters> | undefined;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError> | QueryFiltersByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>, updater: Updater<NoInfer<GetFollowUpTutorialData> | undefined, NoInfer<GetFollowUpTutorialData> | undefined>, options?: SetDataOptions): Array<GetFollowUpTutorialData | undefined>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError> | QueryFiltersByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError> | QueryFiltersByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError> | QueryFiltersByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>): void;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError> | QueryFiltersByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Follow Up Tutorial
         * @description One follow-up tutorial by its permalink slug.
         *
         * 404s for an unknown slug and for a slug that belongs to a post of any other
         * kind — the slug column is shared across all five kinds and is not unique.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError> | QueryFiltersByQueryKey<GetFollowUpTutorialSchema, GetFollowUpTutorialData, TInfinite, GetFollowUpTutorialParameters, GetFollowUpTutorialError>): number;
        schema: GetFollowUpTutorialSchema;
        types: {
            parameters: GetFollowUpTutorialParameters;
            data: GetFollowUpTutorialData;
            error: GetFollowUpTutorialError;
        };
    };
    /**
     * @summary Get Post Term
     * @description One taxonomy term by its slug.
     *
     * Takes no `language`: a term is one row in one language and its name is printed
     * whatever the reader's interface language, exactly as the legacy term archive's
     * heading does.
     */
    getPostTerm: {
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetPostTermSchema, GetPostTermParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetPostTermParameters, TMeta, TSignal>), client?: (schema: GetPostTermSchema, options: {
            parameters: GetPostTermParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetPostTermData, GetPostTermError>>): Promise<RequestFnResponse<GetPostTermData, GetPostTermError>>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        getQueryKey(parameters: DeepReadonly<GetPostTermParameters>): ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPostTerm.useQuery({
         *     path: {
         *         taxonomy: taxonomy,
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetPostTermData>(parameters: ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>), options?: Omit<UndefinedInitialDataOptions<GetPostTermData, GetPostTermError, TData, ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetPostTermError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPostTerm.useQuery({
         *     path: {
         *         taxonomy: taxonomy,
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetPostTermData>(parameters: ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>), options: Omit<DefinedInitialDataOptions<GetPostTermData, GetPostTermError, TData, ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetPostTermError>>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetPostTermParameters>): ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPostTerm.useInfiniteQuery({
         *     path: {
         *         taxonomy: taxonomy,
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetPostTermParameters, TQueryFnData = GetPostTermData, TData = OperationInfiniteData<TQueryFnData, GetPostTermParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetPostTermError, TData, ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetPostTermError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPostTerm.useInfiniteQuery({
         *     path: {
         *         taxonomy: taxonomy,
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetPostTermParameters, TQueryFnData = GetPostTermData, TData = OperationInfiniteData<TQueryFnData, GetPostTermParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetPostTermError, TData, ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetPostTermData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetPostTermError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getPostTermTotal = qraft.v3Service.getPostTerm.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getPostTermByParametersTotal = qraft.v3Service.getPostTerm.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             taxonomy: taxonomy,
         *             slug: slug
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError> | QueryFiltersByQueryKey<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getPostTermResults = qraft.v3Service.getPostTerm.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 taxonomy: taxonomy1,
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 taxonomy: taxonomy2,
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPostTermResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getPostTermCombinedResults = qraft.v3Service.getPostTerm.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 taxonomy: taxonomy1,
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 taxonomy: taxonomy2,
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPostTermCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetPostTermSchema, GetPostTermParameters, GetPostTermData, GetPostTermError>>, TCombinedResult = Array<UseQueryResult<GetPostTermData, GetPostTermError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetPostTermData, GetPostTermError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getPostTerm.useSuspenseQuery({
         *     path: {
         *         taxonomy: taxonomy,
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetPostTermData>(parameters: ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>), options?: Omit<UseSuspenseQueryOptions<GetPostTermData, GetPostTermError, TData, ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetPostTermError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPostTerm.useSuspenseInfiniteQuery({
         *     path: {
         *         taxonomy: taxonomy,
         *         slug: slug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetPostTermParameters, TData = GetPostTermData>(parameters: ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetPostTermData, GetPostTermError, OperationInfiniteData<TData, GetPostTermParameters>, ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetPostTermData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetPostTermParameters>, OperationError<GetPostTermError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getPostTermData = qraft.v3Service.getPostTerm.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 taxonomy: taxonomy1,
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 taxonomy: taxonomy2,
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPostTermResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getPostTermCombinedData = qraft.v3Service.getPostTerm.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 taxonomy: taxonomy1,
         *                 slug: slug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 taxonomy: taxonomy2,
         *                 slug: slug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPostTermCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetPostTermSchema, GetPostTermParameters, GetPostTermData, GetPostTermError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetPostTermData, GetPostTermError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetPostTermData, GetPostTermError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetPostTermSchema, GetPostTermData, GetPostTermParameters, GetPostTermError>): Promise<GetPostTermData>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetPostTermSchema, GetPostTermData, GetPostTermParameters, GetPostTermError>): Promise<void>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetPostTermSchema, GetPostTermData, GetPostTermParameters, GetPostTermError>): Promise<GetPostTermData>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        fetchInfiniteQuery<TPageParam extends GetPostTermParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetPostTermSchema, GetPostTermData, GetPostTermParameters, DeepReadonly<TPageParam>, GetPostTermError>): Promise<OperationInfiniteData<GetPostTermData, GetPostTermParameters>>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        prefetchInfiniteQuery<TPageParam extends GetPostTermParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetPostTermSchema, GetPostTermData, GetPostTermParameters, DeepReadonly<TPageParam>, GetPostTermError>): Promise<void>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        ensureInfiniteQueryData<TPageParam extends GetPostTermParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetPostTermSchema, GetPostTermData, GetPostTermParameters, DeepReadonly<TPageParam>, GetPostTermError>): Promise<OperationInfiniteData<GetPostTermData, GetPostTermParameters>>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>)): GetPostTermData | undefined;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>)): OperationInfiniteData<GetPostTermData, GetPostTermParameters> | undefined;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError> | QueryFiltersByQueryKey<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters>,
            data: NoInfer<OperationInfiniteData<GetPostTermData, GetPostTermParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters>,
            data: GetPostTermData | undefined
        ]>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters> | (DeepReadonly<GetPostTermParameters>)): QueryState<GetPostTermData, GetPostTermError> | undefined;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetPostTermParameters> | ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters>): QueryState<OperationInfiniteData<GetPostTermData, GetPostTermParameters>, GetPostTermError> | undefined;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        setQueryData(parameters: (DeepReadonly<GetPostTermParameters>) | ServiceOperationQueryKey<GetPostTermSchema, GetPostTermParameters>, updater: Updater<NoInfer<GetPostTermData> | undefined, NoInfer<DeepReadonly<GetPostTermData>> | undefined>, options?: SetDataOptions): GetPostTermData | undefined;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetPostTermParameters>) | ServiceOperationInfiniteQueryKey<GetPostTermSchema, GetPostTermParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetPostTermData, GetPostTermParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetPostTermData, GetPostTermParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetPostTermData, GetPostTermParameters> | undefined;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError> | QueryFiltersByQueryKey<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>, updater: Updater<NoInfer<GetPostTermData> | undefined, NoInfer<GetPostTermData> | undefined>, options?: SetDataOptions): Array<GetPostTermData | undefined>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError> | QueryFiltersByQueryKey<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError> | QueryFiltersByQueryKey<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError> | QueryFiltersByQueryKey<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>): void;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError> | QueryFiltersByQueryKey<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Post Term
         * @description One taxonomy term by its slug.
         *
         * Takes no `language`: a term is one row in one language and its name is printed
         * whatever the reader's interface language, exactly as the legacy term archive's
         * heading does.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError> | QueryFiltersByQueryKey<GetPostTermSchema, GetPostTermData, TInfinite, GetPostTermParameters, GetPostTermError>): number;
        schema: GetPostTermSchema;
        types: {
            parameters: GetPostTermParameters;
            data: GetPostTermData;
            error: GetPostTermError;
        };
    };
    /**
     * @summary Get Archive Sidebar
     * @description One archive's sidebar widgets, in stored order, with their content.
     *
     * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
     * taxonomy-terms widget keeps its heading even when no term survives the language and
     * non-empty filters, as in legacy.
     */
    getArchiveSidebar: {
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetArchiveSidebarParameters, TMeta, TSignal>), client?: (schema: GetArchiveSidebarSchema, options: {
            parameters: GetArchiveSidebarParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetArchiveSidebarData, GetArchiveSidebarError>>): Promise<RequestFnResponse<GetArchiveSidebarData, GetArchiveSidebarError>>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        getQueryKey(parameters: DeepReadonly<GetArchiveSidebarParameters>): ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getArchiveSidebar.useQuery({
         *     path: {
         *         sidebar: sidebar
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetArchiveSidebarData>(parameters: ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>), options?: Omit<UndefinedInitialDataOptions<GetArchiveSidebarData, GetArchiveSidebarError, TData, ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetArchiveSidebarError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getArchiveSidebar.useQuery({
         *     path: {
         *         sidebar: sidebar
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetArchiveSidebarData>(parameters: ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>), options: Omit<DefinedInitialDataOptions<GetArchiveSidebarData, GetArchiveSidebarError, TData, ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetArchiveSidebarError>>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetArchiveSidebarParameters>): ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getArchiveSidebar.useInfiniteQuery({
         *     path: {
         *         sidebar: sidebar
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetArchiveSidebarParameters, TQueryFnData = GetArchiveSidebarData, TData = OperationInfiniteData<TQueryFnData, GetArchiveSidebarParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetArchiveSidebarError, TData, ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetArchiveSidebarError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getArchiveSidebar.useInfiniteQuery({
         *     path: {
         *         sidebar: sidebar
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetArchiveSidebarParameters, TQueryFnData = GetArchiveSidebarData, TData = OperationInfiniteData<TQueryFnData, GetArchiveSidebarParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetArchiveSidebarError, TData, ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetArchiveSidebarData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetArchiveSidebarError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getArchiveSidebarTotal = qraft.v3Service.getArchiveSidebar.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getArchiveSidebarByParametersTotal = qraft.v3Service.getArchiveSidebar.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             sidebar: sidebar
         *         },
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError> | QueryFiltersByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getArchiveSidebarResults = qraft.v3Service.getArchiveSidebar.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 sidebar: sidebar1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 sidebar: sidebar2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getArchiveSidebarResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getArchiveSidebarCombinedResults = qraft.v3Service.getArchiveSidebar.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 sidebar: sidebar1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 sidebar: sidebar2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getArchiveSidebarCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetArchiveSidebarSchema, GetArchiveSidebarParameters, GetArchiveSidebarData, GetArchiveSidebarError>>, TCombinedResult = Array<UseQueryResult<GetArchiveSidebarData, GetArchiveSidebarError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetArchiveSidebarData, GetArchiveSidebarError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getArchiveSidebar.useSuspenseQuery({
         *     path: {
         *         sidebar: sidebar
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetArchiveSidebarData>(parameters: ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>), options?: Omit<UseSuspenseQueryOptions<GetArchiveSidebarData, GetArchiveSidebarError, TData, ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetArchiveSidebarError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getArchiveSidebar.useSuspenseInfiniteQuery({
         *     path: {
         *         sidebar: sidebar
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetArchiveSidebarParameters, TData = GetArchiveSidebarData>(parameters: ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetArchiveSidebarData, GetArchiveSidebarError, OperationInfiniteData<TData, GetArchiveSidebarParameters>, ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetArchiveSidebarData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetArchiveSidebarParameters>, OperationError<GetArchiveSidebarError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getArchiveSidebarData = qraft.v3Service.getArchiveSidebar.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 sidebar: sidebar1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 sidebar: sidebar2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getArchiveSidebarResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getArchiveSidebarCombinedData = qraft.v3Service.getArchiveSidebar.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 sidebar: sidebar1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 sidebar: sidebar2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getArchiveSidebarCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetArchiveSidebarSchema, GetArchiveSidebarParameters, GetArchiveSidebarData, GetArchiveSidebarError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetArchiveSidebarData, GetArchiveSidebarError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetArchiveSidebarData, GetArchiveSidebarError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetArchiveSidebarSchema, GetArchiveSidebarData, GetArchiveSidebarParameters, GetArchiveSidebarError>): Promise<GetArchiveSidebarData>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetArchiveSidebarSchema, GetArchiveSidebarData, GetArchiveSidebarParameters, GetArchiveSidebarError>): Promise<void>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetArchiveSidebarSchema, GetArchiveSidebarData, GetArchiveSidebarParameters, GetArchiveSidebarError>): Promise<GetArchiveSidebarData>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        fetchInfiniteQuery<TPageParam extends GetArchiveSidebarParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetArchiveSidebarSchema, GetArchiveSidebarData, GetArchiveSidebarParameters, DeepReadonly<TPageParam>, GetArchiveSidebarError>): Promise<OperationInfiniteData<GetArchiveSidebarData, GetArchiveSidebarParameters>>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        prefetchInfiniteQuery<TPageParam extends GetArchiveSidebarParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetArchiveSidebarSchema, GetArchiveSidebarData, GetArchiveSidebarParameters, DeepReadonly<TPageParam>, GetArchiveSidebarError>): Promise<void>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        ensureInfiniteQueryData<TPageParam extends GetArchiveSidebarParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetArchiveSidebarSchema, GetArchiveSidebarData, GetArchiveSidebarParameters, DeepReadonly<TPageParam>, GetArchiveSidebarError>): Promise<OperationInfiniteData<GetArchiveSidebarData, GetArchiveSidebarParameters>>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>)): GetArchiveSidebarData | undefined;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>)): OperationInfiniteData<GetArchiveSidebarData, GetArchiveSidebarParameters> | undefined;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError> | QueryFiltersByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>,
            data: NoInfer<OperationInfiniteData<GetArchiveSidebarData, GetArchiveSidebarParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>,
            data: GetArchiveSidebarData | undefined
        ]>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters> | (DeepReadonly<GetArchiveSidebarParameters>)): QueryState<GetArchiveSidebarData, GetArchiveSidebarError> | undefined;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetArchiveSidebarParameters> | ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>): QueryState<OperationInfiniteData<GetArchiveSidebarData, GetArchiveSidebarParameters>, GetArchiveSidebarError> | undefined;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        setQueryData(parameters: (DeepReadonly<GetArchiveSidebarParameters>) | ServiceOperationQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>, updater: Updater<NoInfer<GetArchiveSidebarData> | undefined, NoInfer<DeepReadonly<GetArchiveSidebarData>> | undefined>, options?: SetDataOptions): GetArchiveSidebarData | undefined;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetArchiveSidebarParameters>) | ServiceOperationInfiniteQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetArchiveSidebarData, GetArchiveSidebarParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetArchiveSidebarData, GetArchiveSidebarParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetArchiveSidebarData, GetArchiveSidebarParameters> | undefined;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError> | QueryFiltersByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>, updater: Updater<NoInfer<GetArchiveSidebarData> | undefined, NoInfer<GetArchiveSidebarData> | undefined>, options?: SetDataOptions): Array<GetArchiveSidebarData | undefined>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError> | QueryFiltersByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError> | QueryFiltersByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError> | QueryFiltersByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>): void;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError> | QueryFiltersByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Archive Sidebar
         * @description One archive's sidebar widgets, in stored order, with their content.
         *
         * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
         * taxonomy-terms widget keeps its heading even when no term survives the language and
         * non-empty filters, as in legacy.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError> | QueryFiltersByQueryKey<GetArchiveSidebarSchema, GetArchiveSidebarData, TInfinite, GetArchiveSidebarParameters, GetArchiveSidebarError>): number;
        schema: GetArchiveSidebarSchema;
        types: {
            parameters: GetArchiveSidebarParameters;
            data: GetArchiveSidebarData;
            error: GetArchiveSidebarError;
        };
    };
    /**
     * @summary Get Students
     * @description Every student, for the admin console.
     *
     * `tags` is always empty here, since tags are group-scoped and this list has no group.
     * `study_helper` and `adopted` are joined in on the same query.
     */
    getStudents: {
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentsSchema, GetStudentsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentsParameters, TMeta, TSignal> | void), client?: (schema: GetStudentsSchema, options: {
            parameters: GetStudentsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentsData, GetStudentsError>>): Promise<RequestFnResponse<GetStudentsData, GetStudentsError>>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentsParameters> | void): ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudents.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudents.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentsData>(parameters: ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetStudentsData, GetStudentsError, TData, ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudents.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudents.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentsData>(parameters: ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void), options: Omit<DefinedInitialDataOptions<GetStudentsData, GetStudentsError, TData, ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentsError>>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentsParameters> | void): ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudents.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentsParameters, TQueryFnData = GetStudentsData, TData = OperationInfiniteData<TQueryFnData, GetStudentsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentsError, TData, ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudents.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentsParameters, TQueryFnData = GetStudentsData, TData = OperationInfiniteData<TQueryFnData, GetStudentsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentsError, TData, ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentsTotal = qraft.v3Service.getStudents.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentsByParametersTotal = qraft.v3Service.getStudents.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             search: search
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError> | QueryFiltersByQueryKey<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentsResults = qraft.v3Service.getStudents.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentsCombinedResults = qraft.v3Service.getStudents.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentsSchema, GetStudentsParameters, GetStudentsData, GetStudentsError>>, TCombinedResult = Array<UseQueryResult<GetStudentsData, GetStudentsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentsData, GetStudentsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getStudents.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudents.useSuspenseQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentsData>(parameters: ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetStudentsData, GetStudentsError, TData, ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudents.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentsParameters, TData = GetStudentsData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentsData, GetStudentsError, OperationInfiniteData<TData, GetStudentsParameters>, ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentsParameters>, OperationError<GetStudentsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentsData = qraft.v3Service.getStudents.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentsCombinedData = qraft.v3Service.getStudents.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentsSchema, GetStudentsParameters, GetStudentsData, GetStudentsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentsData, GetStudentsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentsData, GetStudentsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentsSchema, GetStudentsData, GetStudentsParameters, GetStudentsError> | void): Promise<GetStudentsData>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentsSchema, GetStudentsData, GetStudentsParameters, GetStudentsError> | void): Promise<void>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentsSchema, GetStudentsData, GetStudentsParameters, GetStudentsError> | void): Promise<GetStudentsData>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentsSchema, GetStudentsData, GetStudentsParameters, DeepReadonly<TPageParam>, GetStudentsError> | void): Promise<OperationInfiniteData<GetStudentsData, GetStudentsParameters>>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentsSchema, GetStudentsData, GetStudentsParameters, DeepReadonly<TPageParam>, GetStudentsError> | void): Promise<void>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentsSchema, GetStudentsData, GetStudentsParameters, DeepReadonly<TPageParam>, GetStudentsError> | void): Promise<OperationInfiniteData<GetStudentsData, GetStudentsParameters>>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void)): GetStudentsData | undefined;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void)): OperationInfiniteData<GetStudentsData, GetStudentsParameters> | undefined;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError> | QueryFiltersByQueryKey<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentsData, GetStudentsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters>,
            data: GetStudentsData | undefined
        ]>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters> | (DeepReadonly<GetStudentsParameters> | void)): QueryState<GetStudentsData, GetStudentsError> | undefined;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentsParameters> | ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters> | void): QueryState<OperationInfiniteData<GetStudentsData, GetStudentsParameters>, GetStudentsError> | undefined;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentsParameters> | undefined) | ServiceOperationQueryKey<GetStudentsSchema, GetStudentsParameters>, updater: Updater<NoInfer<GetStudentsData> | undefined, NoInfer<DeepReadonly<GetStudentsData>> | undefined>, options?: SetDataOptions): GetStudentsData | undefined;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetStudentsSchema, GetStudentsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentsData, GetStudentsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentsData, GetStudentsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentsData, GetStudentsParameters> | undefined;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError> | QueryFiltersByQueryKey<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>, updater: Updater<NoInfer<GetStudentsData> | undefined, NoInfer<GetStudentsData> | undefined>, options?: SetDataOptions): Array<GetStudentsData | undefined>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError> | QueryFiltersByQueryKey<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError> | QueryFiltersByQueryKey<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError> | QueryFiltersByQueryKey<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>): void;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError> | QueryFiltersByQueryKey<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Students
         * @description Every student, for the admin console.
         *
         * `tags` is always empty here, since tags are group-scoped and this list has no group.
         * `study_helper` and `adopted` are joined in on the same query.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError> | QueryFiltersByQueryKey<GetStudentsSchema, GetStudentsData, TInfinite, GetStudentsParameters, GetStudentsError>): number;
        schema: GetStudentsSchema;
        types: {
            parameters: GetStudentsParameters;
            data: GetStudentsData;
            error: GetStudentsError;
        };
    };
    /** @summary Get Student */
    getStudent: {
        /** @summary Get Student */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentSchema, GetStudentParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentParameters, TMeta, TSignal>), client?: (schema: GetStudentSchema, options: {
            parameters: GetStudentParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentData, GetStudentError>>): Promise<RequestFnResponse<GetStudentData, GetStudentError>>;
        /** @summary Get Student */
        getQueryKey(parameters: DeepReadonly<GetStudentParameters>): ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudent.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentData>(parameters: ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentData, GetStudentError, TData, ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudent.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentData>(parameters: ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>), options: Omit<DefinedInitialDataOptions<GetStudentData, GetStudentError, TData, ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentError>>;
        /** @summary Get Student */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentParameters>): ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudent.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentParameters, TQueryFnData = GetStudentData, TData = OperationInfiniteData<TQueryFnData, GetStudentParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentError, TData, ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudent.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentParameters, TQueryFnData = GetStudentData, TData = OperationInfiniteData<TQueryFnData, GetStudentParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentError, TData, ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentTotal = qraft.v3Service.getStudent.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentByParametersTotal = qraft.v3Service.getStudent.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError> | QueryFiltersByQueryKey<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentResults = qraft.v3Service.getStudent.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentCombinedResults = qraft.v3Service.getStudent.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentSchema, GetStudentParameters, GetStudentData, GetStudentError>>, TCombinedResult = Array<UseQueryResult<GetStudentData, GetStudentError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentData, GetStudentError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudent.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentData>(parameters: ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentData, GetStudentError, TData, ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudent.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentParameters, TData = GetStudentData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentData, GetStudentError, OperationInfiniteData<TData, GetStudentParameters>, ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentParameters>, OperationError<GetStudentError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentData = qraft.v3Service.getStudent.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentCombinedData = qraft.v3Service.getStudent.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentSchema, GetStudentParameters, GetStudentData, GetStudentError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentData, GetStudentError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentData, GetStudentError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Student */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentSchema, GetStudentData, GetStudentParameters, GetStudentError>): Promise<GetStudentData>;
        /** @summary Get Student */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentSchema, GetStudentData, GetStudentParameters, GetStudentError>): Promise<void>;
        /** @summary Get Student */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentSchema, GetStudentData, GetStudentParameters, GetStudentError>): Promise<GetStudentData>;
        /** @summary Get Student */
        fetchInfiniteQuery<TPageParam extends GetStudentParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentSchema, GetStudentData, GetStudentParameters, DeepReadonly<TPageParam>, GetStudentError>): Promise<OperationInfiniteData<GetStudentData, GetStudentParameters>>;
        /** @summary Get Student */
        prefetchInfiniteQuery<TPageParam extends GetStudentParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentSchema, GetStudentData, GetStudentParameters, DeepReadonly<TPageParam>, GetStudentError>): Promise<void>;
        /** @summary Get Student */
        ensureInfiniteQueryData<TPageParam extends GetStudentParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentSchema, GetStudentData, GetStudentParameters, DeepReadonly<TPageParam>, GetStudentError>): Promise<OperationInfiniteData<GetStudentData, GetStudentParameters>>;
        /** @summary Get Student */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>)): GetStudentData | undefined;
        /** @summary Get Student */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>)): OperationInfiniteData<GetStudentData, GetStudentParameters> | undefined;
        /** @summary Get Student */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError> | QueryFiltersByQueryKey<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentData, GetStudentParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters>,
            data: GetStudentData | undefined
        ]>;
        /** @summary Get Student */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters> | (DeepReadonly<GetStudentParameters>)): QueryState<GetStudentData, GetStudentError> | undefined;
        /** @summary Get Student */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentParameters> | ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters>): QueryState<OperationInfiniteData<GetStudentData, GetStudentParameters>, GetStudentError> | undefined;
        /** @summary Get Student */
        setQueryData(parameters: (DeepReadonly<GetStudentParameters>) | ServiceOperationQueryKey<GetStudentSchema, GetStudentParameters>, updater: Updater<NoInfer<GetStudentData> | undefined, NoInfer<DeepReadonly<GetStudentData>> | undefined>, options?: SetDataOptions): GetStudentData | undefined;
        /** @summary Get Student */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentParameters>) | ServiceOperationInfiniteQueryKey<GetStudentSchema, GetStudentParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentData, GetStudentParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentData, GetStudentParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentData, GetStudentParameters> | undefined;
        /** @summary Get Student */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError> | QueryFiltersByQueryKey<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>, updater: Updater<NoInfer<GetStudentData> | undefined, NoInfer<GetStudentData> | undefined>, options?: SetDataOptions): Array<GetStudentData | undefined>;
        /** @summary Get Student */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Student */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError> | QueryFiltersByQueryKey<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Student */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError> | QueryFiltersByQueryKey<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Student */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError> | QueryFiltersByQueryKey<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>): void;
        /** @summary Get Student */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError> | QueryFiltersByQueryKey<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Student */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError> | QueryFiltersByQueryKey<GetStudentSchema, GetStudentData, TInfinite, GetStudentParameters, GetStudentError>): number;
        schema: GetStudentSchema;
        types: {
            parameters: GetStudentParameters;
            data: GetStudentData;
            error: GetStudentError;
        };
    };
    /** @summary Set Student Study Helper */
    setStudentStudyHelper: {
        /** @summary Set Student Study Helper */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetStudentStudyHelperBody, SetStudentStudyHelperParameters, TMeta, TSignal>, client?: (schema: SetStudentStudyHelperSchema, options: ServiceOperationMutationFnOptions<SetStudentStudyHelperBody, SetStudentStudyHelperParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetStudentStudyHelperData, SetStudentStudyHelperError>>): Promise<RequestFnResponse<SetStudentStudyHelperData, SetStudentStudyHelperError>>;
        /** @summary Set Student Study Helper */
        getMutationKey(parameters: DeepReadonly<SetStudentStudyHelperParameters> | void): ServiceOperationMutationKey<SetStudentStudyHelperSchema, SetStudentStudyHelperParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Student Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentStudyHelper.useMutation({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentStudyHelper.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetStudentStudyHelperBody, TContext = unknown>(parameters: DeepReadonly<SetStudentStudyHelperParameters>, options?: ServiceOperationUseMutationOptions<SetStudentStudyHelperSchema, SetStudentStudyHelperData, SetStudentStudyHelperParameters, TVariables, OperationError<SetStudentStudyHelperError>, TContext>): UseMutationResult<SetStudentStudyHelperData, OperationError<SetStudentStudyHelperError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Student Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentStudyHelper.useMutation({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentStudyHelper.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetStudentStudyHelperBody, SetStudentStudyHelperParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetStudentStudyHelperSchema, SetStudentStudyHelperData, SetStudentStudyHelperParameters, TVariables, OperationError<SetStudentStudyHelperError>, TContext>): UseMutationResult<SetStudentStudyHelperData, OperationError<SetStudentStudyHelperError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set Student Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setStudentStudyHelperTotal = qraft.v3Service.setStudentStudyHelper.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setStudentStudyHelperTotal = qraft.v3Service.setStudentStudyHelper.useIsMutating({
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext> | MutationFiltersByMutationKey<SetStudentStudyHelperSchema, SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set Student Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setStudentStudyHelperPendingMutationVariables = qraft.v3Service.setStudentStudyHelper.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setStudentStudyHelperMutationData = qraft.v3Service.setStudentStudyHelper.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 student_id: studentId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetStudentStudyHelperData, OperationError<SetStudentStudyHelperError>, MutationVariables<SetStudentStudyHelperBody, SetStudentStudyHelperParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext> | MutationFiltersByMutationKey<SetStudentStudyHelperSchema, SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext>;
            select?: (mutation: Mutation<SetStudentStudyHelperData, OperationError<SetStudentStudyHelperError>, MutationVariables<SetStudentStudyHelperBody, SetStudentStudyHelperParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Set Student Study Helper */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext> | MutationFiltersByMutationKey<SetStudentStudyHelperSchema, SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set Student Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setStudentStudyHelper.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setStudentStudyHelper.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext> | MutationFiltersByMutationKey<SetStudentStudyHelperSchema, SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext>): Mutation<SetStudentStudyHelperData, SetStudentStudyHelperError, MutationVariables<SetStudentStudyHelperBody, SetStudentStudyHelperParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext> | MutationFiltersByMutationKey<SetStudentStudyHelperSchema, SetStudentStudyHelperBody, SetStudentStudyHelperData, SetStudentStudyHelperParameters, OperationError<SetStudentStudyHelperError>, TContext>): Array<Mutation<SetStudentStudyHelperData, SetStudentStudyHelperError, MutationVariables<SetStudentStudyHelperBody, SetStudentStudyHelperParameters>, TContext>>;
        };
        schema: SetStudentStudyHelperSchema;
        types: {
            parameters: SetStudentStudyHelperParameters;
            data: SetStudentStudyHelperData;
            error: SetStudentStudyHelperError;
            body: SetStudentStudyHelperBody;
        };
    };
    /**
     * @summary Get Student Study Helper
     * @description The student's currently-assigned study helper.
     *
     * 404 when the student does not exist, is not a student, has no helper
     * assigned, or the caller may not see them -- one answer for all four.
     */
    getStudentStudyHelper: {
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentStudyHelperParameters, TMeta, TSignal>), client?: (schema: GetStudentStudyHelperSchema, options: {
            parameters: GetStudentStudyHelperParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentStudyHelperData, GetStudentStudyHelperError>>): Promise<RequestFnResponse<GetStudentStudyHelperData, GetStudentStudyHelperError>>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentStudyHelperParameters>): ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentStudyHelper.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentStudyHelperData>(parameters: ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentStudyHelperData, GetStudentStudyHelperError, TData, ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentStudyHelperError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentStudyHelper.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentStudyHelperData>(parameters: ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>), options: Omit<DefinedInitialDataOptions<GetStudentStudyHelperData, GetStudentStudyHelperError, TData, ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentStudyHelperError>>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentStudyHelperParameters>): ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyHelper.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentStudyHelperParameters, TQueryFnData = GetStudentStudyHelperData, TData = OperationInfiniteData<TQueryFnData, GetStudentStudyHelperParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentStudyHelperError, TData, ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentStudyHelperError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyHelper.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentStudyHelperParameters, TQueryFnData = GetStudentStudyHelperData, TData = OperationInfiniteData<TQueryFnData, GetStudentStudyHelperParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentStudyHelperError, TData, ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentStudyHelperData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentStudyHelperError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentStudyHelperTotal = qraft.v3Service.getStudentStudyHelper.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentStudyHelperByParametersTotal = qraft.v3Service.getStudentStudyHelper.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError> | QueryFiltersByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentStudyHelperResults = qraft.v3Service.getStudentStudyHelper.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyHelperResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentStudyHelperCombinedResults = qraft.v3Service.getStudentStudyHelper.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyHelperCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters, GetStudentStudyHelperData, GetStudentStudyHelperError>>, TCombinedResult = Array<UseQueryResult<GetStudentStudyHelperData, GetStudentStudyHelperError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentStudyHelperData, GetStudentStudyHelperError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentStudyHelper.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentStudyHelperData>(parameters: ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentStudyHelperData, GetStudentStudyHelperError, TData, ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentStudyHelperError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyHelper.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentStudyHelperParameters, TData = GetStudentStudyHelperData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentStudyHelperData, GetStudentStudyHelperError, OperationInfiniteData<TData, GetStudentStudyHelperParameters>, ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentStudyHelperData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentStudyHelperParameters>, OperationError<GetStudentStudyHelperError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentStudyHelperData = qraft.v3Service.getStudentStudyHelper.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyHelperResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentStudyHelperCombinedData = qraft.v3Service.getStudentStudyHelper.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyHelperCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters, GetStudentStudyHelperData, GetStudentStudyHelperError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentStudyHelperData, GetStudentStudyHelperError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentStudyHelperData, GetStudentStudyHelperError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentStudyHelperSchema, GetStudentStudyHelperData, GetStudentStudyHelperParameters, GetStudentStudyHelperError>): Promise<GetStudentStudyHelperData>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentStudyHelperSchema, GetStudentStudyHelperData, GetStudentStudyHelperParameters, GetStudentStudyHelperError>): Promise<void>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentStudyHelperSchema, GetStudentStudyHelperData, GetStudentStudyHelperParameters, GetStudentStudyHelperError>): Promise<GetStudentStudyHelperData>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentStudyHelperParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentStudyHelperSchema, GetStudentStudyHelperData, GetStudentStudyHelperParameters, DeepReadonly<TPageParam>, GetStudentStudyHelperError>): Promise<OperationInfiniteData<GetStudentStudyHelperData, GetStudentStudyHelperParameters>>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentStudyHelperParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentStudyHelperSchema, GetStudentStudyHelperData, GetStudentStudyHelperParameters, DeepReadonly<TPageParam>, GetStudentStudyHelperError>): Promise<void>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentStudyHelperParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentStudyHelperSchema, GetStudentStudyHelperData, GetStudentStudyHelperParameters, DeepReadonly<TPageParam>, GetStudentStudyHelperError>): Promise<OperationInfiniteData<GetStudentStudyHelperData, GetStudentStudyHelperParameters>>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>)): GetStudentStudyHelperData | undefined;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>)): OperationInfiniteData<GetStudentStudyHelperData, GetStudentStudyHelperParameters> | undefined;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError> | QueryFiltersByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentStudyHelperData, GetStudentStudyHelperParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>,
            data: GetStudentStudyHelperData | undefined
        ]>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters> | (DeepReadonly<GetStudentStudyHelperParameters>)): QueryState<GetStudentStudyHelperData, GetStudentStudyHelperError> | undefined;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentStudyHelperParameters> | ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>): QueryState<OperationInfiniteData<GetStudentStudyHelperData, GetStudentStudyHelperParameters>, GetStudentStudyHelperError> | undefined;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentStudyHelperParameters>) | ServiceOperationQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>, updater: Updater<NoInfer<GetStudentStudyHelperData> | undefined, NoInfer<DeepReadonly<GetStudentStudyHelperData>> | undefined>, options?: SetDataOptions): GetStudentStudyHelperData | undefined;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentStudyHelperParameters>) | ServiceOperationInfiniteQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentStudyHelperData, GetStudentStudyHelperParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentStudyHelperData, GetStudentStudyHelperParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentStudyHelperData, GetStudentStudyHelperParameters> | undefined;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError> | QueryFiltersByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>, updater: Updater<NoInfer<GetStudentStudyHelperData> | undefined, NoInfer<GetStudentStudyHelperData> | undefined>, options?: SetDataOptions): Array<GetStudentStudyHelperData | undefined>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError> | QueryFiltersByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError> | QueryFiltersByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError> | QueryFiltersByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>): void;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError> | QueryFiltersByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Study Helper
         * @description The student's currently-assigned study helper.
         *
         * 404 when the student does not exist, is not a student, has no helper
         * assigned, or the caller may not see them -- one answer for all four.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError> | QueryFiltersByQueryKey<GetStudentStudyHelperSchema, GetStudentStudyHelperData, TInfinite, GetStudentStudyHelperParameters, GetStudentStudyHelperError>): number;
        schema: GetStudentStudyHelperSchema;
        types: {
            parameters: GetStudentStudyHelperParameters;
            data: GetStudentStudyHelperData;
            error: GetStudentStudyHelperError;
        };
    };
    /**
     * @summary Get Student Viewer Access
     * @description Whether the caller may open this student's supervisory pages.
     *
     * Answers 200 for every authenticated caller, so the web route and the sidebar
     * can gate on one query instead of reading a status code. Same audience as the
     * two study-helper operations, so this probe cannot say yes to a viewer they
     * then 404.
     */
    getStudentViewerAccess: {
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentViewerAccessParameters, TMeta, TSignal>), client?: (schema: GetStudentViewerAccessSchema, options: {
            parameters: GetStudentViewerAccessParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentViewerAccessData, GetStudentViewerAccessError>>): Promise<RequestFnResponse<GetStudentViewerAccessData, GetStudentViewerAccessError>>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentViewerAccessParameters>): ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentViewerAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentViewerAccessData>(parameters: ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentViewerAccessData, GetStudentViewerAccessError, TData, ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentViewerAccessError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentViewerAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentViewerAccessData>(parameters: ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>), options: Omit<DefinedInitialDataOptions<GetStudentViewerAccessData, GetStudentViewerAccessError, TData, ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentViewerAccessError>>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentViewerAccessParameters>): ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentViewerAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentViewerAccessParameters, TQueryFnData = GetStudentViewerAccessData, TData = OperationInfiniteData<TQueryFnData, GetStudentViewerAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentViewerAccessError, TData, ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentViewerAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentViewerAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentViewerAccessParameters, TQueryFnData = GetStudentViewerAccessData, TData = OperationInfiniteData<TQueryFnData, GetStudentViewerAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentViewerAccessError, TData, ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentViewerAccessData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentViewerAccessError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentViewerAccessTotal = qraft.v3Service.getStudentViewerAccess.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentViewerAccessByParametersTotal = qraft.v3Service.getStudentViewerAccess.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError> | QueryFiltersByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentViewerAccessResults = qraft.v3Service.getStudentViewerAccess.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentViewerAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentViewerAccessCombinedResults = qraft.v3Service.getStudentViewerAccess.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentViewerAccessCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters, GetStudentViewerAccessData, GetStudentViewerAccessError>>, TCombinedResult = Array<UseQueryResult<GetStudentViewerAccessData, GetStudentViewerAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentViewerAccessData, GetStudentViewerAccessError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentViewerAccess.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentViewerAccessData>(parameters: ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentViewerAccessData, GetStudentViewerAccessError, TData, ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentViewerAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentViewerAccess.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentViewerAccessParameters, TData = GetStudentViewerAccessData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentViewerAccessData, GetStudentViewerAccessError, OperationInfiniteData<TData, GetStudentViewerAccessParameters>, ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentViewerAccessData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentViewerAccessParameters>, OperationError<GetStudentViewerAccessError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentViewerAccessData = qraft.v3Service.getStudentViewerAccess.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentViewerAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentViewerAccessCombinedData = qraft.v3Service.getStudentViewerAccess.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentViewerAccessCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters, GetStudentViewerAccessData, GetStudentViewerAccessError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentViewerAccessData, GetStudentViewerAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentViewerAccessData, GetStudentViewerAccessError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentViewerAccessSchema, GetStudentViewerAccessData, GetStudentViewerAccessParameters, GetStudentViewerAccessError>): Promise<GetStudentViewerAccessData>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentViewerAccessSchema, GetStudentViewerAccessData, GetStudentViewerAccessParameters, GetStudentViewerAccessError>): Promise<void>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentViewerAccessSchema, GetStudentViewerAccessData, GetStudentViewerAccessParameters, GetStudentViewerAccessError>): Promise<GetStudentViewerAccessData>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentViewerAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentViewerAccessSchema, GetStudentViewerAccessData, GetStudentViewerAccessParameters, DeepReadonly<TPageParam>, GetStudentViewerAccessError>): Promise<OperationInfiniteData<GetStudentViewerAccessData, GetStudentViewerAccessParameters>>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentViewerAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentViewerAccessSchema, GetStudentViewerAccessData, GetStudentViewerAccessParameters, DeepReadonly<TPageParam>, GetStudentViewerAccessError>): Promise<void>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentViewerAccessParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentViewerAccessSchema, GetStudentViewerAccessData, GetStudentViewerAccessParameters, DeepReadonly<TPageParam>, GetStudentViewerAccessError>): Promise<OperationInfiniteData<GetStudentViewerAccessData, GetStudentViewerAccessParameters>>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>)): GetStudentViewerAccessData | undefined;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>)): OperationInfiniteData<GetStudentViewerAccessData, GetStudentViewerAccessParameters> | undefined;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError> | QueryFiltersByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentViewerAccessData, GetStudentViewerAccessParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>,
            data: GetStudentViewerAccessData | undefined
        ]>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters> | (DeepReadonly<GetStudentViewerAccessParameters>)): QueryState<GetStudentViewerAccessData, GetStudentViewerAccessError> | undefined;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentViewerAccessParameters> | ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>): QueryState<OperationInfiniteData<GetStudentViewerAccessData, GetStudentViewerAccessParameters>, GetStudentViewerAccessError> | undefined;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentViewerAccessParameters>) | ServiceOperationQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>, updater: Updater<NoInfer<GetStudentViewerAccessData> | undefined, NoInfer<DeepReadonly<GetStudentViewerAccessData>> | undefined>, options?: SetDataOptions): GetStudentViewerAccessData | undefined;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentViewerAccessParameters>) | ServiceOperationInfiniteQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentViewerAccessData, GetStudentViewerAccessParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentViewerAccessData, GetStudentViewerAccessParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentViewerAccessData, GetStudentViewerAccessParameters> | undefined;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError> | QueryFiltersByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>, updater: Updater<NoInfer<GetStudentViewerAccessData> | undefined, NoInfer<GetStudentViewerAccessData> | undefined>, options?: SetDataOptions): Array<GetStudentViewerAccessData | undefined>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError> | QueryFiltersByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError> | QueryFiltersByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError> | QueryFiltersByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>): void;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError> | QueryFiltersByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Viewer Access
         * @description Whether the caller may open this student's supervisory pages.
         *
         * Answers 200 for every authenticated caller, so the web route and the sidebar
         * can gate on one query instead of reading a status code. Same audience as the
         * two study-helper operations, so this probe cannot say yes to a viewer they
         * then 404.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError> | QueryFiltersByQueryKey<GetStudentViewerAccessSchema, GetStudentViewerAccessData, TInfinite, GetStudentViewerAccessParameters, GetStudentViewerAccessError>): number;
        schema: GetStudentViewerAccessSchema;
        types: {
            parameters: GetStudentViewerAccessParameters;
            data: GetStudentViewerAccessData;
            error: GetStudentViewerAccessError;
        };
    };
    /**
     * @summary Get Student Study Helper History
     * @description A student's study-helper assignment history, newest adoption first.
     *
     * Each row carries the study helper's name, location and languages, the adoption and
     * release timestamps, and the display name of whoever released the student (null while
     * still assigned, or when unrecorded).
     *
     * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
     */
    getStudentStudyHelperHistory: {
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentStudyHelperHistoryParameters, TMeta, TSignal>), client?: (schema: GetStudentStudyHelperHistorySchema, options: {
            parameters: GetStudentStudyHelperHistoryParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError>>): Promise<RequestFnResponse<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError>>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentStudyHelperHistoryParameters>): ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentStudyHelperHistory.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentStudyHelperHistoryData>(parameters: ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError, TData, ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentStudyHelperHistoryError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentStudyHelperHistory.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentStudyHelperHistoryData>(parameters: ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>), options: Omit<DefinedInitialDataOptions<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError, TData, ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentStudyHelperHistoryError>>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentStudyHelperHistoryParameters>): ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyHelperHistory.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentStudyHelperHistoryParameters, TQueryFnData = GetStudentStudyHelperHistoryData, TData = OperationInfiniteData<TQueryFnData, GetStudentStudyHelperHistoryParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentStudyHelperHistoryError, TData, ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentStudyHelperHistoryError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyHelperHistory.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentStudyHelperHistoryParameters, TQueryFnData = GetStudentStudyHelperHistoryData, TData = OperationInfiniteData<TQueryFnData, GetStudentStudyHelperHistoryParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentStudyHelperHistoryError, TData, ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentStudyHelperHistoryData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentStudyHelperHistoryError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentStudyHelperHistoryTotal = qraft.v3Service.getStudentStudyHelperHistory.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentStudyHelperHistoryByParametersTotal = qraft.v3Service.getStudentStudyHelperHistory.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError> | QueryFiltersByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentStudyHelperHistoryResults = qraft.v3Service.getStudentStudyHelperHistory.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyHelperHistoryResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentStudyHelperHistoryCombinedResults = qraft.v3Service.getStudentStudyHelperHistory.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyHelperHistoryCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError>>, TCombinedResult = Array<UseQueryResult<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentStudyHelperHistory.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentStudyHelperHistoryData>(parameters: ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError, TData, ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentStudyHelperHistoryError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyHelperHistory.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentStudyHelperHistoryParameters, TData = GetStudentStudyHelperHistoryData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError, OperationInfiniteData<TData, GetStudentStudyHelperHistoryParameters>, ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentStudyHelperHistoryData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentStudyHelperHistoryParameters>, OperationError<GetStudentStudyHelperHistoryError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentStudyHelperHistoryData = qraft.v3Service.getStudentStudyHelperHistory.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyHelperHistoryResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentStudyHelperHistoryCombinedData = qraft.v3Service.getStudentStudyHelperHistory.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyHelperHistoryCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>): Promise<GetStudentStudyHelperHistoryData>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>): Promise<void>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>): Promise<GetStudentStudyHelperHistoryData>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentStudyHelperHistoryParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters, DeepReadonly<TPageParam>, GetStudentStudyHelperHistoryError>): Promise<OperationInfiniteData<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters>>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentStudyHelperHistoryParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters, DeepReadonly<TPageParam>, GetStudentStudyHelperHistoryError>): Promise<void>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentStudyHelperHistoryParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters, DeepReadonly<TPageParam>, GetStudentStudyHelperHistoryError>): Promise<OperationInfiniteData<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters>>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>)): GetStudentStudyHelperHistoryData | undefined;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>)): OperationInfiniteData<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters> | undefined;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError> | QueryFiltersByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>,
            data: GetStudentStudyHelperHistoryData | undefined
        ]>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters> | (DeepReadonly<GetStudentStudyHelperHistoryParameters>)): QueryState<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryError> | undefined;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentStudyHelperHistoryParameters> | ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>): QueryState<OperationInfiniteData<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters>, GetStudentStudyHelperHistoryError> | undefined;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentStudyHelperHistoryParameters>) | ServiceOperationQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>, updater: Updater<NoInfer<GetStudentStudyHelperHistoryData> | undefined, NoInfer<DeepReadonly<GetStudentStudyHelperHistoryData>> | undefined>, options?: SetDataOptions): GetStudentStudyHelperHistoryData | undefined;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentStudyHelperHistoryParameters>) | ServiceOperationInfiniteQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentStudyHelperHistoryData, GetStudentStudyHelperHistoryParameters> | undefined;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError> | QueryFiltersByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>, updater: Updater<NoInfer<GetStudentStudyHelperHistoryData> | undefined, NoInfer<GetStudentStudyHelperHistoryData> | undefined>, options?: SetDataOptions): Array<GetStudentStudyHelperHistoryData | undefined>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError> | QueryFiltersByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError> | QueryFiltersByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError> | QueryFiltersByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>): void;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError> | QueryFiltersByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Study Helper History
         * @description A student's study-helper assignment history, newest adoption first.
         *
         * Each row carries the study helper's name, location and languages, the adoption and
         * release timestamps, and the display name of whoever released the student (null while
         * still assigned, or when unrecorded).
         *
         * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError> | QueryFiltersByQueryKey<GetStudentStudyHelperHistorySchema, GetStudentStudyHelperHistoryData, TInfinite, GetStudentStudyHelperHistoryParameters, GetStudentStudyHelperHistoryError>): number;
        schema: GetStudentStudyHelperHistorySchema;
        types: {
            parameters: GetStudentStudyHelperHistoryParameters;
            data: GetStudentStudyHelperHistoryData;
            error: GetStudentStudyHelperHistoryError;
        };
    };
    /** @summary Get Study Helpers */
    getStudyHelpers: {
        /** @summary Get Study Helpers */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudyHelpersParameters, TMeta, TSignal> | void), client?: (schema: GetStudyHelpersSchema, options: {
            parameters: GetStudyHelpersParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudyHelpersData, GetStudyHelpersError>>): Promise<RequestFnResponse<GetStudyHelpersData, GetStudyHelpersError>>;
        /** @summary Get Study Helpers */
        getQueryKey(parameters: DeepReadonly<GetStudyHelpersParameters> | void): ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelpers.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelpers.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelpersData>(parameters: ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetStudyHelpersData, GetStudyHelpersError, TData, ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudyHelpersError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelpers.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelpers.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelpersData>(parameters: ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void), options: Omit<DefinedInitialDataOptions<GetStudyHelpersData, GetStudyHelpersError, TData, ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudyHelpersError>>;
        /** @summary Get Study Helpers */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudyHelpersParameters> | void): ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelpers.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelpersParameters, TQueryFnData = GetStudyHelpersData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelpersParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelpersError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudyHelpersError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelpers.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelpersParameters, TQueryFnData = GetStudyHelpersData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelpersParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelpersError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelpersData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudyHelpersError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudyHelpersTotal = qraft.v3Service.getStudyHelpers.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudyHelpersByParametersTotal = qraft.v3Service.getStudyHelpers.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             search: search
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError> | QueryFiltersByQueryKey<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudyHelpersResults = qraft.v3Service.getStudyHelpers.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelpersResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudyHelpersCombinedResults = qraft.v3Service.getStudyHelpers.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelpersCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudyHelpersSchema, GetStudyHelpersParameters, GetStudyHelpersData, GetStudyHelpersError>>, TCombinedResult = Array<UseQueryResult<GetStudyHelpersData, GetStudyHelpersError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudyHelpersData, GetStudyHelpersError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getStudyHelpers.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudyHelpers.useSuspenseQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudyHelpersData>(parameters: ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetStudyHelpersData, GetStudyHelpersError, TData, ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudyHelpersError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelpers.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudyHelpersParameters, TData = GetStudyHelpersData>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudyHelpersData, GetStudyHelpersError, OperationInfiniteData<TData, GetStudyHelpersParameters>, ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelpersData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudyHelpersParameters>, OperationError<GetStudyHelpersError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helpers
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudyHelpersData = qraft.v3Service.getStudyHelpers.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelpersResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudyHelpersCombinedData = qraft.v3Service.getStudyHelpers.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelpersCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudyHelpersSchema, GetStudyHelpersParameters, GetStudyHelpersData, GetStudyHelpersError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudyHelpersData, GetStudyHelpersError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudyHelpersData, GetStudyHelpersError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Study Helpers */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelpersSchema, GetStudyHelpersData, GetStudyHelpersParameters, GetStudyHelpersError> | void): Promise<GetStudyHelpersData>;
        /** @summary Get Study Helpers */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelpersSchema, GetStudyHelpersData, GetStudyHelpersParameters, GetStudyHelpersError> | void): Promise<void>;
        /** @summary Get Study Helpers */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudyHelpersSchema, GetStudyHelpersData, GetStudyHelpersParameters, GetStudyHelpersError> | void): Promise<GetStudyHelpersData>;
        /** @summary Get Study Helpers */
        fetchInfiniteQuery<TPageParam extends GetStudyHelpersParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelpersSchema, GetStudyHelpersData, GetStudyHelpersParameters, DeepReadonly<TPageParam>, GetStudyHelpersError> | void): Promise<OperationInfiniteData<GetStudyHelpersData, GetStudyHelpersParameters>>;
        /** @summary Get Study Helpers */
        prefetchInfiniteQuery<TPageParam extends GetStudyHelpersParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelpersSchema, GetStudyHelpersData, GetStudyHelpersParameters, DeepReadonly<TPageParam>, GetStudyHelpersError> | void): Promise<void>;
        /** @summary Get Study Helpers */
        ensureInfiniteQueryData<TPageParam extends GetStudyHelpersParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudyHelpersSchema, GetStudyHelpersData, GetStudyHelpersParameters, DeepReadonly<TPageParam>, GetStudyHelpersError> | void): Promise<OperationInfiniteData<GetStudyHelpersData, GetStudyHelpersParameters>>;
        /** @summary Get Study Helpers */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void)): GetStudyHelpersData | undefined;
        /** @summary Get Study Helpers */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void)): OperationInfiniteData<GetStudyHelpersData, GetStudyHelpersParameters> | undefined;
        /** @summary Get Study Helpers */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError> | QueryFiltersByQueryKey<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>,
            data: NoInfer<OperationInfiniteData<GetStudyHelpersData, GetStudyHelpersParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>,
            data: GetStudyHelpersData | undefined
        ]>;
        /** @summary Get Study Helpers */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | (DeepReadonly<GetStudyHelpersParameters> | void)): QueryState<GetStudyHelpersData, GetStudyHelpersError> | undefined;
        /** @summary Get Study Helpers */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudyHelpersParameters> | ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters> | void): QueryState<OperationInfiniteData<GetStudyHelpersData, GetStudyHelpersParameters>, GetStudyHelpersError> | undefined;
        /** @summary Get Study Helpers */
        setQueryData(parameters: (DeepReadonly<GetStudyHelpersParameters> | undefined) | ServiceOperationQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>, updater: Updater<NoInfer<GetStudyHelpersData> | undefined, NoInfer<DeepReadonly<GetStudyHelpersData>> | undefined>, options?: SetDataOptions): GetStudyHelpersData | undefined;
        /** @summary Get Study Helpers */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudyHelpersParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetStudyHelpersSchema, GetStudyHelpersParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudyHelpersData, GetStudyHelpersParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudyHelpersData, GetStudyHelpersParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudyHelpersData, GetStudyHelpersParameters> | undefined;
        /** @summary Get Study Helpers */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError> | QueryFiltersByQueryKey<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>, updater: Updater<NoInfer<GetStudyHelpersData> | undefined, NoInfer<GetStudyHelpersData> | undefined>, options?: SetDataOptions): Array<GetStudyHelpersData | undefined>;
        /** @summary Get Study Helpers */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Study Helpers */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError> | QueryFiltersByQueryKey<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Study Helpers */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError> | QueryFiltersByQueryKey<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Study Helpers */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError> | QueryFiltersByQueryKey<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>): void;
        /** @summary Get Study Helpers */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError> | QueryFiltersByQueryKey<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Study Helpers */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError> | QueryFiltersByQueryKey<GetStudyHelpersSchema, GetStudyHelpersData, TInfinite, GetStudyHelpersParameters, GetStudyHelpersError>): number;
        schema: GetStudyHelpersSchema;
        types: {
            parameters: GetStudyHelpersParameters;
            data: GetStudyHelpersData;
            error: GetStudyHelpersError;
        };
    };
    /** @summary Get Study Helper */
    getStudyHelper: {
        /** @summary Get Study Helper */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudyHelperSchema, GetStudyHelperParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudyHelperParameters, TMeta, TSignal>), client?: (schema: GetStudyHelperSchema, options: {
            parameters: GetStudyHelperParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudyHelperData, GetStudyHelperError>>): Promise<RequestFnResponse<GetStudyHelperData, GetStudyHelperError>>;
        /** @summary Get Study Helper */
        getQueryKey(parameters: DeepReadonly<GetStudyHelperParameters>): ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelper.useQuery({
         *     path: {
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelperData>(parameters: ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudyHelperData, GetStudyHelperError, TData, ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudyHelperError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelper.useQuery({
         *     path: {
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelperData>(parameters: ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>), options: Omit<DefinedInitialDataOptions<GetStudyHelperData, GetStudyHelperError, TData, ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudyHelperError>>;
        /** @summary Get Study Helper */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudyHelperParameters>): ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelper.useInfiniteQuery({
         *     path: {
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelperParameters, TQueryFnData = GetStudyHelperData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelperParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelperError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudyHelperError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelper.useInfiniteQuery({
         *     path: {
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelperParameters, TQueryFnData = GetStudyHelperData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelperParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelperError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelperData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudyHelperError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudyHelperTotal = qraft.v3Service.getStudyHelper.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudyHelperByParametersTotal = qraft.v3Service.getStudyHelper.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             study_helper_id: studyHelperId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError> | QueryFiltersByQueryKey<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudyHelperResults = qraft.v3Service.getStudyHelper.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 study_helper_id: studyHelperId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 study_helper_id: studyHelperId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudyHelperCombinedResults = qraft.v3Service.getStudyHelper.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 study_helper_id: studyHelperId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 study_helper_id: studyHelperId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudyHelperSchema, GetStudyHelperParameters, GetStudyHelperData, GetStudyHelperError>>, TCombinedResult = Array<UseQueryResult<GetStudyHelperData, GetStudyHelperError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudyHelperData, GetStudyHelperError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudyHelper.useSuspenseQuery({
         *     path: {
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudyHelperData>(parameters: ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudyHelperData, GetStudyHelperError, TData, ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudyHelperError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelper.useSuspenseInfiniteQuery({
         *     path: {
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudyHelperParameters, TData = GetStudyHelperData>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudyHelperData, GetStudyHelperError, OperationInfiniteData<TData, GetStudyHelperParameters>, ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelperData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudyHelperParameters>, OperationError<GetStudyHelperError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudyHelperData = qraft.v3Service.getStudyHelper.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 study_helper_id: studyHelperId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 study_helper_id: studyHelperId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudyHelperCombinedData = qraft.v3Service.getStudyHelper.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 study_helper_id: studyHelperId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 study_helper_id: studyHelperId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudyHelperSchema, GetStudyHelperParameters, GetStudyHelperData, GetStudyHelperError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudyHelperData, GetStudyHelperError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudyHelperData, GetStudyHelperError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Study Helper */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelperSchema, GetStudyHelperData, GetStudyHelperParameters, GetStudyHelperError>): Promise<GetStudyHelperData>;
        /** @summary Get Study Helper */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelperSchema, GetStudyHelperData, GetStudyHelperParameters, GetStudyHelperError>): Promise<void>;
        /** @summary Get Study Helper */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudyHelperSchema, GetStudyHelperData, GetStudyHelperParameters, GetStudyHelperError>): Promise<GetStudyHelperData>;
        /** @summary Get Study Helper */
        fetchInfiniteQuery<TPageParam extends GetStudyHelperParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelperSchema, GetStudyHelperData, GetStudyHelperParameters, DeepReadonly<TPageParam>, GetStudyHelperError>): Promise<OperationInfiniteData<GetStudyHelperData, GetStudyHelperParameters>>;
        /** @summary Get Study Helper */
        prefetchInfiniteQuery<TPageParam extends GetStudyHelperParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelperSchema, GetStudyHelperData, GetStudyHelperParameters, DeepReadonly<TPageParam>, GetStudyHelperError>): Promise<void>;
        /** @summary Get Study Helper */
        ensureInfiniteQueryData<TPageParam extends GetStudyHelperParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudyHelperSchema, GetStudyHelperData, GetStudyHelperParameters, DeepReadonly<TPageParam>, GetStudyHelperError>): Promise<OperationInfiniteData<GetStudyHelperData, GetStudyHelperParameters>>;
        /** @summary Get Study Helper */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>)): GetStudyHelperData | undefined;
        /** @summary Get Study Helper */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>)): OperationInfiniteData<GetStudyHelperData, GetStudyHelperParameters> | undefined;
        /** @summary Get Study Helper */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError> | QueryFiltersByQueryKey<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>,
            data: NoInfer<OperationInfiniteData<GetStudyHelperData, GetStudyHelperParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>,
            data: GetStudyHelperData | undefined
        ]>;
        /** @summary Get Study Helper */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters> | (DeepReadonly<GetStudyHelperParameters>)): QueryState<GetStudyHelperData, GetStudyHelperError> | undefined;
        /** @summary Get Study Helper */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudyHelperParameters> | ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>): QueryState<OperationInfiniteData<GetStudyHelperData, GetStudyHelperParameters>, GetStudyHelperError> | undefined;
        /** @summary Get Study Helper */
        setQueryData(parameters: (DeepReadonly<GetStudyHelperParameters>) | ServiceOperationQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>, updater: Updater<NoInfer<GetStudyHelperData> | undefined, NoInfer<DeepReadonly<GetStudyHelperData>> | undefined>, options?: SetDataOptions): GetStudyHelperData | undefined;
        /** @summary Get Study Helper */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudyHelperParameters>) | ServiceOperationInfiniteQueryKey<GetStudyHelperSchema, GetStudyHelperParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudyHelperData, GetStudyHelperParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudyHelperData, GetStudyHelperParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudyHelperData, GetStudyHelperParameters> | undefined;
        /** @summary Get Study Helper */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError> | QueryFiltersByQueryKey<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>, updater: Updater<NoInfer<GetStudyHelperData> | undefined, NoInfer<GetStudyHelperData> | undefined>, options?: SetDataOptions): Array<GetStudyHelperData | undefined>;
        /** @summary Get Study Helper */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Study Helper */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError> | QueryFiltersByQueryKey<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Study Helper */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError> | QueryFiltersByQueryKey<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Study Helper */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError> | QueryFiltersByQueryKey<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>): void;
        /** @summary Get Study Helper */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError> | QueryFiltersByQueryKey<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Study Helper */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError> | QueryFiltersByQueryKey<GetStudyHelperSchema, GetStudyHelperData, TInfinite, GetStudyHelperParameters, GetStudyHelperError>): number;
        schema: GetStudyHelperSchema;
        types: {
            parameters: GetStudyHelperParameters;
            data: GetStudyHelperData;
            error: GetStudyHelperError;
        };
    };
    /** @summary Users Me */
    getCurrentUser: {
        /** @summary Users Me */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetCurrentUserSchema, GetCurrentUserParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetCurrentUserParameters, TMeta, TSignal> | void), client?: (schema: GetCurrentUserSchema, options: {
            parameters: GetCurrentUserParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetCurrentUserData, GetCurrentUserError>>): Promise<RequestFnResponse<GetCurrentUserData, GetCurrentUserError>>;
        /** @summary Users Me */
        getQueryKey(parameters: DeepReadonly<GetCurrentUserParameters> | void): ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCurrentUser.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCurrentUser.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCurrentUserData>(parameters: ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetCurrentUserData, GetCurrentUserError, TData, ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetCurrentUserError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCurrentUser.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCurrentUser.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCurrentUserData>(parameters: ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void), options: Omit<DefinedInitialDataOptions<GetCurrentUserData, GetCurrentUserError, TData, ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetCurrentUserError>>;
        /** @summary Users Me */
        getInfiniteQueryKey(parameters: DeepReadonly<GetCurrentUserParameters> | void): ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCurrentUser.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCurrentUserParameters, TQueryFnData = GetCurrentUserData, TData = OperationInfiniteData<TQueryFnData, GetCurrentUserParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetCurrentUserError, TData, ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetCurrentUserError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCurrentUser.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCurrentUserParameters, TQueryFnData = GetCurrentUserData, TData = OperationInfiniteData<TQueryFnData, GetCurrentUserParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetCurrentUserError, TData, ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCurrentUserData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetCurrentUserError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getCurrentUserTotal = qraft.v3Service.getCurrentUser.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getCurrentUserByParametersTotal = qraft.v3Service.getCurrentUser.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError> | QueryFiltersByQueryKey<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getCurrentUserResults = qraft.v3Service.getCurrentUser.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCurrentUserResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getCurrentUserCombinedResults = qraft.v3Service.getCurrentUser.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCurrentUserCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetCurrentUserSchema, GetCurrentUserParameters, GetCurrentUserData, GetCurrentUserError>>, TCombinedResult = Array<UseQueryResult<GetCurrentUserData, GetCurrentUserError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetCurrentUserData, GetCurrentUserError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getCurrentUser.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getCurrentUser.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetCurrentUserData>(parameters: ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetCurrentUserData, GetCurrentUserError, TData, ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetCurrentUserError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCurrentUser.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetCurrentUserParameters, TData = GetCurrentUserData>(parameters: ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetCurrentUserData, GetCurrentUserError, OperationInfiniteData<TData, GetCurrentUserParameters>, ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCurrentUserData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetCurrentUserParameters>, OperationError<GetCurrentUserError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Users Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getCurrentUserData = qraft.v3Service.getCurrentUser.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCurrentUserResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getCurrentUserCombinedData = qraft.v3Service.getCurrentUser.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCurrentUserCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetCurrentUserSchema, GetCurrentUserParameters, GetCurrentUserData, GetCurrentUserError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetCurrentUserData, GetCurrentUserError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetCurrentUserData, GetCurrentUserError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Users Me */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetCurrentUserSchema, GetCurrentUserData, GetCurrentUserParameters, GetCurrentUserError> | void): Promise<GetCurrentUserData>;
        /** @summary Users Me */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetCurrentUserSchema, GetCurrentUserData, GetCurrentUserParameters, GetCurrentUserError> | void): Promise<void>;
        /** @summary Users Me */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetCurrentUserSchema, GetCurrentUserData, GetCurrentUserParameters, GetCurrentUserError> | void): Promise<GetCurrentUserData>;
        /** @summary Users Me */
        fetchInfiniteQuery<TPageParam extends GetCurrentUserParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCurrentUserSchema, GetCurrentUserData, GetCurrentUserParameters, DeepReadonly<TPageParam>, GetCurrentUserError> | void): Promise<OperationInfiniteData<GetCurrentUserData, GetCurrentUserParameters>>;
        /** @summary Users Me */
        prefetchInfiniteQuery<TPageParam extends GetCurrentUserParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCurrentUserSchema, GetCurrentUserData, GetCurrentUserParameters, DeepReadonly<TPageParam>, GetCurrentUserError> | void): Promise<void>;
        /** @summary Users Me */
        ensureInfiniteQueryData<TPageParam extends GetCurrentUserParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetCurrentUserSchema, GetCurrentUserData, GetCurrentUserParameters, DeepReadonly<TPageParam>, GetCurrentUserError> | void): Promise<OperationInfiniteData<GetCurrentUserData, GetCurrentUserParameters>>;
        /** @summary Users Me */
        getQueryData(parameters: ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void)): GetCurrentUserData | undefined;
        /** @summary Users Me */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void)): OperationInfiniteData<GetCurrentUserData, GetCurrentUserParameters> | undefined;
        /** @summary Users Me */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError> | QueryFiltersByQueryKey<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>,
            data: NoInfer<OperationInfiniteData<GetCurrentUserData, GetCurrentUserParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>,
            data: GetCurrentUserData | undefined
        ]>;
        /** @summary Users Me */
        getQueryState(parameters: ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | (DeepReadonly<GetCurrentUserParameters> | void)): QueryState<GetCurrentUserData, GetCurrentUserError> | undefined;
        /** @summary Users Me */
        getInfiniteQueryState(parameters: DeepReadonly<GetCurrentUserParameters> | ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters> | void): QueryState<OperationInfiniteData<GetCurrentUserData, GetCurrentUserParameters>, GetCurrentUserError> | undefined;
        /** @summary Users Me */
        setQueryData(parameters: (DeepReadonly<GetCurrentUserParameters> | undefined) | ServiceOperationQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>, updater: Updater<NoInfer<GetCurrentUserData> | undefined, NoInfer<DeepReadonly<GetCurrentUserData>> | undefined>, options?: SetDataOptions): GetCurrentUserData | undefined;
        /** @summary Users Me */
        setInfiniteQueryData(parameters: (DeepReadonly<GetCurrentUserParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetCurrentUserSchema, GetCurrentUserParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetCurrentUserData, GetCurrentUserParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetCurrentUserData, GetCurrentUserParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetCurrentUserData, GetCurrentUserParameters> | undefined;
        /** @summary Users Me */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError> | QueryFiltersByQueryKey<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>, updater: Updater<NoInfer<GetCurrentUserData> | undefined, NoInfer<GetCurrentUserData> | undefined>, options?: SetDataOptions): Array<GetCurrentUserData | undefined>;
        /** @summary Users Me */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Users Me */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError> | QueryFiltersByQueryKey<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>, options?: RefetchOptions): Promise<void>;
        /** @summary Users Me */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError> | QueryFiltersByQueryKey<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>, options?: CancelOptions): Promise<void>;
        /** @summary Users Me */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError> | QueryFiltersByQueryKey<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>): void;
        /** @summary Users Me */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError> | QueryFiltersByQueryKey<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>, options?: ResetOptions): Promise<void>;
        /** @summary Users Me */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError> | QueryFiltersByQueryKey<GetCurrentUserSchema, GetCurrentUserData, TInfinite, GetCurrentUserParameters, GetCurrentUserError>): number;
        schema: GetCurrentUserSchema;
        types: {
            parameters: GetCurrentUserParameters;
            data: GetCurrentUserData;
            error: GetCurrentUserError;
        };
    };
    /**
     * @summary Set My Language
     * @description Persist the caller's interface language.
     *
     * Switching doesn't need this: the client changes language locally and sends
     * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
     * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
     */
    setMyLanguage: {
        /**
         * @summary Set My Language
         * @description Persist the caller's interface language.
         *
         * Switching doesn't need this: the client changes language locally and sends
         * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
         * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetMyLanguageBody, SetMyLanguageParameters, TMeta, TSignal>, client?: (schema: SetMyLanguageSchema, options: ServiceOperationMutationFnOptions<SetMyLanguageBody, SetMyLanguageParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetMyLanguageData, SetMyLanguageError>>): Promise<RequestFnResponse<SetMyLanguageData, SetMyLanguageError>>;
        /**
         * @summary Set My Language
         * @description Persist the caller's interface language.
         *
         * Switching doesn't need this: the client changes language locally and sends
         * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
         * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
         */
        getMutationKey(parameters: DeepReadonly<SetMyLanguageParameters> | void): ServiceOperationMutationKey<SetMyLanguageSchema, SetMyLanguageParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set My Language
         * @description Persist the caller's interface language.
         *
         * Switching doesn't need this: the client changes language locally and sends
         * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
         * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setMyLanguage.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setMyLanguage.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetMyLanguageBody, TContext = unknown>(parameters: DeepReadonly<SetMyLanguageParameters>, options?: ServiceOperationUseMutationOptions<SetMyLanguageSchema, SetMyLanguageData, SetMyLanguageParameters, TVariables, OperationError<SetMyLanguageError>, TContext>): UseMutationResult<SetMyLanguageData, OperationError<SetMyLanguageError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set My Language
         * @description Persist the caller's interface language.
         *
         * Switching doesn't need this: the client changes language locally and sends
         * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
         * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setMyLanguage.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setMyLanguage.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetMyLanguageBody, SetMyLanguageParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetMyLanguageSchema, SetMyLanguageData, SetMyLanguageParameters, TVariables, OperationError<SetMyLanguageError>, TContext>): UseMutationResult<SetMyLanguageData, OperationError<SetMyLanguageError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set My Language
         * @description Persist the caller's interface language.
         *
         * Switching doesn't need this: the client changes language locally and sends
         * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
         * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setMyLanguageTotal = qraft.v3Service.setMyLanguage.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setMyLanguageTotal = qraft.v3Service.setMyLanguage.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext> | MutationFiltersByMutationKey<SetMyLanguageSchema, SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set My Language
         * @description Persist the caller's interface language.
         *
         * Switching doesn't need this: the client changes language locally and sends
         * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
         * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setMyLanguagePendingMutationVariables = qraft.v3Service.setMyLanguage.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setMyLanguageMutationData = qraft.v3Service.setMyLanguage.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetMyLanguageData, OperationError<SetMyLanguageError>, MutationVariables<SetMyLanguageBody, SetMyLanguageParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext> | MutationFiltersByMutationKey<SetMyLanguageSchema, SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext>;
            select?: (mutation: Mutation<SetMyLanguageData, OperationError<SetMyLanguageError>, MutationVariables<SetMyLanguageBody, SetMyLanguageParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set My Language
         * @description Persist the caller's interface language.
         *
         * Switching doesn't need this: the client changes language locally and sends
         * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
         * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext> | MutationFiltersByMutationKey<SetMyLanguageSchema, SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set My Language
         * @description Persist the caller's interface language.
         *
         * Switching doesn't need this: the client changes language locally and sends
         * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
         * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setMyLanguage.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setMyLanguage.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext> | MutationFiltersByMutationKey<SetMyLanguageSchema, SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext>): Mutation<SetMyLanguageData, SetMyLanguageError, MutationVariables<SetMyLanguageBody, SetMyLanguageParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext> | MutationFiltersByMutationKey<SetMyLanguageSchema, SetMyLanguageBody, SetMyLanguageData, SetMyLanguageParameters, OperationError<SetMyLanguageError>, TContext>): Array<Mutation<SetMyLanguageData, SetMyLanguageError, MutationVariables<SetMyLanguageBody, SetMyLanguageParameters>, TContext>>;
        };
        schema: SetMyLanguageSchema;
        types: {
            parameters: SetMyLanguageParameters;
            data: SetMyLanguageData;
            error: SetMyLanguageError;
            body: SetMyLanguageBody;
        };
    };
    /**
     * @summary Set My Newsletter Subscription
     * @description Subscribe the caller to the newsletter, or unsubscribe them.
     *
     * The subject is always the authenticated caller; the operation takes no
     * member id. Setting the value the account already holds is a 200 with the
     * same body. This does not touch notification preferences: those are
     * per-event, per-channel message routing and are a separate product.
     */
    setMyNewsletterSubscription: {
        /**
         * @summary Set My Newsletter Subscription
         * @description Subscribe the caller to the newsletter, or unsubscribe them.
         *
         * The subject is always the authenticated caller; the operation takes no
         * member id. Setting the value the account already holds is a 200 with the
         * same body. This does not touch notification preferences: those are
         * per-event, per-channel message routing and are a separate product.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionParameters, TMeta, TSignal>, client?: (schema: SetMyNewsletterSubscriptionSchema, options: ServiceOperationMutationFnOptions<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionError>>): Promise<RequestFnResponse<SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionError>>;
        /**
         * @summary Set My Newsletter Subscription
         * @description Subscribe the caller to the newsletter, or unsubscribe them.
         *
         * The subject is always the authenticated caller; the operation takes no
         * member id. Setting the value the account already holds is a 200 with the
         * same body. This does not touch notification preferences: those are
         * per-event, per-channel message routing and are a separate product.
         */
        getMutationKey(parameters: DeepReadonly<SetMyNewsletterSubscriptionParameters> | void): ServiceOperationMutationKey<SetMyNewsletterSubscriptionSchema, SetMyNewsletterSubscriptionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set My Newsletter Subscription
         * @description Subscribe the caller to the newsletter, or unsubscribe them.
         *
         * The subject is always the authenticated caller; the operation takes no
         * member id. Setting the value the account already holds is a 200 with the
         * same body. This does not touch notification preferences: those are
         * per-event, per-channel message routing and are a separate product.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setMyNewsletterSubscription.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setMyNewsletterSubscription.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetMyNewsletterSubscriptionBody, TContext = unknown>(parameters: DeepReadonly<SetMyNewsletterSubscriptionParameters>, options?: ServiceOperationUseMutationOptions<SetMyNewsletterSubscriptionSchema, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, TVariables, OperationError<SetMyNewsletterSubscriptionError>, TContext>): UseMutationResult<SetMyNewsletterSubscriptionData, OperationError<SetMyNewsletterSubscriptionError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set My Newsletter Subscription
         * @description Subscribe the caller to the newsletter, or unsubscribe them.
         *
         * The subject is always the authenticated caller; the operation takes no
         * member id. Setting the value the account already holds is a 200 with the
         * same body. This does not touch notification preferences: those are
         * per-event, per-channel message routing and are a separate product.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setMyNewsletterSubscription.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setMyNewsletterSubscription.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetMyNewsletterSubscriptionSchema, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, TVariables, OperationError<SetMyNewsletterSubscriptionError>, TContext>): UseMutationResult<SetMyNewsletterSubscriptionData, OperationError<SetMyNewsletterSubscriptionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set My Newsletter Subscription
         * @description Subscribe the caller to the newsletter, or unsubscribe them.
         *
         * The subject is always the authenticated caller; the operation takes no
         * member id. Setting the value the account already holds is a 200 with the
         * same body. This does not touch notification preferences: those are
         * per-event, per-channel message routing and are a separate product.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setMyNewsletterSubscriptionTotal = qraft.v3Service.setMyNewsletterSubscription.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setMyNewsletterSubscriptionTotal = qraft.v3Service.setMyNewsletterSubscription.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext> | MutationFiltersByMutationKey<SetMyNewsletterSubscriptionSchema, SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set My Newsletter Subscription
         * @description Subscribe the caller to the newsletter, or unsubscribe them.
         *
         * The subject is always the authenticated caller; the operation takes no
         * member id. Setting the value the account already holds is a 200 with the
         * same body. This does not touch notification preferences: those are
         * per-event, per-channel message routing and are a separate product.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setMyNewsletterSubscriptionPendingMutationVariables = qraft.v3Service.setMyNewsletterSubscription.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setMyNewsletterSubscriptionMutationData = qraft.v3Service.setMyNewsletterSubscription.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetMyNewsletterSubscriptionData, OperationError<SetMyNewsletterSubscriptionError>, MutationVariables<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext> | MutationFiltersByMutationKey<SetMyNewsletterSubscriptionSchema, SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext>;
            select?: (mutation: Mutation<SetMyNewsletterSubscriptionData, OperationError<SetMyNewsletterSubscriptionError>, MutationVariables<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set My Newsletter Subscription
         * @description Subscribe the caller to the newsletter, or unsubscribe them.
         *
         * The subject is always the authenticated caller; the operation takes no
         * member id. Setting the value the account already holds is a 200 with the
         * same body. This does not touch notification preferences: those are
         * per-event, per-channel message routing and are a separate product.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext> | MutationFiltersByMutationKey<SetMyNewsletterSubscriptionSchema, SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set My Newsletter Subscription
         * @description Subscribe the caller to the newsletter, or unsubscribe them.
         *
         * The subject is always the authenticated caller; the operation takes no
         * member id. Setting the value the account already holds is a 200 with the
         * same body. This does not touch notification preferences: those are
         * per-event, per-channel message routing and are a separate product.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setMyNewsletterSubscription.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setMyNewsletterSubscription.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext> | MutationFiltersByMutationKey<SetMyNewsletterSubscriptionSchema, SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext>): Mutation<SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionError, MutationVariables<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext> | MutationFiltersByMutationKey<SetMyNewsletterSubscriptionSchema, SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionParameters, OperationError<SetMyNewsletterSubscriptionError>, TContext>): Array<Mutation<SetMyNewsletterSubscriptionData, SetMyNewsletterSubscriptionError, MutationVariables<SetMyNewsletterSubscriptionBody, SetMyNewsletterSubscriptionParameters>, TContext>>;
        };
        schema: SetMyNewsletterSubscriptionSchema;
        types: {
            parameters: SetMyNewsletterSubscriptionParameters;
            data: SetMyNewsletterSubscriptionData;
            error: SetMyNewsletterSubscriptionError;
            body: SetMyNewsletterSubscriptionBody;
        };
    };
    /**
     * @summary Update My Login Information
     * @description Change the caller's account email and/or password.
     *
     * One operation because it is one form, and the email field is required on every
     * submit, so a password-only save still carries the current address. A changed address
     * is stored as pending and mailed a verification link; the account email doesn't
     * change here.
     */
    updateMyLoginInformation: {
        /**
         * @summary Update My Login Information
         * @description Change the caller's account email and/or password.
         *
         * One operation because it is one form, and the email field is required on every
         * submit, so a password-only save still carries the current address. A changed address
         * is stored as pending and mailed a verification link; the account email doesn't
         * change here.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UpdateMyLoginInformationBody, UpdateMyLoginInformationParameters, TMeta, TSignal>, client?: (schema: UpdateMyLoginInformationSchema, options: ServiceOperationMutationFnOptions<UpdateMyLoginInformationBody, UpdateMyLoginInformationParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UpdateMyLoginInformationData, UpdateMyLoginInformationError>>): Promise<RequestFnResponse<UpdateMyLoginInformationData, UpdateMyLoginInformationError>>;
        /**
         * @summary Update My Login Information
         * @description Change the caller's account email and/or password.
         *
         * One operation because it is one form, and the email field is required on every
         * submit, so a password-only save still carries the current address. A changed address
         * is stored as pending and mailed a verification link; the account email doesn't
         * change here.
         */
        getMutationKey(parameters: DeepReadonly<UpdateMyLoginInformationParameters> | void): ServiceOperationMutationKey<UpdateMyLoginInformationSchema, UpdateMyLoginInformationParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update My Login Information
         * @description Change the caller's account email and/or password.
         *
         * One operation because it is one form, and the email field is required on every
         * submit, so a password-only save still carries the current address. A changed address
         * is stored as pending and mailed a verification link; the account email doesn't
         * change here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateMyLoginInformation.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateMyLoginInformation.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UpdateMyLoginInformationBody, TContext = unknown>(parameters: DeepReadonly<UpdateMyLoginInformationParameters>, options?: ServiceOperationUseMutationOptions<UpdateMyLoginInformationSchema, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, TVariables, OperationError<UpdateMyLoginInformationError>, TContext>): UseMutationResult<UpdateMyLoginInformationData, OperationError<UpdateMyLoginInformationError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update My Login Information
         * @description Change the caller's account email and/or password.
         *
         * One operation because it is one form, and the email field is required on every
         * submit, so a password-only save still carries the current address. A changed address
         * is stored as pending and mailed a verification link; the account email doesn't
         * change here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateMyLoginInformation.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateMyLoginInformation.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UpdateMyLoginInformationBody, UpdateMyLoginInformationParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UpdateMyLoginInformationSchema, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, TVariables, OperationError<UpdateMyLoginInformationError>, TContext>): UseMutationResult<UpdateMyLoginInformationData, OperationError<UpdateMyLoginInformationError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Update My Login Information
         * @description Change the caller's account email and/or password.
         *
         * One operation because it is one form, and the email field is required on every
         * submit, so a password-only save still carries the current address. A changed address
         * is stored as pending and mailed a verification link; the account email doesn't
         * change here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const updateMyLoginInformationTotal = qraft.v3Service.updateMyLoginInformation.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const updateMyLoginInformationTotal = qraft.v3Service.updateMyLoginInformation.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext> | MutationFiltersByMutationKey<UpdateMyLoginInformationSchema, UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Update My Login Information
         * @description Change the caller's account email and/or password.
         *
         * One operation because it is one form, and the email field is required on every
         * submit, so a password-only save still carries the current address. A changed address
         * is stored as pending and mailed a verification link; the account email doesn't
         * change here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const updateMyLoginInformationPendingMutationVariables = qraft.v3Service.updateMyLoginInformation.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const updateMyLoginInformationMutationData = qraft.v3Service.updateMyLoginInformation.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UpdateMyLoginInformationData, OperationError<UpdateMyLoginInformationError>, MutationVariables<UpdateMyLoginInformationBody, UpdateMyLoginInformationParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext> | MutationFiltersByMutationKey<UpdateMyLoginInformationSchema, UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext>;
            select?: (mutation: Mutation<UpdateMyLoginInformationData, OperationError<UpdateMyLoginInformationError>, MutationVariables<UpdateMyLoginInformationBody, UpdateMyLoginInformationParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Update My Login Information
         * @description Change the caller's account email and/or password.
         *
         * One operation because it is one form, and the email field is required on every
         * submit, so a password-only save still carries the current address. A changed address
         * is stored as pending and mailed a verification link; the account email doesn't
         * change here.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext> | MutationFiltersByMutationKey<UpdateMyLoginInformationSchema, UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Update My Login Information
         * @description Change the caller's account email and/or password.
         *
         * One operation because it is one form, and the email field is required on every
         * submit, so a password-only save still carries the current address. A changed address
         * is stored as pending and mailed a verification link; the account email doesn't
         * change here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.updateMyLoginInformation.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.updateMyLoginInformation.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext> | MutationFiltersByMutationKey<UpdateMyLoginInformationSchema, UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext>): Mutation<UpdateMyLoginInformationData, UpdateMyLoginInformationError, MutationVariables<UpdateMyLoginInformationBody, UpdateMyLoginInformationParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext> | MutationFiltersByMutationKey<UpdateMyLoginInformationSchema, UpdateMyLoginInformationBody, UpdateMyLoginInformationData, UpdateMyLoginInformationParameters, OperationError<UpdateMyLoginInformationError>, TContext>): Array<Mutation<UpdateMyLoginInformationData, UpdateMyLoginInformationError, MutationVariables<UpdateMyLoginInformationBody, UpdateMyLoginInformationParameters>, TContext>>;
        };
        schema: UpdateMyLoginInformationSchema;
        types: {
            parameters: UpdateMyLoginInformationParameters;
            data: UpdateMyLoginInformationData;
            error: UpdateMyLoginInformationError;
            body: UpdateMyLoginInformationBody;
        };
    };
    /**
     * @summary Verify My Email Change
     * @description Apply the caller's pending email change, given the key from their mail.
     *
     * The key is single-use: a second call with the same key answers 400. The
     * caller who runs this need not be the mailbox that received the link, but
     * they must be signed in as the account being changed.
     */
    verifyMyEmailChange: {
        /**
         * @summary Verify My Email Change
         * @description Apply the caller's pending email change, given the key from their mail.
         *
         * The key is single-use: a second call with the same key answers 400. The
         * caller who runs this need not be the mailbox that received the link, but
         * they must be signed in as the account being changed.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<VerifyMyEmailChangeBody, VerifyMyEmailChangeParameters, TMeta, TSignal>, client?: (schema: VerifyMyEmailChangeSchema, options: ServiceOperationMutationFnOptions<VerifyMyEmailChangeBody, VerifyMyEmailChangeParameters, TMeta, TSignal>) => Promise<RequestFnResponse<VerifyMyEmailChangeData, VerifyMyEmailChangeError>>): Promise<RequestFnResponse<VerifyMyEmailChangeData, VerifyMyEmailChangeError>>;
        /**
         * @summary Verify My Email Change
         * @description Apply the caller's pending email change, given the key from their mail.
         *
         * The key is single-use: a second call with the same key answers 400. The
         * caller who runs this need not be the mailbox that received the link, but
         * they must be signed in as the account being changed.
         */
        getMutationKey(parameters: DeepReadonly<VerifyMyEmailChangeParameters> | void): ServiceOperationMutationKey<VerifyMyEmailChangeSchema, VerifyMyEmailChangeParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Verify My Email Change
         * @description Apply the caller's pending email change, given the key from their mail.
         *
         * The key is single-use: a second call with the same key answers 400. The
         * caller who runs this need not be the mailbox that received the link, but
         * they must be signed in as the account being changed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.verifyMyEmailChange.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.verifyMyEmailChange.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends VerifyMyEmailChangeBody, TContext = unknown>(parameters: DeepReadonly<VerifyMyEmailChangeParameters>, options?: ServiceOperationUseMutationOptions<VerifyMyEmailChangeSchema, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, TVariables, OperationError<VerifyMyEmailChangeError>, TContext>): UseMutationResult<VerifyMyEmailChangeData, OperationError<VerifyMyEmailChangeError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Verify My Email Change
         * @description Apply the caller's pending email change, given the key from their mail.
         *
         * The key is single-use: a second call with the same key answers 400. The
         * caller who runs this need not be the mailbox that received the link, but
         * they must be signed in as the account being changed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.verifyMyEmailChange.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.verifyMyEmailChange.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<VerifyMyEmailChangeBody, VerifyMyEmailChangeParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<VerifyMyEmailChangeSchema, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, TVariables, OperationError<VerifyMyEmailChangeError>, TContext>): UseMutationResult<VerifyMyEmailChangeData, OperationError<VerifyMyEmailChangeError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Verify My Email Change
         * @description Apply the caller's pending email change, given the key from their mail.
         *
         * The key is single-use: a second call with the same key answers 400. The
         * caller who runs this need not be the mailbox that received the link, but
         * they must be signed in as the account being changed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const verifyMyEmailChangeTotal = qraft.v3Service.verifyMyEmailChange.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const verifyMyEmailChangeTotal = qraft.v3Service.verifyMyEmailChange.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<VerifyMyEmailChangeSchema, VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Verify My Email Change
         * @description Apply the caller's pending email change, given the key from their mail.
         *
         * The key is single-use: a second call with the same key answers 400. The
         * caller who runs this need not be the mailbox that received the link, but
         * they must be signed in as the account being changed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const verifyMyEmailChangePendingMutationVariables = qraft.v3Service.verifyMyEmailChange.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const verifyMyEmailChangeMutationData = qraft.v3Service.verifyMyEmailChange.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<VerifyMyEmailChangeData, OperationError<VerifyMyEmailChangeError>, MutationVariables<VerifyMyEmailChangeBody, VerifyMyEmailChangeParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<VerifyMyEmailChangeSchema, VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext>;
            select?: (mutation: Mutation<VerifyMyEmailChangeData, OperationError<VerifyMyEmailChangeError>, MutationVariables<VerifyMyEmailChangeBody, VerifyMyEmailChangeParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Verify My Email Change
         * @description Apply the caller's pending email change, given the key from their mail.
         *
         * The key is single-use: a second call with the same key answers 400. The
         * caller who runs this need not be the mailbox that received the link, but
         * they must be signed in as the account being changed.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<VerifyMyEmailChangeSchema, VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Verify My Email Change
         * @description Apply the caller's pending email change, given the key from their mail.
         *
         * The key is single-use: a second call with the same key answers 400. The
         * caller who runs this need not be the mailbox that received the link, but
         * they must be signed in as the account being changed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.verifyMyEmailChange.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.verifyMyEmailChange.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<VerifyMyEmailChangeSchema, VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext>): Mutation<VerifyMyEmailChangeData, VerifyMyEmailChangeError, MutationVariables<VerifyMyEmailChangeBody, VerifyMyEmailChangeParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<VerifyMyEmailChangeSchema, VerifyMyEmailChangeBody, VerifyMyEmailChangeData, VerifyMyEmailChangeParameters, OperationError<VerifyMyEmailChangeError>, TContext>): Array<Mutation<VerifyMyEmailChangeData, VerifyMyEmailChangeError, MutationVariables<VerifyMyEmailChangeBody, VerifyMyEmailChangeParameters>, TContext>>;
        };
        schema: VerifyMyEmailChangeSchema;
        types: {
            parameters: VerifyMyEmailChangeParameters;
            data: VerifyMyEmailChangeData;
            error: VerifyMyEmailChangeError;
            body: VerifyMyEmailChangeBody;
        };
    };
    /**
     * @summary Cancel My Email Change
     * @description Dismiss the caller's pending email change.
     *
     * Idempotent -- with nothing pending it answers 200 with a null
     * `pending_email` rather than 404, because the screen's Cancel button is an
     * "ensure cleared" rather than an "assert exists".
     */
    cancelMyEmailChange: {
        /**
         * @summary Cancel My Email Change
         * @description Dismiss the caller's pending email change.
         *
         * Idempotent -- with nothing pending it answers 200 with a null
         * `pending_email` rather than 404, because the screen's Cancel button is an
         * "ensure cleared" rather than an "assert exists".
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CancelMyEmailChangeBody, CancelMyEmailChangeParameters, TMeta, TSignal>, client?: (schema: CancelMyEmailChangeSchema, options: ServiceOperationMutationFnOptions<CancelMyEmailChangeBody, CancelMyEmailChangeParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CancelMyEmailChangeData, CancelMyEmailChangeError>>): Promise<RequestFnResponse<CancelMyEmailChangeData, CancelMyEmailChangeError>>;
        /**
         * @summary Cancel My Email Change
         * @description Dismiss the caller's pending email change.
         *
         * Idempotent -- with nothing pending it answers 200 with a null
         * `pending_email` rather than 404, because the screen's Cancel button is an
         * "ensure cleared" rather than an "assert exists".
         */
        getMutationKey(parameters: DeepReadonly<CancelMyEmailChangeParameters> | void): ServiceOperationMutationKey<CancelMyEmailChangeSchema, CancelMyEmailChangeParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Cancel My Email Change
         * @description Dismiss the caller's pending email change.
         *
         * Idempotent -- with nothing pending it answers 200 with a null
         * `pending_email` rather than 404, because the screen's Cancel button is an
         * "ensure cleared" rather than an "assert exists".
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.cancelMyEmailChange.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.cancelMyEmailChange.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CancelMyEmailChangeBody, TContext = unknown>(parameters: DeepReadonly<CancelMyEmailChangeParameters>, options?: ServiceOperationUseMutationOptions<CancelMyEmailChangeSchema, CancelMyEmailChangeData, CancelMyEmailChangeParameters, TVariables, OperationError<CancelMyEmailChangeError>, TContext>): UseMutationResult<CancelMyEmailChangeData, OperationError<CancelMyEmailChangeError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Cancel My Email Change
         * @description Dismiss the caller's pending email change.
         *
         * Idempotent -- with nothing pending it answers 200 with a null
         * `pending_email` rather than 404, because the screen's Cancel button is an
         * "ensure cleared" rather than an "assert exists".
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.cancelMyEmailChange.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.cancelMyEmailChange.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CancelMyEmailChangeBody, CancelMyEmailChangeParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CancelMyEmailChangeSchema, CancelMyEmailChangeData, CancelMyEmailChangeParameters, TVariables, OperationError<CancelMyEmailChangeError>, TContext>): UseMutationResult<CancelMyEmailChangeData, OperationError<CancelMyEmailChangeError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Cancel My Email Change
         * @description Dismiss the caller's pending email change.
         *
         * Idempotent -- with nothing pending it answers 200 with a null
         * `pending_email` rather than 404, because the screen's Cancel button is an
         * "ensure cleared" rather than an "assert exists".
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const cancelMyEmailChangeTotal = qraft.v3Service.cancelMyEmailChange.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const cancelMyEmailChangeTotal = qraft.v3Service.cancelMyEmailChange.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<CancelMyEmailChangeSchema, CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Cancel My Email Change
         * @description Dismiss the caller's pending email change.
         *
         * Idempotent -- with nothing pending it answers 200 with a null
         * `pending_email` rather than 404, because the screen's Cancel button is an
         * "ensure cleared" rather than an "assert exists".
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const cancelMyEmailChangePendingMutationVariables = qraft.v3Service.cancelMyEmailChange.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const cancelMyEmailChangeMutationData = qraft.v3Service.cancelMyEmailChange.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CancelMyEmailChangeData, OperationError<CancelMyEmailChangeError>, MutationVariables<CancelMyEmailChangeBody, CancelMyEmailChangeParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<CancelMyEmailChangeSchema, CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext>;
            select?: (mutation: Mutation<CancelMyEmailChangeData, OperationError<CancelMyEmailChangeError>, MutationVariables<CancelMyEmailChangeBody, CancelMyEmailChangeParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Cancel My Email Change
         * @description Dismiss the caller's pending email change.
         *
         * Idempotent -- with nothing pending it answers 200 with a null
         * `pending_email` rather than 404, because the screen's Cancel button is an
         * "ensure cleared" rather than an "assert exists".
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<CancelMyEmailChangeSchema, CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Cancel My Email Change
         * @description Dismiss the caller's pending email change.
         *
         * Idempotent -- with nothing pending it answers 200 with a null
         * `pending_email` rather than 404, because the screen's Cancel button is an
         * "ensure cleared" rather than an "assert exists".
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.cancelMyEmailChange.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.cancelMyEmailChange.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<CancelMyEmailChangeSchema, CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext>): Mutation<CancelMyEmailChangeData, CancelMyEmailChangeError, MutationVariables<CancelMyEmailChangeBody, CancelMyEmailChangeParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext> | MutationFiltersByMutationKey<CancelMyEmailChangeSchema, CancelMyEmailChangeBody, CancelMyEmailChangeData, CancelMyEmailChangeParameters, OperationError<CancelMyEmailChangeError>, TContext>): Array<Mutation<CancelMyEmailChangeData, CancelMyEmailChangeError, MutationVariables<CancelMyEmailChangeBody, CancelMyEmailChangeParameters>, TContext>>;
        };
        schema: CancelMyEmailChangeSchema;
        types: {
            parameters: CancelMyEmailChangeParameters;
            data: CancelMyEmailChangeData;
            error: CancelMyEmailChangeError;
            body: CancelMyEmailChangeBody;
        };
    };
    /**
     * @summary Get My Study Helper Announcement
     * @description Get the announcement the current student sees from their study helper.
     */
    getMyStudyHelperAnnouncement: {
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetMyStudyHelperAnnouncementParameters, TMeta, TSignal> | void), client?: (schema: GetMyStudyHelperAnnouncementSchema, options: {
            parameters: GetMyStudyHelperAnnouncementParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError>>): Promise<RequestFnResponse<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError>>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        getQueryKey(parameters: DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void): ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMyStudyHelperAnnouncement.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMyStudyHelperAnnouncement.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMyStudyHelperAnnouncementData>(parameters: ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError, TData, ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetMyStudyHelperAnnouncementError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMyStudyHelperAnnouncement.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMyStudyHelperAnnouncement.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMyStudyHelperAnnouncementData>(parameters: ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void), options: Omit<DefinedInitialDataOptions<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError, TData, ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetMyStudyHelperAnnouncementError>>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void): ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMyStudyHelperAnnouncement.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMyStudyHelperAnnouncementParameters, TQueryFnData = GetMyStudyHelperAnnouncementData, TData = OperationInfiniteData<TQueryFnData, GetMyStudyHelperAnnouncementParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetMyStudyHelperAnnouncementError, TData, ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetMyStudyHelperAnnouncementError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMyStudyHelperAnnouncement.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMyStudyHelperAnnouncementParameters, TQueryFnData = GetMyStudyHelperAnnouncementData, TData = OperationInfiniteData<TQueryFnData, GetMyStudyHelperAnnouncementParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetMyStudyHelperAnnouncementError, TData, ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMyStudyHelperAnnouncementData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetMyStudyHelperAnnouncementError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getMyStudyHelperAnnouncementTotal = qraft.v3Service.getMyStudyHelperAnnouncement.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getMyStudyHelperAnnouncementByParametersTotal = qraft.v3Service.getMyStudyHelperAnnouncement.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | QueryFiltersByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getMyStudyHelperAnnouncementResults = qraft.v3Service.getMyStudyHelperAnnouncement.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMyStudyHelperAnnouncementResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getMyStudyHelperAnnouncementCombinedResults = qraft.v3Service.getMyStudyHelperAnnouncement.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMyStudyHelperAnnouncementCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError>>, TCombinedResult = Array<UseQueryResult<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getMyStudyHelperAnnouncement.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getMyStudyHelperAnnouncement.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetMyStudyHelperAnnouncementData>(parameters: ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError, TData, ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetMyStudyHelperAnnouncementError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMyStudyHelperAnnouncement.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetMyStudyHelperAnnouncementParameters, TData = GetMyStudyHelperAnnouncementData>(parameters: ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError, OperationInfiniteData<TData, GetMyStudyHelperAnnouncementParameters>, ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMyStudyHelperAnnouncementData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetMyStudyHelperAnnouncementParameters>, OperationError<GetMyStudyHelperAnnouncementError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getMyStudyHelperAnnouncementData = qraft.v3Service.getMyStudyHelperAnnouncement.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMyStudyHelperAnnouncementResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getMyStudyHelperAnnouncementCombinedData = qraft.v3Service.getMyStudyHelperAnnouncement.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMyStudyHelperAnnouncementCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | void): Promise<GetMyStudyHelperAnnouncementData>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | void): Promise<void>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | void): Promise<GetMyStudyHelperAnnouncementData>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        fetchInfiniteQuery<TPageParam extends GetMyStudyHelperAnnouncementParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters, DeepReadonly<TPageParam>, GetMyStudyHelperAnnouncementError> | void): Promise<OperationInfiniteData<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters>>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        prefetchInfiniteQuery<TPageParam extends GetMyStudyHelperAnnouncementParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters, DeepReadonly<TPageParam>, GetMyStudyHelperAnnouncementError> | void): Promise<void>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        ensureInfiniteQueryData<TPageParam extends GetMyStudyHelperAnnouncementParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters, DeepReadonly<TPageParam>, GetMyStudyHelperAnnouncementError> | void): Promise<OperationInfiniteData<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters>>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void)): GetMyStudyHelperAnnouncementData | undefined;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void)): OperationInfiniteData<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters> | undefined;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | QueryFiltersByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>,
            data: NoInfer<OperationInfiniteData<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>,
            data: GetMyStudyHelperAnnouncementData | undefined
        ]>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | void)): QueryState<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementError> | undefined;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetMyStudyHelperAnnouncementParameters> | ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters> | void): QueryState<OperationInfiniteData<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters>, GetMyStudyHelperAnnouncementError> | undefined;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        setQueryData(parameters: (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | undefined) | ServiceOperationQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>, updater: Updater<NoInfer<GetMyStudyHelperAnnouncementData> | undefined, NoInfer<DeepReadonly<GetMyStudyHelperAnnouncementData>> | undefined>, options?: SetDataOptions): GetMyStudyHelperAnnouncementData | undefined;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetMyStudyHelperAnnouncementParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetMyStudyHelperAnnouncementData, GetMyStudyHelperAnnouncementParameters> | undefined;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | QueryFiltersByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>, updater: Updater<NoInfer<GetMyStudyHelperAnnouncementData> | undefined, NoInfer<GetMyStudyHelperAnnouncementData> | undefined>, options?: SetDataOptions): Array<GetMyStudyHelperAnnouncementData | undefined>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | QueryFiltersByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | QueryFiltersByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | QueryFiltersByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>): void;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | QueryFiltersByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get My Study Helper Announcement
         * @description Get the announcement the current student sees from their study helper.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError> | QueryFiltersByQueryKey<GetMyStudyHelperAnnouncementSchema, GetMyStudyHelperAnnouncementData, TInfinite, GetMyStudyHelperAnnouncementParameters, GetMyStudyHelperAnnouncementError>): number;
        schema: GetMyStudyHelperAnnouncementSchema;
        types: {
            parameters: GetMyStudyHelperAnnouncementParameters;
            data: GetMyStudyHelperAnnouncementData;
            error: GetMyStudyHelperAnnouncementError;
        };
    };
    /**
     * @summary Get Member Profile Route
     * @description A member's profile page, for every member type and every admitted viewer.
     *
     * A private profile answers 200 with `access` set to private and no sections; only a
     * missing member is a 404. `language` localizes the `country` name.
     */
    getMemberProfile: {
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetMemberProfileSchema, GetMemberProfileParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetMemberProfileParameters, TMeta, TSignal>), client?: (schema: GetMemberProfileSchema, options: {
            parameters: GetMemberProfileParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetMemberProfileData, GetMemberProfileError>>): Promise<RequestFnResponse<GetMemberProfileData, GetMemberProfileError>>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        getQueryKey(parameters: DeepReadonly<GetMemberProfileParameters>): ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMemberProfile.useQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMemberProfileData>(parameters: ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>), options?: Omit<UndefinedInitialDataOptions<GetMemberProfileData, GetMemberProfileError, TData, ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetMemberProfileError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMemberProfile.useQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMemberProfileData>(parameters: ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>), options: Omit<DefinedInitialDataOptions<GetMemberProfileData, GetMemberProfileError, TData, ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetMemberProfileError>>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetMemberProfileParameters>): ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberProfile.useInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMemberProfileParameters, TQueryFnData = GetMemberProfileData, TData = OperationInfiniteData<TQueryFnData, GetMemberProfileParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetMemberProfileError, TData, ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetMemberProfileError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberProfile.useInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMemberProfileParameters, TQueryFnData = GetMemberProfileData, TData = OperationInfiniteData<TQueryFnData, GetMemberProfileParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetMemberProfileError, TData, ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMemberProfileData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetMemberProfileError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getMemberProfileTotal = qraft.v3Service.getMemberProfile.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getMemberProfileByParametersTotal = qraft.v3Service.getMemberProfile.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError> | QueryFiltersByQueryKey<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getMemberProfileResults = qraft.v3Service.getMemberProfile.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberProfileResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getMemberProfileCombinedResults = qraft.v3Service.getMemberProfile.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberProfileCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetMemberProfileSchema, GetMemberProfileParameters, GetMemberProfileData, GetMemberProfileError>>, TCombinedResult = Array<UseQueryResult<GetMemberProfileData, GetMemberProfileError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetMemberProfileData, GetMemberProfileError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getMemberProfile.useSuspenseQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetMemberProfileData>(parameters: ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>), options?: Omit<UseSuspenseQueryOptions<GetMemberProfileData, GetMemberProfileError, TData, ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetMemberProfileError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberProfile.useSuspenseInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetMemberProfileParameters, TData = GetMemberProfileData>(parameters: ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetMemberProfileData, GetMemberProfileError, OperationInfiniteData<TData, GetMemberProfileParameters>, ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMemberProfileData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetMemberProfileParameters>, OperationError<GetMemberProfileError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getMemberProfileData = qraft.v3Service.getMemberProfile.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberProfileResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getMemberProfileCombinedData = qraft.v3Service.getMemberProfile.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberProfileCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetMemberProfileSchema, GetMemberProfileParameters, GetMemberProfileData, GetMemberProfileError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetMemberProfileData, GetMemberProfileError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetMemberProfileData, GetMemberProfileError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetMemberProfileSchema, GetMemberProfileData, GetMemberProfileParameters, GetMemberProfileError>): Promise<GetMemberProfileData>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetMemberProfileSchema, GetMemberProfileData, GetMemberProfileParameters, GetMemberProfileError>): Promise<void>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetMemberProfileSchema, GetMemberProfileData, GetMemberProfileParameters, GetMemberProfileError>): Promise<GetMemberProfileData>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        fetchInfiniteQuery<TPageParam extends GetMemberProfileParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMemberProfileSchema, GetMemberProfileData, GetMemberProfileParameters, DeepReadonly<TPageParam>, GetMemberProfileError>): Promise<OperationInfiniteData<GetMemberProfileData, GetMemberProfileParameters>>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        prefetchInfiniteQuery<TPageParam extends GetMemberProfileParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMemberProfileSchema, GetMemberProfileData, GetMemberProfileParameters, DeepReadonly<TPageParam>, GetMemberProfileError>): Promise<void>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        ensureInfiniteQueryData<TPageParam extends GetMemberProfileParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetMemberProfileSchema, GetMemberProfileData, GetMemberProfileParameters, DeepReadonly<TPageParam>, GetMemberProfileError>): Promise<OperationInfiniteData<GetMemberProfileData, GetMemberProfileParameters>>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>)): GetMemberProfileData | undefined;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>)): OperationInfiniteData<GetMemberProfileData, GetMemberProfileParameters> | undefined;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError> | QueryFiltersByQueryKey<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>,
            data: NoInfer<OperationInfiniteData<GetMemberProfileData, GetMemberProfileParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>,
            data: GetMemberProfileData | undefined
        ]>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters> | (DeepReadonly<GetMemberProfileParameters>)): QueryState<GetMemberProfileData, GetMemberProfileError> | undefined;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetMemberProfileParameters> | ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>): QueryState<OperationInfiniteData<GetMemberProfileData, GetMemberProfileParameters>, GetMemberProfileError> | undefined;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        setQueryData(parameters: (DeepReadonly<GetMemberProfileParameters>) | ServiceOperationQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>, updater: Updater<NoInfer<GetMemberProfileData> | undefined, NoInfer<DeepReadonly<GetMemberProfileData>> | undefined>, options?: SetDataOptions): GetMemberProfileData | undefined;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetMemberProfileParameters>) | ServiceOperationInfiniteQueryKey<GetMemberProfileSchema, GetMemberProfileParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetMemberProfileData, GetMemberProfileParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetMemberProfileData, GetMemberProfileParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetMemberProfileData, GetMemberProfileParameters> | undefined;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError> | QueryFiltersByQueryKey<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>, updater: Updater<NoInfer<GetMemberProfileData> | undefined, NoInfer<GetMemberProfileData> | undefined>, options?: SetDataOptions): Array<GetMemberProfileData | undefined>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError> | QueryFiltersByQueryKey<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError> | QueryFiltersByQueryKey<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError> | QueryFiltersByQueryKey<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>): void;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError> | QueryFiltersByQueryKey<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Member Profile Route
         * @description A member's profile page, for every member type and every admitted viewer.
         *
         * A private profile answers 200 with `access` set to private and no sections; only a
         * missing member is a 404. `language` localizes the `country` name.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError> | QueryFiltersByQueryKey<GetMemberProfileSchema, GetMemberProfileData, TInfinite, GetMemberProfileParameters, GetMemberProfileError>): number;
        schema: GetMemberProfileSchema;
        types: {
            parameters: GetMemberProfileParameters;
            data: GetMemberProfileData;
            error: GetMemberProfileError;
        };
    };
    /**
     * @summary Update Member Profile Route
     * @description Save a profile edit, and answer with the freshly read profile, so the client
     * renders the saved state.
     */
    updateMemberProfile: {
        /**
         * @summary Update Member Profile Route
         * @description Save a profile edit, and answer with the freshly read profile, so the client
         * renders the saved state.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UpdateMemberProfileBody, UpdateMemberProfileParameters, TMeta, TSignal>, client?: (schema: UpdateMemberProfileSchema, options: ServiceOperationMutationFnOptions<UpdateMemberProfileBody, UpdateMemberProfileParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UpdateMemberProfileData, UpdateMemberProfileError>>): Promise<RequestFnResponse<UpdateMemberProfileData, UpdateMemberProfileError>>;
        /**
         * @summary Update Member Profile Route
         * @description Save a profile edit, and answer with the freshly read profile, so the client
         * renders the saved state.
         */
        getMutationKey(parameters: DeepReadonly<UpdateMemberProfileParameters> | void): ServiceOperationMutationKey<UpdateMemberProfileSchema, UpdateMemberProfileParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Member Profile Route
         * @description Save a profile edit, and answer with the freshly read profile, so the client
         * renders the saved state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateMemberProfile.useMutation({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateMemberProfile.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UpdateMemberProfileBody, TContext = unknown>(parameters: DeepReadonly<UpdateMemberProfileParameters>, options?: ServiceOperationUseMutationOptions<UpdateMemberProfileSchema, UpdateMemberProfileData, UpdateMemberProfileParameters, TVariables, OperationError<UpdateMemberProfileError>, TContext>): UseMutationResult<UpdateMemberProfileData, OperationError<UpdateMemberProfileError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Member Profile Route
         * @description Save a profile edit, and answer with the freshly read profile, so the client
         * renders the saved state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateMemberProfile.useMutation({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateMemberProfile.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UpdateMemberProfileBody, UpdateMemberProfileParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UpdateMemberProfileSchema, UpdateMemberProfileData, UpdateMemberProfileParameters, TVariables, OperationError<UpdateMemberProfileError>, TContext>): UseMutationResult<UpdateMemberProfileData, OperationError<UpdateMemberProfileError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Update Member Profile Route
         * @description Save a profile edit, and answer with the freshly read profile, so the client
         * renders the saved state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const updateMemberProfileTotal = qraft.v3Service.updateMemberProfile.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const updateMemberProfileTotal = qraft.v3Service.updateMemberProfile.useIsMutating({
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext> | MutationFiltersByMutationKey<UpdateMemberProfileSchema, UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Update Member Profile Route
         * @description Save a profile edit, and answer with the freshly read profile, so the client
         * renders the saved state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const updateMemberProfilePendingMutationVariables = qraft.v3Service.updateMemberProfile.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const updateMemberProfileMutationData = qraft.v3Service.updateMemberProfile.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 member_id: memberId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UpdateMemberProfileData, OperationError<UpdateMemberProfileError>, MutationVariables<UpdateMemberProfileBody, UpdateMemberProfileParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext> | MutationFiltersByMutationKey<UpdateMemberProfileSchema, UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext>;
            select?: (mutation: Mutation<UpdateMemberProfileData, OperationError<UpdateMemberProfileError>, MutationVariables<UpdateMemberProfileBody, UpdateMemberProfileParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Update Member Profile Route
         * @description Save a profile edit, and answer with the freshly read profile, so the client
         * renders the saved state.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext> | MutationFiltersByMutationKey<UpdateMemberProfileSchema, UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Update Member Profile Route
         * @description Save a profile edit, and answer with the freshly read profile, so the client
         * renders the saved state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.updateMemberProfile.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.updateMemberProfile.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext> | MutationFiltersByMutationKey<UpdateMemberProfileSchema, UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext>): Mutation<UpdateMemberProfileData, UpdateMemberProfileError, MutationVariables<UpdateMemberProfileBody, UpdateMemberProfileParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext> | MutationFiltersByMutationKey<UpdateMemberProfileSchema, UpdateMemberProfileBody, UpdateMemberProfileData, UpdateMemberProfileParameters, OperationError<UpdateMemberProfileError>, TContext>): Array<Mutation<UpdateMemberProfileData, UpdateMemberProfileError, MutationVariables<UpdateMemberProfileBody, UpdateMemberProfileParameters>, TContext>>;
        };
        schema: UpdateMemberProfileSchema;
        types: {
            parameters: UpdateMemberProfileParameters;
            data: UpdateMemberProfileData;
            error: UpdateMemberProfileError;
            body: UpdateMemberProfileBody;
        };
    };
    /**
     * @summary Get Member Profile Form Route
     * @description The edit form's shape: which tabs, which fields, which options.
     *
     * Derived on the server, because the tab set depends on both the member's type and the
     * viewer.
     */
    getMemberProfileForm: {
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetMemberProfileFormParameters, TMeta, TSignal>), client?: (schema: GetMemberProfileFormSchema, options: {
            parameters: GetMemberProfileFormParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetMemberProfileFormData, GetMemberProfileFormError>>): Promise<RequestFnResponse<GetMemberProfileFormData, GetMemberProfileFormError>>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        getQueryKey(parameters: DeepReadonly<GetMemberProfileFormParameters>): ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMemberProfileForm.useQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMemberProfileFormData>(parameters: ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>), options?: Omit<UndefinedInitialDataOptions<GetMemberProfileFormData, GetMemberProfileFormError, TData, ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetMemberProfileFormError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMemberProfileForm.useQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMemberProfileFormData>(parameters: ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>), options: Omit<DefinedInitialDataOptions<GetMemberProfileFormData, GetMemberProfileFormError, TData, ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetMemberProfileFormError>>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetMemberProfileFormParameters>): ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberProfileForm.useInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMemberProfileFormParameters, TQueryFnData = GetMemberProfileFormData, TData = OperationInfiniteData<TQueryFnData, GetMemberProfileFormParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetMemberProfileFormError, TData, ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetMemberProfileFormError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberProfileForm.useInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMemberProfileFormParameters, TQueryFnData = GetMemberProfileFormData, TData = OperationInfiniteData<TQueryFnData, GetMemberProfileFormParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetMemberProfileFormError, TData, ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMemberProfileFormData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetMemberProfileFormError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getMemberProfileFormTotal = qraft.v3Service.getMemberProfileForm.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getMemberProfileFormByParametersTotal = qraft.v3Service.getMemberProfileForm.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError> | QueryFiltersByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getMemberProfileFormResults = qraft.v3Service.getMemberProfileForm.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberProfileFormResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getMemberProfileFormCombinedResults = qraft.v3Service.getMemberProfileForm.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberProfileFormCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetMemberProfileFormSchema, GetMemberProfileFormParameters, GetMemberProfileFormData, GetMemberProfileFormError>>, TCombinedResult = Array<UseQueryResult<GetMemberProfileFormData, GetMemberProfileFormError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetMemberProfileFormData, GetMemberProfileFormError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getMemberProfileForm.useSuspenseQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetMemberProfileFormData>(parameters: ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>), options?: Omit<UseSuspenseQueryOptions<GetMemberProfileFormData, GetMemberProfileFormError, TData, ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetMemberProfileFormError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberProfileForm.useSuspenseInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetMemberProfileFormParameters, TData = GetMemberProfileFormData>(parameters: ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetMemberProfileFormData, GetMemberProfileFormError, OperationInfiniteData<TData, GetMemberProfileFormParameters>, ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMemberProfileFormData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetMemberProfileFormParameters>, OperationError<GetMemberProfileFormError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getMemberProfileFormData = qraft.v3Service.getMemberProfileForm.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberProfileFormResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getMemberProfileFormCombinedData = qraft.v3Service.getMemberProfileForm.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberProfileFormCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetMemberProfileFormSchema, GetMemberProfileFormParameters, GetMemberProfileFormData, GetMemberProfileFormError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetMemberProfileFormData, GetMemberProfileFormError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetMemberProfileFormData, GetMemberProfileFormError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetMemberProfileFormSchema, GetMemberProfileFormData, GetMemberProfileFormParameters, GetMemberProfileFormError>): Promise<GetMemberProfileFormData>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetMemberProfileFormSchema, GetMemberProfileFormData, GetMemberProfileFormParameters, GetMemberProfileFormError>): Promise<void>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetMemberProfileFormSchema, GetMemberProfileFormData, GetMemberProfileFormParameters, GetMemberProfileFormError>): Promise<GetMemberProfileFormData>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        fetchInfiniteQuery<TPageParam extends GetMemberProfileFormParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMemberProfileFormSchema, GetMemberProfileFormData, GetMemberProfileFormParameters, DeepReadonly<TPageParam>, GetMemberProfileFormError>): Promise<OperationInfiniteData<GetMemberProfileFormData, GetMemberProfileFormParameters>>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        prefetchInfiniteQuery<TPageParam extends GetMemberProfileFormParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMemberProfileFormSchema, GetMemberProfileFormData, GetMemberProfileFormParameters, DeepReadonly<TPageParam>, GetMemberProfileFormError>): Promise<void>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        ensureInfiniteQueryData<TPageParam extends GetMemberProfileFormParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetMemberProfileFormSchema, GetMemberProfileFormData, GetMemberProfileFormParameters, DeepReadonly<TPageParam>, GetMemberProfileFormError>): Promise<OperationInfiniteData<GetMemberProfileFormData, GetMemberProfileFormParameters>>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>)): GetMemberProfileFormData | undefined;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>)): OperationInfiniteData<GetMemberProfileFormData, GetMemberProfileFormParameters> | undefined;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError> | QueryFiltersByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>,
            data: NoInfer<OperationInfiniteData<GetMemberProfileFormData, GetMemberProfileFormParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>,
            data: GetMemberProfileFormData | undefined
        ]>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters> | (DeepReadonly<GetMemberProfileFormParameters>)): QueryState<GetMemberProfileFormData, GetMemberProfileFormError> | undefined;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetMemberProfileFormParameters> | ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>): QueryState<OperationInfiniteData<GetMemberProfileFormData, GetMemberProfileFormParameters>, GetMemberProfileFormError> | undefined;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        setQueryData(parameters: (DeepReadonly<GetMemberProfileFormParameters>) | ServiceOperationQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>, updater: Updater<NoInfer<GetMemberProfileFormData> | undefined, NoInfer<DeepReadonly<GetMemberProfileFormData>> | undefined>, options?: SetDataOptions): GetMemberProfileFormData | undefined;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetMemberProfileFormParameters>) | ServiceOperationInfiniteQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetMemberProfileFormData, GetMemberProfileFormParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetMemberProfileFormData, GetMemberProfileFormParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetMemberProfileFormData, GetMemberProfileFormParameters> | undefined;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError> | QueryFiltersByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>, updater: Updater<NoInfer<GetMemberProfileFormData> | undefined, NoInfer<GetMemberProfileFormData> | undefined>, options?: SetDataOptions): Array<GetMemberProfileFormData | undefined>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError> | QueryFiltersByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError> | QueryFiltersByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError> | QueryFiltersByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>): void;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError> | QueryFiltersByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Member Profile Form Route
         * @description The edit form's shape: which tabs, which fields, which options.
         *
         * Derived on the server, because the tab set depends on both the member's type and the
         * viewer.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError> | QueryFiltersByQueryKey<GetMemberProfileFormSchema, GetMemberProfileFormData, TInfinite, GetMemberProfileFormParameters, GetMemberProfileFormError>): number;
        schema: GetMemberProfileFormSchema;
        types: {
            parameters: GetMemberProfileFormParameters;
            data: GetMemberProfileFormData;
            error: GetMemberProfileFormError;
        };
    };
    /**
     * @summary Upload Member Avatar
     * @description Set the member's photo from one multipart POST carrying the cropped image.
     *
     * The gate is a dependency, so it runs before the upload is read: a refused caller
     * writes nothing to object storage, which a session rollback wouldn't undo.
     */
    uploadMemberAvatar: {
        /**
         * @summary Upload Member Avatar
         * @description Set the member's photo from one multipart POST carrying the cropped image.
         *
         * The gate is a dependency, so it runs before the upload is read: a refused caller
         * writes nothing to object storage, which a session rollback wouldn't undo.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UploadMemberAvatarBody, UploadMemberAvatarParameters, TMeta, TSignal>, client?: (schema: UploadMemberAvatarSchema, options: ServiceOperationMutationFnOptions<UploadMemberAvatarBody, UploadMemberAvatarParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UploadMemberAvatarData, UploadMemberAvatarError>>): Promise<RequestFnResponse<UploadMemberAvatarData, UploadMemberAvatarError>>;
        /**
         * @summary Upload Member Avatar
         * @description Set the member's photo from one multipart POST carrying the cropped image.
         *
         * The gate is a dependency, so it runs before the upload is read: a refused caller
         * writes nothing to object storage, which a session rollback wouldn't undo.
         */
        getMutationKey(parameters: DeepReadonly<UploadMemberAvatarParameters> | void): ServiceOperationMutationKey<UploadMemberAvatarSchema, UploadMemberAvatarParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Upload Member Avatar
         * @description Set the member's photo from one multipart POST carrying the cropped image.
         *
         * The gate is a dependency, so it runs before the upload is read: a refused caller
         * writes nothing to object storage, which a session rollback wouldn't undo.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.uploadMemberAvatar.useMutation({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.uploadMemberAvatar.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UploadMemberAvatarBody, TContext = unknown>(parameters: DeepReadonly<UploadMemberAvatarParameters>, options?: ServiceOperationUseMutationOptions<UploadMemberAvatarSchema, UploadMemberAvatarData, UploadMemberAvatarParameters, TVariables, OperationError<UploadMemberAvatarError>, TContext>): UseMutationResult<UploadMemberAvatarData, OperationError<UploadMemberAvatarError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Upload Member Avatar
         * @description Set the member's photo from one multipart POST carrying the cropped image.
         *
         * The gate is a dependency, so it runs before the upload is read: a refused caller
         * writes nothing to object storage, which a session rollback wouldn't undo.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.uploadMemberAvatar.useMutation({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.uploadMemberAvatar.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UploadMemberAvatarBody, UploadMemberAvatarParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UploadMemberAvatarSchema, UploadMemberAvatarData, UploadMemberAvatarParameters, TVariables, OperationError<UploadMemberAvatarError>, TContext>): UseMutationResult<UploadMemberAvatarData, OperationError<UploadMemberAvatarError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Upload Member Avatar
         * @description Set the member's photo from one multipart POST carrying the cropped image.
         *
         * The gate is a dependency, so it runs before the upload is read: a refused caller
         * writes nothing to object storage, which a session rollback wouldn't undo.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const uploadMemberAvatarTotal = qraft.v3Service.uploadMemberAvatar.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const uploadMemberAvatarTotal = qraft.v3Service.uploadMemberAvatar.useIsMutating({
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext> | MutationFiltersByMutationKey<UploadMemberAvatarSchema, UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Upload Member Avatar
         * @description Set the member's photo from one multipart POST carrying the cropped image.
         *
         * The gate is a dependency, so it runs before the upload is read: a refused caller
         * writes nothing to object storage, which a session rollback wouldn't undo.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const uploadMemberAvatarPendingMutationVariables = qraft.v3Service.uploadMemberAvatar.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const uploadMemberAvatarMutationData = qraft.v3Service.uploadMemberAvatar.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 member_id: memberId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UploadMemberAvatarData, OperationError<UploadMemberAvatarError>, MutationVariables<UploadMemberAvatarBody, UploadMemberAvatarParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext> | MutationFiltersByMutationKey<UploadMemberAvatarSchema, UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext>;
            select?: (mutation: Mutation<UploadMemberAvatarData, OperationError<UploadMemberAvatarError>, MutationVariables<UploadMemberAvatarBody, UploadMemberAvatarParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Upload Member Avatar
         * @description Set the member's photo from one multipart POST carrying the cropped image.
         *
         * The gate is a dependency, so it runs before the upload is read: a refused caller
         * writes nothing to object storage, which a session rollback wouldn't undo.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext> | MutationFiltersByMutationKey<UploadMemberAvatarSchema, UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Upload Member Avatar
         * @description Set the member's photo from one multipart POST carrying the cropped image.
         *
         * The gate is a dependency, so it runs before the upload is read: a refused caller
         * writes nothing to object storage, which a session rollback wouldn't undo.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.uploadMemberAvatar.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.uploadMemberAvatar.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext> | MutationFiltersByMutationKey<UploadMemberAvatarSchema, UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext>): Mutation<UploadMemberAvatarData, UploadMemberAvatarError, MutationVariables<UploadMemberAvatarBody, UploadMemberAvatarParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext> | MutationFiltersByMutationKey<UploadMemberAvatarSchema, UploadMemberAvatarBody, UploadMemberAvatarData, UploadMemberAvatarParameters, OperationError<UploadMemberAvatarError>, TContext>): Array<Mutation<UploadMemberAvatarData, UploadMemberAvatarError, MutationVariables<UploadMemberAvatarBody, UploadMemberAvatarParameters>, TContext>>;
        };
        schema: UploadMemberAvatarSchema;
        types: {
            parameters: UploadMemberAvatarParameters;
            data: UploadMemberAvatarData;
            error: UploadMemberAvatarError;
            body: UploadMemberAvatarBody;
        };
    };
    /**
     * @summary Delete Member Avatar
     * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
     */
    deleteMemberAvatar: {
        /**
         * @summary Delete Member Avatar
         * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteMemberAvatarBody, DeleteMemberAvatarParameters, TMeta, TSignal>, client?: (schema: DeleteMemberAvatarSchema, options: ServiceOperationMutationFnOptions<DeleteMemberAvatarBody, DeleteMemberAvatarParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteMemberAvatarData, DeleteMemberAvatarError>>): Promise<RequestFnResponse<DeleteMemberAvatarData, DeleteMemberAvatarError>>;
        /**
         * @summary Delete Member Avatar
         * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
         */
        getMutationKey(parameters: DeepReadonly<DeleteMemberAvatarParameters> | void): ServiceOperationMutationKey<DeleteMemberAvatarSchema, DeleteMemberAvatarParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Member Avatar
         * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMemberAvatar.useMutation({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMemberAvatar.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteMemberAvatarBody, TContext = unknown>(parameters: DeepReadonly<DeleteMemberAvatarParameters>, options?: ServiceOperationUseMutationOptions<DeleteMemberAvatarSchema, DeleteMemberAvatarData, DeleteMemberAvatarParameters, TVariables, OperationError<DeleteMemberAvatarError>, TContext>): UseMutationResult<DeleteMemberAvatarData, OperationError<DeleteMemberAvatarError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Member Avatar
         * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMemberAvatar.useMutation({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMemberAvatar.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteMemberAvatarBody, DeleteMemberAvatarParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteMemberAvatarSchema, DeleteMemberAvatarData, DeleteMemberAvatarParameters, TVariables, OperationError<DeleteMemberAvatarError>, TContext>): UseMutationResult<DeleteMemberAvatarData, OperationError<DeleteMemberAvatarError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Member Avatar
         * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteMemberAvatarTotal = qraft.v3Service.deleteMemberAvatar.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteMemberAvatarTotal = qraft.v3Service.deleteMemberAvatar.useIsMutating({
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteMemberAvatarSchema, DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Member Avatar
         * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteMemberAvatarPendingMutationVariables = qraft.v3Service.deleteMemberAvatar.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteMemberAvatarMutationData = qraft.v3Service.deleteMemberAvatar.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 member_id: memberId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteMemberAvatarData, OperationError<DeleteMemberAvatarError>, MutationVariables<DeleteMemberAvatarBody, DeleteMemberAvatarParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteMemberAvatarSchema, DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext>;
            select?: (mutation: Mutation<DeleteMemberAvatarData, OperationError<DeleteMemberAvatarError>, MutationVariables<DeleteMemberAvatarBody, DeleteMemberAvatarParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete Member Avatar
         * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteMemberAvatarSchema, DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Member Avatar
         * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteMemberAvatar.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteMemberAvatar.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteMemberAvatarSchema, DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext>): Mutation<DeleteMemberAvatarData, DeleteMemberAvatarError, MutationVariables<DeleteMemberAvatarBody, DeleteMemberAvatarParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteMemberAvatarSchema, DeleteMemberAvatarBody, DeleteMemberAvatarData, DeleteMemberAvatarParameters, OperationError<DeleteMemberAvatarError>, TContext>): Array<Mutation<DeleteMemberAvatarData, DeleteMemberAvatarError, MutationVariables<DeleteMemberAvatarBody, DeleteMemberAvatarParameters>, TContext>>;
        };
        schema: DeleteMemberAvatarSchema;
        types: {
            parameters: DeleteMemberAvatarParameters;
            data: DeleteMemberAvatarData;
            error: DeleteMemberAvatarError;
            body: DeleteMemberAvatarBody;
        };
    };
    /** @summary List Onboarding Sequences */
    listOnboardingSequences: {
        /** @summary List Onboarding Sequences */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListOnboardingSequencesParameters, TMeta, TSignal> | void), client?: (schema: ListOnboardingSequencesSchema, options: {
            parameters: ListOnboardingSequencesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListOnboardingSequencesData, ListOnboardingSequencesError>>): Promise<RequestFnResponse<ListOnboardingSequencesData, ListOnboardingSequencesError>>;
        /** @summary List Onboarding Sequences */
        getQueryKey(parameters: DeepReadonly<ListOnboardingSequencesParameters> | void): ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listOnboardingSequences.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listOnboardingSequences.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListOnboardingSequencesData>(parameters: ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListOnboardingSequencesData, ListOnboardingSequencesError, TData, ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListOnboardingSequencesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listOnboardingSequences.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listOnboardingSequences.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListOnboardingSequencesData>(parameters: ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void), options: Omit<DefinedInitialDataOptions<ListOnboardingSequencesData, ListOnboardingSequencesError, TData, ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListOnboardingSequencesError>>;
        /** @summary List Onboarding Sequences */
        getInfiniteQueryKey(parameters: DeepReadonly<ListOnboardingSequencesParameters> | void): ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listOnboardingSequences.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListOnboardingSequencesParameters, TQueryFnData = ListOnboardingSequencesData, TData = OperationInfiniteData<TQueryFnData, ListOnboardingSequencesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListOnboardingSequencesError, TData, ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListOnboardingSequencesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listOnboardingSequences.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListOnboardingSequencesParameters, TQueryFnData = ListOnboardingSequencesData, TData = OperationInfiniteData<TQueryFnData, ListOnboardingSequencesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListOnboardingSequencesError, TData, ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListOnboardingSequencesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListOnboardingSequencesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listOnboardingSequencesTotal = qraft.v3Service.listOnboardingSequences.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listOnboardingSequencesByParametersTotal = qraft.v3Service.listOnboardingSequences.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | QueryFiltersByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listOnboardingSequencesResults = qraft.v3Service.listOnboardingSequences.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listOnboardingSequencesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listOnboardingSequencesCombinedResults = qraft.v3Service.listOnboardingSequences.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listOnboardingSequencesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters, ListOnboardingSequencesData, ListOnboardingSequencesError>>, TCombinedResult = Array<UseQueryResult<ListOnboardingSequencesData, ListOnboardingSequencesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListOnboardingSequencesData, ListOnboardingSequencesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listOnboardingSequences.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listOnboardingSequences.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListOnboardingSequencesData>(parameters: ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListOnboardingSequencesData, ListOnboardingSequencesError, TData, ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListOnboardingSequencesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listOnboardingSequences.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListOnboardingSequencesParameters, TData = ListOnboardingSequencesData>(parameters: ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListOnboardingSequencesData, ListOnboardingSequencesError, OperationInfiniteData<TData, ListOnboardingSequencesParameters>, ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListOnboardingSequencesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListOnboardingSequencesParameters>, OperationError<ListOnboardingSequencesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Onboarding Sequences
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listOnboardingSequencesData = qraft.v3Service.listOnboardingSequences.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listOnboardingSequencesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listOnboardingSequencesCombinedData = qraft.v3Service.listOnboardingSequences.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listOnboardingSequencesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters, ListOnboardingSequencesData, ListOnboardingSequencesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListOnboardingSequencesData, ListOnboardingSequencesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListOnboardingSequencesData, ListOnboardingSequencesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary List Onboarding Sequences */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListOnboardingSequencesSchema, ListOnboardingSequencesData, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | void): Promise<ListOnboardingSequencesData>;
        /** @summary List Onboarding Sequences */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListOnboardingSequencesSchema, ListOnboardingSequencesData, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | void): Promise<void>;
        /** @summary List Onboarding Sequences */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListOnboardingSequencesSchema, ListOnboardingSequencesData, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | void): Promise<ListOnboardingSequencesData>;
        /** @summary List Onboarding Sequences */
        fetchInfiniteQuery<TPageParam extends ListOnboardingSequencesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListOnboardingSequencesSchema, ListOnboardingSequencesData, ListOnboardingSequencesParameters, DeepReadonly<TPageParam>, ListOnboardingSequencesError> | void): Promise<OperationInfiniteData<ListOnboardingSequencesData, ListOnboardingSequencesParameters>>;
        /** @summary List Onboarding Sequences */
        prefetchInfiniteQuery<TPageParam extends ListOnboardingSequencesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListOnboardingSequencesSchema, ListOnboardingSequencesData, ListOnboardingSequencesParameters, DeepReadonly<TPageParam>, ListOnboardingSequencesError> | void): Promise<void>;
        /** @summary List Onboarding Sequences */
        ensureInfiniteQueryData<TPageParam extends ListOnboardingSequencesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListOnboardingSequencesSchema, ListOnboardingSequencesData, ListOnboardingSequencesParameters, DeepReadonly<TPageParam>, ListOnboardingSequencesError> | void): Promise<OperationInfiniteData<ListOnboardingSequencesData, ListOnboardingSequencesParameters>>;
        /** @summary List Onboarding Sequences */
        getQueryData(parameters: ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void)): ListOnboardingSequencesData | undefined;
        /** @summary List Onboarding Sequences */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void)): OperationInfiniteData<ListOnboardingSequencesData, ListOnboardingSequencesParameters> | undefined;
        /** @summary List Onboarding Sequences */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | QueryFiltersByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>,
            data: NoInfer<OperationInfiniteData<ListOnboardingSequencesData, ListOnboardingSequencesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>,
            data: ListOnboardingSequencesData | undefined
        ]>;
        /** @summary List Onboarding Sequences */
        getQueryState(parameters: ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | (DeepReadonly<ListOnboardingSequencesParameters> | void)): QueryState<ListOnboardingSequencesData, ListOnboardingSequencesError> | undefined;
        /** @summary List Onboarding Sequences */
        getInfiniteQueryState(parameters: DeepReadonly<ListOnboardingSequencesParameters> | ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters> | void): QueryState<OperationInfiniteData<ListOnboardingSequencesData, ListOnboardingSequencesParameters>, ListOnboardingSequencesError> | undefined;
        /** @summary List Onboarding Sequences */
        setQueryData(parameters: (DeepReadonly<ListOnboardingSequencesParameters> | undefined) | ServiceOperationQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>, updater: Updater<NoInfer<ListOnboardingSequencesData> | undefined, NoInfer<DeepReadonly<ListOnboardingSequencesData>> | undefined>, options?: SetDataOptions): ListOnboardingSequencesData | undefined;
        /** @summary List Onboarding Sequences */
        setInfiniteQueryData(parameters: (DeepReadonly<ListOnboardingSequencesParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListOnboardingSequencesData, ListOnboardingSequencesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListOnboardingSequencesData, ListOnboardingSequencesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListOnboardingSequencesData, ListOnboardingSequencesParameters> | undefined;
        /** @summary List Onboarding Sequences */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | QueryFiltersByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>, updater: Updater<NoInfer<ListOnboardingSequencesData> | undefined, NoInfer<ListOnboardingSequencesData> | undefined>, options?: SetDataOptions): Array<ListOnboardingSequencesData | undefined>;
        /** @summary List Onboarding Sequences */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary List Onboarding Sequences */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | QueryFiltersByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>, options?: RefetchOptions): Promise<void>;
        /** @summary List Onboarding Sequences */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | QueryFiltersByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>, options?: CancelOptions): Promise<void>;
        /** @summary List Onboarding Sequences */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | QueryFiltersByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>): void;
        /** @summary List Onboarding Sequences */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | QueryFiltersByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>, options?: ResetOptions): Promise<void>;
        /** @summary List Onboarding Sequences */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError> | QueryFiltersByQueryKey<ListOnboardingSequencesSchema, ListOnboardingSequencesData, TInfinite, ListOnboardingSequencesParameters, ListOnboardingSequencesError>): number;
        schema: ListOnboardingSequencesSchema;
        types: {
            parameters: ListOnboardingSequencesParameters;
            data: ListOnboardingSequencesData;
            error: ListOnboardingSequencesError;
        };
    };
    /** @summary Get Onboarding Sequence */
    getOnboardingSequence: {
        /** @summary Get Onboarding Sequence */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetOnboardingSequenceParameters, TMeta, TSignal>), client?: (schema: GetOnboardingSequenceSchema, options: {
            parameters: GetOnboardingSequenceParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetOnboardingSequenceData, GetOnboardingSequenceError>>): Promise<RequestFnResponse<GetOnboardingSequenceData, GetOnboardingSequenceError>>;
        /** @summary Get Onboarding Sequence */
        getQueryKey(parameters: DeepReadonly<GetOnboardingSequenceParameters>): ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getOnboardingSequence.useQuery({
         *     path: {
         *         onboarding_id: onboardingId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetOnboardingSequenceData>(parameters: ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>), options?: Omit<UndefinedInitialDataOptions<GetOnboardingSequenceData, GetOnboardingSequenceError, TData, ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetOnboardingSequenceError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getOnboardingSequence.useQuery({
         *     path: {
         *         onboarding_id: onboardingId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetOnboardingSequenceData>(parameters: ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>), options: Omit<DefinedInitialDataOptions<GetOnboardingSequenceData, GetOnboardingSequenceError, TData, ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetOnboardingSequenceError>>;
        /** @summary Get Onboarding Sequence */
        getInfiniteQueryKey(parameters: DeepReadonly<GetOnboardingSequenceParameters>): ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getOnboardingSequence.useInfiniteQuery({
         *     path: {
         *         onboarding_id: onboardingId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetOnboardingSequenceParameters, TQueryFnData = GetOnboardingSequenceData, TData = OperationInfiniteData<TQueryFnData, GetOnboardingSequenceParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetOnboardingSequenceError, TData, ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetOnboardingSequenceError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getOnboardingSequence.useInfiniteQuery({
         *     path: {
         *         onboarding_id: onboardingId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetOnboardingSequenceParameters, TQueryFnData = GetOnboardingSequenceData, TData = OperationInfiniteData<TQueryFnData, GetOnboardingSequenceParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetOnboardingSequenceError, TData, ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetOnboardingSequenceData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetOnboardingSequenceError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getOnboardingSequenceTotal = qraft.v3Service.getOnboardingSequence.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getOnboardingSequenceByParametersTotal = qraft.v3Service.getOnboardingSequence.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             onboarding_id: onboardingId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError> | QueryFiltersByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getOnboardingSequenceResults = qraft.v3Service.getOnboardingSequence.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 onboarding_id: onboardingId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 onboarding_id: onboardingId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getOnboardingSequenceResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getOnboardingSequenceCombinedResults = qraft.v3Service.getOnboardingSequence.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 onboarding_id: onboardingId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 onboarding_id: onboardingId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getOnboardingSequenceCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters, GetOnboardingSequenceData, GetOnboardingSequenceError>>, TCombinedResult = Array<UseQueryResult<GetOnboardingSequenceData, GetOnboardingSequenceError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetOnboardingSequenceData, GetOnboardingSequenceError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getOnboardingSequence.useSuspenseQuery({
         *     path: {
         *         onboarding_id: onboardingId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetOnboardingSequenceData>(parameters: ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>), options?: Omit<UseSuspenseQueryOptions<GetOnboardingSequenceData, GetOnboardingSequenceError, TData, ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetOnboardingSequenceError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getOnboardingSequence.useSuspenseInfiniteQuery({
         *     path: {
         *         onboarding_id: onboardingId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetOnboardingSequenceParameters, TData = GetOnboardingSequenceData>(parameters: ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetOnboardingSequenceData, GetOnboardingSequenceError, OperationInfiniteData<TData, GetOnboardingSequenceParameters>, ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetOnboardingSequenceData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetOnboardingSequenceParameters>, OperationError<GetOnboardingSequenceError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Onboarding Sequence
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getOnboardingSequenceData = qraft.v3Service.getOnboardingSequence.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 onboarding_id: onboardingId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 onboarding_id: onboardingId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getOnboardingSequenceResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getOnboardingSequenceCombinedData = qraft.v3Service.getOnboardingSequence.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 onboarding_id: onboardingId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 onboarding_id: onboardingId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getOnboardingSequenceCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters, GetOnboardingSequenceData, GetOnboardingSequenceError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetOnboardingSequenceData, GetOnboardingSequenceError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetOnboardingSequenceData, GetOnboardingSequenceError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Onboarding Sequence */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetOnboardingSequenceSchema, GetOnboardingSequenceData, GetOnboardingSequenceParameters, GetOnboardingSequenceError>): Promise<GetOnboardingSequenceData>;
        /** @summary Get Onboarding Sequence */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetOnboardingSequenceSchema, GetOnboardingSequenceData, GetOnboardingSequenceParameters, GetOnboardingSequenceError>): Promise<void>;
        /** @summary Get Onboarding Sequence */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetOnboardingSequenceSchema, GetOnboardingSequenceData, GetOnboardingSequenceParameters, GetOnboardingSequenceError>): Promise<GetOnboardingSequenceData>;
        /** @summary Get Onboarding Sequence */
        fetchInfiniteQuery<TPageParam extends GetOnboardingSequenceParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetOnboardingSequenceSchema, GetOnboardingSequenceData, GetOnboardingSequenceParameters, DeepReadonly<TPageParam>, GetOnboardingSequenceError>): Promise<OperationInfiniteData<GetOnboardingSequenceData, GetOnboardingSequenceParameters>>;
        /** @summary Get Onboarding Sequence */
        prefetchInfiniteQuery<TPageParam extends GetOnboardingSequenceParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetOnboardingSequenceSchema, GetOnboardingSequenceData, GetOnboardingSequenceParameters, DeepReadonly<TPageParam>, GetOnboardingSequenceError>): Promise<void>;
        /** @summary Get Onboarding Sequence */
        ensureInfiniteQueryData<TPageParam extends GetOnboardingSequenceParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetOnboardingSequenceSchema, GetOnboardingSequenceData, GetOnboardingSequenceParameters, DeepReadonly<TPageParam>, GetOnboardingSequenceError>): Promise<OperationInfiniteData<GetOnboardingSequenceData, GetOnboardingSequenceParameters>>;
        /** @summary Get Onboarding Sequence */
        getQueryData(parameters: ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>)): GetOnboardingSequenceData | undefined;
        /** @summary Get Onboarding Sequence */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>)): OperationInfiniteData<GetOnboardingSequenceData, GetOnboardingSequenceParameters> | undefined;
        /** @summary Get Onboarding Sequence */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError> | QueryFiltersByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>,
            data: NoInfer<OperationInfiniteData<GetOnboardingSequenceData, GetOnboardingSequenceParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>,
            data: GetOnboardingSequenceData | undefined
        ]>;
        /** @summary Get Onboarding Sequence */
        getQueryState(parameters: ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters> | (DeepReadonly<GetOnboardingSequenceParameters>)): QueryState<GetOnboardingSequenceData, GetOnboardingSequenceError> | undefined;
        /** @summary Get Onboarding Sequence */
        getInfiniteQueryState(parameters: DeepReadonly<GetOnboardingSequenceParameters> | ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>): QueryState<OperationInfiniteData<GetOnboardingSequenceData, GetOnboardingSequenceParameters>, GetOnboardingSequenceError> | undefined;
        /** @summary Get Onboarding Sequence */
        setQueryData(parameters: (DeepReadonly<GetOnboardingSequenceParameters>) | ServiceOperationQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>, updater: Updater<NoInfer<GetOnboardingSequenceData> | undefined, NoInfer<DeepReadonly<GetOnboardingSequenceData>> | undefined>, options?: SetDataOptions): GetOnboardingSequenceData | undefined;
        /** @summary Get Onboarding Sequence */
        setInfiniteQueryData(parameters: (DeepReadonly<GetOnboardingSequenceParameters>) | ServiceOperationInfiniteQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetOnboardingSequenceData, GetOnboardingSequenceParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetOnboardingSequenceData, GetOnboardingSequenceParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetOnboardingSequenceData, GetOnboardingSequenceParameters> | undefined;
        /** @summary Get Onboarding Sequence */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError> | QueryFiltersByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>, updater: Updater<NoInfer<GetOnboardingSequenceData> | undefined, NoInfer<GetOnboardingSequenceData> | undefined>, options?: SetDataOptions): Array<GetOnboardingSequenceData | undefined>;
        /** @summary Get Onboarding Sequence */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Onboarding Sequence */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError> | QueryFiltersByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Onboarding Sequence */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError> | QueryFiltersByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Onboarding Sequence */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError> | QueryFiltersByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>): void;
        /** @summary Get Onboarding Sequence */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError> | QueryFiltersByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Onboarding Sequence */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError> | QueryFiltersByQueryKey<GetOnboardingSequenceSchema, GetOnboardingSequenceData, TInfinite, GetOnboardingSequenceParameters, GetOnboardingSequenceError>): number;
        schema: GetOnboardingSequenceSchema;
        types: {
            parameters: GetOnboardingSequenceParameters;
            data: GetOnboardingSequenceData;
            error: GetOnboardingSequenceError;
        };
    };
    /** @summary Get Onboarding Slide */
    getOnboardingSlide: {
        /** @summary Get Onboarding Slide */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetOnboardingSlideParameters, TMeta, TSignal>), client?: (schema: GetOnboardingSlideSchema, options: {
            parameters: GetOnboardingSlideParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetOnboardingSlideData, GetOnboardingSlideError>>): Promise<RequestFnResponse<GetOnboardingSlideData, GetOnboardingSlideError>>;
        /** @summary Get Onboarding Slide */
        getQueryKey(parameters: DeepReadonly<GetOnboardingSlideParameters>): ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getOnboardingSlide.useQuery({
         *     path: {
         *         onboarding_id: onboardingId,
         *         slide_index: slideIndex
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetOnboardingSlideData>(parameters: ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>), options?: Omit<UndefinedInitialDataOptions<GetOnboardingSlideData, GetOnboardingSlideError, TData, ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetOnboardingSlideError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getOnboardingSlide.useQuery({
         *     path: {
         *         onboarding_id: onboardingId,
         *         slide_index: slideIndex
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetOnboardingSlideData>(parameters: ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>), options: Omit<DefinedInitialDataOptions<GetOnboardingSlideData, GetOnboardingSlideError, TData, ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetOnboardingSlideError>>;
        /** @summary Get Onboarding Slide */
        getInfiniteQueryKey(parameters: DeepReadonly<GetOnboardingSlideParameters>): ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getOnboardingSlide.useInfiniteQuery({
         *     path: {
         *         onboarding_id: onboardingId,
         *         slide_index: slideIndex
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetOnboardingSlideParameters, TQueryFnData = GetOnboardingSlideData, TData = OperationInfiniteData<TQueryFnData, GetOnboardingSlideParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetOnboardingSlideError, TData, ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetOnboardingSlideError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getOnboardingSlide.useInfiniteQuery({
         *     path: {
         *         onboarding_id: onboardingId,
         *         slide_index: slideIndex
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetOnboardingSlideParameters, TQueryFnData = GetOnboardingSlideData, TData = OperationInfiniteData<TQueryFnData, GetOnboardingSlideParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetOnboardingSlideError, TData, ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetOnboardingSlideData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetOnboardingSlideError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getOnboardingSlideTotal = qraft.v3Service.getOnboardingSlide.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getOnboardingSlideByParametersTotal = qraft.v3Service.getOnboardingSlide.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             onboarding_id: onboardingId,
         *             slide_index: slideIndex
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError> | QueryFiltersByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getOnboardingSlideResults = qraft.v3Service.getOnboardingSlide.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 onboarding_id: onboardingId1,
         *                 slide_index: slideIndex1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 onboarding_id: onboardingId2,
         *                 slide_index: slideIndex2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getOnboardingSlideResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getOnboardingSlideCombinedResults = qraft.v3Service.getOnboardingSlide.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 onboarding_id: onboardingId1,
         *                 slide_index: slideIndex1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 onboarding_id: onboardingId2,
         *                 slide_index: slideIndex2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getOnboardingSlideCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetOnboardingSlideSchema, GetOnboardingSlideParameters, GetOnboardingSlideData, GetOnboardingSlideError>>, TCombinedResult = Array<UseQueryResult<GetOnboardingSlideData, GetOnboardingSlideError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetOnboardingSlideData, GetOnboardingSlideError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getOnboardingSlide.useSuspenseQuery({
         *     path: {
         *         onboarding_id: onboardingId,
         *         slide_index: slideIndex
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetOnboardingSlideData>(parameters: ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>), options?: Omit<UseSuspenseQueryOptions<GetOnboardingSlideData, GetOnboardingSlideError, TData, ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetOnboardingSlideError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getOnboardingSlide.useSuspenseInfiniteQuery({
         *     path: {
         *         onboarding_id: onboardingId,
         *         slide_index: slideIndex
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetOnboardingSlideParameters, TData = GetOnboardingSlideData>(parameters: ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetOnboardingSlideData, GetOnboardingSlideError, OperationInfiniteData<TData, GetOnboardingSlideParameters>, ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetOnboardingSlideData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetOnboardingSlideParameters>, OperationError<GetOnboardingSlideError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Onboarding Slide
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getOnboardingSlideData = qraft.v3Service.getOnboardingSlide.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 onboarding_id: onboardingId1,
         *                 slide_index: slideIndex1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 onboarding_id: onboardingId2,
         *                 slide_index: slideIndex2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getOnboardingSlideResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getOnboardingSlideCombinedData = qraft.v3Service.getOnboardingSlide.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 onboarding_id: onboardingId1,
         *                 slide_index: slideIndex1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 onboarding_id: onboardingId2,
         *                 slide_index: slideIndex2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getOnboardingSlideCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetOnboardingSlideSchema, GetOnboardingSlideParameters, GetOnboardingSlideData, GetOnboardingSlideError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetOnboardingSlideData, GetOnboardingSlideError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetOnboardingSlideData, GetOnboardingSlideError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Onboarding Slide */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetOnboardingSlideSchema, GetOnboardingSlideData, GetOnboardingSlideParameters, GetOnboardingSlideError>): Promise<GetOnboardingSlideData>;
        /** @summary Get Onboarding Slide */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetOnboardingSlideSchema, GetOnboardingSlideData, GetOnboardingSlideParameters, GetOnboardingSlideError>): Promise<void>;
        /** @summary Get Onboarding Slide */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetOnboardingSlideSchema, GetOnboardingSlideData, GetOnboardingSlideParameters, GetOnboardingSlideError>): Promise<GetOnboardingSlideData>;
        /** @summary Get Onboarding Slide */
        fetchInfiniteQuery<TPageParam extends GetOnboardingSlideParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetOnboardingSlideSchema, GetOnboardingSlideData, GetOnboardingSlideParameters, DeepReadonly<TPageParam>, GetOnboardingSlideError>): Promise<OperationInfiniteData<GetOnboardingSlideData, GetOnboardingSlideParameters>>;
        /** @summary Get Onboarding Slide */
        prefetchInfiniteQuery<TPageParam extends GetOnboardingSlideParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetOnboardingSlideSchema, GetOnboardingSlideData, GetOnboardingSlideParameters, DeepReadonly<TPageParam>, GetOnboardingSlideError>): Promise<void>;
        /** @summary Get Onboarding Slide */
        ensureInfiniteQueryData<TPageParam extends GetOnboardingSlideParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetOnboardingSlideSchema, GetOnboardingSlideData, GetOnboardingSlideParameters, DeepReadonly<TPageParam>, GetOnboardingSlideError>): Promise<OperationInfiniteData<GetOnboardingSlideData, GetOnboardingSlideParameters>>;
        /** @summary Get Onboarding Slide */
        getQueryData(parameters: ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>)): GetOnboardingSlideData | undefined;
        /** @summary Get Onboarding Slide */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>)): OperationInfiniteData<GetOnboardingSlideData, GetOnboardingSlideParameters> | undefined;
        /** @summary Get Onboarding Slide */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError> | QueryFiltersByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>,
            data: NoInfer<OperationInfiniteData<GetOnboardingSlideData, GetOnboardingSlideParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>,
            data: GetOnboardingSlideData | undefined
        ]>;
        /** @summary Get Onboarding Slide */
        getQueryState(parameters: ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters> | (DeepReadonly<GetOnboardingSlideParameters>)): QueryState<GetOnboardingSlideData, GetOnboardingSlideError> | undefined;
        /** @summary Get Onboarding Slide */
        getInfiniteQueryState(parameters: DeepReadonly<GetOnboardingSlideParameters> | ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>): QueryState<OperationInfiniteData<GetOnboardingSlideData, GetOnboardingSlideParameters>, GetOnboardingSlideError> | undefined;
        /** @summary Get Onboarding Slide */
        setQueryData(parameters: (DeepReadonly<GetOnboardingSlideParameters>) | ServiceOperationQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>, updater: Updater<NoInfer<GetOnboardingSlideData> | undefined, NoInfer<DeepReadonly<GetOnboardingSlideData>> | undefined>, options?: SetDataOptions): GetOnboardingSlideData | undefined;
        /** @summary Get Onboarding Slide */
        setInfiniteQueryData(parameters: (DeepReadonly<GetOnboardingSlideParameters>) | ServiceOperationInfiniteQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetOnboardingSlideData, GetOnboardingSlideParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetOnboardingSlideData, GetOnboardingSlideParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetOnboardingSlideData, GetOnboardingSlideParameters> | undefined;
        /** @summary Get Onboarding Slide */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError> | QueryFiltersByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>, updater: Updater<NoInfer<GetOnboardingSlideData> | undefined, NoInfer<GetOnboardingSlideData> | undefined>, options?: SetDataOptions): Array<GetOnboardingSlideData | undefined>;
        /** @summary Get Onboarding Slide */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Onboarding Slide */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError> | QueryFiltersByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Onboarding Slide */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError> | QueryFiltersByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Onboarding Slide */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError> | QueryFiltersByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>): void;
        /** @summary Get Onboarding Slide */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError> | QueryFiltersByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Onboarding Slide */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError> | QueryFiltersByQueryKey<GetOnboardingSlideSchema, GetOnboardingSlideData, TInfinite, GetOnboardingSlideParameters, GetOnboardingSlideError>): number;
        schema: GetOnboardingSlideSchema;
        types: {
            parameters: GetOnboardingSlideParameters;
            data: GetOnboardingSlideData;
            error: GetOnboardingSlideError;
        };
    };
    /** @summary Onboarding Status */
    onboardingStatus: {
        /** @summary Onboarding Status */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<OnboardingStatusSchema, OnboardingStatusParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<OnboardingStatusParameters, TMeta, TSignal> | void), client?: (schema: OnboardingStatusSchema, options: {
            parameters: OnboardingStatusParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<OnboardingStatusData, OnboardingStatusError>>): Promise<RequestFnResponse<OnboardingStatusData, OnboardingStatusError>>;
        /** @summary Onboarding Status */
        getQueryKey(parameters: DeepReadonly<OnboardingStatusParameters> | void): ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.onboardingStatus.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.onboardingStatus.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = OnboardingStatusData>(parameters: ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void), options?: Omit<UndefinedInitialDataOptions<OnboardingStatusData, OnboardingStatusError, TData, ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>>, "queryKey">): UseQueryResult<TData, OperationError<OnboardingStatusError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.onboardingStatus.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.onboardingStatus.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = OnboardingStatusData>(parameters: ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void), options: Omit<DefinedInitialDataOptions<OnboardingStatusData, OnboardingStatusError, TData, ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<OnboardingStatusError>>;
        /** @summary Onboarding Status */
        getInfiniteQueryKey(parameters: DeepReadonly<OnboardingStatusParameters> | void): ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.onboardingStatus.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends OnboardingStatusParameters, TQueryFnData = OnboardingStatusData, TData = OperationInfiniteData<TQueryFnData, OnboardingStatusParameters>>(parameters: ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, OnboardingStatusError, TData, ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<OnboardingStatusError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.onboardingStatus.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends OnboardingStatusParameters, TQueryFnData = OnboardingStatusData, TData = OperationInfiniteData<TQueryFnData, OnboardingStatusParameters>>(parameters: ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, OnboardingStatusError, TData, ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<OnboardingStatusData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<OnboardingStatusError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const onboardingStatusTotal = qraft.v3Service.onboardingStatus.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const onboardingStatusByParametersTotal = qraft.v3Service.onboardingStatus.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError> | QueryFiltersByQueryKey<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const onboardingStatusResults = qraft.v3Service.onboardingStatus.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * onboardingStatusResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const onboardingStatusCombinedResults = qraft.v3Service.onboardingStatus.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * onboardingStatusCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<OnboardingStatusSchema, OnboardingStatusParameters, OnboardingStatusData, OnboardingStatusError>>, TCombinedResult = Array<UseQueryResult<OnboardingStatusData, OnboardingStatusError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<OnboardingStatusData, OnboardingStatusError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.onboardingStatus.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.onboardingStatus.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = OnboardingStatusData>(parameters: ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void), options?: Omit<UseSuspenseQueryOptions<OnboardingStatusData, OnboardingStatusError, TData, ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<OnboardingStatusError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.onboardingStatus.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends OnboardingStatusParameters, TData = OnboardingStatusData>(parameters: ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<OnboardingStatusData, OnboardingStatusError, OperationInfiniteData<TData, OnboardingStatusParameters>, ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<OnboardingStatusData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, OnboardingStatusParameters>, OperationError<OnboardingStatusError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Onboarding Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const onboardingStatusData = qraft.v3Service.onboardingStatus.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * onboardingStatusResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const onboardingStatusCombinedData = qraft.v3Service.onboardingStatus.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * onboardingStatusCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<OnboardingStatusSchema, OnboardingStatusParameters, OnboardingStatusData, OnboardingStatusError>>, TCombinedResult = Array<UseSuspenseQueryResult<OnboardingStatusData, OnboardingStatusError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<OnboardingStatusData, OnboardingStatusError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Onboarding Status */
        fetchQuery(options: ServiceOperationFetchQueryOptions<OnboardingStatusSchema, OnboardingStatusData, OnboardingStatusParameters, OnboardingStatusError> | void): Promise<OnboardingStatusData>;
        /** @summary Onboarding Status */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<OnboardingStatusSchema, OnboardingStatusData, OnboardingStatusParameters, OnboardingStatusError> | void): Promise<void>;
        /** @summary Onboarding Status */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<OnboardingStatusSchema, OnboardingStatusData, OnboardingStatusParameters, OnboardingStatusError> | void): Promise<OnboardingStatusData>;
        /** @summary Onboarding Status */
        fetchInfiniteQuery<TPageParam extends OnboardingStatusParameters>(options: ServiceOperationFetchInfiniteQueryOptions<OnboardingStatusSchema, OnboardingStatusData, OnboardingStatusParameters, DeepReadonly<TPageParam>, OnboardingStatusError> | void): Promise<OperationInfiniteData<OnboardingStatusData, OnboardingStatusParameters>>;
        /** @summary Onboarding Status */
        prefetchInfiniteQuery<TPageParam extends OnboardingStatusParameters>(options: ServiceOperationFetchInfiniteQueryOptions<OnboardingStatusSchema, OnboardingStatusData, OnboardingStatusParameters, DeepReadonly<TPageParam>, OnboardingStatusError> | void): Promise<void>;
        /** @summary Onboarding Status */
        ensureInfiniteQueryData<TPageParam extends OnboardingStatusParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<OnboardingStatusSchema, OnboardingStatusData, OnboardingStatusParameters, DeepReadonly<TPageParam>, OnboardingStatusError> | void): Promise<OperationInfiniteData<OnboardingStatusData, OnboardingStatusParameters>>;
        /** @summary Onboarding Status */
        getQueryData(parameters: ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void)): OnboardingStatusData | undefined;
        /** @summary Onboarding Status */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void)): OperationInfiniteData<OnboardingStatusData, OnboardingStatusParameters> | undefined;
        /** @summary Onboarding Status */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError> | QueryFiltersByQueryKey<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>,
            data: NoInfer<OperationInfiniteData<OnboardingStatusData, OnboardingStatusParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>,
            data: OnboardingStatusData | undefined
        ]>;
        /** @summary Onboarding Status */
        getQueryState(parameters: ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | (DeepReadonly<OnboardingStatusParameters> | void)): QueryState<OnboardingStatusData, OnboardingStatusError> | undefined;
        /** @summary Onboarding Status */
        getInfiniteQueryState(parameters: DeepReadonly<OnboardingStatusParameters> | ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters> | void): QueryState<OperationInfiniteData<OnboardingStatusData, OnboardingStatusParameters>, OnboardingStatusError> | undefined;
        /** @summary Onboarding Status */
        setQueryData(parameters: (DeepReadonly<OnboardingStatusParameters> | undefined) | ServiceOperationQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>, updater: Updater<NoInfer<OnboardingStatusData> | undefined, NoInfer<DeepReadonly<OnboardingStatusData>> | undefined>, options?: SetDataOptions): OnboardingStatusData | undefined;
        /** @summary Onboarding Status */
        setInfiniteQueryData(parameters: (DeepReadonly<OnboardingStatusParameters> | undefined) | ServiceOperationInfiniteQueryKey<OnboardingStatusSchema, OnboardingStatusParameters>, updater: Updater<NoInfer<OperationInfiniteData<OnboardingStatusData, OnboardingStatusParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<OnboardingStatusData, OnboardingStatusParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<OnboardingStatusData, OnboardingStatusParameters> | undefined;
        /** @summary Onboarding Status */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError> | QueryFiltersByQueryKey<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>, updater: Updater<NoInfer<OnboardingStatusData> | undefined, NoInfer<OnboardingStatusData> | undefined>, options?: SetDataOptions): Array<OnboardingStatusData | undefined>;
        /** @summary Onboarding Status */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Onboarding Status */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError> | QueryFiltersByQueryKey<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>, options?: RefetchOptions): Promise<void>;
        /** @summary Onboarding Status */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError> | QueryFiltersByQueryKey<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>, options?: CancelOptions): Promise<void>;
        /** @summary Onboarding Status */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError> | QueryFiltersByQueryKey<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>): void;
        /** @summary Onboarding Status */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError> | QueryFiltersByQueryKey<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>, options?: ResetOptions): Promise<void>;
        /** @summary Onboarding Status */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError> | QueryFiltersByQueryKey<OnboardingStatusSchema, OnboardingStatusData, TInfinite, OnboardingStatusParameters, OnboardingStatusError>): number;
        schema: OnboardingStatusSchema;
        types: {
            parameters: OnboardingStatusParameters;
            data: OnboardingStatusData;
            error: OnboardingStatusError;
        };
    };
    /**
     * @summary Onboarding Detail
     * @description A sequence's slides, rendered for the caller.
     *
     * Requires a logged-in user of any profile type. Each slide carries its
     * merge-tagged title and content, and a `ProfileFields` slide carries the
     * fields the caller's own member type may answer, each with the value already
     * stored for them -- so the client renders a pre-filled form. An id with no
     * slides is a 404.
     */
    onboardingDetail: {
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<OnboardingDetailSchema, OnboardingDetailParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<OnboardingDetailParameters, TMeta, TSignal>), client?: (schema: OnboardingDetailSchema, options: {
            parameters: OnboardingDetailParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<OnboardingDetailData, OnboardingDetailError>>): Promise<RequestFnResponse<OnboardingDetailData, OnboardingDetailError>>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        getQueryKey(parameters: DeepReadonly<OnboardingDetailParameters>): ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.onboardingDetail.useQuery({
         *     path: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = OnboardingDetailData>(parameters: ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>), options?: Omit<UndefinedInitialDataOptions<OnboardingDetailData, OnboardingDetailError, TData, ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>>, "queryKey">): UseQueryResult<TData, OperationError<OnboardingDetailError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.onboardingDetail.useQuery({
         *     path: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = OnboardingDetailData>(parameters: ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>), options: Omit<DefinedInitialDataOptions<OnboardingDetailData, OnboardingDetailError, TData, ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<OnboardingDetailError>>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<OnboardingDetailParameters>): ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.onboardingDetail.useInfiniteQuery({
         *     path: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends OnboardingDetailParameters, TQueryFnData = OnboardingDetailData, TData = OperationInfiniteData<TQueryFnData, OnboardingDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, OnboardingDetailError, TData, ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<OnboardingDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.onboardingDetail.useInfiniteQuery({
         *     path: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends OnboardingDetailParameters, TQueryFnData = OnboardingDetailData, TData = OperationInfiniteData<TQueryFnData, OnboardingDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, OnboardingDetailError, TData, ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<OnboardingDetailData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<OnboardingDetailError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const onboardingDetailTotal = qraft.v3Service.onboardingDetail.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const onboardingDetailByParametersTotal = qraft.v3Service.onboardingDetail.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             id: id
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError> | QueryFiltersByQueryKey<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const onboardingDetailResults = qraft.v3Service.onboardingDetail.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * onboardingDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const onboardingDetailCombinedResults = qraft.v3Service.onboardingDetail.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * onboardingDetailCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<OnboardingDetailSchema, OnboardingDetailParameters, OnboardingDetailData, OnboardingDetailError>>, TCombinedResult = Array<UseQueryResult<OnboardingDetailData, OnboardingDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<OnboardingDetailData, OnboardingDetailError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.onboardingDetail.useSuspenseQuery({
         *     path: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = OnboardingDetailData>(parameters: ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>), options?: Omit<UseSuspenseQueryOptions<OnboardingDetailData, OnboardingDetailError, TData, ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<OnboardingDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.onboardingDetail.useSuspenseInfiniteQuery({
         *     path: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends OnboardingDetailParameters, TData = OnboardingDetailData>(parameters: ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<OnboardingDetailData, OnboardingDetailError, OperationInfiniteData<TData, OnboardingDetailParameters>, ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<OnboardingDetailData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, OnboardingDetailParameters>, OperationError<OnboardingDetailError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const onboardingDetailData = qraft.v3Service.onboardingDetail.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * onboardingDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const onboardingDetailCombinedData = qraft.v3Service.onboardingDetail.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * onboardingDetailCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<OnboardingDetailSchema, OnboardingDetailParameters, OnboardingDetailData, OnboardingDetailError>>, TCombinedResult = Array<UseSuspenseQueryResult<OnboardingDetailData, OnboardingDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<OnboardingDetailData, OnboardingDetailError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<OnboardingDetailSchema, OnboardingDetailData, OnboardingDetailParameters, OnboardingDetailError>): Promise<OnboardingDetailData>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<OnboardingDetailSchema, OnboardingDetailData, OnboardingDetailParameters, OnboardingDetailError>): Promise<void>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<OnboardingDetailSchema, OnboardingDetailData, OnboardingDetailParameters, OnboardingDetailError>): Promise<OnboardingDetailData>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        fetchInfiniteQuery<TPageParam extends OnboardingDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<OnboardingDetailSchema, OnboardingDetailData, OnboardingDetailParameters, DeepReadonly<TPageParam>, OnboardingDetailError>): Promise<OperationInfiniteData<OnboardingDetailData, OnboardingDetailParameters>>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        prefetchInfiniteQuery<TPageParam extends OnboardingDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<OnboardingDetailSchema, OnboardingDetailData, OnboardingDetailParameters, DeepReadonly<TPageParam>, OnboardingDetailError>): Promise<void>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        ensureInfiniteQueryData<TPageParam extends OnboardingDetailParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<OnboardingDetailSchema, OnboardingDetailData, OnboardingDetailParameters, DeepReadonly<TPageParam>, OnboardingDetailError>): Promise<OperationInfiniteData<OnboardingDetailData, OnboardingDetailParameters>>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        getQueryData(parameters: ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>)): OnboardingDetailData | undefined;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>)): OperationInfiniteData<OnboardingDetailData, OnboardingDetailParameters> | undefined;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError> | QueryFiltersByQueryKey<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>,
            data: NoInfer<OperationInfiniteData<OnboardingDetailData, OnboardingDetailParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>,
            data: OnboardingDetailData | undefined
        ]>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        getQueryState(parameters: ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters> | (DeepReadonly<OnboardingDetailParameters>)): QueryState<OnboardingDetailData, OnboardingDetailError> | undefined;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        getInfiniteQueryState(parameters: DeepReadonly<OnboardingDetailParameters> | ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>): QueryState<OperationInfiniteData<OnboardingDetailData, OnboardingDetailParameters>, OnboardingDetailError> | undefined;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        setQueryData(parameters: (DeepReadonly<OnboardingDetailParameters>) | ServiceOperationQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>, updater: Updater<NoInfer<OnboardingDetailData> | undefined, NoInfer<DeepReadonly<OnboardingDetailData>> | undefined>, options?: SetDataOptions): OnboardingDetailData | undefined;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<OnboardingDetailParameters>) | ServiceOperationInfiniteQueryKey<OnboardingDetailSchema, OnboardingDetailParameters>, updater: Updater<NoInfer<OperationInfiniteData<OnboardingDetailData, OnboardingDetailParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<OnboardingDetailData, OnboardingDetailParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<OnboardingDetailData, OnboardingDetailParameters> | undefined;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError> | QueryFiltersByQueryKey<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>, updater: Updater<NoInfer<OnboardingDetailData> | undefined, NoInfer<OnboardingDetailData> | undefined>, options?: SetDataOptions): Array<OnboardingDetailData | undefined>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError> | QueryFiltersByQueryKey<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError> | QueryFiltersByQueryKey<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError> | QueryFiltersByQueryKey<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>): void;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError> | QueryFiltersByQueryKey<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Onboarding Detail
         * @description A sequence's slides, rendered for the caller.
         *
         * Requires a logged-in user of any profile type. Each slide carries its
         * merge-tagged title and content, and a `ProfileFields` slide carries the
         * fields the caller's own member type may answer, each with the value already
         * stored for them -- so the client renders a pre-filled form. An id with no
         * slides is a 404.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError> | QueryFiltersByQueryKey<OnboardingDetailSchema, OnboardingDetailData, TInfinite, OnboardingDetailParameters, OnboardingDetailError>): number;
        schema: OnboardingDetailSchema;
        types: {
            parameters: OnboardingDetailParameters;
            data: OnboardingDetailData;
            error: OnboardingDetailError;
        };
    };
    /**
     * @summary Onboarding Submit
     * @description Submit an onboarding slide.
     *
     * Requires a logged-in user of any profile type, who must hold the onboarding
     * being submitted. Only the fields the slide declares and the caller's member
     * type carries are written; anything else in `data` is ignored. Answers are
     * validated server-side, and submitting the final slide runs the sequence's
     * completion chain exactly once.
     */
    submitOnboarding: {
        /**
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Requires a logged-in user of any profile type, who must hold the onboarding
         * being submitted. Only the fields the slide declares and the caller's member
         * type carries are written; anything else in `data` is ignored. Answers are
         * validated server-side, and submitting the final slide runs the sequence's
         * completion chain exactly once.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SubmitOnboardingBody, SubmitOnboardingParameters, TMeta, TSignal>, client?: (schema: SubmitOnboardingSchema, options: ServiceOperationMutationFnOptions<SubmitOnboardingBody, SubmitOnboardingParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SubmitOnboardingData, SubmitOnboardingError>>): Promise<RequestFnResponse<SubmitOnboardingData, SubmitOnboardingError>>;
        /**
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Requires a logged-in user of any profile type, who must hold the onboarding
         * being submitted. Only the fields the slide declares and the caller's member
         * type carries are written; anything else in `data` is ignored. Answers are
         * validated server-side, and submitting the final slide runs the sequence's
         * completion chain exactly once.
         */
        getMutationKey(parameters: DeepReadonly<SubmitOnboardingParameters> | void): ServiceOperationMutationKey<SubmitOnboardingSchema, SubmitOnboardingParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Requires a logged-in user of any profile type, who must hold the onboarding
         * being submitted. Only the fields the slide declares and the caller's member
         * type carries are written; anything else in `data` is ignored. Answers are
         * validated server-side, and submitting the final slide runs the sequence's
         * completion chain exactly once.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitOnboarding.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitOnboarding.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SubmitOnboardingBody, TContext = unknown>(parameters: DeepReadonly<SubmitOnboardingParameters>, options?: ServiceOperationUseMutationOptions<SubmitOnboardingSchema, SubmitOnboardingData, SubmitOnboardingParameters, TVariables, OperationError<SubmitOnboardingError>, TContext>): UseMutationResult<SubmitOnboardingData, OperationError<SubmitOnboardingError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Requires a logged-in user of any profile type, who must hold the onboarding
         * being submitted. Only the fields the slide declares and the caller's member
         * type carries are written; anything else in `data` is ignored. Answers are
         * validated server-side, and submitting the final slide runs the sequence's
         * completion chain exactly once.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitOnboarding.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitOnboarding.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SubmitOnboardingBody, SubmitOnboardingParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SubmitOnboardingSchema, SubmitOnboardingData, SubmitOnboardingParameters, TVariables, OperationError<SubmitOnboardingError>, TContext>): UseMutationResult<SubmitOnboardingData, OperationError<SubmitOnboardingError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Requires a logged-in user of any profile type, who must hold the onboarding
         * being submitted. Only the fields the slide declares and the caller's member
         * type carries are written; anything else in `data` is ignored. Answers are
         * validated server-side, and submitting the final slide runs the sequence's
         * completion chain exactly once.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const submitOnboardingTotal = qraft.v3Service.submitOnboarding.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const submitOnboardingTotal = qraft.v3Service.submitOnboarding.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext> | MutationFiltersByMutationKey<SubmitOnboardingSchema, SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Requires a logged-in user of any profile type, who must hold the onboarding
         * being submitted. Only the fields the slide declares and the caller's member
         * type carries are written; anything else in `data` is ignored. Answers are
         * validated server-side, and submitting the final slide runs the sequence's
         * completion chain exactly once.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const submitOnboardingPendingMutationVariables = qraft.v3Service.submitOnboarding.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const submitOnboardingMutationData = qraft.v3Service.submitOnboarding.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SubmitOnboardingData, OperationError<SubmitOnboardingError>, MutationVariables<SubmitOnboardingBody, SubmitOnboardingParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext> | MutationFiltersByMutationKey<SubmitOnboardingSchema, SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext>;
            select?: (mutation: Mutation<SubmitOnboardingData, OperationError<SubmitOnboardingError>, MutationVariables<SubmitOnboardingBody, SubmitOnboardingParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Requires a logged-in user of any profile type, who must hold the onboarding
         * being submitted. Only the fields the slide declares and the caller's member
         * type carries are written; anything else in `data` is ignored. Answers are
         * validated server-side, and submitting the final slide runs the sequence's
         * completion chain exactly once.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext> | MutationFiltersByMutationKey<SubmitOnboardingSchema, SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Requires a logged-in user of any profile type, who must hold the onboarding
         * being submitted. Only the fields the slide declares and the caller's member
         * type carries are written; anything else in `data` is ignored. Answers are
         * validated server-side, and submitting the final slide runs the sequence's
         * completion chain exactly once.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.submitOnboarding.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.submitOnboarding.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext> | MutationFiltersByMutationKey<SubmitOnboardingSchema, SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext>): Mutation<SubmitOnboardingData, SubmitOnboardingError, MutationVariables<SubmitOnboardingBody, SubmitOnboardingParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext> | MutationFiltersByMutationKey<SubmitOnboardingSchema, SubmitOnboardingBody, SubmitOnboardingData, SubmitOnboardingParameters, OperationError<SubmitOnboardingError>, TContext>): Array<Mutation<SubmitOnboardingData, SubmitOnboardingError, MutationVariables<SubmitOnboardingBody, SubmitOnboardingParameters>, TContext>>;
        };
        schema: SubmitOnboardingSchema;
        types: {
            parameters: SubmitOnboardingParameters;
            data: SubmitOnboardingData;
            error: SubmitOnboardingError;
            body: SubmitOnboardingBody;
        };
    };
    /**
     * @summary List Helper Applications
     * @description List helper applications from all three intake forms; `role` tells them apart.
     */
    listHelperApplications: {
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListHelperApplicationsParameters, TMeta, TSignal> | void), client?: (schema: ListHelperApplicationsSchema, options: {
            parameters: ListHelperApplicationsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListHelperApplicationsData, ListHelperApplicationsError>>): Promise<RequestFnResponse<ListHelperApplicationsData, ListHelperApplicationsError>>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        getQueryKey(parameters: DeepReadonly<ListHelperApplicationsParameters> | void): ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listHelperApplications.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listHelperApplications.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListHelperApplicationsData>(parameters: ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListHelperApplicationsData, ListHelperApplicationsError, TData, ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListHelperApplicationsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listHelperApplications.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listHelperApplications.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListHelperApplicationsData>(parameters: ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void), options: Omit<DefinedInitialDataOptions<ListHelperApplicationsData, ListHelperApplicationsError, TData, ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListHelperApplicationsError>>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListHelperApplicationsParameters> | void): ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listHelperApplications.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListHelperApplicationsParameters, TQueryFnData = ListHelperApplicationsData, TData = OperationInfiniteData<TQueryFnData, ListHelperApplicationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListHelperApplicationsError, TData, ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListHelperApplicationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listHelperApplications.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListHelperApplicationsParameters, TQueryFnData = ListHelperApplicationsData, TData = OperationInfiniteData<TQueryFnData, ListHelperApplicationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListHelperApplicationsError, TData, ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListHelperApplicationsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListHelperApplicationsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listHelperApplicationsTotal = qraft.v3Service.listHelperApplications.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listHelperApplicationsByParametersTotal = qraft.v3Service.listHelperApplications.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError> | QueryFiltersByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listHelperApplicationsResults = qraft.v3Service.listHelperApplications.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listHelperApplicationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listHelperApplicationsCombinedResults = qraft.v3Service.listHelperApplications.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listHelperApplicationsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListHelperApplicationsSchema, ListHelperApplicationsParameters, ListHelperApplicationsData, ListHelperApplicationsError>>, TCombinedResult = Array<UseQueryResult<ListHelperApplicationsData, ListHelperApplicationsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListHelperApplicationsData, ListHelperApplicationsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listHelperApplications.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listHelperApplications.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListHelperApplicationsData>(parameters: ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListHelperApplicationsData, ListHelperApplicationsError, TData, ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListHelperApplicationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listHelperApplications.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListHelperApplicationsParameters, TData = ListHelperApplicationsData>(parameters: ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListHelperApplicationsData, ListHelperApplicationsError, OperationInfiniteData<TData, ListHelperApplicationsParameters>, ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListHelperApplicationsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListHelperApplicationsParameters>, OperationError<ListHelperApplicationsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listHelperApplicationsData = qraft.v3Service.listHelperApplications.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listHelperApplicationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listHelperApplicationsCombinedData = qraft.v3Service.listHelperApplications.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listHelperApplicationsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListHelperApplicationsSchema, ListHelperApplicationsParameters, ListHelperApplicationsData, ListHelperApplicationsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListHelperApplicationsData, ListHelperApplicationsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListHelperApplicationsData, ListHelperApplicationsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListHelperApplicationsSchema, ListHelperApplicationsData, ListHelperApplicationsParameters, ListHelperApplicationsError> | void): Promise<ListHelperApplicationsData>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListHelperApplicationsSchema, ListHelperApplicationsData, ListHelperApplicationsParameters, ListHelperApplicationsError> | void): Promise<void>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListHelperApplicationsSchema, ListHelperApplicationsData, ListHelperApplicationsParameters, ListHelperApplicationsError> | void): Promise<ListHelperApplicationsData>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        fetchInfiniteQuery<TPageParam extends ListHelperApplicationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListHelperApplicationsSchema, ListHelperApplicationsData, ListHelperApplicationsParameters, DeepReadonly<TPageParam>, ListHelperApplicationsError> | void): Promise<OperationInfiniteData<ListHelperApplicationsData, ListHelperApplicationsParameters>>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        prefetchInfiniteQuery<TPageParam extends ListHelperApplicationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListHelperApplicationsSchema, ListHelperApplicationsData, ListHelperApplicationsParameters, DeepReadonly<TPageParam>, ListHelperApplicationsError> | void): Promise<void>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        ensureInfiniteQueryData<TPageParam extends ListHelperApplicationsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListHelperApplicationsSchema, ListHelperApplicationsData, ListHelperApplicationsParameters, DeepReadonly<TPageParam>, ListHelperApplicationsError> | void): Promise<OperationInfiniteData<ListHelperApplicationsData, ListHelperApplicationsParameters>>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void)): ListHelperApplicationsData | undefined;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void)): OperationInfiniteData<ListHelperApplicationsData, ListHelperApplicationsParameters> | undefined;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError> | QueryFiltersByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>,
            data: NoInfer<OperationInfiniteData<ListHelperApplicationsData, ListHelperApplicationsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>,
            data: ListHelperApplicationsData | undefined
        ]>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | (DeepReadonly<ListHelperApplicationsParameters> | void)): QueryState<ListHelperApplicationsData, ListHelperApplicationsError> | undefined;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListHelperApplicationsParameters> | ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters> | void): QueryState<OperationInfiniteData<ListHelperApplicationsData, ListHelperApplicationsParameters>, ListHelperApplicationsError> | undefined;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        setQueryData(parameters: (DeepReadonly<ListHelperApplicationsParameters> | undefined) | ServiceOperationQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>, updater: Updater<NoInfer<ListHelperApplicationsData> | undefined, NoInfer<DeepReadonly<ListHelperApplicationsData>> | undefined>, options?: SetDataOptions): ListHelperApplicationsData | undefined;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListHelperApplicationsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListHelperApplicationsData, ListHelperApplicationsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListHelperApplicationsData, ListHelperApplicationsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListHelperApplicationsData, ListHelperApplicationsParameters> | undefined;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError> | QueryFiltersByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>, updater: Updater<NoInfer<ListHelperApplicationsData> | undefined, NoInfer<ListHelperApplicationsData> | undefined>, options?: SetDataOptions): Array<ListHelperApplicationsData | undefined>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError> | QueryFiltersByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError> | QueryFiltersByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError> | QueryFiltersByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>): void;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError> | QueryFiltersByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Helper Applications
         * @description List helper applications from all three intake forms; `role` tells them apart.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError> | QueryFiltersByQueryKey<ListHelperApplicationsSchema, ListHelperApplicationsData, TInfinite, ListHelperApplicationsParameters, ListHelperApplicationsError>): number;
        schema: ListHelperApplicationsSchema;
        types: {
            parameters: ListHelperApplicationsParameters;
            data: ListHelperApplicationsData;
            error: ListHelperApplicationsError;
        };
    };
    /**
     * @summary Get Helper Application
     * @description Get a helper application by ID.
     */
    getHelperApplication: {
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetHelperApplicationParameters, TMeta, TSignal>), client?: (schema: GetHelperApplicationSchema, options: {
            parameters: GetHelperApplicationParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetHelperApplicationData, GetHelperApplicationError>>): Promise<RequestFnResponse<GetHelperApplicationData, GetHelperApplicationError>>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        getQueryKey(parameters: DeepReadonly<GetHelperApplicationParameters>): ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getHelperApplication.useQuery({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetHelperApplicationData>(parameters: ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>), options?: Omit<UndefinedInitialDataOptions<GetHelperApplicationData, GetHelperApplicationError, TData, ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetHelperApplicationError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getHelperApplication.useQuery({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetHelperApplicationData>(parameters: ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>), options: Omit<DefinedInitialDataOptions<GetHelperApplicationData, GetHelperApplicationError, TData, ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetHelperApplicationError>>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetHelperApplicationParameters>): ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getHelperApplication.useInfiniteQuery({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetHelperApplicationParameters, TQueryFnData = GetHelperApplicationData, TData = OperationInfiniteData<TQueryFnData, GetHelperApplicationParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetHelperApplicationError, TData, ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetHelperApplicationError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getHelperApplication.useInfiniteQuery({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetHelperApplicationParameters, TQueryFnData = GetHelperApplicationData, TData = OperationInfiniteData<TQueryFnData, GetHelperApplicationParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetHelperApplicationError, TData, ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetHelperApplicationData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetHelperApplicationError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getHelperApplicationTotal = qraft.v3Service.getHelperApplication.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getHelperApplicationByParametersTotal = qraft.v3Service.getHelperApplication.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             application_id: applicationId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError> | QueryFiltersByQueryKey<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getHelperApplicationResults = qraft.v3Service.getHelperApplication.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 application_id: applicationId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 application_id: applicationId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getHelperApplicationResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getHelperApplicationCombinedResults = qraft.v3Service.getHelperApplication.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 application_id: applicationId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 application_id: applicationId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getHelperApplicationCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetHelperApplicationSchema, GetHelperApplicationParameters, GetHelperApplicationData, GetHelperApplicationError>>, TCombinedResult = Array<UseQueryResult<GetHelperApplicationData, GetHelperApplicationError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetHelperApplicationData, GetHelperApplicationError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getHelperApplication.useSuspenseQuery({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetHelperApplicationData>(parameters: ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>), options?: Omit<UseSuspenseQueryOptions<GetHelperApplicationData, GetHelperApplicationError, TData, ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetHelperApplicationError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getHelperApplication.useSuspenseInfiniteQuery({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetHelperApplicationParameters, TData = GetHelperApplicationData>(parameters: ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetHelperApplicationData, GetHelperApplicationError, OperationInfiniteData<TData, GetHelperApplicationParameters>, ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetHelperApplicationData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetHelperApplicationParameters>, OperationError<GetHelperApplicationError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getHelperApplicationData = qraft.v3Service.getHelperApplication.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 application_id: applicationId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 application_id: applicationId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getHelperApplicationResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getHelperApplicationCombinedData = qraft.v3Service.getHelperApplication.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 application_id: applicationId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 application_id: applicationId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getHelperApplicationCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetHelperApplicationSchema, GetHelperApplicationParameters, GetHelperApplicationData, GetHelperApplicationError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetHelperApplicationData, GetHelperApplicationError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetHelperApplicationData, GetHelperApplicationError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetHelperApplicationSchema, GetHelperApplicationData, GetHelperApplicationParameters, GetHelperApplicationError>): Promise<GetHelperApplicationData>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetHelperApplicationSchema, GetHelperApplicationData, GetHelperApplicationParameters, GetHelperApplicationError>): Promise<void>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetHelperApplicationSchema, GetHelperApplicationData, GetHelperApplicationParameters, GetHelperApplicationError>): Promise<GetHelperApplicationData>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        fetchInfiniteQuery<TPageParam extends GetHelperApplicationParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetHelperApplicationSchema, GetHelperApplicationData, GetHelperApplicationParameters, DeepReadonly<TPageParam>, GetHelperApplicationError>): Promise<OperationInfiniteData<GetHelperApplicationData, GetHelperApplicationParameters>>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        prefetchInfiniteQuery<TPageParam extends GetHelperApplicationParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetHelperApplicationSchema, GetHelperApplicationData, GetHelperApplicationParameters, DeepReadonly<TPageParam>, GetHelperApplicationError>): Promise<void>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        ensureInfiniteQueryData<TPageParam extends GetHelperApplicationParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetHelperApplicationSchema, GetHelperApplicationData, GetHelperApplicationParameters, DeepReadonly<TPageParam>, GetHelperApplicationError>): Promise<OperationInfiniteData<GetHelperApplicationData, GetHelperApplicationParameters>>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>)): GetHelperApplicationData | undefined;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>)): OperationInfiniteData<GetHelperApplicationData, GetHelperApplicationParameters> | undefined;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError> | QueryFiltersByQueryKey<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>,
            data: NoInfer<OperationInfiniteData<GetHelperApplicationData, GetHelperApplicationParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>,
            data: GetHelperApplicationData | undefined
        ]>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters> | (DeepReadonly<GetHelperApplicationParameters>)): QueryState<GetHelperApplicationData, GetHelperApplicationError> | undefined;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetHelperApplicationParameters> | ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>): QueryState<OperationInfiniteData<GetHelperApplicationData, GetHelperApplicationParameters>, GetHelperApplicationError> | undefined;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        setQueryData(parameters: (DeepReadonly<GetHelperApplicationParameters>) | ServiceOperationQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>, updater: Updater<NoInfer<GetHelperApplicationData> | undefined, NoInfer<DeepReadonly<GetHelperApplicationData>> | undefined>, options?: SetDataOptions): GetHelperApplicationData | undefined;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetHelperApplicationParameters>) | ServiceOperationInfiniteQueryKey<GetHelperApplicationSchema, GetHelperApplicationParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetHelperApplicationData, GetHelperApplicationParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetHelperApplicationData, GetHelperApplicationParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetHelperApplicationData, GetHelperApplicationParameters> | undefined;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError> | QueryFiltersByQueryKey<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>, updater: Updater<NoInfer<GetHelperApplicationData> | undefined, NoInfer<GetHelperApplicationData> | undefined>, options?: SetDataOptions): Array<GetHelperApplicationData | undefined>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError> | QueryFiltersByQueryKey<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError> | QueryFiltersByQueryKey<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError> | QueryFiltersByQueryKey<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>): void;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError> | QueryFiltersByQueryKey<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Helper Application
         * @description Get a helper application by ID.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError> | QueryFiltersByQueryKey<GetHelperApplicationSchema, GetHelperApplicationData, TInfinite, GetHelperApplicationParameters, GetHelperApplicationError>): number;
        schema: GetHelperApplicationSchema;
        types: {
            parameters: GetHelperApplicationParameters;
            data: GetHelperApplicationData;
            error: GetHelperApplicationError;
        };
    };
    /**
     * @summary Submit Helper Application
     * @description Submit a study helper application.
     *
     * Public; the application is stored as PENDING. Runs the same refusal ladder as
     * `_submit_follow_up_application`, all before the first write.
     */
    submitHelperApplication: {
        /**
         * @summary Submit Helper Application
         * @description Submit a study helper application.
         *
         * Public; the application is stored as PENDING. Runs the same refusal ladder as
         * `_submit_follow_up_application`, all before the first write.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SubmitHelperApplicationBody, SubmitHelperApplicationParameters, TMeta, TSignal>, client?: (schema: SubmitHelperApplicationSchema, options: ServiceOperationMutationFnOptions<SubmitHelperApplicationBody, SubmitHelperApplicationParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SubmitHelperApplicationData, SubmitHelperApplicationError>>): Promise<RequestFnResponse<SubmitHelperApplicationData, SubmitHelperApplicationError>>;
        /**
         * @summary Submit Helper Application
         * @description Submit a study helper application.
         *
         * Public; the application is stored as PENDING. Runs the same refusal ladder as
         * `_submit_follow_up_application`, all before the first write.
         */
        getMutationKey(parameters: DeepReadonly<SubmitHelperApplicationParameters> | void): ServiceOperationMutationKey<SubmitHelperApplicationSchema, SubmitHelperApplicationParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Helper Application
         * @description Submit a study helper application.
         *
         * Public; the application is stored as PENDING. Runs the same refusal ladder as
         * `_submit_follow_up_application`, all before the first write.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitHelperApplication.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitHelperApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SubmitHelperApplicationBody, TContext = unknown>(parameters: DeepReadonly<SubmitHelperApplicationParameters>, options?: ServiceOperationUseMutationOptions<SubmitHelperApplicationSchema, SubmitHelperApplicationData, SubmitHelperApplicationParameters, TVariables, OperationError<SubmitHelperApplicationError>, TContext>): UseMutationResult<SubmitHelperApplicationData, OperationError<SubmitHelperApplicationError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Helper Application
         * @description Submit a study helper application.
         *
         * Public; the application is stored as PENDING. Runs the same refusal ladder as
         * `_submit_follow_up_application`, all before the first write.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitHelperApplication.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitHelperApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SubmitHelperApplicationBody, SubmitHelperApplicationParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SubmitHelperApplicationSchema, SubmitHelperApplicationData, SubmitHelperApplicationParameters, TVariables, OperationError<SubmitHelperApplicationError>, TContext>): UseMutationResult<SubmitHelperApplicationData, OperationError<SubmitHelperApplicationError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Submit Helper Application
         * @description Submit a study helper application.
         *
         * Public; the application is stored as PENDING. Runs the same refusal ladder as
         * `_submit_follow_up_application`, all before the first write.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const submitHelperApplicationTotal = qraft.v3Service.submitHelperApplication.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const submitHelperApplicationTotal = qraft.v3Service.submitHelperApplication.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitHelperApplicationSchema, SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Submit Helper Application
         * @description Submit a study helper application.
         *
         * Public; the application is stored as PENDING. Runs the same refusal ladder as
         * `_submit_follow_up_application`, all before the first write.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const submitHelperApplicationPendingMutationVariables = qraft.v3Service.submitHelperApplication.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const submitHelperApplicationMutationData = qraft.v3Service.submitHelperApplication.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SubmitHelperApplicationData, OperationError<SubmitHelperApplicationError>, MutationVariables<SubmitHelperApplicationBody, SubmitHelperApplicationParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitHelperApplicationSchema, SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext>;
            select?: (mutation: Mutation<SubmitHelperApplicationData, OperationError<SubmitHelperApplicationError>, MutationVariables<SubmitHelperApplicationBody, SubmitHelperApplicationParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Submit Helper Application
         * @description Submit a study helper application.
         *
         * Public; the application is stored as PENDING. Runs the same refusal ladder as
         * `_submit_follow_up_application`, all before the first write.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitHelperApplicationSchema, SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Submit Helper Application
         * @description Submit a study helper application.
         *
         * Public; the application is stored as PENDING. Runs the same refusal ladder as
         * `_submit_follow_up_application`, all before the first write.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.submitHelperApplication.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.submitHelperApplication.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitHelperApplicationSchema, SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext>): Mutation<SubmitHelperApplicationData, SubmitHelperApplicationError, MutationVariables<SubmitHelperApplicationBody, SubmitHelperApplicationParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitHelperApplicationSchema, SubmitHelperApplicationBody, SubmitHelperApplicationData, SubmitHelperApplicationParameters, OperationError<SubmitHelperApplicationError>, TContext>): Array<Mutation<SubmitHelperApplicationData, SubmitHelperApplicationError, MutationVariables<SubmitHelperApplicationBody, SubmitHelperApplicationParameters>, TContext>>;
        };
        schema: SubmitHelperApplicationSchema;
        types: {
            parameters: SubmitHelperApplicationParameters;
            data: SubmitHelperApplicationData;
            error: SubmitHelperApplicationError;
            body: SubmitHelperApplicationBody;
        };
    };
    /**
     * @summary Submit Follow Up Coordinator Application
     * @description Submit a follow-up coordinator application.
     *
     * Public, as in legacy. Approving one is the only way a coordinator account is created
     * outside the migrator.
     */
    submitFollowUpCoordinatorApplication: {
        /**
         * @summary Submit Follow Up Coordinator Application
         * @description Submit a follow-up coordinator application.
         *
         * Public, as in legacy. Approving one is the only way a coordinator account is created
         * outside the migrator.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationParameters, TMeta, TSignal>, client?: (schema: SubmitFollowUpCoordinatorApplicationSchema, options: ServiceOperationMutationFnOptions<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationError>>): Promise<RequestFnResponse<SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationError>>;
        /**
         * @summary Submit Follow Up Coordinator Application
         * @description Submit a follow-up coordinator application.
         *
         * Public, as in legacy. Approving one is the only way a coordinator account is created
         * outside the migrator.
         */
        getMutationKey(parameters: DeepReadonly<SubmitFollowUpCoordinatorApplicationParameters> | void): ServiceOperationMutationKey<SubmitFollowUpCoordinatorApplicationSchema, SubmitFollowUpCoordinatorApplicationParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Follow Up Coordinator Application
         * @description Submit a follow-up coordinator application.
         *
         * Public, as in legacy. Approving one is the only way a coordinator account is created
         * outside the migrator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitFollowUpCoordinatorApplication.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitFollowUpCoordinatorApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SubmitFollowUpCoordinatorApplicationBody, TContext = unknown>(parameters: DeepReadonly<SubmitFollowUpCoordinatorApplicationParameters>, options?: ServiceOperationUseMutationOptions<SubmitFollowUpCoordinatorApplicationSchema, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, TVariables, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext>): UseMutationResult<SubmitFollowUpCoordinatorApplicationData, OperationError<SubmitFollowUpCoordinatorApplicationError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Follow Up Coordinator Application
         * @description Submit a follow-up coordinator application.
         *
         * Public, as in legacy. Approving one is the only way a coordinator account is created
         * outside the migrator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitFollowUpCoordinatorApplication.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitFollowUpCoordinatorApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SubmitFollowUpCoordinatorApplicationSchema, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, TVariables, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext>): UseMutationResult<SubmitFollowUpCoordinatorApplicationData, OperationError<SubmitFollowUpCoordinatorApplicationError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Submit Follow Up Coordinator Application
         * @description Submit a follow-up coordinator application.
         *
         * Public, as in legacy. Approving one is the only way a coordinator account is created
         * outside the migrator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const submitFollowUpCoordinatorApplicationTotal = qraft.v3Service.submitFollowUpCoordinatorApplication.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const submitFollowUpCoordinatorApplicationTotal = qraft.v3Service.submitFollowUpCoordinatorApplication.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpCoordinatorApplicationSchema, SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Submit Follow Up Coordinator Application
         * @description Submit a follow-up coordinator application.
         *
         * Public, as in legacy. Approving one is the only way a coordinator account is created
         * outside the migrator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const submitFollowUpCoordinatorApplicationPendingMutationVariables = qraft.v3Service.submitFollowUpCoordinatorApplication.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const submitFollowUpCoordinatorApplicationMutationData = qraft.v3Service.submitFollowUpCoordinatorApplication.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SubmitFollowUpCoordinatorApplicationData, OperationError<SubmitFollowUpCoordinatorApplicationError>, MutationVariables<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpCoordinatorApplicationSchema, SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext>;
            select?: (mutation: Mutation<SubmitFollowUpCoordinatorApplicationData, OperationError<SubmitFollowUpCoordinatorApplicationError>, MutationVariables<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Submit Follow Up Coordinator Application
         * @description Submit a follow-up coordinator application.
         *
         * Public, as in legacy. Approving one is the only way a coordinator account is created
         * outside the migrator.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpCoordinatorApplicationSchema, SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Submit Follow Up Coordinator Application
         * @description Submit a follow-up coordinator application.
         *
         * Public, as in legacy. Approving one is the only way a coordinator account is created
         * outside the migrator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.submitFollowUpCoordinatorApplication.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.submitFollowUpCoordinatorApplication.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpCoordinatorApplicationSchema, SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext>): Mutation<SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationError, MutationVariables<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpCoordinatorApplicationSchema, SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationParameters, OperationError<SubmitFollowUpCoordinatorApplicationError>, TContext>): Array<Mutation<SubmitFollowUpCoordinatorApplicationData, SubmitFollowUpCoordinatorApplicationError, MutationVariables<SubmitFollowUpCoordinatorApplicationBody, SubmitFollowUpCoordinatorApplicationParameters>, TContext>>;
        };
        schema: SubmitFollowUpCoordinatorApplicationSchema;
        types: {
            parameters: SubmitFollowUpCoordinatorApplicationParameters;
            data: SubmitFollowUpCoordinatorApplicationData;
            error: SubmitFollowUpCoordinatorApplicationError;
            body: SubmitFollowUpCoordinatorApplicationBody;
        };
    };
    /**
     * @summary Submit Follow Up Partner Application
     * @description Submit a follow-up partner application.
     *
     * Public. Approval creates a verified partner with no creator and no network edge,
     * unlike a coordinator's Add Partner, which is private to that coordinator.
     */
    submitFollowUpPartnerApplication: {
        /**
         * @summary Submit Follow Up Partner Application
         * @description Submit a follow-up partner application.
         *
         * Public. Approval creates a verified partner with no creator and no network edge,
         * unlike a coordinator's Add Partner, which is private to that coordinator.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationParameters, TMeta, TSignal>, client?: (schema: SubmitFollowUpPartnerApplicationSchema, options: ServiceOperationMutationFnOptions<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationError>>): Promise<RequestFnResponse<SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationError>>;
        /**
         * @summary Submit Follow Up Partner Application
         * @description Submit a follow-up partner application.
         *
         * Public. Approval creates a verified partner with no creator and no network edge,
         * unlike a coordinator's Add Partner, which is private to that coordinator.
         */
        getMutationKey(parameters: DeepReadonly<SubmitFollowUpPartnerApplicationParameters> | void): ServiceOperationMutationKey<SubmitFollowUpPartnerApplicationSchema, SubmitFollowUpPartnerApplicationParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Follow Up Partner Application
         * @description Submit a follow-up partner application.
         *
         * Public. Approval creates a verified partner with no creator and no network edge,
         * unlike a coordinator's Add Partner, which is private to that coordinator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitFollowUpPartnerApplication.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitFollowUpPartnerApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SubmitFollowUpPartnerApplicationBody, TContext = unknown>(parameters: DeepReadonly<SubmitFollowUpPartnerApplicationParameters>, options?: ServiceOperationUseMutationOptions<SubmitFollowUpPartnerApplicationSchema, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, TVariables, OperationError<SubmitFollowUpPartnerApplicationError>, TContext>): UseMutationResult<SubmitFollowUpPartnerApplicationData, OperationError<SubmitFollowUpPartnerApplicationError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Follow Up Partner Application
         * @description Submit a follow-up partner application.
         *
         * Public. Approval creates a verified partner with no creator and no network edge,
         * unlike a coordinator's Add Partner, which is private to that coordinator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitFollowUpPartnerApplication.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitFollowUpPartnerApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SubmitFollowUpPartnerApplicationSchema, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, TVariables, OperationError<SubmitFollowUpPartnerApplicationError>, TContext>): UseMutationResult<SubmitFollowUpPartnerApplicationData, OperationError<SubmitFollowUpPartnerApplicationError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Submit Follow Up Partner Application
         * @description Submit a follow-up partner application.
         *
         * Public. Approval creates a verified partner with no creator and no network edge,
         * unlike a coordinator's Add Partner, which is private to that coordinator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const submitFollowUpPartnerApplicationTotal = qraft.v3Service.submitFollowUpPartnerApplication.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const submitFollowUpPartnerApplicationTotal = qraft.v3Service.submitFollowUpPartnerApplication.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpPartnerApplicationSchema, SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Submit Follow Up Partner Application
         * @description Submit a follow-up partner application.
         *
         * Public. Approval creates a verified partner with no creator and no network edge,
         * unlike a coordinator's Add Partner, which is private to that coordinator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const submitFollowUpPartnerApplicationPendingMutationVariables = qraft.v3Service.submitFollowUpPartnerApplication.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const submitFollowUpPartnerApplicationMutationData = qraft.v3Service.submitFollowUpPartnerApplication.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SubmitFollowUpPartnerApplicationData, OperationError<SubmitFollowUpPartnerApplicationError>, MutationVariables<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpPartnerApplicationSchema, SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext>;
            select?: (mutation: Mutation<SubmitFollowUpPartnerApplicationData, OperationError<SubmitFollowUpPartnerApplicationError>, MutationVariables<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Submit Follow Up Partner Application
         * @description Submit a follow-up partner application.
         *
         * Public. Approval creates a verified partner with no creator and no network edge,
         * unlike a coordinator's Add Partner, which is private to that coordinator.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpPartnerApplicationSchema, SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Submit Follow Up Partner Application
         * @description Submit a follow-up partner application.
         *
         * Public. Approval creates a verified partner with no creator and no network edge,
         * unlike a coordinator's Add Partner, which is private to that coordinator.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.submitFollowUpPartnerApplication.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.submitFollowUpPartnerApplication.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpPartnerApplicationSchema, SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext>): Mutation<SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationError, MutationVariables<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext> | MutationFiltersByMutationKey<SubmitFollowUpPartnerApplicationSchema, SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationParameters, OperationError<SubmitFollowUpPartnerApplicationError>, TContext>): Array<Mutation<SubmitFollowUpPartnerApplicationData, SubmitFollowUpPartnerApplicationError, MutationVariables<SubmitFollowUpPartnerApplicationBody, SubmitFollowUpPartnerApplicationParameters>, TContext>>;
        };
        schema: SubmitFollowUpPartnerApplicationSchema;
        types: {
            parameters: SubmitFollowUpPartnerApplicationParameters;
            data: SubmitFollowUpPartnerApplicationData;
            error: SubmitFollowUpPartnerApplicationError;
            body: SubmitFollowUpPartnerApplicationBody;
        };
    };
    /**
     * @summary Reject Helper Application
     * @description Reject a helper application.
     *
     * Stores the rejection reason. A rejected application no longer blocks its (email,
     * role), so the applicant can re-apply.
     */
    rejectHelperApplication: {
        /**
         * @summary Reject Helper Application
         * @description Reject a helper application.
         *
         * Stores the rejection reason. A rejected application no longer blocks its (email,
         * role), so the applicant can re-apply.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RejectHelperApplicationBody, RejectHelperApplicationParameters, TMeta, TSignal>, client?: (schema: RejectHelperApplicationSchema, options: ServiceOperationMutationFnOptions<RejectHelperApplicationBody, RejectHelperApplicationParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RejectHelperApplicationData, RejectHelperApplicationError>>): Promise<RequestFnResponse<RejectHelperApplicationData, RejectHelperApplicationError>>;
        /**
         * @summary Reject Helper Application
         * @description Reject a helper application.
         *
         * Stores the rejection reason. A rejected application no longer blocks its (email,
         * role), so the applicant can re-apply.
         */
        getMutationKey(parameters: DeepReadonly<RejectHelperApplicationParameters> | void): ServiceOperationMutationKey<RejectHelperApplicationSchema, RejectHelperApplicationParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reject Helper Application
         * @description Reject a helper application.
         *
         * Stores the rejection reason. A rejected application no longer blocks its (email,
         * role), so the applicant can re-apply.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectHelperApplication.useMutation({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectHelperApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RejectHelperApplicationBody, TContext = unknown>(parameters: DeepReadonly<RejectHelperApplicationParameters>, options?: ServiceOperationUseMutationOptions<RejectHelperApplicationSchema, RejectHelperApplicationData, RejectHelperApplicationParameters, TVariables, OperationError<RejectHelperApplicationError>, TContext>): UseMutationResult<RejectHelperApplicationData, OperationError<RejectHelperApplicationError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reject Helper Application
         * @description Reject a helper application.
         *
         * Stores the rejection reason. A rejected application no longer blocks its (email,
         * role), so the applicant can re-apply.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectHelperApplication.useMutation({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectHelperApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RejectHelperApplicationBody, RejectHelperApplicationParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RejectHelperApplicationSchema, RejectHelperApplicationData, RejectHelperApplicationParameters, TVariables, OperationError<RejectHelperApplicationError>, TContext>): UseMutationResult<RejectHelperApplicationData, OperationError<RejectHelperApplicationError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Reject Helper Application
         * @description Reject a helper application.
         *
         * Stores the rejection reason. A rejected application no longer blocks its (email,
         * role), so the applicant can re-apply.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const rejectHelperApplicationTotal = qraft.v3Service.rejectHelperApplication.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const rejectHelperApplicationTotal = qraft.v3Service.rejectHelperApplication.useIsMutating({
         *     parameters: {
         *         path: {
         *             application_id: applicationId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext> | MutationFiltersByMutationKey<RejectHelperApplicationSchema, RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Reject Helper Application
         * @description Reject a helper application.
         *
         * Stores the rejection reason. A rejected application no longer blocks its (email,
         * role), so the applicant can re-apply.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const rejectHelperApplicationPendingMutationVariables = qraft.v3Service.rejectHelperApplication.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const rejectHelperApplicationMutationData = qraft.v3Service.rejectHelperApplication.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 application_id: applicationId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RejectHelperApplicationData, OperationError<RejectHelperApplicationError>, MutationVariables<RejectHelperApplicationBody, RejectHelperApplicationParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext> | MutationFiltersByMutationKey<RejectHelperApplicationSchema, RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext>;
            select?: (mutation: Mutation<RejectHelperApplicationData, OperationError<RejectHelperApplicationError>, MutationVariables<RejectHelperApplicationBody, RejectHelperApplicationParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Reject Helper Application
         * @description Reject a helper application.
         *
         * Stores the rejection reason. A rejected application no longer blocks its (email,
         * role), so the applicant can re-apply.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext> | MutationFiltersByMutationKey<RejectHelperApplicationSchema, RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Reject Helper Application
         * @description Reject a helper application.
         *
         * Stores the rejection reason. A rejected application no longer blocks its (email,
         * role), so the applicant can re-apply.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.rejectHelperApplication.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             application_id: applicationId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.rejectHelperApplication.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext> | MutationFiltersByMutationKey<RejectHelperApplicationSchema, RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext>): Mutation<RejectHelperApplicationData, RejectHelperApplicationError, MutationVariables<RejectHelperApplicationBody, RejectHelperApplicationParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext> | MutationFiltersByMutationKey<RejectHelperApplicationSchema, RejectHelperApplicationBody, RejectHelperApplicationData, RejectHelperApplicationParameters, OperationError<RejectHelperApplicationError>, TContext>): Array<Mutation<RejectHelperApplicationData, RejectHelperApplicationError, MutationVariables<RejectHelperApplicationBody, RejectHelperApplicationParameters>, TContext>>;
        };
        schema: RejectHelperApplicationSchema;
        types: {
            parameters: RejectHelperApplicationParameters;
            data: RejectHelperApplicationData;
            error: RejectHelperApplicationError;
            body: RejectHelperApplicationBody;
        };
    };
    /**
     * @summary Approve Helper Application
     * @description Approve a helper application.
     *
     * Creates the account the application's `role` implies (a `StudyHelper`,
     * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
     */
    approveHelperApplication: {
        /**
         * @summary Approve Helper Application
         * @description Approve a helper application.
         *
         * Creates the account the application's `role` implies (a `StudyHelper`,
         * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ApproveHelperApplicationBody, ApproveHelperApplicationParameters, TMeta, TSignal>, client?: (schema: ApproveHelperApplicationSchema, options: ServiceOperationMutationFnOptions<ApproveHelperApplicationBody, ApproveHelperApplicationParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ApproveHelperApplicationData, ApproveHelperApplicationError>>): Promise<RequestFnResponse<ApproveHelperApplicationData, ApproveHelperApplicationError>>;
        /**
         * @summary Approve Helper Application
         * @description Approve a helper application.
         *
         * Creates the account the application's `role` implies (a `StudyHelper`,
         * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
         */
        getMutationKey(parameters: DeepReadonly<ApproveHelperApplicationParameters> | void): ServiceOperationMutationKey<ApproveHelperApplicationSchema, ApproveHelperApplicationParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Approve Helper Application
         * @description Approve a helper application.
         *
         * Creates the account the application's `role` implies (a `StudyHelper`,
         * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.approveHelperApplication.useMutation({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.approveHelperApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ApproveHelperApplicationBody, TContext = unknown>(parameters: DeepReadonly<ApproveHelperApplicationParameters>, options?: ServiceOperationUseMutationOptions<ApproveHelperApplicationSchema, ApproveHelperApplicationData, ApproveHelperApplicationParameters, TVariables, OperationError<ApproveHelperApplicationError>, TContext>): UseMutationResult<ApproveHelperApplicationData, OperationError<ApproveHelperApplicationError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Approve Helper Application
         * @description Approve a helper application.
         *
         * Creates the account the application's `role` implies (a `StudyHelper`,
         * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.approveHelperApplication.useMutation({
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.approveHelperApplication.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         application_id: applicationId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ApproveHelperApplicationBody, ApproveHelperApplicationParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ApproveHelperApplicationSchema, ApproveHelperApplicationData, ApproveHelperApplicationParameters, TVariables, OperationError<ApproveHelperApplicationError>, TContext>): UseMutationResult<ApproveHelperApplicationData, OperationError<ApproveHelperApplicationError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Approve Helper Application
         * @description Approve a helper application.
         *
         * Creates the account the application's `role` implies (a `StudyHelper`,
         * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const approveHelperApplicationTotal = qraft.v3Service.approveHelperApplication.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const approveHelperApplicationTotal = qraft.v3Service.approveHelperApplication.useIsMutating({
         *     parameters: {
         *         path: {
         *             application_id: applicationId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext> | MutationFiltersByMutationKey<ApproveHelperApplicationSchema, ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Approve Helper Application
         * @description Approve a helper application.
         *
         * Creates the account the application's `role` implies (a `StudyHelper`,
         * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const approveHelperApplicationPendingMutationVariables = qraft.v3Service.approveHelperApplication.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const approveHelperApplicationMutationData = qraft.v3Service.approveHelperApplication.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 application_id: applicationId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ApproveHelperApplicationData, OperationError<ApproveHelperApplicationError>, MutationVariables<ApproveHelperApplicationBody, ApproveHelperApplicationParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext> | MutationFiltersByMutationKey<ApproveHelperApplicationSchema, ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext>;
            select?: (mutation: Mutation<ApproveHelperApplicationData, OperationError<ApproveHelperApplicationError>, MutationVariables<ApproveHelperApplicationBody, ApproveHelperApplicationParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Approve Helper Application
         * @description Approve a helper application.
         *
         * Creates the account the application's `role` implies (a `StudyHelper`,
         * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext> | MutationFiltersByMutationKey<ApproveHelperApplicationSchema, ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Approve Helper Application
         * @description Approve a helper application.
         *
         * Creates the account the application's `role` implies (a `StudyHelper`,
         * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.approveHelperApplication.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             application_id: applicationId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.approveHelperApplication.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext> | MutationFiltersByMutationKey<ApproveHelperApplicationSchema, ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext>): Mutation<ApproveHelperApplicationData, ApproveHelperApplicationError, MutationVariables<ApproveHelperApplicationBody, ApproveHelperApplicationParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext> | MutationFiltersByMutationKey<ApproveHelperApplicationSchema, ApproveHelperApplicationBody, ApproveHelperApplicationData, ApproveHelperApplicationParameters, OperationError<ApproveHelperApplicationError>, TContext>): Array<Mutation<ApproveHelperApplicationData, ApproveHelperApplicationError, MutationVariables<ApproveHelperApplicationBody, ApproveHelperApplicationParameters>, TContext>>;
        };
        schema: ApproveHelperApplicationSchema;
        types: {
            parameters: ApproveHelperApplicationParameters;
            data: ApproveHelperApplicationData;
            error: ApproveHelperApplicationError;
            body: ApproveHelperApplicationBody;
        };
    };
    /** @summary Get Campaigns */
    getCampaigns: {
        /** @summary Get Campaigns */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetCampaignsSchema, GetCampaignsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetCampaignsParameters, TMeta, TSignal> | void), client?: (schema: GetCampaignsSchema, options: {
            parameters: GetCampaignsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetCampaignsData, GetCampaignsError>>): Promise<RequestFnResponse<GetCampaignsData, GetCampaignsError>>;
        /** @summary Get Campaigns */
        getQueryKey(parameters: DeepReadonly<GetCampaignsParameters> | void): ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCampaigns.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCampaigns.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCampaignsData>(parameters: ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetCampaignsData, GetCampaignsError, TData, ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetCampaignsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCampaigns.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCampaigns.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCampaignsData>(parameters: ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void), options: Omit<DefinedInitialDataOptions<GetCampaignsData, GetCampaignsError, TData, ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetCampaignsError>>;
        /** @summary Get Campaigns */
        getInfiniteQueryKey(parameters: DeepReadonly<GetCampaignsParameters> | void): ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCampaigns.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCampaignsParameters, TQueryFnData = GetCampaignsData, TData = OperationInfiniteData<TQueryFnData, GetCampaignsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetCampaignsError, TData, ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetCampaignsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCampaigns.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCampaignsParameters, TQueryFnData = GetCampaignsData, TData = OperationInfiniteData<TQueryFnData, GetCampaignsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetCampaignsError, TData, ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCampaignsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetCampaignsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getCampaignsTotal = qraft.v3Service.getCampaigns.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getCampaignsByParametersTotal = qraft.v3Service.getCampaigns.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError> | QueryFiltersByQueryKey<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getCampaignsResults = qraft.v3Service.getCampaigns.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCampaignsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getCampaignsCombinedResults = qraft.v3Service.getCampaigns.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCampaignsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetCampaignsSchema, GetCampaignsParameters, GetCampaignsData, GetCampaignsError>>, TCombinedResult = Array<UseQueryResult<GetCampaignsData, GetCampaignsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetCampaignsData, GetCampaignsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getCampaigns.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getCampaigns.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetCampaignsData>(parameters: ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetCampaignsData, GetCampaignsError, TData, ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetCampaignsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCampaigns.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetCampaignsParameters, TData = GetCampaignsData>(parameters: ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetCampaignsData, GetCampaignsError, OperationInfiniteData<TData, GetCampaignsParameters>, ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCampaignsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetCampaignsParameters>, OperationError<GetCampaignsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Campaigns
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getCampaignsData = qraft.v3Service.getCampaigns.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCampaignsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getCampaignsCombinedData = qraft.v3Service.getCampaigns.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCampaignsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetCampaignsSchema, GetCampaignsParameters, GetCampaignsData, GetCampaignsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetCampaignsData, GetCampaignsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetCampaignsData, GetCampaignsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Campaigns */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetCampaignsSchema, GetCampaignsData, GetCampaignsParameters, GetCampaignsError> | void): Promise<GetCampaignsData>;
        /** @summary Get Campaigns */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetCampaignsSchema, GetCampaignsData, GetCampaignsParameters, GetCampaignsError> | void): Promise<void>;
        /** @summary Get Campaigns */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetCampaignsSchema, GetCampaignsData, GetCampaignsParameters, GetCampaignsError> | void): Promise<GetCampaignsData>;
        /** @summary Get Campaigns */
        fetchInfiniteQuery<TPageParam extends GetCampaignsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCampaignsSchema, GetCampaignsData, GetCampaignsParameters, DeepReadonly<TPageParam>, GetCampaignsError> | void): Promise<OperationInfiniteData<GetCampaignsData, GetCampaignsParameters>>;
        /** @summary Get Campaigns */
        prefetchInfiniteQuery<TPageParam extends GetCampaignsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCampaignsSchema, GetCampaignsData, GetCampaignsParameters, DeepReadonly<TPageParam>, GetCampaignsError> | void): Promise<void>;
        /** @summary Get Campaigns */
        ensureInfiniteQueryData<TPageParam extends GetCampaignsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetCampaignsSchema, GetCampaignsData, GetCampaignsParameters, DeepReadonly<TPageParam>, GetCampaignsError> | void): Promise<OperationInfiniteData<GetCampaignsData, GetCampaignsParameters>>;
        /** @summary Get Campaigns */
        getQueryData(parameters: ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void)): GetCampaignsData | undefined;
        /** @summary Get Campaigns */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void)): OperationInfiniteData<GetCampaignsData, GetCampaignsParameters> | undefined;
        /** @summary Get Campaigns */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError> | QueryFiltersByQueryKey<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters>,
            data: NoInfer<OperationInfiniteData<GetCampaignsData, GetCampaignsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters>,
            data: GetCampaignsData | undefined
        ]>;
        /** @summary Get Campaigns */
        getQueryState(parameters: ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters> | (DeepReadonly<GetCampaignsParameters> | void)): QueryState<GetCampaignsData, GetCampaignsError> | undefined;
        /** @summary Get Campaigns */
        getInfiniteQueryState(parameters: DeepReadonly<GetCampaignsParameters> | ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters> | void): QueryState<OperationInfiniteData<GetCampaignsData, GetCampaignsParameters>, GetCampaignsError> | undefined;
        /** @summary Get Campaigns */
        setQueryData(parameters: (DeepReadonly<GetCampaignsParameters> | undefined) | ServiceOperationQueryKey<GetCampaignsSchema, GetCampaignsParameters>, updater: Updater<NoInfer<GetCampaignsData> | undefined, NoInfer<DeepReadonly<GetCampaignsData>> | undefined>, options?: SetDataOptions): GetCampaignsData | undefined;
        /** @summary Get Campaigns */
        setInfiniteQueryData(parameters: (DeepReadonly<GetCampaignsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetCampaignsSchema, GetCampaignsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetCampaignsData, GetCampaignsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetCampaignsData, GetCampaignsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetCampaignsData, GetCampaignsParameters> | undefined;
        /** @summary Get Campaigns */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError> | QueryFiltersByQueryKey<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>, updater: Updater<NoInfer<GetCampaignsData> | undefined, NoInfer<GetCampaignsData> | undefined>, options?: SetDataOptions): Array<GetCampaignsData | undefined>;
        /** @summary Get Campaigns */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Campaigns */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError> | QueryFiltersByQueryKey<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Campaigns */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError> | QueryFiltersByQueryKey<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Campaigns */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError> | QueryFiltersByQueryKey<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>): void;
        /** @summary Get Campaigns */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError> | QueryFiltersByQueryKey<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Campaigns */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError> | QueryFiltersByQueryKey<GetCampaignsSchema, GetCampaignsData, TInfinite, GetCampaignsParameters, GetCampaignsError>): number;
        schema: GetCampaignsSchema;
        types: {
            parameters: GetCampaignsParameters;
            data: GetCampaignsData;
            error: GetCampaignsError;
        };
    };
    /**
     * @summary Create Campaign Session
     * @description Open a connect session attributed to the campaign the host names.
     *
     * `domain` is the host the visitor arrived on. Both a campaign subdomain and
     * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
     * does not.
     */
    createCampaignSession: {
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<CreateCampaignSessionParameters, TMeta, TSignal>), client?: (schema: CreateCampaignSessionSchema, options: {
            parameters: CreateCampaignSessionParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<CreateCampaignSessionData, CreateCampaignSessionError>>): Promise<RequestFnResponse<CreateCampaignSessionData, CreateCampaignSessionError>>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        getQueryKey(parameters: DeepReadonly<CreateCampaignSessionParameters>): ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.createCampaignSession.useQuery({
         *     query: {
         *         domain: domain
         *     }
         * })
         * ```
         */
        useQuery<TData = CreateCampaignSessionData>(parameters: ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>), options?: Omit<UndefinedInitialDataOptions<CreateCampaignSessionData, CreateCampaignSessionError, TData, ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>>, "queryKey">): UseQueryResult<TData, OperationError<CreateCampaignSessionError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.createCampaignSession.useQuery({
         *     query: {
         *         domain: domain
         *     }
         * })
         * ```
         */
        useQuery<TData = CreateCampaignSessionData>(parameters: ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>), options: Omit<DefinedInitialDataOptions<CreateCampaignSessionData, CreateCampaignSessionError, TData, ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<CreateCampaignSessionError>>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<CreateCampaignSessionParameters>): ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.createCampaignSession.useInfiniteQuery({
         *     query: {
         *         domain: domain
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             domain: initialDomain
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CreateCampaignSessionParameters, TQueryFnData = CreateCampaignSessionData, TData = OperationInfiniteData<TQueryFnData, CreateCampaignSessionParameters>>(parameters: ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, CreateCampaignSessionError, TData, ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<CreateCampaignSessionError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.createCampaignSession.useInfiniteQuery({
         *     query: {
         *         domain: domain
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             domain: initialDomain
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CreateCampaignSessionParameters, TQueryFnData = CreateCampaignSessionData, TData = OperationInfiniteData<TQueryFnData, CreateCampaignSessionParameters>>(parameters: ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, CreateCampaignSessionError, TData, ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CreateCampaignSessionData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<CreateCampaignSessionError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const createCampaignSessionTotal = qraft.v3Service.createCampaignSession.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const createCampaignSessionByParametersTotal = qraft.v3Service.createCampaignSession.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             domain: domain
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError> | QueryFiltersByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const createCampaignSessionResults = qraft.v3Service.createCampaignSession.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 domain: domain1
         *             }
         *         },
         *         {
         *             query: {
         *                 domain: domain2
         *             }
         *         }
         *     ]
         * });
         * createCampaignSessionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const createCampaignSessionCombinedResults = qraft.v3Service.createCampaignSession.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 domain: domain1
         *             }
         *         },
         *         {
         *             query: {
         *                 domain: domain2
         *             }
         *         }
         *     ]
         * });
         * createCampaignSessionCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<CreateCampaignSessionSchema, CreateCampaignSessionParameters, CreateCampaignSessionData, CreateCampaignSessionError>>, TCombinedResult = Array<UseQueryResult<CreateCampaignSessionData, CreateCampaignSessionError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<CreateCampaignSessionData, CreateCampaignSessionError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.createCampaignSession.useSuspenseQuery({
         *     query: {
         *         domain: domain
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = CreateCampaignSessionData>(parameters: ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>), options?: Omit<UseSuspenseQueryOptions<CreateCampaignSessionData, CreateCampaignSessionError, TData, ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<CreateCampaignSessionError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.createCampaignSession.useSuspenseInfiniteQuery({
         *     query: {
         *         domain: domain
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             domain: initialDomain
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends CreateCampaignSessionParameters, TData = CreateCampaignSessionData>(parameters: ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<CreateCampaignSessionData, CreateCampaignSessionError, OperationInfiniteData<TData, CreateCampaignSessionParameters>, ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CreateCampaignSessionData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, CreateCampaignSessionParameters>, OperationError<CreateCampaignSessionError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const createCampaignSessionData = qraft.v3Service.createCampaignSession.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 domain: domain1
         *             }
         *         },
         *         {
         *             query: {
         *                 domain: domain2
         *             }
         *         }
         *     ]
         * });
         * createCampaignSessionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const createCampaignSessionCombinedData = qraft.v3Service.createCampaignSession.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 domain: domain1
         *             }
         *         },
         *         {
         *             query: {
         *                 domain: domain2
         *             }
         *         }
         *     ]
         * });
         * createCampaignSessionCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<CreateCampaignSessionSchema, CreateCampaignSessionParameters, CreateCampaignSessionData, CreateCampaignSessionError>>, TCombinedResult = Array<UseSuspenseQueryResult<CreateCampaignSessionData, CreateCampaignSessionError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<CreateCampaignSessionData, CreateCampaignSessionError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<CreateCampaignSessionSchema, CreateCampaignSessionData, CreateCampaignSessionParameters, CreateCampaignSessionError>): Promise<CreateCampaignSessionData>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<CreateCampaignSessionSchema, CreateCampaignSessionData, CreateCampaignSessionParameters, CreateCampaignSessionError>): Promise<void>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<CreateCampaignSessionSchema, CreateCampaignSessionData, CreateCampaignSessionParameters, CreateCampaignSessionError>): Promise<CreateCampaignSessionData>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        fetchInfiniteQuery<TPageParam extends CreateCampaignSessionParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CreateCampaignSessionSchema, CreateCampaignSessionData, CreateCampaignSessionParameters, DeepReadonly<TPageParam>, CreateCampaignSessionError>): Promise<OperationInfiniteData<CreateCampaignSessionData, CreateCampaignSessionParameters>>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        prefetchInfiniteQuery<TPageParam extends CreateCampaignSessionParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CreateCampaignSessionSchema, CreateCampaignSessionData, CreateCampaignSessionParameters, DeepReadonly<TPageParam>, CreateCampaignSessionError>): Promise<void>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        ensureInfiniteQueryData<TPageParam extends CreateCampaignSessionParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<CreateCampaignSessionSchema, CreateCampaignSessionData, CreateCampaignSessionParameters, DeepReadonly<TPageParam>, CreateCampaignSessionError>): Promise<OperationInfiniteData<CreateCampaignSessionData, CreateCampaignSessionParameters>>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        getQueryData(parameters: ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>)): CreateCampaignSessionData | undefined;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>)): OperationInfiniteData<CreateCampaignSessionData, CreateCampaignSessionParameters> | undefined;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError> | QueryFiltersByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>,
            data: NoInfer<OperationInfiniteData<CreateCampaignSessionData, CreateCampaignSessionParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>,
            data: CreateCampaignSessionData | undefined
        ]>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        getQueryState(parameters: ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters> | (DeepReadonly<CreateCampaignSessionParameters>)): QueryState<CreateCampaignSessionData, CreateCampaignSessionError> | undefined;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        getInfiniteQueryState(parameters: DeepReadonly<CreateCampaignSessionParameters> | ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>): QueryState<OperationInfiniteData<CreateCampaignSessionData, CreateCampaignSessionParameters>, CreateCampaignSessionError> | undefined;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        setQueryData(parameters: (DeepReadonly<CreateCampaignSessionParameters>) | ServiceOperationQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>, updater: Updater<NoInfer<CreateCampaignSessionData> | undefined, NoInfer<DeepReadonly<CreateCampaignSessionData>> | undefined>, options?: SetDataOptions): CreateCampaignSessionData | undefined;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<CreateCampaignSessionParameters>) | ServiceOperationInfiniteQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionParameters>, updater: Updater<NoInfer<OperationInfiniteData<CreateCampaignSessionData, CreateCampaignSessionParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<CreateCampaignSessionData, CreateCampaignSessionParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<CreateCampaignSessionData, CreateCampaignSessionParameters> | undefined;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError> | QueryFiltersByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>, updater: Updater<NoInfer<CreateCampaignSessionData> | undefined, NoInfer<CreateCampaignSessionData> | undefined>, options?: SetDataOptions): Array<CreateCampaignSessionData | undefined>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError> | QueryFiltersByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError> | QueryFiltersByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError> | QueryFiltersByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>): void;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError> | QueryFiltersByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Create Campaign Session
         * @description Open a connect session attributed to the campaign the host names.
         *
         * `domain` is the host the visitor arrived on. Both a campaign subdomain and
         * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
         * does not.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError> | QueryFiltersByQueryKey<CreateCampaignSessionSchema, CreateCampaignSessionData, TInfinite, CreateCampaignSessionParameters, CreateCampaignSessionError>): number;
        schema: CreateCampaignSessionSchema;
        types: {
            parameters: CreateCampaignSessionParameters;
            data: CreateCampaignSessionData;
            error: CreateCampaignSessionError;
        };
    };
    /** @summary Get Groups */
    getGroups: {
        /** @summary Get Groups */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupsSchema, GetGroupsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupsParameters, TMeta, TSignal> | void), client?: (schema: GetGroupsSchema, options: {
            parameters: GetGroupsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupsData, GetGroupsError>>): Promise<RequestFnResponse<GetGroupsData, GetGroupsError>>;
        /** @summary Get Groups */
        getQueryKey(parameters: DeepReadonly<GetGroupsParameters> | void): ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroups.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroups.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupsData>(parameters: ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetGroupsData, GetGroupsError, TData, ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroups.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroups.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupsData>(parameters: ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void), options: Omit<DefinedInitialDataOptions<GetGroupsData, GetGroupsError, TData, ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupsError>>;
        /** @summary Get Groups */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupsParameters> | void): ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroups.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupsParameters, TQueryFnData = GetGroupsData, TData = OperationInfiniteData<TQueryFnData, GetGroupsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupsError, TData, ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroups.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupsParameters, TQueryFnData = GetGroupsData, TData = OperationInfiniteData<TQueryFnData, GetGroupsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupsError, TData, ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupsTotal = qraft.v3Service.getGroups.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupsByParametersTotal = qraft.v3Service.getGroups.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError> | QueryFiltersByQueryKey<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupsResults = qraft.v3Service.getGroups.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupsCombinedResults = qraft.v3Service.getGroups.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupsSchema, GetGroupsParameters, GetGroupsData, GetGroupsError>>, TCombinedResult = Array<UseQueryResult<GetGroupsData, GetGroupsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupsData, GetGroupsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getGroups.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroups.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupsData>(parameters: ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetGroupsData, GetGroupsError, TData, ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroups.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupsParameters, TData = GetGroupsData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupsData, GetGroupsError, OperationInfiniteData<TData, GetGroupsParameters>, ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupsParameters>, OperationError<GetGroupsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Groups
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupsData = qraft.v3Service.getGroups.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupsCombinedData = qraft.v3Service.getGroups.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupsSchema, GetGroupsParameters, GetGroupsData, GetGroupsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupsData, GetGroupsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupsData, GetGroupsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Groups */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupsSchema, GetGroupsData, GetGroupsParameters, GetGroupsError> | void): Promise<GetGroupsData>;
        /** @summary Get Groups */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupsSchema, GetGroupsData, GetGroupsParameters, GetGroupsError> | void): Promise<void>;
        /** @summary Get Groups */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupsSchema, GetGroupsData, GetGroupsParameters, GetGroupsError> | void): Promise<GetGroupsData>;
        /** @summary Get Groups */
        fetchInfiniteQuery<TPageParam extends GetGroupsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupsSchema, GetGroupsData, GetGroupsParameters, DeepReadonly<TPageParam>, GetGroupsError> | void): Promise<OperationInfiniteData<GetGroupsData, GetGroupsParameters>>;
        /** @summary Get Groups */
        prefetchInfiniteQuery<TPageParam extends GetGroupsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupsSchema, GetGroupsData, GetGroupsParameters, DeepReadonly<TPageParam>, GetGroupsError> | void): Promise<void>;
        /** @summary Get Groups */
        ensureInfiniteQueryData<TPageParam extends GetGroupsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupsSchema, GetGroupsData, GetGroupsParameters, DeepReadonly<TPageParam>, GetGroupsError> | void): Promise<OperationInfiniteData<GetGroupsData, GetGroupsParameters>>;
        /** @summary Get Groups */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void)): GetGroupsData | undefined;
        /** @summary Get Groups */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void)): OperationInfiniteData<GetGroupsData, GetGroupsParameters> | undefined;
        /** @summary Get Groups */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError> | QueryFiltersByQueryKey<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupsData, GetGroupsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters>,
            data: GetGroupsData | undefined
        ]>;
        /** @summary Get Groups */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters> | (DeepReadonly<GetGroupsParameters> | void)): QueryState<GetGroupsData, GetGroupsError> | undefined;
        /** @summary Get Groups */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupsParameters> | ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters> | void): QueryState<OperationInfiniteData<GetGroupsData, GetGroupsParameters>, GetGroupsError> | undefined;
        /** @summary Get Groups */
        setQueryData(parameters: (DeepReadonly<GetGroupsParameters> | undefined) | ServiceOperationQueryKey<GetGroupsSchema, GetGroupsParameters>, updater: Updater<NoInfer<GetGroupsData> | undefined, NoInfer<DeepReadonly<GetGroupsData>> | undefined>, options?: SetDataOptions): GetGroupsData | undefined;
        /** @summary Get Groups */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetGroupsSchema, GetGroupsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupsData, GetGroupsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupsData, GetGroupsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupsData, GetGroupsParameters> | undefined;
        /** @summary Get Groups */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError> | QueryFiltersByQueryKey<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>, updater: Updater<NoInfer<GetGroupsData> | undefined, NoInfer<GetGroupsData> | undefined>, options?: SetDataOptions): Array<GetGroupsData | undefined>;
        /** @summary Get Groups */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Groups */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError> | QueryFiltersByQueryKey<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Groups */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError> | QueryFiltersByQueryKey<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Groups */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError> | QueryFiltersByQueryKey<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>): void;
        /** @summary Get Groups */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError> | QueryFiltersByQueryKey<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Groups */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError> | QueryFiltersByQueryKey<GetGroupsSchema, GetGroupsData, TInfinite, GetGroupsParameters, GetGroupsError>): number;
        schema: GetGroupsSchema;
        types: {
            parameters: GetGroupsParameters;
            data: GetGroupsData;
            error: GetGroupsError;
        };
    };
    /** @summary Create Group Endpoint */
    createGroup: {
        /** @summary Create Group Endpoint */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateGroupBody, CreateGroupParameters, TMeta, TSignal>, client?: (schema: CreateGroupSchema, options: ServiceOperationMutationFnOptions<CreateGroupBody, CreateGroupParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateGroupData, CreateGroupError>>): Promise<RequestFnResponse<CreateGroupData, CreateGroupError>>;
        /** @summary Create Group Endpoint */
        getMutationKey(parameters: DeepReadonly<CreateGroupParameters> | void): ServiceOperationMutationKey<CreateGroupSchema, CreateGroupParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Group Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroup.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroup.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateGroupBody, TContext = unknown>(parameters: DeepReadonly<CreateGroupParameters>, options?: ServiceOperationUseMutationOptions<CreateGroupSchema, CreateGroupData, CreateGroupParameters, TVariables, OperationError<CreateGroupError>, TContext>): UseMutationResult<CreateGroupData, OperationError<CreateGroupError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Group Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroup.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroup.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateGroupBody, CreateGroupParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateGroupSchema, CreateGroupData, CreateGroupParameters, TVariables, OperationError<CreateGroupError>, TContext>): UseMutationResult<CreateGroupData, OperationError<CreateGroupError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Group Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createGroupTotal = qraft.v3Service.createGroup.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createGroupTotal = qraft.v3Service.createGroup.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext> | MutationFiltersByMutationKey<CreateGroupSchema, CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Group Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createGroupPendingMutationVariables = qraft.v3Service.createGroup.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createGroupMutationData = qraft.v3Service.createGroup.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateGroupData, OperationError<CreateGroupError>, MutationVariables<CreateGroupBody, CreateGroupParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext> | MutationFiltersByMutationKey<CreateGroupSchema, CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext>;
            select?: (mutation: Mutation<CreateGroupData, OperationError<CreateGroupError>, MutationVariables<CreateGroupBody, CreateGroupParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Create Group Endpoint */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext> | MutationFiltersByMutationKey<CreateGroupSchema, CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Group Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createGroup.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createGroup.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext> | MutationFiltersByMutationKey<CreateGroupSchema, CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext>): Mutation<CreateGroupData, CreateGroupError, MutationVariables<CreateGroupBody, CreateGroupParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext> | MutationFiltersByMutationKey<CreateGroupSchema, CreateGroupBody, CreateGroupData, CreateGroupParameters, OperationError<CreateGroupError>, TContext>): Array<Mutation<CreateGroupData, CreateGroupError, MutationVariables<CreateGroupBody, CreateGroupParameters>, TContext>>;
        };
        schema: CreateGroupSchema;
        types: {
            parameters: CreateGroupParameters;
            data: CreateGroupData;
            error: CreateGroupError;
            body: CreateGroupBody;
        };
    };
    /**
     * @summary List My Groups Endpoint
     * @description The caller's own groups, for the sidebar's group switcher.
     *
     * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
     * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
     * pagination ceiling; the default of 10 would truncate.
     */
    listMyGroups: {
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListMyGroupsSchema, ListMyGroupsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListMyGroupsParameters, TMeta, TSignal> | void), client?: (schema: ListMyGroupsSchema, options: {
            parameters: ListMyGroupsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListMyGroupsData, ListMyGroupsError>>): Promise<RequestFnResponse<ListMyGroupsData, ListMyGroupsError>>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        getQueryKey(parameters: DeepReadonly<ListMyGroupsParameters> | void): ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMyGroups.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMyGroups.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListMyGroupsData>(parameters: ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListMyGroupsData, ListMyGroupsError, TData, ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListMyGroupsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMyGroups.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMyGroups.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListMyGroupsData>(parameters: ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void), options: Omit<DefinedInitialDataOptions<ListMyGroupsData, ListMyGroupsError, TData, ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListMyGroupsError>>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListMyGroupsParameters> | void): ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMyGroups.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListMyGroupsParameters, TQueryFnData = ListMyGroupsData, TData = OperationInfiniteData<TQueryFnData, ListMyGroupsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListMyGroupsError, TData, ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListMyGroupsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMyGroups.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListMyGroupsParameters, TQueryFnData = ListMyGroupsData, TData = OperationInfiniteData<TQueryFnData, ListMyGroupsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListMyGroupsError, TData, ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListMyGroupsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListMyGroupsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listMyGroupsTotal = qraft.v3Service.listMyGroups.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listMyGroupsByParametersTotal = qraft.v3Service.listMyGroups.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError> | QueryFiltersByQueryKey<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listMyGroupsResults = qraft.v3Service.listMyGroups.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMyGroupsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listMyGroupsCombinedResults = qraft.v3Service.listMyGroups.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMyGroupsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListMyGroupsSchema, ListMyGroupsParameters, ListMyGroupsData, ListMyGroupsError>>, TCombinedResult = Array<UseQueryResult<ListMyGroupsData, ListMyGroupsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListMyGroupsData, ListMyGroupsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listMyGroups.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listMyGroups.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListMyGroupsData>(parameters: ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListMyGroupsData, ListMyGroupsError, TData, ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListMyGroupsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMyGroups.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListMyGroupsParameters, TData = ListMyGroupsData>(parameters: ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListMyGroupsData, ListMyGroupsError, OperationInfiniteData<TData, ListMyGroupsParameters>, ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListMyGroupsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListMyGroupsParameters>, OperationError<ListMyGroupsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listMyGroupsData = qraft.v3Service.listMyGroups.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMyGroupsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listMyGroupsCombinedData = qraft.v3Service.listMyGroups.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMyGroupsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListMyGroupsSchema, ListMyGroupsParameters, ListMyGroupsData, ListMyGroupsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListMyGroupsData, ListMyGroupsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListMyGroupsData, ListMyGroupsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListMyGroupsSchema, ListMyGroupsData, ListMyGroupsParameters, ListMyGroupsError> | void): Promise<ListMyGroupsData>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListMyGroupsSchema, ListMyGroupsData, ListMyGroupsParameters, ListMyGroupsError> | void): Promise<void>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListMyGroupsSchema, ListMyGroupsData, ListMyGroupsParameters, ListMyGroupsError> | void): Promise<ListMyGroupsData>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        fetchInfiniteQuery<TPageParam extends ListMyGroupsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListMyGroupsSchema, ListMyGroupsData, ListMyGroupsParameters, DeepReadonly<TPageParam>, ListMyGroupsError> | void): Promise<OperationInfiniteData<ListMyGroupsData, ListMyGroupsParameters>>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        prefetchInfiniteQuery<TPageParam extends ListMyGroupsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListMyGroupsSchema, ListMyGroupsData, ListMyGroupsParameters, DeepReadonly<TPageParam>, ListMyGroupsError> | void): Promise<void>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        ensureInfiniteQueryData<TPageParam extends ListMyGroupsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListMyGroupsSchema, ListMyGroupsData, ListMyGroupsParameters, DeepReadonly<TPageParam>, ListMyGroupsError> | void): Promise<OperationInfiniteData<ListMyGroupsData, ListMyGroupsParameters>>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void)): ListMyGroupsData | undefined;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void)): OperationInfiniteData<ListMyGroupsData, ListMyGroupsParameters> | undefined;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError> | QueryFiltersByQueryKey<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>,
            data: NoInfer<OperationInfiniteData<ListMyGroupsData, ListMyGroupsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>,
            data: ListMyGroupsData | undefined
        ]>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | (DeepReadonly<ListMyGroupsParameters> | void)): QueryState<ListMyGroupsData, ListMyGroupsError> | undefined;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListMyGroupsParameters> | ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters> | void): QueryState<OperationInfiniteData<ListMyGroupsData, ListMyGroupsParameters>, ListMyGroupsError> | undefined;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        setQueryData(parameters: (DeepReadonly<ListMyGroupsParameters> | undefined) | ServiceOperationQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>, updater: Updater<NoInfer<ListMyGroupsData> | undefined, NoInfer<DeepReadonly<ListMyGroupsData>> | undefined>, options?: SetDataOptions): ListMyGroupsData | undefined;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListMyGroupsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListMyGroupsSchema, ListMyGroupsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListMyGroupsData, ListMyGroupsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListMyGroupsData, ListMyGroupsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListMyGroupsData, ListMyGroupsParameters> | undefined;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError> | QueryFiltersByQueryKey<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>, updater: Updater<NoInfer<ListMyGroupsData> | undefined, NoInfer<ListMyGroupsData> | undefined>, options?: SetDataOptions): Array<ListMyGroupsData | undefined>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError> | QueryFiltersByQueryKey<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError> | QueryFiltersByQueryKey<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError> | QueryFiltersByQueryKey<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>): void;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError> | QueryFiltersByQueryKey<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List My Groups Endpoint
         * @description The caller's own groups, for the sidebar's group switcher.
         *
         * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
         * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
         * pagination ceiling; the default of 10 would truncate.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError> | QueryFiltersByQueryKey<ListMyGroupsSchema, ListMyGroupsData, TInfinite, ListMyGroupsParameters, ListMyGroupsError>): number;
        schema: ListMyGroupsSchema;
        types: {
            parameters: ListMyGroupsParameters;
            data: ListMyGroupsData;
            error: ListMyGroupsError;
        };
    };
    /** @summary Get Group */
    getGroup: {
        /** @summary Get Group */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupSchema, GetGroupParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupParameters, TMeta, TSignal>), client?: (schema: GetGroupSchema, options: {
            parameters: GetGroupParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupData, GetGroupError>>): Promise<RequestFnResponse<GetGroupData, GetGroupError>>;
        /** @summary Get Group */
        getQueryKey(parameters: DeepReadonly<GetGroupParameters>): ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroup.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupData>(parameters: ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupData, GetGroupError, TData, ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroup.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupData>(parameters: ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>), options: Omit<DefinedInitialDataOptions<GetGroupData, GetGroupError, TData, ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupError>>;
        /** @summary Get Group */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupParameters>): ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroup.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupParameters, TQueryFnData = GetGroupData, TData = OperationInfiniteData<TQueryFnData, GetGroupParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupError, TData, ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroup.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupParameters, TQueryFnData = GetGroupData, TData = OperationInfiniteData<TQueryFnData, GetGroupParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupError, TData, ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupTotal = qraft.v3Service.getGroup.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupByParametersTotal = qraft.v3Service.getGroup.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError> | QueryFiltersByQueryKey<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupResults = qraft.v3Service.getGroup.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupCombinedResults = qraft.v3Service.getGroup.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupSchema, GetGroupParameters, GetGroupData, GetGroupError>>, TCombinedResult = Array<UseQueryResult<GetGroupData, GetGroupError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupData, GetGroupError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroup.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupData>(parameters: ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupData, GetGroupError, TData, ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroup.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupParameters, TData = GetGroupData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupData, GetGroupError, OperationInfiniteData<TData, GetGroupParameters>, ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupParameters>, OperationError<GetGroupError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupData = qraft.v3Service.getGroup.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupCombinedData = qraft.v3Service.getGroup.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupSchema, GetGroupParameters, GetGroupData, GetGroupError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupData, GetGroupError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupData, GetGroupError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Group */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupSchema, GetGroupData, GetGroupParameters, GetGroupError>): Promise<GetGroupData>;
        /** @summary Get Group */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupSchema, GetGroupData, GetGroupParameters, GetGroupError>): Promise<void>;
        /** @summary Get Group */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupSchema, GetGroupData, GetGroupParameters, GetGroupError>): Promise<GetGroupData>;
        /** @summary Get Group */
        fetchInfiniteQuery<TPageParam extends GetGroupParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupSchema, GetGroupData, GetGroupParameters, DeepReadonly<TPageParam>, GetGroupError>): Promise<OperationInfiniteData<GetGroupData, GetGroupParameters>>;
        /** @summary Get Group */
        prefetchInfiniteQuery<TPageParam extends GetGroupParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupSchema, GetGroupData, GetGroupParameters, DeepReadonly<TPageParam>, GetGroupError>): Promise<void>;
        /** @summary Get Group */
        ensureInfiniteQueryData<TPageParam extends GetGroupParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupSchema, GetGroupData, GetGroupParameters, DeepReadonly<TPageParam>, GetGroupError>): Promise<OperationInfiniteData<GetGroupData, GetGroupParameters>>;
        /** @summary Get Group */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>)): GetGroupData | undefined;
        /** @summary Get Group */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>)): OperationInfiniteData<GetGroupData, GetGroupParameters> | undefined;
        /** @summary Get Group */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError> | QueryFiltersByQueryKey<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupData, GetGroupParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters>,
            data: GetGroupData | undefined
        ]>;
        /** @summary Get Group */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters> | (DeepReadonly<GetGroupParameters>)): QueryState<GetGroupData, GetGroupError> | undefined;
        /** @summary Get Group */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupParameters> | ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters>): QueryState<OperationInfiniteData<GetGroupData, GetGroupParameters>, GetGroupError> | undefined;
        /** @summary Get Group */
        setQueryData(parameters: (DeepReadonly<GetGroupParameters>) | ServiceOperationQueryKey<GetGroupSchema, GetGroupParameters>, updater: Updater<NoInfer<GetGroupData> | undefined, NoInfer<DeepReadonly<GetGroupData>> | undefined>, options?: SetDataOptions): GetGroupData | undefined;
        /** @summary Get Group */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupParameters>) | ServiceOperationInfiniteQueryKey<GetGroupSchema, GetGroupParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupData, GetGroupParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupData, GetGroupParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupData, GetGroupParameters> | undefined;
        /** @summary Get Group */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError> | QueryFiltersByQueryKey<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>, updater: Updater<NoInfer<GetGroupData> | undefined, NoInfer<GetGroupData> | undefined>, options?: SetDataOptions): Array<GetGroupData | undefined>;
        /** @summary Get Group */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Group */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError> | QueryFiltersByQueryKey<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Group */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError> | QueryFiltersByQueryKey<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Group */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError> | QueryFiltersByQueryKey<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>): void;
        /** @summary Get Group */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError> | QueryFiltersByQueryKey<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Group */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError> | QueryFiltersByQueryKey<GetGroupSchema, GetGroupData, TInfinite, GetGroupParameters, GetGroupError>): number;
        schema: GetGroupSchema;
        types: {
            parameters: GetGroupParameters;
            data: GetGroupData;
            error: GetGroupError;
        };
    };
    /** @summary Get Group By Slug */
    getGroupBySlug: {
        /** @summary Get Group By Slug */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupBySlugParameters, TMeta, TSignal>), client?: (schema: GetGroupBySlugSchema, options: {
            parameters: GetGroupBySlugParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupBySlugData, GetGroupBySlugError>>): Promise<RequestFnResponse<GetGroupBySlugData, GetGroupBySlugError>>;
        /** @summary Get Group By Slug */
        getQueryKey(parameters: DeepReadonly<GetGroupBySlugParameters>): ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupBySlug.useQuery({
         *     path: {
         *         group_slug: groupSlug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupBySlugData>(parameters: ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupBySlugData, GetGroupBySlugError, TData, ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupBySlugError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupBySlug.useQuery({
         *     path: {
         *         group_slug: groupSlug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupBySlugData>(parameters: ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>), options: Omit<DefinedInitialDataOptions<GetGroupBySlugData, GetGroupBySlugError, TData, ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupBySlugError>>;
        /** @summary Get Group By Slug */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupBySlugParameters>): ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupBySlug.useInfiniteQuery({
         *     path: {
         *         group_slug: groupSlug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupBySlugParameters, TQueryFnData = GetGroupBySlugData, TData = OperationInfiniteData<TQueryFnData, GetGroupBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupBySlugError, TData, ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupBySlug.useInfiniteQuery({
         *     path: {
         *         group_slug: groupSlug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupBySlugParameters, TQueryFnData = GetGroupBySlugData, TData = OperationInfiniteData<TQueryFnData, GetGroupBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupBySlugError, TData, ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupBySlugError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupBySlugTotal = qraft.v3Service.getGroupBySlug.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupBySlugByParametersTotal = qraft.v3Service.getGroupBySlug.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_slug: groupSlug
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError> | QueryFiltersByQueryKey<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupBySlugResults = qraft.v3Service.getGroupBySlug.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_slug: groupSlug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_slug: groupSlug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupBySlugCombinedResults = qraft.v3Service.getGroupBySlug.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_slug: groupSlug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_slug: groupSlug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupBySlugCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupBySlugSchema, GetGroupBySlugParameters, GetGroupBySlugData, GetGroupBySlugError>>, TCombinedResult = Array<UseQueryResult<GetGroupBySlugData, GetGroupBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupBySlugData, GetGroupBySlugError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupBySlug.useSuspenseQuery({
         *     path: {
         *         group_slug: groupSlug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupBySlugData>(parameters: ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupBySlugData, GetGroupBySlugError, TData, ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupBySlug.useSuspenseInfiniteQuery({
         *     path: {
         *         group_slug: groupSlug
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupBySlugParameters, TData = GetGroupBySlugData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupBySlugData, GetGroupBySlugError, OperationInfiniteData<TData, GetGroupBySlugParameters>, ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupBySlugParameters>, OperationError<GetGroupBySlugError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupBySlugData = qraft.v3Service.getGroupBySlug.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_slug: groupSlug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_slug: groupSlug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupBySlugCombinedData = qraft.v3Service.getGroupBySlug.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_slug: groupSlug1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_slug: groupSlug2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupBySlugCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupBySlugSchema, GetGroupBySlugParameters, GetGroupBySlugData, GetGroupBySlugError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupBySlugData, GetGroupBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupBySlugData, GetGroupBySlugError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Group By Slug */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupBySlugSchema, GetGroupBySlugData, GetGroupBySlugParameters, GetGroupBySlugError>): Promise<GetGroupBySlugData>;
        /** @summary Get Group By Slug */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupBySlugSchema, GetGroupBySlugData, GetGroupBySlugParameters, GetGroupBySlugError>): Promise<void>;
        /** @summary Get Group By Slug */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupBySlugSchema, GetGroupBySlugData, GetGroupBySlugParameters, GetGroupBySlugError>): Promise<GetGroupBySlugData>;
        /** @summary Get Group By Slug */
        fetchInfiniteQuery<TPageParam extends GetGroupBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupBySlugSchema, GetGroupBySlugData, GetGroupBySlugParameters, DeepReadonly<TPageParam>, GetGroupBySlugError>): Promise<OperationInfiniteData<GetGroupBySlugData, GetGroupBySlugParameters>>;
        /** @summary Get Group By Slug */
        prefetchInfiniteQuery<TPageParam extends GetGroupBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupBySlugSchema, GetGroupBySlugData, GetGroupBySlugParameters, DeepReadonly<TPageParam>, GetGroupBySlugError>): Promise<void>;
        /** @summary Get Group By Slug */
        ensureInfiniteQueryData<TPageParam extends GetGroupBySlugParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupBySlugSchema, GetGroupBySlugData, GetGroupBySlugParameters, DeepReadonly<TPageParam>, GetGroupBySlugError>): Promise<OperationInfiniteData<GetGroupBySlugData, GetGroupBySlugParameters>>;
        /** @summary Get Group By Slug */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>)): GetGroupBySlugData | undefined;
        /** @summary Get Group By Slug */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>)): OperationInfiniteData<GetGroupBySlugData, GetGroupBySlugParameters> | undefined;
        /** @summary Get Group By Slug */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError> | QueryFiltersByQueryKey<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupBySlugData, GetGroupBySlugParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>,
            data: GetGroupBySlugData | undefined
        ]>;
        /** @summary Get Group By Slug */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters> | (DeepReadonly<GetGroupBySlugParameters>)): QueryState<GetGroupBySlugData, GetGroupBySlugError> | undefined;
        /** @summary Get Group By Slug */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupBySlugParameters> | ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>): QueryState<OperationInfiniteData<GetGroupBySlugData, GetGroupBySlugParameters>, GetGroupBySlugError> | undefined;
        /** @summary Get Group By Slug */
        setQueryData(parameters: (DeepReadonly<GetGroupBySlugParameters>) | ServiceOperationQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>, updater: Updater<NoInfer<GetGroupBySlugData> | undefined, NoInfer<DeepReadonly<GetGroupBySlugData>> | undefined>, options?: SetDataOptions): GetGroupBySlugData | undefined;
        /** @summary Get Group By Slug */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupBySlugParameters>) | ServiceOperationInfiniteQueryKey<GetGroupBySlugSchema, GetGroupBySlugParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupBySlugData, GetGroupBySlugParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupBySlugData, GetGroupBySlugParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupBySlugData, GetGroupBySlugParameters> | undefined;
        /** @summary Get Group By Slug */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError> | QueryFiltersByQueryKey<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>, updater: Updater<NoInfer<GetGroupBySlugData> | undefined, NoInfer<GetGroupBySlugData> | undefined>, options?: SetDataOptions): Array<GetGroupBySlugData | undefined>;
        /** @summary Get Group By Slug */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Group By Slug */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError> | QueryFiltersByQueryKey<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Group By Slug */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError> | QueryFiltersByQueryKey<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Group By Slug */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError> | QueryFiltersByQueryKey<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>): void;
        /** @summary Get Group By Slug */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError> | QueryFiltersByQueryKey<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Group By Slug */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError> | QueryFiltersByQueryKey<GetGroupBySlugSchema, GetGroupBySlugData, TInfinite, GetGroupBySlugParameters, GetGroupBySlugError>): number;
        schema: GetGroupBySlugSchema;
        types: {
            parameters: GetGroupBySlugParameters;
            data: GetGroupBySlugData;
            error: GetGroupBySlugError;
        };
    };
    /**
     * @summary Get Group Students
     * @description The group's All Students list.
     *
     * One operation serves all three student list keys and accepts the union of
     * their controls; the list key decides which of them the filter PANEL renders.
     *
     * `student_id` rather than `id`, because `id` is already this endpoint's sort
     * key and a query parameter of that name reads as the group's.
     *
     * `waiting_on` has no default. The same absent value means "every student" on
     * All Students and "any pending action" on Students Waiting, so the caller
     * sends the one it means rather than inheriting either.
     */
    getGroupStudents: {
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupStudentsParameters, TMeta, TSignal>), client?: (schema: GetGroupStudentsSchema, options: {
            parameters: GetGroupStudentsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupStudentsData, GetGroupStudentsError>>): Promise<RequestFnResponse<GetGroupStudentsData, GetGroupStudentsError>>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        getQueryKey(parameters: DeepReadonly<GetGroupStudentsParameters>): ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupStudents.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         group_tags: groupTags
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupStudentsData>(parameters: ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupStudentsData, GetGroupStudentsError, TData, ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupStudentsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupStudents.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         group_tags: groupTags
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupStudentsData>(parameters: ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>), options: Omit<DefinedInitialDataOptions<GetGroupStudentsData, GetGroupStudentsError, TData, ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupStudentsError>>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupStudentsParameters>): ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupStudents.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_tags: initialGroupTags
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupStudentsParameters, TQueryFnData = GetGroupStudentsData, TData = OperationInfiniteData<TQueryFnData, GetGroupStudentsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupStudentsError, TData, ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupStudentsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupStudents.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_tags: initialGroupTags
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupStudentsParameters, TQueryFnData = GetGroupStudentsData, TData = OperationInfiniteData<TQueryFnData, GetGroupStudentsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupStudentsError, TData, ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupStudentsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupStudentsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupStudentsTotal = qraft.v3Service.getGroupStudents.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupStudentsByParametersTotal = qraft.v3Service.getGroupStudents.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             group_tags: groupTags
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError> | QueryFiltersByQueryKey<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupStudentsResults = qraft.v3Service.getGroupStudents.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 group_tags: groupTags1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 group_tags: groupTags2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupStudentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupStudentsCombinedResults = qraft.v3Service.getGroupStudents.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 group_tags: groupTags1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 group_tags: groupTags2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupStudentsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupStudentsSchema, GetGroupStudentsParameters, GetGroupStudentsData, GetGroupStudentsError>>, TCombinedResult = Array<UseQueryResult<GetGroupStudentsData, GetGroupStudentsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupStudentsData, GetGroupStudentsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupStudents.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         group_tags: groupTags
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupStudentsData>(parameters: ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupStudentsData, GetGroupStudentsError, TData, ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupStudentsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupStudents.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_tags: initialGroupTags
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupStudentsParameters, TData = GetGroupStudentsData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupStudentsData, GetGroupStudentsError, OperationInfiniteData<TData, GetGroupStudentsParameters>, ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupStudentsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupStudentsParameters>, OperationError<GetGroupStudentsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupStudentsData = qraft.v3Service.getGroupStudents.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 group_tags: groupTags1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 group_tags: groupTags2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupStudentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupStudentsCombinedData = qraft.v3Service.getGroupStudents.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 group_tags: groupTags1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 group_tags: groupTags2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupStudentsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupStudentsSchema, GetGroupStudentsParameters, GetGroupStudentsData, GetGroupStudentsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupStudentsData, GetGroupStudentsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupStudentsData, GetGroupStudentsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupStudentsSchema, GetGroupStudentsData, GetGroupStudentsParameters, GetGroupStudentsError>): Promise<GetGroupStudentsData>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupStudentsSchema, GetGroupStudentsData, GetGroupStudentsParameters, GetGroupStudentsError>): Promise<void>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupStudentsSchema, GetGroupStudentsData, GetGroupStudentsParameters, GetGroupStudentsError>): Promise<GetGroupStudentsData>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        fetchInfiniteQuery<TPageParam extends GetGroupStudentsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupStudentsSchema, GetGroupStudentsData, GetGroupStudentsParameters, DeepReadonly<TPageParam>, GetGroupStudentsError>): Promise<OperationInfiniteData<GetGroupStudentsData, GetGroupStudentsParameters>>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        prefetchInfiniteQuery<TPageParam extends GetGroupStudentsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupStudentsSchema, GetGroupStudentsData, GetGroupStudentsParameters, DeepReadonly<TPageParam>, GetGroupStudentsError>): Promise<void>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        ensureInfiniteQueryData<TPageParam extends GetGroupStudentsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupStudentsSchema, GetGroupStudentsData, GetGroupStudentsParameters, DeepReadonly<TPageParam>, GetGroupStudentsError>): Promise<OperationInfiniteData<GetGroupStudentsData, GetGroupStudentsParameters>>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>)): GetGroupStudentsData | undefined;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>)): OperationInfiniteData<GetGroupStudentsData, GetGroupStudentsParameters> | undefined;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError> | QueryFiltersByQueryKey<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupStudentsData, GetGroupStudentsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>,
            data: GetGroupStudentsData | undefined
        ]>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters> | (DeepReadonly<GetGroupStudentsParameters>)): QueryState<GetGroupStudentsData, GetGroupStudentsError> | undefined;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupStudentsParameters> | ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>): QueryState<OperationInfiniteData<GetGroupStudentsData, GetGroupStudentsParameters>, GetGroupStudentsError> | undefined;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        setQueryData(parameters: (DeepReadonly<GetGroupStudentsParameters>) | ServiceOperationQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>, updater: Updater<NoInfer<GetGroupStudentsData> | undefined, NoInfer<DeepReadonly<GetGroupStudentsData>> | undefined>, options?: SetDataOptions): GetGroupStudentsData | undefined;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupStudentsParameters>) | ServiceOperationInfiniteQueryKey<GetGroupStudentsSchema, GetGroupStudentsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupStudentsData, GetGroupStudentsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupStudentsData, GetGroupStudentsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupStudentsData, GetGroupStudentsParameters> | undefined;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError> | QueryFiltersByQueryKey<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>, updater: Updater<NoInfer<GetGroupStudentsData> | undefined, NoInfer<GetGroupStudentsData> | undefined>, options?: SetDataOptions): Array<GetGroupStudentsData | undefined>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError> | QueryFiltersByQueryKey<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError> | QueryFiltersByQueryKey<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError> | QueryFiltersByQueryKey<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>): void;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError> | QueryFiltersByQueryKey<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Group Students
         * @description The group's All Students list.
         *
         * One operation serves all three student list keys and accepts the union of
         * their controls; the list key decides which of them the filter PANEL renders.
         *
         * `student_id` rather than `id`, because `id` is already this endpoint's sort
         * key and a query parameter of that name reads as the group's.
         *
         * `waiting_on` has no default. The same absent value means "every student" on
         * All Students and "any pending action" on Students Waiting, so the caller
         * sends the one it means rather than inheriting either.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError> | QueryFiltersByQueryKey<GetGroupStudentsSchema, GetGroupStudentsData, TInfinite, GetGroupStudentsParameters, GetGroupStudentsError>): number;
        schema: GetGroupStudentsSchema;
        types: {
            parameters: GetGroupStudentsParameters;
            data: GetGroupStudentsData;
            error: GetGroupStudentsError;
        };
    };
    /**
     * @summary Create Postal Student
     * @description Create a postal student and attach them to this study group's helper.
     *
     * The study helper is the group's, never the caller's and never client-supplied.
     * The new account has a generated, undeliverable address and no usable password.
     */
    createPostalStudent: {
        /**
         * @summary Create Postal Student
         * @description Create a postal student and attach them to this study group's helper.
         *
         * The study helper is the group's, never the caller's and never client-supplied.
         * The new account has a generated, undeliverable address and no usable password.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreatePostalStudentBody, CreatePostalStudentParameters, TMeta, TSignal>, client?: (schema: CreatePostalStudentSchema, options: ServiceOperationMutationFnOptions<CreatePostalStudentBody, CreatePostalStudentParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreatePostalStudentData, CreatePostalStudentError>>): Promise<RequestFnResponse<CreatePostalStudentData, CreatePostalStudentError>>;
        /**
         * @summary Create Postal Student
         * @description Create a postal student and attach them to this study group's helper.
         *
         * The study helper is the group's, never the caller's and never client-supplied.
         * The new account has a generated, undeliverable address and no usable password.
         */
        getMutationKey(parameters: DeepReadonly<CreatePostalStudentParameters> | void): ServiceOperationMutationKey<CreatePostalStudentSchema, CreatePostalStudentParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Postal Student
         * @description Create a postal student and attach them to this study group's helper.
         *
         * The study helper is the group's, never the caller's and never client-supplied.
         * The new account has a generated, undeliverable address and no usable password.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createPostalStudent.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createPostalStudent.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreatePostalStudentBody, TContext = unknown>(parameters: DeepReadonly<CreatePostalStudentParameters>, options?: ServiceOperationUseMutationOptions<CreatePostalStudentSchema, CreatePostalStudentData, CreatePostalStudentParameters, TVariables, OperationError<CreatePostalStudentError>, TContext>): UseMutationResult<CreatePostalStudentData, OperationError<CreatePostalStudentError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Postal Student
         * @description Create a postal student and attach them to this study group's helper.
         *
         * The study helper is the group's, never the caller's and never client-supplied.
         * The new account has a generated, undeliverable address and no usable password.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createPostalStudent.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createPostalStudent.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreatePostalStudentBody, CreatePostalStudentParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreatePostalStudentSchema, CreatePostalStudentData, CreatePostalStudentParameters, TVariables, OperationError<CreatePostalStudentError>, TContext>): UseMutationResult<CreatePostalStudentData, OperationError<CreatePostalStudentError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Postal Student
         * @description Create a postal student and attach them to this study group's helper.
         *
         * The study helper is the group's, never the caller's and never client-supplied.
         * The new account has a generated, undeliverable address and no usable password.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createPostalStudentTotal = qraft.v3Service.createPostalStudent.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createPostalStudentTotal = qraft.v3Service.createPostalStudent.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext> | MutationFiltersByMutationKey<CreatePostalStudentSchema, CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Postal Student
         * @description Create a postal student and attach them to this study group's helper.
         *
         * The study helper is the group's, never the caller's and never client-supplied.
         * The new account has a generated, undeliverable address and no usable password.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createPostalStudentPendingMutationVariables = qraft.v3Service.createPostalStudent.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createPostalStudentMutationData = qraft.v3Service.createPostalStudent.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreatePostalStudentData, OperationError<CreatePostalStudentError>, MutationVariables<CreatePostalStudentBody, CreatePostalStudentParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext> | MutationFiltersByMutationKey<CreatePostalStudentSchema, CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext>;
            select?: (mutation: Mutation<CreatePostalStudentData, OperationError<CreatePostalStudentError>, MutationVariables<CreatePostalStudentBody, CreatePostalStudentParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Postal Student
         * @description Create a postal student and attach them to this study group's helper.
         *
         * The study helper is the group's, never the caller's and never client-supplied.
         * The new account has a generated, undeliverable address and no usable password.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext> | MutationFiltersByMutationKey<CreatePostalStudentSchema, CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Postal Student
         * @description Create a postal student and attach them to this study group's helper.
         *
         * The study helper is the group's, never the caller's and never client-supplied.
         * The new account has a generated, undeliverable address and no usable password.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createPostalStudent.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createPostalStudent.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext> | MutationFiltersByMutationKey<CreatePostalStudentSchema, CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext>): Mutation<CreatePostalStudentData, CreatePostalStudentError, MutationVariables<CreatePostalStudentBody, CreatePostalStudentParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext> | MutationFiltersByMutationKey<CreatePostalStudentSchema, CreatePostalStudentBody, CreatePostalStudentData, CreatePostalStudentParameters, OperationError<CreatePostalStudentError>, TContext>): Array<Mutation<CreatePostalStudentData, CreatePostalStudentError, MutationVariables<CreatePostalStudentBody, CreatePostalStudentParameters>, TContext>>;
        };
        schema: CreatePostalStudentSchema;
        types: {
            parameters: CreatePostalStudentParameters;
            data: CreatePostalStudentData;
            error: CreatePostalStudentError;
            body: CreatePostalStudentBody;
        };
    };
    /**
     * @summary Preview Group Students Reassign
     * @description The confirm popup's contents: each submitted student beside their current
     * study helper, and whether the target may take them.
     *
     * An id outside this congregation comes back blanked and indistinguishable from
     * a nonexistent one.
     */
    previewGroupStudentsReassign: {
        /**
         * @summary Preview Group Students Reassign
         * @description The confirm popup's contents: each submitted student beside their current
         * study helper, and whether the target may take them.
         *
         * An id outside this congregation comes back blanked and indistinguishable from
         * a nonexistent one.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignParameters, TMeta, TSignal>, client?: (schema: PreviewGroupStudentsReassignSchema, options: ServiceOperationMutationFnOptions<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignParameters, TMeta, TSignal>) => Promise<RequestFnResponse<PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignError>>): Promise<RequestFnResponse<PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignError>>;
        /**
         * @summary Preview Group Students Reassign
         * @description The confirm popup's contents: each submitted student beside their current
         * study helper, and whether the target may take them.
         *
         * An id outside this congregation comes back blanked and indistinguishable from
         * a nonexistent one.
         */
        getMutationKey(parameters: DeepReadonly<PreviewGroupStudentsReassignParameters> | void): ServiceOperationMutationKey<PreviewGroupStudentsReassignSchema, PreviewGroupStudentsReassignParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Preview Group Students Reassign
         * @description The confirm popup's contents: each submitted student beside their current
         * study helper, and whether the target may take them.
         *
         * An id outside this congregation comes back blanked and indistinguishable from
         * a nonexistent one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewGroupStudentsReassign.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewGroupStudentsReassign.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends PreviewGroupStudentsReassignBody, TContext = unknown>(parameters: DeepReadonly<PreviewGroupStudentsReassignParameters>, options?: ServiceOperationUseMutationOptions<PreviewGroupStudentsReassignSchema, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, TVariables, OperationError<PreviewGroupStudentsReassignError>, TContext>): UseMutationResult<PreviewGroupStudentsReassignData, OperationError<PreviewGroupStudentsReassignError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Preview Group Students Reassign
         * @description The confirm popup's contents: each submitted student beside their current
         * study helper, and whether the target may take them.
         *
         * An id outside this congregation comes back blanked and indistinguishable from
         * a nonexistent one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewGroupStudentsReassign.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewGroupStudentsReassign.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<PreviewGroupStudentsReassignSchema, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, TVariables, OperationError<PreviewGroupStudentsReassignError>, TContext>): UseMutationResult<PreviewGroupStudentsReassignData, OperationError<PreviewGroupStudentsReassignError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Preview Group Students Reassign
         * @description The confirm popup's contents: each submitted student beside their current
         * study helper, and whether the target may take them.
         *
         * An id outside this congregation comes back blanked and indistinguishable from
         * a nonexistent one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const previewGroupStudentsReassignTotal = qraft.v3Service.previewGroupStudentsReassign.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const previewGroupStudentsReassignTotal = qraft.v3Service.previewGroupStudentsReassign.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext> | MutationFiltersByMutationKey<PreviewGroupStudentsReassignSchema, PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Preview Group Students Reassign
         * @description The confirm popup's contents: each submitted student beside their current
         * study helper, and whether the target may take them.
         *
         * An id outside this congregation comes back blanked and indistinguishable from
         * a nonexistent one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const previewGroupStudentsReassignPendingMutationVariables = qraft.v3Service.previewGroupStudentsReassign.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const previewGroupStudentsReassignMutationData = qraft.v3Service.previewGroupStudentsReassign.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<PreviewGroupStudentsReassignData, OperationError<PreviewGroupStudentsReassignError>, MutationVariables<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext> | MutationFiltersByMutationKey<PreviewGroupStudentsReassignSchema, PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext>;
            select?: (mutation: Mutation<PreviewGroupStudentsReassignData, OperationError<PreviewGroupStudentsReassignError>, MutationVariables<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Preview Group Students Reassign
         * @description The confirm popup's contents: each submitted student beside their current
         * study helper, and whether the target may take them.
         *
         * An id outside this congregation comes back blanked and indistinguishable from
         * a nonexistent one.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext> | MutationFiltersByMutationKey<PreviewGroupStudentsReassignSchema, PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Preview Group Students Reassign
         * @description The confirm popup's contents: each submitted student beside their current
         * study helper, and whether the target may take them.
         *
         * An id outside this congregation comes back blanked and indistinguishable from
         * a nonexistent one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.previewGroupStudentsReassign.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.previewGroupStudentsReassign.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext> | MutationFiltersByMutationKey<PreviewGroupStudentsReassignSchema, PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext>): Mutation<PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignError, MutationVariables<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext> | MutationFiltersByMutationKey<PreviewGroupStudentsReassignSchema, PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignParameters, OperationError<PreviewGroupStudentsReassignError>, TContext>): Array<Mutation<PreviewGroupStudentsReassignData, PreviewGroupStudentsReassignError, MutationVariables<PreviewGroupStudentsReassignBody, PreviewGroupStudentsReassignParameters>, TContext>>;
        };
        schema: PreviewGroupStudentsReassignSchema;
        types: {
            parameters: PreviewGroupStudentsReassignParameters;
            data: PreviewGroupStudentsReassignData;
            error: PreviewGroupStudentsReassignError;
            body: PreviewGroupStudentsReassignBody;
        };
    };
    /**
     * @summary Reassign Group Students
     * @description Move every eligible submitted student onto `study_helper_id`, in one
     * synchronous request, and report the skip-excluding count.
     *
     * Eligibility is re-checked here, so `skipped` may name a student the preview
     * passed.
     */
    reassignGroupStudents: {
        /**
         * @summary Reassign Group Students
         * @description Move every eligible submitted student onto `study_helper_id`, in one
         * synchronous request, and report the skip-excluding count.
         *
         * Eligibility is re-checked here, so `skipped` may name a student the preview
         * passed.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ReassignGroupStudentsBody, ReassignGroupStudentsParameters, TMeta, TSignal>, client?: (schema: ReassignGroupStudentsSchema, options: ServiceOperationMutationFnOptions<ReassignGroupStudentsBody, ReassignGroupStudentsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ReassignGroupStudentsData, ReassignGroupStudentsError>>): Promise<RequestFnResponse<ReassignGroupStudentsData, ReassignGroupStudentsError>>;
        /**
         * @summary Reassign Group Students
         * @description Move every eligible submitted student onto `study_helper_id`, in one
         * synchronous request, and report the skip-excluding count.
         *
         * Eligibility is re-checked here, so `skipped` may name a student the preview
         * passed.
         */
        getMutationKey(parameters: DeepReadonly<ReassignGroupStudentsParameters> | void): ServiceOperationMutationKey<ReassignGroupStudentsSchema, ReassignGroupStudentsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reassign Group Students
         * @description Move every eligible submitted student onto `study_helper_id`, in one
         * synchronous request, and report the skip-excluding count.
         *
         * Eligibility is re-checked here, so `skipped` may name a student the preview
         * passed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.reassignGroupStudents.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.reassignGroupStudents.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ReassignGroupStudentsBody, TContext = unknown>(parameters: DeepReadonly<ReassignGroupStudentsParameters>, options?: ServiceOperationUseMutationOptions<ReassignGroupStudentsSchema, ReassignGroupStudentsData, ReassignGroupStudentsParameters, TVariables, OperationError<ReassignGroupStudentsError>, TContext>): UseMutationResult<ReassignGroupStudentsData, OperationError<ReassignGroupStudentsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reassign Group Students
         * @description Move every eligible submitted student onto `study_helper_id`, in one
         * synchronous request, and report the skip-excluding count.
         *
         * Eligibility is re-checked here, so `skipped` may name a student the preview
         * passed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.reassignGroupStudents.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.reassignGroupStudents.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ReassignGroupStudentsBody, ReassignGroupStudentsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ReassignGroupStudentsSchema, ReassignGroupStudentsData, ReassignGroupStudentsParameters, TVariables, OperationError<ReassignGroupStudentsError>, TContext>): UseMutationResult<ReassignGroupStudentsData, OperationError<ReassignGroupStudentsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Reassign Group Students
         * @description Move every eligible submitted student onto `study_helper_id`, in one
         * synchronous request, and report the skip-excluding count.
         *
         * Eligibility is re-checked here, so `skipped` may name a student the preview
         * passed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const reassignGroupStudentsTotal = qraft.v3Service.reassignGroupStudents.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const reassignGroupStudentsTotal = qraft.v3Service.reassignGroupStudents.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext> | MutationFiltersByMutationKey<ReassignGroupStudentsSchema, ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Reassign Group Students
         * @description Move every eligible submitted student onto `study_helper_id`, in one
         * synchronous request, and report the skip-excluding count.
         *
         * Eligibility is re-checked here, so `skipped` may name a student the preview
         * passed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const reassignGroupStudentsPendingMutationVariables = qraft.v3Service.reassignGroupStudents.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const reassignGroupStudentsMutationData = qraft.v3Service.reassignGroupStudents.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ReassignGroupStudentsData, OperationError<ReassignGroupStudentsError>, MutationVariables<ReassignGroupStudentsBody, ReassignGroupStudentsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext> | MutationFiltersByMutationKey<ReassignGroupStudentsSchema, ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext>;
            select?: (mutation: Mutation<ReassignGroupStudentsData, OperationError<ReassignGroupStudentsError>, MutationVariables<ReassignGroupStudentsBody, ReassignGroupStudentsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Reassign Group Students
         * @description Move every eligible submitted student onto `study_helper_id`, in one
         * synchronous request, and report the skip-excluding count.
         *
         * Eligibility is re-checked here, so `skipped` may name a student the preview
         * passed.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext> | MutationFiltersByMutationKey<ReassignGroupStudentsSchema, ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Reassign Group Students
         * @description Move every eligible submitted student onto `study_helper_id`, in one
         * synchronous request, and report the skip-excluding count.
         *
         * Eligibility is re-checked here, so `skipped` may name a student the preview
         * passed.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.reassignGroupStudents.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.reassignGroupStudents.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext> | MutationFiltersByMutationKey<ReassignGroupStudentsSchema, ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext>): Mutation<ReassignGroupStudentsData, ReassignGroupStudentsError, MutationVariables<ReassignGroupStudentsBody, ReassignGroupStudentsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext> | MutationFiltersByMutationKey<ReassignGroupStudentsSchema, ReassignGroupStudentsBody, ReassignGroupStudentsData, ReassignGroupStudentsParameters, OperationError<ReassignGroupStudentsError>, TContext>): Array<Mutation<ReassignGroupStudentsData, ReassignGroupStudentsError, MutationVariables<ReassignGroupStudentsBody, ReassignGroupStudentsParameters>, TContext>>;
        };
        schema: ReassignGroupStudentsSchema;
        types: {
            parameters: ReassignGroupStudentsParameters;
            data: ReassignGroupStudentsData;
            error: ReassignGroupStudentsError;
            body: ReassignGroupStudentsBody;
        };
    };
    /**
     * @summary Get Group Study Helpers
     * @description The group's Members roster.
     *
     * Readable by any member of the group and by a platform admin.
     */
    getGroupStudyHelpers: {
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupStudyHelpersParameters, TMeta, TSignal>), client?: (schema: GetGroupStudyHelpersSchema, options: {
            parameters: GetGroupStudyHelpersParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupStudyHelpersData, GetGroupStudyHelpersError>>): Promise<RequestFnResponse<GetGroupStudyHelpersData, GetGroupStudyHelpersError>>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        getQueryKey(parameters: DeepReadonly<GetGroupStudyHelpersParameters>): ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupStudyHelpers.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         display_name: displayName
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupStudyHelpersData>(parameters: ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupStudyHelpersData, GetGroupStudyHelpersError, TData, ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupStudyHelpersError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupStudyHelpers.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         display_name: displayName
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupStudyHelpersData>(parameters: ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>), options: Omit<DefinedInitialDataOptions<GetGroupStudyHelpersData, GetGroupStudyHelpersError, TData, ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupStudyHelpersError>>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupStudyHelpersParameters>): ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupStudyHelpers.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             display_name: initialDisplayName
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupStudyHelpersParameters, TQueryFnData = GetGroupStudyHelpersData, TData = OperationInfiniteData<TQueryFnData, GetGroupStudyHelpersParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupStudyHelpersError, TData, ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupStudyHelpersError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupStudyHelpers.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             display_name: initialDisplayName
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupStudyHelpersParameters, TQueryFnData = GetGroupStudyHelpersData, TData = OperationInfiniteData<TQueryFnData, GetGroupStudyHelpersParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupStudyHelpersError, TData, ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupStudyHelpersData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupStudyHelpersError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupStudyHelpersTotal = qraft.v3Service.getGroupStudyHelpers.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupStudyHelpersByParametersTotal = qraft.v3Service.getGroupStudyHelpers.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             display_name: displayName
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError> | QueryFiltersByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupStudyHelpersResults = qraft.v3Service.getGroupStudyHelpers.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 display_name: displayName1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 display_name: displayName2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupStudyHelpersResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupStudyHelpersCombinedResults = qraft.v3Service.getGroupStudyHelpers.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 display_name: displayName1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 display_name: displayName2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupStudyHelpersCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters, GetGroupStudyHelpersData, GetGroupStudyHelpersError>>, TCombinedResult = Array<UseQueryResult<GetGroupStudyHelpersData, GetGroupStudyHelpersError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupStudyHelpersData, GetGroupStudyHelpersError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupStudyHelpers.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         display_name: displayName
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupStudyHelpersData>(parameters: ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupStudyHelpersData, GetGroupStudyHelpersError, TData, ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupStudyHelpersError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupStudyHelpers.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             display_name: initialDisplayName
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupStudyHelpersParameters, TData = GetGroupStudyHelpersData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupStudyHelpersData, GetGroupStudyHelpersError, OperationInfiniteData<TData, GetGroupStudyHelpersParameters>, ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupStudyHelpersData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupStudyHelpersParameters>, OperationError<GetGroupStudyHelpersError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupStudyHelpersData = qraft.v3Service.getGroupStudyHelpers.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 display_name: displayName1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 display_name: displayName2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupStudyHelpersResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupStudyHelpersCombinedData = qraft.v3Service.getGroupStudyHelpers.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 display_name: displayName1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 display_name: displayName2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupStudyHelpersCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters, GetGroupStudyHelpersData, GetGroupStudyHelpersError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupStudyHelpersData, GetGroupStudyHelpersError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupStudyHelpersData, GetGroupStudyHelpersError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>): Promise<GetGroupStudyHelpersData>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>): Promise<void>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>): Promise<GetGroupStudyHelpersData>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        fetchInfiniteQuery<TPageParam extends GetGroupStudyHelpersParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, GetGroupStudyHelpersParameters, DeepReadonly<TPageParam>, GetGroupStudyHelpersError>): Promise<OperationInfiniteData<GetGroupStudyHelpersData, GetGroupStudyHelpersParameters>>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        prefetchInfiniteQuery<TPageParam extends GetGroupStudyHelpersParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, GetGroupStudyHelpersParameters, DeepReadonly<TPageParam>, GetGroupStudyHelpersError>): Promise<void>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        ensureInfiniteQueryData<TPageParam extends GetGroupStudyHelpersParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, GetGroupStudyHelpersParameters, DeepReadonly<TPageParam>, GetGroupStudyHelpersError>): Promise<OperationInfiniteData<GetGroupStudyHelpersData, GetGroupStudyHelpersParameters>>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>)): GetGroupStudyHelpersData | undefined;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>)): OperationInfiniteData<GetGroupStudyHelpersData, GetGroupStudyHelpersParameters> | undefined;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError> | QueryFiltersByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupStudyHelpersData, GetGroupStudyHelpersParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>,
            data: GetGroupStudyHelpersData | undefined
        ]>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters> | (DeepReadonly<GetGroupStudyHelpersParameters>)): QueryState<GetGroupStudyHelpersData, GetGroupStudyHelpersError> | undefined;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupStudyHelpersParameters> | ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>): QueryState<OperationInfiniteData<GetGroupStudyHelpersData, GetGroupStudyHelpersParameters>, GetGroupStudyHelpersError> | undefined;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        setQueryData(parameters: (DeepReadonly<GetGroupStudyHelpersParameters>) | ServiceOperationQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>, updater: Updater<NoInfer<GetGroupStudyHelpersData> | undefined, NoInfer<DeepReadonly<GetGroupStudyHelpersData>> | undefined>, options?: SetDataOptions): GetGroupStudyHelpersData | undefined;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupStudyHelpersParameters>) | ServiceOperationInfiniteQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupStudyHelpersData, GetGroupStudyHelpersParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupStudyHelpersData, GetGroupStudyHelpersParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupStudyHelpersData, GetGroupStudyHelpersParameters> | undefined;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError> | QueryFiltersByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>, updater: Updater<NoInfer<GetGroupStudyHelpersData> | undefined, NoInfer<GetGroupStudyHelpersData> | undefined>, options?: SetDataOptions): Array<GetGroupStudyHelpersData | undefined>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError> | QueryFiltersByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError> | QueryFiltersByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError> | QueryFiltersByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>): void;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError> | QueryFiltersByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Group Study Helpers
         * @description The group's Members roster.
         *
         * Readable by any member of the group and by a platform admin.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError> | QueryFiltersByQueryKey<GetGroupStudyHelpersSchema, GetGroupStudyHelpersData, TInfinite, GetGroupStudyHelpersParameters, GetGroupStudyHelpersError>): number;
        schema: GetGroupStudyHelpersSchema;
        types: {
            parameters: GetGroupStudyHelpersParameters;
            data: GetGroupStudyHelpersData;
            error: GetGroupStudyHelpersError;
        };
    };
    /**
     * @summary Add Group Study Helper
     * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
     *
     * The response is the same widened roster row the `GET` serves, aggregates
     * included, so the admin page can render the row it just created without a
     * refetch.
     */
    addGroupStudyHelper: {
        /**
         * @summary Add Group Study Helper
         * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
         *
         * The response is the same widened roster row the `GET` serves, aggregates
         * included, so the admin page can render the row it just created without a
         * refetch.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AddGroupStudyHelperBody, AddGroupStudyHelperParameters, TMeta, TSignal>, client?: (schema: AddGroupStudyHelperSchema, options: ServiceOperationMutationFnOptions<AddGroupStudyHelperBody, AddGroupStudyHelperParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AddGroupStudyHelperData, AddGroupStudyHelperError>>): Promise<RequestFnResponse<AddGroupStudyHelperData, AddGroupStudyHelperError>>;
        /**
         * @summary Add Group Study Helper
         * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
         *
         * The response is the same widened roster row the `GET` serves, aggregates
         * included, so the admin page can render the row it just created without a
         * refetch.
         */
        getMutationKey(parameters: DeepReadonly<AddGroupStudyHelperParameters> | void): ServiceOperationMutationKey<AddGroupStudyHelperSchema, AddGroupStudyHelperParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Add Group Study Helper
         * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
         *
         * The response is the same widened roster row the `GET` serves, aggregates
         * included, so the admin page can render the row it just created without a
         * refetch.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.addGroupStudyHelper.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.addGroupStudyHelper.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AddGroupStudyHelperBody, TContext = unknown>(parameters: DeepReadonly<AddGroupStudyHelperParameters>, options?: ServiceOperationUseMutationOptions<AddGroupStudyHelperSchema, AddGroupStudyHelperData, AddGroupStudyHelperParameters, TVariables, OperationError<AddGroupStudyHelperError>, TContext>): UseMutationResult<AddGroupStudyHelperData, OperationError<AddGroupStudyHelperError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Add Group Study Helper
         * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
         *
         * The response is the same widened roster row the `GET` serves, aggregates
         * included, so the admin page can render the row it just created without a
         * refetch.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.addGroupStudyHelper.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.addGroupStudyHelper.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AddGroupStudyHelperBody, AddGroupStudyHelperParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AddGroupStudyHelperSchema, AddGroupStudyHelperData, AddGroupStudyHelperParameters, TVariables, OperationError<AddGroupStudyHelperError>, TContext>): UseMutationResult<AddGroupStudyHelperData, OperationError<AddGroupStudyHelperError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Add Group Study Helper
         * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
         *
         * The response is the same widened roster row the `GET` serves, aggregates
         * included, so the admin page can render the row it just created without a
         * refetch.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const addGroupStudyHelperTotal = qraft.v3Service.addGroupStudyHelper.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const addGroupStudyHelperTotal = qraft.v3Service.addGroupStudyHelper.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<AddGroupStudyHelperSchema, AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Add Group Study Helper
         * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
         *
         * The response is the same widened roster row the `GET` serves, aggregates
         * included, so the admin page can render the row it just created without a
         * refetch.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const addGroupStudyHelperPendingMutationVariables = qraft.v3Service.addGroupStudyHelper.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const addGroupStudyHelperMutationData = qraft.v3Service.addGroupStudyHelper.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AddGroupStudyHelperData, OperationError<AddGroupStudyHelperError>, MutationVariables<AddGroupStudyHelperBody, AddGroupStudyHelperParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<AddGroupStudyHelperSchema, AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext>;
            select?: (mutation: Mutation<AddGroupStudyHelperData, OperationError<AddGroupStudyHelperError>, MutationVariables<AddGroupStudyHelperBody, AddGroupStudyHelperParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Add Group Study Helper
         * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
         *
         * The response is the same widened roster row the `GET` serves, aggregates
         * included, so the admin page can render the row it just created without a
         * refetch.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<AddGroupStudyHelperSchema, AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Add Group Study Helper
         * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
         *
         * The response is the same widened roster row the `GET` serves, aggregates
         * included, so the admin page can render the row it just created without a
         * refetch.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.addGroupStudyHelper.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.addGroupStudyHelper.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<AddGroupStudyHelperSchema, AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext>): Mutation<AddGroupStudyHelperData, AddGroupStudyHelperError, MutationVariables<AddGroupStudyHelperBody, AddGroupStudyHelperParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<AddGroupStudyHelperSchema, AddGroupStudyHelperBody, AddGroupStudyHelperData, AddGroupStudyHelperParameters, OperationError<AddGroupStudyHelperError>, TContext>): Array<Mutation<AddGroupStudyHelperData, AddGroupStudyHelperError, MutationVariables<AddGroupStudyHelperBody, AddGroupStudyHelperParameters>, TContext>>;
        };
        schema: AddGroupStudyHelperSchema;
        types: {
            parameters: AddGroupStudyHelperParameters;
            data: AddGroupStudyHelperData;
            error: AddGroupStudyHelperError;
            body: AddGroupStudyHelperBody;
        };
    };
    /**
     * @summary Remove Group Study Helper
     * @description Remove a study helper from the group. Platform-admin-only.
     */
    removeGroupStudyHelper: {
        /**
         * @summary Remove Group Study Helper
         * @description Remove a study helper from the group. Platform-admin-only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperParameters, TMeta, TSignal>, client?: (schema: RemoveGroupStudyHelperSchema, options: ServiceOperationMutationFnOptions<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RemoveGroupStudyHelperData, RemoveGroupStudyHelperError>>): Promise<RequestFnResponse<RemoveGroupStudyHelperData, RemoveGroupStudyHelperError>>;
        /**
         * @summary Remove Group Study Helper
         * @description Remove a study helper from the group. Platform-admin-only.
         */
        getMutationKey(parameters: DeepReadonly<RemoveGroupStudyHelperParameters> | void): ServiceOperationMutationKey<RemoveGroupStudyHelperSchema, RemoveGroupStudyHelperParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Remove Group Study Helper
         * @description Remove a study helper from the group. Platform-admin-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.removeGroupStudyHelper.useMutation({
         *     path: {
         *         group_id: groupId,
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.removeGroupStudyHelper.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId,
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RemoveGroupStudyHelperBody, TContext = unknown>(parameters: DeepReadonly<RemoveGroupStudyHelperParameters>, options?: ServiceOperationUseMutationOptions<RemoveGroupStudyHelperSchema, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, TVariables, OperationError<RemoveGroupStudyHelperError>, TContext>): UseMutationResult<RemoveGroupStudyHelperData, OperationError<RemoveGroupStudyHelperError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Remove Group Study Helper
         * @description Remove a study helper from the group. Platform-admin-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.removeGroupStudyHelper.useMutation({
         *     path: {
         *         group_id: groupId,
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.removeGroupStudyHelper.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId,
         *         study_helper_id: studyHelperId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RemoveGroupStudyHelperSchema, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, TVariables, OperationError<RemoveGroupStudyHelperError>, TContext>): UseMutationResult<RemoveGroupStudyHelperData, OperationError<RemoveGroupStudyHelperError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Remove Group Study Helper
         * @description Remove a study helper from the group. Platform-admin-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const removeGroupStudyHelperTotal = qraft.v3Service.removeGroupStudyHelper.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const removeGroupStudyHelperTotal = qraft.v3Service.removeGroupStudyHelper.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId,
         *             study_helper_id: studyHelperId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<RemoveGroupStudyHelperSchema, RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Remove Group Study Helper
         * @description Remove a study helper from the group. Platform-admin-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const removeGroupStudyHelperPendingMutationVariables = qraft.v3Service.removeGroupStudyHelper.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const removeGroupStudyHelperMutationData = qraft.v3Service.removeGroupStudyHelper.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId,
         *                 study_helper_id: studyHelperId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RemoveGroupStudyHelperData, OperationError<RemoveGroupStudyHelperError>, MutationVariables<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<RemoveGroupStudyHelperSchema, RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext>;
            select?: (mutation: Mutation<RemoveGroupStudyHelperData, OperationError<RemoveGroupStudyHelperError>, MutationVariables<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Remove Group Study Helper
         * @description Remove a study helper from the group. Platform-admin-only.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<RemoveGroupStudyHelperSchema, RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Remove Group Study Helper
         * @description Remove a study helper from the group. Platform-admin-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.removeGroupStudyHelper.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId,
         *             study_helper_id: studyHelperId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.removeGroupStudyHelper.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<RemoveGroupStudyHelperSchema, RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext>): Mutation<RemoveGroupStudyHelperData, RemoveGroupStudyHelperError, MutationVariables<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext> | MutationFiltersByMutationKey<RemoveGroupStudyHelperSchema, RemoveGroupStudyHelperBody, RemoveGroupStudyHelperData, RemoveGroupStudyHelperParameters, OperationError<RemoveGroupStudyHelperError>, TContext>): Array<Mutation<RemoveGroupStudyHelperData, RemoveGroupStudyHelperError, MutationVariables<RemoveGroupStudyHelperBody, RemoveGroupStudyHelperParameters>, TContext>>;
        };
        schema: RemoveGroupStudyHelperSchema;
        types: {
            parameters: RemoveGroupStudyHelperParameters;
            data: RemoveGroupStudyHelperData;
            error: RemoveGroupStudyHelperError;
            body: RemoveGroupStudyHelperBody;
        };
    };
    /**
     * @summary Upload Group Avatar
     * @description Set the group's photo — one multipart POST carrying the cropped image.
     *
     * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
     * delete) with a mandatory server-side crop; the crop moved to the client,
     * which already enforces a 1:1 aspect, so the stored artifact is still square.
     *
     * The gate is a dependency, so it runs before the first `read()` and long
     * before the first `put_object`: a refused caller writes nothing to the bucket,
     * which matters because `put_object` is not transactional and a session
     * rollback would not undo it.
     */
    uploadGroupAvatar: {
        /**
         * @summary Upload Group Avatar
         * @description Set the group's photo — one multipart POST carrying the cropped image.
         *
         * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
         * delete) with a mandatory server-side crop; the crop moved to the client,
         * which already enforces a 1:1 aspect, so the stored artifact is still square.
         *
         * The gate is a dependency, so it runs before the first `read()` and long
         * before the first `put_object`: a refused caller writes nothing to the bucket,
         * which matters because `put_object` is not transactional and a session
         * rollback would not undo it.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UploadGroupAvatarBody, UploadGroupAvatarParameters, TMeta, TSignal>, client?: (schema: UploadGroupAvatarSchema, options: ServiceOperationMutationFnOptions<UploadGroupAvatarBody, UploadGroupAvatarParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UploadGroupAvatarData, UploadGroupAvatarError>>): Promise<RequestFnResponse<UploadGroupAvatarData, UploadGroupAvatarError>>;
        /**
         * @summary Upload Group Avatar
         * @description Set the group's photo — one multipart POST carrying the cropped image.
         *
         * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
         * delete) with a mandatory server-side crop; the crop moved to the client,
         * which already enforces a 1:1 aspect, so the stored artifact is still square.
         *
         * The gate is a dependency, so it runs before the first `read()` and long
         * before the first `put_object`: a refused caller writes nothing to the bucket,
         * which matters because `put_object` is not transactional and a session
         * rollback would not undo it.
         */
        getMutationKey(parameters: DeepReadonly<UploadGroupAvatarParameters> | void): ServiceOperationMutationKey<UploadGroupAvatarSchema, UploadGroupAvatarParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Upload Group Avatar
         * @description Set the group's photo — one multipart POST carrying the cropped image.
         *
         * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
         * delete) with a mandatory server-side crop; the crop moved to the client,
         * which already enforces a 1:1 aspect, so the stored artifact is still square.
         *
         * The gate is a dependency, so it runs before the first `read()` and long
         * before the first `put_object`: a refused caller writes nothing to the bucket,
         * which matters because `put_object` is not transactional and a session
         * rollback would not undo it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.uploadGroupAvatar.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.uploadGroupAvatar.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UploadGroupAvatarBody, TContext = unknown>(parameters: DeepReadonly<UploadGroupAvatarParameters>, options?: ServiceOperationUseMutationOptions<UploadGroupAvatarSchema, UploadGroupAvatarData, UploadGroupAvatarParameters, TVariables, OperationError<UploadGroupAvatarError>, TContext>): UseMutationResult<UploadGroupAvatarData, OperationError<UploadGroupAvatarError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Upload Group Avatar
         * @description Set the group's photo — one multipart POST carrying the cropped image.
         *
         * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
         * delete) with a mandatory server-side crop; the crop moved to the client,
         * which already enforces a 1:1 aspect, so the stored artifact is still square.
         *
         * The gate is a dependency, so it runs before the first `read()` and long
         * before the first `put_object`: a refused caller writes nothing to the bucket,
         * which matters because `put_object` is not transactional and a session
         * rollback would not undo it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.uploadGroupAvatar.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.uploadGroupAvatar.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UploadGroupAvatarBody, UploadGroupAvatarParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UploadGroupAvatarSchema, UploadGroupAvatarData, UploadGroupAvatarParameters, TVariables, OperationError<UploadGroupAvatarError>, TContext>): UseMutationResult<UploadGroupAvatarData, OperationError<UploadGroupAvatarError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Upload Group Avatar
         * @description Set the group's photo — one multipart POST carrying the cropped image.
         *
         * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
         * delete) with a mandatory server-side crop; the crop moved to the client,
         * which already enforces a 1:1 aspect, so the stored artifact is still square.
         *
         * The gate is a dependency, so it runs before the first `read()` and long
         * before the first `put_object`: a refused caller writes nothing to the bucket,
         * which matters because `put_object` is not transactional and a session
         * rollback would not undo it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const uploadGroupAvatarTotal = qraft.v3Service.uploadGroupAvatar.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const uploadGroupAvatarTotal = qraft.v3Service.uploadGroupAvatar.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext> | MutationFiltersByMutationKey<UploadGroupAvatarSchema, UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Upload Group Avatar
         * @description Set the group's photo — one multipart POST carrying the cropped image.
         *
         * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
         * delete) with a mandatory server-side crop; the crop moved to the client,
         * which already enforces a 1:1 aspect, so the stored artifact is still square.
         *
         * The gate is a dependency, so it runs before the first `read()` and long
         * before the first `put_object`: a refused caller writes nothing to the bucket,
         * which matters because `put_object` is not transactional and a session
         * rollback would not undo it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const uploadGroupAvatarPendingMutationVariables = qraft.v3Service.uploadGroupAvatar.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const uploadGroupAvatarMutationData = qraft.v3Service.uploadGroupAvatar.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UploadGroupAvatarData, OperationError<UploadGroupAvatarError>, MutationVariables<UploadGroupAvatarBody, UploadGroupAvatarParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext> | MutationFiltersByMutationKey<UploadGroupAvatarSchema, UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext>;
            select?: (mutation: Mutation<UploadGroupAvatarData, OperationError<UploadGroupAvatarError>, MutationVariables<UploadGroupAvatarBody, UploadGroupAvatarParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Upload Group Avatar
         * @description Set the group's photo — one multipart POST carrying the cropped image.
         *
         * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
         * delete) with a mandatory server-side crop; the crop moved to the client,
         * which already enforces a 1:1 aspect, so the stored artifact is still square.
         *
         * The gate is a dependency, so it runs before the first `read()` and long
         * before the first `put_object`: a refused caller writes nothing to the bucket,
         * which matters because `put_object` is not transactional and a session
         * rollback would not undo it.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext> | MutationFiltersByMutationKey<UploadGroupAvatarSchema, UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Upload Group Avatar
         * @description Set the group's photo — one multipart POST carrying the cropped image.
         *
         * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
         * delete) with a mandatory server-side crop; the crop moved to the client,
         * which already enforces a 1:1 aspect, so the stored artifact is still square.
         *
         * The gate is a dependency, so it runs before the first `read()` and long
         * before the first `put_object`: a refused caller writes nothing to the bucket,
         * which matters because `put_object` is not transactional and a session
         * rollback would not undo it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.uploadGroupAvatar.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.uploadGroupAvatar.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext> | MutationFiltersByMutationKey<UploadGroupAvatarSchema, UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext>): Mutation<UploadGroupAvatarData, UploadGroupAvatarError, MutationVariables<UploadGroupAvatarBody, UploadGroupAvatarParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext> | MutationFiltersByMutationKey<UploadGroupAvatarSchema, UploadGroupAvatarBody, UploadGroupAvatarData, UploadGroupAvatarParameters, OperationError<UploadGroupAvatarError>, TContext>): Array<Mutation<UploadGroupAvatarData, UploadGroupAvatarError, MutationVariables<UploadGroupAvatarBody, UploadGroupAvatarParameters>, TContext>>;
        };
        schema: UploadGroupAvatarSchema;
        types: {
            parameters: UploadGroupAvatarParameters;
            data: UploadGroupAvatarData;
            error: UploadGroupAvatarError;
            body: UploadGroupAvatarBody;
        };
    };
    /**
     * @summary Delete Group Avatar
     * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
     *
     * Idempotent rather than a 404: the UI only offers the tab when the group has a
     * photo, and a fifth status here would be one nobody reads.
     */
    deleteGroupAvatar: {
        /**
         * @summary Delete Group Avatar
         * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
         *
         * Idempotent rather than a 404: the UI only offers the tab when the group has a
         * photo, and a fifth status here would be one nobody reads.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteGroupAvatarBody, DeleteGroupAvatarParameters, TMeta, TSignal>, client?: (schema: DeleteGroupAvatarSchema, options: ServiceOperationMutationFnOptions<DeleteGroupAvatarBody, DeleteGroupAvatarParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteGroupAvatarData, DeleteGroupAvatarError>>): Promise<RequestFnResponse<DeleteGroupAvatarData, DeleteGroupAvatarError>>;
        /**
         * @summary Delete Group Avatar
         * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
         *
         * Idempotent rather than a 404: the UI only offers the tab when the group has a
         * photo, and a fifth status here would be one nobody reads.
         */
        getMutationKey(parameters: DeepReadonly<DeleteGroupAvatarParameters> | void): ServiceOperationMutationKey<DeleteGroupAvatarSchema, DeleteGroupAvatarParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Group Avatar
         * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
         *
         * Idempotent rather than a 404: the UI only offers the tab when the group has a
         * photo, and a fifth status here would be one nobody reads.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGroupAvatar.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGroupAvatar.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteGroupAvatarBody, TContext = unknown>(parameters: DeepReadonly<DeleteGroupAvatarParameters>, options?: ServiceOperationUseMutationOptions<DeleteGroupAvatarSchema, DeleteGroupAvatarData, DeleteGroupAvatarParameters, TVariables, OperationError<DeleteGroupAvatarError>, TContext>): UseMutationResult<DeleteGroupAvatarData, OperationError<DeleteGroupAvatarError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Group Avatar
         * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
         *
         * Idempotent rather than a 404: the UI only offers the tab when the group has a
         * photo, and a fifth status here would be one nobody reads.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGroupAvatar.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGroupAvatar.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteGroupAvatarBody, DeleteGroupAvatarParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteGroupAvatarSchema, DeleteGroupAvatarData, DeleteGroupAvatarParameters, TVariables, OperationError<DeleteGroupAvatarError>, TContext>): UseMutationResult<DeleteGroupAvatarData, OperationError<DeleteGroupAvatarError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Group Avatar
         * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
         *
         * Idempotent rather than a 404: the UI only offers the tab when the group has a
         * photo, and a fifth status here would be one nobody reads.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteGroupAvatarTotal = qraft.v3Service.deleteGroupAvatar.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteGroupAvatarTotal = qraft.v3Service.deleteGroupAvatar.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteGroupAvatarSchema, DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Group Avatar
         * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
         *
         * Idempotent rather than a 404: the UI only offers the tab when the group has a
         * photo, and a fifth status here would be one nobody reads.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteGroupAvatarPendingMutationVariables = qraft.v3Service.deleteGroupAvatar.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteGroupAvatarMutationData = qraft.v3Service.deleteGroupAvatar.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteGroupAvatarData, OperationError<DeleteGroupAvatarError>, MutationVariables<DeleteGroupAvatarBody, DeleteGroupAvatarParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteGroupAvatarSchema, DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext>;
            select?: (mutation: Mutation<DeleteGroupAvatarData, OperationError<DeleteGroupAvatarError>, MutationVariables<DeleteGroupAvatarBody, DeleteGroupAvatarParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete Group Avatar
         * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
         *
         * Idempotent rather than a 404: the UI only offers the tab when the group has a
         * photo, and a fifth status here would be one nobody reads.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteGroupAvatarSchema, DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Group Avatar
         * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
         *
         * Idempotent rather than a 404: the UI only offers the tab when the group has a
         * photo, and a fifth status here would be one nobody reads.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteGroupAvatar.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteGroupAvatar.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteGroupAvatarSchema, DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext>): Mutation<DeleteGroupAvatarData, DeleteGroupAvatarError, MutationVariables<DeleteGroupAvatarBody, DeleteGroupAvatarParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext> | MutationFiltersByMutationKey<DeleteGroupAvatarSchema, DeleteGroupAvatarBody, DeleteGroupAvatarData, DeleteGroupAvatarParameters, OperationError<DeleteGroupAvatarError>, TContext>): Array<Mutation<DeleteGroupAvatarData, DeleteGroupAvatarError, MutationVariables<DeleteGroupAvatarBody, DeleteGroupAvatarParameters>, TContext>>;
        };
        schema: DeleteGroupAvatarSchema;
        types: {
            parameters: DeleteGroupAvatarParameters;
            data: DeleteGroupAvatarData;
            error: DeleteGroupAvatarError;
            body: DeleteGroupAvatarBody;
        };
    };
    /**
     * @summary Create Geo Target Endpoint
     * @description Add a web-ad target to the group, subject to the 20-target cap.
     */
    createGeoTarget: {
        /**
         * @summary Create Geo Target Endpoint
         * @description Add a web-ad target to the group, subject to the 20-target cap.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateGeoTargetBody, CreateGeoTargetParameters, TMeta, TSignal>, client?: (schema: CreateGeoTargetSchema, options: ServiceOperationMutationFnOptions<CreateGeoTargetBody, CreateGeoTargetParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateGeoTargetData, CreateGeoTargetError>>): Promise<RequestFnResponse<CreateGeoTargetData, CreateGeoTargetError>>;
        /**
         * @summary Create Geo Target Endpoint
         * @description Add a web-ad target to the group, subject to the 20-target cap.
         */
        getMutationKey(parameters: DeepReadonly<CreateGeoTargetParameters> | void): ServiceOperationMutationKey<CreateGeoTargetSchema, CreateGeoTargetParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Geo Target Endpoint
         * @description Add a web-ad target to the group, subject to the 20-target cap.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGeoTarget.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGeoTarget.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateGeoTargetBody, TContext = unknown>(parameters: DeepReadonly<CreateGeoTargetParameters>, options?: ServiceOperationUseMutationOptions<CreateGeoTargetSchema, CreateGeoTargetData, CreateGeoTargetParameters, TVariables, OperationError<CreateGeoTargetError>, TContext>): UseMutationResult<CreateGeoTargetData, OperationError<CreateGeoTargetError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Geo Target Endpoint
         * @description Add a web-ad target to the group, subject to the 20-target cap.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGeoTarget.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGeoTarget.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateGeoTargetBody, CreateGeoTargetParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateGeoTargetSchema, CreateGeoTargetData, CreateGeoTargetParameters, TVariables, OperationError<CreateGeoTargetError>, TContext>): UseMutationResult<CreateGeoTargetData, OperationError<CreateGeoTargetError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Geo Target Endpoint
         * @description Add a web-ad target to the group, subject to the 20-target cap.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createGeoTargetTotal = qraft.v3Service.createGeoTarget.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createGeoTargetTotal = qraft.v3Service.createGeoTarget.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext> | MutationFiltersByMutationKey<CreateGeoTargetSchema, CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Geo Target Endpoint
         * @description Add a web-ad target to the group, subject to the 20-target cap.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createGeoTargetPendingMutationVariables = qraft.v3Service.createGeoTarget.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createGeoTargetMutationData = qraft.v3Service.createGeoTarget.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateGeoTargetData, OperationError<CreateGeoTargetError>, MutationVariables<CreateGeoTargetBody, CreateGeoTargetParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext> | MutationFiltersByMutationKey<CreateGeoTargetSchema, CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext>;
            select?: (mutation: Mutation<CreateGeoTargetData, OperationError<CreateGeoTargetError>, MutationVariables<CreateGeoTargetBody, CreateGeoTargetParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Geo Target Endpoint
         * @description Add a web-ad target to the group, subject to the 20-target cap.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext> | MutationFiltersByMutationKey<CreateGeoTargetSchema, CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Geo Target Endpoint
         * @description Add a web-ad target to the group, subject to the 20-target cap.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createGeoTarget.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createGeoTarget.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext> | MutationFiltersByMutationKey<CreateGeoTargetSchema, CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext>): Mutation<CreateGeoTargetData, CreateGeoTargetError, MutationVariables<CreateGeoTargetBody, CreateGeoTargetParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext> | MutationFiltersByMutationKey<CreateGeoTargetSchema, CreateGeoTargetBody, CreateGeoTargetData, CreateGeoTargetParameters, OperationError<CreateGeoTargetError>, TContext>): Array<Mutation<CreateGeoTargetData, CreateGeoTargetError, MutationVariables<CreateGeoTargetBody, CreateGeoTargetParameters>, TContext>>;
        };
        schema: CreateGeoTargetSchema;
        types: {
            parameters: CreateGeoTargetParameters;
            data: CreateGeoTargetData;
            error: CreateGeoTargetError;
            body: CreateGeoTargetBody;
        };
    };
    /** @summary List Group Geo Targets Endpoint */
    listGroupGeoTargets: {
        /** @summary List Group Geo Targets Endpoint */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupGeoTargetsParameters, TMeta, TSignal>), client?: (schema: ListGroupGeoTargetsSchema, options: {
            parameters: ListGroupGeoTargetsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupGeoTargetsData, ListGroupGeoTargetsError>>): Promise<RequestFnResponse<ListGroupGeoTargetsData, ListGroupGeoTargetsError>>;
        /** @summary List Group Geo Targets Endpoint */
        getQueryKey(parameters: DeepReadonly<ListGroupGeoTargetsParameters>): ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupGeoTargets.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupGeoTargetsData>(parameters: ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupGeoTargetsData, ListGroupGeoTargetsError, TData, ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupGeoTargetsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupGeoTargets.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupGeoTargetsData>(parameters: ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>), options: Omit<DefinedInitialDataOptions<ListGroupGeoTargetsData, ListGroupGeoTargetsError, TData, ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupGeoTargetsError>>;
        /** @summary List Group Geo Targets Endpoint */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupGeoTargetsParameters>): ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupGeoTargets.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupGeoTargetsParameters, TQueryFnData = ListGroupGeoTargetsData, TData = OperationInfiniteData<TQueryFnData, ListGroupGeoTargetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupGeoTargetsError, TData, ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupGeoTargetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupGeoTargets.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupGeoTargetsParameters, TQueryFnData = ListGroupGeoTargetsData, TData = OperationInfiniteData<TQueryFnData, ListGroupGeoTargetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupGeoTargetsError, TData, ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupGeoTargetsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupGeoTargetsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupGeoTargetsTotal = qraft.v3Service.listGroupGeoTargets.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupGeoTargetsByParametersTotal = qraft.v3Service.listGroupGeoTargets.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError> | QueryFiltersByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupGeoTargetsResults = qraft.v3Service.listGroupGeoTargets.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupGeoTargetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupGeoTargetsCombinedResults = qraft.v3Service.listGroupGeoTargets.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupGeoTargetsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters, ListGroupGeoTargetsData, ListGroupGeoTargetsError>>, TCombinedResult = Array<UseQueryResult<ListGroupGeoTargetsData, ListGroupGeoTargetsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupGeoTargetsData, ListGroupGeoTargetsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupGeoTargets.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupGeoTargetsData>(parameters: ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupGeoTargetsData, ListGroupGeoTargetsError, TData, ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupGeoTargetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupGeoTargets.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupGeoTargetsParameters, TData = ListGroupGeoTargetsData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupGeoTargetsData, ListGroupGeoTargetsError, OperationInfiniteData<TData, ListGroupGeoTargetsParameters>, ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupGeoTargetsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupGeoTargetsParameters>, OperationError<ListGroupGeoTargetsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Geo Targets Endpoint
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupGeoTargetsData = qraft.v3Service.listGroupGeoTargets.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupGeoTargetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupGeoTargetsCombinedData = qraft.v3Service.listGroupGeoTargets.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupGeoTargetsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters, ListGroupGeoTargetsData, ListGroupGeoTargetsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupGeoTargetsData, ListGroupGeoTargetsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupGeoTargetsData, ListGroupGeoTargetsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary List Group Geo Targets Endpoint */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>): Promise<ListGroupGeoTargetsData>;
        /** @summary List Group Geo Targets Endpoint */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>): Promise<void>;
        /** @summary List Group Geo Targets Endpoint */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>): Promise<ListGroupGeoTargetsData>;
        /** @summary List Group Geo Targets Endpoint */
        fetchInfiniteQuery<TPageParam extends ListGroupGeoTargetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, ListGroupGeoTargetsParameters, DeepReadonly<TPageParam>, ListGroupGeoTargetsError>): Promise<OperationInfiniteData<ListGroupGeoTargetsData, ListGroupGeoTargetsParameters>>;
        /** @summary List Group Geo Targets Endpoint */
        prefetchInfiniteQuery<TPageParam extends ListGroupGeoTargetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, ListGroupGeoTargetsParameters, DeepReadonly<TPageParam>, ListGroupGeoTargetsError>): Promise<void>;
        /** @summary List Group Geo Targets Endpoint */
        ensureInfiniteQueryData<TPageParam extends ListGroupGeoTargetsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, ListGroupGeoTargetsParameters, DeepReadonly<TPageParam>, ListGroupGeoTargetsError>): Promise<OperationInfiniteData<ListGroupGeoTargetsData, ListGroupGeoTargetsParameters>>;
        /** @summary List Group Geo Targets Endpoint */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>)): ListGroupGeoTargetsData | undefined;
        /** @summary List Group Geo Targets Endpoint */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>)): OperationInfiniteData<ListGroupGeoTargetsData, ListGroupGeoTargetsParameters> | undefined;
        /** @summary List Group Geo Targets Endpoint */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError> | QueryFiltersByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupGeoTargetsData, ListGroupGeoTargetsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>,
            data: ListGroupGeoTargetsData | undefined
        ]>;
        /** @summary List Group Geo Targets Endpoint */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters> | (DeepReadonly<ListGroupGeoTargetsParameters>)): QueryState<ListGroupGeoTargetsData, ListGroupGeoTargetsError> | undefined;
        /** @summary List Group Geo Targets Endpoint */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupGeoTargetsParameters> | ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>): QueryState<OperationInfiniteData<ListGroupGeoTargetsData, ListGroupGeoTargetsParameters>, ListGroupGeoTargetsError> | undefined;
        /** @summary List Group Geo Targets Endpoint */
        setQueryData(parameters: (DeepReadonly<ListGroupGeoTargetsParameters>) | ServiceOperationQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>, updater: Updater<NoInfer<ListGroupGeoTargetsData> | undefined, NoInfer<DeepReadonly<ListGroupGeoTargetsData>> | undefined>, options?: SetDataOptions): ListGroupGeoTargetsData | undefined;
        /** @summary List Group Geo Targets Endpoint */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupGeoTargetsParameters>) | ServiceOperationInfiniteQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupGeoTargetsData, ListGroupGeoTargetsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupGeoTargetsData, ListGroupGeoTargetsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupGeoTargetsData, ListGroupGeoTargetsParameters> | undefined;
        /** @summary List Group Geo Targets Endpoint */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError> | QueryFiltersByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>, updater: Updater<NoInfer<ListGroupGeoTargetsData> | undefined, NoInfer<ListGroupGeoTargetsData> | undefined>, options?: SetDataOptions): Array<ListGroupGeoTargetsData | undefined>;
        /** @summary List Group Geo Targets Endpoint */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary List Group Geo Targets Endpoint */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError> | QueryFiltersByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>, options?: RefetchOptions): Promise<void>;
        /** @summary List Group Geo Targets Endpoint */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError> | QueryFiltersByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>, options?: CancelOptions): Promise<void>;
        /** @summary List Group Geo Targets Endpoint */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError> | QueryFiltersByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>): void;
        /** @summary List Group Geo Targets Endpoint */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError> | QueryFiltersByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>, options?: ResetOptions): Promise<void>;
        /** @summary List Group Geo Targets Endpoint */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError> | QueryFiltersByQueryKey<ListGroupGeoTargetsSchema, ListGroupGeoTargetsData, TInfinite, ListGroupGeoTargetsParameters, ListGroupGeoTargetsError>): number;
        schema: ListGroupGeoTargetsSchema;
        types: {
            parameters: ListGroupGeoTargetsParameters;
            data: ListGroupGeoTargetsData;
            error: ListGroupGeoTargetsError;
        };
    };
    /**
     * @summary Update Geo Target Endpoint
     * @description Edit one of the group's web-ad targets, or activate/deactivate it.
     *
     * Absent fields are unchanged. Editing a target never re-runs matching:
     * students already matched to it stay matched.
     */
    updateGeoTarget: {
        /**
         * @summary Update Geo Target Endpoint
         * @description Edit one of the group's web-ad targets, or activate/deactivate it.
         *
         * Absent fields are unchanged. Editing a target never re-runs matching:
         * students already matched to it stay matched.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UpdateGeoTargetBody, UpdateGeoTargetParameters, TMeta, TSignal>, client?: (schema: UpdateGeoTargetSchema, options: ServiceOperationMutationFnOptions<UpdateGeoTargetBody, UpdateGeoTargetParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UpdateGeoTargetData, UpdateGeoTargetError>>): Promise<RequestFnResponse<UpdateGeoTargetData, UpdateGeoTargetError>>;
        /**
         * @summary Update Geo Target Endpoint
         * @description Edit one of the group's web-ad targets, or activate/deactivate it.
         *
         * Absent fields are unchanged. Editing a target never re-runs matching:
         * students already matched to it stay matched.
         */
        getMutationKey(parameters: DeepReadonly<UpdateGeoTargetParameters> | void): ServiceOperationMutationKey<UpdateGeoTargetSchema, UpdateGeoTargetParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Geo Target Endpoint
         * @description Edit one of the group's web-ad targets, or activate/deactivate it.
         *
         * Absent fields are unchanged. Editing a target never re-runs matching:
         * students already matched to it stay matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateGeoTarget.useMutation({
         *     path: {
         *         group_id: groupId,
         *         target_id: targetId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateGeoTarget.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId,
         *         target_id: targetId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UpdateGeoTargetBody, TContext = unknown>(parameters: DeepReadonly<UpdateGeoTargetParameters>, options?: ServiceOperationUseMutationOptions<UpdateGeoTargetSchema, UpdateGeoTargetData, UpdateGeoTargetParameters, TVariables, OperationError<UpdateGeoTargetError>, TContext>): UseMutationResult<UpdateGeoTargetData, OperationError<UpdateGeoTargetError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Geo Target Endpoint
         * @description Edit one of the group's web-ad targets, or activate/deactivate it.
         *
         * Absent fields are unchanged. Editing a target never re-runs matching:
         * students already matched to it stay matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateGeoTarget.useMutation({
         *     path: {
         *         group_id: groupId,
         *         target_id: targetId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateGeoTarget.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId,
         *         target_id: targetId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UpdateGeoTargetBody, UpdateGeoTargetParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UpdateGeoTargetSchema, UpdateGeoTargetData, UpdateGeoTargetParameters, TVariables, OperationError<UpdateGeoTargetError>, TContext>): UseMutationResult<UpdateGeoTargetData, OperationError<UpdateGeoTargetError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Update Geo Target Endpoint
         * @description Edit one of the group's web-ad targets, or activate/deactivate it.
         *
         * Absent fields are unchanged. Editing a target never re-runs matching:
         * students already matched to it stay matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const updateGeoTargetTotal = qraft.v3Service.updateGeoTarget.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const updateGeoTargetTotal = qraft.v3Service.updateGeoTarget.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId,
         *             target_id: targetId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext> | MutationFiltersByMutationKey<UpdateGeoTargetSchema, UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Update Geo Target Endpoint
         * @description Edit one of the group's web-ad targets, or activate/deactivate it.
         *
         * Absent fields are unchanged. Editing a target never re-runs matching:
         * students already matched to it stay matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const updateGeoTargetPendingMutationVariables = qraft.v3Service.updateGeoTarget.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const updateGeoTargetMutationData = qraft.v3Service.updateGeoTarget.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId,
         *                 target_id: targetId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UpdateGeoTargetData, OperationError<UpdateGeoTargetError>, MutationVariables<UpdateGeoTargetBody, UpdateGeoTargetParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext> | MutationFiltersByMutationKey<UpdateGeoTargetSchema, UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext>;
            select?: (mutation: Mutation<UpdateGeoTargetData, OperationError<UpdateGeoTargetError>, MutationVariables<UpdateGeoTargetBody, UpdateGeoTargetParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Update Geo Target Endpoint
         * @description Edit one of the group's web-ad targets, or activate/deactivate it.
         *
         * Absent fields are unchanged. Editing a target never re-runs matching:
         * students already matched to it stay matched.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext> | MutationFiltersByMutationKey<UpdateGeoTargetSchema, UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Update Geo Target Endpoint
         * @description Edit one of the group's web-ad targets, or activate/deactivate it.
         *
         * Absent fields are unchanged. Editing a target never re-runs matching:
         * students already matched to it stay matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.updateGeoTarget.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId,
         *             target_id: targetId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.updateGeoTarget.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext> | MutationFiltersByMutationKey<UpdateGeoTargetSchema, UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext>): Mutation<UpdateGeoTargetData, UpdateGeoTargetError, MutationVariables<UpdateGeoTargetBody, UpdateGeoTargetParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext> | MutationFiltersByMutationKey<UpdateGeoTargetSchema, UpdateGeoTargetBody, UpdateGeoTargetData, UpdateGeoTargetParameters, OperationError<UpdateGeoTargetError>, TContext>): Array<Mutation<UpdateGeoTargetData, UpdateGeoTargetError, MutationVariables<UpdateGeoTargetBody, UpdateGeoTargetParameters>, TContext>>;
        };
        schema: UpdateGeoTargetSchema;
        types: {
            parameters: UpdateGeoTargetParameters;
            data: UpdateGeoTargetData;
            error: UpdateGeoTargetError;
            body: UpdateGeoTargetBody;
        };
    };
    /**
     * @summary Delete Geo Target Endpoint
     * @description Soft-delete one of the group's web-ad targets and release the students it
     * matched.
     */
    deleteGeoTarget: {
        /**
         * @summary Delete Geo Target Endpoint
         * @description Soft-delete one of the group's web-ad targets and release the students it
         * matched.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteGeoTargetBody, DeleteGeoTargetParameters, TMeta, TSignal>, client?: (schema: DeleteGeoTargetSchema, options: ServiceOperationMutationFnOptions<DeleteGeoTargetBody, DeleteGeoTargetParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteGeoTargetData, DeleteGeoTargetError>>): Promise<RequestFnResponse<DeleteGeoTargetData, DeleteGeoTargetError>>;
        /**
         * @summary Delete Geo Target Endpoint
         * @description Soft-delete one of the group's web-ad targets and release the students it
         * matched.
         */
        getMutationKey(parameters: DeepReadonly<DeleteGeoTargetParameters> | void): ServiceOperationMutationKey<DeleteGeoTargetSchema, DeleteGeoTargetParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Geo Target Endpoint
         * @description Soft-delete one of the group's web-ad targets and release the students it
         * matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGeoTarget.useMutation({
         *     path: {
         *         group_id: groupId,
         *         target_id: targetId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGeoTarget.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId,
         *         target_id: targetId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteGeoTargetBody, TContext = unknown>(parameters: DeepReadonly<DeleteGeoTargetParameters>, options?: ServiceOperationUseMutationOptions<DeleteGeoTargetSchema, DeleteGeoTargetData, DeleteGeoTargetParameters, TVariables, OperationError<DeleteGeoTargetError>, TContext>): UseMutationResult<DeleteGeoTargetData, OperationError<DeleteGeoTargetError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Geo Target Endpoint
         * @description Soft-delete one of the group's web-ad targets and release the students it
         * matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGeoTarget.useMutation({
         *     path: {
         *         group_id: groupId,
         *         target_id: targetId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGeoTarget.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId,
         *         target_id: targetId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteGeoTargetBody, DeleteGeoTargetParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteGeoTargetSchema, DeleteGeoTargetData, DeleteGeoTargetParameters, TVariables, OperationError<DeleteGeoTargetError>, TContext>): UseMutationResult<DeleteGeoTargetData, OperationError<DeleteGeoTargetError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Geo Target Endpoint
         * @description Soft-delete one of the group's web-ad targets and release the students it
         * matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteGeoTargetTotal = qraft.v3Service.deleteGeoTarget.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteGeoTargetTotal = qraft.v3Service.deleteGeoTarget.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId,
         *             target_id: targetId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext> | MutationFiltersByMutationKey<DeleteGeoTargetSchema, DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Geo Target Endpoint
         * @description Soft-delete one of the group's web-ad targets and release the students it
         * matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteGeoTargetPendingMutationVariables = qraft.v3Service.deleteGeoTarget.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteGeoTargetMutationData = qraft.v3Service.deleteGeoTarget.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId,
         *                 target_id: targetId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteGeoTargetData, OperationError<DeleteGeoTargetError>, MutationVariables<DeleteGeoTargetBody, DeleteGeoTargetParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext> | MutationFiltersByMutationKey<DeleteGeoTargetSchema, DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext>;
            select?: (mutation: Mutation<DeleteGeoTargetData, OperationError<DeleteGeoTargetError>, MutationVariables<DeleteGeoTargetBody, DeleteGeoTargetParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete Geo Target Endpoint
         * @description Soft-delete one of the group's web-ad targets and release the students it
         * matched.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext> | MutationFiltersByMutationKey<DeleteGeoTargetSchema, DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Geo Target Endpoint
         * @description Soft-delete one of the group's web-ad targets and release the students it
         * matched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteGeoTarget.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId,
         *             target_id: targetId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteGeoTarget.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext> | MutationFiltersByMutationKey<DeleteGeoTargetSchema, DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext>): Mutation<DeleteGeoTargetData, DeleteGeoTargetError, MutationVariables<DeleteGeoTargetBody, DeleteGeoTargetParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext> | MutationFiltersByMutationKey<DeleteGeoTargetSchema, DeleteGeoTargetBody, DeleteGeoTargetData, DeleteGeoTargetParameters, OperationError<DeleteGeoTargetError>, TContext>): Array<Mutation<DeleteGeoTargetData, DeleteGeoTargetError, MutationVariables<DeleteGeoTargetBody, DeleteGeoTargetParameters>, TContext>>;
        };
        schema: DeleteGeoTargetSchema;
        types: {
            parameters: DeleteGeoTargetParameters;
            data: DeleteGeoTargetData;
            error: DeleteGeoTargetError;
            body: DeleteGeoTargetBody;
        };
    };
    /** @summary Get Group Pending Tasks */
    getGroupPendingTasks: {
        /** @summary Get Group Pending Tasks */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupPendingTasksParameters, TMeta, TSignal>), client?: (schema: GetGroupPendingTasksSchema, options: {
            parameters: GetGroupPendingTasksParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupPendingTasksData, GetGroupPendingTasksError>>): Promise<RequestFnResponse<GetGroupPendingTasksData, GetGroupPendingTasksError>>;
        /** @summary Get Group Pending Tasks */
        getQueryKey(parameters: DeepReadonly<GetGroupPendingTasksParameters>): ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupPendingTasks.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupPendingTasksData>(parameters: ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupPendingTasksData, GetGroupPendingTasksError, TData, ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupPendingTasksError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupPendingTasks.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupPendingTasksData>(parameters: ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>), options: Omit<DefinedInitialDataOptions<GetGroupPendingTasksData, GetGroupPendingTasksError, TData, ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupPendingTasksError>>;
        /** @summary Get Group Pending Tasks */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupPendingTasksParameters>): ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupPendingTasks.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupPendingTasksParameters, TQueryFnData = GetGroupPendingTasksData, TData = OperationInfiniteData<TQueryFnData, GetGroupPendingTasksParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupPendingTasksError, TData, ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupPendingTasksError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupPendingTasks.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupPendingTasksParameters, TQueryFnData = GetGroupPendingTasksData, TData = OperationInfiniteData<TQueryFnData, GetGroupPendingTasksParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupPendingTasksError, TData, ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupPendingTasksData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupPendingTasksError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupPendingTasksTotal = qraft.v3Service.getGroupPendingTasks.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupPendingTasksByParametersTotal = qraft.v3Service.getGroupPendingTasks.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError> | QueryFiltersByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupPendingTasksResults = qraft.v3Service.getGroupPendingTasks.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupPendingTasksResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupPendingTasksCombinedResults = qraft.v3Service.getGroupPendingTasks.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupPendingTasksCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters, GetGroupPendingTasksData, GetGroupPendingTasksError>>, TCombinedResult = Array<UseQueryResult<GetGroupPendingTasksData, GetGroupPendingTasksError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupPendingTasksData, GetGroupPendingTasksError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupPendingTasks.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupPendingTasksData>(parameters: ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupPendingTasksData, GetGroupPendingTasksError, TData, ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupPendingTasksError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupPendingTasks.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupPendingTasksParameters, TData = GetGroupPendingTasksData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupPendingTasksData, GetGroupPendingTasksError, OperationInfiniteData<TData, GetGroupPendingTasksParameters>, ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupPendingTasksData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupPendingTasksParameters>, OperationError<GetGroupPendingTasksError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Pending Tasks
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupPendingTasksData = qraft.v3Service.getGroupPendingTasks.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupPendingTasksResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupPendingTasksCombinedData = qraft.v3Service.getGroupPendingTasks.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupPendingTasksCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters, GetGroupPendingTasksData, GetGroupPendingTasksError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupPendingTasksData, GetGroupPendingTasksError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupPendingTasksData, GetGroupPendingTasksError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Group Pending Tasks */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupPendingTasksSchema, GetGroupPendingTasksData, GetGroupPendingTasksParameters, GetGroupPendingTasksError>): Promise<GetGroupPendingTasksData>;
        /** @summary Get Group Pending Tasks */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupPendingTasksSchema, GetGroupPendingTasksData, GetGroupPendingTasksParameters, GetGroupPendingTasksError>): Promise<void>;
        /** @summary Get Group Pending Tasks */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupPendingTasksSchema, GetGroupPendingTasksData, GetGroupPendingTasksParameters, GetGroupPendingTasksError>): Promise<GetGroupPendingTasksData>;
        /** @summary Get Group Pending Tasks */
        fetchInfiniteQuery<TPageParam extends GetGroupPendingTasksParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupPendingTasksSchema, GetGroupPendingTasksData, GetGroupPendingTasksParameters, DeepReadonly<TPageParam>, GetGroupPendingTasksError>): Promise<OperationInfiniteData<GetGroupPendingTasksData, GetGroupPendingTasksParameters>>;
        /** @summary Get Group Pending Tasks */
        prefetchInfiniteQuery<TPageParam extends GetGroupPendingTasksParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupPendingTasksSchema, GetGroupPendingTasksData, GetGroupPendingTasksParameters, DeepReadonly<TPageParam>, GetGroupPendingTasksError>): Promise<void>;
        /** @summary Get Group Pending Tasks */
        ensureInfiniteQueryData<TPageParam extends GetGroupPendingTasksParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupPendingTasksSchema, GetGroupPendingTasksData, GetGroupPendingTasksParameters, DeepReadonly<TPageParam>, GetGroupPendingTasksError>): Promise<OperationInfiniteData<GetGroupPendingTasksData, GetGroupPendingTasksParameters>>;
        /** @summary Get Group Pending Tasks */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>)): GetGroupPendingTasksData | undefined;
        /** @summary Get Group Pending Tasks */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>)): OperationInfiniteData<GetGroupPendingTasksData, GetGroupPendingTasksParameters> | undefined;
        /** @summary Get Group Pending Tasks */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError> | QueryFiltersByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupPendingTasksData, GetGroupPendingTasksParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>,
            data: GetGroupPendingTasksData | undefined
        ]>;
        /** @summary Get Group Pending Tasks */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters> | (DeepReadonly<GetGroupPendingTasksParameters>)): QueryState<GetGroupPendingTasksData, GetGroupPendingTasksError> | undefined;
        /** @summary Get Group Pending Tasks */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupPendingTasksParameters> | ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>): QueryState<OperationInfiniteData<GetGroupPendingTasksData, GetGroupPendingTasksParameters>, GetGroupPendingTasksError> | undefined;
        /** @summary Get Group Pending Tasks */
        setQueryData(parameters: (DeepReadonly<GetGroupPendingTasksParameters>) | ServiceOperationQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>, updater: Updater<NoInfer<GetGroupPendingTasksData> | undefined, NoInfer<DeepReadonly<GetGroupPendingTasksData>> | undefined>, options?: SetDataOptions): GetGroupPendingTasksData | undefined;
        /** @summary Get Group Pending Tasks */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupPendingTasksParameters>) | ServiceOperationInfiniteQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupPendingTasksData, GetGroupPendingTasksParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupPendingTasksData, GetGroupPendingTasksParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupPendingTasksData, GetGroupPendingTasksParameters> | undefined;
        /** @summary Get Group Pending Tasks */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError> | QueryFiltersByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>, updater: Updater<NoInfer<GetGroupPendingTasksData> | undefined, NoInfer<GetGroupPendingTasksData> | undefined>, options?: SetDataOptions): Array<GetGroupPendingTasksData | undefined>;
        /** @summary Get Group Pending Tasks */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Group Pending Tasks */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError> | QueryFiltersByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Group Pending Tasks */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError> | QueryFiltersByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Group Pending Tasks */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError> | QueryFiltersByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>): void;
        /** @summary Get Group Pending Tasks */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError> | QueryFiltersByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Group Pending Tasks */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError> | QueryFiltersByQueryKey<GetGroupPendingTasksSchema, GetGroupPendingTasksData, TInfinite, GetGroupPendingTasksParameters, GetGroupPendingTasksError>): number;
        schema: GetGroupPendingTasksSchema;
        types: {
            parameters: GetGroupPendingTasksParameters;
            data: GetGroupPendingTasksData;
            error: GetGroupPendingTasksError;
        };
    };
    /**
     * @summary List Group Member Tags
     * @description The group's tags with a three-member preview each.
     *
     * The screen has no pager, so callers should pass `limit: 50`.
     */
    listGroupMemberTags: {
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupMemberTagsParameters, TMeta, TSignal>), client?: (schema: ListGroupMemberTagsSchema, options: {
            parameters: ListGroupMemberTagsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupMemberTagsData, ListGroupMemberTagsError>>): Promise<RequestFnResponse<ListGroupMemberTagsData, ListGroupMemberTagsError>>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupMemberTagsParameters>): ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupMemberTags.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupMemberTagsData>(parameters: ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupMemberTagsData, ListGroupMemberTagsError, TData, ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupMemberTagsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupMemberTags.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupMemberTagsData>(parameters: ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>), options: Omit<DefinedInitialDataOptions<ListGroupMemberTagsData, ListGroupMemberTagsError, TData, ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupMemberTagsError>>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupMemberTagsParameters>): ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupMemberTags.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupMemberTagsParameters, TQueryFnData = ListGroupMemberTagsData, TData = OperationInfiniteData<TQueryFnData, ListGroupMemberTagsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupMemberTagsError, TData, ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupMemberTagsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupMemberTags.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupMemberTagsParameters, TQueryFnData = ListGroupMemberTagsData, TData = OperationInfiniteData<TQueryFnData, ListGroupMemberTagsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupMemberTagsError, TData, ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupMemberTagsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupMemberTagsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupMemberTagsTotal = qraft.v3Service.listGroupMemberTags.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupMemberTagsByParametersTotal = qraft.v3Service.listGroupMemberTags.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError> | QueryFiltersByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupMemberTagsResults = qraft.v3Service.listGroupMemberTags.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupMemberTagsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupMemberTagsCombinedResults = qraft.v3Service.listGroupMemberTags.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupMemberTagsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters, ListGroupMemberTagsData, ListGroupMemberTagsError>>, TCombinedResult = Array<UseQueryResult<ListGroupMemberTagsData, ListGroupMemberTagsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupMemberTagsData, ListGroupMemberTagsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupMemberTags.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupMemberTagsData>(parameters: ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupMemberTagsData, ListGroupMemberTagsError, TData, ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupMemberTagsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupMemberTags.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupMemberTagsParameters, TData = ListGroupMemberTagsData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupMemberTagsData, ListGroupMemberTagsError, OperationInfiniteData<TData, ListGroupMemberTagsParameters>, ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupMemberTagsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupMemberTagsParameters>, OperationError<ListGroupMemberTagsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupMemberTagsData = qraft.v3Service.listGroupMemberTags.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupMemberTagsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupMemberTagsCombinedData = qraft.v3Service.listGroupMemberTags.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupMemberTagsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters, ListGroupMemberTagsData, ListGroupMemberTagsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupMemberTagsData, ListGroupMemberTagsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupMemberTagsData, ListGroupMemberTagsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupMemberTagsSchema, ListGroupMemberTagsData, ListGroupMemberTagsParameters, ListGroupMemberTagsError>): Promise<ListGroupMemberTagsData>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupMemberTagsSchema, ListGroupMemberTagsData, ListGroupMemberTagsParameters, ListGroupMemberTagsError>): Promise<void>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupMemberTagsSchema, ListGroupMemberTagsData, ListGroupMemberTagsParameters, ListGroupMemberTagsError>): Promise<ListGroupMemberTagsData>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupMemberTagsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupMemberTagsSchema, ListGroupMemberTagsData, ListGroupMemberTagsParameters, DeepReadonly<TPageParam>, ListGroupMemberTagsError>): Promise<OperationInfiniteData<ListGroupMemberTagsData, ListGroupMemberTagsParameters>>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupMemberTagsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupMemberTagsSchema, ListGroupMemberTagsData, ListGroupMemberTagsParameters, DeepReadonly<TPageParam>, ListGroupMemberTagsError>): Promise<void>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupMemberTagsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupMemberTagsSchema, ListGroupMemberTagsData, ListGroupMemberTagsParameters, DeepReadonly<TPageParam>, ListGroupMemberTagsError>): Promise<OperationInfiniteData<ListGroupMemberTagsData, ListGroupMemberTagsParameters>>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>)): ListGroupMemberTagsData | undefined;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>)): OperationInfiniteData<ListGroupMemberTagsData, ListGroupMemberTagsParameters> | undefined;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError> | QueryFiltersByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupMemberTagsData, ListGroupMemberTagsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>,
            data: ListGroupMemberTagsData | undefined
        ]>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters> | (DeepReadonly<ListGroupMemberTagsParameters>)): QueryState<ListGroupMemberTagsData, ListGroupMemberTagsError> | undefined;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupMemberTagsParameters> | ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>): QueryState<OperationInfiniteData<ListGroupMemberTagsData, ListGroupMemberTagsParameters>, ListGroupMemberTagsError> | undefined;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupMemberTagsParameters>) | ServiceOperationQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>, updater: Updater<NoInfer<ListGroupMemberTagsData> | undefined, NoInfer<DeepReadonly<ListGroupMemberTagsData>> | undefined>, options?: SetDataOptions): ListGroupMemberTagsData | undefined;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupMemberTagsParameters>) | ServiceOperationInfiniteQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupMemberTagsData, ListGroupMemberTagsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupMemberTagsData, ListGroupMemberTagsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupMemberTagsData, ListGroupMemberTagsParameters> | undefined;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError> | QueryFiltersByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>, updater: Updater<NoInfer<ListGroupMemberTagsData> | undefined, NoInfer<ListGroupMemberTagsData> | undefined>, options?: SetDataOptions): Array<ListGroupMemberTagsData | undefined>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError> | QueryFiltersByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError> | QueryFiltersByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError> | QueryFiltersByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>): void;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError> | QueryFiltersByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Member Tags
         * @description The group's tags with a three-member preview each.
         *
         * The screen has no pager, so callers should pass `limit: 50`.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError> | QueryFiltersByQueryKey<ListGroupMemberTagsSchema, ListGroupMemberTagsData, TInfinite, ListGroupMemberTagsParameters, ListGroupMemberTagsError>): number;
        schema: ListGroupMemberTagsSchema;
        types: {
            parameters: ListGroupMemberTagsParameters;
            data: ListGroupMemberTagsData;
            error: ListGroupMemberTagsError;
        };
    };
    /** @summary Create Group Member Tag */
    createGroupMemberTag: {
        /** @summary Create Group Member Tag */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateGroupMemberTagBody, CreateGroupMemberTagParameters, TMeta, TSignal>, client?: (schema: CreateGroupMemberTagSchema, options: ServiceOperationMutationFnOptions<CreateGroupMemberTagBody, CreateGroupMemberTagParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateGroupMemberTagData, CreateGroupMemberTagError>>): Promise<RequestFnResponse<CreateGroupMemberTagData, CreateGroupMemberTagError>>;
        /** @summary Create Group Member Tag */
        getMutationKey(parameters: DeepReadonly<CreateGroupMemberTagParameters> | void): ServiceOperationMutationKey<CreateGroupMemberTagSchema, CreateGroupMemberTagParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupMemberTag.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupMemberTag.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateGroupMemberTagBody, TContext = unknown>(parameters: DeepReadonly<CreateGroupMemberTagParameters>, options?: ServiceOperationUseMutationOptions<CreateGroupMemberTagSchema, CreateGroupMemberTagData, CreateGroupMemberTagParameters, TVariables, OperationError<CreateGroupMemberTagError>, TContext>): UseMutationResult<CreateGroupMemberTagData, OperationError<CreateGroupMemberTagError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupMemberTag.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupMemberTag.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateGroupMemberTagBody, CreateGroupMemberTagParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateGroupMemberTagSchema, CreateGroupMemberTagData, CreateGroupMemberTagParameters, TVariables, OperationError<CreateGroupMemberTagError>, TContext>): UseMutationResult<CreateGroupMemberTagData, OperationError<CreateGroupMemberTagError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createGroupMemberTagTotal = qraft.v3Service.createGroupMemberTag.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createGroupMemberTagTotal = qraft.v3Service.createGroupMemberTag.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<CreateGroupMemberTagSchema, CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createGroupMemberTagPendingMutationVariables = qraft.v3Service.createGroupMemberTag.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createGroupMemberTagMutationData = qraft.v3Service.createGroupMemberTag.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateGroupMemberTagData, OperationError<CreateGroupMemberTagError>, MutationVariables<CreateGroupMemberTagBody, CreateGroupMemberTagParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<CreateGroupMemberTagSchema, CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext>;
            select?: (mutation: Mutation<CreateGroupMemberTagData, OperationError<CreateGroupMemberTagError>, MutationVariables<CreateGroupMemberTagBody, CreateGroupMemberTagParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Create Group Member Tag */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<CreateGroupMemberTagSchema, CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createGroupMemberTag.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createGroupMemberTag.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<CreateGroupMemberTagSchema, CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext>): Mutation<CreateGroupMemberTagData, CreateGroupMemberTagError, MutationVariables<CreateGroupMemberTagBody, CreateGroupMemberTagParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<CreateGroupMemberTagSchema, CreateGroupMemberTagBody, CreateGroupMemberTagData, CreateGroupMemberTagParameters, OperationError<CreateGroupMemberTagError>, TContext>): Array<Mutation<CreateGroupMemberTagData, CreateGroupMemberTagError, MutationVariables<CreateGroupMemberTagBody, CreateGroupMemberTagParameters>, TContext>>;
        };
        schema: CreateGroupMemberTagSchema;
        types: {
            parameters: CreateGroupMemberTagParameters;
            data: CreateGroupMemberTagData;
            error: CreateGroupMemberTagError;
            body: CreateGroupMemberTagBody;
        };
    };
    /**
     * @summary Get Group Member Tag
     * @description One tag with its full in-group member set, which the edit form preselects.
     *
     * Unpaginated, as in legacy; bounded by the group's roster.
     */
    getGroupMemberTag: {
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupMemberTagParameters, TMeta, TSignal>), client?: (schema: GetGroupMemberTagSchema, options: {
            parameters: GetGroupMemberTagParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupMemberTagData, GetGroupMemberTagError>>): Promise<RequestFnResponse<GetGroupMemberTagData, GetGroupMemberTagError>>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        getQueryKey(parameters: DeepReadonly<GetGroupMemberTagParameters>): ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupMemberTag.useQuery({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupMemberTagData>(parameters: ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupMemberTagData, GetGroupMemberTagError, TData, ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupMemberTagError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupMemberTag.useQuery({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupMemberTagData>(parameters: ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>), options: Omit<DefinedInitialDataOptions<GetGroupMemberTagData, GetGroupMemberTagError, TData, ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupMemberTagError>>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupMemberTagParameters>): ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupMemberTag.useInfiniteQuery({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupMemberTagParameters, TQueryFnData = GetGroupMemberTagData, TData = OperationInfiniteData<TQueryFnData, GetGroupMemberTagParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupMemberTagError, TData, ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupMemberTagError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupMemberTag.useInfiniteQuery({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupMemberTagParameters, TQueryFnData = GetGroupMemberTagData, TData = OperationInfiniteData<TQueryFnData, GetGroupMemberTagParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupMemberTagError, TData, ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupMemberTagData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupMemberTagError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupMemberTagTotal = qraft.v3Service.getGroupMemberTag.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupMemberTagByParametersTotal = qraft.v3Service.getGroupMemberTag.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             tag_id: tagId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError> | QueryFiltersByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupMemberTagResults = qraft.v3Service.getGroupMemberTag.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 tag_id: tagId1,
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 tag_id: tagId2,
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupMemberTagResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupMemberTagCombinedResults = qraft.v3Service.getGroupMemberTag.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 tag_id: tagId1,
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 tag_id: tagId2,
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupMemberTagCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupMemberTagSchema, GetGroupMemberTagParameters, GetGroupMemberTagData, GetGroupMemberTagError>>, TCombinedResult = Array<UseQueryResult<GetGroupMemberTagData, GetGroupMemberTagError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupMemberTagData, GetGroupMemberTagError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupMemberTag.useSuspenseQuery({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupMemberTagData>(parameters: ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupMemberTagData, GetGroupMemberTagError, TData, ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupMemberTagError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupMemberTag.useSuspenseInfiniteQuery({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupMemberTagParameters, TData = GetGroupMemberTagData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupMemberTagData, GetGroupMemberTagError, OperationInfiniteData<TData, GetGroupMemberTagParameters>, ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupMemberTagData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupMemberTagParameters>, OperationError<GetGroupMemberTagError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupMemberTagData = qraft.v3Service.getGroupMemberTag.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 tag_id: tagId1,
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 tag_id: tagId2,
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupMemberTagResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupMemberTagCombinedData = qraft.v3Service.getGroupMemberTag.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 tag_id: tagId1,
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 tag_id: tagId2,
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupMemberTagCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupMemberTagSchema, GetGroupMemberTagParameters, GetGroupMemberTagData, GetGroupMemberTagError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupMemberTagData, GetGroupMemberTagError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupMemberTagData, GetGroupMemberTagError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupMemberTagSchema, GetGroupMemberTagData, GetGroupMemberTagParameters, GetGroupMemberTagError>): Promise<GetGroupMemberTagData>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupMemberTagSchema, GetGroupMemberTagData, GetGroupMemberTagParameters, GetGroupMemberTagError>): Promise<void>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupMemberTagSchema, GetGroupMemberTagData, GetGroupMemberTagParameters, GetGroupMemberTagError>): Promise<GetGroupMemberTagData>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        fetchInfiniteQuery<TPageParam extends GetGroupMemberTagParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupMemberTagSchema, GetGroupMemberTagData, GetGroupMemberTagParameters, DeepReadonly<TPageParam>, GetGroupMemberTagError>): Promise<OperationInfiniteData<GetGroupMemberTagData, GetGroupMemberTagParameters>>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        prefetchInfiniteQuery<TPageParam extends GetGroupMemberTagParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupMemberTagSchema, GetGroupMemberTagData, GetGroupMemberTagParameters, DeepReadonly<TPageParam>, GetGroupMemberTagError>): Promise<void>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        ensureInfiniteQueryData<TPageParam extends GetGroupMemberTagParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupMemberTagSchema, GetGroupMemberTagData, GetGroupMemberTagParameters, DeepReadonly<TPageParam>, GetGroupMemberTagError>): Promise<OperationInfiniteData<GetGroupMemberTagData, GetGroupMemberTagParameters>>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>)): GetGroupMemberTagData | undefined;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>)): OperationInfiniteData<GetGroupMemberTagData, GetGroupMemberTagParameters> | undefined;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError> | QueryFiltersByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupMemberTagData, GetGroupMemberTagParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>,
            data: GetGroupMemberTagData | undefined
        ]>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters> | (DeepReadonly<GetGroupMemberTagParameters>)): QueryState<GetGroupMemberTagData, GetGroupMemberTagError> | undefined;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupMemberTagParameters> | ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>): QueryState<OperationInfiniteData<GetGroupMemberTagData, GetGroupMemberTagParameters>, GetGroupMemberTagError> | undefined;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        setQueryData(parameters: (DeepReadonly<GetGroupMemberTagParameters>) | ServiceOperationQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>, updater: Updater<NoInfer<GetGroupMemberTagData> | undefined, NoInfer<DeepReadonly<GetGroupMemberTagData>> | undefined>, options?: SetDataOptions): GetGroupMemberTagData | undefined;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupMemberTagParameters>) | ServiceOperationInfiniteQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupMemberTagData, GetGroupMemberTagParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupMemberTagData, GetGroupMemberTagParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupMemberTagData, GetGroupMemberTagParameters> | undefined;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError> | QueryFiltersByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>, updater: Updater<NoInfer<GetGroupMemberTagData> | undefined, NoInfer<GetGroupMemberTagData> | undefined>, options?: SetDataOptions): Array<GetGroupMemberTagData | undefined>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError> | QueryFiltersByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError> | QueryFiltersByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError> | QueryFiltersByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>): void;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError> | QueryFiltersByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Group Member Tag
         * @description One tag with its full in-group member set, which the edit form preselects.
         *
         * Unpaginated, as in legacy; bounded by the group's roster.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError> | QueryFiltersByQueryKey<GetGroupMemberTagSchema, GetGroupMemberTagData, TInfinite, GetGroupMemberTagParameters, GetGroupMemberTagError>): number;
        schema: GetGroupMemberTagSchema;
        types: {
            parameters: GetGroupMemberTagParameters;
            data: GetGroupMemberTagData;
            error: GetGroupMemberTagError;
        };
    };
    /**
     * @summary Update Group Member Tag
     * @description PUT, not PATCH: the member set is replaced, not merged.
     */
    updateGroupMemberTag: {
        /**
         * @summary Update Group Member Tag
         * @description PUT, not PATCH: the member set is replaced, not merged.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UpdateGroupMemberTagBody, UpdateGroupMemberTagParameters, TMeta, TSignal>, client?: (schema: UpdateGroupMemberTagSchema, options: ServiceOperationMutationFnOptions<UpdateGroupMemberTagBody, UpdateGroupMemberTagParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UpdateGroupMemberTagData, UpdateGroupMemberTagError>>): Promise<RequestFnResponse<UpdateGroupMemberTagData, UpdateGroupMemberTagError>>;
        /**
         * @summary Update Group Member Tag
         * @description PUT, not PATCH: the member set is replaced, not merged.
         */
        getMutationKey(parameters: DeepReadonly<UpdateGroupMemberTagParameters> | void): ServiceOperationMutationKey<UpdateGroupMemberTagSchema, UpdateGroupMemberTagParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Group Member Tag
         * @description PUT, not PATCH: the member set is replaced, not merged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateGroupMemberTag.useMutation({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateGroupMemberTag.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UpdateGroupMemberTagBody, TContext = unknown>(parameters: DeepReadonly<UpdateGroupMemberTagParameters>, options?: ServiceOperationUseMutationOptions<UpdateGroupMemberTagSchema, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, TVariables, OperationError<UpdateGroupMemberTagError>, TContext>): UseMutationResult<UpdateGroupMemberTagData, OperationError<UpdateGroupMemberTagError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Group Member Tag
         * @description PUT, not PATCH: the member set is replaced, not merged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateGroupMemberTag.useMutation({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateGroupMemberTag.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UpdateGroupMemberTagBody, UpdateGroupMemberTagParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UpdateGroupMemberTagSchema, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, TVariables, OperationError<UpdateGroupMemberTagError>, TContext>): UseMutationResult<UpdateGroupMemberTagData, OperationError<UpdateGroupMemberTagError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Update Group Member Tag
         * @description PUT, not PATCH: the member set is replaced, not merged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const updateGroupMemberTagTotal = qraft.v3Service.updateGroupMemberTag.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const updateGroupMemberTagTotal = qraft.v3Service.updateGroupMemberTag.useIsMutating({
         *     parameters: {
         *         path: {
         *             tag_id: tagId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<UpdateGroupMemberTagSchema, UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Update Group Member Tag
         * @description PUT, not PATCH: the member set is replaced, not merged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const updateGroupMemberTagPendingMutationVariables = qraft.v3Service.updateGroupMemberTag.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const updateGroupMemberTagMutationData = qraft.v3Service.updateGroupMemberTag.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 tag_id: tagId,
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UpdateGroupMemberTagData, OperationError<UpdateGroupMemberTagError>, MutationVariables<UpdateGroupMemberTagBody, UpdateGroupMemberTagParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<UpdateGroupMemberTagSchema, UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext>;
            select?: (mutation: Mutation<UpdateGroupMemberTagData, OperationError<UpdateGroupMemberTagError>, MutationVariables<UpdateGroupMemberTagBody, UpdateGroupMemberTagParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Update Group Member Tag
         * @description PUT, not PATCH: the member set is replaced, not merged.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<UpdateGroupMemberTagSchema, UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Update Group Member Tag
         * @description PUT, not PATCH: the member set is replaced, not merged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.updateGroupMemberTag.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             tag_id: tagId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.updateGroupMemberTag.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<UpdateGroupMemberTagSchema, UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext>): Mutation<UpdateGroupMemberTagData, UpdateGroupMemberTagError, MutationVariables<UpdateGroupMemberTagBody, UpdateGroupMemberTagParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<UpdateGroupMemberTagSchema, UpdateGroupMemberTagBody, UpdateGroupMemberTagData, UpdateGroupMemberTagParameters, OperationError<UpdateGroupMemberTagError>, TContext>): Array<Mutation<UpdateGroupMemberTagData, UpdateGroupMemberTagError, MutationVariables<UpdateGroupMemberTagBody, UpdateGroupMemberTagParameters>, TContext>>;
        };
        schema: UpdateGroupMemberTagSchema;
        types: {
            parameters: UpdateGroupMemberTagParameters;
            data: UpdateGroupMemberTagData;
            error: UpdateGroupMemberTagError;
            body: UpdateGroupMemberTagBody;
        };
    };
    /** @summary Delete Group Member Tag */
    deleteGroupMemberTag: {
        /** @summary Delete Group Member Tag */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteGroupMemberTagBody, DeleteGroupMemberTagParameters, TMeta, TSignal>, client?: (schema: DeleteGroupMemberTagSchema, options: ServiceOperationMutationFnOptions<DeleteGroupMemberTagBody, DeleteGroupMemberTagParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteGroupMemberTagData, DeleteGroupMemberTagError>>): Promise<RequestFnResponse<DeleteGroupMemberTagData, DeleteGroupMemberTagError>>;
        /** @summary Delete Group Member Tag */
        getMutationKey(parameters: DeepReadonly<DeleteGroupMemberTagParameters> | void): ServiceOperationMutationKey<DeleteGroupMemberTagSchema, DeleteGroupMemberTagParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGroupMemberTag.useMutation({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGroupMemberTag.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteGroupMemberTagBody, TContext = unknown>(parameters: DeepReadonly<DeleteGroupMemberTagParameters>, options?: ServiceOperationUseMutationOptions<DeleteGroupMemberTagSchema, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, TVariables, OperationError<DeleteGroupMemberTagError>, TContext>): UseMutationResult<DeleteGroupMemberTagData, OperationError<DeleteGroupMemberTagError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGroupMemberTag.useMutation({
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteGroupMemberTag.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         tag_id: tagId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteGroupMemberTagBody, DeleteGroupMemberTagParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteGroupMemberTagSchema, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, TVariables, OperationError<DeleteGroupMemberTagError>, TContext>): UseMutationResult<DeleteGroupMemberTagData, OperationError<DeleteGroupMemberTagError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteGroupMemberTagTotal = qraft.v3Service.deleteGroupMemberTag.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteGroupMemberTagTotal = qraft.v3Service.deleteGroupMemberTag.useIsMutating({
         *     parameters: {
         *         path: {
         *             tag_id: tagId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<DeleteGroupMemberTagSchema, DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteGroupMemberTagPendingMutationVariables = qraft.v3Service.deleteGroupMemberTag.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteGroupMemberTagMutationData = qraft.v3Service.deleteGroupMemberTag.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 tag_id: tagId,
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteGroupMemberTagData, OperationError<DeleteGroupMemberTagError>, MutationVariables<DeleteGroupMemberTagBody, DeleteGroupMemberTagParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<DeleteGroupMemberTagSchema, DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext>;
            select?: (mutation: Mutation<DeleteGroupMemberTagData, OperationError<DeleteGroupMemberTagError>, MutationVariables<DeleteGroupMemberTagBody, DeleteGroupMemberTagParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Delete Group Member Tag */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<DeleteGroupMemberTagSchema, DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Group Member Tag
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteGroupMemberTag.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             tag_id: tagId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteGroupMemberTag.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<DeleteGroupMemberTagSchema, DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext>): Mutation<DeleteGroupMemberTagData, DeleteGroupMemberTagError, MutationVariables<DeleteGroupMemberTagBody, DeleteGroupMemberTagParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext> | MutationFiltersByMutationKey<DeleteGroupMemberTagSchema, DeleteGroupMemberTagBody, DeleteGroupMemberTagData, DeleteGroupMemberTagParameters, OperationError<DeleteGroupMemberTagError>, TContext>): Array<Mutation<DeleteGroupMemberTagData, DeleteGroupMemberTagError, MutationVariables<DeleteGroupMemberTagBody, DeleteGroupMemberTagParameters>, TContext>>;
        };
        schema: DeleteGroupMemberTagSchema;
        types: {
            parameters: DeleteGroupMemberTagParameters;
            data: DeleteGroupMemberTagData;
            error: DeleteGroupMemberTagError;
            body: DeleteGroupMemberTagBody;
        };
    };
    /**
     * @summary Set Student Member Tags
     * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
     *
     * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
     * Student` the 400 below, which folds "no such student" into "not in this group" as
     * legacy does.
     *
     * The permission check runs first, as a dependency. Legacy ran it last, which told a
     * non-admin whether someone was a member.
     */
    setStudentMemberTags: {
        /**
         * @summary Set Student Member Tags
         * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
         *
         * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
         * Student` the 400 below, which folds "no such student" into "not in this group" as
         * legacy does.
         *
         * The permission check runs first, as a dependency. Legacy ran it last, which told a
         * non-admin whether someone was a member.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetStudentMemberTagsBody, SetStudentMemberTagsParameters, TMeta, TSignal>, client?: (schema: SetStudentMemberTagsSchema, options: ServiceOperationMutationFnOptions<SetStudentMemberTagsBody, SetStudentMemberTagsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetStudentMemberTagsData, SetStudentMemberTagsError>>): Promise<RequestFnResponse<SetStudentMemberTagsData, SetStudentMemberTagsError>>;
        /**
         * @summary Set Student Member Tags
         * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
         *
         * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
         * Student` the 400 below, which folds "no such student" into "not in this group" as
         * legacy does.
         *
         * The permission check runs first, as a dependency. Legacy ran it last, which told a
         * non-admin whether someone was a member.
         */
        getMutationKey(parameters: DeepReadonly<SetStudentMemberTagsParameters> | void): ServiceOperationMutationKey<SetStudentMemberTagsSchema, SetStudentMemberTagsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Student Member Tags
         * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
         *
         * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
         * Student` the 400 below, which folds "no such student" into "not in this group" as
         * legacy does.
         *
         * The permission check runs first, as a dependency. Legacy ran it last, which told a
         * non-admin whether someone was a member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentMemberTags.useMutation({
         *     path: {
         *         student_id: studentId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentMemberTags.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         student_id: studentId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetStudentMemberTagsBody, TContext = unknown>(parameters: DeepReadonly<SetStudentMemberTagsParameters>, options?: ServiceOperationUseMutationOptions<SetStudentMemberTagsSchema, SetStudentMemberTagsData, SetStudentMemberTagsParameters, TVariables, OperationError<SetStudentMemberTagsError>, TContext>): UseMutationResult<SetStudentMemberTagsData, OperationError<SetStudentMemberTagsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Student Member Tags
         * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
         *
         * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
         * Student` the 400 below, which folds "no such student" into "not in this group" as
         * legacy does.
         *
         * The permission check runs first, as a dependency. Legacy ran it last, which told a
         * non-admin whether someone was a member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentMemberTags.useMutation({
         *     path: {
         *         student_id: studentId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentMemberTags.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         student_id: studentId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetStudentMemberTagsBody, SetStudentMemberTagsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetStudentMemberTagsSchema, SetStudentMemberTagsData, SetStudentMemberTagsParameters, TVariables, OperationError<SetStudentMemberTagsError>, TContext>): UseMutationResult<SetStudentMemberTagsData, OperationError<SetStudentMemberTagsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set Student Member Tags
         * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
         *
         * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
         * Student` the 400 below, which folds "no such student" into "not in this group" as
         * legacy does.
         *
         * The permission check runs first, as a dependency. Legacy ran it last, which told a
         * non-admin whether someone was a member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setStudentMemberTagsTotal = qraft.v3Service.setStudentMemberTags.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setStudentMemberTagsTotal = qraft.v3Service.setStudentMemberTags.useIsMutating({
         *     parameters: {
         *         path: {
         *             student_id: studentId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext> | MutationFiltersByMutationKey<SetStudentMemberTagsSchema, SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set Student Member Tags
         * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
         *
         * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
         * Student` the 400 below, which folds "no such student" into "not in this group" as
         * legacy does.
         *
         * The permission check runs first, as a dependency. Legacy ran it last, which told a
         * non-admin whether someone was a member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setStudentMemberTagsPendingMutationVariables = qraft.v3Service.setStudentMemberTags.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setStudentMemberTagsMutationData = qraft.v3Service.setStudentMemberTags.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 student_id: studentId,
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetStudentMemberTagsData, OperationError<SetStudentMemberTagsError>, MutationVariables<SetStudentMemberTagsBody, SetStudentMemberTagsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext> | MutationFiltersByMutationKey<SetStudentMemberTagsSchema, SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext>;
            select?: (mutation: Mutation<SetStudentMemberTagsData, OperationError<SetStudentMemberTagsError>, MutationVariables<SetStudentMemberTagsBody, SetStudentMemberTagsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set Student Member Tags
         * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
         *
         * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
         * Student` the 400 below, which folds "no such student" into "not in this group" as
         * legacy does.
         *
         * The permission check runs first, as a dependency. Legacy ran it last, which told a
         * non-admin whether someone was a member.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext> | MutationFiltersByMutationKey<SetStudentMemberTagsSchema, SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set Student Member Tags
         * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
         *
         * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
         * Student` the 400 below, which folds "no such student" into "not in this group" as
         * legacy does.
         *
         * The permission check runs first, as a dependency. Legacy ran it last, which told a
         * non-admin whether someone was a member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setStudentMemberTags.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             student_id: studentId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setStudentMemberTags.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext> | MutationFiltersByMutationKey<SetStudentMemberTagsSchema, SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext>): Mutation<SetStudentMemberTagsData, SetStudentMemberTagsError, MutationVariables<SetStudentMemberTagsBody, SetStudentMemberTagsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext> | MutationFiltersByMutationKey<SetStudentMemberTagsSchema, SetStudentMemberTagsBody, SetStudentMemberTagsData, SetStudentMemberTagsParameters, OperationError<SetStudentMemberTagsError>, TContext>): Array<Mutation<SetStudentMemberTagsData, SetStudentMemberTagsError, MutationVariables<SetStudentMemberTagsBody, SetStudentMemberTagsParameters>, TContext>>;
        };
        schema: SetStudentMemberTagsSchema;
        types: {
            parameters: SetStudentMemberTagsParameters;
            data: SetStudentMemberTagsData;
            error: SetStudentMemberTagsError;
            body: SetStudentMemberTagsBody;
        };
    };
    /**
     * @summary List Geo Target Map Endpoint
     * @description Every active target's footprint across all groups, anonymized — for
     * drawing coverage circles on the Web Targets overview map.
     *
     * Study-helper only: the overview map is a study-helper tool, and students have
     * no reason to enumerate every group's coverage, anonymized or not.
     */
    listGeoTargetMap: {
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGeoTargetMapParameters, TMeta, TSignal> | void), client?: (schema: ListGeoTargetMapSchema, options: {
            parameters: ListGeoTargetMapParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGeoTargetMapData, ListGeoTargetMapError>>): Promise<RequestFnResponse<ListGeoTargetMapData, ListGeoTargetMapError>>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        getQueryKey(parameters: DeepReadonly<ListGeoTargetMapParameters> | void): ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGeoTargetMap.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGeoTargetMap.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGeoTargetMapData>(parameters: ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListGeoTargetMapData, ListGeoTargetMapError, TData, ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGeoTargetMapError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGeoTargetMap.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGeoTargetMap.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGeoTargetMapData>(parameters: ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void), options: Omit<DefinedInitialDataOptions<ListGeoTargetMapData, ListGeoTargetMapError, TData, ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGeoTargetMapError>>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGeoTargetMapParameters> | void): ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGeoTargetMap.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGeoTargetMapParameters, TQueryFnData = ListGeoTargetMapData, TData = OperationInfiniteData<TQueryFnData, ListGeoTargetMapParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGeoTargetMapError, TData, ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGeoTargetMapError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGeoTargetMap.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGeoTargetMapParameters, TQueryFnData = ListGeoTargetMapData, TData = OperationInfiniteData<TQueryFnData, ListGeoTargetMapParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGeoTargetMapError, TData, ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGeoTargetMapData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGeoTargetMapError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGeoTargetMapTotal = qraft.v3Service.listGeoTargetMap.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGeoTargetMapByParametersTotal = qraft.v3Service.listGeoTargetMap.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError> | QueryFiltersByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGeoTargetMapResults = qraft.v3Service.listGeoTargetMap.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGeoTargetMapResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGeoTargetMapCombinedResults = qraft.v3Service.listGeoTargetMap.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGeoTargetMapCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGeoTargetMapSchema, ListGeoTargetMapParameters, ListGeoTargetMapData, ListGeoTargetMapError>>, TCombinedResult = Array<UseQueryResult<ListGeoTargetMapData, ListGeoTargetMapError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGeoTargetMapData, ListGeoTargetMapError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listGeoTargetMap.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGeoTargetMap.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGeoTargetMapData>(parameters: ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListGeoTargetMapData, ListGeoTargetMapError, TData, ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGeoTargetMapError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGeoTargetMap.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGeoTargetMapParameters, TData = ListGeoTargetMapData>(parameters: ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListGeoTargetMapData, ListGeoTargetMapError, OperationInfiniteData<TData, ListGeoTargetMapParameters>, ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGeoTargetMapData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGeoTargetMapParameters>, OperationError<ListGeoTargetMapError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGeoTargetMapData = qraft.v3Service.listGeoTargetMap.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGeoTargetMapResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGeoTargetMapCombinedData = qraft.v3Service.listGeoTargetMap.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGeoTargetMapCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGeoTargetMapSchema, ListGeoTargetMapParameters, ListGeoTargetMapData, ListGeoTargetMapError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGeoTargetMapData, ListGeoTargetMapError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGeoTargetMapData, ListGeoTargetMapError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGeoTargetMapSchema, ListGeoTargetMapData, ListGeoTargetMapParameters, ListGeoTargetMapError> | void): Promise<ListGeoTargetMapData>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGeoTargetMapSchema, ListGeoTargetMapData, ListGeoTargetMapParameters, ListGeoTargetMapError> | void): Promise<void>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGeoTargetMapSchema, ListGeoTargetMapData, ListGeoTargetMapParameters, ListGeoTargetMapError> | void): Promise<ListGeoTargetMapData>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        fetchInfiniteQuery<TPageParam extends ListGeoTargetMapParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGeoTargetMapSchema, ListGeoTargetMapData, ListGeoTargetMapParameters, DeepReadonly<TPageParam>, ListGeoTargetMapError> | void): Promise<OperationInfiniteData<ListGeoTargetMapData, ListGeoTargetMapParameters>>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        prefetchInfiniteQuery<TPageParam extends ListGeoTargetMapParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGeoTargetMapSchema, ListGeoTargetMapData, ListGeoTargetMapParameters, DeepReadonly<TPageParam>, ListGeoTargetMapError> | void): Promise<void>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        ensureInfiniteQueryData<TPageParam extends ListGeoTargetMapParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGeoTargetMapSchema, ListGeoTargetMapData, ListGeoTargetMapParameters, DeepReadonly<TPageParam>, ListGeoTargetMapError> | void): Promise<OperationInfiniteData<ListGeoTargetMapData, ListGeoTargetMapParameters>>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void)): ListGeoTargetMapData | undefined;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void)): OperationInfiniteData<ListGeoTargetMapData, ListGeoTargetMapParameters> | undefined;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError> | QueryFiltersByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>,
            data: NoInfer<OperationInfiniteData<ListGeoTargetMapData, ListGeoTargetMapParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>,
            data: ListGeoTargetMapData | undefined
        ]>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | (DeepReadonly<ListGeoTargetMapParameters> | void)): QueryState<ListGeoTargetMapData, ListGeoTargetMapError> | undefined;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGeoTargetMapParameters> | ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters> | void): QueryState<OperationInfiniteData<ListGeoTargetMapData, ListGeoTargetMapParameters>, ListGeoTargetMapError> | undefined;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        setQueryData(parameters: (DeepReadonly<ListGeoTargetMapParameters> | undefined) | ServiceOperationQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>, updater: Updater<NoInfer<ListGeoTargetMapData> | undefined, NoInfer<DeepReadonly<ListGeoTargetMapData>> | undefined>, options?: SetDataOptions): ListGeoTargetMapData | undefined;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGeoTargetMapParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGeoTargetMapData, ListGeoTargetMapParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGeoTargetMapData, ListGeoTargetMapParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGeoTargetMapData, ListGeoTargetMapParameters> | undefined;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError> | QueryFiltersByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>, updater: Updater<NoInfer<ListGeoTargetMapData> | undefined, NoInfer<ListGeoTargetMapData> | undefined>, options?: SetDataOptions): Array<ListGeoTargetMapData | undefined>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError> | QueryFiltersByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError> | QueryFiltersByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError> | QueryFiltersByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>): void;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError> | QueryFiltersByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Geo Target Map Endpoint
         * @description Every active target's footprint across all groups, anonymized — for
         * drawing coverage circles on the Web Targets overview map.
         *
         * Study-helper only: the overview map is a study-helper tool, and students have
         * no reason to enumerate every group's coverage, anonymized or not.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError> | QueryFiltersByQueryKey<ListGeoTargetMapSchema, ListGeoTargetMapData, TInfinite, ListGeoTargetMapParameters, ListGeoTargetMapError>): number;
        schema: ListGeoTargetMapSchema;
        types: {
            parameters: ListGeoTargetMapParameters;
            data: ListGeoTargetMapData;
            error: ListGeoTargetMapError;
        };
    };
    /**
     * @summary List Group Campaigns
     * @description The congregation's campaigns, oldest first.
     *
     * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
     * panel.
     */
    listGroupCampaigns: {
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupCampaignsParameters, TMeta, TSignal>), client?: (schema: ListGroupCampaignsSchema, options: {
            parameters: ListGroupCampaignsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupCampaignsData, ListGroupCampaignsError>>): Promise<RequestFnResponse<ListGroupCampaignsData, ListGroupCampaignsError>>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupCampaignsParameters>): ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupCampaigns.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupCampaignsData>(parameters: ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupCampaignsData, ListGroupCampaignsError, TData, ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupCampaignsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupCampaigns.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupCampaignsData>(parameters: ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>), options: Omit<DefinedInitialDataOptions<ListGroupCampaignsData, ListGroupCampaignsError, TData, ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupCampaignsError>>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupCampaignsParameters>): ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupCampaigns.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupCampaignsParameters, TQueryFnData = ListGroupCampaignsData, TData = OperationInfiniteData<TQueryFnData, ListGroupCampaignsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupCampaignsError, TData, ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupCampaignsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupCampaigns.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupCampaignsParameters, TQueryFnData = ListGroupCampaignsData, TData = OperationInfiniteData<TQueryFnData, ListGroupCampaignsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupCampaignsError, TData, ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupCampaignsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupCampaignsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupCampaignsTotal = qraft.v3Service.listGroupCampaigns.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupCampaignsByParametersTotal = qraft.v3Service.listGroupCampaigns.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError> | QueryFiltersByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupCampaignsResults = qraft.v3Service.listGroupCampaigns.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupCampaignsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupCampaignsCombinedResults = qraft.v3Service.listGroupCampaigns.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupCampaignsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupCampaignsSchema, ListGroupCampaignsParameters, ListGroupCampaignsData, ListGroupCampaignsError>>, TCombinedResult = Array<UseQueryResult<ListGroupCampaignsData, ListGroupCampaignsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupCampaignsData, ListGroupCampaignsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupCampaigns.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupCampaignsData>(parameters: ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupCampaignsData, ListGroupCampaignsError, TData, ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupCampaignsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupCampaigns.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupCampaignsParameters, TData = ListGroupCampaignsData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupCampaignsData, ListGroupCampaignsError, OperationInfiniteData<TData, ListGroupCampaignsParameters>, ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupCampaignsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupCampaignsParameters>, OperationError<ListGroupCampaignsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupCampaignsData = qraft.v3Service.listGroupCampaigns.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupCampaignsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupCampaignsCombinedData = qraft.v3Service.listGroupCampaigns.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupCampaignsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupCampaignsSchema, ListGroupCampaignsParameters, ListGroupCampaignsData, ListGroupCampaignsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupCampaignsData, ListGroupCampaignsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupCampaignsData, ListGroupCampaignsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupCampaignsSchema, ListGroupCampaignsData, ListGroupCampaignsParameters, ListGroupCampaignsError>): Promise<ListGroupCampaignsData>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupCampaignsSchema, ListGroupCampaignsData, ListGroupCampaignsParameters, ListGroupCampaignsError>): Promise<void>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupCampaignsSchema, ListGroupCampaignsData, ListGroupCampaignsParameters, ListGroupCampaignsError>): Promise<ListGroupCampaignsData>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupCampaignsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupCampaignsSchema, ListGroupCampaignsData, ListGroupCampaignsParameters, DeepReadonly<TPageParam>, ListGroupCampaignsError>): Promise<OperationInfiniteData<ListGroupCampaignsData, ListGroupCampaignsParameters>>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupCampaignsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupCampaignsSchema, ListGroupCampaignsData, ListGroupCampaignsParameters, DeepReadonly<TPageParam>, ListGroupCampaignsError>): Promise<void>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupCampaignsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupCampaignsSchema, ListGroupCampaignsData, ListGroupCampaignsParameters, DeepReadonly<TPageParam>, ListGroupCampaignsError>): Promise<OperationInfiniteData<ListGroupCampaignsData, ListGroupCampaignsParameters>>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>)): ListGroupCampaignsData | undefined;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>)): OperationInfiniteData<ListGroupCampaignsData, ListGroupCampaignsParameters> | undefined;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError> | QueryFiltersByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupCampaignsData, ListGroupCampaignsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>,
            data: ListGroupCampaignsData | undefined
        ]>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters> | (DeepReadonly<ListGroupCampaignsParameters>)): QueryState<ListGroupCampaignsData, ListGroupCampaignsError> | undefined;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupCampaignsParameters> | ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>): QueryState<OperationInfiniteData<ListGroupCampaignsData, ListGroupCampaignsParameters>, ListGroupCampaignsError> | undefined;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupCampaignsParameters>) | ServiceOperationQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>, updater: Updater<NoInfer<ListGroupCampaignsData> | undefined, NoInfer<DeepReadonly<ListGroupCampaignsData>> | undefined>, options?: SetDataOptions): ListGroupCampaignsData | undefined;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupCampaignsParameters>) | ServiceOperationInfiniteQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupCampaignsData, ListGroupCampaignsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupCampaignsData, ListGroupCampaignsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupCampaignsData, ListGroupCampaignsParameters> | undefined;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError> | QueryFiltersByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>, updater: Updater<NoInfer<ListGroupCampaignsData> | undefined, NoInfer<ListGroupCampaignsData> | undefined>, options?: SetDataOptions): Array<ListGroupCampaignsData | undefined>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError> | QueryFiltersByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError> | QueryFiltersByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError> | QueryFiltersByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>): void;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError> | QueryFiltersByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Campaigns
         * @description The congregation's campaigns, oldest first.
         *
         * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
         * panel.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError> | QueryFiltersByQueryKey<ListGroupCampaignsSchema, ListGroupCampaignsData, TInfinite, ListGroupCampaignsParameters, ListGroupCampaignsError>): number;
        schema: ListGroupCampaignsSchema;
        types: {
            parameters: ListGroupCampaignsParameters;
            data: ListGroupCampaignsData;
            error: ListGroupCampaignsError;
        };
    };
    /**
     * @summary Create Group Campaign
     * @description Create one congregation campaign.
     */
    createGroupCampaign: {
        /**
         * @summary Create Group Campaign
         * @description Create one congregation campaign.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateGroupCampaignBody, CreateGroupCampaignParameters, TMeta, TSignal>, client?: (schema: CreateGroupCampaignSchema, options: ServiceOperationMutationFnOptions<CreateGroupCampaignBody, CreateGroupCampaignParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateGroupCampaignData, CreateGroupCampaignError>>): Promise<RequestFnResponse<CreateGroupCampaignData, CreateGroupCampaignError>>;
        /**
         * @summary Create Group Campaign
         * @description Create one congregation campaign.
         */
        getMutationKey(parameters: DeepReadonly<CreateGroupCampaignParameters> | void): ServiceOperationMutationKey<CreateGroupCampaignSchema, CreateGroupCampaignParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Group Campaign
         * @description Create one congregation campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupCampaign.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupCampaign.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateGroupCampaignBody, TContext = unknown>(parameters: DeepReadonly<CreateGroupCampaignParameters>, options?: ServiceOperationUseMutationOptions<CreateGroupCampaignSchema, CreateGroupCampaignData, CreateGroupCampaignParameters, TVariables, OperationError<CreateGroupCampaignError>, TContext>): UseMutationResult<CreateGroupCampaignData, OperationError<CreateGroupCampaignError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Group Campaign
         * @description Create one congregation campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupCampaign.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupCampaign.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateGroupCampaignBody, CreateGroupCampaignParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateGroupCampaignSchema, CreateGroupCampaignData, CreateGroupCampaignParameters, TVariables, OperationError<CreateGroupCampaignError>, TContext>): UseMutationResult<CreateGroupCampaignData, OperationError<CreateGroupCampaignError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Group Campaign
         * @description Create one congregation campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createGroupCampaignTotal = qraft.v3Service.createGroupCampaign.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createGroupCampaignTotal = qraft.v3Service.createGroupCampaign.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext> | MutationFiltersByMutationKey<CreateGroupCampaignSchema, CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Group Campaign
         * @description Create one congregation campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createGroupCampaignPendingMutationVariables = qraft.v3Service.createGroupCampaign.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createGroupCampaignMutationData = qraft.v3Service.createGroupCampaign.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateGroupCampaignData, OperationError<CreateGroupCampaignError>, MutationVariables<CreateGroupCampaignBody, CreateGroupCampaignParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext> | MutationFiltersByMutationKey<CreateGroupCampaignSchema, CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext>;
            select?: (mutation: Mutation<CreateGroupCampaignData, OperationError<CreateGroupCampaignError>, MutationVariables<CreateGroupCampaignBody, CreateGroupCampaignParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Group Campaign
         * @description Create one congregation campaign.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext> | MutationFiltersByMutationKey<CreateGroupCampaignSchema, CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Group Campaign
         * @description Create one congregation campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createGroupCampaign.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createGroupCampaign.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext> | MutationFiltersByMutationKey<CreateGroupCampaignSchema, CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext>): Mutation<CreateGroupCampaignData, CreateGroupCampaignError, MutationVariables<CreateGroupCampaignBody, CreateGroupCampaignParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext> | MutationFiltersByMutationKey<CreateGroupCampaignSchema, CreateGroupCampaignBody, CreateGroupCampaignData, CreateGroupCampaignParameters, OperationError<CreateGroupCampaignError>, TContext>): Array<Mutation<CreateGroupCampaignData, CreateGroupCampaignError, MutationVariables<CreateGroupCampaignBody, CreateGroupCampaignParameters>, TContext>>;
        };
        schema: CreateGroupCampaignSchema;
        types: {
            parameters: CreateGroupCampaignParameters;
            data: CreateGroupCampaignData;
            error: CreateGroupCampaignError;
            body: CreateGroupCampaignBody;
        };
    };
    /**
     * @summary Get Personal Campaign
     * @description The study helper's personal campaign, or the Enable empty state.
     */
    getPersonalCampaign: {
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetPersonalCampaignParameters, TMeta, TSignal>), client?: (schema: GetPersonalCampaignSchema, options: {
            parameters: GetPersonalCampaignParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetPersonalCampaignData, GetPersonalCampaignError>>): Promise<RequestFnResponse<GetPersonalCampaignData, GetPersonalCampaignError>>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        getQueryKey(parameters: DeepReadonly<GetPersonalCampaignParameters>): ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPersonalCampaign.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetPersonalCampaignData>(parameters: ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>), options?: Omit<UndefinedInitialDataOptions<GetPersonalCampaignData, GetPersonalCampaignError, TData, ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetPersonalCampaignError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPersonalCampaign.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetPersonalCampaignData>(parameters: ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>), options: Omit<DefinedInitialDataOptions<GetPersonalCampaignData, GetPersonalCampaignError, TData, ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetPersonalCampaignError>>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetPersonalCampaignParameters>): ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPersonalCampaign.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetPersonalCampaignParameters, TQueryFnData = GetPersonalCampaignData, TData = OperationInfiniteData<TQueryFnData, GetPersonalCampaignParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetPersonalCampaignError, TData, ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetPersonalCampaignError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPersonalCampaign.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetPersonalCampaignParameters, TQueryFnData = GetPersonalCampaignData, TData = OperationInfiniteData<TQueryFnData, GetPersonalCampaignParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetPersonalCampaignError, TData, ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetPersonalCampaignData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetPersonalCampaignError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getPersonalCampaignTotal = qraft.v3Service.getPersonalCampaign.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getPersonalCampaignByParametersTotal = qraft.v3Service.getPersonalCampaign.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError> | QueryFiltersByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getPersonalCampaignResults = qraft.v3Service.getPersonalCampaign.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPersonalCampaignResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getPersonalCampaignCombinedResults = qraft.v3Service.getPersonalCampaign.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPersonalCampaignCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetPersonalCampaignSchema, GetPersonalCampaignParameters, GetPersonalCampaignData, GetPersonalCampaignError>>, TCombinedResult = Array<UseQueryResult<GetPersonalCampaignData, GetPersonalCampaignError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetPersonalCampaignData, GetPersonalCampaignError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getPersonalCampaign.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetPersonalCampaignData>(parameters: ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>), options?: Omit<UseSuspenseQueryOptions<GetPersonalCampaignData, GetPersonalCampaignError, TData, ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetPersonalCampaignError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPersonalCampaign.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetPersonalCampaignParameters, TData = GetPersonalCampaignData>(parameters: ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetPersonalCampaignData, GetPersonalCampaignError, OperationInfiniteData<TData, GetPersonalCampaignParameters>, ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetPersonalCampaignData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetPersonalCampaignParameters>, OperationError<GetPersonalCampaignError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getPersonalCampaignData = qraft.v3Service.getPersonalCampaign.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPersonalCampaignResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getPersonalCampaignCombinedData = qraft.v3Service.getPersonalCampaign.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPersonalCampaignCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetPersonalCampaignSchema, GetPersonalCampaignParameters, GetPersonalCampaignData, GetPersonalCampaignError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetPersonalCampaignData, GetPersonalCampaignError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetPersonalCampaignData, GetPersonalCampaignError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetPersonalCampaignSchema, GetPersonalCampaignData, GetPersonalCampaignParameters, GetPersonalCampaignError>): Promise<GetPersonalCampaignData>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetPersonalCampaignSchema, GetPersonalCampaignData, GetPersonalCampaignParameters, GetPersonalCampaignError>): Promise<void>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetPersonalCampaignSchema, GetPersonalCampaignData, GetPersonalCampaignParameters, GetPersonalCampaignError>): Promise<GetPersonalCampaignData>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        fetchInfiniteQuery<TPageParam extends GetPersonalCampaignParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetPersonalCampaignSchema, GetPersonalCampaignData, GetPersonalCampaignParameters, DeepReadonly<TPageParam>, GetPersonalCampaignError>): Promise<OperationInfiniteData<GetPersonalCampaignData, GetPersonalCampaignParameters>>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        prefetchInfiniteQuery<TPageParam extends GetPersonalCampaignParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetPersonalCampaignSchema, GetPersonalCampaignData, GetPersonalCampaignParameters, DeepReadonly<TPageParam>, GetPersonalCampaignError>): Promise<void>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        ensureInfiniteQueryData<TPageParam extends GetPersonalCampaignParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetPersonalCampaignSchema, GetPersonalCampaignData, GetPersonalCampaignParameters, DeepReadonly<TPageParam>, GetPersonalCampaignError>): Promise<OperationInfiniteData<GetPersonalCampaignData, GetPersonalCampaignParameters>>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>)): GetPersonalCampaignData | undefined;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>)): OperationInfiniteData<GetPersonalCampaignData, GetPersonalCampaignParameters> | undefined;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError> | QueryFiltersByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>,
            data: NoInfer<OperationInfiniteData<GetPersonalCampaignData, GetPersonalCampaignParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>,
            data: GetPersonalCampaignData | undefined
        ]>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters> | (DeepReadonly<GetPersonalCampaignParameters>)): QueryState<GetPersonalCampaignData, GetPersonalCampaignError> | undefined;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetPersonalCampaignParameters> | ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>): QueryState<OperationInfiniteData<GetPersonalCampaignData, GetPersonalCampaignParameters>, GetPersonalCampaignError> | undefined;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        setQueryData(parameters: (DeepReadonly<GetPersonalCampaignParameters>) | ServiceOperationQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>, updater: Updater<NoInfer<GetPersonalCampaignData> | undefined, NoInfer<DeepReadonly<GetPersonalCampaignData>> | undefined>, options?: SetDataOptions): GetPersonalCampaignData | undefined;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetPersonalCampaignParameters>) | ServiceOperationInfiniteQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetPersonalCampaignData, GetPersonalCampaignParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetPersonalCampaignData, GetPersonalCampaignParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetPersonalCampaignData, GetPersonalCampaignParameters> | undefined;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError> | QueryFiltersByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>, updater: Updater<NoInfer<GetPersonalCampaignData> | undefined, NoInfer<GetPersonalCampaignData> | undefined>, options?: SetDataOptions): Array<GetPersonalCampaignData | undefined>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError> | QueryFiltersByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError> | QueryFiltersByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError> | QueryFiltersByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>): void;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError> | QueryFiltersByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Personal Campaign
         * @description The study helper's personal campaign, or the Enable empty state.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError> | QueryFiltersByQueryKey<GetPersonalCampaignSchema, GetPersonalCampaignData, TInfinite, GetPersonalCampaignParameters, GetPersonalCampaignError>): number;
        schema: GetPersonalCampaignSchema;
        types: {
            parameters: GetPersonalCampaignParameters;
            data: GetPersonalCampaignData;
            error: GetPersonalCampaignError;
        };
    };
    /**
     * @summary Enable Personal Campaign
     * @description Enable (auto-create) the group's personal campaign.
     *
     * Idempotent: posting again returns the existing campaign unchanged.
     */
    enablePersonalCampaign: {
        /**
         * @summary Enable Personal Campaign
         * @description Enable (auto-create) the group's personal campaign.
         *
         * Idempotent: posting again returns the existing campaign unchanged.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<EnablePersonalCampaignBody, EnablePersonalCampaignParameters, TMeta, TSignal>, client?: (schema: EnablePersonalCampaignSchema, options: ServiceOperationMutationFnOptions<EnablePersonalCampaignBody, EnablePersonalCampaignParameters, TMeta, TSignal>) => Promise<RequestFnResponse<EnablePersonalCampaignData, EnablePersonalCampaignError>>): Promise<RequestFnResponse<EnablePersonalCampaignData, EnablePersonalCampaignError>>;
        /**
         * @summary Enable Personal Campaign
         * @description Enable (auto-create) the group's personal campaign.
         *
         * Idempotent: posting again returns the existing campaign unchanged.
         */
        getMutationKey(parameters: DeepReadonly<EnablePersonalCampaignParameters> | void): ServiceOperationMutationKey<EnablePersonalCampaignSchema, EnablePersonalCampaignParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Enable Personal Campaign
         * @description Enable (auto-create) the group's personal campaign.
         *
         * Idempotent: posting again returns the existing campaign unchanged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.enablePersonalCampaign.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.enablePersonalCampaign.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends EnablePersonalCampaignBody, TContext = unknown>(parameters: DeepReadonly<EnablePersonalCampaignParameters>, options?: ServiceOperationUseMutationOptions<EnablePersonalCampaignSchema, EnablePersonalCampaignData, EnablePersonalCampaignParameters, TVariables, OperationError<EnablePersonalCampaignError>, TContext>): UseMutationResult<EnablePersonalCampaignData, OperationError<EnablePersonalCampaignError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Enable Personal Campaign
         * @description Enable (auto-create) the group's personal campaign.
         *
         * Idempotent: posting again returns the existing campaign unchanged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.enablePersonalCampaign.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.enablePersonalCampaign.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<EnablePersonalCampaignBody, EnablePersonalCampaignParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<EnablePersonalCampaignSchema, EnablePersonalCampaignData, EnablePersonalCampaignParameters, TVariables, OperationError<EnablePersonalCampaignError>, TContext>): UseMutationResult<EnablePersonalCampaignData, OperationError<EnablePersonalCampaignError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Enable Personal Campaign
         * @description Enable (auto-create) the group's personal campaign.
         *
         * Idempotent: posting again returns the existing campaign unchanged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const enablePersonalCampaignTotal = qraft.v3Service.enablePersonalCampaign.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const enablePersonalCampaignTotal = qraft.v3Service.enablePersonalCampaign.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext> | MutationFiltersByMutationKey<EnablePersonalCampaignSchema, EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Enable Personal Campaign
         * @description Enable (auto-create) the group's personal campaign.
         *
         * Idempotent: posting again returns the existing campaign unchanged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const enablePersonalCampaignPendingMutationVariables = qraft.v3Service.enablePersonalCampaign.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const enablePersonalCampaignMutationData = qraft.v3Service.enablePersonalCampaign.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<EnablePersonalCampaignData, OperationError<EnablePersonalCampaignError>, MutationVariables<EnablePersonalCampaignBody, EnablePersonalCampaignParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext> | MutationFiltersByMutationKey<EnablePersonalCampaignSchema, EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext>;
            select?: (mutation: Mutation<EnablePersonalCampaignData, OperationError<EnablePersonalCampaignError>, MutationVariables<EnablePersonalCampaignBody, EnablePersonalCampaignParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Enable Personal Campaign
         * @description Enable (auto-create) the group's personal campaign.
         *
         * Idempotent: posting again returns the existing campaign unchanged.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext> | MutationFiltersByMutationKey<EnablePersonalCampaignSchema, EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Enable Personal Campaign
         * @description Enable (auto-create) the group's personal campaign.
         *
         * Idempotent: posting again returns the existing campaign unchanged.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.enablePersonalCampaign.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.enablePersonalCampaign.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext> | MutationFiltersByMutationKey<EnablePersonalCampaignSchema, EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext>): Mutation<EnablePersonalCampaignData, EnablePersonalCampaignError, MutationVariables<EnablePersonalCampaignBody, EnablePersonalCampaignParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext> | MutationFiltersByMutationKey<EnablePersonalCampaignSchema, EnablePersonalCampaignBody, EnablePersonalCampaignData, EnablePersonalCampaignParameters, OperationError<EnablePersonalCampaignError>, TContext>): Array<Mutation<EnablePersonalCampaignData, EnablePersonalCampaignError, MutationVariables<EnablePersonalCampaignBody, EnablePersonalCampaignParameters>, TContext>>;
        };
        schema: EnablePersonalCampaignSchema;
        types: {
            parameters: EnablePersonalCampaignParameters;
            data: EnablePersonalCampaignData;
            error: EnablePersonalCampaignError;
            body: EnablePersonalCampaignBody;
        };
    };
    /**
     * @summary List Personal Campaign Students
     * @description The board under the share card: the leads that arrived through this
     * study helper's own campaign.
     */
    listPersonalCampaignStudents: {
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListPersonalCampaignStudentsParameters, TMeta, TSignal>), client?: (schema: ListPersonalCampaignStudentsSchema, options: {
            parameters: ListPersonalCampaignStudentsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError>>): Promise<RequestFnResponse<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError>>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        getQueryKey(parameters: DeepReadonly<ListPersonalCampaignStudentsParameters>): ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPersonalCampaignStudents.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         intro: intro
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPersonalCampaignStudentsData>(parameters: ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>), options?: Omit<UndefinedInitialDataOptions<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError, TData, ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListPersonalCampaignStudentsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPersonalCampaignStudents.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         intro: intro
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPersonalCampaignStudentsData>(parameters: ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>), options: Omit<DefinedInitialDataOptions<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError, TData, ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListPersonalCampaignStudentsError>>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListPersonalCampaignStudentsParameters>): ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPersonalCampaignStudents.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             intro: initialIntro
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPersonalCampaignStudentsParameters, TQueryFnData = ListPersonalCampaignStudentsData, TData = OperationInfiniteData<TQueryFnData, ListPersonalCampaignStudentsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListPersonalCampaignStudentsError, TData, ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListPersonalCampaignStudentsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPersonalCampaignStudents.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             intro: initialIntro
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPersonalCampaignStudentsParameters, TQueryFnData = ListPersonalCampaignStudentsData, TData = OperationInfiniteData<TQueryFnData, ListPersonalCampaignStudentsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListPersonalCampaignStudentsError, TData, ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPersonalCampaignStudentsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListPersonalCampaignStudentsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listPersonalCampaignStudentsTotal = qraft.v3Service.listPersonalCampaignStudents.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listPersonalCampaignStudentsByParametersTotal = qraft.v3Service.listPersonalCampaignStudents.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             intro: intro
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError> | QueryFiltersByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listPersonalCampaignStudentsResults = qraft.v3Service.listPersonalCampaignStudents.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 intro: intro1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 intro: intro2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPersonalCampaignStudentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listPersonalCampaignStudentsCombinedResults = qraft.v3Service.listPersonalCampaignStudents.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 intro: intro1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 intro: intro2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPersonalCampaignStudentsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError>>, TCombinedResult = Array<UseQueryResult<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listPersonalCampaignStudents.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         intro: intro
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListPersonalCampaignStudentsData>(parameters: ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>), options?: Omit<UseSuspenseQueryOptions<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError, TData, ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListPersonalCampaignStudentsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPersonalCampaignStudents.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             intro: initialIntro
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListPersonalCampaignStudentsParameters, TData = ListPersonalCampaignStudentsData>(parameters: ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError, OperationInfiniteData<TData, ListPersonalCampaignStudentsParameters>, ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPersonalCampaignStudentsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListPersonalCampaignStudentsParameters>, OperationError<ListPersonalCampaignStudentsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listPersonalCampaignStudentsData = qraft.v3Service.listPersonalCampaignStudents.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 intro: intro1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 intro: intro2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPersonalCampaignStudentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listPersonalCampaignStudentsCombinedData = qraft.v3Service.listPersonalCampaignStudents.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 intro: intro1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 intro: intro2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPersonalCampaignStudentsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>): Promise<ListPersonalCampaignStudentsData>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>): Promise<void>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>): Promise<ListPersonalCampaignStudentsData>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        fetchInfiniteQuery<TPageParam extends ListPersonalCampaignStudentsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters, DeepReadonly<TPageParam>, ListPersonalCampaignStudentsError>): Promise<OperationInfiniteData<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters>>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        prefetchInfiniteQuery<TPageParam extends ListPersonalCampaignStudentsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters, DeepReadonly<TPageParam>, ListPersonalCampaignStudentsError>): Promise<void>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        ensureInfiniteQueryData<TPageParam extends ListPersonalCampaignStudentsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters, DeepReadonly<TPageParam>, ListPersonalCampaignStudentsError>): Promise<OperationInfiniteData<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters>>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>)): ListPersonalCampaignStudentsData | undefined;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>)): OperationInfiniteData<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters> | undefined;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError> | QueryFiltersByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>,
            data: NoInfer<OperationInfiniteData<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>,
            data: ListPersonalCampaignStudentsData | undefined
        ]>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters> | (DeepReadonly<ListPersonalCampaignStudentsParameters>)): QueryState<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsError> | undefined;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListPersonalCampaignStudentsParameters> | ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>): QueryState<OperationInfiniteData<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters>, ListPersonalCampaignStudentsError> | undefined;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        setQueryData(parameters: (DeepReadonly<ListPersonalCampaignStudentsParameters>) | ServiceOperationQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>, updater: Updater<NoInfer<ListPersonalCampaignStudentsData> | undefined, NoInfer<DeepReadonly<ListPersonalCampaignStudentsData>> | undefined>, options?: SetDataOptions): ListPersonalCampaignStudentsData | undefined;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListPersonalCampaignStudentsParameters>) | ServiceOperationInfiniteQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListPersonalCampaignStudentsData, ListPersonalCampaignStudentsParameters> | undefined;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError> | QueryFiltersByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>, updater: Updater<NoInfer<ListPersonalCampaignStudentsData> | undefined, NoInfer<ListPersonalCampaignStudentsData> | undefined>, options?: SetDataOptions): Array<ListPersonalCampaignStudentsData | undefined>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError> | QueryFiltersByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError> | QueryFiltersByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError> | QueryFiltersByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>): void;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError> | QueryFiltersByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Personal Campaign Students
         * @description The board under the share card: the leads that arrived through this
         * study helper's own campaign.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError> | QueryFiltersByQueryKey<ListPersonalCampaignStudentsSchema, ListPersonalCampaignStudentsData, TInfinite, ListPersonalCampaignStudentsParameters, ListPersonalCampaignStudentsError>): number;
        schema: ListPersonalCampaignStudentsSchema;
        types: {
            parameters: ListPersonalCampaignStudentsParameters;
            data: ListPersonalCampaignStudentsData;
            error: ListPersonalCampaignStudentsError;
        };
    };
    /**
     * @summary Check Campaign Subdomain
     * @description Is this campaign subdomain free? Compared case-insensitively.
     */
    checkCampaignSubdomain: {
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<CheckCampaignSubdomainParameters, TMeta, TSignal>), client?: (schema: CheckCampaignSubdomainSchema, options: {
            parameters: CheckCampaignSubdomainParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<CheckCampaignSubdomainData, CheckCampaignSubdomainError>>): Promise<RequestFnResponse<CheckCampaignSubdomainData, CheckCampaignSubdomainError>>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        getQueryKey(parameters: DeepReadonly<CheckCampaignSubdomainParameters>): ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.checkCampaignSubdomain.useQuery({
         *     query: {
         *         subdomain: subdomain
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CheckCampaignSubdomainData>(parameters: ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>), options?: Omit<UndefinedInitialDataOptions<CheckCampaignSubdomainData, CheckCampaignSubdomainError, TData, ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>>, "queryKey">): UseQueryResult<TData, OperationError<CheckCampaignSubdomainError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.checkCampaignSubdomain.useQuery({
         *     query: {
         *         subdomain: subdomain
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CheckCampaignSubdomainData>(parameters: ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>), options: Omit<DefinedInitialDataOptions<CheckCampaignSubdomainData, CheckCampaignSubdomainError, TData, ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<CheckCampaignSubdomainError>>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<CheckCampaignSubdomainParameters>): ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.checkCampaignSubdomain.useInfiniteQuery({
         *     query: {
         *         subdomain: subdomain
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             subdomain: initialSubdomain
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CheckCampaignSubdomainParameters, TQueryFnData = CheckCampaignSubdomainData, TData = OperationInfiniteData<TQueryFnData, CheckCampaignSubdomainParameters>>(parameters: ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, CheckCampaignSubdomainError, TData, ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<CheckCampaignSubdomainError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.checkCampaignSubdomain.useInfiniteQuery({
         *     query: {
         *         subdomain: subdomain
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             subdomain: initialSubdomain
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CheckCampaignSubdomainParameters, TQueryFnData = CheckCampaignSubdomainData, TData = OperationInfiniteData<TQueryFnData, CheckCampaignSubdomainParameters>>(parameters: ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, CheckCampaignSubdomainError, TData, ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CheckCampaignSubdomainData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<CheckCampaignSubdomainError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const checkCampaignSubdomainTotal = qraft.v3Service.checkCampaignSubdomain.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const checkCampaignSubdomainByParametersTotal = qraft.v3Service.checkCampaignSubdomain.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             subdomain: subdomain
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError> | QueryFiltersByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const checkCampaignSubdomainResults = qraft.v3Service.checkCampaignSubdomain.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 subdomain: subdomain1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 subdomain: subdomain2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * checkCampaignSubdomainResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const checkCampaignSubdomainCombinedResults = qraft.v3Service.checkCampaignSubdomain.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 subdomain: subdomain1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 subdomain: subdomain2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * checkCampaignSubdomainCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters, CheckCampaignSubdomainData, CheckCampaignSubdomainError>>, TCombinedResult = Array<UseQueryResult<CheckCampaignSubdomainData, CheckCampaignSubdomainError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<CheckCampaignSubdomainData, CheckCampaignSubdomainError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.checkCampaignSubdomain.useSuspenseQuery({
         *     query: {
         *         subdomain: subdomain
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = CheckCampaignSubdomainData>(parameters: ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>), options?: Omit<UseSuspenseQueryOptions<CheckCampaignSubdomainData, CheckCampaignSubdomainError, TData, ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<CheckCampaignSubdomainError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.checkCampaignSubdomain.useSuspenseInfiniteQuery({
         *     query: {
         *         subdomain: subdomain
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             subdomain: initialSubdomain
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends CheckCampaignSubdomainParameters, TData = CheckCampaignSubdomainData>(parameters: ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<CheckCampaignSubdomainData, CheckCampaignSubdomainError, OperationInfiniteData<TData, CheckCampaignSubdomainParameters>, ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CheckCampaignSubdomainData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, CheckCampaignSubdomainParameters>, OperationError<CheckCampaignSubdomainError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const checkCampaignSubdomainData = qraft.v3Service.checkCampaignSubdomain.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 subdomain: subdomain1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 subdomain: subdomain2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * checkCampaignSubdomainResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const checkCampaignSubdomainCombinedData = qraft.v3Service.checkCampaignSubdomain.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 subdomain: subdomain1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 subdomain: subdomain2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * checkCampaignSubdomainCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters, CheckCampaignSubdomainData, CheckCampaignSubdomainError>>, TCombinedResult = Array<UseSuspenseQueryResult<CheckCampaignSubdomainData, CheckCampaignSubdomainError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<CheckCampaignSubdomainData, CheckCampaignSubdomainError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>): Promise<CheckCampaignSubdomainData>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>): Promise<void>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>): Promise<CheckCampaignSubdomainData>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        fetchInfiniteQuery<TPageParam extends CheckCampaignSubdomainParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, CheckCampaignSubdomainParameters, DeepReadonly<TPageParam>, CheckCampaignSubdomainError>): Promise<OperationInfiniteData<CheckCampaignSubdomainData, CheckCampaignSubdomainParameters>>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        prefetchInfiniteQuery<TPageParam extends CheckCampaignSubdomainParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, CheckCampaignSubdomainParameters, DeepReadonly<TPageParam>, CheckCampaignSubdomainError>): Promise<void>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        ensureInfiniteQueryData<TPageParam extends CheckCampaignSubdomainParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, CheckCampaignSubdomainParameters, DeepReadonly<TPageParam>, CheckCampaignSubdomainError>): Promise<OperationInfiniteData<CheckCampaignSubdomainData, CheckCampaignSubdomainParameters>>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        getQueryData(parameters: ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>)): CheckCampaignSubdomainData | undefined;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>)): OperationInfiniteData<CheckCampaignSubdomainData, CheckCampaignSubdomainParameters> | undefined;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError> | QueryFiltersByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>,
            data: NoInfer<OperationInfiniteData<CheckCampaignSubdomainData, CheckCampaignSubdomainParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>,
            data: CheckCampaignSubdomainData | undefined
        ]>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        getQueryState(parameters: ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters> | (DeepReadonly<CheckCampaignSubdomainParameters>)): QueryState<CheckCampaignSubdomainData, CheckCampaignSubdomainError> | undefined;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        getInfiniteQueryState(parameters: DeepReadonly<CheckCampaignSubdomainParameters> | ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>): QueryState<OperationInfiniteData<CheckCampaignSubdomainData, CheckCampaignSubdomainParameters>, CheckCampaignSubdomainError> | undefined;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        setQueryData(parameters: (DeepReadonly<CheckCampaignSubdomainParameters>) | ServiceOperationQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>, updater: Updater<NoInfer<CheckCampaignSubdomainData> | undefined, NoInfer<DeepReadonly<CheckCampaignSubdomainData>> | undefined>, options?: SetDataOptions): CheckCampaignSubdomainData | undefined;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<CheckCampaignSubdomainParameters>) | ServiceOperationInfiniteQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainParameters>, updater: Updater<NoInfer<OperationInfiniteData<CheckCampaignSubdomainData, CheckCampaignSubdomainParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<CheckCampaignSubdomainData, CheckCampaignSubdomainParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<CheckCampaignSubdomainData, CheckCampaignSubdomainParameters> | undefined;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError> | QueryFiltersByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>, updater: Updater<NoInfer<CheckCampaignSubdomainData> | undefined, NoInfer<CheckCampaignSubdomainData> | undefined>, options?: SetDataOptions): Array<CheckCampaignSubdomainData | undefined>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError> | QueryFiltersByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError> | QueryFiltersByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError> | QueryFiltersByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>): void;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError> | QueryFiltersByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Check Campaign Subdomain
         * @description Is this campaign subdomain free? Compared case-insensitively.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError> | QueryFiltersByQueryKey<CheckCampaignSubdomainSchema, CheckCampaignSubdomainData, TInfinite, CheckCampaignSubdomainParameters, CheckCampaignSubdomainError>): number;
        schema: CheckCampaignSubdomainSchema;
        types: {
            parameters: CheckCampaignSubdomainParameters;
            data: CheckCampaignSubdomainData;
            error: CheckCampaignSubdomainError;
        };
    };
    /** @summary Series List */
    listSeries: {
        /** @summary Series List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListSeriesSchema, ListSeriesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListSeriesParameters, TMeta, TSignal>), client?: (schema: ListSeriesSchema, options: {
            parameters: ListSeriesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListSeriesData, ListSeriesError>>): Promise<RequestFnResponse<ListSeriesData, ListSeriesError>>;
        /** @summary Series List */
        getQueryKey(parameters: DeepReadonly<ListSeriesParameters>): ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listSeries.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListSeriesData>(parameters: ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>), options?: Omit<UndefinedInitialDataOptions<ListSeriesData, ListSeriesError, TData, ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListSeriesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listSeries.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListSeriesData>(parameters: ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>), options: Omit<DefinedInitialDataOptions<ListSeriesData, ListSeriesError, TData, ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListSeriesError>>;
        /** @summary Series List */
        getInfiniteQueryKey(parameters: DeepReadonly<ListSeriesParameters>): ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listSeries.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListSeriesParameters, TQueryFnData = ListSeriesData, TData = OperationInfiniteData<TQueryFnData, ListSeriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListSeriesError, TData, ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListSeriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listSeries.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListSeriesParameters, TQueryFnData = ListSeriesData, TData = OperationInfiniteData<TQueryFnData, ListSeriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListSeriesError, TData, ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListSeriesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListSeriesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listSeriesTotal = qraft.v3Service.listSeries.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listSeriesByParametersTotal = qraft.v3Service.listSeries.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError> | QueryFiltersByQueryKey<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listSeriesResults = qraft.v3Service.listSeries.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listSeriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listSeriesCombinedResults = qraft.v3Service.listSeries.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listSeriesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListSeriesSchema, ListSeriesParameters, ListSeriesData, ListSeriesError>>, TCombinedResult = Array<UseQueryResult<ListSeriesData, ListSeriesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListSeriesData, ListSeriesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listSeries.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListSeriesData>(parameters: ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>), options?: Omit<UseSuspenseQueryOptions<ListSeriesData, ListSeriesError, TData, ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListSeriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listSeries.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListSeriesParameters, TData = ListSeriesData>(parameters: ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListSeriesData, ListSeriesError, OperationInfiniteData<TData, ListSeriesParameters>, ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListSeriesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListSeriesParameters>, OperationError<ListSeriesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Series List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listSeriesData = qraft.v3Service.listSeries.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listSeriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listSeriesCombinedData = qraft.v3Service.listSeries.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listSeriesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListSeriesSchema, ListSeriesParameters, ListSeriesData, ListSeriesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListSeriesData, ListSeriesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListSeriesData, ListSeriesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Series List */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListSeriesSchema, ListSeriesData, ListSeriesParameters, ListSeriesError>): Promise<ListSeriesData>;
        /** @summary Series List */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListSeriesSchema, ListSeriesData, ListSeriesParameters, ListSeriesError>): Promise<void>;
        /** @summary Series List */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListSeriesSchema, ListSeriesData, ListSeriesParameters, ListSeriesError>): Promise<ListSeriesData>;
        /** @summary Series List */
        fetchInfiniteQuery<TPageParam extends ListSeriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListSeriesSchema, ListSeriesData, ListSeriesParameters, DeepReadonly<TPageParam>, ListSeriesError>): Promise<OperationInfiniteData<ListSeriesData, ListSeriesParameters>>;
        /** @summary Series List */
        prefetchInfiniteQuery<TPageParam extends ListSeriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListSeriesSchema, ListSeriesData, ListSeriesParameters, DeepReadonly<TPageParam>, ListSeriesError>): Promise<void>;
        /** @summary Series List */
        ensureInfiniteQueryData<TPageParam extends ListSeriesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListSeriesSchema, ListSeriesData, ListSeriesParameters, DeepReadonly<TPageParam>, ListSeriesError>): Promise<OperationInfiniteData<ListSeriesData, ListSeriesParameters>>;
        /** @summary Series List */
        getQueryData(parameters: ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>)): ListSeriesData | undefined;
        /** @summary Series List */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>)): OperationInfiniteData<ListSeriesData, ListSeriesParameters> | undefined;
        /** @summary Series List */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError> | QueryFiltersByQueryKey<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters>,
            data: NoInfer<OperationInfiniteData<ListSeriesData, ListSeriesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters>,
            data: ListSeriesData | undefined
        ]>;
        /** @summary Series List */
        getQueryState(parameters: ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters> | (DeepReadonly<ListSeriesParameters>)): QueryState<ListSeriesData, ListSeriesError> | undefined;
        /** @summary Series List */
        getInfiniteQueryState(parameters: DeepReadonly<ListSeriesParameters> | ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters>): QueryState<OperationInfiniteData<ListSeriesData, ListSeriesParameters>, ListSeriesError> | undefined;
        /** @summary Series List */
        setQueryData(parameters: (DeepReadonly<ListSeriesParameters>) | ServiceOperationQueryKey<ListSeriesSchema, ListSeriesParameters>, updater: Updater<NoInfer<ListSeriesData> | undefined, NoInfer<DeepReadonly<ListSeriesData>> | undefined>, options?: SetDataOptions): ListSeriesData | undefined;
        /** @summary Series List */
        setInfiniteQueryData(parameters: (DeepReadonly<ListSeriesParameters>) | ServiceOperationInfiniteQueryKey<ListSeriesSchema, ListSeriesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListSeriesData, ListSeriesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListSeriesData, ListSeriesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListSeriesData, ListSeriesParameters> | undefined;
        /** @summary Series List */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError> | QueryFiltersByQueryKey<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>, updater: Updater<NoInfer<ListSeriesData> | undefined, NoInfer<ListSeriesData> | undefined>, options?: SetDataOptions): Array<ListSeriesData | undefined>;
        /** @summary Series List */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Series List */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError> | QueryFiltersByQueryKey<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>, options?: RefetchOptions): Promise<void>;
        /** @summary Series List */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError> | QueryFiltersByQueryKey<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>, options?: CancelOptions): Promise<void>;
        /** @summary Series List */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError> | QueryFiltersByQueryKey<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>): void;
        /** @summary Series List */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError> | QueryFiltersByQueryKey<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>, options?: ResetOptions): Promise<void>;
        /** @summary Series List */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError> | QueryFiltersByQueryKey<ListSeriesSchema, ListSeriesData, TInfinite, ListSeriesParameters, ListSeriesError>): number;
        schema: ListSeriesSchema;
        types: {
            parameters: ListSeriesParameters;
            data: ListSeriesData;
            error: ListSeriesError;
        };
    };
    /** @summary Courses List */
    listCourses: {
        /** @summary Courses List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCoursesSchema, ListCoursesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCoursesParameters, TMeta, TSignal> | void), client?: (schema: ListCoursesSchema, options: {
            parameters: ListCoursesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCoursesData, ListCoursesError>>): Promise<RequestFnResponse<ListCoursesData, ListCoursesError>>;
        /** @summary Courses List */
        getQueryKey(parameters: DeepReadonly<ListCoursesParameters> | void): ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCourses.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCourses.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoursesData>(parameters: ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListCoursesData, ListCoursesError, TData, ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCoursesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCourses.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCourses.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoursesData>(parameters: ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void), options: Omit<DefinedInitialDataOptions<ListCoursesData, ListCoursesError, TData, ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCoursesError>>;
        /** @summary Courses List */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCoursesParameters> | void): ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCourses.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoursesParameters, TQueryFnData = ListCoursesData, TData = OperationInfiniteData<TQueryFnData, ListCoursesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCoursesError, TData, ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCoursesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCourses.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoursesParameters, TQueryFnData = ListCoursesData, TData = OperationInfiniteData<TQueryFnData, ListCoursesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCoursesError, TData, ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoursesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCoursesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCoursesTotal = qraft.v3Service.listCourses.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCoursesByParametersTotal = qraft.v3Service.listCourses.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError> | QueryFiltersByQueryKey<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCoursesResults = qraft.v3Service.listCourses.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoursesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCoursesCombinedResults = qraft.v3Service.listCourses.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoursesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCoursesSchema, ListCoursesParameters, ListCoursesData, ListCoursesError>>, TCombinedResult = Array<UseQueryResult<ListCoursesData, ListCoursesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCoursesData, ListCoursesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listCourses.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCourses.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCoursesData>(parameters: ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListCoursesData, ListCoursesError, TData, ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCoursesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCourses.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCoursesParameters, TData = ListCoursesData>(parameters: ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListCoursesData, ListCoursesError, OperationInfiniteData<TData, ListCoursesParameters>, ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoursesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCoursesParameters>, OperationError<ListCoursesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCoursesData = qraft.v3Service.listCourses.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoursesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCoursesCombinedData = qraft.v3Service.listCourses.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoursesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCoursesSchema, ListCoursesParameters, ListCoursesData, ListCoursesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCoursesData, ListCoursesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCoursesData, ListCoursesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Courses List */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCoursesSchema, ListCoursesData, ListCoursesParameters, ListCoursesError> | void): Promise<ListCoursesData>;
        /** @summary Courses List */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCoursesSchema, ListCoursesData, ListCoursesParameters, ListCoursesError> | void): Promise<void>;
        /** @summary Courses List */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCoursesSchema, ListCoursesData, ListCoursesParameters, ListCoursesError> | void): Promise<ListCoursesData>;
        /** @summary Courses List */
        fetchInfiniteQuery<TPageParam extends ListCoursesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoursesSchema, ListCoursesData, ListCoursesParameters, DeepReadonly<TPageParam>, ListCoursesError> | void): Promise<OperationInfiniteData<ListCoursesData, ListCoursesParameters>>;
        /** @summary Courses List */
        prefetchInfiniteQuery<TPageParam extends ListCoursesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoursesSchema, ListCoursesData, ListCoursesParameters, DeepReadonly<TPageParam>, ListCoursesError> | void): Promise<void>;
        /** @summary Courses List */
        ensureInfiniteQueryData<TPageParam extends ListCoursesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCoursesSchema, ListCoursesData, ListCoursesParameters, DeepReadonly<TPageParam>, ListCoursesError> | void): Promise<OperationInfiniteData<ListCoursesData, ListCoursesParameters>>;
        /** @summary Courses List */
        getQueryData(parameters: ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void)): ListCoursesData | undefined;
        /** @summary Courses List */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void)): OperationInfiniteData<ListCoursesData, ListCoursesParameters> | undefined;
        /** @summary Courses List */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError> | QueryFiltersByQueryKey<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters>,
            data: NoInfer<OperationInfiniteData<ListCoursesData, ListCoursesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters>,
            data: ListCoursesData | undefined
        ]>;
        /** @summary Courses List */
        getQueryState(parameters: ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters> | (DeepReadonly<ListCoursesParameters> | void)): QueryState<ListCoursesData, ListCoursesError> | undefined;
        /** @summary Courses List */
        getInfiniteQueryState(parameters: DeepReadonly<ListCoursesParameters> | ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters> | void): QueryState<OperationInfiniteData<ListCoursesData, ListCoursesParameters>, ListCoursesError> | undefined;
        /** @summary Courses List */
        setQueryData(parameters: (DeepReadonly<ListCoursesParameters> | undefined) | ServiceOperationQueryKey<ListCoursesSchema, ListCoursesParameters>, updater: Updater<NoInfer<ListCoursesData> | undefined, NoInfer<DeepReadonly<ListCoursesData>> | undefined>, options?: SetDataOptions): ListCoursesData | undefined;
        /** @summary Courses List */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCoursesParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListCoursesSchema, ListCoursesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCoursesData, ListCoursesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCoursesData, ListCoursesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCoursesData, ListCoursesParameters> | undefined;
        /** @summary Courses List */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError> | QueryFiltersByQueryKey<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>, updater: Updater<NoInfer<ListCoursesData> | undefined, NoInfer<ListCoursesData> | undefined>, options?: SetDataOptions): Array<ListCoursesData | undefined>;
        /** @summary Courses List */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Courses List */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError> | QueryFiltersByQueryKey<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>, options?: RefetchOptions): Promise<void>;
        /** @summary Courses List */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError> | QueryFiltersByQueryKey<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>, options?: CancelOptions): Promise<void>;
        /** @summary Courses List */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError> | QueryFiltersByQueryKey<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>): void;
        /** @summary Courses List */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError> | QueryFiltersByQueryKey<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>, options?: ResetOptions): Promise<void>;
        /** @summary Courses List */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError> | QueryFiltersByQueryKey<ListCoursesSchema, ListCoursesData, TInfinite, ListCoursesParameters, ListCoursesError>): number;
        schema: ListCoursesSchema;
        types: {
            parameters: ListCoursesParameters;
            data: ListCoursesData;
            error: ListCoursesError;
        };
    };
    /** @summary Self Paced Courses */
    listSelfPacedCourses: {
        /** @summary Self Paced Courses */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListSelfPacedCoursesParameters, TMeta, TSignal>), client?: (schema: ListSelfPacedCoursesSchema, options: {
            parameters: ListSelfPacedCoursesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListSelfPacedCoursesData, ListSelfPacedCoursesError>>): Promise<RequestFnResponse<ListSelfPacedCoursesData, ListSelfPacedCoursesError>>;
        /** @summary Self Paced Courses */
        getQueryKey(parameters: DeepReadonly<ListSelfPacedCoursesParameters>): ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listSelfPacedCourses.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListSelfPacedCoursesData>(parameters: ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>), options?: Omit<UndefinedInitialDataOptions<ListSelfPacedCoursesData, ListSelfPacedCoursesError, TData, ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListSelfPacedCoursesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listSelfPacedCourses.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListSelfPacedCoursesData>(parameters: ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>), options: Omit<DefinedInitialDataOptions<ListSelfPacedCoursesData, ListSelfPacedCoursesError, TData, ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListSelfPacedCoursesError>>;
        /** @summary Self Paced Courses */
        getInfiniteQueryKey(parameters: DeepReadonly<ListSelfPacedCoursesParameters>): ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listSelfPacedCourses.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListSelfPacedCoursesParameters, TQueryFnData = ListSelfPacedCoursesData, TData = OperationInfiniteData<TQueryFnData, ListSelfPacedCoursesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListSelfPacedCoursesError, TData, ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListSelfPacedCoursesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listSelfPacedCourses.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListSelfPacedCoursesParameters, TQueryFnData = ListSelfPacedCoursesData, TData = OperationInfiniteData<TQueryFnData, ListSelfPacedCoursesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListSelfPacedCoursesError, TData, ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListSelfPacedCoursesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListSelfPacedCoursesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listSelfPacedCoursesTotal = qraft.v3Service.listSelfPacedCourses.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listSelfPacedCoursesByParametersTotal = qraft.v3Service.listSelfPacedCourses.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError> | QueryFiltersByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listSelfPacedCoursesResults = qraft.v3Service.listSelfPacedCourses.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listSelfPacedCoursesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listSelfPacedCoursesCombinedResults = qraft.v3Service.listSelfPacedCourses.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listSelfPacedCoursesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters, ListSelfPacedCoursesData, ListSelfPacedCoursesError>>, TCombinedResult = Array<UseQueryResult<ListSelfPacedCoursesData, ListSelfPacedCoursesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListSelfPacedCoursesData, ListSelfPacedCoursesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listSelfPacedCourses.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListSelfPacedCoursesData>(parameters: ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>), options?: Omit<UseSuspenseQueryOptions<ListSelfPacedCoursesData, ListSelfPacedCoursesError, TData, ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListSelfPacedCoursesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listSelfPacedCourses.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListSelfPacedCoursesParameters, TData = ListSelfPacedCoursesData>(parameters: ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListSelfPacedCoursesData, ListSelfPacedCoursesError, OperationInfiniteData<TData, ListSelfPacedCoursesParameters>, ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListSelfPacedCoursesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListSelfPacedCoursesParameters>, OperationError<ListSelfPacedCoursesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Self Paced Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listSelfPacedCoursesData = qraft.v3Service.listSelfPacedCourses.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listSelfPacedCoursesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listSelfPacedCoursesCombinedData = qraft.v3Service.listSelfPacedCourses.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listSelfPacedCoursesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters, ListSelfPacedCoursesData, ListSelfPacedCoursesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListSelfPacedCoursesData, ListSelfPacedCoursesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListSelfPacedCoursesData, ListSelfPacedCoursesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Self Paced Courses */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>): Promise<ListSelfPacedCoursesData>;
        /** @summary Self Paced Courses */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>): Promise<void>;
        /** @summary Self Paced Courses */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>): Promise<ListSelfPacedCoursesData>;
        /** @summary Self Paced Courses */
        fetchInfiniteQuery<TPageParam extends ListSelfPacedCoursesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, ListSelfPacedCoursesParameters, DeepReadonly<TPageParam>, ListSelfPacedCoursesError>): Promise<OperationInfiniteData<ListSelfPacedCoursesData, ListSelfPacedCoursesParameters>>;
        /** @summary Self Paced Courses */
        prefetchInfiniteQuery<TPageParam extends ListSelfPacedCoursesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, ListSelfPacedCoursesParameters, DeepReadonly<TPageParam>, ListSelfPacedCoursesError>): Promise<void>;
        /** @summary Self Paced Courses */
        ensureInfiniteQueryData<TPageParam extends ListSelfPacedCoursesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, ListSelfPacedCoursesParameters, DeepReadonly<TPageParam>, ListSelfPacedCoursesError>): Promise<OperationInfiniteData<ListSelfPacedCoursesData, ListSelfPacedCoursesParameters>>;
        /** @summary Self Paced Courses */
        getQueryData(parameters: ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>)): ListSelfPacedCoursesData | undefined;
        /** @summary Self Paced Courses */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>)): OperationInfiniteData<ListSelfPacedCoursesData, ListSelfPacedCoursesParameters> | undefined;
        /** @summary Self Paced Courses */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError> | QueryFiltersByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>,
            data: NoInfer<OperationInfiniteData<ListSelfPacedCoursesData, ListSelfPacedCoursesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>,
            data: ListSelfPacedCoursesData | undefined
        ]>;
        /** @summary Self Paced Courses */
        getQueryState(parameters: ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters> | (DeepReadonly<ListSelfPacedCoursesParameters>)): QueryState<ListSelfPacedCoursesData, ListSelfPacedCoursesError> | undefined;
        /** @summary Self Paced Courses */
        getInfiniteQueryState(parameters: DeepReadonly<ListSelfPacedCoursesParameters> | ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>): QueryState<OperationInfiniteData<ListSelfPacedCoursesData, ListSelfPacedCoursesParameters>, ListSelfPacedCoursesError> | undefined;
        /** @summary Self Paced Courses */
        setQueryData(parameters: (DeepReadonly<ListSelfPacedCoursesParameters>) | ServiceOperationQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>, updater: Updater<NoInfer<ListSelfPacedCoursesData> | undefined, NoInfer<DeepReadonly<ListSelfPacedCoursesData>> | undefined>, options?: SetDataOptions): ListSelfPacedCoursesData | undefined;
        /** @summary Self Paced Courses */
        setInfiniteQueryData(parameters: (DeepReadonly<ListSelfPacedCoursesParameters>) | ServiceOperationInfiniteQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListSelfPacedCoursesData, ListSelfPacedCoursesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListSelfPacedCoursesData, ListSelfPacedCoursesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListSelfPacedCoursesData, ListSelfPacedCoursesParameters> | undefined;
        /** @summary Self Paced Courses */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError> | QueryFiltersByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>, updater: Updater<NoInfer<ListSelfPacedCoursesData> | undefined, NoInfer<ListSelfPacedCoursesData> | undefined>, options?: SetDataOptions): Array<ListSelfPacedCoursesData | undefined>;
        /** @summary Self Paced Courses */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Self Paced Courses */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError> | QueryFiltersByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>, options?: RefetchOptions): Promise<void>;
        /** @summary Self Paced Courses */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError> | QueryFiltersByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>, options?: CancelOptions): Promise<void>;
        /** @summary Self Paced Courses */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError> | QueryFiltersByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>): void;
        /** @summary Self Paced Courses */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError> | QueryFiltersByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>, options?: ResetOptions): Promise<void>;
        /** @summary Self Paced Courses */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError> | QueryFiltersByQueryKey<ListSelfPacedCoursesSchema, ListSelfPacedCoursesData, TInfinite, ListSelfPacedCoursesParameters, ListSelfPacedCoursesError>): number;
        schema: ListSelfPacedCoursesSchema;
        types: {
            parameters: ListSelfPacedCoursesParameters;
            data: ListSelfPacedCoursesData;
            error: ListSelfPacedCoursesError;
        };
    };
    /** @summary Course Detail By Slug */
    courseBySlug: {
        /** @summary Course Detail By Slug */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<CourseBySlugSchema, CourseBySlugParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<CourseBySlugParameters, TMeta, TSignal>), client?: (schema: CourseBySlugSchema, options: {
            parameters: CourseBySlugParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<CourseBySlugData, CourseBySlugError>>): Promise<RequestFnResponse<CourseBySlugData, CourseBySlugError>>;
        /** @summary Course Detail By Slug */
        getQueryKey(parameters: DeepReadonly<CourseBySlugParameters>): ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseBySlug.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseBySlugData>(parameters: ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>), options?: Omit<UndefinedInitialDataOptions<CourseBySlugData, CourseBySlugError, TData, ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters>>, "queryKey">): UseQueryResult<TData, OperationError<CourseBySlugError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseBySlug.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseBySlugData>(parameters: ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>), options: Omit<DefinedInitialDataOptions<CourseBySlugData, CourseBySlugError, TData, ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<CourseBySlugError>>;
        /** @summary Course Detail By Slug */
        getInfiniteQueryKey(parameters: DeepReadonly<CourseBySlugParameters>): ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseBySlug.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseBySlugParameters, TQueryFnData = CourseBySlugData, TData = OperationInfiniteData<TQueryFnData, CourseBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, CourseBySlugError, TData, ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<CourseBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseBySlug.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseBySlugParameters, TQueryFnData = CourseBySlugData, TData = OperationInfiniteData<TQueryFnData, CourseBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, CourseBySlugError, TData, ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<CourseBySlugError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const courseBySlugTotal = qraft.v3Service.courseBySlug.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const courseBySlugByParametersTotal = qraft.v3Service.courseBySlug.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError> | QueryFiltersByQueryKey<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const courseBySlugResults = qraft.v3Service.courseBySlug.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const courseBySlugCombinedResults = qraft.v3Service.courseBySlug.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseBySlugCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<CourseBySlugSchema, CourseBySlugParameters, CourseBySlugData, CourseBySlugError>>, TCombinedResult = Array<UseQueryResult<CourseBySlugData, CourseBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<CourseBySlugData, CourseBySlugError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.courseBySlug.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = CourseBySlugData>(parameters: ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>), options?: Omit<UseSuspenseQueryOptions<CourseBySlugData, CourseBySlugError, TData, ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<CourseBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseBySlug.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends CourseBySlugParameters, TData = CourseBySlugData>(parameters: ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<CourseBySlugData, CourseBySlugError, OperationInfiniteData<TData, CourseBySlugParameters>, ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, CourseBySlugParameters>, OperationError<CourseBySlugError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Course Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const courseBySlugData = qraft.v3Service.courseBySlug.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const courseBySlugCombinedData = qraft.v3Service.courseBySlug.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseBySlugCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<CourseBySlugSchema, CourseBySlugParameters, CourseBySlugData, CourseBySlugError>>, TCombinedResult = Array<UseSuspenseQueryResult<CourseBySlugData, CourseBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<CourseBySlugData, CourseBySlugError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Course Detail By Slug */
        fetchQuery(options: ServiceOperationFetchQueryOptions<CourseBySlugSchema, CourseBySlugData, CourseBySlugParameters, CourseBySlugError>): Promise<CourseBySlugData>;
        /** @summary Course Detail By Slug */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<CourseBySlugSchema, CourseBySlugData, CourseBySlugParameters, CourseBySlugError>): Promise<void>;
        /** @summary Course Detail By Slug */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<CourseBySlugSchema, CourseBySlugData, CourseBySlugParameters, CourseBySlugError>): Promise<CourseBySlugData>;
        /** @summary Course Detail By Slug */
        fetchInfiniteQuery<TPageParam extends CourseBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseBySlugSchema, CourseBySlugData, CourseBySlugParameters, DeepReadonly<TPageParam>, CourseBySlugError>): Promise<OperationInfiniteData<CourseBySlugData, CourseBySlugParameters>>;
        /** @summary Course Detail By Slug */
        prefetchInfiniteQuery<TPageParam extends CourseBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseBySlugSchema, CourseBySlugData, CourseBySlugParameters, DeepReadonly<TPageParam>, CourseBySlugError>): Promise<void>;
        /** @summary Course Detail By Slug */
        ensureInfiniteQueryData<TPageParam extends CourseBySlugParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<CourseBySlugSchema, CourseBySlugData, CourseBySlugParameters, DeepReadonly<TPageParam>, CourseBySlugError>): Promise<OperationInfiniteData<CourseBySlugData, CourseBySlugParameters>>;
        /** @summary Course Detail By Slug */
        getQueryData(parameters: ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>)): CourseBySlugData | undefined;
        /** @summary Course Detail By Slug */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>)): OperationInfiniteData<CourseBySlugData, CourseBySlugParameters> | undefined;
        /** @summary Course Detail By Slug */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError> | QueryFiltersByQueryKey<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters>,
            data: NoInfer<OperationInfiniteData<CourseBySlugData, CourseBySlugParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters>,
            data: CourseBySlugData | undefined
        ]>;
        /** @summary Course Detail By Slug */
        getQueryState(parameters: ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters> | (DeepReadonly<CourseBySlugParameters>)): QueryState<CourseBySlugData, CourseBySlugError> | undefined;
        /** @summary Course Detail By Slug */
        getInfiniteQueryState(parameters: DeepReadonly<CourseBySlugParameters> | ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters>): QueryState<OperationInfiniteData<CourseBySlugData, CourseBySlugParameters>, CourseBySlugError> | undefined;
        /** @summary Course Detail By Slug */
        setQueryData(parameters: (DeepReadonly<CourseBySlugParameters>) | ServiceOperationQueryKey<CourseBySlugSchema, CourseBySlugParameters>, updater: Updater<NoInfer<CourseBySlugData> | undefined, NoInfer<DeepReadonly<CourseBySlugData>> | undefined>, options?: SetDataOptions): CourseBySlugData | undefined;
        /** @summary Course Detail By Slug */
        setInfiniteQueryData(parameters: (DeepReadonly<CourseBySlugParameters>) | ServiceOperationInfiniteQueryKey<CourseBySlugSchema, CourseBySlugParameters>, updater: Updater<NoInfer<OperationInfiniteData<CourseBySlugData, CourseBySlugParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<CourseBySlugData, CourseBySlugParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<CourseBySlugData, CourseBySlugParameters> | undefined;
        /** @summary Course Detail By Slug */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError> | QueryFiltersByQueryKey<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>, updater: Updater<NoInfer<CourseBySlugData> | undefined, NoInfer<CourseBySlugData> | undefined>, options?: SetDataOptions): Array<CourseBySlugData | undefined>;
        /** @summary Course Detail By Slug */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Course Detail By Slug */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError> | QueryFiltersByQueryKey<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>, options?: RefetchOptions): Promise<void>;
        /** @summary Course Detail By Slug */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError> | QueryFiltersByQueryKey<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>, options?: CancelOptions): Promise<void>;
        /** @summary Course Detail By Slug */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError> | QueryFiltersByQueryKey<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>): void;
        /** @summary Course Detail By Slug */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError> | QueryFiltersByQueryKey<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>, options?: ResetOptions): Promise<void>;
        /** @summary Course Detail By Slug */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError> | QueryFiltersByQueryKey<CourseBySlugSchema, CourseBySlugData, TInfinite, CourseBySlugParameters, CourseBySlugError>): number;
        schema: CourseBySlugSchema;
        types: {
            parameters: CourseBySlugParameters;
            data: CourseBySlugData;
            error: CourseBySlugError;
        };
    };
    /** @summary Lesson Detail By Slug */
    lessonBySlug: {
        /** @summary Lesson Detail By Slug */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<LessonBySlugSchema, LessonBySlugParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<LessonBySlugParameters, TMeta, TSignal>), client?: (schema: LessonBySlugSchema, options: {
            parameters: LessonBySlugParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<LessonBySlugData, LessonBySlugError>>): Promise<RequestFnResponse<LessonBySlugData, LessonBySlugError>>;
        /** @summary Lesson Detail By Slug */
        getQueryKey(parameters: DeepReadonly<LessonBySlugParameters>): ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonBySlug.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonBySlugData>(parameters: ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>), options?: Omit<UndefinedInitialDataOptions<LessonBySlugData, LessonBySlugError, TData, ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters>>, "queryKey">): UseQueryResult<TData, OperationError<LessonBySlugError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonBySlug.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonBySlugData>(parameters: ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>), options: Omit<DefinedInitialDataOptions<LessonBySlugData, LessonBySlugError, TData, ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<LessonBySlugError>>;
        /** @summary Lesson Detail By Slug */
        getInfiniteQueryKey(parameters: DeepReadonly<LessonBySlugParameters>): ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonBySlug.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonBySlugParameters, TQueryFnData = LessonBySlugData, TData = OperationInfiniteData<TQueryFnData, LessonBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, LessonBySlugError, TData, ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<LessonBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonBySlug.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonBySlugParameters, TQueryFnData = LessonBySlugData, TData = OperationInfiniteData<TQueryFnData, LessonBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, LessonBySlugError, TData, ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<LessonBySlugError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const lessonBySlugTotal = qraft.v3Service.lessonBySlug.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const lessonBySlugByParametersTotal = qraft.v3Service.lessonBySlug.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError> | QueryFiltersByQueryKey<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const lessonBySlugResults = qraft.v3Service.lessonBySlug.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const lessonBySlugCombinedResults = qraft.v3Service.lessonBySlug.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonBySlugCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<LessonBySlugSchema, LessonBySlugParameters, LessonBySlugData, LessonBySlugError>>, TCombinedResult = Array<UseQueryResult<LessonBySlugData, LessonBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<LessonBySlugData, LessonBySlugError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.lessonBySlug.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = LessonBySlugData>(parameters: ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>), options?: Omit<UseSuspenseQueryOptions<LessonBySlugData, LessonBySlugError, TData, ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<LessonBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonBySlug.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends LessonBySlugParameters, TData = LessonBySlugData>(parameters: ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<LessonBySlugData, LessonBySlugError, OperationInfiniteData<TData, LessonBySlugParameters>, ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, LessonBySlugParameters>, OperationError<LessonBySlugError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Lesson Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const lessonBySlugData = qraft.v3Service.lessonBySlug.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const lessonBySlugCombinedData = qraft.v3Service.lessonBySlug.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonBySlugCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<LessonBySlugSchema, LessonBySlugParameters, LessonBySlugData, LessonBySlugError>>, TCombinedResult = Array<UseSuspenseQueryResult<LessonBySlugData, LessonBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<LessonBySlugData, LessonBySlugError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Lesson Detail By Slug */
        fetchQuery(options: ServiceOperationFetchQueryOptions<LessonBySlugSchema, LessonBySlugData, LessonBySlugParameters, LessonBySlugError>): Promise<LessonBySlugData>;
        /** @summary Lesson Detail By Slug */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<LessonBySlugSchema, LessonBySlugData, LessonBySlugParameters, LessonBySlugError>): Promise<void>;
        /** @summary Lesson Detail By Slug */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<LessonBySlugSchema, LessonBySlugData, LessonBySlugParameters, LessonBySlugError>): Promise<LessonBySlugData>;
        /** @summary Lesson Detail By Slug */
        fetchInfiniteQuery<TPageParam extends LessonBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonBySlugSchema, LessonBySlugData, LessonBySlugParameters, DeepReadonly<TPageParam>, LessonBySlugError>): Promise<OperationInfiniteData<LessonBySlugData, LessonBySlugParameters>>;
        /** @summary Lesson Detail By Slug */
        prefetchInfiniteQuery<TPageParam extends LessonBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonBySlugSchema, LessonBySlugData, LessonBySlugParameters, DeepReadonly<TPageParam>, LessonBySlugError>): Promise<void>;
        /** @summary Lesson Detail By Slug */
        ensureInfiniteQueryData<TPageParam extends LessonBySlugParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<LessonBySlugSchema, LessonBySlugData, LessonBySlugParameters, DeepReadonly<TPageParam>, LessonBySlugError>): Promise<OperationInfiniteData<LessonBySlugData, LessonBySlugParameters>>;
        /** @summary Lesson Detail By Slug */
        getQueryData(parameters: ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>)): LessonBySlugData | undefined;
        /** @summary Lesson Detail By Slug */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>)): OperationInfiniteData<LessonBySlugData, LessonBySlugParameters> | undefined;
        /** @summary Lesson Detail By Slug */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError> | QueryFiltersByQueryKey<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters>,
            data: NoInfer<OperationInfiniteData<LessonBySlugData, LessonBySlugParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters>,
            data: LessonBySlugData | undefined
        ]>;
        /** @summary Lesson Detail By Slug */
        getQueryState(parameters: ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters> | (DeepReadonly<LessonBySlugParameters>)): QueryState<LessonBySlugData, LessonBySlugError> | undefined;
        /** @summary Lesson Detail By Slug */
        getInfiniteQueryState(parameters: DeepReadonly<LessonBySlugParameters> | ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters>): QueryState<OperationInfiniteData<LessonBySlugData, LessonBySlugParameters>, LessonBySlugError> | undefined;
        /** @summary Lesson Detail By Slug */
        setQueryData(parameters: (DeepReadonly<LessonBySlugParameters>) | ServiceOperationQueryKey<LessonBySlugSchema, LessonBySlugParameters>, updater: Updater<NoInfer<LessonBySlugData> | undefined, NoInfer<DeepReadonly<LessonBySlugData>> | undefined>, options?: SetDataOptions): LessonBySlugData | undefined;
        /** @summary Lesson Detail By Slug */
        setInfiniteQueryData(parameters: (DeepReadonly<LessonBySlugParameters>) | ServiceOperationInfiniteQueryKey<LessonBySlugSchema, LessonBySlugParameters>, updater: Updater<NoInfer<OperationInfiniteData<LessonBySlugData, LessonBySlugParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<LessonBySlugData, LessonBySlugParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<LessonBySlugData, LessonBySlugParameters> | undefined;
        /** @summary Lesson Detail By Slug */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError> | QueryFiltersByQueryKey<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>, updater: Updater<NoInfer<LessonBySlugData> | undefined, NoInfer<LessonBySlugData> | undefined>, options?: SetDataOptions): Array<LessonBySlugData | undefined>;
        /** @summary Lesson Detail By Slug */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Lesson Detail By Slug */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError> | QueryFiltersByQueryKey<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>, options?: RefetchOptions): Promise<void>;
        /** @summary Lesson Detail By Slug */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError> | QueryFiltersByQueryKey<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>, options?: CancelOptions): Promise<void>;
        /** @summary Lesson Detail By Slug */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError> | QueryFiltersByQueryKey<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>): void;
        /** @summary Lesson Detail By Slug */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError> | QueryFiltersByQueryKey<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>, options?: ResetOptions): Promise<void>;
        /** @summary Lesson Detail By Slug */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError> | QueryFiltersByQueryKey<LessonBySlugSchema, LessonBySlugData, TInfinite, LessonBySlugParameters, LessonBySlugError>): number;
        schema: LessonBySlugSchema;
        types: {
            parameters: LessonBySlugParameters;
            data: LessonBySlugData;
            error: LessonBySlugError;
        };
    };
    /** @summary Topic Detail By Slug */
    topicBySlug: {
        /** @summary Topic Detail By Slug */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<TopicBySlugSchema, TopicBySlugParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<TopicBySlugParameters, TMeta, TSignal>), client?: (schema: TopicBySlugSchema, options: {
            parameters: TopicBySlugParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<TopicBySlugData, TopicBySlugError>>): Promise<RequestFnResponse<TopicBySlugData, TopicBySlugError>>;
        /** @summary Topic Detail By Slug */
        getQueryKey(parameters: DeepReadonly<TopicBySlugParameters>): ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.topicBySlug.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = TopicBySlugData>(parameters: ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>), options?: Omit<UndefinedInitialDataOptions<TopicBySlugData, TopicBySlugError, TData, ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters>>, "queryKey">): UseQueryResult<TData, OperationError<TopicBySlugError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.topicBySlug.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = TopicBySlugData>(parameters: ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>), options: Omit<DefinedInitialDataOptions<TopicBySlugData, TopicBySlugError, TData, ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<TopicBySlugError>>;
        /** @summary Topic Detail By Slug */
        getInfiniteQueryKey(parameters: DeepReadonly<TopicBySlugParameters>): ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicBySlug.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TopicBySlugParameters, TQueryFnData = TopicBySlugData, TData = OperationInfiniteData<TQueryFnData, TopicBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, TopicBySlugError, TData, ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<TopicBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicBySlug.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TopicBySlugParameters, TQueryFnData = TopicBySlugData, TData = OperationInfiniteData<TQueryFnData, TopicBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, TopicBySlugError, TData, ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TopicBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<TopicBySlugError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const topicBySlugTotal = qraft.v3Service.topicBySlug.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const topicBySlugByParametersTotal = qraft.v3Service.topicBySlug.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError> | QueryFiltersByQueryKey<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const topicBySlugResults = qraft.v3Service.topicBySlug.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const topicBySlugCombinedResults = qraft.v3Service.topicBySlug.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicBySlugCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<TopicBySlugSchema, TopicBySlugParameters, TopicBySlugData, TopicBySlugError>>, TCombinedResult = Array<UseQueryResult<TopicBySlugData, TopicBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<TopicBySlugData, TopicBySlugError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.topicBySlug.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = TopicBySlugData>(parameters: ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>), options?: Omit<UseSuspenseQueryOptions<TopicBySlugData, TopicBySlugError, TData, ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<TopicBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicBySlug.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends TopicBySlugParameters, TData = TopicBySlugData>(parameters: ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<TopicBySlugData, TopicBySlugError, OperationInfiniteData<TData, TopicBySlugParameters>, ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TopicBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, TopicBySlugParameters>, OperationError<TopicBySlugError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Topic Detail By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const topicBySlugData = qraft.v3Service.topicBySlug.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const topicBySlugCombinedData = qraft.v3Service.topicBySlug.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicBySlugCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<TopicBySlugSchema, TopicBySlugParameters, TopicBySlugData, TopicBySlugError>>, TCombinedResult = Array<UseSuspenseQueryResult<TopicBySlugData, TopicBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<TopicBySlugData, TopicBySlugError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Topic Detail By Slug */
        fetchQuery(options: ServiceOperationFetchQueryOptions<TopicBySlugSchema, TopicBySlugData, TopicBySlugParameters, TopicBySlugError>): Promise<TopicBySlugData>;
        /** @summary Topic Detail By Slug */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<TopicBySlugSchema, TopicBySlugData, TopicBySlugParameters, TopicBySlugError>): Promise<void>;
        /** @summary Topic Detail By Slug */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<TopicBySlugSchema, TopicBySlugData, TopicBySlugParameters, TopicBySlugError>): Promise<TopicBySlugData>;
        /** @summary Topic Detail By Slug */
        fetchInfiniteQuery<TPageParam extends TopicBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TopicBySlugSchema, TopicBySlugData, TopicBySlugParameters, DeepReadonly<TPageParam>, TopicBySlugError>): Promise<OperationInfiniteData<TopicBySlugData, TopicBySlugParameters>>;
        /** @summary Topic Detail By Slug */
        prefetchInfiniteQuery<TPageParam extends TopicBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TopicBySlugSchema, TopicBySlugData, TopicBySlugParameters, DeepReadonly<TPageParam>, TopicBySlugError>): Promise<void>;
        /** @summary Topic Detail By Slug */
        ensureInfiniteQueryData<TPageParam extends TopicBySlugParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<TopicBySlugSchema, TopicBySlugData, TopicBySlugParameters, DeepReadonly<TPageParam>, TopicBySlugError>): Promise<OperationInfiniteData<TopicBySlugData, TopicBySlugParameters>>;
        /** @summary Topic Detail By Slug */
        getQueryData(parameters: ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>)): TopicBySlugData | undefined;
        /** @summary Topic Detail By Slug */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>)): OperationInfiniteData<TopicBySlugData, TopicBySlugParameters> | undefined;
        /** @summary Topic Detail By Slug */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError> | QueryFiltersByQueryKey<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters>,
            data: NoInfer<OperationInfiniteData<TopicBySlugData, TopicBySlugParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters>,
            data: TopicBySlugData | undefined
        ]>;
        /** @summary Topic Detail By Slug */
        getQueryState(parameters: ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters> | (DeepReadonly<TopicBySlugParameters>)): QueryState<TopicBySlugData, TopicBySlugError> | undefined;
        /** @summary Topic Detail By Slug */
        getInfiniteQueryState(parameters: DeepReadonly<TopicBySlugParameters> | ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters>): QueryState<OperationInfiniteData<TopicBySlugData, TopicBySlugParameters>, TopicBySlugError> | undefined;
        /** @summary Topic Detail By Slug */
        setQueryData(parameters: (DeepReadonly<TopicBySlugParameters>) | ServiceOperationQueryKey<TopicBySlugSchema, TopicBySlugParameters>, updater: Updater<NoInfer<TopicBySlugData> | undefined, NoInfer<DeepReadonly<TopicBySlugData>> | undefined>, options?: SetDataOptions): TopicBySlugData | undefined;
        /** @summary Topic Detail By Slug */
        setInfiniteQueryData(parameters: (DeepReadonly<TopicBySlugParameters>) | ServiceOperationInfiniteQueryKey<TopicBySlugSchema, TopicBySlugParameters>, updater: Updater<NoInfer<OperationInfiniteData<TopicBySlugData, TopicBySlugParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<TopicBySlugData, TopicBySlugParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<TopicBySlugData, TopicBySlugParameters> | undefined;
        /** @summary Topic Detail By Slug */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError> | QueryFiltersByQueryKey<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>, updater: Updater<NoInfer<TopicBySlugData> | undefined, NoInfer<TopicBySlugData> | undefined>, options?: SetDataOptions): Array<TopicBySlugData | undefined>;
        /** @summary Topic Detail By Slug */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Topic Detail By Slug */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError> | QueryFiltersByQueryKey<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>, options?: RefetchOptions): Promise<void>;
        /** @summary Topic Detail By Slug */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError> | QueryFiltersByQueryKey<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>, options?: CancelOptions): Promise<void>;
        /** @summary Topic Detail By Slug */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError> | QueryFiltersByQueryKey<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>): void;
        /** @summary Topic Detail By Slug */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError> | QueryFiltersByQueryKey<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>, options?: ResetOptions): Promise<void>;
        /** @summary Topic Detail By Slug */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError> | QueryFiltersByQueryKey<TopicBySlugSchema, TopicBySlugData, TInfinite, TopicBySlugParameters, TopicBySlugError>): number;
        schema: TopicBySlugSchema;
        types: {
            parameters: TopicBySlugParameters;
            data: TopicBySlugData;
            error: TopicBySlugError;
        };
    };
    /** @summary Quiz By Slug */
    quizBySlug: {
        /** @summary Quiz By Slug */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<QuizBySlugSchema, QuizBySlugParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<QuizBySlugParameters, TMeta, TSignal>), client?: (schema: QuizBySlugSchema, options: {
            parameters: QuizBySlugParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<QuizBySlugData, QuizBySlugError>>): Promise<RequestFnResponse<QuizBySlugData, QuizBySlugError>>;
        /** @summary Quiz By Slug */
        getQueryKey(parameters: DeepReadonly<QuizBySlugParameters>): ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.quizBySlug.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = QuizBySlugData>(parameters: ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>), options?: Omit<UndefinedInitialDataOptions<QuizBySlugData, QuizBySlugError, TData, ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters>>, "queryKey">): UseQueryResult<TData, OperationError<QuizBySlugError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.quizBySlug.useQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = QuizBySlugData>(parameters: ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>), options: Omit<DefinedInitialDataOptions<QuizBySlugData, QuizBySlugError, TData, ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<QuizBySlugError>>;
        /** @summary Quiz By Slug */
        getInfiniteQueryKey(parameters: DeepReadonly<QuizBySlugParameters>): ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.quizBySlug.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends QuizBySlugParameters, TQueryFnData = QuizBySlugData, TData = OperationInfiniteData<TQueryFnData, QuizBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, QuizBySlugError, TData, ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<QuizBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.quizBySlug.useInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends QuizBySlugParameters, TQueryFnData = QuizBySlugData, TData = OperationInfiniteData<TQueryFnData, QuizBySlugParameters>>(parameters: ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, QuizBySlugError, TData, ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<QuizBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<QuizBySlugError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const quizBySlugTotal = qraft.v3Service.quizBySlug.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const quizBySlugByParametersTotal = qraft.v3Service.quizBySlug.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             slug: slug
         *         },
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError> | QueryFiltersByQueryKey<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const quizBySlugResults = qraft.v3Service.quizBySlug.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * quizBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const quizBySlugCombinedResults = qraft.v3Service.quizBySlug.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * quizBySlugCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<QuizBySlugSchema, QuizBySlugParameters, QuizBySlugData, QuizBySlugError>>, TCombinedResult = Array<UseQueryResult<QuizBySlugData, QuizBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<QuizBySlugData, QuizBySlugError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.quizBySlug.useSuspenseQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = QuizBySlugData>(parameters: ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>), options?: Omit<UseSuspenseQueryOptions<QuizBySlugData, QuizBySlugError, TData, ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<QuizBySlugError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.quizBySlug.useSuspenseInfiniteQuery({
         *     path: {
         *         slug: slug
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends QuizBySlugParameters, TData = QuizBySlugData>(parameters: ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<QuizBySlugData, QuizBySlugError, OperationInfiniteData<TData, QuizBySlugParameters>, ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<QuizBySlugData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, QuizBySlugParameters>, OperationError<QuizBySlugError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Quiz By Slug
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const quizBySlugData = qraft.v3Service.quizBySlug.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * quizBySlugResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const quizBySlugCombinedData = qraft.v3Service.quizBySlug.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 slug: slug1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 slug: slug2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * quizBySlugCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<QuizBySlugSchema, QuizBySlugParameters, QuizBySlugData, QuizBySlugError>>, TCombinedResult = Array<UseSuspenseQueryResult<QuizBySlugData, QuizBySlugError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<QuizBySlugData, QuizBySlugError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Quiz By Slug */
        fetchQuery(options: ServiceOperationFetchQueryOptions<QuizBySlugSchema, QuizBySlugData, QuizBySlugParameters, QuizBySlugError>): Promise<QuizBySlugData>;
        /** @summary Quiz By Slug */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<QuizBySlugSchema, QuizBySlugData, QuizBySlugParameters, QuizBySlugError>): Promise<void>;
        /** @summary Quiz By Slug */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<QuizBySlugSchema, QuizBySlugData, QuizBySlugParameters, QuizBySlugError>): Promise<QuizBySlugData>;
        /** @summary Quiz By Slug */
        fetchInfiniteQuery<TPageParam extends QuizBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<QuizBySlugSchema, QuizBySlugData, QuizBySlugParameters, DeepReadonly<TPageParam>, QuizBySlugError>): Promise<OperationInfiniteData<QuizBySlugData, QuizBySlugParameters>>;
        /** @summary Quiz By Slug */
        prefetchInfiniteQuery<TPageParam extends QuizBySlugParameters>(options: ServiceOperationFetchInfiniteQueryOptions<QuizBySlugSchema, QuizBySlugData, QuizBySlugParameters, DeepReadonly<TPageParam>, QuizBySlugError>): Promise<void>;
        /** @summary Quiz By Slug */
        ensureInfiniteQueryData<TPageParam extends QuizBySlugParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<QuizBySlugSchema, QuizBySlugData, QuizBySlugParameters, DeepReadonly<TPageParam>, QuizBySlugError>): Promise<OperationInfiniteData<QuizBySlugData, QuizBySlugParameters>>;
        /** @summary Quiz By Slug */
        getQueryData(parameters: ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>)): QuizBySlugData | undefined;
        /** @summary Quiz By Slug */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>)): OperationInfiniteData<QuizBySlugData, QuizBySlugParameters> | undefined;
        /** @summary Quiz By Slug */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError> | QueryFiltersByQueryKey<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters>,
            data: NoInfer<OperationInfiniteData<QuizBySlugData, QuizBySlugParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters>,
            data: QuizBySlugData | undefined
        ]>;
        /** @summary Quiz By Slug */
        getQueryState(parameters: ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters> | (DeepReadonly<QuizBySlugParameters>)): QueryState<QuizBySlugData, QuizBySlugError> | undefined;
        /** @summary Quiz By Slug */
        getInfiniteQueryState(parameters: DeepReadonly<QuizBySlugParameters> | ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters>): QueryState<OperationInfiniteData<QuizBySlugData, QuizBySlugParameters>, QuizBySlugError> | undefined;
        /** @summary Quiz By Slug */
        setQueryData(parameters: (DeepReadonly<QuizBySlugParameters>) | ServiceOperationQueryKey<QuizBySlugSchema, QuizBySlugParameters>, updater: Updater<NoInfer<QuizBySlugData> | undefined, NoInfer<DeepReadonly<QuizBySlugData>> | undefined>, options?: SetDataOptions): QuizBySlugData | undefined;
        /** @summary Quiz By Slug */
        setInfiniteQueryData(parameters: (DeepReadonly<QuizBySlugParameters>) | ServiceOperationInfiniteQueryKey<QuizBySlugSchema, QuizBySlugParameters>, updater: Updater<NoInfer<OperationInfiniteData<QuizBySlugData, QuizBySlugParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<QuizBySlugData, QuizBySlugParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<QuizBySlugData, QuizBySlugParameters> | undefined;
        /** @summary Quiz By Slug */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError> | QueryFiltersByQueryKey<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>, updater: Updater<NoInfer<QuizBySlugData> | undefined, NoInfer<QuizBySlugData> | undefined>, options?: SetDataOptions): Array<QuizBySlugData | undefined>;
        /** @summary Quiz By Slug */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Quiz By Slug */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError> | QueryFiltersByQueryKey<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>, options?: RefetchOptions): Promise<void>;
        /** @summary Quiz By Slug */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError> | QueryFiltersByQueryKey<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>, options?: CancelOptions): Promise<void>;
        /** @summary Quiz By Slug */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError> | QueryFiltersByQueryKey<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>): void;
        /** @summary Quiz By Slug */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError> | QueryFiltersByQueryKey<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>, options?: ResetOptions): Promise<void>;
        /** @summary Quiz By Slug */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError> | QueryFiltersByQueryKey<QuizBySlugSchema, QuizBySlugData, TInfinite, QuizBySlugParameters, QuizBySlugError>): number;
        schema: QuizBySlugSchema;
        types: {
            parameters: QuizBySlugParameters;
            data: QuizBySlugData;
            error: QuizBySlugError;
        };
    };
    /** @summary Course Detail */
    courseDetail: {
        /** @summary Course Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<CourseDetailSchema, CourseDetailParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<CourseDetailParameters, TMeta, TSignal>), client?: (schema: CourseDetailSchema, options: {
            parameters: CourseDetailParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<CourseDetailData, CourseDetailError>>): Promise<RequestFnResponse<CourseDetailData, CourseDetailError>>;
        /** @summary Course Detail */
        getQueryKey(parameters: DeepReadonly<CourseDetailParameters>): ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseDetail.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseDetailData>(parameters: ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>), options?: Omit<UndefinedInitialDataOptions<CourseDetailData, CourseDetailError, TData, ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters>>, "queryKey">): UseQueryResult<TData, OperationError<CourseDetailError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseDetail.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseDetailData>(parameters: ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>), options: Omit<DefinedInitialDataOptions<CourseDetailData, CourseDetailError, TData, ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<CourseDetailError>>;
        /** @summary Course Detail */
        getInfiniteQueryKey(parameters: DeepReadonly<CourseDetailParameters>): ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseDetail.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseDetailParameters, TQueryFnData = CourseDetailData, TData = OperationInfiniteData<TQueryFnData, CourseDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, CourseDetailError, TData, ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<CourseDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseDetail.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseDetailParameters, TQueryFnData = CourseDetailData, TData = OperationInfiniteData<TQueryFnData, CourseDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, CourseDetailError, TData, ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseDetailData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<CourseDetailError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const courseDetailTotal = qraft.v3Service.courseDetail.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const courseDetailByParametersTotal = qraft.v3Service.courseDetail.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         query: {
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError> | QueryFiltersByQueryKey<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const courseDetailResults = qraft.v3Service.courseDetail.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const courseDetailCombinedResults = qraft.v3Service.courseDetail.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseDetailCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<CourseDetailSchema, CourseDetailParameters, CourseDetailData, CourseDetailError>>, TCombinedResult = Array<UseQueryResult<CourseDetailData, CourseDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<CourseDetailData, CourseDetailError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.courseDetail.useSuspenseQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = CourseDetailData>(parameters: ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>), options?: Omit<UseSuspenseQueryOptions<CourseDetailData, CourseDetailError, TData, ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<CourseDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseDetail.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends CourseDetailParameters, TData = CourseDetailData>(parameters: ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<CourseDetailData, CourseDetailError, OperationInfiniteData<TData, CourseDetailParameters>, ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseDetailData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, CourseDetailParameters>, OperationError<CourseDetailError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const courseDetailData = qraft.v3Service.courseDetail.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const courseDetailCombinedData = qraft.v3Service.courseDetail.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseDetailCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<CourseDetailSchema, CourseDetailParameters, CourseDetailData, CourseDetailError>>, TCombinedResult = Array<UseSuspenseQueryResult<CourseDetailData, CourseDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<CourseDetailData, CourseDetailError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Course Detail */
        fetchQuery(options: ServiceOperationFetchQueryOptions<CourseDetailSchema, CourseDetailData, CourseDetailParameters, CourseDetailError>): Promise<CourseDetailData>;
        /** @summary Course Detail */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<CourseDetailSchema, CourseDetailData, CourseDetailParameters, CourseDetailError>): Promise<void>;
        /** @summary Course Detail */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<CourseDetailSchema, CourseDetailData, CourseDetailParameters, CourseDetailError>): Promise<CourseDetailData>;
        /** @summary Course Detail */
        fetchInfiniteQuery<TPageParam extends CourseDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseDetailSchema, CourseDetailData, CourseDetailParameters, DeepReadonly<TPageParam>, CourseDetailError>): Promise<OperationInfiniteData<CourseDetailData, CourseDetailParameters>>;
        /** @summary Course Detail */
        prefetchInfiniteQuery<TPageParam extends CourseDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseDetailSchema, CourseDetailData, CourseDetailParameters, DeepReadonly<TPageParam>, CourseDetailError>): Promise<void>;
        /** @summary Course Detail */
        ensureInfiniteQueryData<TPageParam extends CourseDetailParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<CourseDetailSchema, CourseDetailData, CourseDetailParameters, DeepReadonly<TPageParam>, CourseDetailError>): Promise<OperationInfiniteData<CourseDetailData, CourseDetailParameters>>;
        /** @summary Course Detail */
        getQueryData(parameters: ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>)): CourseDetailData | undefined;
        /** @summary Course Detail */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>)): OperationInfiniteData<CourseDetailData, CourseDetailParameters> | undefined;
        /** @summary Course Detail */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError> | QueryFiltersByQueryKey<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters>,
            data: NoInfer<OperationInfiniteData<CourseDetailData, CourseDetailParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters>,
            data: CourseDetailData | undefined
        ]>;
        /** @summary Course Detail */
        getQueryState(parameters: ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters> | (DeepReadonly<CourseDetailParameters>)): QueryState<CourseDetailData, CourseDetailError> | undefined;
        /** @summary Course Detail */
        getInfiniteQueryState(parameters: DeepReadonly<CourseDetailParameters> | ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters>): QueryState<OperationInfiniteData<CourseDetailData, CourseDetailParameters>, CourseDetailError> | undefined;
        /** @summary Course Detail */
        setQueryData(parameters: (DeepReadonly<CourseDetailParameters>) | ServiceOperationQueryKey<CourseDetailSchema, CourseDetailParameters>, updater: Updater<NoInfer<CourseDetailData> | undefined, NoInfer<DeepReadonly<CourseDetailData>> | undefined>, options?: SetDataOptions): CourseDetailData | undefined;
        /** @summary Course Detail */
        setInfiniteQueryData(parameters: (DeepReadonly<CourseDetailParameters>) | ServiceOperationInfiniteQueryKey<CourseDetailSchema, CourseDetailParameters>, updater: Updater<NoInfer<OperationInfiniteData<CourseDetailData, CourseDetailParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<CourseDetailData, CourseDetailParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<CourseDetailData, CourseDetailParameters> | undefined;
        /** @summary Course Detail */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError> | QueryFiltersByQueryKey<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>, updater: Updater<NoInfer<CourseDetailData> | undefined, NoInfer<CourseDetailData> | undefined>, options?: SetDataOptions): Array<CourseDetailData | undefined>;
        /** @summary Course Detail */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Course Detail */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError> | QueryFiltersByQueryKey<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>, options?: RefetchOptions): Promise<void>;
        /** @summary Course Detail */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError> | QueryFiltersByQueryKey<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>, options?: CancelOptions): Promise<void>;
        /** @summary Course Detail */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError> | QueryFiltersByQueryKey<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>): void;
        /** @summary Course Detail */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError> | QueryFiltersByQueryKey<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>, options?: ResetOptions): Promise<void>;
        /** @summary Course Detail */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError> | QueryFiltersByQueryKey<CourseDetailSchema, CourseDetailData, TInfinite, CourseDetailParameters, CourseDetailError>): number;
        schema: CourseDetailSchema;
        types: {
            parameters: CourseDetailParameters;
            data: CourseDetailData;
            error: CourseDetailError;
        };
    };
    /** @summary Course Lessons */
    courseLessons: {
        /** @summary Course Lessons */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<CourseLessonsSchema, CourseLessonsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<CourseLessonsParameters, TMeta, TSignal>), client?: (schema: CourseLessonsSchema, options: {
            parameters: CourseLessonsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<CourseLessonsData, CourseLessonsError>>): Promise<RequestFnResponse<CourseLessonsData, CourseLessonsError>>;
        /** @summary Course Lessons */
        getQueryKey(parameters: DeepReadonly<CourseLessonsParameters>): ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseLessons.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseLessonsData>(parameters: ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>), options?: Omit<UndefinedInitialDataOptions<CourseLessonsData, CourseLessonsError, TData, ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<CourseLessonsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseLessons.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseLessonsData>(parameters: ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>), options: Omit<DefinedInitialDataOptions<CourseLessonsData, CourseLessonsError, TData, ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<CourseLessonsError>>;
        /** @summary Course Lessons */
        getInfiniteQueryKey(parameters: DeepReadonly<CourseLessonsParameters>): ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseLessons.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseLessonsParameters, TQueryFnData = CourseLessonsData, TData = OperationInfiniteData<TQueryFnData, CourseLessonsParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, CourseLessonsError, TData, ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<CourseLessonsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseLessons.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseLessonsParameters, TQueryFnData = CourseLessonsData, TData = OperationInfiniteData<TQueryFnData, CourseLessonsParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, CourseLessonsError, TData, ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseLessonsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<CourseLessonsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const courseLessonsTotal = qraft.v3Service.courseLessons.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const courseLessonsByParametersTotal = qraft.v3Service.courseLessons.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         query: {
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError> | QueryFiltersByQueryKey<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const courseLessonsResults = qraft.v3Service.courseLessons.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseLessonsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const courseLessonsCombinedResults = qraft.v3Service.courseLessons.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseLessonsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<CourseLessonsSchema, CourseLessonsParameters, CourseLessonsData, CourseLessonsError>>, TCombinedResult = Array<UseQueryResult<CourseLessonsData, CourseLessonsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<CourseLessonsData, CourseLessonsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.courseLessons.useSuspenseQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = CourseLessonsData>(parameters: ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>), options?: Omit<UseSuspenseQueryOptions<CourseLessonsData, CourseLessonsError, TData, ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<CourseLessonsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseLessons.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends CourseLessonsParameters, TData = CourseLessonsData>(parameters: ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<CourseLessonsData, CourseLessonsError, OperationInfiniteData<TData, CourseLessonsParameters>, ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseLessonsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, CourseLessonsParameters>, OperationError<CourseLessonsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Course Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const courseLessonsData = qraft.v3Service.courseLessons.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseLessonsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const courseLessonsCombinedData = qraft.v3Service.courseLessons.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseLessonsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<CourseLessonsSchema, CourseLessonsParameters, CourseLessonsData, CourseLessonsError>>, TCombinedResult = Array<UseSuspenseQueryResult<CourseLessonsData, CourseLessonsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<CourseLessonsData, CourseLessonsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Course Lessons */
        fetchQuery(options: ServiceOperationFetchQueryOptions<CourseLessonsSchema, CourseLessonsData, CourseLessonsParameters, CourseLessonsError>): Promise<CourseLessonsData>;
        /** @summary Course Lessons */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<CourseLessonsSchema, CourseLessonsData, CourseLessonsParameters, CourseLessonsError>): Promise<void>;
        /** @summary Course Lessons */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<CourseLessonsSchema, CourseLessonsData, CourseLessonsParameters, CourseLessonsError>): Promise<CourseLessonsData>;
        /** @summary Course Lessons */
        fetchInfiniteQuery<TPageParam extends CourseLessonsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseLessonsSchema, CourseLessonsData, CourseLessonsParameters, DeepReadonly<TPageParam>, CourseLessonsError>): Promise<OperationInfiniteData<CourseLessonsData, CourseLessonsParameters>>;
        /** @summary Course Lessons */
        prefetchInfiniteQuery<TPageParam extends CourseLessonsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseLessonsSchema, CourseLessonsData, CourseLessonsParameters, DeepReadonly<TPageParam>, CourseLessonsError>): Promise<void>;
        /** @summary Course Lessons */
        ensureInfiniteQueryData<TPageParam extends CourseLessonsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<CourseLessonsSchema, CourseLessonsData, CourseLessonsParameters, DeepReadonly<TPageParam>, CourseLessonsError>): Promise<OperationInfiniteData<CourseLessonsData, CourseLessonsParameters>>;
        /** @summary Course Lessons */
        getQueryData(parameters: ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>)): CourseLessonsData | undefined;
        /** @summary Course Lessons */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>)): OperationInfiniteData<CourseLessonsData, CourseLessonsParameters> | undefined;
        /** @summary Course Lessons */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError> | QueryFiltersByQueryKey<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters>,
            data: NoInfer<OperationInfiniteData<CourseLessonsData, CourseLessonsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters>,
            data: CourseLessonsData | undefined
        ]>;
        /** @summary Course Lessons */
        getQueryState(parameters: ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters> | (DeepReadonly<CourseLessonsParameters>)): QueryState<CourseLessonsData, CourseLessonsError> | undefined;
        /** @summary Course Lessons */
        getInfiniteQueryState(parameters: DeepReadonly<CourseLessonsParameters> | ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters>): QueryState<OperationInfiniteData<CourseLessonsData, CourseLessonsParameters>, CourseLessonsError> | undefined;
        /** @summary Course Lessons */
        setQueryData(parameters: (DeepReadonly<CourseLessonsParameters>) | ServiceOperationQueryKey<CourseLessonsSchema, CourseLessonsParameters>, updater: Updater<NoInfer<CourseLessonsData> | undefined, NoInfer<DeepReadonly<CourseLessonsData>> | undefined>, options?: SetDataOptions): CourseLessonsData | undefined;
        /** @summary Course Lessons */
        setInfiniteQueryData(parameters: (DeepReadonly<CourseLessonsParameters>) | ServiceOperationInfiniteQueryKey<CourseLessonsSchema, CourseLessonsParameters>, updater: Updater<NoInfer<OperationInfiniteData<CourseLessonsData, CourseLessonsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<CourseLessonsData, CourseLessonsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<CourseLessonsData, CourseLessonsParameters> | undefined;
        /** @summary Course Lessons */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError> | QueryFiltersByQueryKey<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>, updater: Updater<NoInfer<CourseLessonsData> | undefined, NoInfer<CourseLessonsData> | undefined>, options?: SetDataOptions): Array<CourseLessonsData | undefined>;
        /** @summary Course Lessons */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Course Lessons */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError> | QueryFiltersByQueryKey<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Course Lessons */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError> | QueryFiltersByQueryKey<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>, options?: CancelOptions): Promise<void>;
        /** @summary Course Lessons */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError> | QueryFiltersByQueryKey<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>): void;
        /** @summary Course Lessons */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError> | QueryFiltersByQueryKey<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>, options?: ResetOptions): Promise<void>;
        /** @summary Course Lessons */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError> | QueryFiltersByQueryKey<CourseLessonsSchema, CourseLessonsData, TInfinite, CourseLessonsParameters, CourseLessonsError>): number;
        schema: CourseLessonsSchema;
        types: {
            parameters: CourseLessonsParameters;
            data: CourseLessonsData;
            error: CourseLessonsError;
        };
    };
    /** @summary Lesson Detail */
    lessonDetail: {
        /** @summary Lesson Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<LessonDetailSchema, LessonDetailParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<LessonDetailParameters, TMeta, TSignal>), client?: (schema: LessonDetailSchema, options: {
            parameters: LessonDetailParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<LessonDetailData, LessonDetailError>>): Promise<RequestFnResponse<LessonDetailData, LessonDetailError>>;
        /** @summary Lesson Detail */
        getQueryKey(parameters: DeepReadonly<LessonDetailParameters>): ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonDetail.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonDetailData>(parameters: ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>), options?: Omit<UndefinedInitialDataOptions<LessonDetailData, LessonDetailError, TData, ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters>>, "queryKey">): UseQueryResult<TData, OperationError<LessonDetailError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonDetail.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonDetailData>(parameters: ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>), options: Omit<DefinedInitialDataOptions<LessonDetailData, LessonDetailError, TData, ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<LessonDetailError>>;
        /** @summary Lesson Detail */
        getInfiniteQueryKey(parameters: DeepReadonly<LessonDetailParameters>): ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonDetail.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonDetailParameters, TQueryFnData = LessonDetailData, TData = OperationInfiniteData<TQueryFnData, LessonDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, LessonDetailError, TData, ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<LessonDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonDetail.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonDetailParameters, TQueryFnData = LessonDetailData, TData = OperationInfiniteData<TQueryFnData, LessonDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, LessonDetailError, TData, ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonDetailData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<LessonDetailError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const lessonDetailTotal = qraft.v3Service.lessonDetail.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const lessonDetailByParametersTotal = qraft.v3Service.lessonDetail.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError> | QueryFiltersByQueryKey<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const lessonDetailResults = qraft.v3Service.lessonDetail.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const lessonDetailCombinedResults = qraft.v3Service.lessonDetail.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonDetailCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<LessonDetailSchema, LessonDetailParameters, LessonDetailData, LessonDetailError>>, TCombinedResult = Array<UseQueryResult<LessonDetailData, LessonDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<LessonDetailData, LessonDetailError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.lessonDetail.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = LessonDetailData>(parameters: ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>), options?: Omit<UseSuspenseQueryOptions<LessonDetailData, LessonDetailError, TData, ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<LessonDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonDetail.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends LessonDetailParameters, TData = LessonDetailData>(parameters: ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<LessonDetailData, LessonDetailError, OperationInfiniteData<TData, LessonDetailParameters>, ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonDetailData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, LessonDetailParameters>, OperationError<LessonDetailError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const lessonDetailData = qraft.v3Service.lessonDetail.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const lessonDetailCombinedData = qraft.v3Service.lessonDetail.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonDetailCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<LessonDetailSchema, LessonDetailParameters, LessonDetailData, LessonDetailError>>, TCombinedResult = Array<UseSuspenseQueryResult<LessonDetailData, LessonDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<LessonDetailData, LessonDetailError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Lesson Detail */
        fetchQuery(options: ServiceOperationFetchQueryOptions<LessonDetailSchema, LessonDetailData, LessonDetailParameters, LessonDetailError>): Promise<LessonDetailData>;
        /** @summary Lesson Detail */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<LessonDetailSchema, LessonDetailData, LessonDetailParameters, LessonDetailError>): Promise<void>;
        /** @summary Lesson Detail */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<LessonDetailSchema, LessonDetailData, LessonDetailParameters, LessonDetailError>): Promise<LessonDetailData>;
        /** @summary Lesson Detail */
        fetchInfiniteQuery<TPageParam extends LessonDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonDetailSchema, LessonDetailData, LessonDetailParameters, DeepReadonly<TPageParam>, LessonDetailError>): Promise<OperationInfiniteData<LessonDetailData, LessonDetailParameters>>;
        /** @summary Lesson Detail */
        prefetchInfiniteQuery<TPageParam extends LessonDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonDetailSchema, LessonDetailData, LessonDetailParameters, DeepReadonly<TPageParam>, LessonDetailError>): Promise<void>;
        /** @summary Lesson Detail */
        ensureInfiniteQueryData<TPageParam extends LessonDetailParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<LessonDetailSchema, LessonDetailData, LessonDetailParameters, DeepReadonly<TPageParam>, LessonDetailError>): Promise<OperationInfiniteData<LessonDetailData, LessonDetailParameters>>;
        /** @summary Lesson Detail */
        getQueryData(parameters: ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>)): LessonDetailData | undefined;
        /** @summary Lesson Detail */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>)): OperationInfiniteData<LessonDetailData, LessonDetailParameters> | undefined;
        /** @summary Lesson Detail */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError> | QueryFiltersByQueryKey<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters>,
            data: NoInfer<OperationInfiniteData<LessonDetailData, LessonDetailParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters>,
            data: LessonDetailData | undefined
        ]>;
        /** @summary Lesson Detail */
        getQueryState(parameters: ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters> | (DeepReadonly<LessonDetailParameters>)): QueryState<LessonDetailData, LessonDetailError> | undefined;
        /** @summary Lesson Detail */
        getInfiniteQueryState(parameters: DeepReadonly<LessonDetailParameters> | ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters>): QueryState<OperationInfiniteData<LessonDetailData, LessonDetailParameters>, LessonDetailError> | undefined;
        /** @summary Lesson Detail */
        setQueryData(parameters: (DeepReadonly<LessonDetailParameters>) | ServiceOperationQueryKey<LessonDetailSchema, LessonDetailParameters>, updater: Updater<NoInfer<LessonDetailData> | undefined, NoInfer<DeepReadonly<LessonDetailData>> | undefined>, options?: SetDataOptions): LessonDetailData | undefined;
        /** @summary Lesson Detail */
        setInfiniteQueryData(parameters: (DeepReadonly<LessonDetailParameters>) | ServiceOperationInfiniteQueryKey<LessonDetailSchema, LessonDetailParameters>, updater: Updater<NoInfer<OperationInfiniteData<LessonDetailData, LessonDetailParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<LessonDetailData, LessonDetailParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<LessonDetailData, LessonDetailParameters> | undefined;
        /** @summary Lesson Detail */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError> | QueryFiltersByQueryKey<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>, updater: Updater<NoInfer<LessonDetailData> | undefined, NoInfer<LessonDetailData> | undefined>, options?: SetDataOptions): Array<LessonDetailData | undefined>;
        /** @summary Lesson Detail */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Lesson Detail */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError> | QueryFiltersByQueryKey<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>, options?: RefetchOptions): Promise<void>;
        /** @summary Lesson Detail */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError> | QueryFiltersByQueryKey<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>, options?: CancelOptions): Promise<void>;
        /** @summary Lesson Detail */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError> | QueryFiltersByQueryKey<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>): void;
        /** @summary Lesson Detail */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError> | QueryFiltersByQueryKey<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>, options?: ResetOptions): Promise<void>;
        /** @summary Lesson Detail */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError> | QueryFiltersByQueryKey<LessonDetailSchema, LessonDetailData, TInfinite, LessonDetailParameters, LessonDetailError>): number;
        schema: LessonDetailSchema;
        types: {
            parameters: LessonDetailParameters;
            data: LessonDetailData;
            error: LessonDetailError;
        };
    };
    /** @summary Lesson Topics */
    lessonTopics: {
        /** @summary Lesson Topics */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<LessonTopicsSchema, LessonTopicsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<LessonTopicsParameters, TMeta, TSignal>), client?: (schema: LessonTopicsSchema, options: {
            parameters: LessonTopicsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<LessonTopicsData, LessonTopicsError>>): Promise<RequestFnResponse<LessonTopicsData, LessonTopicsError>>;
        /** @summary Lesson Topics */
        getQueryKey(parameters: DeepReadonly<LessonTopicsParameters>): ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonTopics.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonTopicsData>(parameters: ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>), options?: Omit<UndefinedInitialDataOptions<LessonTopicsData, LessonTopicsError, TData, ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<LessonTopicsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonTopics.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonTopicsData>(parameters: ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>), options: Omit<DefinedInitialDataOptions<LessonTopicsData, LessonTopicsError, TData, ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<LessonTopicsError>>;
        /** @summary Lesson Topics */
        getInfiniteQueryKey(parameters: DeepReadonly<LessonTopicsParameters>): ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonTopics.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonTopicsParameters, TQueryFnData = LessonTopicsData, TData = OperationInfiniteData<TQueryFnData, LessonTopicsParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, LessonTopicsError, TData, ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<LessonTopicsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonTopics.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonTopicsParameters, TQueryFnData = LessonTopicsData, TData = OperationInfiniteData<TQueryFnData, LessonTopicsParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, LessonTopicsError, TData, ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonTopicsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<LessonTopicsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const lessonTopicsTotal = qraft.v3Service.lessonTopics.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const lessonTopicsByParametersTotal = qraft.v3Service.lessonTopics.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError> | QueryFiltersByQueryKey<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const lessonTopicsResults = qraft.v3Service.lessonTopics.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonTopicsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const lessonTopicsCombinedResults = qraft.v3Service.lessonTopics.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonTopicsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<LessonTopicsSchema, LessonTopicsParameters, LessonTopicsData, LessonTopicsError>>, TCombinedResult = Array<UseQueryResult<LessonTopicsData, LessonTopicsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<LessonTopicsData, LessonTopicsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.lessonTopics.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = LessonTopicsData>(parameters: ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>), options?: Omit<UseSuspenseQueryOptions<LessonTopicsData, LessonTopicsError, TData, ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<LessonTopicsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonTopics.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends LessonTopicsParameters, TData = LessonTopicsData>(parameters: ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<LessonTopicsData, LessonTopicsError, OperationInfiniteData<TData, LessonTopicsParameters>, ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonTopicsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, LessonTopicsParameters>, OperationError<LessonTopicsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Lesson Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const lessonTopicsData = qraft.v3Service.lessonTopics.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonTopicsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const lessonTopicsCombinedData = qraft.v3Service.lessonTopics.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonTopicsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<LessonTopicsSchema, LessonTopicsParameters, LessonTopicsData, LessonTopicsError>>, TCombinedResult = Array<UseSuspenseQueryResult<LessonTopicsData, LessonTopicsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<LessonTopicsData, LessonTopicsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Lesson Topics */
        fetchQuery(options: ServiceOperationFetchQueryOptions<LessonTopicsSchema, LessonTopicsData, LessonTopicsParameters, LessonTopicsError>): Promise<LessonTopicsData>;
        /** @summary Lesson Topics */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<LessonTopicsSchema, LessonTopicsData, LessonTopicsParameters, LessonTopicsError>): Promise<void>;
        /** @summary Lesson Topics */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<LessonTopicsSchema, LessonTopicsData, LessonTopicsParameters, LessonTopicsError>): Promise<LessonTopicsData>;
        /** @summary Lesson Topics */
        fetchInfiniteQuery<TPageParam extends LessonTopicsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonTopicsSchema, LessonTopicsData, LessonTopicsParameters, DeepReadonly<TPageParam>, LessonTopicsError>): Promise<OperationInfiniteData<LessonTopicsData, LessonTopicsParameters>>;
        /** @summary Lesson Topics */
        prefetchInfiniteQuery<TPageParam extends LessonTopicsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonTopicsSchema, LessonTopicsData, LessonTopicsParameters, DeepReadonly<TPageParam>, LessonTopicsError>): Promise<void>;
        /** @summary Lesson Topics */
        ensureInfiniteQueryData<TPageParam extends LessonTopicsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<LessonTopicsSchema, LessonTopicsData, LessonTopicsParameters, DeepReadonly<TPageParam>, LessonTopicsError>): Promise<OperationInfiniteData<LessonTopicsData, LessonTopicsParameters>>;
        /** @summary Lesson Topics */
        getQueryData(parameters: ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>)): LessonTopicsData | undefined;
        /** @summary Lesson Topics */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>)): OperationInfiniteData<LessonTopicsData, LessonTopicsParameters> | undefined;
        /** @summary Lesson Topics */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError> | QueryFiltersByQueryKey<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters>,
            data: NoInfer<OperationInfiniteData<LessonTopicsData, LessonTopicsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters>,
            data: LessonTopicsData | undefined
        ]>;
        /** @summary Lesson Topics */
        getQueryState(parameters: ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters> | (DeepReadonly<LessonTopicsParameters>)): QueryState<LessonTopicsData, LessonTopicsError> | undefined;
        /** @summary Lesson Topics */
        getInfiniteQueryState(parameters: DeepReadonly<LessonTopicsParameters> | ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters>): QueryState<OperationInfiniteData<LessonTopicsData, LessonTopicsParameters>, LessonTopicsError> | undefined;
        /** @summary Lesson Topics */
        setQueryData(parameters: (DeepReadonly<LessonTopicsParameters>) | ServiceOperationQueryKey<LessonTopicsSchema, LessonTopicsParameters>, updater: Updater<NoInfer<LessonTopicsData> | undefined, NoInfer<DeepReadonly<LessonTopicsData>> | undefined>, options?: SetDataOptions): LessonTopicsData | undefined;
        /** @summary Lesson Topics */
        setInfiniteQueryData(parameters: (DeepReadonly<LessonTopicsParameters>) | ServiceOperationInfiniteQueryKey<LessonTopicsSchema, LessonTopicsParameters>, updater: Updater<NoInfer<OperationInfiniteData<LessonTopicsData, LessonTopicsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<LessonTopicsData, LessonTopicsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<LessonTopicsData, LessonTopicsParameters> | undefined;
        /** @summary Lesson Topics */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError> | QueryFiltersByQueryKey<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>, updater: Updater<NoInfer<LessonTopicsData> | undefined, NoInfer<LessonTopicsData> | undefined>, options?: SetDataOptions): Array<LessonTopicsData | undefined>;
        /** @summary Lesson Topics */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Lesson Topics */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError> | QueryFiltersByQueryKey<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Lesson Topics */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError> | QueryFiltersByQueryKey<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>, options?: CancelOptions): Promise<void>;
        /** @summary Lesson Topics */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError> | QueryFiltersByQueryKey<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>): void;
        /** @summary Lesson Topics */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError> | QueryFiltersByQueryKey<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>, options?: ResetOptions): Promise<void>;
        /** @summary Lesson Topics */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError> | QueryFiltersByQueryKey<LessonTopicsSchema, LessonTopicsData, TInfinite, LessonTopicsParameters, LessonTopicsError>): number;
        schema: LessonTopicsSchema;
        types: {
            parameters: LessonTopicsParameters;
            data: LessonTopicsData;
            error: LessonTopicsError;
        };
    };
    /** @summary Topic Detail */
    topicDetail: {
        /** @summary Topic Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<TopicDetailSchema, TopicDetailParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<TopicDetailParameters, TMeta, TSignal>), client?: (schema: TopicDetailSchema, options: {
            parameters: TopicDetailParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<TopicDetailData, TopicDetailError>>): Promise<RequestFnResponse<TopicDetailData, TopicDetailError>>;
        /** @summary Topic Detail */
        getQueryKey(parameters: DeepReadonly<TopicDetailParameters>): ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.topicDetail.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = TopicDetailData>(parameters: ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>), options?: Omit<UndefinedInitialDataOptions<TopicDetailData, TopicDetailError, TData, ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters>>, "queryKey">): UseQueryResult<TData, OperationError<TopicDetailError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.topicDetail.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = TopicDetailData>(parameters: ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>), options: Omit<DefinedInitialDataOptions<TopicDetailData, TopicDetailError, TData, ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<TopicDetailError>>;
        /** @summary Topic Detail */
        getInfiniteQueryKey(parameters: DeepReadonly<TopicDetailParameters>): ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicDetail.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TopicDetailParameters, TQueryFnData = TopicDetailData, TData = OperationInfiniteData<TQueryFnData, TopicDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, TopicDetailError, TData, ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<TopicDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicDetail.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TopicDetailParameters, TQueryFnData = TopicDetailData, TData = OperationInfiniteData<TQueryFnData, TopicDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, TopicDetailError, TData, ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TopicDetailData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<TopicDetailError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const topicDetailTotal = qraft.v3Service.topicDetail.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const topicDetailByParametersTotal = qraft.v3Service.topicDetail.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError> | QueryFiltersByQueryKey<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const topicDetailResults = qraft.v3Service.topicDetail.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const topicDetailCombinedResults = qraft.v3Service.topicDetail.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicDetailCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<TopicDetailSchema, TopicDetailParameters, TopicDetailData, TopicDetailError>>, TCombinedResult = Array<UseQueryResult<TopicDetailData, TopicDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<TopicDetailData, TopicDetailError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.topicDetail.useSuspenseQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = TopicDetailData>(parameters: ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>), options?: Omit<UseSuspenseQueryOptions<TopicDetailData, TopicDetailError, TData, ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<TopicDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicDetail.useSuspenseInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends TopicDetailParameters, TData = TopicDetailData>(parameters: ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<TopicDetailData, TopicDetailError, OperationInfiniteData<TData, TopicDetailParameters>, ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TopicDetailData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, TopicDetailParameters>, OperationError<TopicDetailError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const topicDetailData = qraft.v3Service.topicDetail.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const topicDetailCombinedData = qraft.v3Service.topicDetail.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicDetailCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<TopicDetailSchema, TopicDetailParameters, TopicDetailData, TopicDetailError>>, TCombinedResult = Array<UseSuspenseQueryResult<TopicDetailData, TopicDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<TopicDetailData, TopicDetailError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Topic Detail */
        fetchQuery(options: ServiceOperationFetchQueryOptions<TopicDetailSchema, TopicDetailData, TopicDetailParameters, TopicDetailError>): Promise<TopicDetailData>;
        /** @summary Topic Detail */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<TopicDetailSchema, TopicDetailData, TopicDetailParameters, TopicDetailError>): Promise<void>;
        /** @summary Topic Detail */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<TopicDetailSchema, TopicDetailData, TopicDetailParameters, TopicDetailError>): Promise<TopicDetailData>;
        /** @summary Topic Detail */
        fetchInfiniteQuery<TPageParam extends TopicDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TopicDetailSchema, TopicDetailData, TopicDetailParameters, DeepReadonly<TPageParam>, TopicDetailError>): Promise<OperationInfiniteData<TopicDetailData, TopicDetailParameters>>;
        /** @summary Topic Detail */
        prefetchInfiniteQuery<TPageParam extends TopicDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TopicDetailSchema, TopicDetailData, TopicDetailParameters, DeepReadonly<TPageParam>, TopicDetailError>): Promise<void>;
        /** @summary Topic Detail */
        ensureInfiniteQueryData<TPageParam extends TopicDetailParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<TopicDetailSchema, TopicDetailData, TopicDetailParameters, DeepReadonly<TPageParam>, TopicDetailError>): Promise<OperationInfiniteData<TopicDetailData, TopicDetailParameters>>;
        /** @summary Topic Detail */
        getQueryData(parameters: ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>)): TopicDetailData | undefined;
        /** @summary Topic Detail */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>)): OperationInfiniteData<TopicDetailData, TopicDetailParameters> | undefined;
        /** @summary Topic Detail */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError> | QueryFiltersByQueryKey<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters>,
            data: NoInfer<OperationInfiniteData<TopicDetailData, TopicDetailParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters>,
            data: TopicDetailData | undefined
        ]>;
        /** @summary Topic Detail */
        getQueryState(parameters: ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters> | (DeepReadonly<TopicDetailParameters>)): QueryState<TopicDetailData, TopicDetailError> | undefined;
        /** @summary Topic Detail */
        getInfiniteQueryState(parameters: DeepReadonly<TopicDetailParameters> | ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters>): QueryState<OperationInfiniteData<TopicDetailData, TopicDetailParameters>, TopicDetailError> | undefined;
        /** @summary Topic Detail */
        setQueryData(parameters: (DeepReadonly<TopicDetailParameters>) | ServiceOperationQueryKey<TopicDetailSchema, TopicDetailParameters>, updater: Updater<NoInfer<TopicDetailData> | undefined, NoInfer<DeepReadonly<TopicDetailData>> | undefined>, options?: SetDataOptions): TopicDetailData | undefined;
        /** @summary Topic Detail */
        setInfiniteQueryData(parameters: (DeepReadonly<TopicDetailParameters>) | ServiceOperationInfiniteQueryKey<TopicDetailSchema, TopicDetailParameters>, updater: Updater<NoInfer<OperationInfiniteData<TopicDetailData, TopicDetailParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<TopicDetailData, TopicDetailParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<TopicDetailData, TopicDetailParameters> | undefined;
        /** @summary Topic Detail */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError> | QueryFiltersByQueryKey<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>, updater: Updater<NoInfer<TopicDetailData> | undefined, NoInfer<TopicDetailData> | undefined>, options?: SetDataOptions): Array<TopicDetailData | undefined>;
        /** @summary Topic Detail */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Topic Detail */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError> | QueryFiltersByQueryKey<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>, options?: RefetchOptions): Promise<void>;
        /** @summary Topic Detail */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError> | QueryFiltersByQueryKey<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>, options?: CancelOptions): Promise<void>;
        /** @summary Topic Detail */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError> | QueryFiltersByQueryKey<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>): void;
        /** @summary Topic Detail */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError> | QueryFiltersByQueryKey<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>, options?: ResetOptions): Promise<void>;
        /** @summary Topic Detail */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError> | QueryFiltersByQueryKey<TopicDetailSchema, TopicDetailData, TInfinite, TopicDetailParameters, TopicDetailError>): number;
        schema: TopicDetailSchema;
        types: {
            parameters: TopicDetailParameters;
            data: TopicDetailData;
            error: TopicDetailError;
        };
    };
    /** @summary Lesson Questions */
    lessonQuestions: {
        /** @summary Lesson Questions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<LessonQuestionsSchema, LessonQuestionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<LessonQuestionsParameters, TMeta, TSignal>), client?: (schema: LessonQuestionsSchema, options: {
            parameters: LessonQuestionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<LessonQuestionsData, LessonQuestionsError>>): Promise<RequestFnResponse<LessonQuestionsData, LessonQuestionsError>>;
        /** @summary Lesson Questions */
        getQueryKey(parameters: DeepReadonly<LessonQuestionsParameters>): ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonQuestions.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonQuestionsData>(parameters: ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>), options?: Omit<UndefinedInitialDataOptions<LessonQuestionsData, LessonQuestionsError, TData, ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<LessonQuestionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonQuestions.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonQuestionsData>(parameters: ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>), options: Omit<DefinedInitialDataOptions<LessonQuestionsData, LessonQuestionsError, TData, ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<LessonQuestionsError>>;
        /** @summary Lesson Questions */
        getInfiniteQueryKey(parameters: DeepReadonly<LessonQuestionsParameters>): ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuestions.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonQuestionsParameters, TQueryFnData = LessonQuestionsData, TData = OperationInfiniteData<TQueryFnData, LessonQuestionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, LessonQuestionsError, TData, ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<LessonQuestionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuestions.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonQuestionsParameters, TQueryFnData = LessonQuestionsData, TData = OperationInfiniteData<TQueryFnData, LessonQuestionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, LessonQuestionsError, TData, ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonQuestionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<LessonQuestionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const lessonQuestionsTotal = qraft.v3Service.lessonQuestions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const lessonQuestionsByParametersTotal = qraft.v3Service.lessonQuestions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError> | QueryFiltersByQueryKey<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const lessonQuestionsResults = qraft.v3Service.lessonQuestions.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const lessonQuestionsCombinedResults = qraft.v3Service.lessonQuestions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuestionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<LessonQuestionsSchema, LessonQuestionsParameters, LessonQuestionsData, LessonQuestionsError>>, TCombinedResult = Array<UseQueryResult<LessonQuestionsData, LessonQuestionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<LessonQuestionsData, LessonQuestionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.lessonQuestions.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = LessonQuestionsData>(parameters: ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>), options?: Omit<UseSuspenseQueryOptions<LessonQuestionsData, LessonQuestionsError, TData, ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<LessonQuestionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuestions.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends LessonQuestionsParameters, TData = LessonQuestionsData>(parameters: ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<LessonQuestionsData, LessonQuestionsError, OperationInfiniteData<TData, LessonQuestionsParameters>, ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonQuestionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, LessonQuestionsParameters>, OperationError<LessonQuestionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const lessonQuestionsData = qraft.v3Service.lessonQuestions.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const lessonQuestionsCombinedData = qraft.v3Service.lessonQuestions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuestionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<LessonQuestionsSchema, LessonQuestionsParameters, LessonQuestionsData, LessonQuestionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<LessonQuestionsData, LessonQuestionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<LessonQuestionsData, LessonQuestionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Lesson Questions */
        fetchQuery(options: ServiceOperationFetchQueryOptions<LessonQuestionsSchema, LessonQuestionsData, LessonQuestionsParameters, LessonQuestionsError>): Promise<LessonQuestionsData>;
        /** @summary Lesson Questions */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<LessonQuestionsSchema, LessonQuestionsData, LessonQuestionsParameters, LessonQuestionsError>): Promise<void>;
        /** @summary Lesson Questions */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<LessonQuestionsSchema, LessonQuestionsData, LessonQuestionsParameters, LessonQuestionsError>): Promise<LessonQuestionsData>;
        /** @summary Lesson Questions */
        fetchInfiniteQuery<TPageParam extends LessonQuestionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonQuestionsSchema, LessonQuestionsData, LessonQuestionsParameters, DeepReadonly<TPageParam>, LessonQuestionsError>): Promise<OperationInfiniteData<LessonQuestionsData, LessonQuestionsParameters>>;
        /** @summary Lesson Questions */
        prefetchInfiniteQuery<TPageParam extends LessonQuestionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonQuestionsSchema, LessonQuestionsData, LessonQuestionsParameters, DeepReadonly<TPageParam>, LessonQuestionsError>): Promise<void>;
        /** @summary Lesson Questions */
        ensureInfiniteQueryData<TPageParam extends LessonQuestionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<LessonQuestionsSchema, LessonQuestionsData, LessonQuestionsParameters, DeepReadonly<TPageParam>, LessonQuestionsError>): Promise<OperationInfiniteData<LessonQuestionsData, LessonQuestionsParameters>>;
        /** @summary Lesson Questions */
        getQueryData(parameters: ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>)): LessonQuestionsData | undefined;
        /** @summary Lesson Questions */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>)): OperationInfiniteData<LessonQuestionsData, LessonQuestionsParameters> | undefined;
        /** @summary Lesson Questions */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError> | QueryFiltersByQueryKey<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>,
            data: NoInfer<OperationInfiniteData<LessonQuestionsData, LessonQuestionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>,
            data: LessonQuestionsData | undefined
        ]>;
        /** @summary Lesson Questions */
        getQueryState(parameters: ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters> | (DeepReadonly<LessonQuestionsParameters>)): QueryState<LessonQuestionsData, LessonQuestionsError> | undefined;
        /** @summary Lesson Questions */
        getInfiniteQueryState(parameters: DeepReadonly<LessonQuestionsParameters> | ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>): QueryState<OperationInfiniteData<LessonQuestionsData, LessonQuestionsParameters>, LessonQuestionsError> | undefined;
        /** @summary Lesson Questions */
        setQueryData(parameters: (DeepReadonly<LessonQuestionsParameters>) | ServiceOperationQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>, updater: Updater<NoInfer<LessonQuestionsData> | undefined, NoInfer<DeepReadonly<LessonQuestionsData>> | undefined>, options?: SetDataOptions): LessonQuestionsData | undefined;
        /** @summary Lesson Questions */
        setInfiniteQueryData(parameters: (DeepReadonly<LessonQuestionsParameters>) | ServiceOperationInfiniteQueryKey<LessonQuestionsSchema, LessonQuestionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<LessonQuestionsData, LessonQuestionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<LessonQuestionsData, LessonQuestionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<LessonQuestionsData, LessonQuestionsParameters> | undefined;
        /** @summary Lesson Questions */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError> | QueryFiltersByQueryKey<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>, updater: Updater<NoInfer<LessonQuestionsData> | undefined, NoInfer<LessonQuestionsData> | undefined>, options?: SetDataOptions): Array<LessonQuestionsData | undefined>;
        /** @summary Lesson Questions */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Lesson Questions */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError> | QueryFiltersByQueryKey<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Lesson Questions */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError> | QueryFiltersByQueryKey<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>, options?: CancelOptions): Promise<void>;
        /** @summary Lesson Questions */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError> | QueryFiltersByQueryKey<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>): void;
        /** @summary Lesson Questions */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError> | QueryFiltersByQueryKey<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>, options?: ResetOptions): Promise<void>;
        /** @summary Lesson Questions */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError> | QueryFiltersByQueryKey<LessonQuestionsSchema, LessonQuestionsData, TInfinite, LessonQuestionsParameters, LessonQuestionsError>): number;
        schema: LessonQuestionsSchema;
        types: {
            parameters: LessonQuestionsParameters;
            data: LessonQuestionsData;
            error: LessonQuestionsError;
        };
    };
    /** @summary Admin Get Topic */
    adminGetTopic: {
        /** @summary Admin Get Topic */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminGetTopicSchema, AdminGetTopicParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminGetTopicParameters, TMeta, TSignal>), client?: (schema: AdminGetTopicSchema, options: {
            parameters: AdminGetTopicParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminGetTopicData, AdminGetTopicError>>): Promise<RequestFnResponse<AdminGetTopicData, AdminGetTopicError>>;
        /** @summary Admin Get Topic */
        getQueryKey(parameters: DeepReadonly<AdminGetTopicParameters>): ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetTopic.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetTopicData>(parameters: ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>), options?: Omit<UndefinedInitialDataOptions<AdminGetTopicData, AdminGetTopicError, TData, ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminGetTopicError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetTopic.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetTopicData>(parameters: ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>), options: Omit<DefinedInitialDataOptions<AdminGetTopicData, AdminGetTopicError, TData, ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminGetTopicError>>;
        /** @summary Admin Get Topic */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminGetTopicParameters>): ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetTopic.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetTopicParameters, TQueryFnData = AdminGetTopicData, TData = OperationInfiniteData<TQueryFnData, AdminGetTopicParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetTopicError, TData, ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminGetTopicError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetTopic.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetTopicParameters, TQueryFnData = AdminGetTopicData, TData = OperationInfiniteData<TQueryFnData, AdminGetTopicParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetTopicError, TData, ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetTopicData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminGetTopicError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminGetTopicTotal = qraft.v3Service.adminGetTopic.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminGetTopicByParametersTotal = qraft.v3Service.adminGetTopic.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError> | QueryFiltersByQueryKey<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminGetTopicResults = qraft.v3Service.adminGetTopic.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetTopicResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminGetTopicCombinedResults = qraft.v3Service.adminGetTopic.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetTopicCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminGetTopicSchema, AdminGetTopicParameters, AdminGetTopicData, AdminGetTopicError>>, TCombinedResult = Array<UseQueryResult<AdminGetTopicData, AdminGetTopicError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminGetTopicData, AdminGetTopicError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminGetTopic.useSuspenseQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminGetTopicData>(parameters: ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>), options?: Omit<UseSuspenseQueryOptions<AdminGetTopicData, AdminGetTopicError, TData, ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminGetTopicError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetTopic.useSuspenseInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminGetTopicParameters, TData = AdminGetTopicData>(parameters: ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminGetTopicData, AdminGetTopicError, OperationInfiniteData<TData, AdminGetTopicParameters>, ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetTopicData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminGetTopicParameters>, OperationError<AdminGetTopicError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminGetTopicData = qraft.v3Service.adminGetTopic.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetTopicResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminGetTopicCombinedData = qraft.v3Service.adminGetTopic.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetTopicCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminGetTopicSchema, AdminGetTopicParameters, AdminGetTopicData, AdminGetTopicError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminGetTopicData, AdminGetTopicError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminGetTopicData, AdminGetTopicError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Get Topic */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetTopicSchema, AdminGetTopicData, AdminGetTopicParameters, AdminGetTopicError>): Promise<AdminGetTopicData>;
        /** @summary Admin Get Topic */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetTopicSchema, AdminGetTopicData, AdminGetTopicParameters, AdminGetTopicError>): Promise<void>;
        /** @summary Admin Get Topic */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminGetTopicSchema, AdminGetTopicData, AdminGetTopicParameters, AdminGetTopicError>): Promise<AdminGetTopicData>;
        /** @summary Admin Get Topic */
        fetchInfiniteQuery<TPageParam extends AdminGetTopicParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetTopicSchema, AdminGetTopicData, AdminGetTopicParameters, DeepReadonly<TPageParam>, AdminGetTopicError>): Promise<OperationInfiniteData<AdminGetTopicData, AdminGetTopicParameters>>;
        /** @summary Admin Get Topic */
        prefetchInfiniteQuery<TPageParam extends AdminGetTopicParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetTopicSchema, AdminGetTopicData, AdminGetTopicParameters, DeepReadonly<TPageParam>, AdminGetTopicError>): Promise<void>;
        /** @summary Admin Get Topic */
        ensureInfiniteQueryData<TPageParam extends AdminGetTopicParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminGetTopicSchema, AdminGetTopicData, AdminGetTopicParameters, DeepReadonly<TPageParam>, AdminGetTopicError>): Promise<OperationInfiniteData<AdminGetTopicData, AdminGetTopicParameters>>;
        /** @summary Admin Get Topic */
        getQueryData(parameters: ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>)): AdminGetTopicData | undefined;
        /** @summary Admin Get Topic */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>)): OperationInfiniteData<AdminGetTopicData, AdminGetTopicParameters> | undefined;
        /** @summary Admin Get Topic */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError> | QueryFiltersByQueryKey<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>,
            data: NoInfer<OperationInfiniteData<AdminGetTopicData, AdminGetTopicParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>,
            data: AdminGetTopicData | undefined
        ]>;
        /** @summary Admin Get Topic */
        getQueryState(parameters: ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters> | (DeepReadonly<AdminGetTopicParameters>)): QueryState<AdminGetTopicData, AdminGetTopicError> | undefined;
        /** @summary Admin Get Topic */
        getInfiniteQueryState(parameters: DeepReadonly<AdminGetTopicParameters> | ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>): QueryState<OperationInfiniteData<AdminGetTopicData, AdminGetTopicParameters>, AdminGetTopicError> | undefined;
        /** @summary Admin Get Topic */
        setQueryData(parameters: (DeepReadonly<AdminGetTopicParameters>) | ServiceOperationQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>, updater: Updater<NoInfer<AdminGetTopicData> | undefined, NoInfer<DeepReadonly<AdminGetTopicData>> | undefined>, options?: SetDataOptions): AdminGetTopicData | undefined;
        /** @summary Admin Get Topic */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminGetTopicParameters>) | ServiceOperationInfiniteQueryKey<AdminGetTopicSchema, AdminGetTopicParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminGetTopicData, AdminGetTopicParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminGetTopicData, AdminGetTopicParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminGetTopicData, AdminGetTopicParameters> | undefined;
        /** @summary Admin Get Topic */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError> | QueryFiltersByQueryKey<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>, updater: Updater<NoInfer<AdminGetTopicData> | undefined, NoInfer<AdminGetTopicData> | undefined>, options?: SetDataOptions): Array<AdminGetTopicData | undefined>;
        /** @summary Admin Get Topic */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Get Topic */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError> | QueryFiltersByQueryKey<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Get Topic */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError> | QueryFiltersByQueryKey<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Get Topic */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError> | QueryFiltersByQueryKey<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>): void;
        /** @summary Admin Get Topic */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError> | QueryFiltersByQueryKey<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Get Topic */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError> | QueryFiltersByQueryKey<AdminGetTopicSchema, AdminGetTopicData, TInfinite, AdminGetTopicParameters, AdminGetTopicError>): number;
        schema: AdminGetTopicSchema;
        types: {
            parameters: AdminGetTopicParameters;
            data: AdminGetTopicData;
            error: AdminGetTopicError;
        };
    };
    /** @summary Admin Update Topic */
    adminUpdateTopic: {
        /** @summary Admin Update Topic */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminUpdateTopicBody, AdminUpdateTopicParameters, TMeta, TSignal>, client?: (schema: AdminUpdateTopicSchema, options: ServiceOperationMutationFnOptions<AdminUpdateTopicBody, AdminUpdateTopicParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminUpdateTopicData, AdminUpdateTopicError>>): Promise<RequestFnResponse<AdminUpdateTopicData, AdminUpdateTopicError>>;
        /** @summary Admin Update Topic */
        getMutationKey(parameters: DeepReadonly<AdminUpdateTopicParameters> | void): ServiceOperationMutationKey<AdminUpdateTopicSchema, AdminUpdateTopicParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateTopic.useMutation({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateTopic.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminUpdateTopicBody, TContext = unknown>(parameters: DeepReadonly<AdminUpdateTopicParameters>, options?: ServiceOperationUseMutationOptions<AdminUpdateTopicSchema, AdminUpdateTopicData, AdminUpdateTopicParameters, TVariables, OperationError<AdminUpdateTopicError>, TContext>): UseMutationResult<AdminUpdateTopicData, OperationError<AdminUpdateTopicError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateTopic.useMutation({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateTopic.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminUpdateTopicBody, AdminUpdateTopicParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminUpdateTopicSchema, AdminUpdateTopicData, AdminUpdateTopicParameters, TVariables, OperationError<AdminUpdateTopicError>, TContext>): UseMutationResult<AdminUpdateTopicData, OperationError<AdminUpdateTopicError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Update Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminUpdateTopicTotal = qraft.v3Service.adminUpdateTopic.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminUpdateTopicTotal = qraft.v3Service.adminUpdateTopic.useIsMutating({
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext> | MutationFiltersByMutationKey<AdminUpdateTopicSchema, AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Update Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminUpdateTopicPendingMutationVariables = qraft.v3Service.adminUpdateTopic.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminUpdateTopicMutationData = qraft.v3Service.adminUpdateTopic.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 topic_id: topicId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminUpdateTopicData, OperationError<AdminUpdateTopicError>, MutationVariables<AdminUpdateTopicBody, AdminUpdateTopicParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext> | MutationFiltersByMutationKey<AdminUpdateTopicSchema, AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext>;
            select?: (mutation: Mutation<AdminUpdateTopicData, OperationError<AdminUpdateTopicError>, MutationVariables<AdminUpdateTopicBody, AdminUpdateTopicParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Update Topic */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext> | MutationFiltersByMutationKey<AdminUpdateTopicSchema, AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Update Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateTopic.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateTopic.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext> | MutationFiltersByMutationKey<AdminUpdateTopicSchema, AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext>): Mutation<AdminUpdateTopicData, AdminUpdateTopicError, MutationVariables<AdminUpdateTopicBody, AdminUpdateTopicParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext> | MutationFiltersByMutationKey<AdminUpdateTopicSchema, AdminUpdateTopicBody, AdminUpdateTopicData, AdminUpdateTopicParameters, OperationError<AdminUpdateTopicError>, TContext>): Array<Mutation<AdminUpdateTopicData, AdminUpdateTopicError, MutationVariables<AdminUpdateTopicBody, AdminUpdateTopicParameters>, TContext>>;
        };
        schema: AdminUpdateTopicSchema;
        types: {
            parameters: AdminUpdateTopicParameters;
            data: AdminUpdateTopicData;
            error: AdminUpdateTopicError;
            body: AdminUpdateTopicBody;
        };
    };
    /** @summary Admin Delete Topic */
    adminDeleteTopic: {
        /** @summary Admin Delete Topic */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminDeleteTopicBody, AdminDeleteTopicParameters, TMeta, TSignal>, client?: (schema: AdminDeleteTopicSchema, options: ServiceOperationMutationFnOptions<AdminDeleteTopicBody, AdminDeleteTopicParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminDeleteTopicData, AdminDeleteTopicError>>): Promise<RequestFnResponse<AdminDeleteTopicData, AdminDeleteTopicError>>;
        /** @summary Admin Delete Topic */
        getMutationKey(parameters: DeepReadonly<AdminDeleteTopicParameters> | void): ServiceOperationMutationKey<AdminDeleteTopicSchema, AdminDeleteTopicParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteTopic.useMutation({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteTopic.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminDeleteTopicBody, TContext = unknown>(parameters: DeepReadonly<AdminDeleteTopicParameters>, options?: ServiceOperationUseMutationOptions<AdminDeleteTopicSchema, AdminDeleteTopicData, AdminDeleteTopicParameters, TVariables, OperationError<AdminDeleteTopicError>, TContext>): UseMutationResult<AdminDeleteTopicData, OperationError<AdminDeleteTopicError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteTopic.useMutation({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteTopic.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminDeleteTopicBody, AdminDeleteTopicParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminDeleteTopicSchema, AdminDeleteTopicData, AdminDeleteTopicParameters, TVariables, OperationError<AdminDeleteTopicError>, TContext>): UseMutationResult<AdminDeleteTopicData, OperationError<AdminDeleteTopicError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Delete Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminDeleteTopicTotal = qraft.v3Service.adminDeleteTopic.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminDeleteTopicTotal = qraft.v3Service.adminDeleteTopic.useIsMutating({
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext> | MutationFiltersByMutationKey<AdminDeleteTopicSchema, AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Delete Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminDeleteTopicPendingMutationVariables = qraft.v3Service.adminDeleteTopic.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminDeleteTopicMutationData = qraft.v3Service.adminDeleteTopic.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 topic_id: topicId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminDeleteTopicData, OperationError<AdminDeleteTopicError>, MutationVariables<AdminDeleteTopicBody, AdminDeleteTopicParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext> | MutationFiltersByMutationKey<AdminDeleteTopicSchema, AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext>;
            select?: (mutation: Mutation<AdminDeleteTopicData, OperationError<AdminDeleteTopicError>, MutationVariables<AdminDeleteTopicBody, AdminDeleteTopicParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Delete Topic */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext> | MutationFiltersByMutationKey<AdminDeleteTopicSchema, AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Delete Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteTopic.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteTopic.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext> | MutationFiltersByMutationKey<AdminDeleteTopicSchema, AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext>): Mutation<AdminDeleteTopicData, AdminDeleteTopicError, MutationVariables<AdminDeleteTopicBody, AdminDeleteTopicParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext> | MutationFiltersByMutationKey<AdminDeleteTopicSchema, AdminDeleteTopicBody, AdminDeleteTopicData, AdminDeleteTopicParameters, OperationError<AdminDeleteTopicError>, TContext>): Array<Mutation<AdminDeleteTopicData, AdminDeleteTopicError, MutationVariables<AdminDeleteTopicBody, AdminDeleteTopicParameters>, TContext>>;
        };
        schema: AdminDeleteTopicSchema;
        types: {
            parameters: AdminDeleteTopicParameters;
            data: AdminDeleteTopicData;
            error: AdminDeleteTopicError;
            body: AdminDeleteTopicBody;
        };
    };
    /** @summary Admin List Topics */
    adminListTopics: {
        /** @summary Admin List Topics */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminListTopicsSchema, AdminListTopicsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminListTopicsParameters, TMeta, TSignal>), client?: (schema: AdminListTopicsSchema, options: {
            parameters: AdminListTopicsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminListTopicsData, AdminListTopicsError>>): Promise<RequestFnResponse<AdminListTopicsData, AdminListTopicsError>>;
        /** @summary Admin List Topics */
        getQueryKey(parameters: DeepReadonly<AdminListTopicsParameters>): ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListTopics.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListTopicsData>(parameters: ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>), options?: Omit<UndefinedInitialDataOptions<AdminListTopicsData, AdminListTopicsError, TData, ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminListTopicsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListTopics.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListTopicsData>(parameters: ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>), options: Omit<DefinedInitialDataOptions<AdminListTopicsData, AdminListTopicsError, TData, ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminListTopicsError>>;
        /** @summary Admin List Topics */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminListTopicsParameters>): ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListTopics.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListTopicsParameters, TQueryFnData = AdminListTopicsData, TData = OperationInfiniteData<TQueryFnData, AdminListTopicsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminListTopicsError, TData, ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminListTopicsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListTopics.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListTopicsParameters, TQueryFnData = AdminListTopicsData, TData = OperationInfiniteData<TQueryFnData, AdminListTopicsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminListTopicsError, TData, ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListTopicsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListTopicsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminListTopicsTotal = qraft.v3Service.adminListTopics.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminListTopicsByParametersTotal = qraft.v3Service.adminListTopics.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError> | QueryFiltersByQueryKey<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminListTopicsResults = qraft.v3Service.adminListTopics.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListTopicsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminListTopicsCombinedResults = qraft.v3Service.adminListTopics.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListTopicsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminListTopicsSchema, AdminListTopicsParameters, AdminListTopicsData, AdminListTopicsError>>, TCombinedResult = Array<UseQueryResult<AdminListTopicsData, AdminListTopicsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminListTopicsData, AdminListTopicsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminListTopics.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminListTopicsData>(parameters: ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>), options?: Omit<UseSuspenseQueryOptions<AdminListTopicsData, AdminListTopicsError, TData, ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminListTopicsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListTopics.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminListTopicsParameters, TData = AdminListTopicsData>(parameters: ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminListTopicsData, AdminListTopicsError, OperationInfiniteData<TData, AdminListTopicsParameters>, ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListTopicsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminListTopicsParameters>, OperationError<AdminListTopicsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin List Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminListTopicsData = qraft.v3Service.adminListTopics.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListTopicsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminListTopicsCombinedData = qraft.v3Service.adminListTopics.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListTopicsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminListTopicsSchema, AdminListTopicsParameters, AdminListTopicsData, AdminListTopicsError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminListTopicsData, AdminListTopicsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminListTopicsData, AdminListTopicsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin List Topics */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminListTopicsSchema, AdminListTopicsData, AdminListTopicsParameters, AdminListTopicsError>): Promise<AdminListTopicsData>;
        /** @summary Admin List Topics */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminListTopicsSchema, AdminListTopicsData, AdminListTopicsParameters, AdminListTopicsError>): Promise<void>;
        /** @summary Admin List Topics */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminListTopicsSchema, AdminListTopicsData, AdminListTopicsParameters, AdminListTopicsError>): Promise<AdminListTopicsData>;
        /** @summary Admin List Topics */
        fetchInfiniteQuery<TPageParam extends AdminListTopicsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListTopicsSchema, AdminListTopicsData, AdminListTopicsParameters, DeepReadonly<TPageParam>, AdminListTopicsError>): Promise<OperationInfiniteData<AdminListTopicsData, AdminListTopicsParameters>>;
        /** @summary Admin List Topics */
        prefetchInfiniteQuery<TPageParam extends AdminListTopicsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListTopicsSchema, AdminListTopicsData, AdminListTopicsParameters, DeepReadonly<TPageParam>, AdminListTopicsError>): Promise<void>;
        /** @summary Admin List Topics */
        ensureInfiniteQueryData<TPageParam extends AdminListTopicsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminListTopicsSchema, AdminListTopicsData, AdminListTopicsParameters, DeepReadonly<TPageParam>, AdminListTopicsError>): Promise<OperationInfiniteData<AdminListTopicsData, AdminListTopicsParameters>>;
        /** @summary Admin List Topics */
        getQueryData(parameters: ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>)): AdminListTopicsData | undefined;
        /** @summary Admin List Topics */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>)): OperationInfiniteData<AdminListTopicsData, AdminListTopicsParameters> | undefined;
        /** @summary Admin List Topics */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError> | QueryFiltersByQueryKey<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>,
            data: NoInfer<OperationInfiniteData<AdminListTopicsData, AdminListTopicsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>,
            data: AdminListTopicsData | undefined
        ]>;
        /** @summary Admin List Topics */
        getQueryState(parameters: ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters> | (DeepReadonly<AdminListTopicsParameters>)): QueryState<AdminListTopicsData, AdminListTopicsError> | undefined;
        /** @summary Admin List Topics */
        getInfiniteQueryState(parameters: DeepReadonly<AdminListTopicsParameters> | ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>): QueryState<OperationInfiniteData<AdminListTopicsData, AdminListTopicsParameters>, AdminListTopicsError> | undefined;
        /** @summary Admin List Topics */
        setQueryData(parameters: (DeepReadonly<AdminListTopicsParameters>) | ServiceOperationQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>, updater: Updater<NoInfer<AdminListTopicsData> | undefined, NoInfer<DeepReadonly<AdminListTopicsData>> | undefined>, options?: SetDataOptions): AdminListTopicsData | undefined;
        /** @summary Admin List Topics */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminListTopicsParameters>) | ServiceOperationInfiniteQueryKey<AdminListTopicsSchema, AdminListTopicsParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminListTopicsData, AdminListTopicsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminListTopicsData, AdminListTopicsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminListTopicsData, AdminListTopicsParameters> | undefined;
        /** @summary Admin List Topics */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError> | QueryFiltersByQueryKey<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>, updater: Updater<NoInfer<AdminListTopicsData> | undefined, NoInfer<AdminListTopicsData> | undefined>, options?: SetDataOptions): Array<AdminListTopicsData | undefined>;
        /** @summary Admin List Topics */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin List Topics */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError> | QueryFiltersByQueryKey<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin List Topics */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError> | QueryFiltersByQueryKey<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin List Topics */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError> | QueryFiltersByQueryKey<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>): void;
        /** @summary Admin List Topics */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError> | QueryFiltersByQueryKey<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin List Topics */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError> | QueryFiltersByQueryKey<AdminListTopicsSchema, AdminListTopicsData, TInfinite, AdminListTopicsParameters, AdminListTopicsError>): number;
        schema: AdminListTopicsSchema;
        types: {
            parameters: AdminListTopicsParameters;
            data: AdminListTopicsData;
            error: AdminListTopicsError;
        };
    };
    /** @summary Admin Create Topic */
    adminCreateTopic: {
        /** @summary Admin Create Topic */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminCreateTopicBody, AdminCreateTopicParameters, TMeta, TSignal>, client?: (schema: AdminCreateTopicSchema, options: ServiceOperationMutationFnOptions<AdminCreateTopicBody, AdminCreateTopicParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminCreateTopicData, AdminCreateTopicError>>): Promise<RequestFnResponse<AdminCreateTopicData, AdminCreateTopicError>>;
        /** @summary Admin Create Topic */
        getMutationKey(parameters: DeepReadonly<AdminCreateTopicParameters> | void): ServiceOperationMutationKey<AdminCreateTopicSchema, AdminCreateTopicParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateTopic.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateTopic.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminCreateTopicBody, TContext = unknown>(parameters: DeepReadonly<AdminCreateTopicParameters>, options?: ServiceOperationUseMutationOptions<AdminCreateTopicSchema, AdminCreateTopicData, AdminCreateTopicParameters, TVariables, OperationError<AdminCreateTopicError>, TContext>): UseMutationResult<AdminCreateTopicData, OperationError<AdminCreateTopicError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateTopic.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateTopic.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminCreateTopicBody, AdminCreateTopicParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminCreateTopicSchema, AdminCreateTopicData, AdminCreateTopicParameters, TVariables, OperationError<AdminCreateTopicError>, TContext>): UseMutationResult<AdminCreateTopicData, OperationError<AdminCreateTopicError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Create Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminCreateTopicTotal = qraft.v3Service.adminCreateTopic.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminCreateTopicTotal = qraft.v3Service.adminCreateTopic.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext> | MutationFiltersByMutationKey<AdminCreateTopicSchema, AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Create Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminCreateTopicPendingMutationVariables = qraft.v3Service.adminCreateTopic.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminCreateTopicMutationData = qraft.v3Service.adminCreateTopic.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminCreateTopicData, OperationError<AdminCreateTopicError>, MutationVariables<AdminCreateTopicBody, AdminCreateTopicParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext> | MutationFiltersByMutationKey<AdminCreateTopicSchema, AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext>;
            select?: (mutation: Mutation<AdminCreateTopicData, OperationError<AdminCreateTopicError>, MutationVariables<AdminCreateTopicBody, AdminCreateTopicParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Create Topic */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext> | MutationFiltersByMutationKey<AdminCreateTopicSchema, AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Create Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateTopic.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateTopic.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext> | MutationFiltersByMutationKey<AdminCreateTopicSchema, AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext>): Mutation<AdminCreateTopicData, AdminCreateTopicError, MutationVariables<AdminCreateTopicBody, AdminCreateTopicParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext> | MutationFiltersByMutationKey<AdminCreateTopicSchema, AdminCreateTopicBody, AdminCreateTopicData, AdminCreateTopicParameters, OperationError<AdminCreateTopicError>, TContext>): Array<Mutation<AdminCreateTopicData, AdminCreateTopicError, MutationVariables<AdminCreateTopicBody, AdminCreateTopicParameters>, TContext>>;
        };
        schema: AdminCreateTopicSchema;
        types: {
            parameters: AdminCreateTopicParameters;
            data: AdminCreateTopicData;
            error: AdminCreateTopicError;
            body: AdminCreateTopicBody;
        };
    };
    /** @summary Admin List Series */
    adminListSeries: {
        /** @summary Admin List Series */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminListSeriesSchema, AdminListSeriesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminListSeriesParameters, TMeta, TSignal> | void), client?: (schema: AdminListSeriesSchema, options: {
            parameters: AdminListSeriesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminListSeriesData, AdminListSeriesError>>): Promise<RequestFnResponse<AdminListSeriesData, AdminListSeriesError>>;
        /** @summary Admin List Series */
        getQueryKey(parameters: DeepReadonly<AdminListSeriesParameters> | void): ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListSeries.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListSeries.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListSeriesData>(parameters: ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void), options?: Omit<UndefinedInitialDataOptions<AdminListSeriesData, AdminListSeriesError, TData, ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminListSeriesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListSeries.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListSeries.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListSeriesData>(parameters: ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void), options: Omit<DefinedInitialDataOptions<AdminListSeriesData, AdminListSeriesError, TData, ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminListSeriesError>>;
        /** @summary Admin List Series */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminListSeriesParameters> | void): ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListSeries.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListSeriesParameters, TQueryFnData = AdminListSeriesData, TData = OperationInfiniteData<TQueryFnData, AdminListSeriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminListSeriesError, TData, ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminListSeriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListSeries.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListSeriesParameters, TQueryFnData = AdminListSeriesData, TData = OperationInfiniteData<TQueryFnData, AdminListSeriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminListSeriesError, TData, ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListSeriesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListSeriesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminListSeriesTotal = qraft.v3Service.adminListSeries.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminListSeriesByParametersTotal = qraft.v3Service.adminListSeries.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError> | QueryFiltersByQueryKey<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminListSeriesResults = qraft.v3Service.adminListSeries.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListSeriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminListSeriesCombinedResults = qraft.v3Service.adminListSeries.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListSeriesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminListSeriesSchema, AdminListSeriesParameters, AdminListSeriesData, AdminListSeriesError>>, TCombinedResult = Array<UseQueryResult<AdminListSeriesData, AdminListSeriesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminListSeriesData, AdminListSeriesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.adminListSeries.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminListSeries.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminListSeriesData>(parameters: ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void), options?: Omit<UseSuspenseQueryOptions<AdminListSeriesData, AdminListSeriesError, TData, ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminListSeriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListSeries.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminListSeriesParameters, TData = AdminListSeriesData>(parameters: ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<AdminListSeriesData, AdminListSeriesError, OperationInfiniteData<TData, AdminListSeriesParameters>, ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListSeriesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminListSeriesParameters>, OperationError<AdminListSeriesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin List Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminListSeriesData = qraft.v3Service.adminListSeries.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListSeriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminListSeriesCombinedData = qraft.v3Service.adminListSeries.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListSeriesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminListSeriesSchema, AdminListSeriesParameters, AdminListSeriesData, AdminListSeriesError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminListSeriesData, AdminListSeriesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminListSeriesData, AdminListSeriesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin List Series */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminListSeriesSchema, AdminListSeriesData, AdminListSeriesParameters, AdminListSeriesError> | void): Promise<AdminListSeriesData>;
        /** @summary Admin List Series */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminListSeriesSchema, AdminListSeriesData, AdminListSeriesParameters, AdminListSeriesError> | void): Promise<void>;
        /** @summary Admin List Series */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminListSeriesSchema, AdminListSeriesData, AdminListSeriesParameters, AdminListSeriesError> | void): Promise<AdminListSeriesData>;
        /** @summary Admin List Series */
        fetchInfiniteQuery<TPageParam extends AdminListSeriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListSeriesSchema, AdminListSeriesData, AdminListSeriesParameters, DeepReadonly<TPageParam>, AdminListSeriesError> | void): Promise<OperationInfiniteData<AdminListSeriesData, AdminListSeriesParameters>>;
        /** @summary Admin List Series */
        prefetchInfiniteQuery<TPageParam extends AdminListSeriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListSeriesSchema, AdminListSeriesData, AdminListSeriesParameters, DeepReadonly<TPageParam>, AdminListSeriesError> | void): Promise<void>;
        /** @summary Admin List Series */
        ensureInfiniteQueryData<TPageParam extends AdminListSeriesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminListSeriesSchema, AdminListSeriesData, AdminListSeriesParameters, DeepReadonly<TPageParam>, AdminListSeriesError> | void): Promise<OperationInfiniteData<AdminListSeriesData, AdminListSeriesParameters>>;
        /** @summary Admin List Series */
        getQueryData(parameters: ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void)): AdminListSeriesData | undefined;
        /** @summary Admin List Series */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void)): OperationInfiniteData<AdminListSeriesData, AdminListSeriesParameters> | undefined;
        /** @summary Admin List Series */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError> | QueryFiltersByQueryKey<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>,
            data: NoInfer<OperationInfiniteData<AdminListSeriesData, AdminListSeriesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>,
            data: AdminListSeriesData | undefined
        ]>;
        /** @summary Admin List Series */
        getQueryState(parameters: ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | (DeepReadonly<AdminListSeriesParameters> | void)): QueryState<AdminListSeriesData, AdminListSeriesError> | undefined;
        /** @summary Admin List Series */
        getInfiniteQueryState(parameters: DeepReadonly<AdminListSeriesParameters> | ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters> | void): QueryState<OperationInfiniteData<AdminListSeriesData, AdminListSeriesParameters>, AdminListSeriesError> | undefined;
        /** @summary Admin List Series */
        setQueryData(parameters: (DeepReadonly<AdminListSeriesParameters> | undefined) | ServiceOperationQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>, updater: Updater<NoInfer<AdminListSeriesData> | undefined, NoInfer<DeepReadonly<AdminListSeriesData>> | undefined>, options?: SetDataOptions): AdminListSeriesData | undefined;
        /** @summary Admin List Series */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminListSeriesParameters> | undefined) | ServiceOperationInfiniteQueryKey<AdminListSeriesSchema, AdminListSeriesParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminListSeriesData, AdminListSeriesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminListSeriesData, AdminListSeriesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminListSeriesData, AdminListSeriesParameters> | undefined;
        /** @summary Admin List Series */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError> | QueryFiltersByQueryKey<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>, updater: Updater<NoInfer<AdminListSeriesData> | undefined, NoInfer<AdminListSeriesData> | undefined>, options?: SetDataOptions): Array<AdminListSeriesData | undefined>;
        /** @summary Admin List Series */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin List Series */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError> | QueryFiltersByQueryKey<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin List Series */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError> | QueryFiltersByQueryKey<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin List Series */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError> | QueryFiltersByQueryKey<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>): void;
        /** @summary Admin List Series */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError> | QueryFiltersByQueryKey<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin List Series */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError> | QueryFiltersByQueryKey<AdminListSeriesSchema, AdminListSeriesData, TInfinite, AdminListSeriesParameters, AdminListSeriesError>): number;
        schema: AdminListSeriesSchema;
        types: {
            parameters: AdminListSeriesParameters;
            data: AdminListSeriesData;
            error: AdminListSeriesError;
        };
    };
    /** @summary Admin Create Series */
    adminCreateSeries: {
        /** @summary Admin Create Series */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminCreateSeriesBody, AdminCreateSeriesParameters, TMeta, TSignal>, client?: (schema: AdminCreateSeriesSchema, options: ServiceOperationMutationFnOptions<AdminCreateSeriesBody, AdminCreateSeriesParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminCreateSeriesData, AdminCreateSeriesError>>): Promise<RequestFnResponse<AdminCreateSeriesData, AdminCreateSeriesError>>;
        /** @summary Admin Create Series */
        getMutationKey(parameters: DeepReadonly<AdminCreateSeriesParameters> | void): ServiceOperationMutationKey<AdminCreateSeriesSchema, AdminCreateSeriesParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateSeries.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateSeries.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminCreateSeriesBody, TContext = unknown>(parameters: DeepReadonly<AdminCreateSeriesParameters>, options?: ServiceOperationUseMutationOptions<AdminCreateSeriesSchema, AdminCreateSeriesData, AdminCreateSeriesParameters, TVariables, OperationError<AdminCreateSeriesError>, TContext>): UseMutationResult<AdminCreateSeriesData, OperationError<AdminCreateSeriesError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateSeries.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateSeries.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminCreateSeriesBody, AdminCreateSeriesParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminCreateSeriesSchema, AdminCreateSeriesData, AdminCreateSeriesParameters, TVariables, OperationError<AdminCreateSeriesError>, TContext>): UseMutationResult<AdminCreateSeriesData, OperationError<AdminCreateSeriesError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Create Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminCreateSeriesTotal = qraft.v3Service.adminCreateSeries.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminCreateSeriesTotal = qraft.v3Service.adminCreateSeries.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesSchema, AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Create Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminCreateSeriesPendingMutationVariables = qraft.v3Service.adminCreateSeries.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminCreateSeriesMutationData = qraft.v3Service.adminCreateSeries.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminCreateSeriesData, OperationError<AdminCreateSeriesError>, MutationVariables<AdminCreateSeriesBody, AdminCreateSeriesParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesSchema, AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext>;
            select?: (mutation: Mutation<AdminCreateSeriesData, OperationError<AdminCreateSeriesError>, MutationVariables<AdminCreateSeriesBody, AdminCreateSeriesParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Create Series */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesSchema, AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Create Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateSeries.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateSeries.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesSchema, AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext>): Mutation<AdminCreateSeriesData, AdminCreateSeriesError, MutationVariables<AdminCreateSeriesBody, AdminCreateSeriesParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesSchema, AdminCreateSeriesBody, AdminCreateSeriesData, AdminCreateSeriesParameters, OperationError<AdminCreateSeriesError>, TContext>): Array<Mutation<AdminCreateSeriesData, AdminCreateSeriesError, MutationVariables<AdminCreateSeriesBody, AdminCreateSeriesParameters>, TContext>>;
        };
        schema: AdminCreateSeriesSchema;
        types: {
            parameters: AdminCreateSeriesParameters;
            data: AdminCreateSeriesData;
            error: AdminCreateSeriesError;
            body: AdminCreateSeriesBody;
        };
    };
    /** @summary Admin Get Series */
    adminGetSeries: {
        /** @summary Admin Get Series */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminGetSeriesParameters, TMeta, TSignal>), client?: (schema: AdminGetSeriesSchema, options: {
            parameters: AdminGetSeriesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminGetSeriesData, AdminGetSeriesError>>): Promise<RequestFnResponse<AdminGetSeriesData, AdminGetSeriesError>>;
        /** @summary Admin Get Series */
        getQueryKey(parameters: DeepReadonly<AdminGetSeriesParameters>): ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetSeries.useQuery({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetSeriesData>(parameters: ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>), options?: Omit<UndefinedInitialDataOptions<AdminGetSeriesData, AdminGetSeriesError, TData, ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminGetSeriesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetSeries.useQuery({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetSeriesData>(parameters: ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>), options: Omit<DefinedInitialDataOptions<AdminGetSeriesData, AdminGetSeriesError, TData, ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminGetSeriesError>>;
        /** @summary Admin Get Series */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminGetSeriesParameters>): ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetSeries.useInfiniteQuery({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetSeriesParameters, TQueryFnData = AdminGetSeriesData, TData = OperationInfiniteData<TQueryFnData, AdminGetSeriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetSeriesError, TData, ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminGetSeriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetSeries.useInfiniteQuery({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetSeriesParameters, TQueryFnData = AdminGetSeriesData, TData = OperationInfiniteData<TQueryFnData, AdminGetSeriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetSeriesError, TData, ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetSeriesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminGetSeriesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminGetSeriesTotal = qraft.v3Service.adminGetSeries.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminGetSeriesByParametersTotal = qraft.v3Service.adminGetSeries.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError> | QueryFiltersByQueryKey<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminGetSeriesResults = qraft.v3Service.adminGetSeries.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 series_id: seriesId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 series_id: seriesId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetSeriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminGetSeriesCombinedResults = qraft.v3Service.adminGetSeries.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 series_id: seriesId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 series_id: seriesId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetSeriesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminGetSeriesSchema, AdminGetSeriesParameters, AdminGetSeriesData, AdminGetSeriesError>>, TCombinedResult = Array<UseQueryResult<AdminGetSeriesData, AdminGetSeriesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminGetSeriesData, AdminGetSeriesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminGetSeries.useSuspenseQuery({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminGetSeriesData>(parameters: ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>), options?: Omit<UseSuspenseQueryOptions<AdminGetSeriesData, AdminGetSeriesError, TData, ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminGetSeriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetSeries.useSuspenseInfiniteQuery({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminGetSeriesParameters, TData = AdminGetSeriesData>(parameters: ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminGetSeriesData, AdminGetSeriesError, OperationInfiniteData<TData, AdminGetSeriesParameters>, ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetSeriesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminGetSeriesParameters>, OperationError<AdminGetSeriesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminGetSeriesData = qraft.v3Service.adminGetSeries.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 series_id: seriesId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 series_id: seriesId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetSeriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminGetSeriesCombinedData = qraft.v3Service.adminGetSeries.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 series_id: seriesId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 series_id: seriesId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetSeriesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminGetSeriesSchema, AdminGetSeriesParameters, AdminGetSeriesData, AdminGetSeriesError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminGetSeriesData, AdminGetSeriesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminGetSeriesData, AdminGetSeriesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Get Series */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetSeriesSchema, AdminGetSeriesData, AdminGetSeriesParameters, AdminGetSeriesError>): Promise<AdminGetSeriesData>;
        /** @summary Admin Get Series */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetSeriesSchema, AdminGetSeriesData, AdminGetSeriesParameters, AdminGetSeriesError>): Promise<void>;
        /** @summary Admin Get Series */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminGetSeriesSchema, AdminGetSeriesData, AdminGetSeriesParameters, AdminGetSeriesError>): Promise<AdminGetSeriesData>;
        /** @summary Admin Get Series */
        fetchInfiniteQuery<TPageParam extends AdminGetSeriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetSeriesSchema, AdminGetSeriesData, AdminGetSeriesParameters, DeepReadonly<TPageParam>, AdminGetSeriesError>): Promise<OperationInfiniteData<AdminGetSeriesData, AdminGetSeriesParameters>>;
        /** @summary Admin Get Series */
        prefetchInfiniteQuery<TPageParam extends AdminGetSeriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetSeriesSchema, AdminGetSeriesData, AdminGetSeriesParameters, DeepReadonly<TPageParam>, AdminGetSeriesError>): Promise<void>;
        /** @summary Admin Get Series */
        ensureInfiniteQueryData<TPageParam extends AdminGetSeriesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminGetSeriesSchema, AdminGetSeriesData, AdminGetSeriesParameters, DeepReadonly<TPageParam>, AdminGetSeriesError>): Promise<OperationInfiniteData<AdminGetSeriesData, AdminGetSeriesParameters>>;
        /** @summary Admin Get Series */
        getQueryData(parameters: ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>)): AdminGetSeriesData | undefined;
        /** @summary Admin Get Series */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>)): OperationInfiniteData<AdminGetSeriesData, AdminGetSeriesParameters> | undefined;
        /** @summary Admin Get Series */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError> | QueryFiltersByQueryKey<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>,
            data: NoInfer<OperationInfiniteData<AdminGetSeriesData, AdminGetSeriesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>,
            data: AdminGetSeriesData | undefined
        ]>;
        /** @summary Admin Get Series */
        getQueryState(parameters: ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters> | (DeepReadonly<AdminGetSeriesParameters>)): QueryState<AdminGetSeriesData, AdminGetSeriesError> | undefined;
        /** @summary Admin Get Series */
        getInfiniteQueryState(parameters: DeepReadonly<AdminGetSeriesParameters> | ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>): QueryState<OperationInfiniteData<AdminGetSeriesData, AdminGetSeriesParameters>, AdminGetSeriesError> | undefined;
        /** @summary Admin Get Series */
        setQueryData(parameters: (DeepReadonly<AdminGetSeriesParameters>) | ServiceOperationQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>, updater: Updater<NoInfer<AdminGetSeriesData> | undefined, NoInfer<DeepReadonly<AdminGetSeriesData>> | undefined>, options?: SetDataOptions): AdminGetSeriesData | undefined;
        /** @summary Admin Get Series */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminGetSeriesParameters>) | ServiceOperationInfiniteQueryKey<AdminGetSeriesSchema, AdminGetSeriesParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminGetSeriesData, AdminGetSeriesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminGetSeriesData, AdminGetSeriesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminGetSeriesData, AdminGetSeriesParameters> | undefined;
        /** @summary Admin Get Series */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError> | QueryFiltersByQueryKey<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>, updater: Updater<NoInfer<AdminGetSeriesData> | undefined, NoInfer<AdminGetSeriesData> | undefined>, options?: SetDataOptions): Array<AdminGetSeriesData | undefined>;
        /** @summary Admin Get Series */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Get Series */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError> | QueryFiltersByQueryKey<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Get Series */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError> | QueryFiltersByQueryKey<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Get Series */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError> | QueryFiltersByQueryKey<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>): void;
        /** @summary Admin Get Series */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError> | QueryFiltersByQueryKey<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Get Series */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError> | QueryFiltersByQueryKey<AdminGetSeriesSchema, AdminGetSeriesData, TInfinite, AdminGetSeriesParameters, AdminGetSeriesError>): number;
        schema: AdminGetSeriesSchema;
        types: {
            parameters: AdminGetSeriesParameters;
            data: AdminGetSeriesData;
            error: AdminGetSeriesError;
        };
    };
    /** @summary Admin Update Series */
    adminUpdateSeries: {
        /** @summary Admin Update Series */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminUpdateSeriesBody, AdminUpdateSeriesParameters, TMeta, TSignal>, client?: (schema: AdminUpdateSeriesSchema, options: ServiceOperationMutationFnOptions<AdminUpdateSeriesBody, AdminUpdateSeriesParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminUpdateSeriesData, AdminUpdateSeriesError>>): Promise<RequestFnResponse<AdminUpdateSeriesData, AdminUpdateSeriesError>>;
        /** @summary Admin Update Series */
        getMutationKey(parameters: DeepReadonly<AdminUpdateSeriesParameters> | void): ServiceOperationMutationKey<AdminUpdateSeriesSchema, AdminUpdateSeriesParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateSeries.useMutation({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateSeries.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminUpdateSeriesBody, TContext = unknown>(parameters: DeepReadonly<AdminUpdateSeriesParameters>, options?: ServiceOperationUseMutationOptions<AdminUpdateSeriesSchema, AdminUpdateSeriesData, AdminUpdateSeriesParameters, TVariables, OperationError<AdminUpdateSeriesError>, TContext>): UseMutationResult<AdminUpdateSeriesData, OperationError<AdminUpdateSeriesError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateSeries.useMutation({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateSeries.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminUpdateSeriesBody, AdminUpdateSeriesParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminUpdateSeriesSchema, AdminUpdateSeriesData, AdminUpdateSeriesParameters, TVariables, OperationError<AdminUpdateSeriesError>, TContext>): UseMutationResult<AdminUpdateSeriesData, OperationError<AdminUpdateSeriesError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Update Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminUpdateSeriesTotal = qraft.v3Service.adminUpdateSeries.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminUpdateSeriesTotal = qraft.v3Service.adminUpdateSeries.useIsMutating({
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminUpdateSeriesSchema, AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Update Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminUpdateSeriesPendingMutationVariables = qraft.v3Service.adminUpdateSeries.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminUpdateSeriesMutationData = qraft.v3Service.adminUpdateSeries.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 series_id: seriesId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminUpdateSeriesData, OperationError<AdminUpdateSeriesError>, MutationVariables<AdminUpdateSeriesBody, AdminUpdateSeriesParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminUpdateSeriesSchema, AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext>;
            select?: (mutation: Mutation<AdminUpdateSeriesData, OperationError<AdminUpdateSeriesError>, MutationVariables<AdminUpdateSeriesBody, AdminUpdateSeriesParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Update Series */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminUpdateSeriesSchema, AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Update Series
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateSeries.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateSeries.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminUpdateSeriesSchema, AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext>): Mutation<AdminUpdateSeriesData, AdminUpdateSeriesError, MutationVariables<AdminUpdateSeriesBody, AdminUpdateSeriesParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext> | MutationFiltersByMutationKey<AdminUpdateSeriesSchema, AdminUpdateSeriesBody, AdminUpdateSeriesData, AdminUpdateSeriesParameters, OperationError<AdminUpdateSeriesError>, TContext>): Array<Mutation<AdminUpdateSeriesData, AdminUpdateSeriesError, MutationVariables<AdminUpdateSeriesBody, AdminUpdateSeriesParameters>, TContext>>;
        };
        schema: AdminUpdateSeriesSchema;
        types: {
            parameters: AdminUpdateSeriesParameters;
            data: AdminUpdateSeriesData;
            error: AdminUpdateSeriesError;
            body: AdminUpdateSeriesBody;
        };
    };
    /** @summary Admin List Questions */
    adminListQuestions: {
        /** @summary Admin List Questions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminListQuestionsParameters, TMeta, TSignal>), client?: (schema: AdminListQuestionsSchema, options: {
            parameters: AdminListQuestionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminListQuestionsData, AdminListQuestionsError>>): Promise<RequestFnResponse<AdminListQuestionsData, AdminListQuestionsError>>;
        /** @summary Admin List Questions */
        getQueryKey(parameters: DeepReadonly<AdminListQuestionsParameters>): ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListQuestions.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListQuestionsData>(parameters: ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>), options?: Omit<UndefinedInitialDataOptions<AdminListQuestionsData, AdminListQuestionsError, TData, ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminListQuestionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListQuestions.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListQuestionsData>(parameters: ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>), options: Omit<DefinedInitialDataOptions<AdminListQuestionsData, AdminListQuestionsError, TData, ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminListQuestionsError>>;
        /** @summary Admin List Questions */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminListQuestionsParameters>): ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListQuestions.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             topic_id: initialTopicId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListQuestionsParameters, TQueryFnData = AdminListQuestionsData, TData = OperationInfiniteData<TQueryFnData, AdminListQuestionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminListQuestionsError, TData, ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminListQuestionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListQuestions.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             topic_id: initialTopicId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListQuestionsParameters, TQueryFnData = AdminListQuestionsData, TData = OperationInfiniteData<TQueryFnData, AdminListQuestionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminListQuestionsError, TData, ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListQuestionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListQuestionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminListQuestionsTotal = qraft.v3Service.adminListQuestions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminListQuestionsByParametersTotal = qraft.v3Service.adminListQuestions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         query: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError> | QueryFiltersByQueryKey<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminListQuestionsResults = qraft.v3Service.adminListQuestions.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminListQuestionsCombinedResults = qraft.v3Service.adminListQuestions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListQuestionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminListQuestionsSchema, AdminListQuestionsParameters, AdminListQuestionsData, AdminListQuestionsError>>, TCombinedResult = Array<UseQueryResult<AdminListQuestionsData, AdminListQuestionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminListQuestionsData, AdminListQuestionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminListQuestions.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     query: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminListQuestionsData>(parameters: ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>), options?: Omit<UseSuspenseQueryOptions<AdminListQuestionsData, AdminListQuestionsError, TData, ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminListQuestionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListQuestions.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             topic_id: initialTopicId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminListQuestionsParameters, TData = AdminListQuestionsData>(parameters: ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminListQuestionsData, AdminListQuestionsError, OperationInfiniteData<TData, AdminListQuestionsParameters>, ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListQuestionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminListQuestionsParameters>, OperationError<AdminListQuestionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin List Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminListQuestionsData = qraft.v3Service.adminListQuestions.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminListQuestionsCombinedData = qraft.v3Service.adminListQuestions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             query: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             query: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListQuestionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminListQuestionsSchema, AdminListQuestionsParameters, AdminListQuestionsData, AdminListQuestionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminListQuestionsData, AdminListQuestionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminListQuestionsData, AdminListQuestionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin List Questions */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminListQuestionsSchema, AdminListQuestionsData, AdminListQuestionsParameters, AdminListQuestionsError>): Promise<AdminListQuestionsData>;
        /** @summary Admin List Questions */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminListQuestionsSchema, AdminListQuestionsData, AdminListQuestionsParameters, AdminListQuestionsError>): Promise<void>;
        /** @summary Admin List Questions */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminListQuestionsSchema, AdminListQuestionsData, AdminListQuestionsParameters, AdminListQuestionsError>): Promise<AdminListQuestionsData>;
        /** @summary Admin List Questions */
        fetchInfiniteQuery<TPageParam extends AdminListQuestionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListQuestionsSchema, AdminListQuestionsData, AdminListQuestionsParameters, DeepReadonly<TPageParam>, AdminListQuestionsError>): Promise<OperationInfiniteData<AdminListQuestionsData, AdminListQuestionsParameters>>;
        /** @summary Admin List Questions */
        prefetchInfiniteQuery<TPageParam extends AdminListQuestionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListQuestionsSchema, AdminListQuestionsData, AdminListQuestionsParameters, DeepReadonly<TPageParam>, AdminListQuestionsError>): Promise<void>;
        /** @summary Admin List Questions */
        ensureInfiniteQueryData<TPageParam extends AdminListQuestionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminListQuestionsSchema, AdminListQuestionsData, AdminListQuestionsParameters, DeepReadonly<TPageParam>, AdminListQuestionsError>): Promise<OperationInfiniteData<AdminListQuestionsData, AdminListQuestionsParameters>>;
        /** @summary Admin List Questions */
        getQueryData(parameters: ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>)): AdminListQuestionsData | undefined;
        /** @summary Admin List Questions */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>)): OperationInfiniteData<AdminListQuestionsData, AdminListQuestionsParameters> | undefined;
        /** @summary Admin List Questions */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError> | QueryFiltersByQueryKey<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>,
            data: NoInfer<OperationInfiniteData<AdminListQuestionsData, AdminListQuestionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>,
            data: AdminListQuestionsData | undefined
        ]>;
        /** @summary Admin List Questions */
        getQueryState(parameters: ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters> | (DeepReadonly<AdminListQuestionsParameters>)): QueryState<AdminListQuestionsData, AdminListQuestionsError> | undefined;
        /** @summary Admin List Questions */
        getInfiniteQueryState(parameters: DeepReadonly<AdminListQuestionsParameters> | ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>): QueryState<OperationInfiniteData<AdminListQuestionsData, AdminListQuestionsParameters>, AdminListQuestionsError> | undefined;
        /** @summary Admin List Questions */
        setQueryData(parameters: (DeepReadonly<AdminListQuestionsParameters>) | ServiceOperationQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>, updater: Updater<NoInfer<AdminListQuestionsData> | undefined, NoInfer<DeepReadonly<AdminListQuestionsData>> | undefined>, options?: SetDataOptions): AdminListQuestionsData | undefined;
        /** @summary Admin List Questions */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminListQuestionsParameters>) | ServiceOperationInfiniteQueryKey<AdminListQuestionsSchema, AdminListQuestionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminListQuestionsData, AdminListQuestionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminListQuestionsData, AdminListQuestionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminListQuestionsData, AdminListQuestionsParameters> | undefined;
        /** @summary Admin List Questions */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError> | QueryFiltersByQueryKey<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>, updater: Updater<NoInfer<AdminListQuestionsData> | undefined, NoInfer<AdminListQuestionsData> | undefined>, options?: SetDataOptions): Array<AdminListQuestionsData | undefined>;
        /** @summary Admin List Questions */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin List Questions */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError> | QueryFiltersByQueryKey<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin List Questions */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError> | QueryFiltersByQueryKey<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin List Questions */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError> | QueryFiltersByQueryKey<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>): void;
        /** @summary Admin List Questions */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError> | QueryFiltersByQueryKey<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin List Questions */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError> | QueryFiltersByQueryKey<AdminListQuestionsSchema, AdminListQuestionsData, TInfinite, AdminListQuestionsParameters, AdminListQuestionsError>): number;
        schema: AdminListQuestionsSchema;
        types: {
            parameters: AdminListQuestionsParameters;
            data: AdminListQuestionsData;
            error: AdminListQuestionsError;
        };
    };
    /** @summary Admin Create Question */
    adminCreateQuestion: {
        /** @summary Admin Create Question */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminCreateQuestionBody, AdminCreateQuestionParameters, TMeta, TSignal>, client?: (schema: AdminCreateQuestionSchema, options: ServiceOperationMutationFnOptions<AdminCreateQuestionBody, AdminCreateQuestionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminCreateQuestionData, AdminCreateQuestionError>>): Promise<RequestFnResponse<AdminCreateQuestionData, AdminCreateQuestionError>>;
        /** @summary Admin Create Question */
        getMutationKey(parameters: DeepReadonly<AdminCreateQuestionParameters> | void): ServiceOperationMutationKey<AdminCreateQuestionSchema, AdminCreateQuestionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateQuestion.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateQuestion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminCreateQuestionBody, TContext = unknown>(parameters: DeepReadonly<AdminCreateQuestionParameters>, options?: ServiceOperationUseMutationOptions<AdminCreateQuestionSchema, AdminCreateQuestionData, AdminCreateQuestionParameters, TVariables, OperationError<AdminCreateQuestionError>, TContext>): UseMutationResult<AdminCreateQuestionData, OperationError<AdminCreateQuestionError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateQuestion.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateQuestion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminCreateQuestionBody, AdminCreateQuestionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminCreateQuestionSchema, AdminCreateQuestionData, AdminCreateQuestionParameters, TVariables, OperationError<AdminCreateQuestionError>, TContext>): UseMutationResult<AdminCreateQuestionData, OperationError<AdminCreateQuestionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Create Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminCreateQuestionTotal = qraft.v3Service.adminCreateQuestion.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminCreateQuestionTotal = qraft.v3Service.adminCreateQuestion.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminCreateQuestionSchema, AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Create Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminCreateQuestionPendingMutationVariables = qraft.v3Service.adminCreateQuestion.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminCreateQuestionMutationData = qraft.v3Service.adminCreateQuestion.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminCreateQuestionData, OperationError<AdminCreateQuestionError>, MutationVariables<AdminCreateQuestionBody, AdminCreateQuestionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminCreateQuestionSchema, AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext>;
            select?: (mutation: Mutation<AdminCreateQuestionData, OperationError<AdminCreateQuestionError>, MutationVariables<AdminCreateQuestionBody, AdminCreateQuestionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Create Question */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminCreateQuestionSchema, AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Create Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateQuestion.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateQuestion.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminCreateQuestionSchema, AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext>): Mutation<AdminCreateQuestionData, AdminCreateQuestionError, MutationVariables<AdminCreateQuestionBody, AdminCreateQuestionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminCreateQuestionSchema, AdminCreateQuestionBody, AdminCreateQuestionData, AdminCreateQuestionParameters, OperationError<AdminCreateQuestionError>, TContext>): Array<Mutation<AdminCreateQuestionData, AdminCreateQuestionError, MutationVariables<AdminCreateQuestionBody, AdminCreateQuestionParameters>, TContext>>;
        };
        schema: AdminCreateQuestionSchema;
        types: {
            parameters: AdminCreateQuestionParameters;
            data: AdminCreateQuestionData;
            error: AdminCreateQuestionError;
            body: AdminCreateQuestionBody;
        };
    };
    /** @summary Admin Get Question */
    adminGetQuestion: {
        /** @summary Admin Get Question */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminGetQuestionParameters, TMeta, TSignal>), client?: (schema: AdminGetQuestionSchema, options: {
            parameters: AdminGetQuestionParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminGetQuestionData, AdminGetQuestionError>>): Promise<RequestFnResponse<AdminGetQuestionData, AdminGetQuestionError>>;
        /** @summary Admin Get Question */
        getQueryKey(parameters: DeepReadonly<AdminGetQuestionParameters>): ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetQuestion.useQuery({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetQuestionData>(parameters: ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>), options?: Omit<UndefinedInitialDataOptions<AdminGetQuestionData, AdminGetQuestionError, TData, ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminGetQuestionError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetQuestion.useQuery({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetQuestionData>(parameters: ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>), options: Omit<DefinedInitialDataOptions<AdminGetQuestionData, AdminGetQuestionError, TData, ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminGetQuestionError>>;
        /** @summary Admin Get Question */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminGetQuestionParameters>): ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetQuestion.useInfiniteQuery({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetQuestionParameters, TQueryFnData = AdminGetQuestionData, TData = OperationInfiniteData<TQueryFnData, AdminGetQuestionParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetQuestionError, TData, ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminGetQuestionError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetQuestion.useInfiniteQuery({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetQuestionParameters, TQueryFnData = AdminGetQuestionData, TData = OperationInfiniteData<TQueryFnData, AdminGetQuestionParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetQuestionError, TData, ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetQuestionData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminGetQuestionError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminGetQuestionTotal = qraft.v3Service.adminGetQuestion.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminGetQuestionByParametersTotal = qraft.v3Service.adminGetQuestion.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             question_id: questionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError> | QueryFiltersByQueryKey<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminGetQuestionResults = qraft.v3Service.adminGetQuestion.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 question_id: questionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 question_id: questionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetQuestionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminGetQuestionCombinedResults = qraft.v3Service.adminGetQuestion.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 question_id: questionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 question_id: questionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetQuestionCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminGetQuestionSchema, AdminGetQuestionParameters, AdminGetQuestionData, AdminGetQuestionError>>, TCombinedResult = Array<UseQueryResult<AdminGetQuestionData, AdminGetQuestionError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminGetQuestionData, AdminGetQuestionError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminGetQuestion.useSuspenseQuery({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminGetQuestionData>(parameters: ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>), options?: Omit<UseSuspenseQueryOptions<AdminGetQuestionData, AdminGetQuestionError, TData, ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminGetQuestionError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetQuestion.useSuspenseInfiniteQuery({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminGetQuestionParameters, TData = AdminGetQuestionData>(parameters: ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminGetQuestionData, AdminGetQuestionError, OperationInfiniteData<TData, AdminGetQuestionParameters>, ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetQuestionData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminGetQuestionParameters>, OperationError<AdminGetQuestionError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminGetQuestionData = qraft.v3Service.adminGetQuestion.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 question_id: questionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 question_id: questionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetQuestionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminGetQuestionCombinedData = qraft.v3Service.adminGetQuestion.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 question_id: questionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 question_id: questionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetQuestionCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminGetQuestionSchema, AdminGetQuestionParameters, AdminGetQuestionData, AdminGetQuestionError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminGetQuestionData, AdminGetQuestionError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminGetQuestionData, AdminGetQuestionError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Get Question */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetQuestionSchema, AdminGetQuestionData, AdminGetQuestionParameters, AdminGetQuestionError>): Promise<AdminGetQuestionData>;
        /** @summary Admin Get Question */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetQuestionSchema, AdminGetQuestionData, AdminGetQuestionParameters, AdminGetQuestionError>): Promise<void>;
        /** @summary Admin Get Question */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminGetQuestionSchema, AdminGetQuestionData, AdminGetQuestionParameters, AdminGetQuestionError>): Promise<AdminGetQuestionData>;
        /** @summary Admin Get Question */
        fetchInfiniteQuery<TPageParam extends AdminGetQuestionParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetQuestionSchema, AdminGetQuestionData, AdminGetQuestionParameters, DeepReadonly<TPageParam>, AdminGetQuestionError>): Promise<OperationInfiniteData<AdminGetQuestionData, AdminGetQuestionParameters>>;
        /** @summary Admin Get Question */
        prefetchInfiniteQuery<TPageParam extends AdminGetQuestionParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetQuestionSchema, AdminGetQuestionData, AdminGetQuestionParameters, DeepReadonly<TPageParam>, AdminGetQuestionError>): Promise<void>;
        /** @summary Admin Get Question */
        ensureInfiniteQueryData<TPageParam extends AdminGetQuestionParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminGetQuestionSchema, AdminGetQuestionData, AdminGetQuestionParameters, DeepReadonly<TPageParam>, AdminGetQuestionError>): Promise<OperationInfiniteData<AdminGetQuestionData, AdminGetQuestionParameters>>;
        /** @summary Admin Get Question */
        getQueryData(parameters: ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>)): AdminGetQuestionData | undefined;
        /** @summary Admin Get Question */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>)): OperationInfiniteData<AdminGetQuestionData, AdminGetQuestionParameters> | undefined;
        /** @summary Admin Get Question */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError> | QueryFiltersByQueryKey<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>,
            data: NoInfer<OperationInfiniteData<AdminGetQuestionData, AdminGetQuestionParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>,
            data: AdminGetQuestionData | undefined
        ]>;
        /** @summary Admin Get Question */
        getQueryState(parameters: ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters> | (DeepReadonly<AdminGetQuestionParameters>)): QueryState<AdminGetQuestionData, AdminGetQuestionError> | undefined;
        /** @summary Admin Get Question */
        getInfiniteQueryState(parameters: DeepReadonly<AdminGetQuestionParameters> | ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>): QueryState<OperationInfiniteData<AdminGetQuestionData, AdminGetQuestionParameters>, AdminGetQuestionError> | undefined;
        /** @summary Admin Get Question */
        setQueryData(parameters: (DeepReadonly<AdminGetQuestionParameters>) | ServiceOperationQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>, updater: Updater<NoInfer<AdminGetQuestionData> | undefined, NoInfer<DeepReadonly<AdminGetQuestionData>> | undefined>, options?: SetDataOptions): AdminGetQuestionData | undefined;
        /** @summary Admin Get Question */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminGetQuestionParameters>) | ServiceOperationInfiniteQueryKey<AdminGetQuestionSchema, AdminGetQuestionParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminGetQuestionData, AdminGetQuestionParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminGetQuestionData, AdminGetQuestionParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminGetQuestionData, AdminGetQuestionParameters> | undefined;
        /** @summary Admin Get Question */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError> | QueryFiltersByQueryKey<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>, updater: Updater<NoInfer<AdminGetQuestionData> | undefined, NoInfer<AdminGetQuestionData> | undefined>, options?: SetDataOptions): Array<AdminGetQuestionData | undefined>;
        /** @summary Admin Get Question */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Get Question */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError> | QueryFiltersByQueryKey<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Get Question */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError> | QueryFiltersByQueryKey<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Get Question */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError> | QueryFiltersByQueryKey<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>): void;
        /** @summary Admin Get Question */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError> | QueryFiltersByQueryKey<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Get Question */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError> | QueryFiltersByQueryKey<AdminGetQuestionSchema, AdminGetQuestionData, TInfinite, AdminGetQuestionParameters, AdminGetQuestionError>): number;
        schema: AdminGetQuestionSchema;
        types: {
            parameters: AdminGetQuestionParameters;
            data: AdminGetQuestionData;
            error: AdminGetQuestionError;
        };
    };
    /** @summary Admin Update Question */
    adminUpdateQuestion: {
        /** @summary Admin Update Question */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminUpdateQuestionBody, AdminUpdateQuestionParameters, TMeta, TSignal>, client?: (schema: AdminUpdateQuestionSchema, options: ServiceOperationMutationFnOptions<AdminUpdateQuestionBody, AdminUpdateQuestionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminUpdateQuestionData, AdminUpdateQuestionError>>): Promise<RequestFnResponse<AdminUpdateQuestionData, AdminUpdateQuestionError>>;
        /** @summary Admin Update Question */
        getMutationKey(parameters: DeepReadonly<AdminUpdateQuestionParameters> | void): ServiceOperationMutationKey<AdminUpdateQuestionSchema, AdminUpdateQuestionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateQuestion.useMutation({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateQuestion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminUpdateQuestionBody, TContext = unknown>(parameters: DeepReadonly<AdminUpdateQuestionParameters>, options?: ServiceOperationUseMutationOptions<AdminUpdateQuestionSchema, AdminUpdateQuestionData, AdminUpdateQuestionParameters, TVariables, OperationError<AdminUpdateQuestionError>, TContext>): UseMutationResult<AdminUpdateQuestionData, OperationError<AdminUpdateQuestionError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateQuestion.useMutation({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateQuestion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminUpdateQuestionBody, AdminUpdateQuestionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminUpdateQuestionSchema, AdminUpdateQuestionData, AdminUpdateQuestionParameters, TVariables, OperationError<AdminUpdateQuestionError>, TContext>): UseMutationResult<AdminUpdateQuestionData, OperationError<AdminUpdateQuestionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Update Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminUpdateQuestionTotal = qraft.v3Service.adminUpdateQuestion.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminUpdateQuestionTotal = qraft.v3Service.adminUpdateQuestion.useIsMutating({
         *     parameters: {
         *         path: {
         *             question_id: questionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminUpdateQuestionSchema, AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Update Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminUpdateQuestionPendingMutationVariables = qraft.v3Service.adminUpdateQuestion.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminUpdateQuestionMutationData = qraft.v3Service.adminUpdateQuestion.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 question_id: questionId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminUpdateQuestionData, OperationError<AdminUpdateQuestionError>, MutationVariables<AdminUpdateQuestionBody, AdminUpdateQuestionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminUpdateQuestionSchema, AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext>;
            select?: (mutation: Mutation<AdminUpdateQuestionData, OperationError<AdminUpdateQuestionError>, MutationVariables<AdminUpdateQuestionBody, AdminUpdateQuestionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Update Question */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminUpdateQuestionSchema, AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Update Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateQuestion.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             question_id: questionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateQuestion.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminUpdateQuestionSchema, AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext>): Mutation<AdminUpdateQuestionData, AdminUpdateQuestionError, MutationVariables<AdminUpdateQuestionBody, AdminUpdateQuestionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext> | MutationFiltersByMutationKey<AdminUpdateQuestionSchema, AdminUpdateQuestionBody, AdminUpdateQuestionData, AdminUpdateQuestionParameters, OperationError<AdminUpdateQuestionError>, TContext>): Array<Mutation<AdminUpdateQuestionData, AdminUpdateQuestionError, MutationVariables<AdminUpdateQuestionBody, AdminUpdateQuestionParameters>, TContext>>;
        };
        schema: AdminUpdateQuestionSchema;
        types: {
            parameters: AdminUpdateQuestionParameters;
            data: AdminUpdateQuestionData;
            error: AdminUpdateQuestionError;
            body: AdminUpdateQuestionBody;
        };
    };
    /** @summary Admin Delete Question */
    adminDeleteQuestion: {
        /** @summary Admin Delete Question */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminDeleteQuestionBody, AdminDeleteQuestionParameters, TMeta, TSignal>, client?: (schema: AdminDeleteQuestionSchema, options: ServiceOperationMutationFnOptions<AdminDeleteQuestionBody, AdminDeleteQuestionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminDeleteQuestionData, AdminDeleteQuestionError>>): Promise<RequestFnResponse<AdminDeleteQuestionData, AdminDeleteQuestionError>>;
        /** @summary Admin Delete Question */
        getMutationKey(parameters: DeepReadonly<AdminDeleteQuestionParameters> | void): ServiceOperationMutationKey<AdminDeleteQuestionSchema, AdminDeleteQuestionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteQuestion.useMutation({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteQuestion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminDeleteQuestionBody, TContext = unknown>(parameters: DeepReadonly<AdminDeleteQuestionParameters>, options?: ServiceOperationUseMutationOptions<AdminDeleteQuestionSchema, AdminDeleteQuestionData, AdminDeleteQuestionParameters, TVariables, OperationError<AdminDeleteQuestionError>, TContext>): UseMutationResult<AdminDeleteQuestionData, OperationError<AdminDeleteQuestionError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteQuestion.useMutation({
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteQuestion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         question_id: questionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminDeleteQuestionBody, AdminDeleteQuestionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminDeleteQuestionSchema, AdminDeleteQuestionData, AdminDeleteQuestionParameters, TVariables, OperationError<AdminDeleteQuestionError>, TContext>): UseMutationResult<AdminDeleteQuestionData, OperationError<AdminDeleteQuestionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Delete Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminDeleteQuestionTotal = qraft.v3Service.adminDeleteQuestion.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminDeleteQuestionTotal = qraft.v3Service.adminDeleteQuestion.useIsMutating({
         *     parameters: {
         *         path: {
         *             question_id: questionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext> | MutationFiltersByMutationKey<AdminDeleteQuestionSchema, AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Delete Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminDeleteQuestionPendingMutationVariables = qraft.v3Service.adminDeleteQuestion.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminDeleteQuestionMutationData = qraft.v3Service.adminDeleteQuestion.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 question_id: questionId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminDeleteQuestionData, OperationError<AdminDeleteQuestionError>, MutationVariables<AdminDeleteQuestionBody, AdminDeleteQuestionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext> | MutationFiltersByMutationKey<AdminDeleteQuestionSchema, AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext>;
            select?: (mutation: Mutation<AdminDeleteQuestionData, OperationError<AdminDeleteQuestionError>, MutationVariables<AdminDeleteQuestionBody, AdminDeleteQuestionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Delete Question */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext> | MutationFiltersByMutationKey<AdminDeleteQuestionSchema, AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Delete Question
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteQuestion.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             question_id: questionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteQuestion.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext> | MutationFiltersByMutationKey<AdminDeleteQuestionSchema, AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext>): Mutation<AdminDeleteQuestionData, AdminDeleteQuestionError, MutationVariables<AdminDeleteQuestionBody, AdminDeleteQuestionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext> | MutationFiltersByMutationKey<AdminDeleteQuestionSchema, AdminDeleteQuestionBody, AdminDeleteQuestionData, AdminDeleteQuestionParameters, OperationError<AdminDeleteQuestionError>, TContext>): Array<Mutation<AdminDeleteQuestionData, AdminDeleteQuestionError, MutationVariables<AdminDeleteQuestionBody, AdminDeleteQuestionParameters>, TContext>>;
        };
        schema: AdminDeleteQuestionSchema;
        types: {
            parameters: AdminDeleteQuestionParameters;
            data: AdminDeleteQuestionData;
            error: AdminDeleteQuestionError;
            body: AdminDeleteQuestionBody;
        };
    };
    /** @summary Admin Bulk Delete Questions */
    adminBulkDeleteQuestions: {
        /** @summary Admin Bulk Delete Questions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsParameters, TMeta, TSignal>, client?: (schema: AdminBulkDeleteQuestionsSchema, options: ServiceOperationMutationFnOptions<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsError>>): Promise<RequestFnResponse<AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsError>>;
        /** @summary Admin Bulk Delete Questions */
        getMutationKey(parameters: DeepReadonly<AdminBulkDeleteQuestionsParameters> | void): ServiceOperationMutationKey<AdminBulkDeleteQuestionsSchema, AdminBulkDeleteQuestionsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Bulk Delete Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminBulkDeleteQuestions.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminBulkDeleteQuestions.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminBulkDeleteQuestionsBody, TContext = unknown>(parameters: DeepReadonly<AdminBulkDeleteQuestionsParameters>, options?: ServiceOperationUseMutationOptions<AdminBulkDeleteQuestionsSchema, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, TVariables, OperationError<AdminBulkDeleteQuestionsError>, TContext>): UseMutationResult<AdminBulkDeleteQuestionsData, OperationError<AdminBulkDeleteQuestionsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Bulk Delete Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminBulkDeleteQuestions.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminBulkDeleteQuestions.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminBulkDeleteQuestionsSchema, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, TVariables, OperationError<AdminBulkDeleteQuestionsError>, TContext>): UseMutationResult<AdminBulkDeleteQuestionsData, OperationError<AdminBulkDeleteQuestionsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Bulk Delete Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminBulkDeleteQuestionsTotal = qraft.v3Service.adminBulkDeleteQuestions.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminBulkDeleteQuestionsTotal = qraft.v3Service.adminBulkDeleteQuestions.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkDeleteQuestionsSchema, AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Bulk Delete Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminBulkDeleteQuestionsPendingMutationVariables = qraft.v3Service.adminBulkDeleteQuestions.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminBulkDeleteQuestionsMutationData = qraft.v3Service.adminBulkDeleteQuestions.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminBulkDeleteQuestionsData, OperationError<AdminBulkDeleteQuestionsError>, MutationVariables<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkDeleteQuestionsSchema, AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext>;
            select?: (mutation: Mutation<AdminBulkDeleteQuestionsData, OperationError<AdminBulkDeleteQuestionsError>, MutationVariables<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Bulk Delete Questions */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkDeleteQuestionsSchema, AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Bulk Delete Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminBulkDeleteQuestions.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminBulkDeleteQuestions.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkDeleteQuestionsSchema, AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext>): Mutation<AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsError, MutationVariables<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkDeleteQuestionsSchema, AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsParameters, OperationError<AdminBulkDeleteQuestionsError>, TContext>): Array<Mutation<AdminBulkDeleteQuestionsData, AdminBulkDeleteQuestionsError, MutationVariables<AdminBulkDeleteQuestionsBody, AdminBulkDeleteQuestionsParameters>, TContext>>;
        };
        schema: AdminBulkDeleteQuestionsSchema;
        types: {
            parameters: AdminBulkDeleteQuestionsParameters;
            data: AdminBulkDeleteQuestionsData;
            error: AdminBulkDeleteQuestionsError;
            body: AdminBulkDeleteQuestionsBody;
        };
    };
    /** @summary Admin Bulk Publish Questions */
    adminBulkPublishQuestions: {
        /** @summary Admin Bulk Publish Questions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsParameters, TMeta, TSignal>, client?: (schema: AdminBulkPublishQuestionsSchema, options: ServiceOperationMutationFnOptions<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsError>>): Promise<RequestFnResponse<AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsError>>;
        /** @summary Admin Bulk Publish Questions */
        getMutationKey(parameters: DeepReadonly<AdminBulkPublishQuestionsParameters> | void): ServiceOperationMutationKey<AdminBulkPublishQuestionsSchema, AdminBulkPublishQuestionsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Bulk Publish Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminBulkPublishQuestions.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminBulkPublishQuestions.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminBulkPublishQuestionsBody, TContext = unknown>(parameters: DeepReadonly<AdminBulkPublishQuestionsParameters>, options?: ServiceOperationUseMutationOptions<AdminBulkPublishQuestionsSchema, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, TVariables, OperationError<AdminBulkPublishQuestionsError>, TContext>): UseMutationResult<AdminBulkPublishQuestionsData, OperationError<AdminBulkPublishQuestionsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Bulk Publish Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminBulkPublishQuestions.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminBulkPublishQuestions.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminBulkPublishQuestionsSchema, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, TVariables, OperationError<AdminBulkPublishQuestionsError>, TContext>): UseMutationResult<AdminBulkPublishQuestionsData, OperationError<AdminBulkPublishQuestionsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Bulk Publish Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminBulkPublishQuestionsTotal = qraft.v3Service.adminBulkPublishQuestions.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminBulkPublishQuestionsTotal = qraft.v3Service.adminBulkPublishQuestions.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkPublishQuestionsSchema, AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Bulk Publish Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminBulkPublishQuestionsPendingMutationVariables = qraft.v3Service.adminBulkPublishQuestions.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminBulkPublishQuestionsMutationData = qraft.v3Service.adminBulkPublishQuestions.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminBulkPublishQuestionsData, OperationError<AdminBulkPublishQuestionsError>, MutationVariables<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkPublishQuestionsSchema, AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext>;
            select?: (mutation: Mutation<AdminBulkPublishQuestionsData, OperationError<AdminBulkPublishQuestionsError>, MutationVariables<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Bulk Publish Questions */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkPublishQuestionsSchema, AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Bulk Publish Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminBulkPublishQuestions.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminBulkPublishQuestions.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkPublishQuestionsSchema, AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext>): Mutation<AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsError, MutationVariables<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext> | MutationFiltersByMutationKey<AdminBulkPublishQuestionsSchema, AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsParameters, OperationError<AdminBulkPublishQuestionsError>, TContext>): Array<Mutation<AdminBulkPublishQuestionsData, AdminBulkPublishQuestionsError, MutationVariables<AdminBulkPublishQuestionsBody, AdminBulkPublishQuestionsParameters>, TContext>>;
        };
        schema: AdminBulkPublishQuestionsSchema;
        types: {
            parameters: AdminBulkPublishQuestionsParameters;
            data: AdminBulkPublishQuestionsData;
            error: AdminBulkPublishQuestionsError;
            body: AdminBulkPublishQuestionsBody;
        };
    };
    /** @summary Admin Upload Media */
    adminUploadMedia: {
        /** @summary Admin Upload Media */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminUploadMediaBody, AdminUploadMediaParameters, TMeta, TSignal>, client?: (schema: AdminUploadMediaSchema, options: ServiceOperationMutationFnOptions<AdminUploadMediaBody, AdminUploadMediaParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminUploadMediaData, AdminUploadMediaError>>): Promise<RequestFnResponse<AdminUploadMediaData, AdminUploadMediaError>>;
        /** @summary Admin Upload Media */
        getMutationKey(parameters: DeepReadonly<AdminUploadMediaParameters> | void): ServiceOperationMutationKey<AdminUploadMediaSchema, AdminUploadMediaParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Upload Media
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUploadMedia.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUploadMedia.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminUploadMediaBody, TContext = unknown>(parameters: DeepReadonly<AdminUploadMediaParameters>, options?: ServiceOperationUseMutationOptions<AdminUploadMediaSchema, AdminUploadMediaData, AdminUploadMediaParameters, TVariables, OperationError<AdminUploadMediaError>, TContext>): UseMutationResult<AdminUploadMediaData, OperationError<AdminUploadMediaError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Upload Media
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUploadMedia.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUploadMedia.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminUploadMediaBody, AdminUploadMediaParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminUploadMediaSchema, AdminUploadMediaData, AdminUploadMediaParameters, TVariables, OperationError<AdminUploadMediaError>, TContext>): UseMutationResult<AdminUploadMediaData, OperationError<AdminUploadMediaError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Upload Media
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminUploadMediaTotal = qraft.v3Service.adminUploadMedia.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminUploadMediaTotal = qraft.v3Service.adminUploadMedia.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext> | MutationFiltersByMutationKey<AdminUploadMediaSchema, AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Upload Media
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminUploadMediaPendingMutationVariables = qraft.v3Service.adminUploadMedia.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminUploadMediaMutationData = qraft.v3Service.adminUploadMedia.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminUploadMediaData, OperationError<AdminUploadMediaError>, MutationVariables<AdminUploadMediaBody, AdminUploadMediaParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext> | MutationFiltersByMutationKey<AdminUploadMediaSchema, AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext>;
            select?: (mutation: Mutation<AdminUploadMediaData, OperationError<AdminUploadMediaError>, MutationVariables<AdminUploadMediaBody, AdminUploadMediaParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Upload Media */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext> | MutationFiltersByMutationKey<AdminUploadMediaSchema, AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Upload Media
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminUploadMedia.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminUploadMedia.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext> | MutationFiltersByMutationKey<AdminUploadMediaSchema, AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext>): Mutation<AdminUploadMediaData, AdminUploadMediaError, MutationVariables<AdminUploadMediaBody, AdminUploadMediaParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext> | MutationFiltersByMutationKey<AdminUploadMediaSchema, AdminUploadMediaBody, AdminUploadMediaData, AdminUploadMediaParameters, OperationError<AdminUploadMediaError>, TContext>): Array<Mutation<AdminUploadMediaData, AdminUploadMediaError, MutationVariables<AdminUploadMediaBody, AdminUploadMediaParameters>, TContext>>;
        };
        schema: AdminUploadMediaSchema;
        types: {
            parameters: AdminUploadMediaParameters;
            data: AdminUploadMediaData;
            error: AdminUploadMediaError;
            body: AdminUploadMediaBody;
        };
    };
    /** @summary Admin Get Lesson */
    adminGetLesson: {
        /** @summary Admin Get Lesson */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminGetLessonSchema, AdminGetLessonParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminGetLessonParameters, TMeta, TSignal>), client?: (schema: AdminGetLessonSchema, options: {
            parameters: AdminGetLessonParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminGetLessonData, AdminGetLessonError>>): Promise<RequestFnResponse<AdminGetLessonData, AdminGetLessonError>>;
        /** @summary Admin Get Lesson */
        getQueryKey(parameters: DeepReadonly<AdminGetLessonParameters>): ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetLesson.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetLessonData>(parameters: ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>), options?: Omit<UndefinedInitialDataOptions<AdminGetLessonData, AdminGetLessonError, TData, ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminGetLessonError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetLesson.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetLessonData>(parameters: ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>), options: Omit<DefinedInitialDataOptions<AdminGetLessonData, AdminGetLessonError, TData, ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminGetLessonError>>;
        /** @summary Admin Get Lesson */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminGetLessonParameters>): ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetLesson.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetLessonParameters, TQueryFnData = AdminGetLessonData, TData = OperationInfiniteData<TQueryFnData, AdminGetLessonParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetLessonError, TData, ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminGetLessonError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetLesson.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetLessonParameters, TQueryFnData = AdminGetLessonData, TData = OperationInfiniteData<TQueryFnData, AdminGetLessonParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetLessonError, TData, ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetLessonData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminGetLessonError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminGetLessonTotal = qraft.v3Service.adminGetLesson.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminGetLessonByParametersTotal = qraft.v3Service.adminGetLesson.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError> | QueryFiltersByQueryKey<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminGetLessonResults = qraft.v3Service.adminGetLesson.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetLessonResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminGetLessonCombinedResults = qraft.v3Service.adminGetLesson.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetLessonCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminGetLessonSchema, AdminGetLessonParameters, AdminGetLessonData, AdminGetLessonError>>, TCombinedResult = Array<UseQueryResult<AdminGetLessonData, AdminGetLessonError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminGetLessonData, AdminGetLessonError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminGetLesson.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminGetLessonData>(parameters: ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>), options?: Omit<UseSuspenseQueryOptions<AdminGetLessonData, AdminGetLessonError, TData, ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminGetLessonError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetLesson.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminGetLessonParameters, TData = AdminGetLessonData>(parameters: ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminGetLessonData, AdminGetLessonError, OperationInfiniteData<TData, AdminGetLessonParameters>, ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetLessonData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminGetLessonParameters>, OperationError<AdminGetLessonError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminGetLessonData = qraft.v3Service.adminGetLesson.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetLessonResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminGetLessonCombinedData = qraft.v3Service.adminGetLesson.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetLessonCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminGetLessonSchema, AdminGetLessonParameters, AdminGetLessonData, AdminGetLessonError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminGetLessonData, AdminGetLessonError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminGetLessonData, AdminGetLessonError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Get Lesson */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetLessonSchema, AdminGetLessonData, AdminGetLessonParameters, AdminGetLessonError>): Promise<AdminGetLessonData>;
        /** @summary Admin Get Lesson */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetLessonSchema, AdminGetLessonData, AdminGetLessonParameters, AdminGetLessonError>): Promise<void>;
        /** @summary Admin Get Lesson */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminGetLessonSchema, AdminGetLessonData, AdminGetLessonParameters, AdminGetLessonError>): Promise<AdminGetLessonData>;
        /** @summary Admin Get Lesson */
        fetchInfiniteQuery<TPageParam extends AdminGetLessonParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetLessonSchema, AdminGetLessonData, AdminGetLessonParameters, DeepReadonly<TPageParam>, AdminGetLessonError>): Promise<OperationInfiniteData<AdminGetLessonData, AdminGetLessonParameters>>;
        /** @summary Admin Get Lesson */
        prefetchInfiniteQuery<TPageParam extends AdminGetLessonParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetLessonSchema, AdminGetLessonData, AdminGetLessonParameters, DeepReadonly<TPageParam>, AdminGetLessonError>): Promise<void>;
        /** @summary Admin Get Lesson */
        ensureInfiniteQueryData<TPageParam extends AdminGetLessonParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminGetLessonSchema, AdminGetLessonData, AdminGetLessonParameters, DeepReadonly<TPageParam>, AdminGetLessonError>): Promise<OperationInfiniteData<AdminGetLessonData, AdminGetLessonParameters>>;
        /** @summary Admin Get Lesson */
        getQueryData(parameters: ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>)): AdminGetLessonData | undefined;
        /** @summary Admin Get Lesson */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>)): OperationInfiniteData<AdminGetLessonData, AdminGetLessonParameters> | undefined;
        /** @summary Admin Get Lesson */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError> | QueryFiltersByQueryKey<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>,
            data: NoInfer<OperationInfiniteData<AdminGetLessonData, AdminGetLessonParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>,
            data: AdminGetLessonData | undefined
        ]>;
        /** @summary Admin Get Lesson */
        getQueryState(parameters: ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters> | (DeepReadonly<AdminGetLessonParameters>)): QueryState<AdminGetLessonData, AdminGetLessonError> | undefined;
        /** @summary Admin Get Lesson */
        getInfiniteQueryState(parameters: DeepReadonly<AdminGetLessonParameters> | ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>): QueryState<OperationInfiniteData<AdminGetLessonData, AdminGetLessonParameters>, AdminGetLessonError> | undefined;
        /** @summary Admin Get Lesson */
        setQueryData(parameters: (DeepReadonly<AdminGetLessonParameters>) | ServiceOperationQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>, updater: Updater<NoInfer<AdminGetLessonData> | undefined, NoInfer<DeepReadonly<AdminGetLessonData>> | undefined>, options?: SetDataOptions): AdminGetLessonData | undefined;
        /** @summary Admin Get Lesson */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminGetLessonParameters>) | ServiceOperationInfiniteQueryKey<AdminGetLessonSchema, AdminGetLessonParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminGetLessonData, AdminGetLessonParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminGetLessonData, AdminGetLessonParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminGetLessonData, AdminGetLessonParameters> | undefined;
        /** @summary Admin Get Lesson */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError> | QueryFiltersByQueryKey<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>, updater: Updater<NoInfer<AdminGetLessonData> | undefined, NoInfer<AdminGetLessonData> | undefined>, options?: SetDataOptions): Array<AdminGetLessonData | undefined>;
        /** @summary Admin Get Lesson */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Get Lesson */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError> | QueryFiltersByQueryKey<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Get Lesson */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError> | QueryFiltersByQueryKey<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Get Lesson */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError> | QueryFiltersByQueryKey<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>): void;
        /** @summary Admin Get Lesson */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError> | QueryFiltersByQueryKey<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Get Lesson */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError> | QueryFiltersByQueryKey<AdminGetLessonSchema, AdminGetLessonData, TInfinite, AdminGetLessonParameters, AdminGetLessonError>): number;
        schema: AdminGetLessonSchema;
        types: {
            parameters: AdminGetLessonParameters;
            data: AdminGetLessonData;
            error: AdminGetLessonError;
        };
    };
    /** @summary Admin Update Lesson */
    adminUpdateLesson: {
        /** @summary Admin Update Lesson */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminUpdateLessonBody, AdminUpdateLessonParameters, TMeta, TSignal>, client?: (schema: AdminUpdateLessonSchema, options: ServiceOperationMutationFnOptions<AdminUpdateLessonBody, AdminUpdateLessonParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminUpdateLessonData, AdminUpdateLessonError>>): Promise<RequestFnResponse<AdminUpdateLessonData, AdminUpdateLessonError>>;
        /** @summary Admin Update Lesson */
        getMutationKey(parameters: DeepReadonly<AdminUpdateLessonParameters> | void): ServiceOperationMutationKey<AdminUpdateLessonSchema, AdminUpdateLessonParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateLesson.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminUpdateLessonBody, TContext = unknown>(parameters: DeepReadonly<AdminUpdateLessonParameters>, options?: ServiceOperationUseMutationOptions<AdminUpdateLessonSchema, AdminUpdateLessonData, AdminUpdateLessonParameters, TVariables, OperationError<AdminUpdateLessonError>, TContext>): UseMutationResult<AdminUpdateLessonData, OperationError<AdminUpdateLessonError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateLesson.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminUpdateLessonBody, AdminUpdateLessonParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminUpdateLessonSchema, AdminUpdateLessonData, AdminUpdateLessonParameters, TVariables, OperationError<AdminUpdateLessonError>, TContext>): UseMutationResult<AdminUpdateLessonData, OperationError<AdminUpdateLessonError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Update Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminUpdateLessonTotal = qraft.v3Service.adminUpdateLesson.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminUpdateLessonTotal = qraft.v3Service.adminUpdateLesson.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext> | MutationFiltersByMutationKey<AdminUpdateLessonSchema, AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Update Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminUpdateLessonPendingMutationVariables = qraft.v3Service.adminUpdateLesson.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminUpdateLessonMutationData = qraft.v3Service.adminUpdateLesson.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminUpdateLessonData, OperationError<AdminUpdateLessonError>, MutationVariables<AdminUpdateLessonBody, AdminUpdateLessonParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext> | MutationFiltersByMutationKey<AdminUpdateLessonSchema, AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext>;
            select?: (mutation: Mutation<AdminUpdateLessonData, OperationError<AdminUpdateLessonError>, MutationVariables<AdminUpdateLessonBody, AdminUpdateLessonParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Update Lesson */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext> | MutationFiltersByMutationKey<AdminUpdateLessonSchema, AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Update Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateLesson.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateLesson.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext> | MutationFiltersByMutationKey<AdminUpdateLessonSchema, AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext>): Mutation<AdminUpdateLessonData, AdminUpdateLessonError, MutationVariables<AdminUpdateLessonBody, AdminUpdateLessonParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext> | MutationFiltersByMutationKey<AdminUpdateLessonSchema, AdminUpdateLessonBody, AdminUpdateLessonData, AdminUpdateLessonParameters, OperationError<AdminUpdateLessonError>, TContext>): Array<Mutation<AdminUpdateLessonData, AdminUpdateLessonError, MutationVariables<AdminUpdateLessonBody, AdminUpdateLessonParameters>, TContext>>;
        };
        schema: AdminUpdateLessonSchema;
        types: {
            parameters: AdminUpdateLessonParameters;
            data: AdminUpdateLessonData;
            error: AdminUpdateLessonError;
            body: AdminUpdateLessonBody;
        };
    };
    /** @summary Admin Delete Lesson */
    adminDeleteLesson: {
        /** @summary Admin Delete Lesson */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminDeleteLessonBody, AdminDeleteLessonParameters, TMeta, TSignal>, client?: (schema: AdminDeleteLessonSchema, options: ServiceOperationMutationFnOptions<AdminDeleteLessonBody, AdminDeleteLessonParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminDeleteLessonData, AdminDeleteLessonError>>): Promise<RequestFnResponse<AdminDeleteLessonData, AdminDeleteLessonError>>;
        /** @summary Admin Delete Lesson */
        getMutationKey(parameters: DeepReadonly<AdminDeleteLessonParameters> | void): ServiceOperationMutationKey<AdminDeleteLessonSchema, AdminDeleteLessonParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteLesson.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminDeleteLessonBody, TContext = unknown>(parameters: DeepReadonly<AdminDeleteLessonParameters>, options?: ServiceOperationUseMutationOptions<AdminDeleteLessonSchema, AdminDeleteLessonData, AdminDeleteLessonParameters, TVariables, OperationError<AdminDeleteLessonError>, TContext>): UseMutationResult<AdminDeleteLessonData, OperationError<AdminDeleteLessonError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteLesson.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminDeleteLessonBody, AdminDeleteLessonParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminDeleteLessonSchema, AdminDeleteLessonData, AdminDeleteLessonParameters, TVariables, OperationError<AdminDeleteLessonError>, TContext>): UseMutationResult<AdminDeleteLessonData, OperationError<AdminDeleteLessonError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Delete Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminDeleteLessonTotal = qraft.v3Service.adminDeleteLesson.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminDeleteLessonTotal = qraft.v3Service.adminDeleteLesson.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext> | MutationFiltersByMutationKey<AdminDeleteLessonSchema, AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Delete Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminDeleteLessonPendingMutationVariables = qraft.v3Service.adminDeleteLesson.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminDeleteLessonMutationData = qraft.v3Service.adminDeleteLesson.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminDeleteLessonData, OperationError<AdminDeleteLessonError>, MutationVariables<AdminDeleteLessonBody, AdminDeleteLessonParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext> | MutationFiltersByMutationKey<AdminDeleteLessonSchema, AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext>;
            select?: (mutation: Mutation<AdminDeleteLessonData, OperationError<AdminDeleteLessonError>, MutationVariables<AdminDeleteLessonBody, AdminDeleteLessonParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Delete Lesson */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext> | MutationFiltersByMutationKey<AdminDeleteLessonSchema, AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Delete Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteLesson.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteLesson.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext> | MutationFiltersByMutationKey<AdminDeleteLessonSchema, AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext>): Mutation<AdminDeleteLessonData, AdminDeleteLessonError, MutationVariables<AdminDeleteLessonBody, AdminDeleteLessonParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext> | MutationFiltersByMutationKey<AdminDeleteLessonSchema, AdminDeleteLessonBody, AdminDeleteLessonData, AdminDeleteLessonParameters, OperationError<AdminDeleteLessonError>, TContext>): Array<Mutation<AdminDeleteLessonData, AdminDeleteLessonError, MutationVariables<AdminDeleteLessonBody, AdminDeleteLessonParameters>, TContext>>;
        };
        schema: AdminDeleteLessonSchema;
        types: {
            parameters: AdminDeleteLessonParameters;
            data: AdminDeleteLessonData;
            error: AdminDeleteLessonError;
            body: AdminDeleteLessonBody;
        };
    };
    /** @summary Admin List Lessons */
    adminListLessons: {
        /** @summary Admin List Lessons */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminListLessonsSchema, AdminListLessonsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminListLessonsParameters, TMeta, TSignal>), client?: (schema: AdminListLessonsSchema, options: {
            parameters: AdminListLessonsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminListLessonsData, AdminListLessonsError>>): Promise<RequestFnResponse<AdminListLessonsData, AdminListLessonsError>>;
        /** @summary Admin List Lessons */
        getQueryKey(parameters: DeepReadonly<AdminListLessonsParameters>): ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListLessons.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListLessonsData>(parameters: ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>), options?: Omit<UndefinedInitialDataOptions<AdminListLessonsData, AdminListLessonsError, TData, ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminListLessonsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListLessons.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListLessonsData>(parameters: ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>), options: Omit<DefinedInitialDataOptions<AdminListLessonsData, AdminListLessonsError, TData, ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminListLessonsError>>;
        /** @summary Admin List Lessons */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminListLessonsParameters>): ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListLessons.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListLessonsParameters, TQueryFnData = AdminListLessonsData, TData = OperationInfiniteData<TQueryFnData, AdminListLessonsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminListLessonsError, TData, ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminListLessonsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListLessons.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListLessonsParameters, TQueryFnData = AdminListLessonsData, TData = OperationInfiniteData<TQueryFnData, AdminListLessonsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminListLessonsError, TData, ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListLessonsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListLessonsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminListLessonsTotal = qraft.v3Service.adminListLessons.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminListLessonsByParametersTotal = qraft.v3Service.adminListLessons.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         query: {
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError> | QueryFiltersByQueryKey<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminListLessonsResults = qraft.v3Service.adminListLessons.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListLessonsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminListLessonsCombinedResults = qraft.v3Service.adminListLessons.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListLessonsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminListLessonsSchema, AdminListLessonsParameters, AdminListLessonsData, AdminListLessonsError>>, TCombinedResult = Array<UseQueryResult<AdminListLessonsData, AdminListLessonsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminListLessonsData, AdminListLessonsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminListLessons.useSuspenseQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminListLessonsData>(parameters: ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>), options?: Omit<UseSuspenseQueryOptions<AdminListLessonsData, AdminListLessonsError, TData, ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminListLessonsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListLessons.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminListLessonsParameters, TData = AdminListLessonsData>(parameters: ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminListLessonsData, AdminListLessonsError, OperationInfiniteData<TData, AdminListLessonsParameters>, ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListLessonsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminListLessonsParameters>, OperationError<AdminListLessonsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin List Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminListLessonsData = qraft.v3Service.adminListLessons.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListLessonsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminListLessonsCombinedData = qraft.v3Service.adminListLessons.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListLessonsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminListLessonsSchema, AdminListLessonsParameters, AdminListLessonsData, AdminListLessonsError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminListLessonsData, AdminListLessonsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminListLessonsData, AdminListLessonsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin List Lessons */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminListLessonsSchema, AdminListLessonsData, AdminListLessonsParameters, AdminListLessonsError>): Promise<AdminListLessonsData>;
        /** @summary Admin List Lessons */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminListLessonsSchema, AdminListLessonsData, AdminListLessonsParameters, AdminListLessonsError>): Promise<void>;
        /** @summary Admin List Lessons */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminListLessonsSchema, AdminListLessonsData, AdminListLessonsParameters, AdminListLessonsError>): Promise<AdminListLessonsData>;
        /** @summary Admin List Lessons */
        fetchInfiniteQuery<TPageParam extends AdminListLessonsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListLessonsSchema, AdminListLessonsData, AdminListLessonsParameters, DeepReadonly<TPageParam>, AdminListLessonsError>): Promise<OperationInfiniteData<AdminListLessonsData, AdminListLessonsParameters>>;
        /** @summary Admin List Lessons */
        prefetchInfiniteQuery<TPageParam extends AdminListLessonsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListLessonsSchema, AdminListLessonsData, AdminListLessonsParameters, DeepReadonly<TPageParam>, AdminListLessonsError>): Promise<void>;
        /** @summary Admin List Lessons */
        ensureInfiniteQueryData<TPageParam extends AdminListLessonsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminListLessonsSchema, AdminListLessonsData, AdminListLessonsParameters, DeepReadonly<TPageParam>, AdminListLessonsError>): Promise<OperationInfiniteData<AdminListLessonsData, AdminListLessonsParameters>>;
        /** @summary Admin List Lessons */
        getQueryData(parameters: ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>)): AdminListLessonsData | undefined;
        /** @summary Admin List Lessons */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>)): OperationInfiniteData<AdminListLessonsData, AdminListLessonsParameters> | undefined;
        /** @summary Admin List Lessons */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError> | QueryFiltersByQueryKey<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>,
            data: NoInfer<OperationInfiniteData<AdminListLessonsData, AdminListLessonsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>,
            data: AdminListLessonsData | undefined
        ]>;
        /** @summary Admin List Lessons */
        getQueryState(parameters: ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters> | (DeepReadonly<AdminListLessonsParameters>)): QueryState<AdminListLessonsData, AdminListLessonsError> | undefined;
        /** @summary Admin List Lessons */
        getInfiniteQueryState(parameters: DeepReadonly<AdminListLessonsParameters> | ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>): QueryState<OperationInfiniteData<AdminListLessonsData, AdminListLessonsParameters>, AdminListLessonsError> | undefined;
        /** @summary Admin List Lessons */
        setQueryData(parameters: (DeepReadonly<AdminListLessonsParameters>) | ServiceOperationQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>, updater: Updater<NoInfer<AdminListLessonsData> | undefined, NoInfer<DeepReadonly<AdminListLessonsData>> | undefined>, options?: SetDataOptions): AdminListLessonsData | undefined;
        /** @summary Admin List Lessons */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminListLessonsParameters>) | ServiceOperationInfiniteQueryKey<AdminListLessonsSchema, AdminListLessonsParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminListLessonsData, AdminListLessonsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminListLessonsData, AdminListLessonsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminListLessonsData, AdminListLessonsParameters> | undefined;
        /** @summary Admin List Lessons */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError> | QueryFiltersByQueryKey<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>, updater: Updater<NoInfer<AdminListLessonsData> | undefined, NoInfer<AdminListLessonsData> | undefined>, options?: SetDataOptions): Array<AdminListLessonsData | undefined>;
        /** @summary Admin List Lessons */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin List Lessons */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError> | QueryFiltersByQueryKey<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin List Lessons */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError> | QueryFiltersByQueryKey<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin List Lessons */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError> | QueryFiltersByQueryKey<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>): void;
        /** @summary Admin List Lessons */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError> | QueryFiltersByQueryKey<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin List Lessons */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError> | QueryFiltersByQueryKey<AdminListLessonsSchema, AdminListLessonsData, TInfinite, AdminListLessonsParameters, AdminListLessonsError>): number;
        schema: AdminListLessonsSchema;
        types: {
            parameters: AdminListLessonsParameters;
            data: AdminListLessonsData;
            error: AdminListLessonsError;
        };
    };
    /** @summary Admin Create Lesson */
    adminCreateLesson: {
        /** @summary Admin Create Lesson */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminCreateLessonBody, AdminCreateLessonParameters, TMeta, TSignal>, client?: (schema: AdminCreateLessonSchema, options: ServiceOperationMutationFnOptions<AdminCreateLessonBody, AdminCreateLessonParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminCreateLessonData, AdminCreateLessonError>>): Promise<RequestFnResponse<AdminCreateLessonData, AdminCreateLessonError>>;
        /** @summary Admin Create Lesson */
        getMutationKey(parameters: DeepReadonly<AdminCreateLessonParameters> | void): ServiceOperationMutationKey<AdminCreateLessonSchema, AdminCreateLessonParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateLesson.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminCreateLessonBody, TContext = unknown>(parameters: DeepReadonly<AdminCreateLessonParameters>, options?: ServiceOperationUseMutationOptions<AdminCreateLessonSchema, AdminCreateLessonData, AdminCreateLessonParameters, TVariables, OperationError<AdminCreateLessonError>, TContext>): UseMutationResult<AdminCreateLessonData, OperationError<AdminCreateLessonError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateLesson.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminCreateLessonBody, AdminCreateLessonParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminCreateLessonSchema, AdminCreateLessonData, AdminCreateLessonParameters, TVariables, OperationError<AdminCreateLessonError>, TContext>): UseMutationResult<AdminCreateLessonData, OperationError<AdminCreateLessonError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Create Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminCreateLessonTotal = qraft.v3Service.adminCreateLesson.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminCreateLessonTotal = qraft.v3Service.adminCreateLesson.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext> | MutationFiltersByMutationKey<AdminCreateLessonSchema, AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Create Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminCreateLessonPendingMutationVariables = qraft.v3Service.adminCreateLesson.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminCreateLessonMutationData = qraft.v3Service.adminCreateLesson.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminCreateLessonData, OperationError<AdminCreateLessonError>, MutationVariables<AdminCreateLessonBody, AdminCreateLessonParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext> | MutationFiltersByMutationKey<AdminCreateLessonSchema, AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext>;
            select?: (mutation: Mutation<AdminCreateLessonData, OperationError<AdminCreateLessonError>, MutationVariables<AdminCreateLessonBody, AdminCreateLessonParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Create Lesson */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext> | MutationFiltersByMutationKey<AdminCreateLessonSchema, AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Create Lesson
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateLesson.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateLesson.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext> | MutationFiltersByMutationKey<AdminCreateLessonSchema, AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext>): Mutation<AdminCreateLessonData, AdminCreateLessonError, MutationVariables<AdminCreateLessonBody, AdminCreateLessonParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext> | MutationFiltersByMutationKey<AdminCreateLessonSchema, AdminCreateLessonBody, AdminCreateLessonData, AdminCreateLessonParameters, OperationError<AdminCreateLessonError>, TContext>): Array<Mutation<AdminCreateLessonData, AdminCreateLessonError, MutationVariables<AdminCreateLessonBody, AdminCreateLessonParameters>, TContext>>;
        };
        schema: AdminCreateLessonSchema;
        types: {
            parameters: AdminCreateLessonParameters;
            data: AdminCreateLessonData;
            error: AdminCreateLessonError;
            body: AdminCreateLessonBody;
        };
    };
    /** @summary Admin Get Course Outline */
    adminGetCourseOutline: {
        /** @summary Admin Get Course Outline */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminGetCourseOutlineParameters, TMeta, TSignal>), client?: (schema: AdminGetCourseOutlineSchema, options: {
            parameters: AdminGetCourseOutlineParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminGetCourseOutlineData, AdminGetCourseOutlineError>>): Promise<RequestFnResponse<AdminGetCourseOutlineData, AdminGetCourseOutlineError>>;
        /** @summary Admin Get Course Outline */
        getQueryKey(parameters: DeepReadonly<AdminGetCourseOutlineParameters>): ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetCourseOutline.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetCourseOutlineData>(parameters: ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>), options?: Omit<UndefinedInitialDataOptions<AdminGetCourseOutlineData, AdminGetCourseOutlineError, TData, ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminGetCourseOutlineError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetCourseOutline.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetCourseOutlineData>(parameters: ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>), options: Omit<DefinedInitialDataOptions<AdminGetCourseOutlineData, AdminGetCourseOutlineError, TData, ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminGetCourseOutlineError>>;
        /** @summary Admin Get Course Outline */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminGetCourseOutlineParameters>): ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetCourseOutline.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetCourseOutlineParameters, TQueryFnData = AdminGetCourseOutlineData, TData = OperationInfiniteData<TQueryFnData, AdminGetCourseOutlineParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetCourseOutlineError, TData, ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminGetCourseOutlineError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetCourseOutline.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetCourseOutlineParameters, TQueryFnData = AdminGetCourseOutlineData, TData = OperationInfiniteData<TQueryFnData, AdminGetCourseOutlineParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetCourseOutlineError, TData, ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetCourseOutlineData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminGetCourseOutlineError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminGetCourseOutlineTotal = qraft.v3Service.adminGetCourseOutline.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminGetCourseOutlineByParametersTotal = qraft.v3Service.adminGetCourseOutline.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         query: {
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError> | QueryFiltersByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminGetCourseOutlineResults = qraft.v3Service.adminGetCourseOutline.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetCourseOutlineResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminGetCourseOutlineCombinedResults = qraft.v3Service.adminGetCourseOutline.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetCourseOutlineCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters, AdminGetCourseOutlineData, AdminGetCourseOutlineError>>, TCombinedResult = Array<UseQueryResult<AdminGetCourseOutlineData, AdminGetCourseOutlineError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminGetCourseOutlineData, AdminGetCourseOutlineError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminGetCourseOutline.useSuspenseQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminGetCourseOutlineData>(parameters: ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>), options?: Omit<UseSuspenseQueryOptions<AdminGetCourseOutlineData, AdminGetCourseOutlineError, TData, ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminGetCourseOutlineError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetCourseOutline.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminGetCourseOutlineParameters, TData = AdminGetCourseOutlineData>(parameters: ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminGetCourseOutlineData, AdminGetCourseOutlineError, OperationInfiniteData<TData, AdminGetCourseOutlineParameters>, ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetCourseOutlineData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminGetCourseOutlineParameters>, OperationError<AdminGetCourseOutlineError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Course Outline
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminGetCourseOutlineData = qraft.v3Service.adminGetCourseOutline.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetCourseOutlineResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminGetCourseOutlineCombinedData = qraft.v3Service.adminGetCourseOutline.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetCourseOutlineCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters, AdminGetCourseOutlineData, AdminGetCourseOutlineError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminGetCourseOutlineData, AdminGetCourseOutlineError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminGetCourseOutlineData, AdminGetCourseOutlineError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Get Course Outline */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>): Promise<AdminGetCourseOutlineData>;
        /** @summary Admin Get Course Outline */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>): Promise<void>;
        /** @summary Admin Get Course Outline */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>): Promise<AdminGetCourseOutlineData>;
        /** @summary Admin Get Course Outline */
        fetchInfiniteQuery<TPageParam extends AdminGetCourseOutlineParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, AdminGetCourseOutlineParameters, DeepReadonly<TPageParam>, AdminGetCourseOutlineError>): Promise<OperationInfiniteData<AdminGetCourseOutlineData, AdminGetCourseOutlineParameters>>;
        /** @summary Admin Get Course Outline */
        prefetchInfiniteQuery<TPageParam extends AdminGetCourseOutlineParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, AdminGetCourseOutlineParameters, DeepReadonly<TPageParam>, AdminGetCourseOutlineError>): Promise<void>;
        /** @summary Admin Get Course Outline */
        ensureInfiniteQueryData<TPageParam extends AdminGetCourseOutlineParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, AdminGetCourseOutlineParameters, DeepReadonly<TPageParam>, AdminGetCourseOutlineError>): Promise<OperationInfiniteData<AdminGetCourseOutlineData, AdminGetCourseOutlineParameters>>;
        /** @summary Admin Get Course Outline */
        getQueryData(parameters: ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>)): AdminGetCourseOutlineData | undefined;
        /** @summary Admin Get Course Outline */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>)): OperationInfiniteData<AdminGetCourseOutlineData, AdminGetCourseOutlineParameters> | undefined;
        /** @summary Admin Get Course Outline */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError> | QueryFiltersByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>,
            data: NoInfer<OperationInfiniteData<AdminGetCourseOutlineData, AdminGetCourseOutlineParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>,
            data: AdminGetCourseOutlineData | undefined
        ]>;
        /** @summary Admin Get Course Outline */
        getQueryState(parameters: ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters> | (DeepReadonly<AdminGetCourseOutlineParameters>)): QueryState<AdminGetCourseOutlineData, AdminGetCourseOutlineError> | undefined;
        /** @summary Admin Get Course Outline */
        getInfiniteQueryState(parameters: DeepReadonly<AdminGetCourseOutlineParameters> | ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>): QueryState<OperationInfiniteData<AdminGetCourseOutlineData, AdminGetCourseOutlineParameters>, AdminGetCourseOutlineError> | undefined;
        /** @summary Admin Get Course Outline */
        setQueryData(parameters: (DeepReadonly<AdminGetCourseOutlineParameters>) | ServiceOperationQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>, updater: Updater<NoInfer<AdminGetCourseOutlineData> | undefined, NoInfer<DeepReadonly<AdminGetCourseOutlineData>> | undefined>, options?: SetDataOptions): AdminGetCourseOutlineData | undefined;
        /** @summary Admin Get Course Outline */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminGetCourseOutlineParameters>) | ServiceOperationInfiniteQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminGetCourseOutlineData, AdminGetCourseOutlineParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminGetCourseOutlineData, AdminGetCourseOutlineParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminGetCourseOutlineData, AdminGetCourseOutlineParameters> | undefined;
        /** @summary Admin Get Course Outline */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError> | QueryFiltersByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>, updater: Updater<NoInfer<AdminGetCourseOutlineData> | undefined, NoInfer<AdminGetCourseOutlineData> | undefined>, options?: SetDataOptions): Array<AdminGetCourseOutlineData | undefined>;
        /** @summary Admin Get Course Outline */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Get Course Outline */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError> | QueryFiltersByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Get Course Outline */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError> | QueryFiltersByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Get Course Outline */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError> | QueryFiltersByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>): void;
        /** @summary Admin Get Course Outline */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError> | QueryFiltersByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Get Course Outline */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError> | QueryFiltersByQueryKey<AdminGetCourseOutlineSchema, AdminGetCourseOutlineData, TInfinite, AdminGetCourseOutlineParameters, AdminGetCourseOutlineError>): number;
        schema: AdminGetCourseOutlineSchema;
        types: {
            parameters: AdminGetCourseOutlineParameters;
            data: AdminGetCourseOutlineData;
            error: AdminGetCourseOutlineError;
        };
    };
    /** @summary Admin Search Lessons */
    adminSearchLessons: {
        /** @summary Admin Search Lessons */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminSearchLessonsParameters, TMeta, TSignal> | void), client?: (schema: AdminSearchLessonsSchema, options: {
            parameters: AdminSearchLessonsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminSearchLessonsData, AdminSearchLessonsError>>): Promise<RequestFnResponse<AdminSearchLessonsData, AdminSearchLessonsError>>;
        /** @summary Admin Search Lessons */
        getQueryKey(parameters: DeepReadonly<AdminSearchLessonsParameters> | void): ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchLessons.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchLessons.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminSearchLessonsData>(parameters: ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void), options?: Omit<UndefinedInitialDataOptions<AdminSearchLessonsData, AdminSearchLessonsError, TData, ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminSearchLessonsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchLessons.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchLessons.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminSearchLessonsData>(parameters: ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void), options: Omit<DefinedInitialDataOptions<AdminSearchLessonsData, AdminSearchLessonsError, TData, ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminSearchLessonsError>>;
        /** @summary Admin Search Lessons */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminSearchLessonsParameters> | void): ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchLessons.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminSearchLessonsParameters, TQueryFnData = AdminSearchLessonsData, TData = OperationInfiniteData<TQueryFnData, AdminSearchLessonsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminSearchLessonsError, TData, ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminSearchLessonsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchLessons.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminSearchLessonsParameters, TQueryFnData = AdminSearchLessonsData, TData = OperationInfiniteData<TQueryFnData, AdminSearchLessonsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminSearchLessonsError, TData, ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminSearchLessonsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminSearchLessonsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminSearchLessonsTotal = qraft.v3Service.adminSearchLessons.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminSearchLessonsByParametersTotal = qraft.v3Service.adminSearchLessons.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             search: search
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError> | QueryFiltersByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminSearchLessonsResults = qraft.v3Service.adminSearchLessons.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchLessonsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminSearchLessonsCombinedResults = qraft.v3Service.adminSearchLessons.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchLessonsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminSearchLessonsSchema, AdminSearchLessonsParameters, AdminSearchLessonsData, AdminSearchLessonsError>>, TCombinedResult = Array<UseQueryResult<AdminSearchLessonsData, AdminSearchLessonsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminSearchLessonsData, AdminSearchLessonsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.adminSearchLessons.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminSearchLessons.useSuspenseQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminSearchLessonsData>(parameters: ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void), options?: Omit<UseSuspenseQueryOptions<AdminSearchLessonsData, AdminSearchLessonsError, TData, ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminSearchLessonsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchLessons.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminSearchLessonsParameters, TData = AdminSearchLessonsData>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<AdminSearchLessonsData, AdminSearchLessonsError, OperationInfiniteData<TData, AdminSearchLessonsParameters>, ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminSearchLessonsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminSearchLessonsParameters>, OperationError<AdminSearchLessonsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Search Lessons
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminSearchLessonsData = qraft.v3Service.adminSearchLessons.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchLessonsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminSearchLessonsCombinedData = qraft.v3Service.adminSearchLessons.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchLessonsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminSearchLessonsSchema, AdminSearchLessonsParameters, AdminSearchLessonsData, AdminSearchLessonsError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminSearchLessonsData, AdminSearchLessonsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminSearchLessonsData, AdminSearchLessonsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Search Lessons */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminSearchLessonsSchema, AdminSearchLessonsData, AdminSearchLessonsParameters, AdminSearchLessonsError> | void): Promise<AdminSearchLessonsData>;
        /** @summary Admin Search Lessons */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminSearchLessonsSchema, AdminSearchLessonsData, AdminSearchLessonsParameters, AdminSearchLessonsError> | void): Promise<void>;
        /** @summary Admin Search Lessons */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminSearchLessonsSchema, AdminSearchLessonsData, AdminSearchLessonsParameters, AdminSearchLessonsError> | void): Promise<AdminSearchLessonsData>;
        /** @summary Admin Search Lessons */
        fetchInfiniteQuery<TPageParam extends AdminSearchLessonsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminSearchLessonsSchema, AdminSearchLessonsData, AdminSearchLessonsParameters, DeepReadonly<TPageParam>, AdminSearchLessonsError> | void): Promise<OperationInfiniteData<AdminSearchLessonsData, AdminSearchLessonsParameters>>;
        /** @summary Admin Search Lessons */
        prefetchInfiniteQuery<TPageParam extends AdminSearchLessonsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminSearchLessonsSchema, AdminSearchLessonsData, AdminSearchLessonsParameters, DeepReadonly<TPageParam>, AdminSearchLessonsError> | void): Promise<void>;
        /** @summary Admin Search Lessons */
        ensureInfiniteQueryData<TPageParam extends AdminSearchLessonsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminSearchLessonsSchema, AdminSearchLessonsData, AdminSearchLessonsParameters, DeepReadonly<TPageParam>, AdminSearchLessonsError> | void): Promise<OperationInfiniteData<AdminSearchLessonsData, AdminSearchLessonsParameters>>;
        /** @summary Admin Search Lessons */
        getQueryData(parameters: ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void)): AdminSearchLessonsData | undefined;
        /** @summary Admin Search Lessons */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void)): OperationInfiniteData<AdminSearchLessonsData, AdminSearchLessonsParameters> | undefined;
        /** @summary Admin Search Lessons */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError> | QueryFiltersByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>,
            data: NoInfer<OperationInfiniteData<AdminSearchLessonsData, AdminSearchLessonsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>,
            data: AdminSearchLessonsData | undefined
        ]>;
        /** @summary Admin Search Lessons */
        getQueryState(parameters: ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | (DeepReadonly<AdminSearchLessonsParameters> | void)): QueryState<AdminSearchLessonsData, AdminSearchLessonsError> | undefined;
        /** @summary Admin Search Lessons */
        getInfiniteQueryState(parameters: DeepReadonly<AdminSearchLessonsParameters> | ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters> | void): QueryState<OperationInfiniteData<AdminSearchLessonsData, AdminSearchLessonsParameters>, AdminSearchLessonsError> | undefined;
        /** @summary Admin Search Lessons */
        setQueryData(parameters: (DeepReadonly<AdminSearchLessonsParameters> | undefined) | ServiceOperationQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>, updater: Updater<NoInfer<AdminSearchLessonsData> | undefined, NoInfer<DeepReadonly<AdminSearchLessonsData>> | undefined>, options?: SetDataOptions): AdminSearchLessonsData | undefined;
        /** @summary Admin Search Lessons */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminSearchLessonsParameters> | undefined) | ServiceOperationInfiniteQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminSearchLessonsData, AdminSearchLessonsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminSearchLessonsData, AdminSearchLessonsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminSearchLessonsData, AdminSearchLessonsParameters> | undefined;
        /** @summary Admin Search Lessons */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError> | QueryFiltersByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>, updater: Updater<NoInfer<AdminSearchLessonsData> | undefined, NoInfer<AdminSearchLessonsData> | undefined>, options?: SetDataOptions): Array<AdminSearchLessonsData | undefined>;
        /** @summary Admin Search Lessons */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Search Lessons */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError> | QueryFiltersByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Search Lessons */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError> | QueryFiltersByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Search Lessons */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError> | QueryFiltersByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>): void;
        /** @summary Admin Search Lessons */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError> | QueryFiltersByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Search Lessons */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError> | QueryFiltersByQueryKey<AdminSearchLessonsSchema, AdminSearchLessonsData, TInfinite, AdminSearchLessonsParameters, AdminSearchLessonsError>): number;
        schema: AdminSearchLessonsSchema;
        types: {
            parameters: AdminSearchLessonsParameters;
            data: AdminSearchLessonsData;
            error: AdminSearchLessonsError;
        };
    };
    /** @summary Admin Search Topics */
    adminSearchTopics: {
        /** @summary Admin Search Topics */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminSearchTopicsParameters, TMeta, TSignal> | void), client?: (schema: AdminSearchTopicsSchema, options: {
            parameters: AdminSearchTopicsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminSearchTopicsData, AdminSearchTopicsError>>): Promise<RequestFnResponse<AdminSearchTopicsData, AdminSearchTopicsError>>;
        /** @summary Admin Search Topics */
        getQueryKey(parameters: DeepReadonly<AdminSearchTopicsParameters> | void): ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchTopics.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchTopics.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminSearchTopicsData>(parameters: ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void), options?: Omit<UndefinedInitialDataOptions<AdminSearchTopicsData, AdminSearchTopicsError, TData, ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminSearchTopicsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchTopics.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchTopics.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminSearchTopicsData>(parameters: ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void), options: Omit<DefinedInitialDataOptions<AdminSearchTopicsData, AdminSearchTopicsError, TData, ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminSearchTopicsError>>;
        /** @summary Admin Search Topics */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminSearchTopicsParameters> | void): ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchTopics.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminSearchTopicsParameters, TQueryFnData = AdminSearchTopicsData, TData = OperationInfiniteData<TQueryFnData, AdminSearchTopicsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminSearchTopicsError, TData, ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminSearchTopicsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchTopics.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminSearchTopicsParameters, TQueryFnData = AdminSearchTopicsData, TData = OperationInfiniteData<TQueryFnData, AdminSearchTopicsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminSearchTopicsError, TData, ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminSearchTopicsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminSearchTopicsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminSearchTopicsTotal = qraft.v3Service.adminSearchTopics.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminSearchTopicsByParametersTotal = qraft.v3Service.adminSearchTopics.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             search: search
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError> | QueryFiltersByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminSearchTopicsResults = qraft.v3Service.adminSearchTopics.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchTopicsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminSearchTopicsCombinedResults = qraft.v3Service.adminSearchTopics.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchTopicsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminSearchTopicsSchema, AdminSearchTopicsParameters, AdminSearchTopicsData, AdminSearchTopicsError>>, TCombinedResult = Array<UseQueryResult<AdminSearchTopicsData, AdminSearchTopicsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminSearchTopicsData, AdminSearchTopicsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.adminSearchTopics.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminSearchTopics.useSuspenseQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminSearchTopicsData>(parameters: ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void), options?: Omit<UseSuspenseQueryOptions<AdminSearchTopicsData, AdminSearchTopicsError, TData, ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminSearchTopicsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchTopics.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminSearchTopicsParameters, TData = AdminSearchTopicsData>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<AdminSearchTopicsData, AdminSearchTopicsError, OperationInfiniteData<TData, AdminSearchTopicsParameters>, ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminSearchTopicsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminSearchTopicsParameters>, OperationError<AdminSearchTopicsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Search Topics
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminSearchTopicsData = qraft.v3Service.adminSearchTopics.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchTopicsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminSearchTopicsCombinedData = qraft.v3Service.adminSearchTopics.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchTopicsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminSearchTopicsSchema, AdminSearchTopicsParameters, AdminSearchTopicsData, AdminSearchTopicsError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminSearchTopicsData, AdminSearchTopicsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminSearchTopicsData, AdminSearchTopicsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Search Topics */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminSearchTopicsSchema, AdminSearchTopicsData, AdminSearchTopicsParameters, AdminSearchTopicsError> | void): Promise<AdminSearchTopicsData>;
        /** @summary Admin Search Topics */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminSearchTopicsSchema, AdminSearchTopicsData, AdminSearchTopicsParameters, AdminSearchTopicsError> | void): Promise<void>;
        /** @summary Admin Search Topics */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminSearchTopicsSchema, AdminSearchTopicsData, AdminSearchTopicsParameters, AdminSearchTopicsError> | void): Promise<AdminSearchTopicsData>;
        /** @summary Admin Search Topics */
        fetchInfiniteQuery<TPageParam extends AdminSearchTopicsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminSearchTopicsSchema, AdminSearchTopicsData, AdminSearchTopicsParameters, DeepReadonly<TPageParam>, AdminSearchTopicsError> | void): Promise<OperationInfiniteData<AdminSearchTopicsData, AdminSearchTopicsParameters>>;
        /** @summary Admin Search Topics */
        prefetchInfiniteQuery<TPageParam extends AdminSearchTopicsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminSearchTopicsSchema, AdminSearchTopicsData, AdminSearchTopicsParameters, DeepReadonly<TPageParam>, AdminSearchTopicsError> | void): Promise<void>;
        /** @summary Admin Search Topics */
        ensureInfiniteQueryData<TPageParam extends AdminSearchTopicsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminSearchTopicsSchema, AdminSearchTopicsData, AdminSearchTopicsParameters, DeepReadonly<TPageParam>, AdminSearchTopicsError> | void): Promise<OperationInfiniteData<AdminSearchTopicsData, AdminSearchTopicsParameters>>;
        /** @summary Admin Search Topics */
        getQueryData(parameters: ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void)): AdminSearchTopicsData | undefined;
        /** @summary Admin Search Topics */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void)): OperationInfiniteData<AdminSearchTopicsData, AdminSearchTopicsParameters> | undefined;
        /** @summary Admin Search Topics */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError> | QueryFiltersByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>,
            data: NoInfer<OperationInfiniteData<AdminSearchTopicsData, AdminSearchTopicsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>,
            data: AdminSearchTopicsData | undefined
        ]>;
        /** @summary Admin Search Topics */
        getQueryState(parameters: ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | (DeepReadonly<AdminSearchTopicsParameters> | void)): QueryState<AdminSearchTopicsData, AdminSearchTopicsError> | undefined;
        /** @summary Admin Search Topics */
        getInfiniteQueryState(parameters: DeepReadonly<AdminSearchTopicsParameters> | ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters> | void): QueryState<OperationInfiniteData<AdminSearchTopicsData, AdminSearchTopicsParameters>, AdminSearchTopicsError> | undefined;
        /** @summary Admin Search Topics */
        setQueryData(parameters: (DeepReadonly<AdminSearchTopicsParameters> | undefined) | ServiceOperationQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>, updater: Updater<NoInfer<AdminSearchTopicsData> | undefined, NoInfer<DeepReadonly<AdminSearchTopicsData>> | undefined>, options?: SetDataOptions): AdminSearchTopicsData | undefined;
        /** @summary Admin Search Topics */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminSearchTopicsParameters> | undefined) | ServiceOperationInfiniteQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminSearchTopicsData, AdminSearchTopicsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminSearchTopicsData, AdminSearchTopicsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminSearchTopicsData, AdminSearchTopicsParameters> | undefined;
        /** @summary Admin Search Topics */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError> | QueryFiltersByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>, updater: Updater<NoInfer<AdminSearchTopicsData> | undefined, NoInfer<AdminSearchTopicsData> | undefined>, options?: SetDataOptions): Array<AdminSearchTopicsData | undefined>;
        /** @summary Admin Search Topics */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Search Topics */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError> | QueryFiltersByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Search Topics */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError> | QueryFiltersByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Search Topics */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError> | QueryFiltersByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>): void;
        /** @summary Admin Search Topics */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError> | QueryFiltersByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Search Topics */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError> | QueryFiltersByQueryKey<AdminSearchTopicsSchema, AdminSearchTopicsData, TInfinite, AdminSearchTopicsParameters, AdminSearchTopicsError>): number;
        schema: AdminSearchTopicsSchema;
        types: {
            parameters: AdminSearchTopicsParameters;
            data: AdminSearchTopicsData;
            error: AdminSearchTopicsError;
        };
    };
    /** @summary Admin Search Questions */
    adminSearchQuestions: {
        /** @summary Admin Search Questions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminSearchQuestionsParameters, TMeta, TSignal> | void), client?: (schema: AdminSearchQuestionsSchema, options: {
            parameters: AdminSearchQuestionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminSearchQuestionsData, AdminSearchQuestionsError>>): Promise<RequestFnResponse<AdminSearchQuestionsData, AdminSearchQuestionsError>>;
        /** @summary Admin Search Questions */
        getQueryKey(parameters: DeepReadonly<AdminSearchQuestionsParameters> | void): ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchQuestions.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchQuestions.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminSearchQuestionsData>(parameters: ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void), options?: Omit<UndefinedInitialDataOptions<AdminSearchQuestionsData, AdminSearchQuestionsError, TData, ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminSearchQuestionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchQuestions.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminSearchQuestions.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminSearchQuestionsData>(parameters: ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void), options: Omit<DefinedInitialDataOptions<AdminSearchQuestionsData, AdminSearchQuestionsError, TData, ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminSearchQuestionsError>>;
        /** @summary Admin Search Questions */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminSearchQuestionsParameters> | void): ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchQuestions.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminSearchQuestionsParameters, TQueryFnData = AdminSearchQuestionsData, TData = OperationInfiniteData<TQueryFnData, AdminSearchQuestionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminSearchQuestionsError, TData, ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminSearchQuestionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchQuestions.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminSearchQuestionsParameters, TQueryFnData = AdminSearchQuestionsData, TData = OperationInfiniteData<TQueryFnData, AdminSearchQuestionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminSearchQuestionsError, TData, ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminSearchQuestionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminSearchQuestionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminSearchQuestionsTotal = qraft.v3Service.adminSearchQuestions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminSearchQuestionsByParametersTotal = qraft.v3Service.adminSearchQuestions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             search: search
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | QueryFiltersByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminSearchQuestionsResults = qraft.v3Service.adminSearchQuestions.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminSearchQuestionsCombinedResults = qraft.v3Service.adminSearchQuestions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchQuestionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters, AdminSearchQuestionsData, AdminSearchQuestionsError>>, TCombinedResult = Array<UseQueryResult<AdminSearchQuestionsData, AdminSearchQuestionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminSearchQuestionsData, AdminSearchQuestionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.adminSearchQuestions.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminSearchQuestions.useSuspenseQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminSearchQuestionsData>(parameters: ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void), options?: Omit<UseSuspenseQueryOptions<AdminSearchQuestionsData, AdminSearchQuestionsError, TData, ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminSearchQuestionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminSearchQuestions.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminSearchQuestionsParameters, TData = AdminSearchQuestionsData>(parameters: ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<AdminSearchQuestionsData, AdminSearchQuestionsError, OperationInfiniteData<TData, AdminSearchQuestionsParameters>, ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminSearchQuestionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminSearchQuestionsParameters>, OperationError<AdminSearchQuestionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Search Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminSearchQuestionsData = qraft.v3Service.adminSearchQuestions.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminSearchQuestionsCombinedData = qraft.v3Service.adminSearchQuestions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminSearchQuestionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters, AdminSearchQuestionsData, AdminSearchQuestionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminSearchQuestionsData, AdminSearchQuestionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminSearchQuestionsData, AdminSearchQuestionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Search Questions */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminSearchQuestionsSchema, AdminSearchQuestionsData, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | void): Promise<AdminSearchQuestionsData>;
        /** @summary Admin Search Questions */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminSearchQuestionsSchema, AdminSearchQuestionsData, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | void): Promise<void>;
        /** @summary Admin Search Questions */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminSearchQuestionsSchema, AdminSearchQuestionsData, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | void): Promise<AdminSearchQuestionsData>;
        /** @summary Admin Search Questions */
        fetchInfiniteQuery<TPageParam extends AdminSearchQuestionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminSearchQuestionsSchema, AdminSearchQuestionsData, AdminSearchQuestionsParameters, DeepReadonly<TPageParam>, AdminSearchQuestionsError> | void): Promise<OperationInfiniteData<AdminSearchQuestionsData, AdminSearchQuestionsParameters>>;
        /** @summary Admin Search Questions */
        prefetchInfiniteQuery<TPageParam extends AdminSearchQuestionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminSearchQuestionsSchema, AdminSearchQuestionsData, AdminSearchQuestionsParameters, DeepReadonly<TPageParam>, AdminSearchQuestionsError> | void): Promise<void>;
        /** @summary Admin Search Questions */
        ensureInfiniteQueryData<TPageParam extends AdminSearchQuestionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminSearchQuestionsSchema, AdminSearchQuestionsData, AdminSearchQuestionsParameters, DeepReadonly<TPageParam>, AdminSearchQuestionsError> | void): Promise<OperationInfiniteData<AdminSearchQuestionsData, AdminSearchQuestionsParameters>>;
        /** @summary Admin Search Questions */
        getQueryData(parameters: ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void)): AdminSearchQuestionsData | undefined;
        /** @summary Admin Search Questions */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void)): OperationInfiniteData<AdminSearchQuestionsData, AdminSearchQuestionsParameters> | undefined;
        /** @summary Admin Search Questions */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | QueryFiltersByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>,
            data: NoInfer<OperationInfiniteData<AdminSearchQuestionsData, AdminSearchQuestionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>,
            data: AdminSearchQuestionsData | undefined
        ]>;
        /** @summary Admin Search Questions */
        getQueryState(parameters: ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | (DeepReadonly<AdminSearchQuestionsParameters> | void)): QueryState<AdminSearchQuestionsData, AdminSearchQuestionsError> | undefined;
        /** @summary Admin Search Questions */
        getInfiniteQueryState(parameters: DeepReadonly<AdminSearchQuestionsParameters> | ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters> | void): QueryState<OperationInfiniteData<AdminSearchQuestionsData, AdminSearchQuestionsParameters>, AdminSearchQuestionsError> | undefined;
        /** @summary Admin Search Questions */
        setQueryData(parameters: (DeepReadonly<AdminSearchQuestionsParameters> | undefined) | ServiceOperationQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>, updater: Updater<NoInfer<AdminSearchQuestionsData> | undefined, NoInfer<DeepReadonly<AdminSearchQuestionsData>> | undefined>, options?: SetDataOptions): AdminSearchQuestionsData | undefined;
        /** @summary Admin Search Questions */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminSearchQuestionsParameters> | undefined) | ServiceOperationInfiniteQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminSearchQuestionsData, AdminSearchQuestionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminSearchQuestionsData, AdminSearchQuestionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminSearchQuestionsData, AdminSearchQuestionsParameters> | undefined;
        /** @summary Admin Search Questions */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | QueryFiltersByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>, updater: Updater<NoInfer<AdminSearchQuestionsData> | undefined, NoInfer<AdminSearchQuestionsData> | undefined>, options?: SetDataOptions): Array<AdminSearchQuestionsData | undefined>;
        /** @summary Admin Search Questions */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Search Questions */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | QueryFiltersByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Search Questions */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | QueryFiltersByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Search Questions */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | QueryFiltersByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>): void;
        /** @summary Admin Search Questions */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | QueryFiltersByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Search Questions */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError> | QueryFiltersByQueryKey<AdminSearchQuestionsSchema, AdminSearchQuestionsData, TInfinite, AdminSearchQuestionsParameters, AdminSearchQuestionsError>): number;
        schema: AdminSearchQuestionsSchema;
        types: {
            parameters: AdminSearchQuestionsParameters;
            data: AdminSearchQuestionsData;
            error: AdminSearchQuestionsError;
        };
    };
    /** @summary Admin List Courses */
    adminListCourses: {
        /** @summary Admin List Courses */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminListCoursesSchema, AdminListCoursesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminListCoursesParameters, TMeta, TSignal> | void), client?: (schema: AdminListCoursesSchema, options: {
            parameters: AdminListCoursesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminListCoursesData, AdminListCoursesError>>): Promise<RequestFnResponse<AdminListCoursesData, AdminListCoursesError>>;
        /** @summary Admin List Courses */
        getQueryKey(parameters: DeepReadonly<AdminListCoursesParameters> | void): ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListCourses.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListCourses.useQuery({
         *     query: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListCoursesData>(parameters: ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void), options?: Omit<UndefinedInitialDataOptions<AdminListCoursesData, AdminListCoursesError, TData, ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminListCoursesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListCourses.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListCourses.useQuery({
         *     query: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListCoursesData>(parameters: ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void), options: Omit<DefinedInitialDataOptions<AdminListCoursesData, AdminListCoursesError, TData, ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminListCoursesError>>;
        /** @summary Admin List Courses */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminListCoursesParameters> | void): ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListCourses.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             series_id: initialSeriesId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListCoursesParameters, TQueryFnData = AdminListCoursesData, TData = OperationInfiniteData<TQueryFnData, AdminListCoursesParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminListCoursesError, TData, ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminListCoursesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListCourses.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             series_id: initialSeriesId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListCoursesParameters, TQueryFnData = AdminListCoursesData, TData = OperationInfiniteData<TQueryFnData, AdminListCoursesParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminListCoursesError, TData, ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListCoursesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListCoursesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminListCoursesTotal = qraft.v3Service.adminListCourses.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminListCoursesByParametersTotal = qraft.v3Service.adminListCourses.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError> | QueryFiltersByQueryKey<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminListCoursesResults = qraft.v3Service.adminListCourses.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 series_id: seriesId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 series_id: seriesId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListCoursesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminListCoursesCombinedResults = qraft.v3Service.adminListCourses.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 series_id: seriesId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 series_id: seriesId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListCoursesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminListCoursesSchema, AdminListCoursesParameters, AdminListCoursesData, AdminListCoursesError>>, TCombinedResult = Array<UseQueryResult<AdminListCoursesData, AdminListCoursesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminListCoursesData, AdminListCoursesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.adminListCourses.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminListCourses.useSuspenseQuery({
         *     query: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminListCoursesData>(parameters: ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void), options?: Omit<UseSuspenseQueryOptions<AdminListCoursesData, AdminListCoursesError, TData, ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminListCoursesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListCourses.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             series_id: initialSeriesId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminListCoursesParameters, TData = AdminListCoursesData>(parameters: ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<AdminListCoursesData, AdminListCoursesError, OperationInfiniteData<TData, AdminListCoursesParameters>, ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListCoursesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminListCoursesParameters>, OperationError<AdminListCoursesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin List Courses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminListCoursesData = qraft.v3Service.adminListCourses.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 series_id: seriesId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 series_id: seriesId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListCoursesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminListCoursesCombinedData = qraft.v3Service.adminListCourses.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 series_id: seriesId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 series_id: seriesId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListCoursesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminListCoursesSchema, AdminListCoursesParameters, AdminListCoursesData, AdminListCoursesError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminListCoursesData, AdminListCoursesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminListCoursesData, AdminListCoursesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin List Courses */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminListCoursesSchema, AdminListCoursesData, AdminListCoursesParameters, AdminListCoursesError> | void): Promise<AdminListCoursesData>;
        /** @summary Admin List Courses */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminListCoursesSchema, AdminListCoursesData, AdminListCoursesParameters, AdminListCoursesError> | void): Promise<void>;
        /** @summary Admin List Courses */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminListCoursesSchema, AdminListCoursesData, AdminListCoursesParameters, AdminListCoursesError> | void): Promise<AdminListCoursesData>;
        /** @summary Admin List Courses */
        fetchInfiniteQuery<TPageParam extends AdminListCoursesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListCoursesSchema, AdminListCoursesData, AdminListCoursesParameters, DeepReadonly<TPageParam>, AdminListCoursesError> | void): Promise<OperationInfiniteData<AdminListCoursesData, AdminListCoursesParameters>>;
        /** @summary Admin List Courses */
        prefetchInfiniteQuery<TPageParam extends AdminListCoursesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListCoursesSchema, AdminListCoursesData, AdminListCoursesParameters, DeepReadonly<TPageParam>, AdminListCoursesError> | void): Promise<void>;
        /** @summary Admin List Courses */
        ensureInfiniteQueryData<TPageParam extends AdminListCoursesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminListCoursesSchema, AdminListCoursesData, AdminListCoursesParameters, DeepReadonly<TPageParam>, AdminListCoursesError> | void): Promise<OperationInfiniteData<AdminListCoursesData, AdminListCoursesParameters>>;
        /** @summary Admin List Courses */
        getQueryData(parameters: ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void)): AdminListCoursesData | undefined;
        /** @summary Admin List Courses */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void)): OperationInfiniteData<AdminListCoursesData, AdminListCoursesParameters> | undefined;
        /** @summary Admin List Courses */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError> | QueryFiltersByQueryKey<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>,
            data: NoInfer<OperationInfiniteData<AdminListCoursesData, AdminListCoursesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>,
            data: AdminListCoursesData | undefined
        ]>;
        /** @summary Admin List Courses */
        getQueryState(parameters: ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | (DeepReadonly<AdminListCoursesParameters> | void)): QueryState<AdminListCoursesData, AdminListCoursesError> | undefined;
        /** @summary Admin List Courses */
        getInfiniteQueryState(parameters: DeepReadonly<AdminListCoursesParameters> | ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters> | void): QueryState<OperationInfiniteData<AdminListCoursesData, AdminListCoursesParameters>, AdminListCoursesError> | undefined;
        /** @summary Admin List Courses */
        setQueryData(parameters: (DeepReadonly<AdminListCoursesParameters> | undefined) | ServiceOperationQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>, updater: Updater<NoInfer<AdminListCoursesData> | undefined, NoInfer<DeepReadonly<AdminListCoursesData>> | undefined>, options?: SetDataOptions): AdminListCoursesData | undefined;
        /** @summary Admin List Courses */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminListCoursesParameters> | undefined) | ServiceOperationInfiniteQueryKey<AdminListCoursesSchema, AdminListCoursesParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminListCoursesData, AdminListCoursesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminListCoursesData, AdminListCoursesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminListCoursesData, AdminListCoursesParameters> | undefined;
        /** @summary Admin List Courses */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError> | QueryFiltersByQueryKey<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>, updater: Updater<NoInfer<AdminListCoursesData> | undefined, NoInfer<AdminListCoursesData> | undefined>, options?: SetDataOptions): Array<AdminListCoursesData | undefined>;
        /** @summary Admin List Courses */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin List Courses */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError> | QueryFiltersByQueryKey<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin List Courses */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError> | QueryFiltersByQueryKey<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin List Courses */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError> | QueryFiltersByQueryKey<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>): void;
        /** @summary Admin List Courses */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError> | QueryFiltersByQueryKey<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin List Courses */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError> | QueryFiltersByQueryKey<AdminListCoursesSchema, AdminListCoursesData, TInfinite, AdminListCoursesParameters, AdminListCoursesError>): number;
        schema: AdminListCoursesSchema;
        types: {
            parameters: AdminListCoursesParameters;
            data: AdminListCoursesData;
            error: AdminListCoursesError;
        };
    };
    /** @summary Admin Create Course */
    adminCreateCourse: {
        /** @summary Admin Create Course */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminCreateCourseBody, AdminCreateCourseParameters, TMeta, TSignal>, client?: (schema: AdminCreateCourseSchema, options: ServiceOperationMutationFnOptions<AdminCreateCourseBody, AdminCreateCourseParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminCreateCourseData, AdminCreateCourseError>>): Promise<RequestFnResponse<AdminCreateCourseData, AdminCreateCourseError>>;
        /** @summary Admin Create Course */
        getMutationKey(parameters: DeepReadonly<AdminCreateCourseParameters> | void): ServiceOperationMutationKey<AdminCreateCourseSchema, AdminCreateCourseParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateCourse.useMutation({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateCourse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminCreateCourseBody, TContext = unknown>(parameters: DeepReadonly<AdminCreateCourseParameters>, options?: ServiceOperationUseMutationOptions<AdminCreateCourseSchema, AdminCreateCourseData, AdminCreateCourseParameters, TVariables, OperationError<AdminCreateCourseError>, TContext>): UseMutationResult<AdminCreateCourseData, OperationError<AdminCreateCourseError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateCourse.useMutation({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateCourse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminCreateCourseBody, AdminCreateCourseParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminCreateCourseSchema, AdminCreateCourseData, AdminCreateCourseParameters, TVariables, OperationError<AdminCreateCourseError>, TContext>): UseMutationResult<AdminCreateCourseData, OperationError<AdminCreateCourseError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Create Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminCreateCourseTotal = qraft.v3Service.adminCreateCourse.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminCreateCourseTotal = qraft.v3Service.adminCreateCourse.useIsMutating({
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseSchema, AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Create Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminCreateCoursePendingMutationVariables = qraft.v3Service.adminCreateCourse.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminCreateCourseMutationData = qraft.v3Service.adminCreateCourse.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 series_id: seriesId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminCreateCourseData, OperationError<AdminCreateCourseError>, MutationVariables<AdminCreateCourseBody, AdminCreateCourseParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseSchema, AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext>;
            select?: (mutation: Mutation<AdminCreateCourseData, OperationError<AdminCreateCourseError>, MutationVariables<AdminCreateCourseBody, AdminCreateCourseParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Create Course */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseSchema, AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Create Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateCourse.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateCourse.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseSchema, AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext>): Mutation<AdminCreateCourseData, AdminCreateCourseError, MutationVariables<AdminCreateCourseBody, AdminCreateCourseParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseSchema, AdminCreateCourseBody, AdminCreateCourseData, AdminCreateCourseParameters, OperationError<AdminCreateCourseError>, TContext>): Array<Mutation<AdminCreateCourseData, AdminCreateCourseError, MutationVariables<AdminCreateCourseBody, AdminCreateCourseParameters>, TContext>>;
        };
        schema: AdminCreateCourseSchema;
        types: {
            parameters: AdminCreateCourseParameters;
            data: AdminCreateCourseData;
            error: AdminCreateCourseError;
            body: AdminCreateCourseBody;
        };
    };
    /** @summary Admin Get Course */
    adminGetCourse: {
        /** @summary Admin Get Course */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminGetCourseSchema, AdminGetCourseParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminGetCourseParameters, TMeta, TSignal>), client?: (schema: AdminGetCourseSchema, options: {
            parameters: AdminGetCourseParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminGetCourseData, AdminGetCourseError>>): Promise<RequestFnResponse<AdminGetCourseData, AdminGetCourseError>>;
        /** @summary Admin Get Course */
        getQueryKey(parameters: DeepReadonly<AdminGetCourseParameters>): ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetCourse.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetCourseData>(parameters: ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>), options?: Omit<UndefinedInitialDataOptions<AdminGetCourseData, AdminGetCourseError, TData, ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminGetCourseError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetCourse.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetCourseData>(parameters: ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>), options: Omit<DefinedInitialDataOptions<AdminGetCourseData, AdminGetCourseError, TData, ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminGetCourseError>>;
        /** @summary Admin Get Course */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminGetCourseParameters>): ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetCourse.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetCourseParameters, TQueryFnData = AdminGetCourseData, TData = OperationInfiniteData<TQueryFnData, AdminGetCourseParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetCourseError, TData, ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminGetCourseError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetCourse.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetCourseParameters, TQueryFnData = AdminGetCourseData, TData = OperationInfiniteData<TQueryFnData, AdminGetCourseParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetCourseError, TData, ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetCourseData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminGetCourseError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminGetCourseTotal = qraft.v3Service.adminGetCourse.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminGetCourseByParametersTotal = qraft.v3Service.adminGetCourse.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         query: {
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError> | QueryFiltersByQueryKey<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminGetCourseResults = qraft.v3Service.adminGetCourse.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetCourseResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminGetCourseCombinedResults = qraft.v3Service.adminGetCourse.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetCourseCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminGetCourseSchema, AdminGetCourseParameters, AdminGetCourseData, AdminGetCourseError>>, TCombinedResult = Array<UseQueryResult<AdminGetCourseData, AdminGetCourseError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminGetCourseData, AdminGetCourseError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminGetCourse.useSuspenseQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminGetCourseData>(parameters: ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>), options?: Omit<UseSuspenseQueryOptions<AdminGetCourseData, AdminGetCourseError, TData, ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminGetCourseError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetCourse.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminGetCourseParameters, TData = AdminGetCourseData>(parameters: ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminGetCourseData, AdminGetCourseError, OperationInfiniteData<TData, AdminGetCourseParameters>, ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetCourseData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminGetCourseParameters>, OperationError<AdminGetCourseError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminGetCourseData = qraft.v3Service.adminGetCourse.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetCourseResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminGetCourseCombinedData = qraft.v3Service.adminGetCourse.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetCourseCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminGetCourseSchema, AdminGetCourseParameters, AdminGetCourseData, AdminGetCourseError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminGetCourseData, AdminGetCourseError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminGetCourseData, AdminGetCourseError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Get Course */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetCourseSchema, AdminGetCourseData, AdminGetCourseParameters, AdminGetCourseError>): Promise<AdminGetCourseData>;
        /** @summary Admin Get Course */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetCourseSchema, AdminGetCourseData, AdminGetCourseParameters, AdminGetCourseError>): Promise<void>;
        /** @summary Admin Get Course */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminGetCourseSchema, AdminGetCourseData, AdminGetCourseParameters, AdminGetCourseError>): Promise<AdminGetCourseData>;
        /** @summary Admin Get Course */
        fetchInfiniteQuery<TPageParam extends AdminGetCourseParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetCourseSchema, AdminGetCourseData, AdminGetCourseParameters, DeepReadonly<TPageParam>, AdminGetCourseError>): Promise<OperationInfiniteData<AdminGetCourseData, AdminGetCourseParameters>>;
        /** @summary Admin Get Course */
        prefetchInfiniteQuery<TPageParam extends AdminGetCourseParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetCourseSchema, AdminGetCourseData, AdminGetCourseParameters, DeepReadonly<TPageParam>, AdminGetCourseError>): Promise<void>;
        /** @summary Admin Get Course */
        ensureInfiniteQueryData<TPageParam extends AdminGetCourseParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminGetCourseSchema, AdminGetCourseData, AdminGetCourseParameters, DeepReadonly<TPageParam>, AdminGetCourseError>): Promise<OperationInfiniteData<AdminGetCourseData, AdminGetCourseParameters>>;
        /** @summary Admin Get Course */
        getQueryData(parameters: ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>)): AdminGetCourseData | undefined;
        /** @summary Admin Get Course */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>)): OperationInfiniteData<AdminGetCourseData, AdminGetCourseParameters> | undefined;
        /** @summary Admin Get Course */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError> | QueryFiltersByQueryKey<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>,
            data: NoInfer<OperationInfiniteData<AdminGetCourseData, AdminGetCourseParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>,
            data: AdminGetCourseData | undefined
        ]>;
        /** @summary Admin Get Course */
        getQueryState(parameters: ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters> | (DeepReadonly<AdminGetCourseParameters>)): QueryState<AdminGetCourseData, AdminGetCourseError> | undefined;
        /** @summary Admin Get Course */
        getInfiniteQueryState(parameters: DeepReadonly<AdminGetCourseParameters> | ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>): QueryState<OperationInfiniteData<AdminGetCourseData, AdminGetCourseParameters>, AdminGetCourseError> | undefined;
        /** @summary Admin Get Course */
        setQueryData(parameters: (DeepReadonly<AdminGetCourseParameters>) | ServiceOperationQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>, updater: Updater<NoInfer<AdminGetCourseData> | undefined, NoInfer<DeepReadonly<AdminGetCourseData>> | undefined>, options?: SetDataOptions): AdminGetCourseData | undefined;
        /** @summary Admin Get Course */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminGetCourseParameters>) | ServiceOperationInfiniteQueryKey<AdminGetCourseSchema, AdminGetCourseParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminGetCourseData, AdminGetCourseParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminGetCourseData, AdminGetCourseParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminGetCourseData, AdminGetCourseParameters> | undefined;
        /** @summary Admin Get Course */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError> | QueryFiltersByQueryKey<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>, updater: Updater<NoInfer<AdminGetCourseData> | undefined, NoInfer<AdminGetCourseData> | undefined>, options?: SetDataOptions): Array<AdminGetCourseData | undefined>;
        /** @summary Admin Get Course */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Get Course */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError> | QueryFiltersByQueryKey<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Get Course */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError> | QueryFiltersByQueryKey<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Get Course */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError> | QueryFiltersByQueryKey<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>): void;
        /** @summary Admin Get Course */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError> | QueryFiltersByQueryKey<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Get Course */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError> | QueryFiltersByQueryKey<AdminGetCourseSchema, AdminGetCourseData, TInfinite, AdminGetCourseParameters, AdminGetCourseError>): number;
        schema: AdminGetCourseSchema;
        types: {
            parameters: AdminGetCourseParameters;
            data: AdminGetCourseData;
            error: AdminGetCourseError;
        };
    };
    /** @summary Admin Update Course */
    adminUpdateCourse: {
        /** @summary Admin Update Course */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminUpdateCourseBody, AdminUpdateCourseParameters, TMeta, TSignal>, client?: (schema: AdminUpdateCourseSchema, options: ServiceOperationMutationFnOptions<AdminUpdateCourseBody, AdminUpdateCourseParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminUpdateCourseData, AdminUpdateCourseError>>): Promise<RequestFnResponse<AdminUpdateCourseData, AdminUpdateCourseError>>;
        /** @summary Admin Update Course */
        getMutationKey(parameters: DeepReadonly<AdminUpdateCourseParameters> | void): ServiceOperationMutationKey<AdminUpdateCourseSchema, AdminUpdateCourseParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateCourse.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateCourse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminUpdateCourseBody, TContext = unknown>(parameters: DeepReadonly<AdminUpdateCourseParameters>, options?: ServiceOperationUseMutationOptions<AdminUpdateCourseSchema, AdminUpdateCourseData, AdminUpdateCourseParameters, TVariables, OperationError<AdminUpdateCourseError>, TContext>): UseMutationResult<AdminUpdateCourseData, OperationError<AdminUpdateCourseError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Update Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateCourse.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminUpdateCourse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminUpdateCourseBody, AdminUpdateCourseParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminUpdateCourseSchema, AdminUpdateCourseData, AdminUpdateCourseParameters, TVariables, OperationError<AdminUpdateCourseError>, TContext>): UseMutationResult<AdminUpdateCourseData, OperationError<AdminUpdateCourseError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Update Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminUpdateCourseTotal = qraft.v3Service.adminUpdateCourse.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminUpdateCourseTotal = qraft.v3Service.adminUpdateCourse.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         query: {
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext> | MutationFiltersByMutationKey<AdminUpdateCourseSchema, AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Update Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminUpdateCoursePendingMutationVariables = qraft.v3Service.adminUpdateCourse.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminUpdateCourseMutationData = qraft.v3Service.adminUpdateCourse.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId
         *             },
         *             query: {
         *                 version: version
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminUpdateCourseData, OperationError<AdminUpdateCourseError>, MutationVariables<AdminUpdateCourseBody, AdminUpdateCourseParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext> | MutationFiltersByMutationKey<AdminUpdateCourseSchema, AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext>;
            select?: (mutation: Mutation<AdminUpdateCourseData, OperationError<AdminUpdateCourseError>, MutationVariables<AdminUpdateCourseBody, AdminUpdateCourseParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Update Course */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext> | MutationFiltersByMutationKey<AdminUpdateCourseSchema, AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Update Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateCourse.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         query: {
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminUpdateCourse.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext> | MutationFiltersByMutationKey<AdminUpdateCourseSchema, AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext>): Mutation<AdminUpdateCourseData, AdminUpdateCourseError, MutationVariables<AdminUpdateCourseBody, AdminUpdateCourseParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext> | MutationFiltersByMutationKey<AdminUpdateCourseSchema, AdminUpdateCourseBody, AdminUpdateCourseData, AdminUpdateCourseParameters, OperationError<AdminUpdateCourseError>, TContext>): Array<Mutation<AdminUpdateCourseData, AdminUpdateCourseError, MutationVariables<AdminUpdateCourseBody, AdminUpdateCourseParameters>, TContext>>;
        };
        schema: AdminUpdateCourseSchema;
        types: {
            parameters: AdminUpdateCourseParameters;
            data: AdminUpdateCourseData;
            error: AdminUpdateCourseError;
            body: AdminUpdateCourseBody;
        };
    };
    /** @summary Admin List Course Versions */
    adminListCourseVersions: {
        /** @summary Admin List Course Versions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminListCourseVersionsParameters, TMeta, TSignal>), client?: (schema: AdminListCourseVersionsSchema, options: {
            parameters: AdminListCourseVersionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminListCourseVersionsData, AdminListCourseVersionsError>>): Promise<RequestFnResponse<AdminListCourseVersionsData, AdminListCourseVersionsError>>;
        /** @summary Admin List Course Versions */
        getQueryKey(parameters: DeepReadonly<AdminListCourseVersionsParameters>): ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListCourseVersions.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListCourseVersionsData>(parameters: ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>), options?: Omit<UndefinedInitialDataOptions<AdminListCourseVersionsData, AdminListCourseVersionsError, TData, ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminListCourseVersionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListCourseVersions.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListCourseVersionsData>(parameters: ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>), options: Omit<DefinedInitialDataOptions<AdminListCourseVersionsData, AdminListCourseVersionsError, TData, ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminListCourseVersionsError>>;
        /** @summary Admin List Course Versions */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminListCourseVersionsParameters>): ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListCourseVersions.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListCourseVersionsParameters, TQueryFnData = AdminListCourseVersionsData, TData = OperationInfiniteData<TQueryFnData, AdminListCourseVersionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminListCourseVersionsError, TData, ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminListCourseVersionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListCourseVersions.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListCourseVersionsParameters, TQueryFnData = AdminListCourseVersionsData, TData = OperationInfiniteData<TQueryFnData, AdminListCourseVersionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminListCourseVersionsError, TData, ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListCourseVersionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListCourseVersionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminListCourseVersionsTotal = qraft.v3Service.adminListCourseVersions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminListCourseVersionsByParametersTotal = qraft.v3Service.adminListCourseVersions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError> | QueryFiltersByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminListCourseVersionsResults = qraft.v3Service.adminListCourseVersions.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListCourseVersionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminListCourseVersionsCombinedResults = qraft.v3Service.adminListCourseVersions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListCourseVersionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters, AdminListCourseVersionsData, AdminListCourseVersionsError>>, TCombinedResult = Array<UseQueryResult<AdminListCourseVersionsData, AdminListCourseVersionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminListCourseVersionsData, AdminListCourseVersionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminListCourseVersions.useSuspenseQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminListCourseVersionsData>(parameters: ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>), options?: Omit<UseSuspenseQueryOptions<AdminListCourseVersionsData, AdminListCourseVersionsError, TData, ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminListCourseVersionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListCourseVersions.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminListCourseVersionsParameters, TData = AdminListCourseVersionsData>(parameters: ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminListCourseVersionsData, AdminListCourseVersionsError, OperationInfiniteData<TData, AdminListCourseVersionsParameters>, ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListCourseVersionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminListCourseVersionsParameters>, OperationError<AdminListCourseVersionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin List Course Versions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminListCourseVersionsData = qraft.v3Service.adminListCourseVersions.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListCourseVersionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminListCourseVersionsCombinedData = qraft.v3Service.adminListCourseVersions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListCourseVersionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters, AdminListCourseVersionsData, AdminListCourseVersionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminListCourseVersionsData, AdminListCourseVersionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminListCourseVersionsData, AdminListCourseVersionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin List Course Versions */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminListCourseVersionsSchema, AdminListCourseVersionsData, AdminListCourseVersionsParameters, AdminListCourseVersionsError>): Promise<AdminListCourseVersionsData>;
        /** @summary Admin List Course Versions */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminListCourseVersionsSchema, AdminListCourseVersionsData, AdminListCourseVersionsParameters, AdminListCourseVersionsError>): Promise<void>;
        /** @summary Admin List Course Versions */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminListCourseVersionsSchema, AdminListCourseVersionsData, AdminListCourseVersionsParameters, AdminListCourseVersionsError>): Promise<AdminListCourseVersionsData>;
        /** @summary Admin List Course Versions */
        fetchInfiniteQuery<TPageParam extends AdminListCourseVersionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListCourseVersionsSchema, AdminListCourseVersionsData, AdminListCourseVersionsParameters, DeepReadonly<TPageParam>, AdminListCourseVersionsError>): Promise<OperationInfiniteData<AdminListCourseVersionsData, AdminListCourseVersionsParameters>>;
        /** @summary Admin List Course Versions */
        prefetchInfiniteQuery<TPageParam extends AdminListCourseVersionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListCourseVersionsSchema, AdminListCourseVersionsData, AdminListCourseVersionsParameters, DeepReadonly<TPageParam>, AdminListCourseVersionsError>): Promise<void>;
        /** @summary Admin List Course Versions */
        ensureInfiniteQueryData<TPageParam extends AdminListCourseVersionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminListCourseVersionsSchema, AdminListCourseVersionsData, AdminListCourseVersionsParameters, DeepReadonly<TPageParam>, AdminListCourseVersionsError>): Promise<OperationInfiniteData<AdminListCourseVersionsData, AdminListCourseVersionsParameters>>;
        /** @summary Admin List Course Versions */
        getQueryData(parameters: ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>)): AdminListCourseVersionsData | undefined;
        /** @summary Admin List Course Versions */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>)): OperationInfiniteData<AdminListCourseVersionsData, AdminListCourseVersionsParameters> | undefined;
        /** @summary Admin List Course Versions */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError> | QueryFiltersByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>,
            data: NoInfer<OperationInfiniteData<AdminListCourseVersionsData, AdminListCourseVersionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>,
            data: AdminListCourseVersionsData | undefined
        ]>;
        /** @summary Admin List Course Versions */
        getQueryState(parameters: ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters> | (DeepReadonly<AdminListCourseVersionsParameters>)): QueryState<AdminListCourseVersionsData, AdminListCourseVersionsError> | undefined;
        /** @summary Admin List Course Versions */
        getInfiniteQueryState(parameters: DeepReadonly<AdminListCourseVersionsParameters> | ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>): QueryState<OperationInfiniteData<AdminListCourseVersionsData, AdminListCourseVersionsParameters>, AdminListCourseVersionsError> | undefined;
        /** @summary Admin List Course Versions */
        setQueryData(parameters: (DeepReadonly<AdminListCourseVersionsParameters>) | ServiceOperationQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>, updater: Updater<NoInfer<AdminListCourseVersionsData> | undefined, NoInfer<DeepReadonly<AdminListCourseVersionsData>> | undefined>, options?: SetDataOptions): AdminListCourseVersionsData | undefined;
        /** @summary Admin List Course Versions */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminListCourseVersionsParameters>) | ServiceOperationInfiniteQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminListCourseVersionsData, AdminListCourseVersionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminListCourseVersionsData, AdminListCourseVersionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminListCourseVersionsData, AdminListCourseVersionsParameters> | undefined;
        /** @summary Admin List Course Versions */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError> | QueryFiltersByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>, updater: Updater<NoInfer<AdminListCourseVersionsData> | undefined, NoInfer<AdminListCourseVersionsData> | undefined>, options?: SetDataOptions): Array<AdminListCourseVersionsData | undefined>;
        /** @summary Admin List Course Versions */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin List Course Versions */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError> | QueryFiltersByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin List Course Versions */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError> | QueryFiltersByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin List Course Versions */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError> | QueryFiltersByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>): void;
        /** @summary Admin List Course Versions */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError> | QueryFiltersByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin List Course Versions */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError> | QueryFiltersByQueryKey<AdminListCourseVersionsSchema, AdminListCourseVersionsData, TInfinite, AdminListCourseVersionsParameters, AdminListCourseVersionsError>): number;
        schema: AdminListCourseVersionsSchema;
        types: {
            parameters: AdminListCourseVersionsParameters;
            data: AdminListCourseVersionsData;
            error: AdminListCourseVersionsError;
        };
    };
    /** @summary Admin Start Course Version */
    adminStartCourseVersion: {
        /** @summary Admin Start Course Version */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminStartCourseVersionBody, AdminStartCourseVersionParameters, TMeta, TSignal>, client?: (schema: AdminStartCourseVersionSchema, options: ServiceOperationMutationFnOptions<AdminStartCourseVersionBody, AdminStartCourseVersionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminStartCourseVersionData, AdminStartCourseVersionError>>): Promise<RequestFnResponse<AdminStartCourseVersionData, AdminStartCourseVersionError>>;
        /** @summary Admin Start Course Version */
        getMutationKey(parameters: DeepReadonly<AdminStartCourseVersionParameters> | void): ServiceOperationMutationKey<AdminStartCourseVersionSchema, AdminStartCourseVersionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Start Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminStartCourseVersion.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminStartCourseVersion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminStartCourseVersionBody, TContext = unknown>(parameters: DeepReadonly<AdminStartCourseVersionParameters>, options?: ServiceOperationUseMutationOptions<AdminStartCourseVersionSchema, AdminStartCourseVersionData, AdminStartCourseVersionParameters, TVariables, OperationError<AdminStartCourseVersionError>, TContext>): UseMutationResult<AdminStartCourseVersionData, OperationError<AdminStartCourseVersionError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Start Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminStartCourseVersion.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminStartCourseVersion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminStartCourseVersionBody, AdminStartCourseVersionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminStartCourseVersionSchema, AdminStartCourseVersionData, AdminStartCourseVersionParameters, TVariables, OperationError<AdminStartCourseVersionError>, TContext>): UseMutationResult<AdminStartCourseVersionData, OperationError<AdminStartCourseVersionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Start Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminStartCourseVersionTotal = qraft.v3Service.adminStartCourseVersion.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminStartCourseVersionTotal = qraft.v3Service.adminStartCourseVersion.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminStartCourseVersionSchema, AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Start Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminStartCourseVersionPendingMutationVariables = qraft.v3Service.adminStartCourseVersion.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminStartCourseVersionMutationData = qraft.v3Service.adminStartCourseVersion.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminStartCourseVersionData, OperationError<AdminStartCourseVersionError>, MutationVariables<AdminStartCourseVersionBody, AdminStartCourseVersionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminStartCourseVersionSchema, AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext>;
            select?: (mutation: Mutation<AdminStartCourseVersionData, OperationError<AdminStartCourseVersionError>, MutationVariables<AdminStartCourseVersionBody, AdminStartCourseVersionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Start Course Version */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminStartCourseVersionSchema, AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Start Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminStartCourseVersion.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminStartCourseVersion.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminStartCourseVersionSchema, AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext>): Mutation<AdminStartCourseVersionData, AdminStartCourseVersionError, MutationVariables<AdminStartCourseVersionBody, AdminStartCourseVersionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminStartCourseVersionSchema, AdminStartCourseVersionBody, AdminStartCourseVersionData, AdminStartCourseVersionParameters, OperationError<AdminStartCourseVersionError>, TContext>): Array<Mutation<AdminStartCourseVersionData, AdminStartCourseVersionError, MutationVariables<AdminStartCourseVersionBody, AdminStartCourseVersionParameters>, TContext>>;
        };
        schema: AdminStartCourseVersionSchema;
        types: {
            parameters: AdminStartCourseVersionParameters;
            data: AdminStartCourseVersionData;
            error: AdminStartCourseVersionError;
            body: AdminStartCourseVersionBody;
        };
    };
    /** @summary Admin Discard Course Version */
    adminDiscardCourseVersion: {
        /** @summary Admin Discard Course Version */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionParameters, TMeta, TSignal>, client?: (schema: AdminDiscardCourseVersionSchema, options: ServiceOperationMutationFnOptions<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminDiscardCourseVersionData, AdminDiscardCourseVersionError>>): Promise<RequestFnResponse<AdminDiscardCourseVersionData, AdminDiscardCourseVersionError>>;
        /** @summary Admin Discard Course Version */
        getMutationKey(parameters: DeepReadonly<AdminDiscardCourseVersionParameters> | void): ServiceOperationMutationKey<AdminDiscardCourseVersionSchema, AdminDiscardCourseVersionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Discard Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDiscardCourseVersion.useMutation({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDiscardCourseVersion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminDiscardCourseVersionBody, TContext = unknown>(parameters: DeepReadonly<AdminDiscardCourseVersionParameters>, options?: ServiceOperationUseMutationOptions<AdminDiscardCourseVersionSchema, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, TVariables, OperationError<AdminDiscardCourseVersionError>, TContext>): UseMutationResult<AdminDiscardCourseVersionData, OperationError<AdminDiscardCourseVersionError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Discard Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDiscardCourseVersion.useMutation({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDiscardCourseVersion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminDiscardCourseVersionSchema, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, TVariables, OperationError<AdminDiscardCourseVersionError>, TContext>): UseMutationResult<AdminDiscardCourseVersionData, OperationError<AdminDiscardCourseVersionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Discard Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminDiscardCourseVersionTotal = qraft.v3Service.adminDiscardCourseVersion.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminDiscardCourseVersionTotal = qraft.v3Service.adminDiscardCourseVersion.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminDiscardCourseVersionSchema, AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Discard Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminDiscardCourseVersionPendingMutationVariables = qraft.v3Service.adminDiscardCourseVersion.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminDiscardCourseVersionMutationData = qraft.v3Service.adminDiscardCourseVersion.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId,
         *                 version: version
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminDiscardCourseVersionData, OperationError<AdminDiscardCourseVersionError>, MutationVariables<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminDiscardCourseVersionSchema, AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext>;
            select?: (mutation: Mutation<AdminDiscardCourseVersionData, OperationError<AdminDiscardCourseVersionError>, MutationVariables<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Discard Course Version */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminDiscardCourseVersionSchema, AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Discard Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminDiscardCourseVersion.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminDiscardCourseVersion.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminDiscardCourseVersionSchema, AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext>): Mutation<AdminDiscardCourseVersionData, AdminDiscardCourseVersionError, MutationVariables<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminDiscardCourseVersionSchema, AdminDiscardCourseVersionBody, AdminDiscardCourseVersionData, AdminDiscardCourseVersionParameters, OperationError<AdminDiscardCourseVersionError>, TContext>): Array<Mutation<AdminDiscardCourseVersionData, AdminDiscardCourseVersionError, MutationVariables<AdminDiscardCourseVersionBody, AdminDiscardCourseVersionParameters>, TContext>>;
        };
        schema: AdminDiscardCourseVersionSchema;
        types: {
            parameters: AdminDiscardCourseVersionParameters;
            data: AdminDiscardCourseVersionData;
            error: AdminDiscardCourseVersionError;
            body: AdminDiscardCourseVersionBody;
        };
    };
    /** @summary Admin Find In Course Version */
    adminFindInCourseVersion: {
        /** @summary Admin Find In Course Version */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminFindInCourseVersionParameters, TMeta, TSignal>), client?: (schema: AdminFindInCourseVersionSchema, options: {
            parameters: AdminFindInCourseVersionParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminFindInCourseVersionData, AdminFindInCourseVersionError>>): Promise<RequestFnResponse<AdminFindInCourseVersionData, AdminFindInCourseVersionError>>;
        /** @summary Admin Find In Course Version */
        getQueryKey(parameters: DeepReadonly<AdminFindInCourseVersionParameters>): ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminFindInCourseVersion.useQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     query: {
         *         entity: entity,
         *         lineage_id: lineageId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminFindInCourseVersionData>(parameters: ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>), options?: Omit<UndefinedInitialDataOptions<AdminFindInCourseVersionData, AdminFindInCourseVersionError, TData, ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminFindInCourseVersionError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminFindInCourseVersion.useQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     query: {
         *         entity: entity,
         *         lineage_id: lineageId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminFindInCourseVersionData>(parameters: ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>), options: Omit<DefinedInitialDataOptions<AdminFindInCourseVersionData, AdminFindInCourseVersionError, TData, ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminFindInCourseVersionError>>;
        /** @summary Admin Find In Course Version */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminFindInCourseVersionParameters>): ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminFindInCourseVersion.useInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     query: {
         *         entity: entity,
         *         lineage_id: lineageId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             entity: initialEntity,
         *             lineage_id: initialLineageId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminFindInCourseVersionParameters, TQueryFnData = AdminFindInCourseVersionData, TData = OperationInfiniteData<TQueryFnData, AdminFindInCourseVersionParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminFindInCourseVersionError, TData, ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminFindInCourseVersionError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminFindInCourseVersion.useInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     query: {
         *         entity: entity,
         *         lineage_id: lineageId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             entity: initialEntity,
         *             lineage_id: initialLineageId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminFindInCourseVersionParameters, TQueryFnData = AdminFindInCourseVersionData, TData = OperationInfiniteData<TQueryFnData, AdminFindInCourseVersionParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminFindInCourseVersionError, TData, ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminFindInCourseVersionData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminFindInCourseVersionError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminFindInCourseVersionTotal = qraft.v3Service.adminFindInCourseVersion.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminFindInCourseVersionByParametersTotal = qraft.v3Service.adminFindInCourseVersion.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         query: {
         *             entity: entity,
         *             lineage_id: lineageId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError> | QueryFiltersByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminFindInCourseVersionResults = qraft.v3Service.adminFindInCourseVersion.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             query: {
         *                 entity: entity1,
         *                 lineage_id: lineageId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             query: {
         *                 entity: entity2,
         *                 lineage_id: lineageId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminFindInCourseVersionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminFindInCourseVersionCombinedResults = qraft.v3Service.adminFindInCourseVersion.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             query: {
         *                 entity: entity1,
         *                 lineage_id: lineageId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             query: {
         *                 entity: entity2,
         *                 lineage_id: lineageId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminFindInCourseVersionCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters, AdminFindInCourseVersionData, AdminFindInCourseVersionError>>, TCombinedResult = Array<UseQueryResult<AdminFindInCourseVersionData, AdminFindInCourseVersionError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminFindInCourseVersionData, AdminFindInCourseVersionError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminFindInCourseVersion.useSuspenseQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     query: {
         *         entity: entity,
         *         lineage_id: lineageId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminFindInCourseVersionData>(parameters: ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>), options?: Omit<UseSuspenseQueryOptions<AdminFindInCourseVersionData, AdminFindInCourseVersionError, TData, ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminFindInCourseVersionError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminFindInCourseVersion.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     query: {
         *         entity: entity,
         *         lineage_id: lineageId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             entity: initialEntity,
         *             lineage_id: initialLineageId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminFindInCourseVersionParameters, TData = AdminFindInCourseVersionData>(parameters: ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminFindInCourseVersionData, AdminFindInCourseVersionError, OperationInfiniteData<TData, AdminFindInCourseVersionParameters>, ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminFindInCourseVersionData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminFindInCourseVersionParameters>, OperationError<AdminFindInCourseVersionError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Find In Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminFindInCourseVersionData = qraft.v3Service.adminFindInCourseVersion.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             query: {
         *                 entity: entity1,
         *                 lineage_id: lineageId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             query: {
         *                 entity: entity2,
         *                 lineage_id: lineageId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminFindInCourseVersionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminFindInCourseVersionCombinedData = qraft.v3Service.adminFindInCourseVersion.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             query: {
         *                 entity: entity1,
         *                 lineage_id: lineageId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             query: {
         *                 entity: entity2,
         *                 lineage_id: lineageId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminFindInCourseVersionCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters, AdminFindInCourseVersionData, AdminFindInCourseVersionError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminFindInCourseVersionData, AdminFindInCourseVersionError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminFindInCourseVersionData, AdminFindInCourseVersionError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Find In Course Version */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>): Promise<AdminFindInCourseVersionData>;
        /** @summary Admin Find In Course Version */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>): Promise<void>;
        /** @summary Admin Find In Course Version */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>): Promise<AdminFindInCourseVersionData>;
        /** @summary Admin Find In Course Version */
        fetchInfiniteQuery<TPageParam extends AdminFindInCourseVersionParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, AdminFindInCourseVersionParameters, DeepReadonly<TPageParam>, AdminFindInCourseVersionError>): Promise<OperationInfiniteData<AdminFindInCourseVersionData, AdminFindInCourseVersionParameters>>;
        /** @summary Admin Find In Course Version */
        prefetchInfiniteQuery<TPageParam extends AdminFindInCourseVersionParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, AdminFindInCourseVersionParameters, DeepReadonly<TPageParam>, AdminFindInCourseVersionError>): Promise<void>;
        /** @summary Admin Find In Course Version */
        ensureInfiniteQueryData<TPageParam extends AdminFindInCourseVersionParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, AdminFindInCourseVersionParameters, DeepReadonly<TPageParam>, AdminFindInCourseVersionError>): Promise<OperationInfiniteData<AdminFindInCourseVersionData, AdminFindInCourseVersionParameters>>;
        /** @summary Admin Find In Course Version */
        getQueryData(parameters: ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>)): AdminFindInCourseVersionData | undefined;
        /** @summary Admin Find In Course Version */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>)): OperationInfiniteData<AdminFindInCourseVersionData, AdminFindInCourseVersionParameters> | undefined;
        /** @summary Admin Find In Course Version */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError> | QueryFiltersByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>,
            data: NoInfer<OperationInfiniteData<AdminFindInCourseVersionData, AdminFindInCourseVersionParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>,
            data: AdminFindInCourseVersionData | undefined
        ]>;
        /** @summary Admin Find In Course Version */
        getQueryState(parameters: ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters> | (DeepReadonly<AdminFindInCourseVersionParameters>)): QueryState<AdminFindInCourseVersionData, AdminFindInCourseVersionError> | undefined;
        /** @summary Admin Find In Course Version */
        getInfiniteQueryState(parameters: DeepReadonly<AdminFindInCourseVersionParameters> | ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>): QueryState<OperationInfiniteData<AdminFindInCourseVersionData, AdminFindInCourseVersionParameters>, AdminFindInCourseVersionError> | undefined;
        /** @summary Admin Find In Course Version */
        setQueryData(parameters: (DeepReadonly<AdminFindInCourseVersionParameters>) | ServiceOperationQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>, updater: Updater<NoInfer<AdminFindInCourseVersionData> | undefined, NoInfer<DeepReadonly<AdminFindInCourseVersionData>> | undefined>, options?: SetDataOptions): AdminFindInCourseVersionData | undefined;
        /** @summary Admin Find In Course Version */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminFindInCourseVersionParameters>) | ServiceOperationInfiniteQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminFindInCourseVersionData, AdminFindInCourseVersionParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminFindInCourseVersionData, AdminFindInCourseVersionParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminFindInCourseVersionData, AdminFindInCourseVersionParameters> | undefined;
        /** @summary Admin Find In Course Version */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError> | QueryFiltersByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>, updater: Updater<NoInfer<AdminFindInCourseVersionData> | undefined, NoInfer<AdminFindInCourseVersionData> | undefined>, options?: SetDataOptions): Array<AdminFindInCourseVersionData | undefined>;
        /** @summary Admin Find In Course Version */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Find In Course Version */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError> | QueryFiltersByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Find In Course Version */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError> | QueryFiltersByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Find In Course Version */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError> | QueryFiltersByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>): void;
        /** @summary Admin Find In Course Version */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError> | QueryFiltersByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Find In Course Version */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError> | QueryFiltersByQueryKey<AdminFindInCourseVersionSchema, AdminFindInCourseVersionData, TInfinite, AdminFindInCourseVersionParameters, AdminFindInCourseVersionError>): number;
        schema: AdminFindInCourseVersionSchema;
        types: {
            parameters: AdminFindInCourseVersionParameters;
            data: AdminFindInCourseVersionData;
            error: AdminFindInCourseVersionError;
        };
    };
    /** @summary Admin Course Version Changes */
    adminCourseVersionChanges: {
        /** @summary Admin Course Version Changes */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminCourseVersionChangesParameters, TMeta, TSignal>), client?: (schema: AdminCourseVersionChangesSchema, options: {
            parameters: AdminCourseVersionChangesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminCourseVersionChangesData, AdminCourseVersionChangesError>>): Promise<RequestFnResponse<AdminCourseVersionChangesData, AdminCourseVersionChangesError>>;
        /** @summary Admin Course Version Changes */
        getQueryKey(parameters: DeepReadonly<AdminCourseVersionChangesParameters>): ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminCourseVersionChanges.useQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminCourseVersionChangesData>(parameters: ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>), options?: Omit<UndefinedInitialDataOptions<AdminCourseVersionChangesData, AdminCourseVersionChangesError, TData, ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminCourseVersionChangesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminCourseVersionChanges.useQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminCourseVersionChangesData>(parameters: ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>), options: Omit<DefinedInitialDataOptions<AdminCourseVersionChangesData, AdminCourseVersionChangesError, TData, ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminCourseVersionChangesError>>;
        /** @summary Admin Course Version Changes */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminCourseVersionChangesParameters>): ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminCourseVersionChanges.useInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminCourseVersionChangesParameters, TQueryFnData = AdminCourseVersionChangesData, TData = OperationInfiniteData<TQueryFnData, AdminCourseVersionChangesParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminCourseVersionChangesError, TData, ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminCourseVersionChangesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminCourseVersionChanges.useInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminCourseVersionChangesParameters, TQueryFnData = AdminCourseVersionChangesData, TData = OperationInfiniteData<TQueryFnData, AdminCourseVersionChangesParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminCourseVersionChangesError, TData, ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminCourseVersionChangesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminCourseVersionChangesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminCourseVersionChangesTotal = qraft.v3Service.adminCourseVersionChanges.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminCourseVersionChangesByParametersTotal = qraft.v3Service.adminCourseVersionChanges.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError> | QueryFiltersByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminCourseVersionChangesResults = qraft.v3Service.adminCourseVersionChanges.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminCourseVersionChangesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminCourseVersionChangesCombinedResults = qraft.v3Service.adminCourseVersionChanges.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminCourseVersionChangesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters, AdminCourseVersionChangesData, AdminCourseVersionChangesError>>, TCombinedResult = Array<UseQueryResult<AdminCourseVersionChangesData, AdminCourseVersionChangesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminCourseVersionChangesData, AdminCourseVersionChangesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminCourseVersionChanges.useSuspenseQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminCourseVersionChangesData>(parameters: ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>), options?: Omit<UseSuspenseQueryOptions<AdminCourseVersionChangesData, AdminCourseVersionChangesError, TData, ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminCourseVersionChangesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminCourseVersionChanges.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminCourseVersionChangesParameters, TData = AdminCourseVersionChangesData>(parameters: ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminCourseVersionChangesData, AdminCourseVersionChangesError, OperationInfiniteData<TData, AdminCourseVersionChangesParameters>, ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminCourseVersionChangesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminCourseVersionChangesParameters>, OperationError<AdminCourseVersionChangesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Course Version Changes
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminCourseVersionChangesData = qraft.v3Service.adminCourseVersionChanges.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminCourseVersionChangesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminCourseVersionChangesCombinedData = qraft.v3Service.adminCourseVersionChanges.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminCourseVersionChangesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters, AdminCourseVersionChangesData, AdminCourseVersionChangesError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminCourseVersionChangesData, AdminCourseVersionChangesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminCourseVersionChangesData, AdminCourseVersionChangesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Course Version Changes */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>): Promise<AdminCourseVersionChangesData>;
        /** @summary Admin Course Version Changes */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>): Promise<void>;
        /** @summary Admin Course Version Changes */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>): Promise<AdminCourseVersionChangesData>;
        /** @summary Admin Course Version Changes */
        fetchInfiniteQuery<TPageParam extends AdminCourseVersionChangesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, AdminCourseVersionChangesParameters, DeepReadonly<TPageParam>, AdminCourseVersionChangesError>): Promise<OperationInfiniteData<AdminCourseVersionChangesData, AdminCourseVersionChangesParameters>>;
        /** @summary Admin Course Version Changes */
        prefetchInfiniteQuery<TPageParam extends AdminCourseVersionChangesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, AdminCourseVersionChangesParameters, DeepReadonly<TPageParam>, AdminCourseVersionChangesError>): Promise<void>;
        /** @summary Admin Course Version Changes */
        ensureInfiniteQueryData<TPageParam extends AdminCourseVersionChangesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, AdminCourseVersionChangesParameters, DeepReadonly<TPageParam>, AdminCourseVersionChangesError>): Promise<OperationInfiniteData<AdminCourseVersionChangesData, AdminCourseVersionChangesParameters>>;
        /** @summary Admin Course Version Changes */
        getQueryData(parameters: ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>)): AdminCourseVersionChangesData | undefined;
        /** @summary Admin Course Version Changes */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>)): OperationInfiniteData<AdminCourseVersionChangesData, AdminCourseVersionChangesParameters> | undefined;
        /** @summary Admin Course Version Changes */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError> | QueryFiltersByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>,
            data: NoInfer<OperationInfiniteData<AdminCourseVersionChangesData, AdminCourseVersionChangesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>,
            data: AdminCourseVersionChangesData | undefined
        ]>;
        /** @summary Admin Course Version Changes */
        getQueryState(parameters: ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters> | (DeepReadonly<AdminCourseVersionChangesParameters>)): QueryState<AdminCourseVersionChangesData, AdminCourseVersionChangesError> | undefined;
        /** @summary Admin Course Version Changes */
        getInfiniteQueryState(parameters: DeepReadonly<AdminCourseVersionChangesParameters> | ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>): QueryState<OperationInfiniteData<AdminCourseVersionChangesData, AdminCourseVersionChangesParameters>, AdminCourseVersionChangesError> | undefined;
        /** @summary Admin Course Version Changes */
        setQueryData(parameters: (DeepReadonly<AdminCourseVersionChangesParameters>) | ServiceOperationQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>, updater: Updater<NoInfer<AdminCourseVersionChangesData> | undefined, NoInfer<DeepReadonly<AdminCourseVersionChangesData>> | undefined>, options?: SetDataOptions): AdminCourseVersionChangesData | undefined;
        /** @summary Admin Course Version Changes */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminCourseVersionChangesParameters>) | ServiceOperationInfiniteQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminCourseVersionChangesData, AdminCourseVersionChangesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminCourseVersionChangesData, AdminCourseVersionChangesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminCourseVersionChangesData, AdminCourseVersionChangesParameters> | undefined;
        /** @summary Admin Course Version Changes */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError> | QueryFiltersByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>, updater: Updater<NoInfer<AdminCourseVersionChangesData> | undefined, NoInfer<AdminCourseVersionChangesData> | undefined>, options?: SetDataOptions): Array<AdminCourseVersionChangesData | undefined>;
        /** @summary Admin Course Version Changes */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Course Version Changes */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError> | QueryFiltersByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Course Version Changes */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError> | QueryFiltersByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Course Version Changes */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError> | QueryFiltersByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>): void;
        /** @summary Admin Course Version Changes */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError> | QueryFiltersByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Course Version Changes */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError> | QueryFiltersByQueryKey<AdminCourseVersionChangesSchema, AdminCourseVersionChangesData, TInfinite, AdminCourseVersionChangesParameters, AdminCourseVersionChangesError>): number;
        schema: AdminCourseVersionChangesSchema;
        types: {
            parameters: AdminCourseVersionChangesParameters;
            data: AdminCourseVersionChangesData;
            error: AdminCourseVersionChangesError;
        };
    };
    /** @summary Admin Revert Course Version Change */
    adminRevertCourseVersionChange: {
        /** @summary Admin Revert Course Version Change */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeParameters, TMeta, TSignal>, client?: (schema: AdminRevertCourseVersionChangeSchema, options: ServiceOperationMutationFnOptions<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeError>>): Promise<RequestFnResponse<AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeError>>;
        /** @summary Admin Revert Course Version Change */
        getMutationKey(parameters: DeepReadonly<AdminRevertCourseVersionChangeParameters> | void): ServiceOperationMutationKey<AdminRevertCourseVersionChangeSchema, AdminRevertCourseVersionChangeParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Revert Course Version Change
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminRevertCourseVersionChange.useMutation({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminRevertCourseVersionChange.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminRevertCourseVersionChangeBody, TContext = unknown>(parameters: DeepReadonly<AdminRevertCourseVersionChangeParameters>, options?: ServiceOperationUseMutationOptions<AdminRevertCourseVersionChangeSchema, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, TVariables, OperationError<AdminRevertCourseVersionChangeError>, TContext>): UseMutationResult<AdminRevertCourseVersionChangeData, OperationError<AdminRevertCourseVersionChangeError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Revert Course Version Change
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminRevertCourseVersionChange.useMutation({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminRevertCourseVersionChange.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminRevertCourseVersionChangeSchema, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, TVariables, OperationError<AdminRevertCourseVersionChangeError>, TContext>): UseMutationResult<AdminRevertCourseVersionChangeData, OperationError<AdminRevertCourseVersionChangeError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Revert Course Version Change
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminRevertCourseVersionChangeTotal = qraft.v3Service.adminRevertCourseVersionChange.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminRevertCourseVersionChangeTotal = qraft.v3Service.adminRevertCourseVersionChange.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext> | MutationFiltersByMutationKey<AdminRevertCourseVersionChangeSchema, AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Revert Course Version Change
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminRevertCourseVersionChangePendingMutationVariables = qraft.v3Service.adminRevertCourseVersionChange.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminRevertCourseVersionChangeMutationData = qraft.v3Service.adminRevertCourseVersionChange.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId,
         *                 version: version
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminRevertCourseVersionChangeData, OperationError<AdminRevertCourseVersionChangeError>, MutationVariables<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext> | MutationFiltersByMutationKey<AdminRevertCourseVersionChangeSchema, AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext>;
            select?: (mutation: Mutation<AdminRevertCourseVersionChangeData, OperationError<AdminRevertCourseVersionChangeError>, MutationVariables<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Revert Course Version Change */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext> | MutationFiltersByMutationKey<AdminRevertCourseVersionChangeSchema, AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Revert Course Version Change
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminRevertCourseVersionChange.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminRevertCourseVersionChange.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext> | MutationFiltersByMutationKey<AdminRevertCourseVersionChangeSchema, AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext>): Mutation<AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeError, MutationVariables<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext> | MutationFiltersByMutationKey<AdminRevertCourseVersionChangeSchema, AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeParameters, OperationError<AdminRevertCourseVersionChangeError>, TContext>): Array<Mutation<AdminRevertCourseVersionChangeData, AdminRevertCourseVersionChangeError, MutationVariables<AdminRevertCourseVersionChangeBody, AdminRevertCourseVersionChangeParameters>, TContext>>;
        };
        schema: AdminRevertCourseVersionChangeSchema;
        types: {
            parameters: AdminRevertCourseVersionChangeParameters;
            data: AdminRevertCourseVersionChangeData;
            error: AdminRevertCourseVersionChangeError;
            body: AdminRevertCourseVersionChangeBody;
        };
    };
    /** @summary Admin Course Version Publish Check */
    adminCourseVersionPublishCheck: {
        /** @summary Admin Course Version Publish Check */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminCourseVersionPublishCheckParameters, TMeta, TSignal>), client?: (schema: AdminCourseVersionPublishCheckSchema, options: {
            parameters: AdminCourseVersionPublishCheckParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError>>): Promise<RequestFnResponse<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError>>;
        /** @summary Admin Course Version Publish Check */
        getQueryKey(parameters: DeepReadonly<AdminCourseVersionPublishCheckParameters>): ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminCourseVersionPublishCheck.useQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminCourseVersionPublishCheckData>(parameters: ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>), options?: Omit<UndefinedInitialDataOptions<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError, TData, ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminCourseVersionPublishCheckError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminCourseVersionPublishCheck.useQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminCourseVersionPublishCheckData>(parameters: ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>), options: Omit<DefinedInitialDataOptions<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError, TData, ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminCourseVersionPublishCheckError>>;
        /** @summary Admin Course Version Publish Check */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminCourseVersionPublishCheckParameters>): ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminCourseVersionPublishCheck.useInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminCourseVersionPublishCheckParameters, TQueryFnData = AdminCourseVersionPublishCheckData, TData = OperationInfiniteData<TQueryFnData, AdminCourseVersionPublishCheckParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminCourseVersionPublishCheckError, TData, ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminCourseVersionPublishCheckError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminCourseVersionPublishCheck.useInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminCourseVersionPublishCheckParameters, TQueryFnData = AdminCourseVersionPublishCheckData, TData = OperationInfiniteData<TQueryFnData, AdminCourseVersionPublishCheckParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminCourseVersionPublishCheckError, TData, ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminCourseVersionPublishCheckData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminCourseVersionPublishCheckError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminCourseVersionPublishCheckTotal = qraft.v3Service.adminCourseVersionPublishCheck.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminCourseVersionPublishCheckByParametersTotal = qraft.v3Service.adminCourseVersionPublishCheck.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError> | QueryFiltersByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminCourseVersionPublishCheckResults = qraft.v3Service.adminCourseVersionPublishCheck.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminCourseVersionPublishCheckResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminCourseVersionPublishCheckCombinedResults = qraft.v3Service.adminCourseVersionPublishCheck.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminCourseVersionPublishCheckCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError>>, TCombinedResult = Array<UseQueryResult<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminCourseVersionPublishCheck.useSuspenseQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminCourseVersionPublishCheckData>(parameters: ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>), options?: Omit<UseSuspenseQueryOptions<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError, TData, ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminCourseVersionPublishCheckError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminCourseVersionPublishCheck.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminCourseVersionPublishCheckParameters, TData = AdminCourseVersionPublishCheckData>(parameters: ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError, OperationInfiniteData<TData, AdminCourseVersionPublishCheckParameters>, ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminCourseVersionPublishCheckData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminCourseVersionPublishCheckParameters>, OperationError<AdminCourseVersionPublishCheckError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Course Version Publish Check
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminCourseVersionPublishCheckData = qraft.v3Service.adminCourseVersionPublishCheck.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminCourseVersionPublishCheckResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminCourseVersionPublishCheckCombinedData = qraft.v3Service.adminCourseVersionPublishCheck.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminCourseVersionPublishCheckCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Course Version Publish Check */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>): Promise<AdminCourseVersionPublishCheckData>;
        /** @summary Admin Course Version Publish Check */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>): Promise<void>;
        /** @summary Admin Course Version Publish Check */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>): Promise<AdminCourseVersionPublishCheckData>;
        /** @summary Admin Course Version Publish Check */
        fetchInfiniteQuery<TPageParam extends AdminCourseVersionPublishCheckParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters, DeepReadonly<TPageParam>, AdminCourseVersionPublishCheckError>): Promise<OperationInfiniteData<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters>>;
        /** @summary Admin Course Version Publish Check */
        prefetchInfiniteQuery<TPageParam extends AdminCourseVersionPublishCheckParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters, DeepReadonly<TPageParam>, AdminCourseVersionPublishCheckError>): Promise<void>;
        /** @summary Admin Course Version Publish Check */
        ensureInfiniteQueryData<TPageParam extends AdminCourseVersionPublishCheckParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters, DeepReadonly<TPageParam>, AdminCourseVersionPublishCheckError>): Promise<OperationInfiniteData<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters>>;
        /** @summary Admin Course Version Publish Check */
        getQueryData(parameters: ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>)): AdminCourseVersionPublishCheckData | undefined;
        /** @summary Admin Course Version Publish Check */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>)): OperationInfiniteData<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters> | undefined;
        /** @summary Admin Course Version Publish Check */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError> | QueryFiltersByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>,
            data: NoInfer<OperationInfiniteData<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>,
            data: AdminCourseVersionPublishCheckData | undefined
        ]>;
        /** @summary Admin Course Version Publish Check */
        getQueryState(parameters: ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters> | (DeepReadonly<AdminCourseVersionPublishCheckParameters>)): QueryState<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckError> | undefined;
        /** @summary Admin Course Version Publish Check */
        getInfiniteQueryState(parameters: DeepReadonly<AdminCourseVersionPublishCheckParameters> | ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>): QueryState<OperationInfiniteData<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters>, AdminCourseVersionPublishCheckError> | undefined;
        /** @summary Admin Course Version Publish Check */
        setQueryData(parameters: (DeepReadonly<AdminCourseVersionPublishCheckParameters>) | ServiceOperationQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>, updater: Updater<NoInfer<AdminCourseVersionPublishCheckData> | undefined, NoInfer<DeepReadonly<AdminCourseVersionPublishCheckData>> | undefined>, options?: SetDataOptions): AdminCourseVersionPublishCheckData | undefined;
        /** @summary Admin Course Version Publish Check */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminCourseVersionPublishCheckParameters>) | ServiceOperationInfiniteQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminCourseVersionPublishCheckData, AdminCourseVersionPublishCheckParameters> | undefined;
        /** @summary Admin Course Version Publish Check */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError> | QueryFiltersByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>, updater: Updater<NoInfer<AdminCourseVersionPublishCheckData> | undefined, NoInfer<AdminCourseVersionPublishCheckData> | undefined>, options?: SetDataOptions): Array<AdminCourseVersionPublishCheckData | undefined>;
        /** @summary Admin Course Version Publish Check */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Course Version Publish Check */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError> | QueryFiltersByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Course Version Publish Check */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError> | QueryFiltersByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Course Version Publish Check */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError> | QueryFiltersByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>): void;
        /** @summary Admin Course Version Publish Check */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError> | QueryFiltersByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Course Version Publish Check */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError> | QueryFiltersByQueryKey<AdminCourseVersionPublishCheckSchema, AdminCourseVersionPublishCheckData, TInfinite, AdminCourseVersionPublishCheckParameters, AdminCourseVersionPublishCheckError>): number;
        schema: AdminCourseVersionPublishCheckSchema;
        types: {
            parameters: AdminCourseVersionPublishCheckParameters;
            data: AdminCourseVersionPublishCheckData;
            error: AdminCourseVersionPublishCheckError;
        };
    };
    /** @summary Admin Publish Course Version */
    adminPublishCourseVersion: {
        /** @summary Admin Publish Course Version */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminPublishCourseVersionBody, AdminPublishCourseVersionParameters, TMeta, TSignal>, client?: (schema: AdminPublishCourseVersionSchema, options: ServiceOperationMutationFnOptions<AdminPublishCourseVersionBody, AdminPublishCourseVersionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminPublishCourseVersionData, AdminPublishCourseVersionError>>): Promise<RequestFnResponse<AdminPublishCourseVersionData, AdminPublishCourseVersionError>>;
        /** @summary Admin Publish Course Version */
        getMutationKey(parameters: DeepReadonly<AdminPublishCourseVersionParameters> | void): ServiceOperationMutationKey<AdminPublishCourseVersionSchema, AdminPublishCourseVersionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Publish Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminPublishCourseVersion.useMutation({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminPublishCourseVersion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminPublishCourseVersionBody, TContext = unknown>(parameters: DeepReadonly<AdminPublishCourseVersionParameters>, options?: ServiceOperationUseMutationOptions<AdminPublishCourseVersionSchema, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, TVariables, OperationError<AdminPublishCourseVersionError>, TContext>): UseMutationResult<AdminPublishCourseVersionData, OperationError<AdminPublishCourseVersionError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Publish Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminPublishCourseVersion.useMutation({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminPublishCourseVersion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminPublishCourseVersionBody, AdminPublishCourseVersionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminPublishCourseVersionSchema, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, TVariables, OperationError<AdminPublishCourseVersionError>, TContext>): UseMutationResult<AdminPublishCourseVersionData, OperationError<AdminPublishCourseVersionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Publish Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminPublishCourseVersionTotal = qraft.v3Service.adminPublishCourseVersion.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminPublishCourseVersionTotal = qraft.v3Service.adminPublishCourseVersion.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPublishCourseVersionSchema, AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Publish Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminPublishCourseVersionPendingMutationVariables = qraft.v3Service.adminPublishCourseVersion.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminPublishCourseVersionMutationData = qraft.v3Service.adminPublishCourseVersion.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId,
         *                 version: version
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminPublishCourseVersionData, OperationError<AdminPublishCourseVersionError>, MutationVariables<AdminPublishCourseVersionBody, AdminPublishCourseVersionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPublishCourseVersionSchema, AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext>;
            select?: (mutation: Mutation<AdminPublishCourseVersionData, OperationError<AdminPublishCourseVersionError>, MutationVariables<AdminPublishCourseVersionBody, AdminPublishCourseVersionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Publish Course Version */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPublishCourseVersionSchema, AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Publish Course Version
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminPublishCourseVersion.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminPublishCourseVersion.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPublishCourseVersionSchema, AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext>): Mutation<AdminPublishCourseVersionData, AdminPublishCourseVersionError, MutationVariables<AdminPublishCourseVersionBody, AdminPublishCourseVersionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPublishCourseVersionSchema, AdminPublishCourseVersionBody, AdminPublishCourseVersionData, AdminPublishCourseVersionParameters, OperationError<AdminPublishCourseVersionError>, TContext>): Array<Mutation<AdminPublishCourseVersionData, AdminPublishCourseVersionError, MutationVariables<AdminPublishCourseVersionBody, AdminPublishCourseVersionParameters>, TContext>>;
        };
        schema: AdminPublishCourseVersionSchema;
        types: {
            parameters: AdminPublishCourseVersionParameters;
            data: AdminPublishCourseVersionData;
            error: AdminPublishCourseVersionError;
            body: AdminPublishCourseVersionBody;
        };
    };
    /**
     * @summary Admin Preview Course Version
     * @description A one-time link that opens this version in the student web app.
     */
    adminPreviewCourseVersion: {
        /**
         * @summary Admin Preview Course Version
         * @description A one-time link that opens this version in the student web app.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionParameters, TMeta, TSignal>, client?: (schema: AdminPreviewCourseVersionSchema, options: ServiceOperationMutationFnOptions<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminPreviewCourseVersionData, AdminPreviewCourseVersionError>>): Promise<RequestFnResponse<AdminPreviewCourseVersionData, AdminPreviewCourseVersionError>>;
        /**
         * @summary Admin Preview Course Version
         * @description A one-time link that opens this version in the student web app.
         */
        getMutationKey(parameters: DeepReadonly<AdminPreviewCourseVersionParameters> | void): ServiceOperationMutationKey<AdminPreviewCourseVersionSchema, AdminPreviewCourseVersionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Preview Course Version
         * @description A one-time link that opens this version in the student web app.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminPreviewCourseVersion.useMutation({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminPreviewCourseVersion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminPreviewCourseVersionBody, TContext = unknown>(parameters: DeepReadonly<AdminPreviewCourseVersionParameters>, options?: ServiceOperationUseMutationOptions<AdminPreviewCourseVersionSchema, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, TVariables, OperationError<AdminPreviewCourseVersionError>, TContext>): UseMutationResult<AdminPreviewCourseVersionData, OperationError<AdminPreviewCourseVersionError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Preview Course Version
         * @description A one-time link that opens this version in the student web app.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminPreviewCourseVersion.useMutation({
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminPreviewCourseVersion.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminPreviewCourseVersionSchema, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, TVariables, OperationError<AdminPreviewCourseVersionError>, TContext>): UseMutationResult<AdminPreviewCourseVersionData, OperationError<AdminPreviewCourseVersionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Preview Course Version
         * @description A one-time link that opens this version in the student web app.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminPreviewCourseVersionTotal = qraft.v3Service.adminPreviewCourseVersion.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminPreviewCourseVersionTotal = qraft.v3Service.adminPreviewCourseVersion.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPreviewCourseVersionSchema, AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Preview Course Version
         * @description A one-time link that opens this version in the student web app.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminPreviewCourseVersionPendingMutationVariables = qraft.v3Service.adminPreviewCourseVersion.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminPreviewCourseVersionMutationData = qraft.v3Service.adminPreviewCourseVersion.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId,
         *                 version: version
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminPreviewCourseVersionData, OperationError<AdminPreviewCourseVersionError>, MutationVariables<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPreviewCourseVersionSchema, AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext>;
            select?: (mutation: Mutation<AdminPreviewCourseVersionData, OperationError<AdminPreviewCourseVersionError>, MutationVariables<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Admin Preview Course Version
         * @description A one-time link that opens this version in the student web app.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPreviewCourseVersionSchema, AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Preview Course Version
         * @description A one-time link that opens this version in the student web app.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminPreviewCourseVersion.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminPreviewCourseVersion.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPreviewCourseVersionSchema, AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext>): Mutation<AdminPreviewCourseVersionData, AdminPreviewCourseVersionError, MutationVariables<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext> | MutationFiltersByMutationKey<AdminPreviewCourseVersionSchema, AdminPreviewCourseVersionBody, AdminPreviewCourseVersionData, AdminPreviewCourseVersionParameters, OperationError<AdminPreviewCourseVersionError>, TContext>): Array<Mutation<AdminPreviewCourseVersionData, AdminPreviewCourseVersionError, MutationVariables<AdminPreviewCourseVersionBody, AdminPreviewCourseVersionParameters>, TContext>>;
        };
        schema: AdminPreviewCourseVersionSchema;
        types: {
            parameters: AdminPreviewCourseVersionParameters;
            data: AdminPreviewCourseVersionData;
            error: AdminPreviewCourseVersionError;
            body: AdminPreviewCourseVersionBody;
        };
    };
    /** @summary Preview Redeem */
    previewRedeem: {
        /** @summary Preview Redeem */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<PreviewRedeemBody, PreviewRedeemParameters, TMeta, TSignal>, client?: (schema: PreviewRedeemSchema, options: ServiceOperationMutationFnOptions<PreviewRedeemBody, PreviewRedeemParameters, TMeta, TSignal>) => Promise<RequestFnResponse<PreviewRedeemData, PreviewRedeemError>>): Promise<RequestFnResponse<PreviewRedeemData, PreviewRedeemError>>;
        /** @summary Preview Redeem */
        getMutationKey(parameters: DeepReadonly<PreviewRedeemParameters> | void): ServiceOperationMutationKey<PreviewRedeemSchema, PreviewRedeemParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Preview Redeem
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewRedeem.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewRedeem.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends PreviewRedeemBody, TContext = unknown>(parameters: DeepReadonly<PreviewRedeemParameters>, options?: ServiceOperationUseMutationOptions<PreviewRedeemSchema, PreviewRedeemData, PreviewRedeemParameters, TVariables, OperationError<PreviewRedeemError>, TContext>): UseMutationResult<PreviewRedeemData, OperationError<PreviewRedeemError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Preview Redeem
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewRedeem.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewRedeem.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<PreviewRedeemBody, PreviewRedeemParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<PreviewRedeemSchema, PreviewRedeemData, PreviewRedeemParameters, TVariables, OperationError<PreviewRedeemError>, TContext>): UseMutationResult<PreviewRedeemData, OperationError<PreviewRedeemError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Preview Redeem
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const previewRedeemTotal = qraft.v3Service.previewRedeem.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const previewRedeemTotal = qraft.v3Service.previewRedeem.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext> | MutationFiltersByMutationKey<PreviewRedeemSchema, PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Preview Redeem
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const previewRedeemPendingMutationVariables = qraft.v3Service.previewRedeem.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const previewRedeemMutationData = qraft.v3Service.previewRedeem.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<PreviewRedeemData, OperationError<PreviewRedeemError>, MutationVariables<PreviewRedeemBody, PreviewRedeemParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext> | MutationFiltersByMutationKey<PreviewRedeemSchema, PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext>;
            select?: (mutation: Mutation<PreviewRedeemData, OperationError<PreviewRedeemError>, MutationVariables<PreviewRedeemBody, PreviewRedeemParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Preview Redeem */
        isMutating<TContext>(filters?: MutationFiltersByParameters<PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext> | MutationFiltersByMutationKey<PreviewRedeemSchema, PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Preview Redeem
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.previewRedeem.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.previewRedeem.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext> | MutationFiltersByMutationKey<PreviewRedeemSchema, PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext>): Mutation<PreviewRedeemData, PreviewRedeemError, MutationVariables<PreviewRedeemBody, PreviewRedeemParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext> | MutationFiltersByMutationKey<PreviewRedeemSchema, PreviewRedeemBody, PreviewRedeemData, PreviewRedeemParameters, OperationError<PreviewRedeemError>, TContext>): Array<Mutation<PreviewRedeemData, PreviewRedeemError, MutationVariables<PreviewRedeemBody, PreviewRedeemParameters>, TContext>>;
        };
        schema: PreviewRedeemSchema;
        types: {
            parameters: PreviewRedeemParameters;
            data: PreviewRedeemData;
            error: PreviewRedeemError;
            body: PreviewRedeemBody;
        };
    };
    /** @summary Preview End */
    previewEnd: {
        /** @summary Preview End */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<PreviewEndBody, PreviewEndParameters, TMeta, TSignal>, client?: (schema: PreviewEndSchema, options: ServiceOperationMutationFnOptions<PreviewEndBody, PreviewEndParameters, TMeta, TSignal>) => Promise<RequestFnResponse<PreviewEndData, PreviewEndError>>): Promise<RequestFnResponse<PreviewEndData, PreviewEndError>>;
        /** @summary Preview End */
        getMutationKey(parameters: DeepReadonly<PreviewEndParameters> | void): ServiceOperationMutationKey<PreviewEndSchema, PreviewEndParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Preview End
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewEnd.useMutation({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewEnd.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends PreviewEndBody, TContext = unknown>(parameters: DeepReadonly<PreviewEndParameters>, options?: ServiceOperationUseMutationOptions<PreviewEndSchema, PreviewEndData, PreviewEndParameters, TVariables, OperationError<PreviewEndError>, TContext>): UseMutationResult<PreviewEndData, OperationError<PreviewEndError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Preview End
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewEnd.useMutation({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewEnd.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<PreviewEndBody, PreviewEndParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<PreviewEndSchema, PreviewEndData, PreviewEndParameters, TVariables, OperationError<PreviewEndError>, TContext>): UseMutationResult<PreviewEndData, OperationError<PreviewEndError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Preview End
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const previewEndTotal = qraft.v3Service.previewEnd.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const previewEndTotal = qraft.v3Service.previewEnd.useIsMutating({
         *     parameters: {
         *         cookie: {
         *             wbs_preview: wbsPreview
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext> | MutationFiltersByMutationKey<PreviewEndSchema, PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Preview End
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const previewEndPendingMutationVariables = qraft.v3Service.previewEnd.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const previewEndMutationData = qraft.v3Service.previewEnd.useMutationState({
         *     filters: {
         *         parameters: {
         *             cookie: {
         *                 wbs_preview: wbsPreview
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<PreviewEndData, OperationError<PreviewEndError>, MutationVariables<PreviewEndBody, PreviewEndParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext> | MutationFiltersByMutationKey<PreviewEndSchema, PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext>;
            select?: (mutation: Mutation<PreviewEndData, OperationError<PreviewEndError>, MutationVariables<PreviewEndBody, PreviewEndParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Preview End */
        isMutating<TContext>(filters?: MutationFiltersByParameters<PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext> | MutationFiltersByMutationKey<PreviewEndSchema, PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Preview End
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.previewEnd.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         cookie: {
         *             wbs_preview: wbsPreview
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.previewEnd.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext> | MutationFiltersByMutationKey<PreviewEndSchema, PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext>): Mutation<PreviewEndData, PreviewEndError, MutationVariables<PreviewEndBody, PreviewEndParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext> | MutationFiltersByMutationKey<PreviewEndSchema, PreviewEndBody, PreviewEndData, PreviewEndParameters, OperationError<PreviewEndError>, TContext>): Array<Mutation<PreviewEndData, PreviewEndError, MutationVariables<PreviewEndBody, PreviewEndParameters>, TContext>>;
        };
        schema: PreviewEndSchema;
        types: {
            parameters: PreviewEndParameters;
            data: PreviewEndData;
            error: PreviewEndError;
            body: PreviewEndBody;
        };
    };
    /** @summary Preview Course */
    previewCourse: {
        /** @summary Preview Course */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<PreviewCourseSchema, PreviewCourseParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<PreviewCourseParameters, TMeta, TSignal> | void), client?: (schema: PreviewCourseSchema, options: {
            parameters: PreviewCourseParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<PreviewCourseData, PreviewCourseError>>): Promise<RequestFnResponse<PreviewCourseData, PreviewCourseError>>;
        /** @summary Preview Course */
        getQueryKey(parameters: DeepReadonly<PreviewCourseParameters> | void): ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.previewCourse.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.previewCourse.useQuery({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useQuery<TData = PreviewCourseData>(parameters: ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void), options?: Omit<UndefinedInitialDataOptions<PreviewCourseData, PreviewCourseError, TData, ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters>>, "queryKey">): UseQueryResult<TData, OperationError<PreviewCourseError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.previewCourse.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.previewCourse.useQuery({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useQuery<TData = PreviewCourseData>(parameters: ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void), options: Omit<DefinedInitialDataOptions<PreviewCourseData, PreviewCourseError, TData, ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<PreviewCourseError>>;
        /** @summary Preview Course */
        getInfiniteQueryKey(parameters: DeepReadonly<PreviewCourseParameters> | void): ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewCourse.useInfiniteQuery({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends PreviewCourseParameters, TQueryFnData = PreviewCourseData, TData = OperationInfiniteData<TQueryFnData, PreviewCourseParameters>>(parameters: ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, PreviewCourseError, TData, ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<PreviewCourseError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewCourse.useInfiniteQuery({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends PreviewCourseParameters, TQueryFnData = PreviewCourseData, TData = OperationInfiniteData<TQueryFnData, PreviewCourseParameters>>(parameters: ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, PreviewCourseError, TData, ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<PreviewCourseData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<PreviewCourseError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const previewCourseTotal = qraft.v3Service.previewCourse.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const previewCourseByParametersTotal = qraft.v3Service.previewCourse.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         cookie: {
         *             wbs_preview: wbsPreview
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError> | QueryFiltersByQueryKey<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const previewCourseResults = qraft.v3Service.previewCourse.useQueries({
         *     queries: [
         *         {
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewCourseResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const previewCourseCombinedResults = qraft.v3Service.previewCourse.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewCourseCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<PreviewCourseSchema, PreviewCourseParameters, PreviewCourseData, PreviewCourseError>>, TCombinedResult = Array<UseQueryResult<PreviewCourseData, PreviewCourseError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<PreviewCourseData, PreviewCourseError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.previewCourse.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.previewCourse.useSuspenseQuery({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = PreviewCourseData>(parameters: ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void), options?: Omit<UseSuspenseQueryOptions<PreviewCourseData, PreviewCourseError, TData, ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<PreviewCourseError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewCourse.useSuspenseInfiniteQuery({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends PreviewCourseParameters, TData = PreviewCourseData>(parameters: ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<PreviewCourseData, PreviewCourseError, OperationInfiniteData<TData, PreviewCourseParameters>, ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<PreviewCourseData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, PreviewCourseParameters>, OperationError<PreviewCourseError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Preview Course
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const previewCourseData = qraft.v3Service.previewCourse.useSuspenseQueries({
         *     queries: [
         *         {
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewCourseResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const previewCourseCombinedData = qraft.v3Service.previewCourse.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewCourseCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<PreviewCourseSchema, PreviewCourseParameters, PreviewCourseData, PreviewCourseError>>, TCombinedResult = Array<UseSuspenseQueryResult<PreviewCourseData, PreviewCourseError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<PreviewCourseData, PreviewCourseError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Preview Course */
        fetchQuery(options: ServiceOperationFetchQueryOptions<PreviewCourseSchema, PreviewCourseData, PreviewCourseParameters, PreviewCourseError> | void): Promise<PreviewCourseData>;
        /** @summary Preview Course */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<PreviewCourseSchema, PreviewCourseData, PreviewCourseParameters, PreviewCourseError> | void): Promise<void>;
        /** @summary Preview Course */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<PreviewCourseSchema, PreviewCourseData, PreviewCourseParameters, PreviewCourseError> | void): Promise<PreviewCourseData>;
        /** @summary Preview Course */
        fetchInfiniteQuery<TPageParam extends PreviewCourseParameters>(options: ServiceOperationFetchInfiniteQueryOptions<PreviewCourseSchema, PreviewCourseData, PreviewCourseParameters, DeepReadonly<TPageParam>, PreviewCourseError> | void): Promise<OperationInfiniteData<PreviewCourseData, PreviewCourseParameters>>;
        /** @summary Preview Course */
        prefetchInfiniteQuery<TPageParam extends PreviewCourseParameters>(options: ServiceOperationFetchInfiniteQueryOptions<PreviewCourseSchema, PreviewCourseData, PreviewCourseParameters, DeepReadonly<TPageParam>, PreviewCourseError> | void): Promise<void>;
        /** @summary Preview Course */
        ensureInfiniteQueryData<TPageParam extends PreviewCourseParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<PreviewCourseSchema, PreviewCourseData, PreviewCourseParameters, DeepReadonly<TPageParam>, PreviewCourseError> | void): Promise<OperationInfiniteData<PreviewCourseData, PreviewCourseParameters>>;
        /** @summary Preview Course */
        getQueryData(parameters: ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void)): PreviewCourseData | undefined;
        /** @summary Preview Course */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void)): OperationInfiniteData<PreviewCourseData, PreviewCourseParameters> | undefined;
        /** @summary Preview Course */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError> | QueryFiltersByQueryKey<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters>,
            data: NoInfer<OperationInfiniteData<PreviewCourseData, PreviewCourseParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters>,
            data: PreviewCourseData | undefined
        ]>;
        /** @summary Preview Course */
        getQueryState(parameters: ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters> | (DeepReadonly<PreviewCourseParameters> | void)): QueryState<PreviewCourseData, PreviewCourseError> | undefined;
        /** @summary Preview Course */
        getInfiniteQueryState(parameters: DeepReadonly<PreviewCourseParameters> | ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters> | void): QueryState<OperationInfiniteData<PreviewCourseData, PreviewCourseParameters>, PreviewCourseError> | undefined;
        /** @summary Preview Course */
        setQueryData(parameters: (DeepReadonly<PreviewCourseParameters> | undefined) | ServiceOperationQueryKey<PreviewCourseSchema, PreviewCourseParameters>, updater: Updater<NoInfer<PreviewCourseData> | undefined, NoInfer<DeepReadonly<PreviewCourseData>> | undefined>, options?: SetDataOptions): PreviewCourseData | undefined;
        /** @summary Preview Course */
        setInfiniteQueryData(parameters: (DeepReadonly<PreviewCourseParameters> | undefined) | ServiceOperationInfiniteQueryKey<PreviewCourseSchema, PreviewCourseParameters>, updater: Updater<NoInfer<OperationInfiniteData<PreviewCourseData, PreviewCourseParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<PreviewCourseData, PreviewCourseParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<PreviewCourseData, PreviewCourseParameters> | undefined;
        /** @summary Preview Course */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError> | QueryFiltersByQueryKey<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>, updater: Updater<NoInfer<PreviewCourseData> | undefined, NoInfer<PreviewCourseData> | undefined>, options?: SetDataOptions): Array<PreviewCourseData | undefined>;
        /** @summary Preview Course */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Preview Course */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError> | QueryFiltersByQueryKey<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>, options?: RefetchOptions): Promise<void>;
        /** @summary Preview Course */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError> | QueryFiltersByQueryKey<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>, options?: CancelOptions): Promise<void>;
        /** @summary Preview Course */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError> | QueryFiltersByQueryKey<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>): void;
        /** @summary Preview Course */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError> | QueryFiltersByQueryKey<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>, options?: ResetOptions): Promise<void>;
        /** @summary Preview Course */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError> | QueryFiltersByQueryKey<PreviewCourseSchema, PreviewCourseData, TInfinite, PreviewCourseParameters, PreviewCourseError>): number;
        schema: PreviewCourseSchema;
        types: {
            parameters: PreviewCourseParameters;
            data: PreviewCourseData;
            error: PreviewCourseError;
        };
    };
    /** @summary Preview Topic */
    previewTopic: {
        /** @summary Preview Topic */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<PreviewTopicSchema, PreviewTopicParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<PreviewTopicParameters, TMeta, TSignal>), client?: (schema: PreviewTopicSchema, options: {
            parameters: PreviewTopicParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<PreviewTopicData, PreviewTopicError>>): Promise<RequestFnResponse<PreviewTopicData, PreviewTopicError>>;
        /** @summary Preview Topic */
        getQueryKey(parameters: DeepReadonly<PreviewTopicParameters>): ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.previewTopic.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useQuery<TData = PreviewTopicData>(parameters: ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>), options?: Omit<UndefinedInitialDataOptions<PreviewTopicData, PreviewTopicError, TData, ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters>>, "queryKey">): UseQueryResult<TData, OperationError<PreviewTopicError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.previewTopic.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useQuery<TData = PreviewTopicData>(parameters: ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>), options: Omit<DefinedInitialDataOptions<PreviewTopicData, PreviewTopicError, TData, ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<PreviewTopicError>>;
        /** @summary Preview Topic */
        getInfiniteQueryKey(parameters: DeepReadonly<PreviewTopicParameters>): ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewTopic.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends PreviewTopicParameters, TQueryFnData = PreviewTopicData, TData = OperationInfiniteData<TQueryFnData, PreviewTopicParameters>>(parameters: ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, PreviewTopicError, TData, ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<PreviewTopicError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewTopic.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends PreviewTopicParameters, TQueryFnData = PreviewTopicData, TData = OperationInfiniteData<TQueryFnData, PreviewTopicParameters>>(parameters: ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, PreviewTopicError, TData, ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<PreviewTopicData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<PreviewTopicError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const previewTopicTotal = qraft.v3Service.previewTopic.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const previewTopicByParametersTotal = qraft.v3Service.previewTopic.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         cookie: {
         *             wbs_preview: wbsPreview
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError> | QueryFiltersByQueryKey<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const previewTopicResults = qraft.v3Service.previewTopic.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewTopicResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const previewTopicCombinedResults = qraft.v3Service.previewTopic.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewTopicCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<PreviewTopicSchema, PreviewTopicParameters, PreviewTopicData, PreviewTopicError>>, TCombinedResult = Array<UseQueryResult<PreviewTopicData, PreviewTopicError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<PreviewTopicData, PreviewTopicError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.previewTopic.useSuspenseQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = PreviewTopicData>(parameters: ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>), options?: Omit<UseSuspenseQueryOptions<PreviewTopicData, PreviewTopicError, TData, ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<PreviewTopicError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewTopic.useSuspenseInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends PreviewTopicParameters, TData = PreviewTopicData>(parameters: ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<PreviewTopicData, PreviewTopicError, OperationInfiniteData<TData, PreviewTopicParameters>, ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<PreviewTopicData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, PreviewTopicParameters>, OperationError<PreviewTopicError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Preview Topic
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const previewTopicData = qraft.v3Service.previewTopic.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewTopicResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const previewTopicCombinedData = qraft.v3Service.previewTopic.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewTopicCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<PreviewTopicSchema, PreviewTopicParameters, PreviewTopicData, PreviewTopicError>>, TCombinedResult = Array<UseSuspenseQueryResult<PreviewTopicData, PreviewTopicError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<PreviewTopicData, PreviewTopicError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Preview Topic */
        fetchQuery(options: ServiceOperationFetchQueryOptions<PreviewTopicSchema, PreviewTopicData, PreviewTopicParameters, PreviewTopicError>): Promise<PreviewTopicData>;
        /** @summary Preview Topic */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<PreviewTopicSchema, PreviewTopicData, PreviewTopicParameters, PreviewTopicError>): Promise<void>;
        /** @summary Preview Topic */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<PreviewTopicSchema, PreviewTopicData, PreviewTopicParameters, PreviewTopicError>): Promise<PreviewTopicData>;
        /** @summary Preview Topic */
        fetchInfiniteQuery<TPageParam extends PreviewTopicParameters>(options: ServiceOperationFetchInfiniteQueryOptions<PreviewTopicSchema, PreviewTopicData, PreviewTopicParameters, DeepReadonly<TPageParam>, PreviewTopicError>): Promise<OperationInfiniteData<PreviewTopicData, PreviewTopicParameters>>;
        /** @summary Preview Topic */
        prefetchInfiniteQuery<TPageParam extends PreviewTopicParameters>(options: ServiceOperationFetchInfiniteQueryOptions<PreviewTopicSchema, PreviewTopicData, PreviewTopicParameters, DeepReadonly<TPageParam>, PreviewTopicError>): Promise<void>;
        /** @summary Preview Topic */
        ensureInfiniteQueryData<TPageParam extends PreviewTopicParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<PreviewTopicSchema, PreviewTopicData, PreviewTopicParameters, DeepReadonly<TPageParam>, PreviewTopicError>): Promise<OperationInfiniteData<PreviewTopicData, PreviewTopicParameters>>;
        /** @summary Preview Topic */
        getQueryData(parameters: ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>)): PreviewTopicData | undefined;
        /** @summary Preview Topic */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>)): OperationInfiniteData<PreviewTopicData, PreviewTopicParameters> | undefined;
        /** @summary Preview Topic */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError> | QueryFiltersByQueryKey<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters>,
            data: NoInfer<OperationInfiniteData<PreviewTopicData, PreviewTopicParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters>,
            data: PreviewTopicData | undefined
        ]>;
        /** @summary Preview Topic */
        getQueryState(parameters: ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters> | (DeepReadonly<PreviewTopicParameters>)): QueryState<PreviewTopicData, PreviewTopicError> | undefined;
        /** @summary Preview Topic */
        getInfiniteQueryState(parameters: DeepReadonly<PreviewTopicParameters> | ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters>): QueryState<OperationInfiniteData<PreviewTopicData, PreviewTopicParameters>, PreviewTopicError> | undefined;
        /** @summary Preview Topic */
        setQueryData(parameters: (DeepReadonly<PreviewTopicParameters>) | ServiceOperationQueryKey<PreviewTopicSchema, PreviewTopicParameters>, updater: Updater<NoInfer<PreviewTopicData> | undefined, NoInfer<DeepReadonly<PreviewTopicData>> | undefined>, options?: SetDataOptions): PreviewTopicData | undefined;
        /** @summary Preview Topic */
        setInfiniteQueryData(parameters: (DeepReadonly<PreviewTopicParameters>) | ServiceOperationInfiniteQueryKey<PreviewTopicSchema, PreviewTopicParameters>, updater: Updater<NoInfer<OperationInfiniteData<PreviewTopicData, PreviewTopicParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<PreviewTopicData, PreviewTopicParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<PreviewTopicData, PreviewTopicParameters> | undefined;
        /** @summary Preview Topic */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError> | QueryFiltersByQueryKey<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>, updater: Updater<NoInfer<PreviewTopicData> | undefined, NoInfer<PreviewTopicData> | undefined>, options?: SetDataOptions): Array<PreviewTopicData | undefined>;
        /** @summary Preview Topic */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Preview Topic */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError> | QueryFiltersByQueryKey<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>, options?: RefetchOptions): Promise<void>;
        /** @summary Preview Topic */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError> | QueryFiltersByQueryKey<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>, options?: CancelOptions): Promise<void>;
        /** @summary Preview Topic */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError> | QueryFiltersByQueryKey<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>): void;
        /** @summary Preview Topic */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError> | QueryFiltersByQueryKey<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>, options?: ResetOptions): Promise<void>;
        /** @summary Preview Topic */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError> | QueryFiltersByQueryKey<PreviewTopicSchema, PreviewTopicData, TInfinite, PreviewTopicParameters, PreviewTopicError>): number;
        schema: PreviewTopicSchema;
        types: {
            parameters: PreviewTopicParameters;
            data: PreviewTopicData;
            error: PreviewTopicError;
        };
    };
    /** @summary Preview Lesson Questions */
    previewLessonQuestions: {
        /** @summary Preview Lesson Questions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<PreviewLessonQuestionsParameters, TMeta, TSignal>), client?: (schema: PreviewLessonQuestionsSchema, options: {
            parameters: PreviewLessonQuestionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<PreviewLessonQuestionsData, PreviewLessonQuestionsError>>): Promise<RequestFnResponse<PreviewLessonQuestionsData, PreviewLessonQuestionsError>>;
        /** @summary Preview Lesson Questions */
        getQueryKey(parameters: DeepReadonly<PreviewLessonQuestionsParameters>): ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.previewLessonQuestions.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useQuery<TData = PreviewLessonQuestionsData>(parameters: ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>), options?: Omit<UndefinedInitialDataOptions<PreviewLessonQuestionsData, PreviewLessonQuestionsError, TData, ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<PreviewLessonQuestionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.previewLessonQuestions.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useQuery<TData = PreviewLessonQuestionsData>(parameters: ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>), options: Omit<DefinedInitialDataOptions<PreviewLessonQuestionsData, PreviewLessonQuestionsError, TData, ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<PreviewLessonQuestionsError>>;
        /** @summary Preview Lesson Questions */
        getInfiniteQueryKey(parameters: DeepReadonly<PreviewLessonQuestionsParameters>): ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewLessonQuestions.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends PreviewLessonQuestionsParameters, TQueryFnData = PreviewLessonQuestionsData, TData = OperationInfiniteData<TQueryFnData, PreviewLessonQuestionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, PreviewLessonQuestionsError, TData, ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<PreviewLessonQuestionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewLessonQuestions.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends PreviewLessonQuestionsParameters, TQueryFnData = PreviewLessonQuestionsData, TData = OperationInfiniteData<TQueryFnData, PreviewLessonQuestionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, PreviewLessonQuestionsError, TData, ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<PreviewLessonQuestionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<PreviewLessonQuestionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const previewLessonQuestionsTotal = qraft.v3Service.previewLessonQuestions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const previewLessonQuestionsByParametersTotal = qraft.v3Service.previewLessonQuestions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         cookie: {
         *             wbs_preview: wbsPreview
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError> | QueryFiltersByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const previewLessonQuestionsResults = qraft.v3Service.previewLessonQuestions.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewLessonQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const previewLessonQuestionsCombinedResults = qraft.v3Service.previewLessonQuestions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewLessonQuestionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters, PreviewLessonQuestionsData, PreviewLessonQuestionsError>>, TCombinedResult = Array<UseQueryResult<PreviewLessonQuestionsData, PreviewLessonQuestionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<PreviewLessonQuestionsData, PreviewLessonQuestionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.previewLessonQuestions.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = PreviewLessonQuestionsData>(parameters: ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>), options?: Omit<UseSuspenseQueryOptions<PreviewLessonQuestionsData, PreviewLessonQuestionsError, TData, ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<PreviewLessonQuestionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.previewLessonQuestions.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends PreviewLessonQuestionsParameters, TData = PreviewLessonQuestionsData>(parameters: ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<PreviewLessonQuestionsData, PreviewLessonQuestionsError, OperationInfiniteData<TData, PreviewLessonQuestionsParameters>, ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<PreviewLessonQuestionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, PreviewLessonQuestionsParameters>, OperationError<PreviewLessonQuestionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Preview Lesson Questions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const previewLessonQuestionsData = qraft.v3Service.previewLessonQuestions.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewLessonQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const previewLessonQuestionsCombinedData = qraft.v3Service.previewLessonQuestions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             cookie: {
         *                 wbs_preview: wbsPreview2
         *             }
         *         }
         *     ]
         * });
         * previewLessonQuestionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters, PreviewLessonQuestionsData, PreviewLessonQuestionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<PreviewLessonQuestionsData, PreviewLessonQuestionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<PreviewLessonQuestionsData, PreviewLessonQuestionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Preview Lesson Questions */
        fetchQuery(options: ServiceOperationFetchQueryOptions<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>): Promise<PreviewLessonQuestionsData>;
        /** @summary Preview Lesson Questions */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>): Promise<void>;
        /** @summary Preview Lesson Questions */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>): Promise<PreviewLessonQuestionsData>;
        /** @summary Preview Lesson Questions */
        fetchInfiniteQuery<TPageParam extends PreviewLessonQuestionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, PreviewLessonQuestionsParameters, DeepReadonly<TPageParam>, PreviewLessonQuestionsError>): Promise<OperationInfiniteData<PreviewLessonQuestionsData, PreviewLessonQuestionsParameters>>;
        /** @summary Preview Lesson Questions */
        prefetchInfiniteQuery<TPageParam extends PreviewLessonQuestionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, PreviewLessonQuestionsParameters, DeepReadonly<TPageParam>, PreviewLessonQuestionsError>): Promise<void>;
        /** @summary Preview Lesson Questions */
        ensureInfiniteQueryData<TPageParam extends PreviewLessonQuestionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, PreviewLessonQuestionsParameters, DeepReadonly<TPageParam>, PreviewLessonQuestionsError>): Promise<OperationInfiniteData<PreviewLessonQuestionsData, PreviewLessonQuestionsParameters>>;
        /** @summary Preview Lesson Questions */
        getQueryData(parameters: ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>)): PreviewLessonQuestionsData | undefined;
        /** @summary Preview Lesson Questions */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>)): OperationInfiniteData<PreviewLessonQuestionsData, PreviewLessonQuestionsParameters> | undefined;
        /** @summary Preview Lesson Questions */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError> | QueryFiltersByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>,
            data: NoInfer<OperationInfiniteData<PreviewLessonQuestionsData, PreviewLessonQuestionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>,
            data: PreviewLessonQuestionsData | undefined
        ]>;
        /** @summary Preview Lesson Questions */
        getQueryState(parameters: ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters> | (DeepReadonly<PreviewLessonQuestionsParameters>)): QueryState<PreviewLessonQuestionsData, PreviewLessonQuestionsError> | undefined;
        /** @summary Preview Lesson Questions */
        getInfiniteQueryState(parameters: DeepReadonly<PreviewLessonQuestionsParameters> | ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>): QueryState<OperationInfiniteData<PreviewLessonQuestionsData, PreviewLessonQuestionsParameters>, PreviewLessonQuestionsError> | undefined;
        /** @summary Preview Lesson Questions */
        setQueryData(parameters: (DeepReadonly<PreviewLessonQuestionsParameters>) | ServiceOperationQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>, updater: Updater<NoInfer<PreviewLessonQuestionsData> | undefined, NoInfer<DeepReadonly<PreviewLessonQuestionsData>> | undefined>, options?: SetDataOptions): PreviewLessonQuestionsData | undefined;
        /** @summary Preview Lesson Questions */
        setInfiniteQueryData(parameters: (DeepReadonly<PreviewLessonQuestionsParameters>) | ServiceOperationInfiniteQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<PreviewLessonQuestionsData, PreviewLessonQuestionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<PreviewLessonQuestionsData, PreviewLessonQuestionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<PreviewLessonQuestionsData, PreviewLessonQuestionsParameters> | undefined;
        /** @summary Preview Lesson Questions */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError> | QueryFiltersByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>, updater: Updater<NoInfer<PreviewLessonQuestionsData> | undefined, NoInfer<PreviewLessonQuestionsData> | undefined>, options?: SetDataOptions): Array<PreviewLessonQuestionsData | undefined>;
        /** @summary Preview Lesson Questions */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Preview Lesson Questions */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError> | QueryFiltersByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Preview Lesson Questions */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError> | QueryFiltersByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>, options?: CancelOptions): Promise<void>;
        /** @summary Preview Lesson Questions */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError> | QueryFiltersByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>): void;
        /** @summary Preview Lesson Questions */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError> | QueryFiltersByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>, options?: ResetOptions): Promise<void>;
        /** @summary Preview Lesson Questions */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError> | QueryFiltersByQueryKey<PreviewLessonQuestionsSchema, PreviewLessonQuestionsData, TInfinite, PreviewLessonQuestionsParameters, PreviewLessonQuestionsError>): number;
        schema: PreviewLessonQuestionsSchema;
        types: {
            parameters: PreviewLessonQuestionsParameters;
            data: PreviewLessonQuestionsData;
            error: PreviewLessonQuestionsError;
        };
    };
    /** @summary Preview Mark */
    previewMark: {
        /** @summary Preview Mark */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<PreviewMarkBody, PreviewMarkParameters, TMeta, TSignal>, client?: (schema: PreviewMarkSchema, options: ServiceOperationMutationFnOptions<PreviewMarkBody, PreviewMarkParameters, TMeta, TSignal>) => Promise<RequestFnResponse<PreviewMarkData, PreviewMarkError>>): Promise<RequestFnResponse<PreviewMarkData, PreviewMarkError>>;
        /** @summary Preview Mark */
        getMutationKey(parameters: DeepReadonly<PreviewMarkParameters> | void): ServiceOperationMutationKey<PreviewMarkSchema, PreviewMarkParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Preview Mark
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewMark.useMutation({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewMark.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends PreviewMarkBody, TContext = unknown>(parameters: DeepReadonly<PreviewMarkParameters>, options?: ServiceOperationUseMutationOptions<PreviewMarkSchema, PreviewMarkData, PreviewMarkParameters, TVariables, OperationError<PreviewMarkError>, TContext>): UseMutationResult<PreviewMarkData, OperationError<PreviewMarkError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Preview Mark
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewMark.useMutation({
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.previewMark.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     cookie: {
         *         wbs_preview: wbsPreview
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<PreviewMarkBody, PreviewMarkParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<PreviewMarkSchema, PreviewMarkData, PreviewMarkParameters, TVariables, OperationError<PreviewMarkError>, TContext>): UseMutationResult<PreviewMarkData, OperationError<PreviewMarkError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Preview Mark
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const previewMarkTotal = qraft.v3Service.previewMark.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const previewMarkTotal = qraft.v3Service.previewMark.useIsMutating({
         *     parameters: {
         *         cookie: {
         *             wbs_preview: wbsPreview
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext> | MutationFiltersByMutationKey<PreviewMarkSchema, PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Preview Mark
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const previewMarkPendingMutationVariables = qraft.v3Service.previewMark.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const previewMarkMutationData = qraft.v3Service.previewMark.useMutationState({
         *     filters: {
         *         parameters: {
         *             cookie: {
         *                 wbs_preview: wbsPreview
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<PreviewMarkData, OperationError<PreviewMarkError>, MutationVariables<PreviewMarkBody, PreviewMarkParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext> | MutationFiltersByMutationKey<PreviewMarkSchema, PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext>;
            select?: (mutation: Mutation<PreviewMarkData, OperationError<PreviewMarkError>, MutationVariables<PreviewMarkBody, PreviewMarkParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Preview Mark */
        isMutating<TContext>(filters?: MutationFiltersByParameters<PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext> | MutationFiltersByMutationKey<PreviewMarkSchema, PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Preview Mark
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.previewMark.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         cookie: {
         *             wbs_preview: wbsPreview
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.previewMark.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext> | MutationFiltersByMutationKey<PreviewMarkSchema, PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext>): Mutation<PreviewMarkData, PreviewMarkError, MutationVariables<PreviewMarkBody, PreviewMarkParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext> | MutationFiltersByMutationKey<PreviewMarkSchema, PreviewMarkBody, PreviewMarkData, PreviewMarkParameters, OperationError<PreviewMarkError>, TContext>): Array<Mutation<PreviewMarkData, PreviewMarkError, MutationVariables<PreviewMarkBody, PreviewMarkParameters>, TContext>>;
        };
        schema: PreviewMarkSchema;
        types: {
            parameters: PreviewMarkParameters;
            data: PreviewMarkData;
            error: PreviewMarkError;
            body: PreviewMarkBody;
        };
    };
    /**
     * @summary Global Search
     * @description One corpus of global search results, ordered title-matches first.
     *
     * `kind` is required and names one corpus per call, which is what the legacy
     * engine's own SQL does. `q` is a single contiguous substring matched
     * case-insensitively and accent-insensitively against the title and against
     * the tag-stripped body, as two independent tests: a term spanning the end of
     * the title and the start of the body matches neither. LIKE wildcards in `q`
     * are matched literally.
     *
     * `language` is required. Every destination route resolves a slug within one
     * language and 404s outside it, so an unfiltered result would list
     * unreachable pages.
     *
     * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
     */
    globalSearch: {
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GlobalSearchSchema, GlobalSearchParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GlobalSearchParameters, TMeta, TSignal>), client?: (schema: GlobalSearchSchema, options: {
            parameters: GlobalSearchParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GlobalSearchData, GlobalSearchError>>): Promise<RequestFnResponse<GlobalSearchData, GlobalSearchError>>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        getQueryKey(parameters: DeepReadonly<GlobalSearchParameters>): ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.globalSearch.useQuery({
         *     query: {
         *         q: q,
         *         kind: kind,
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GlobalSearchData>(parameters: ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>), options?: Omit<UndefinedInitialDataOptions<GlobalSearchData, GlobalSearchError, TData, ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GlobalSearchError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.globalSearch.useQuery({
         *     query: {
         *         q: q,
         *         kind: kind,
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GlobalSearchData>(parameters: ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>), options: Omit<DefinedInitialDataOptions<GlobalSearchData, GlobalSearchError, TData, ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GlobalSearchError>>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GlobalSearchParameters>): ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.globalSearch.useInfiniteQuery({
         *     query: {
         *         q: q,
         *         kind: kind,
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             q: initialQ,
         *             kind: initialKind,
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GlobalSearchParameters, TQueryFnData = GlobalSearchData, TData = OperationInfiniteData<TQueryFnData, GlobalSearchParameters>>(parameters: ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GlobalSearchError, TData, ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GlobalSearchError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.globalSearch.useInfiniteQuery({
         *     query: {
         *         q: q,
         *         kind: kind,
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             q: initialQ,
         *             kind: initialKind,
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GlobalSearchParameters, TQueryFnData = GlobalSearchData, TData = OperationInfiniteData<TQueryFnData, GlobalSearchParameters>>(parameters: ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GlobalSearchError, TData, ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GlobalSearchData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GlobalSearchError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const globalSearchTotal = qraft.v3Service.globalSearch.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const globalSearchByParametersTotal = qraft.v3Service.globalSearch.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             q: q,
         *             kind: kind,
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError> | QueryFiltersByQueryKey<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const globalSearchResults = qraft.v3Service.globalSearch.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 q: q1,
         *                 kind: kind1,
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 q: q2,
         *                 kind: kind2,
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * globalSearchResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const globalSearchCombinedResults = qraft.v3Service.globalSearch.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 q: q1,
         *                 kind: kind1,
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 q: q2,
         *                 kind: kind2,
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * globalSearchCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GlobalSearchSchema, GlobalSearchParameters, GlobalSearchData, GlobalSearchError>>, TCombinedResult = Array<UseQueryResult<GlobalSearchData, GlobalSearchError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GlobalSearchData, GlobalSearchError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.globalSearch.useSuspenseQuery({
         *     query: {
         *         q: q,
         *         kind: kind,
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GlobalSearchData>(parameters: ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>), options?: Omit<UseSuspenseQueryOptions<GlobalSearchData, GlobalSearchError, TData, ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GlobalSearchError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.globalSearch.useSuspenseInfiniteQuery({
         *     query: {
         *         q: q,
         *         kind: kind,
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             q: initialQ,
         *             kind: initialKind,
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GlobalSearchParameters, TData = GlobalSearchData>(parameters: ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GlobalSearchData, GlobalSearchError, OperationInfiniteData<TData, GlobalSearchParameters>, ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GlobalSearchData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GlobalSearchParameters>, OperationError<GlobalSearchError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const globalSearchData = qraft.v3Service.globalSearch.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 q: q1,
         *                 kind: kind1,
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 q: q2,
         *                 kind: kind2,
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * globalSearchResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const globalSearchCombinedData = qraft.v3Service.globalSearch.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 q: q1,
         *                 kind: kind1,
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 q: q2,
         *                 kind: kind2,
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * globalSearchCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GlobalSearchSchema, GlobalSearchParameters, GlobalSearchData, GlobalSearchError>>, TCombinedResult = Array<UseSuspenseQueryResult<GlobalSearchData, GlobalSearchError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GlobalSearchData, GlobalSearchError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GlobalSearchSchema, GlobalSearchData, GlobalSearchParameters, GlobalSearchError>): Promise<GlobalSearchData>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GlobalSearchSchema, GlobalSearchData, GlobalSearchParameters, GlobalSearchError>): Promise<void>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GlobalSearchSchema, GlobalSearchData, GlobalSearchParameters, GlobalSearchError>): Promise<GlobalSearchData>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        fetchInfiniteQuery<TPageParam extends GlobalSearchParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GlobalSearchSchema, GlobalSearchData, GlobalSearchParameters, DeepReadonly<TPageParam>, GlobalSearchError>): Promise<OperationInfiniteData<GlobalSearchData, GlobalSearchParameters>>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        prefetchInfiniteQuery<TPageParam extends GlobalSearchParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GlobalSearchSchema, GlobalSearchData, GlobalSearchParameters, DeepReadonly<TPageParam>, GlobalSearchError>): Promise<void>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        ensureInfiniteQueryData<TPageParam extends GlobalSearchParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GlobalSearchSchema, GlobalSearchData, GlobalSearchParameters, DeepReadonly<TPageParam>, GlobalSearchError>): Promise<OperationInfiniteData<GlobalSearchData, GlobalSearchParameters>>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>)): GlobalSearchData | undefined;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>)): OperationInfiniteData<GlobalSearchData, GlobalSearchParameters> | undefined;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError> | QueryFiltersByQueryKey<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters>,
            data: NoInfer<OperationInfiniteData<GlobalSearchData, GlobalSearchParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters>,
            data: GlobalSearchData | undefined
        ]>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters> | (DeepReadonly<GlobalSearchParameters>)): QueryState<GlobalSearchData, GlobalSearchError> | undefined;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GlobalSearchParameters> | ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters>): QueryState<OperationInfiniteData<GlobalSearchData, GlobalSearchParameters>, GlobalSearchError> | undefined;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        setQueryData(parameters: (DeepReadonly<GlobalSearchParameters>) | ServiceOperationQueryKey<GlobalSearchSchema, GlobalSearchParameters>, updater: Updater<NoInfer<GlobalSearchData> | undefined, NoInfer<DeepReadonly<GlobalSearchData>> | undefined>, options?: SetDataOptions): GlobalSearchData | undefined;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GlobalSearchParameters>) | ServiceOperationInfiniteQueryKey<GlobalSearchSchema, GlobalSearchParameters>, updater: Updater<NoInfer<OperationInfiniteData<GlobalSearchData, GlobalSearchParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GlobalSearchData, GlobalSearchParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GlobalSearchData, GlobalSearchParameters> | undefined;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError> | QueryFiltersByQueryKey<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>, updater: Updater<NoInfer<GlobalSearchData> | undefined, NoInfer<GlobalSearchData> | undefined>, options?: SetDataOptions): Array<GlobalSearchData | undefined>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError> | QueryFiltersByQueryKey<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError> | QueryFiltersByQueryKey<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError> | QueryFiltersByQueryKey<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>): void;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError> | QueryFiltersByQueryKey<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Global Search
         * @description One corpus of global search results, ordered title-matches first.
         *
         * `kind` is required and names one corpus per call, which is what the legacy
         * engine's own SQL does. `q` is a single contiguous substring matched
         * case-insensitively and accent-insensitively against the title and against
         * the tag-stripped body, as two independent tests: a term spanning the end of
         * the title and the start of the body matches neither. LIKE wildcards in `q`
         * are matched literally.
         *
         * `language` is required. Every destination route resolves a slug within one
         * language and 404s outside it, so an unfiltered result would list
         * unreachable pages.
         *
         * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError> | QueryFiltersByQueryKey<GlobalSearchSchema, GlobalSearchData, TInfinite, GlobalSearchParameters, GlobalSearchError>): number;
        schema: GlobalSearchSchema;
        types: {
            parameters: GlobalSearchParameters;
            data: GlobalSearchData;
            error: GlobalSearchError;
        };
    };
    /**
     * @summary Email Lesson
     * @description Mail the caller every topic of this lesson, plus its final exam link.
     *
     * The recipient is always the caller, so there is no `user_id` parameter.
     */
    emailLesson: {
        /**
         * @summary Email Lesson
         * @description Mail the caller every topic of this lesson, plus its final exam link.
         *
         * The recipient is always the caller, so there is no `user_id` parameter.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<EmailLessonBody, EmailLessonParameters, TMeta, TSignal>, client?: (schema: EmailLessonSchema, options: ServiceOperationMutationFnOptions<EmailLessonBody, EmailLessonParameters, TMeta, TSignal>) => Promise<RequestFnResponse<EmailLessonData, EmailLessonError>>): Promise<RequestFnResponse<EmailLessonData, EmailLessonError>>;
        /**
         * @summary Email Lesson
         * @description Mail the caller every topic of this lesson, plus its final exam link.
         *
         * The recipient is always the caller, so there is no `user_id` parameter.
         */
        getMutationKey(parameters: DeepReadonly<EmailLessonParameters> | void): ServiceOperationMutationKey<EmailLessonSchema, EmailLessonParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Email Lesson
         * @description Mail the caller every topic of this lesson, plus its final exam link.
         *
         * The recipient is always the caller, so there is no `user_id` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.emailLesson.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.emailLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends EmailLessonBody, TContext = unknown>(parameters: DeepReadonly<EmailLessonParameters>, options?: ServiceOperationUseMutationOptions<EmailLessonSchema, EmailLessonData, EmailLessonParameters, TVariables, OperationError<EmailLessonError>, TContext>): UseMutationResult<EmailLessonData, OperationError<EmailLessonError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Email Lesson
         * @description Mail the caller every topic of this lesson, plus its final exam link.
         *
         * The recipient is always the caller, so there is no `user_id` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.emailLesson.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.emailLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<EmailLessonBody, EmailLessonParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<EmailLessonSchema, EmailLessonData, EmailLessonParameters, TVariables, OperationError<EmailLessonError>, TContext>): UseMutationResult<EmailLessonData, OperationError<EmailLessonError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Email Lesson
         * @description Mail the caller every topic of this lesson, plus its final exam link.
         *
         * The recipient is always the caller, so there is no `user_id` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const emailLessonTotal = qraft.v3Service.emailLesson.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const emailLessonTotal = qraft.v3Service.emailLesson.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext> | MutationFiltersByMutationKey<EmailLessonSchema, EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Email Lesson
         * @description Mail the caller every topic of this lesson, plus its final exam link.
         *
         * The recipient is always the caller, so there is no `user_id` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const emailLessonPendingMutationVariables = qraft.v3Service.emailLesson.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const emailLessonMutationData = qraft.v3Service.emailLesson.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<EmailLessonData, OperationError<EmailLessonError>, MutationVariables<EmailLessonBody, EmailLessonParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext> | MutationFiltersByMutationKey<EmailLessonSchema, EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext>;
            select?: (mutation: Mutation<EmailLessonData, OperationError<EmailLessonError>, MutationVariables<EmailLessonBody, EmailLessonParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Email Lesson
         * @description Mail the caller every topic of this lesson, plus its final exam link.
         *
         * The recipient is always the caller, so there is no `user_id` parameter.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext> | MutationFiltersByMutationKey<EmailLessonSchema, EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Email Lesson
         * @description Mail the caller every topic of this lesson, plus its final exam link.
         *
         * The recipient is always the caller, so there is no `user_id` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.emailLesson.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.emailLesson.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext> | MutationFiltersByMutationKey<EmailLessonSchema, EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext>): Mutation<EmailLessonData, EmailLessonError, MutationVariables<EmailLessonBody, EmailLessonParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext> | MutationFiltersByMutationKey<EmailLessonSchema, EmailLessonBody, EmailLessonData, EmailLessonParameters, OperationError<EmailLessonError>, TContext>): Array<Mutation<EmailLessonData, EmailLessonError, MutationVariables<EmailLessonBody, EmailLessonParameters>, TContext>>;
        };
        schema: EmailLessonSchema;
        types: {
            parameters: EmailLessonParameters;
            data: EmailLessonData;
            error: EmailLessonError;
            body: EmailLessonBody;
        };
    };
    /** @summary List Certificates */
    listCertificates: {
        /** @summary List Certificates */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCertificatesSchema, ListCertificatesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCertificatesParameters, TMeta, TSignal> | void), client?: (schema: ListCertificatesSchema, options: {
            parameters: ListCertificatesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCertificatesData, ListCertificatesError>>): Promise<RequestFnResponse<ListCertificatesData, ListCertificatesError>>;
        /** @summary List Certificates */
        getQueryKey(parameters: DeepReadonly<ListCertificatesParameters> | void): ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCertificates.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCertificates.useQuery({
         *     query: {
         *         user_id: userId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCertificatesData>(parameters: ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListCertificatesData, ListCertificatesError, TData, ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCertificatesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCertificates.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCertificates.useQuery({
         *     query: {
         *         user_id: userId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCertificatesData>(parameters: ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void), options: Omit<DefinedInitialDataOptions<ListCertificatesData, ListCertificatesError, TData, ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCertificatesError>>;
        /** @summary List Certificates */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCertificatesParameters> | void): ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCertificates.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             user_id: initialUserId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCertificatesParameters, TQueryFnData = ListCertificatesData, TData = OperationInfiniteData<TQueryFnData, ListCertificatesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCertificatesError, TData, ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCertificatesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCertificates.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             user_id: initialUserId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCertificatesParameters, TQueryFnData = ListCertificatesData, TData = OperationInfiniteData<TQueryFnData, ListCertificatesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCertificatesError, TData, ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCertificatesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCertificatesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCertificatesTotal = qraft.v3Service.listCertificates.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCertificatesByParametersTotal = qraft.v3Service.listCertificates.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             user_id: userId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError> | QueryFiltersByQueryKey<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCertificatesResults = qraft.v3Service.listCertificates.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 user_id: userId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 user_id: userId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCertificatesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCertificatesCombinedResults = qraft.v3Service.listCertificates.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 user_id: userId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 user_id: userId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCertificatesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCertificatesSchema, ListCertificatesParameters, ListCertificatesData, ListCertificatesError>>, TCombinedResult = Array<UseQueryResult<ListCertificatesData, ListCertificatesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCertificatesData, ListCertificatesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listCertificates.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCertificates.useSuspenseQuery({
         *     query: {
         *         user_id: userId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCertificatesData>(parameters: ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListCertificatesData, ListCertificatesError, TData, ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCertificatesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCertificates.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             user_id: initialUserId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCertificatesParameters, TData = ListCertificatesData>(parameters: ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListCertificatesData, ListCertificatesError, OperationInfiniteData<TData, ListCertificatesParameters>, ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCertificatesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCertificatesParameters>, OperationError<ListCertificatesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCertificatesData = qraft.v3Service.listCertificates.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 user_id: userId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 user_id: userId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCertificatesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCertificatesCombinedData = qraft.v3Service.listCertificates.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 user_id: userId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 user_id: userId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCertificatesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCertificatesSchema, ListCertificatesParameters, ListCertificatesData, ListCertificatesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCertificatesData, ListCertificatesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCertificatesData, ListCertificatesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary List Certificates */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCertificatesSchema, ListCertificatesData, ListCertificatesParameters, ListCertificatesError> | void): Promise<ListCertificatesData>;
        /** @summary List Certificates */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCertificatesSchema, ListCertificatesData, ListCertificatesParameters, ListCertificatesError> | void): Promise<void>;
        /** @summary List Certificates */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCertificatesSchema, ListCertificatesData, ListCertificatesParameters, ListCertificatesError> | void): Promise<ListCertificatesData>;
        /** @summary List Certificates */
        fetchInfiniteQuery<TPageParam extends ListCertificatesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCertificatesSchema, ListCertificatesData, ListCertificatesParameters, DeepReadonly<TPageParam>, ListCertificatesError> | void): Promise<OperationInfiniteData<ListCertificatesData, ListCertificatesParameters>>;
        /** @summary List Certificates */
        prefetchInfiniteQuery<TPageParam extends ListCertificatesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCertificatesSchema, ListCertificatesData, ListCertificatesParameters, DeepReadonly<TPageParam>, ListCertificatesError> | void): Promise<void>;
        /** @summary List Certificates */
        ensureInfiniteQueryData<TPageParam extends ListCertificatesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCertificatesSchema, ListCertificatesData, ListCertificatesParameters, DeepReadonly<TPageParam>, ListCertificatesError> | void): Promise<OperationInfiniteData<ListCertificatesData, ListCertificatesParameters>>;
        /** @summary List Certificates */
        getQueryData(parameters: ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void)): ListCertificatesData | undefined;
        /** @summary List Certificates */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void)): OperationInfiniteData<ListCertificatesData, ListCertificatesParameters> | undefined;
        /** @summary List Certificates */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError> | QueryFiltersByQueryKey<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters>,
            data: NoInfer<OperationInfiniteData<ListCertificatesData, ListCertificatesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters>,
            data: ListCertificatesData | undefined
        ]>;
        /** @summary List Certificates */
        getQueryState(parameters: ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters> | (DeepReadonly<ListCertificatesParameters> | void)): QueryState<ListCertificatesData, ListCertificatesError> | undefined;
        /** @summary List Certificates */
        getInfiniteQueryState(parameters: DeepReadonly<ListCertificatesParameters> | ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters> | void): QueryState<OperationInfiniteData<ListCertificatesData, ListCertificatesParameters>, ListCertificatesError> | undefined;
        /** @summary List Certificates */
        setQueryData(parameters: (DeepReadonly<ListCertificatesParameters> | undefined) | ServiceOperationQueryKey<ListCertificatesSchema, ListCertificatesParameters>, updater: Updater<NoInfer<ListCertificatesData> | undefined, NoInfer<DeepReadonly<ListCertificatesData>> | undefined>, options?: SetDataOptions): ListCertificatesData | undefined;
        /** @summary List Certificates */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCertificatesParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListCertificatesSchema, ListCertificatesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCertificatesData, ListCertificatesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCertificatesData, ListCertificatesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCertificatesData, ListCertificatesParameters> | undefined;
        /** @summary List Certificates */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError> | QueryFiltersByQueryKey<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>, updater: Updater<NoInfer<ListCertificatesData> | undefined, NoInfer<ListCertificatesData> | undefined>, options?: SetDataOptions): Array<ListCertificatesData | undefined>;
        /** @summary List Certificates */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary List Certificates */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError> | QueryFiltersByQueryKey<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>, options?: RefetchOptions): Promise<void>;
        /** @summary List Certificates */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError> | QueryFiltersByQueryKey<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>, options?: CancelOptions): Promise<void>;
        /** @summary List Certificates */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError> | QueryFiltersByQueryKey<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>): void;
        /** @summary List Certificates */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError> | QueryFiltersByQueryKey<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>, options?: ResetOptions): Promise<void>;
        /** @summary List Certificates */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError> | QueryFiltersByQueryKey<ListCertificatesSchema, ListCertificatesData, TInfinite, ListCertificatesParameters, ListCertificatesError>): number;
        schema: ListCertificatesSchema;
        types: {
            parameters: ListCertificatesParameters;
            data: ListCertificatesData;
            error: ListCertificatesError;
        };
    };
    /**
     * @summary Download Certificate
     * @description Render and serve the certificate PDF, for a viewer entitled to it.
     */
    downloadCertificate: {
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<DownloadCertificateSchema, DownloadCertificateParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<DownloadCertificateParameters, TMeta, TSignal>), client?: (schema: DownloadCertificateSchema, options: {
            parameters: DownloadCertificateParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<DownloadCertificateData, DownloadCertificateError>>): Promise<RequestFnResponse<DownloadCertificateData, DownloadCertificateError>>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        getQueryKey(parameters: DeepReadonly<DownloadCertificateParameters>): ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.downloadCertificate.useQuery({
         *     path: {
         *         certificate_id: certificateId
         *     },
         *     query: {
         *         token: token
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = DownloadCertificateData>(parameters: ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>), options?: Omit<UndefinedInitialDataOptions<DownloadCertificateData, DownloadCertificateError, TData, ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>>, "queryKey">): UseQueryResult<TData, OperationError<DownloadCertificateError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.downloadCertificate.useQuery({
         *     path: {
         *         certificate_id: certificateId
         *     },
         *     query: {
         *         token: token
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = DownloadCertificateData>(parameters: ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>), options: Omit<DefinedInitialDataOptions<DownloadCertificateData, DownloadCertificateError, TData, ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<DownloadCertificateError>>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<DownloadCertificateParameters>): ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.downloadCertificate.useInfiniteQuery({
         *     path: {
         *         certificate_id: certificateId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             token: initialToken
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends DownloadCertificateParameters, TQueryFnData = DownloadCertificateData, TData = OperationInfiniteData<TQueryFnData, DownloadCertificateParameters>>(parameters: ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, DownloadCertificateError, TData, ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<DownloadCertificateError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.downloadCertificate.useInfiniteQuery({
         *     path: {
         *         certificate_id: certificateId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             token: initialToken
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends DownloadCertificateParameters, TQueryFnData = DownloadCertificateData, TData = OperationInfiniteData<TQueryFnData, DownloadCertificateParameters>>(parameters: ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, DownloadCertificateError, TData, ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<DownloadCertificateData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<DownloadCertificateError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const downloadCertificateTotal = qraft.v3Service.downloadCertificate.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const downloadCertificateByParametersTotal = qraft.v3Service.downloadCertificate.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             certificate_id: certificateId
         *         },
         *         query: {
         *             token: token
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError> | QueryFiltersByQueryKey<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const downloadCertificateResults = qraft.v3Service.downloadCertificate.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 certificate_id: certificateId1
         *             },
         *             query: {
         *                 token: token1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 certificate_id: certificateId2
         *             },
         *             query: {
         *                 token: token2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * downloadCertificateResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const downloadCertificateCombinedResults = qraft.v3Service.downloadCertificate.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 certificate_id: certificateId1
         *             },
         *             query: {
         *                 token: token1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 certificate_id: certificateId2
         *             },
         *             query: {
         *                 token: token2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * downloadCertificateCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<DownloadCertificateSchema, DownloadCertificateParameters, DownloadCertificateData, DownloadCertificateError>>, TCombinedResult = Array<UseQueryResult<DownloadCertificateData, DownloadCertificateError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<DownloadCertificateData, DownloadCertificateError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.downloadCertificate.useSuspenseQuery({
         *     path: {
         *         certificate_id: certificateId
         *     },
         *     query: {
         *         token: token
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = DownloadCertificateData>(parameters: ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>), options?: Omit<UseSuspenseQueryOptions<DownloadCertificateData, DownloadCertificateError, TData, ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<DownloadCertificateError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.downloadCertificate.useSuspenseInfiniteQuery({
         *     path: {
         *         certificate_id: certificateId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             token: initialToken
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends DownloadCertificateParameters, TData = DownloadCertificateData>(parameters: ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<DownloadCertificateData, DownloadCertificateError, OperationInfiniteData<TData, DownloadCertificateParameters>, ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<DownloadCertificateData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, DownloadCertificateParameters>, OperationError<DownloadCertificateError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const downloadCertificateData = qraft.v3Service.downloadCertificate.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 certificate_id: certificateId1
         *             },
         *             query: {
         *                 token: token1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 certificate_id: certificateId2
         *             },
         *             query: {
         *                 token: token2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * downloadCertificateResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const downloadCertificateCombinedData = qraft.v3Service.downloadCertificate.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 certificate_id: certificateId1
         *             },
         *             query: {
         *                 token: token1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 certificate_id: certificateId2
         *             },
         *             query: {
         *                 token: token2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * downloadCertificateCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<DownloadCertificateSchema, DownloadCertificateParameters, DownloadCertificateData, DownloadCertificateError>>, TCombinedResult = Array<UseSuspenseQueryResult<DownloadCertificateData, DownloadCertificateError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<DownloadCertificateData, DownloadCertificateError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<DownloadCertificateSchema, DownloadCertificateData, DownloadCertificateParameters, DownloadCertificateError>): Promise<DownloadCertificateData>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<DownloadCertificateSchema, DownloadCertificateData, DownloadCertificateParameters, DownloadCertificateError>): Promise<void>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<DownloadCertificateSchema, DownloadCertificateData, DownloadCertificateParameters, DownloadCertificateError>): Promise<DownloadCertificateData>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        fetchInfiniteQuery<TPageParam extends DownloadCertificateParameters>(options: ServiceOperationFetchInfiniteQueryOptions<DownloadCertificateSchema, DownloadCertificateData, DownloadCertificateParameters, DeepReadonly<TPageParam>, DownloadCertificateError>): Promise<OperationInfiniteData<DownloadCertificateData, DownloadCertificateParameters>>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        prefetchInfiniteQuery<TPageParam extends DownloadCertificateParameters>(options: ServiceOperationFetchInfiniteQueryOptions<DownloadCertificateSchema, DownloadCertificateData, DownloadCertificateParameters, DeepReadonly<TPageParam>, DownloadCertificateError>): Promise<void>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        ensureInfiniteQueryData<TPageParam extends DownloadCertificateParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<DownloadCertificateSchema, DownloadCertificateData, DownloadCertificateParameters, DeepReadonly<TPageParam>, DownloadCertificateError>): Promise<OperationInfiniteData<DownloadCertificateData, DownloadCertificateParameters>>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        getQueryData(parameters: ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>)): DownloadCertificateData | undefined;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>)): OperationInfiniteData<DownloadCertificateData, DownloadCertificateParameters> | undefined;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError> | QueryFiltersByQueryKey<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>,
            data: NoInfer<OperationInfiniteData<DownloadCertificateData, DownloadCertificateParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>,
            data: DownloadCertificateData | undefined
        ]>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        getQueryState(parameters: ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters> | (DeepReadonly<DownloadCertificateParameters>)): QueryState<DownloadCertificateData, DownloadCertificateError> | undefined;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        getInfiniteQueryState(parameters: DeepReadonly<DownloadCertificateParameters> | ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>): QueryState<OperationInfiniteData<DownloadCertificateData, DownloadCertificateParameters>, DownloadCertificateError> | undefined;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        setQueryData(parameters: (DeepReadonly<DownloadCertificateParameters>) | ServiceOperationQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>, updater: Updater<NoInfer<DownloadCertificateData> | undefined, NoInfer<DeepReadonly<DownloadCertificateData>> | undefined>, options?: SetDataOptions): DownloadCertificateData | undefined;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<DownloadCertificateParameters>) | ServiceOperationInfiniteQueryKey<DownloadCertificateSchema, DownloadCertificateParameters>, updater: Updater<NoInfer<OperationInfiniteData<DownloadCertificateData, DownloadCertificateParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<DownloadCertificateData, DownloadCertificateParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<DownloadCertificateData, DownloadCertificateParameters> | undefined;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError> | QueryFiltersByQueryKey<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>, updater: Updater<NoInfer<DownloadCertificateData> | undefined, NoInfer<DownloadCertificateData> | undefined>, options?: SetDataOptions): Array<DownloadCertificateData | undefined>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError> | QueryFiltersByQueryKey<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError> | QueryFiltersByQueryKey<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError> | QueryFiltersByQueryKey<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>): void;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError> | QueryFiltersByQueryKey<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Download Certificate
         * @description Render and serve the certificate PDF, for a viewer entitled to it.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError> | QueryFiltersByQueryKey<DownloadCertificateSchema, DownloadCertificateData, TInfinite, DownloadCertificateParameters, DownloadCertificateError>): number;
        schema: DownloadCertificateSchema;
        types: {
            parameters: DownloadCertificateParameters;
            data: DownloadCertificateData;
            error: DownloadCertificateError;
        };
    };
    /**
     * @summary Award Certificate
     * @description Issue a course or series certificate to a student.
     */
    awardCertificate: {
        /**
         * @summary Award Certificate
         * @description Issue a course or series certificate to a student.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AwardCertificateBody, AwardCertificateParameters, TMeta, TSignal>, client?: (schema: AwardCertificateSchema, options: ServiceOperationMutationFnOptions<AwardCertificateBody, AwardCertificateParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AwardCertificateData, AwardCertificateError>>): Promise<RequestFnResponse<AwardCertificateData, AwardCertificateError>>;
        /**
         * @summary Award Certificate
         * @description Issue a course or series certificate to a student.
         */
        getMutationKey(parameters: DeepReadonly<AwardCertificateParameters> | void): ServiceOperationMutationKey<AwardCertificateSchema, AwardCertificateParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Award Certificate
         * @description Issue a course or series certificate to a student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.awardCertificate.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.awardCertificate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AwardCertificateBody, TContext = unknown>(parameters: DeepReadonly<AwardCertificateParameters>, options?: ServiceOperationUseMutationOptions<AwardCertificateSchema, AwardCertificateData, AwardCertificateParameters, TVariables, OperationError<AwardCertificateError>, TContext>): UseMutationResult<AwardCertificateData, OperationError<AwardCertificateError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Award Certificate
         * @description Issue a course or series certificate to a student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.awardCertificate.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.awardCertificate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AwardCertificateBody, AwardCertificateParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AwardCertificateSchema, AwardCertificateData, AwardCertificateParameters, TVariables, OperationError<AwardCertificateError>, TContext>): UseMutationResult<AwardCertificateData, OperationError<AwardCertificateError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Award Certificate
         * @description Issue a course or series certificate to a student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const awardCertificateTotal = qraft.v3Service.awardCertificate.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const awardCertificateTotal = qraft.v3Service.awardCertificate.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext> | MutationFiltersByMutationKey<AwardCertificateSchema, AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Award Certificate
         * @description Issue a course or series certificate to a student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const awardCertificatePendingMutationVariables = qraft.v3Service.awardCertificate.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const awardCertificateMutationData = qraft.v3Service.awardCertificate.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AwardCertificateData, OperationError<AwardCertificateError>, MutationVariables<AwardCertificateBody, AwardCertificateParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext> | MutationFiltersByMutationKey<AwardCertificateSchema, AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext>;
            select?: (mutation: Mutation<AwardCertificateData, OperationError<AwardCertificateError>, MutationVariables<AwardCertificateBody, AwardCertificateParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Award Certificate
         * @description Issue a course or series certificate to a student.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext> | MutationFiltersByMutationKey<AwardCertificateSchema, AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Award Certificate
         * @description Issue a course or series certificate to a student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.awardCertificate.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.awardCertificate.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext> | MutationFiltersByMutationKey<AwardCertificateSchema, AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext>): Mutation<AwardCertificateData, AwardCertificateError, MutationVariables<AwardCertificateBody, AwardCertificateParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext> | MutationFiltersByMutationKey<AwardCertificateSchema, AwardCertificateBody, AwardCertificateData, AwardCertificateParameters, OperationError<AwardCertificateError>, TContext>): Array<Mutation<AwardCertificateData, AwardCertificateError, MutationVariables<AwardCertificateBody, AwardCertificateParameters>, TContext>>;
        };
        schema: AwardCertificateSchema;
        types: {
            parameters: AwardCertificateParameters;
            data: AwardCertificateData;
            error: AwardCertificateError;
            body: AwardCertificateBody;
        };
    };
    /** @summary Admin Create Course Certificate Template */
    adminCreateCourseCertificateTemplate: {
        /** @summary Admin Create Course Certificate Template */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateParameters, TMeta, TSignal>, client?: (schema: AdminCreateCourseCertificateTemplateSchema, options: ServiceOperationMutationFnOptions<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateError>>): Promise<RequestFnResponse<AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateError>>;
        /** @summary Admin Create Course Certificate Template */
        getMutationKey(parameters: DeepReadonly<AdminCreateCourseCertificateTemplateParameters> | void): ServiceOperationMutationKey<AdminCreateCourseCertificateTemplateSchema, AdminCreateCourseCertificateTemplateParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateCourseCertificateTemplate.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateCourseCertificateTemplate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminCreateCourseCertificateTemplateBody, TContext = unknown>(parameters: DeepReadonly<AdminCreateCourseCertificateTemplateParameters>, options?: ServiceOperationUseMutationOptions<AdminCreateCourseCertificateTemplateSchema, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, TVariables, OperationError<AdminCreateCourseCertificateTemplateError>, TContext>): UseMutationResult<AdminCreateCourseCertificateTemplateData, OperationError<AdminCreateCourseCertificateTemplateError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateCourseCertificateTemplate.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateCourseCertificateTemplate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminCreateCourseCertificateTemplateSchema, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, TVariables, OperationError<AdminCreateCourseCertificateTemplateError>, TContext>): UseMutationResult<AdminCreateCourseCertificateTemplateData, OperationError<AdminCreateCourseCertificateTemplateError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Create Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminCreateCourseCertificateTemplateTotal = qraft.v3Service.adminCreateCourseCertificateTemplate.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminCreateCourseCertificateTemplateTotal = qraft.v3Service.adminCreateCourseCertificateTemplate.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseCertificateTemplateSchema, AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Create Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminCreateCourseCertificateTemplatePendingMutationVariables = qraft.v3Service.adminCreateCourseCertificateTemplate.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminCreateCourseCertificateTemplateMutationData = qraft.v3Service.adminCreateCourseCertificateTemplate.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminCreateCourseCertificateTemplateData, OperationError<AdminCreateCourseCertificateTemplateError>, MutationVariables<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseCertificateTemplateSchema, AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext>;
            select?: (mutation: Mutation<AdminCreateCourseCertificateTemplateData, OperationError<AdminCreateCourseCertificateTemplateError>, MutationVariables<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Create Course Certificate Template */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseCertificateTemplateSchema, AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Create Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateCourseCertificateTemplate.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateCourseCertificateTemplate.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseCertificateTemplateSchema, AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext>): Mutation<AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateError, MutationVariables<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateCourseCertificateTemplateSchema, AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateParameters, OperationError<AdminCreateCourseCertificateTemplateError>, TContext>): Array<Mutation<AdminCreateCourseCertificateTemplateData, AdminCreateCourseCertificateTemplateError, MutationVariables<AdminCreateCourseCertificateTemplateBody, AdminCreateCourseCertificateTemplateParameters>, TContext>>;
        };
        schema: AdminCreateCourseCertificateTemplateSchema;
        types: {
            parameters: AdminCreateCourseCertificateTemplateParameters;
            data: AdminCreateCourseCertificateTemplateData;
            error: AdminCreateCourseCertificateTemplateError;
            body: AdminCreateCourseCertificateTemplateBody;
        };
    };
    /** @summary Admin Delete Course Certificate Template */
    adminDeleteCourseCertificateTemplate: {
        /** @summary Admin Delete Course Certificate Template */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateParameters, TMeta, TSignal>, client?: (schema: AdminDeleteCourseCertificateTemplateSchema, options: ServiceOperationMutationFnOptions<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateError>>): Promise<RequestFnResponse<AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateError>>;
        /** @summary Admin Delete Course Certificate Template */
        getMutationKey(parameters: DeepReadonly<AdminDeleteCourseCertificateTemplateParameters> | void): ServiceOperationMutationKey<AdminDeleteCourseCertificateTemplateSchema, AdminDeleteCourseCertificateTemplateParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteCourseCertificateTemplate.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteCourseCertificateTemplate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminDeleteCourseCertificateTemplateBody, TContext = unknown>(parameters: DeepReadonly<AdminDeleteCourseCertificateTemplateParameters>, options?: ServiceOperationUseMutationOptions<AdminDeleteCourseCertificateTemplateSchema, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, TVariables, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext>): UseMutationResult<AdminDeleteCourseCertificateTemplateData, OperationError<AdminDeleteCourseCertificateTemplateError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteCourseCertificateTemplate.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteCourseCertificateTemplate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminDeleteCourseCertificateTemplateSchema, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, TVariables, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext>): UseMutationResult<AdminDeleteCourseCertificateTemplateData, OperationError<AdminDeleteCourseCertificateTemplateError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Delete Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminDeleteCourseCertificateTemplateTotal = qraft.v3Service.adminDeleteCourseCertificateTemplate.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminDeleteCourseCertificateTemplateTotal = qraft.v3Service.adminDeleteCourseCertificateTemplate.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteCourseCertificateTemplateSchema, AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Delete Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminDeleteCourseCertificateTemplatePendingMutationVariables = qraft.v3Service.adminDeleteCourseCertificateTemplate.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminDeleteCourseCertificateTemplateMutationData = qraft.v3Service.adminDeleteCourseCertificateTemplate.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminDeleteCourseCertificateTemplateData, OperationError<AdminDeleteCourseCertificateTemplateError>, MutationVariables<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteCourseCertificateTemplateSchema, AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext>;
            select?: (mutation: Mutation<AdminDeleteCourseCertificateTemplateData, OperationError<AdminDeleteCourseCertificateTemplateError>, MutationVariables<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Delete Course Certificate Template */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteCourseCertificateTemplateSchema, AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Delete Course Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteCourseCertificateTemplate.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteCourseCertificateTemplate.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteCourseCertificateTemplateSchema, AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext>): Mutation<AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateError, MutationVariables<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteCourseCertificateTemplateSchema, AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateParameters, OperationError<AdminDeleteCourseCertificateTemplateError>, TContext>): Array<Mutation<AdminDeleteCourseCertificateTemplateData, AdminDeleteCourseCertificateTemplateError, MutationVariables<AdminDeleteCourseCertificateTemplateBody, AdminDeleteCourseCertificateTemplateParameters>, TContext>>;
        };
        schema: AdminDeleteCourseCertificateTemplateSchema;
        types: {
            parameters: AdminDeleteCourseCertificateTemplateParameters;
            data: AdminDeleteCourseCertificateTemplateData;
            error: AdminDeleteCourseCertificateTemplateError;
            body: AdminDeleteCourseCertificateTemplateBody;
        };
    };
    /** @summary Admin Create Series Certificate Template */
    adminCreateSeriesCertificateTemplate: {
        /** @summary Admin Create Series Certificate Template */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateParameters, TMeta, TSignal>, client?: (schema: AdminCreateSeriesCertificateTemplateSchema, options: ServiceOperationMutationFnOptions<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateError>>): Promise<RequestFnResponse<AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateError>>;
        /** @summary Admin Create Series Certificate Template */
        getMutationKey(parameters: DeepReadonly<AdminCreateSeriesCertificateTemplateParameters> | void): ServiceOperationMutationKey<AdminCreateSeriesCertificateTemplateSchema, AdminCreateSeriesCertificateTemplateParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateSeriesCertificateTemplate.useMutation({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateSeriesCertificateTemplate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminCreateSeriesCertificateTemplateBody, TContext = unknown>(parameters: DeepReadonly<AdminCreateSeriesCertificateTemplateParameters>, options?: ServiceOperationUseMutationOptions<AdminCreateSeriesCertificateTemplateSchema, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, TVariables, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext>): UseMutationResult<AdminCreateSeriesCertificateTemplateData, OperationError<AdminCreateSeriesCertificateTemplateError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Create Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateSeriesCertificateTemplate.useMutation({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminCreateSeriesCertificateTemplate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminCreateSeriesCertificateTemplateSchema, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, TVariables, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext>): UseMutationResult<AdminCreateSeriesCertificateTemplateData, OperationError<AdminCreateSeriesCertificateTemplateError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Create Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminCreateSeriesCertificateTemplateTotal = qraft.v3Service.adminCreateSeriesCertificateTemplate.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminCreateSeriesCertificateTemplateTotal = qraft.v3Service.adminCreateSeriesCertificateTemplate.useIsMutating({
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesCertificateTemplateSchema, AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Create Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminCreateSeriesCertificateTemplatePendingMutationVariables = qraft.v3Service.adminCreateSeriesCertificateTemplate.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminCreateSeriesCertificateTemplateMutationData = qraft.v3Service.adminCreateSeriesCertificateTemplate.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 series_id: seriesId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminCreateSeriesCertificateTemplateData, OperationError<AdminCreateSeriesCertificateTemplateError>, MutationVariables<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesCertificateTemplateSchema, AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext>;
            select?: (mutation: Mutation<AdminCreateSeriesCertificateTemplateData, OperationError<AdminCreateSeriesCertificateTemplateError>, MutationVariables<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Create Series Certificate Template */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesCertificateTemplateSchema, AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Create Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateSeriesCertificateTemplate.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminCreateSeriesCertificateTemplate.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesCertificateTemplateSchema, AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext>): Mutation<AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateError, MutationVariables<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminCreateSeriesCertificateTemplateSchema, AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateParameters, OperationError<AdminCreateSeriesCertificateTemplateError>, TContext>): Array<Mutation<AdminCreateSeriesCertificateTemplateData, AdminCreateSeriesCertificateTemplateError, MutationVariables<AdminCreateSeriesCertificateTemplateBody, AdminCreateSeriesCertificateTemplateParameters>, TContext>>;
        };
        schema: AdminCreateSeriesCertificateTemplateSchema;
        types: {
            parameters: AdminCreateSeriesCertificateTemplateParameters;
            data: AdminCreateSeriesCertificateTemplateData;
            error: AdminCreateSeriesCertificateTemplateError;
            body: AdminCreateSeriesCertificateTemplateBody;
        };
    };
    /** @summary Admin Delete Series Certificate Template */
    adminDeleteSeriesCertificateTemplate: {
        /** @summary Admin Delete Series Certificate Template */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateParameters, TMeta, TSignal>, client?: (schema: AdminDeleteSeriesCertificateTemplateSchema, options: ServiceOperationMutationFnOptions<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateError>>): Promise<RequestFnResponse<AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateError>>;
        /** @summary Admin Delete Series Certificate Template */
        getMutationKey(parameters: DeepReadonly<AdminDeleteSeriesCertificateTemplateParameters> | void): ServiceOperationMutationKey<AdminDeleteSeriesCertificateTemplateSchema, AdminDeleteSeriesCertificateTemplateParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteSeriesCertificateTemplate.useMutation({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteSeriesCertificateTemplate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminDeleteSeriesCertificateTemplateBody, TContext = unknown>(parameters: DeepReadonly<AdminDeleteSeriesCertificateTemplateParameters>, options?: ServiceOperationUseMutationOptions<AdminDeleteSeriesCertificateTemplateSchema, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, TVariables, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext>): UseMutationResult<AdminDeleteSeriesCertificateTemplateData, OperationError<AdminDeleteSeriesCertificateTemplateError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Delete Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteSeriesCertificateTemplate.useMutation({
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adminDeleteSeriesCertificateTemplate.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         series_id: seriesId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminDeleteSeriesCertificateTemplateSchema, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, TVariables, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext>): UseMutationResult<AdminDeleteSeriesCertificateTemplateData, OperationError<AdminDeleteSeriesCertificateTemplateError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Delete Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminDeleteSeriesCertificateTemplateTotal = qraft.v3Service.adminDeleteSeriesCertificateTemplate.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminDeleteSeriesCertificateTemplateTotal = qraft.v3Service.adminDeleteSeriesCertificateTemplate.useIsMutating({
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteSeriesCertificateTemplateSchema, AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Delete Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminDeleteSeriesCertificateTemplatePendingMutationVariables = qraft.v3Service.adminDeleteSeriesCertificateTemplate.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminDeleteSeriesCertificateTemplateMutationData = qraft.v3Service.adminDeleteSeriesCertificateTemplate.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 series_id: seriesId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminDeleteSeriesCertificateTemplateData, OperationError<AdminDeleteSeriesCertificateTemplateError>, MutationVariables<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteSeriesCertificateTemplateSchema, AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext>;
            select?: (mutation: Mutation<AdminDeleteSeriesCertificateTemplateData, OperationError<AdminDeleteSeriesCertificateTemplateError>, MutationVariables<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Admin Delete Series Certificate Template */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteSeriesCertificateTemplateSchema, AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Delete Series Certificate Template
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteSeriesCertificateTemplate.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             series_id: seriesId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adminDeleteSeriesCertificateTemplate.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteSeriesCertificateTemplateSchema, AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext>): Mutation<AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateError, MutationVariables<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext> | MutationFiltersByMutationKey<AdminDeleteSeriesCertificateTemplateSchema, AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateParameters, OperationError<AdminDeleteSeriesCertificateTemplateError>, TContext>): Array<Mutation<AdminDeleteSeriesCertificateTemplateData, AdminDeleteSeriesCertificateTemplateError, MutationVariables<AdminDeleteSeriesCertificateTemplateBody, AdminDeleteSeriesCertificateTemplateParameters>, TContext>>;
        };
        schema: AdminDeleteSeriesCertificateTemplateSchema;
        types: {
            parameters: AdminDeleteSeriesCertificateTemplateParameters;
            data: AdminDeleteSeriesCertificateTemplateData;
            error: AdminDeleteSeriesCertificateTemplateError;
            body: AdminDeleteSeriesCertificateTemplateBody;
        };
    };
    /** @summary Topic Complete */
    topicComplete: {
        /** @summary Topic Complete */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TopicCompleteBody, TopicCompleteParameters, TMeta, TSignal>, client?: (schema: TopicCompleteSchema, options: ServiceOperationMutationFnOptions<TopicCompleteBody, TopicCompleteParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TopicCompleteData, TopicCompleteError>>): Promise<RequestFnResponse<TopicCompleteData, TopicCompleteError>>;
        /** @summary Topic Complete */
        getMutationKey(parameters: DeepReadonly<TopicCompleteParameters> | void): ServiceOperationMutationKey<TopicCompleteSchema, TopicCompleteParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topic Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.topicComplete.useMutation({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.topicComplete.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TopicCompleteBody, TContext = unknown>(parameters: DeepReadonly<TopicCompleteParameters>, options?: ServiceOperationUseMutationOptions<TopicCompleteSchema, TopicCompleteData, TopicCompleteParameters, TVariables, OperationError<TopicCompleteError>, TContext>): UseMutationResult<TopicCompleteData, OperationError<TopicCompleteError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topic Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.topicComplete.useMutation({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.topicComplete.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TopicCompleteBody, TopicCompleteParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TopicCompleteSchema, TopicCompleteData, TopicCompleteParameters, TVariables, OperationError<TopicCompleteError>, TContext>): UseMutationResult<TopicCompleteData, OperationError<TopicCompleteError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Topic Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const topicCompleteTotal = qraft.v3Service.topicComplete.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const topicCompleteTotal = qraft.v3Service.topicComplete.useIsMutating({
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext> | MutationFiltersByMutationKey<TopicCompleteSchema, TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Topic Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const topicCompletePendingMutationVariables = qraft.v3Service.topicComplete.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const topicCompleteMutationData = qraft.v3Service.topicComplete.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 topic_id: topicId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TopicCompleteData, OperationError<TopicCompleteError>, MutationVariables<TopicCompleteBody, TopicCompleteParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext> | MutationFiltersByMutationKey<TopicCompleteSchema, TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext>;
            select?: (mutation: Mutation<TopicCompleteData, OperationError<TopicCompleteError>, MutationVariables<TopicCompleteBody, TopicCompleteParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Topic Complete */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext> | MutationFiltersByMutationKey<TopicCompleteSchema, TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Topic Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.topicComplete.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.topicComplete.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext> | MutationFiltersByMutationKey<TopicCompleteSchema, TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext>): Mutation<TopicCompleteData, TopicCompleteError, MutationVariables<TopicCompleteBody, TopicCompleteParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext> | MutationFiltersByMutationKey<TopicCompleteSchema, TopicCompleteBody, TopicCompleteData, TopicCompleteParameters, OperationError<TopicCompleteError>, TContext>): Array<Mutation<TopicCompleteData, TopicCompleteError, MutationVariables<TopicCompleteBody, TopicCompleteParameters>, TContext>>;
        };
        schema: TopicCompleteSchema;
        types: {
            parameters: TopicCompleteParameters;
            data: TopicCompleteData;
            error: TopicCompleteError;
            body: TopicCompleteBody;
        };
    };
    /** @summary Submit Lesson Quiz */
    submitLessonQuiz: {
        /** @summary Submit Lesson Quiz */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SubmitLessonQuizBody, SubmitLessonQuizParameters, TMeta, TSignal>, client?: (schema: SubmitLessonQuizSchema, options: ServiceOperationMutationFnOptions<SubmitLessonQuizBody, SubmitLessonQuizParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SubmitLessonQuizData, SubmitLessonQuizError>>): Promise<RequestFnResponse<SubmitLessonQuizData, SubmitLessonQuizError>>;
        /** @summary Submit Lesson Quiz */
        getMutationKey(parameters: DeepReadonly<SubmitLessonQuizParameters> | void): ServiceOperationMutationKey<SubmitLessonQuizSchema, SubmitLessonQuizParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Lesson Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitLessonQuiz.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitLessonQuiz.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SubmitLessonQuizBody, TContext = unknown>(parameters: DeepReadonly<SubmitLessonQuizParameters>, options?: ServiceOperationUseMutationOptions<SubmitLessonQuizSchema, SubmitLessonQuizData, SubmitLessonQuizParameters, TVariables, OperationError<SubmitLessonQuizError>, TContext>): UseMutationResult<SubmitLessonQuizData, OperationError<SubmitLessonQuizError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Lesson Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitLessonQuiz.useMutation({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitLessonQuiz.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SubmitLessonQuizBody, SubmitLessonQuizParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SubmitLessonQuizSchema, SubmitLessonQuizData, SubmitLessonQuizParameters, TVariables, OperationError<SubmitLessonQuizError>, TContext>): UseMutationResult<SubmitLessonQuizData, OperationError<SubmitLessonQuizError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Submit Lesson Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const submitLessonQuizTotal = qraft.v3Service.submitLessonQuiz.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const submitLessonQuizTotal = qraft.v3Service.submitLessonQuiz.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext> | MutationFiltersByMutationKey<SubmitLessonQuizSchema, SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Submit Lesson Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const submitLessonQuizPendingMutationVariables = qraft.v3Service.submitLessonQuiz.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const submitLessonQuizMutationData = qraft.v3Service.submitLessonQuiz.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SubmitLessonQuizData, OperationError<SubmitLessonQuizError>, MutationVariables<SubmitLessonQuizBody, SubmitLessonQuizParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext> | MutationFiltersByMutationKey<SubmitLessonQuizSchema, SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext>;
            select?: (mutation: Mutation<SubmitLessonQuizData, OperationError<SubmitLessonQuizError>, MutationVariables<SubmitLessonQuizBody, SubmitLessonQuizParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Submit Lesson Quiz */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext> | MutationFiltersByMutationKey<SubmitLessonQuizSchema, SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Submit Lesson Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.submitLessonQuiz.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.submitLessonQuiz.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext> | MutationFiltersByMutationKey<SubmitLessonQuizSchema, SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext>): Mutation<SubmitLessonQuizData, SubmitLessonQuizError, MutationVariables<SubmitLessonQuizBody, SubmitLessonQuizParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext> | MutationFiltersByMutationKey<SubmitLessonQuizSchema, SubmitLessonQuizBody, SubmitLessonQuizData, SubmitLessonQuizParameters, OperationError<SubmitLessonQuizError>, TContext>): Array<Mutation<SubmitLessonQuizData, SubmitLessonQuizError, MutationVariables<SubmitLessonQuizBody, SubmitLessonQuizParameters>, TContext>>;
        };
        schema: SubmitLessonQuizSchema;
        types: {
            parameters: SubmitLessonQuizParameters;
            data: SubmitLessonQuizData;
            error: SubmitLessonQuizError;
            body: SubmitLessonQuizBody;
        };
    };
    /** @summary Lesson Quiz Progress */
    lessonQuizProgress: {
        /** @summary Lesson Quiz Progress */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<LessonQuizProgressParameters, TMeta, TSignal>), client?: (schema: LessonQuizProgressSchema, options: {
            parameters: LessonQuizProgressParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<LessonQuizProgressData, LessonQuizProgressError>>): Promise<RequestFnResponse<LessonQuizProgressData, LessonQuizProgressError>>;
        /** @summary Lesson Quiz Progress */
        getQueryKey(parameters: DeepReadonly<LessonQuizProgressParameters>): ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonQuizProgress.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonQuizProgressData>(parameters: ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>), options?: Omit<UndefinedInitialDataOptions<LessonQuizProgressData, LessonQuizProgressError, TData, ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>>, "queryKey">): UseQueryResult<TData, OperationError<LessonQuizProgressError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonQuizProgress.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonQuizProgressData>(parameters: ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>), options: Omit<DefinedInitialDataOptions<LessonQuizProgressData, LessonQuizProgressError, TData, ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<LessonQuizProgressError>>;
        /** @summary Lesson Quiz Progress */
        getInfiniteQueryKey(parameters: DeepReadonly<LessonQuizProgressParameters>): ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuizProgress.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonQuizProgressParameters, TQueryFnData = LessonQuizProgressData, TData = OperationInfiniteData<TQueryFnData, LessonQuizProgressParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, LessonQuizProgressError, TData, ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<LessonQuizProgressError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuizProgress.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonQuizProgressParameters, TQueryFnData = LessonQuizProgressData, TData = OperationInfiniteData<TQueryFnData, LessonQuizProgressParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, LessonQuizProgressError, TData, ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonQuizProgressData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<LessonQuizProgressError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const lessonQuizProgressTotal = qraft.v3Service.lessonQuizProgress.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const lessonQuizProgressByParametersTotal = qraft.v3Service.lessonQuizProgress.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError> | QueryFiltersByQueryKey<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const lessonQuizProgressResults = qraft.v3Service.lessonQuizProgress.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuizProgressResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const lessonQuizProgressCombinedResults = qraft.v3Service.lessonQuizProgress.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuizProgressCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<LessonQuizProgressSchema, LessonQuizProgressParameters, LessonQuizProgressData, LessonQuizProgressError>>, TCombinedResult = Array<UseQueryResult<LessonQuizProgressData, LessonQuizProgressError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<LessonQuizProgressData, LessonQuizProgressError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.lessonQuizProgress.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = LessonQuizProgressData>(parameters: ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>), options?: Omit<UseSuspenseQueryOptions<LessonQuizProgressData, LessonQuizProgressError, TData, ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<LessonQuizProgressError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuizProgress.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends LessonQuizProgressParameters, TData = LessonQuizProgressData>(parameters: ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<LessonQuizProgressData, LessonQuizProgressError, OperationInfiniteData<TData, LessonQuizProgressParameters>, ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonQuizProgressData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, LessonQuizProgressParameters>, OperationError<LessonQuizProgressError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Lesson Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const lessonQuizProgressData = qraft.v3Service.lessonQuizProgress.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuizProgressResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const lessonQuizProgressCombinedData = qraft.v3Service.lessonQuizProgress.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuizProgressCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<LessonQuizProgressSchema, LessonQuizProgressParameters, LessonQuizProgressData, LessonQuizProgressError>>, TCombinedResult = Array<UseSuspenseQueryResult<LessonQuizProgressData, LessonQuizProgressError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<LessonQuizProgressData, LessonQuizProgressError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Lesson Quiz Progress */
        fetchQuery(options: ServiceOperationFetchQueryOptions<LessonQuizProgressSchema, LessonQuizProgressData, LessonQuizProgressParameters, LessonQuizProgressError>): Promise<LessonQuizProgressData>;
        /** @summary Lesson Quiz Progress */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<LessonQuizProgressSchema, LessonQuizProgressData, LessonQuizProgressParameters, LessonQuizProgressError>): Promise<void>;
        /** @summary Lesson Quiz Progress */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<LessonQuizProgressSchema, LessonQuizProgressData, LessonQuizProgressParameters, LessonQuizProgressError>): Promise<LessonQuizProgressData>;
        /** @summary Lesson Quiz Progress */
        fetchInfiniteQuery<TPageParam extends LessonQuizProgressParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonQuizProgressSchema, LessonQuizProgressData, LessonQuizProgressParameters, DeepReadonly<TPageParam>, LessonQuizProgressError>): Promise<OperationInfiniteData<LessonQuizProgressData, LessonQuizProgressParameters>>;
        /** @summary Lesson Quiz Progress */
        prefetchInfiniteQuery<TPageParam extends LessonQuizProgressParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonQuizProgressSchema, LessonQuizProgressData, LessonQuizProgressParameters, DeepReadonly<TPageParam>, LessonQuizProgressError>): Promise<void>;
        /** @summary Lesson Quiz Progress */
        ensureInfiniteQueryData<TPageParam extends LessonQuizProgressParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<LessonQuizProgressSchema, LessonQuizProgressData, LessonQuizProgressParameters, DeepReadonly<TPageParam>, LessonQuizProgressError>): Promise<OperationInfiniteData<LessonQuizProgressData, LessonQuizProgressParameters>>;
        /** @summary Lesson Quiz Progress */
        getQueryData(parameters: ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>)): LessonQuizProgressData | undefined;
        /** @summary Lesson Quiz Progress */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>)): OperationInfiniteData<LessonQuizProgressData, LessonQuizProgressParameters> | undefined;
        /** @summary Lesson Quiz Progress */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError> | QueryFiltersByQueryKey<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>,
            data: NoInfer<OperationInfiniteData<LessonQuizProgressData, LessonQuizProgressParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>,
            data: LessonQuizProgressData | undefined
        ]>;
        /** @summary Lesson Quiz Progress */
        getQueryState(parameters: ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters> | (DeepReadonly<LessonQuizProgressParameters>)): QueryState<LessonQuizProgressData, LessonQuizProgressError> | undefined;
        /** @summary Lesson Quiz Progress */
        getInfiniteQueryState(parameters: DeepReadonly<LessonQuizProgressParameters> | ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>): QueryState<OperationInfiniteData<LessonQuizProgressData, LessonQuizProgressParameters>, LessonQuizProgressError> | undefined;
        /** @summary Lesson Quiz Progress */
        setQueryData(parameters: (DeepReadonly<LessonQuizProgressParameters>) | ServiceOperationQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>, updater: Updater<NoInfer<LessonQuizProgressData> | undefined, NoInfer<DeepReadonly<LessonQuizProgressData>> | undefined>, options?: SetDataOptions): LessonQuizProgressData | undefined;
        /** @summary Lesson Quiz Progress */
        setInfiniteQueryData(parameters: (DeepReadonly<LessonQuizProgressParameters>) | ServiceOperationInfiniteQueryKey<LessonQuizProgressSchema, LessonQuizProgressParameters>, updater: Updater<NoInfer<OperationInfiniteData<LessonQuizProgressData, LessonQuizProgressParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<LessonQuizProgressData, LessonQuizProgressParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<LessonQuizProgressData, LessonQuizProgressParameters> | undefined;
        /** @summary Lesson Quiz Progress */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError> | QueryFiltersByQueryKey<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>, updater: Updater<NoInfer<LessonQuizProgressData> | undefined, NoInfer<LessonQuizProgressData> | undefined>, options?: SetDataOptions): Array<LessonQuizProgressData | undefined>;
        /** @summary Lesson Quiz Progress */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Lesson Quiz Progress */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError> | QueryFiltersByQueryKey<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>, options?: RefetchOptions): Promise<void>;
        /** @summary Lesson Quiz Progress */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError> | QueryFiltersByQueryKey<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>, options?: CancelOptions): Promise<void>;
        /** @summary Lesson Quiz Progress */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError> | QueryFiltersByQueryKey<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>): void;
        /** @summary Lesson Quiz Progress */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError> | QueryFiltersByQueryKey<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>, options?: ResetOptions): Promise<void>;
        /** @summary Lesson Quiz Progress */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError> | QueryFiltersByQueryKey<LessonQuizProgressSchema, LessonQuizProgressData, TInfinite, LessonQuizProgressParameters, LessonQuizProgressError>): number;
        schema: LessonQuizProgressSchema;
        types: {
            parameters: LessonQuizProgressParameters;
            data: LessonQuizProgressData;
            error: LessonQuizProgressError;
        };
    };
    /** @summary Submit Topic Quiz */
    submitTopicQuiz: {
        /** @summary Submit Topic Quiz */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SubmitTopicQuizBody, SubmitTopicQuizParameters, TMeta, TSignal>, client?: (schema: SubmitTopicQuizSchema, options: ServiceOperationMutationFnOptions<SubmitTopicQuizBody, SubmitTopicQuizParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SubmitTopicQuizData, SubmitTopicQuizError>>): Promise<RequestFnResponse<SubmitTopicQuizData, SubmitTopicQuizError>>;
        /** @summary Submit Topic Quiz */
        getMutationKey(parameters: DeepReadonly<SubmitTopicQuizParameters> | void): ServiceOperationMutationKey<SubmitTopicQuizSchema, SubmitTopicQuizParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Topic Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitTopicQuiz.useMutation({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitTopicQuiz.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SubmitTopicQuizBody, TContext = unknown>(parameters: DeepReadonly<SubmitTopicQuizParameters>, options?: ServiceOperationUseMutationOptions<SubmitTopicQuizSchema, SubmitTopicQuizData, SubmitTopicQuizParameters, TVariables, OperationError<SubmitTopicQuizError>, TContext>): UseMutationResult<SubmitTopicQuizData, OperationError<SubmitTopicQuizError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Topic Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitTopicQuiz.useMutation({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.submitTopicQuiz.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SubmitTopicQuizBody, SubmitTopicQuizParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SubmitTopicQuizSchema, SubmitTopicQuizData, SubmitTopicQuizParameters, TVariables, OperationError<SubmitTopicQuizError>, TContext>): UseMutationResult<SubmitTopicQuizData, OperationError<SubmitTopicQuizError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Submit Topic Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const submitTopicQuizTotal = qraft.v3Service.submitTopicQuiz.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const submitTopicQuizTotal = qraft.v3Service.submitTopicQuiz.useIsMutating({
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext> | MutationFiltersByMutationKey<SubmitTopicQuizSchema, SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Submit Topic Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const submitTopicQuizPendingMutationVariables = qraft.v3Service.submitTopicQuiz.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const submitTopicQuizMutationData = qraft.v3Service.submitTopicQuiz.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 topic_id: topicId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SubmitTopicQuizData, OperationError<SubmitTopicQuizError>, MutationVariables<SubmitTopicQuizBody, SubmitTopicQuizParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext> | MutationFiltersByMutationKey<SubmitTopicQuizSchema, SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext>;
            select?: (mutation: Mutation<SubmitTopicQuizData, OperationError<SubmitTopicQuizError>, MutationVariables<SubmitTopicQuizBody, SubmitTopicQuizParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Submit Topic Quiz */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext> | MutationFiltersByMutationKey<SubmitTopicQuizSchema, SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Submit Topic Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.submitTopicQuiz.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.submitTopicQuiz.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext> | MutationFiltersByMutationKey<SubmitTopicQuizSchema, SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext>): Mutation<SubmitTopicQuizData, SubmitTopicQuizError, MutationVariables<SubmitTopicQuizBody, SubmitTopicQuizParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext> | MutationFiltersByMutationKey<SubmitTopicQuizSchema, SubmitTopicQuizBody, SubmitTopicQuizData, SubmitTopicQuizParameters, OperationError<SubmitTopicQuizError>, TContext>): Array<Mutation<SubmitTopicQuizData, SubmitTopicQuizError, MutationVariables<SubmitTopicQuizBody, SubmitTopicQuizParameters>, TContext>>;
        };
        schema: SubmitTopicQuizSchema;
        types: {
            parameters: SubmitTopicQuizParameters;
            data: SubmitTopicQuizData;
            error: SubmitTopicQuizError;
            body: SubmitTopicQuizBody;
        };
    };
    /** @summary Topic Quiz Progress */
    topicQuizProgress: {
        /** @summary Topic Quiz Progress */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<TopicQuizProgressParameters, TMeta, TSignal>), client?: (schema: TopicQuizProgressSchema, options: {
            parameters: TopicQuizProgressParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<TopicQuizProgressData, TopicQuizProgressError>>): Promise<RequestFnResponse<TopicQuizProgressData, TopicQuizProgressError>>;
        /** @summary Topic Quiz Progress */
        getQueryKey(parameters: DeepReadonly<TopicQuizProgressParameters>): ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.topicQuizProgress.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = TopicQuizProgressData>(parameters: ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>), options?: Omit<UndefinedInitialDataOptions<TopicQuizProgressData, TopicQuizProgressError, TData, ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>>, "queryKey">): UseQueryResult<TData, OperationError<TopicQuizProgressError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.topicQuizProgress.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = TopicQuizProgressData>(parameters: ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>), options: Omit<DefinedInitialDataOptions<TopicQuizProgressData, TopicQuizProgressError, TData, ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<TopicQuizProgressError>>;
        /** @summary Topic Quiz Progress */
        getInfiniteQueryKey(parameters: DeepReadonly<TopicQuizProgressParameters>): ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicQuizProgress.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TopicQuizProgressParameters, TQueryFnData = TopicQuizProgressData, TData = OperationInfiniteData<TQueryFnData, TopicQuizProgressParameters>>(parameters: ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, TopicQuizProgressError, TData, ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<TopicQuizProgressError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicQuizProgress.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TopicQuizProgressParameters, TQueryFnData = TopicQuizProgressData, TData = OperationInfiniteData<TQueryFnData, TopicQuizProgressParameters>>(parameters: ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, TopicQuizProgressError, TData, ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TopicQuizProgressData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<TopicQuizProgressError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const topicQuizProgressTotal = qraft.v3Service.topicQuizProgress.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const topicQuizProgressByParametersTotal = qraft.v3Service.topicQuizProgress.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError> | QueryFiltersByQueryKey<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const topicQuizProgressResults = qraft.v3Service.topicQuizProgress.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicQuizProgressResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const topicQuizProgressCombinedResults = qraft.v3Service.topicQuizProgress.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicQuizProgressCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<TopicQuizProgressSchema, TopicQuizProgressParameters, TopicQuizProgressData, TopicQuizProgressError>>, TCombinedResult = Array<UseQueryResult<TopicQuizProgressData, TopicQuizProgressError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<TopicQuizProgressData, TopicQuizProgressError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.topicQuizProgress.useSuspenseQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = TopicQuizProgressData>(parameters: ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>), options?: Omit<UseSuspenseQueryOptions<TopicQuizProgressData, TopicQuizProgressError, TData, ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<TopicQuizProgressError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicQuizProgress.useSuspenseInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends TopicQuizProgressParameters, TData = TopicQuizProgressData>(parameters: ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<TopicQuizProgressData, TopicQuizProgressError, OperationInfiniteData<TData, TopicQuizProgressParameters>, ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TopicQuizProgressData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, TopicQuizProgressParameters>, OperationError<TopicQuizProgressError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Topic Quiz Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const topicQuizProgressData = qraft.v3Service.topicQuizProgress.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicQuizProgressResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const topicQuizProgressCombinedData = qraft.v3Service.topicQuizProgress.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicQuizProgressCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<TopicQuizProgressSchema, TopicQuizProgressParameters, TopicQuizProgressData, TopicQuizProgressError>>, TCombinedResult = Array<UseSuspenseQueryResult<TopicQuizProgressData, TopicQuizProgressError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<TopicQuizProgressData, TopicQuizProgressError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Topic Quiz Progress */
        fetchQuery(options: ServiceOperationFetchQueryOptions<TopicQuizProgressSchema, TopicQuizProgressData, TopicQuizProgressParameters, TopicQuizProgressError>): Promise<TopicQuizProgressData>;
        /** @summary Topic Quiz Progress */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<TopicQuizProgressSchema, TopicQuizProgressData, TopicQuizProgressParameters, TopicQuizProgressError>): Promise<void>;
        /** @summary Topic Quiz Progress */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<TopicQuizProgressSchema, TopicQuizProgressData, TopicQuizProgressParameters, TopicQuizProgressError>): Promise<TopicQuizProgressData>;
        /** @summary Topic Quiz Progress */
        fetchInfiniteQuery<TPageParam extends TopicQuizProgressParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TopicQuizProgressSchema, TopicQuizProgressData, TopicQuizProgressParameters, DeepReadonly<TPageParam>, TopicQuizProgressError>): Promise<OperationInfiniteData<TopicQuizProgressData, TopicQuizProgressParameters>>;
        /** @summary Topic Quiz Progress */
        prefetchInfiniteQuery<TPageParam extends TopicQuizProgressParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TopicQuizProgressSchema, TopicQuizProgressData, TopicQuizProgressParameters, DeepReadonly<TPageParam>, TopicQuizProgressError>): Promise<void>;
        /** @summary Topic Quiz Progress */
        ensureInfiniteQueryData<TPageParam extends TopicQuizProgressParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<TopicQuizProgressSchema, TopicQuizProgressData, TopicQuizProgressParameters, DeepReadonly<TPageParam>, TopicQuizProgressError>): Promise<OperationInfiniteData<TopicQuizProgressData, TopicQuizProgressParameters>>;
        /** @summary Topic Quiz Progress */
        getQueryData(parameters: ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>)): TopicQuizProgressData | undefined;
        /** @summary Topic Quiz Progress */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>)): OperationInfiniteData<TopicQuizProgressData, TopicQuizProgressParameters> | undefined;
        /** @summary Topic Quiz Progress */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError> | QueryFiltersByQueryKey<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>,
            data: NoInfer<OperationInfiniteData<TopicQuizProgressData, TopicQuizProgressParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>,
            data: TopicQuizProgressData | undefined
        ]>;
        /** @summary Topic Quiz Progress */
        getQueryState(parameters: ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters> | (DeepReadonly<TopicQuizProgressParameters>)): QueryState<TopicQuizProgressData, TopicQuizProgressError> | undefined;
        /** @summary Topic Quiz Progress */
        getInfiniteQueryState(parameters: DeepReadonly<TopicQuizProgressParameters> | ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>): QueryState<OperationInfiniteData<TopicQuizProgressData, TopicQuizProgressParameters>, TopicQuizProgressError> | undefined;
        /** @summary Topic Quiz Progress */
        setQueryData(parameters: (DeepReadonly<TopicQuizProgressParameters>) | ServiceOperationQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>, updater: Updater<NoInfer<TopicQuizProgressData> | undefined, NoInfer<DeepReadonly<TopicQuizProgressData>> | undefined>, options?: SetDataOptions): TopicQuizProgressData | undefined;
        /** @summary Topic Quiz Progress */
        setInfiniteQueryData(parameters: (DeepReadonly<TopicQuizProgressParameters>) | ServiceOperationInfiniteQueryKey<TopicQuizProgressSchema, TopicQuizProgressParameters>, updater: Updater<NoInfer<OperationInfiniteData<TopicQuizProgressData, TopicQuizProgressParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<TopicQuizProgressData, TopicQuizProgressParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<TopicQuizProgressData, TopicQuizProgressParameters> | undefined;
        /** @summary Topic Quiz Progress */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError> | QueryFiltersByQueryKey<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>, updater: Updater<NoInfer<TopicQuizProgressData> | undefined, NoInfer<TopicQuizProgressData> | undefined>, options?: SetDataOptions): Array<TopicQuizProgressData | undefined>;
        /** @summary Topic Quiz Progress */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Topic Quiz Progress */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError> | QueryFiltersByQueryKey<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>, options?: RefetchOptions): Promise<void>;
        /** @summary Topic Quiz Progress */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError> | QueryFiltersByQueryKey<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>, options?: CancelOptions): Promise<void>;
        /** @summary Topic Quiz Progress */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError> | QueryFiltersByQueryKey<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>): void;
        /** @summary Topic Quiz Progress */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError> | QueryFiltersByQueryKey<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>, options?: ResetOptions): Promise<void>;
        /** @summary Topic Quiz Progress */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError> | QueryFiltersByQueryKey<TopicQuizProgressSchema, TopicQuizProgressData, TInfinite, TopicQuizProgressParameters, TopicQuizProgressError>): number;
        schema: TopicQuizProgressSchema;
        types: {
            parameters: TopicQuizProgressParameters;
            data: TopicQuizProgressData;
            error: TopicQuizProgressError;
        };
    };
    /** @summary Read Lesson Quiz Result */
    lessonQuizResult: {
        /** @summary Read Lesson Quiz Result */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<LessonQuizResultSchema, LessonQuizResultParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<LessonQuizResultParameters, TMeta, TSignal>), client?: (schema: LessonQuizResultSchema, options: {
            parameters: LessonQuizResultParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<LessonQuizResultData, LessonQuizResultError>>): Promise<RequestFnResponse<LessonQuizResultData, LessonQuizResultError>>;
        /** @summary Read Lesson Quiz Result */
        getQueryKey(parameters: DeepReadonly<LessonQuizResultParameters>): ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonQuizResult.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonQuizResultData>(parameters: ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>), options?: Omit<UndefinedInitialDataOptions<LessonQuizResultData, LessonQuizResultError, TData, ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>>, "queryKey">): UseQueryResult<TData, OperationError<LessonQuizResultError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.lessonQuizResult.useQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = LessonQuizResultData>(parameters: ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>), options: Omit<DefinedInitialDataOptions<LessonQuizResultData, LessonQuizResultError, TData, ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<LessonQuizResultError>>;
        /** @summary Read Lesson Quiz Result */
        getInfiniteQueryKey(parameters: DeepReadonly<LessonQuizResultParameters>): ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuizResult.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonQuizResultParameters, TQueryFnData = LessonQuizResultData, TData = OperationInfiniteData<TQueryFnData, LessonQuizResultParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, LessonQuizResultError, TData, ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<LessonQuizResultError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuizResult.useInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends LessonQuizResultParameters, TQueryFnData = LessonQuizResultData, TData = OperationInfiniteData<TQueryFnData, LessonQuizResultParameters>>(parameters: ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, LessonQuizResultError, TData, ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonQuizResultData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<LessonQuizResultError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const lessonQuizResultTotal = qraft.v3Service.lessonQuizResult.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const lessonQuizResultByParametersTotal = qraft.v3Service.lessonQuizResult.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError> | QueryFiltersByQueryKey<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const lessonQuizResultResults = qraft.v3Service.lessonQuizResult.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuizResultResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const lessonQuizResultCombinedResults = qraft.v3Service.lessonQuizResult.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuizResultCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<LessonQuizResultSchema, LessonQuizResultParameters, LessonQuizResultData, LessonQuizResultError>>, TCombinedResult = Array<UseQueryResult<LessonQuizResultData, LessonQuizResultError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<LessonQuizResultData, LessonQuizResultError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.lessonQuizResult.useSuspenseQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = LessonQuizResultData>(parameters: ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>), options?: Omit<UseSuspenseQueryOptions<LessonQuizResultData, LessonQuizResultError, TData, ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<LessonQuizResultError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.lessonQuizResult.useSuspenseInfiniteQuery({
         *     path: {
         *         lesson_id: lessonId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends LessonQuizResultParameters, TData = LessonQuizResultData>(parameters: ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<LessonQuizResultData, LessonQuizResultError, OperationInfiniteData<TData, LessonQuizResultParameters>, ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<LessonQuizResultData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, LessonQuizResultParameters>, OperationError<LessonQuizResultError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Read Lesson Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const lessonQuizResultData = qraft.v3Service.lessonQuizResult.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuizResultResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const lessonQuizResultCombinedData = qraft.v3Service.lessonQuizResult.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 lesson_id: lessonId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 lesson_id: lessonId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * lessonQuizResultCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<LessonQuizResultSchema, LessonQuizResultParameters, LessonQuizResultData, LessonQuizResultError>>, TCombinedResult = Array<UseSuspenseQueryResult<LessonQuizResultData, LessonQuizResultError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<LessonQuizResultData, LessonQuizResultError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Read Lesson Quiz Result */
        fetchQuery(options: ServiceOperationFetchQueryOptions<LessonQuizResultSchema, LessonQuizResultData, LessonQuizResultParameters, LessonQuizResultError>): Promise<LessonQuizResultData>;
        /** @summary Read Lesson Quiz Result */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<LessonQuizResultSchema, LessonQuizResultData, LessonQuizResultParameters, LessonQuizResultError>): Promise<void>;
        /** @summary Read Lesson Quiz Result */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<LessonQuizResultSchema, LessonQuizResultData, LessonQuizResultParameters, LessonQuizResultError>): Promise<LessonQuizResultData>;
        /** @summary Read Lesson Quiz Result */
        fetchInfiniteQuery<TPageParam extends LessonQuizResultParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonQuizResultSchema, LessonQuizResultData, LessonQuizResultParameters, DeepReadonly<TPageParam>, LessonQuizResultError>): Promise<OperationInfiniteData<LessonQuizResultData, LessonQuizResultParameters>>;
        /** @summary Read Lesson Quiz Result */
        prefetchInfiniteQuery<TPageParam extends LessonQuizResultParameters>(options: ServiceOperationFetchInfiniteQueryOptions<LessonQuizResultSchema, LessonQuizResultData, LessonQuizResultParameters, DeepReadonly<TPageParam>, LessonQuizResultError>): Promise<void>;
        /** @summary Read Lesson Quiz Result */
        ensureInfiniteQueryData<TPageParam extends LessonQuizResultParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<LessonQuizResultSchema, LessonQuizResultData, LessonQuizResultParameters, DeepReadonly<TPageParam>, LessonQuizResultError>): Promise<OperationInfiniteData<LessonQuizResultData, LessonQuizResultParameters>>;
        /** @summary Read Lesson Quiz Result */
        getQueryData(parameters: ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>)): LessonQuizResultData | undefined;
        /** @summary Read Lesson Quiz Result */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>)): OperationInfiniteData<LessonQuizResultData, LessonQuizResultParameters> | undefined;
        /** @summary Read Lesson Quiz Result */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError> | QueryFiltersByQueryKey<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>,
            data: NoInfer<OperationInfiniteData<LessonQuizResultData, LessonQuizResultParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>,
            data: LessonQuizResultData | undefined
        ]>;
        /** @summary Read Lesson Quiz Result */
        getQueryState(parameters: ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters> | (DeepReadonly<LessonQuizResultParameters>)): QueryState<LessonQuizResultData, LessonQuizResultError> | undefined;
        /** @summary Read Lesson Quiz Result */
        getInfiniteQueryState(parameters: DeepReadonly<LessonQuizResultParameters> | ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>): QueryState<OperationInfiniteData<LessonQuizResultData, LessonQuizResultParameters>, LessonQuizResultError> | undefined;
        /** @summary Read Lesson Quiz Result */
        setQueryData(parameters: (DeepReadonly<LessonQuizResultParameters>) | ServiceOperationQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>, updater: Updater<NoInfer<LessonQuizResultData> | undefined, NoInfer<DeepReadonly<LessonQuizResultData>> | undefined>, options?: SetDataOptions): LessonQuizResultData | undefined;
        /** @summary Read Lesson Quiz Result */
        setInfiniteQueryData(parameters: (DeepReadonly<LessonQuizResultParameters>) | ServiceOperationInfiniteQueryKey<LessonQuizResultSchema, LessonQuizResultParameters>, updater: Updater<NoInfer<OperationInfiniteData<LessonQuizResultData, LessonQuizResultParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<LessonQuizResultData, LessonQuizResultParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<LessonQuizResultData, LessonQuizResultParameters> | undefined;
        /** @summary Read Lesson Quiz Result */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError> | QueryFiltersByQueryKey<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>, updater: Updater<NoInfer<LessonQuizResultData> | undefined, NoInfer<LessonQuizResultData> | undefined>, options?: SetDataOptions): Array<LessonQuizResultData | undefined>;
        /** @summary Read Lesson Quiz Result */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Read Lesson Quiz Result */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError> | QueryFiltersByQueryKey<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>, options?: RefetchOptions): Promise<void>;
        /** @summary Read Lesson Quiz Result */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError> | QueryFiltersByQueryKey<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>, options?: CancelOptions): Promise<void>;
        /** @summary Read Lesson Quiz Result */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError> | QueryFiltersByQueryKey<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>): void;
        /** @summary Read Lesson Quiz Result */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError> | QueryFiltersByQueryKey<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>, options?: ResetOptions): Promise<void>;
        /** @summary Read Lesson Quiz Result */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError> | QueryFiltersByQueryKey<LessonQuizResultSchema, LessonQuizResultData, TInfinite, LessonQuizResultParameters, LessonQuizResultError>): number;
        schema: LessonQuizResultSchema;
        types: {
            parameters: LessonQuizResultParameters;
            data: LessonQuizResultData;
            error: LessonQuizResultError;
        };
    };
    /** @summary Read Topic Quiz Result */
    topicQuizResult: {
        /** @summary Read Topic Quiz Result */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<TopicQuizResultSchema, TopicQuizResultParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<TopicQuizResultParameters, TMeta, TSignal>), client?: (schema: TopicQuizResultSchema, options: {
            parameters: TopicQuizResultParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<TopicQuizResultData, TopicQuizResultError>>): Promise<RequestFnResponse<TopicQuizResultData, TopicQuizResultError>>;
        /** @summary Read Topic Quiz Result */
        getQueryKey(parameters: DeepReadonly<TopicQuizResultParameters>): ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.topicQuizResult.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = TopicQuizResultData>(parameters: ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>), options?: Omit<UndefinedInitialDataOptions<TopicQuizResultData, TopicQuizResultError, TData, ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>>, "queryKey">): UseQueryResult<TData, OperationError<TopicQuizResultError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.topicQuizResult.useQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = TopicQuizResultData>(parameters: ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>), options: Omit<DefinedInitialDataOptions<TopicQuizResultData, TopicQuizResultError, TData, ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<TopicQuizResultError>>;
        /** @summary Read Topic Quiz Result */
        getInfiniteQueryKey(parameters: DeepReadonly<TopicQuizResultParameters>): ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicQuizResult.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TopicQuizResultParameters, TQueryFnData = TopicQuizResultData, TData = OperationInfiniteData<TQueryFnData, TopicQuizResultParameters>>(parameters: ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, TopicQuizResultError, TData, ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<TopicQuizResultError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicQuizResult.useInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TopicQuizResultParameters, TQueryFnData = TopicQuizResultData, TData = OperationInfiniteData<TQueryFnData, TopicQuizResultParameters>>(parameters: ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, TopicQuizResultError, TData, ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TopicQuizResultData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<TopicQuizResultError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const topicQuizResultTotal = qraft.v3Service.topicQuizResult.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const topicQuizResultByParametersTotal = qraft.v3Service.topicQuizResult.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             topic_id: topicId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError> | QueryFiltersByQueryKey<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const topicQuizResultResults = qraft.v3Service.topicQuizResult.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicQuizResultResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const topicQuizResultCombinedResults = qraft.v3Service.topicQuizResult.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicQuizResultCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<TopicQuizResultSchema, TopicQuizResultParameters, TopicQuizResultData, TopicQuizResultError>>, TCombinedResult = Array<UseQueryResult<TopicQuizResultData, TopicQuizResultError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<TopicQuizResultData, TopicQuizResultError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.topicQuizResult.useSuspenseQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = TopicQuizResultData>(parameters: ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>), options?: Omit<UseSuspenseQueryOptions<TopicQuizResultData, TopicQuizResultError, TData, ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<TopicQuizResultError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.topicQuizResult.useSuspenseInfiniteQuery({
         *     path: {
         *         topic_id: topicId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends TopicQuizResultParameters, TData = TopicQuizResultData>(parameters: ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<TopicQuizResultData, TopicQuizResultError, OperationInfiniteData<TData, TopicQuizResultParameters>, ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TopicQuizResultData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, TopicQuizResultParameters>, OperationError<TopicQuizResultError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Read Topic Quiz Result
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const topicQuizResultData = qraft.v3Service.topicQuizResult.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicQuizResultResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const topicQuizResultCombinedData = qraft.v3Service.topicQuizResult.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 topic_id: topicId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 topic_id: topicId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * topicQuizResultCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<TopicQuizResultSchema, TopicQuizResultParameters, TopicQuizResultData, TopicQuizResultError>>, TCombinedResult = Array<UseSuspenseQueryResult<TopicQuizResultData, TopicQuizResultError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<TopicQuizResultData, TopicQuizResultError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Read Topic Quiz Result */
        fetchQuery(options: ServiceOperationFetchQueryOptions<TopicQuizResultSchema, TopicQuizResultData, TopicQuizResultParameters, TopicQuizResultError>): Promise<TopicQuizResultData>;
        /** @summary Read Topic Quiz Result */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<TopicQuizResultSchema, TopicQuizResultData, TopicQuizResultParameters, TopicQuizResultError>): Promise<void>;
        /** @summary Read Topic Quiz Result */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<TopicQuizResultSchema, TopicQuizResultData, TopicQuizResultParameters, TopicQuizResultError>): Promise<TopicQuizResultData>;
        /** @summary Read Topic Quiz Result */
        fetchInfiniteQuery<TPageParam extends TopicQuizResultParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TopicQuizResultSchema, TopicQuizResultData, TopicQuizResultParameters, DeepReadonly<TPageParam>, TopicQuizResultError>): Promise<OperationInfiniteData<TopicQuizResultData, TopicQuizResultParameters>>;
        /** @summary Read Topic Quiz Result */
        prefetchInfiniteQuery<TPageParam extends TopicQuizResultParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TopicQuizResultSchema, TopicQuizResultData, TopicQuizResultParameters, DeepReadonly<TPageParam>, TopicQuizResultError>): Promise<void>;
        /** @summary Read Topic Quiz Result */
        ensureInfiniteQueryData<TPageParam extends TopicQuizResultParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<TopicQuizResultSchema, TopicQuizResultData, TopicQuizResultParameters, DeepReadonly<TPageParam>, TopicQuizResultError>): Promise<OperationInfiniteData<TopicQuizResultData, TopicQuizResultParameters>>;
        /** @summary Read Topic Quiz Result */
        getQueryData(parameters: ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>)): TopicQuizResultData | undefined;
        /** @summary Read Topic Quiz Result */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>)): OperationInfiniteData<TopicQuizResultData, TopicQuizResultParameters> | undefined;
        /** @summary Read Topic Quiz Result */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError> | QueryFiltersByQueryKey<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>,
            data: NoInfer<OperationInfiniteData<TopicQuizResultData, TopicQuizResultParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>,
            data: TopicQuizResultData | undefined
        ]>;
        /** @summary Read Topic Quiz Result */
        getQueryState(parameters: ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters> | (DeepReadonly<TopicQuizResultParameters>)): QueryState<TopicQuizResultData, TopicQuizResultError> | undefined;
        /** @summary Read Topic Quiz Result */
        getInfiniteQueryState(parameters: DeepReadonly<TopicQuizResultParameters> | ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>): QueryState<OperationInfiniteData<TopicQuizResultData, TopicQuizResultParameters>, TopicQuizResultError> | undefined;
        /** @summary Read Topic Quiz Result */
        setQueryData(parameters: (DeepReadonly<TopicQuizResultParameters>) | ServiceOperationQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>, updater: Updater<NoInfer<TopicQuizResultData> | undefined, NoInfer<DeepReadonly<TopicQuizResultData>> | undefined>, options?: SetDataOptions): TopicQuizResultData | undefined;
        /** @summary Read Topic Quiz Result */
        setInfiniteQueryData(parameters: (DeepReadonly<TopicQuizResultParameters>) | ServiceOperationInfiniteQueryKey<TopicQuizResultSchema, TopicQuizResultParameters>, updater: Updater<NoInfer<OperationInfiniteData<TopicQuizResultData, TopicQuizResultParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<TopicQuizResultData, TopicQuizResultParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<TopicQuizResultData, TopicQuizResultParameters> | undefined;
        /** @summary Read Topic Quiz Result */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError> | QueryFiltersByQueryKey<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>, updater: Updater<NoInfer<TopicQuizResultData> | undefined, NoInfer<TopicQuizResultData> | undefined>, options?: SetDataOptions): Array<TopicQuizResultData | undefined>;
        /** @summary Read Topic Quiz Result */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Read Topic Quiz Result */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError> | QueryFiltersByQueryKey<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>, options?: RefetchOptions): Promise<void>;
        /** @summary Read Topic Quiz Result */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError> | QueryFiltersByQueryKey<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>, options?: CancelOptions): Promise<void>;
        /** @summary Read Topic Quiz Result */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError> | QueryFiltersByQueryKey<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>): void;
        /** @summary Read Topic Quiz Result */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError> | QueryFiltersByQueryKey<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>, options?: ResetOptions): Promise<void>;
        /** @summary Read Topic Quiz Result */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError> | QueryFiltersByQueryKey<TopicQuizResultSchema, TopicQuizResultData, TInfinite, TopicQuizResultParameters, TopicQuizResultError>): number;
        schema: TopicQuizResultSchema;
        types: {
            parameters: TopicQuizResultParameters;
            data: TopicQuizResultData;
            error: TopicQuizResultError;
        };
    };
    /** @summary Read Course Viewer State */
    courseViewerState: {
        /** @summary Read Course Viewer State */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<CourseViewerStateSchema, CourseViewerStateParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<CourseViewerStateParameters, TMeta, TSignal>), client?: (schema: CourseViewerStateSchema, options: {
            parameters: CourseViewerStateParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<CourseViewerStateData, CourseViewerStateError>>): Promise<RequestFnResponse<CourseViewerStateData, CourseViewerStateError>>;
        /** @summary Read Course Viewer State */
        getQueryKey(parameters: DeepReadonly<CourseViewerStateParameters>): ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseViewerState.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseViewerStateData>(parameters: ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>), options?: Omit<UndefinedInitialDataOptions<CourseViewerStateData, CourseViewerStateError, TData, ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>>, "queryKey">): UseQueryResult<TData, OperationError<CourseViewerStateError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseViewerState.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseViewerStateData>(parameters: ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>), options: Omit<DefinedInitialDataOptions<CourseViewerStateData, CourseViewerStateError, TData, ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<CourseViewerStateError>>;
        /** @summary Read Course Viewer State */
        getInfiniteQueryKey(parameters: DeepReadonly<CourseViewerStateParameters>): ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseViewerState.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseViewerStateParameters, TQueryFnData = CourseViewerStateData, TData = OperationInfiniteData<TQueryFnData, CourseViewerStateParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, CourseViewerStateError, TData, ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<CourseViewerStateError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseViewerState.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseViewerStateParameters, TQueryFnData = CourseViewerStateData, TData = OperationInfiniteData<TQueryFnData, CourseViewerStateParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, CourseViewerStateError, TData, ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseViewerStateData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<CourseViewerStateError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const courseViewerStateTotal = qraft.v3Service.courseViewerState.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const courseViewerStateByParametersTotal = qraft.v3Service.courseViewerState.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError> | QueryFiltersByQueryKey<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const courseViewerStateResults = qraft.v3Service.courseViewerState.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseViewerStateResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const courseViewerStateCombinedResults = qraft.v3Service.courseViewerState.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseViewerStateCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<CourseViewerStateSchema, CourseViewerStateParameters, CourseViewerStateData, CourseViewerStateError>>, TCombinedResult = Array<UseQueryResult<CourseViewerStateData, CourseViewerStateError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<CourseViewerStateData, CourseViewerStateError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.courseViewerState.useSuspenseQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = CourseViewerStateData>(parameters: ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>), options?: Omit<UseSuspenseQueryOptions<CourseViewerStateData, CourseViewerStateError, TData, ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<CourseViewerStateError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseViewerState.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends CourseViewerStateParameters, TData = CourseViewerStateData>(parameters: ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<CourseViewerStateData, CourseViewerStateError, OperationInfiniteData<TData, CourseViewerStateParameters>, ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseViewerStateData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, CourseViewerStateParameters>, OperationError<CourseViewerStateError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Read Course Viewer State
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const courseViewerStateData = qraft.v3Service.courseViewerState.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseViewerStateResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const courseViewerStateCombinedData = qraft.v3Service.courseViewerState.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseViewerStateCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<CourseViewerStateSchema, CourseViewerStateParameters, CourseViewerStateData, CourseViewerStateError>>, TCombinedResult = Array<UseSuspenseQueryResult<CourseViewerStateData, CourseViewerStateError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<CourseViewerStateData, CourseViewerStateError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Read Course Viewer State */
        fetchQuery(options: ServiceOperationFetchQueryOptions<CourseViewerStateSchema, CourseViewerStateData, CourseViewerStateParameters, CourseViewerStateError>): Promise<CourseViewerStateData>;
        /** @summary Read Course Viewer State */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<CourseViewerStateSchema, CourseViewerStateData, CourseViewerStateParameters, CourseViewerStateError>): Promise<void>;
        /** @summary Read Course Viewer State */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<CourseViewerStateSchema, CourseViewerStateData, CourseViewerStateParameters, CourseViewerStateError>): Promise<CourseViewerStateData>;
        /** @summary Read Course Viewer State */
        fetchInfiniteQuery<TPageParam extends CourseViewerStateParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseViewerStateSchema, CourseViewerStateData, CourseViewerStateParameters, DeepReadonly<TPageParam>, CourseViewerStateError>): Promise<OperationInfiniteData<CourseViewerStateData, CourseViewerStateParameters>>;
        /** @summary Read Course Viewer State */
        prefetchInfiniteQuery<TPageParam extends CourseViewerStateParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseViewerStateSchema, CourseViewerStateData, CourseViewerStateParameters, DeepReadonly<TPageParam>, CourseViewerStateError>): Promise<void>;
        /** @summary Read Course Viewer State */
        ensureInfiniteQueryData<TPageParam extends CourseViewerStateParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<CourseViewerStateSchema, CourseViewerStateData, CourseViewerStateParameters, DeepReadonly<TPageParam>, CourseViewerStateError>): Promise<OperationInfiniteData<CourseViewerStateData, CourseViewerStateParameters>>;
        /** @summary Read Course Viewer State */
        getQueryData(parameters: ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>)): CourseViewerStateData | undefined;
        /** @summary Read Course Viewer State */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>)): OperationInfiniteData<CourseViewerStateData, CourseViewerStateParameters> | undefined;
        /** @summary Read Course Viewer State */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError> | QueryFiltersByQueryKey<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>,
            data: NoInfer<OperationInfiniteData<CourseViewerStateData, CourseViewerStateParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>,
            data: CourseViewerStateData | undefined
        ]>;
        /** @summary Read Course Viewer State */
        getQueryState(parameters: ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters> | (DeepReadonly<CourseViewerStateParameters>)): QueryState<CourseViewerStateData, CourseViewerStateError> | undefined;
        /** @summary Read Course Viewer State */
        getInfiniteQueryState(parameters: DeepReadonly<CourseViewerStateParameters> | ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>): QueryState<OperationInfiniteData<CourseViewerStateData, CourseViewerStateParameters>, CourseViewerStateError> | undefined;
        /** @summary Read Course Viewer State */
        setQueryData(parameters: (DeepReadonly<CourseViewerStateParameters>) | ServiceOperationQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>, updater: Updater<NoInfer<CourseViewerStateData> | undefined, NoInfer<DeepReadonly<CourseViewerStateData>> | undefined>, options?: SetDataOptions): CourseViewerStateData | undefined;
        /** @summary Read Course Viewer State */
        setInfiniteQueryData(parameters: (DeepReadonly<CourseViewerStateParameters>) | ServiceOperationInfiniteQueryKey<CourseViewerStateSchema, CourseViewerStateParameters>, updater: Updater<NoInfer<OperationInfiniteData<CourseViewerStateData, CourseViewerStateParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<CourseViewerStateData, CourseViewerStateParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<CourseViewerStateData, CourseViewerStateParameters> | undefined;
        /** @summary Read Course Viewer State */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError> | QueryFiltersByQueryKey<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>, updater: Updater<NoInfer<CourseViewerStateData> | undefined, NoInfer<CourseViewerStateData> | undefined>, options?: SetDataOptions): Array<CourseViewerStateData | undefined>;
        /** @summary Read Course Viewer State */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Read Course Viewer State */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError> | QueryFiltersByQueryKey<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>, options?: RefetchOptions): Promise<void>;
        /** @summary Read Course Viewer State */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError> | QueryFiltersByQueryKey<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>, options?: CancelOptions): Promise<void>;
        /** @summary Read Course Viewer State */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError> | QueryFiltersByQueryKey<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>): void;
        /** @summary Read Course Viewer State */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError> | QueryFiltersByQueryKey<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>, options?: ResetOptions): Promise<void>;
        /** @summary Read Course Viewer State */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError> | QueryFiltersByQueryKey<CourseViewerStateSchema, CourseViewerStateData, TInfinite, CourseViewerStateParameters, CourseViewerStateError>): number;
        schema: CourseViewerStateSchema;
        types: {
            parameters: CourseViewerStateParameters;
            data: CourseViewerStateData;
            error: CourseViewerStateError;
        };
    };
    /**
     * @summary Unlock Course
     * @description Self-join a course. The study-helper arm stays on fullapp.
     */
    unlockCourse: {
        /**
         * @summary Unlock Course
         * @description Self-join a course. The study-helper arm stays on fullapp.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UnlockCourseBody, UnlockCourseParameters, TMeta, TSignal>, client?: (schema: UnlockCourseSchema, options: ServiceOperationMutationFnOptions<UnlockCourseBody, UnlockCourseParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UnlockCourseData, UnlockCourseError>>): Promise<RequestFnResponse<UnlockCourseData, UnlockCourseError>>;
        /**
         * @summary Unlock Course
         * @description Self-join a course. The study-helper arm stays on fullapp.
         */
        getMutationKey(parameters: DeepReadonly<UnlockCourseParameters> | void): ServiceOperationMutationKey<UnlockCourseSchema, UnlockCourseParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Unlock Course
         * @description Self-join a course. The study-helper arm stays on fullapp.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockCourse.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockCourse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UnlockCourseBody, TContext = unknown>(parameters: DeepReadonly<UnlockCourseParameters>, options?: ServiceOperationUseMutationOptions<UnlockCourseSchema, UnlockCourseData, UnlockCourseParameters, TVariables, OperationError<UnlockCourseError>, TContext>): UseMutationResult<UnlockCourseData, OperationError<UnlockCourseError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Unlock Course
         * @description Self-join a course. The study-helper arm stays on fullapp.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockCourse.useMutation({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockCourse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UnlockCourseBody, UnlockCourseParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UnlockCourseSchema, UnlockCourseData, UnlockCourseParameters, TVariables, OperationError<UnlockCourseError>, TContext>): UseMutationResult<UnlockCourseData, OperationError<UnlockCourseError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Unlock Course
         * @description Self-join a course. The study-helper arm stays on fullapp.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const unlockCourseTotal = qraft.v3Service.unlockCourse.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const unlockCourseTotal = qraft.v3Service.unlockCourse.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext> | MutationFiltersByMutationKey<UnlockCourseSchema, UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Unlock Course
         * @description Self-join a course. The study-helper arm stays on fullapp.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const unlockCoursePendingMutationVariables = qraft.v3Service.unlockCourse.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const unlockCourseMutationData = qraft.v3Service.unlockCourse.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UnlockCourseData, OperationError<UnlockCourseError>, MutationVariables<UnlockCourseBody, UnlockCourseParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext> | MutationFiltersByMutationKey<UnlockCourseSchema, UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext>;
            select?: (mutation: Mutation<UnlockCourseData, OperationError<UnlockCourseError>, MutationVariables<UnlockCourseBody, UnlockCourseParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Unlock Course
         * @description Self-join a course. The study-helper arm stays on fullapp.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext> | MutationFiltersByMutationKey<UnlockCourseSchema, UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Unlock Course
         * @description Self-join a course. The study-helper arm stays on fullapp.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.unlockCourse.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.unlockCourse.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext> | MutationFiltersByMutationKey<UnlockCourseSchema, UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext>): Mutation<UnlockCourseData, UnlockCourseError, MutationVariables<UnlockCourseBody, UnlockCourseParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext> | MutationFiltersByMutationKey<UnlockCourseSchema, UnlockCourseBody, UnlockCourseData, UnlockCourseParameters, OperationError<UnlockCourseError>, TContext>): Array<Mutation<UnlockCourseData, UnlockCourseError, MutationVariables<UnlockCourseBody, UnlockCourseParameters>, TContext>>;
        };
        schema: UnlockCourseSchema;
        types: {
            parameters: UnlockCourseParameters;
            data: UnlockCourseData;
            error: UnlockCourseError;
            body: UnlockCourseBody;
        };
    };
    /** @summary Continue Study */
    continueStudy: {
        /** @summary Continue Study */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ContinueStudySchema, ContinueStudyParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ContinueStudyParameters, TMeta, TSignal> | void), client?: (schema: ContinueStudySchema, options: {
            parameters: ContinueStudyParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ContinueStudyData, ContinueStudyError>>): Promise<RequestFnResponse<ContinueStudyData, ContinueStudyError>>;
        /** @summary Continue Study */
        getQueryKey(parameters: DeepReadonly<ContinueStudyParameters> | void): ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.continueStudy.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.continueStudy.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ContinueStudyData>(parameters: ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void), options?: Omit<UndefinedInitialDataOptions<ContinueStudyData, ContinueStudyError, TData, ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ContinueStudyError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.continueStudy.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.continueStudy.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ContinueStudyData>(parameters: ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void), options: Omit<DefinedInitialDataOptions<ContinueStudyData, ContinueStudyError, TData, ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ContinueStudyError>>;
        /** @summary Continue Study */
        getInfiniteQueryKey(parameters: DeepReadonly<ContinueStudyParameters> | void): ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.continueStudy.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ContinueStudyParameters, TQueryFnData = ContinueStudyData, TData = OperationInfiniteData<TQueryFnData, ContinueStudyParameters>>(parameters: ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ContinueStudyError, TData, ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ContinueStudyError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.continueStudy.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ContinueStudyParameters, TQueryFnData = ContinueStudyData, TData = OperationInfiniteData<TQueryFnData, ContinueStudyParameters>>(parameters: ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ContinueStudyError, TData, ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ContinueStudyData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ContinueStudyError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const continueStudyTotal = qraft.v3Service.continueStudy.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const continueStudyByParametersTotal = qraft.v3Service.continueStudy.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError> | QueryFiltersByQueryKey<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const continueStudyResults = qraft.v3Service.continueStudy.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * continueStudyResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const continueStudyCombinedResults = qraft.v3Service.continueStudy.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * continueStudyCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ContinueStudySchema, ContinueStudyParameters, ContinueStudyData, ContinueStudyError>>, TCombinedResult = Array<UseQueryResult<ContinueStudyData, ContinueStudyError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ContinueStudyData, ContinueStudyError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.continueStudy.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.continueStudy.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ContinueStudyData>(parameters: ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void), options?: Omit<UseSuspenseQueryOptions<ContinueStudyData, ContinueStudyError, TData, ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ContinueStudyError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.continueStudy.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ContinueStudyParameters, TData = ContinueStudyData>(parameters: ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ContinueStudyData, ContinueStudyError, OperationInfiniteData<TData, ContinueStudyParameters>, ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ContinueStudyData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ContinueStudyParameters>, OperationError<ContinueStudyError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Continue Study
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const continueStudyData = qraft.v3Service.continueStudy.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * continueStudyResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const continueStudyCombinedData = qraft.v3Service.continueStudy.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * continueStudyCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ContinueStudySchema, ContinueStudyParameters, ContinueStudyData, ContinueStudyError>>, TCombinedResult = Array<UseSuspenseQueryResult<ContinueStudyData, ContinueStudyError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ContinueStudyData, ContinueStudyError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Continue Study */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ContinueStudySchema, ContinueStudyData, ContinueStudyParameters, ContinueStudyError> | void): Promise<ContinueStudyData>;
        /** @summary Continue Study */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ContinueStudySchema, ContinueStudyData, ContinueStudyParameters, ContinueStudyError> | void): Promise<void>;
        /** @summary Continue Study */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ContinueStudySchema, ContinueStudyData, ContinueStudyParameters, ContinueStudyError> | void): Promise<ContinueStudyData>;
        /** @summary Continue Study */
        fetchInfiniteQuery<TPageParam extends ContinueStudyParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ContinueStudySchema, ContinueStudyData, ContinueStudyParameters, DeepReadonly<TPageParam>, ContinueStudyError> | void): Promise<OperationInfiniteData<ContinueStudyData, ContinueStudyParameters>>;
        /** @summary Continue Study */
        prefetchInfiniteQuery<TPageParam extends ContinueStudyParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ContinueStudySchema, ContinueStudyData, ContinueStudyParameters, DeepReadonly<TPageParam>, ContinueStudyError> | void): Promise<void>;
        /** @summary Continue Study */
        ensureInfiniteQueryData<TPageParam extends ContinueStudyParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ContinueStudySchema, ContinueStudyData, ContinueStudyParameters, DeepReadonly<TPageParam>, ContinueStudyError> | void): Promise<OperationInfiniteData<ContinueStudyData, ContinueStudyParameters>>;
        /** @summary Continue Study */
        getQueryData(parameters: ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void)): ContinueStudyData | undefined;
        /** @summary Continue Study */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void)): OperationInfiniteData<ContinueStudyData, ContinueStudyParameters> | undefined;
        /** @summary Continue Study */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError> | QueryFiltersByQueryKey<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters>,
            data: NoInfer<OperationInfiniteData<ContinueStudyData, ContinueStudyParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters>,
            data: ContinueStudyData | undefined
        ]>;
        /** @summary Continue Study */
        getQueryState(parameters: ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters> | (DeepReadonly<ContinueStudyParameters> | void)): QueryState<ContinueStudyData, ContinueStudyError> | undefined;
        /** @summary Continue Study */
        getInfiniteQueryState(parameters: DeepReadonly<ContinueStudyParameters> | ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters> | void): QueryState<OperationInfiniteData<ContinueStudyData, ContinueStudyParameters>, ContinueStudyError> | undefined;
        /** @summary Continue Study */
        setQueryData(parameters: (DeepReadonly<ContinueStudyParameters> | undefined) | ServiceOperationQueryKey<ContinueStudySchema, ContinueStudyParameters>, updater: Updater<NoInfer<ContinueStudyData> | undefined, NoInfer<DeepReadonly<ContinueStudyData>> | undefined>, options?: SetDataOptions): ContinueStudyData | undefined;
        /** @summary Continue Study */
        setInfiniteQueryData(parameters: (DeepReadonly<ContinueStudyParameters> | undefined) | ServiceOperationInfiniteQueryKey<ContinueStudySchema, ContinueStudyParameters>, updater: Updater<NoInfer<OperationInfiniteData<ContinueStudyData, ContinueStudyParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ContinueStudyData, ContinueStudyParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ContinueStudyData, ContinueStudyParameters> | undefined;
        /** @summary Continue Study */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError> | QueryFiltersByQueryKey<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>, updater: Updater<NoInfer<ContinueStudyData> | undefined, NoInfer<ContinueStudyData> | undefined>, options?: SetDataOptions): Array<ContinueStudyData | undefined>;
        /** @summary Continue Study */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Continue Study */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError> | QueryFiltersByQueryKey<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>, options?: RefetchOptions): Promise<void>;
        /** @summary Continue Study */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError> | QueryFiltersByQueryKey<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>, options?: CancelOptions): Promise<void>;
        /** @summary Continue Study */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError> | QueryFiltersByQueryKey<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>): void;
        /** @summary Continue Study */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError> | QueryFiltersByQueryKey<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>, options?: ResetOptions): Promise<void>;
        /** @summary Continue Study */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError> | QueryFiltersByQueryKey<ContinueStudySchema, ContinueStudyData, TInfinite, ContinueStudyParameters, ContinueStudyError>): number;
        schema: ContinueStudySchema;
        types: {
            parameters: ContinueStudyParameters;
            data: ContinueStudyData;
            error: ContinueStudyError;
        };
    };
    /** @summary Progress */
    allProgress: {
        /** @summary Progress */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AllProgressSchema, AllProgressParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AllProgressParameters, TMeta, TSignal> | void), client?: (schema: AllProgressSchema, options: {
            parameters: AllProgressParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AllProgressData, AllProgressError>>): Promise<RequestFnResponse<AllProgressData, AllProgressError>>;
        /** @summary Progress */
        getQueryKey(parameters: DeepReadonly<AllProgressParameters> | void): ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.allProgress.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.allProgress.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AllProgressData>(parameters: ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void), options?: Omit<UndefinedInitialDataOptions<AllProgressData, AllProgressError, TData, ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AllProgressError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.allProgress.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.allProgress.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AllProgressData>(parameters: ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void), options: Omit<DefinedInitialDataOptions<AllProgressData, AllProgressError, TData, ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AllProgressError>>;
        /** @summary Progress */
        getInfiniteQueryKey(parameters: DeepReadonly<AllProgressParameters> | void): ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.allProgress.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AllProgressParameters, TQueryFnData = AllProgressData, TData = OperationInfiniteData<TQueryFnData, AllProgressParameters>>(parameters: ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AllProgressError, TData, ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AllProgressError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.allProgress.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AllProgressParameters, TQueryFnData = AllProgressData, TData = OperationInfiniteData<TQueryFnData, AllProgressParameters>>(parameters: ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AllProgressError, TData, ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AllProgressData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AllProgressError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const allProgressTotal = qraft.v3Service.allProgress.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const allProgressByParametersTotal = qraft.v3Service.allProgress.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError> | QueryFiltersByQueryKey<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const allProgressResults = qraft.v3Service.allProgress.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * allProgressResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const allProgressCombinedResults = qraft.v3Service.allProgress.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * allProgressCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AllProgressSchema, AllProgressParameters, AllProgressData, AllProgressError>>, TCombinedResult = Array<UseQueryResult<AllProgressData, AllProgressError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AllProgressData, AllProgressError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.allProgress.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.allProgress.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AllProgressData>(parameters: ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void), options?: Omit<UseSuspenseQueryOptions<AllProgressData, AllProgressError, TData, ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AllProgressError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.allProgress.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AllProgressParameters, TData = AllProgressData>(parameters: ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<AllProgressData, AllProgressError, OperationInfiniteData<TData, AllProgressParameters>, ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AllProgressData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AllProgressParameters>, OperationError<AllProgressError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const allProgressData = qraft.v3Service.allProgress.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * allProgressResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const allProgressCombinedData = qraft.v3Service.allProgress.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * allProgressCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AllProgressSchema, AllProgressParameters, AllProgressData, AllProgressError>>, TCombinedResult = Array<UseSuspenseQueryResult<AllProgressData, AllProgressError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AllProgressData, AllProgressError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Progress */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AllProgressSchema, AllProgressData, AllProgressParameters, AllProgressError> | void): Promise<AllProgressData>;
        /** @summary Progress */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AllProgressSchema, AllProgressData, AllProgressParameters, AllProgressError> | void): Promise<void>;
        /** @summary Progress */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AllProgressSchema, AllProgressData, AllProgressParameters, AllProgressError> | void): Promise<AllProgressData>;
        /** @summary Progress */
        fetchInfiniteQuery<TPageParam extends AllProgressParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AllProgressSchema, AllProgressData, AllProgressParameters, DeepReadonly<TPageParam>, AllProgressError> | void): Promise<OperationInfiniteData<AllProgressData, AllProgressParameters>>;
        /** @summary Progress */
        prefetchInfiniteQuery<TPageParam extends AllProgressParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AllProgressSchema, AllProgressData, AllProgressParameters, DeepReadonly<TPageParam>, AllProgressError> | void): Promise<void>;
        /** @summary Progress */
        ensureInfiniteQueryData<TPageParam extends AllProgressParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AllProgressSchema, AllProgressData, AllProgressParameters, DeepReadonly<TPageParam>, AllProgressError> | void): Promise<OperationInfiniteData<AllProgressData, AllProgressParameters>>;
        /** @summary Progress */
        getQueryData(parameters: ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void)): AllProgressData | undefined;
        /** @summary Progress */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void)): OperationInfiniteData<AllProgressData, AllProgressParameters> | undefined;
        /** @summary Progress */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError> | QueryFiltersByQueryKey<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters>,
            data: NoInfer<OperationInfiniteData<AllProgressData, AllProgressParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters>,
            data: AllProgressData | undefined
        ]>;
        /** @summary Progress */
        getQueryState(parameters: ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters> | (DeepReadonly<AllProgressParameters> | void)): QueryState<AllProgressData, AllProgressError> | undefined;
        /** @summary Progress */
        getInfiniteQueryState(parameters: DeepReadonly<AllProgressParameters> | ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters> | void): QueryState<OperationInfiniteData<AllProgressData, AllProgressParameters>, AllProgressError> | undefined;
        /** @summary Progress */
        setQueryData(parameters: (DeepReadonly<AllProgressParameters> | undefined) | ServiceOperationQueryKey<AllProgressSchema, AllProgressParameters>, updater: Updater<NoInfer<AllProgressData> | undefined, NoInfer<DeepReadonly<AllProgressData>> | undefined>, options?: SetDataOptions): AllProgressData | undefined;
        /** @summary Progress */
        setInfiniteQueryData(parameters: (DeepReadonly<AllProgressParameters> | undefined) | ServiceOperationInfiniteQueryKey<AllProgressSchema, AllProgressParameters>, updater: Updater<NoInfer<OperationInfiniteData<AllProgressData, AllProgressParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AllProgressData, AllProgressParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AllProgressData, AllProgressParameters> | undefined;
        /** @summary Progress */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError> | QueryFiltersByQueryKey<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>, updater: Updater<NoInfer<AllProgressData> | undefined, NoInfer<AllProgressData> | undefined>, options?: SetDataOptions): Array<AllProgressData | undefined>;
        /** @summary Progress */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Progress */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError> | QueryFiltersByQueryKey<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>, options?: RefetchOptions): Promise<void>;
        /** @summary Progress */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError> | QueryFiltersByQueryKey<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>, options?: CancelOptions): Promise<void>;
        /** @summary Progress */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError> | QueryFiltersByQueryKey<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>): void;
        /** @summary Progress */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError> | QueryFiltersByQueryKey<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>, options?: ResetOptions): Promise<void>;
        /** @summary Progress */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError> | QueryFiltersByQueryKey<AllProgressSchema, AllProgressData, TInfinite, AllProgressParameters, AllProgressError>): number;
        schema: AllProgressSchema;
        types: {
            parameters: AllProgressParameters;
            data: AllProgressData;
            error: AllProgressError;
        };
    };
    /** @summary Course Progress */
    courseProgress: {
        /** @summary Course Progress */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<CourseProgressSchema, CourseProgressParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<CourseProgressParameters, TMeta, TSignal>), client?: (schema: CourseProgressSchema, options: {
            parameters: CourseProgressParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<CourseProgressData, CourseProgressError>>): Promise<RequestFnResponse<CourseProgressData, CourseProgressError>>;
        /** @summary Course Progress */
        getQueryKey(parameters: DeepReadonly<CourseProgressParameters>): ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseProgress.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseProgressData>(parameters: ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>), options?: Omit<UndefinedInitialDataOptions<CourseProgressData, CourseProgressError, TData, ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters>>, "queryKey">): UseQueryResult<TData, OperationError<CourseProgressError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.courseProgress.useQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = CourseProgressData>(parameters: ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>), options: Omit<DefinedInitialDataOptions<CourseProgressData, CourseProgressError, TData, ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<CourseProgressError>>;
        /** @summary Course Progress */
        getInfiniteQueryKey(parameters: DeepReadonly<CourseProgressParameters>): ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseProgress.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseProgressParameters, TQueryFnData = CourseProgressData, TData = OperationInfiniteData<TQueryFnData, CourseProgressParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, CourseProgressError, TData, ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<CourseProgressError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseProgress.useInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends CourseProgressParameters, TQueryFnData = CourseProgressData, TData = OperationInfiniteData<TQueryFnData, CourseProgressParameters>>(parameters: ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, CourseProgressError, TData, ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseProgressData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<CourseProgressError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const courseProgressTotal = qraft.v3Service.courseProgress.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const courseProgressByParametersTotal = qraft.v3Service.courseProgress.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError> | QueryFiltersByQueryKey<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const courseProgressResults = qraft.v3Service.courseProgress.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseProgressResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const courseProgressCombinedResults = qraft.v3Service.courseProgress.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseProgressCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<CourseProgressSchema, CourseProgressParameters, CourseProgressData, CourseProgressError>>, TCombinedResult = Array<UseQueryResult<CourseProgressData, CourseProgressError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<CourseProgressData, CourseProgressError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.courseProgress.useSuspenseQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = CourseProgressData>(parameters: ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>), options?: Omit<UseSuspenseQueryOptions<CourseProgressData, CourseProgressError, TData, ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<CourseProgressError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.courseProgress.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends CourseProgressParameters, TData = CourseProgressData>(parameters: ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<CourseProgressData, CourseProgressError, OperationInfiniteData<TData, CourseProgressParameters>, ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<CourseProgressData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, CourseProgressParameters>, OperationError<CourseProgressError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Course Progress
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const courseProgressData = qraft.v3Service.courseProgress.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseProgressResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const courseProgressCombinedData = qraft.v3Service.courseProgress.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * courseProgressCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<CourseProgressSchema, CourseProgressParameters, CourseProgressData, CourseProgressError>>, TCombinedResult = Array<UseSuspenseQueryResult<CourseProgressData, CourseProgressError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<CourseProgressData, CourseProgressError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Course Progress */
        fetchQuery(options: ServiceOperationFetchQueryOptions<CourseProgressSchema, CourseProgressData, CourseProgressParameters, CourseProgressError>): Promise<CourseProgressData>;
        /** @summary Course Progress */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<CourseProgressSchema, CourseProgressData, CourseProgressParameters, CourseProgressError>): Promise<void>;
        /** @summary Course Progress */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<CourseProgressSchema, CourseProgressData, CourseProgressParameters, CourseProgressError>): Promise<CourseProgressData>;
        /** @summary Course Progress */
        fetchInfiniteQuery<TPageParam extends CourseProgressParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseProgressSchema, CourseProgressData, CourseProgressParameters, DeepReadonly<TPageParam>, CourseProgressError>): Promise<OperationInfiniteData<CourseProgressData, CourseProgressParameters>>;
        /** @summary Course Progress */
        prefetchInfiniteQuery<TPageParam extends CourseProgressParameters>(options: ServiceOperationFetchInfiniteQueryOptions<CourseProgressSchema, CourseProgressData, CourseProgressParameters, DeepReadonly<TPageParam>, CourseProgressError>): Promise<void>;
        /** @summary Course Progress */
        ensureInfiniteQueryData<TPageParam extends CourseProgressParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<CourseProgressSchema, CourseProgressData, CourseProgressParameters, DeepReadonly<TPageParam>, CourseProgressError>): Promise<OperationInfiniteData<CourseProgressData, CourseProgressParameters>>;
        /** @summary Course Progress */
        getQueryData(parameters: ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>)): CourseProgressData | undefined;
        /** @summary Course Progress */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>)): OperationInfiniteData<CourseProgressData, CourseProgressParameters> | undefined;
        /** @summary Course Progress */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError> | QueryFiltersByQueryKey<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters>,
            data: NoInfer<OperationInfiniteData<CourseProgressData, CourseProgressParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters>,
            data: CourseProgressData | undefined
        ]>;
        /** @summary Course Progress */
        getQueryState(parameters: ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters> | (DeepReadonly<CourseProgressParameters>)): QueryState<CourseProgressData, CourseProgressError> | undefined;
        /** @summary Course Progress */
        getInfiniteQueryState(parameters: DeepReadonly<CourseProgressParameters> | ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters>): QueryState<OperationInfiniteData<CourseProgressData, CourseProgressParameters>, CourseProgressError> | undefined;
        /** @summary Course Progress */
        setQueryData(parameters: (DeepReadonly<CourseProgressParameters>) | ServiceOperationQueryKey<CourseProgressSchema, CourseProgressParameters>, updater: Updater<NoInfer<CourseProgressData> | undefined, NoInfer<DeepReadonly<CourseProgressData>> | undefined>, options?: SetDataOptions): CourseProgressData | undefined;
        /** @summary Course Progress */
        setInfiniteQueryData(parameters: (DeepReadonly<CourseProgressParameters>) | ServiceOperationInfiniteQueryKey<CourseProgressSchema, CourseProgressParameters>, updater: Updater<NoInfer<OperationInfiniteData<CourseProgressData, CourseProgressParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<CourseProgressData, CourseProgressParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<CourseProgressData, CourseProgressParameters> | undefined;
        /** @summary Course Progress */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError> | QueryFiltersByQueryKey<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>, updater: Updater<NoInfer<CourseProgressData> | undefined, NoInfer<CourseProgressData> | undefined>, options?: SetDataOptions): Array<CourseProgressData | undefined>;
        /** @summary Course Progress */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Course Progress */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError> | QueryFiltersByQueryKey<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>, options?: RefetchOptions): Promise<void>;
        /** @summary Course Progress */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError> | QueryFiltersByQueryKey<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>, options?: CancelOptions): Promise<void>;
        /** @summary Course Progress */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError> | QueryFiltersByQueryKey<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>): void;
        /** @summary Course Progress */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError> | QueryFiltersByQueryKey<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>, options?: ResetOptions): Promise<void>;
        /** @summary Course Progress */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError> | QueryFiltersByQueryKey<CourseProgressSchema, CourseProgressData, TInfinite, CourseProgressParameters, CourseProgressError>): number;
        schema: CourseProgressSchema;
        types: {
            parameters: CourseProgressParameters;
            data: CourseProgressData;
            error: CourseProgressError;
        };
    };
    /** @summary List Quiz Responses */
    listQuizResponses: {
        /** @summary List Quiz Responses */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListQuizResponsesParameters, TMeta, TSignal> | void), client?: (schema: ListQuizResponsesSchema, options: {
            parameters: ListQuizResponsesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListQuizResponsesData, ListQuizResponsesError>>): Promise<RequestFnResponse<ListQuizResponsesData, ListQuizResponsesError>>;
        /** @summary List Quiz Responses */
        getQueryKey(parameters: DeepReadonly<ListQuizResponsesParameters> | void): ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listQuizResponses.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listQuizResponses.useQuery({
         *     query: {
         *         user_id: userId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListQuizResponsesData>(parameters: ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListQuizResponsesData, ListQuizResponsesError, TData, ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListQuizResponsesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listQuizResponses.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listQuizResponses.useQuery({
         *     query: {
         *         user_id: userId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListQuizResponsesData>(parameters: ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void), options: Omit<DefinedInitialDataOptions<ListQuizResponsesData, ListQuizResponsesError, TData, ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListQuizResponsesError>>;
        /** @summary List Quiz Responses */
        getInfiniteQueryKey(parameters: DeepReadonly<ListQuizResponsesParameters> | void): ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listQuizResponses.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             user_id: initialUserId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListQuizResponsesParameters, TQueryFnData = ListQuizResponsesData, TData = OperationInfiniteData<TQueryFnData, ListQuizResponsesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListQuizResponsesError, TData, ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListQuizResponsesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listQuizResponses.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             user_id: initialUserId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListQuizResponsesParameters, TQueryFnData = ListQuizResponsesData, TData = OperationInfiniteData<TQueryFnData, ListQuizResponsesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListQuizResponsesError, TData, ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListQuizResponsesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListQuizResponsesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listQuizResponsesTotal = qraft.v3Service.listQuizResponses.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listQuizResponsesByParametersTotal = qraft.v3Service.listQuizResponses.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             user_id: userId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError> | QueryFiltersByQueryKey<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listQuizResponsesResults = qraft.v3Service.listQuizResponses.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 user_id: userId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 user_id: userId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listQuizResponsesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listQuizResponsesCombinedResults = qraft.v3Service.listQuizResponses.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 user_id: userId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 user_id: userId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listQuizResponsesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListQuizResponsesSchema, ListQuizResponsesParameters, ListQuizResponsesData, ListQuizResponsesError>>, TCombinedResult = Array<UseQueryResult<ListQuizResponsesData, ListQuizResponsesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListQuizResponsesData, ListQuizResponsesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listQuizResponses.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listQuizResponses.useSuspenseQuery({
         *     query: {
         *         user_id: userId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListQuizResponsesData>(parameters: ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListQuizResponsesData, ListQuizResponsesError, TData, ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListQuizResponsesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listQuizResponses.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             user_id: initialUserId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListQuizResponsesParameters, TData = ListQuizResponsesData>(parameters: ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListQuizResponsesData, ListQuizResponsesError, OperationInfiniteData<TData, ListQuizResponsesParameters>, ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListQuizResponsesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListQuizResponsesParameters>, OperationError<ListQuizResponsesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Quiz Responses
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listQuizResponsesData = qraft.v3Service.listQuizResponses.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 user_id: userId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 user_id: userId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listQuizResponsesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listQuizResponsesCombinedData = qraft.v3Service.listQuizResponses.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 user_id: userId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 user_id: userId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listQuizResponsesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListQuizResponsesSchema, ListQuizResponsesParameters, ListQuizResponsesData, ListQuizResponsesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListQuizResponsesData, ListQuizResponsesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListQuizResponsesData, ListQuizResponsesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary List Quiz Responses */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListQuizResponsesSchema, ListQuizResponsesData, ListQuizResponsesParameters, ListQuizResponsesError> | void): Promise<ListQuizResponsesData>;
        /** @summary List Quiz Responses */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListQuizResponsesSchema, ListQuizResponsesData, ListQuizResponsesParameters, ListQuizResponsesError> | void): Promise<void>;
        /** @summary List Quiz Responses */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListQuizResponsesSchema, ListQuizResponsesData, ListQuizResponsesParameters, ListQuizResponsesError> | void): Promise<ListQuizResponsesData>;
        /** @summary List Quiz Responses */
        fetchInfiniteQuery<TPageParam extends ListQuizResponsesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListQuizResponsesSchema, ListQuizResponsesData, ListQuizResponsesParameters, DeepReadonly<TPageParam>, ListQuizResponsesError> | void): Promise<OperationInfiniteData<ListQuizResponsesData, ListQuizResponsesParameters>>;
        /** @summary List Quiz Responses */
        prefetchInfiniteQuery<TPageParam extends ListQuizResponsesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListQuizResponsesSchema, ListQuizResponsesData, ListQuizResponsesParameters, DeepReadonly<TPageParam>, ListQuizResponsesError> | void): Promise<void>;
        /** @summary List Quiz Responses */
        ensureInfiniteQueryData<TPageParam extends ListQuizResponsesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListQuizResponsesSchema, ListQuizResponsesData, ListQuizResponsesParameters, DeepReadonly<TPageParam>, ListQuizResponsesError> | void): Promise<OperationInfiniteData<ListQuizResponsesData, ListQuizResponsesParameters>>;
        /** @summary List Quiz Responses */
        getQueryData(parameters: ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void)): ListQuizResponsesData | undefined;
        /** @summary List Quiz Responses */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void)): OperationInfiniteData<ListQuizResponsesData, ListQuizResponsesParameters> | undefined;
        /** @summary List Quiz Responses */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError> | QueryFiltersByQueryKey<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>,
            data: NoInfer<OperationInfiniteData<ListQuizResponsesData, ListQuizResponsesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>,
            data: ListQuizResponsesData | undefined
        ]>;
        /** @summary List Quiz Responses */
        getQueryState(parameters: ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | (DeepReadonly<ListQuizResponsesParameters> | void)): QueryState<ListQuizResponsesData, ListQuizResponsesError> | undefined;
        /** @summary List Quiz Responses */
        getInfiniteQueryState(parameters: DeepReadonly<ListQuizResponsesParameters> | ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters> | void): QueryState<OperationInfiniteData<ListQuizResponsesData, ListQuizResponsesParameters>, ListQuizResponsesError> | undefined;
        /** @summary List Quiz Responses */
        setQueryData(parameters: (DeepReadonly<ListQuizResponsesParameters> | undefined) | ServiceOperationQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>, updater: Updater<NoInfer<ListQuizResponsesData> | undefined, NoInfer<DeepReadonly<ListQuizResponsesData>> | undefined>, options?: SetDataOptions): ListQuizResponsesData | undefined;
        /** @summary List Quiz Responses */
        setInfiniteQueryData(parameters: (DeepReadonly<ListQuizResponsesParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListQuizResponsesSchema, ListQuizResponsesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListQuizResponsesData, ListQuizResponsesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListQuizResponsesData, ListQuizResponsesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListQuizResponsesData, ListQuizResponsesParameters> | undefined;
        /** @summary List Quiz Responses */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError> | QueryFiltersByQueryKey<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>, updater: Updater<NoInfer<ListQuizResponsesData> | undefined, NoInfer<ListQuizResponsesData> | undefined>, options?: SetDataOptions): Array<ListQuizResponsesData | undefined>;
        /** @summary List Quiz Responses */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>, options?: InvalidateOptions): Promise<void>;
        /** @summary List Quiz Responses */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError> | QueryFiltersByQueryKey<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>, options?: RefetchOptions): Promise<void>;
        /** @summary List Quiz Responses */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError> | QueryFiltersByQueryKey<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>, options?: CancelOptions): Promise<void>;
        /** @summary List Quiz Responses */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError> | QueryFiltersByQueryKey<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>): void;
        /** @summary List Quiz Responses */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError> | QueryFiltersByQueryKey<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>, options?: ResetOptions): Promise<void>;
        /** @summary List Quiz Responses */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError> | QueryFiltersByQueryKey<ListQuizResponsesSchema, ListQuizResponsesData, TInfinite, ListQuizResponsesParameters, ListQuizResponsesError>): number;
        schema: ListQuizResponsesSchema;
        types: {
            parameters: ListQuizResponsesParameters;
            data: ListQuizResponsesData;
            error: ListQuizResponsesError;
        };
    };
    /** @summary Get Quiz Response Detail */
    getQuizResponseDetail: {
        /** @summary Get Quiz Response Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetQuizResponseDetailParameters, TMeta, TSignal>), client?: (schema: GetQuizResponseDetailSchema, options: {
            parameters: GetQuizResponseDetailParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetQuizResponseDetailData, GetQuizResponseDetailError>>): Promise<RequestFnResponse<GetQuizResponseDetailData, GetQuizResponseDetailError>>;
        /** @summary Get Quiz Response Detail */
        getQueryKey(parameters: DeepReadonly<GetQuizResponseDetailParameters>): ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getQuizResponseDetail.useQuery({
         *     path: {
         *         response_id: responseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetQuizResponseDetailData>(parameters: ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>), options?: Omit<UndefinedInitialDataOptions<GetQuizResponseDetailData, GetQuizResponseDetailError, TData, ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetQuizResponseDetailError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getQuizResponseDetail.useQuery({
         *     path: {
         *         response_id: responseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetQuizResponseDetailData>(parameters: ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>), options: Omit<DefinedInitialDataOptions<GetQuizResponseDetailData, GetQuizResponseDetailError, TData, ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetQuizResponseDetailError>>;
        /** @summary Get Quiz Response Detail */
        getInfiniteQueryKey(parameters: DeepReadonly<GetQuizResponseDetailParameters>): ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getQuizResponseDetail.useInfiniteQuery({
         *     path: {
         *         response_id: responseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetQuizResponseDetailParameters, TQueryFnData = GetQuizResponseDetailData, TData = OperationInfiniteData<TQueryFnData, GetQuizResponseDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetQuizResponseDetailError, TData, ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetQuizResponseDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getQuizResponseDetail.useInfiniteQuery({
         *     path: {
         *         response_id: responseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetQuizResponseDetailParameters, TQueryFnData = GetQuizResponseDetailData, TData = OperationInfiniteData<TQueryFnData, GetQuizResponseDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetQuizResponseDetailError, TData, ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetQuizResponseDetailData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetQuizResponseDetailError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getQuizResponseDetailTotal = qraft.v3Service.getQuizResponseDetail.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getQuizResponseDetailByParametersTotal = qraft.v3Service.getQuizResponseDetail.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             response_id: responseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError> | QueryFiltersByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getQuizResponseDetailResults = qraft.v3Service.getQuizResponseDetail.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 response_id: responseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 response_id: responseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getQuizResponseDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getQuizResponseDetailCombinedResults = qraft.v3Service.getQuizResponseDetail.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 response_id: responseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 response_id: responseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getQuizResponseDetailCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters, GetQuizResponseDetailData, GetQuizResponseDetailError>>, TCombinedResult = Array<UseQueryResult<GetQuizResponseDetailData, GetQuizResponseDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetQuizResponseDetailData, GetQuizResponseDetailError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getQuizResponseDetail.useSuspenseQuery({
         *     path: {
         *         response_id: responseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetQuizResponseDetailData>(parameters: ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>), options?: Omit<UseSuspenseQueryOptions<GetQuizResponseDetailData, GetQuizResponseDetailError, TData, ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetQuizResponseDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getQuizResponseDetail.useSuspenseInfiniteQuery({
         *     path: {
         *         response_id: responseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetQuizResponseDetailParameters, TData = GetQuizResponseDetailData>(parameters: ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetQuizResponseDetailData, GetQuizResponseDetailError, OperationInfiniteData<TData, GetQuizResponseDetailParameters>, ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetQuizResponseDetailData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetQuizResponseDetailParameters>, OperationError<GetQuizResponseDetailError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Quiz Response Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getQuizResponseDetailData = qraft.v3Service.getQuizResponseDetail.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 response_id: responseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 response_id: responseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getQuizResponseDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getQuizResponseDetailCombinedData = qraft.v3Service.getQuizResponseDetail.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 response_id: responseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 response_id: responseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getQuizResponseDetailCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters, GetQuizResponseDetailData, GetQuizResponseDetailError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetQuizResponseDetailData, GetQuizResponseDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetQuizResponseDetailData, GetQuizResponseDetailError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Quiz Response Detail */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetQuizResponseDetailSchema, GetQuizResponseDetailData, GetQuizResponseDetailParameters, GetQuizResponseDetailError>): Promise<GetQuizResponseDetailData>;
        /** @summary Get Quiz Response Detail */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetQuizResponseDetailSchema, GetQuizResponseDetailData, GetQuizResponseDetailParameters, GetQuizResponseDetailError>): Promise<void>;
        /** @summary Get Quiz Response Detail */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetQuizResponseDetailSchema, GetQuizResponseDetailData, GetQuizResponseDetailParameters, GetQuizResponseDetailError>): Promise<GetQuizResponseDetailData>;
        /** @summary Get Quiz Response Detail */
        fetchInfiniteQuery<TPageParam extends GetQuizResponseDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetQuizResponseDetailSchema, GetQuizResponseDetailData, GetQuizResponseDetailParameters, DeepReadonly<TPageParam>, GetQuizResponseDetailError>): Promise<OperationInfiniteData<GetQuizResponseDetailData, GetQuizResponseDetailParameters>>;
        /** @summary Get Quiz Response Detail */
        prefetchInfiniteQuery<TPageParam extends GetQuizResponseDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetQuizResponseDetailSchema, GetQuizResponseDetailData, GetQuizResponseDetailParameters, DeepReadonly<TPageParam>, GetQuizResponseDetailError>): Promise<void>;
        /** @summary Get Quiz Response Detail */
        ensureInfiniteQueryData<TPageParam extends GetQuizResponseDetailParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetQuizResponseDetailSchema, GetQuizResponseDetailData, GetQuizResponseDetailParameters, DeepReadonly<TPageParam>, GetQuizResponseDetailError>): Promise<OperationInfiniteData<GetQuizResponseDetailData, GetQuizResponseDetailParameters>>;
        /** @summary Get Quiz Response Detail */
        getQueryData(parameters: ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>)): GetQuizResponseDetailData | undefined;
        /** @summary Get Quiz Response Detail */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>)): OperationInfiniteData<GetQuizResponseDetailData, GetQuizResponseDetailParameters> | undefined;
        /** @summary Get Quiz Response Detail */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError> | QueryFiltersByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>,
            data: NoInfer<OperationInfiniteData<GetQuizResponseDetailData, GetQuizResponseDetailParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>,
            data: GetQuizResponseDetailData | undefined
        ]>;
        /** @summary Get Quiz Response Detail */
        getQueryState(parameters: ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters> | (DeepReadonly<GetQuizResponseDetailParameters>)): QueryState<GetQuizResponseDetailData, GetQuizResponseDetailError> | undefined;
        /** @summary Get Quiz Response Detail */
        getInfiniteQueryState(parameters: DeepReadonly<GetQuizResponseDetailParameters> | ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>): QueryState<OperationInfiniteData<GetQuizResponseDetailData, GetQuizResponseDetailParameters>, GetQuizResponseDetailError> | undefined;
        /** @summary Get Quiz Response Detail */
        setQueryData(parameters: (DeepReadonly<GetQuizResponseDetailParameters>) | ServiceOperationQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>, updater: Updater<NoInfer<GetQuizResponseDetailData> | undefined, NoInfer<DeepReadonly<GetQuizResponseDetailData>> | undefined>, options?: SetDataOptions): GetQuizResponseDetailData | undefined;
        /** @summary Get Quiz Response Detail */
        setInfiniteQueryData(parameters: (DeepReadonly<GetQuizResponseDetailParameters>) | ServiceOperationInfiniteQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetQuizResponseDetailData, GetQuizResponseDetailParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetQuizResponseDetailData, GetQuizResponseDetailParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetQuizResponseDetailData, GetQuizResponseDetailParameters> | undefined;
        /** @summary Get Quiz Response Detail */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError> | QueryFiltersByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>, updater: Updater<NoInfer<GetQuizResponseDetailData> | undefined, NoInfer<GetQuizResponseDetailData> | undefined>, options?: SetDataOptions): Array<GetQuizResponseDetailData | undefined>;
        /** @summary Get Quiz Response Detail */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Quiz Response Detail */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError> | QueryFiltersByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Quiz Response Detail */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError> | QueryFiltersByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Quiz Response Detail */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError> | QueryFiltersByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>): void;
        /** @summary Get Quiz Response Detail */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError> | QueryFiltersByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Quiz Response Detail */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError> | QueryFiltersByQueryKey<GetQuizResponseDetailSchema, GetQuizResponseDetailData, TInfinite, GetQuizResponseDetailParameters, GetQuizResponseDetailError>): number;
        schema: GetQuizResponseDetailSchema;
        types: {
            parameters: GetQuizResponseDetailParameters;
            data: GetQuizResponseDetailData;
            error: GetQuizResponseDetailError;
        };
    };
    /**
     * @summary List Group Quiz Submissions
     * @description The group's quiz submissions: legacy's pending and completed tables, as one
     * operation.
     *
     * `status` is an include list. The pending table sends `[PENDING]`; the completed
     * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
     *
     * No `search` parameter, since legacy's tables have no search box.
     */
    listGroupQuizSubmissions: {
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupQuizSubmissionsParameters, TMeta, TSignal>), client?: (schema: ListGroupQuizSubmissionsSchema, options: {
            parameters: ListGroupQuizSubmissionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError>>): Promise<RequestFnResponse<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError>>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupQuizSubmissionsParameters>): ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupQuizSubmissions.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupQuizSubmissionsData>(parameters: ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError, TData, ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupQuizSubmissionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupQuizSubmissions.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupQuizSubmissionsData>(parameters: ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>), options: Omit<DefinedInitialDataOptions<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError, TData, ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupQuizSubmissionsError>>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupQuizSubmissionsParameters>): ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupQuizSubmissions.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupQuizSubmissionsParameters, TQueryFnData = ListGroupQuizSubmissionsData, TData = OperationInfiniteData<TQueryFnData, ListGroupQuizSubmissionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupQuizSubmissionsError, TData, ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupQuizSubmissionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupQuizSubmissions.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupQuizSubmissionsParameters, TQueryFnData = ListGroupQuizSubmissionsData, TData = OperationInfiniteData<TQueryFnData, ListGroupQuizSubmissionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupQuizSubmissionsError, TData, ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupQuizSubmissionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupQuizSubmissionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupQuizSubmissionsTotal = qraft.v3Service.listGroupQuizSubmissions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupQuizSubmissionsByParametersTotal = qraft.v3Service.listGroupQuizSubmissions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             status: status
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError> | QueryFiltersByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupQuizSubmissionsResults = qraft.v3Service.listGroupQuizSubmissions.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupQuizSubmissionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupQuizSubmissionsCombinedResults = qraft.v3Service.listGroupQuizSubmissions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupQuizSubmissionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError>>, TCombinedResult = Array<UseQueryResult<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupQuizSubmissions.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupQuizSubmissionsData>(parameters: ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError, TData, ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupQuizSubmissionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupQuizSubmissions.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupQuizSubmissionsParameters, TData = ListGroupQuizSubmissionsData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError, OperationInfiniteData<TData, ListGroupQuizSubmissionsParameters>, ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupQuizSubmissionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupQuizSubmissionsParameters>, OperationError<ListGroupQuizSubmissionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupQuizSubmissionsData = qraft.v3Service.listGroupQuizSubmissions.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupQuizSubmissionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupQuizSubmissionsCombinedData = qraft.v3Service.listGroupQuizSubmissions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupQuizSubmissionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>): Promise<ListGroupQuizSubmissionsData>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>): Promise<void>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>): Promise<ListGroupQuizSubmissionsData>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupQuizSubmissionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters, DeepReadonly<TPageParam>, ListGroupQuizSubmissionsError>): Promise<OperationInfiniteData<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters>>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupQuizSubmissionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters, DeepReadonly<TPageParam>, ListGroupQuizSubmissionsError>): Promise<void>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupQuizSubmissionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters, DeepReadonly<TPageParam>, ListGroupQuizSubmissionsError>): Promise<OperationInfiniteData<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters>>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>)): ListGroupQuizSubmissionsData | undefined;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>)): OperationInfiniteData<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters> | undefined;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError> | QueryFiltersByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>,
            data: ListGroupQuizSubmissionsData | undefined
        ]>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters> | (DeepReadonly<ListGroupQuizSubmissionsParameters>)): QueryState<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsError> | undefined;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupQuizSubmissionsParameters> | ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>): QueryState<OperationInfiniteData<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters>, ListGroupQuizSubmissionsError> | undefined;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupQuizSubmissionsParameters>) | ServiceOperationQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>, updater: Updater<NoInfer<ListGroupQuizSubmissionsData> | undefined, NoInfer<DeepReadonly<ListGroupQuizSubmissionsData>> | undefined>, options?: SetDataOptions): ListGroupQuizSubmissionsData | undefined;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupQuizSubmissionsParameters>) | ServiceOperationInfiniteQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupQuizSubmissionsData, ListGroupQuizSubmissionsParameters> | undefined;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError> | QueryFiltersByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>, updater: Updater<NoInfer<ListGroupQuizSubmissionsData> | undefined, NoInfer<ListGroupQuizSubmissionsData> | undefined>, options?: SetDataOptions): Array<ListGroupQuizSubmissionsData | undefined>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError> | QueryFiltersByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError> | QueryFiltersByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError> | QueryFiltersByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>): void;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError> | QueryFiltersByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Quiz Submissions
         * @description The group's quiz submissions: legacy's pending and completed tables, as one
         * operation.
         *
         * `status` is an include list. The pending table sends `[PENDING]`; the completed
         * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
         *
         * No `search` parameter, since legacy's tables have no search box.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError> | QueryFiltersByQueryKey<ListGroupQuizSubmissionsSchema, ListGroupQuizSubmissionsData, TInfinite, ListGroupQuizSubmissionsParameters, ListGroupQuizSubmissionsError>): number;
        schema: ListGroupQuizSubmissionsSchema;
        types: {
            parameters: ListGroupQuizSubmissionsParameters;
            data: ListGroupQuizSubmissionsData;
            error: ListGroupQuizSubmissionsError;
        };
    };
    /**
     * @summary List Student Quiz Submissions
     * @description One student's quiz submissions, on their Course Study tab.
     *
     * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
     * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
     *
     * This gate is wider than the detail's: it admits the student's group coordinator,
     * whom the submission detail refuses.
     */
    listStudentQuizSubmissions: {
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentQuizSubmissionsParameters, TMeta, TSignal>), client?: (schema: ListStudentQuizSubmissionsSchema, options: {
            parameters: ListStudentQuizSubmissionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError>>): Promise<RequestFnResponse<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError>>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentQuizSubmissionsParameters>): ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentQuizSubmissions.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentQuizSubmissionsData>(parameters: ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError, TData, ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentQuizSubmissionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentQuizSubmissions.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentQuizSubmissionsData>(parameters: ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>), options: Omit<DefinedInitialDataOptions<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError, TData, ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentQuizSubmissionsError>>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentQuizSubmissionsParameters>): ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentQuizSubmissions.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentQuizSubmissionsParameters, TQueryFnData = ListStudentQuizSubmissionsData, TData = OperationInfiniteData<TQueryFnData, ListStudentQuizSubmissionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentQuizSubmissionsError, TData, ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentQuizSubmissionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentQuizSubmissions.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentQuizSubmissionsParameters, TQueryFnData = ListStudentQuizSubmissionsData, TData = OperationInfiniteData<TQueryFnData, ListStudentQuizSubmissionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentQuizSubmissionsError, TData, ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentQuizSubmissionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentQuizSubmissionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentQuizSubmissionsTotal = qraft.v3Service.listStudentQuizSubmissions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentQuizSubmissionsByParametersTotal = qraft.v3Service.listStudentQuizSubmissions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             status: status
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError> | QueryFiltersByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentQuizSubmissionsResults = qraft.v3Service.listStudentQuizSubmissions.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentQuizSubmissionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentQuizSubmissionsCombinedResults = qraft.v3Service.listStudentQuizSubmissions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentQuizSubmissionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError>>, TCombinedResult = Array<UseQueryResult<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentQuizSubmissions.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentQuizSubmissionsData>(parameters: ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError, TData, ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentQuizSubmissionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentQuizSubmissions.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentQuizSubmissionsParameters, TData = ListStudentQuizSubmissionsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError, OperationInfiniteData<TData, ListStudentQuizSubmissionsParameters>, ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentQuizSubmissionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentQuizSubmissionsParameters>, OperationError<ListStudentQuizSubmissionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentQuizSubmissionsData = qraft.v3Service.listStudentQuizSubmissions.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentQuizSubmissionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentQuizSubmissionsCombinedData = qraft.v3Service.listStudentQuizSubmissions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentQuizSubmissionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>): Promise<ListStudentQuizSubmissionsData>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>): Promise<void>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>): Promise<ListStudentQuizSubmissionsData>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentQuizSubmissionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters, DeepReadonly<TPageParam>, ListStudentQuizSubmissionsError>): Promise<OperationInfiniteData<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters>>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentQuizSubmissionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters, DeepReadonly<TPageParam>, ListStudentQuizSubmissionsError>): Promise<void>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentQuizSubmissionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters, DeepReadonly<TPageParam>, ListStudentQuizSubmissionsError>): Promise<OperationInfiniteData<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters>>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>)): ListStudentQuizSubmissionsData | undefined;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>)): OperationInfiniteData<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters> | undefined;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError> | QueryFiltersByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>,
            data: ListStudentQuizSubmissionsData | undefined
        ]>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters> | (DeepReadonly<ListStudentQuizSubmissionsParameters>)): QueryState<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsError> | undefined;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentQuizSubmissionsParameters> | ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>): QueryState<OperationInfiniteData<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters>, ListStudentQuizSubmissionsError> | undefined;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentQuizSubmissionsParameters>) | ServiceOperationQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>, updater: Updater<NoInfer<ListStudentQuizSubmissionsData> | undefined, NoInfer<DeepReadonly<ListStudentQuizSubmissionsData>> | undefined>, options?: SetDataOptions): ListStudentQuizSubmissionsData | undefined;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentQuizSubmissionsParameters>) | ServiceOperationInfiniteQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentQuizSubmissionsData, ListStudentQuizSubmissionsParameters> | undefined;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError> | QueryFiltersByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>, updater: Updater<NoInfer<ListStudentQuizSubmissionsData> | undefined, NoInfer<ListStudentQuizSubmissionsData> | undefined>, options?: SetDataOptions): Array<ListStudentQuizSubmissionsData | undefined>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError> | QueryFiltersByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError> | QueryFiltersByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError> | QueryFiltersByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>): void;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError> | QueryFiltersByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Quiz Submissions
         * @description One student's quiz submissions, on their Course Study tab.
         *
         * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
         * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
         *
         * This gate is wider than the detail's: it admits the student's group coordinator,
         * whom the submission detail refuses.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError> | QueryFiltersByQueryKey<ListStudentQuizSubmissionsSchema, ListStudentQuizSubmissionsData, TInfinite, ListStudentQuizSubmissionsParameters, ListStudentQuizSubmissionsError>): number;
        schema: ListStudentQuizSubmissionsSchema;
        types: {
            parameters: ListStudentQuizSubmissionsParameters;
            data: ListStudentQuizSubmissionsData;
            error: ListStudentQuizSubmissionsError;
        };
    };
    /**
     * @summary Grading Submissions List
     * @description The caller's own submissions: a student's rows, or a study helper's students'.
     */
    gradingSubmissionsList: {
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GradingSubmissionsListParameters, TMeta, TSignal> | void), client?: (schema: GradingSubmissionsListSchema, options: {
            parameters: GradingSubmissionsListParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GradingSubmissionsListData, GradingSubmissionsListError>>): Promise<RequestFnResponse<GradingSubmissionsListData, GradingSubmissionsListError>>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        getQueryKey(parameters: DeepReadonly<GradingSubmissionsListParameters> | void): ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.gradingSubmissionsList.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.gradingSubmissionsList.useQuery({
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GradingSubmissionsListData>(parameters: ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void), options?: Omit<UndefinedInitialDataOptions<GradingSubmissionsListData, GradingSubmissionsListError, TData, ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GradingSubmissionsListError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.gradingSubmissionsList.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.gradingSubmissionsList.useQuery({
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GradingSubmissionsListData>(parameters: ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void), options: Omit<DefinedInitialDataOptions<GradingSubmissionsListData, GradingSubmissionsListError, TData, ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GradingSubmissionsListError>>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GradingSubmissionsListParameters> | void): ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.gradingSubmissionsList.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GradingSubmissionsListParameters, TQueryFnData = GradingSubmissionsListData, TData = OperationInfiniteData<TQueryFnData, GradingSubmissionsListParameters>>(parameters: ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GradingSubmissionsListError, TData, ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GradingSubmissionsListError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.gradingSubmissionsList.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GradingSubmissionsListParameters, TQueryFnData = GradingSubmissionsListData, TData = OperationInfiniteData<TQueryFnData, GradingSubmissionsListParameters>>(parameters: ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GradingSubmissionsListError, TData, ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GradingSubmissionsListData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GradingSubmissionsListError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const gradingSubmissionsListTotal = qraft.v3Service.gradingSubmissionsList.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const gradingSubmissionsListByParametersTotal = qraft.v3Service.gradingSubmissionsList.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             status: status
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError> | QueryFiltersByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const gradingSubmissionsListResults = qraft.v3Service.gradingSubmissionsList.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * gradingSubmissionsListResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const gradingSubmissionsListCombinedResults = qraft.v3Service.gradingSubmissionsList.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * gradingSubmissionsListCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GradingSubmissionsListSchema, GradingSubmissionsListParameters, GradingSubmissionsListData, GradingSubmissionsListError>>, TCombinedResult = Array<UseQueryResult<GradingSubmissionsListData, GradingSubmissionsListError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GradingSubmissionsListData, GradingSubmissionsListError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.gradingSubmissionsList.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.gradingSubmissionsList.useSuspenseQuery({
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GradingSubmissionsListData>(parameters: ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void), options?: Omit<UseSuspenseQueryOptions<GradingSubmissionsListData, GradingSubmissionsListError, TData, ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GradingSubmissionsListError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.gradingSubmissionsList.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GradingSubmissionsListParameters, TData = GradingSubmissionsListData>(parameters: ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GradingSubmissionsListData, GradingSubmissionsListError, OperationInfiniteData<TData, GradingSubmissionsListParameters>, ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GradingSubmissionsListData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GradingSubmissionsListParameters>, OperationError<GradingSubmissionsListError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const gradingSubmissionsListData = qraft.v3Service.gradingSubmissionsList.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * gradingSubmissionsListResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const gradingSubmissionsListCombinedData = qraft.v3Service.gradingSubmissionsList.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * gradingSubmissionsListCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GradingSubmissionsListSchema, GradingSubmissionsListParameters, GradingSubmissionsListData, GradingSubmissionsListError>>, TCombinedResult = Array<UseSuspenseQueryResult<GradingSubmissionsListData, GradingSubmissionsListError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GradingSubmissionsListData, GradingSubmissionsListError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GradingSubmissionsListSchema, GradingSubmissionsListData, GradingSubmissionsListParameters, GradingSubmissionsListError> | void): Promise<GradingSubmissionsListData>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GradingSubmissionsListSchema, GradingSubmissionsListData, GradingSubmissionsListParameters, GradingSubmissionsListError> | void): Promise<void>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GradingSubmissionsListSchema, GradingSubmissionsListData, GradingSubmissionsListParameters, GradingSubmissionsListError> | void): Promise<GradingSubmissionsListData>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        fetchInfiniteQuery<TPageParam extends GradingSubmissionsListParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GradingSubmissionsListSchema, GradingSubmissionsListData, GradingSubmissionsListParameters, DeepReadonly<TPageParam>, GradingSubmissionsListError> | void): Promise<OperationInfiniteData<GradingSubmissionsListData, GradingSubmissionsListParameters>>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        prefetchInfiniteQuery<TPageParam extends GradingSubmissionsListParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GradingSubmissionsListSchema, GradingSubmissionsListData, GradingSubmissionsListParameters, DeepReadonly<TPageParam>, GradingSubmissionsListError> | void): Promise<void>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        ensureInfiniteQueryData<TPageParam extends GradingSubmissionsListParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GradingSubmissionsListSchema, GradingSubmissionsListData, GradingSubmissionsListParameters, DeepReadonly<TPageParam>, GradingSubmissionsListError> | void): Promise<OperationInfiniteData<GradingSubmissionsListData, GradingSubmissionsListParameters>>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void)): GradingSubmissionsListData | undefined;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void)): OperationInfiniteData<GradingSubmissionsListData, GradingSubmissionsListParameters> | undefined;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError> | QueryFiltersByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>,
            data: NoInfer<OperationInfiniteData<GradingSubmissionsListData, GradingSubmissionsListParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>,
            data: GradingSubmissionsListData | undefined
        ]>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | (DeepReadonly<GradingSubmissionsListParameters> | void)): QueryState<GradingSubmissionsListData, GradingSubmissionsListError> | undefined;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GradingSubmissionsListParameters> | ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters> | void): QueryState<OperationInfiniteData<GradingSubmissionsListData, GradingSubmissionsListParameters>, GradingSubmissionsListError> | undefined;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        setQueryData(parameters: (DeepReadonly<GradingSubmissionsListParameters> | undefined) | ServiceOperationQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>, updater: Updater<NoInfer<GradingSubmissionsListData> | undefined, NoInfer<DeepReadonly<GradingSubmissionsListData>> | undefined>, options?: SetDataOptions): GradingSubmissionsListData | undefined;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GradingSubmissionsListParameters> | undefined) | ServiceOperationInfiniteQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListParameters>, updater: Updater<NoInfer<OperationInfiniteData<GradingSubmissionsListData, GradingSubmissionsListParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GradingSubmissionsListData, GradingSubmissionsListParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GradingSubmissionsListData, GradingSubmissionsListParameters> | undefined;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError> | QueryFiltersByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>, updater: Updater<NoInfer<GradingSubmissionsListData> | undefined, NoInfer<GradingSubmissionsListData> | undefined>, options?: SetDataOptions): Array<GradingSubmissionsListData | undefined>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError> | QueryFiltersByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError> | QueryFiltersByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError> | QueryFiltersByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>): void;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError> | QueryFiltersByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Grading Submissions List
         * @description The caller's own submissions: a student's rows, or a study helper's students'.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError> | QueryFiltersByQueryKey<GradingSubmissionsListSchema, GradingSubmissionsListData, TInfinite, GradingSubmissionsListParameters, GradingSubmissionsListError>): number;
        schema: GradingSubmissionsListSchema;
        types: {
            parameters: GradingSubmissionsListParameters;
            data: GradingSubmissionsListData;
            error: GradingSubmissionsListError;
        };
    };
    /**
     * @summary Grading Submission Detail
     * @description One grading, for both the grade screen and the view screen.
     *
     * Returned for a PENDING submission too, which the grade screen needs. The view
     * screen's not-graded-yet refusal is a client rule; on the server, a student's view
     * stamps `viewed_at` only on a GRADED or FAILED submission.
     */
    gradingSubmissionDetail: {
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GradingSubmissionDetailParameters, TMeta, TSignal>), client?: (schema: GradingSubmissionDetailSchema, options: {
            parameters: GradingSubmissionDetailParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GradingSubmissionDetailData, GradingSubmissionDetailError>>): Promise<RequestFnResponse<GradingSubmissionDetailData, GradingSubmissionDetailError>>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        getQueryKey(parameters: DeepReadonly<GradingSubmissionDetailParameters>): ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.gradingSubmissionDetail.useQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GradingSubmissionDetailData>(parameters: ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>), options?: Omit<UndefinedInitialDataOptions<GradingSubmissionDetailData, GradingSubmissionDetailError, TData, ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GradingSubmissionDetailError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.gradingSubmissionDetail.useQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GradingSubmissionDetailData>(parameters: ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>), options: Omit<DefinedInitialDataOptions<GradingSubmissionDetailData, GradingSubmissionDetailError, TData, ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GradingSubmissionDetailError>>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GradingSubmissionDetailParameters>): ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.gradingSubmissionDetail.useInfiniteQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GradingSubmissionDetailParameters, TQueryFnData = GradingSubmissionDetailData, TData = OperationInfiniteData<TQueryFnData, GradingSubmissionDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GradingSubmissionDetailError, TData, ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GradingSubmissionDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.gradingSubmissionDetail.useInfiniteQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GradingSubmissionDetailParameters, TQueryFnData = GradingSubmissionDetailData, TData = OperationInfiniteData<TQueryFnData, GradingSubmissionDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GradingSubmissionDetailError, TData, ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GradingSubmissionDetailData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GradingSubmissionDetailError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const gradingSubmissionDetailTotal = qraft.v3Service.gradingSubmissionDetail.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const gradingSubmissionDetailByParametersTotal = qraft.v3Service.gradingSubmissionDetail.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             submission_id: submissionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError> | QueryFiltersByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const gradingSubmissionDetailResults = qraft.v3Service.gradingSubmissionDetail.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 submission_id: submissionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 submission_id: submissionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * gradingSubmissionDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const gradingSubmissionDetailCombinedResults = qraft.v3Service.gradingSubmissionDetail.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 submission_id: submissionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 submission_id: submissionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * gradingSubmissionDetailCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters, GradingSubmissionDetailData, GradingSubmissionDetailError>>, TCombinedResult = Array<UseQueryResult<GradingSubmissionDetailData, GradingSubmissionDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GradingSubmissionDetailData, GradingSubmissionDetailError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.gradingSubmissionDetail.useSuspenseQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GradingSubmissionDetailData>(parameters: ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>), options?: Omit<UseSuspenseQueryOptions<GradingSubmissionDetailData, GradingSubmissionDetailError, TData, ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GradingSubmissionDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.gradingSubmissionDetail.useSuspenseInfiniteQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GradingSubmissionDetailParameters, TData = GradingSubmissionDetailData>(parameters: ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GradingSubmissionDetailData, GradingSubmissionDetailError, OperationInfiniteData<TData, GradingSubmissionDetailParameters>, ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GradingSubmissionDetailData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GradingSubmissionDetailParameters>, OperationError<GradingSubmissionDetailError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const gradingSubmissionDetailData = qraft.v3Service.gradingSubmissionDetail.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 submission_id: submissionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 submission_id: submissionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * gradingSubmissionDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const gradingSubmissionDetailCombinedData = qraft.v3Service.gradingSubmissionDetail.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 submission_id: submissionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 submission_id: submissionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * gradingSubmissionDetailCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters, GradingSubmissionDetailData, GradingSubmissionDetailError>>, TCombinedResult = Array<UseSuspenseQueryResult<GradingSubmissionDetailData, GradingSubmissionDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GradingSubmissionDetailData, GradingSubmissionDetailError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GradingSubmissionDetailSchema, GradingSubmissionDetailData, GradingSubmissionDetailParameters, GradingSubmissionDetailError>): Promise<GradingSubmissionDetailData>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GradingSubmissionDetailSchema, GradingSubmissionDetailData, GradingSubmissionDetailParameters, GradingSubmissionDetailError>): Promise<void>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GradingSubmissionDetailSchema, GradingSubmissionDetailData, GradingSubmissionDetailParameters, GradingSubmissionDetailError>): Promise<GradingSubmissionDetailData>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        fetchInfiniteQuery<TPageParam extends GradingSubmissionDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GradingSubmissionDetailSchema, GradingSubmissionDetailData, GradingSubmissionDetailParameters, DeepReadonly<TPageParam>, GradingSubmissionDetailError>): Promise<OperationInfiniteData<GradingSubmissionDetailData, GradingSubmissionDetailParameters>>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        prefetchInfiniteQuery<TPageParam extends GradingSubmissionDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GradingSubmissionDetailSchema, GradingSubmissionDetailData, GradingSubmissionDetailParameters, DeepReadonly<TPageParam>, GradingSubmissionDetailError>): Promise<void>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        ensureInfiniteQueryData<TPageParam extends GradingSubmissionDetailParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GradingSubmissionDetailSchema, GradingSubmissionDetailData, GradingSubmissionDetailParameters, DeepReadonly<TPageParam>, GradingSubmissionDetailError>): Promise<OperationInfiniteData<GradingSubmissionDetailData, GradingSubmissionDetailParameters>>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>)): GradingSubmissionDetailData | undefined;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>)): OperationInfiniteData<GradingSubmissionDetailData, GradingSubmissionDetailParameters> | undefined;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError> | QueryFiltersByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>,
            data: NoInfer<OperationInfiniteData<GradingSubmissionDetailData, GradingSubmissionDetailParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>,
            data: GradingSubmissionDetailData | undefined
        ]>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters> | (DeepReadonly<GradingSubmissionDetailParameters>)): QueryState<GradingSubmissionDetailData, GradingSubmissionDetailError> | undefined;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GradingSubmissionDetailParameters> | ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>): QueryState<OperationInfiniteData<GradingSubmissionDetailData, GradingSubmissionDetailParameters>, GradingSubmissionDetailError> | undefined;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        setQueryData(parameters: (DeepReadonly<GradingSubmissionDetailParameters>) | ServiceOperationQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>, updater: Updater<NoInfer<GradingSubmissionDetailData> | undefined, NoInfer<DeepReadonly<GradingSubmissionDetailData>> | undefined>, options?: SetDataOptions): GradingSubmissionDetailData | undefined;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GradingSubmissionDetailParameters>) | ServiceOperationInfiniteQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailParameters>, updater: Updater<NoInfer<OperationInfiniteData<GradingSubmissionDetailData, GradingSubmissionDetailParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GradingSubmissionDetailData, GradingSubmissionDetailParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GradingSubmissionDetailData, GradingSubmissionDetailParameters> | undefined;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError> | QueryFiltersByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>, updater: Updater<NoInfer<GradingSubmissionDetailData> | undefined, NoInfer<GradingSubmissionDetailData> | undefined>, options?: SetDataOptions): Array<GradingSubmissionDetailData | undefined>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError> | QueryFiltersByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError> | QueryFiltersByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError> | QueryFiltersByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>): void;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError> | QueryFiltersByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Grading Submission Detail
         * @description One grading, for both the grade screen and the view screen.
         *
         * Returned for a PENDING submission too, which the grade screen needs. The view
         * screen's not-graded-yet refusal is a client rule; on the server, a student's view
         * stamps `viewed_at` only on a GRADED or FAILED submission.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError> | QueryFiltersByQueryKey<GradingSubmissionDetailSchema, GradingSubmissionDetailData, TInfinite, GradingSubmissionDetailParameters, GradingSubmissionDetailError>): number;
        schema: GradingSubmissionDetailSchema;
        types: {
            parameters: GradingSubmissionDetailParameters;
            data: GradingSubmissionDetailData;
            error: GradingSubmissionDetailError;
        };
    };
    /**
     * @summary Grade Submission
     * @description Assigned study helper only, and only while PENDING.
     *
     * Not widened to platform admins.
     */
    gradingSubmissionGrade: {
        /**
         * @summary Grade Submission
         * @description Assigned study helper only, and only while PENDING.
         *
         * Not widened to platform admins.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GradingSubmissionGradeBody, GradingSubmissionGradeParameters, TMeta, TSignal>, client?: (schema: GradingSubmissionGradeSchema, options: ServiceOperationMutationFnOptions<GradingSubmissionGradeBody, GradingSubmissionGradeParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GradingSubmissionGradeData, GradingSubmissionGradeError>>): Promise<RequestFnResponse<GradingSubmissionGradeData, GradingSubmissionGradeError>>;
        /**
         * @summary Grade Submission
         * @description Assigned study helper only, and only while PENDING.
         *
         * Not widened to platform admins.
         */
        getMutationKey(parameters: DeepReadonly<GradingSubmissionGradeParameters> | void): ServiceOperationMutationKey<GradingSubmissionGradeSchema, GradingSubmissionGradeParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Grade Submission
         * @description Assigned study helper only, and only while PENDING.
         *
         * Not widened to platform admins.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.gradingSubmissionGrade.useMutation({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.gradingSubmissionGrade.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GradingSubmissionGradeBody, TContext = unknown>(parameters: DeepReadonly<GradingSubmissionGradeParameters>, options?: ServiceOperationUseMutationOptions<GradingSubmissionGradeSchema, GradingSubmissionGradeData, GradingSubmissionGradeParameters, TVariables, OperationError<GradingSubmissionGradeError>, TContext>): UseMutationResult<GradingSubmissionGradeData, OperationError<GradingSubmissionGradeError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Grade Submission
         * @description Assigned study helper only, and only while PENDING.
         *
         * Not widened to platform admins.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.gradingSubmissionGrade.useMutation({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.gradingSubmissionGrade.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GradingSubmissionGradeBody, GradingSubmissionGradeParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GradingSubmissionGradeSchema, GradingSubmissionGradeData, GradingSubmissionGradeParameters, TVariables, OperationError<GradingSubmissionGradeError>, TContext>): UseMutationResult<GradingSubmissionGradeData, OperationError<GradingSubmissionGradeError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Grade Submission
         * @description Assigned study helper only, and only while PENDING.
         *
         * Not widened to platform admins.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const gradingSubmissionGradeTotal = qraft.v3Service.gradingSubmissionGrade.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const gradingSubmissionGradeTotal = qraft.v3Service.gradingSubmissionGrade.useIsMutating({
         *     parameters: {
         *         path: {
         *             submission_id: submissionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext> | MutationFiltersByMutationKey<GradingSubmissionGradeSchema, GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Grade Submission
         * @description Assigned study helper only, and only while PENDING.
         *
         * Not widened to platform admins.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const gradingSubmissionGradePendingMutationVariables = qraft.v3Service.gradingSubmissionGrade.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const gradingSubmissionGradeMutationData = qraft.v3Service.gradingSubmissionGrade.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 submission_id: submissionId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GradingSubmissionGradeData, OperationError<GradingSubmissionGradeError>, MutationVariables<GradingSubmissionGradeBody, GradingSubmissionGradeParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext> | MutationFiltersByMutationKey<GradingSubmissionGradeSchema, GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext>;
            select?: (mutation: Mutation<GradingSubmissionGradeData, OperationError<GradingSubmissionGradeError>, MutationVariables<GradingSubmissionGradeBody, GradingSubmissionGradeParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Grade Submission
         * @description Assigned study helper only, and only while PENDING.
         *
         * Not widened to platform admins.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext> | MutationFiltersByMutationKey<GradingSubmissionGradeSchema, GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Grade Submission
         * @description Assigned study helper only, and only while PENDING.
         *
         * Not widened to platform admins.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.gradingSubmissionGrade.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             submission_id: submissionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.gradingSubmissionGrade.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext> | MutationFiltersByMutationKey<GradingSubmissionGradeSchema, GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext>): Mutation<GradingSubmissionGradeData, GradingSubmissionGradeError, MutationVariables<GradingSubmissionGradeBody, GradingSubmissionGradeParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext> | MutationFiltersByMutationKey<GradingSubmissionGradeSchema, GradingSubmissionGradeBody, GradingSubmissionGradeData, GradingSubmissionGradeParameters, OperationError<GradingSubmissionGradeError>, TContext>): Array<Mutation<GradingSubmissionGradeData, GradingSubmissionGradeError, MutationVariables<GradingSubmissionGradeBody, GradingSubmissionGradeParameters>, TContext>>;
        };
        schema: GradingSubmissionGradeSchema;
        types: {
            parameters: GradingSubmissionGradeParameters;
            data: GradingSubmissionGradeData;
            error: GradingSubmissionGradeError;
            body: GradingSubmissionGradeBody;
        };
    };
    /** @summary Admin List Feedback Submissions */
    adminListFeedbackSubmissions: {
        /** @summary Admin List Feedback Submissions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminListFeedbackSubmissionsParameters, TMeta, TSignal> | void), client?: (schema: AdminListFeedbackSubmissionsSchema, options: {
            parameters: AdminListFeedbackSubmissionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError>>): Promise<RequestFnResponse<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError>>;
        /** @summary Admin List Feedback Submissions */
        getQueryKey(parameters: DeepReadonly<AdminListFeedbackSubmissionsParameters> | void): ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListFeedbackSubmissions.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListFeedbackSubmissions.useQuery({
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListFeedbackSubmissionsData>(parameters: ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void), options?: Omit<UndefinedInitialDataOptions<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError, TData, ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminListFeedbackSubmissionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListFeedbackSubmissions.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminListFeedbackSubmissions.useQuery({
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminListFeedbackSubmissionsData>(parameters: ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void), options: Omit<DefinedInitialDataOptions<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError, TData, ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminListFeedbackSubmissionsError>>;
        /** @summary Admin List Feedback Submissions */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminListFeedbackSubmissionsParameters> | void): ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListFeedbackSubmissions.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListFeedbackSubmissionsParameters, TQueryFnData = AdminListFeedbackSubmissionsData, TData = OperationInfiniteData<TQueryFnData, AdminListFeedbackSubmissionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminListFeedbackSubmissionsError, TData, ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminListFeedbackSubmissionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListFeedbackSubmissions.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminListFeedbackSubmissionsParameters, TQueryFnData = AdminListFeedbackSubmissionsData, TData = OperationInfiniteData<TQueryFnData, AdminListFeedbackSubmissionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminListFeedbackSubmissionsError, TData, ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListFeedbackSubmissionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListFeedbackSubmissionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminListFeedbackSubmissionsTotal = qraft.v3Service.adminListFeedbackSubmissions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminListFeedbackSubmissionsByParametersTotal = qraft.v3Service.adminListFeedbackSubmissions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             status: status
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | QueryFiltersByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminListFeedbackSubmissionsResults = qraft.v3Service.adminListFeedbackSubmissions.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListFeedbackSubmissionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminListFeedbackSubmissionsCombinedResults = qraft.v3Service.adminListFeedbackSubmissions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListFeedbackSubmissionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError>>, TCombinedResult = Array<UseQueryResult<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.adminListFeedbackSubmissions.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminListFeedbackSubmissions.useSuspenseQuery({
         *     query: {
         *         status: status
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminListFeedbackSubmissionsData>(parameters: ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void), options?: Omit<UseSuspenseQueryOptions<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError, TData, ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminListFeedbackSubmissionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminListFeedbackSubmissions.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             status: initialStatus
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminListFeedbackSubmissionsParameters, TData = AdminListFeedbackSubmissionsData>(parameters: ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError, OperationInfiniteData<TData, AdminListFeedbackSubmissionsParameters>, ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminListFeedbackSubmissionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminListFeedbackSubmissionsParameters>, OperationError<AdminListFeedbackSubmissionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin List Feedback Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminListFeedbackSubmissionsData = qraft.v3Service.adminListFeedbackSubmissions.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListFeedbackSubmissionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminListFeedbackSubmissionsCombinedData = qraft.v3Service.adminListFeedbackSubmissions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 status: status1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 status: status2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminListFeedbackSubmissionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin List Feedback Submissions */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | void): Promise<AdminListFeedbackSubmissionsData>;
        /** @summary Admin List Feedback Submissions */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | void): Promise<void>;
        /** @summary Admin List Feedback Submissions */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | void): Promise<AdminListFeedbackSubmissionsData>;
        /** @summary Admin List Feedback Submissions */
        fetchInfiniteQuery<TPageParam extends AdminListFeedbackSubmissionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters, DeepReadonly<TPageParam>, AdminListFeedbackSubmissionsError> | void): Promise<OperationInfiniteData<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters>>;
        /** @summary Admin List Feedback Submissions */
        prefetchInfiniteQuery<TPageParam extends AdminListFeedbackSubmissionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters, DeepReadonly<TPageParam>, AdminListFeedbackSubmissionsError> | void): Promise<void>;
        /** @summary Admin List Feedback Submissions */
        ensureInfiniteQueryData<TPageParam extends AdminListFeedbackSubmissionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters, DeepReadonly<TPageParam>, AdminListFeedbackSubmissionsError> | void): Promise<OperationInfiniteData<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters>>;
        /** @summary Admin List Feedback Submissions */
        getQueryData(parameters: ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void)): AdminListFeedbackSubmissionsData | undefined;
        /** @summary Admin List Feedback Submissions */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void)): OperationInfiniteData<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters> | undefined;
        /** @summary Admin List Feedback Submissions */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | QueryFiltersByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>,
            data: NoInfer<OperationInfiniteData<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>,
            data: AdminListFeedbackSubmissionsData | undefined
        ]>;
        /** @summary Admin List Feedback Submissions */
        getQueryState(parameters: ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | (DeepReadonly<AdminListFeedbackSubmissionsParameters> | void)): QueryState<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsError> | undefined;
        /** @summary Admin List Feedback Submissions */
        getInfiniteQueryState(parameters: DeepReadonly<AdminListFeedbackSubmissionsParameters> | ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters> | void): QueryState<OperationInfiniteData<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters>, AdminListFeedbackSubmissionsError> | undefined;
        /** @summary Admin List Feedback Submissions */
        setQueryData(parameters: (DeepReadonly<AdminListFeedbackSubmissionsParameters> | undefined) | ServiceOperationQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>, updater: Updater<NoInfer<AdminListFeedbackSubmissionsData> | undefined, NoInfer<DeepReadonly<AdminListFeedbackSubmissionsData>> | undefined>, options?: SetDataOptions): AdminListFeedbackSubmissionsData | undefined;
        /** @summary Admin List Feedback Submissions */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminListFeedbackSubmissionsParameters> | undefined) | ServiceOperationInfiniteQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminListFeedbackSubmissionsData, AdminListFeedbackSubmissionsParameters> | undefined;
        /** @summary Admin List Feedback Submissions */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | QueryFiltersByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>, updater: Updater<NoInfer<AdminListFeedbackSubmissionsData> | undefined, NoInfer<AdminListFeedbackSubmissionsData> | undefined>, options?: SetDataOptions): Array<AdminListFeedbackSubmissionsData | undefined>;
        /** @summary Admin List Feedback Submissions */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin List Feedback Submissions */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | QueryFiltersByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin List Feedback Submissions */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | QueryFiltersByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin List Feedback Submissions */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | QueryFiltersByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>): void;
        /** @summary Admin List Feedback Submissions */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | QueryFiltersByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin List Feedback Submissions */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError> | QueryFiltersByQueryKey<AdminListFeedbackSubmissionsSchema, AdminListFeedbackSubmissionsData, TInfinite, AdminListFeedbackSubmissionsParameters, AdminListFeedbackSubmissionsError>): number;
        schema: AdminListFeedbackSubmissionsSchema;
        types: {
            parameters: AdminListFeedbackSubmissionsParameters;
            data: AdminListFeedbackSubmissionsData;
            error: AdminListFeedbackSubmissionsError;
        };
    };
    /** @summary Admin Get Feedback Submission */
    adminGetFeedbackSubmission: {
        /** @summary Admin Get Feedback Submission */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AdminGetFeedbackSubmissionParameters, TMeta, TSignal>), client?: (schema: AdminGetFeedbackSubmissionSchema, options: {
            parameters: AdminGetFeedbackSubmissionParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError>>): Promise<RequestFnResponse<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError>>;
        /** @summary Admin Get Feedback Submission */
        getQueryKey(parameters: DeepReadonly<AdminGetFeedbackSubmissionParameters>): ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetFeedbackSubmission.useQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetFeedbackSubmissionData>(parameters: ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>), options?: Omit<UndefinedInitialDataOptions<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError, TData, ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AdminGetFeedbackSubmissionError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.adminGetFeedbackSubmission.useQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = AdminGetFeedbackSubmissionData>(parameters: ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>), options: Omit<DefinedInitialDataOptions<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError, TData, ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AdminGetFeedbackSubmissionError>>;
        /** @summary Admin Get Feedback Submission */
        getInfiniteQueryKey(parameters: DeepReadonly<AdminGetFeedbackSubmissionParameters>): ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetFeedbackSubmission.useInfiniteQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetFeedbackSubmissionParameters, TQueryFnData = AdminGetFeedbackSubmissionData, TData = OperationInfiniteData<TQueryFnData, AdminGetFeedbackSubmissionParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetFeedbackSubmissionError, TData, ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AdminGetFeedbackSubmissionError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetFeedbackSubmission.useInfiniteQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AdminGetFeedbackSubmissionParameters, TQueryFnData = AdminGetFeedbackSubmissionData, TData = OperationInfiniteData<TQueryFnData, AdminGetFeedbackSubmissionParameters>>(parameters: ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AdminGetFeedbackSubmissionError, TData, ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetFeedbackSubmissionData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AdminGetFeedbackSubmissionError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const adminGetFeedbackSubmissionTotal = qraft.v3Service.adminGetFeedbackSubmission.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const adminGetFeedbackSubmissionByParametersTotal = qraft.v3Service.adminGetFeedbackSubmission.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             submission_id: submissionId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError> | QueryFiltersByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const adminGetFeedbackSubmissionResults = qraft.v3Service.adminGetFeedbackSubmission.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 submission_id: submissionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 submission_id: submissionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetFeedbackSubmissionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const adminGetFeedbackSubmissionCombinedResults = qraft.v3Service.adminGetFeedbackSubmission.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 submission_id: submissionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 submission_id: submissionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetFeedbackSubmissionCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError>>, TCombinedResult = Array<UseQueryResult<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.adminGetFeedbackSubmission.useSuspenseQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AdminGetFeedbackSubmissionData>(parameters: ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>), options?: Omit<UseSuspenseQueryOptions<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError, TData, ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AdminGetFeedbackSubmissionError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.adminGetFeedbackSubmission.useSuspenseInfiniteQuery({
         *     path: {
         *         submission_id: submissionId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AdminGetFeedbackSubmissionParameters, TData = AdminGetFeedbackSubmissionData>(parameters: ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError, OperationInfiniteData<TData, AdminGetFeedbackSubmissionParameters>, ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AdminGetFeedbackSubmissionData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AdminGetFeedbackSubmissionParameters>, OperationError<AdminGetFeedbackSubmissionError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Admin Get Feedback Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const adminGetFeedbackSubmissionData = qraft.v3Service.adminGetFeedbackSubmission.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 submission_id: submissionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 submission_id: submissionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetFeedbackSubmissionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const adminGetFeedbackSubmissionCombinedData = qraft.v3Service.adminGetFeedbackSubmission.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 submission_id: submissionId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 submission_id: submissionId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * adminGetFeedbackSubmissionCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError>>, TCombinedResult = Array<UseSuspenseQueryResult<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Admin Get Feedback Submission */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>): Promise<AdminGetFeedbackSubmissionData>;
        /** @summary Admin Get Feedback Submission */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>): Promise<void>;
        /** @summary Admin Get Feedback Submission */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>): Promise<AdminGetFeedbackSubmissionData>;
        /** @summary Admin Get Feedback Submission */
        fetchInfiniteQuery<TPageParam extends AdminGetFeedbackSubmissionParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters, DeepReadonly<TPageParam>, AdminGetFeedbackSubmissionError>): Promise<OperationInfiniteData<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters>>;
        /** @summary Admin Get Feedback Submission */
        prefetchInfiniteQuery<TPageParam extends AdminGetFeedbackSubmissionParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters, DeepReadonly<TPageParam>, AdminGetFeedbackSubmissionError>): Promise<void>;
        /** @summary Admin Get Feedback Submission */
        ensureInfiniteQueryData<TPageParam extends AdminGetFeedbackSubmissionParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters, DeepReadonly<TPageParam>, AdminGetFeedbackSubmissionError>): Promise<OperationInfiniteData<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters>>;
        /** @summary Admin Get Feedback Submission */
        getQueryData(parameters: ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>)): AdminGetFeedbackSubmissionData | undefined;
        /** @summary Admin Get Feedback Submission */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>)): OperationInfiniteData<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters> | undefined;
        /** @summary Admin Get Feedback Submission */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError> | QueryFiltersByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>,
            data: NoInfer<OperationInfiniteData<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>,
            data: AdminGetFeedbackSubmissionData | undefined
        ]>;
        /** @summary Admin Get Feedback Submission */
        getQueryState(parameters: ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters> | (DeepReadonly<AdminGetFeedbackSubmissionParameters>)): QueryState<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionError> | undefined;
        /** @summary Admin Get Feedback Submission */
        getInfiniteQueryState(parameters: DeepReadonly<AdminGetFeedbackSubmissionParameters> | ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>): QueryState<OperationInfiniteData<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters>, AdminGetFeedbackSubmissionError> | undefined;
        /** @summary Admin Get Feedback Submission */
        setQueryData(parameters: (DeepReadonly<AdminGetFeedbackSubmissionParameters>) | ServiceOperationQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>, updater: Updater<NoInfer<AdminGetFeedbackSubmissionData> | undefined, NoInfer<DeepReadonly<AdminGetFeedbackSubmissionData>> | undefined>, options?: SetDataOptions): AdminGetFeedbackSubmissionData | undefined;
        /** @summary Admin Get Feedback Submission */
        setInfiniteQueryData(parameters: (DeepReadonly<AdminGetFeedbackSubmissionParameters>) | ServiceOperationInfiniteQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionParameters>, updater: Updater<NoInfer<OperationInfiniteData<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AdminGetFeedbackSubmissionData, AdminGetFeedbackSubmissionParameters> | undefined;
        /** @summary Admin Get Feedback Submission */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError> | QueryFiltersByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>, updater: Updater<NoInfer<AdminGetFeedbackSubmissionData> | undefined, NoInfer<AdminGetFeedbackSubmissionData> | undefined>, options?: SetDataOptions): Array<AdminGetFeedbackSubmissionData | undefined>;
        /** @summary Admin Get Feedback Submission */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Admin Get Feedback Submission */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError> | QueryFiltersByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>, options?: RefetchOptions): Promise<void>;
        /** @summary Admin Get Feedback Submission */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError> | QueryFiltersByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>, options?: CancelOptions): Promise<void>;
        /** @summary Admin Get Feedback Submission */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError> | QueryFiltersByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>): void;
        /** @summary Admin Get Feedback Submission */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError> | QueryFiltersByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>, options?: ResetOptions): Promise<void>;
        /** @summary Admin Get Feedback Submission */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError> | QueryFiltersByQueryKey<AdminGetFeedbackSubmissionSchema, AdminGetFeedbackSubmissionData, TInfinite, AdminGetFeedbackSubmissionParameters, AdminGetFeedbackSubmissionError>): number;
        schema: AdminGetFeedbackSubmissionSchema;
        types: {
            parameters: AdminGetFeedbackSubmissionParameters;
            data: AdminGetFeedbackSubmissionData;
            error: AdminGetFeedbackSubmissionError;
        };
    };
    /**
     * @summary Create Manual Grading Route
     * @description Enter a grade for a postal student who studies on paper.
     *
     * A separate operation from `POST /grading/submissions/{id}/grade`, which
     * grades an EXISTING attempt and carries no score -- a postal student never
     * sits one. The subject comes from the path, the quiz is the parameter, and the
     * lesson is derived from the quiz.
     */
    createManualGrading: {
        /**
         * @summary Create Manual Grading Route
         * @description Enter a grade for a postal student who studies on paper.
         *
         * A separate operation from `POST /grading/submissions/{id}/grade`, which
         * grades an EXISTING attempt and carries no score -- a postal student never
         * sits one. The subject comes from the path, the quiz is the parameter, and the
         * lesson is derived from the quiz.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateManualGradingBody, CreateManualGradingParameters, TMeta, TSignal>, client?: (schema: CreateManualGradingSchema, options: ServiceOperationMutationFnOptions<CreateManualGradingBody, CreateManualGradingParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateManualGradingData, CreateManualGradingError>>): Promise<RequestFnResponse<CreateManualGradingData, CreateManualGradingError>>;
        /**
         * @summary Create Manual Grading Route
         * @description Enter a grade for a postal student who studies on paper.
         *
         * A separate operation from `POST /grading/submissions/{id}/grade`, which
         * grades an EXISTING attempt and carries no score -- a postal student never
         * sits one. The subject comes from the path, the quiz is the parameter, and the
         * lesson is derived from the quiz.
         */
        getMutationKey(parameters: DeepReadonly<CreateManualGradingParameters> | void): ServiceOperationMutationKey<CreateManualGradingSchema, CreateManualGradingParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Manual Grading Route
         * @description Enter a grade for a postal student who studies on paper.
         *
         * A separate operation from `POST /grading/submissions/{id}/grade`, which
         * grades an EXISTING attempt and carries no score -- a postal student never
         * sits one. The subject comes from the path, the quiz is the parameter, and the
         * lesson is derived from the quiz.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createManualGrading.useMutation({
         *     path: {
         *         quiz_id: quizId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createManualGrading.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         quiz_id: quizId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateManualGradingBody, TContext = unknown>(parameters: DeepReadonly<CreateManualGradingParameters>, options?: ServiceOperationUseMutationOptions<CreateManualGradingSchema, CreateManualGradingData, CreateManualGradingParameters, TVariables, OperationError<CreateManualGradingError>, TContext>): UseMutationResult<CreateManualGradingData, OperationError<CreateManualGradingError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Manual Grading Route
         * @description Enter a grade for a postal student who studies on paper.
         *
         * A separate operation from `POST /grading/submissions/{id}/grade`, which
         * grades an EXISTING attempt and carries no score -- a postal student never
         * sits one. The subject comes from the path, the quiz is the parameter, and the
         * lesson is derived from the quiz.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createManualGrading.useMutation({
         *     path: {
         *         quiz_id: quizId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createManualGrading.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         quiz_id: quizId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateManualGradingBody, CreateManualGradingParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateManualGradingSchema, CreateManualGradingData, CreateManualGradingParameters, TVariables, OperationError<CreateManualGradingError>, TContext>): UseMutationResult<CreateManualGradingData, OperationError<CreateManualGradingError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Manual Grading Route
         * @description Enter a grade for a postal student who studies on paper.
         *
         * A separate operation from `POST /grading/submissions/{id}/grade`, which
         * grades an EXISTING attempt and carries no score -- a postal student never
         * sits one. The subject comes from the path, the quiz is the parameter, and the
         * lesson is derived from the quiz.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createManualGradingTotal = qraft.v3Service.createManualGrading.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createManualGradingTotal = qraft.v3Service.createManualGrading.useIsMutating({
         *     parameters: {
         *         path: {
         *             quiz_id: quizId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext> | MutationFiltersByMutationKey<CreateManualGradingSchema, CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Manual Grading Route
         * @description Enter a grade for a postal student who studies on paper.
         *
         * A separate operation from `POST /grading/submissions/{id}/grade`, which
         * grades an EXISTING attempt and carries no score -- a postal student never
         * sits one. The subject comes from the path, the quiz is the parameter, and the
         * lesson is derived from the quiz.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createManualGradingPendingMutationVariables = qraft.v3Service.createManualGrading.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createManualGradingMutationData = qraft.v3Service.createManualGrading.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 quiz_id: quizId,
         *                 student_id: studentId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateManualGradingData, OperationError<CreateManualGradingError>, MutationVariables<CreateManualGradingBody, CreateManualGradingParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext> | MutationFiltersByMutationKey<CreateManualGradingSchema, CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext>;
            select?: (mutation: Mutation<CreateManualGradingData, OperationError<CreateManualGradingError>, MutationVariables<CreateManualGradingBody, CreateManualGradingParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Manual Grading Route
         * @description Enter a grade for a postal student who studies on paper.
         *
         * A separate operation from `POST /grading/submissions/{id}/grade`, which
         * grades an EXISTING attempt and carries no score -- a postal student never
         * sits one. The subject comes from the path, the quiz is the parameter, and the
         * lesson is derived from the quiz.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext> | MutationFiltersByMutationKey<CreateManualGradingSchema, CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Manual Grading Route
         * @description Enter a grade for a postal student who studies on paper.
         *
         * A separate operation from `POST /grading/submissions/{id}/grade`, which
         * grades an EXISTING attempt and carries no score -- a postal student never
         * sits one. The subject comes from the path, the quiz is the parameter, and the
         * lesson is derived from the quiz.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createManualGrading.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             quiz_id: quizId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createManualGrading.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext> | MutationFiltersByMutationKey<CreateManualGradingSchema, CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext>): Mutation<CreateManualGradingData, CreateManualGradingError, MutationVariables<CreateManualGradingBody, CreateManualGradingParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext> | MutationFiltersByMutationKey<CreateManualGradingSchema, CreateManualGradingBody, CreateManualGradingData, CreateManualGradingParameters, OperationError<CreateManualGradingError>, TContext>): Array<Mutation<CreateManualGradingData, CreateManualGradingError, MutationVariables<CreateManualGradingBody, CreateManualGradingParameters>, TContext>>;
        };
        schema: CreateManualGradingSchema;
        types: {
            parameters: CreateManualGradingParameters;
            data: CreateManualGradingData;
            error: CreateManualGradingError;
            body: CreateManualGradingBody;
        };
    };
    /**
     * @summary List Canned Responses
     * @description The caller's own reusable comments plus the built-in ones for a node.
     *
     * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
     * three; a row filed against `0` is visible from every target. Built-ins sort first,
     * then title. An empty page is the normal answer on most questions.
     *
     * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
     * caller helps has their name substituted into `content`. Otherwise the tags stay
     * literal.
     */
    listCannedResponses: {
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCannedResponsesParameters, TMeta, TSignal>), client?: (schema: ListCannedResponsesSchema, options: {
            parameters: ListCannedResponsesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCannedResponsesData, ListCannedResponsesError>>): Promise<RequestFnResponse<ListCannedResponsesData, ListCannedResponsesError>>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        getQueryKey(parameters: DeepReadonly<ListCannedResponsesParameters>): ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCannedResponses.useQuery({
         *     query: {
         *         node: node,
         *         node_id: nodeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCannedResponsesData>(parameters: ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>), options?: Omit<UndefinedInitialDataOptions<ListCannedResponsesData, ListCannedResponsesError, TData, ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCannedResponsesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCannedResponses.useQuery({
         *     query: {
         *         node: node,
         *         node_id: nodeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCannedResponsesData>(parameters: ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>), options: Omit<DefinedInitialDataOptions<ListCannedResponsesData, ListCannedResponsesError, TData, ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCannedResponsesError>>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCannedResponsesParameters>): ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCannedResponses.useInfiniteQuery({
         *     query: {
         *         node: node,
         *         node_id: nodeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             node: initialNode,
         *             node_id: initialNodeId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCannedResponsesParameters, TQueryFnData = ListCannedResponsesData, TData = OperationInfiniteData<TQueryFnData, ListCannedResponsesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCannedResponsesError, TData, ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCannedResponsesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCannedResponses.useInfiniteQuery({
         *     query: {
         *         node: node,
         *         node_id: nodeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             node: initialNode,
         *             node_id: initialNodeId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCannedResponsesParameters, TQueryFnData = ListCannedResponsesData, TData = OperationInfiniteData<TQueryFnData, ListCannedResponsesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCannedResponsesError, TData, ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCannedResponsesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCannedResponsesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCannedResponsesTotal = qraft.v3Service.listCannedResponses.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCannedResponsesByParametersTotal = qraft.v3Service.listCannedResponses.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             node: node,
         *             node_id: nodeId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError> | QueryFiltersByQueryKey<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCannedResponsesResults = qraft.v3Service.listCannedResponses.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 node: node1,
         *                 node_id: nodeId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 node: node2,
         *                 node_id: nodeId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCannedResponsesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCannedResponsesCombinedResults = qraft.v3Service.listCannedResponses.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 node: node1,
         *                 node_id: nodeId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 node: node2,
         *                 node_id: nodeId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCannedResponsesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCannedResponsesSchema, ListCannedResponsesParameters, ListCannedResponsesData, ListCannedResponsesError>>, TCombinedResult = Array<UseQueryResult<ListCannedResponsesData, ListCannedResponsesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCannedResponsesData, ListCannedResponsesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCannedResponses.useSuspenseQuery({
         *     query: {
         *         node: node,
         *         node_id: nodeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCannedResponsesData>(parameters: ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>), options?: Omit<UseSuspenseQueryOptions<ListCannedResponsesData, ListCannedResponsesError, TData, ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCannedResponsesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCannedResponses.useSuspenseInfiniteQuery({
         *     query: {
         *         node: node,
         *         node_id: nodeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             node: initialNode,
         *             node_id: initialNodeId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCannedResponsesParameters, TData = ListCannedResponsesData>(parameters: ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListCannedResponsesData, ListCannedResponsesError, OperationInfiniteData<TData, ListCannedResponsesParameters>, ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCannedResponsesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCannedResponsesParameters>, OperationError<ListCannedResponsesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCannedResponsesData = qraft.v3Service.listCannedResponses.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 node: node1,
         *                 node_id: nodeId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 node: node2,
         *                 node_id: nodeId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCannedResponsesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCannedResponsesCombinedData = qraft.v3Service.listCannedResponses.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 node: node1,
         *                 node_id: nodeId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 node: node2,
         *                 node_id: nodeId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCannedResponsesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCannedResponsesSchema, ListCannedResponsesParameters, ListCannedResponsesData, ListCannedResponsesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCannedResponsesData, ListCannedResponsesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCannedResponsesData, ListCannedResponsesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCannedResponsesSchema, ListCannedResponsesData, ListCannedResponsesParameters, ListCannedResponsesError>): Promise<ListCannedResponsesData>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCannedResponsesSchema, ListCannedResponsesData, ListCannedResponsesParameters, ListCannedResponsesError>): Promise<void>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCannedResponsesSchema, ListCannedResponsesData, ListCannedResponsesParameters, ListCannedResponsesError>): Promise<ListCannedResponsesData>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        fetchInfiniteQuery<TPageParam extends ListCannedResponsesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCannedResponsesSchema, ListCannedResponsesData, ListCannedResponsesParameters, DeepReadonly<TPageParam>, ListCannedResponsesError>): Promise<OperationInfiniteData<ListCannedResponsesData, ListCannedResponsesParameters>>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        prefetchInfiniteQuery<TPageParam extends ListCannedResponsesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCannedResponsesSchema, ListCannedResponsesData, ListCannedResponsesParameters, DeepReadonly<TPageParam>, ListCannedResponsesError>): Promise<void>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        ensureInfiniteQueryData<TPageParam extends ListCannedResponsesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCannedResponsesSchema, ListCannedResponsesData, ListCannedResponsesParameters, DeepReadonly<TPageParam>, ListCannedResponsesError>): Promise<OperationInfiniteData<ListCannedResponsesData, ListCannedResponsesParameters>>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>)): ListCannedResponsesData | undefined;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>)): OperationInfiniteData<ListCannedResponsesData, ListCannedResponsesParameters> | undefined;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError> | QueryFiltersByQueryKey<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>,
            data: NoInfer<OperationInfiniteData<ListCannedResponsesData, ListCannedResponsesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>,
            data: ListCannedResponsesData | undefined
        ]>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters> | (DeepReadonly<ListCannedResponsesParameters>)): QueryState<ListCannedResponsesData, ListCannedResponsesError> | undefined;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListCannedResponsesParameters> | ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>): QueryState<OperationInfiniteData<ListCannedResponsesData, ListCannedResponsesParameters>, ListCannedResponsesError> | undefined;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        setQueryData(parameters: (DeepReadonly<ListCannedResponsesParameters>) | ServiceOperationQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>, updater: Updater<NoInfer<ListCannedResponsesData> | undefined, NoInfer<DeepReadonly<ListCannedResponsesData>> | undefined>, options?: SetDataOptions): ListCannedResponsesData | undefined;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCannedResponsesParameters>) | ServiceOperationInfiniteQueryKey<ListCannedResponsesSchema, ListCannedResponsesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCannedResponsesData, ListCannedResponsesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCannedResponsesData, ListCannedResponsesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCannedResponsesData, ListCannedResponsesParameters> | undefined;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError> | QueryFiltersByQueryKey<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>, updater: Updater<NoInfer<ListCannedResponsesData> | undefined, NoInfer<ListCannedResponsesData> | undefined>, options?: SetDataOptions): Array<ListCannedResponsesData | undefined>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError> | QueryFiltersByQueryKey<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError> | QueryFiltersByQueryKey<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError> | QueryFiltersByQueryKey<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>): void;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError> | QueryFiltersByQueryKey<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Canned Responses
         * @description The caller's own reusable comments plus the built-in ones for a node.
         *
         * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
         * three; a row filed against `0` is visible from every target. Built-ins sort first,
         * then title. An empty page is the normal answer on most questions.
         *
         * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
         * caller helps has their name substituted into `content`. Otherwise the tags stay
         * literal.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError> | QueryFiltersByQueryKey<ListCannedResponsesSchema, ListCannedResponsesData, TInfinite, ListCannedResponsesParameters, ListCannedResponsesError>): number;
        schema: ListCannedResponsesSchema;
        types: {
            parameters: ListCannedResponsesParameters;
            data: ListCannedResponsesData;
            error: ListCannedResponsesError;
        };
    };
    /**
     * @summary Create Canned Response
     * @description Author a reusable comment owned by the calling study helper.
     *
     * The title is derived from the body server-side and the row is never a
     * built-in, so neither is accepted from the client.
     */
    createCannedResponse: {
        /**
         * @summary Create Canned Response
         * @description Author a reusable comment owned by the calling study helper.
         *
         * The title is derived from the body server-side and the row is never a
         * built-in, so neither is accepted from the client.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateCannedResponseBody, CreateCannedResponseParameters, TMeta, TSignal>, client?: (schema: CreateCannedResponseSchema, options: ServiceOperationMutationFnOptions<CreateCannedResponseBody, CreateCannedResponseParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateCannedResponseData, CreateCannedResponseError>>): Promise<RequestFnResponse<CreateCannedResponseData, CreateCannedResponseError>>;
        /**
         * @summary Create Canned Response
         * @description Author a reusable comment owned by the calling study helper.
         *
         * The title is derived from the body server-side and the row is never a
         * built-in, so neither is accepted from the client.
         */
        getMutationKey(parameters: DeepReadonly<CreateCannedResponseParameters> | void): ServiceOperationMutationKey<CreateCannedResponseSchema, CreateCannedResponseParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Canned Response
         * @description Author a reusable comment owned by the calling study helper.
         *
         * The title is derived from the body server-side and the row is never a
         * built-in, so neither is accepted from the client.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createCannedResponse.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createCannedResponse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateCannedResponseBody, TContext = unknown>(parameters: DeepReadonly<CreateCannedResponseParameters>, options?: ServiceOperationUseMutationOptions<CreateCannedResponseSchema, CreateCannedResponseData, CreateCannedResponseParameters, TVariables, OperationError<CreateCannedResponseError>, TContext>): UseMutationResult<CreateCannedResponseData, OperationError<CreateCannedResponseError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Canned Response
         * @description Author a reusable comment owned by the calling study helper.
         *
         * The title is derived from the body server-side and the row is never a
         * built-in, so neither is accepted from the client.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createCannedResponse.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createCannedResponse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateCannedResponseBody, CreateCannedResponseParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateCannedResponseSchema, CreateCannedResponseData, CreateCannedResponseParameters, TVariables, OperationError<CreateCannedResponseError>, TContext>): UseMutationResult<CreateCannedResponseData, OperationError<CreateCannedResponseError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Canned Response
         * @description Author a reusable comment owned by the calling study helper.
         *
         * The title is derived from the body server-side and the row is never a
         * built-in, so neither is accepted from the client.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createCannedResponseTotal = qraft.v3Service.createCannedResponse.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createCannedResponseTotal = qraft.v3Service.createCannedResponse.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext> | MutationFiltersByMutationKey<CreateCannedResponseSchema, CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Canned Response
         * @description Author a reusable comment owned by the calling study helper.
         *
         * The title is derived from the body server-side and the row is never a
         * built-in, so neither is accepted from the client.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createCannedResponsePendingMutationVariables = qraft.v3Service.createCannedResponse.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createCannedResponseMutationData = qraft.v3Service.createCannedResponse.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateCannedResponseData, OperationError<CreateCannedResponseError>, MutationVariables<CreateCannedResponseBody, CreateCannedResponseParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext> | MutationFiltersByMutationKey<CreateCannedResponseSchema, CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext>;
            select?: (mutation: Mutation<CreateCannedResponseData, OperationError<CreateCannedResponseError>, MutationVariables<CreateCannedResponseBody, CreateCannedResponseParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Canned Response
         * @description Author a reusable comment owned by the calling study helper.
         *
         * The title is derived from the body server-side and the row is never a
         * built-in, so neither is accepted from the client.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext> | MutationFiltersByMutationKey<CreateCannedResponseSchema, CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Canned Response
         * @description Author a reusable comment owned by the calling study helper.
         *
         * The title is derived from the body server-side and the row is never a
         * built-in, so neither is accepted from the client.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createCannedResponse.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createCannedResponse.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext> | MutationFiltersByMutationKey<CreateCannedResponseSchema, CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext>): Mutation<CreateCannedResponseData, CreateCannedResponseError, MutationVariables<CreateCannedResponseBody, CreateCannedResponseParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext> | MutationFiltersByMutationKey<CreateCannedResponseSchema, CreateCannedResponseBody, CreateCannedResponseData, CreateCannedResponseParameters, OperationError<CreateCannedResponseError>, TContext>): Array<Mutation<CreateCannedResponseData, CreateCannedResponseError, MutationVariables<CreateCannedResponseBody, CreateCannedResponseParameters>, TContext>>;
        };
        schema: CreateCannedResponseSchema;
        types: {
            parameters: CreateCannedResponseParameters;
            data: CreateCannedResponseData;
            error: CreateCannedResponseError;
            body: CreateCannedResponseBody;
        };
    };
    /**
     * @summary Update Canned Response
     * @description Rewrite one of the caller's own reusable comments.
     *
     * Content only: node and target are immutable. A built-in is refused before
     * ownership is considered, so a built-in owned by nobody answers `forbidden`
     * rather than `invalid_ownership`.
     */
    updateCannedResponse: {
        /**
         * @summary Update Canned Response
         * @description Rewrite one of the caller's own reusable comments.
         *
         * Content only: node and target are immutable. A built-in is refused before
         * ownership is considered, so a built-in owned by nobody answers `forbidden`
         * rather than `invalid_ownership`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UpdateCannedResponseBody, UpdateCannedResponseParameters, TMeta, TSignal>, client?: (schema: UpdateCannedResponseSchema, options: ServiceOperationMutationFnOptions<UpdateCannedResponseBody, UpdateCannedResponseParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UpdateCannedResponseData, UpdateCannedResponseError>>): Promise<RequestFnResponse<UpdateCannedResponseData, UpdateCannedResponseError>>;
        /**
         * @summary Update Canned Response
         * @description Rewrite one of the caller's own reusable comments.
         *
         * Content only: node and target are immutable. A built-in is refused before
         * ownership is considered, so a built-in owned by nobody answers `forbidden`
         * rather than `invalid_ownership`.
         */
        getMutationKey(parameters: DeepReadonly<UpdateCannedResponseParameters> | void): ServiceOperationMutationKey<UpdateCannedResponseSchema, UpdateCannedResponseParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Canned Response
         * @description Rewrite one of the caller's own reusable comments.
         *
         * Content only: node and target are immutable. A built-in is refused before
         * ownership is considered, so a built-in owned by nobody answers `forbidden`
         * rather than `invalid_ownership`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateCannedResponse.useMutation({
         *     path: {
         *         canned_response_id: cannedResponseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateCannedResponse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         canned_response_id: cannedResponseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UpdateCannedResponseBody, TContext = unknown>(parameters: DeepReadonly<UpdateCannedResponseParameters>, options?: ServiceOperationUseMutationOptions<UpdateCannedResponseSchema, UpdateCannedResponseData, UpdateCannedResponseParameters, TVariables, OperationError<UpdateCannedResponseError>, TContext>): UseMutationResult<UpdateCannedResponseData, OperationError<UpdateCannedResponseError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Canned Response
         * @description Rewrite one of the caller's own reusable comments.
         *
         * Content only: node and target are immutable. A built-in is refused before
         * ownership is considered, so a built-in owned by nobody answers `forbidden`
         * rather than `invalid_ownership`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateCannedResponse.useMutation({
         *     path: {
         *         canned_response_id: cannedResponseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateCannedResponse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         canned_response_id: cannedResponseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UpdateCannedResponseBody, UpdateCannedResponseParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UpdateCannedResponseSchema, UpdateCannedResponseData, UpdateCannedResponseParameters, TVariables, OperationError<UpdateCannedResponseError>, TContext>): UseMutationResult<UpdateCannedResponseData, OperationError<UpdateCannedResponseError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Update Canned Response
         * @description Rewrite one of the caller's own reusable comments.
         *
         * Content only: node and target are immutable. A built-in is refused before
         * ownership is considered, so a built-in owned by nobody answers `forbidden`
         * rather than `invalid_ownership`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const updateCannedResponseTotal = qraft.v3Service.updateCannedResponse.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const updateCannedResponseTotal = qraft.v3Service.updateCannedResponse.useIsMutating({
         *     parameters: {
         *         path: {
         *             canned_response_id: cannedResponseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext> | MutationFiltersByMutationKey<UpdateCannedResponseSchema, UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Update Canned Response
         * @description Rewrite one of the caller's own reusable comments.
         *
         * Content only: node and target are immutable. A built-in is refused before
         * ownership is considered, so a built-in owned by nobody answers `forbidden`
         * rather than `invalid_ownership`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const updateCannedResponsePendingMutationVariables = qraft.v3Service.updateCannedResponse.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const updateCannedResponseMutationData = qraft.v3Service.updateCannedResponse.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 canned_response_id: cannedResponseId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UpdateCannedResponseData, OperationError<UpdateCannedResponseError>, MutationVariables<UpdateCannedResponseBody, UpdateCannedResponseParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext> | MutationFiltersByMutationKey<UpdateCannedResponseSchema, UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext>;
            select?: (mutation: Mutation<UpdateCannedResponseData, OperationError<UpdateCannedResponseError>, MutationVariables<UpdateCannedResponseBody, UpdateCannedResponseParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Update Canned Response
         * @description Rewrite one of the caller's own reusable comments.
         *
         * Content only: node and target are immutable. A built-in is refused before
         * ownership is considered, so a built-in owned by nobody answers `forbidden`
         * rather than `invalid_ownership`.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext> | MutationFiltersByMutationKey<UpdateCannedResponseSchema, UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Update Canned Response
         * @description Rewrite one of the caller's own reusable comments.
         *
         * Content only: node and target are immutable. A built-in is refused before
         * ownership is considered, so a built-in owned by nobody answers `forbidden`
         * rather than `invalid_ownership`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.updateCannedResponse.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             canned_response_id: cannedResponseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.updateCannedResponse.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext> | MutationFiltersByMutationKey<UpdateCannedResponseSchema, UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext>): Mutation<UpdateCannedResponseData, UpdateCannedResponseError, MutationVariables<UpdateCannedResponseBody, UpdateCannedResponseParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext> | MutationFiltersByMutationKey<UpdateCannedResponseSchema, UpdateCannedResponseBody, UpdateCannedResponseData, UpdateCannedResponseParameters, OperationError<UpdateCannedResponseError>, TContext>): Array<Mutation<UpdateCannedResponseData, UpdateCannedResponseError, MutationVariables<UpdateCannedResponseBody, UpdateCannedResponseParameters>, TContext>>;
        };
        schema: UpdateCannedResponseSchema;
        types: {
            parameters: UpdateCannedResponseParameters;
            data: UpdateCannedResponseData;
            error: UpdateCannedResponseError;
            body: UpdateCannedResponseBody;
        };
    };
    /**
     * @summary Delete Canned Response
     * @description Soft-delete one of the caller's own reusable comments.
     *
     * Same guard chain and same order as the update. The row is stamped rather than
     * removed, so it drops out of every fetch and stays auditable.
     */
    deleteCannedResponse: {
        /**
         * @summary Delete Canned Response
         * @description Soft-delete one of the caller's own reusable comments.
         *
         * Same guard chain and same order as the update. The row is stamped rather than
         * removed, so it drops out of every fetch and stays auditable.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteCannedResponseBody, DeleteCannedResponseParameters, TMeta, TSignal>, client?: (schema: DeleteCannedResponseSchema, options: ServiceOperationMutationFnOptions<DeleteCannedResponseBody, DeleteCannedResponseParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteCannedResponseData, DeleteCannedResponseError>>): Promise<RequestFnResponse<DeleteCannedResponseData, DeleteCannedResponseError>>;
        /**
         * @summary Delete Canned Response
         * @description Soft-delete one of the caller's own reusable comments.
         *
         * Same guard chain and same order as the update. The row is stamped rather than
         * removed, so it drops out of every fetch and stays auditable.
         */
        getMutationKey(parameters: DeepReadonly<DeleteCannedResponseParameters> | void): ServiceOperationMutationKey<DeleteCannedResponseSchema, DeleteCannedResponseParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Canned Response
         * @description Soft-delete one of the caller's own reusable comments.
         *
         * Same guard chain and same order as the update. The row is stamped rather than
         * removed, so it drops out of every fetch and stays auditable.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteCannedResponse.useMutation({
         *     path: {
         *         canned_response_id: cannedResponseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteCannedResponse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         canned_response_id: cannedResponseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteCannedResponseBody, TContext = unknown>(parameters: DeepReadonly<DeleteCannedResponseParameters>, options?: ServiceOperationUseMutationOptions<DeleteCannedResponseSchema, DeleteCannedResponseData, DeleteCannedResponseParameters, TVariables, OperationError<DeleteCannedResponseError>, TContext>): UseMutationResult<DeleteCannedResponseData, OperationError<DeleteCannedResponseError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Canned Response
         * @description Soft-delete one of the caller's own reusable comments.
         *
         * Same guard chain and same order as the update. The row is stamped rather than
         * removed, so it drops out of every fetch and stays auditable.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteCannedResponse.useMutation({
         *     path: {
         *         canned_response_id: cannedResponseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteCannedResponse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         canned_response_id: cannedResponseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteCannedResponseBody, DeleteCannedResponseParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteCannedResponseSchema, DeleteCannedResponseData, DeleteCannedResponseParameters, TVariables, OperationError<DeleteCannedResponseError>, TContext>): UseMutationResult<DeleteCannedResponseData, OperationError<DeleteCannedResponseError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Canned Response
         * @description Soft-delete one of the caller's own reusable comments.
         *
         * Same guard chain and same order as the update. The row is stamped rather than
         * removed, so it drops out of every fetch and stays auditable.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteCannedResponseTotal = qraft.v3Service.deleteCannedResponse.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteCannedResponseTotal = qraft.v3Service.deleteCannedResponse.useIsMutating({
         *     parameters: {
         *         path: {
         *             canned_response_id: cannedResponseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext> | MutationFiltersByMutationKey<DeleteCannedResponseSchema, DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Canned Response
         * @description Soft-delete one of the caller's own reusable comments.
         *
         * Same guard chain and same order as the update. The row is stamped rather than
         * removed, so it drops out of every fetch and stays auditable.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteCannedResponsePendingMutationVariables = qraft.v3Service.deleteCannedResponse.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteCannedResponseMutationData = qraft.v3Service.deleteCannedResponse.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 canned_response_id: cannedResponseId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteCannedResponseData, OperationError<DeleteCannedResponseError>, MutationVariables<DeleteCannedResponseBody, DeleteCannedResponseParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext> | MutationFiltersByMutationKey<DeleteCannedResponseSchema, DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext>;
            select?: (mutation: Mutation<DeleteCannedResponseData, OperationError<DeleteCannedResponseError>, MutationVariables<DeleteCannedResponseBody, DeleteCannedResponseParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete Canned Response
         * @description Soft-delete one of the caller's own reusable comments.
         *
         * Same guard chain and same order as the update. The row is stamped rather than
         * removed, so it drops out of every fetch and stays auditable.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext> | MutationFiltersByMutationKey<DeleteCannedResponseSchema, DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Canned Response
         * @description Soft-delete one of the caller's own reusable comments.
         *
         * Same guard chain and same order as the update. The row is stamped rather than
         * removed, so it drops out of every fetch and stays auditable.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteCannedResponse.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             canned_response_id: cannedResponseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteCannedResponse.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext> | MutationFiltersByMutationKey<DeleteCannedResponseSchema, DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext>): Mutation<DeleteCannedResponseData, DeleteCannedResponseError, MutationVariables<DeleteCannedResponseBody, DeleteCannedResponseParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext> | MutationFiltersByMutationKey<DeleteCannedResponseSchema, DeleteCannedResponseBody, DeleteCannedResponseData, DeleteCannedResponseParameters, OperationError<DeleteCannedResponseError>, TContext>): Array<Mutation<DeleteCannedResponseData, DeleteCannedResponseError, MutationVariables<DeleteCannedResponseBody, DeleteCannedResponseParameters>, TContext>>;
        };
        schema: DeleteCannedResponseSchema;
        types: {
            parameters: DeleteCannedResponseParameters;
            data: DeleteCannedResponseData;
            error: DeleteCannedResponseError;
            body: DeleteCannedResponseBody;
        };
    };
    /** @summary Get Study Helper Board */
    getStudyHelperBoard: {
        /** @summary Get Study Helper Board */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudyHelperBoardParameters, TMeta, TSignal> | void), client?: (schema: GetStudyHelperBoardSchema, options: {
            parameters: GetStudyHelperBoardParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudyHelperBoardData, GetStudyHelperBoardError>>): Promise<RequestFnResponse<GetStudyHelperBoardData, GetStudyHelperBoardError>>;
        /** @summary Get Study Helper Board */
        getQueryKey(parameters: DeepReadonly<GetStudyHelperBoardParameters> | void): ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelperBoard.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelperBoard.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelperBoardData>(parameters: ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetStudyHelperBoardData, GetStudyHelperBoardError, TData, ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudyHelperBoardError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelperBoard.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudyHelperBoard.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudyHelperBoardData>(parameters: ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void), options: Omit<DefinedInitialDataOptions<GetStudyHelperBoardData, GetStudyHelperBoardError, TData, ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudyHelperBoardError>>;
        /** @summary Get Study Helper Board */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudyHelperBoardParameters> | void): ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperBoard.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelperBoardParameters, TQueryFnData = GetStudyHelperBoardData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelperBoardParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelperBoardError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudyHelperBoardError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperBoard.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudyHelperBoardParameters, TQueryFnData = GetStudyHelperBoardData, TData = OperationInfiniteData<TQueryFnData, GetStudyHelperBoardParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudyHelperBoardError, TData, ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelperBoardData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudyHelperBoardError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudyHelperBoardTotal = qraft.v3Service.getStudyHelperBoard.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudyHelperBoardByParametersTotal = qraft.v3Service.getStudyHelperBoard.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | QueryFiltersByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudyHelperBoardResults = qraft.v3Service.getStudyHelperBoard.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperBoardResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudyHelperBoardCombinedResults = qraft.v3Service.getStudyHelperBoard.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperBoardCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters, GetStudyHelperBoardData, GetStudyHelperBoardError>>, TCombinedResult = Array<UseQueryResult<GetStudyHelperBoardData, GetStudyHelperBoardError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudyHelperBoardData, GetStudyHelperBoardError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getStudyHelperBoard.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudyHelperBoard.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudyHelperBoardData>(parameters: ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetStudyHelperBoardData, GetStudyHelperBoardError, TData, ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudyHelperBoardError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudyHelperBoard.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudyHelperBoardParameters, TData = GetStudyHelperBoardData>(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudyHelperBoardData, GetStudyHelperBoardError, OperationInfiniteData<TData, GetStudyHelperBoardParameters>, ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudyHelperBoardData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudyHelperBoardParameters>, OperationError<GetStudyHelperBoardError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Study Helper Board
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudyHelperBoardData = qraft.v3Service.getStudyHelperBoard.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperBoardResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudyHelperBoardCombinedData = qraft.v3Service.getStudyHelperBoard.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudyHelperBoardCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters, GetStudyHelperBoardData, GetStudyHelperBoardError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudyHelperBoardData, GetStudyHelperBoardError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudyHelperBoardData, GetStudyHelperBoardError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get Study Helper Board */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelperBoardSchema, GetStudyHelperBoardData, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | void): Promise<GetStudyHelperBoardData>;
        /** @summary Get Study Helper Board */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudyHelperBoardSchema, GetStudyHelperBoardData, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | void): Promise<void>;
        /** @summary Get Study Helper Board */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudyHelperBoardSchema, GetStudyHelperBoardData, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | void): Promise<GetStudyHelperBoardData>;
        /** @summary Get Study Helper Board */
        fetchInfiniteQuery<TPageParam extends GetStudyHelperBoardParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelperBoardSchema, GetStudyHelperBoardData, GetStudyHelperBoardParameters, DeepReadonly<TPageParam>, GetStudyHelperBoardError> | void): Promise<OperationInfiniteData<GetStudyHelperBoardData, GetStudyHelperBoardParameters>>;
        /** @summary Get Study Helper Board */
        prefetchInfiniteQuery<TPageParam extends GetStudyHelperBoardParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudyHelperBoardSchema, GetStudyHelperBoardData, GetStudyHelperBoardParameters, DeepReadonly<TPageParam>, GetStudyHelperBoardError> | void): Promise<void>;
        /** @summary Get Study Helper Board */
        ensureInfiniteQueryData<TPageParam extends GetStudyHelperBoardParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudyHelperBoardSchema, GetStudyHelperBoardData, GetStudyHelperBoardParameters, DeepReadonly<TPageParam>, GetStudyHelperBoardError> | void): Promise<OperationInfiniteData<GetStudyHelperBoardData, GetStudyHelperBoardParameters>>;
        /** @summary Get Study Helper Board */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void)): GetStudyHelperBoardData | undefined;
        /** @summary Get Study Helper Board */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void)): OperationInfiniteData<GetStudyHelperBoardData, GetStudyHelperBoardParameters> | undefined;
        /** @summary Get Study Helper Board */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | QueryFiltersByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>,
            data: NoInfer<OperationInfiniteData<GetStudyHelperBoardData, GetStudyHelperBoardParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>,
            data: GetStudyHelperBoardData | undefined
        ]>;
        /** @summary Get Study Helper Board */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | (DeepReadonly<GetStudyHelperBoardParameters> | void)): QueryState<GetStudyHelperBoardData, GetStudyHelperBoardError> | undefined;
        /** @summary Get Study Helper Board */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudyHelperBoardParameters> | ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters> | void): QueryState<OperationInfiniteData<GetStudyHelperBoardData, GetStudyHelperBoardParameters>, GetStudyHelperBoardError> | undefined;
        /** @summary Get Study Helper Board */
        setQueryData(parameters: (DeepReadonly<GetStudyHelperBoardParameters> | undefined) | ServiceOperationQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>, updater: Updater<NoInfer<GetStudyHelperBoardData> | undefined, NoInfer<DeepReadonly<GetStudyHelperBoardData>> | undefined>, options?: SetDataOptions): GetStudyHelperBoardData | undefined;
        /** @summary Get Study Helper Board */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudyHelperBoardParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudyHelperBoardData, GetStudyHelperBoardParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudyHelperBoardData, GetStudyHelperBoardParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudyHelperBoardData, GetStudyHelperBoardParameters> | undefined;
        /** @summary Get Study Helper Board */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | QueryFiltersByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>, updater: Updater<NoInfer<GetStudyHelperBoardData> | undefined, NoInfer<GetStudyHelperBoardData> | undefined>, options?: SetDataOptions): Array<GetStudyHelperBoardData | undefined>;
        /** @summary Get Study Helper Board */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get Study Helper Board */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | QueryFiltersByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get Study Helper Board */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | QueryFiltersByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>, options?: CancelOptions): Promise<void>;
        /** @summary Get Study Helper Board */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | QueryFiltersByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>): void;
        /** @summary Get Study Helper Board */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | QueryFiltersByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>, options?: ResetOptions): Promise<void>;
        /** @summary Get Study Helper Board */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError> | QueryFiltersByQueryKey<GetStudyHelperBoardSchema, GetStudyHelperBoardData, TInfinite, GetStudyHelperBoardParameters, GetStudyHelperBoardError>): number;
        schema: GetStudyHelperBoardSchema;
        types: {
            parameters: GetStudyHelperBoardParameters;
            data: GetStudyHelperBoardData;
            error: GetStudyHelperBoardError;
        };
    };
    /** @summary Get My Study Helper */
    getMyStudyHelper: {
        /** @summary Get My Study Helper */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetMyStudyHelperParameters, TMeta, TSignal> | void), client?: (schema: GetMyStudyHelperSchema, options: {
            parameters: GetMyStudyHelperParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetMyStudyHelperData, GetMyStudyHelperError>>): Promise<RequestFnResponse<GetMyStudyHelperData, GetMyStudyHelperError>>;
        /** @summary Get My Study Helper */
        getQueryKey(parameters: DeepReadonly<GetMyStudyHelperParameters> | void): ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMyStudyHelper.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMyStudyHelper.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMyStudyHelperData>(parameters: ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetMyStudyHelperData, GetMyStudyHelperError, TData, ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetMyStudyHelperError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMyStudyHelper.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMyStudyHelper.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMyStudyHelperData>(parameters: ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void), options: Omit<DefinedInitialDataOptions<GetMyStudyHelperData, GetMyStudyHelperError, TData, ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetMyStudyHelperError>>;
        /** @summary Get My Study Helper */
        getInfiniteQueryKey(parameters: DeepReadonly<GetMyStudyHelperParameters> | void): ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMyStudyHelper.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMyStudyHelperParameters, TQueryFnData = GetMyStudyHelperData, TData = OperationInfiniteData<TQueryFnData, GetMyStudyHelperParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetMyStudyHelperError, TData, ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetMyStudyHelperError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMyStudyHelper.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMyStudyHelperParameters, TQueryFnData = GetMyStudyHelperData, TData = OperationInfiniteData<TQueryFnData, GetMyStudyHelperParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetMyStudyHelperError, TData, ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMyStudyHelperData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetMyStudyHelperError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getMyStudyHelperTotal = qraft.v3Service.getMyStudyHelper.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getMyStudyHelperByParametersTotal = qraft.v3Service.getMyStudyHelper.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError> | QueryFiltersByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getMyStudyHelperResults = qraft.v3Service.getMyStudyHelper.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMyStudyHelperResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getMyStudyHelperCombinedResults = qraft.v3Service.getMyStudyHelper.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMyStudyHelperCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetMyStudyHelperSchema, GetMyStudyHelperParameters, GetMyStudyHelperData, GetMyStudyHelperError>>, TCombinedResult = Array<UseQueryResult<GetMyStudyHelperData, GetMyStudyHelperError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetMyStudyHelperData, GetMyStudyHelperError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getMyStudyHelper.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getMyStudyHelper.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetMyStudyHelperData>(parameters: ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetMyStudyHelperData, GetMyStudyHelperError, TData, ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetMyStudyHelperError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMyStudyHelper.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetMyStudyHelperParameters, TData = GetMyStudyHelperData>(parameters: ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetMyStudyHelperData, GetMyStudyHelperError, OperationInfiniteData<TData, GetMyStudyHelperParameters>, ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMyStudyHelperData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetMyStudyHelperParameters>, OperationError<GetMyStudyHelperError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get My Study Helper
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getMyStudyHelperData = qraft.v3Service.getMyStudyHelper.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMyStudyHelperResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getMyStudyHelperCombinedData = qraft.v3Service.getMyStudyHelper.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMyStudyHelperCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetMyStudyHelperSchema, GetMyStudyHelperParameters, GetMyStudyHelperData, GetMyStudyHelperError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetMyStudyHelperData, GetMyStudyHelperError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetMyStudyHelperData, GetMyStudyHelperError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Get My Study Helper */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetMyStudyHelperSchema, GetMyStudyHelperData, GetMyStudyHelperParameters, GetMyStudyHelperError> | void): Promise<GetMyStudyHelperData>;
        /** @summary Get My Study Helper */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetMyStudyHelperSchema, GetMyStudyHelperData, GetMyStudyHelperParameters, GetMyStudyHelperError> | void): Promise<void>;
        /** @summary Get My Study Helper */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetMyStudyHelperSchema, GetMyStudyHelperData, GetMyStudyHelperParameters, GetMyStudyHelperError> | void): Promise<GetMyStudyHelperData>;
        /** @summary Get My Study Helper */
        fetchInfiniteQuery<TPageParam extends GetMyStudyHelperParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMyStudyHelperSchema, GetMyStudyHelperData, GetMyStudyHelperParameters, DeepReadonly<TPageParam>, GetMyStudyHelperError> | void): Promise<OperationInfiniteData<GetMyStudyHelperData, GetMyStudyHelperParameters>>;
        /** @summary Get My Study Helper */
        prefetchInfiniteQuery<TPageParam extends GetMyStudyHelperParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMyStudyHelperSchema, GetMyStudyHelperData, GetMyStudyHelperParameters, DeepReadonly<TPageParam>, GetMyStudyHelperError> | void): Promise<void>;
        /** @summary Get My Study Helper */
        ensureInfiniteQueryData<TPageParam extends GetMyStudyHelperParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetMyStudyHelperSchema, GetMyStudyHelperData, GetMyStudyHelperParameters, DeepReadonly<TPageParam>, GetMyStudyHelperError> | void): Promise<OperationInfiniteData<GetMyStudyHelperData, GetMyStudyHelperParameters>>;
        /** @summary Get My Study Helper */
        getQueryData(parameters: ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void)): GetMyStudyHelperData | undefined;
        /** @summary Get My Study Helper */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void)): OperationInfiniteData<GetMyStudyHelperData, GetMyStudyHelperParameters> | undefined;
        /** @summary Get My Study Helper */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError> | QueryFiltersByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>,
            data: NoInfer<OperationInfiniteData<GetMyStudyHelperData, GetMyStudyHelperParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>,
            data: GetMyStudyHelperData | undefined
        ]>;
        /** @summary Get My Study Helper */
        getQueryState(parameters: ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | (DeepReadonly<GetMyStudyHelperParameters> | void)): QueryState<GetMyStudyHelperData, GetMyStudyHelperError> | undefined;
        /** @summary Get My Study Helper */
        getInfiniteQueryState(parameters: DeepReadonly<GetMyStudyHelperParameters> | ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters> | void): QueryState<OperationInfiniteData<GetMyStudyHelperData, GetMyStudyHelperParameters>, GetMyStudyHelperError> | undefined;
        /** @summary Get My Study Helper */
        setQueryData(parameters: (DeepReadonly<GetMyStudyHelperParameters> | undefined) | ServiceOperationQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>, updater: Updater<NoInfer<GetMyStudyHelperData> | undefined, NoInfer<DeepReadonly<GetMyStudyHelperData>> | undefined>, options?: SetDataOptions): GetMyStudyHelperData | undefined;
        /** @summary Get My Study Helper */
        setInfiniteQueryData(parameters: (DeepReadonly<GetMyStudyHelperParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetMyStudyHelperData, GetMyStudyHelperParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetMyStudyHelperData, GetMyStudyHelperParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetMyStudyHelperData, GetMyStudyHelperParameters> | undefined;
        /** @summary Get My Study Helper */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError> | QueryFiltersByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>, updater: Updater<NoInfer<GetMyStudyHelperData> | undefined, NoInfer<GetMyStudyHelperData> | undefined>, options?: SetDataOptions): Array<GetMyStudyHelperData | undefined>;
        /** @summary Get My Study Helper */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Get My Study Helper */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError> | QueryFiltersByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>, options?: RefetchOptions): Promise<void>;
        /** @summary Get My Study Helper */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError> | QueryFiltersByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>, options?: CancelOptions): Promise<void>;
        /** @summary Get My Study Helper */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError> | QueryFiltersByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>): void;
        /** @summary Get My Study Helper */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError> | QueryFiltersByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>, options?: ResetOptions): Promise<void>;
        /** @summary Get My Study Helper */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError> | QueryFiltersByQueryKey<GetMyStudyHelperSchema, GetMyStudyHelperData, TInfinite, GetMyStudyHelperParameters, GetMyStudyHelperError>): number;
        schema: GetMyStudyHelperSchema;
        types: {
            parameters: GetMyStudyHelperParameters;
            data: GetMyStudyHelperData;
            error: GetMyStudyHelperError;
        };
    };
    /**
     * @summary Get Student Board
     * @description The student board, for both surfaces.
     *
     * `group_id` is the group tab's board: it is gated admin/mod on a
     * congregation-type group and replaces the open board's reservation with that
     * group's own leads. `outreach_group_id` is the site-wide board's Outreach
     * Target filter over the open pool, membership-checked with no role axis. The
     * two are separate parameters so each can keep its own gate.
     */
    getStudentBoard: {
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentBoardSchema, GetStudentBoardParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentBoardParameters, TMeta, TSignal> | void), client?: (schema: GetStudentBoardSchema, options: {
            parameters: GetStudentBoardParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentBoardData, GetStudentBoardError>>): Promise<RequestFnResponse<GetStudentBoardData, GetStudentBoardError>>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentBoardParameters> | void): ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentBoard.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentBoard.useQuery({
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentBoardData>(parameters: ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetStudentBoardData, GetStudentBoardError, TData, ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentBoardError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentBoard.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentBoard.useQuery({
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentBoardData>(parameters: ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void), options: Omit<DefinedInitialDataOptions<GetStudentBoardData, GetStudentBoardError, TData, ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentBoardError>>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentBoardParameters> | void): ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentBoard.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentBoardParameters, TQueryFnData = GetStudentBoardData, TData = OperationInfiniteData<TQueryFnData, GetStudentBoardParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentBoardError, TData, ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentBoardError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentBoard.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentBoardParameters, TQueryFnData = GetStudentBoardData, TData = OperationInfiniteData<TQueryFnData, GetStudentBoardParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentBoardError, TData, ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentBoardData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentBoardError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentBoardTotal = qraft.v3Service.getStudentBoard.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentBoardByParametersTotal = qraft.v3Service.getStudentBoard.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError> | QueryFiltersByQueryKey<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentBoardResults = qraft.v3Service.getStudentBoard.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentBoardResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentBoardCombinedResults = qraft.v3Service.getStudentBoard.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentBoardCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentBoardSchema, GetStudentBoardParameters, GetStudentBoardData, GetStudentBoardError>>, TCombinedResult = Array<UseQueryResult<GetStudentBoardData, GetStudentBoardError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentBoardData, GetStudentBoardError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getStudentBoard.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentBoard.useSuspenseQuery({
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentBoardData>(parameters: ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetStudentBoardData, GetStudentBoardError, TData, ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentBoardError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentBoard.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentBoardParameters, TData = GetStudentBoardData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentBoardData, GetStudentBoardError, OperationInfiniteData<TData, GetStudentBoardParameters>, ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentBoardData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentBoardParameters>, OperationError<GetStudentBoardError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentBoardData = qraft.v3Service.getStudentBoard.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentBoardResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentBoardCombinedData = qraft.v3Service.getStudentBoard.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentBoardCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentBoardSchema, GetStudentBoardParameters, GetStudentBoardData, GetStudentBoardError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentBoardData, GetStudentBoardError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentBoardData, GetStudentBoardError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentBoardSchema, GetStudentBoardData, GetStudentBoardParameters, GetStudentBoardError> | void): Promise<GetStudentBoardData>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentBoardSchema, GetStudentBoardData, GetStudentBoardParameters, GetStudentBoardError> | void): Promise<void>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentBoardSchema, GetStudentBoardData, GetStudentBoardParameters, GetStudentBoardError> | void): Promise<GetStudentBoardData>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentBoardParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentBoardSchema, GetStudentBoardData, GetStudentBoardParameters, DeepReadonly<TPageParam>, GetStudentBoardError> | void): Promise<OperationInfiniteData<GetStudentBoardData, GetStudentBoardParameters>>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentBoardParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentBoardSchema, GetStudentBoardData, GetStudentBoardParameters, DeepReadonly<TPageParam>, GetStudentBoardError> | void): Promise<void>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentBoardParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentBoardSchema, GetStudentBoardData, GetStudentBoardParameters, DeepReadonly<TPageParam>, GetStudentBoardError> | void): Promise<OperationInfiniteData<GetStudentBoardData, GetStudentBoardParameters>>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void)): GetStudentBoardData | undefined;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void)): OperationInfiniteData<GetStudentBoardData, GetStudentBoardParameters> | undefined;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError> | QueryFiltersByQueryKey<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentBoardData, GetStudentBoardParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>,
            data: GetStudentBoardData | undefined
        ]>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | (DeepReadonly<GetStudentBoardParameters> | void)): QueryState<GetStudentBoardData, GetStudentBoardError> | undefined;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentBoardParameters> | ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters> | void): QueryState<OperationInfiniteData<GetStudentBoardData, GetStudentBoardParameters>, GetStudentBoardError> | undefined;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentBoardParameters> | undefined) | ServiceOperationQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>, updater: Updater<NoInfer<GetStudentBoardData> | undefined, NoInfer<DeepReadonly<GetStudentBoardData>> | undefined>, options?: SetDataOptions): GetStudentBoardData | undefined;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentBoardParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetStudentBoardSchema, GetStudentBoardParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentBoardData, GetStudentBoardParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentBoardData, GetStudentBoardParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentBoardData, GetStudentBoardParameters> | undefined;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError> | QueryFiltersByQueryKey<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>, updater: Updater<NoInfer<GetStudentBoardData> | undefined, NoInfer<GetStudentBoardData> | undefined>, options?: SetDataOptions): Array<GetStudentBoardData | undefined>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError> | QueryFiltersByQueryKey<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError> | QueryFiltersByQueryKey<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError> | QueryFiltersByQueryKey<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>): void;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError> | QueryFiltersByQueryKey<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Board
         * @description The student board, for both surfaces.
         *
         * `group_id` is the group tab's board: it is gated admin/mod on a
         * congregation-type group and replaces the open board's reservation with that
         * group's own leads. `outreach_group_id` is the site-wide board's Outreach
         * Target filter over the open pool, membership-checked with no role axis. The
         * two are separate parameters so each can keep its own gate.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError> | QueryFiltersByQueryKey<GetStudentBoardSchema, GetStudentBoardData, TInfinite, GetStudentBoardParameters, GetStudentBoardError>): number;
        schema: GetStudentBoardSchema;
        types: {
            parameters: GetStudentBoardParameters;
            data: GetStudentBoardData;
            error: GetStudentBoardError;
        };
    };
    /**
     * @summary Get Student Adoption Info
     * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
     *
     * A caller who may not act gets the same typed 4xx the write raises, before any of the
     * student's details are served. `mode` selects the ladder: `adopt` runs all three
     * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
     * gating instead on the caller coordinating a group that claims the student. The board
     * scope check applies in every mode.
     */
    getStudentAdoptionInfo: {
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentAdoptionInfoParameters, TMeta, TSignal>), client?: (schema: GetStudentAdoptionInfoSchema, options: {
            parameters: GetStudentAdoptionInfoParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError>>): Promise<RequestFnResponse<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError>>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentAdoptionInfoParameters>): ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentAdoptionInfo.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         mode: mode
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentAdoptionInfoData>(parameters: ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError, TData, ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentAdoptionInfoError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentAdoptionInfo.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         mode: mode
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentAdoptionInfoData>(parameters: ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>), options: Omit<DefinedInitialDataOptions<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError, TData, ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentAdoptionInfoError>>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentAdoptionInfoParameters>): ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentAdoptionInfo.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             mode: initialMode
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentAdoptionInfoParameters, TQueryFnData = GetStudentAdoptionInfoData, TData = OperationInfiniteData<TQueryFnData, GetStudentAdoptionInfoParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentAdoptionInfoError, TData, ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentAdoptionInfoError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentAdoptionInfo.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             mode: initialMode
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentAdoptionInfoParameters, TQueryFnData = GetStudentAdoptionInfoData, TData = OperationInfiniteData<TQueryFnData, GetStudentAdoptionInfoParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentAdoptionInfoError, TData, ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentAdoptionInfoData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentAdoptionInfoError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentAdoptionInfoTotal = qraft.v3Service.getStudentAdoptionInfo.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentAdoptionInfoByParametersTotal = qraft.v3Service.getStudentAdoptionInfo.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             mode: mode
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError> | QueryFiltersByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentAdoptionInfoResults = qraft.v3Service.getStudentAdoptionInfo.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 mode: mode1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 mode: mode2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentAdoptionInfoResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentAdoptionInfoCombinedResults = qraft.v3Service.getStudentAdoptionInfo.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 mode: mode1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 mode: mode2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentAdoptionInfoCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoData, GetStudentAdoptionInfoError>>, TCombinedResult = Array<UseQueryResult<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentAdoptionInfo.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         mode: mode
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentAdoptionInfoData>(parameters: ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError, TData, ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentAdoptionInfoError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentAdoptionInfo.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             mode: initialMode
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentAdoptionInfoParameters, TData = GetStudentAdoptionInfoData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError, OperationInfiniteData<TData, GetStudentAdoptionInfoParameters>, ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentAdoptionInfoData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentAdoptionInfoParameters>, OperationError<GetStudentAdoptionInfoError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentAdoptionInfoData = qraft.v3Service.getStudentAdoptionInfo.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 mode: mode1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 mode: mode2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentAdoptionInfoResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentAdoptionInfoCombinedData = qraft.v3Service.getStudentAdoptionInfo.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 mode: mode1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 mode: mode2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentAdoptionInfoCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoData, GetStudentAdoptionInfoError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>): Promise<GetStudentAdoptionInfoData>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>): Promise<void>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>): Promise<GetStudentAdoptionInfoData>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentAdoptionInfoParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters, DeepReadonly<TPageParam>, GetStudentAdoptionInfoError>): Promise<OperationInfiniteData<GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters>>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentAdoptionInfoParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters, DeepReadonly<TPageParam>, GetStudentAdoptionInfoError>): Promise<void>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentAdoptionInfoParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters, DeepReadonly<TPageParam>, GetStudentAdoptionInfoError>): Promise<OperationInfiniteData<GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters>>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>)): GetStudentAdoptionInfoData | undefined;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>)): OperationInfiniteData<GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters> | undefined;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError> | QueryFiltersByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>,
            data: GetStudentAdoptionInfoData | undefined
        ]>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters> | (DeepReadonly<GetStudentAdoptionInfoParameters>)): QueryState<GetStudentAdoptionInfoData, GetStudentAdoptionInfoError> | undefined;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentAdoptionInfoParameters> | ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>): QueryState<OperationInfiniteData<GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters>, GetStudentAdoptionInfoError> | undefined;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentAdoptionInfoParameters>) | ServiceOperationQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>, updater: Updater<NoInfer<GetStudentAdoptionInfoData> | undefined, NoInfer<DeepReadonly<GetStudentAdoptionInfoData>> | undefined>, options?: SetDataOptions): GetStudentAdoptionInfoData | undefined;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentAdoptionInfoParameters>) | ServiceOperationInfiniteQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentAdoptionInfoData, GetStudentAdoptionInfoParameters> | undefined;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError> | QueryFiltersByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>, updater: Updater<NoInfer<GetStudentAdoptionInfoData> | undefined, NoInfer<GetStudentAdoptionInfoData> | undefined>, options?: SetDataOptions): Array<GetStudentAdoptionInfoData | undefined>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError> | QueryFiltersByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError> | QueryFiltersByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError> | QueryFiltersByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>): void;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError> | QueryFiltersByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Adoption Info
         * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
         *
         * A caller who may not act gets the same typed 4xx the write raises, before any of the
         * student's details are served. `mode` selects the ladder: `adopt` runs all three
         * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
         * gating instead on the caller coordinating a group that claims the student. The board
         * scope check applies in every mode.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError> | QueryFiltersByQueryKey<GetStudentAdoptionInfoSchema, GetStudentAdoptionInfoData, TInfinite, GetStudentAdoptionInfoParameters, GetStudentAdoptionInfoError>): number;
        schema: GetStudentAdoptionInfoSchema;
        types: {
            parameters: GetStudentAdoptionInfoParameters;
            data: GetStudentAdoptionInfoData;
            error: GetStudentAdoptionInfoError;
        };
    };
    /** @summary Adopt Student */
    adoptStudent: {
        /** @summary Adopt Student */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdoptStudentBody, AdoptStudentParameters, TMeta, TSignal>, client?: (schema: AdoptStudentSchema, options: ServiceOperationMutationFnOptions<AdoptStudentBody, AdoptStudentParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdoptStudentData, AdoptStudentError>>): Promise<RequestFnResponse<AdoptStudentData, AdoptStudentError>>;
        /** @summary Adopt Student */
        getMutationKey(parameters: DeepReadonly<AdoptStudentParameters> | void): ServiceOperationMutationKey<AdoptStudentSchema, AdoptStudentParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adoptStudent.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adoptStudent.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdoptStudentBody, TContext = unknown>(parameters: DeepReadonly<AdoptStudentParameters>, options?: ServiceOperationUseMutationOptions<AdoptStudentSchema, AdoptStudentData, AdoptStudentParameters, TVariables, OperationError<AdoptStudentError>, TContext>): UseMutationResult<AdoptStudentData, OperationError<AdoptStudentError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adoptStudent.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.adoptStudent.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdoptStudentBody, AdoptStudentParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdoptStudentSchema, AdoptStudentData, AdoptStudentParameters, TVariables, OperationError<AdoptStudentError>, TContext>): UseMutationResult<AdoptStudentData, OperationError<AdoptStudentError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adoptStudentTotal = qraft.v3Service.adoptStudent.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adoptStudentTotal = qraft.v3Service.adoptStudent.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext> | MutationFiltersByMutationKey<AdoptStudentSchema, AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adoptStudentPendingMutationVariables = qraft.v3Service.adoptStudent.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adoptStudentMutationData = qraft.v3Service.adoptStudent.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdoptStudentData, OperationError<AdoptStudentError>, MutationVariables<AdoptStudentBody, AdoptStudentParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext> | MutationFiltersByMutationKey<AdoptStudentSchema, AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext>;
            select?: (mutation: Mutation<AdoptStudentData, OperationError<AdoptStudentError>, MutationVariables<AdoptStudentBody, AdoptStudentParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Adopt Student */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext> | MutationFiltersByMutationKey<AdoptStudentSchema, AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.adoptStudent.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.adoptStudent.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext> | MutationFiltersByMutationKey<AdoptStudentSchema, AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext>): Mutation<AdoptStudentData, AdoptStudentError, MutationVariables<AdoptStudentBody, AdoptStudentParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext> | MutationFiltersByMutationKey<AdoptStudentSchema, AdoptStudentBody, AdoptStudentData, AdoptStudentParameters, OperationError<AdoptStudentError>, TContext>): Array<Mutation<AdoptStudentData, AdoptStudentError, MutationVariables<AdoptStudentBody, AdoptStudentParameters>, TContext>>;
        };
        schema: AdoptStudentSchema;
        types: {
            parameters: AdoptStudentParameters;
            data: AdoptStudentData;
            error: AdoptStudentError;
            body: AdoptStudentBody;
        };
    };
    /**
     * @summary Pass On Student
     * @description Release this helper's groups' claims on a lead.
     *
     * Clears the student's matched web targets in every group the caller
     * moderates, and their matched campaign when the caller moderates its group;
     * the student stays on the open board for another helper. The student must be
     * on an active board item and must not already have a study helper. Neither
     * the daily adoption limit nor the adoptability rule applies here.
     */
    passOnStudent: {
        /**
         * @summary Pass On Student
         * @description Release this helper's groups' claims on a lead.
         *
         * Clears the student's matched web targets in every group the caller
         * moderates, and their matched campaign when the caller moderates its group;
         * the student stays on the open board for another helper. The student must be
         * on an active board item and must not already have a study helper. Neither
         * the daily adoption limit nor the adoptability rule applies here.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<PassOnStudentBody, PassOnStudentParameters, TMeta, TSignal>, client?: (schema: PassOnStudentSchema, options: ServiceOperationMutationFnOptions<PassOnStudentBody, PassOnStudentParameters, TMeta, TSignal>) => Promise<RequestFnResponse<PassOnStudentData, PassOnStudentError>>): Promise<RequestFnResponse<PassOnStudentData, PassOnStudentError>>;
        /**
         * @summary Pass On Student
         * @description Release this helper's groups' claims on a lead.
         *
         * Clears the student's matched web targets in every group the caller
         * moderates, and their matched campaign when the caller moderates its group;
         * the student stays on the open board for another helper. The student must be
         * on an active board item and must not already have a study helper. Neither
         * the daily adoption limit nor the adoptability rule applies here.
         */
        getMutationKey(parameters: DeepReadonly<PassOnStudentParameters> | void): ServiceOperationMutationKey<PassOnStudentSchema, PassOnStudentParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Pass On Student
         * @description Release this helper's groups' claims on a lead.
         *
         * Clears the student's matched web targets in every group the caller
         * moderates, and their matched campaign when the caller moderates its group;
         * the student stays on the open board for another helper. The student must be
         * on an active board item and must not already have a study helper. Neither
         * the daily adoption limit nor the adoptability rule applies here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.passOnStudent.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.passOnStudent.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends PassOnStudentBody, TContext = unknown>(parameters: DeepReadonly<PassOnStudentParameters>, options?: ServiceOperationUseMutationOptions<PassOnStudentSchema, PassOnStudentData, PassOnStudentParameters, TVariables, OperationError<PassOnStudentError>, TContext>): UseMutationResult<PassOnStudentData, OperationError<PassOnStudentError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Pass On Student
         * @description Release this helper's groups' claims on a lead.
         *
         * Clears the student's matched web targets in every group the caller
         * moderates, and their matched campaign when the caller moderates its group;
         * the student stays on the open board for another helper. The student must be
         * on an active board item and must not already have a study helper. Neither
         * the daily adoption limit nor the adoptability rule applies here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.passOnStudent.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.passOnStudent.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<PassOnStudentBody, PassOnStudentParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<PassOnStudentSchema, PassOnStudentData, PassOnStudentParameters, TVariables, OperationError<PassOnStudentError>, TContext>): UseMutationResult<PassOnStudentData, OperationError<PassOnStudentError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Pass On Student
         * @description Release this helper's groups' claims on a lead.
         *
         * Clears the student's matched web targets in every group the caller
         * moderates, and their matched campaign when the caller moderates its group;
         * the student stays on the open board for another helper. The student must be
         * on an active board item and must not already have a study helper. Neither
         * the daily adoption limit nor the adoptability rule applies here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const passOnStudentTotal = qraft.v3Service.passOnStudent.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const passOnStudentTotal = qraft.v3Service.passOnStudent.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext> | MutationFiltersByMutationKey<PassOnStudentSchema, PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Pass On Student
         * @description Release this helper's groups' claims on a lead.
         *
         * Clears the student's matched web targets in every group the caller
         * moderates, and their matched campaign when the caller moderates its group;
         * the student stays on the open board for another helper. The student must be
         * on an active board item and must not already have a study helper. Neither
         * the daily adoption limit nor the adoptability rule applies here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const passOnStudentPendingMutationVariables = qraft.v3Service.passOnStudent.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const passOnStudentMutationData = qraft.v3Service.passOnStudent.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<PassOnStudentData, OperationError<PassOnStudentError>, MutationVariables<PassOnStudentBody, PassOnStudentParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext> | MutationFiltersByMutationKey<PassOnStudentSchema, PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext>;
            select?: (mutation: Mutation<PassOnStudentData, OperationError<PassOnStudentError>, MutationVariables<PassOnStudentBody, PassOnStudentParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Pass On Student
         * @description Release this helper's groups' claims on a lead.
         *
         * Clears the student's matched web targets in every group the caller
         * moderates, and their matched campaign when the caller moderates its group;
         * the student stays on the open board for another helper. The student must be
         * on an active board item and must not already have a study helper. Neither
         * the daily adoption limit nor the adoptability rule applies here.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext> | MutationFiltersByMutationKey<PassOnStudentSchema, PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Pass On Student
         * @description Release this helper's groups' claims on a lead.
         *
         * Clears the student's matched web targets in every group the caller
         * moderates, and their matched campaign when the caller moderates its group;
         * the student stays on the open board for another helper. The student must be
         * on an active board item and must not already have a study helper. Neither
         * the daily adoption limit nor the adoptability rule applies here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.passOnStudent.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.passOnStudent.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext> | MutationFiltersByMutationKey<PassOnStudentSchema, PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext>): Mutation<PassOnStudentData, PassOnStudentError, MutationVariables<PassOnStudentBody, PassOnStudentParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext> | MutationFiltersByMutationKey<PassOnStudentSchema, PassOnStudentBody, PassOnStudentData, PassOnStudentParameters, OperationError<PassOnStudentError>, TContext>): Array<Mutation<PassOnStudentData, PassOnStudentError, MutationVariables<PassOnStudentBody, PassOnStudentParameters>, TContext>>;
        };
        schema: PassOnStudentSchema;
        types: {
            parameters: PassOnStudentParameters;
            data: PassOnStudentData;
            error: PassOnStudentError;
            body: PassOnStudentBody;
        };
    };
    /**
     * @summary Get Assign Candidates
     * @description The assign modal's study-helper picker: the posted target's own leaders.
     *
     * The admin and mod members of the group the SELECTED target belongs to, minus
     * the caller, searched by name. The picker is bound to the target rather than
     * to the student, and the posted target is validated against the student's own
     * claim set and the caller's ADMIN groups.
     */
    getAssignCandidates: {
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetAssignCandidatesParameters, TMeta, TSignal>), client?: (schema: GetAssignCandidatesSchema, options: {
            parameters: GetAssignCandidatesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetAssignCandidatesData, GetAssignCandidatesError>>): Promise<RequestFnResponse<GetAssignCandidatesData, GetAssignCandidatesError>>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        getQueryKey(parameters: DeepReadonly<GetAssignCandidatesParameters>): ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getAssignCandidates.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         campaign_id: campaignId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetAssignCandidatesData>(parameters: ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>), options?: Omit<UndefinedInitialDataOptions<GetAssignCandidatesData, GetAssignCandidatesError, TData, ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetAssignCandidatesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getAssignCandidates.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         campaign_id: campaignId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetAssignCandidatesData>(parameters: ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>), options: Omit<DefinedInitialDataOptions<GetAssignCandidatesData, GetAssignCandidatesError, TData, ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetAssignCandidatesError>>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetAssignCandidatesParameters>): ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getAssignCandidates.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             campaign_id: initialCampaignId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetAssignCandidatesParameters, TQueryFnData = GetAssignCandidatesData, TData = OperationInfiniteData<TQueryFnData, GetAssignCandidatesParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetAssignCandidatesError, TData, ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetAssignCandidatesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getAssignCandidates.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             campaign_id: initialCampaignId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetAssignCandidatesParameters, TQueryFnData = GetAssignCandidatesData, TData = OperationInfiniteData<TQueryFnData, GetAssignCandidatesParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetAssignCandidatesError, TData, ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetAssignCandidatesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetAssignCandidatesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getAssignCandidatesTotal = qraft.v3Service.getAssignCandidates.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getAssignCandidatesByParametersTotal = qraft.v3Service.getAssignCandidates.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             campaign_id: campaignId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError> | QueryFiltersByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getAssignCandidatesResults = qraft.v3Service.getAssignCandidates.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 campaign_id: campaignId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 campaign_id: campaignId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getAssignCandidatesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getAssignCandidatesCombinedResults = qraft.v3Service.getAssignCandidates.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 campaign_id: campaignId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 campaign_id: campaignId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getAssignCandidatesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetAssignCandidatesSchema, GetAssignCandidatesParameters, GetAssignCandidatesData, GetAssignCandidatesError>>, TCombinedResult = Array<UseQueryResult<GetAssignCandidatesData, GetAssignCandidatesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetAssignCandidatesData, GetAssignCandidatesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getAssignCandidates.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         campaign_id: campaignId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetAssignCandidatesData>(parameters: ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>), options?: Omit<UseSuspenseQueryOptions<GetAssignCandidatesData, GetAssignCandidatesError, TData, ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetAssignCandidatesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getAssignCandidates.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             campaign_id: initialCampaignId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetAssignCandidatesParameters, TData = GetAssignCandidatesData>(parameters: ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetAssignCandidatesData, GetAssignCandidatesError, OperationInfiniteData<TData, GetAssignCandidatesParameters>, ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetAssignCandidatesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetAssignCandidatesParameters>, OperationError<GetAssignCandidatesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getAssignCandidatesData = qraft.v3Service.getAssignCandidates.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 campaign_id: campaignId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 campaign_id: campaignId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getAssignCandidatesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getAssignCandidatesCombinedData = qraft.v3Service.getAssignCandidates.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 campaign_id: campaignId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 campaign_id: campaignId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getAssignCandidatesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetAssignCandidatesSchema, GetAssignCandidatesParameters, GetAssignCandidatesData, GetAssignCandidatesError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetAssignCandidatesData, GetAssignCandidatesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetAssignCandidatesData, GetAssignCandidatesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetAssignCandidatesSchema, GetAssignCandidatesData, GetAssignCandidatesParameters, GetAssignCandidatesError>): Promise<GetAssignCandidatesData>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetAssignCandidatesSchema, GetAssignCandidatesData, GetAssignCandidatesParameters, GetAssignCandidatesError>): Promise<void>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetAssignCandidatesSchema, GetAssignCandidatesData, GetAssignCandidatesParameters, GetAssignCandidatesError>): Promise<GetAssignCandidatesData>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        fetchInfiniteQuery<TPageParam extends GetAssignCandidatesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetAssignCandidatesSchema, GetAssignCandidatesData, GetAssignCandidatesParameters, DeepReadonly<TPageParam>, GetAssignCandidatesError>): Promise<OperationInfiniteData<GetAssignCandidatesData, GetAssignCandidatesParameters>>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        prefetchInfiniteQuery<TPageParam extends GetAssignCandidatesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetAssignCandidatesSchema, GetAssignCandidatesData, GetAssignCandidatesParameters, DeepReadonly<TPageParam>, GetAssignCandidatesError>): Promise<void>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        ensureInfiniteQueryData<TPageParam extends GetAssignCandidatesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetAssignCandidatesSchema, GetAssignCandidatesData, GetAssignCandidatesParameters, DeepReadonly<TPageParam>, GetAssignCandidatesError>): Promise<OperationInfiniteData<GetAssignCandidatesData, GetAssignCandidatesParameters>>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>)): GetAssignCandidatesData | undefined;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>)): OperationInfiniteData<GetAssignCandidatesData, GetAssignCandidatesParameters> | undefined;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError> | QueryFiltersByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>,
            data: NoInfer<OperationInfiniteData<GetAssignCandidatesData, GetAssignCandidatesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>,
            data: GetAssignCandidatesData | undefined
        ]>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters> | (DeepReadonly<GetAssignCandidatesParameters>)): QueryState<GetAssignCandidatesData, GetAssignCandidatesError> | undefined;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetAssignCandidatesParameters> | ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>): QueryState<OperationInfiniteData<GetAssignCandidatesData, GetAssignCandidatesParameters>, GetAssignCandidatesError> | undefined;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        setQueryData(parameters: (DeepReadonly<GetAssignCandidatesParameters>) | ServiceOperationQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>, updater: Updater<NoInfer<GetAssignCandidatesData> | undefined, NoInfer<DeepReadonly<GetAssignCandidatesData>> | undefined>, options?: SetDataOptions): GetAssignCandidatesData | undefined;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetAssignCandidatesParameters>) | ServiceOperationInfiniteQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetAssignCandidatesData, GetAssignCandidatesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetAssignCandidatesData, GetAssignCandidatesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetAssignCandidatesData, GetAssignCandidatesParameters> | undefined;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError> | QueryFiltersByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>, updater: Updater<NoInfer<GetAssignCandidatesData> | undefined, NoInfer<GetAssignCandidatesData> | undefined>, options?: SetDataOptions): Array<GetAssignCandidatesData | undefined>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError> | QueryFiltersByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError> | QueryFiltersByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError> | QueryFiltersByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>): void;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError> | QueryFiltersByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Assign Candidates
         * @description The assign modal's study-helper picker: the posted target's own leaders.
         *
         * The admin and mod members of the group the SELECTED target belongs to, minus
         * the caller, searched by name. The picker is bound to the target rather than
         * to the student, and the posted target is validated against the student's own
         * claim set and the caller's ADMIN groups.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError> | QueryFiltersByQueryKey<GetAssignCandidatesSchema, GetAssignCandidatesData, TInfinite, GetAssignCandidatesParameters, GetAssignCandidatesError>): number;
        schema: GetAssignCandidatesSchema;
        types: {
            parameters: GetAssignCandidatesParameters;
            data: GetAssignCandidatesData;
            error: GetAssignCandidatesError;
        };
    };
    /**
     * @summary Assign Student
     * @description Adopt a board student on behalf of one of the claiming group's leaders.
     *
     * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
     * emailed. Each gate is commented at its line.
     */
    assignStudent: {
        /**
         * @summary Assign Student
         * @description Adopt a board student on behalf of one of the claiming group's leaders.
         *
         * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
         * emailed. Each gate is commented at its line.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AssignStudentBody, AssignStudentParameters, TMeta, TSignal>, client?: (schema: AssignStudentSchema, options: ServiceOperationMutationFnOptions<AssignStudentBody, AssignStudentParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AssignStudentData, AssignStudentError>>): Promise<RequestFnResponse<AssignStudentData, AssignStudentError>>;
        /**
         * @summary Assign Student
         * @description Adopt a board student on behalf of one of the claiming group's leaders.
         *
         * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
         * emailed. Each gate is commented at its line.
         */
        getMutationKey(parameters: DeepReadonly<AssignStudentParameters> | void): ServiceOperationMutationKey<AssignStudentSchema, AssignStudentParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Assign Student
         * @description Adopt a board student on behalf of one of the claiming group's leaders.
         *
         * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
         * emailed. Each gate is commented at its line.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.assignStudent.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.assignStudent.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AssignStudentBody, TContext = unknown>(parameters: DeepReadonly<AssignStudentParameters>, options?: ServiceOperationUseMutationOptions<AssignStudentSchema, AssignStudentData, AssignStudentParameters, TVariables, OperationError<AssignStudentError>, TContext>): UseMutationResult<AssignStudentData, OperationError<AssignStudentError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Assign Student
         * @description Adopt a board student on behalf of one of the claiming group's leaders.
         *
         * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
         * emailed. Each gate is commented at its line.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.assignStudent.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.assignStudent.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AssignStudentBody, AssignStudentParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AssignStudentSchema, AssignStudentData, AssignStudentParameters, TVariables, OperationError<AssignStudentError>, TContext>): UseMutationResult<AssignStudentData, OperationError<AssignStudentError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Assign Student
         * @description Adopt a board student on behalf of one of the claiming group's leaders.
         *
         * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
         * emailed. Each gate is commented at its line.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const assignStudentTotal = qraft.v3Service.assignStudent.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const assignStudentTotal = qraft.v3Service.assignStudent.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext> | MutationFiltersByMutationKey<AssignStudentSchema, AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Assign Student
         * @description Adopt a board student on behalf of one of the claiming group's leaders.
         *
         * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
         * emailed. Each gate is commented at its line.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const assignStudentPendingMutationVariables = qraft.v3Service.assignStudent.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const assignStudentMutationData = qraft.v3Service.assignStudent.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AssignStudentData, OperationError<AssignStudentError>, MutationVariables<AssignStudentBody, AssignStudentParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext> | MutationFiltersByMutationKey<AssignStudentSchema, AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext>;
            select?: (mutation: Mutation<AssignStudentData, OperationError<AssignStudentError>, MutationVariables<AssignStudentBody, AssignStudentParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Assign Student
         * @description Adopt a board student on behalf of one of the claiming group's leaders.
         *
         * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
         * emailed. Each gate is commented at its line.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext> | MutationFiltersByMutationKey<AssignStudentSchema, AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Assign Student
         * @description Adopt a board student on behalf of one of the claiming group's leaders.
         *
         * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
         * emailed. Each gate is commented at its line.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.assignStudent.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.assignStudent.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext> | MutationFiltersByMutationKey<AssignStudentSchema, AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext>): Mutation<AssignStudentData, AssignStudentError, MutationVariables<AssignStudentBody, AssignStudentParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext> | MutationFiltersByMutationKey<AssignStudentSchema, AssignStudentBody, AssignStudentData, AssignStudentParameters, OperationError<AssignStudentError>, TContext>): Array<Mutation<AssignStudentData, AssignStudentError, MutationVariables<AssignStudentBody, AssignStudentParameters>, TContext>>;
        };
        schema: AssignStudentSchema;
        types: {
            parameters: AssignStudentParameters;
            data: AssignStudentData;
            error: AssignStudentError;
            body: AssignStudentBody;
        };
    };
    /**
     * @summary Create Adoption Request
     * @description Ask a study helper to adopt you, or to take you over from your current one.
     *
     * A student with no study helper creates an adoption request; a student who
     * already has one creates a SWITCH request, which carries a reason. The two are
     * the same row and the same accept.
     */
    createAdoptionRequest: {
        /**
         * @summary Create Adoption Request
         * @description Ask a study helper to adopt you, or to take you over from your current one.
         *
         * A student with no study helper creates an adoption request; a student who
         * already has one creates a SWITCH request, which carries a reason. The two are
         * the same row and the same accept.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateAdoptionRequestBody, CreateAdoptionRequestParameters, TMeta, TSignal>, client?: (schema: CreateAdoptionRequestSchema, options: ServiceOperationMutationFnOptions<CreateAdoptionRequestBody, CreateAdoptionRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateAdoptionRequestData, CreateAdoptionRequestError>>): Promise<RequestFnResponse<CreateAdoptionRequestData, CreateAdoptionRequestError>>;
        /**
         * @summary Create Adoption Request
         * @description Ask a study helper to adopt you, or to take you over from your current one.
         *
         * A student with no study helper creates an adoption request; a student who
         * already has one creates a SWITCH request, which carries a reason. The two are
         * the same row and the same accept.
         */
        getMutationKey(parameters: DeepReadonly<CreateAdoptionRequestParameters> | void): ServiceOperationMutationKey<CreateAdoptionRequestSchema, CreateAdoptionRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Adoption Request
         * @description Ask a study helper to adopt you, or to take you over from your current one.
         *
         * A student with no study helper creates an adoption request; a student who
         * already has one creates a SWITCH request, which carries a reason. The two are
         * the same row and the same accept.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createAdoptionRequest.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createAdoptionRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateAdoptionRequestBody, TContext = unknown>(parameters: DeepReadonly<CreateAdoptionRequestParameters>, options?: ServiceOperationUseMutationOptions<CreateAdoptionRequestSchema, CreateAdoptionRequestData, CreateAdoptionRequestParameters, TVariables, OperationError<CreateAdoptionRequestError>, TContext>): UseMutationResult<CreateAdoptionRequestData, OperationError<CreateAdoptionRequestError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Adoption Request
         * @description Ask a study helper to adopt you, or to take you over from your current one.
         *
         * A student with no study helper creates an adoption request; a student who
         * already has one creates a SWITCH request, which carries a reason. The two are
         * the same row and the same accept.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createAdoptionRequest.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createAdoptionRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateAdoptionRequestBody, CreateAdoptionRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateAdoptionRequestSchema, CreateAdoptionRequestData, CreateAdoptionRequestParameters, TVariables, OperationError<CreateAdoptionRequestError>, TContext>): UseMutationResult<CreateAdoptionRequestData, OperationError<CreateAdoptionRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Adoption Request
         * @description Ask a study helper to adopt you, or to take you over from your current one.
         *
         * A student with no study helper creates an adoption request; a student who
         * already has one creates a SWITCH request, which carries a reason. The two are
         * the same row and the same accept.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createAdoptionRequestTotal = qraft.v3Service.createAdoptionRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createAdoptionRequestTotal = qraft.v3Service.createAdoptionRequest.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<CreateAdoptionRequestSchema, CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Adoption Request
         * @description Ask a study helper to adopt you, or to take you over from your current one.
         *
         * A student with no study helper creates an adoption request; a student who
         * already has one creates a SWITCH request, which carries a reason. The two are
         * the same row and the same accept.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createAdoptionRequestPendingMutationVariables = qraft.v3Service.createAdoptionRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createAdoptionRequestMutationData = qraft.v3Service.createAdoptionRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateAdoptionRequestData, OperationError<CreateAdoptionRequestError>, MutationVariables<CreateAdoptionRequestBody, CreateAdoptionRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<CreateAdoptionRequestSchema, CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext>;
            select?: (mutation: Mutation<CreateAdoptionRequestData, OperationError<CreateAdoptionRequestError>, MutationVariables<CreateAdoptionRequestBody, CreateAdoptionRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Adoption Request
         * @description Ask a study helper to adopt you, or to take you over from your current one.
         *
         * A student with no study helper creates an adoption request; a student who
         * already has one creates a SWITCH request, which carries a reason. The two are
         * the same row and the same accept.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<CreateAdoptionRequestSchema, CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Adoption Request
         * @description Ask a study helper to adopt you, or to take you over from your current one.
         *
         * A student with no study helper creates an adoption request; a student who
         * already has one creates a SWITCH request, which carries a reason. The two are
         * the same row and the same accept.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createAdoptionRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createAdoptionRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<CreateAdoptionRequestSchema, CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext>): Mutation<CreateAdoptionRequestData, CreateAdoptionRequestError, MutationVariables<CreateAdoptionRequestBody, CreateAdoptionRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<CreateAdoptionRequestSchema, CreateAdoptionRequestBody, CreateAdoptionRequestData, CreateAdoptionRequestParameters, OperationError<CreateAdoptionRequestError>, TContext>): Array<Mutation<CreateAdoptionRequestData, CreateAdoptionRequestError, MutationVariables<CreateAdoptionRequestBody, CreateAdoptionRequestParameters>, TContext>>;
        };
        schema: CreateAdoptionRequestSchema;
        types: {
            parameters: CreateAdoptionRequestParameters;
            data: CreateAdoptionRequestData;
            error: CreateAdoptionRequestError;
            body: CreateAdoptionRequestBody;
        };
    };
    /**
     * @summary Get Adoption Requests
     * @description Pending adoption requests, helper-scoped or group-scoped.
     *
     * Without `group_id`, the caller's own requests (the dashboard widget). With
     * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
     * group's leaders.
     */
    getAdoptionRequests: {
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetAdoptionRequestsParameters, TMeta, TSignal> | void), client?: (schema: GetAdoptionRequestsSchema, options: {
            parameters: GetAdoptionRequestsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetAdoptionRequestsData, GetAdoptionRequestsError>>): Promise<RequestFnResponse<GetAdoptionRequestsData, GetAdoptionRequestsError>>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        getQueryKey(parameters: DeepReadonly<GetAdoptionRequestsParameters> | void): ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getAdoptionRequests.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getAdoptionRequests.useQuery({
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetAdoptionRequestsData>(parameters: ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetAdoptionRequestsData, GetAdoptionRequestsError, TData, ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetAdoptionRequestsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getAdoptionRequests.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getAdoptionRequests.useQuery({
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetAdoptionRequestsData>(parameters: ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void), options: Omit<DefinedInitialDataOptions<GetAdoptionRequestsData, GetAdoptionRequestsError, TData, ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetAdoptionRequestsError>>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetAdoptionRequestsParameters> | void): ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getAdoptionRequests.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetAdoptionRequestsParameters, TQueryFnData = GetAdoptionRequestsData, TData = OperationInfiniteData<TQueryFnData, GetAdoptionRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetAdoptionRequestsError, TData, ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetAdoptionRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getAdoptionRequests.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetAdoptionRequestsParameters, TQueryFnData = GetAdoptionRequestsData, TData = OperationInfiniteData<TQueryFnData, GetAdoptionRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetAdoptionRequestsError, TData, ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetAdoptionRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetAdoptionRequestsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getAdoptionRequestsTotal = qraft.v3Service.getAdoptionRequests.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getAdoptionRequestsByParametersTotal = qraft.v3Service.getAdoptionRequests.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | QueryFiltersByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getAdoptionRequestsResults = qraft.v3Service.getAdoptionRequests.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getAdoptionRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getAdoptionRequestsCombinedResults = qraft.v3Service.getAdoptionRequests.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getAdoptionRequestsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters, GetAdoptionRequestsData, GetAdoptionRequestsError>>, TCombinedResult = Array<UseQueryResult<GetAdoptionRequestsData, GetAdoptionRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetAdoptionRequestsData, GetAdoptionRequestsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getAdoptionRequests.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getAdoptionRequests.useSuspenseQuery({
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetAdoptionRequestsData>(parameters: ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetAdoptionRequestsData, GetAdoptionRequestsError, TData, ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetAdoptionRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getAdoptionRequests.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetAdoptionRequestsParameters, TData = GetAdoptionRequestsData>(parameters: ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetAdoptionRequestsData, GetAdoptionRequestsError, OperationInfiniteData<TData, GetAdoptionRequestsParameters>, ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetAdoptionRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetAdoptionRequestsParameters>, OperationError<GetAdoptionRequestsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getAdoptionRequestsData = qraft.v3Service.getAdoptionRequests.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getAdoptionRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getAdoptionRequestsCombinedData = qraft.v3Service.getAdoptionRequests.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getAdoptionRequestsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters, GetAdoptionRequestsData, GetAdoptionRequestsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetAdoptionRequestsData, GetAdoptionRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetAdoptionRequestsData, GetAdoptionRequestsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetAdoptionRequestsSchema, GetAdoptionRequestsData, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | void): Promise<GetAdoptionRequestsData>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetAdoptionRequestsSchema, GetAdoptionRequestsData, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | void): Promise<void>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetAdoptionRequestsSchema, GetAdoptionRequestsData, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | void): Promise<GetAdoptionRequestsData>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        fetchInfiniteQuery<TPageParam extends GetAdoptionRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetAdoptionRequestsSchema, GetAdoptionRequestsData, GetAdoptionRequestsParameters, DeepReadonly<TPageParam>, GetAdoptionRequestsError> | void): Promise<OperationInfiniteData<GetAdoptionRequestsData, GetAdoptionRequestsParameters>>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        prefetchInfiniteQuery<TPageParam extends GetAdoptionRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetAdoptionRequestsSchema, GetAdoptionRequestsData, GetAdoptionRequestsParameters, DeepReadonly<TPageParam>, GetAdoptionRequestsError> | void): Promise<void>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        ensureInfiniteQueryData<TPageParam extends GetAdoptionRequestsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetAdoptionRequestsSchema, GetAdoptionRequestsData, GetAdoptionRequestsParameters, DeepReadonly<TPageParam>, GetAdoptionRequestsError> | void): Promise<OperationInfiniteData<GetAdoptionRequestsData, GetAdoptionRequestsParameters>>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void)): GetAdoptionRequestsData | undefined;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void)): OperationInfiniteData<GetAdoptionRequestsData, GetAdoptionRequestsParameters> | undefined;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | QueryFiltersByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>,
            data: NoInfer<OperationInfiniteData<GetAdoptionRequestsData, GetAdoptionRequestsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>,
            data: GetAdoptionRequestsData | undefined
        ]>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | (DeepReadonly<GetAdoptionRequestsParameters> | void)): QueryState<GetAdoptionRequestsData, GetAdoptionRequestsError> | undefined;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetAdoptionRequestsParameters> | ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters> | void): QueryState<OperationInfiniteData<GetAdoptionRequestsData, GetAdoptionRequestsParameters>, GetAdoptionRequestsError> | undefined;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        setQueryData(parameters: (DeepReadonly<GetAdoptionRequestsParameters> | undefined) | ServiceOperationQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>, updater: Updater<NoInfer<GetAdoptionRequestsData> | undefined, NoInfer<DeepReadonly<GetAdoptionRequestsData>> | undefined>, options?: SetDataOptions): GetAdoptionRequestsData | undefined;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetAdoptionRequestsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetAdoptionRequestsData, GetAdoptionRequestsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetAdoptionRequestsData, GetAdoptionRequestsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetAdoptionRequestsData, GetAdoptionRequestsParameters> | undefined;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | QueryFiltersByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>, updater: Updater<NoInfer<GetAdoptionRequestsData> | undefined, NoInfer<GetAdoptionRequestsData> | undefined>, options?: SetDataOptions): Array<GetAdoptionRequestsData | undefined>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | QueryFiltersByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | QueryFiltersByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | QueryFiltersByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>): void;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | QueryFiltersByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Adoption Requests
         * @description Pending adoption requests, helper-scoped or group-scoped.
         *
         * Without `group_id`, the caller's own requests (the dashboard widget). With
         * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
         * group's leaders.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError> | QueryFiltersByQueryKey<GetAdoptionRequestsSchema, GetAdoptionRequestsData, TInfinite, GetAdoptionRequestsParameters, GetAdoptionRequestsError>): number;
        schema: GetAdoptionRequestsSchema;
        types: {
            parameters: GetAdoptionRequestsParameters;
            data: GetAdoptionRequestsData;
            error: GetAdoptionRequestsError;
        };
    };
    /**
     * @summary Accept Adoption Request
     * @description Accept a request addressed to you, adopting or reassigning the student.
     */
    acceptAdoptionRequest: {
        /**
         * @summary Accept Adoption Request
         * @description Accept a request addressed to you, adopting or reassigning the student.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AcceptAdoptionRequestBody, AcceptAdoptionRequestParameters, TMeta, TSignal>, client?: (schema: AcceptAdoptionRequestSchema, options: ServiceOperationMutationFnOptions<AcceptAdoptionRequestBody, AcceptAdoptionRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AcceptAdoptionRequestData, AcceptAdoptionRequestError>>): Promise<RequestFnResponse<AcceptAdoptionRequestData, AcceptAdoptionRequestError>>;
        /**
         * @summary Accept Adoption Request
         * @description Accept a request addressed to you, adopting or reassigning the student.
         */
        getMutationKey(parameters: DeepReadonly<AcceptAdoptionRequestParameters> | void): ServiceOperationMutationKey<AcceptAdoptionRequestSchema, AcceptAdoptionRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Accept Adoption Request
         * @description Accept a request addressed to you, adopting or reassigning the student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.acceptAdoptionRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.acceptAdoptionRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AcceptAdoptionRequestBody, TContext = unknown>(parameters: DeepReadonly<AcceptAdoptionRequestParameters>, options?: ServiceOperationUseMutationOptions<AcceptAdoptionRequestSchema, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, TVariables, OperationError<AcceptAdoptionRequestError>, TContext>): UseMutationResult<AcceptAdoptionRequestData, OperationError<AcceptAdoptionRequestError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Accept Adoption Request
         * @description Accept a request addressed to you, adopting or reassigning the student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.acceptAdoptionRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.acceptAdoptionRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AcceptAdoptionRequestBody, AcceptAdoptionRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AcceptAdoptionRequestSchema, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, TVariables, OperationError<AcceptAdoptionRequestError>, TContext>): UseMutationResult<AcceptAdoptionRequestData, OperationError<AcceptAdoptionRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Accept Adoption Request
         * @description Accept a request addressed to you, adopting or reassigning the student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const acceptAdoptionRequestTotal = qraft.v3Service.acceptAdoptionRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const acceptAdoptionRequestTotal = qraft.v3Service.acceptAdoptionRequest.useIsMutating({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestSchema, AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Accept Adoption Request
         * @description Accept a request addressed to you, adopting or reassigning the student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const acceptAdoptionRequestPendingMutationVariables = qraft.v3Service.acceptAdoptionRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const acceptAdoptionRequestMutationData = qraft.v3Service.acceptAdoptionRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 request_id: requestId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AcceptAdoptionRequestData, OperationError<AcceptAdoptionRequestError>, MutationVariables<AcceptAdoptionRequestBody, AcceptAdoptionRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestSchema, AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext>;
            select?: (mutation: Mutation<AcceptAdoptionRequestData, OperationError<AcceptAdoptionRequestError>, MutationVariables<AcceptAdoptionRequestBody, AcceptAdoptionRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Accept Adoption Request
         * @description Accept a request addressed to you, adopting or reassigning the student.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestSchema, AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Accept Adoption Request
         * @description Accept a request addressed to you, adopting or reassigning the student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.acceptAdoptionRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.acceptAdoptionRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestSchema, AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext>): Mutation<AcceptAdoptionRequestData, AcceptAdoptionRequestError, MutationVariables<AcceptAdoptionRequestBody, AcceptAdoptionRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestSchema, AcceptAdoptionRequestBody, AcceptAdoptionRequestData, AcceptAdoptionRequestParameters, OperationError<AcceptAdoptionRequestError>, TContext>): Array<Mutation<AcceptAdoptionRequestData, AcceptAdoptionRequestError, MutationVariables<AcceptAdoptionRequestBody, AcceptAdoptionRequestParameters>, TContext>>;
        };
        schema: AcceptAdoptionRequestSchema;
        types: {
            parameters: AcceptAdoptionRequestParameters;
            data: AcceptAdoptionRequestData;
            error: AcceptAdoptionRequestError;
            body: AcceptAdoptionRequestBody;
        };
    };
    /**
     * @summary Decline Adoption Request
     * @description Decline a request addressed to you, and block this pair from re-requesting.
     */
    declineAdoptionRequest: {
        /**
         * @summary Decline Adoption Request
         * @description Decline a request addressed to you, and block this pair from re-requesting.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeclineAdoptionRequestBody, DeclineAdoptionRequestParameters, TMeta, TSignal>, client?: (schema: DeclineAdoptionRequestSchema, options: ServiceOperationMutationFnOptions<DeclineAdoptionRequestBody, DeclineAdoptionRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeclineAdoptionRequestData, DeclineAdoptionRequestError>>): Promise<RequestFnResponse<DeclineAdoptionRequestData, DeclineAdoptionRequestError>>;
        /**
         * @summary Decline Adoption Request
         * @description Decline a request addressed to you, and block this pair from re-requesting.
         */
        getMutationKey(parameters: DeepReadonly<DeclineAdoptionRequestParameters> | void): ServiceOperationMutationKey<DeclineAdoptionRequestSchema, DeclineAdoptionRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Decline Adoption Request
         * @description Decline a request addressed to you, and block this pair from re-requesting.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.declineAdoptionRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.declineAdoptionRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeclineAdoptionRequestBody, TContext = unknown>(parameters: DeepReadonly<DeclineAdoptionRequestParameters>, options?: ServiceOperationUseMutationOptions<DeclineAdoptionRequestSchema, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, TVariables, OperationError<DeclineAdoptionRequestError>, TContext>): UseMutationResult<DeclineAdoptionRequestData, OperationError<DeclineAdoptionRequestError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Decline Adoption Request
         * @description Decline a request addressed to you, and block this pair from re-requesting.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.declineAdoptionRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.declineAdoptionRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeclineAdoptionRequestBody, DeclineAdoptionRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeclineAdoptionRequestSchema, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, TVariables, OperationError<DeclineAdoptionRequestError>, TContext>): UseMutationResult<DeclineAdoptionRequestData, OperationError<DeclineAdoptionRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Decline Adoption Request
         * @description Decline a request addressed to you, and block this pair from re-requesting.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const declineAdoptionRequestTotal = qraft.v3Service.declineAdoptionRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const declineAdoptionRequestTotal = qraft.v3Service.declineAdoptionRequest.useIsMutating({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestSchema, DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Decline Adoption Request
         * @description Decline a request addressed to you, and block this pair from re-requesting.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const declineAdoptionRequestPendingMutationVariables = qraft.v3Service.declineAdoptionRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const declineAdoptionRequestMutationData = qraft.v3Service.declineAdoptionRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 request_id: requestId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeclineAdoptionRequestData, OperationError<DeclineAdoptionRequestError>, MutationVariables<DeclineAdoptionRequestBody, DeclineAdoptionRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestSchema, DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext>;
            select?: (mutation: Mutation<DeclineAdoptionRequestData, OperationError<DeclineAdoptionRequestError>, MutationVariables<DeclineAdoptionRequestBody, DeclineAdoptionRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Decline Adoption Request
         * @description Decline a request addressed to you, and block this pair from re-requesting.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestSchema, DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Decline Adoption Request
         * @description Decline a request addressed to you, and block this pair from re-requesting.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.declineAdoptionRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.declineAdoptionRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestSchema, DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext>): Mutation<DeclineAdoptionRequestData, DeclineAdoptionRequestError, MutationVariables<DeclineAdoptionRequestBody, DeclineAdoptionRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestSchema, DeclineAdoptionRequestBody, DeclineAdoptionRequestData, DeclineAdoptionRequestParameters, OperationError<DeclineAdoptionRequestError>, TContext>): Array<Mutation<DeclineAdoptionRequestData, DeclineAdoptionRequestError, MutationVariables<DeclineAdoptionRequestBody, DeclineAdoptionRequestParameters>, TContext>>;
        };
        schema: DeclineAdoptionRequestSchema;
        types: {
            parameters: DeclineAdoptionRequestParameters;
            data: DeclineAdoptionRequestData;
            error: DeclineAdoptionRequestError;
            body: DeclineAdoptionRequestBody;
        };
    };
    /**
     * @summary Send Encouragement
     * @description Send one written encouragement to a student on the open board.
     *
     * A study helper may encourage a student they have not adopted, once per
     * student, and a student receives at most three in total. The message is
     * stored display-formatted and carries a `scheduled_email_at` that spaces the
     * drip one per student per day.
     */
    sendEncouragement: {
        /**
         * @summary Send Encouragement
         * @description Send one written encouragement to a student on the open board.
         *
         * A study helper may encourage a student they have not adopted, once per
         * student, and a student receives at most three in total. The message is
         * stored display-formatted and carries a `scheduled_email_at` that spaces the
         * drip one per student per day.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SendEncouragementBody, SendEncouragementParameters, TMeta, TSignal>, client?: (schema: SendEncouragementSchema, options: ServiceOperationMutationFnOptions<SendEncouragementBody, SendEncouragementParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SendEncouragementData, SendEncouragementError>>): Promise<RequestFnResponse<SendEncouragementData, SendEncouragementError>>;
        /**
         * @summary Send Encouragement
         * @description Send one written encouragement to a student on the open board.
         *
         * A study helper may encourage a student they have not adopted, once per
         * student, and a student receives at most three in total. The message is
         * stored display-formatted and carries a `scheduled_email_at` that spaces the
         * drip one per student per day.
         */
        getMutationKey(parameters: DeepReadonly<SendEncouragementParameters> | void): ServiceOperationMutationKey<SendEncouragementSchema, SendEncouragementParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Encouragement
         * @description Send one written encouragement to a student on the open board.
         *
         * A study helper may encourage a student they have not adopted, once per
         * student, and a student receives at most three in total. The message is
         * stored display-formatted and carries a `scheduled_email_at` that spaces the
         * drip one per student per day.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendEncouragement.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendEncouragement.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SendEncouragementBody, TContext = unknown>(parameters: DeepReadonly<SendEncouragementParameters>, options?: ServiceOperationUseMutationOptions<SendEncouragementSchema, SendEncouragementData, SendEncouragementParameters, TVariables, OperationError<SendEncouragementError>, TContext>): UseMutationResult<SendEncouragementData, OperationError<SendEncouragementError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Encouragement
         * @description Send one written encouragement to a student on the open board.
         *
         * A study helper may encourage a student they have not adopted, once per
         * student, and a student receives at most three in total. The message is
         * stored display-formatted and carries a `scheduled_email_at` that spaces the
         * drip one per student per day.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendEncouragement.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendEncouragement.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SendEncouragementBody, SendEncouragementParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SendEncouragementSchema, SendEncouragementData, SendEncouragementParameters, TVariables, OperationError<SendEncouragementError>, TContext>): UseMutationResult<SendEncouragementData, OperationError<SendEncouragementError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Send Encouragement
         * @description Send one written encouragement to a student on the open board.
         *
         * A study helper may encourage a student they have not adopted, once per
         * student, and a student receives at most three in total. The message is
         * stored display-formatted and carries a `scheduled_email_at` that spaces the
         * drip one per student per day.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const sendEncouragementTotal = qraft.v3Service.sendEncouragement.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const sendEncouragementTotal = qraft.v3Service.sendEncouragement.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext> | MutationFiltersByMutationKey<SendEncouragementSchema, SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Send Encouragement
         * @description Send one written encouragement to a student on the open board.
         *
         * A study helper may encourage a student they have not adopted, once per
         * student, and a student receives at most three in total. The message is
         * stored display-formatted and carries a `scheduled_email_at` that spaces the
         * drip one per student per day.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const sendEncouragementPendingMutationVariables = qraft.v3Service.sendEncouragement.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const sendEncouragementMutationData = qraft.v3Service.sendEncouragement.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SendEncouragementData, OperationError<SendEncouragementError>, MutationVariables<SendEncouragementBody, SendEncouragementParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext> | MutationFiltersByMutationKey<SendEncouragementSchema, SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext>;
            select?: (mutation: Mutation<SendEncouragementData, OperationError<SendEncouragementError>, MutationVariables<SendEncouragementBody, SendEncouragementParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Send Encouragement
         * @description Send one written encouragement to a student on the open board.
         *
         * A study helper may encourage a student they have not adopted, once per
         * student, and a student receives at most three in total. The message is
         * stored display-formatted and carries a `scheduled_email_at` that spaces the
         * drip one per student per day.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext> | MutationFiltersByMutationKey<SendEncouragementSchema, SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Send Encouragement
         * @description Send one written encouragement to a student on the open board.
         *
         * A study helper may encourage a student they have not adopted, once per
         * student, and a student receives at most three in total. The message is
         * stored display-formatted and carries a `scheduled_email_at` that spaces the
         * drip one per student per day.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.sendEncouragement.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.sendEncouragement.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext> | MutationFiltersByMutationKey<SendEncouragementSchema, SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext>): Mutation<SendEncouragementData, SendEncouragementError, MutationVariables<SendEncouragementBody, SendEncouragementParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext> | MutationFiltersByMutationKey<SendEncouragementSchema, SendEncouragementBody, SendEncouragementData, SendEncouragementParameters, OperationError<SendEncouragementError>, TContext>): Array<Mutation<SendEncouragementData, SendEncouragementError, MutationVariables<SendEncouragementBody, SendEncouragementParameters>, TContext>>;
        };
        schema: SendEncouragementSchema;
        types: {
            parameters: SendEncouragementParameters;
            data: SendEncouragementData;
            error: SendEncouragementError;
            body: SendEncouragementBody;
        };
    };
    /**
     * @summary List Message Threads
     * @description Inbox: the current user's threads, most-recently-active first.
     */
    listMessageThreads: {
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListMessageThreadsParameters, TMeta, TSignal> | void), client?: (schema: ListMessageThreadsSchema, options: {
            parameters: ListMessageThreadsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListMessageThreadsData, ListMessageThreadsError>>): Promise<RequestFnResponse<ListMessageThreadsData, ListMessageThreadsError>>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        getQueryKey(parameters: DeepReadonly<ListMessageThreadsParameters> | void): ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMessageThreads.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMessageThreads.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListMessageThreadsData>(parameters: ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListMessageThreadsData, ListMessageThreadsError, TData, ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListMessageThreadsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMessageThreads.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMessageThreads.useQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListMessageThreadsData>(parameters: ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void), options: Omit<DefinedInitialDataOptions<ListMessageThreadsData, ListMessageThreadsError, TData, ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListMessageThreadsError>>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListMessageThreadsParameters> | void): ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMessageThreads.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListMessageThreadsParameters, TQueryFnData = ListMessageThreadsData, TData = OperationInfiniteData<TQueryFnData, ListMessageThreadsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListMessageThreadsError, TData, ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListMessageThreadsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMessageThreads.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListMessageThreadsParameters, TQueryFnData = ListMessageThreadsData, TData = OperationInfiniteData<TQueryFnData, ListMessageThreadsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListMessageThreadsError, TData, ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListMessageThreadsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListMessageThreadsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listMessageThreadsTotal = qraft.v3Service.listMessageThreads.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listMessageThreadsByParametersTotal = qraft.v3Service.listMessageThreads.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             search: search
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError> | QueryFiltersByQueryKey<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listMessageThreadsResults = qraft.v3Service.listMessageThreads.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMessageThreadsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listMessageThreadsCombinedResults = qraft.v3Service.listMessageThreads.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMessageThreadsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListMessageThreadsSchema, ListMessageThreadsParameters, ListMessageThreadsData, ListMessageThreadsError>>, TCombinedResult = Array<UseQueryResult<ListMessageThreadsData, ListMessageThreadsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListMessageThreadsData, ListMessageThreadsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listMessageThreads.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listMessageThreads.useSuspenseQuery({
         *     query: {
         *         search: search
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListMessageThreadsData>(parameters: ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListMessageThreadsData, ListMessageThreadsError, TData, ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListMessageThreadsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMessageThreads.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             search: initialSearch
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListMessageThreadsParameters, TData = ListMessageThreadsData>(parameters: ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListMessageThreadsData, ListMessageThreadsError, OperationInfiniteData<TData, ListMessageThreadsParameters>, ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListMessageThreadsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListMessageThreadsParameters>, OperationError<ListMessageThreadsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listMessageThreadsData = qraft.v3Service.listMessageThreads.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMessageThreadsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listMessageThreadsCombinedData = qraft.v3Service.listMessageThreads.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 search: search1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 search: search2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMessageThreadsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListMessageThreadsSchema, ListMessageThreadsParameters, ListMessageThreadsData, ListMessageThreadsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListMessageThreadsData, ListMessageThreadsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListMessageThreadsData, ListMessageThreadsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListMessageThreadsSchema, ListMessageThreadsData, ListMessageThreadsParameters, ListMessageThreadsError> | void): Promise<ListMessageThreadsData>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListMessageThreadsSchema, ListMessageThreadsData, ListMessageThreadsParameters, ListMessageThreadsError> | void): Promise<void>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListMessageThreadsSchema, ListMessageThreadsData, ListMessageThreadsParameters, ListMessageThreadsError> | void): Promise<ListMessageThreadsData>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        fetchInfiniteQuery<TPageParam extends ListMessageThreadsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListMessageThreadsSchema, ListMessageThreadsData, ListMessageThreadsParameters, DeepReadonly<TPageParam>, ListMessageThreadsError> | void): Promise<OperationInfiniteData<ListMessageThreadsData, ListMessageThreadsParameters>>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        prefetchInfiniteQuery<TPageParam extends ListMessageThreadsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListMessageThreadsSchema, ListMessageThreadsData, ListMessageThreadsParameters, DeepReadonly<TPageParam>, ListMessageThreadsError> | void): Promise<void>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        ensureInfiniteQueryData<TPageParam extends ListMessageThreadsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListMessageThreadsSchema, ListMessageThreadsData, ListMessageThreadsParameters, DeepReadonly<TPageParam>, ListMessageThreadsError> | void): Promise<OperationInfiniteData<ListMessageThreadsData, ListMessageThreadsParameters>>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void)): ListMessageThreadsData | undefined;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void)): OperationInfiniteData<ListMessageThreadsData, ListMessageThreadsParameters> | undefined;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError> | QueryFiltersByQueryKey<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>,
            data: NoInfer<OperationInfiniteData<ListMessageThreadsData, ListMessageThreadsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>,
            data: ListMessageThreadsData | undefined
        ]>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | (DeepReadonly<ListMessageThreadsParameters> | void)): QueryState<ListMessageThreadsData, ListMessageThreadsError> | undefined;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListMessageThreadsParameters> | ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters> | void): QueryState<OperationInfiniteData<ListMessageThreadsData, ListMessageThreadsParameters>, ListMessageThreadsError> | undefined;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        setQueryData(parameters: (DeepReadonly<ListMessageThreadsParameters> | undefined) | ServiceOperationQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>, updater: Updater<NoInfer<ListMessageThreadsData> | undefined, NoInfer<DeepReadonly<ListMessageThreadsData>> | undefined>, options?: SetDataOptions): ListMessageThreadsData | undefined;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListMessageThreadsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListMessageThreadsSchema, ListMessageThreadsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListMessageThreadsData, ListMessageThreadsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListMessageThreadsData, ListMessageThreadsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListMessageThreadsData, ListMessageThreadsParameters> | undefined;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError> | QueryFiltersByQueryKey<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>, updater: Updater<NoInfer<ListMessageThreadsData> | undefined, NoInfer<ListMessageThreadsData> | undefined>, options?: SetDataOptions): Array<ListMessageThreadsData | undefined>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError> | QueryFiltersByQueryKey<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError> | QueryFiltersByQueryKey<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError> | QueryFiltersByQueryKey<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>): void;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError> | QueryFiltersByQueryKey<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Message Threads
         * @description Inbox: the current user's threads, most-recently-active first.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError> | QueryFiltersByQueryKey<ListMessageThreadsSchema, ListMessageThreadsData, TInfinite, ListMessageThreadsParameters, ListMessageThreadsError>): number;
        schema: ListMessageThreadsSchema;
        types: {
            parameters: ListMessageThreadsParameters;
            data: ListMessageThreadsData;
            error: ListMessageThreadsError;
        };
    };
    /**
     * @summary Create Thread
     * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
     *
     * A new conversation is created recipient-first; an existing 1:1 thread with
     * that user is reused. Reply into an existing thread via
     * ``POST /threads/{thread_id}/messages`` instead.
     */
    createThread: {
        /**
         * @summary Create Thread
         * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
         *
         * A new conversation is created recipient-first; an existing 1:1 thread with
         * that user is reused. Reply into an existing thread via
         * ``POST /threads/{thread_id}/messages`` instead.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateThreadBody, CreateThreadParameters, TMeta, TSignal>, client?: (schema: CreateThreadSchema, options: ServiceOperationMutationFnOptions<CreateThreadBody, CreateThreadParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateThreadData, CreateThreadError>>): Promise<RequestFnResponse<CreateThreadData, CreateThreadError>>;
        /**
         * @summary Create Thread
         * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
         *
         * A new conversation is created recipient-first; an existing 1:1 thread with
         * that user is reused. Reply into an existing thread via
         * ``POST /threads/{thread_id}/messages`` instead.
         */
        getMutationKey(parameters: DeepReadonly<CreateThreadParameters> | void): ServiceOperationMutationKey<CreateThreadSchema, CreateThreadParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Thread
         * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
         *
         * A new conversation is created recipient-first; an existing 1:1 thread with
         * that user is reused. Reply into an existing thread via
         * ``POST /threads/{thread_id}/messages`` instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createThread.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createThread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateThreadBody, TContext = unknown>(parameters: DeepReadonly<CreateThreadParameters>, options?: ServiceOperationUseMutationOptions<CreateThreadSchema, CreateThreadData, CreateThreadParameters, TVariables, OperationError<CreateThreadError>, TContext>): UseMutationResult<CreateThreadData, OperationError<CreateThreadError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Thread
         * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
         *
         * A new conversation is created recipient-first; an existing 1:1 thread with
         * that user is reused. Reply into an existing thread via
         * ``POST /threads/{thread_id}/messages`` instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createThread.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createThread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateThreadBody, CreateThreadParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateThreadSchema, CreateThreadData, CreateThreadParameters, TVariables, OperationError<CreateThreadError>, TContext>): UseMutationResult<CreateThreadData, OperationError<CreateThreadError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Thread
         * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
         *
         * A new conversation is created recipient-first; an existing 1:1 thread with
         * that user is reused. Reply into an existing thread via
         * ``POST /threads/{thread_id}/messages`` instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createThreadTotal = qraft.v3Service.createThread.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createThreadTotal = qraft.v3Service.createThread.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext> | MutationFiltersByMutationKey<CreateThreadSchema, CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Thread
         * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
         *
         * A new conversation is created recipient-first; an existing 1:1 thread with
         * that user is reused. Reply into an existing thread via
         * ``POST /threads/{thread_id}/messages`` instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createThreadPendingMutationVariables = qraft.v3Service.createThread.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createThreadMutationData = qraft.v3Service.createThread.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateThreadData, OperationError<CreateThreadError>, MutationVariables<CreateThreadBody, CreateThreadParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext> | MutationFiltersByMutationKey<CreateThreadSchema, CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext>;
            select?: (mutation: Mutation<CreateThreadData, OperationError<CreateThreadError>, MutationVariables<CreateThreadBody, CreateThreadParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Thread
         * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
         *
         * A new conversation is created recipient-first; an existing 1:1 thread with
         * that user is reused. Reply into an existing thread via
         * ``POST /threads/{thread_id}/messages`` instead.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext> | MutationFiltersByMutationKey<CreateThreadSchema, CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Thread
         * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
         *
         * A new conversation is created recipient-first; an existing 1:1 thread with
         * that user is reused. Reply into an existing thread via
         * ``POST /threads/{thread_id}/messages`` instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createThread.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createThread.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext> | MutationFiltersByMutationKey<CreateThreadSchema, CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext>): Mutation<CreateThreadData, CreateThreadError, MutationVariables<CreateThreadBody, CreateThreadParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext> | MutationFiltersByMutationKey<CreateThreadSchema, CreateThreadBody, CreateThreadData, CreateThreadParameters, OperationError<CreateThreadError>, TContext>): Array<Mutation<CreateThreadData, CreateThreadError, MutationVariables<CreateThreadBody, CreateThreadParameters>, TContext>>;
        };
        schema: CreateThreadSchema;
        types: {
            parameters: CreateThreadParameters;
            data: CreateThreadData;
            error: CreateThreadError;
            body: CreateThreadBody;
        };
    };
    /**
     * @summary Get Unread Message Count
     * @description Total unread messages — the header envelope badge.
     */
    getUnreadMessageCount: {
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetUnreadMessageCountParameters, TMeta, TSignal> | void), client?: (schema: GetUnreadMessageCountSchema, options: {
            parameters: GetUnreadMessageCountParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetUnreadMessageCountData, GetUnreadMessageCountError>>): Promise<RequestFnResponse<GetUnreadMessageCountData, GetUnreadMessageCountError>>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        getQueryKey(parameters: DeepReadonly<GetUnreadMessageCountParameters> | void): ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getUnreadMessageCount.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getUnreadMessageCount.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetUnreadMessageCountData>(parameters: ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetUnreadMessageCountData, GetUnreadMessageCountError, TData, ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetUnreadMessageCountError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getUnreadMessageCount.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getUnreadMessageCount.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetUnreadMessageCountData>(parameters: ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void), options: Omit<DefinedInitialDataOptions<GetUnreadMessageCountData, GetUnreadMessageCountError, TData, ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetUnreadMessageCountError>>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetUnreadMessageCountParameters> | void): ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getUnreadMessageCount.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetUnreadMessageCountParameters, TQueryFnData = GetUnreadMessageCountData, TData = OperationInfiniteData<TQueryFnData, GetUnreadMessageCountParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetUnreadMessageCountError, TData, ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetUnreadMessageCountError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getUnreadMessageCount.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetUnreadMessageCountParameters, TQueryFnData = GetUnreadMessageCountData, TData = OperationInfiniteData<TQueryFnData, GetUnreadMessageCountParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetUnreadMessageCountError, TData, ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetUnreadMessageCountData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetUnreadMessageCountError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getUnreadMessageCountTotal = qraft.v3Service.getUnreadMessageCount.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getUnreadMessageCountByParametersTotal = qraft.v3Service.getUnreadMessageCount.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | QueryFiltersByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getUnreadMessageCountResults = qraft.v3Service.getUnreadMessageCount.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getUnreadMessageCountResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getUnreadMessageCountCombinedResults = qraft.v3Service.getUnreadMessageCount.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getUnreadMessageCountCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters, GetUnreadMessageCountData, GetUnreadMessageCountError>>, TCombinedResult = Array<UseQueryResult<GetUnreadMessageCountData, GetUnreadMessageCountError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetUnreadMessageCountData, GetUnreadMessageCountError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getUnreadMessageCount.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getUnreadMessageCount.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetUnreadMessageCountData>(parameters: ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetUnreadMessageCountData, GetUnreadMessageCountError, TData, ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetUnreadMessageCountError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getUnreadMessageCount.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetUnreadMessageCountParameters, TData = GetUnreadMessageCountData>(parameters: ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetUnreadMessageCountData, GetUnreadMessageCountError, OperationInfiniteData<TData, GetUnreadMessageCountParameters>, ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetUnreadMessageCountData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetUnreadMessageCountParameters>, OperationError<GetUnreadMessageCountError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getUnreadMessageCountData = qraft.v3Service.getUnreadMessageCount.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getUnreadMessageCountResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getUnreadMessageCountCombinedData = qraft.v3Service.getUnreadMessageCount.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getUnreadMessageCountCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters, GetUnreadMessageCountData, GetUnreadMessageCountError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetUnreadMessageCountData, GetUnreadMessageCountError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetUnreadMessageCountData, GetUnreadMessageCountError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetUnreadMessageCountSchema, GetUnreadMessageCountData, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | void): Promise<GetUnreadMessageCountData>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetUnreadMessageCountSchema, GetUnreadMessageCountData, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | void): Promise<void>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetUnreadMessageCountSchema, GetUnreadMessageCountData, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | void): Promise<GetUnreadMessageCountData>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        fetchInfiniteQuery<TPageParam extends GetUnreadMessageCountParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetUnreadMessageCountSchema, GetUnreadMessageCountData, GetUnreadMessageCountParameters, DeepReadonly<TPageParam>, GetUnreadMessageCountError> | void): Promise<OperationInfiniteData<GetUnreadMessageCountData, GetUnreadMessageCountParameters>>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        prefetchInfiniteQuery<TPageParam extends GetUnreadMessageCountParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetUnreadMessageCountSchema, GetUnreadMessageCountData, GetUnreadMessageCountParameters, DeepReadonly<TPageParam>, GetUnreadMessageCountError> | void): Promise<void>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        ensureInfiniteQueryData<TPageParam extends GetUnreadMessageCountParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetUnreadMessageCountSchema, GetUnreadMessageCountData, GetUnreadMessageCountParameters, DeepReadonly<TPageParam>, GetUnreadMessageCountError> | void): Promise<OperationInfiniteData<GetUnreadMessageCountData, GetUnreadMessageCountParameters>>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void)): GetUnreadMessageCountData | undefined;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void)): OperationInfiniteData<GetUnreadMessageCountData, GetUnreadMessageCountParameters> | undefined;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | QueryFiltersByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>,
            data: NoInfer<OperationInfiniteData<GetUnreadMessageCountData, GetUnreadMessageCountParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>,
            data: GetUnreadMessageCountData | undefined
        ]>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | (DeepReadonly<GetUnreadMessageCountParameters> | void)): QueryState<GetUnreadMessageCountData, GetUnreadMessageCountError> | undefined;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetUnreadMessageCountParameters> | ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters> | void): QueryState<OperationInfiniteData<GetUnreadMessageCountData, GetUnreadMessageCountParameters>, GetUnreadMessageCountError> | undefined;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        setQueryData(parameters: (DeepReadonly<GetUnreadMessageCountParameters> | undefined) | ServiceOperationQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>, updater: Updater<NoInfer<GetUnreadMessageCountData> | undefined, NoInfer<DeepReadonly<GetUnreadMessageCountData>> | undefined>, options?: SetDataOptions): GetUnreadMessageCountData | undefined;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetUnreadMessageCountParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetUnreadMessageCountData, GetUnreadMessageCountParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetUnreadMessageCountData, GetUnreadMessageCountParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetUnreadMessageCountData, GetUnreadMessageCountParameters> | undefined;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | QueryFiltersByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>, updater: Updater<NoInfer<GetUnreadMessageCountData> | undefined, NoInfer<GetUnreadMessageCountData> | undefined>, options?: SetDataOptions): Array<GetUnreadMessageCountData | undefined>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | QueryFiltersByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | QueryFiltersByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | QueryFiltersByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>): void;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | QueryFiltersByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Unread Message Count
         * @description Total unread messages — the header envelope badge.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError> | QueryFiltersByQueryKey<GetUnreadMessageCountSchema, GetUnreadMessageCountData, TInfinite, GetUnreadMessageCountParameters, GetUnreadMessageCountError>): number;
        schema: GetUnreadMessageCountSchema;
        types: {
            parameters: GetUnreadMessageCountParameters;
            data: GetUnreadMessageCountData;
            error: GetUnreadMessageCountError;
        };
    };
    /**
     * @summary Get Thread Messages
     * @description The messages in ``thread_id`` — the caller must be a participant.
     */
    getThreadMessages: {
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetThreadMessagesParameters, TMeta, TSignal>), client?: (schema: GetThreadMessagesSchema, options: {
            parameters: GetThreadMessagesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetThreadMessagesData, GetThreadMessagesError>>): Promise<RequestFnResponse<GetThreadMessagesData, GetThreadMessagesError>>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        getQueryKey(parameters: DeepReadonly<GetThreadMessagesParameters>): ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getThreadMessages.useQuery({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetThreadMessagesData>(parameters: ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>), options?: Omit<UndefinedInitialDataOptions<GetThreadMessagesData, GetThreadMessagesError, TData, ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetThreadMessagesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getThreadMessages.useQuery({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetThreadMessagesData>(parameters: ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>), options: Omit<DefinedInitialDataOptions<GetThreadMessagesData, GetThreadMessagesError, TData, ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetThreadMessagesError>>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetThreadMessagesParameters>): ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getThreadMessages.useInfiniteQuery({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetThreadMessagesParameters, TQueryFnData = GetThreadMessagesData, TData = OperationInfiniteData<TQueryFnData, GetThreadMessagesParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetThreadMessagesError, TData, ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetThreadMessagesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getThreadMessages.useInfiniteQuery({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetThreadMessagesParameters, TQueryFnData = GetThreadMessagesData, TData = OperationInfiniteData<TQueryFnData, GetThreadMessagesParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetThreadMessagesError, TData, ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetThreadMessagesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetThreadMessagesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getThreadMessagesTotal = qraft.v3Service.getThreadMessages.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getThreadMessagesByParametersTotal = qraft.v3Service.getThreadMessages.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError> | QueryFiltersByQueryKey<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getThreadMessagesResults = qraft.v3Service.getThreadMessages.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 thread_id: threadId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 thread_id: threadId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getThreadMessagesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getThreadMessagesCombinedResults = qraft.v3Service.getThreadMessages.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 thread_id: threadId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 thread_id: threadId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getThreadMessagesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetThreadMessagesSchema, GetThreadMessagesParameters, GetThreadMessagesData, GetThreadMessagesError>>, TCombinedResult = Array<UseQueryResult<GetThreadMessagesData, GetThreadMessagesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetThreadMessagesData, GetThreadMessagesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getThreadMessages.useSuspenseQuery({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetThreadMessagesData>(parameters: ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>), options?: Omit<UseSuspenseQueryOptions<GetThreadMessagesData, GetThreadMessagesError, TData, ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetThreadMessagesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getThreadMessages.useSuspenseInfiniteQuery({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetThreadMessagesParameters, TData = GetThreadMessagesData>(parameters: ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetThreadMessagesData, GetThreadMessagesError, OperationInfiniteData<TData, GetThreadMessagesParameters>, ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetThreadMessagesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetThreadMessagesParameters>, OperationError<GetThreadMessagesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getThreadMessagesData = qraft.v3Service.getThreadMessages.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 thread_id: threadId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 thread_id: threadId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getThreadMessagesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getThreadMessagesCombinedData = qraft.v3Service.getThreadMessages.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 thread_id: threadId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 thread_id: threadId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getThreadMessagesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetThreadMessagesSchema, GetThreadMessagesParameters, GetThreadMessagesData, GetThreadMessagesError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetThreadMessagesData, GetThreadMessagesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetThreadMessagesData, GetThreadMessagesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetThreadMessagesSchema, GetThreadMessagesData, GetThreadMessagesParameters, GetThreadMessagesError>): Promise<GetThreadMessagesData>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetThreadMessagesSchema, GetThreadMessagesData, GetThreadMessagesParameters, GetThreadMessagesError>): Promise<void>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetThreadMessagesSchema, GetThreadMessagesData, GetThreadMessagesParameters, GetThreadMessagesError>): Promise<GetThreadMessagesData>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        fetchInfiniteQuery<TPageParam extends GetThreadMessagesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetThreadMessagesSchema, GetThreadMessagesData, GetThreadMessagesParameters, DeepReadonly<TPageParam>, GetThreadMessagesError>): Promise<OperationInfiniteData<GetThreadMessagesData, GetThreadMessagesParameters>>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        prefetchInfiniteQuery<TPageParam extends GetThreadMessagesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetThreadMessagesSchema, GetThreadMessagesData, GetThreadMessagesParameters, DeepReadonly<TPageParam>, GetThreadMessagesError>): Promise<void>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        ensureInfiniteQueryData<TPageParam extends GetThreadMessagesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetThreadMessagesSchema, GetThreadMessagesData, GetThreadMessagesParameters, DeepReadonly<TPageParam>, GetThreadMessagesError>): Promise<OperationInfiniteData<GetThreadMessagesData, GetThreadMessagesParameters>>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>)): GetThreadMessagesData | undefined;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>)): OperationInfiniteData<GetThreadMessagesData, GetThreadMessagesParameters> | undefined;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError> | QueryFiltersByQueryKey<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>,
            data: NoInfer<OperationInfiniteData<GetThreadMessagesData, GetThreadMessagesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>,
            data: GetThreadMessagesData | undefined
        ]>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters> | (DeepReadonly<GetThreadMessagesParameters>)): QueryState<GetThreadMessagesData, GetThreadMessagesError> | undefined;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetThreadMessagesParameters> | ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>): QueryState<OperationInfiniteData<GetThreadMessagesData, GetThreadMessagesParameters>, GetThreadMessagesError> | undefined;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        setQueryData(parameters: (DeepReadonly<GetThreadMessagesParameters>) | ServiceOperationQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>, updater: Updater<NoInfer<GetThreadMessagesData> | undefined, NoInfer<DeepReadonly<GetThreadMessagesData>> | undefined>, options?: SetDataOptions): GetThreadMessagesData | undefined;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetThreadMessagesParameters>) | ServiceOperationInfiniteQueryKey<GetThreadMessagesSchema, GetThreadMessagesParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetThreadMessagesData, GetThreadMessagesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetThreadMessagesData, GetThreadMessagesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetThreadMessagesData, GetThreadMessagesParameters> | undefined;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError> | QueryFiltersByQueryKey<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>, updater: Updater<NoInfer<GetThreadMessagesData> | undefined, NoInfer<GetThreadMessagesData> | undefined>, options?: SetDataOptions): Array<GetThreadMessagesData | undefined>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError> | QueryFiltersByQueryKey<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError> | QueryFiltersByQueryKey<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError> | QueryFiltersByQueryKey<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>): void;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError> | QueryFiltersByQueryKey<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Thread Messages
         * @description The messages in ``thread_id`` — the caller must be a participant.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError> | QueryFiltersByQueryKey<GetThreadMessagesSchema, GetThreadMessagesData, TInfinite, GetThreadMessagesParameters, GetThreadMessagesError>): number;
        schema: GetThreadMessagesSchema;
        types: {
            parameters: GetThreadMessagesParameters;
            data: GetThreadMessagesData;
            error: GetThreadMessagesError;
        };
    };
    /**
     * @summary Send Thread Message
     * @description Reply into an existing thread the caller participates in.
     */
    sendThreadMessage: {
        /**
         * @summary Send Thread Message
         * @description Reply into an existing thread the caller participates in.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SendThreadMessageBody, SendThreadMessageParameters, TMeta, TSignal>, client?: (schema: SendThreadMessageSchema, options: ServiceOperationMutationFnOptions<SendThreadMessageBody, SendThreadMessageParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SendThreadMessageData, SendThreadMessageError>>): Promise<RequestFnResponse<SendThreadMessageData, SendThreadMessageError>>;
        /**
         * @summary Send Thread Message
         * @description Reply into an existing thread the caller participates in.
         */
        getMutationKey(parameters: DeepReadonly<SendThreadMessageParameters> | void): ServiceOperationMutationKey<SendThreadMessageSchema, SendThreadMessageParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Thread Message
         * @description Reply into an existing thread the caller participates in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendThreadMessage.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendThreadMessage.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SendThreadMessageBody, TContext = unknown>(parameters: DeepReadonly<SendThreadMessageParameters>, options?: ServiceOperationUseMutationOptions<SendThreadMessageSchema, SendThreadMessageData, SendThreadMessageParameters, TVariables, OperationError<SendThreadMessageError>, TContext>): UseMutationResult<SendThreadMessageData, OperationError<SendThreadMessageError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Thread Message
         * @description Reply into an existing thread the caller participates in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendThreadMessage.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendThreadMessage.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SendThreadMessageBody, SendThreadMessageParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SendThreadMessageSchema, SendThreadMessageData, SendThreadMessageParameters, TVariables, OperationError<SendThreadMessageError>, TContext>): UseMutationResult<SendThreadMessageData, OperationError<SendThreadMessageError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Send Thread Message
         * @description Reply into an existing thread the caller participates in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const sendThreadMessageTotal = qraft.v3Service.sendThreadMessage.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const sendThreadMessageTotal = qraft.v3Service.sendThreadMessage.useIsMutating({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext> | MutationFiltersByMutationKey<SendThreadMessageSchema, SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Send Thread Message
         * @description Reply into an existing thread the caller participates in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const sendThreadMessagePendingMutationVariables = qraft.v3Service.sendThreadMessage.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const sendThreadMessageMutationData = qraft.v3Service.sendThreadMessage.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 thread_id: threadId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SendThreadMessageData, OperationError<SendThreadMessageError>, MutationVariables<SendThreadMessageBody, SendThreadMessageParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext> | MutationFiltersByMutationKey<SendThreadMessageSchema, SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext>;
            select?: (mutation: Mutation<SendThreadMessageData, OperationError<SendThreadMessageError>, MutationVariables<SendThreadMessageBody, SendThreadMessageParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Send Thread Message
         * @description Reply into an existing thread the caller participates in.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext> | MutationFiltersByMutationKey<SendThreadMessageSchema, SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Send Thread Message
         * @description Reply into an existing thread the caller participates in.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.sendThreadMessage.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.sendThreadMessage.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext> | MutationFiltersByMutationKey<SendThreadMessageSchema, SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext>): Mutation<SendThreadMessageData, SendThreadMessageError, MutationVariables<SendThreadMessageBody, SendThreadMessageParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext> | MutationFiltersByMutationKey<SendThreadMessageSchema, SendThreadMessageBody, SendThreadMessageData, SendThreadMessageParameters, OperationError<SendThreadMessageError>, TContext>): Array<Mutation<SendThreadMessageData, SendThreadMessageError, MutationVariables<SendThreadMessageBody, SendThreadMessageParameters>, TContext>>;
        };
        schema: SendThreadMessageSchema;
        types: {
            parameters: SendThreadMessageParameters;
            data: SendThreadMessageData;
            error: SendThreadMessageError;
            body: SendThreadMessageBody;
        };
    };
    /** @summary Mark Message Thread Read */
    markMessageThreadRead: {
        /** @summary Mark Message Thread Read */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkMessageThreadReadBody, MarkMessageThreadReadParameters, TMeta, TSignal>, client?: (schema: MarkMessageThreadReadSchema, options: ServiceOperationMutationFnOptions<MarkMessageThreadReadBody, MarkMessageThreadReadParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkMessageThreadReadData, MarkMessageThreadReadError>>): Promise<RequestFnResponse<MarkMessageThreadReadData, MarkMessageThreadReadError>>;
        /** @summary Mark Message Thread Read */
        getMutationKey(parameters: DeepReadonly<MarkMessageThreadReadParameters> | void): ServiceOperationMutationKey<MarkMessageThreadReadSchema, MarkMessageThreadReadParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Message Thread Read
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markMessageThreadRead.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markMessageThreadRead.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkMessageThreadReadBody, TContext = unknown>(parameters: DeepReadonly<MarkMessageThreadReadParameters>, options?: ServiceOperationUseMutationOptions<MarkMessageThreadReadSchema, MarkMessageThreadReadData, MarkMessageThreadReadParameters, TVariables, OperationError<MarkMessageThreadReadError>, TContext>): UseMutationResult<MarkMessageThreadReadData, OperationError<MarkMessageThreadReadError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Message Thread Read
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markMessageThreadRead.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markMessageThreadRead.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkMessageThreadReadBody, MarkMessageThreadReadParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkMessageThreadReadSchema, MarkMessageThreadReadData, MarkMessageThreadReadParameters, TVariables, OperationError<MarkMessageThreadReadError>, TContext>): UseMutationResult<MarkMessageThreadReadData, OperationError<MarkMessageThreadReadError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark Message Thread Read
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markMessageThreadReadTotal = qraft.v3Service.markMessageThreadRead.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markMessageThreadReadTotal = qraft.v3Service.markMessageThreadRead.useIsMutating({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadReadSchema, MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark Message Thread Read
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markMessageThreadReadPendingMutationVariables = qraft.v3Service.markMessageThreadRead.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markMessageThreadReadMutationData = qraft.v3Service.markMessageThreadRead.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 thread_id: threadId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkMessageThreadReadData, OperationError<MarkMessageThreadReadError>, MutationVariables<MarkMessageThreadReadBody, MarkMessageThreadReadParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadReadSchema, MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext>;
            select?: (mutation: Mutation<MarkMessageThreadReadData, OperationError<MarkMessageThreadReadError>, MutationVariables<MarkMessageThreadReadBody, MarkMessageThreadReadParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Mark Message Thread Read */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadReadSchema, MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark Message Thread Read
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.markMessageThreadRead.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.markMessageThreadRead.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadReadSchema, MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext>): Mutation<MarkMessageThreadReadData, MarkMessageThreadReadError, MutationVariables<MarkMessageThreadReadBody, MarkMessageThreadReadParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadReadSchema, MarkMessageThreadReadBody, MarkMessageThreadReadData, MarkMessageThreadReadParameters, OperationError<MarkMessageThreadReadError>, TContext>): Array<Mutation<MarkMessageThreadReadData, MarkMessageThreadReadError, MutationVariables<MarkMessageThreadReadBody, MarkMessageThreadReadParameters>, TContext>>;
        };
        schema: MarkMessageThreadReadSchema;
        types: {
            parameters: MarkMessageThreadReadParameters;
            data: MarkMessageThreadReadData;
            error: MarkMessageThreadReadError;
            body: MarkMessageThreadReadBody;
        };
    };
    /** @summary Mark Message Thread Unread */
    markMessageThreadUnread: {
        /** @summary Mark Message Thread Unread */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadParameters, TMeta, TSignal>, client?: (schema: MarkMessageThreadUnreadSchema, options: ServiceOperationMutationFnOptions<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkMessageThreadUnreadData, MarkMessageThreadUnreadError>>): Promise<RequestFnResponse<MarkMessageThreadUnreadData, MarkMessageThreadUnreadError>>;
        /** @summary Mark Message Thread Unread */
        getMutationKey(parameters: DeepReadonly<MarkMessageThreadUnreadParameters> | void): ServiceOperationMutationKey<MarkMessageThreadUnreadSchema, MarkMessageThreadUnreadParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Message Thread Unread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markMessageThreadUnread.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markMessageThreadUnread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkMessageThreadUnreadBody, TContext = unknown>(parameters: DeepReadonly<MarkMessageThreadUnreadParameters>, options?: ServiceOperationUseMutationOptions<MarkMessageThreadUnreadSchema, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, TVariables, OperationError<MarkMessageThreadUnreadError>, TContext>): UseMutationResult<MarkMessageThreadUnreadData, OperationError<MarkMessageThreadUnreadError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Message Thread Unread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markMessageThreadUnread.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markMessageThreadUnread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkMessageThreadUnreadSchema, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, TVariables, OperationError<MarkMessageThreadUnreadError>, TContext>): UseMutationResult<MarkMessageThreadUnreadData, OperationError<MarkMessageThreadUnreadError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark Message Thread Unread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markMessageThreadUnreadTotal = qraft.v3Service.markMessageThreadUnread.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markMessageThreadUnreadTotal = qraft.v3Service.markMessageThreadUnread.useIsMutating({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadUnreadSchema, MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark Message Thread Unread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markMessageThreadUnreadPendingMutationVariables = qraft.v3Service.markMessageThreadUnread.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markMessageThreadUnreadMutationData = qraft.v3Service.markMessageThreadUnread.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 thread_id: threadId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkMessageThreadUnreadData, OperationError<MarkMessageThreadUnreadError>, MutationVariables<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadUnreadSchema, MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext>;
            select?: (mutation: Mutation<MarkMessageThreadUnreadData, OperationError<MarkMessageThreadUnreadError>, MutationVariables<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Mark Message Thread Unread */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadUnreadSchema, MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark Message Thread Unread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.markMessageThreadUnread.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.markMessageThreadUnread.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadUnreadSchema, MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext>): Mutation<MarkMessageThreadUnreadData, MarkMessageThreadUnreadError, MutationVariables<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext> | MutationFiltersByMutationKey<MarkMessageThreadUnreadSchema, MarkMessageThreadUnreadBody, MarkMessageThreadUnreadData, MarkMessageThreadUnreadParameters, OperationError<MarkMessageThreadUnreadError>, TContext>): Array<Mutation<MarkMessageThreadUnreadData, MarkMessageThreadUnreadError, MutationVariables<MarkMessageThreadUnreadBody, MarkMessageThreadUnreadParameters>, TContext>>;
        };
        schema: MarkMessageThreadUnreadSchema;
        types: {
            parameters: MarkMessageThreadUnreadParameters;
            data: MarkMessageThreadUnreadData;
            error: MarkMessageThreadUnreadError;
            body: MarkMessageThreadUnreadBody;
        };
    };
    /** @summary Hide Message Thread */
    hideMessageThread: {
        /** @summary Hide Message Thread */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<HideMessageThreadBody, HideMessageThreadParameters, TMeta, TSignal>, client?: (schema: HideMessageThreadSchema, options: ServiceOperationMutationFnOptions<HideMessageThreadBody, HideMessageThreadParameters, TMeta, TSignal>) => Promise<RequestFnResponse<HideMessageThreadData, HideMessageThreadError>>): Promise<RequestFnResponse<HideMessageThreadData, HideMessageThreadError>>;
        /** @summary Hide Message Thread */
        getMutationKey(parameters: DeepReadonly<HideMessageThreadParameters> | void): ServiceOperationMutationKey<HideMessageThreadSchema, HideMessageThreadParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Hide Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.hideMessageThread.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.hideMessageThread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends HideMessageThreadBody, TContext = unknown>(parameters: DeepReadonly<HideMessageThreadParameters>, options?: ServiceOperationUseMutationOptions<HideMessageThreadSchema, HideMessageThreadData, HideMessageThreadParameters, TVariables, OperationError<HideMessageThreadError>, TContext>): UseMutationResult<HideMessageThreadData, OperationError<HideMessageThreadError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Hide Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.hideMessageThread.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.hideMessageThread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<HideMessageThreadBody, HideMessageThreadParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<HideMessageThreadSchema, HideMessageThreadData, HideMessageThreadParameters, TVariables, OperationError<HideMessageThreadError>, TContext>): UseMutationResult<HideMessageThreadData, OperationError<HideMessageThreadError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Hide Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const hideMessageThreadTotal = qraft.v3Service.hideMessageThread.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const hideMessageThreadTotal = qraft.v3Service.hideMessageThread.useIsMutating({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext> | MutationFiltersByMutationKey<HideMessageThreadSchema, HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Hide Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const hideMessageThreadPendingMutationVariables = qraft.v3Service.hideMessageThread.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const hideMessageThreadMutationData = qraft.v3Service.hideMessageThread.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 thread_id: threadId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<HideMessageThreadData, OperationError<HideMessageThreadError>, MutationVariables<HideMessageThreadBody, HideMessageThreadParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext> | MutationFiltersByMutationKey<HideMessageThreadSchema, HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext>;
            select?: (mutation: Mutation<HideMessageThreadData, OperationError<HideMessageThreadError>, MutationVariables<HideMessageThreadBody, HideMessageThreadParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Hide Message Thread */
        isMutating<TContext>(filters?: MutationFiltersByParameters<HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext> | MutationFiltersByMutationKey<HideMessageThreadSchema, HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Hide Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.hideMessageThread.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.hideMessageThread.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext> | MutationFiltersByMutationKey<HideMessageThreadSchema, HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext>): Mutation<HideMessageThreadData, HideMessageThreadError, MutationVariables<HideMessageThreadBody, HideMessageThreadParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext> | MutationFiltersByMutationKey<HideMessageThreadSchema, HideMessageThreadBody, HideMessageThreadData, HideMessageThreadParameters, OperationError<HideMessageThreadError>, TContext>): Array<Mutation<HideMessageThreadData, HideMessageThreadError, MutationVariables<HideMessageThreadBody, HideMessageThreadParameters>, TContext>>;
        };
        schema: HideMessageThreadSchema;
        types: {
            parameters: HideMessageThreadParameters;
            data: HideMessageThreadData;
            error: HideMessageThreadError;
            body: HideMessageThreadBody;
        };
    };
    /** @summary Delete Message Thread */
    deleteMessageThread: {
        /** @summary Delete Message Thread */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteMessageThreadBody, DeleteMessageThreadParameters, TMeta, TSignal>, client?: (schema: DeleteMessageThreadSchema, options: ServiceOperationMutationFnOptions<DeleteMessageThreadBody, DeleteMessageThreadParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteMessageThreadData, DeleteMessageThreadError>>): Promise<RequestFnResponse<DeleteMessageThreadData, DeleteMessageThreadError>>;
        /** @summary Delete Message Thread */
        getMutationKey(parameters: DeepReadonly<DeleteMessageThreadParameters> | void): ServiceOperationMutationKey<DeleteMessageThreadSchema, DeleteMessageThreadParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMessageThread.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMessageThread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteMessageThreadBody, TContext = unknown>(parameters: DeepReadonly<DeleteMessageThreadParameters>, options?: ServiceOperationUseMutationOptions<DeleteMessageThreadSchema, DeleteMessageThreadData, DeleteMessageThreadParameters, TVariables, OperationError<DeleteMessageThreadError>, TContext>): UseMutationResult<DeleteMessageThreadData, OperationError<DeleteMessageThreadError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMessageThread.useMutation({
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMessageThread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteMessageThreadBody, DeleteMessageThreadParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteMessageThreadSchema, DeleteMessageThreadData, DeleteMessageThreadParameters, TVariables, OperationError<DeleteMessageThreadError>, TContext>): UseMutationResult<DeleteMessageThreadData, OperationError<DeleteMessageThreadError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteMessageThreadTotal = qraft.v3Service.deleteMessageThread.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteMessageThreadTotal = qraft.v3Service.deleteMessageThread.useIsMutating({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext> | MutationFiltersByMutationKey<DeleteMessageThreadSchema, DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteMessageThreadPendingMutationVariables = qraft.v3Service.deleteMessageThread.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteMessageThreadMutationData = qraft.v3Service.deleteMessageThread.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 thread_id: threadId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteMessageThreadData, OperationError<DeleteMessageThreadError>, MutationVariables<DeleteMessageThreadBody, DeleteMessageThreadParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext> | MutationFiltersByMutationKey<DeleteMessageThreadSchema, DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext>;
            select?: (mutation: Mutation<DeleteMessageThreadData, OperationError<DeleteMessageThreadError>, MutationVariables<DeleteMessageThreadBody, DeleteMessageThreadParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Delete Message Thread */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext> | MutationFiltersByMutationKey<DeleteMessageThreadSchema, DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Message Thread
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteMessageThread.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             thread_id: threadId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteMessageThread.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext> | MutationFiltersByMutationKey<DeleteMessageThreadSchema, DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext>): Mutation<DeleteMessageThreadData, DeleteMessageThreadError, MutationVariables<DeleteMessageThreadBody, DeleteMessageThreadParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext> | MutationFiltersByMutationKey<DeleteMessageThreadSchema, DeleteMessageThreadBody, DeleteMessageThreadData, DeleteMessageThreadParameters, OperationError<DeleteMessageThreadError>, TContext>): Array<Mutation<DeleteMessageThreadData, DeleteMessageThreadError, MutationVariables<DeleteMessageThreadBody, DeleteMessageThreadParameters>, TContext>>;
        };
        schema: DeleteMessageThreadSchema;
        types: {
            parameters: DeleteMessageThreadParameters;
            data: DeleteMessageThreadData;
            error: DeleteMessageThreadError;
            body: DeleteMessageThreadBody;
        };
    };
    /**
     * @summary List Mass Messages
     * @description The group's mass messages, newest first.
     *
     * No search box and no filter panel, as legacy's table has neither, so no `searchable`
     * or `sortable` map is offered and an unrecognised `sort` key leaves this order
     * untouched.
     */
    listMassMessages: {
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListMassMessagesSchema, ListMassMessagesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListMassMessagesParameters, TMeta, TSignal>), client?: (schema: ListMassMessagesSchema, options: {
            parameters: ListMassMessagesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListMassMessagesData, ListMassMessagesError>>): Promise<RequestFnResponse<ListMassMessagesData, ListMassMessagesError>>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        getQueryKey(parameters: DeepReadonly<ListMassMessagesParameters>): ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMassMessages.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListMassMessagesData>(parameters: ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>), options?: Omit<UndefinedInitialDataOptions<ListMassMessagesData, ListMassMessagesError, TData, ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListMassMessagesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMassMessages.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListMassMessagesData>(parameters: ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>), options: Omit<DefinedInitialDataOptions<ListMassMessagesData, ListMassMessagesError, TData, ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListMassMessagesError>>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListMassMessagesParameters>): ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMassMessages.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListMassMessagesParameters, TQueryFnData = ListMassMessagesData, TData = OperationInfiniteData<TQueryFnData, ListMassMessagesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListMassMessagesError, TData, ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListMassMessagesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMassMessages.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListMassMessagesParameters, TQueryFnData = ListMassMessagesData, TData = OperationInfiniteData<TQueryFnData, ListMassMessagesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListMassMessagesError, TData, ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListMassMessagesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListMassMessagesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listMassMessagesTotal = qraft.v3Service.listMassMessages.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listMassMessagesByParametersTotal = qraft.v3Service.listMassMessages.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError> | QueryFiltersByQueryKey<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listMassMessagesResults = qraft.v3Service.listMassMessages.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMassMessagesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listMassMessagesCombinedResults = qraft.v3Service.listMassMessages.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMassMessagesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListMassMessagesSchema, ListMassMessagesParameters, ListMassMessagesData, ListMassMessagesError>>, TCombinedResult = Array<UseQueryResult<ListMassMessagesData, ListMassMessagesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListMassMessagesData, ListMassMessagesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listMassMessages.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListMassMessagesData>(parameters: ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>), options?: Omit<UseSuspenseQueryOptions<ListMassMessagesData, ListMassMessagesError, TData, ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListMassMessagesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMassMessages.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListMassMessagesParameters, TData = ListMassMessagesData>(parameters: ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListMassMessagesData, ListMassMessagesError, OperationInfiniteData<TData, ListMassMessagesParameters>, ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListMassMessagesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListMassMessagesParameters>, OperationError<ListMassMessagesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listMassMessagesData = qraft.v3Service.listMassMessages.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMassMessagesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listMassMessagesCombinedData = qraft.v3Service.listMassMessages.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMassMessagesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListMassMessagesSchema, ListMassMessagesParameters, ListMassMessagesData, ListMassMessagesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListMassMessagesData, ListMassMessagesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListMassMessagesData, ListMassMessagesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListMassMessagesSchema, ListMassMessagesData, ListMassMessagesParameters, ListMassMessagesError>): Promise<ListMassMessagesData>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListMassMessagesSchema, ListMassMessagesData, ListMassMessagesParameters, ListMassMessagesError>): Promise<void>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListMassMessagesSchema, ListMassMessagesData, ListMassMessagesParameters, ListMassMessagesError>): Promise<ListMassMessagesData>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        fetchInfiniteQuery<TPageParam extends ListMassMessagesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListMassMessagesSchema, ListMassMessagesData, ListMassMessagesParameters, DeepReadonly<TPageParam>, ListMassMessagesError>): Promise<OperationInfiniteData<ListMassMessagesData, ListMassMessagesParameters>>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        prefetchInfiniteQuery<TPageParam extends ListMassMessagesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListMassMessagesSchema, ListMassMessagesData, ListMassMessagesParameters, DeepReadonly<TPageParam>, ListMassMessagesError>): Promise<void>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        ensureInfiniteQueryData<TPageParam extends ListMassMessagesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListMassMessagesSchema, ListMassMessagesData, ListMassMessagesParameters, DeepReadonly<TPageParam>, ListMassMessagesError>): Promise<OperationInfiniteData<ListMassMessagesData, ListMassMessagesParameters>>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>)): ListMassMessagesData | undefined;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>)): OperationInfiniteData<ListMassMessagesData, ListMassMessagesParameters> | undefined;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError> | QueryFiltersByQueryKey<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>,
            data: NoInfer<OperationInfiniteData<ListMassMessagesData, ListMassMessagesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>,
            data: ListMassMessagesData | undefined
        ]>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters> | (DeepReadonly<ListMassMessagesParameters>)): QueryState<ListMassMessagesData, ListMassMessagesError> | undefined;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListMassMessagesParameters> | ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>): QueryState<OperationInfiniteData<ListMassMessagesData, ListMassMessagesParameters>, ListMassMessagesError> | undefined;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        setQueryData(parameters: (DeepReadonly<ListMassMessagesParameters>) | ServiceOperationQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>, updater: Updater<NoInfer<ListMassMessagesData> | undefined, NoInfer<DeepReadonly<ListMassMessagesData>> | undefined>, options?: SetDataOptions): ListMassMessagesData | undefined;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListMassMessagesParameters>) | ServiceOperationInfiniteQueryKey<ListMassMessagesSchema, ListMassMessagesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListMassMessagesData, ListMassMessagesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListMassMessagesData, ListMassMessagesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListMassMessagesData, ListMassMessagesParameters> | undefined;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError> | QueryFiltersByQueryKey<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>, updater: Updater<NoInfer<ListMassMessagesData> | undefined, NoInfer<ListMassMessagesData> | undefined>, options?: SetDataOptions): Array<ListMassMessagesData | undefined>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError> | QueryFiltersByQueryKey<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError> | QueryFiltersByQueryKey<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError> | QueryFiltersByQueryKey<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>): void;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError> | QueryFiltersByQueryKey<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Mass Messages
         * @description The group's mass messages, newest first.
         *
         * No search box and no filter panel, as legacy's table has neither, so no `searchable`
         * or `sortable` map is offered and an unrecognised `sort` key leaves this order
         * untouched.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError> | QueryFiltersByQueryKey<ListMassMessagesSchema, ListMassMessagesData, TInfinite, ListMassMessagesParameters, ListMassMessagesError>): number;
        schema: ListMassMessagesSchema;
        types: {
            parameters: ListMassMessagesParameters;
            data: ListMassMessagesData;
            error: ListMassMessagesError;
        };
    };
    /**
     * @summary Send Mass Message
     * @description Broadcast one message to every leader of the group.
     *
     * One fresh thread per broadcast, never appended to an existing one, with every
     * recipient and the sender on it. The sender cannot reply into it and each
     * recipient's reply forks into a 1:1 with them.
     */
    sendMassMessage: {
        /**
         * @summary Send Mass Message
         * @description Broadcast one message to every leader of the group.
         *
         * One fresh thread per broadcast, never appended to an existing one, with every
         * recipient and the sender on it. The sender cannot reply into it and each
         * recipient's reply forks into a 1:1 with them.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SendMassMessageBody, SendMassMessageParameters, TMeta, TSignal>, client?: (schema: SendMassMessageSchema, options: ServiceOperationMutationFnOptions<SendMassMessageBody, SendMassMessageParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SendMassMessageData, SendMassMessageError>>): Promise<RequestFnResponse<SendMassMessageData, SendMassMessageError>>;
        /**
         * @summary Send Mass Message
         * @description Broadcast one message to every leader of the group.
         *
         * One fresh thread per broadcast, never appended to an existing one, with every
         * recipient and the sender on it. The sender cannot reply into it and each
         * recipient's reply forks into a 1:1 with them.
         */
        getMutationKey(parameters: DeepReadonly<SendMassMessageParameters> | void): ServiceOperationMutationKey<SendMassMessageSchema, SendMassMessageParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Mass Message
         * @description Broadcast one message to every leader of the group.
         *
         * One fresh thread per broadcast, never appended to an existing one, with every
         * recipient and the sender on it. The sender cannot reply into it and each
         * recipient's reply forks into a 1:1 with them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendMassMessage.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendMassMessage.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SendMassMessageBody, TContext = unknown>(parameters: DeepReadonly<SendMassMessageParameters>, options?: ServiceOperationUseMutationOptions<SendMassMessageSchema, SendMassMessageData, SendMassMessageParameters, TVariables, OperationError<SendMassMessageError>, TContext>): UseMutationResult<SendMassMessageData, OperationError<SendMassMessageError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Mass Message
         * @description Broadcast one message to every leader of the group.
         *
         * One fresh thread per broadcast, never appended to an existing one, with every
         * recipient and the sender on it. The sender cannot reply into it and each
         * recipient's reply forks into a 1:1 with them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendMassMessage.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendMassMessage.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SendMassMessageBody, SendMassMessageParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SendMassMessageSchema, SendMassMessageData, SendMassMessageParameters, TVariables, OperationError<SendMassMessageError>, TContext>): UseMutationResult<SendMassMessageData, OperationError<SendMassMessageError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Send Mass Message
         * @description Broadcast one message to every leader of the group.
         *
         * One fresh thread per broadcast, never appended to an existing one, with every
         * recipient and the sender on it. The sender cannot reply into it and each
         * recipient's reply forks into a 1:1 with them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const sendMassMessageTotal = qraft.v3Service.sendMassMessage.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const sendMassMessageTotal = qraft.v3Service.sendMassMessage.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext> | MutationFiltersByMutationKey<SendMassMessageSchema, SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Send Mass Message
         * @description Broadcast one message to every leader of the group.
         *
         * One fresh thread per broadcast, never appended to an existing one, with every
         * recipient and the sender on it. The sender cannot reply into it and each
         * recipient's reply forks into a 1:1 with them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const sendMassMessagePendingMutationVariables = qraft.v3Service.sendMassMessage.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const sendMassMessageMutationData = qraft.v3Service.sendMassMessage.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SendMassMessageData, OperationError<SendMassMessageError>, MutationVariables<SendMassMessageBody, SendMassMessageParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext> | MutationFiltersByMutationKey<SendMassMessageSchema, SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext>;
            select?: (mutation: Mutation<SendMassMessageData, OperationError<SendMassMessageError>, MutationVariables<SendMassMessageBody, SendMassMessageParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Send Mass Message
         * @description Broadcast one message to every leader of the group.
         *
         * One fresh thread per broadcast, never appended to an existing one, with every
         * recipient and the sender on it. The sender cannot reply into it and each
         * recipient's reply forks into a 1:1 with them.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext> | MutationFiltersByMutationKey<SendMassMessageSchema, SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Send Mass Message
         * @description Broadcast one message to every leader of the group.
         *
         * One fresh thread per broadcast, never appended to an existing one, with every
         * recipient and the sender on it. The sender cannot reply into it and each
         * recipient's reply forks into a 1:1 with them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.sendMassMessage.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.sendMassMessage.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext> | MutationFiltersByMutationKey<SendMassMessageSchema, SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext>): Mutation<SendMassMessageData, SendMassMessageError, MutationVariables<SendMassMessageBody, SendMassMessageParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext> | MutationFiltersByMutationKey<SendMassMessageSchema, SendMassMessageBody, SendMassMessageData, SendMassMessageParameters, OperationError<SendMassMessageError>, TContext>): Array<Mutation<SendMassMessageData, SendMassMessageError, MutationVariables<SendMassMessageBody, SendMassMessageParameters>, TContext>>;
        };
        schema: SendMassMessageSchema;
        types: {
            parameters: SendMassMessageParameters;
            data: SendMassMessageData;
            error: SendMassMessageError;
            body: SendMassMessageBody;
        };
    };
    /**
     * @summary Delete Mass Message
     * @description Hide the message from this group's list. It is NOT retracted.
     *
     * Any leader of the owning group may delete any of its mass messages, not only
     * the sender: that is legacy's in-group behaviour, where the tab shows every
     * row with a Delete link to every admin and mod.
     */
    deleteMassMessage: {
        /**
         * @summary Delete Mass Message
         * @description Hide the message from this group's list. It is NOT retracted.
         *
         * Any leader of the owning group may delete any of its mass messages, not only
         * the sender: that is legacy's in-group behaviour, where the tab shows every
         * row with a Delete link to every admin and mod.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteMassMessageBody, DeleteMassMessageParameters, TMeta, TSignal>, client?: (schema: DeleteMassMessageSchema, options: ServiceOperationMutationFnOptions<DeleteMassMessageBody, DeleteMassMessageParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteMassMessageData, DeleteMassMessageError>>): Promise<RequestFnResponse<DeleteMassMessageData, DeleteMassMessageError>>;
        /**
         * @summary Delete Mass Message
         * @description Hide the message from this group's list. It is NOT retracted.
         *
         * Any leader of the owning group may delete any of its mass messages, not only
         * the sender: that is legacy's in-group behaviour, where the tab shows every
         * row with a Delete link to every admin and mod.
         */
        getMutationKey(parameters: DeepReadonly<DeleteMassMessageParameters> | void): ServiceOperationMutationKey<DeleteMassMessageSchema, DeleteMassMessageParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Mass Message
         * @description Hide the message from this group's list. It is NOT retracted.
         *
         * Any leader of the owning group may delete any of its mass messages, not only
         * the sender: that is legacy's in-group behaviour, where the tab shows every
         * row with a Delete link to every admin and mod.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMassMessage.useMutation({
         *     path: {
         *         thread_id: threadId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMassMessage.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteMassMessageBody, TContext = unknown>(parameters: DeepReadonly<DeleteMassMessageParameters>, options?: ServiceOperationUseMutationOptions<DeleteMassMessageSchema, DeleteMassMessageData, DeleteMassMessageParameters, TVariables, OperationError<DeleteMassMessageError>, TContext>): UseMutationResult<DeleteMassMessageData, OperationError<DeleteMassMessageError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Mass Message
         * @description Hide the message from this group's list. It is NOT retracted.
         *
         * Any leader of the owning group may delete any of its mass messages, not only
         * the sender: that is legacy's in-group behaviour, where the tab shows every
         * row with a Delete link to every admin and mod.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMassMessage.useMutation({
         *     path: {
         *         thread_id: threadId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteMassMessage.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         thread_id: threadId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteMassMessageBody, DeleteMassMessageParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteMassMessageSchema, DeleteMassMessageData, DeleteMassMessageParameters, TVariables, OperationError<DeleteMassMessageError>, TContext>): UseMutationResult<DeleteMassMessageData, OperationError<DeleteMassMessageError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Mass Message
         * @description Hide the message from this group's list. It is NOT retracted.
         *
         * Any leader of the owning group may delete any of its mass messages, not only
         * the sender: that is legacy's in-group behaviour, where the tab shows every
         * row with a Delete link to every admin and mod.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteMassMessageTotal = qraft.v3Service.deleteMassMessage.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteMassMessageTotal = qraft.v3Service.deleteMassMessage.useIsMutating({
         *     parameters: {
         *         path: {
         *             thread_id: threadId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext> | MutationFiltersByMutationKey<DeleteMassMessageSchema, DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Mass Message
         * @description Hide the message from this group's list. It is NOT retracted.
         *
         * Any leader of the owning group may delete any of its mass messages, not only
         * the sender: that is legacy's in-group behaviour, where the tab shows every
         * row with a Delete link to every admin and mod.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteMassMessagePendingMutationVariables = qraft.v3Service.deleteMassMessage.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteMassMessageMutationData = qraft.v3Service.deleteMassMessage.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 thread_id: threadId,
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteMassMessageData, OperationError<DeleteMassMessageError>, MutationVariables<DeleteMassMessageBody, DeleteMassMessageParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext> | MutationFiltersByMutationKey<DeleteMassMessageSchema, DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext>;
            select?: (mutation: Mutation<DeleteMassMessageData, OperationError<DeleteMassMessageError>, MutationVariables<DeleteMassMessageBody, DeleteMassMessageParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete Mass Message
         * @description Hide the message from this group's list. It is NOT retracted.
         *
         * Any leader of the owning group may delete any of its mass messages, not only
         * the sender: that is legacy's in-group behaviour, where the tab shows every
         * row with a Delete link to every admin and mod.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext> | MutationFiltersByMutationKey<DeleteMassMessageSchema, DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Mass Message
         * @description Hide the message from this group's list. It is NOT retracted.
         *
         * Any leader of the owning group may delete any of its mass messages, not only
         * the sender: that is legacy's in-group behaviour, where the tab shows every
         * row with a Delete link to every admin and mod.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteMassMessage.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             thread_id: threadId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteMassMessage.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext> | MutationFiltersByMutationKey<DeleteMassMessageSchema, DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext>): Mutation<DeleteMassMessageData, DeleteMassMessageError, MutationVariables<DeleteMassMessageBody, DeleteMassMessageParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext> | MutationFiltersByMutationKey<DeleteMassMessageSchema, DeleteMassMessageBody, DeleteMassMessageData, DeleteMassMessageParameters, OperationError<DeleteMassMessageError>, TContext>): Array<Mutation<DeleteMassMessageData, DeleteMassMessageError, MutationVariables<DeleteMassMessageBody, DeleteMassMessageParameters>, TContext>>;
        };
        schema: DeleteMassMessageSchema;
        types: {
            parameters: DeleteMassMessageParameters;
            data: DeleteMassMessageData;
            error: DeleteMassMessageError;
            body: DeleteMassMessageBody;
        };
    };
    /**
     * @summary Send Introduction
     * @description Send an introduction to a newly-adopted student (study-helper only).
     *
     * Reuses the shared introduction service: the introduction is a normal message
     * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
     * student is marked introduced by this study helper.
     */
    sendIntroduction: {
        /**
         * @summary Send Introduction
         * @description Send an introduction to a newly-adopted student (study-helper only).
         *
         * Reuses the shared introduction service: the introduction is a normal message
         * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
         * student is marked introduced by this study helper.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SendIntroductionBody, SendIntroductionParameters, TMeta, TSignal>, client?: (schema: SendIntroductionSchema, options: ServiceOperationMutationFnOptions<SendIntroductionBody, SendIntroductionParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SendIntroductionData, SendIntroductionError>>): Promise<RequestFnResponse<SendIntroductionData, SendIntroductionError>>;
        /**
         * @summary Send Introduction
         * @description Send an introduction to a newly-adopted student (study-helper only).
         *
         * Reuses the shared introduction service: the introduction is a normal message
         * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
         * student is marked introduced by this study helper.
         */
        getMutationKey(parameters: DeepReadonly<SendIntroductionParameters> | void): ServiceOperationMutationKey<SendIntroductionSchema, SendIntroductionParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Introduction
         * @description Send an introduction to a newly-adopted student (study-helper only).
         *
         * Reuses the shared introduction service: the introduction is a normal message
         * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
         * student is marked introduced by this study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendIntroduction.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendIntroduction.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SendIntroductionBody, TContext = unknown>(parameters: DeepReadonly<SendIntroductionParameters>, options?: ServiceOperationUseMutationOptions<SendIntroductionSchema, SendIntroductionData, SendIntroductionParameters, TVariables, OperationError<SendIntroductionError>, TContext>): UseMutationResult<SendIntroductionData, OperationError<SendIntroductionError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Introduction
         * @description Send an introduction to a newly-adopted student (study-helper only).
         *
         * Reuses the shared introduction service: the introduction is a normal message
         * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
         * student is marked introduced by this study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendIntroduction.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.sendIntroduction.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SendIntroductionBody, SendIntroductionParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SendIntroductionSchema, SendIntroductionData, SendIntroductionParameters, TVariables, OperationError<SendIntroductionError>, TContext>): UseMutationResult<SendIntroductionData, OperationError<SendIntroductionError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Send Introduction
         * @description Send an introduction to a newly-adopted student (study-helper only).
         *
         * Reuses the shared introduction service: the introduction is a normal message
         * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
         * student is marked introduced by this study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const sendIntroductionTotal = qraft.v3Service.sendIntroduction.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const sendIntroductionTotal = qraft.v3Service.sendIntroduction.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext> | MutationFiltersByMutationKey<SendIntroductionSchema, SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Send Introduction
         * @description Send an introduction to a newly-adopted student (study-helper only).
         *
         * Reuses the shared introduction service: the introduction is a normal message
         * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
         * student is marked introduced by this study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const sendIntroductionPendingMutationVariables = qraft.v3Service.sendIntroduction.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const sendIntroductionMutationData = qraft.v3Service.sendIntroduction.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SendIntroductionData, OperationError<SendIntroductionError>, MutationVariables<SendIntroductionBody, SendIntroductionParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext> | MutationFiltersByMutationKey<SendIntroductionSchema, SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext>;
            select?: (mutation: Mutation<SendIntroductionData, OperationError<SendIntroductionError>, MutationVariables<SendIntroductionBody, SendIntroductionParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Send Introduction
         * @description Send an introduction to a newly-adopted student (study-helper only).
         *
         * Reuses the shared introduction service: the introduction is a normal message
         * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
         * student is marked introduced by this study helper.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext> | MutationFiltersByMutationKey<SendIntroductionSchema, SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Send Introduction
         * @description Send an introduction to a newly-adopted student (study-helper only).
         *
         * Reuses the shared introduction service: the introduction is a normal message
         * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
         * student is marked introduced by this study helper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.sendIntroduction.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.sendIntroduction.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext> | MutationFiltersByMutationKey<SendIntroductionSchema, SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext>): Mutation<SendIntroductionData, SendIntroductionError, MutationVariables<SendIntroductionBody, SendIntroductionParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext> | MutationFiltersByMutationKey<SendIntroductionSchema, SendIntroductionBody, SendIntroductionData, SendIntroductionParameters, OperationError<SendIntroductionError>, TContext>): Array<Mutation<SendIntroductionData, SendIntroductionError, MutationVariables<SendIntroductionBody, SendIntroductionParameters>, TContext>>;
        };
        schema: SendIntroductionSchema;
        types: {
            parameters: SendIntroductionParameters;
            data: SendIntroductionData;
            error: SendIntroductionError;
            body: SendIntroductionBody;
        };
    };
    /**
     * @summary Get List Filters
     * @description Describe a list's filters: key, label, control type and options.
     *
     * Options are resolved in the caller's language. Group-scoped lists require
     * ``group_id``, whose permission gate is per group; member-scoped ones require
     * ``student_id``. The permission check can't gate ``student_id``, so every per-student
     * option source re-checks the viewer itself and returns no options when refused.
     *
     * A ``search`` control has no options to browse: the client searches for them. Pass
     * the student ids such a control already holds as ``selected_student_ids`` to get
     * their labels back as its options; ids outside the list's own students are ignored.
     */
    getListFilters: {
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetListFiltersSchema, GetListFiltersParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetListFiltersParameters, TMeta, TSignal>), client?: (schema: GetListFiltersSchema, options: {
            parameters: GetListFiltersParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetListFiltersData, GetListFiltersError>>): Promise<RequestFnResponse<GetListFiltersData, GetListFiltersError>>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        getQueryKey(parameters: DeepReadonly<GetListFiltersParameters>): ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getListFilters.useQuery({
         *     path: {
         *         list_key: listKey
         *     },
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetListFiltersData>(parameters: ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>), options?: Omit<UndefinedInitialDataOptions<GetListFiltersData, GetListFiltersError, TData, ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetListFiltersError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getListFilters.useQuery({
         *     path: {
         *         list_key: listKey
         *     },
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetListFiltersData>(parameters: ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>), options: Omit<DefinedInitialDataOptions<GetListFiltersData, GetListFiltersError, TData, ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetListFiltersError>>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetListFiltersParameters>): ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getListFilters.useInfiniteQuery({
         *     path: {
         *         list_key: listKey
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetListFiltersParameters, TQueryFnData = GetListFiltersData, TData = OperationInfiniteData<TQueryFnData, GetListFiltersParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetListFiltersError, TData, ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetListFiltersError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getListFilters.useInfiniteQuery({
         *     path: {
         *         list_key: listKey
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetListFiltersParameters, TQueryFnData = GetListFiltersData, TData = OperationInfiniteData<TQueryFnData, GetListFiltersParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetListFiltersError, TData, ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetListFiltersData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetListFiltersError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getListFiltersTotal = qraft.v3Service.getListFilters.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getListFiltersByParametersTotal = qraft.v3Service.getListFilters.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             list_key: listKey
         *         },
         *         query: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError> | QueryFiltersByQueryKey<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getListFiltersResults = qraft.v3Service.getListFilters.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 list_key: listKey1
         *             },
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 list_key: listKey2
         *             },
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getListFiltersResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getListFiltersCombinedResults = qraft.v3Service.getListFilters.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 list_key: listKey1
         *             },
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 list_key: listKey2
         *             },
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getListFiltersCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetListFiltersSchema, GetListFiltersParameters, GetListFiltersData, GetListFiltersError>>, TCombinedResult = Array<UseQueryResult<GetListFiltersData, GetListFiltersError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetListFiltersData, GetListFiltersError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getListFilters.useSuspenseQuery({
         *     path: {
         *         list_key: listKey
         *     },
         *     query: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetListFiltersData>(parameters: ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>), options?: Omit<UseSuspenseQueryOptions<GetListFiltersData, GetListFiltersError, TData, ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetListFiltersError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getListFilters.useSuspenseInfiniteQuery({
         *     path: {
         *         list_key: listKey
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             group_id: initialGroupId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetListFiltersParameters, TData = GetListFiltersData>(parameters: ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetListFiltersData, GetListFiltersError, OperationInfiniteData<TData, GetListFiltersParameters>, ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetListFiltersData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetListFiltersParameters>, OperationError<GetListFiltersError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getListFiltersData = qraft.v3Service.getListFilters.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 list_key: listKey1
         *             },
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 list_key: listKey2
         *             },
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getListFiltersResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getListFiltersCombinedData = qraft.v3Service.getListFilters.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 list_key: listKey1
         *             },
         *             query: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 list_key: listKey2
         *             },
         *             query: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getListFiltersCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetListFiltersSchema, GetListFiltersParameters, GetListFiltersData, GetListFiltersError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetListFiltersData, GetListFiltersError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetListFiltersData, GetListFiltersError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetListFiltersSchema, GetListFiltersData, GetListFiltersParameters, GetListFiltersError>): Promise<GetListFiltersData>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetListFiltersSchema, GetListFiltersData, GetListFiltersParameters, GetListFiltersError>): Promise<void>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetListFiltersSchema, GetListFiltersData, GetListFiltersParameters, GetListFiltersError>): Promise<GetListFiltersData>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        fetchInfiniteQuery<TPageParam extends GetListFiltersParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetListFiltersSchema, GetListFiltersData, GetListFiltersParameters, DeepReadonly<TPageParam>, GetListFiltersError>): Promise<OperationInfiniteData<GetListFiltersData, GetListFiltersParameters>>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        prefetchInfiniteQuery<TPageParam extends GetListFiltersParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetListFiltersSchema, GetListFiltersData, GetListFiltersParameters, DeepReadonly<TPageParam>, GetListFiltersError>): Promise<void>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        ensureInfiniteQueryData<TPageParam extends GetListFiltersParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetListFiltersSchema, GetListFiltersData, GetListFiltersParameters, DeepReadonly<TPageParam>, GetListFiltersError>): Promise<OperationInfiniteData<GetListFiltersData, GetListFiltersParameters>>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>)): GetListFiltersData | undefined;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>)): OperationInfiniteData<GetListFiltersData, GetListFiltersParameters> | undefined;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError> | QueryFiltersByQueryKey<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters>,
            data: NoInfer<OperationInfiniteData<GetListFiltersData, GetListFiltersParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters>,
            data: GetListFiltersData | undefined
        ]>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters> | (DeepReadonly<GetListFiltersParameters>)): QueryState<GetListFiltersData, GetListFiltersError> | undefined;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetListFiltersParameters> | ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters>): QueryState<OperationInfiniteData<GetListFiltersData, GetListFiltersParameters>, GetListFiltersError> | undefined;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        setQueryData(parameters: (DeepReadonly<GetListFiltersParameters>) | ServiceOperationQueryKey<GetListFiltersSchema, GetListFiltersParameters>, updater: Updater<NoInfer<GetListFiltersData> | undefined, NoInfer<DeepReadonly<GetListFiltersData>> | undefined>, options?: SetDataOptions): GetListFiltersData | undefined;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetListFiltersParameters>) | ServiceOperationInfiniteQueryKey<GetListFiltersSchema, GetListFiltersParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetListFiltersData, GetListFiltersParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetListFiltersData, GetListFiltersParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetListFiltersData, GetListFiltersParameters> | undefined;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError> | QueryFiltersByQueryKey<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>, updater: Updater<NoInfer<GetListFiltersData> | undefined, NoInfer<GetListFiltersData> | undefined>, options?: SetDataOptions): Array<GetListFiltersData | undefined>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError> | QueryFiltersByQueryKey<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError> | QueryFiltersByQueryKey<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError> | QueryFiltersByQueryKey<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>): void;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError> | QueryFiltersByQueryKey<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get List Filters
         * @description Describe a list's filters: key, label, control type and options.
         *
         * Options are resolved in the caller's language. Group-scoped lists require
         * ``group_id``, whose permission gate is per group; member-scoped ones require
         * ``student_id``. The permission check can't gate ``student_id``, so every per-student
         * option source re-checks the viewer itself and returns no options when refused.
         *
         * A ``search`` control has no options to browse: the client searches for them. Pass
         * the student ids such a control already holds as ``selected_student_ids`` to get
         * their labels back as its options; ids outside the list's own students are ignored.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError> | QueryFiltersByQueryKey<GetListFiltersSchema, GetListFiltersData, TInfinite, GetListFiltersParameters, GetListFiltersError>): number;
        schema: GetListFiltersSchema;
        types: {
            parameters: GetListFiltersParameters;
            data: GetListFiltersData;
            error: GetListFiltersError;
        };
    };
    /**
     * @summary Get Countries
     * @description Every country, localized, sorted by name.
     *
     * Public, since the intake forms that need it are anonymous pages. The list is the
     * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
     * territories.
     */
    getCountries: {
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetCountriesSchema, GetCountriesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetCountriesParameters, TMeta, TSignal> | void), client?: (schema: GetCountriesSchema, options: {
            parameters: GetCountriesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetCountriesData, GetCountriesError>>): Promise<RequestFnResponse<GetCountriesData, GetCountriesError>>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        getQueryKey(parameters: DeepReadonly<GetCountriesParameters> | void): ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCountries.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCountries.useQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCountriesData>(parameters: ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetCountriesData, GetCountriesError, TData, ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetCountriesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCountries.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCountries.useQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCountriesData>(parameters: ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void), options: Omit<DefinedInitialDataOptions<GetCountriesData, GetCountriesError, TData, ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetCountriesError>>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetCountriesParameters> | void): ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCountries.useInfiniteQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCountriesParameters, TQueryFnData = GetCountriesData, TData = OperationInfiniteData<TQueryFnData, GetCountriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetCountriesError, TData, ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetCountriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCountries.useInfiniteQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCountriesParameters, TQueryFnData = GetCountriesData, TData = OperationInfiniteData<TQueryFnData, GetCountriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetCountriesError, TData, ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCountriesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetCountriesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getCountriesTotal = qraft.v3Service.getCountries.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getCountriesByParametersTotal = qraft.v3Service.getCountries.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError> | QueryFiltersByQueryKey<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getCountriesResults = qraft.v3Service.getCountries.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage2
         *             }
         *         }
         *     ]
         * });
         * getCountriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getCountriesCombinedResults = qraft.v3Service.getCountries.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage2
         *             }
         *         }
         *     ]
         * });
         * getCountriesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetCountriesSchema, GetCountriesParameters, GetCountriesData, GetCountriesError>>, TCombinedResult = Array<UseQueryResult<GetCountriesData, GetCountriesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetCountriesData, GetCountriesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getCountries.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getCountries.useSuspenseQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetCountriesData>(parameters: ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetCountriesData, GetCountriesError, TData, ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetCountriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCountries.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetCountriesParameters, TData = GetCountriesData>(parameters: ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetCountriesData, GetCountriesError, OperationInfiniteData<TData, GetCountriesParameters>, ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCountriesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetCountriesParameters>, OperationError<GetCountriesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getCountriesData = qraft.v3Service.getCountries.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage2
         *             }
         *         }
         *     ]
         * });
         * getCountriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getCountriesCombinedData = qraft.v3Service.getCountries.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage2
         *             }
         *         }
         *     ]
         * });
         * getCountriesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetCountriesSchema, GetCountriesParameters, GetCountriesData, GetCountriesError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetCountriesData, GetCountriesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetCountriesData, GetCountriesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetCountriesSchema, GetCountriesData, GetCountriesParameters, GetCountriesError> | void): Promise<GetCountriesData>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetCountriesSchema, GetCountriesData, GetCountriesParameters, GetCountriesError> | void): Promise<void>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetCountriesSchema, GetCountriesData, GetCountriesParameters, GetCountriesError> | void): Promise<GetCountriesData>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        fetchInfiniteQuery<TPageParam extends GetCountriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCountriesSchema, GetCountriesData, GetCountriesParameters, DeepReadonly<TPageParam>, GetCountriesError> | void): Promise<OperationInfiniteData<GetCountriesData, GetCountriesParameters>>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        prefetchInfiniteQuery<TPageParam extends GetCountriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCountriesSchema, GetCountriesData, GetCountriesParameters, DeepReadonly<TPageParam>, GetCountriesError> | void): Promise<void>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        ensureInfiniteQueryData<TPageParam extends GetCountriesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetCountriesSchema, GetCountriesData, GetCountriesParameters, DeepReadonly<TPageParam>, GetCountriesError> | void): Promise<OperationInfiniteData<GetCountriesData, GetCountriesParameters>>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void)): GetCountriesData | undefined;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void)): OperationInfiniteData<GetCountriesData, GetCountriesParameters> | undefined;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError> | QueryFiltersByQueryKey<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters>,
            data: NoInfer<OperationInfiniteData<GetCountriesData, GetCountriesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters>,
            data: GetCountriesData | undefined
        ]>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters> | (DeepReadonly<GetCountriesParameters> | void)): QueryState<GetCountriesData, GetCountriesError> | undefined;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetCountriesParameters> | ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters> | void): QueryState<OperationInfiniteData<GetCountriesData, GetCountriesParameters>, GetCountriesError> | undefined;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        setQueryData(parameters: (DeepReadonly<GetCountriesParameters> | undefined) | ServiceOperationQueryKey<GetCountriesSchema, GetCountriesParameters>, updater: Updater<NoInfer<GetCountriesData> | undefined, NoInfer<DeepReadonly<GetCountriesData>> | undefined>, options?: SetDataOptions): GetCountriesData | undefined;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetCountriesParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetCountriesSchema, GetCountriesParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetCountriesData, GetCountriesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetCountriesData, GetCountriesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetCountriesData, GetCountriesParameters> | undefined;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError> | QueryFiltersByQueryKey<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>, updater: Updater<NoInfer<GetCountriesData> | undefined, NoInfer<GetCountriesData> | undefined>, options?: SetDataOptions): Array<GetCountriesData | undefined>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError> | QueryFiltersByQueryKey<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError> | QueryFiltersByQueryKey<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError> | QueryFiltersByQueryKey<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>): void;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError> | QueryFiltersByQueryKey<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Countries
         * @description Every country, localized, sorted by name.
         *
         * Public, since the intake forms that need it are anonymous pages. The list is the
         * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
         * territories.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError> | QueryFiltersByQueryKey<GetCountriesSchema, GetCountriesData, TInfinite, GetCountriesParameters, GetCountriesError>): number;
        schema: GetCountriesSchema;
        types: {
            parameters: GetCountriesParameters;
            data: GetCountriesData;
            error: GetCountriesError;
        };
    };
    /**
     * @summary Get Gdpr Notice
     * @description The GDPR cookie notice copy, in the request's language.
     *
     * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
     * legacy's only set a cookie, so the client sets it with the name and lifetime
     * returned here.
     */
    getGdprNotice: {
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGdprNoticeParameters, TMeta, TSignal> | void), client?: (schema: GetGdprNoticeSchema, options: {
            parameters: GetGdprNoticeParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGdprNoticeData, GetGdprNoticeError>>): Promise<RequestFnResponse<GetGdprNoticeData, GetGdprNoticeError>>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        getQueryKey(parameters: DeepReadonly<GetGdprNoticeParameters> | void): ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGdprNotice.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGdprNotice.useQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGdprNoticeData>(parameters: ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetGdprNoticeData, GetGdprNoticeError, TData, ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGdprNoticeError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGdprNotice.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGdprNotice.useQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGdprNoticeData>(parameters: ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void), options: Omit<DefinedInitialDataOptions<GetGdprNoticeData, GetGdprNoticeError, TData, ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGdprNoticeError>>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGdprNoticeParameters> | void): ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGdprNotice.useInfiniteQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGdprNoticeParameters, TQueryFnData = GetGdprNoticeData, TData = OperationInfiniteData<TQueryFnData, GetGdprNoticeParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGdprNoticeError, TData, ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGdprNoticeError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGdprNotice.useInfiniteQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGdprNoticeParameters, TQueryFnData = GetGdprNoticeData, TData = OperationInfiniteData<TQueryFnData, GetGdprNoticeParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGdprNoticeError, TData, ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGdprNoticeData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGdprNoticeError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGdprNoticeTotal = qraft.v3Service.getGdprNotice.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGdprNoticeByParametersTotal = qraft.v3Service.getGdprNotice.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError> | QueryFiltersByQueryKey<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGdprNoticeResults = qraft.v3Service.getGdprNotice.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage2
         *             }
         *         }
         *     ]
         * });
         * getGdprNoticeResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGdprNoticeCombinedResults = qraft.v3Service.getGdprNotice.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage2
         *             }
         *         }
         *     ]
         * });
         * getGdprNoticeCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGdprNoticeSchema, GetGdprNoticeParameters, GetGdprNoticeData, GetGdprNoticeError>>, TCombinedResult = Array<UseQueryResult<GetGdprNoticeData, GetGdprNoticeError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGdprNoticeData, GetGdprNoticeError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getGdprNotice.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGdprNotice.useSuspenseQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGdprNoticeData>(parameters: ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetGdprNoticeData, GetGdprNoticeError, TData, ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGdprNoticeError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGdprNotice.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGdprNoticeParameters, TData = GetGdprNoticeData>(parameters: ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetGdprNoticeData, GetGdprNoticeError, OperationInfiniteData<TData, GetGdprNoticeParameters>, ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGdprNoticeData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGdprNoticeParameters>, OperationError<GetGdprNoticeError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGdprNoticeData = qraft.v3Service.getGdprNotice.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage2
         *             }
         *         }
         *     ]
         * });
         * getGdprNoticeResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGdprNoticeCombinedData = qraft.v3Service.getGdprNotice.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage2
         *             }
         *         }
         *     ]
         * });
         * getGdprNoticeCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGdprNoticeSchema, GetGdprNoticeParameters, GetGdprNoticeData, GetGdprNoticeError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGdprNoticeData, GetGdprNoticeError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGdprNoticeData, GetGdprNoticeError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGdprNoticeSchema, GetGdprNoticeData, GetGdprNoticeParameters, GetGdprNoticeError> | void): Promise<GetGdprNoticeData>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGdprNoticeSchema, GetGdprNoticeData, GetGdprNoticeParameters, GetGdprNoticeError> | void): Promise<void>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGdprNoticeSchema, GetGdprNoticeData, GetGdprNoticeParameters, GetGdprNoticeError> | void): Promise<GetGdprNoticeData>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        fetchInfiniteQuery<TPageParam extends GetGdprNoticeParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGdprNoticeSchema, GetGdprNoticeData, GetGdprNoticeParameters, DeepReadonly<TPageParam>, GetGdprNoticeError> | void): Promise<OperationInfiniteData<GetGdprNoticeData, GetGdprNoticeParameters>>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        prefetchInfiniteQuery<TPageParam extends GetGdprNoticeParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGdprNoticeSchema, GetGdprNoticeData, GetGdprNoticeParameters, DeepReadonly<TPageParam>, GetGdprNoticeError> | void): Promise<void>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        ensureInfiniteQueryData<TPageParam extends GetGdprNoticeParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGdprNoticeSchema, GetGdprNoticeData, GetGdprNoticeParameters, DeepReadonly<TPageParam>, GetGdprNoticeError> | void): Promise<OperationInfiniteData<GetGdprNoticeData, GetGdprNoticeParameters>>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void)): GetGdprNoticeData | undefined;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void)): OperationInfiniteData<GetGdprNoticeData, GetGdprNoticeParameters> | undefined;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError> | QueryFiltersByQueryKey<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>,
            data: NoInfer<OperationInfiniteData<GetGdprNoticeData, GetGdprNoticeParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>,
            data: GetGdprNoticeData | undefined
        ]>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | (DeepReadonly<GetGdprNoticeParameters> | void)): QueryState<GetGdprNoticeData, GetGdprNoticeError> | undefined;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGdprNoticeParameters> | ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters> | void): QueryState<OperationInfiniteData<GetGdprNoticeData, GetGdprNoticeParameters>, GetGdprNoticeError> | undefined;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        setQueryData(parameters: (DeepReadonly<GetGdprNoticeParameters> | undefined) | ServiceOperationQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>, updater: Updater<NoInfer<GetGdprNoticeData> | undefined, NoInfer<DeepReadonly<GetGdprNoticeData>> | undefined>, options?: SetDataOptions): GetGdprNoticeData | undefined;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGdprNoticeParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetGdprNoticeSchema, GetGdprNoticeParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGdprNoticeData, GetGdprNoticeParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGdprNoticeData, GetGdprNoticeParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGdprNoticeData, GetGdprNoticeParameters> | undefined;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError> | QueryFiltersByQueryKey<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>, updater: Updater<NoInfer<GetGdprNoticeData> | undefined, NoInfer<GetGdprNoticeData> | undefined>, options?: SetDataOptions): Array<GetGdprNoticeData | undefined>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError> | QueryFiltersByQueryKey<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError> | QueryFiltersByQueryKey<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError> | QueryFiltersByQueryKey<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>): void;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError> | QueryFiltersByQueryKey<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Gdpr Notice
         * @description The GDPR cookie notice copy, in the request's language.
         *
         * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
         * legacy's only set a cookie, so the client sets it with the name and lifetime
         * returned here.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError> | QueryFiltersByQueryKey<GetGdprNoticeSchema, GetGdprNoticeData, TInfinite, GetGdprNoticeParameters, GetGdprNoticeError>): number;
        schema: GetGdprNoticeSchema;
        types: {
            parameters: GetGdprNoticeParameters;
            data: GetGdprNoticeData;
            error: GetGdprNoticeError;
        };
    };
    /**
     * @summary List Header Notices
     * @description The sitewide notice band for this viewer, oldest first.
     *
     * Four filters, all applied here: the requested language with no English
     * fallback; unexpired; addressed to this viewer's profile type (an empty audience
     * means everyone); and not already dismissed by this viewer. An empty list is the
     * normal state — the band is chrome that is usually absent.
     *
     * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
     * it and prints only the body.
     */
    listHeaderNotices: {
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListHeaderNoticesParameters, TMeta, TSignal>), client?: (schema: ListHeaderNoticesSchema, options: {
            parameters: ListHeaderNoticesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListHeaderNoticesData, ListHeaderNoticesError>>): Promise<RequestFnResponse<ListHeaderNoticesData, ListHeaderNoticesError>>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        getQueryKey(parameters: DeepReadonly<ListHeaderNoticesParameters>): ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listHeaderNotices.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListHeaderNoticesData>(parameters: ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>), options?: Omit<UndefinedInitialDataOptions<ListHeaderNoticesData, ListHeaderNoticesError, TData, ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListHeaderNoticesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listHeaderNotices.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListHeaderNoticesData>(parameters: ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>), options: Omit<DefinedInitialDataOptions<ListHeaderNoticesData, ListHeaderNoticesError, TData, ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListHeaderNoticesError>>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListHeaderNoticesParameters>): ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listHeaderNotices.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListHeaderNoticesParameters, TQueryFnData = ListHeaderNoticesData, TData = OperationInfiniteData<TQueryFnData, ListHeaderNoticesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListHeaderNoticesError, TData, ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListHeaderNoticesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listHeaderNotices.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListHeaderNoticesParameters, TQueryFnData = ListHeaderNoticesData, TData = OperationInfiniteData<TQueryFnData, ListHeaderNoticesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListHeaderNoticesError, TData, ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListHeaderNoticesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListHeaderNoticesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listHeaderNoticesTotal = qraft.v3Service.listHeaderNotices.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listHeaderNoticesByParametersTotal = qraft.v3Service.listHeaderNotices.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError> | QueryFiltersByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listHeaderNoticesResults = qraft.v3Service.listHeaderNotices.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listHeaderNoticesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listHeaderNoticesCombinedResults = qraft.v3Service.listHeaderNotices.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listHeaderNoticesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListHeaderNoticesSchema, ListHeaderNoticesParameters, ListHeaderNoticesData, ListHeaderNoticesError>>, TCombinedResult = Array<UseQueryResult<ListHeaderNoticesData, ListHeaderNoticesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListHeaderNoticesData, ListHeaderNoticesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listHeaderNotices.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListHeaderNoticesData>(parameters: ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>), options?: Omit<UseSuspenseQueryOptions<ListHeaderNoticesData, ListHeaderNoticesError, TData, ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListHeaderNoticesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listHeaderNotices.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListHeaderNoticesParameters, TData = ListHeaderNoticesData>(parameters: ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListHeaderNoticesData, ListHeaderNoticesError, OperationInfiniteData<TData, ListHeaderNoticesParameters>, ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListHeaderNoticesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListHeaderNoticesParameters>, OperationError<ListHeaderNoticesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listHeaderNoticesData = qraft.v3Service.listHeaderNotices.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listHeaderNoticesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listHeaderNoticesCombinedData = qraft.v3Service.listHeaderNotices.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listHeaderNoticesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListHeaderNoticesSchema, ListHeaderNoticesParameters, ListHeaderNoticesData, ListHeaderNoticesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListHeaderNoticesData, ListHeaderNoticesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListHeaderNoticesData, ListHeaderNoticesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListHeaderNoticesSchema, ListHeaderNoticesData, ListHeaderNoticesParameters, ListHeaderNoticesError>): Promise<ListHeaderNoticesData>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListHeaderNoticesSchema, ListHeaderNoticesData, ListHeaderNoticesParameters, ListHeaderNoticesError>): Promise<void>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListHeaderNoticesSchema, ListHeaderNoticesData, ListHeaderNoticesParameters, ListHeaderNoticesError>): Promise<ListHeaderNoticesData>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        fetchInfiniteQuery<TPageParam extends ListHeaderNoticesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListHeaderNoticesSchema, ListHeaderNoticesData, ListHeaderNoticesParameters, DeepReadonly<TPageParam>, ListHeaderNoticesError>): Promise<OperationInfiniteData<ListHeaderNoticesData, ListHeaderNoticesParameters>>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        prefetchInfiniteQuery<TPageParam extends ListHeaderNoticesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListHeaderNoticesSchema, ListHeaderNoticesData, ListHeaderNoticesParameters, DeepReadonly<TPageParam>, ListHeaderNoticesError>): Promise<void>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        ensureInfiniteQueryData<TPageParam extends ListHeaderNoticesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListHeaderNoticesSchema, ListHeaderNoticesData, ListHeaderNoticesParameters, DeepReadonly<TPageParam>, ListHeaderNoticesError>): Promise<OperationInfiniteData<ListHeaderNoticesData, ListHeaderNoticesParameters>>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>)): ListHeaderNoticesData | undefined;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>)): OperationInfiniteData<ListHeaderNoticesData, ListHeaderNoticesParameters> | undefined;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError> | QueryFiltersByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>,
            data: NoInfer<OperationInfiniteData<ListHeaderNoticesData, ListHeaderNoticesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>,
            data: ListHeaderNoticesData | undefined
        ]>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters> | (DeepReadonly<ListHeaderNoticesParameters>)): QueryState<ListHeaderNoticesData, ListHeaderNoticesError> | undefined;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListHeaderNoticesParameters> | ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>): QueryState<OperationInfiniteData<ListHeaderNoticesData, ListHeaderNoticesParameters>, ListHeaderNoticesError> | undefined;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        setQueryData(parameters: (DeepReadonly<ListHeaderNoticesParameters>) | ServiceOperationQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>, updater: Updater<NoInfer<ListHeaderNoticesData> | undefined, NoInfer<DeepReadonly<ListHeaderNoticesData>> | undefined>, options?: SetDataOptions): ListHeaderNoticesData | undefined;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListHeaderNoticesParameters>) | ServiceOperationInfiniteQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListHeaderNoticesData, ListHeaderNoticesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListHeaderNoticesData, ListHeaderNoticesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListHeaderNoticesData, ListHeaderNoticesParameters> | undefined;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError> | QueryFiltersByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>, updater: Updater<NoInfer<ListHeaderNoticesData> | undefined, NoInfer<ListHeaderNoticesData> | undefined>, options?: SetDataOptions): Array<ListHeaderNoticesData | undefined>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError> | QueryFiltersByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError> | QueryFiltersByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError> | QueryFiltersByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>): void;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError> | QueryFiltersByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Header Notices
         * @description The sitewide notice band for this viewer, oldest first.
         *
         * Four filters, all applied here: the requested language with no English
         * fallback; unexpired; addressed to this viewer's profile type (an empty audience
         * means everyone); and not already dismissed by this viewer. An empty list is the
         * normal state — the band is chrome that is usually absent.
         *
         * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
         * it and prints only the body.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError> | QueryFiltersByQueryKey<ListHeaderNoticesSchema, ListHeaderNoticesData, TInfinite, ListHeaderNoticesParameters, ListHeaderNoticesError>): number;
        schema: ListHeaderNoticesSchema;
        types: {
            parameters: ListHeaderNoticesParameters;
            data: ListHeaderNoticesData;
            error: ListHeaderNoticesError;
        };
    };
    /**
     * @summary Dismiss Header Notice
     * @description Dismiss one notice for the authenticated caller, permanently.
     *
     * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
     * the session and can never be written on another user's behalf. An id that is not
     * a notice is a 404.
     */
    dismissHeaderNotice: {
        /**
         * @summary Dismiss Header Notice
         * @description Dismiss one notice for the authenticated caller, permanently.
         *
         * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
         * the session and can never be written on another user's behalf. An id that is not
         * a notice is a 404.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DismissHeaderNoticeBody, DismissHeaderNoticeParameters, TMeta, TSignal>, client?: (schema: DismissHeaderNoticeSchema, options: ServiceOperationMutationFnOptions<DismissHeaderNoticeBody, DismissHeaderNoticeParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DismissHeaderNoticeData, DismissHeaderNoticeError>>): Promise<RequestFnResponse<DismissHeaderNoticeData, DismissHeaderNoticeError>>;
        /**
         * @summary Dismiss Header Notice
         * @description Dismiss one notice for the authenticated caller, permanently.
         *
         * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
         * the session and can never be written on another user's behalf. An id that is not
         * a notice is a 404.
         */
        getMutationKey(parameters: DeepReadonly<DismissHeaderNoticeParameters> | void): ServiceOperationMutationKey<DismissHeaderNoticeSchema, DismissHeaderNoticeParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Dismiss Header Notice
         * @description Dismiss one notice for the authenticated caller, permanently.
         *
         * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
         * the session and can never be written on another user's behalf. An id that is not
         * a notice is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.dismissHeaderNotice.useMutation({
         *     path: {
         *         notice_id: noticeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.dismissHeaderNotice.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         notice_id: noticeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DismissHeaderNoticeBody, TContext = unknown>(parameters: DeepReadonly<DismissHeaderNoticeParameters>, options?: ServiceOperationUseMutationOptions<DismissHeaderNoticeSchema, DismissHeaderNoticeData, DismissHeaderNoticeParameters, TVariables, OperationError<DismissHeaderNoticeError>, TContext>): UseMutationResult<DismissHeaderNoticeData, OperationError<DismissHeaderNoticeError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Dismiss Header Notice
         * @description Dismiss one notice for the authenticated caller, permanently.
         *
         * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
         * the session and can never be written on another user's behalf. An id that is not
         * a notice is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.dismissHeaderNotice.useMutation({
         *     path: {
         *         notice_id: noticeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.dismissHeaderNotice.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         notice_id: noticeId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DismissHeaderNoticeBody, DismissHeaderNoticeParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DismissHeaderNoticeSchema, DismissHeaderNoticeData, DismissHeaderNoticeParameters, TVariables, OperationError<DismissHeaderNoticeError>, TContext>): UseMutationResult<DismissHeaderNoticeData, OperationError<DismissHeaderNoticeError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Dismiss Header Notice
         * @description Dismiss one notice for the authenticated caller, permanently.
         *
         * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
         * the session and can never be written on another user's behalf. An id that is not
         * a notice is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const dismissHeaderNoticeTotal = qraft.v3Service.dismissHeaderNotice.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const dismissHeaderNoticeTotal = qraft.v3Service.dismissHeaderNotice.useIsMutating({
         *     parameters: {
         *         path: {
         *             notice_id: noticeId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext> | MutationFiltersByMutationKey<DismissHeaderNoticeSchema, DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Dismiss Header Notice
         * @description Dismiss one notice for the authenticated caller, permanently.
         *
         * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
         * the session and can never be written on another user's behalf. An id that is not
         * a notice is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const dismissHeaderNoticePendingMutationVariables = qraft.v3Service.dismissHeaderNotice.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const dismissHeaderNoticeMutationData = qraft.v3Service.dismissHeaderNotice.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 notice_id: noticeId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DismissHeaderNoticeData, OperationError<DismissHeaderNoticeError>, MutationVariables<DismissHeaderNoticeBody, DismissHeaderNoticeParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext> | MutationFiltersByMutationKey<DismissHeaderNoticeSchema, DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext>;
            select?: (mutation: Mutation<DismissHeaderNoticeData, OperationError<DismissHeaderNoticeError>, MutationVariables<DismissHeaderNoticeBody, DismissHeaderNoticeParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Dismiss Header Notice
         * @description Dismiss one notice for the authenticated caller, permanently.
         *
         * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
         * the session and can never be written on another user's behalf. An id that is not
         * a notice is a 404.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext> | MutationFiltersByMutationKey<DismissHeaderNoticeSchema, DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Dismiss Header Notice
         * @description Dismiss one notice for the authenticated caller, permanently.
         *
         * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
         * the session and can never be written on another user's behalf. An id that is not
         * a notice is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.dismissHeaderNotice.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             notice_id: noticeId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.dismissHeaderNotice.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext> | MutationFiltersByMutationKey<DismissHeaderNoticeSchema, DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext>): Mutation<DismissHeaderNoticeData, DismissHeaderNoticeError, MutationVariables<DismissHeaderNoticeBody, DismissHeaderNoticeParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext> | MutationFiltersByMutationKey<DismissHeaderNoticeSchema, DismissHeaderNoticeBody, DismissHeaderNoticeData, DismissHeaderNoticeParameters, OperationError<DismissHeaderNoticeError>, TContext>): Array<Mutation<DismissHeaderNoticeData, DismissHeaderNoticeError, MutationVariables<DismissHeaderNoticeBody, DismissHeaderNoticeParameters>, TContext>>;
        };
        schema: DismissHeaderNoticeSchema;
        types: {
            parameters: DismissHeaderNoticeParameters;
            data: DismissHeaderNoticeData;
            error: DismissHeaderNoticeError;
            body: DismissHeaderNoticeBody;
        };
    };
    /**
     * @summary List Contextual Help Placements
     * @description Which help anchors resolve to a section in `language`.
     *
     * One small request per language per session. Advisory, not a boundary: the client
     * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
     * placement resolves to no section, which is why this exists.
     */
    listContextualHelpPlacements: {
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListContextualHelpPlacementsParameters, TMeta, TSignal>), client?: (schema: ListContextualHelpPlacementsSchema, options: {
            parameters: ListContextualHelpPlacementsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError>>): Promise<RequestFnResponse<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError>>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        getQueryKey(parameters: DeepReadonly<ListContextualHelpPlacementsParameters>): ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listContextualHelpPlacements.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListContextualHelpPlacementsData>(parameters: ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>), options?: Omit<UndefinedInitialDataOptions<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError, TData, ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListContextualHelpPlacementsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listContextualHelpPlacements.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListContextualHelpPlacementsData>(parameters: ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>), options: Omit<DefinedInitialDataOptions<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError, TData, ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListContextualHelpPlacementsError>>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListContextualHelpPlacementsParameters>): ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listContextualHelpPlacements.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListContextualHelpPlacementsParameters, TQueryFnData = ListContextualHelpPlacementsData, TData = OperationInfiniteData<TQueryFnData, ListContextualHelpPlacementsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListContextualHelpPlacementsError, TData, ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListContextualHelpPlacementsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listContextualHelpPlacements.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListContextualHelpPlacementsParameters, TQueryFnData = ListContextualHelpPlacementsData, TData = OperationInfiniteData<TQueryFnData, ListContextualHelpPlacementsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListContextualHelpPlacementsError, TData, ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListContextualHelpPlacementsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListContextualHelpPlacementsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listContextualHelpPlacementsTotal = qraft.v3Service.listContextualHelpPlacements.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listContextualHelpPlacementsByParametersTotal = qraft.v3Service.listContextualHelpPlacements.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError> | QueryFiltersByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listContextualHelpPlacementsResults = qraft.v3Service.listContextualHelpPlacements.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listContextualHelpPlacementsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listContextualHelpPlacementsCombinedResults = qraft.v3Service.listContextualHelpPlacements.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listContextualHelpPlacementsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsData, ListContextualHelpPlacementsError>>, TCombinedResult = Array<UseQueryResult<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listContextualHelpPlacements.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListContextualHelpPlacementsData>(parameters: ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>), options?: Omit<UseSuspenseQueryOptions<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError, TData, ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListContextualHelpPlacementsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listContextualHelpPlacements.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListContextualHelpPlacementsParameters, TData = ListContextualHelpPlacementsData>(parameters: ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError, OperationInfiniteData<TData, ListContextualHelpPlacementsParameters>, ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListContextualHelpPlacementsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListContextualHelpPlacementsParameters>, OperationError<ListContextualHelpPlacementsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listContextualHelpPlacementsData = qraft.v3Service.listContextualHelpPlacements.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listContextualHelpPlacementsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listContextualHelpPlacementsCombinedData = qraft.v3Service.listContextualHelpPlacements.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listContextualHelpPlacementsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsData, ListContextualHelpPlacementsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>): Promise<ListContextualHelpPlacementsData>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>): Promise<void>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>): Promise<ListContextualHelpPlacementsData>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        fetchInfiniteQuery<TPageParam extends ListContextualHelpPlacementsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters, DeepReadonly<TPageParam>, ListContextualHelpPlacementsError>): Promise<OperationInfiniteData<ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters>>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        prefetchInfiniteQuery<TPageParam extends ListContextualHelpPlacementsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters, DeepReadonly<TPageParam>, ListContextualHelpPlacementsError>): Promise<void>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        ensureInfiniteQueryData<TPageParam extends ListContextualHelpPlacementsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters, DeepReadonly<TPageParam>, ListContextualHelpPlacementsError>): Promise<OperationInfiniteData<ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters>>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>)): ListContextualHelpPlacementsData | undefined;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>)): OperationInfiniteData<ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters> | undefined;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError> | QueryFiltersByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>,
            data: NoInfer<OperationInfiniteData<ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>,
            data: ListContextualHelpPlacementsData | undefined
        ]>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters> | (DeepReadonly<ListContextualHelpPlacementsParameters>)): QueryState<ListContextualHelpPlacementsData, ListContextualHelpPlacementsError> | undefined;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListContextualHelpPlacementsParameters> | ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>): QueryState<OperationInfiniteData<ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters>, ListContextualHelpPlacementsError> | undefined;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        setQueryData(parameters: (DeepReadonly<ListContextualHelpPlacementsParameters>) | ServiceOperationQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>, updater: Updater<NoInfer<ListContextualHelpPlacementsData> | undefined, NoInfer<DeepReadonly<ListContextualHelpPlacementsData>> | undefined>, options?: SetDataOptions): ListContextualHelpPlacementsData | undefined;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListContextualHelpPlacementsParameters>) | ServiceOperationInfiniteQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListContextualHelpPlacementsData, ListContextualHelpPlacementsParameters> | undefined;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError> | QueryFiltersByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>, updater: Updater<NoInfer<ListContextualHelpPlacementsData> | undefined, NoInfer<ListContextualHelpPlacementsData> | undefined>, options?: SetDataOptions): Array<ListContextualHelpPlacementsData | undefined>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError> | QueryFiltersByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError> | QueryFiltersByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError> | QueryFiltersByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>): void;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError> | QueryFiltersByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Contextual Help Placements
         * @description Which help anchors resolve to a section in `language`.
         *
         * One small request per language per session. Advisory, not a boundary: the client
         * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
         * placement resolves to no section, which is why this exists.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError> | QueryFiltersByQueryKey<ListContextualHelpPlacementsSchema, ListContextualHelpPlacementsData, TInfinite, ListContextualHelpPlacementsParameters, ListContextualHelpPlacementsError>): number;
        schema: ListContextualHelpPlacementsSchema;
        types: {
            parameters: ListContextualHelpPlacementsParameters;
            data: ListContextualHelpPlacementsData;
            error: ListContextualHelpPlacementsError;
        };
    };
    /**
     * @summary Get Contextual Help Placement
     * @description The single help section a screen anchors.
     *
     * Deliberately not filtered by the caller's profile type: the audience filter
     * applies to the whole-tree read only, so a screen's own help is whatever that
     * screen anchors. An anchor with no section in `language` is a 404.
     */
    getContextualHelpPlacement: {
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetContextualHelpPlacementParameters, TMeta, TSignal>), client?: (schema: GetContextualHelpPlacementSchema, options: {
            parameters: GetContextualHelpPlacementParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetContextualHelpPlacementData, GetContextualHelpPlacementError>>): Promise<RequestFnResponse<GetContextualHelpPlacementData, GetContextualHelpPlacementError>>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        getQueryKey(parameters: DeepReadonly<GetContextualHelpPlacementParameters>): ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getContextualHelpPlacement.useQuery({
         *     path: {
         *         placement: placement
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetContextualHelpPlacementData>(parameters: ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>), options?: Omit<UndefinedInitialDataOptions<GetContextualHelpPlacementData, GetContextualHelpPlacementError, TData, ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetContextualHelpPlacementError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getContextualHelpPlacement.useQuery({
         *     path: {
         *         placement: placement
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetContextualHelpPlacementData>(parameters: ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>), options: Omit<DefinedInitialDataOptions<GetContextualHelpPlacementData, GetContextualHelpPlacementError, TData, ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetContextualHelpPlacementError>>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetContextualHelpPlacementParameters>): ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContextualHelpPlacement.useInfiniteQuery({
         *     path: {
         *         placement: placement
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetContextualHelpPlacementParameters, TQueryFnData = GetContextualHelpPlacementData, TData = OperationInfiniteData<TQueryFnData, GetContextualHelpPlacementParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetContextualHelpPlacementError, TData, ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetContextualHelpPlacementError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContextualHelpPlacement.useInfiniteQuery({
         *     path: {
         *         placement: placement
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetContextualHelpPlacementParameters, TQueryFnData = GetContextualHelpPlacementData, TData = OperationInfiniteData<TQueryFnData, GetContextualHelpPlacementParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetContextualHelpPlacementError, TData, ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetContextualHelpPlacementData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetContextualHelpPlacementError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getContextualHelpPlacementTotal = qraft.v3Service.getContextualHelpPlacement.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getContextualHelpPlacementByParametersTotal = qraft.v3Service.getContextualHelpPlacement.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             placement: placement
         *         },
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError> | QueryFiltersByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getContextualHelpPlacementResults = qraft.v3Service.getContextualHelpPlacement.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 placement: placement1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 placement: placement2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContextualHelpPlacementResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getContextualHelpPlacementCombinedResults = qraft.v3Service.getContextualHelpPlacement.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 placement: placement1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 placement: placement2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContextualHelpPlacementCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters, GetContextualHelpPlacementData, GetContextualHelpPlacementError>>, TCombinedResult = Array<UseQueryResult<GetContextualHelpPlacementData, GetContextualHelpPlacementError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetContextualHelpPlacementData, GetContextualHelpPlacementError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getContextualHelpPlacement.useSuspenseQuery({
         *     path: {
         *         placement: placement
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetContextualHelpPlacementData>(parameters: ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>), options?: Omit<UseSuspenseQueryOptions<GetContextualHelpPlacementData, GetContextualHelpPlacementError, TData, ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetContextualHelpPlacementError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContextualHelpPlacement.useSuspenseInfiniteQuery({
         *     path: {
         *         placement: placement
         *     },
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetContextualHelpPlacementParameters, TData = GetContextualHelpPlacementData>(parameters: ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetContextualHelpPlacementData, GetContextualHelpPlacementError, OperationInfiniteData<TData, GetContextualHelpPlacementParameters>, ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetContextualHelpPlacementData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetContextualHelpPlacementParameters>, OperationError<GetContextualHelpPlacementError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getContextualHelpPlacementData = qraft.v3Service.getContextualHelpPlacement.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 placement: placement1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 placement: placement2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContextualHelpPlacementResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getContextualHelpPlacementCombinedData = qraft.v3Service.getContextualHelpPlacement.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 placement: placement1
         *             },
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 placement: placement2
         *             },
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContextualHelpPlacementCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters, GetContextualHelpPlacementData, GetContextualHelpPlacementError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetContextualHelpPlacementData, GetContextualHelpPlacementError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetContextualHelpPlacementData, GetContextualHelpPlacementError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>): Promise<GetContextualHelpPlacementData>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>): Promise<void>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>): Promise<GetContextualHelpPlacementData>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        fetchInfiniteQuery<TPageParam extends GetContextualHelpPlacementParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, GetContextualHelpPlacementParameters, DeepReadonly<TPageParam>, GetContextualHelpPlacementError>): Promise<OperationInfiniteData<GetContextualHelpPlacementData, GetContextualHelpPlacementParameters>>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        prefetchInfiniteQuery<TPageParam extends GetContextualHelpPlacementParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, GetContextualHelpPlacementParameters, DeepReadonly<TPageParam>, GetContextualHelpPlacementError>): Promise<void>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        ensureInfiniteQueryData<TPageParam extends GetContextualHelpPlacementParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, GetContextualHelpPlacementParameters, DeepReadonly<TPageParam>, GetContextualHelpPlacementError>): Promise<OperationInfiniteData<GetContextualHelpPlacementData, GetContextualHelpPlacementParameters>>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>)): GetContextualHelpPlacementData | undefined;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>)): OperationInfiniteData<GetContextualHelpPlacementData, GetContextualHelpPlacementParameters> | undefined;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError> | QueryFiltersByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>,
            data: NoInfer<OperationInfiniteData<GetContextualHelpPlacementData, GetContextualHelpPlacementParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>,
            data: GetContextualHelpPlacementData | undefined
        ]>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters> | (DeepReadonly<GetContextualHelpPlacementParameters>)): QueryState<GetContextualHelpPlacementData, GetContextualHelpPlacementError> | undefined;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetContextualHelpPlacementParameters> | ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>): QueryState<OperationInfiniteData<GetContextualHelpPlacementData, GetContextualHelpPlacementParameters>, GetContextualHelpPlacementError> | undefined;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        setQueryData(parameters: (DeepReadonly<GetContextualHelpPlacementParameters>) | ServiceOperationQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>, updater: Updater<NoInfer<GetContextualHelpPlacementData> | undefined, NoInfer<DeepReadonly<GetContextualHelpPlacementData>> | undefined>, options?: SetDataOptions): GetContextualHelpPlacementData | undefined;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetContextualHelpPlacementParameters>) | ServiceOperationInfiniteQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetContextualHelpPlacementData, GetContextualHelpPlacementParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetContextualHelpPlacementData, GetContextualHelpPlacementParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetContextualHelpPlacementData, GetContextualHelpPlacementParameters> | undefined;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError> | QueryFiltersByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>, updater: Updater<NoInfer<GetContextualHelpPlacementData> | undefined, NoInfer<GetContextualHelpPlacementData> | undefined>, options?: SetDataOptions): Array<GetContextualHelpPlacementData | undefined>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError> | QueryFiltersByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError> | QueryFiltersByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError> | QueryFiltersByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>): void;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError> | QueryFiltersByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Contextual Help Placement
         * @description The single help section a screen anchors.
         *
         * Deliberately not filtered by the caller's profile type: the audience filter
         * applies to the whole-tree read only, so a screen's own help is whatever that
         * screen anchors. An anchor with no section in `language` is a 404.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError> | QueryFiltersByQueryKey<GetContextualHelpPlacementSchema, GetContextualHelpPlacementData, TInfinite, GetContextualHelpPlacementParameters, GetContextualHelpPlacementError>): number;
        schema: GetContextualHelpPlacementSchema;
        types: {
            parameters: GetContextualHelpPlacementParameters;
            data: GetContextualHelpPlacementData;
            error: GetContextualHelpPlacementError;
        };
    };
    /**
     * @summary Get Contextual Help Tree
     * @description The whole help tree for the caller, in `language`.
     *
     * Sections the caller's profile type is excluded from are omitted, and so are
     * sections excluded from everyone. `sections` may be empty, and a section's
     * `articles` may be empty; both are states to render.
     */
    getContextualHelpTree: {
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetContextualHelpTreeParameters, TMeta, TSignal>), client?: (schema: GetContextualHelpTreeSchema, options: {
            parameters: GetContextualHelpTreeParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetContextualHelpTreeData, GetContextualHelpTreeError>>): Promise<RequestFnResponse<GetContextualHelpTreeData, GetContextualHelpTreeError>>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        getQueryKey(parameters: DeepReadonly<GetContextualHelpTreeParameters>): ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getContextualHelpTree.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetContextualHelpTreeData>(parameters: ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>), options?: Omit<UndefinedInitialDataOptions<GetContextualHelpTreeData, GetContextualHelpTreeError, TData, ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetContextualHelpTreeError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getContextualHelpTree.useQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetContextualHelpTreeData>(parameters: ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>), options: Omit<DefinedInitialDataOptions<GetContextualHelpTreeData, GetContextualHelpTreeError, TData, ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetContextualHelpTreeError>>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetContextualHelpTreeParameters>): ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContextualHelpTree.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetContextualHelpTreeParameters, TQueryFnData = GetContextualHelpTreeData, TData = OperationInfiniteData<TQueryFnData, GetContextualHelpTreeParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetContextualHelpTreeError, TData, ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetContextualHelpTreeError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContextualHelpTree.useInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetContextualHelpTreeParameters, TQueryFnData = GetContextualHelpTreeData, TData = OperationInfiniteData<TQueryFnData, GetContextualHelpTreeParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetContextualHelpTreeError, TData, ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetContextualHelpTreeData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetContextualHelpTreeError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getContextualHelpTreeTotal = qraft.v3Service.getContextualHelpTree.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getContextualHelpTreeByParametersTotal = qraft.v3Service.getContextualHelpTree.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             language: language
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError> | QueryFiltersByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getContextualHelpTreeResults = qraft.v3Service.getContextualHelpTree.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContextualHelpTreeResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getContextualHelpTreeCombinedResults = qraft.v3Service.getContextualHelpTree.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContextualHelpTreeCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters, GetContextualHelpTreeData, GetContextualHelpTreeError>>, TCombinedResult = Array<UseQueryResult<GetContextualHelpTreeData, GetContextualHelpTreeError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetContextualHelpTreeData, GetContextualHelpTreeError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getContextualHelpTree.useSuspenseQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetContextualHelpTreeData>(parameters: ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>), options?: Omit<UseSuspenseQueryOptions<GetContextualHelpTreeData, GetContextualHelpTreeError, TData, ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetContextualHelpTreeError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContextualHelpTree.useSuspenseInfiniteQuery({
         *     query: {
         *         language: language
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             language: initialLanguage
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetContextualHelpTreeParameters, TData = GetContextualHelpTreeData>(parameters: ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetContextualHelpTreeData, GetContextualHelpTreeError, OperationInfiniteData<TData, GetContextualHelpTreeParameters>, ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetContextualHelpTreeData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetContextualHelpTreeParameters>, OperationError<GetContextualHelpTreeError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getContextualHelpTreeData = qraft.v3Service.getContextualHelpTree.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContextualHelpTreeResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getContextualHelpTreeCombinedData = qraft.v3Service.getContextualHelpTree.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 language: language1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 language: language2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContextualHelpTreeCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters, GetContextualHelpTreeData, GetContextualHelpTreeError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetContextualHelpTreeData, GetContextualHelpTreeError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetContextualHelpTreeData, GetContextualHelpTreeError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetContextualHelpTreeSchema, GetContextualHelpTreeData, GetContextualHelpTreeParameters, GetContextualHelpTreeError>): Promise<GetContextualHelpTreeData>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetContextualHelpTreeSchema, GetContextualHelpTreeData, GetContextualHelpTreeParameters, GetContextualHelpTreeError>): Promise<void>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetContextualHelpTreeSchema, GetContextualHelpTreeData, GetContextualHelpTreeParameters, GetContextualHelpTreeError>): Promise<GetContextualHelpTreeData>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        fetchInfiniteQuery<TPageParam extends GetContextualHelpTreeParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetContextualHelpTreeSchema, GetContextualHelpTreeData, GetContextualHelpTreeParameters, DeepReadonly<TPageParam>, GetContextualHelpTreeError>): Promise<OperationInfiniteData<GetContextualHelpTreeData, GetContextualHelpTreeParameters>>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        prefetchInfiniteQuery<TPageParam extends GetContextualHelpTreeParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetContextualHelpTreeSchema, GetContextualHelpTreeData, GetContextualHelpTreeParameters, DeepReadonly<TPageParam>, GetContextualHelpTreeError>): Promise<void>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        ensureInfiniteQueryData<TPageParam extends GetContextualHelpTreeParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetContextualHelpTreeSchema, GetContextualHelpTreeData, GetContextualHelpTreeParameters, DeepReadonly<TPageParam>, GetContextualHelpTreeError>): Promise<OperationInfiniteData<GetContextualHelpTreeData, GetContextualHelpTreeParameters>>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>)): GetContextualHelpTreeData | undefined;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>)): OperationInfiniteData<GetContextualHelpTreeData, GetContextualHelpTreeParameters> | undefined;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError> | QueryFiltersByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>,
            data: NoInfer<OperationInfiniteData<GetContextualHelpTreeData, GetContextualHelpTreeParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>,
            data: GetContextualHelpTreeData | undefined
        ]>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters> | (DeepReadonly<GetContextualHelpTreeParameters>)): QueryState<GetContextualHelpTreeData, GetContextualHelpTreeError> | undefined;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetContextualHelpTreeParameters> | ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>): QueryState<OperationInfiniteData<GetContextualHelpTreeData, GetContextualHelpTreeParameters>, GetContextualHelpTreeError> | undefined;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        setQueryData(parameters: (DeepReadonly<GetContextualHelpTreeParameters>) | ServiceOperationQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>, updater: Updater<NoInfer<GetContextualHelpTreeData> | undefined, NoInfer<DeepReadonly<GetContextualHelpTreeData>> | undefined>, options?: SetDataOptions): GetContextualHelpTreeData | undefined;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetContextualHelpTreeParameters>) | ServiceOperationInfiniteQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetContextualHelpTreeData, GetContextualHelpTreeParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetContextualHelpTreeData, GetContextualHelpTreeParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetContextualHelpTreeData, GetContextualHelpTreeParameters> | undefined;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError> | QueryFiltersByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>, updater: Updater<NoInfer<GetContextualHelpTreeData> | undefined, NoInfer<GetContextualHelpTreeData> | undefined>, options?: SetDataOptions): Array<GetContextualHelpTreeData | undefined>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError> | QueryFiltersByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError> | QueryFiltersByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError> | QueryFiltersByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>): void;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError> | QueryFiltersByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Contextual Help Tree
         * @description The whole help tree for the caller, in `language`.
         *
         * Sections the caller's profile type is excluded from are omitted, and so are
         * sections excluded from everyone. `sections` may be empty, and a section's
         * `articles` may be empty; both are states to render.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError> | QueryFiltersByQueryKey<GetContextualHelpTreeSchema, GetContextualHelpTreeData, TInfinite, GetContextualHelpTreeParameters, GetContextualHelpTreeError>): number;
        schema: GetContextualHelpTreeSchema;
        types: {
            parameters: GetContextualHelpTreeParameters;
            data: GetContextualHelpTreeData;
            error: GetContextualHelpTreeError;
        };
    };
    /**
     * @summary List Notifications
     * @description The caller's notifications, newest first by default, split by read state.
     *
     * `action` backs the screen's action filter.
     */
    listNotifications: {
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListNotificationsSchema, ListNotificationsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListNotificationsParameters, TMeta, TSignal> | void), client?: (schema: ListNotificationsSchema, options: {
            parameters: ListNotificationsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListNotificationsData, ListNotificationsError>>): Promise<RequestFnResponse<ListNotificationsData, ListNotificationsError>>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        getQueryKey(parameters: DeepReadonly<ListNotificationsParameters> | void): ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listNotifications.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listNotifications.useQuery({
         *     query: {
         *         read: read
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListNotificationsData>(parameters: ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListNotificationsData, ListNotificationsError, TData, ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListNotificationsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listNotifications.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listNotifications.useQuery({
         *     query: {
         *         read: read
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListNotificationsData>(parameters: ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void), options: Omit<DefinedInitialDataOptions<ListNotificationsData, ListNotificationsError, TData, ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListNotificationsError>>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListNotificationsParameters> | void): ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listNotifications.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             read: initialRead
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListNotificationsParameters, TQueryFnData = ListNotificationsData, TData = OperationInfiniteData<TQueryFnData, ListNotificationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListNotificationsError, TData, ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListNotificationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listNotifications.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             read: initialRead
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListNotificationsParameters, TQueryFnData = ListNotificationsData, TData = OperationInfiniteData<TQueryFnData, ListNotificationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListNotificationsError, TData, ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListNotificationsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListNotificationsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listNotificationsTotal = qraft.v3Service.listNotifications.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listNotificationsByParametersTotal = qraft.v3Service.listNotifications.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             read: read
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError> | QueryFiltersByQueryKey<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listNotificationsResults = qraft.v3Service.listNotifications.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 read: read1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 read: read2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listNotificationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listNotificationsCombinedResults = qraft.v3Service.listNotifications.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 read: read1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 read: read2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listNotificationsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListNotificationsSchema, ListNotificationsParameters, ListNotificationsData, ListNotificationsError>>, TCombinedResult = Array<UseQueryResult<ListNotificationsData, ListNotificationsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListNotificationsData, ListNotificationsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listNotifications.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listNotifications.useSuspenseQuery({
         *     query: {
         *         read: read
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListNotificationsData>(parameters: ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListNotificationsData, ListNotificationsError, TData, ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListNotificationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listNotifications.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             read: initialRead
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListNotificationsParameters, TData = ListNotificationsData>(parameters: ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListNotificationsData, ListNotificationsError, OperationInfiniteData<TData, ListNotificationsParameters>, ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListNotificationsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListNotificationsParameters>, OperationError<ListNotificationsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listNotificationsData = qraft.v3Service.listNotifications.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 read: read1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 read: read2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listNotificationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listNotificationsCombinedData = qraft.v3Service.listNotifications.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 read: read1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 read: read2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listNotificationsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListNotificationsSchema, ListNotificationsParameters, ListNotificationsData, ListNotificationsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListNotificationsData, ListNotificationsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListNotificationsData, ListNotificationsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListNotificationsSchema, ListNotificationsData, ListNotificationsParameters, ListNotificationsError> | void): Promise<ListNotificationsData>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListNotificationsSchema, ListNotificationsData, ListNotificationsParameters, ListNotificationsError> | void): Promise<void>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListNotificationsSchema, ListNotificationsData, ListNotificationsParameters, ListNotificationsError> | void): Promise<ListNotificationsData>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        fetchInfiniteQuery<TPageParam extends ListNotificationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListNotificationsSchema, ListNotificationsData, ListNotificationsParameters, DeepReadonly<TPageParam>, ListNotificationsError> | void): Promise<OperationInfiniteData<ListNotificationsData, ListNotificationsParameters>>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        prefetchInfiniteQuery<TPageParam extends ListNotificationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListNotificationsSchema, ListNotificationsData, ListNotificationsParameters, DeepReadonly<TPageParam>, ListNotificationsError> | void): Promise<void>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        ensureInfiniteQueryData<TPageParam extends ListNotificationsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListNotificationsSchema, ListNotificationsData, ListNotificationsParameters, DeepReadonly<TPageParam>, ListNotificationsError> | void): Promise<OperationInfiniteData<ListNotificationsData, ListNotificationsParameters>>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void)): ListNotificationsData | undefined;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void)): OperationInfiniteData<ListNotificationsData, ListNotificationsParameters> | undefined;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError> | QueryFiltersByQueryKey<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters>,
            data: NoInfer<OperationInfiniteData<ListNotificationsData, ListNotificationsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters>,
            data: ListNotificationsData | undefined
        ]>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters> | (DeepReadonly<ListNotificationsParameters> | void)): QueryState<ListNotificationsData, ListNotificationsError> | undefined;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListNotificationsParameters> | ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters> | void): QueryState<OperationInfiniteData<ListNotificationsData, ListNotificationsParameters>, ListNotificationsError> | undefined;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        setQueryData(parameters: (DeepReadonly<ListNotificationsParameters> | undefined) | ServiceOperationQueryKey<ListNotificationsSchema, ListNotificationsParameters>, updater: Updater<NoInfer<ListNotificationsData> | undefined, NoInfer<DeepReadonly<ListNotificationsData>> | undefined>, options?: SetDataOptions): ListNotificationsData | undefined;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListNotificationsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListNotificationsSchema, ListNotificationsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListNotificationsData, ListNotificationsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListNotificationsData, ListNotificationsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListNotificationsData, ListNotificationsParameters> | undefined;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError> | QueryFiltersByQueryKey<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>, updater: Updater<NoInfer<ListNotificationsData> | undefined, NoInfer<ListNotificationsData> | undefined>, options?: SetDataOptions): Array<ListNotificationsData | undefined>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError> | QueryFiltersByQueryKey<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError> | QueryFiltersByQueryKey<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError> | QueryFiltersByQueryKey<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>): void;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError> | QueryFiltersByQueryKey<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Notifications
         * @description The caller's notifications, newest first by default, split by read state.
         *
         * `action` backs the screen's action filter.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError> | QueryFiltersByQueryKey<ListNotificationsSchema, ListNotificationsData, TInfinite, ListNotificationsParameters, ListNotificationsError>): number;
        schema: ListNotificationsSchema;
        types: {
            parameters: ListNotificationsParameters;
            data: ListNotificationsData;
            error: ListNotificationsError;
        };
    };
    /**
     * @summary Get Unread Notification Count
     * @description How many unread notifications the caller has — the header bell's badge.
     */
    getUnreadNotificationCount: {
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetUnreadNotificationCountParameters, TMeta, TSignal> | void), client?: (schema: GetUnreadNotificationCountSchema, options: {
            parameters: GetUnreadNotificationCountParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetUnreadNotificationCountData, GetUnreadNotificationCountError>>): Promise<RequestFnResponse<GetUnreadNotificationCountData, GetUnreadNotificationCountError>>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        getQueryKey(parameters: DeepReadonly<GetUnreadNotificationCountParameters> | void): ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getUnreadNotificationCount.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getUnreadNotificationCount.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetUnreadNotificationCountData>(parameters: ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetUnreadNotificationCountData, GetUnreadNotificationCountError, TData, ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetUnreadNotificationCountError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getUnreadNotificationCount.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getUnreadNotificationCount.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetUnreadNotificationCountData>(parameters: ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void), options: Omit<DefinedInitialDataOptions<GetUnreadNotificationCountData, GetUnreadNotificationCountError, TData, ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetUnreadNotificationCountError>>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetUnreadNotificationCountParameters> | void): ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getUnreadNotificationCount.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetUnreadNotificationCountParameters, TQueryFnData = GetUnreadNotificationCountData, TData = OperationInfiniteData<TQueryFnData, GetUnreadNotificationCountParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetUnreadNotificationCountError, TData, ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetUnreadNotificationCountError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getUnreadNotificationCount.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetUnreadNotificationCountParameters, TQueryFnData = GetUnreadNotificationCountData, TData = OperationInfiniteData<TQueryFnData, GetUnreadNotificationCountParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetUnreadNotificationCountError, TData, ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetUnreadNotificationCountData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetUnreadNotificationCountError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getUnreadNotificationCountTotal = qraft.v3Service.getUnreadNotificationCount.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getUnreadNotificationCountByParametersTotal = qraft.v3Service.getUnreadNotificationCount.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | QueryFiltersByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getUnreadNotificationCountResults = qraft.v3Service.getUnreadNotificationCount.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getUnreadNotificationCountResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getUnreadNotificationCountCombinedResults = qraft.v3Service.getUnreadNotificationCount.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getUnreadNotificationCountCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters, GetUnreadNotificationCountData, GetUnreadNotificationCountError>>, TCombinedResult = Array<UseQueryResult<GetUnreadNotificationCountData, GetUnreadNotificationCountError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetUnreadNotificationCountData, GetUnreadNotificationCountError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getUnreadNotificationCount.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getUnreadNotificationCount.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetUnreadNotificationCountData>(parameters: ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetUnreadNotificationCountData, GetUnreadNotificationCountError, TData, ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetUnreadNotificationCountError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getUnreadNotificationCount.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetUnreadNotificationCountParameters, TData = GetUnreadNotificationCountData>(parameters: ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetUnreadNotificationCountData, GetUnreadNotificationCountError, OperationInfiniteData<TData, GetUnreadNotificationCountParameters>, ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetUnreadNotificationCountData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetUnreadNotificationCountParameters>, OperationError<GetUnreadNotificationCountError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getUnreadNotificationCountData = qraft.v3Service.getUnreadNotificationCount.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getUnreadNotificationCountResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getUnreadNotificationCountCombinedData = qraft.v3Service.getUnreadNotificationCount.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getUnreadNotificationCountCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters, GetUnreadNotificationCountData, GetUnreadNotificationCountError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetUnreadNotificationCountData, GetUnreadNotificationCountError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetUnreadNotificationCountData, GetUnreadNotificationCountError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | void): Promise<GetUnreadNotificationCountData>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | void): Promise<void>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | void): Promise<GetUnreadNotificationCountData>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        fetchInfiniteQuery<TPageParam extends GetUnreadNotificationCountParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, GetUnreadNotificationCountParameters, DeepReadonly<TPageParam>, GetUnreadNotificationCountError> | void): Promise<OperationInfiniteData<GetUnreadNotificationCountData, GetUnreadNotificationCountParameters>>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        prefetchInfiniteQuery<TPageParam extends GetUnreadNotificationCountParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, GetUnreadNotificationCountParameters, DeepReadonly<TPageParam>, GetUnreadNotificationCountError> | void): Promise<void>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        ensureInfiniteQueryData<TPageParam extends GetUnreadNotificationCountParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, GetUnreadNotificationCountParameters, DeepReadonly<TPageParam>, GetUnreadNotificationCountError> | void): Promise<OperationInfiniteData<GetUnreadNotificationCountData, GetUnreadNotificationCountParameters>>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void)): GetUnreadNotificationCountData | undefined;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void)): OperationInfiniteData<GetUnreadNotificationCountData, GetUnreadNotificationCountParameters> | undefined;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | QueryFiltersByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>,
            data: NoInfer<OperationInfiniteData<GetUnreadNotificationCountData, GetUnreadNotificationCountParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>,
            data: GetUnreadNotificationCountData | undefined
        ]>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | (DeepReadonly<GetUnreadNotificationCountParameters> | void)): QueryState<GetUnreadNotificationCountData, GetUnreadNotificationCountError> | undefined;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetUnreadNotificationCountParameters> | ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters> | void): QueryState<OperationInfiniteData<GetUnreadNotificationCountData, GetUnreadNotificationCountParameters>, GetUnreadNotificationCountError> | undefined;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        setQueryData(parameters: (DeepReadonly<GetUnreadNotificationCountParameters> | undefined) | ServiceOperationQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>, updater: Updater<NoInfer<GetUnreadNotificationCountData> | undefined, NoInfer<DeepReadonly<GetUnreadNotificationCountData>> | undefined>, options?: SetDataOptions): GetUnreadNotificationCountData | undefined;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetUnreadNotificationCountParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetUnreadNotificationCountData, GetUnreadNotificationCountParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetUnreadNotificationCountData, GetUnreadNotificationCountParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetUnreadNotificationCountData, GetUnreadNotificationCountParameters> | undefined;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | QueryFiltersByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>, updater: Updater<NoInfer<GetUnreadNotificationCountData> | undefined, NoInfer<GetUnreadNotificationCountData> | undefined>, options?: SetDataOptions): Array<GetUnreadNotificationCountData | undefined>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | QueryFiltersByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | QueryFiltersByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | QueryFiltersByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>): void;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | QueryFiltersByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Unread Notification Count
         * @description How many unread notifications the caller has — the header bell's badge.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError> | QueryFiltersByQueryKey<GetUnreadNotificationCountSchema, GetUnreadNotificationCountData, TInfinite, GetUnreadNotificationCountParameters, GetUnreadNotificationCountError>): number;
        schema: GetUnreadNotificationCountSchema;
        types: {
            parameters: GetUnreadNotificationCountParameters;
            data: GetUnreadNotificationCountData;
            error: GetUnreadNotificationCountError;
        };
    };
    /**
     * @summary Mark Notifications Read
     * @description Mark the caller's notifications read. Idempotent.
     */
    markNotificationsRead: {
        /**
         * @summary Mark Notifications Read
         * @description Mark the caller's notifications read. Idempotent.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkNotificationsReadBody, MarkNotificationsReadParameters, TMeta, TSignal>, client?: (schema: MarkNotificationsReadSchema, options: ServiceOperationMutationFnOptions<MarkNotificationsReadBody, MarkNotificationsReadParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkNotificationsReadData, MarkNotificationsReadError>>): Promise<RequestFnResponse<MarkNotificationsReadData, MarkNotificationsReadError>>;
        /**
         * @summary Mark Notifications Read
         * @description Mark the caller's notifications read. Idempotent.
         */
        getMutationKey(parameters: DeepReadonly<MarkNotificationsReadParameters> | void): ServiceOperationMutationKey<MarkNotificationsReadSchema, MarkNotificationsReadParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Notifications Read
         * @description Mark the caller's notifications read. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markNotificationsRead.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markNotificationsRead.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkNotificationsReadBody, TContext = unknown>(parameters: DeepReadonly<MarkNotificationsReadParameters>, options?: ServiceOperationUseMutationOptions<MarkNotificationsReadSchema, MarkNotificationsReadData, MarkNotificationsReadParameters, TVariables, OperationError<MarkNotificationsReadError>, TContext>): UseMutationResult<MarkNotificationsReadData, OperationError<MarkNotificationsReadError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Notifications Read
         * @description Mark the caller's notifications read. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markNotificationsRead.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markNotificationsRead.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkNotificationsReadBody, MarkNotificationsReadParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkNotificationsReadSchema, MarkNotificationsReadData, MarkNotificationsReadParameters, TVariables, OperationError<MarkNotificationsReadError>, TContext>): UseMutationResult<MarkNotificationsReadData, OperationError<MarkNotificationsReadError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark Notifications Read
         * @description Mark the caller's notifications read. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markNotificationsReadTotal = qraft.v3Service.markNotificationsRead.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markNotificationsReadTotal = qraft.v3Service.markNotificationsRead.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsReadSchema, MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark Notifications Read
         * @description Mark the caller's notifications read. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markNotificationsReadPendingMutationVariables = qraft.v3Service.markNotificationsRead.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markNotificationsReadMutationData = qraft.v3Service.markNotificationsRead.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkNotificationsReadData, OperationError<MarkNotificationsReadError>, MutationVariables<MarkNotificationsReadBody, MarkNotificationsReadParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsReadSchema, MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext>;
            select?: (mutation: Mutation<MarkNotificationsReadData, OperationError<MarkNotificationsReadError>, MutationVariables<MarkNotificationsReadBody, MarkNotificationsReadParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Mark Notifications Read
         * @description Mark the caller's notifications read. Idempotent.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsReadSchema, MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark Notifications Read
         * @description Mark the caller's notifications read. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.markNotificationsRead.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.markNotificationsRead.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsReadSchema, MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext>): Mutation<MarkNotificationsReadData, MarkNotificationsReadError, MutationVariables<MarkNotificationsReadBody, MarkNotificationsReadParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsReadSchema, MarkNotificationsReadBody, MarkNotificationsReadData, MarkNotificationsReadParameters, OperationError<MarkNotificationsReadError>, TContext>): Array<Mutation<MarkNotificationsReadData, MarkNotificationsReadError, MutationVariables<MarkNotificationsReadBody, MarkNotificationsReadParameters>, TContext>>;
        };
        schema: MarkNotificationsReadSchema;
        types: {
            parameters: MarkNotificationsReadParameters;
            data: MarkNotificationsReadData;
            error: MarkNotificationsReadError;
            body: MarkNotificationsReadBody;
        };
    };
    /**
     * @summary Mark Notifications Unread
     * @description Mark the caller's notifications unread. Idempotent.
     */
    markNotificationsUnread: {
        /**
         * @summary Mark Notifications Unread
         * @description Mark the caller's notifications unread. Idempotent.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkNotificationsUnreadBody, MarkNotificationsUnreadParameters, TMeta, TSignal>, client?: (schema: MarkNotificationsUnreadSchema, options: ServiceOperationMutationFnOptions<MarkNotificationsUnreadBody, MarkNotificationsUnreadParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkNotificationsUnreadData, MarkNotificationsUnreadError>>): Promise<RequestFnResponse<MarkNotificationsUnreadData, MarkNotificationsUnreadError>>;
        /**
         * @summary Mark Notifications Unread
         * @description Mark the caller's notifications unread. Idempotent.
         */
        getMutationKey(parameters: DeepReadonly<MarkNotificationsUnreadParameters> | void): ServiceOperationMutationKey<MarkNotificationsUnreadSchema, MarkNotificationsUnreadParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Notifications Unread
         * @description Mark the caller's notifications unread. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markNotificationsUnread.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markNotificationsUnread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkNotificationsUnreadBody, TContext = unknown>(parameters: DeepReadonly<MarkNotificationsUnreadParameters>, options?: ServiceOperationUseMutationOptions<MarkNotificationsUnreadSchema, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, TVariables, OperationError<MarkNotificationsUnreadError>, TContext>): UseMutationResult<MarkNotificationsUnreadData, OperationError<MarkNotificationsUnreadError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Notifications Unread
         * @description Mark the caller's notifications unread. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markNotificationsUnread.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.markNotificationsUnread.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkNotificationsUnreadBody, MarkNotificationsUnreadParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkNotificationsUnreadSchema, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, TVariables, OperationError<MarkNotificationsUnreadError>, TContext>): UseMutationResult<MarkNotificationsUnreadData, OperationError<MarkNotificationsUnreadError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark Notifications Unread
         * @description Mark the caller's notifications unread. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markNotificationsUnreadTotal = qraft.v3Service.markNotificationsUnread.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markNotificationsUnreadTotal = qraft.v3Service.markNotificationsUnread.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsUnreadSchema, MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark Notifications Unread
         * @description Mark the caller's notifications unread. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markNotificationsUnreadPendingMutationVariables = qraft.v3Service.markNotificationsUnread.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markNotificationsUnreadMutationData = qraft.v3Service.markNotificationsUnread.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkNotificationsUnreadData, OperationError<MarkNotificationsUnreadError>, MutationVariables<MarkNotificationsUnreadBody, MarkNotificationsUnreadParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsUnreadSchema, MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext>;
            select?: (mutation: Mutation<MarkNotificationsUnreadData, OperationError<MarkNotificationsUnreadError>, MutationVariables<MarkNotificationsUnreadBody, MarkNotificationsUnreadParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Mark Notifications Unread
         * @description Mark the caller's notifications unread. Idempotent.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsUnreadSchema, MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark Notifications Unread
         * @description Mark the caller's notifications unread. Idempotent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.markNotificationsUnread.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.markNotificationsUnread.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsUnreadSchema, MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext>): Mutation<MarkNotificationsUnreadData, MarkNotificationsUnreadError, MutationVariables<MarkNotificationsUnreadBody, MarkNotificationsUnreadParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext> | MutationFiltersByMutationKey<MarkNotificationsUnreadSchema, MarkNotificationsUnreadBody, MarkNotificationsUnreadData, MarkNotificationsUnreadParameters, OperationError<MarkNotificationsUnreadError>, TContext>): Array<Mutation<MarkNotificationsUnreadData, MarkNotificationsUnreadError, MutationVariables<MarkNotificationsUnreadBody, MarkNotificationsUnreadParameters>, TContext>>;
        };
        schema: MarkNotificationsUnreadSchema;
        types: {
            parameters: MarkNotificationsUnreadParameters;
            data: MarkNotificationsUnreadData;
            error: MarkNotificationsUnreadError;
            body: MarkNotificationsUnreadBody;
        };
    };
    /**
     * @summary Delete Notifications
     * @description Delete the caller's notifications.
     *
     * A POST rather than a DELETE because the ids (up to 100) go in the body.
     */
    deleteNotifications: {
        /**
         * @summary Delete Notifications
         * @description Delete the caller's notifications.
         *
         * A POST rather than a DELETE because the ids (up to 100) go in the body.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteNotificationsBody, DeleteNotificationsParameters, TMeta, TSignal>, client?: (schema: DeleteNotificationsSchema, options: ServiceOperationMutationFnOptions<DeleteNotificationsBody, DeleteNotificationsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteNotificationsData, DeleteNotificationsError>>): Promise<RequestFnResponse<DeleteNotificationsData, DeleteNotificationsError>>;
        /**
         * @summary Delete Notifications
         * @description Delete the caller's notifications.
         *
         * A POST rather than a DELETE because the ids (up to 100) go in the body.
         */
        getMutationKey(parameters: DeepReadonly<DeleteNotificationsParameters> | void): ServiceOperationMutationKey<DeleteNotificationsSchema, DeleteNotificationsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Notifications
         * @description Delete the caller's notifications.
         *
         * A POST rather than a DELETE because the ids (up to 100) go in the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteNotifications.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteNotifications.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteNotificationsBody, TContext = unknown>(parameters: DeepReadonly<DeleteNotificationsParameters>, options?: ServiceOperationUseMutationOptions<DeleteNotificationsSchema, DeleteNotificationsData, DeleteNotificationsParameters, TVariables, OperationError<DeleteNotificationsError>, TContext>): UseMutationResult<DeleteNotificationsData, OperationError<DeleteNotificationsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Notifications
         * @description Delete the caller's notifications.
         *
         * A POST rather than a DELETE because the ids (up to 100) go in the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteNotifications.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteNotifications.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteNotificationsBody, DeleteNotificationsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteNotificationsSchema, DeleteNotificationsData, DeleteNotificationsParameters, TVariables, OperationError<DeleteNotificationsError>, TContext>): UseMutationResult<DeleteNotificationsData, OperationError<DeleteNotificationsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Notifications
         * @description Delete the caller's notifications.
         *
         * A POST rather than a DELETE because the ids (up to 100) go in the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteNotificationsTotal = qraft.v3Service.deleteNotifications.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteNotificationsTotal = qraft.v3Service.deleteNotifications.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext> | MutationFiltersByMutationKey<DeleteNotificationsSchema, DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Notifications
         * @description Delete the caller's notifications.
         *
         * A POST rather than a DELETE because the ids (up to 100) go in the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteNotificationsPendingMutationVariables = qraft.v3Service.deleteNotifications.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteNotificationsMutationData = qraft.v3Service.deleteNotifications.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteNotificationsData, OperationError<DeleteNotificationsError>, MutationVariables<DeleteNotificationsBody, DeleteNotificationsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext> | MutationFiltersByMutationKey<DeleteNotificationsSchema, DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext>;
            select?: (mutation: Mutation<DeleteNotificationsData, OperationError<DeleteNotificationsError>, MutationVariables<DeleteNotificationsBody, DeleteNotificationsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete Notifications
         * @description Delete the caller's notifications.
         *
         * A POST rather than a DELETE because the ids (up to 100) go in the body.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext> | MutationFiltersByMutationKey<DeleteNotificationsSchema, DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Notifications
         * @description Delete the caller's notifications.
         *
         * A POST rather than a DELETE because the ids (up to 100) go in the body.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteNotifications.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteNotifications.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext> | MutationFiltersByMutationKey<DeleteNotificationsSchema, DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext>): Mutation<DeleteNotificationsData, DeleteNotificationsError, MutationVariables<DeleteNotificationsBody, DeleteNotificationsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext> | MutationFiltersByMutationKey<DeleteNotificationsSchema, DeleteNotificationsBody, DeleteNotificationsData, DeleteNotificationsParameters, OperationError<DeleteNotificationsError>, TContext>): Array<Mutation<DeleteNotificationsData, DeleteNotificationsError, MutationVariables<DeleteNotificationsBody, DeleteNotificationsParameters>, TContext>>;
        };
        schema: DeleteNotificationsSchema;
        types: {
            parameters: DeleteNotificationsParameters;
            data: DeleteNotificationsData;
            error: DeleteNotificationsError;
            body: DeleteNotificationsBody;
        };
    };
    /**
     * @summary Get Notification Preferences
     * @description The caller's own preferences, as columns and rows.
     *
     * Always the caller: legacy's is a BuddyPress Settings screen, and those are
     * own-profile only with no cross-user view to port.
     */
    getNotificationPreferences: {
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetNotificationPreferencesParameters, TMeta, TSignal> | void), client?: (schema: GetNotificationPreferencesSchema, options: {
            parameters: GetNotificationPreferencesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetNotificationPreferencesData, GetNotificationPreferencesError>>): Promise<RequestFnResponse<GetNotificationPreferencesData, GetNotificationPreferencesError>>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        getQueryKey(parameters: DeepReadonly<GetNotificationPreferencesParameters> | void): ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getNotificationPreferences.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getNotificationPreferences.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetNotificationPreferencesData>(parameters: ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetNotificationPreferencesData, GetNotificationPreferencesError, TData, ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetNotificationPreferencesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getNotificationPreferences.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getNotificationPreferences.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetNotificationPreferencesData>(parameters: ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void), options: Omit<DefinedInitialDataOptions<GetNotificationPreferencesData, GetNotificationPreferencesError, TData, ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetNotificationPreferencesError>>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetNotificationPreferencesParameters> | void): ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getNotificationPreferences.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetNotificationPreferencesParameters, TQueryFnData = GetNotificationPreferencesData, TData = OperationInfiniteData<TQueryFnData, GetNotificationPreferencesParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetNotificationPreferencesError, TData, ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetNotificationPreferencesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getNotificationPreferences.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetNotificationPreferencesParameters, TQueryFnData = GetNotificationPreferencesData, TData = OperationInfiniteData<TQueryFnData, GetNotificationPreferencesParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetNotificationPreferencesError, TData, ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetNotificationPreferencesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetNotificationPreferencesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getNotificationPreferencesTotal = qraft.v3Service.getNotificationPreferences.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getNotificationPreferencesByParametersTotal = qraft.v3Service.getNotificationPreferences.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | QueryFiltersByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getNotificationPreferencesResults = qraft.v3Service.getNotificationPreferences.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getNotificationPreferencesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getNotificationPreferencesCombinedResults = qraft.v3Service.getNotificationPreferences.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getNotificationPreferencesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters, GetNotificationPreferencesData, GetNotificationPreferencesError>>, TCombinedResult = Array<UseQueryResult<GetNotificationPreferencesData, GetNotificationPreferencesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetNotificationPreferencesData, GetNotificationPreferencesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getNotificationPreferences.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getNotificationPreferences.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetNotificationPreferencesData>(parameters: ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetNotificationPreferencesData, GetNotificationPreferencesError, TData, ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetNotificationPreferencesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getNotificationPreferences.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetNotificationPreferencesParameters, TData = GetNotificationPreferencesData>(parameters: ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetNotificationPreferencesData, GetNotificationPreferencesError, OperationInfiniteData<TData, GetNotificationPreferencesParameters>, ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetNotificationPreferencesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetNotificationPreferencesParameters>, OperationError<GetNotificationPreferencesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getNotificationPreferencesData = qraft.v3Service.getNotificationPreferences.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getNotificationPreferencesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getNotificationPreferencesCombinedData = qraft.v3Service.getNotificationPreferences.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getNotificationPreferencesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters, GetNotificationPreferencesData, GetNotificationPreferencesError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetNotificationPreferencesData, GetNotificationPreferencesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetNotificationPreferencesData, GetNotificationPreferencesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetNotificationPreferencesSchema, GetNotificationPreferencesData, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | void): Promise<GetNotificationPreferencesData>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetNotificationPreferencesSchema, GetNotificationPreferencesData, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | void): Promise<void>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetNotificationPreferencesSchema, GetNotificationPreferencesData, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | void): Promise<GetNotificationPreferencesData>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        fetchInfiniteQuery<TPageParam extends GetNotificationPreferencesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetNotificationPreferencesSchema, GetNotificationPreferencesData, GetNotificationPreferencesParameters, DeepReadonly<TPageParam>, GetNotificationPreferencesError> | void): Promise<OperationInfiniteData<GetNotificationPreferencesData, GetNotificationPreferencesParameters>>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        prefetchInfiniteQuery<TPageParam extends GetNotificationPreferencesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetNotificationPreferencesSchema, GetNotificationPreferencesData, GetNotificationPreferencesParameters, DeepReadonly<TPageParam>, GetNotificationPreferencesError> | void): Promise<void>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        ensureInfiniteQueryData<TPageParam extends GetNotificationPreferencesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetNotificationPreferencesSchema, GetNotificationPreferencesData, GetNotificationPreferencesParameters, DeepReadonly<TPageParam>, GetNotificationPreferencesError> | void): Promise<OperationInfiniteData<GetNotificationPreferencesData, GetNotificationPreferencesParameters>>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void)): GetNotificationPreferencesData | undefined;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void)): OperationInfiniteData<GetNotificationPreferencesData, GetNotificationPreferencesParameters> | undefined;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | QueryFiltersByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>,
            data: NoInfer<OperationInfiniteData<GetNotificationPreferencesData, GetNotificationPreferencesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>,
            data: GetNotificationPreferencesData | undefined
        ]>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | (DeepReadonly<GetNotificationPreferencesParameters> | void)): QueryState<GetNotificationPreferencesData, GetNotificationPreferencesError> | undefined;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetNotificationPreferencesParameters> | ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters> | void): QueryState<OperationInfiniteData<GetNotificationPreferencesData, GetNotificationPreferencesParameters>, GetNotificationPreferencesError> | undefined;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        setQueryData(parameters: (DeepReadonly<GetNotificationPreferencesParameters> | undefined) | ServiceOperationQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>, updater: Updater<NoInfer<GetNotificationPreferencesData> | undefined, NoInfer<DeepReadonly<GetNotificationPreferencesData>> | undefined>, options?: SetDataOptions): GetNotificationPreferencesData | undefined;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetNotificationPreferencesParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetNotificationPreferencesData, GetNotificationPreferencesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetNotificationPreferencesData, GetNotificationPreferencesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetNotificationPreferencesData, GetNotificationPreferencesParameters> | undefined;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | QueryFiltersByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>, updater: Updater<NoInfer<GetNotificationPreferencesData> | undefined, NoInfer<GetNotificationPreferencesData> | undefined>, options?: SetDataOptions): Array<GetNotificationPreferencesData | undefined>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | QueryFiltersByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | QueryFiltersByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | QueryFiltersByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>): void;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | QueryFiltersByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Notification Preferences
         * @description The caller's own preferences, as columns and rows.
         *
         * Always the caller: legacy's is a BuddyPress Settings screen, and those are
         * own-profile only with no cross-user view to port.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError> | QueryFiltersByQueryKey<GetNotificationPreferencesSchema, GetNotificationPreferencesData, TInfinite, GetNotificationPreferencesParameters, GetNotificationPreferencesError>): number;
        schema: GetNotificationPreferencesSchema;
        types: {
            parameters: GetNotificationPreferencesParameters;
            data: GetNotificationPreferencesData;
            error: GetNotificationPreferencesError;
        };
    };
    /**
     * @summary Update Notification Preferences
     * @description Write a partial update and return the whole grid.
     *
     * The whole grid rather than an echo of the accepted keys, because connecting
     * a channel elsewhere changes which columns exist and the screen would
     * otherwise keep drawing a stale set.
     */
    updateNotificationPreferences: {
        /**
         * @summary Update Notification Preferences
         * @description Write a partial update and return the whole grid.
         *
         * The whole grid rather than an echo of the accepted keys, because connecting
         * a channel elsewhere changes which columns exist and the screen would
         * otherwise keep drawing a stale set.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesParameters, TMeta, TSignal>, client?: (schema: UpdateNotificationPreferencesSchema, options: ServiceOperationMutationFnOptions<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UpdateNotificationPreferencesData, UpdateNotificationPreferencesError>>): Promise<RequestFnResponse<UpdateNotificationPreferencesData, UpdateNotificationPreferencesError>>;
        /**
         * @summary Update Notification Preferences
         * @description Write a partial update and return the whole grid.
         *
         * The whole grid rather than an echo of the accepted keys, because connecting
         * a channel elsewhere changes which columns exist and the screen would
         * otherwise keep drawing a stale set.
         */
        getMutationKey(parameters: DeepReadonly<UpdateNotificationPreferencesParameters> | void): ServiceOperationMutationKey<UpdateNotificationPreferencesSchema, UpdateNotificationPreferencesParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Notification Preferences
         * @description Write a partial update and return the whole grid.
         *
         * The whole grid rather than an echo of the accepted keys, because connecting
         * a channel elsewhere changes which columns exist and the screen would
         * otherwise keep drawing a stale set.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateNotificationPreferences.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateNotificationPreferences.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UpdateNotificationPreferencesBody, TContext = unknown>(parameters: DeepReadonly<UpdateNotificationPreferencesParameters>, options?: ServiceOperationUseMutationOptions<UpdateNotificationPreferencesSchema, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, TVariables, OperationError<UpdateNotificationPreferencesError>, TContext>): UseMutationResult<UpdateNotificationPreferencesData, OperationError<UpdateNotificationPreferencesError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update Notification Preferences
         * @description Write a partial update and return the whole grid.
         *
         * The whole grid rather than an echo of the accepted keys, because connecting
         * a channel elsewhere changes which columns exist and the screen would
         * otherwise keep drawing a stale set.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateNotificationPreferences.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.updateNotificationPreferences.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UpdateNotificationPreferencesSchema, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, TVariables, OperationError<UpdateNotificationPreferencesError>, TContext>): UseMutationResult<UpdateNotificationPreferencesData, OperationError<UpdateNotificationPreferencesError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Update Notification Preferences
         * @description Write a partial update and return the whole grid.
         *
         * The whole grid rather than an echo of the accepted keys, because connecting
         * a channel elsewhere changes which columns exist and the screen would
         * otherwise keep drawing a stale set.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const updateNotificationPreferencesTotal = qraft.v3Service.updateNotificationPreferences.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const updateNotificationPreferencesTotal = qraft.v3Service.updateNotificationPreferences.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext> | MutationFiltersByMutationKey<UpdateNotificationPreferencesSchema, UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Update Notification Preferences
         * @description Write a partial update and return the whole grid.
         *
         * The whole grid rather than an echo of the accepted keys, because connecting
         * a channel elsewhere changes which columns exist and the screen would
         * otherwise keep drawing a stale set.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const updateNotificationPreferencesPendingMutationVariables = qraft.v3Service.updateNotificationPreferences.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const updateNotificationPreferencesMutationData = qraft.v3Service.updateNotificationPreferences.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UpdateNotificationPreferencesData, OperationError<UpdateNotificationPreferencesError>, MutationVariables<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext> | MutationFiltersByMutationKey<UpdateNotificationPreferencesSchema, UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext>;
            select?: (mutation: Mutation<UpdateNotificationPreferencesData, OperationError<UpdateNotificationPreferencesError>, MutationVariables<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Update Notification Preferences
         * @description Write a partial update and return the whole grid.
         *
         * The whole grid rather than an echo of the accepted keys, because connecting
         * a channel elsewhere changes which columns exist and the screen would
         * otherwise keep drawing a stale set.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext> | MutationFiltersByMutationKey<UpdateNotificationPreferencesSchema, UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Update Notification Preferences
         * @description Write a partial update and return the whole grid.
         *
         * The whole grid rather than an echo of the accepted keys, because connecting
         * a channel elsewhere changes which columns exist and the screen would
         * otherwise keep drawing a stale set.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.updateNotificationPreferences.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.updateNotificationPreferences.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext> | MutationFiltersByMutationKey<UpdateNotificationPreferencesSchema, UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext>): Mutation<UpdateNotificationPreferencesData, UpdateNotificationPreferencesError, MutationVariables<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext> | MutationFiltersByMutationKey<UpdateNotificationPreferencesSchema, UpdateNotificationPreferencesBody, UpdateNotificationPreferencesData, UpdateNotificationPreferencesParameters, OperationError<UpdateNotificationPreferencesError>, TContext>): Array<Mutation<UpdateNotificationPreferencesData, UpdateNotificationPreferencesError, MutationVariables<UpdateNotificationPreferencesBody, UpdateNotificationPreferencesParameters>, TContext>>;
        };
        schema: UpdateNotificationPreferencesSchema;
        types: {
            parameters: UpdateNotificationPreferencesParameters;
            data: UpdateNotificationPreferencesData;
            error: UpdateNotificationPreferencesError;
            body: UpdateNotificationPreferencesBody;
        };
    };
    /**
     * @summary Get Contact Channels
     * @description Both channels and their connected numbers, in one response so the settings screen
     * can draw its cards with one call.
     */
    getContactChannels: {
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetContactChannelsSchema, GetContactChannelsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetContactChannelsParameters, TMeta, TSignal> | void), client?: (schema: GetContactChannelsSchema, options: {
            parameters: GetContactChannelsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetContactChannelsData, GetContactChannelsError>>): Promise<RequestFnResponse<GetContactChannelsData, GetContactChannelsError>>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        getQueryKey(parameters: DeepReadonly<GetContactChannelsParameters> | void): ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getContactChannels.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getContactChannels.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetContactChannelsData>(parameters: ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetContactChannelsData, GetContactChannelsError, TData, ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetContactChannelsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getContactChannels.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getContactChannels.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetContactChannelsData>(parameters: ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void), options: Omit<DefinedInitialDataOptions<GetContactChannelsData, GetContactChannelsError, TData, ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetContactChannelsError>>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetContactChannelsParameters> | void): ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContactChannels.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetContactChannelsParameters, TQueryFnData = GetContactChannelsData, TData = OperationInfiniteData<TQueryFnData, GetContactChannelsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetContactChannelsError, TData, ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetContactChannelsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContactChannels.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetContactChannelsParameters, TQueryFnData = GetContactChannelsData, TData = OperationInfiniteData<TQueryFnData, GetContactChannelsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetContactChannelsError, TData, ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetContactChannelsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetContactChannelsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getContactChannelsTotal = qraft.v3Service.getContactChannels.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getContactChannelsByParametersTotal = qraft.v3Service.getContactChannels.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError> | QueryFiltersByQueryKey<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getContactChannelsResults = qraft.v3Service.getContactChannels.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContactChannelsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getContactChannelsCombinedResults = qraft.v3Service.getContactChannels.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContactChannelsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetContactChannelsSchema, GetContactChannelsParameters, GetContactChannelsData, GetContactChannelsError>>, TCombinedResult = Array<UseQueryResult<GetContactChannelsData, GetContactChannelsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetContactChannelsData, GetContactChannelsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getContactChannels.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getContactChannels.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetContactChannelsData>(parameters: ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetContactChannelsData, GetContactChannelsError, TData, ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetContactChannelsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getContactChannels.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetContactChannelsParameters, TData = GetContactChannelsData>(parameters: ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetContactChannelsData, GetContactChannelsError, OperationInfiniteData<TData, GetContactChannelsParameters>, ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetContactChannelsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetContactChannelsParameters>, OperationError<GetContactChannelsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getContactChannelsData = qraft.v3Service.getContactChannels.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContactChannelsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getContactChannelsCombinedData = qraft.v3Service.getContactChannels.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getContactChannelsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetContactChannelsSchema, GetContactChannelsParameters, GetContactChannelsData, GetContactChannelsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetContactChannelsData, GetContactChannelsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetContactChannelsData, GetContactChannelsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetContactChannelsSchema, GetContactChannelsData, GetContactChannelsParameters, GetContactChannelsError> | void): Promise<GetContactChannelsData>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetContactChannelsSchema, GetContactChannelsData, GetContactChannelsParameters, GetContactChannelsError> | void): Promise<void>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetContactChannelsSchema, GetContactChannelsData, GetContactChannelsParameters, GetContactChannelsError> | void): Promise<GetContactChannelsData>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        fetchInfiniteQuery<TPageParam extends GetContactChannelsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetContactChannelsSchema, GetContactChannelsData, GetContactChannelsParameters, DeepReadonly<TPageParam>, GetContactChannelsError> | void): Promise<OperationInfiniteData<GetContactChannelsData, GetContactChannelsParameters>>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        prefetchInfiniteQuery<TPageParam extends GetContactChannelsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetContactChannelsSchema, GetContactChannelsData, GetContactChannelsParameters, DeepReadonly<TPageParam>, GetContactChannelsError> | void): Promise<void>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        ensureInfiniteQueryData<TPageParam extends GetContactChannelsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetContactChannelsSchema, GetContactChannelsData, GetContactChannelsParameters, DeepReadonly<TPageParam>, GetContactChannelsError> | void): Promise<OperationInfiniteData<GetContactChannelsData, GetContactChannelsParameters>>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void)): GetContactChannelsData | undefined;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void)): OperationInfiniteData<GetContactChannelsData, GetContactChannelsParameters> | undefined;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError> | QueryFiltersByQueryKey<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>,
            data: NoInfer<OperationInfiniteData<GetContactChannelsData, GetContactChannelsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>,
            data: GetContactChannelsData | undefined
        ]>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | (DeepReadonly<GetContactChannelsParameters> | void)): QueryState<GetContactChannelsData, GetContactChannelsError> | undefined;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetContactChannelsParameters> | ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters> | void): QueryState<OperationInfiniteData<GetContactChannelsData, GetContactChannelsParameters>, GetContactChannelsError> | undefined;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        setQueryData(parameters: (DeepReadonly<GetContactChannelsParameters> | undefined) | ServiceOperationQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>, updater: Updater<NoInfer<GetContactChannelsData> | undefined, NoInfer<DeepReadonly<GetContactChannelsData>> | undefined>, options?: SetDataOptions): GetContactChannelsData | undefined;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetContactChannelsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetContactChannelsSchema, GetContactChannelsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetContactChannelsData, GetContactChannelsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetContactChannelsData, GetContactChannelsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetContactChannelsData, GetContactChannelsParameters> | undefined;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError> | QueryFiltersByQueryKey<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>, updater: Updater<NoInfer<GetContactChannelsData> | undefined, NoInfer<GetContactChannelsData> | undefined>, options?: SetDataOptions): Array<GetContactChannelsData | undefined>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError> | QueryFiltersByQueryKey<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError> | QueryFiltersByQueryKey<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError> | QueryFiltersByQueryKey<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>): void;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError> | QueryFiltersByQueryKey<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Contact Channels
         * @description Both channels and their connected numbers, in one response so the settings screen
         * can draw its cards with one call.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError> | QueryFiltersByQueryKey<GetContactChannelsSchema, GetContactChannelsData, TInfinite, GetContactChannelsParameters, GetContactChannelsError>): number;
        schema: GetContactChannelsSchema;
        types: {
            parameters: GetContactChannelsParameters;
            data: GetContactChannelsData;
            error: GetContactChannelsError;
        };
    };
    /**
     * @summary Start Contact Channel Verification
     * @description Send a six-digit code to ``number``.
     *
     * 202, not 200: what comes back is an acknowledgement that a message is on its
     * way, and nothing is connected until the code is spent.
     */
    startContactChannelVerification: {
        /**
         * @summary Start Contact Channel Verification
         * @description Send a six-digit code to ``number``.
         *
         * 202, not 200: what comes back is an acknowledgement that a message is on its
         * way, and nothing is connected until the code is spent.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StartContactChannelVerificationBody, StartContactChannelVerificationParameters, TMeta, TSignal>, client?: (schema: StartContactChannelVerificationSchema, options: ServiceOperationMutationFnOptions<StartContactChannelVerificationBody, StartContactChannelVerificationParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StartContactChannelVerificationData, StartContactChannelVerificationError>>): Promise<RequestFnResponse<StartContactChannelVerificationData, StartContactChannelVerificationError>>;
        /**
         * @summary Start Contact Channel Verification
         * @description Send a six-digit code to ``number``.
         *
         * 202, not 200: what comes back is an acknowledgement that a message is on its
         * way, and nothing is connected until the code is spent.
         */
        getMutationKey(parameters: DeepReadonly<StartContactChannelVerificationParameters> | void): ServiceOperationMutationKey<StartContactChannelVerificationSchema, StartContactChannelVerificationParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Start Contact Channel Verification
         * @description Send a six-digit code to ``number``.
         *
         * 202, not 200: what comes back is an acknowledgement that a message is on its
         * way, and nothing is connected until the code is spent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.startContactChannelVerification.useMutation({
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.startContactChannelVerification.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StartContactChannelVerificationBody, TContext = unknown>(parameters: DeepReadonly<StartContactChannelVerificationParameters>, options?: ServiceOperationUseMutationOptions<StartContactChannelVerificationSchema, StartContactChannelVerificationData, StartContactChannelVerificationParameters, TVariables, OperationError<StartContactChannelVerificationError>, TContext>): UseMutationResult<StartContactChannelVerificationData, OperationError<StartContactChannelVerificationError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Start Contact Channel Verification
         * @description Send a six-digit code to ``number``.
         *
         * 202, not 200: what comes back is an acknowledgement that a message is on its
         * way, and nothing is connected until the code is spent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.startContactChannelVerification.useMutation({
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.startContactChannelVerification.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StartContactChannelVerificationBody, StartContactChannelVerificationParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StartContactChannelVerificationSchema, StartContactChannelVerificationData, StartContactChannelVerificationParameters, TVariables, OperationError<StartContactChannelVerificationError>, TContext>): UseMutationResult<StartContactChannelVerificationData, OperationError<StartContactChannelVerificationError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Start Contact Channel Verification
         * @description Send a six-digit code to ``number``.
         *
         * 202, not 200: what comes back is an acknowledgement that a message is on its
         * way, and nothing is connected until the code is spent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const startContactChannelVerificationTotal = qraft.v3Service.startContactChannelVerification.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const startContactChannelVerificationTotal = qraft.v3Service.startContactChannelVerification.useIsMutating({
         *     parameters: {
         *         path: {
         *             channel: channel
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<StartContactChannelVerificationSchema, StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Start Contact Channel Verification
         * @description Send a six-digit code to ``number``.
         *
         * 202, not 200: what comes back is an acknowledgement that a message is on its
         * way, and nothing is connected until the code is spent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const startContactChannelVerificationPendingMutationVariables = qraft.v3Service.startContactChannelVerification.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const startContactChannelVerificationMutationData = qraft.v3Service.startContactChannelVerification.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 channel: channel
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StartContactChannelVerificationData, OperationError<StartContactChannelVerificationError>, MutationVariables<StartContactChannelVerificationBody, StartContactChannelVerificationParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<StartContactChannelVerificationSchema, StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext>;
            select?: (mutation: Mutation<StartContactChannelVerificationData, OperationError<StartContactChannelVerificationError>, MutationVariables<StartContactChannelVerificationBody, StartContactChannelVerificationParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Start Contact Channel Verification
         * @description Send a six-digit code to ``number``.
         *
         * 202, not 200: what comes back is an acknowledgement that a message is on its
         * way, and nothing is connected until the code is spent.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<StartContactChannelVerificationSchema, StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Start Contact Channel Verification
         * @description Send a six-digit code to ``number``.
         *
         * 202, not 200: what comes back is an acknowledgement that a message is on its
         * way, and nothing is connected until the code is spent.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.startContactChannelVerification.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             channel: channel
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.startContactChannelVerification.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<StartContactChannelVerificationSchema, StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext>): Mutation<StartContactChannelVerificationData, StartContactChannelVerificationError, MutationVariables<StartContactChannelVerificationBody, StartContactChannelVerificationParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<StartContactChannelVerificationSchema, StartContactChannelVerificationBody, StartContactChannelVerificationData, StartContactChannelVerificationParameters, OperationError<StartContactChannelVerificationError>, TContext>): Array<Mutation<StartContactChannelVerificationData, StartContactChannelVerificationError, MutationVariables<StartContactChannelVerificationBody, StartContactChannelVerificationParameters>, TContext>>;
        };
        schema: StartContactChannelVerificationSchema;
        types: {
            parameters: StartContactChannelVerificationParameters;
            data: StartContactChannelVerificationData;
            error: StartContactChannelVerificationError;
            body: StartContactChannelVerificationBody;
        };
    };
    /**
     * @summary Complete Contact Channel Verification
     * @description Spend the code and connect the number.
     */
    completeContactChannelVerification: {
        /**
         * @summary Complete Contact Channel Verification
         * @description Spend the code and connect the number.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationParameters, TMeta, TSignal>, client?: (schema: CompleteContactChannelVerificationSchema, options: ServiceOperationMutationFnOptions<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CompleteContactChannelVerificationData, CompleteContactChannelVerificationError>>): Promise<RequestFnResponse<CompleteContactChannelVerificationData, CompleteContactChannelVerificationError>>;
        /**
         * @summary Complete Contact Channel Verification
         * @description Spend the code and connect the number.
         */
        getMutationKey(parameters: DeepReadonly<CompleteContactChannelVerificationParameters> | void): ServiceOperationMutationKey<CompleteContactChannelVerificationSchema, CompleteContactChannelVerificationParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Complete Contact Channel Verification
         * @description Spend the code and connect the number.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.completeContactChannelVerification.useMutation({
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.completeContactChannelVerification.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CompleteContactChannelVerificationBody, TContext = unknown>(parameters: DeepReadonly<CompleteContactChannelVerificationParameters>, options?: ServiceOperationUseMutationOptions<CompleteContactChannelVerificationSchema, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, TVariables, OperationError<CompleteContactChannelVerificationError>, TContext>): UseMutationResult<CompleteContactChannelVerificationData, OperationError<CompleteContactChannelVerificationError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Complete Contact Channel Verification
         * @description Spend the code and connect the number.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.completeContactChannelVerification.useMutation({
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.completeContactChannelVerification.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CompleteContactChannelVerificationSchema, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, TVariables, OperationError<CompleteContactChannelVerificationError>, TContext>): UseMutationResult<CompleteContactChannelVerificationData, OperationError<CompleteContactChannelVerificationError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Complete Contact Channel Verification
         * @description Spend the code and connect the number.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const completeContactChannelVerificationTotal = qraft.v3Service.completeContactChannelVerification.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const completeContactChannelVerificationTotal = qraft.v3Service.completeContactChannelVerification.useIsMutating({
         *     parameters: {
         *         path: {
         *             channel: channel
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<CompleteContactChannelVerificationSchema, CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Complete Contact Channel Verification
         * @description Spend the code and connect the number.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const completeContactChannelVerificationPendingMutationVariables = qraft.v3Service.completeContactChannelVerification.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const completeContactChannelVerificationMutationData = qraft.v3Service.completeContactChannelVerification.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 channel: channel
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CompleteContactChannelVerificationData, OperationError<CompleteContactChannelVerificationError>, MutationVariables<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<CompleteContactChannelVerificationSchema, CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext>;
            select?: (mutation: Mutation<CompleteContactChannelVerificationData, OperationError<CompleteContactChannelVerificationError>, MutationVariables<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Complete Contact Channel Verification
         * @description Spend the code and connect the number.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<CompleteContactChannelVerificationSchema, CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Complete Contact Channel Verification
         * @description Spend the code and connect the number.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.completeContactChannelVerification.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             channel: channel
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.completeContactChannelVerification.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<CompleteContactChannelVerificationSchema, CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext>): Mutation<CompleteContactChannelVerificationData, CompleteContactChannelVerificationError, MutationVariables<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext> | MutationFiltersByMutationKey<CompleteContactChannelVerificationSchema, CompleteContactChannelVerificationBody, CompleteContactChannelVerificationData, CompleteContactChannelVerificationParameters, OperationError<CompleteContactChannelVerificationError>, TContext>): Array<Mutation<CompleteContactChannelVerificationData, CompleteContactChannelVerificationError, MutationVariables<CompleteContactChannelVerificationBody, CompleteContactChannelVerificationParameters>, TContext>>;
        };
        schema: CompleteContactChannelVerificationSchema;
        types: {
            parameters: CompleteContactChannelVerificationParameters;
            data: CompleteContactChannelVerificationData;
            error: CompleteContactChannelVerificationError;
            body: CompleteContactChannelVerificationBody;
        };
    };
    /**
     * @summary Disconnect Contact Channel
     * @description Drop the connected number. Succeeds when there was nothing to drop.
     */
    disconnectContactChannel: {
        /**
         * @summary Disconnect Contact Channel
         * @description Drop the connected number. Succeeds when there was nothing to drop.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DisconnectContactChannelBody, DisconnectContactChannelParameters, TMeta, TSignal>, client?: (schema: DisconnectContactChannelSchema, options: ServiceOperationMutationFnOptions<DisconnectContactChannelBody, DisconnectContactChannelParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DisconnectContactChannelData, DisconnectContactChannelError>>): Promise<RequestFnResponse<DisconnectContactChannelData, DisconnectContactChannelError>>;
        /**
         * @summary Disconnect Contact Channel
         * @description Drop the connected number. Succeeds when there was nothing to drop.
         */
        getMutationKey(parameters: DeepReadonly<DisconnectContactChannelParameters> | void): ServiceOperationMutationKey<DisconnectContactChannelSchema, DisconnectContactChannelParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Disconnect Contact Channel
         * @description Drop the connected number. Succeeds when there was nothing to drop.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.disconnectContactChannel.useMutation({
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.disconnectContactChannel.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DisconnectContactChannelBody, TContext = unknown>(parameters: DeepReadonly<DisconnectContactChannelParameters>, options?: ServiceOperationUseMutationOptions<DisconnectContactChannelSchema, DisconnectContactChannelData, DisconnectContactChannelParameters, TVariables, OperationError<DisconnectContactChannelError>, TContext>): UseMutationResult<DisconnectContactChannelData, OperationError<DisconnectContactChannelError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Disconnect Contact Channel
         * @description Drop the connected number. Succeeds when there was nothing to drop.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.disconnectContactChannel.useMutation({
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.disconnectContactChannel.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         channel: channel
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DisconnectContactChannelBody, DisconnectContactChannelParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DisconnectContactChannelSchema, DisconnectContactChannelData, DisconnectContactChannelParameters, TVariables, OperationError<DisconnectContactChannelError>, TContext>): UseMutationResult<DisconnectContactChannelData, OperationError<DisconnectContactChannelError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Disconnect Contact Channel
         * @description Drop the connected number. Succeeds when there was nothing to drop.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const disconnectContactChannelTotal = qraft.v3Service.disconnectContactChannel.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const disconnectContactChannelTotal = qraft.v3Service.disconnectContactChannel.useIsMutating({
         *     parameters: {
         *         path: {
         *             channel: channel
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext> | MutationFiltersByMutationKey<DisconnectContactChannelSchema, DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Disconnect Contact Channel
         * @description Drop the connected number. Succeeds when there was nothing to drop.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const disconnectContactChannelPendingMutationVariables = qraft.v3Service.disconnectContactChannel.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const disconnectContactChannelMutationData = qraft.v3Service.disconnectContactChannel.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 channel: channel
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DisconnectContactChannelData, OperationError<DisconnectContactChannelError>, MutationVariables<DisconnectContactChannelBody, DisconnectContactChannelParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext> | MutationFiltersByMutationKey<DisconnectContactChannelSchema, DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext>;
            select?: (mutation: Mutation<DisconnectContactChannelData, OperationError<DisconnectContactChannelError>, MutationVariables<DisconnectContactChannelBody, DisconnectContactChannelParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Disconnect Contact Channel
         * @description Drop the connected number. Succeeds when there was nothing to drop.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext> | MutationFiltersByMutationKey<DisconnectContactChannelSchema, DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Disconnect Contact Channel
         * @description Drop the connected number. Succeeds when there was nothing to drop.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.disconnectContactChannel.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             channel: channel
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.disconnectContactChannel.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext> | MutationFiltersByMutationKey<DisconnectContactChannelSchema, DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext>): Mutation<DisconnectContactChannelData, DisconnectContactChannelError, MutationVariables<DisconnectContactChannelBody, DisconnectContactChannelParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext> | MutationFiltersByMutationKey<DisconnectContactChannelSchema, DisconnectContactChannelBody, DisconnectContactChannelData, DisconnectContactChannelParameters, OperationError<DisconnectContactChannelError>, TContext>): Array<Mutation<DisconnectContactChannelData, DisconnectContactChannelError, MutationVariables<DisconnectContactChannelBody, DisconnectContactChannelParameters>, TContext>>;
        };
        schema: DisconnectContactChannelSchema;
        types: {
            parameters: DisconnectContactChannelParameters;
            data: DisconnectContactChannelData;
            error: DisconnectContactChannelError;
            body: DisconnectContactChannelBody;
        };
    };
    /**
     * @summary List Group Activity
     * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
     * pager.
     */
    listGroupActivity: {
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupActivitySchema, ListGroupActivityParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupActivityParameters, TMeta, TSignal>), client?: (schema: ListGroupActivitySchema, options: {
            parameters: ListGroupActivityParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupActivityData, ListGroupActivityError>>): Promise<RequestFnResponse<ListGroupActivityData, ListGroupActivityError>>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupActivityParameters>): ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupActivity.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupActivityData>(parameters: ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupActivityData, ListGroupActivityError, TData, ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupActivityError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupActivity.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupActivityData>(parameters: ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>), options: Omit<DefinedInitialDataOptions<ListGroupActivityData, ListGroupActivityError, TData, ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupActivityError>>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupActivityParameters>): ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupActivity.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupActivityParameters, TQueryFnData = ListGroupActivityData, TData = OperationInfiniteData<TQueryFnData, ListGroupActivityParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupActivityError, TData, ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupActivityError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupActivity.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupActivityParameters, TQueryFnData = ListGroupActivityData, TData = OperationInfiniteData<TQueryFnData, ListGroupActivityParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupActivityError, TData, ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupActivityData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupActivityError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupActivityTotal = qraft.v3Service.listGroupActivity.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupActivityByParametersTotal = qraft.v3Service.listGroupActivity.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError> | QueryFiltersByQueryKey<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupActivityResults = qraft.v3Service.listGroupActivity.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupActivityResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupActivityCombinedResults = qraft.v3Service.listGroupActivity.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupActivityCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupActivitySchema, ListGroupActivityParameters, ListGroupActivityData, ListGroupActivityError>>, TCombinedResult = Array<UseQueryResult<ListGroupActivityData, ListGroupActivityError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupActivityData, ListGroupActivityError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupActivity.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupActivityData>(parameters: ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupActivityData, ListGroupActivityError, TData, ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupActivityError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupActivity.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupActivityParameters, TData = ListGroupActivityData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupActivityData, ListGroupActivityError, OperationInfiniteData<TData, ListGroupActivityParameters>, ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupActivityData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupActivityParameters>, OperationError<ListGroupActivityError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupActivityData = qraft.v3Service.listGroupActivity.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupActivityResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupActivityCombinedData = qraft.v3Service.listGroupActivity.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupActivityCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupActivitySchema, ListGroupActivityParameters, ListGroupActivityData, ListGroupActivityError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupActivityData, ListGroupActivityError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupActivityData, ListGroupActivityError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupActivitySchema, ListGroupActivityData, ListGroupActivityParameters, ListGroupActivityError>): Promise<ListGroupActivityData>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupActivitySchema, ListGroupActivityData, ListGroupActivityParameters, ListGroupActivityError>): Promise<void>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupActivitySchema, ListGroupActivityData, ListGroupActivityParameters, ListGroupActivityError>): Promise<ListGroupActivityData>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupActivityParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupActivitySchema, ListGroupActivityData, ListGroupActivityParameters, DeepReadonly<TPageParam>, ListGroupActivityError>): Promise<OperationInfiniteData<ListGroupActivityData, ListGroupActivityParameters>>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupActivityParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupActivitySchema, ListGroupActivityData, ListGroupActivityParameters, DeepReadonly<TPageParam>, ListGroupActivityError>): Promise<void>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupActivityParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupActivitySchema, ListGroupActivityData, ListGroupActivityParameters, DeepReadonly<TPageParam>, ListGroupActivityError>): Promise<OperationInfiniteData<ListGroupActivityData, ListGroupActivityParameters>>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>)): ListGroupActivityData | undefined;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>)): OperationInfiniteData<ListGroupActivityData, ListGroupActivityParameters> | undefined;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError> | QueryFiltersByQueryKey<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupActivityData, ListGroupActivityParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>,
            data: ListGroupActivityData | undefined
        ]>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters> | (DeepReadonly<ListGroupActivityParameters>)): QueryState<ListGroupActivityData, ListGroupActivityError> | undefined;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupActivityParameters> | ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>): QueryState<OperationInfiniteData<ListGroupActivityData, ListGroupActivityParameters>, ListGroupActivityError> | undefined;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupActivityParameters>) | ServiceOperationQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>, updater: Updater<NoInfer<ListGroupActivityData> | undefined, NoInfer<DeepReadonly<ListGroupActivityData>> | undefined>, options?: SetDataOptions): ListGroupActivityData | undefined;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupActivityParameters>) | ServiceOperationInfiniteQueryKey<ListGroupActivitySchema, ListGroupActivityParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupActivityData, ListGroupActivityParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupActivityData, ListGroupActivityParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupActivityData, ListGroupActivityParameters> | undefined;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError> | QueryFiltersByQueryKey<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>, updater: Updater<NoInfer<ListGroupActivityData> | undefined, NoInfer<ListGroupActivityData> | undefined>, options?: SetDataOptions): Array<ListGroupActivityData | undefined>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError> | QueryFiltersByQueryKey<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError> | QueryFiltersByQueryKey<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError> | QueryFiltersByQueryKey<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>): void;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError> | QueryFiltersByQueryKey<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Activity
         * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
         * pager.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError> | QueryFiltersByQueryKey<ListGroupActivitySchema, ListGroupActivityData, TInfinite, ListGroupActivityParameters, ListGroupActivityError>): number;
        schema: ListGroupActivitySchema;
        types: {
            parameters: ListGroupActivityParameters;
            data: ListGroupActivityData;
            error: ListGroupActivityError;
        };
    };
    /**
     * @summary List Member Activity
     * @description One member's Timeline: their own activity rows, newest first.
     *
     * A student caller is refused every timeline, their own included.
     */
    listMemberActivity: {
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListMemberActivitySchema, ListMemberActivityParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListMemberActivityParameters, TMeta, TSignal>), client?: (schema: ListMemberActivitySchema, options: {
            parameters: ListMemberActivityParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListMemberActivityData, ListMemberActivityError>>): Promise<RequestFnResponse<ListMemberActivityData, ListMemberActivityError>>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        getQueryKey(parameters: DeepReadonly<ListMemberActivityParameters>): ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMemberActivity.useQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListMemberActivityData>(parameters: ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>), options?: Omit<UndefinedInitialDataOptions<ListMemberActivityData, ListMemberActivityError, TData, ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListMemberActivityError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listMemberActivity.useQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListMemberActivityData>(parameters: ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>), options: Omit<DefinedInitialDataOptions<ListMemberActivityData, ListMemberActivityError, TData, ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListMemberActivityError>>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListMemberActivityParameters>): ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMemberActivity.useInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListMemberActivityParameters, TQueryFnData = ListMemberActivityData, TData = OperationInfiniteData<TQueryFnData, ListMemberActivityParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListMemberActivityError, TData, ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListMemberActivityError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMemberActivity.useInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListMemberActivityParameters, TQueryFnData = ListMemberActivityData, TData = OperationInfiniteData<TQueryFnData, ListMemberActivityParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListMemberActivityError, TData, ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListMemberActivityData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListMemberActivityError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listMemberActivityTotal = qraft.v3Service.listMemberActivity.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listMemberActivityByParametersTotal = qraft.v3Service.listMemberActivity.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError> | QueryFiltersByQueryKey<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listMemberActivityResults = qraft.v3Service.listMemberActivity.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMemberActivityResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listMemberActivityCombinedResults = qraft.v3Service.listMemberActivity.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMemberActivityCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListMemberActivitySchema, ListMemberActivityParameters, ListMemberActivityData, ListMemberActivityError>>, TCombinedResult = Array<UseQueryResult<ListMemberActivityData, ListMemberActivityError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListMemberActivityData, ListMemberActivityError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listMemberActivity.useSuspenseQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListMemberActivityData>(parameters: ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>), options?: Omit<UseSuspenseQueryOptions<ListMemberActivityData, ListMemberActivityError, TData, ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListMemberActivityError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listMemberActivity.useSuspenseInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListMemberActivityParameters, TData = ListMemberActivityData>(parameters: ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListMemberActivityData, ListMemberActivityError, OperationInfiniteData<TData, ListMemberActivityParameters>, ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListMemberActivityData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListMemberActivityParameters>, OperationError<ListMemberActivityError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listMemberActivityData = qraft.v3Service.listMemberActivity.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMemberActivityResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listMemberActivityCombinedData = qraft.v3Service.listMemberActivity.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listMemberActivityCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListMemberActivitySchema, ListMemberActivityParameters, ListMemberActivityData, ListMemberActivityError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListMemberActivityData, ListMemberActivityError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListMemberActivityData, ListMemberActivityError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListMemberActivitySchema, ListMemberActivityData, ListMemberActivityParameters, ListMemberActivityError>): Promise<ListMemberActivityData>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListMemberActivitySchema, ListMemberActivityData, ListMemberActivityParameters, ListMemberActivityError>): Promise<void>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListMemberActivitySchema, ListMemberActivityData, ListMemberActivityParameters, ListMemberActivityError>): Promise<ListMemberActivityData>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        fetchInfiniteQuery<TPageParam extends ListMemberActivityParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListMemberActivitySchema, ListMemberActivityData, ListMemberActivityParameters, DeepReadonly<TPageParam>, ListMemberActivityError>): Promise<OperationInfiniteData<ListMemberActivityData, ListMemberActivityParameters>>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        prefetchInfiniteQuery<TPageParam extends ListMemberActivityParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListMemberActivitySchema, ListMemberActivityData, ListMemberActivityParameters, DeepReadonly<TPageParam>, ListMemberActivityError>): Promise<void>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        ensureInfiniteQueryData<TPageParam extends ListMemberActivityParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListMemberActivitySchema, ListMemberActivityData, ListMemberActivityParameters, DeepReadonly<TPageParam>, ListMemberActivityError>): Promise<OperationInfiniteData<ListMemberActivityData, ListMemberActivityParameters>>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>)): ListMemberActivityData | undefined;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>)): OperationInfiniteData<ListMemberActivityData, ListMemberActivityParameters> | undefined;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError> | QueryFiltersByQueryKey<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>,
            data: NoInfer<OperationInfiniteData<ListMemberActivityData, ListMemberActivityParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>,
            data: ListMemberActivityData | undefined
        ]>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters> | (DeepReadonly<ListMemberActivityParameters>)): QueryState<ListMemberActivityData, ListMemberActivityError> | undefined;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListMemberActivityParameters> | ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>): QueryState<OperationInfiniteData<ListMemberActivityData, ListMemberActivityParameters>, ListMemberActivityError> | undefined;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        setQueryData(parameters: (DeepReadonly<ListMemberActivityParameters>) | ServiceOperationQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>, updater: Updater<NoInfer<ListMemberActivityData> | undefined, NoInfer<DeepReadonly<ListMemberActivityData>> | undefined>, options?: SetDataOptions): ListMemberActivityData | undefined;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListMemberActivityParameters>) | ServiceOperationInfiniteQueryKey<ListMemberActivitySchema, ListMemberActivityParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListMemberActivityData, ListMemberActivityParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListMemberActivityData, ListMemberActivityParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListMemberActivityData, ListMemberActivityParameters> | undefined;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError> | QueryFiltersByQueryKey<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>, updater: Updater<NoInfer<ListMemberActivityData> | undefined, NoInfer<ListMemberActivityData> | undefined>, options?: SetDataOptions): Array<ListMemberActivityData | undefined>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError> | QueryFiltersByQueryKey<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError> | QueryFiltersByQueryKey<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError> | QueryFiltersByQueryKey<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>): void;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError> | QueryFiltersByQueryKey<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Member Activity
         * @description One member's Timeline: their own activity rows, newest first.
         *
         * A student caller is refused every timeline, their own included.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError> | QueryFiltersByQueryKey<ListMemberActivitySchema, ListMemberActivityData, TInfinite, ListMemberActivityParameters, ListMemberActivityError>): number;
        schema: ListMemberActivitySchema;
        types: {
            parameters: ListMemberActivityParameters;
            data: ListMemberActivityData;
            error: ListMemberActivityError;
        };
    };
    /**
     * @summary Get Member Activity Access
     * @description Whether the caller may open this member's Timeline tab.
     *
     * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
     * means render no tab. It runs the feed's own predicate, so the probe can't disagree
     * with the read.
     */
    getMemberActivityAccess: {
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetMemberActivityAccessParameters, TMeta, TSignal>), client?: (schema: GetMemberActivityAccessSchema, options: {
            parameters: GetMemberActivityAccessParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetMemberActivityAccessData, GetMemberActivityAccessError>>): Promise<RequestFnResponse<GetMemberActivityAccessData, GetMemberActivityAccessError>>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        getQueryKey(parameters: DeepReadonly<GetMemberActivityAccessParameters>): ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMemberActivityAccess.useQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMemberActivityAccessData>(parameters: ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>), options?: Omit<UndefinedInitialDataOptions<GetMemberActivityAccessData, GetMemberActivityAccessError, TData, ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetMemberActivityAccessError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getMemberActivityAccess.useQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetMemberActivityAccessData>(parameters: ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>), options: Omit<DefinedInitialDataOptions<GetMemberActivityAccessData, GetMemberActivityAccessError, TData, ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetMemberActivityAccessError>>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetMemberActivityAccessParameters>): ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberActivityAccess.useInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMemberActivityAccessParameters, TQueryFnData = GetMemberActivityAccessData, TData = OperationInfiniteData<TQueryFnData, GetMemberActivityAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetMemberActivityAccessError, TData, ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetMemberActivityAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberActivityAccess.useInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetMemberActivityAccessParameters, TQueryFnData = GetMemberActivityAccessData, TData = OperationInfiniteData<TQueryFnData, GetMemberActivityAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetMemberActivityAccessError, TData, ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMemberActivityAccessData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetMemberActivityAccessError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getMemberActivityAccessTotal = qraft.v3Service.getMemberActivityAccess.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getMemberActivityAccessByParametersTotal = qraft.v3Service.getMemberActivityAccess.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             member_id: memberId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError> | QueryFiltersByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getMemberActivityAccessResults = qraft.v3Service.getMemberActivityAccess.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberActivityAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getMemberActivityAccessCombinedResults = qraft.v3Service.getMemberActivityAccess.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberActivityAccessCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters, GetMemberActivityAccessData, GetMemberActivityAccessError>>, TCombinedResult = Array<UseQueryResult<GetMemberActivityAccessData, GetMemberActivityAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetMemberActivityAccessData, GetMemberActivityAccessError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getMemberActivityAccess.useSuspenseQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetMemberActivityAccessData>(parameters: ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>), options?: Omit<UseSuspenseQueryOptions<GetMemberActivityAccessData, GetMemberActivityAccessError, TData, ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetMemberActivityAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getMemberActivityAccess.useSuspenseInfiniteQuery({
         *     path: {
         *         member_id: memberId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetMemberActivityAccessParameters, TData = GetMemberActivityAccessData>(parameters: ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetMemberActivityAccessData, GetMemberActivityAccessError, OperationInfiniteData<TData, GetMemberActivityAccessParameters>, ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetMemberActivityAccessData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetMemberActivityAccessParameters>, OperationError<GetMemberActivityAccessError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getMemberActivityAccessData = qraft.v3Service.getMemberActivityAccess.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberActivityAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getMemberActivityAccessCombinedData = qraft.v3Service.getMemberActivityAccess.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 member_id: memberId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 member_id: memberId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getMemberActivityAccessCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters, GetMemberActivityAccessData, GetMemberActivityAccessError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetMemberActivityAccessData, GetMemberActivityAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetMemberActivityAccessData, GetMemberActivityAccessError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetMemberActivityAccessSchema, GetMemberActivityAccessData, GetMemberActivityAccessParameters, GetMemberActivityAccessError>): Promise<GetMemberActivityAccessData>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetMemberActivityAccessSchema, GetMemberActivityAccessData, GetMemberActivityAccessParameters, GetMemberActivityAccessError>): Promise<void>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetMemberActivityAccessSchema, GetMemberActivityAccessData, GetMemberActivityAccessParameters, GetMemberActivityAccessError>): Promise<GetMemberActivityAccessData>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        fetchInfiniteQuery<TPageParam extends GetMemberActivityAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMemberActivityAccessSchema, GetMemberActivityAccessData, GetMemberActivityAccessParameters, DeepReadonly<TPageParam>, GetMemberActivityAccessError>): Promise<OperationInfiniteData<GetMemberActivityAccessData, GetMemberActivityAccessParameters>>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        prefetchInfiniteQuery<TPageParam extends GetMemberActivityAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetMemberActivityAccessSchema, GetMemberActivityAccessData, GetMemberActivityAccessParameters, DeepReadonly<TPageParam>, GetMemberActivityAccessError>): Promise<void>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        ensureInfiniteQueryData<TPageParam extends GetMemberActivityAccessParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetMemberActivityAccessSchema, GetMemberActivityAccessData, GetMemberActivityAccessParameters, DeepReadonly<TPageParam>, GetMemberActivityAccessError>): Promise<OperationInfiniteData<GetMemberActivityAccessData, GetMemberActivityAccessParameters>>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>)): GetMemberActivityAccessData | undefined;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>)): OperationInfiniteData<GetMemberActivityAccessData, GetMemberActivityAccessParameters> | undefined;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError> | QueryFiltersByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>,
            data: NoInfer<OperationInfiniteData<GetMemberActivityAccessData, GetMemberActivityAccessParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>,
            data: GetMemberActivityAccessData | undefined
        ]>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters> | (DeepReadonly<GetMemberActivityAccessParameters>)): QueryState<GetMemberActivityAccessData, GetMemberActivityAccessError> | undefined;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetMemberActivityAccessParameters> | ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>): QueryState<OperationInfiniteData<GetMemberActivityAccessData, GetMemberActivityAccessParameters>, GetMemberActivityAccessError> | undefined;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        setQueryData(parameters: (DeepReadonly<GetMemberActivityAccessParameters>) | ServiceOperationQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>, updater: Updater<NoInfer<GetMemberActivityAccessData> | undefined, NoInfer<DeepReadonly<GetMemberActivityAccessData>> | undefined>, options?: SetDataOptions): GetMemberActivityAccessData | undefined;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetMemberActivityAccessParameters>) | ServiceOperationInfiniteQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetMemberActivityAccessData, GetMemberActivityAccessParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetMemberActivityAccessData, GetMemberActivityAccessParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetMemberActivityAccessData, GetMemberActivityAccessParameters> | undefined;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError> | QueryFiltersByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>, updater: Updater<NoInfer<GetMemberActivityAccessData> | undefined, NoInfer<GetMemberActivityAccessData> | undefined>, options?: SetDataOptions): Array<GetMemberActivityAccessData | undefined>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError> | QueryFiltersByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError> | QueryFiltersByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError> | QueryFiltersByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>): void;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError> | QueryFiltersByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Member Activity Access
         * @description Whether the caller may open this member's Timeline tab.
         *
         * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
         * means render no tab. It runs the feed's own predicate, so the probe can't disagree
         * with the read.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError> | QueryFiltersByQueryKey<GetMemberActivityAccessSchema, GetMemberActivityAccessData, TInfinite, GetMemberActivityAccessParameters, GetMemberActivityAccessError>): number;
        schema: GetMemberActivityAccessSchema;
        types: {
            parameters: GetMemberActivityAccessParameters;
            data: GetMemberActivityAccessData;
            error: GetMemberActivityAccessError;
        };
    };
    /**
     * @summary Get Group Announcement
     * @description The group's stored announcement, as its author sees it.
     *
     * ``group_id`` comes from the path, not the caller's main group. A group with no row
     * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
     * screen opens on groups that never had an announcement.
     */
    getGroupAnnouncement: {
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupAnnouncementParameters, TMeta, TSignal>), client?: (schema: GetGroupAnnouncementSchema, options: {
            parameters: GetGroupAnnouncementParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupAnnouncementData, GetGroupAnnouncementError>>): Promise<RequestFnResponse<GetGroupAnnouncementData, GetGroupAnnouncementError>>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        getQueryKey(parameters: DeepReadonly<GetGroupAnnouncementParameters>): ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupAnnouncement.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupAnnouncementData>(parameters: ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupAnnouncementData, GetGroupAnnouncementError, TData, ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupAnnouncementError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupAnnouncement.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupAnnouncementData>(parameters: ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>), options: Omit<DefinedInitialDataOptions<GetGroupAnnouncementData, GetGroupAnnouncementError, TData, ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupAnnouncementError>>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupAnnouncementParameters>): ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupAnnouncement.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupAnnouncementParameters, TQueryFnData = GetGroupAnnouncementData, TData = OperationInfiniteData<TQueryFnData, GetGroupAnnouncementParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupAnnouncementError, TData, ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupAnnouncementError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupAnnouncement.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupAnnouncementParameters, TQueryFnData = GetGroupAnnouncementData, TData = OperationInfiniteData<TQueryFnData, GetGroupAnnouncementParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupAnnouncementError, TData, ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupAnnouncementData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupAnnouncementError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupAnnouncementTotal = qraft.v3Service.getGroupAnnouncement.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupAnnouncementByParametersTotal = qraft.v3Service.getGroupAnnouncement.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError> | QueryFiltersByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupAnnouncementResults = qraft.v3Service.getGroupAnnouncement.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupAnnouncementResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupAnnouncementCombinedResults = qraft.v3Service.getGroupAnnouncement.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupAnnouncementCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters, GetGroupAnnouncementData, GetGroupAnnouncementError>>, TCombinedResult = Array<UseQueryResult<GetGroupAnnouncementData, GetGroupAnnouncementError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupAnnouncementData, GetGroupAnnouncementError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupAnnouncement.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupAnnouncementData>(parameters: ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupAnnouncementData, GetGroupAnnouncementError, TData, ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupAnnouncementError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupAnnouncement.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupAnnouncementParameters, TData = GetGroupAnnouncementData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupAnnouncementData, GetGroupAnnouncementError, OperationInfiniteData<TData, GetGroupAnnouncementParameters>, ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupAnnouncementData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupAnnouncementParameters>, OperationError<GetGroupAnnouncementError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupAnnouncementData = qraft.v3Service.getGroupAnnouncement.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupAnnouncementResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupAnnouncementCombinedData = qraft.v3Service.getGroupAnnouncement.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupAnnouncementCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters, GetGroupAnnouncementData, GetGroupAnnouncementError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupAnnouncementData, GetGroupAnnouncementError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupAnnouncementData, GetGroupAnnouncementError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupAnnouncementSchema, GetGroupAnnouncementData, GetGroupAnnouncementParameters, GetGroupAnnouncementError>): Promise<GetGroupAnnouncementData>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupAnnouncementSchema, GetGroupAnnouncementData, GetGroupAnnouncementParameters, GetGroupAnnouncementError>): Promise<void>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupAnnouncementSchema, GetGroupAnnouncementData, GetGroupAnnouncementParameters, GetGroupAnnouncementError>): Promise<GetGroupAnnouncementData>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        fetchInfiniteQuery<TPageParam extends GetGroupAnnouncementParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupAnnouncementSchema, GetGroupAnnouncementData, GetGroupAnnouncementParameters, DeepReadonly<TPageParam>, GetGroupAnnouncementError>): Promise<OperationInfiniteData<GetGroupAnnouncementData, GetGroupAnnouncementParameters>>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        prefetchInfiniteQuery<TPageParam extends GetGroupAnnouncementParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupAnnouncementSchema, GetGroupAnnouncementData, GetGroupAnnouncementParameters, DeepReadonly<TPageParam>, GetGroupAnnouncementError>): Promise<void>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        ensureInfiniteQueryData<TPageParam extends GetGroupAnnouncementParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupAnnouncementSchema, GetGroupAnnouncementData, GetGroupAnnouncementParameters, DeepReadonly<TPageParam>, GetGroupAnnouncementError>): Promise<OperationInfiniteData<GetGroupAnnouncementData, GetGroupAnnouncementParameters>>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>)): GetGroupAnnouncementData | undefined;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>)): OperationInfiniteData<GetGroupAnnouncementData, GetGroupAnnouncementParameters> | undefined;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError> | QueryFiltersByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupAnnouncementData, GetGroupAnnouncementParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>,
            data: GetGroupAnnouncementData | undefined
        ]>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters> | (DeepReadonly<GetGroupAnnouncementParameters>)): QueryState<GetGroupAnnouncementData, GetGroupAnnouncementError> | undefined;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupAnnouncementParameters> | ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>): QueryState<OperationInfiniteData<GetGroupAnnouncementData, GetGroupAnnouncementParameters>, GetGroupAnnouncementError> | undefined;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        setQueryData(parameters: (DeepReadonly<GetGroupAnnouncementParameters>) | ServiceOperationQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>, updater: Updater<NoInfer<GetGroupAnnouncementData> | undefined, NoInfer<DeepReadonly<GetGroupAnnouncementData>> | undefined>, options?: SetDataOptions): GetGroupAnnouncementData | undefined;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupAnnouncementParameters>) | ServiceOperationInfiniteQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupAnnouncementData, GetGroupAnnouncementParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupAnnouncementData, GetGroupAnnouncementParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupAnnouncementData, GetGroupAnnouncementParameters> | undefined;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError> | QueryFiltersByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>, updater: Updater<NoInfer<GetGroupAnnouncementData> | undefined, NoInfer<GetGroupAnnouncementData> | undefined>, options?: SetDataOptions): Array<GetGroupAnnouncementData | undefined>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError> | QueryFiltersByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError> | QueryFiltersByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError> | QueryFiltersByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>): void;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError> | QueryFiltersByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Group Announcement
         * @description The group's stored announcement, as its author sees it.
         *
         * ``group_id`` comes from the path, not the caller's main group. A group with no row
         * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
         * screen opens on groups that never had an announcement.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError> | QueryFiltersByQueryKey<GetGroupAnnouncementSchema, GetGroupAnnouncementData, TInfinite, GetGroupAnnouncementParameters, GetGroupAnnouncementError>): number;
        schema: GetGroupAnnouncementSchema;
        types: {
            parameters: GetGroupAnnouncementParameters;
            data: GetGroupAnnouncementData;
            error: GetGroupAnnouncementError;
        };
    };
    /**
     * @summary Set Group Announcement
     * @description Replace the group's announcement, and return what was stored.
     *
     * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
     * sent. The response is the stored row, never ``body``, because the write sanitises.
     */
    setGroupAnnouncement: {
        /**
         * @summary Set Group Announcement
         * @description Replace the group's announcement, and return what was stored.
         *
         * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
         * sent. The response is the stored row, never ``body``, because the write sanitises.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetGroupAnnouncementBody, SetGroupAnnouncementParameters, TMeta, TSignal>, client?: (schema: SetGroupAnnouncementSchema, options: ServiceOperationMutationFnOptions<SetGroupAnnouncementBody, SetGroupAnnouncementParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetGroupAnnouncementData, SetGroupAnnouncementError>>): Promise<RequestFnResponse<SetGroupAnnouncementData, SetGroupAnnouncementError>>;
        /**
         * @summary Set Group Announcement
         * @description Replace the group's announcement, and return what was stored.
         *
         * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
         * sent. The response is the stored row, never ``body``, because the write sanitises.
         */
        getMutationKey(parameters: DeepReadonly<SetGroupAnnouncementParameters> | void): ServiceOperationMutationKey<SetGroupAnnouncementSchema, SetGroupAnnouncementParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Group Announcement
         * @description Replace the group's announcement, and return what was stored.
         *
         * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
         * sent. The response is the stored row, never ``body``, because the write sanitises.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setGroupAnnouncement.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setGroupAnnouncement.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetGroupAnnouncementBody, TContext = unknown>(parameters: DeepReadonly<SetGroupAnnouncementParameters>, options?: ServiceOperationUseMutationOptions<SetGroupAnnouncementSchema, SetGroupAnnouncementData, SetGroupAnnouncementParameters, TVariables, OperationError<SetGroupAnnouncementError>, TContext>): UseMutationResult<SetGroupAnnouncementData, OperationError<SetGroupAnnouncementError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Group Announcement
         * @description Replace the group's announcement, and return what was stored.
         *
         * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
         * sent. The response is the stored row, never ``body``, because the write sanitises.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setGroupAnnouncement.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setGroupAnnouncement.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetGroupAnnouncementBody, SetGroupAnnouncementParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetGroupAnnouncementSchema, SetGroupAnnouncementData, SetGroupAnnouncementParameters, TVariables, OperationError<SetGroupAnnouncementError>, TContext>): UseMutationResult<SetGroupAnnouncementData, OperationError<SetGroupAnnouncementError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set Group Announcement
         * @description Replace the group's announcement, and return what was stored.
         *
         * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
         * sent. The response is the stored row, never ``body``, because the write sanitises.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setGroupAnnouncementTotal = qraft.v3Service.setGroupAnnouncement.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setGroupAnnouncementTotal = qraft.v3Service.setGroupAnnouncement.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext> | MutationFiltersByMutationKey<SetGroupAnnouncementSchema, SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set Group Announcement
         * @description Replace the group's announcement, and return what was stored.
         *
         * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
         * sent. The response is the stored row, never ``body``, because the write sanitises.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setGroupAnnouncementPendingMutationVariables = qraft.v3Service.setGroupAnnouncement.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setGroupAnnouncementMutationData = qraft.v3Service.setGroupAnnouncement.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetGroupAnnouncementData, OperationError<SetGroupAnnouncementError>, MutationVariables<SetGroupAnnouncementBody, SetGroupAnnouncementParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext> | MutationFiltersByMutationKey<SetGroupAnnouncementSchema, SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext>;
            select?: (mutation: Mutation<SetGroupAnnouncementData, OperationError<SetGroupAnnouncementError>, MutationVariables<SetGroupAnnouncementBody, SetGroupAnnouncementParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set Group Announcement
         * @description Replace the group's announcement, and return what was stored.
         *
         * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
         * sent. The response is the stored row, never ``body``, because the write sanitises.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext> | MutationFiltersByMutationKey<SetGroupAnnouncementSchema, SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set Group Announcement
         * @description Replace the group's announcement, and return what was stored.
         *
         * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
         * sent. The response is the stored row, never ``body``, because the write sanitises.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setGroupAnnouncement.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setGroupAnnouncement.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext> | MutationFiltersByMutationKey<SetGroupAnnouncementSchema, SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext>): Mutation<SetGroupAnnouncementData, SetGroupAnnouncementError, MutationVariables<SetGroupAnnouncementBody, SetGroupAnnouncementParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext> | MutationFiltersByMutationKey<SetGroupAnnouncementSchema, SetGroupAnnouncementBody, SetGroupAnnouncementData, SetGroupAnnouncementParameters, OperationError<SetGroupAnnouncementError>, TContext>): Array<Mutation<SetGroupAnnouncementData, SetGroupAnnouncementError, MutationVariables<SetGroupAnnouncementBody, SetGroupAnnouncementParameters>, TContext>>;
        };
        schema: SetGroupAnnouncementSchema;
        types: {
            parameters: SetGroupAnnouncementParameters;
            data: SetGroupAnnouncementData;
            error: SetGroupAnnouncementError;
            body: SetGroupAnnouncementBody;
        };
    };
    /**
     * @summary Get Group Dashboard Stats
     * @description The four counters on a study group's stat bar, in legacy's order.
     *
     * `unread_messages` is the viewer's own inbox, not the group's.
     */
    getGroupDashboardStats: {
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupDashboardStatsParameters, TMeta, TSignal>), client?: (schema: GetGroupDashboardStatsSchema, options: {
            parameters: GetGroupDashboardStatsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupDashboardStatsData, GetGroupDashboardStatsError>>): Promise<RequestFnResponse<GetGroupDashboardStatsData, GetGroupDashboardStatsError>>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        getQueryKey(parameters: DeepReadonly<GetGroupDashboardStatsParameters>): ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupDashboardStats.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupDashboardStatsData>(parameters: ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupDashboardStatsData, GetGroupDashboardStatsError, TData, ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupDashboardStats.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupDashboardStatsData>(parameters: ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>), options: Omit<DefinedInitialDataOptions<GetGroupDashboardStatsData, GetGroupDashboardStatsError, TData, ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupDashboardStatsError>>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupDashboardStatsParameters>): ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupDashboardStats.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupDashboardStatsParameters, TQueryFnData = GetGroupDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetGroupDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupDashboardStats.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupDashboardStatsParameters, TQueryFnData = GetGroupDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetGroupDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupDashboardStatsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupDashboardStatsTotal = qraft.v3Service.getGroupDashboardStats.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupDashboardStatsByParametersTotal = qraft.v3Service.getGroupDashboardStats.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError> | QueryFiltersByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupDashboardStatsResults = qraft.v3Service.getGroupDashboardStats.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupDashboardStatsCombinedResults = qraft.v3Service.getGroupDashboardStats.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupDashboardStatsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters, GetGroupDashboardStatsData, GetGroupDashboardStatsError>>, TCombinedResult = Array<UseQueryResult<GetGroupDashboardStatsData, GetGroupDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupDashboardStatsData, GetGroupDashboardStatsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupDashboardStats.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupDashboardStatsData>(parameters: ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupDashboardStatsData, GetGroupDashboardStatsError, TData, ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupDashboardStats.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupDashboardStatsParameters, TData = GetGroupDashboardStatsData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupDashboardStatsData, GetGroupDashboardStatsError, OperationInfiniteData<TData, GetGroupDashboardStatsParameters>, ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupDashboardStatsParameters>, OperationError<GetGroupDashboardStatsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupDashboardStatsData = qraft.v3Service.getGroupDashboardStats.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupDashboardStatsCombinedData = qraft.v3Service.getGroupDashboardStats.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupDashboardStatsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters, GetGroupDashboardStatsData, GetGroupDashboardStatsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupDashboardStatsData, GetGroupDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupDashboardStatsData, GetGroupDashboardStatsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>): Promise<GetGroupDashboardStatsData>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>): Promise<void>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>): Promise<GetGroupDashboardStatsData>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        fetchInfiniteQuery<TPageParam extends GetGroupDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, GetGroupDashboardStatsParameters, DeepReadonly<TPageParam>, GetGroupDashboardStatsError>): Promise<OperationInfiniteData<GetGroupDashboardStatsData, GetGroupDashboardStatsParameters>>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        prefetchInfiniteQuery<TPageParam extends GetGroupDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, GetGroupDashboardStatsParameters, DeepReadonly<TPageParam>, GetGroupDashboardStatsError>): Promise<void>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        ensureInfiniteQueryData<TPageParam extends GetGroupDashboardStatsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, GetGroupDashboardStatsParameters, DeepReadonly<TPageParam>, GetGroupDashboardStatsError>): Promise<OperationInfiniteData<GetGroupDashboardStatsData, GetGroupDashboardStatsParameters>>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>)): GetGroupDashboardStatsData | undefined;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>)): OperationInfiniteData<GetGroupDashboardStatsData, GetGroupDashboardStatsParameters> | undefined;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError> | QueryFiltersByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupDashboardStatsData, GetGroupDashboardStatsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>,
            data: GetGroupDashboardStatsData | undefined
        ]>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters> | (DeepReadonly<GetGroupDashboardStatsParameters>)): QueryState<GetGroupDashboardStatsData, GetGroupDashboardStatsError> | undefined;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupDashboardStatsParameters> | ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>): QueryState<OperationInfiniteData<GetGroupDashboardStatsData, GetGroupDashboardStatsParameters>, GetGroupDashboardStatsError> | undefined;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        setQueryData(parameters: (DeepReadonly<GetGroupDashboardStatsParameters>) | ServiceOperationQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>, updater: Updater<NoInfer<GetGroupDashboardStatsData> | undefined, NoInfer<DeepReadonly<GetGroupDashboardStatsData>> | undefined>, options?: SetDataOptions): GetGroupDashboardStatsData | undefined;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupDashboardStatsParameters>) | ServiceOperationInfiniteQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupDashboardStatsData, GetGroupDashboardStatsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupDashboardStatsData, GetGroupDashboardStatsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupDashboardStatsData, GetGroupDashboardStatsParameters> | undefined;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError> | QueryFiltersByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>, updater: Updater<NoInfer<GetGroupDashboardStatsData> | undefined, NoInfer<GetGroupDashboardStatsData> | undefined>, options?: SetDataOptions): Array<GetGroupDashboardStatsData | undefined>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError> | QueryFiltersByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError> | QueryFiltersByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError> | QueryFiltersByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>): void;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError> | QueryFiltersByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Group Dashboard Stats
         * @description The four counters on a study group's stat bar, in legacy's order.
         *
         * `unread_messages` is the viewer's own inbox, not the group's.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError> | QueryFiltersByQueryKey<GetGroupDashboardStatsSchema, GetGroupDashboardStatsData, TInfinite, GetGroupDashboardStatsParameters, GetGroupDashboardStatsError>): number;
        schema: GetGroupDashboardStatsSchema;
        types: {
            parameters: GetGroupDashboardStatsParameters;
            data: GetGroupDashboardStatsData;
            error: GetGroupDashboardStatsError;
        };
    };
    /**
     * @summary Get Congregation Dashboard Stats
     * @description The congregation / custom-study stat bar: four tiles, the last a composite.
     *
     * Group admins only, on a congregation or a custom study group.
     */
    getCongregationDashboardStats: {
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetCongregationDashboardStatsParameters, TMeta, TSignal>), client?: (schema: GetCongregationDashboardStatsSchema, options: {
            parameters: GetCongregationDashboardStatsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError>>): Promise<RequestFnResponse<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError>>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        getQueryKey(parameters: DeepReadonly<GetCongregationDashboardStatsParameters>): ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCongregationDashboardStats.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCongregationDashboardStatsData>(parameters: ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>), options?: Omit<UndefinedInitialDataOptions<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError, TData, ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetCongregationDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCongregationDashboardStats.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCongregationDashboardStatsData>(parameters: ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>), options: Omit<DefinedInitialDataOptions<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError, TData, ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetCongregationDashboardStatsError>>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetCongregationDashboardStatsParameters>): ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCongregationDashboardStats.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCongregationDashboardStatsParameters, TQueryFnData = GetCongregationDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetCongregationDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetCongregationDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetCongregationDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCongregationDashboardStats.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCongregationDashboardStatsParameters, TQueryFnData = GetCongregationDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetCongregationDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetCongregationDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCongregationDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetCongregationDashboardStatsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getCongregationDashboardStatsTotal = qraft.v3Service.getCongregationDashboardStats.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getCongregationDashboardStatsByParametersTotal = qraft.v3Service.getCongregationDashboardStats.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError> | QueryFiltersByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getCongregationDashboardStatsResults = qraft.v3Service.getCongregationDashboardStats.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCongregationDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getCongregationDashboardStatsCombinedResults = qraft.v3Service.getCongregationDashboardStats.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCongregationDashboardStatsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsData, GetCongregationDashboardStatsError>>, TCombinedResult = Array<UseQueryResult<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getCongregationDashboardStats.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetCongregationDashboardStatsData>(parameters: ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>), options?: Omit<UseSuspenseQueryOptions<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError, TData, ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetCongregationDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCongregationDashboardStats.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetCongregationDashboardStatsParameters, TData = GetCongregationDashboardStatsData>(parameters: ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError, OperationInfiniteData<TData, GetCongregationDashboardStatsParameters>, ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCongregationDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetCongregationDashboardStatsParameters>, OperationError<GetCongregationDashboardStatsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getCongregationDashboardStatsData = qraft.v3Service.getCongregationDashboardStats.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCongregationDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getCongregationDashboardStatsCombinedData = qraft.v3Service.getCongregationDashboardStats.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCongregationDashboardStatsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsData, GetCongregationDashboardStatsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>): Promise<GetCongregationDashboardStatsData>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>): Promise<GetCongregationDashboardStatsData>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        fetchInfiniteQuery<TPageParam extends GetCongregationDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters, DeepReadonly<TPageParam>, GetCongregationDashboardStatsError>): Promise<OperationInfiniteData<GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters>>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        prefetchInfiniteQuery<TPageParam extends GetCongregationDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters, DeepReadonly<TPageParam>, GetCongregationDashboardStatsError>): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        ensureInfiniteQueryData<TPageParam extends GetCongregationDashboardStatsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters, DeepReadonly<TPageParam>, GetCongregationDashboardStatsError>): Promise<OperationInfiniteData<GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters>>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>)): GetCongregationDashboardStatsData | undefined;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>)): OperationInfiniteData<GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters> | undefined;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError> | QueryFiltersByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>,
            data: NoInfer<OperationInfiniteData<GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>,
            data: GetCongregationDashboardStatsData | undefined
        ]>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters> | (DeepReadonly<GetCongregationDashboardStatsParameters>)): QueryState<GetCongregationDashboardStatsData, GetCongregationDashboardStatsError> | undefined;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetCongregationDashboardStatsParameters> | ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>): QueryState<OperationInfiniteData<GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters>, GetCongregationDashboardStatsError> | undefined;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        setQueryData(parameters: (DeepReadonly<GetCongregationDashboardStatsParameters>) | ServiceOperationQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>, updater: Updater<NoInfer<GetCongregationDashboardStatsData> | undefined, NoInfer<DeepReadonly<GetCongregationDashboardStatsData>> | undefined>, options?: SetDataOptions): GetCongregationDashboardStatsData | undefined;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetCongregationDashboardStatsParameters>) | ServiceOperationInfiniteQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetCongregationDashboardStatsData, GetCongregationDashboardStatsParameters> | undefined;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError> | QueryFiltersByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>, updater: Updater<NoInfer<GetCongregationDashboardStatsData> | undefined, NoInfer<GetCongregationDashboardStatsData> | undefined>, options?: SetDataOptions): Array<GetCongregationDashboardStatsData | undefined>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError> | QueryFiltersByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError> | QueryFiltersByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError> | QueryFiltersByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>): void;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError> | QueryFiltersByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Stats
         * @description The congregation / custom-study stat bar: four tiles, the last a composite.
         *
         * Group admins only, on a congregation or a custom study group.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError> | QueryFiltersByQueryKey<GetCongregationDashboardStatsSchema, GetCongregationDashboardStatsData, TInfinite, GetCongregationDashboardStatsParameters, GetCongregationDashboardStatsError>): number;
        schema: GetCongregationDashboardStatsSchema;
        types: {
            parameters: GetCongregationDashboardStatsParameters;
            data: GetCongregationDashboardStatsData;
            error: GetCongregationDashboardStatsError;
        };
    };
    /**
     * @summary List Congregation Dashboard Waiting
     * @description The Students Waiting panel: one row per grading the group still owes, oldest
     * first.
     *
     * A student with two qualifying gradings has two rows, and the stat tile counts the
     * same rows.
     */
    listCongregationDashboardWaiting: {
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCongregationDashboardWaitingParameters, TMeta, TSignal>), client?: (schema: ListCongregationDashboardWaitingSchema, options: {
            parameters: ListCongregationDashboardWaitingParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError>>): Promise<RequestFnResponse<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError>>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        getQueryKey(parameters: DeepReadonly<ListCongregationDashboardWaitingParameters>): ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCongregationDashboardWaiting.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCongregationDashboardWaitingData>(parameters: ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>), options?: Omit<UndefinedInitialDataOptions<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError, TData, ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCongregationDashboardWaitingError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCongregationDashboardWaiting.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCongregationDashboardWaitingData>(parameters: ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>), options: Omit<DefinedInitialDataOptions<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError, TData, ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCongregationDashboardWaitingError>>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCongregationDashboardWaitingParameters>): ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCongregationDashboardWaiting.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCongregationDashboardWaitingParameters, TQueryFnData = ListCongregationDashboardWaitingData, TData = OperationInfiniteData<TQueryFnData, ListCongregationDashboardWaitingParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCongregationDashboardWaitingError, TData, ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCongregationDashboardWaitingError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCongregationDashboardWaiting.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCongregationDashboardWaitingParameters, TQueryFnData = ListCongregationDashboardWaitingData, TData = OperationInfiniteData<TQueryFnData, ListCongregationDashboardWaitingParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCongregationDashboardWaitingError, TData, ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCongregationDashboardWaitingData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCongregationDashboardWaitingError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCongregationDashboardWaitingTotal = qraft.v3Service.listCongregationDashboardWaiting.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCongregationDashboardWaitingByParametersTotal = qraft.v3Service.listCongregationDashboardWaiting.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError> | QueryFiltersByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCongregationDashboardWaitingResults = qraft.v3Service.listCongregationDashboardWaiting.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCongregationDashboardWaitingResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCongregationDashboardWaitingCombinedResults = qraft.v3Service.listCongregationDashboardWaiting.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCongregationDashboardWaitingCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError>>, TCombinedResult = Array<UseQueryResult<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCongregationDashboardWaiting.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCongregationDashboardWaitingData>(parameters: ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>), options?: Omit<UseSuspenseQueryOptions<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError, TData, ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCongregationDashboardWaitingError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCongregationDashboardWaiting.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCongregationDashboardWaitingParameters, TData = ListCongregationDashboardWaitingData>(parameters: ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError, OperationInfiniteData<TData, ListCongregationDashboardWaitingParameters>, ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCongregationDashboardWaitingData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCongregationDashboardWaitingParameters>, OperationError<ListCongregationDashboardWaitingError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCongregationDashboardWaitingData = qraft.v3Service.listCongregationDashboardWaiting.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCongregationDashboardWaitingResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCongregationDashboardWaitingCombinedData = qraft.v3Service.listCongregationDashboardWaiting.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCongregationDashboardWaitingCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>): Promise<ListCongregationDashboardWaitingData>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>): Promise<void>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>): Promise<ListCongregationDashboardWaitingData>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        fetchInfiniteQuery<TPageParam extends ListCongregationDashboardWaitingParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters, DeepReadonly<TPageParam>, ListCongregationDashboardWaitingError>): Promise<OperationInfiniteData<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters>>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        prefetchInfiniteQuery<TPageParam extends ListCongregationDashboardWaitingParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters, DeepReadonly<TPageParam>, ListCongregationDashboardWaitingError>): Promise<void>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        ensureInfiniteQueryData<TPageParam extends ListCongregationDashboardWaitingParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters, DeepReadonly<TPageParam>, ListCongregationDashboardWaitingError>): Promise<OperationInfiniteData<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters>>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>)): ListCongregationDashboardWaitingData | undefined;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>)): OperationInfiniteData<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters> | undefined;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError> | QueryFiltersByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>,
            data: NoInfer<OperationInfiniteData<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>,
            data: ListCongregationDashboardWaitingData | undefined
        ]>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters> | (DeepReadonly<ListCongregationDashboardWaitingParameters>)): QueryState<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingError> | undefined;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListCongregationDashboardWaitingParameters> | ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>): QueryState<OperationInfiniteData<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters>, ListCongregationDashboardWaitingError> | undefined;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        setQueryData(parameters: (DeepReadonly<ListCongregationDashboardWaitingParameters>) | ServiceOperationQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>, updater: Updater<NoInfer<ListCongregationDashboardWaitingData> | undefined, NoInfer<DeepReadonly<ListCongregationDashboardWaitingData>> | undefined>, options?: SetDataOptions): ListCongregationDashboardWaitingData | undefined;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCongregationDashboardWaitingParameters>) | ServiceOperationInfiniteQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCongregationDashboardWaitingData, ListCongregationDashboardWaitingParameters> | undefined;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError> | QueryFiltersByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>, updater: Updater<NoInfer<ListCongregationDashboardWaitingData> | undefined, NoInfer<ListCongregationDashboardWaitingData> | undefined>, options?: SetDataOptions): Array<ListCongregationDashboardWaitingData | undefined>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError> | QueryFiltersByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError> | QueryFiltersByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError> | QueryFiltersByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>): void;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError> | QueryFiltersByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Congregation Dashboard Waiting
         * @description The Students Waiting panel: one row per grading the group still owes, oldest
         * first.
         *
         * A student with two qualifying gradings has two rows, and the stat tile counts the
         * same rows.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError> | QueryFiltersByQueryKey<ListCongregationDashboardWaitingSchema, ListCongregationDashboardWaitingData, TInfinite, ListCongregationDashboardWaitingParameters, ListCongregationDashboardWaitingError>): number;
        schema: ListCongregationDashboardWaitingSchema;
        types: {
            parameters: ListCongregationDashboardWaitingParameters;
            data: ListCongregationDashboardWaitingData;
            error: ListCongregationDashboardWaitingError;
        };
    };
    /**
     * @summary List Congregation Dashboard Locations
     * @description The congregation dashboard's Locations widget: the group's derived students.
     *
     * Every marker is a student. Legacy also plotted the group's leaders, but study
     * helpers have no stored coordinates.
     */
    listCongregationDashboardLocations: {
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCongregationDashboardLocationsParameters, TMeta, TSignal>), client?: (schema: ListCongregationDashboardLocationsSchema, options: {
            parameters: ListCongregationDashboardLocationsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError>>): Promise<RequestFnResponse<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError>>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        getQueryKey(parameters: DeepReadonly<ListCongregationDashboardLocationsParameters>): ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCongregationDashboardLocations.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCongregationDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>), options?: Omit<UndefinedInitialDataOptions<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError, TData, ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCongregationDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCongregationDashboardLocations.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCongregationDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>), options: Omit<DefinedInitialDataOptions<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError, TData, ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCongregationDashboardLocationsError>>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCongregationDashboardLocationsParameters>): ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCongregationDashboardLocations.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCongregationDashboardLocationsParameters, TQueryFnData = ListCongregationDashboardLocationsData, TData = OperationInfiniteData<TQueryFnData, ListCongregationDashboardLocationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCongregationDashboardLocationsError, TData, ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCongregationDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCongregationDashboardLocations.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCongregationDashboardLocationsParameters, TQueryFnData = ListCongregationDashboardLocationsData, TData = OperationInfiniteData<TQueryFnData, ListCongregationDashboardLocationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCongregationDashboardLocationsError, TData, ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCongregationDashboardLocationsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCongregationDashboardLocationsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCongregationDashboardLocationsTotal = qraft.v3Service.listCongregationDashboardLocations.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCongregationDashboardLocationsByParametersTotal = qraft.v3Service.listCongregationDashboardLocations.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError> | QueryFiltersByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCongregationDashboardLocationsResults = qraft.v3Service.listCongregationDashboardLocations.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCongregationDashboardLocationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCongregationDashboardLocationsCombinedResults = qraft.v3Service.listCongregationDashboardLocations.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCongregationDashboardLocationsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError>>, TCombinedResult = Array<UseQueryResult<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCongregationDashboardLocations.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCongregationDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>), options?: Omit<UseSuspenseQueryOptions<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError, TData, ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCongregationDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCongregationDashboardLocations.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCongregationDashboardLocationsParameters, TData = ListCongregationDashboardLocationsData>(parameters: ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError, OperationInfiniteData<TData, ListCongregationDashboardLocationsParameters>, ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCongregationDashboardLocationsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCongregationDashboardLocationsParameters>, OperationError<ListCongregationDashboardLocationsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCongregationDashboardLocationsData = qraft.v3Service.listCongregationDashboardLocations.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCongregationDashboardLocationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCongregationDashboardLocationsCombinedData = qraft.v3Service.listCongregationDashboardLocations.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCongregationDashboardLocationsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>): Promise<ListCongregationDashboardLocationsData>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>): Promise<void>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>): Promise<ListCongregationDashboardLocationsData>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        fetchInfiniteQuery<TPageParam extends ListCongregationDashboardLocationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters, DeepReadonly<TPageParam>, ListCongregationDashboardLocationsError>): Promise<OperationInfiniteData<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters>>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        prefetchInfiniteQuery<TPageParam extends ListCongregationDashboardLocationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters, DeepReadonly<TPageParam>, ListCongregationDashboardLocationsError>): Promise<void>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        ensureInfiniteQueryData<TPageParam extends ListCongregationDashboardLocationsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters, DeepReadonly<TPageParam>, ListCongregationDashboardLocationsError>): Promise<OperationInfiniteData<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters>>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>)): ListCongregationDashboardLocationsData | undefined;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>)): OperationInfiniteData<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters> | undefined;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError> | QueryFiltersByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>,
            data: NoInfer<OperationInfiniteData<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>,
            data: ListCongregationDashboardLocationsData | undefined
        ]>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters> | (DeepReadonly<ListCongregationDashboardLocationsParameters>)): QueryState<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsError> | undefined;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListCongregationDashboardLocationsParameters> | ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>): QueryState<OperationInfiniteData<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters>, ListCongregationDashboardLocationsError> | undefined;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        setQueryData(parameters: (DeepReadonly<ListCongregationDashboardLocationsParameters>) | ServiceOperationQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>, updater: Updater<NoInfer<ListCongregationDashboardLocationsData> | undefined, NoInfer<DeepReadonly<ListCongregationDashboardLocationsData>> | undefined>, options?: SetDataOptions): ListCongregationDashboardLocationsData | undefined;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCongregationDashboardLocationsParameters>) | ServiceOperationInfiniteQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCongregationDashboardLocationsData, ListCongregationDashboardLocationsParameters> | undefined;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError> | QueryFiltersByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>, updater: Updater<NoInfer<ListCongregationDashboardLocationsData> | undefined, NoInfer<ListCongregationDashboardLocationsData> | undefined>, options?: SetDataOptions): Array<ListCongregationDashboardLocationsData | undefined>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError> | QueryFiltersByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError> | QueryFiltersByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError> | QueryFiltersByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>): void;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError> | QueryFiltersByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Congregation Dashboard Locations
         * @description The congregation dashboard's Locations widget: the group's derived students.
         *
         * Every marker is a student. Legacy also plotted the group's leaders, but study
         * helpers have no stored coordinates.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError> | QueryFiltersByQueryKey<ListCongregationDashboardLocationsSchema, ListCongregationDashboardLocationsData, TInfinite, ListCongregationDashboardLocationsParameters, ListCongregationDashboardLocationsError>): number;
        schema: ListCongregationDashboardLocationsSchema;
        types: {
            parameters: ListCongregationDashboardLocationsParameters;
            data: ListCongregationDashboardLocationsData;
            error: ListCongregationDashboardLocationsError;
        };
    };
    /**
     * @summary List Group Student Languages
     * @description One row per language with the group's derived-student count, zeros included.
     */
    listGroupStudentLanguages: {
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupStudentLanguagesParameters, TMeta, TSignal>), client?: (schema: ListGroupStudentLanguagesSchema, options: {
            parameters: ListGroupStudentLanguagesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError>>): Promise<RequestFnResponse<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError>>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupStudentLanguagesParameters>): ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupStudentLanguages.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupStudentLanguagesData>(parameters: ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError, TData, ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupStudentLanguagesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupStudentLanguages.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupStudentLanguagesData>(parameters: ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>), options: Omit<DefinedInitialDataOptions<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError, TData, ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupStudentLanguagesError>>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupStudentLanguagesParameters>): ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupStudentLanguages.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupStudentLanguagesParameters, TQueryFnData = ListGroupStudentLanguagesData, TData = OperationInfiniteData<TQueryFnData, ListGroupStudentLanguagesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupStudentLanguagesError, TData, ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupStudentLanguagesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupStudentLanguages.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupStudentLanguagesParameters, TQueryFnData = ListGroupStudentLanguagesData, TData = OperationInfiniteData<TQueryFnData, ListGroupStudentLanguagesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupStudentLanguagesError, TData, ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupStudentLanguagesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupStudentLanguagesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupStudentLanguagesTotal = qraft.v3Service.listGroupStudentLanguages.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupStudentLanguagesByParametersTotal = qraft.v3Service.listGroupStudentLanguages.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError> | QueryFiltersByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupStudentLanguagesResults = qraft.v3Service.listGroupStudentLanguages.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupStudentLanguagesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupStudentLanguagesCombinedResults = qraft.v3Service.listGroupStudentLanguages.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupStudentLanguagesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesData, ListGroupStudentLanguagesError>>, TCombinedResult = Array<UseQueryResult<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupStudentLanguages.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupStudentLanguagesData>(parameters: ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError, TData, ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupStudentLanguagesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupStudentLanguages.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupStudentLanguagesParameters, TData = ListGroupStudentLanguagesData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError, OperationInfiniteData<TData, ListGroupStudentLanguagesParameters>, ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupStudentLanguagesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupStudentLanguagesParameters>, OperationError<ListGroupStudentLanguagesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupStudentLanguagesData = qraft.v3Service.listGroupStudentLanguages.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupStudentLanguagesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupStudentLanguagesCombinedData = qraft.v3Service.listGroupStudentLanguages.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupStudentLanguagesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesData, ListGroupStudentLanguagesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>): Promise<ListGroupStudentLanguagesData>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>): Promise<void>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>): Promise<ListGroupStudentLanguagesData>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupStudentLanguagesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters, DeepReadonly<TPageParam>, ListGroupStudentLanguagesError>): Promise<OperationInfiniteData<ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters>>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupStudentLanguagesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters, DeepReadonly<TPageParam>, ListGroupStudentLanguagesError>): Promise<void>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupStudentLanguagesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters, DeepReadonly<TPageParam>, ListGroupStudentLanguagesError>): Promise<OperationInfiniteData<ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters>>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>)): ListGroupStudentLanguagesData | undefined;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>)): OperationInfiniteData<ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters> | undefined;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError> | QueryFiltersByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>,
            data: ListGroupStudentLanguagesData | undefined
        ]>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters> | (DeepReadonly<ListGroupStudentLanguagesParameters>)): QueryState<ListGroupStudentLanguagesData, ListGroupStudentLanguagesError> | undefined;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupStudentLanguagesParameters> | ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>): QueryState<OperationInfiniteData<ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters>, ListGroupStudentLanguagesError> | undefined;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupStudentLanguagesParameters>) | ServiceOperationQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>, updater: Updater<NoInfer<ListGroupStudentLanguagesData> | undefined, NoInfer<DeepReadonly<ListGroupStudentLanguagesData>> | undefined>, options?: SetDataOptions): ListGroupStudentLanguagesData | undefined;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupStudentLanguagesParameters>) | ServiceOperationInfiniteQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupStudentLanguagesData, ListGroupStudentLanguagesParameters> | undefined;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError> | QueryFiltersByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>, updater: Updater<NoInfer<ListGroupStudentLanguagesData> | undefined, NoInfer<ListGroupStudentLanguagesData> | undefined>, options?: SetDataOptions): Array<ListGroupStudentLanguagesData | undefined>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError> | QueryFiltersByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError> | QueryFiltersByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError> | QueryFiltersByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>): void;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError> | QueryFiltersByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Student Languages
         * @description One row per language with the group's derived-student count, zeros included.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError> | QueryFiltersByQueryKey<ListGroupStudentLanguagesSchema, ListGroupStudentLanguagesData, TInfinite, ListGroupStudentLanguagesParameters, ListGroupStudentLanguagesError>): number;
        schema: ListGroupStudentLanguagesSchema;
        types: {
            parameters: ListGroupStudentLanguagesParameters;
            data: ListGroupStudentLanguagesData;
            error: ListGroupStudentLanguagesError;
        };
    };
    /**
     * @summary Get Student Dashboard Stats
     * @description The four cards on the caller's own student dashboard. Self-only.
     */
    getStudentDashboardStats: {
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentDashboardStatsParameters, TMeta, TSignal> | void), client?: (schema: GetStudentDashboardStatsSchema, options: {
            parameters: GetStudentDashboardStatsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentDashboardStatsData, GetStudentDashboardStatsError>>): Promise<RequestFnResponse<GetStudentDashboardStatsData, GetStudentDashboardStatsError>>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentDashboardStatsParameters> | void): ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentDashboardStats.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentDashboardStats.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentDashboardStatsData>(parameters: ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetStudentDashboardStatsData, GetStudentDashboardStatsError, TData, ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentDashboardStats.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentDashboardStats.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentDashboardStatsData>(parameters: ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void), options: Omit<DefinedInitialDataOptions<GetStudentDashboardStatsData, GetStudentDashboardStatsError, TData, ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentDashboardStatsError>>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentDashboardStatsParameters> | void): ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentDashboardStats.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentDashboardStatsParameters, TQueryFnData = GetStudentDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetStudentDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentDashboardStats.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentDashboardStatsParameters, TQueryFnData = GetStudentDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetStudentDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentDashboardStatsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentDashboardStatsTotal = qraft.v3Service.getStudentDashboardStats.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentDashboardStatsByParametersTotal = qraft.v3Service.getStudentDashboardStats.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | QueryFiltersByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentDashboardStatsResults = qraft.v3Service.getStudentDashboardStats.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentDashboardStatsCombinedResults = qraft.v3Service.getStudentDashboardStats.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentDashboardStatsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters, GetStudentDashboardStatsData, GetStudentDashboardStatsError>>, TCombinedResult = Array<UseQueryResult<GetStudentDashboardStatsData, GetStudentDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentDashboardStatsData, GetStudentDashboardStatsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getStudentDashboardStats.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentDashboardStats.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentDashboardStatsData>(parameters: ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetStudentDashboardStatsData, GetStudentDashboardStatsError, TData, ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentDashboardStats.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentDashboardStatsParameters, TData = GetStudentDashboardStatsData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentDashboardStatsData, GetStudentDashboardStatsError, OperationInfiniteData<TData, GetStudentDashboardStatsParameters>, ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentDashboardStatsParameters>, OperationError<GetStudentDashboardStatsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentDashboardStatsData = qraft.v3Service.getStudentDashboardStats.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentDashboardStatsCombinedData = qraft.v3Service.getStudentDashboardStats.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentDashboardStatsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters, GetStudentDashboardStatsData, GetStudentDashboardStatsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentDashboardStatsData, GetStudentDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentDashboardStatsData, GetStudentDashboardStatsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | void): Promise<GetStudentDashboardStatsData>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | void): Promise<void>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | void): Promise<GetStudentDashboardStatsData>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, GetStudentDashboardStatsParameters, DeepReadonly<TPageParam>, GetStudentDashboardStatsError> | void): Promise<OperationInfiniteData<GetStudentDashboardStatsData, GetStudentDashboardStatsParameters>>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, GetStudentDashboardStatsParameters, DeepReadonly<TPageParam>, GetStudentDashboardStatsError> | void): Promise<void>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentDashboardStatsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, GetStudentDashboardStatsParameters, DeepReadonly<TPageParam>, GetStudentDashboardStatsError> | void): Promise<OperationInfiniteData<GetStudentDashboardStatsData, GetStudentDashboardStatsParameters>>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void)): GetStudentDashboardStatsData | undefined;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void)): OperationInfiniteData<GetStudentDashboardStatsData, GetStudentDashboardStatsParameters> | undefined;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | QueryFiltersByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentDashboardStatsData, GetStudentDashboardStatsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>,
            data: GetStudentDashboardStatsData | undefined
        ]>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | (DeepReadonly<GetStudentDashboardStatsParameters> | void)): QueryState<GetStudentDashboardStatsData, GetStudentDashboardStatsError> | undefined;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentDashboardStatsParameters> | ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters> | void): QueryState<OperationInfiniteData<GetStudentDashboardStatsData, GetStudentDashboardStatsParameters>, GetStudentDashboardStatsError> | undefined;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentDashboardStatsParameters> | undefined) | ServiceOperationQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>, updater: Updater<NoInfer<GetStudentDashboardStatsData> | undefined, NoInfer<DeepReadonly<GetStudentDashboardStatsData>> | undefined>, options?: SetDataOptions): GetStudentDashboardStatsData | undefined;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentDashboardStatsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentDashboardStatsData, GetStudentDashboardStatsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentDashboardStatsData, GetStudentDashboardStatsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentDashboardStatsData, GetStudentDashboardStatsParameters> | undefined;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | QueryFiltersByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>, updater: Updater<NoInfer<GetStudentDashboardStatsData> | undefined, NoInfer<GetStudentDashboardStatsData> | undefined>, options?: SetDataOptions): Array<GetStudentDashboardStatsData | undefined>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | QueryFiltersByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | QueryFiltersByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | QueryFiltersByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>): void;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | QueryFiltersByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Dashboard Stats
         * @description The four cards on the caller's own student dashboard. Self-only.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError> | QueryFiltersByQueryKey<GetStudentDashboardStatsSchema, GetStudentDashboardStatsData, TInfinite, GetStudentDashboardStatsParameters, GetStudentDashboardStatsError>): number;
        schema: GetStudentDashboardStatsSchema;
        types: {
            parameters: GetStudentDashboardStatsParameters;
            data: GetStudentDashboardStatsData;
            error: GetStudentDashboardStatsError;
        };
    };
    /**
     * @summary Get Student Dashboard Widgets
     * @description The caller's own dashboard: which widgets, in what order, and which hidden.
     *
     * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
     * profile's real dashboard rather than an error.
     */
    getStudentDashboardWidgets: {
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentDashboardWidgetsParameters, TMeta, TSignal> | void), client?: (schema: GetStudentDashboardWidgetsSchema, options: {
            parameters: GetStudentDashboardWidgetsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError>>): Promise<RequestFnResponse<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError>>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentDashboardWidgetsParameters> | void): ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentDashboardWidgets.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentDashboardWidgets.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError, TData, ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentDashboardWidgets.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentDashboardWidgets.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void), options: Omit<DefinedInitialDataOptions<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError, TData, ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentDashboardWidgetsError>>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentDashboardWidgetsParameters> | void): ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentDashboardWidgets.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentDashboardWidgetsParameters, TQueryFnData = GetStudentDashboardWidgetsData, TData = OperationInfiniteData<TQueryFnData, GetStudentDashboardWidgetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentDashboardWidgetsError, TData, ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentDashboardWidgets.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentDashboardWidgetsParameters, TQueryFnData = GetStudentDashboardWidgetsData, TData = OperationInfiniteData<TQueryFnData, GetStudentDashboardWidgetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentDashboardWidgetsError, TData, ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentDashboardWidgetsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentDashboardWidgetsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentDashboardWidgetsTotal = qraft.v3Service.getStudentDashboardWidgets.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentDashboardWidgetsByParametersTotal = qraft.v3Service.getStudentDashboardWidgets.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | QueryFiltersByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentDashboardWidgetsResults = qraft.v3Service.getStudentDashboardWidgets.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentDashboardWidgetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentDashboardWidgetsCombinedResults = qraft.v3Service.getStudentDashboardWidgets.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentDashboardWidgetsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError>>, TCombinedResult = Array<UseQueryResult<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getStudentDashboardWidgets.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentDashboardWidgets.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError, TData, ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentDashboardWidgets.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentDashboardWidgetsParameters, TData = GetStudentDashboardWidgetsData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError, OperationInfiniteData<TData, GetStudentDashboardWidgetsParameters>, ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentDashboardWidgetsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentDashboardWidgetsParameters>, OperationError<GetStudentDashboardWidgetsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentDashboardWidgetsData = qraft.v3Service.getStudentDashboardWidgets.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentDashboardWidgetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentDashboardWidgetsCombinedData = qraft.v3Service.getStudentDashboardWidgets.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentDashboardWidgetsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | void): Promise<GetStudentDashboardWidgetsData>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | void): Promise<void>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | void): Promise<GetStudentDashboardWidgetsData>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentDashboardWidgetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetStudentDashboardWidgetsError> | void): Promise<OperationInfiniteData<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters>>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentDashboardWidgetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetStudentDashboardWidgetsError> | void): Promise<void>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentDashboardWidgetsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetStudentDashboardWidgetsError> | void): Promise<OperationInfiniteData<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters>>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void)): GetStudentDashboardWidgetsData | undefined;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void)): OperationInfiniteData<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters> | undefined;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | QueryFiltersByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>,
            data: GetStudentDashboardWidgetsData | undefined
        ]>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | (DeepReadonly<GetStudentDashboardWidgetsParameters> | void)): QueryState<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsError> | undefined;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentDashboardWidgetsParameters> | ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters> | void): QueryState<OperationInfiniteData<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters>, GetStudentDashboardWidgetsError> | undefined;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentDashboardWidgetsParameters> | undefined) | ServiceOperationQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>, updater: Updater<NoInfer<GetStudentDashboardWidgetsData> | undefined, NoInfer<DeepReadonly<GetStudentDashboardWidgetsData>> | undefined>, options?: SetDataOptions): GetStudentDashboardWidgetsData | undefined;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentDashboardWidgetsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentDashboardWidgetsData, GetStudentDashboardWidgetsParameters> | undefined;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | QueryFiltersByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>, updater: Updater<NoInfer<GetStudentDashboardWidgetsData> | undefined, NoInfer<GetStudentDashboardWidgetsData> | undefined>, options?: SetDataOptions): Array<GetStudentDashboardWidgetsData | undefined>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | QueryFiltersByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | QueryFiltersByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | QueryFiltersByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>): void;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | QueryFiltersByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Dashboard Widgets
         * @description The caller's own dashboard: which widgets, in what order, and which hidden.
         *
         * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
         * profile's real dashboard rather than an error.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError> | QueryFiltersByQueryKey<GetStudentDashboardWidgetsSchema, GetStudentDashboardWidgetsData, TInfinite, GetStudentDashboardWidgetsParameters, GetStudentDashboardWidgetsError>): number;
        schema: GetStudentDashboardWidgetsSchema;
        types: {
            parameters: GetStudentDashboardWidgetsParameters;
            data: GetStudentDashboardWidgetsData;
            error: GetStudentDashboardWidgetsError;
        };
    };
    /**
     * @summary Set Student Hidden Widgets
     * @description Replace the caller's whole hidden set for their own dashboard.
     *
     * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
     */
    setStudentHiddenWidgets: {
        /**
         * @summary Set Student Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard.
         *
         * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsParameters, TMeta, TSignal>, client?: (schema: SetStudentHiddenWidgetsSchema, options: ServiceOperationMutationFnOptions<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsError>>): Promise<RequestFnResponse<SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsError>>;
        /**
         * @summary Set Student Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard.
         *
         * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
         */
        getMutationKey(parameters: DeepReadonly<SetStudentHiddenWidgetsParameters> | void): ServiceOperationMutationKey<SetStudentHiddenWidgetsSchema, SetStudentHiddenWidgetsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Student Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard.
         *
         * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentHiddenWidgets.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentHiddenWidgets.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetStudentHiddenWidgetsBody, TContext = unknown>(parameters: DeepReadonly<SetStudentHiddenWidgetsParameters>, options?: ServiceOperationUseMutationOptions<SetStudentHiddenWidgetsSchema, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, TVariables, OperationError<SetStudentHiddenWidgetsError>, TContext>): UseMutationResult<SetStudentHiddenWidgetsData, OperationError<SetStudentHiddenWidgetsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Student Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard.
         *
         * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentHiddenWidgets.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setStudentHiddenWidgets.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetStudentHiddenWidgetsSchema, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, TVariables, OperationError<SetStudentHiddenWidgetsError>, TContext>): UseMutationResult<SetStudentHiddenWidgetsData, OperationError<SetStudentHiddenWidgetsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set Student Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard.
         *
         * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setStudentHiddenWidgetsTotal = qraft.v3Service.setStudentHiddenWidgets.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setStudentHiddenWidgetsTotal = qraft.v3Service.setStudentHiddenWidgets.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetStudentHiddenWidgetsSchema, SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set Student Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard.
         *
         * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setStudentHiddenWidgetsPendingMutationVariables = qraft.v3Service.setStudentHiddenWidgets.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setStudentHiddenWidgetsMutationData = qraft.v3Service.setStudentHiddenWidgets.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetStudentHiddenWidgetsData, OperationError<SetStudentHiddenWidgetsError>, MutationVariables<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetStudentHiddenWidgetsSchema, SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext>;
            select?: (mutation: Mutation<SetStudentHiddenWidgetsData, OperationError<SetStudentHiddenWidgetsError>, MutationVariables<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set Student Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard.
         *
         * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetStudentHiddenWidgetsSchema, SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set Student Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard.
         *
         * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setStudentHiddenWidgets.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setStudentHiddenWidgets.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetStudentHiddenWidgetsSchema, SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext>): Mutation<SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsError, MutationVariables<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetStudentHiddenWidgetsSchema, SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsParameters, OperationError<SetStudentHiddenWidgetsError>, TContext>): Array<Mutation<SetStudentHiddenWidgetsData, SetStudentHiddenWidgetsError, MutationVariables<SetStudentHiddenWidgetsBody, SetStudentHiddenWidgetsParameters>, TContext>>;
        };
        schema: SetStudentHiddenWidgetsSchema;
        types: {
            parameters: SetStudentHiddenWidgetsParameters;
            data: SetStudentHiddenWidgetsData;
            error: SetStudentHiddenWidgetsError;
            body: SetStudentHiddenWidgetsBody;
        };
    };
    /**
     * @summary Get Group Dashboard Widgets
     * @description One study group's dashboard layout. Group leaders only.
     */
    getGroupDashboardWidgets: {
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupDashboardWidgetsParameters, TMeta, TSignal>), client?: (schema: GetGroupDashboardWidgetsSchema, options: {
            parameters: GetGroupDashboardWidgetsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError>>): Promise<RequestFnResponse<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError>>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        getQueryKey(parameters: DeepReadonly<GetGroupDashboardWidgetsParameters>): ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupDashboardWidgets.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError, TData, ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupDashboardWidgets.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>), options: Omit<DefinedInitialDataOptions<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError, TData, ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupDashboardWidgetsError>>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupDashboardWidgetsParameters>): ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupDashboardWidgets.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupDashboardWidgetsParameters, TQueryFnData = GetGroupDashboardWidgetsData, TData = OperationInfiniteData<TQueryFnData, GetGroupDashboardWidgetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupDashboardWidgetsError, TData, ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupDashboardWidgets.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupDashboardWidgetsParameters, TQueryFnData = GetGroupDashboardWidgetsData, TData = OperationInfiniteData<TQueryFnData, GetGroupDashboardWidgetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupDashboardWidgetsError, TData, ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupDashboardWidgetsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupDashboardWidgetsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupDashboardWidgetsTotal = qraft.v3Service.getGroupDashboardWidgets.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupDashboardWidgetsByParametersTotal = qraft.v3Service.getGroupDashboardWidgets.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError> | QueryFiltersByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupDashboardWidgetsResults = qraft.v3Service.getGroupDashboardWidgets.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupDashboardWidgetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupDashboardWidgetsCombinedResults = qraft.v3Service.getGroupDashboardWidgets.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupDashboardWidgetsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError>>, TCombinedResult = Array<UseQueryResult<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupDashboardWidgets.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError, TData, ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupDashboardWidgets.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupDashboardWidgetsParameters, TData = GetGroupDashboardWidgetsData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError, OperationInfiniteData<TData, GetGroupDashboardWidgetsParameters>, ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupDashboardWidgetsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupDashboardWidgetsParameters>, OperationError<GetGroupDashboardWidgetsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupDashboardWidgetsData = qraft.v3Service.getGroupDashboardWidgets.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupDashboardWidgetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupDashboardWidgetsCombinedData = qraft.v3Service.getGroupDashboardWidgets.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupDashboardWidgetsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>): Promise<GetGroupDashboardWidgetsData>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>): Promise<void>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>): Promise<GetGroupDashboardWidgetsData>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        fetchInfiniteQuery<TPageParam extends GetGroupDashboardWidgetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetGroupDashboardWidgetsError>): Promise<OperationInfiniteData<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters>>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        prefetchInfiniteQuery<TPageParam extends GetGroupDashboardWidgetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetGroupDashboardWidgetsError>): Promise<void>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        ensureInfiniteQueryData<TPageParam extends GetGroupDashboardWidgetsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetGroupDashboardWidgetsError>): Promise<OperationInfiniteData<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters>>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>)): GetGroupDashboardWidgetsData | undefined;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>)): OperationInfiniteData<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters> | undefined;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError> | QueryFiltersByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>,
            data: GetGroupDashboardWidgetsData | undefined
        ]>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters> | (DeepReadonly<GetGroupDashboardWidgetsParameters>)): QueryState<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsError> | undefined;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupDashboardWidgetsParameters> | ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>): QueryState<OperationInfiniteData<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters>, GetGroupDashboardWidgetsError> | undefined;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        setQueryData(parameters: (DeepReadonly<GetGroupDashboardWidgetsParameters>) | ServiceOperationQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>, updater: Updater<NoInfer<GetGroupDashboardWidgetsData> | undefined, NoInfer<DeepReadonly<GetGroupDashboardWidgetsData>> | undefined>, options?: SetDataOptions): GetGroupDashboardWidgetsData | undefined;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupDashboardWidgetsParameters>) | ServiceOperationInfiniteQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupDashboardWidgetsData, GetGroupDashboardWidgetsParameters> | undefined;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError> | QueryFiltersByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>, updater: Updater<NoInfer<GetGroupDashboardWidgetsData> | undefined, NoInfer<GetGroupDashboardWidgetsData> | undefined>, options?: SetDataOptions): Array<GetGroupDashboardWidgetsData | undefined>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError> | QueryFiltersByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError> | QueryFiltersByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError> | QueryFiltersByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>): void;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError> | QueryFiltersByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Group Dashboard Widgets
         * @description One study group's dashboard layout. Group leaders only.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError> | QueryFiltersByQueryKey<GetGroupDashboardWidgetsSchema, GetGroupDashboardWidgetsData, TInfinite, GetGroupDashboardWidgetsParameters, GetGroupDashboardWidgetsError>): number;
        schema: GetGroupDashboardWidgetsSchema;
        types: {
            parameters: GetGroupDashboardWidgetsParameters;
            data: GetGroupDashboardWidgetsData;
            error: GetGroupDashboardWidgetsError;
        };
    };
    /**
     * @summary Set Group Hidden Widgets
     * @description Replace the group's whole hidden set. Group leaders only.
     */
    setGroupHiddenWidgets: {
        /**
         * @summary Set Group Hidden Widgets
         * @description Replace the group's whole hidden set. Group leaders only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsParameters, TMeta, TSignal>, client?: (schema: SetGroupHiddenWidgetsSchema, options: ServiceOperationMutationFnOptions<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsError>>): Promise<RequestFnResponse<SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsError>>;
        /**
         * @summary Set Group Hidden Widgets
         * @description Replace the group's whole hidden set. Group leaders only.
         */
        getMutationKey(parameters: DeepReadonly<SetGroupHiddenWidgetsParameters> | void): ServiceOperationMutationKey<SetGroupHiddenWidgetsSchema, SetGroupHiddenWidgetsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Group Hidden Widgets
         * @description Replace the group's whole hidden set. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setGroupHiddenWidgets.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setGroupHiddenWidgets.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetGroupHiddenWidgetsBody, TContext = unknown>(parameters: DeepReadonly<SetGroupHiddenWidgetsParameters>, options?: ServiceOperationUseMutationOptions<SetGroupHiddenWidgetsSchema, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, TVariables, OperationError<SetGroupHiddenWidgetsError>, TContext>): UseMutationResult<SetGroupHiddenWidgetsData, OperationError<SetGroupHiddenWidgetsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Group Hidden Widgets
         * @description Replace the group's whole hidden set. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setGroupHiddenWidgets.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setGroupHiddenWidgets.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetGroupHiddenWidgetsSchema, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, TVariables, OperationError<SetGroupHiddenWidgetsError>, TContext>): UseMutationResult<SetGroupHiddenWidgetsData, OperationError<SetGroupHiddenWidgetsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set Group Hidden Widgets
         * @description Replace the group's whole hidden set. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setGroupHiddenWidgetsTotal = qraft.v3Service.setGroupHiddenWidgets.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setGroupHiddenWidgetsTotal = qraft.v3Service.setGroupHiddenWidgets.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetGroupHiddenWidgetsSchema, SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set Group Hidden Widgets
         * @description Replace the group's whole hidden set. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setGroupHiddenWidgetsPendingMutationVariables = qraft.v3Service.setGroupHiddenWidgets.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setGroupHiddenWidgetsMutationData = qraft.v3Service.setGroupHiddenWidgets.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetGroupHiddenWidgetsData, OperationError<SetGroupHiddenWidgetsError>, MutationVariables<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetGroupHiddenWidgetsSchema, SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext>;
            select?: (mutation: Mutation<SetGroupHiddenWidgetsData, OperationError<SetGroupHiddenWidgetsError>, MutationVariables<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set Group Hidden Widgets
         * @description Replace the group's whole hidden set. Group leaders only.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetGroupHiddenWidgetsSchema, SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set Group Hidden Widgets
         * @description Replace the group's whole hidden set. Group leaders only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setGroupHiddenWidgets.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setGroupHiddenWidgets.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetGroupHiddenWidgetsSchema, SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext>): Mutation<SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsError, MutationVariables<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetGroupHiddenWidgetsSchema, SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsParameters, OperationError<SetGroupHiddenWidgetsError>, TContext>): Array<Mutation<SetGroupHiddenWidgetsData, SetGroupHiddenWidgetsError, MutationVariables<SetGroupHiddenWidgetsBody, SetGroupHiddenWidgetsParameters>, TContext>>;
        };
        schema: SetGroupHiddenWidgetsSchema;
        types: {
            parameters: SetGroupHiddenWidgetsParameters;
            data: SetGroupHiddenWidgetsData;
            error: SetGroupHiddenWidgetsError;
            body: SetGroupHiddenWidgetsBody;
        };
    };
    /**
     * @summary Get Congregation Dashboard Widgets
     * @description One congregation's or custom study group's dashboard layout. Admins only.
     */
    getCongregationDashboardWidgets: {
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetCongregationDashboardWidgetsParameters, TMeta, TSignal>), client?: (schema: GetCongregationDashboardWidgetsSchema, options: {
            parameters: GetCongregationDashboardWidgetsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError>>): Promise<RequestFnResponse<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError>>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        getQueryKey(parameters: DeepReadonly<GetCongregationDashboardWidgetsParameters>): ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCongregationDashboardWidgets.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCongregationDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>), options?: Omit<UndefinedInitialDataOptions<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError, TData, ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetCongregationDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCongregationDashboardWidgets.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCongregationDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>), options: Omit<DefinedInitialDataOptions<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError, TData, ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetCongregationDashboardWidgetsError>>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetCongregationDashboardWidgetsParameters>): ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCongregationDashboardWidgets.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCongregationDashboardWidgetsParameters, TQueryFnData = GetCongregationDashboardWidgetsData, TData = OperationInfiniteData<TQueryFnData, GetCongregationDashboardWidgetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetCongregationDashboardWidgetsError, TData, ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetCongregationDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCongregationDashboardWidgets.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCongregationDashboardWidgetsParameters, TQueryFnData = GetCongregationDashboardWidgetsData, TData = OperationInfiniteData<TQueryFnData, GetCongregationDashboardWidgetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetCongregationDashboardWidgetsError, TData, ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCongregationDashboardWidgetsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetCongregationDashboardWidgetsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getCongregationDashboardWidgetsTotal = qraft.v3Service.getCongregationDashboardWidgets.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getCongregationDashboardWidgetsByParametersTotal = qraft.v3Service.getCongregationDashboardWidgets.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError> | QueryFiltersByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getCongregationDashboardWidgetsResults = qraft.v3Service.getCongregationDashboardWidgets.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCongregationDashboardWidgetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getCongregationDashboardWidgetsCombinedResults = qraft.v3Service.getCongregationDashboardWidgets.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCongregationDashboardWidgetsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError>>, TCombinedResult = Array<UseQueryResult<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getCongregationDashboardWidgets.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetCongregationDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>), options?: Omit<UseSuspenseQueryOptions<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError, TData, ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetCongregationDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCongregationDashboardWidgets.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetCongregationDashboardWidgetsParameters, TData = GetCongregationDashboardWidgetsData>(parameters: ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError, OperationInfiniteData<TData, GetCongregationDashboardWidgetsParameters>, ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCongregationDashboardWidgetsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetCongregationDashboardWidgetsParameters>, OperationError<GetCongregationDashboardWidgetsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getCongregationDashboardWidgetsData = qraft.v3Service.getCongregationDashboardWidgets.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCongregationDashboardWidgetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getCongregationDashboardWidgetsCombinedData = qraft.v3Service.getCongregationDashboardWidgets.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCongregationDashboardWidgetsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>): Promise<GetCongregationDashboardWidgetsData>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>): Promise<GetCongregationDashboardWidgetsData>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        fetchInfiniteQuery<TPageParam extends GetCongregationDashboardWidgetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetCongregationDashboardWidgetsError>): Promise<OperationInfiniteData<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters>>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        prefetchInfiniteQuery<TPageParam extends GetCongregationDashboardWidgetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetCongregationDashboardWidgetsError>): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        ensureInfiniteQueryData<TPageParam extends GetCongregationDashboardWidgetsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetCongregationDashboardWidgetsError>): Promise<OperationInfiniteData<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters>>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>)): GetCongregationDashboardWidgetsData | undefined;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>)): OperationInfiniteData<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters> | undefined;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError> | QueryFiltersByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>,
            data: NoInfer<OperationInfiniteData<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>,
            data: GetCongregationDashboardWidgetsData | undefined
        ]>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters> | (DeepReadonly<GetCongregationDashboardWidgetsParameters>)): QueryState<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsError> | undefined;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetCongregationDashboardWidgetsParameters> | ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>): QueryState<OperationInfiniteData<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters>, GetCongregationDashboardWidgetsError> | undefined;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        setQueryData(parameters: (DeepReadonly<GetCongregationDashboardWidgetsParameters>) | ServiceOperationQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>, updater: Updater<NoInfer<GetCongregationDashboardWidgetsData> | undefined, NoInfer<DeepReadonly<GetCongregationDashboardWidgetsData>> | undefined>, options?: SetDataOptions): GetCongregationDashboardWidgetsData | undefined;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetCongregationDashboardWidgetsParameters>) | ServiceOperationInfiniteQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetCongregationDashboardWidgetsData, GetCongregationDashboardWidgetsParameters> | undefined;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError> | QueryFiltersByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>, updater: Updater<NoInfer<GetCongregationDashboardWidgetsData> | undefined, NoInfer<GetCongregationDashboardWidgetsData> | undefined>, options?: SetDataOptions): Array<GetCongregationDashboardWidgetsData | undefined>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError> | QueryFiltersByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError> | QueryFiltersByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError> | QueryFiltersByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>): void;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError> | QueryFiltersByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Congregation Dashboard Widgets
         * @description One congregation's or custom study group's dashboard layout. Admins only.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError> | QueryFiltersByQueryKey<GetCongregationDashboardWidgetsSchema, GetCongregationDashboardWidgetsData, TInfinite, GetCongregationDashboardWidgetsParameters, GetCongregationDashboardWidgetsError>): number;
        schema: GetCongregationDashboardWidgetsSchema;
        types: {
            parameters: GetCongregationDashboardWidgetsParameters;
            data: GetCongregationDashboardWidgetsData;
            error: GetCongregationDashboardWidgetsError;
        };
    };
    /**
     * @summary Set Congregation Hidden Widgets
     * @description Replace the group's whole hidden set. Admins only.
     */
    setCongregationHiddenWidgets: {
        /**
         * @summary Set Congregation Hidden Widgets
         * @description Replace the group's whole hidden set. Admins only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsParameters, TMeta, TSignal>, client?: (schema: SetCongregationHiddenWidgetsSchema, options: ServiceOperationMutationFnOptions<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsError>>): Promise<RequestFnResponse<SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsError>>;
        /**
         * @summary Set Congregation Hidden Widgets
         * @description Replace the group's whole hidden set. Admins only.
         */
        getMutationKey(parameters: DeepReadonly<SetCongregationHiddenWidgetsParameters> | void): ServiceOperationMutationKey<SetCongregationHiddenWidgetsSchema, SetCongregationHiddenWidgetsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Congregation Hidden Widgets
         * @description Replace the group's whole hidden set. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setCongregationHiddenWidgets.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setCongregationHiddenWidgets.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetCongregationHiddenWidgetsBody, TContext = unknown>(parameters: DeepReadonly<SetCongregationHiddenWidgetsParameters>, options?: ServiceOperationUseMutationOptions<SetCongregationHiddenWidgetsSchema, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, TVariables, OperationError<SetCongregationHiddenWidgetsError>, TContext>): UseMutationResult<SetCongregationHiddenWidgetsData, OperationError<SetCongregationHiddenWidgetsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Congregation Hidden Widgets
         * @description Replace the group's whole hidden set. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setCongregationHiddenWidgets.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setCongregationHiddenWidgets.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetCongregationHiddenWidgetsSchema, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, TVariables, OperationError<SetCongregationHiddenWidgetsError>, TContext>): UseMutationResult<SetCongregationHiddenWidgetsData, OperationError<SetCongregationHiddenWidgetsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set Congregation Hidden Widgets
         * @description Replace the group's whole hidden set. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setCongregationHiddenWidgetsTotal = qraft.v3Service.setCongregationHiddenWidgets.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setCongregationHiddenWidgetsTotal = qraft.v3Service.setCongregationHiddenWidgets.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetCongregationHiddenWidgetsSchema, SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set Congregation Hidden Widgets
         * @description Replace the group's whole hidden set. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setCongregationHiddenWidgetsPendingMutationVariables = qraft.v3Service.setCongregationHiddenWidgets.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setCongregationHiddenWidgetsMutationData = qraft.v3Service.setCongregationHiddenWidgets.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetCongregationHiddenWidgetsData, OperationError<SetCongregationHiddenWidgetsError>, MutationVariables<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetCongregationHiddenWidgetsSchema, SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext>;
            select?: (mutation: Mutation<SetCongregationHiddenWidgetsData, OperationError<SetCongregationHiddenWidgetsError>, MutationVariables<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set Congregation Hidden Widgets
         * @description Replace the group's whole hidden set. Admins only.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetCongregationHiddenWidgetsSchema, SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set Congregation Hidden Widgets
         * @description Replace the group's whole hidden set. Admins only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setCongregationHiddenWidgets.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setCongregationHiddenWidgets.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetCongregationHiddenWidgetsSchema, SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext>): Mutation<SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsError, MutationVariables<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetCongregationHiddenWidgetsSchema, SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsParameters, OperationError<SetCongregationHiddenWidgetsError>, TContext>): Array<Mutation<SetCongregationHiddenWidgetsData, SetCongregationHiddenWidgetsError, MutationVariables<SetCongregationHiddenWidgetsBody, SetCongregationHiddenWidgetsParameters>, TContext>>;
        };
        schema: SetCongregationHiddenWidgetsSchema;
        types: {
            parameters: SetCongregationHiddenWidgetsParameters;
            data: SetCongregationHiddenWidgetsData;
            error: SetCongregationHiddenWidgetsError;
            body: SetCongregationHiddenWidgetsBody;
        };
    };
    /**
     * @summary Get Coordinator Dashboard Stats
     * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
     *
     * Self-only. Zero is a common, valid answer, so the client must not treat a refused
     * request as 0.
     */
    getCoordinatorDashboardStats: {
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetCoordinatorDashboardStatsParameters, TMeta, TSignal> | void), client?: (schema: GetCoordinatorDashboardStatsSchema, options: {
            parameters: GetCoordinatorDashboardStatsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError>>): Promise<RequestFnResponse<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError>>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        getQueryKey(parameters: DeepReadonly<GetCoordinatorDashboardStatsParameters> | void): ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCoordinatorDashboardStats.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCoordinatorDashboardStats.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCoordinatorDashboardStatsData>(parameters: ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError, TData, ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetCoordinatorDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCoordinatorDashboardStats.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCoordinatorDashboardStats.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCoordinatorDashboardStatsData>(parameters: ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void), options: Omit<DefinedInitialDataOptions<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError, TData, ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetCoordinatorDashboardStatsError>>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetCoordinatorDashboardStatsParameters> | void): ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCoordinatorDashboardStats.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCoordinatorDashboardStatsParameters, TQueryFnData = GetCoordinatorDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetCoordinatorDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetCoordinatorDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetCoordinatorDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCoordinatorDashboardStats.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCoordinatorDashboardStatsParameters, TQueryFnData = GetCoordinatorDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetCoordinatorDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetCoordinatorDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCoordinatorDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetCoordinatorDashboardStatsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getCoordinatorDashboardStatsTotal = qraft.v3Service.getCoordinatorDashboardStats.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getCoordinatorDashboardStatsByParametersTotal = qraft.v3Service.getCoordinatorDashboardStats.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | QueryFiltersByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getCoordinatorDashboardStatsResults = qraft.v3Service.getCoordinatorDashboardStats.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCoordinatorDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getCoordinatorDashboardStatsCombinedResults = qraft.v3Service.getCoordinatorDashboardStats.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCoordinatorDashboardStatsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError>>, TCombinedResult = Array<UseQueryResult<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getCoordinatorDashboardStats.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getCoordinatorDashboardStats.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetCoordinatorDashboardStatsData>(parameters: ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError, TData, ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetCoordinatorDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCoordinatorDashboardStats.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetCoordinatorDashboardStatsParameters, TData = GetCoordinatorDashboardStatsData>(parameters: ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError, OperationInfiniteData<TData, GetCoordinatorDashboardStatsParameters>, ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCoordinatorDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetCoordinatorDashboardStatsParameters>, OperationError<GetCoordinatorDashboardStatsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getCoordinatorDashboardStatsData = qraft.v3Service.getCoordinatorDashboardStats.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCoordinatorDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getCoordinatorDashboardStatsCombinedData = qraft.v3Service.getCoordinatorDashboardStats.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCoordinatorDashboardStatsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | void): Promise<GetCoordinatorDashboardStatsData>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | void): Promise<void>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | void): Promise<GetCoordinatorDashboardStatsData>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        fetchInfiniteQuery<TPageParam extends GetCoordinatorDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters, DeepReadonly<TPageParam>, GetCoordinatorDashboardStatsError> | void): Promise<OperationInfiniteData<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters>>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        prefetchInfiniteQuery<TPageParam extends GetCoordinatorDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters, DeepReadonly<TPageParam>, GetCoordinatorDashboardStatsError> | void): Promise<void>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        ensureInfiniteQueryData<TPageParam extends GetCoordinatorDashboardStatsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters, DeepReadonly<TPageParam>, GetCoordinatorDashboardStatsError> | void): Promise<OperationInfiniteData<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters>>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void)): GetCoordinatorDashboardStatsData | undefined;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void)): OperationInfiniteData<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters> | undefined;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | QueryFiltersByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>,
            data: NoInfer<OperationInfiniteData<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>,
            data: GetCoordinatorDashboardStatsData | undefined
        ]>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | (DeepReadonly<GetCoordinatorDashboardStatsParameters> | void)): QueryState<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsError> | undefined;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetCoordinatorDashboardStatsParameters> | ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters> | void): QueryState<OperationInfiniteData<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters>, GetCoordinatorDashboardStatsError> | undefined;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        setQueryData(parameters: (DeepReadonly<GetCoordinatorDashboardStatsParameters> | undefined) | ServiceOperationQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>, updater: Updater<NoInfer<GetCoordinatorDashboardStatsData> | undefined, NoInfer<DeepReadonly<GetCoordinatorDashboardStatsData>> | undefined>, options?: SetDataOptions): GetCoordinatorDashboardStatsData | undefined;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetCoordinatorDashboardStatsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetCoordinatorDashboardStatsData, GetCoordinatorDashboardStatsParameters> | undefined;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | QueryFiltersByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>, updater: Updater<NoInfer<GetCoordinatorDashboardStatsData> | undefined, NoInfer<GetCoordinatorDashboardStatsData> | undefined>, options?: SetDataOptions): Array<GetCoordinatorDashboardStatsData | undefined>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | QueryFiltersByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | QueryFiltersByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | QueryFiltersByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>): void;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | QueryFiltersByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Coordinator Dashboard Stats
         * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
         *
         * Self-only. Zero is a common, valid answer, so the client must not treat a refused
         * request as 0.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError> | QueryFiltersByQueryKey<GetCoordinatorDashboardStatsSchema, GetCoordinatorDashboardStatsData, TInfinite, GetCoordinatorDashboardStatsParameters, GetCoordinatorDashboardStatsError>): number;
        schema: GetCoordinatorDashboardStatsSchema;
        types: {
            parameters: GetCoordinatorDashboardStatsParameters;
            data: GetCoordinatorDashboardStatsData;
            error: GetCoordinatorDashboardStatsError;
        };
    };
    /**
     * @summary Get Partner Dashboard Stats
     * @description The caller's own follow-up partner stat bar: two counts and a composite.
     * Self-only.
     */
    getPartnerDashboardStats: {
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetPartnerDashboardStatsParameters, TMeta, TSignal> | void), client?: (schema: GetPartnerDashboardStatsSchema, options: {
            parameters: GetPartnerDashboardStatsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError>>): Promise<RequestFnResponse<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError>>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        getQueryKey(parameters: DeepReadonly<GetPartnerDashboardStatsParameters> | void): ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPartnerDashboardStats.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPartnerDashboardStats.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetPartnerDashboardStatsData>(parameters: ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError, TData, ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetPartnerDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPartnerDashboardStats.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPartnerDashboardStats.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetPartnerDashboardStatsData>(parameters: ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void), options: Omit<DefinedInitialDataOptions<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError, TData, ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetPartnerDashboardStatsError>>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetPartnerDashboardStatsParameters> | void): ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPartnerDashboardStats.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetPartnerDashboardStatsParameters, TQueryFnData = GetPartnerDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetPartnerDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetPartnerDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetPartnerDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPartnerDashboardStats.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetPartnerDashboardStatsParameters, TQueryFnData = GetPartnerDashboardStatsData, TData = OperationInfiniteData<TQueryFnData, GetPartnerDashboardStatsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetPartnerDashboardStatsError, TData, ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetPartnerDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetPartnerDashboardStatsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getPartnerDashboardStatsTotal = qraft.v3Service.getPartnerDashboardStats.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getPartnerDashboardStatsByParametersTotal = qraft.v3Service.getPartnerDashboardStats.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | QueryFiltersByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getPartnerDashboardStatsResults = qraft.v3Service.getPartnerDashboardStats.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPartnerDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getPartnerDashboardStatsCombinedResults = qraft.v3Service.getPartnerDashboardStats.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPartnerDashboardStatsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsData, GetPartnerDashboardStatsError>>, TCombinedResult = Array<UseQueryResult<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getPartnerDashboardStats.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getPartnerDashboardStats.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetPartnerDashboardStatsData>(parameters: ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError, TData, ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetPartnerDashboardStatsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPartnerDashboardStats.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetPartnerDashboardStatsParameters, TData = GetPartnerDashboardStatsData>(parameters: ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError, OperationInfiniteData<TData, GetPartnerDashboardStatsParameters>, ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetPartnerDashboardStatsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetPartnerDashboardStatsParameters>, OperationError<GetPartnerDashboardStatsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getPartnerDashboardStatsData = qraft.v3Service.getPartnerDashboardStats.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPartnerDashboardStatsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getPartnerDashboardStatsCombinedData = qraft.v3Service.getPartnerDashboardStats.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPartnerDashboardStatsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsData, GetPartnerDashboardStatsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | void): Promise<GetPartnerDashboardStatsData>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | void): Promise<void>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | void): Promise<GetPartnerDashboardStatsData>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        fetchInfiniteQuery<TPageParam extends GetPartnerDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters, DeepReadonly<TPageParam>, GetPartnerDashboardStatsError> | void): Promise<OperationInfiniteData<GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters>>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        prefetchInfiniteQuery<TPageParam extends GetPartnerDashboardStatsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters, DeepReadonly<TPageParam>, GetPartnerDashboardStatsError> | void): Promise<void>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        ensureInfiniteQueryData<TPageParam extends GetPartnerDashboardStatsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters, DeepReadonly<TPageParam>, GetPartnerDashboardStatsError> | void): Promise<OperationInfiniteData<GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters>>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void)): GetPartnerDashboardStatsData | undefined;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void)): OperationInfiniteData<GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters> | undefined;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | QueryFiltersByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>,
            data: NoInfer<OperationInfiniteData<GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>,
            data: GetPartnerDashboardStatsData | undefined
        ]>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | (DeepReadonly<GetPartnerDashboardStatsParameters> | void)): QueryState<GetPartnerDashboardStatsData, GetPartnerDashboardStatsError> | undefined;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetPartnerDashboardStatsParameters> | ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters> | void): QueryState<OperationInfiniteData<GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters>, GetPartnerDashboardStatsError> | undefined;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        setQueryData(parameters: (DeepReadonly<GetPartnerDashboardStatsParameters> | undefined) | ServiceOperationQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>, updater: Updater<NoInfer<GetPartnerDashboardStatsData> | undefined, NoInfer<DeepReadonly<GetPartnerDashboardStatsData>> | undefined>, options?: SetDataOptions): GetPartnerDashboardStatsData | undefined;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetPartnerDashboardStatsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetPartnerDashboardStatsData, GetPartnerDashboardStatsParameters> | undefined;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | QueryFiltersByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>, updater: Updater<NoInfer<GetPartnerDashboardStatsData> | undefined, NoInfer<GetPartnerDashboardStatsData> | undefined>, options?: SetDataOptions): Array<GetPartnerDashboardStatsData | undefined>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | QueryFiltersByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | QueryFiltersByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | QueryFiltersByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>): void;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | QueryFiltersByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Partner Dashboard Stats
         * @description The caller's own follow-up partner stat bar: two counts and a composite.
         * Self-only.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError> | QueryFiltersByQueryKey<GetPartnerDashboardStatsSchema, GetPartnerDashboardStatsData, TInfinite, GetPartnerDashboardStatsParameters, GetPartnerDashboardStatsError>): number;
        schema: GetPartnerDashboardStatsSchema;
        types: {
            parameters: GetPartnerDashboardStatsParameters;
            data: GetPartnerDashboardStatsData;
            error: GetPartnerDashboardStatsError;
        };
    };
    /**
     * @summary Get Follow Up Dashboard Widgets
     * @description The caller's own coordinator or partner dashboard layout. Self-only.
     */
    getFollowUpDashboardWidgets: {
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetFollowUpDashboardWidgetsParameters, TMeta, TSignal> | void), client?: (schema: GetFollowUpDashboardWidgetsSchema, options: {
            parameters: GetFollowUpDashboardWidgetsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError>>): Promise<RequestFnResponse<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError>>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        getQueryKey(parameters: DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void): ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpDashboardWidgets.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpDashboardWidgets.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError, TData, ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetFollowUpDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpDashboardWidgets.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpDashboardWidgets.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void), options: Omit<DefinedInitialDataOptions<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError, TData, ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetFollowUpDashboardWidgetsError>>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void): ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpDashboardWidgets.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpDashboardWidgetsParameters, TQueryFnData = GetFollowUpDashboardWidgetsData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpDashboardWidgetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpDashboardWidgetsError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetFollowUpDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpDashboardWidgets.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpDashboardWidgetsParameters, TQueryFnData = GetFollowUpDashboardWidgetsData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpDashboardWidgetsParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpDashboardWidgetsError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpDashboardWidgetsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetFollowUpDashboardWidgetsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getFollowUpDashboardWidgetsTotal = qraft.v3Service.getFollowUpDashboardWidgets.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getFollowUpDashboardWidgetsByParametersTotal = qraft.v3Service.getFollowUpDashboardWidgets.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | QueryFiltersByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getFollowUpDashboardWidgetsResults = qraft.v3Service.getFollowUpDashboardWidgets.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpDashboardWidgetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getFollowUpDashboardWidgetsCombinedResults = qraft.v3Service.getFollowUpDashboardWidgets.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpDashboardWidgetsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError>>, TCombinedResult = Array<UseQueryResult<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getFollowUpDashboardWidgets.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getFollowUpDashboardWidgets.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetFollowUpDashboardWidgetsData>(parameters: ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError, TData, ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetFollowUpDashboardWidgetsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpDashboardWidgets.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetFollowUpDashboardWidgetsParameters, TData = GetFollowUpDashboardWidgetsData>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError, OperationInfiniteData<TData, GetFollowUpDashboardWidgetsParameters>, ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpDashboardWidgetsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetFollowUpDashboardWidgetsParameters>, OperationError<GetFollowUpDashboardWidgetsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getFollowUpDashboardWidgetsData = qraft.v3Service.getFollowUpDashboardWidgets.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpDashboardWidgetsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getFollowUpDashboardWidgetsCombinedData = qraft.v3Service.getFollowUpDashboardWidgets.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpDashboardWidgetsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | void): Promise<GetFollowUpDashboardWidgetsData>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | void): Promise<void>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | void): Promise<GetFollowUpDashboardWidgetsData>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        fetchInfiniteQuery<TPageParam extends GetFollowUpDashboardWidgetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetFollowUpDashboardWidgetsError> | void): Promise<OperationInfiniteData<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters>>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        prefetchInfiniteQuery<TPageParam extends GetFollowUpDashboardWidgetsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetFollowUpDashboardWidgetsError> | void): Promise<void>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        ensureInfiniteQueryData<TPageParam extends GetFollowUpDashboardWidgetsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters, DeepReadonly<TPageParam>, GetFollowUpDashboardWidgetsError> | void): Promise<OperationInfiniteData<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters>>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void)): GetFollowUpDashboardWidgetsData | undefined;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void)): OperationInfiniteData<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters> | undefined;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | QueryFiltersByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>,
            data: NoInfer<OperationInfiniteData<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>,
            data: GetFollowUpDashboardWidgetsData | undefined
        ]>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | void)): QueryState<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsError> | undefined;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetFollowUpDashboardWidgetsParameters> | ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters> | void): QueryState<OperationInfiniteData<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters>, GetFollowUpDashboardWidgetsError> | undefined;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        setQueryData(parameters: (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | undefined) | ServiceOperationQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>, updater: Updater<NoInfer<GetFollowUpDashboardWidgetsData> | undefined, NoInfer<DeepReadonly<GetFollowUpDashboardWidgetsData>> | undefined>, options?: SetDataOptions): GetFollowUpDashboardWidgetsData | undefined;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetFollowUpDashboardWidgetsParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetFollowUpDashboardWidgetsData, GetFollowUpDashboardWidgetsParameters> | undefined;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | QueryFiltersByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>, updater: Updater<NoInfer<GetFollowUpDashboardWidgetsData> | undefined, NoInfer<GetFollowUpDashboardWidgetsData> | undefined>, options?: SetDataOptions): Array<GetFollowUpDashboardWidgetsData | undefined>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | QueryFiltersByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | QueryFiltersByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | QueryFiltersByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>): void;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | QueryFiltersByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Follow Up Dashboard Widgets
         * @description The caller's own coordinator or partner dashboard layout. Self-only.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError> | QueryFiltersByQueryKey<GetFollowUpDashboardWidgetsSchema, GetFollowUpDashboardWidgetsData, TInfinite, GetFollowUpDashboardWidgetsParameters, GetFollowUpDashboardWidgetsError>): number;
        schema: GetFollowUpDashboardWidgetsSchema;
        types: {
            parameters: GetFollowUpDashboardWidgetsParameters;
            data: GetFollowUpDashboardWidgetsData;
            error: GetFollowUpDashboardWidgetsError;
        };
    };
    /**
     * @summary Set Follow Up Hidden Widgets
     * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
     */
    setFollowUpHiddenWidgets: {
        /**
         * @summary Set Follow Up Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsParameters, TMeta, TSignal>, client?: (schema: SetFollowUpHiddenWidgetsSchema, options: ServiceOperationMutationFnOptions<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsError>>): Promise<RequestFnResponse<SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsError>>;
        /**
         * @summary Set Follow Up Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
         */
        getMutationKey(parameters: DeepReadonly<SetFollowUpHiddenWidgetsParameters> | void): ServiceOperationMutationKey<SetFollowUpHiddenWidgetsSchema, SetFollowUpHiddenWidgetsParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Follow Up Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setFollowUpHiddenWidgets.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setFollowUpHiddenWidgets.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetFollowUpHiddenWidgetsBody, TContext = unknown>(parameters: DeepReadonly<SetFollowUpHiddenWidgetsParameters>, options?: ServiceOperationUseMutationOptions<SetFollowUpHiddenWidgetsSchema, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, TVariables, OperationError<SetFollowUpHiddenWidgetsError>, TContext>): UseMutationResult<SetFollowUpHiddenWidgetsData, OperationError<SetFollowUpHiddenWidgetsError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Follow Up Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setFollowUpHiddenWidgets.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setFollowUpHiddenWidgets.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetFollowUpHiddenWidgetsSchema, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, TVariables, OperationError<SetFollowUpHiddenWidgetsError>, TContext>): UseMutationResult<SetFollowUpHiddenWidgetsData, OperationError<SetFollowUpHiddenWidgetsError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set Follow Up Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setFollowUpHiddenWidgetsTotal = qraft.v3Service.setFollowUpHiddenWidgets.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setFollowUpHiddenWidgetsTotal = qraft.v3Service.setFollowUpHiddenWidgets.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetFollowUpHiddenWidgetsSchema, SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set Follow Up Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setFollowUpHiddenWidgetsPendingMutationVariables = qraft.v3Service.setFollowUpHiddenWidgets.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setFollowUpHiddenWidgetsMutationData = qraft.v3Service.setFollowUpHiddenWidgets.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetFollowUpHiddenWidgetsData, OperationError<SetFollowUpHiddenWidgetsError>, MutationVariables<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetFollowUpHiddenWidgetsSchema, SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext>;
            select?: (mutation: Mutation<SetFollowUpHiddenWidgetsData, OperationError<SetFollowUpHiddenWidgetsError>, MutationVariables<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set Follow Up Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetFollowUpHiddenWidgetsSchema, SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set Follow Up Hidden Widgets
         * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setFollowUpHiddenWidgets.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setFollowUpHiddenWidgets.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetFollowUpHiddenWidgetsSchema, SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext>): Mutation<SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsError, MutationVariables<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext> | MutationFiltersByMutationKey<SetFollowUpHiddenWidgetsSchema, SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsParameters, OperationError<SetFollowUpHiddenWidgetsError>, TContext>): Array<Mutation<SetFollowUpHiddenWidgetsData, SetFollowUpHiddenWidgetsError, MutationVariables<SetFollowUpHiddenWidgetsBody, SetFollowUpHiddenWidgetsParameters>, TContext>>;
        };
        schema: SetFollowUpHiddenWidgetsSchema;
        types: {
            parameters: SetFollowUpHiddenWidgetsParameters;
            data: SetFollowUpHiddenWidgetsData;
            error: SetFollowUpHiddenWidgetsError;
            body: SetFollowUpHiddenWidgetsBody;
        };
    };
    /**
     * @summary List Group Study Activities
     * @description The group's study-activity log.
     *
     * `student_id` and `study_mode` take lists because legacy's controls are
     * multi-select; the frozen fullapp twin's `student` filter stays a single int.
     * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
     * anchored at midnight in the site's timezone.
     */
    listGroupStudyActivities: {
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupStudyActivitiesParameters, TMeta, TSignal>), client?: (schema: ListGroupStudyActivitiesSchema, options: {
            parameters: ListGroupStudyActivitiesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError>>): Promise<RequestFnResponse<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError>>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupStudyActivitiesParameters>): ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupStudyActivities.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupStudyActivitiesData>(parameters: ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError, TData, ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupStudyActivitiesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupStudyActivities.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupStudyActivitiesData>(parameters: ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>), options: Omit<DefinedInitialDataOptions<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError, TData, ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupStudyActivitiesError>>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupStudyActivitiesParameters>): ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupStudyActivities.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupStudyActivitiesParameters, TQueryFnData = ListGroupStudyActivitiesData, TData = OperationInfiniteData<TQueryFnData, ListGroupStudyActivitiesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupStudyActivitiesError, TData, ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupStudyActivitiesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupStudyActivities.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupStudyActivitiesParameters, TQueryFnData = ListGroupStudyActivitiesData, TData = OperationInfiniteData<TQueryFnData, ListGroupStudyActivitiesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupStudyActivitiesError, TData, ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupStudyActivitiesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupStudyActivitiesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupStudyActivitiesTotal = qraft.v3Service.listGroupStudyActivities.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupStudyActivitiesByParametersTotal = qraft.v3Service.listGroupStudyActivities.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError> | QueryFiltersByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupStudyActivitiesResults = qraft.v3Service.listGroupStudyActivities.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupStudyActivitiesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupStudyActivitiesCombinedResults = qraft.v3Service.listGroupStudyActivities.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupStudyActivitiesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesData, ListGroupStudyActivitiesError>>, TCombinedResult = Array<UseQueryResult<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupStudyActivities.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupStudyActivitiesData>(parameters: ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError, TData, ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupStudyActivitiesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupStudyActivities.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupStudyActivitiesParameters, TData = ListGroupStudyActivitiesData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError, OperationInfiniteData<TData, ListGroupStudyActivitiesParameters>, ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupStudyActivitiesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupStudyActivitiesParameters>, OperationError<ListGroupStudyActivitiesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupStudyActivitiesData = qraft.v3Service.listGroupStudyActivities.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupStudyActivitiesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupStudyActivitiesCombinedData = qraft.v3Service.listGroupStudyActivities.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupStudyActivitiesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesData, ListGroupStudyActivitiesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>): Promise<ListGroupStudyActivitiesData>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>): Promise<void>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>): Promise<ListGroupStudyActivitiesData>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupStudyActivitiesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters, DeepReadonly<TPageParam>, ListGroupStudyActivitiesError>): Promise<OperationInfiniteData<ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters>>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupStudyActivitiesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters, DeepReadonly<TPageParam>, ListGroupStudyActivitiesError>): Promise<void>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupStudyActivitiesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters, DeepReadonly<TPageParam>, ListGroupStudyActivitiesError>): Promise<OperationInfiniteData<ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters>>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>)): ListGroupStudyActivitiesData | undefined;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>)): OperationInfiniteData<ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters> | undefined;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError> | QueryFiltersByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>,
            data: ListGroupStudyActivitiesData | undefined
        ]>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters> | (DeepReadonly<ListGroupStudyActivitiesParameters>)): QueryState<ListGroupStudyActivitiesData, ListGroupStudyActivitiesError> | undefined;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupStudyActivitiesParameters> | ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>): QueryState<OperationInfiniteData<ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters>, ListGroupStudyActivitiesError> | undefined;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupStudyActivitiesParameters>) | ServiceOperationQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>, updater: Updater<NoInfer<ListGroupStudyActivitiesData> | undefined, NoInfer<DeepReadonly<ListGroupStudyActivitiesData>> | undefined>, options?: SetDataOptions): ListGroupStudyActivitiesData | undefined;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupStudyActivitiesParameters>) | ServiceOperationInfiniteQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupStudyActivitiesData, ListGroupStudyActivitiesParameters> | undefined;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError> | QueryFiltersByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>, updater: Updater<NoInfer<ListGroupStudyActivitiesData> | undefined, NoInfer<ListGroupStudyActivitiesData> | undefined>, options?: SetDataOptions): Array<ListGroupStudyActivitiesData | undefined>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError> | QueryFiltersByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError> | QueryFiltersByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError> | QueryFiltersByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>): void;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError> | QueryFiltersByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Study Activities
         * @description The group's study-activity log.
         *
         * `student_id` and `study_mode` take lists because legacy's controls are
         * multi-select; the frozen fullapp twin's `student` filter stays a single int.
         * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
         * anchored at midnight in the site's timezone.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError> | QueryFiltersByQueryKey<ListGroupStudyActivitiesSchema, ListGroupStudyActivitiesData, TInfinite, ListGroupStudyActivitiesParameters, ListGroupStudyActivitiesError>): number;
        schema: ListGroupStudyActivitiesSchema;
        types: {
            parameters: ListGroupStudyActivitiesParameters;
            data: ListGroupStudyActivitiesData;
            error: ListGroupStudyActivitiesError;
        };
    };
    /**
     * @summary List Student Study Activities
     * @description One student's study-activity log.
     *
     * The subject comes from the path. A viewer the gate refuses, including the student
     * themselves, gets the same 404 as an unknown id.
     */
    listStudentStudyActivities: {
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentStudyActivitiesParameters, TMeta, TSignal>), client?: (schema: ListStudentStudyActivitiesSchema, options: {
            parameters: ListStudentStudyActivitiesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError>>): Promise<RequestFnResponse<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError>>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentStudyActivitiesParameters>): ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentStudyActivities.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentStudyActivitiesData>(parameters: ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError, TData, ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentStudyActivitiesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentStudyActivities.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentStudyActivitiesData>(parameters: ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>), options: Omit<DefinedInitialDataOptions<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError, TData, ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentStudyActivitiesError>>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentStudyActivitiesParameters>): ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentStudyActivities.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             course_id: initialCourseId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentStudyActivitiesParameters, TQueryFnData = ListStudentStudyActivitiesData, TData = OperationInfiniteData<TQueryFnData, ListStudentStudyActivitiesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentStudyActivitiesError, TData, ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentStudyActivitiesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentStudyActivities.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             course_id: initialCourseId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentStudyActivitiesParameters, TQueryFnData = ListStudentStudyActivitiesData, TData = OperationInfiniteData<TQueryFnData, ListStudentStudyActivitiesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentStudyActivitiesError, TData, ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentStudyActivitiesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentStudyActivitiesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentStudyActivitiesTotal = qraft.v3Service.listStudentStudyActivities.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentStudyActivitiesByParametersTotal = qraft.v3Service.listStudentStudyActivities.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             course_id: courseId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError> | QueryFiltersByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentStudyActivitiesResults = qraft.v3Service.listStudentStudyActivities.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentStudyActivitiesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentStudyActivitiesCombinedResults = qraft.v3Service.listStudentStudyActivities.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentStudyActivitiesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesData, ListStudentStudyActivitiesError>>, TCombinedResult = Array<UseQueryResult<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentStudyActivities.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         course_id: courseId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentStudyActivitiesData>(parameters: ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError, TData, ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentStudyActivitiesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentStudyActivities.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             course_id: initialCourseId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentStudyActivitiesParameters, TData = ListStudentStudyActivitiesData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError, OperationInfiniteData<TData, ListStudentStudyActivitiesParameters>, ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentStudyActivitiesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentStudyActivitiesParameters>, OperationError<ListStudentStudyActivitiesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentStudyActivitiesData = qraft.v3Service.listStudentStudyActivities.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentStudyActivitiesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentStudyActivitiesCombinedData = qraft.v3Service.listStudentStudyActivities.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 course_id: courseId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 course_id: courseId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentStudyActivitiesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesData, ListStudentStudyActivitiesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>): Promise<ListStudentStudyActivitiesData>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>): Promise<void>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>): Promise<ListStudentStudyActivitiesData>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentStudyActivitiesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters, DeepReadonly<TPageParam>, ListStudentStudyActivitiesError>): Promise<OperationInfiniteData<ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters>>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentStudyActivitiesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters, DeepReadonly<TPageParam>, ListStudentStudyActivitiesError>): Promise<void>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentStudyActivitiesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters, DeepReadonly<TPageParam>, ListStudentStudyActivitiesError>): Promise<OperationInfiniteData<ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters>>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>)): ListStudentStudyActivitiesData | undefined;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>)): OperationInfiniteData<ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters> | undefined;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError> | QueryFiltersByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>,
            data: ListStudentStudyActivitiesData | undefined
        ]>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters> | (DeepReadonly<ListStudentStudyActivitiesParameters>)): QueryState<ListStudentStudyActivitiesData, ListStudentStudyActivitiesError> | undefined;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentStudyActivitiesParameters> | ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>): QueryState<OperationInfiniteData<ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters>, ListStudentStudyActivitiesError> | undefined;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentStudyActivitiesParameters>) | ServiceOperationQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>, updater: Updater<NoInfer<ListStudentStudyActivitiesData> | undefined, NoInfer<DeepReadonly<ListStudentStudyActivitiesData>> | undefined>, options?: SetDataOptions): ListStudentStudyActivitiesData | undefined;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentStudyActivitiesParameters>) | ServiceOperationInfiniteQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentStudyActivitiesData, ListStudentStudyActivitiesParameters> | undefined;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError> | QueryFiltersByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>, updater: Updater<NoInfer<ListStudentStudyActivitiesData> | undefined, NoInfer<ListStudentStudyActivitiesData> | undefined>, options?: SetDataOptions): Array<ListStudentStudyActivitiesData | undefined>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError> | QueryFiltersByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError> | QueryFiltersByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError> | QueryFiltersByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>): void;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError> | QueryFiltersByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Study Activities
         * @description One student's study-activity log.
         *
         * The subject comes from the path. A viewer the gate refuses, including the student
         * themselves, gets the same 404 as an unknown id.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError> | QueryFiltersByQueryKey<ListStudentStudyActivitiesSchema, ListStudentStudyActivitiesData, TInfinite, ListStudentStudyActivitiesParameters, ListStudentStudyActivitiesError>): number;
        schema: ListStudentStudyActivitiesSchema;
        types: {
            parameters: ListStudentStudyActivitiesParameters;
            data: ListStudentStudyActivitiesData;
            error: ListStudentStudyActivitiesError;
        };
    };
    /**
     * @summary Get Student Study Activity Access
     * @description Whether the caller may open this student's study-activity log.
     *
     * Answers 200 for every authenticated caller, so the web route can gate on one
     * query instead of reading a status code, and carries the student's name so the
     * page can title the table without a second, wider read.
     */
    getStudentStudyActivityAccess: {
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentStudyActivityAccessParameters, TMeta, TSignal>), client?: (schema: GetStudentStudyActivityAccessSchema, options: {
            parameters: GetStudentStudyActivityAccessParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError>>): Promise<RequestFnResponse<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError>>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentStudyActivityAccessParameters>): ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentStudyActivityAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentStudyActivityAccessData>(parameters: ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError, TData, ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentStudyActivityAccessError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentStudyActivityAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentStudyActivityAccessData>(parameters: ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>), options: Omit<DefinedInitialDataOptions<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError, TData, ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentStudyActivityAccessError>>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentStudyActivityAccessParameters>): ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyActivityAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentStudyActivityAccessParameters, TQueryFnData = GetStudentStudyActivityAccessData, TData = OperationInfiniteData<TQueryFnData, GetStudentStudyActivityAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentStudyActivityAccessError, TData, ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentStudyActivityAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyActivityAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentStudyActivityAccessParameters, TQueryFnData = GetStudentStudyActivityAccessData, TData = OperationInfiniteData<TQueryFnData, GetStudentStudyActivityAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentStudyActivityAccessError, TData, ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentStudyActivityAccessData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentStudyActivityAccessError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentStudyActivityAccessTotal = qraft.v3Service.getStudentStudyActivityAccess.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentStudyActivityAccessByParametersTotal = qraft.v3Service.getStudentStudyActivityAccess.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError> | QueryFiltersByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentStudyActivityAccessResults = qraft.v3Service.getStudentStudyActivityAccess.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyActivityAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentStudyActivityAccessCombinedResults = qraft.v3Service.getStudentStudyActivityAccess.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyActivityAccessCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError>>, TCombinedResult = Array<UseQueryResult<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentStudyActivityAccess.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentStudyActivityAccessData>(parameters: ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError, TData, ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentStudyActivityAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentStudyActivityAccess.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentStudyActivityAccessParameters, TData = GetStudentStudyActivityAccessData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError, OperationInfiniteData<TData, GetStudentStudyActivityAccessParameters>, ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentStudyActivityAccessData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentStudyActivityAccessParameters>, OperationError<GetStudentStudyActivityAccessError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentStudyActivityAccessData = qraft.v3Service.getStudentStudyActivityAccess.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyActivityAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentStudyActivityAccessCombinedData = qraft.v3Service.getStudentStudyActivityAccess.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentStudyActivityAccessCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>): Promise<GetStudentStudyActivityAccessData>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>): Promise<void>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>): Promise<GetStudentStudyActivityAccessData>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentStudyActivityAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters, DeepReadonly<TPageParam>, GetStudentStudyActivityAccessError>): Promise<OperationInfiniteData<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters>>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentStudyActivityAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters, DeepReadonly<TPageParam>, GetStudentStudyActivityAccessError>): Promise<void>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentStudyActivityAccessParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters, DeepReadonly<TPageParam>, GetStudentStudyActivityAccessError>): Promise<OperationInfiniteData<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters>>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>)): GetStudentStudyActivityAccessData | undefined;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>)): OperationInfiniteData<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters> | undefined;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError> | QueryFiltersByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>,
            data: GetStudentStudyActivityAccessData | undefined
        ]>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters> | (DeepReadonly<GetStudentStudyActivityAccessParameters>)): QueryState<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessError> | undefined;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentStudyActivityAccessParameters> | ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>): QueryState<OperationInfiniteData<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters>, GetStudentStudyActivityAccessError> | undefined;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentStudyActivityAccessParameters>) | ServiceOperationQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>, updater: Updater<NoInfer<GetStudentStudyActivityAccessData> | undefined, NoInfer<DeepReadonly<GetStudentStudyActivityAccessData>> | undefined>, options?: SetDataOptions): GetStudentStudyActivityAccessData | undefined;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentStudyActivityAccessParameters>) | ServiceOperationInfiniteQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentStudyActivityAccessData, GetStudentStudyActivityAccessParameters> | undefined;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError> | QueryFiltersByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>, updater: Updater<NoInfer<GetStudentStudyActivityAccessData> | undefined, NoInfer<GetStudentStudyActivityAccessData> | undefined>, options?: SetDataOptions): Array<GetStudentStudyActivityAccessData | undefined>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError> | QueryFiltersByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError> | QueryFiltersByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError> | QueryFiltersByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>): void;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError> | QueryFiltersByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Study Activity Access
         * @description Whether the caller may open this student's study-activity log.
         *
         * Answers 200 for every authenticated caller, so the web route can gate on one
         * query instead of reading a status code, and carries the student's name so the
         * page can title the table without a second, wider read.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError> | QueryFiltersByQueryKey<GetStudentStudyActivityAccessSchema, GetStudentStudyActivityAccessData, TInfinite, GetStudentStudyActivityAccessParameters, GetStudentStudyActivityAccessError>): number;
        schema: GetStudentStudyActivityAccessSchema;
        types: {
            parameters: GetStudentStudyActivityAccessParameters;
            data: GetStudentStudyActivityAccessData;
            error: GetStudentStudyActivityAccessError;
        };
    };
    /**
     * @summary Get Student Follow Ups Access
     * @description Whether the caller may open this student's Follow-ups tab.
     *
     * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
     * can gate on one query, and carries the student's name for the page title. Separate
     * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
     * partner this tab exists for.
     */
    getStudentFollowUpsAccess: {
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentFollowUpsAccessParameters, TMeta, TSignal>), client?: (schema: GetStudentFollowUpsAccessSchema, options: {
            parameters: GetStudentFollowUpsAccessParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError>>): Promise<RequestFnResponse<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError>>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentFollowUpsAccessParameters>): ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentFollowUpsAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentFollowUpsAccessData>(parameters: ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError, TData, ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentFollowUpsAccessError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentFollowUpsAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentFollowUpsAccessData>(parameters: ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>), options: Omit<DefinedInitialDataOptions<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError, TData, ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentFollowUpsAccessError>>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentFollowUpsAccessParameters>): ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentFollowUpsAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentFollowUpsAccessParameters, TQueryFnData = GetStudentFollowUpsAccessData, TData = OperationInfiniteData<TQueryFnData, GetStudentFollowUpsAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentFollowUpsAccessError, TData, ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentFollowUpsAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentFollowUpsAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentFollowUpsAccessParameters, TQueryFnData = GetStudentFollowUpsAccessData, TData = OperationInfiniteData<TQueryFnData, GetStudentFollowUpsAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentFollowUpsAccessError, TData, ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentFollowUpsAccessData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentFollowUpsAccessError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentFollowUpsAccessTotal = qraft.v3Service.getStudentFollowUpsAccess.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentFollowUpsAccessByParametersTotal = qraft.v3Service.getStudentFollowUpsAccess.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError> | QueryFiltersByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentFollowUpsAccessResults = qraft.v3Service.getStudentFollowUpsAccess.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentFollowUpsAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentFollowUpsAccessCombinedResults = qraft.v3Service.getStudentFollowUpsAccess.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentFollowUpsAccessCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError>>, TCombinedResult = Array<UseQueryResult<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentFollowUpsAccess.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentFollowUpsAccessData>(parameters: ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError, TData, ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentFollowUpsAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentFollowUpsAccess.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentFollowUpsAccessParameters, TData = GetStudentFollowUpsAccessData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError, OperationInfiniteData<TData, GetStudentFollowUpsAccessParameters>, ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentFollowUpsAccessData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentFollowUpsAccessParameters>, OperationError<GetStudentFollowUpsAccessError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentFollowUpsAccessData = qraft.v3Service.getStudentFollowUpsAccess.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentFollowUpsAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentFollowUpsAccessCombinedData = qraft.v3Service.getStudentFollowUpsAccess.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentFollowUpsAccessCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>): Promise<GetStudentFollowUpsAccessData>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>): Promise<void>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>): Promise<GetStudentFollowUpsAccessData>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentFollowUpsAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters, DeepReadonly<TPageParam>, GetStudentFollowUpsAccessError>): Promise<OperationInfiniteData<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters>>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentFollowUpsAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters, DeepReadonly<TPageParam>, GetStudentFollowUpsAccessError>): Promise<void>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentFollowUpsAccessParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters, DeepReadonly<TPageParam>, GetStudentFollowUpsAccessError>): Promise<OperationInfiniteData<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters>>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>)): GetStudentFollowUpsAccessData | undefined;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>)): OperationInfiniteData<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters> | undefined;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError> | QueryFiltersByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>,
            data: GetStudentFollowUpsAccessData | undefined
        ]>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters> | (DeepReadonly<GetStudentFollowUpsAccessParameters>)): QueryState<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessError> | undefined;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentFollowUpsAccessParameters> | ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>): QueryState<OperationInfiniteData<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters>, GetStudentFollowUpsAccessError> | undefined;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentFollowUpsAccessParameters>) | ServiceOperationQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>, updater: Updater<NoInfer<GetStudentFollowUpsAccessData> | undefined, NoInfer<DeepReadonly<GetStudentFollowUpsAccessData>> | undefined>, options?: SetDataOptions): GetStudentFollowUpsAccessData | undefined;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentFollowUpsAccessParameters>) | ServiceOperationInfiniteQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentFollowUpsAccessData, GetStudentFollowUpsAccessParameters> | undefined;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError> | QueryFiltersByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>, updater: Updater<NoInfer<GetStudentFollowUpsAccessData> | undefined, NoInfer<GetStudentFollowUpsAccessData> | undefined>, options?: SetDataOptions): Array<GetStudentFollowUpsAccessData | undefined>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError> | QueryFiltersByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError> | QueryFiltersByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError> | QueryFiltersByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>): void;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError> | QueryFiltersByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Follow Ups Access
         * @description Whether the caller may open this student's Follow-ups tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
         * can gate on one query, and carries the student's name for the page title. Separate
         * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
         * partner this tab exists for.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError> | QueryFiltersByQueryKey<GetStudentFollowUpsAccessSchema, GetStudentFollowUpsAccessData, TInfinite, GetStudentFollowUpsAccessParameters, GetStudentFollowUpsAccessError>): number;
        schema: GetStudentFollowUpsAccessSchema;
        types: {
            parameters: GetStudentFollowUpsAccessParameters;
            data: GetStudentFollowUpsAccessData;
            error: GetStudentFollowUpsAccessError;
        };
    };
    /**
     * @summary List Student Follow Up Requests
     * @description The student's follow-up requests that have not become a follow-up.
     *
     * The subject comes from the path and the gate, never a query parameter. `status`
     * accepts the full enum, though the filter panel offers only four values.
     */
    listStudentFollowUpRequests: {
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentFollowUpRequestsParameters, TMeta, TSignal>), client?: (schema: ListStudentFollowUpRequestsSchema, options: {
            parameters: ListStudentFollowUpRequestsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError>>): Promise<RequestFnResponse<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError>>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentFollowUpRequestsParameters>): ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentFollowUpRequests.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         selected_requests: selectedRequests
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError, TData, ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentFollowUpRequests.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         selected_requests: selectedRequests
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>), options: Omit<DefinedInitialDataOptions<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError, TData, ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentFollowUpRequestsError>>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentFollowUpRequestsParameters>): ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentFollowUpRequests.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             selected_requests: initialSelectedRequests
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentFollowUpRequestsParameters, TQueryFnData = ListStudentFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListStudentFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentFollowUpRequests.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             selected_requests: initialSelectedRequests
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentFollowUpRequestsParameters, TQueryFnData = ListStudentFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListStudentFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentFollowUpRequestsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentFollowUpRequestsTotal = qraft.v3Service.listStudentFollowUpRequests.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentFollowUpRequestsByParametersTotal = qraft.v3Service.listStudentFollowUpRequests.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             selected_requests: selectedRequests
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentFollowUpRequestsResults = qraft.v3Service.listStudentFollowUpRequests.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 selected_requests: selectedRequests1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 selected_requests: selectedRequests2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentFollowUpRequestsCombinedResults = qraft.v3Service.listStudentFollowUpRequests.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 selected_requests: selectedRequests1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 selected_requests: selectedRequests2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentFollowUpRequestsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError>>, TCombinedResult = Array<UseQueryResult<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentFollowUpRequests.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         selected_requests: selectedRequests
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError, TData, ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentFollowUpRequests.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             selected_requests: initialSelectedRequests
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentFollowUpRequestsParameters, TData = ListStudentFollowUpRequestsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError, OperationInfiniteData<TData, ListStudentFollowUpRequestsParameters>, ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentFollowUpRequestsParameters>, OperationError<ListStudentFollowUpRequestsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentFollowUpRequestsData = qraft.v3Service.listStudentFollowUpRequests.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 selected_requests: selectedRequests1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 selected_requests: selectedRequests2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentFollowUpRequestsCombinedData = qraft.v3Service.listStudentFollowUpRequests.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 selected_requests: selectedRequests1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 selected_requests: selectedRequests2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentFollowUpRequestsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>): Promise<ListStudentFollowUpRequestsData>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>): Promise<void>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>): Promise<ListStudentFollowUpRequestsData>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListStudentFollowUpRequestsError>): Promise<OperationInfiniteData<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters>>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListStudentFollowUpRequestsError>): Promise<void>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentFollowUpRequestsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListStudentFollowUpRequestsError>): Promise<OperationInfiniteData<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters>>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>)): ListStudentFollowUpRequestsData | undefined;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>)): OperationInfiniteData<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>,
            data: ListStudentFollowUpRequestsData | undefined
        ]>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters> | (DeepReadonly<ListStudentFollowUpRequestsParameters>)): QueryState<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsError> | undefined;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentFollowUpRequestsParameters> | ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>): QueryState<OperationInfiniteData<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters>, ListStudentFollowUpRequestsError> | undefined;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentFollowUpRequestsParameters>) | ServiceOperationQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>, updater: Updater<NoInfer<ListStudentFollowUpRequestsData> | undefined, NoInfer<DeepReadonly<ListStudentFollowUpRequestsData>> | undefined>, options?: SetDataOptions): ListStudentFollowUpRequestsData | undefined;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentFollowUpRequestsParameters>) | ServiceOperationInfiniteQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentFollowUpRequestsData, ListStudentFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>, updater: Updater<NoInfer<ListStudentFollowUpRequestsData> | undefined, NoInfer<ListStudentFollowUpRequestsData> | undefined>, options?: SetDataOptions): Array<ListStudentFollowUpRequestsData | undefined>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>): void;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Follow Up Requests
         * @description The student's follow-up requests that have not become a follow-up.
         *
         * The subject comes from the path and the gate, never a query parameter. `status`
         * accepts the full enum, though the filter panel offers only four values.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentFollowUpRequestsSchema, ListStudentFollowUpRequestsData, TInfinite, ListStudentFollowUpRequestsParameters, ListStudentFollowUpRequestsError>): number;
        schema: ListStudentFollowUpRequestsSchema;
        types: {
            parameters: ListStudentFollowUpRequestsParameters;
            data: ListStudentFollowUpRequestsData;
            error: ListStudentFollowUpRequestsError;
        };
    };
    /**
     * @summary List Student Pending Follow Up Requests
     * @description The student's requests still awaiting their answer.
     *
     * No filters, no search and no sort keys, and the subject comes from the path.
     */
    listStudentPendingFollowUpRequests: {
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentPendingFollowUpRequestsParameters, TMeta, TSignal>), client?: (schema: ListStudentPendingFollowUpRequestsSchema, options: {
            parameters: ListStudentPendingFollowUpRequestsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError>>): Promise<RequestFnResponse<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError>>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentPendingFollowUpRequestsParameters>): ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentPendingFollowUpRequests.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentPendingFollowUpRequests.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>), options: Omit<DefinedInitialDataOptions<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentPendingFollowUpRequestsError>>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentPendingFollowUpRequestsParameters>): ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentPendingFollowUpRequests.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentPendingFollowUpRequestsParameters, TQueryFnData = ListStudentPendingFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListStudentPendingFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentPendingFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentPendingFollowUpRequests.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentPendingFollowUpRequestsParameters, TQueryFnData = ListStudentPendingFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListStudentPendingFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentPendingFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentPendingFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentPendingFollowUpRequestsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentPendingFollowUpRequestsTotal = qraft.v3Service.listStudentPendingFollowUpRequests.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentPendingFollowUpRequestsByParametersTotal = qraft.v3Service.listStudentPendingFollowUpRequests.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentPendingFollowUpRequestsResults = qraft.v3Service.listStudentPendingFollowUpRequests.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentPendingFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentPendingFollowUpRequestsCombinedResults = qraft.v3Service.listStudentPendingFollowUpRequests.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentPendingFollowUpRequestsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError>>, TCombinedResult = Array<UseQueryResult<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentPendingFollowUpRequests.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentPendingFollowUpRequests.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentPendingFollowUpRequestsParameters, TData = ListStudentPendingFollowUpRequestsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError, OperationInfiniteData<TData, ListStudentPendingFollowUpRequestsParameters>, ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentPendingFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentPendingFollowUpRequestsParameters>, OperationError<ListStudentPendingFollowUpRequestsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentPendingFollowUpRequestsData = qraft.v3Service.listStudentPendingFollowUpRequests.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentPendingFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentPendingFollowUpRequestsCombinedData = qraft.v3Service.listStudentPendingFollowUpRequests.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentPendingFollowUpRequestsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>): Promise<ListStudentPendingFollowUpRequestsData>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>): Promise<void>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>): Promise<ListStudentPendingFollowUpRequestsData>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentPendingFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListStudentPendingFollowUpRequestsError>): Promise<OperationInfiniteData<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters>>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentPendingFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListStudentPendingFollowUpRequestsError>): Promise<void>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentPendingFollowUpRequestsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListStudentPendingFollowUpRequestsError>): Promise<OperationInfiniteData<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters>>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>)): ListStudentPendingFollowUpRequestsData | undefined;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>)): OperationInfiniteData<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>,
            data: ListStudentPendingFollowUpRequestsData | undefined
        ]>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters> | (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>)): QueryState<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsError> | undefined;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentPendingFollowUpRequestsParameters> | ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>): QueryState<OperationInfiniteData<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters>, ListStudentPendingFollowUpRequestsError> | undefined;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>) | ServiceOperationQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>, updater: Updater<NoInfer<ListStudentPendingFollowUpRequestsData> | undefined, NoInfer<DeepReadonly<ListStudentPendingFollowUpRequestsData>> | undefined>, options?: SetDataOptions): ListStudentPendingFollowUpRequestsData | undefined;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentPendingFollowUpRequestsParameters>) | ServiceOperationInfiniteQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentPendingFollowUpRequestsData, ListStudentPendingFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>, updater: Updater<NoInfer<ListStudentPendingFollowUpRequestsData> | undefined, NoInfer<ListStudentPendingFollowUpRequestsData> | undefined>, options?: SetDataOptions): Array<ListStudentPendingFollowUpRequestsData | undefined>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>): void;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Pending Follow Up Requests
         * @description The student's requests still awaiting their answer.
         *
         * No filters, no search and no sort keys, and the subject comes from the path.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListStudentPendingFollowUpRequestsSchema, ListStudentPendingFollowUpRequestsData, TInfinite, ListStudentPendingFollowUpRequestsParameters, ListStudentPendingFollowUpRequestsError>): number;
        schema: ListStudentPendingFollowUpRequestsSchema;
        types: {
            parameters: ListStudentPendingFollowUpRequestsParameters;
            data: ListStudentPendingFollowUpRequestsData;
            error: ListStudentPendingFollowUpRequestsError;
        };
    };
    /**
     * @summary List Student Follow Ups
     * @description The student's in-person follow-ups.
     *
     * Omitting `status` returns all seven statuses. Date bounds include the named day, in
     * site time.
     */
    listStudentFollowUps: {
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentFollowUpsParameters, TMeta, TSignal>), client?: (schema: ListStudentFollowUpsSchema, options: {
            parameters: ListStudentFollowUpsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentFollowUpsData, ListStudentFollowUpsError>>): Promise<RequestFnResponse<ListStudentFollowUpsData, ListStudentFollowUpsError>>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentFollowUpsParameters>): ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentFollowUps.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentFollowUpsData>(parameters: ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentFollowUpsData, ListStudentFollowUpsError, TData, ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentFollowUpsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentFollowUps.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentFollowUpsData>(parameters: ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>), options: Omit<DefinedInitialDataOptions<ListStudentFollowUpsData, ListStudentFollowUpsError, TData, ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentFollowUpsError>>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentFollowUpsParameters>): ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentFollowUps.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentFollowUpsParameters, TQueryFnData = ListStudentFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListStudentFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentFollowUps.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentFollowUpsParameters, TQueryFnData = ListStudentFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListStudentFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentFollowUpsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentFollowUpsTotal = qraft.v3Service.listStudentFollowUps.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentFollowUpsByParametersTotal = qraft.v3Service.listStudentFollowUps.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             id: id
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError> | QueryFiltersByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentFollowUpsResults = qraft.v3Service.listStudentFollowUps.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentFollowUpsCombinedResults = qraft.v3Service.listStudentFollowUps.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentFollowUpsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters, ListStudentFollowUpsData, ListStudentFollowUpsError>>, TCombinedResult = Array<UseQueryResult<ListStudentFollowUpsData, ListStudentFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentFollowUpsData, ListStudentFollowUpsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentFollowUps.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentFollowUpsData>(parameters: ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentFollowUpsData, ListStudentFollowUpsError, TData, ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentFollowUps.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentFollowUpsParameters, TData = ListStudentFollowUpsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentFollowUpsData, ListStudentFollowUpsError, OperationInfiniteData<TData, ListStudentFollowUpsParameters>, ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentFollowUpsParameters>, OperationError<ListStudentFollowUpsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentFollowUpsData = qraft.v3Service.listStudentFollowUps.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentFollowUpsCombinedData = qraft.v3Service.listStudentFollowUps.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentFollowUpsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters, ListStudentFollowUpsData, ListStudentFollowUpsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentFollowUpsData, ListStudentFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentFollowUpsData, ListStudentFollowUpsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentFollowUpsSchema, ListStudentFollowUpsData, ListStudentFollowUpsParameters, ListStudentFollowUpsError>): Promise<ListStudentFollowUpsData>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentFollowUpsSchema, ListStudentFollowUpsData, ListStudentFollowUpsParameters, ListStudentFollowUpsError>): Promise<void>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentFollowUpsSchema, ListStudentFollowUpsData, ListStudentFollowUpsParameters, ListStudentFollowUpsError>): Promise<ListStudentFollowUpsData>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentFollowUpsSchema, ListStudentFollowUpsData, ListStudentFollowUpsParameters, DeepReadonly<TPageParam>, ListStudentFollowUpsError>): Promise<OperationInfiniteData<ListStudentFollowUpsData, ListStudentFollowUpsParameters>>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentFollowUpsSchema, ListStudentFollowUpsData, ListStudentFollowUpsParameters, DeepReadonly<TPageParam>, ListStudentFollowUpsError>): Promise<void>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentFollowUpsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentFollowUpsSchema, ListStudentFollowUpsData, ListStudentFollowUpsParameters, DeepReadonly<TPageParam>, ListStudentFollowUpsError>): Promise<OperationInfiniteData<ListStudentFollowUpsData, ListStudentFollowUpsParameters>>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>)): ListStudentFollowUpsData | undefined;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>)): OperationInfiniteData<ListStudentFollowUpsData, ListStudentFollowUpsParameters> | undefined;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError> | QueryFiltersByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentFollowUpsData, ListStudentFollowUpsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>,
            data: ListStudentFollowUpsData | undefined
        ]>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters> | (DeepReadonly<ListStudentFollowUpsParameters>)): QueryState<ListStudentFollowUpsData, ListStudentFollowUpsError> | undefined;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentFollowUpsParameters> | ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>): QueryState<OperationInfiniteData<ListStudentFollowUpsData, ListStudentFollowUpsParameters>, ListStudentFollowUpsError> | undefined;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentFollowUpsParameters>) | ServiceOperationQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>, updater: Updater<NoInfer<ListStudentFollowUpsData> | undefined, NoInfer<DeepReadonly<ListStudentFollowUpsData>> | undefined>, options?: SetDataOptions): ListStudentFollowUpsData | undefined;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentFollowUpsParameters>) | ServiceOperationInfiniteQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentFollowUpsData, ListStudentFollowUpsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentFollowUpsData, ListStudentFollowUpsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentFollowUpsData, ListStudentFollowUpsParameters> | undefined;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError> | QueryFiltersByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>, updater: Updater<NoInfer<ListStudentFollowUpsData> | undefined, NoInfer<ListStudentFollowUpsData> | undefined>, options?: SetDataOptions): Array<ListStudentFollowUpsData | undefined>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError> | QueryFiltersByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError> | QueryFiltersByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError> | QueryFiltersByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>): void;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError> | QueryFiltersByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Follow Ups
         * @description The student's in-person follow-ups.
         *
         * Omitting `status` returns all seven statuses. Date bounds include the named day, in
         * site time.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError> | QueryFiltersByQueryKey<ListStudentFollowUpsSchema, ListStudentFollowUpsData, TInfinite, ListStudentFollowUpsParameters, ListStudentFollowUpsError>): number;
        schema: ListStudentFollowUpsSchema;
        types: {
            parameters: ListStudentFollowUpsParameters;
            data: ListStudentFollowUpsData;
            error: ListStudentFollowUpsError;
        };
    };
    /**
     * @summary Get Pending Follow Up Verification
     * @description The one pending request the site-wide verification popup is about.
     *
     * 404 when there is none, so the web hook can treat no body as no popup.
     */
    getPendingFollowUpVerification: {
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetPendingFollowUpVerificationParameters, TMeta, TSignal> | void), client?: (schema: GetPendingFollowUpVerificationSchema, options: {
            parameters: GetPendingFollowUpVerificationParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError>>): Promise<RequestFnResponse<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError>>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        getQueryKey(parameters: DeepReadonly<GetPendingFollowUpVerificationParameters> | void): ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPendingFollowUpVerification.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPendingFollowUpVerification.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetPendingFollowUpVerificationData>(parameters: ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void), options?: Omit<UndefinedInitialDataOptions<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError, TData, ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetPendingFollowUpVerificationError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPendingFollowUpVerification.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getPendingFollowUpVerification.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetPendingFollowUpVerificationData>(parameters: ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void), options: Omit<DefinedInitialDataOptions<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError, TData, ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetPendingFollowUpVerificationError>>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetPendingFollowUpVerificationParameters> | void): ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPendingFollowUpVerification.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetPendingFollowUpVerificationParameters, TQueryFnData = GetPendingFollowUpVerificationData, TData = OperationInfiniteData<TQueryFnData, GetPendingFollowUpVerificationParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetPendingFollowUpVerificationError, TData, ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetPendingFollowUpVerificationError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPendingFollowUpVerification.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetPendingFollowUpVerificationParameters, TQueryFnData = GetPendingFollowUpVerificationData, TData = OperationInfiniteData<TQueryFnData, GetPendingFollowUpVerificationParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetPendingFollowUpVerificationError, TData, ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetPendingFollowUpVerificationData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetPendingFollowUpVerificationError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getPendingFollowUpVerificationTotal = qraft.v3Service.getPendingFollowUpVerification.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getPendingFollowUpVerificationByParametersTotal = qraft.v3Service.getPendingFollowUpVerification.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | QueryFiltersByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getPendingFollowUpVerificationResults = qraft.v3Service.getPendingFollowUpVerification.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPendingFollowUpVerificationResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getPendingFollowUpVerificationCombinedResults = qraft.v3Service.getPendingFollowUpVerification.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPendingFollowUpVerificationCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError>>, TCombinedResult = Array<UseQueryResult<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.getPendingFollowUpVerification.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getPendingFollowUpVerification.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetPendingFollowUpVerificationData>(parameters: ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void), options?: Omit<UseSuspenseQueryOptions<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError, TData, ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetPendingFollowUpVerificationError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getPendingFollowUpVerification.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetPendingFollowUpVerificationParameters, TData = GetPendingFollowUpVerificationData>(parameters: ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError, OperationInfiniteData<TData, GetPendingFollowUpVerificationParameters>, ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetPendingFollowUpVerificationData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetPendingFollowUpVerificationParameters>, OperationError<GetPendingFollowUpVerificationError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getPendingFollowUpVerificationData = qraft.v3Service.getPendingFollowUpVerification.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPendingFollowUpVerificationResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getPendingFollowUpVerificationCombinedData = qraft.v3Service.getPendingFollowUpVerification.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getPendingFollowUpVerificationCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | void): Promise<GetPendingFollowUpVerificationData>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | void): Promise<void>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | void): Promise<GetPendingFollowUpVerificationData>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        fetchInfiniteQuery<TPageParam extends GetPendingFollowUpVerificationParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters, DeepReadonly<TPageParam>, GetPendingFollowUpVerificationError> | void): Promise<OperationInfiniteData<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters>>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        prefetchInfiniteQuery<TPageParam extends GetPendingFollowUpVerificationParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters, DeepReadonly<TPageParam>, GetPendingFollowUpVerificationError> | void): Promise<void>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        ensureInfiniteQueryData<TPageParam extends GetPendingFollowUpVerificationParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters, DeepReadonly<TPageParam>, GetPendingFollowUpVerificationError> | void): Promise<OperationInfiniteData<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters>>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void)): GetPendingFollowUpVerificationData | undefined;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void)): OperationInfiniteData<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters> | undefined;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | QueryFiltersByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>,
            data: NoInfer<OperationInfiniteData<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>,
            data: GetPendingFollowUpVerificationData | undefined
        ]>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | (DeepReadonly<GetPendingFollowUpVerificationParameters> | void)): QueryState<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationError> | undefined;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetPendingFollowUpVerificationParameters> | ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters> | void): QueryState<OperationInfiniteData<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters>, GetPendingFollowUpVerificationError> | undefined;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        setQueryData(parameters: (DeepReadonly<GetPendingFollowUpVerificationParameters> | undefined) | ServiceOperationQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>, updater: Updater<NoInfer<GetPendingFollowUpVerificationData> | undefined, NoInfer<DeepReadonly<GetPendingFollowUpVerificationData>> | undefined>, options?: SetDataOptions): GetPendingFollowUpVerificationData | undefined;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetPendingFollowUpVerificationParameters> | undefined) | ServiceOperationInfiniteQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetPendingFollowUpVerificationData, GetPendingFollowUpVerificationParameters> | undefined;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | QueryFiltersByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>, updater: Updater<NoInfer<GetPendingFollowUpVerificationData> | undefined, NoInfer<GetPendingFollowUpVerificationData> | undefined>, options?: SetDataOptions): Array<GetPendingFollowUpVerificationData | undefined>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | QueryFiltersByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | QueryFiltersByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | QueryFiltersByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>): void;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | QueryFiltersByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Pending Follow Up Verification
         * @description The one pending request the site-wide verification popup is about.
         *
         * 404 when there is none, so the web hook can treat no body as no popup.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError> | QueryFiltersByQueryKey<GetPendingFollowUpVerificationSchema, GetPendingFollowUpVerificationData, TInfinite, GetPendingFollowUpVerificationParameters, GetPendingFollowUpVerificationError>): number;
        schema: GetPendingFollowUpVerificationSchema;
        types: {
            parameters: GetPendingFollowUpVerificationParameters;
            data: GetPendingFollowUpVerificationData;
            error: GetPendingFollowUpVerificationError;
        };
    };
    /**
     * @summary Approve Follow Up Request
     * @description The student consents to their own pending follow-up request.
     *
     * The merged contact snapshot is saved before the field and consent checks run, so a
     * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
     * keeps the stored value and a submitted empty string clears it.
     */
    approveFollowUpRequest: {
        /**
         * @summary Approve Follow Up Request
         * @description The student consents to their own pending follow-up request.
         *
         * The merged contact snapshot is saved before the field and consent checks run, so a
         * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
         * keeps the stored value and a submitted empty string clears it.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ApproveFollowUpRequestBody, ApproveFollowUpRequestParameters, TMeta, TSignal>, client?: (schema: ApproveFollowUpRequestSchema, options: ServiceOperationMutationFnOptions<ApproveFollowUpRequestBody, ApproveFollowUpRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ApproveFollowUpRequestData, ApproveFollowUpRequestError>>): Promise<RequestFnResponse<ApproveFollowUpRequestData, ApproveFollowUpRequestError>>;
        /**
         * @summary Approve Follow Up Request
         * @description The student consents to their own pending follow-up request.
         *
         * The merged contact snapshot is saved before the field and consent checks run, so a
         * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
         * keeps the stored value and a submitted empty string clears it.
         */
        getMutationKey(parameters: DeepReadonly<ApproveFollowUpRequestParameters> | void): ServiceOperationMutationKey<ApproveFollowUpRequestSchema, ApproveFollowUpRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Approve Follow Up Request
         * @description The student consents to their own pending follow-up request.
         *
         * The merged contact snapshot is saved before the field and consent checks run, so a
         * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
         * keeps the stored value and a submitted empty string clears it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.approveFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.approveFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ApproveFollowUpRequestBody, TContext = unknown>(parameters: DeepReadonly<ApproveFollowUpRequestParameters>, options?: ServiceOperationUseMutationOptions<ApproveFollowUpRequestSchema, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, TVariables, OperationError<ApproveFollowUpRequestError>, TContext>): UseMutationResult<ApproveFollowUpRequestData, OperationError<ApproveFollowUpRequestError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Approve Follow Up Request
         * @description The student consents to their own pending follow-up request.
         *
         * The merged contact snapshot is saved before the field and consent checks run, so a
         * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
         * keeps the stored value and a submitted empty string clears it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.approveFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.approveFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ApproveFollowUpRequestBody, ApproveFollowUpRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ApproveFollowUpRequestSchema, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, TVariables, OperationError<ApproveFollowUpRequestError>, TContext>): UseMutationResult<ApproveFollowUpRequestData, OperationError<ApproveFollowUpRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Approve Follow Up Request
         * @description The student consents to their own pending follow-up request.
         *
         * The merged contact snapshot is saved before the field and consent checks run, so a
         * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
         * keeps the stored value and a submitted empty string clears it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const approveFollowUpRequestTotal = qraft.v3Service.approveFollowUpRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const approveFollowUpRequestTotal = qraft.v3Service.approveFollowUpRequest.useIsMutating({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestSchema, ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Approve Follow Up Request
         * @description The student consents to their own pending follow-up request.
         *
         * The merged contact snapshot is saved before the field and consent checks run, so a
         * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
         * keeps the stored value and a submitted empty string clears it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const approveFollowUpRequestPendingMutationVariables = qraft.v3Service.approveFollowUpRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const approveFollowUpRequestMutationData = qraft.v3Service.approveFollowUpRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 request_id: requestId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ApproveFollowUpRequestData, OperationError<ApproveFollowUpRequestError>, MutationVariables<ApproveFollowUpRequestBody, ApproveFollowUpRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestSchema, ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext>;
            select?: (mutation: Mutation<ApproveFollowUpRequestData, OperationError<ApproveFollowUpRequestError>, MutationVariables<ApproveFollowUpRequestBody, ApproveFollowUpRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Approve Follow Up Request
         * @description The student consents to their own pending follow-up request.
         *
         * The merged contact snapshot is saved before the field and consent checks run, so a
         * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
         * keeps the stored value and a submitted empty string clears it.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestSchema, ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Approve Follow Up Request
         * @description The student consents to their own pending follow-up request.
         *
         * The merged contact snapshot is saved before the field and consent checks run, so a
         * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
         * keeps the stored value and a submitted empty string clears it.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.approveFollowUpRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.approveFollowUpRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestSchema, ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext>): Mutation<ApproveFollowUpRequestData, ApproveFollowUpRequestError, MutationVariables<ApproveFollowUpRequestBody, ApproveFollowUpRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestSchema, ApproveFollowUpRequestBody, ApproveFollowUpRequestData, ApproveFollowUpRequestParameters, OperationError<ApproveFollowUpRequestError>, TContext>): Array<Mutation<ApproveFollowUpRequestData, ApproveFollowUpRequestError, MutationVariables<ApproveFollowUpRequestBody, ApproveFollowUpRequestParameters>, TContext>>;
        };
        schema: ApproveFollowUpRequestSchema;
        types: {
            parameters: ApproveFollowUpRequestParameters;
            data: ApproveFollowUpRequestData;
            error: ApproveFollowUpRequestError;
            body: ApproveFollowUpRequestBody;
        };
    };
    /**
     * @summary Reject Follow Up Request
     * @description The student declines their own pending follow-up request.
     *
     * `reason` is optional, may be empty, and is written to
     * `message_for_study_helper_reject`.
     */
    rejectFollowUpRequest: {
        /**
         * @summary Reject Follow Up Request
         * @description The student declines their own pending follow-up request.
         *
         * `reason` is optional, may be empty, and is written to
         * `message_for_study_helper_reject`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RejectFollowUpRequestBody, RejectFollowUpRequestParameters, TMeta, TSignal>, client?: (schema: RejectFollowUpRequestSchema, options: ServiceOperationMutationFnOptions<RejectFollowUpRequestBody, RejectFollowUpRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RejectFollowUpRequestData, RejectFollowUpRequestError>>): Promise<RequestFnResponse<RejectFollowUpRequestData, RejectFollowUpRequestError>>;
        /**
         * @summary Reject Follow Up Request
         * @description The student declines their own pending follow-up request.
         *
         * `reason` is optional, may be empty, and is written to
         * `message_for_study_helper_reject`.
         */
        getMutationKey(parameters: DeepReadonly<RejectFollowUpRequestParameters> | void): ServiceOperationMutationKey<RejectFollowUpRequestSchema, RejectFollowUpRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reject Follow Up Request
         * @description The student declines their own pending follow-up request.
         *
         * `reason` is optional, may be empty, and is written to
         * `message_for_study_helper_reject`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RejectFollowUpRequestBody, TContext = unknown>(parameters: DeepReadonly<RejectFollowUpRequestParameters>, options?: ServiceOperationUseMutationOptions<RejectFollowUpRequestSchema, RejectFollowUpRequestData, RejectFollowUpRequestParameters, TVariables, OperationError<RejectFollowUpRequestError>, TContext>): UseMutationResult<RejectFollowUpRequestData, OperationError<RejectFollowUpRequestError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reject Follow Up Request
         * @description The student declines their own pending follow-up request.
         *
         * `reason` is optional, may be empty, and is written to
         * `message_for_study_helper_reject`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RejectFollowUpRequestBody, RejectFollowUpRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RejectFollowUpRequestSchema, RejectFollowUpRequestData, RejectFollowUpRequestParameters, TVariables, OperationError<RejectFollowUpRequestError>, TContext>): UseMutationResult<RejectFollowUpRequestData, OperationError<RejectFollowUpRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Reject Follow Up Request
         * @description The student declines their own pending follow-up request.
         *
         * `reason` is optional, may be empty, and is written to
         * `message_for_study_helper_reject`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const rejectFollowUpRequestTotal = qraft.v3Service.rejectFollowUpRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const rejectFollowUpRequestTotal = qraft.v3Service.rejectFollowUpRequest.useIsMutating({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestSchema, RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Reject Follow Up Request
         * @description The student declines their own pending follow-up request.
         *
         * `reason` is optional, may be empty, and is written to
         * `message_for_study_helper_reject`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const rejectFollowUpRequestPendingMutationVariables = qraft.v3Service.rejectFollowUpRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const rejectFollowUpRequestMutationData = qraft.v3Service.rejectFollowUpRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 request_id: requestId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RejectFollowUpRequestData, OperationError<RejectFollowUpRequestError>, MutationVariables<RejectFollowUpRequestBody, RejectFollowUpRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestSchema, RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext>;
            select?: (mutation: Mutation<RejectFollowUpRequestData, OperationError<RejectFollowUpRequestError>, MutationVariables<RejectFollowUpRequestBody, RejectFollowUpRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Reject Follow Up Request
         * @description The student declines their own pending follow-up request.
         *
         * `reason` is optional, may be empty, and is written to
         * `message_for_study_helper_reject`.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestSchema, RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Reject Follow Up Request
         * @description The student declines their own pending follow-up request.
         *
         * `reason` is optional, may be empty, and is written to
         * `message_for_study_helper_reject`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.rejectFollowUpRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.rejectFollowUpRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestSchema, RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext>): Mutation<RejectFollowUpRequestData, RejectFollowUpRequestError, MutationVariables<RejectFollowUpRequestBody, RejectFollowUpRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestSchema, RejectFollowUpRequestBody, RejectFollowUpRequestData, RejectFollowUpRequestParameters, OperationError<RejectFollowUpRequestError>, TContext>): Array<Mutation<RejectFollowUpRequestData, RejectFollowUpRequestError, MutationVariables<RejectFollowUpRequestBody, RejectFollowUpRequestParameters>, TContext>>;
        };
        schema: RejectFollowUpRequestSchema;
        types: {
            parameters: RejectFollowUpRequestParameters;
            data: RejectFollowUpRequestData;
            error: RejectFollowUpRequestError;
            body: RejectFollowUpRequestBody;
        };
    };
    /**
     * @summary List Group Follow Up Requests
     * @description Every follow-up request the group's students carry.
     *
     * Omitting `status` hides `pending` and `in_progress`, which is legacy's
     * value-less filter default; supplying any value REPLACES that exclusion rather
     * than intersecting with it, so `?status=pending` returns exactly the rows the
     * bare list hides.
     */
    listGroupFollowUpRequests: {
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupFollowUpRequestsParameters, TMeta, TSignal>), client?: (schema: ListGroupFollowUpRequestsSchema, options: {
            parameters: ListGroupFollowUpRequestsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError>>): Promise<RequestFnResponse<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError>>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupFollowUpRequestsParameters>): ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupFollowUpRequests.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError, TData, ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupFollowUpRequests.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>), options: Omit<DefinedInitialDataOptions<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError, TData, ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupFollowUpRequestsError>>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupFollowUpRequestsParameters>): ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUpRequests.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupFollowUpRequestsParameters, TQueryFnData = ListGroupFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListGroupFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUpRequests.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupFollowUpRequestsParameters, TQueryFnData = ListGroupFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListGroupFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupFollowUpRequestsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupFollowUpRequestsTotal = qraft.v3Service.listGroupFollowUpRequests.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupFollowUpRequestsByParametersTotal = qraft.v3Service.listGroupFollowUpRequests.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupFollowUpRequestsResults = qraft.v3Service.listGroupFollowUpRequests.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupFollowUpRequestsCombinedResults = qraft.v3Service.listGroupFollowUpRequests.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpRequestsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError>>, TCombinedResult = Array<UseQueryResult<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupFollowUpRequests.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError, TData, ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUpRequests.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupFollowUpRequestsParameters, TData = ListGroupFollowUpRequestsData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError, OperationInfiniteData<TData, ListGroupFollowUpRequestsParameters>, ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupFollowUpRequestsParameters>, OperationError<ListGroupFollowUpRequestsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupFollowUpRequestsData = qraft.v3Service.listGroupFollowUpRequests.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupFollowUpRequestsCombinedData = qraft.v3Service.listGroupFollowUpRequests.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpRequestsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>): Promise<ListGroupFollowUpRequestsData>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>): Promise<void>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>): Promise<ListGroupFollowUpRequestsData>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpRequestsError>): Promise<OperationInfiniteData<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters>>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpRequestsError>): Promise<void>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupFollowUpRequestsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpRequestsError>): Promise<OperationInfiniteData<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters>>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>)): ListGroupFollowUpRequestsData | undefined;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>)): OperationInfiniteData<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>,
            data: ListGroupFollowUpRequestsData | undefined
        ]>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters> | (DeepReadonly<ListGroupFollowUpRequestsParameters>)): QueryState<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsError> | undefined;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupFollowUpRequestsParameters> | ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>): QueryState<OperationInfiniteData<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters>, ListGroupFollowUpRequestsError> | undefined;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupFollowUpRequestsParameters>) | ServiceOperationQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>, updater: Updater<NoInfer<ListGroupFollowUpRequestsData> | undefined, NoInfer<DeepReadonly<ListGroupFollowUpRequestsData>> | undefined>, options?: SetDataOptions): ListGroupFollowUpRequestsData | undefined;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupFollowUpRequestsParameters>) | ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupFollowUpRequestsData, ListGroupFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>, updater: Updater<NoInfer<ListGroupFollowUpRequestsData> | undefined, NoInfer<ListGroupFollowUpRequestsData> | undefined>, options?: SetDataOptions): Array<ListGroupFollowUpRequestsData | undefined>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>): void;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Follow Up Requests
         * @description Every follow-up request the group's students carry.
         *
         * Omitting `status` hides `pending` and `in_progress`, which is legacy's
         * value-less filter default; supplying any value REPLACES that exclusion rather
         * than intersecting with it, so `?status=pending` returns exactly the rows the
         * bare list hides.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestsSchema, ListGroupFollowUpRequestsData, TInfinite, ListGroupFollowUpRequestsParameters, ListGroupFollowUpRequestsError>): number;
        schema: ListGroupFollowUpRequestsSchema;
        types: {
            parameters: ListGroupFollowUpRequestsParameters;
            data: ListGroupFollowUpRequestsData;
            error: ListGroupFollowUpRequestsError;
        };
    };
    /**
     * @summary Create Group Follow Up Request
     * @description A study helper asks that one of their group's students be visited.
     *
     * A request for a private unverified postal student auto-approves and never
     * reaches the student's consent popup.
     */
    createGroupFollowUpRequest: {
        /**
         * @summary Create Group Follow Up Request
         * @description A study helper asks that one of their group's students be visited.
         *
         * A request for a private unverified postal student auto-approves and never
         * reaches the student's consent popup.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestParameters, TMeta, TSignal>, client?: (schema: CreateGroupFollowUpRequestSchema, options: ServiceOperationMutationFnOptions<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestError>>): Promise<RequestFnResponse<CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestError>>;
        /**
         * @summary Create Group Follow Up Request
         * @description A study helper asks that one of their group's students be visited.
         *
         * A request for a private unverified postal student auto-approves and never
         * reaches the student's consent popup.
         */
        getMutationKey(parameters: DeepReadonly<CreateGroupFollowUpRequestParameters> | void): ServiceOperationMutationKey<CreateGroupFollowUpRequestSchema, CreateGroupFollowUpRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Group Follow Up Request
         * @description A study helper asks that one of their group's students be visited.
         *
         * A request for a private unverified postal student auto-approves and never
         * reaches the student's consent popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupFollowUpRequest.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateGroupFollowUpRequestBody, TContext = unknown>(parameters: DeepReadonly<CreateGroupFollowUpRequestParameters>, options?: ServiceOperationUseMutationOptions<CreateGroupFollowUpRequestSchema, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, TVariables, OperationError<CreateGroupFollowUpRequestError>, TContext>): UseMutationResult<CreateGroupFollowUpRequestData, OperationError<CreateGroupFollowUpRequestError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Group Follow Up Request
         * @description A study helper asks that one of their group's students be visited.
         *
         * A request for a private unverified postal student auto-approves and never
         * reaches the student's consent popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupFollowUpRequest.useMutation({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createGroupFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateGroupFollowUpRequestSchema, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, TVariables, OperationError<CreateGroupFollowUpRequestError>, TContext>): UseMutationResult<CreateGroupFollowUpRequestData, OperationError<CreateGroupFollowUpRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Group Follow Up Request
         * @description A study helper asks that one of their group's students be visited.
         *
         * A request for a private unverified postal student auto-approves and never
         * reaches the student's consent popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createGroupFollowUpRequestTotal = qraft.v3Service.createGroupFollowUpRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createGroupFollowUpRequestTotal = qraft.v3Service.createGroupFollowUpRequest.useIsMutating({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CreateGroupFollowUpRequestSchema, CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Group Follow Up Request
         * @description A study helper asks that one of their group's students be visited.
         *
         * A request for a private unverified postal student auto-approves and never
         * reaches the student's consent popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createGroupFollowUpRequestPendingMutationVariables = qraft.v3Service.createGroupFollowUpRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createGroupFollowUpRequestMutationData = qraft.v3Service.createGroupFollowUpRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateGroupFollowUpRequestData, OperationError<CreateGroupFollowUpRequestError>, MutationVariables<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CreateGroupFollowUpRequestSchema, CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext>;
            select?: (mutation: Mutation<CreateGroupFollowUpRequestData, OperationError<CreateGroupFollowUpRequestError>, MutationVariables<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Group Follow Up Request
         * @description A study helper asks that one of their group's students be visited.
         *
         * A request for a private unverified postal student auto-approves and never
         * reaches the student's consent popup.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CreateGroupFollowUpRequestSchema, CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Group Follow Up Request
         * @description A study helper asks that one of their group's students be visited.
         *
         * A request for a private unverified postal student auto-approves and never
         * reaches the student's consent popup.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createGroupFollowUpRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createGroupFollowUpRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CreateGroupFollowUpRequestSchema, CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext>): Mutation<CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestError, MutationVariables<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CreateGroupFollowUpRequestSchema, CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestParameters, OperationError<CreateGroupFollowUpRequestError>, TContext>): Array<Mutation<CreateGroupFollowUpRequestData, CreateGroupFollowUpRequestError, MutationVariables<CreateGroupFollowUpRequestBody, CreateGroupFollowUpRequestParameters>, TContext>>;
        };
        schema: CreateGroupFollowUpRequestSchema;
        types: {
            parameters: CreateGroupFollowUpRequestParameters;
            data: CreateGroupFollowUpRequestData;
            error: CreateGroupFollowUpRequestError;
            body: CreateGroupFollowUpRequestBody;
        };
    };
    /**
     * @summary List Group Pending Follow Up Requests
     * @description The group's requests still waiting on their student's answer.
     *
     * Four fixed predicates and no controls of any kind: the student is in the
     * group's derived roster, the creator is one of the group's helpers, the request
     * is unadopted, and its status is `pending`.
     */
    listGroupPendingFollowUpRequests: {
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupPendingFollowUpRequestsParameters, TMeta, TSignal>), client?: (schema: ListGroupPendingFollowUpRequestsSchema, options: {
            parameters: ListGroupPendingFollowUpRequestsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError>>): Promise<RequestFnResponse<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError>>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupPendingFollowUpRequestsParameters>): ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupPendingFollowUpRequests.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupPendingFollowUpRequests.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>), options: Omit<DefinedInitialDataOptions<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupPendingFollowUpRequestsError>>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupPendingFollowUpRequestsParameters>): ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupPendingFollowUpRequests.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupPendingFollowUpRequestsParameters, TQueryFnData = ListGroupPendingFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListGroupPendingFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupPendingFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupPendingFollowUpRequests.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupPendingFollowUpRequestsParameters, TQueryFnData = ListGroupPendingFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListGroupPendingFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupPendingFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupPendingFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupPendingFollowUpRequestsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupPendingFollowUpRequestsTotal = qraft.v3Service.listGroupPendingFollowUpRequests.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupPendingFollowUpRequestsByParametersTotal = qraft.v3Service.listGroupPendingFollowUpRequests.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupPendingFollowUpRequestsResults = qraft.v3Service.listGroupPendingFollowUpRequests.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupPendingFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupPendingFollowUpRequestsCombinedResults = qraft.v3Service.listGroupPendingFollowUpRequests.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupPendingFollowUpRequestsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError>>, TCombinedResult = Array<UseQueryResult<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupPendingFollowUpRequests.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupPendingFollowUpRequests.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupPendingFollowUpRequestsParameters, TData = ListGroupPendingFollowUpRequestsData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError, OperationInfiniteData<TData, ListGroupPendingFollowUpRequestsParameters>, ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupPendingFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupPendingFollowUpRequestsParameters>, OperationError<ListGroupPendingFollowUpRequestsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupPendingFollowUpRequestsData = qraft.v3Service.listGroupPendingFollowUpRequests.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupPendingFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupPendingFollowUpRequestsCombinedData = qraft.v3Service.listGroupPendingFollowUpRequests.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupPendingFollowUpRequestsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>): Promise<ListGroupPendingFollowUpRequestsData>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>): Promise<void>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>): Promise<ListGroupPendingFollowUpRequestsData>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupPendingFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListGroupPendingFollowUpRequestsError>): Promise<OperationInfiniteData<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters>>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupPendingFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListGroupPendingFollowUpRequestsError>): Promise<void>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupPendingFollowUpRequestsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListGroupPendingFollowUpRequestsError>): Promise<OperationInfiniteData<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters>>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>)): ListGroupPendingFollowUpRequestsData | undefined;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>)): OperationInfiniteData<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>,
            data: ListGroupPendingFollowUpRequestsData | undefined
        ]>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters> | (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>)): QueryState<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsError> | undefined;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupPendingFollowUpRequestsParameters> | ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>): QueryState<OperationInfiniteData<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters>, ListGroupPendingFollowUpRequestsError> | undefined;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>) | ServiceOperationQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>, updater: Updater<NoInfer<ListGroupPendingFollowUpRequestsData> | undefined, NoInfer<DeepReadonly<ListGroupPendingFollowUpRequestsData>> | undefined>, options?: SetDataOptions): ListGroupPendingFollowUpRequestsData | undefined;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupPendingFollowUpRequestsParameters>) | ServiceOperationInfiniteQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupPendingFollowUpRequestsData, ListGroupPendingFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>, updater: Updater<NoInfer<ListGroupPendingFollowUpRequestsData> | undefined, NoInfer<ListGroupPendingFollowUpRequestsData> | undefined>, options?: SetDataOptions): Array<ListGroupPendingFollowUpRequestsData | undefined>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>): void;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Pending Follow Up Requests
         * @description The group's requests still waiting on their student's answer.
         *
         * Four fixed predicates and no controls of any kind: the student is in the
         * group's derived roster, the creator is one of the group's helpers, the request
         * is unadopted, and its status is `pending`.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListGroupPendingFollowUpRequestsSchema, ListGroupPendingFollowUpRequestsData, TInfinite, ListGroupPendingFollowUpRequestsParameters, ListGroupPendingFollowUpRequestsError>): number;
        schema: ListGroupPendingFollowUpRequestsSchema;
        types: {
            parameters: ListGroupPendingFollowUpRequestsParameters;
            data: ListGroupPendingFollowUpRequestsData;
            error: ListGroupPendingFollowUpRequestsError;
        };
    };
    /**
     * @summary List Group Follow Up Request Student Options
     * @description The create wizard's target-student picker.
     *
     * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
     * tab admits any member.
     */
    listGroupFollowUpRequestStudentOptions: {
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupFollowUpRequestStudentOptionsParameters, TMeta, TSignal>), client?: (schema: ListGroupFollowUpRequestStudentOptionsSchema, options: {
            parameters: ListGroupFollowUpRequestStudentOptionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError>>): Promise<RequestFnResponse<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError>>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>): ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupFollowUpRequestStudentOptionsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError, TData, ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupFollowUpRequestStudentOptionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupFollowUpRequestStudentOptionsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>), options: Omit<DefinedInitialDataOptions<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError, TData, ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupFollowUpRequestStudentOptionsError>>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>): ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupFollowUpRequestStudentOptionsParameters, TQueryFnData = ListGroupFollowUpRequestStudentOptionsData, TData = OperationInfiniteData<TQueryFnData, ListGroupFollowUpRequestStudentOptionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupFollowUpRequestStudentOptionsError, TData, ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupFollowUpRequestStudentOptionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupFollowUpRequestStudentOptionsParameters, TQueryFnData = ListGroupFollowUpRequestStudentOptionsData, TData = OperationInfiniteData<TQueryFnData, ListGroupFollowUpRequestStudentOptionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupFollowUpRequestStudentOptionsError, TData, ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupFollowUpRequestStudentOptionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupFollowUpRequestStudentOptionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupFollowUpRequestStudentOptionsTotal = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupFollowUpRequestStudentOptionsByParametersTotal = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupFollowUpRequestStudentOptionsResults = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpRequestStudentOptionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupFollowUpRequestStudentOptionsCombinedResults = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpRequestStudentOptionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError>>, TCombinedResult = Array<UseQueryResult<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupFollowUpRequestStudentOptionsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError, TData, ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupFollowUpRequestStudentOptionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupFollowUpRequestStudentOptionsParameters, TData = ListGroupFollowUpRequestStudentOptionsData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError, OperationInfiniteData<TData, ListGroupFollowUpRequestStudentOptionsParameters>, ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupFollowUpRequestStudentOptionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupFollowUpRequestStudentOptionsParameters>, OperationError<ListGroupFollowUpRequestStudentOptionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupFollowUpRequestStudentOptionsData = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpRequestStudentOptionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupFollowUpRequestStudentOptionsCombinedData = qraft.v3Service.listGroupFollowUpRequestStudentOptions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpRequestStudentOptionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>): Promise<ListGroupFollowUpRequestStudentOptionsData>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>): Promise<void>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>): Promise<ListGroupFollowUpRequestStudentOptionsData>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupFollowUpRequestStudentOptionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpRequestStudentOptionsError>): Promise<OperationInfiniteData<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters>>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupFollowUpRequestStudentOptionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpRequestStudentOptionsError>): Promise<void>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupFollowUpRequestStudentOptionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpRequestStudentOptionsError>): Promise<OperationInfiniteData<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters>>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>)): ListGroupFollowUpRequestStudentOptionsData | undefined;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>)): OperationInfiniteData<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters> | undefined;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>,
            data: ListGroupFollowUpRequestStudentOptionsData | undefined
        ]>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters> | (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>)): QueryState<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsError> | undefined;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters> | ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>): QueryState<OperationInfiniteData<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters>, ListGroupFollowUpRequestStudentOptionsError> | undefined;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>) | ServiceOperationQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>, updater: Updater<NoInfer<ListGroupFollowUpRequestStudentOptionsData> | undefined, NoInfer<DeepReadonly<ListGroupFollowUpRequestStudentOptionsData>> | undefined>, options?: SetDataOptions): ListGroupFollowUpRequestStudentOptionsData | undefined;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupFollowUpRequestStudentOptionsParameters>) | ServiceOperationInfiniteQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupFollowUpRequestStudentOptionsData, ListGroupFollowUpRequestStudentOptionsParameters> | undefined;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>, updater: Updater<NoInfer<ListGroupFollowUpRequestStudentOptionsData> | undefined, NoInfer<ListGroupFollowUpRequestStudentOptionsData> | undefined>, options?: SetDataOptions): Array<ListGroupFollowUpRequestStudentOptionsData | undefined>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>): void;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Follow Up Request Student Options
         * @description The create wizard's target-student picker.
         *
         * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
         * tab admits any member.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError> | QueryFiltersByQueryKey<ListGroupFollowUpRequestStudentOptionsSchema, ListGroupFollowUpRequestStudentOptionsData, TInfinite, ListGroupFollowUpRequestStudentOptionsParameters, ListGroupFollowUpRequestStudentOptionsError>): number;
        schema: ListGroupFollowUpRequestStudentOptionsSchema;
        types: {
            parameters: ListGroupFollowUpRequestStudentOptionsParameters;
            data: ListGroupFollowUpRequestStudentOptionsData;
            error: ListGroupFollowUpRequestStudentOptionsError;
        };
    };
    /**
     * @summary Get Group Follow Up Request Draft
     * @description Everything step 2 of the create wizard renders, for one target student.
     *
     * Each objective's `disabled` / `checked` state is resolved server-side: a
     * disabled checkbox is never submitted, so the client cannot derive it from a
     * status.
     */
    getGroupFollowUpRequestDraft: {
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupFollowUpRequestDraftParameters, TMeta, TSignal>), client?: (schema: GetGroupFollowUpRequestDraftSchema, options: {
            parameters: GetGroupFollowUpRequestDraftParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError>>): Promise<RequestFnResponse<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError>>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        getQueryKey(parameters: DeepReadonly<GetGroupFollowUpRequestDraftParameters>): ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupFollowUpRequestDraft.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupFollowUpRequestDraftData>(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError, TData, ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupFollowUpRequestDraftError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupFollowUpRequestDraft.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupFollowUpRequestDraftData>(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>), options: Omit<DefinedInitialDataOptions<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError, TData, ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupFollowUpRequestDraftError>>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupFollowUpRequestDraftParameters>): ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupFollowUpRequestDraft.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupFollowUpRequestDraftParameters, TQueryFnData = GetGroupFollowUpRequestDraftData, TData = OperationInfiniteData<TQueryFnData, GetGroupFollowUpRequestDraftParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupFollowUpRequestDraftError, TData, ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupFollowUpRequestDraftError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupFollowUpRequestDraft.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupFollowUpRequestDraftParameters, TQueryFnData = GetGroupFollowUpRequestDraftData, TData = OperationInfiniteData<TQueryFnData, GetGroupFollowUpRequestDraftParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupFollowUpRequestDraftError, TData, ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupFollowUpRequestDraftData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupFollowUpRequestDraftError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupFollowUpRequestDraftTotal = qraft.v3Service.getGroupFollowUpRequestDraft.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupFollowUpRequestDraftByParametersTotal = qraft.v3Service.getGroupFollowUpRequestDraft.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupFollowUpRequestDraftResults = qraft.v3Service.getGroupFollowUpRequestDraft.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupFollowUpRequestDraftResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupFollowUpRequestDraftCombinedResults = qraft.v3Service.getGroupFollowUpRequestDraft.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupFollowUpRequestDraftCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError>>, TCombinedResult = Array<UseQueryResult<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupFollowUpRequestDraft.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupFollowUpRequestDraftData>(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError, TData, ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupFollowUpRequestDraftError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupFollowUpRequestDraft.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupFollowUpRequestDraftParameters, TData = GetGroupFollowUpRequestDraftData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError, OperationInfiniteData<TData, GetGroupFollowUpRequestDraftParameters>, ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupFollowUpRequestDraftData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupFollowUpRequestDraftParameters>, OperationError<GetGroupFollowUpRequestDraftError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupFollowUpRequestDraftData = qraft.v3Service.getGroupFollowUpRequestDraft.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupFollowUpRequestDraftResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupFollowUpRequestDraftCombinedData = qraft.v3Service.getGroupFollowUpRequestDraft.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupFollowUpRequestDraftCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>): Promise<GetGroupFollowUpRequestDraftData>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>): Promise<void>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>): Promise<GetGroupFollowUpRequestDraftData>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        fetchInfiniteQuery<TPageParam extends GetGroupFollowUpRequestDraftParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters, DeepReadonly<TPageParam>, GetGroupFollowUpRequestDraftError>): Promise<OperationInfiniteData<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters>>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        prefetchInfiniteQuery<TPageParam extends GetGroupFollowUpRequestDraftParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters, DeepReadonly<TPageParam>, GetGroupFollowUpRequestDraftError>): Promise<void>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        ensureInfiniteQueryData<TPageParam extends GetGroupFollowUpRequestDraftParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters, DeepReadonly<TPageParam>, GetGroupFollowUpRequestDraftError>): Promise<OperationInfiniteData<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters>>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>)): GetGroupFollowUpRequestDraftData | undefined;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>)): OperationInfiniteData<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters> | undefined;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>,
            data: GetGroupFollowUpRequestDraftData | undefined
        ]>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters> | (DeepReadonly<GetGroupFollowUpRequestDraftParameters>)): QueryState<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftError> | undefined;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupFollowUpRequestDraftParameters> | ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>): QueryState<OperationInfiniteData<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters>, GetGroupFollowUpRequestDraftError> | undefined;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        setQueryData(parameters: (DeepReadonly<GetGroupFollowUpRequestDraftParameters>) | ServiceOperationQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>, updater: Updater<NoInfer<GetGroupFollowUpRequestDraftData> | undefined, NoInfer<DeepReadonly<GetGroupFollowUpRequestDraftData>> | undefined>, options?: SetDataOptions): GetGroupFollowUpRequestDraftData | undefined;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupFollowUpRequestDraftParameters>) | ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupFollowUpRequestDraftData, GetGroupFollowUpRequestDraftParameters> | undefined;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>, updater: Updater<NoInfer<GetGroupFollowUpRequestDraftData> | undefined, NoInfer<GetGroupFollowUpRequestDraftData> | undefined>, options?: SetDataOptions): Array<GetGroupFollowUpRequestDraftData | undefined>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>): void;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Group Follow Up Request Draft
         * @description Everything step 2 of the create wizard renders, for one target student.
         *
         * Each objective's `disabled` / `checked` state is resolved server-side: a
         * disabled checkbox is never submitted, so the client cannot derive it from a
         * status.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestDraftSchema, GetGroupFollowUpRequestDraftData, TInfinite, GetGroupFollowUpRequestDraftParameters, GetGroupFollowUpRequestDraftError>): number;
        schema: GetGroupFollowUpRequestDraftSchema;
        types: {
            parameters: GetGroupFollowUpRequestDraftParameters;
            data: GetGroupFollowUpRequestDraftData;
            error: GetGroupFollowUpRequestDraftError;
        };
    };
    /**
     * @summary Get Group Follow Up Request
     * @description One request, as both group detail routes render it.
     *
     * Scoped to the group's derived roster: a request outside it answers 404, not
     * 403, so the endpoint is not an existence oracle over requests.
     */
    getGroupFollowUpRequest: {
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetGroupFollowUpRequestParameters, TMeta, TSignal>), client?: (schema: GetGroupFollowUpRequestSchema, options: {
            parameters: GetGroupFollowUpRequestParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError>>): Promise<RequestFnResponse<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError>>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        getQueryKey(parameters: DeepReadonly<GetGroupFollowUpRequestParameters>): ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupFollowUpRequest.useQuery({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupFollowUpRequestData>(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>), options?: Omit<UndefinedInitialDataOptions<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError, TData, ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetGroupFollowUpRequestError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getGroupFollowUpRequest.useQuery({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetGroupFollowUpRequestData>(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>), options: Omit<DefinedInitialDataOptions<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError, TData, ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetGroupFollowUpRequestError>>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetGroupFollowUpRequestParameters>): ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupFollowUpRequest.useInfiniteQuery({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupFollowUpRequestParameters, TQueryFnData = GetGroupFollowUpRequestData, TData = OperationInfiniteData<TQueryFnData, GetGroupFollowUpRequestParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupFollowUpRequestError, TData, ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetGroupFollowUpRequestError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupFollowUpRequest.useInfiniteQuery({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetGroupFollowUpRequestParameters, TQueryFnData = GetGroupFollowUpRequestData, TData = OperationInfiniteData<TQueryFnData, GetGroupFollowUpRequestParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetGroupFollowUpRequestError, TData, ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupFollowUpRequestData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetGroupFollowUpRequestError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getGroupFollowUpRequestTotal = qraft.v3Service.getGroupFollowUpRequest.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getGroupFollowUpRequestByParametersTotal = qraft.v3Service.getGroupFollowUpRequest.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             request_id: requestId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getGroupFollowUpRequestResults = qraft.v3Service.getGroupFollowUpRequest.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1,
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2,
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupFollowUpRequestResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getGroupFollowUpRequestCombinedResults = qraft.v3Service.getGroupFollowUpRequest.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1,
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2,
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupFollowUpRequestCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestData, GetGroupFollowUpRequestError>>, TCombinedResult = Array<UseQueryResult<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getGroupFollowUpRequest.useSuspenseQuery({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetGroupFollowUpRequestData>(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>), options?: Omit<UseSuspenseQueryOptions<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError, TData, ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetGroupFollowUpRequestError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getGroupFollowUpRequest.useSuspenseInfiniteQuery({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetGroupFollowUpRequestParameters, TData = GetGroupFollowUpRequestData>(parameters: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError, OperationInfiniteData<TData, GetGroupFollowUpRequestParameters>, ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetGroupFollowUpRequestData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetGroupFollowUpRequestParameters>, OperationError<GetGroupFollowUpRequestError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getGroupFollowUpRequestData = qraft.v3Service.getGroupFollowUpRequest.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1,
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2,
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupFollowUpRequestResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getGroupFollowUpRequestCombinedData = qraft.v3Service.getGroupFollowUpRequest.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1,
         *                 group_id: groupId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2,
         *                 group_id: groupId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getGroupFollowUpRequestCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestData, GetGroupFollowUpRequestError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>): Promise<GetGroupFollowUpRequestData>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>): Promise<void>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>): Promise<GetGroupFollowUpRequestData>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        fetchInfiniteQuery<TPageParam extends GetGroupFollowUpRequestParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters, DeepReadonly<TPageParam>, GetGroupFollowUpRequestError>): Promise<OperationInfiniteData<GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters>>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        prefetchInfiniteQuery<TPageParam extends GetGroupFollowUpRequestParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters, DeepReadonly<TPageParam>, GetGroupFollowUpRequestError>): Promise<void>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        ensureInfiniteQueryData<TPageParam extends GetGroupFollowUpRequestParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters, DeepReadonly<TPageParam>, GetGroupFollowUpRequestError>): Promise<OperationInfiniteData<GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters>>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>)): GetGroupFollowUpRequestData | undefined;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>)): OperationInfiniteData<GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters> | undefined;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>,
            data: NoInfer<OperationInfiniteData<GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>,
            data: GetGroupFollowUpRequestData | undefined
        ]>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters> | (DeepReadonly<GetGroupFollowUpRequestParameters>)): QueryState<GetGroupFollowUpRequestData, GetGroupFollowUpRequestError> | undefined;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetGroupFollowUpRequestParameters> | ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>): QueryState<OperationInfiniteData<GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters>, GetGroupFollowUpRequestError> | undefined;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        setQueryData(parameters: (DeepReadonly<GetGroupFollowUpRequestParameters>) | ServiceOperationQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>, updater: Updater<NoInfer<GetGroupFollowUpRequestData> | undefined, NoInfer<DeepReadonly<GetGroupFollowUpRequestData>> | undefined>, options?: SetDataOptions): GetGroupFollowUpRequestData | undefined;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetGroupFollowUpRequestParameters>) | ServiceOperationInfiniteQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetGroupFollowUpRequestData, GetGroupFollowUpRequestParameters> | undefined;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>, updater: Updater<NoInfer<GetGroupFollowUpRequestData> | undefined, NoInfer<GetGroupFollowUpRequestData> | undefined>, options?: SetDataOptions): Array<GetGroupFollowUpRequestData | undefined>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>): void;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Group Follow Up Request
         * @description One request, as both group detail routes render it.
         *
         * Scoped to the group's derived roster: a request outside it answers 404, not
         * 403, so the endpoint is not an existence oracle over requests.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError> | QueryFiltersByQueryKey<GetGroupFollowUpRequestSchema, GetGroupFollowUpRequestData, TInfinite, GetGroupFollowUpRequestParameters, GetGroupFollowUpRequestError>): number;
        schema: GetGroupFollowUpRequestSchema;
        types: {
            parameters: GetGroupFollowUpRequestParameters;
            data: GetGroupFollowUpRequestData;
            error: GetGroupFollowUpRequestError;
        };
    };
    /**
     * @summary List Group Follow Ups
     * @description The in-person follow-ups the group's students carry.
     *
     * Omitting `status` returns all seven. The group axis is the student's current helper,
     * not `follow_ups.study_helper_id`.
     */
    listGroupFollowUps: {
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListGroupFollowUpsParameters, TMeta, TSignal>), client?: (schema: ListGroupFollowUpsSchema, options: {
            parameters: ListGroupFollowUpsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListGroupFollowUpsData, ListGroupFollowUpsError>>): Promise<RequestFnResponse<ListGroupFollowUpsData, ListGroupFollowUpsError>>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        getQueryKey(parameters: DeepReadonly<ListGroupFollowUpsParameters>): ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupFollowUps.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupFollowUpsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>), options?: Omit<UndefinedInitialDataOptions<ListGroupFollowUpsData, ListGroupFollowUpsError, TData, ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListGroupFollowUpsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listGroupFollowUps.useQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListGroupFollowUpsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>), options: Omit<DefinedInitialDataOptions<ListGroupFollowUpsData, ListGroupFollowUpsError, TData, ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListGroupFollowUpsError>>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListGroupFollowUpsParameters>): ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUps.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupFollowUpsParameters, TQueryFnData = ListGroupFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListGroupFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListGroupFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUps.useInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListGroupFollowUpsParameters, TQueryFnData = ListGroupFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListGroupFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListGroupFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListGroupFollowUpsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listGroupFollowUpsTotal = qraft.v3Service.listGroupFollowUps.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listGroupFollowUpsByParametersTotal = qraft.v3Service.listGroupFollowUps.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             group_id: groupId
         *         },
         *         query: {
         *             id: id
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError> | QueryFiltersByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listGroupFollowUpsResults = qraft.v3Service.listGroupFollowUps.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listGroupFollowUpsCombinedResults = qraft.v3Service.listGroupFollowUps.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters, ListGroupFollowUpsData, ListGroupFollowUpsError>>, TCombinedResult = Array<UseQueryResult<ListGroupFollowUpsData, ListGroupFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListGroupFollowUpsData, ListGroupFollowUpsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listGroupFollowUps.useSuspenseQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListGroupFollowUpsData>(parameters: ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>), options?: Omit<UseSuspenseQueryOptions<ListGroupFollowUpsData, ListGroupFollowUpsError, TData, ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListGroupFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listGroupFollowUps.useSuspenseInfiniteQuery({
         *     path: {
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListGroupFollowUpsParameters, TData = ListGroupFollowUpsData>(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListGroupFollowUpsData, ListGroupFollowUpsError, OperationInfiniteData<TData, ListGroupFollowUpsParameters>, ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListGroupFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListGroupFollowUpsParameters>, OperationError<ListGroupFollowUpsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listGroupFollowUpsData = qraft.v3Service.listGroupFollowUps.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listGroupFollowUpsCombinedData = qraft.v3Service.listGroupFollowUps.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 group_id: groupId1
         *             },
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 group_id: groupId2
         *             },
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listGroupFollowUpsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters, ListGroupFollowUpsData, ListGroupFollowUpsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListGroupFollowUpsData, ListGroupFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListGroupFollowUpsData, ListGroupFollowUpsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupFollowUpsSchema, ListGroupFollowUpsData, ListGroupFollowUpsParameters, ListGroupFollowUpsError>): Promise<ListGroupFollowUpsData>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListGroupFollowUpsSchema, ListGroupFollowUpsData, ListGroupFollowUpsParameters, ListGroupFollowUpsError>): Promise<void>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListGroupFollowUpsSchema, ListGroupFollowUpsData, ListGroupFollowUpsParameters, ListGroupFollowUpsError>): Promise<ListGroupFollowUpsData>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        fetchInfiniteQuery<TPageParam extends ListGroupFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupFollowUpsSchema, ListGroupFollowUpsData, ListGroupFollowUpsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpsError>): Promise<OperationInfiniteData<ListGroupFollowUpsData, ListGroupFollowUpsParameters>>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        prefetchInfiniteQuery<TPageParam extends ListGroupFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListGroupFollowUpsSchema, ListGroupFollowUpsData, ListGroupFollowUpsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpsError>): Promise<void>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        ensureInfiniteQueryData<TPageParam extends ListGroupFollowUpsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListGroupFollowUpsSchema, ListGroupFollowUpsData, ListGroupFollowUpsParameters, DeepReadonly<TPageParam>, ListGroupFollowUpsError>): Promise<OperationInfiniteData<ListGroupFollowUpsData, ListGroupFollowUpsParameters>>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>)): ListGroupFollowUpsData | undefined;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>)): OperationInfiniteData<ListGroupFollowUpsData, ListGroupFollowUpsParameters> | undefined;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError> | QueryFiltersByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>,
            data: NoInfer<OperationInfiniteData<ListGroupFollowUpsData, ListGroupFollowUpsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>,
            data: ListGroupFollowUpsData | undefined
        ]>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters> | (DeepReadonly<ListGroupFollowUpsParameters>)): QueryState<ListGroupFollowUpsData, ListGroupFollowUpsError> | undefined;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListGroupFollowUpsParameters> | ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>): QueryState<OperationInfiniteData<ListGroupFollowUpsData, ListGroupFollowUpsParameters>, ListGroupFollowUpsError> | undefined;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        setQueryData(parameters: (DeepReadonly<ListGroupFollowUpsParameters>) | ServiceOperationQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>, updater: Updater<NoInfer<ListGroupFollowUpsData> | undefined, NoInfer<DeepReadonly<ListGroupFollowUpsData>> | undefined>, options?: SetDataOptions): ListGroupFollowUpsData | undefined;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListGroupFollowUpsParameters>) | ServiceOperationInfiniteQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListGroupFollowUpsData, ListGroupFollowUpsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListGroupFollowUpsData, ListGroupFollowUpsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListGroupFollowUpsData, ListGroupFollowUpsParameters> | undefined;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError> | QueryFiltersByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>, updater: Updater<NoInfer<ListGroupFollowUpsData> | undefined, NoInfer<ListGroupFollowUpsData> | undefined>, options?: SetDataOptions): Array<ListGroupFollowUpsData | undefined>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError> | QueryFiltersByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError> | QueryFiltersByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError> | QueryFiltersByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>): void;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError> | QueryFiltersByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Group Follow Ups
         * @description The in-person follow-ups the group's students carry.
         *
         * Omitting `status` returns all seven. The group axis is the student's current helper,
         * not `follow_ups.study_helper_id`.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError> | QueryFiltersByQueryKey<ListGroupFollowUpsSchema, ListGroupFollowUpsData, TInfinite, ListGroupFollowUpsParameters, ListGroupFollowUpsError>): number;
        schema: ListGroupFollowUpsSchema;
        types: {
            parameters: ListGroupFollowUpsParameters;
            data: ListGroupFollowUpsData;
            error: ListGroupFollowUpsError;
        };
    };
    /**
     * @summary Cancel Group Follow Up Request
     * @description The student's assigned study helper withdraws a pending request.
     *
     * `reason` is required and non-empty, and a request that is no longer `pending`
     * is refused — legacy had no such guard and could orphan a follow-up.
     */
    cancelGroupFollowUpRequest: {
        /**
         * @summary Cancel Group Follow Up Request
         * @description The student's assigned study helper withdraws a pending request.
         *
         * `reason` is required and non-empty, and a request that is no longer `pending`
         * is refused — legacy had no such guard and could orphan a follow-up.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestParameters, TMeta, TSignal>, client?: (schema: CancelGroupFollowUpRequestSchema, options: ServiceOperationMutationFnOptions<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestError>>): Promise<RequestFnResponse<CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestError>>;
        /**
         * @summary Cancel Group Follow Up Request
         * @description The student's assigned study helper withdraws a pending request.
         *
         * `reason` is required and non-empty, and a request that is no longer `pending`
         * is refused — legacy had no such guard and could orphan a follow-up.
         */
        getMutationKey(parameters: DeepReadonly<CancelGroupFollowUpRequestParameters> | void): ServiceOperationMutationKey<CancelGroupFollowUpRequestSchema, CancelGroupFollowUpRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Cancel Group Follow Up Request
         * @description The student's assigned study helper withdraws a pending request.
         *
         * `reason` is required and non-empty, and a request that is no longer `pending`
         * is refused — legacy had no such guard and could orphan a follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.cancelGroupFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.cancelGroupFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CancelGroupFollowUpRequestBody, TContext = unknown>(parameters: DeepReadonly<CancelGroupFollowUpRequestParameters>, options?: ServiceOperationUseMutationOptions<CancelGroupFollowUpRequestSchema, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, TVariables, OperationError<CancelGroupFollowUpRequestError>, TContext>): UseMutationResult<CancelGroupFollowUpRequestData, OperationError<CancelGroupFollowUpRequestError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Cancel Group Follow Up Request
         * @description The student's assigned study helper withdraws a pending request.
         *
         * `reason` is required and non-empty, and a request that is no longer `pending`
         * is refused — legacy had no such guard and could orphan a follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.cancelGroupFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.cancelGroupFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CancelGroupFollowUpRequestSchema, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, TVariables, OperationError<CancelGroupFollowUpRequestError>, TContext>): UseMutationResult<CancelGroupFollowUpRequestData, OperationError<CancelGroupFollowUpRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Cancel Group Follow Up Request
         * @description The student's assigned study helper withdraws a pending request.
         *
         * `reason` is required and non-empty, and a request that is no longer `pending`
         * is refused — legacy had no such guard and could orphan a follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const cancelGroupFollowUpRequestTotal = qraft.v3Service.cancelGroupFollowUpRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const cancelGroupFollowUpRequestTotal = qraft.v3Service.cancelGroupFollowUpRequest.useIsMutating({
         *     parameters: {
         *         path: {
         *             request_id: requestId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CancelGroupFollowUpRequestSchema, CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Cancel Group Follow Up Request
         * @description The student's assigned study helper withdraws a pending request.
         *
         * `reason` is required and non-empty, and a request that is no longer `pending`
         * is refused — legacy had no such guard and could orphan a follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const cancelGroupFollowUpRequestPendingMutationVariables = qraft.v3Service.cancelGroupFollowUpRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const cancelGroupFollowUpRequestMutationData = qraft.v3Service.cancelGroupFollowUpRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 request_id: requestId,
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CancelGroupFollowUpRequestData, OperationError<CancelGroupFollowUpRequestError>, MutationVariables<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CancelGroupFollowUpRequestSchema, CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext>;
            select?: (mutation: Mutation<CancelGroupFollowUpRequestData, OperationError<CancelGroupFollowUpRequestError>, MutationVariables<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Cancel Group Follow Up Request
         * @description The student's assigned study helper withdraws a pending request.
         *
         * `reason` is required and non-empty, and a request that is no longer `pending`
         * is refused — legacy had no such guard and could orphan a follow-up.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CancelGroupFollowUpRequestSchema, CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Cancel Group Follow Up Request
         * @description The student's assigned study helper withdraws a pending request.
         *
         * `reason` is required and non-empty, and a request that is no longer `pending`
         * is refused — legacy had no such guard and could orphan a follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.cancelGroupFollowUpRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             request_id: requestId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.cancelGroupFollowUpRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CancelGroupFollowUpRequestSchema, CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext>): Mutation<CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestError, MutationVariables<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<CancelGroupFollowUpRequestSchema, CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestParameters, OperationError<CancelGroupFollowUpRequestError>, TContext>): Array<Mutation<CancelGroupFollowUpRequestData, CancelGroupFollowUpRequestError, MutationVariables<CancelGroupFollowUpRequestBody, CancelGroupFollowUpRequestParameters>, TContext>>;
        };
        schema: CancelGroupFollowUpRequestSchema;
        types: {
            parameters: CancelGroupFollowUpRequestParameters;
            data: CancelGroupFollowUpRequestData;
            error: CancelGroupFollowUpRequestError;
            body: CancelGroupFollowUpRequestBody;
        };
    };
    /**
     * @summary Dismiss Group Follow Up Request
     * @description The study helper acknowledges a student's rejection.
     *
     * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
     * the row itself is the only observable change.
     */
    dismissGroupFollowUpRequest: {
        /**
         * @summary Dismiss Group Follow Up Request
         * @description The study helper acknowledges a student's rejection.
         *
         * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
         * the row itself is the only observable change.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestParameters, TMeta, TSignal>, client?: (schema: DismissGroupFollowUpRequestSchema, options: ServiceOperationMutationFnOptions<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestError>>): Promise<RequestFnResponse<DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestError>>;
        /**
         * @summary Dismiss Group Follow Up Request
         * @description The study helper acknowledges a student's rejection.
         *
         * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
         * the row itself is the only observable change.
         */
        getMutationKey(parameters: DeepReadonly<DismissGroupFollowUpRequestParameters> | void): ServiceOperationMutationKey<DismissGroupFollowUpRequestSchema, DismissGroupFollowUpRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Dismiss Group Follow Up Request
         * @description The study helper acknowledges a student's rejection.
         *
         * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
         * the row itself is the only observable change.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.dismissGroupFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.dismissGroupFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DismissGroupFollowUpRequestBody, TContext = unknown>(parameters: DeepReadonly<DismissGroupFollowUpRequestParameters>, options?: ServiceOperationUseMutationOptions<DismissGroupFollowUpRequestSchema, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, TVariables, OperationError<DismissGroupFollowUpRequestError>, TContext>): UseMutationResult<DismissGroupFollowUpRequestData, OperationError<DismissGroupFollowUpRequestError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Dismiss Group Follow Up Request
         * @description The study helper acknowledges a student's rejection.
         *
         * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
         * the row itself is the only observable change.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.dismissGroupFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.dismissGroupFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId,
         *         group_id: groupId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DismissGroupFollowUpRequestSchema, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, TVariables, OperationError<DismissGroupFollowUpRequestError>, TContext>): UseMutationResult<DismissGroupFollowUpRequestData, OperationError<DismissGroupFollowUpRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Dismiss Group Follow Up Request
         * @description The study helper acknowledges a student's rejection.
         *
         * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
         * the row itself is the only observable change.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const dismissGroupFollowUpRequestTotal = qraft.v3Service.dismissGroupFollowUpRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const dismissGroupFollowUpRequestTotal = qraft.v3Service.dismissGroupFollowUpRequest.useIsMutating({
         *     parameters: {
         *         path: {
         *             request_id: requestId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<DismissGroupFollowUpRequestSchema, DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Dismiss Group Follow Up Request
         * @description The study helper acknowledges a student's rejection.
         *
         * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
         * the row itself is the only observable change.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const dismissGroupFollowUpRequestPendingMutationVariables = qraft.v3Service.dismissGroupFollowUpRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const dismissGroupFollowUpRequestMutationData = qraft.v3Service.dismissGroupFollowUpRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 request_id: requestId,
         *                 group_id: groupId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DismissGroupFollowUpRequestData, OperationError<DismissGroupFollowUpRequestError>, MutationVariables<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<DismissGroupFollowUpRequestSchema, DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext>;
            select?: (mutation: Mutation<DismissGroupFollowUpRequestData, OperationError<DismissGroupFollowUpRequestError>, MutationVariables<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Dismiss Group Follow Up Request
         * @description The study helper acknowledges a student's rejection.
         *
         * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
         * the row itself is the only observable change.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<DismissGroupFollowUpRequestSchema, DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Dismiss Group Follow Up Request
         * @description The study helper acknowledges a student's rejection.
         *
         * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
         * the row itself is the only observable change.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.dismissGroupFollowUpRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             request_id: requestId,
         *             group_id: groupId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.dismissGroupFollowUpRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<DismissGroupFollowUpRequestSchema, DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext>): Mutation<DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestError, MutationVariables<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<DismissGroupFollowUpRequestSchema, DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestParameters, OperationError<DismissGroupFollowUpRequestError>, TContext>): Array<Mutation<DismissGroupFollowUpRequestData, DismissGroupFollowUpRequestError, MutationVariables<DismissGroupFollowUpRequestBody, DismissGroupFollowUpRequestParameters>, TContext>>;
        };
        schema: DismissGroupFollowUpRequestSchema;
        types: {
            parameters: DismissGroupFollowUpRequestParameters;
            data: DismissGroupFollowUpRequestData;
            error: DismissGroupFollowUpRequestError;
            body: DismissGroupFollowUpRequestBody;
        };
    };
    /**
     * @summary List Follow Up Request Board
     * @description Every approved, unclaimed, unconverted follow-up request in the network.
     *
     * Defaults to the caller's own approved countries and student languages, and an empty
     * preference serves an empty board, as in legacy. An admin gets neither default and
     * reads the board unfiltered. Status, claim and conversion state are fixed server-side
     * and are not parameters.
     */
    listFollowUpRequestBoard: {
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpRequestBoardParameters, TMeta, TSignal> | void), client?: (schema: ListFollowUpRequestBoardSchema, options: {
            parameters: ListFollowUpRequestBoardParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError>>): Promise<RequestFnResponse<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError>>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpRequestBoardParameters> | void): ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpRequestBoard.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpRequestBoard.useQuery({
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpRequestBoardData>(parameters: ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError, TData, ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpRequestBoardError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpRequestBoard.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpRequestBoard.useQuery({
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpRequestBoardData>(parameters: ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void), options: Omit<DefinedInitialDataOptions<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError, TData, ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpRequestBoardError>>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpRequestBoardParameters> | void): ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpRequestBoard.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpRequestBoardParameters, TQueryFnData = ListFollowUpRequestBoardData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpRequestBoardParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpRequestBoardError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpRequestBoardError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpRequestBoard.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpRequestBoardParameters, TQueryFnData = ListFollowUpRequestBoardData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpRequestBoardParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpRequestBoardError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpRequestBoardData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpRequestBoardError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpRequestBoardTotal = qraft.v3Service.listFollowUpRequestBoard.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpRequestBoardByParametersTotal = qraft.v3Service.listFollowUpRequestBoard.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | QueryFiltersByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpRequestBoardResults = qraft.v3Service.listFollowUpRequestBoard.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpRequestBoardResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpRequestBoardCombinedResults = qraft.v3Service.listFollowUpRequestBoard.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpRequestBoardCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardData, ListFollowUpRequestBoardError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpRequestBoard.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpRequestBoard.useSuspenseQuery({
         *     query: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpRequestBoardData>(parameters: ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError, TData, ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpRequestBoardError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpRequestBoard.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             student_id: initialStudentId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpRequestBoardParameters, TData = ListFollowUpRequestBoardData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError, OperationInfiniteData<TData, ListFollowUpRequestBoardParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpRequestBoardData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpRequestBoardParameters>, OperationError<ListFollowUpRequestBoardError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpRequestBoardData = qraft.v3Service.listFollowUpRequestBoard.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpRequestBoardResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpRequestBoardCombinedData = qraft.v3Service.listFollowUpRequestBoard.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpRequestBoardCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardData, ListFollowUpRequestBoardError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | void): Promise<ListFollowUpRequestBoardData>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | void): Promise<void>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | void): Promise<ListFollowUpRequestBoardData>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpRequestBoardParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters, DeepReadonly<TPageParam>, ListFollowUpRequestBoardError> | void): Promise<OperationInfiniteData<ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters>>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpRequestBoardParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters, DeepReadonly<TPageParam>, ListFollowUpRequestBoardError> | void): Promise<void>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpRequestBoardParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters, DeepReadonly<TPageParam>, ListFollowUpRequestBoardError> | void): Promise<OperationInfiniteData<ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters>>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void)): ListFollowUpRequestBoardData | undefined;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void)): OperationInfiniteData<ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters> | undefined;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | QueryFiltersByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>,
            data: ListFollowUpRequestBoardData | undefined
        ]>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | (DeepReadonly<ListFollowUpRequestBoardParameters> | void)): QueryState<ListFollowUpRequestBoardData, ListFollowUpRequestBoardError> | undefined;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpRequestBoardParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters> | void): QueryState<OperationInfiniteData<ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters>, ListFollowUpRequestBoardError> | undefined;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpRequestBoardParameters> | undefined) | ServiceOperationQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>, updater: Updater<NoInfer<ListFollowUpRequestBoardData> | undefined, NoInfer<DeepReadonly<ListFollowUpRequestBoardData>> | undefined>, options?: SetDataOptions): ListFollowUpRequestBoardData | undefined;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpRequestBoardParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpRequestBoardData, ListFollowUpRequestBoardParameters> | undefined;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | QueryFiltersByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>, updater: Updater<NoInfer<ListFollowUpRequestBoardData> | undefined, NoInfer<ListFollowUpRequestBoardData> | undefined>, options?: SetDataOptions): Array<ListFollowUpRequestBoardData | undefined>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | QueryFiltersByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | QueryFiltersByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | QueryFiltersByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>): void;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | QueryFiltersByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Request Board
         * @description Every approved, unclaimed, unconverted follow-up request in the network.
         *
         * Defaults to the caller's own approved countries and student languages, and an empty
         * preference serves an empty board, as in legacy. An admin gets neither default and
         * reads the board unfiltered. Status, claim and conversion state are fixed server-side
         * and are not parameters.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError> | QueryFiltersByQueryKey<ListFollowUpRequestBoardSchema, ListFollowUpRequestBoardData, TInfinite, ListFollowUpRequestBoardParameters, ListFollowUpRequestBoardError>): number;
        schema: ListFollowUpRequestBoardSchema;
        types: {
            parameters: ListFollowUpRequestBoardParameters;
            data: ListFollowUpRequestBoardData;
            error: ListFollowUpRequestBoardError;
        };
    };
    /**
     * @summary Get Follow Up Request Board Detail
     * @description One board request, as the View Request Detail popup renders it.
     *
     * Limited to requests on the board, requests the caller has claimed, and admins;
     * anything else is a 404, not 403, so the endpoint is not an existence oracle.
     */
    getFollowUpRequestBoardDetail: {
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetFollowUpRequestBoardDetailParameters, TMeta, TSignal>), client?: (schema: GetFollowUpRequestBoardDetailSchema, options: {
            parameters: GetFollowUpRequestBoardDetailParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError>>): Promise<RequestFnResponse<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError>>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        getQueryKey(parameters: DeepReadonly<GetFollowUpRequestBoardDetailParameters>): ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpRequestBoardDetail.useQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpRequestBoardDetailData>(parameters: ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>), options?: Omit<UndefinedInitialDataOptions<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError, TData, ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetFollowUpRequestBoardDetailError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpRequestBoardDetail.useQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpRequestBoardDetailData>(parameters: ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>), options: Omit<DefinedInitialDataOptions<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError, TData, ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetFollowUpRequestBoardDetailError>>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetFollowUpRequestBoardDetailParameters>): ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpRequestBoardDetail.useInfiniteQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpRequestBoardDetailParameters, TQueryFnData = GetFollowUpRequestBoardDetailData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpRequestBoardDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpRequestBoardDetailError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetFollowUpRequestBoardDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpRequestBoardDetail.useInfiniteQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpRequestBoardDetailParameters, TQueryFnData = GetFollowUpRequestBoardDetailData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpRequestBoardDetailParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpRequestBoardDetailError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpRequestBoardDetailData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetFollowUpRequestBoardDetailError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getFollowUpRequestBoardDetailTotal = qraft.v3Service.getFollowUpRequestBoardDetail.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getFollowUpRequestBoardDetailByParametersTotal = qraft.v3Service.getFollowUpRequestBoardDetail.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError> | QueryFiltersByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getFollowUpRequestBoardDetailResults = qraft.v3Service.getFollowUpRequestBoardDetail.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpRequestBoardDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getFollowUpRequestBoardDetailCombinedResults = qraft.v3Service.getFollowUpRequestBoardDetail.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpRequestBoardDetailCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError>>, TCombinedResult = Array<UseQueryResult<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getFollowUpRequestBoardDetail.useSuspenseQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetFollowUpRequestBoardDetailData>(parameters: ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>), options?: Omit<UseSuspenseQueryOptions<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError, TData, ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetFollowUpRequestBoardDetailError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpRequestBoardDetail.useSuspenseInfiniteQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetFollowUpRequestBoardDetailParameters, TData = GetFollowUpRequestBoardDetailData>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError, OperationInfiniteData<TData, GetFollowUpRequestBoardDetailParameters>, ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpRequestBoardDetailData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetFollowUpRequestBoardDetailParameters>, OperationError<GetFollowUpRequestBoardDetailError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getFollowUpRequestBoardDetailData = qraft.v3Service.getFollowUpRequestBoardDetail.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpRequestBoardDetailResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getFollowUpRequestBoardDetailCombinedData = qraft.v3Service.getFollowUpRequestBoardDetail.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpRequestBoardDetailCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>): Promise<GetFollowUpRequestBoardDetailData>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>): Promise<void>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>): Promise<GetFollowUpRequestBoardDetailData>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        fetchInfiniteQuery<TPageParam extends GetFollowUpRequestBoardDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters, DeepReadonly<TPageParam>, GetFollowUpRequestBoardDetailError>): Promise<OperationInfiniteData<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters>>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        prefetchInfiniteQuery<TPageParam extends GetFollowUpRequestBoardDetailParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters, DeepReadonly<TPageParam>, GetFollowUpRequestBoardDetailError>): Promise<void>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        ensureInfiniteQueryData<TPageParam extends GetFollowUpRequestBoardDetailParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters, DeepReadonly<TPageParam>, GetFollowUpRequestBoardDetailError>): Promise<OperationInfiniteData<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters>>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>)): GetFollowUpRequestBoardDetailData | undefined;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>)): OperationInfiniteData<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters> | undefined;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError> | QueryFiltersByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>,
            data: NoInfer<OperationInfiniteData<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>,
            data: GetFollowUpRequestBoardDetailData | undefined
        ]>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters> | (DeepReadonly<GetFollowUpRequestBoardDetailParameters>)): QueryState<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailError> | undefined;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetFollowUpRequestBoardDetailParameters> | ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>): QueryState<OperationInfiniteData<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters>, GetFollowUpRequestBoardDetailError> | undefined;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        setQueryData(parameters: (DeepReadonly<GetFollowUpRequestBoardDetailParameters>) | ServiceOperationQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>, updater: Updater<NoInfer<GetFollowUpRequestBoardDetailData> | undefined, NoInfer<DeepReadonly<GetFollowUpRequestBoardDetailData>> | undefined>, options?: SetDataOptions): GetFollowUpRequestBoardDetailData | undefined;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetFollowUpRequestBoardDetailParameters>) | ServiceOperationInfiniteQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetFollowUpRequestBoardDetailData, GetFollowUpRequestBoardDetailParameters> | undefined;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError> | QueryFiltersByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>, updater: Updater<NoInfer<GetFollowUpRequestBoardDetailData> | undefined, NoInfer<GetFollowUpRequestBoardDetailData> | undefined>, options?: SetDataOptions): Array<GetFollowUpRequestBoardDetailData | undefined>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError> | QueryFiltersByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError> | QueryFiltersByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError> | QueryFiltersByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>): void;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError> | QueryFiltersByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Follow Up Request Board Detail
         * @description One board request, as the View Request Detail popup renders it.
         *
         * Limited to requests on the board, requests the caller has claimed, and admins;
         * anything else is a 404, not 403, so the endpoint is not an existence oracle.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError> | QueryFiltersByQueryKey<GetFollowUpRequestBoardDetailSchema, GetFollowUpRequestBoardDetailData, TInfinite, GetFollowUpRequestBoardDetailParameters, GetFollowUpRequestBoardDetailError>): number;
        schema: GetFollowUpRequestBoardDetailSchema;
        types: {
            parameters: GetFollowUpRequestBoardDetailParameters;
            data: GetFollowUpRequestBoardDetailData;
            error: GetFollowUpRequestBoardDetailError;
        };
    };
    /**
     * @summary Take Follow Up Request
     * @description A follow-up coordinator claims one board request.
     *
     * No body and no redirect; the row leaves the board because its status becomes
     * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
     * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
     * so an admin reaching the update would be a 500 instead of a 403.
     */
    takeFollowUpRequest: {
        /**
         * @summary Take Follow Up Request
         * @description A follow-up coordinator claims one board request.
         *
         * No body and no redirect; the row leaves the board because its status becomes
         * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
         * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
         * so an admin reaching the update would be a 500 instead of a 403.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TakeFollowUpRequestBody, TakeFollowUpRequestParameters, TMeta, TSignal>, client?: (schema: TakeFollowUpRequestSchema, options: ServiceOperationMutationFnOptions<TakeFollowUpRequestBody, TakeFollowUpRequestParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TakeFollowUpRequestData, TakeFollowUpRequestError>>): Promise<RequestFnResponse<TakeFollowUpRequestData, TakeFollowUpRequestError>>;
        /**
         * @summary Take Follow Up Request
         * @description A follow-up coordinator claims one board request.
         *
         * No body and no redirect; the row leaves the board because its status becomes
         * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
         * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
         * so an admin reaching the update would be a 500 instead of a 403.
         */
        getMutationKey(parameters: DeepReadonly<TakeFollowUpRequestParameters> | void): ServiceOperationMutationKey<TakeFollowUpRequestSchema, TakeFollowUpRequestParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Take Follow Up Request
         * @description A follow-up coordinator claims one board request.
         *
         * No body and no redirect; the row leaves the board because its status becomes
         * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
         * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
         * so an admin reaching the update would be a 500 instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.takeFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.takeFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TakeFollowUpRequestBody, TContext = unknown>(parameters: DeepReadonly<TakeFollowUpRequestParameters>, options?: ServiceOperationUseMutationOptions<TakeFollowUpRequestSchema, TakeFollowUpRequestData, TakeFollowUpRequestParameters, TVariables, OperationError<TakeFollowUpRequestError>, TContext>): UseMutationResult<TakeFollowUpRequestData, OperationError<TakeFollowUpRequestError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Take Follow Up Request
         * @description A follow-up coordinator claims one board request.
         *
         * No body and no redirect; the row leaves the board because its status becomes
         * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
         * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
         * so an admin reaching the update would be a 500 instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.takeFollowUpRequest.useMutation({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.takeFollowUpRequest.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TakeFollowUpRequestBody, TakeFollowUpRequestParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TakeFollowUpRequestSchema, TakeFollowUpRequestData, TakeFollowUpRequestParameters, TVariables, OperationError<TakeFollowUpRequestError>, TContext>): UseMutationResult<TakeFollowUpRequestData, OperationError<TakeFollowUpRequestError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Take Follow Up Request
         * @description A follow-up coordinator claims one board request.
         *
         * No body and no redirect; the row leaves the board because its status becomes
         * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
         * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
         * so an admin reaching the update would be a 500 instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const takeFollowUpRequestTotal = qraft.v3Service.takeFollowUpRequest.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const takeFollowUpRequestTotal = qraft.v3Service.takeFollowUpRequest.useIsMutating({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<TakeFollowUpRequestSchema, TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Take Follow Up Request
         * @description A follow-up coordinator claims one board request.
         *
         * No body and no redirect; the row leaves the board because its status becomes
         * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
         * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
         * so an admin reaching the update would be a 500 instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const takeFollowUpRequestPendingMutationVariables = qraft.v3Service.takeFollowUpRequest.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const takeFollowUpRequestMutationData = qraft.v3Service.takeFollowUpRequest.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 request_id: requestId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TakeFollowUpRequestData, OperationError<TakeFollowUpRequestError>, MutationVariables<TakeFollowUpRequestBody, TakeFollowUpRequestParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<TakeFollowUpRequestSchema, TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext>;
            select?: (mutation: Mutation<TakeFollowUpRequestData, OperationError<TakeFollowUpRequestError>, MutationVariables<TakeFollowUpRequestBody, TakeFollowUpRequestParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Take Follow Up Request
         * @description A follow-up coordinator claims one board request.
         *
         * No body and no redirect; the row leaves the board because its status becomes
         * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
         * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
         * so an admin reaching the update would be a 500 instead of a 403.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<TakeFollowUpRequestSchema, TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Take Follow Up Request
         * @description A follow-up coordinator claims one board request.
         *
         * No body and no redirect; the row leaves the board because its status becomes
         * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
         * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
         * so an admin reaching the update would be a 500 instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.takeFollowUpRequest.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.takeFollowUpRequest.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<TakeFollowUpRequestSchema, TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext>): Mutation<TakeFollowUpRequestData, TakeFollowUpRequestError, MutationVariables<TakeFollowUpRequestBody, TakeFollowUpRequestParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext> | MutationFiltersByMutationKey<TakeFollowUpRequestSchema, TakeFollowUpRequestBody, TakeFollowUpRequestData, TakeFollowUpRequestParameters, OperationError<TakeFollowUpRequestError>, TContext>): Array<Mutation<TakeFollowUpRequestData, TakeFollowUpRequestError, MutationVariables<TakeFollowUpRequestBody, TakeFollowUpRequestParameters>, TContext>>;
        };
        schema: TakeFollowUpRequestSchema;
        types: {
            parameters: TakeFollowUpRequestParameters;
            data: TakeFollowUpRequestData;
            error: TakeFollowUpRequestError;
            body: TakeFollowUpRequestBody;
        };
    };
    /**
     * @summary List Coordinator Pending Follow Up Requests
     * @description The coordinator's convert queue: requests they adopted and have not converted.
     *
     * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
     * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
     * bypass would show an empty tab instead of a 403.
     */
    listCoordinatorPendingFollowUpRequests: {
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCoordinatorPendingFollowUpRequestsParameters, TMeta, TSignal> | void), client?: (schema: ListCoordinatorPendingFollowUpRequestsSchema, options: {
            parameters: ListCoordinatorPendingFollowUpRequestsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError>>): Promise<RequestFnResponse<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError>>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        getQueryKey(parameters: DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void): ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoordinatorPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCoordinatorPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoordinatorPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void), options: Omit<DefinedInitialDataOptions<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCoordinatorPendingFollowUpRequestsError>>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void): ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoordinatorPendingFollowUpRequestsParameters, TQueryFnData = ListCoordinatorPendingFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListCoordinatorPendingFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCoordinatorPendingFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCoordinatorPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoordinatorPendingFollowUpRequestsParameters, TQueryFnData = ListCoordinatorPendingFollowUpRequestsData, TData = OperationInfiniteData<TQueryFnData, ListCoordinatorPendingFollowUpRequestsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCoordinatorPendingFollowUpRequestsError, TData, ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoordinatorPendingFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCoordinatorPendingFollowUpRequestsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCoordinatorPendingFollowUpRequestsTotal = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCoordinatorPendingFollowUpRequestsByParametersTotal = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             id: id
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCoordinatorPendingFollowUpRequestsResults = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorPendingFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCoordinatorPendingFollowUpRequestsCombinedResults = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorPendingFollowUpRequestsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError>>, TCombinedResult = Array<UseQueryResult<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useSuspenseQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCoordinatorPendingFollowUpRequestsData>(parameters: ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError, TData, ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCoordinatorPendingFollowUpRequestsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCoordinatorPendingFollowUpRequestsParameters, TData = ListCoordinatorPendingFollowUpRequestsData>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError, OperationInfiniteData<TData, ListCoordinatorPendingFollowUpRequestsParameters>, ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoordinatorPendingFollowUpRequestsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCoordinatorPendingFollowUpRequestsParameters>, OperationError<ListCoordinatorPendingFollowUpRequestsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCoordinatorPendingFollowUpRequestsData = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorPendingFollowUpRequestsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCoordinatorPendingFollowUpRequestsCombinedData = qraft.v3Service.listCoordinatorPendingFollowUpRequests.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorPendingFollowUpRequestsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | void): Promise<ListCoordinatorPendingFollowUpRequestsData>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | void): Promise<void>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | void): Promise<ListCoordinatorPendingFollowUpRequestsData>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        fetchInfiniteQuery<TPageParam extends ListCoordinatorPendingFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListCoordinatorPendingFollowUpRequestsError> | void): Promise<OperationInfiniteData<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters>>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        prefetchInfiniteQuery<TPageParam extends ListCoordinatorPendingFollowUpRequestsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListCoordinatorPendingFollowUpRequestsError> | void): Promise<void>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        ensureInfiniteQueryData<TPageParam extends ListCoordinatorPendingFollowUpRequestsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters, DeepReadonly<TPageParam>, ListCoordinatorPendingFollowUpRequestsError> | void): Promise<OperationInfiniteData<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters>>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void)): ListCoordinatorPendingFollowUpRequestsData | undefined;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void)): OperationInfiniteData<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>,
            data: NoInfer<OperationInfiniteData<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>,
            data: ListCoordinatorPendingFollowUpRequestsData | undefined
        ]>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | void)): QueryState<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsError> | undefined;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters> | void): QueryState<OperationInfiniteData<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters>, ListCoordinatorPendingFollowUpRequestsError> | undefined;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        setQueryData(parameters: (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | undefined) | ServiceOperationQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>, updater: Updater<NoInfer<ListCoordinatorPendingFollowUpRequestsData> | undefined, NoInfer<DeepReadonly<ListCoordinatorPendingFollowUpRequestsData>> | undefined>, options?: SetDataOptions): ListCoordinatorPendingFollowUpRequestsData | undefined;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCoordinatorPendingFollowUpRequestsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCoordinatorPendingFollowUpRequestsData, ListCoordinatorPendingFollowUpRequestsParameters> | undefined;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>, updater: Updater<NoInfer<ListCoordinatorPendingFollowUpRequestsData> | undefined, NoInfer<ListCoordinatorPendingFollowUpRequestsData> | undefined>, options?: SetDataOptions): Array<ListCoordinatorPendingFollowUpRequestsData | undefined>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>): void;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Coordinator Pending Follow Up Requests
         * @description The coordinator's convert queue: requests they adopted and have not converted.
         *
         * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
         * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
         * bypass would show an empty tab instead of a 403.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError> | QueryFiltersByQueryKey<ListCoordinatorPendingFollowUpRequestsSchema, ListCoordinatorPendingFollowUpRequestsData, TInfinite, ListCoordinatorPendingFollowUpRequestsParameters, ListCoordinatorPendingFollowUpRequestsError>): number;
        schema: ListCoordinatorPendingFollowUpRequestsSchema;
        types: {
            parameters: ListCoordinatorPendingFollowUpRequestsParameters;
            data: ListCoordinatorPendingFollowUpRequestsData;
            error: ListCoordinatorPendingFollowUpRequestsError;
        };
    };
    /**
     * @summary List Coordinator Follow Ups
     * @description The follow-ups this coordinator owns.
     *
     * Omitting `status` returns all seven. `display_name` is a prefix match on the
     * student's name and is also where the table's quick search lands, so there is no
     * separate `search` parameter.
     */
    listCoordinatorFollowUps: {
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCoordinatorFollowUpsParameters, TMeta, TSignal> | void), client?: (schema: ListCoordinatorFollowUpsSchema, options: {
            parameters: ListCoordinatorFollowUpsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError>>): Promise<RequestFnResponse<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError>>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        getQueryKey(parameters: DeepReadonly<ListCoordinatorFollowUpsParameters> | void): ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorFollowUps.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorFollowUps.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoordinatorFollowUpsData>(parameters: ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError, TData, ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCoordinatorFollowUpsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorFollowUps.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorFollowUps.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoordinatorFollowUpsData>(parameters: ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void), options: Omit<DefinedInitialDataOptions<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError, TData, ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCoordinatorFollowUpsError>>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCoordinatorFollowUpsParameters> | void): ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorFollowUps.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoordinatorFollowUpsParameters, TQueryFnData = ListCoordinatorFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListCoordinatorFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCoordinatorFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCoordinatorFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorFollowUps.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoordinatorFollowUpsParameters, TQueryFnData = ListCoordinatorFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListCoordinatorFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCoordinatorFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoordinatorFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCoordinatorFollowUpsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCoordinatorFollowUpsTotal = qraft.v3Service.listCoordinatorFollowUps.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCoordinatorFollowUpsByParametersTotal = qraft.v3Service.listCoordinatorFollowUps.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             id: id
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCoordinatorFollowUpsResults = qraft.v3Service.listCoordinatorFollowUps.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCoordinatorFollowUpsCombinedResults = qraft.v3Service.listCoordinatorFollowUps.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorFollowUpsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError>>, TCombinedResult = Array<UseQueryResult<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listCoordinatorFollowUps.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCoordinatorFollowUps.useSuspenseQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCoordinatorFollowUpsData>(parameters: ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError, TData, ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCoordinatorFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorFollowUps.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCoordinatorFollowUpsParameters, TData = ListCoordinatorFollowUpsData>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError, OperationInfiniteData<TData, ListCoordinatorFollowUpsParameters>, ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoordinatorFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCoordinatorFollowUpsParameters>, OperationError<ListCoordinatorFollowUpsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCoordinatorFollowUpsData = qraft.v3Service.listCoordinatorFollowUps.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCoordinatorFollowUpsCombinedData = qraft.v3Service.listCoordinatorFollowUps.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorFollowUpsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | void): Promise<ListCoordinatorFollowUpsData>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | void): Promise<void>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | void): Promise<ListCoordinatorFollowUpsData>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        fetchInfiniteQuery<TPageParam extends ListCoordinatorFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters, DeepReadonly<TPageParam>, ListCoordinatorFollowUpsError> | void): Promise<OperationInfiniteData<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters>>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        prefetchInfiniteQuery<TPageParam extends ListCoordinatorFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters, DeepReadonly<TPageParam>, ListCoordinatorFollowUpsError> | void): Promise<void>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        ensureInfiniteQueryData<TPageParam extends ListCoordinatorFollowUpsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters, DeepReadonly<TPageParam>, ListCoordinatorFollowUpsError> | void): Promise<OperationInfiniteData<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters>>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void)): ListCoordinatorFollowUpsData | undefined;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void)): OperationInfiniteData<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters> | undefined;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>,
            data: NoInfer<OperationInfiniteData<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>,
            data: ListCoordinatorFollowUpsData | undefined
        ]>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | (DeepReadonly<ListCoordinatorFollowUpsParameters> | void)): QueryState<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsError> | undefined;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListCoordinatorFollowUpsParameters> | ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters> | void): QueryState<OperationInfiniteData<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters>, ListCoordinatorFollowUpsError> | undefined;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        setQueryData(parameters: (DeepReadonly<ListCoordinatorFollowUpsParameters> | undefined) | ServiceOperationQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>, updater: Updater<NoInfer<ListCoordinatorFollowUpsData> | undefined, NoInfer<DeepReadonly<ListCoordinatorFollowUpsData>> | undefined>, options?: SetDataOptions): ListCoordinatorFollowUpsData | undefined;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCoordinatorFollowUpsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCoordinatorFollowUpsData, ListCoordinatorFollowUpsParameters> | undefined;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>, updater: Updater<NoInfer<ListCoordinatorFollowUpsData> | undefined, NoInfer<ListCoordinatorFollowUpsData> | undefined>, options?: SetDataOptions): Array<ListCoordinatorFollowUpsData | undefined>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>): void;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Coordinator Follow Ups
         * @description The follow-ups this coordinator owns.
         *
         * Omitting `status` returns all seven. `display_name` is a prefix match on the
         * student's name and is also where the table's quick search lands, so there is no
         * separate `search` parameter.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorFollowUpsSchema, ListCoordinatorFollowUpsData, TInfinite, ListCoordinatorFollowUpsParameters, ListCoordinatorFollowUpsError>): number;
        schema: ListCoordinatorFollowUpsSchema;
        types: {
            parameters: ListCoordinatorFollowUpsParameters;
            data: ListCoordinatorFollowUpsData;
            error: ListCoordinatorFollowUpsError;
        };
    };
    /**
     * @summary List Partner Pending Follow Ups
     * @description The invitations this partner has not answered yet.
     *
     * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
     * partner never answered still appears. No filters, sorting or search, as in legacy,
     * but still paginated.
     */
    listPartnerPendingFollowUps: {
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListPartnerPendingFollowUpsParameters, TMeta, TSignal> | void), client?: (schema: ListPartnerPendingFollowUpsSchema, options: {
            parameters: ListPartnerPendingFollowUpsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError>>): Promise<RequestFnResponse<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError>>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        getQueryKey(parameters: DeepReadonly<ListPartnerPendingFollowUpsParameters> | void): ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerPendingFollowUps.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerPendingFollowUps.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPartnerPendingFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListPartnerPendingFollowUpsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerPendingFollowUps.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerPendingFollowUps.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPartnerPendingFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void), options: Omit<DefinedInitialDataOptions<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListPartnerPendingFollowUpsError>>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListPartnerPendingFollowUpsParameters> | void): ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerPendingFollowUps.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPartnerPendingFollowUpsParameters, TQueryFnData = ListPartnerPendingFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListPartnerPendingFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListPartnerPendingFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListPartnerPendingFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerPendingFollowUps.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPartnerPendingFollowUpsParameters, TQueryFnData = ListPartnerPendingFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListPartnerPendingFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListPartnerPendingFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPartnerPendingFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListPartnerPendingFollowUpsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listPartnerPendingFollowUpsTotal = qraft.v3Service.listPartnerPendingFollowUps.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listPartnerPendingFollowUpsByParametersTotal = qraft.v3Service.listPartnerPendingFollowUps.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | QueryFiltersByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listPartnerPendingFollowUpsResults = qraft.v3Service.listPartnerPendingFollowUps.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerPendingFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listPartnerPendingFollowUpsCombinedResults = qraft.v3Service.listPartnerPendingFollowUps.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerPendingFollowUpsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError>>, TCombinedResult = Array<UseQueryResult<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listPartnerPendingFollowUps.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listPartnerPendingFollowUps.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListPartnerPendingFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListPartnerPendingFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerPendingFollowUps.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListPartnerPendingFollowUpsParameters, TData = ListPartnerPendingFollowUpsData>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError, OperationInfiniteData<TData, ListPartnerPendingFollowUpsParameters>, ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPartnerPendingFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListPartnerPendingFollowUpsParameters>, OperationError<ListPartnerPendingFollowUpsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listPartnerPendingFollowUpsData = qraft.v3Service.listPartnerPendingFollowUps.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerPendingFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listPartnerPendingFollowUpsCombinedData = qraft.v3Service.listPartnerPendingFollowUps.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerPendingFollowUpsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | void): Promise<ListPartnerPendingFollowUpsData>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | void): Promise<void>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | void): Promise<ListPartnerPendingFollowUpsData>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        fetchInfiniteQuery<TPageParam extends ListPartnerPendingFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerPendingFollowUpsError> | void): Promise<OperationInfiniteData<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters>>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        prefetchInfiniteQuery<TPageParam extends ListPartnerPendingFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerPendingFollowUpsError> | void): Promise<void>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        ensureInfiniteQueryData<TPageParam extends ListPartnerPendingFollowUpsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerPendingFollowUpsError> | void): Promise<OperationInfiniteData<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters>>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void)): ListPartnerPendingFollowUpsData | undefined;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void)): OperationInfiniteData<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters> | undefined;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | QueryFiltersByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>,
            data: NoInfer<OperationInfiniteData<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>,
            data: ListPartnerPendingFollowUpsData | undefined
        ]>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | (DeepReadonly<ListPartnerPendingFollowUpsParameters> | void)): QueryState<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsError> | undefined;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListPartnerPendingFollowUpsParameters> | ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters> | void): QueryState<OperationInfiniteData<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters>, ListPartnerPendingFollowUpsError> | undefined;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        setQueryData(parameters: (DeepReadonly<ListPartnerPendingFollowUpsParameters> | undefined) | ServiceOperationQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>, updater: Updater<NoInfer<ListPartnerPendingFollowUpsData> | undefined, NoInfer<DeepReadonly<ListPartnerPendingFollowUpsData>> | undefined>, options?: SetDataOptions): ListPartnerPendingFollowUpsData | undefined;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListPartnerPendingFollowUpsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListPartnerPendingFollowUpsData, ListPartnerPendingFollowUpsParameters> | undefined;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | QueryFiltersByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>, updater: Updater<NoInfer<ListPartnerPendingFollowUpsData> | undefined, NoInfer<ListPartnerPendingFollowUpsData> | undefined>, options?: SetDataOptions): Array<ListPartnerPendingFollowUpsData | undefined>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | QueryFiltersByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | QueryFiltersByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | QueryFiltersByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>): void;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | QueryFiltersByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Partner Pending Follow Ups
         * @description The invitations this partner has not answered yet.
         *
         * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
         * partner never answered still appears. No filters, sorting or search, as in legacy,
         * but still paginated.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError> | QueryFiltersByQueryKey<ListPartnerPendingFollowUpsSchema, ListPartnerPendingFollowUpsData, TInfinite, ListPartnerPendingFollowUpsParameters, ListPartnerPendingFollowUpsError>): number;
        schema: ListPartnerPendingFollowUpsSchema;
        types: {
            parameters: ListPartnerPendingFollowUpsParameters;
            data: ListPartnerPendingFollowUpsData;
            error: ListPartnerPendingFollowUpsError;
        };
    };
    /**
     * @summary List Partner Follow Ups
     * @description The follow-ups this partner has accepted.
     *
     * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
     * on Pending Requests instead.
     */
    listPartnerFollowUps: {
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListPartnerFollowUpsParameters, TMeta, TSignal> | void), client?: (schema: ListPartnerFollowUpsSchema, options: {
            parameters: ListPartnerFollowUpsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListPartnerFollowUpsData, ListPartnerFollowUpsError>>): Promise<RequestFnResponse<ListPartnerFollowUpsData, ListPartnerFollowUpsError>>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        getQueryKey(parameters: DeepReadonly<ListPartnerFollowUpsParameters> | void): ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerFollowUps.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerFollowUps.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPartnerFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListPartnerFollowUpsData, ListPartnerFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListPartnerFollowUpsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerFollowUps.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerFollowUps.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPartnerFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void), options: Omit<DefinedInitialDataOptions<ListPartnerFollowUpsData, ListPartnerFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListPartnerFollowUpsError>>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListPartnerFollowUpsParameters> | void): ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerFollowUps.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPartnerFollowUpsParameters, TQueryFnData = ListPartnerFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListPartnerFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListPartnerFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListPartnerFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerFollowUps.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPartnerFollowUpsParameters, TQueryFnData = ListPartnerFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListPartnerFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListPartnerFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPartnerFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListPartnerFollowUpsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listPartnerFollowUpsTotal = qraft.v3Service.listPartnerFollowUps.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listPartnerFollowUpsByParametersTotal = qraft.v3Service.listPartnerFollowUps.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             id: id
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | QueryFiltersByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listPartnerFollowUpsResults = qraft.v3Service.listPartnerFollowUps.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listPartnerFollowUpsCombinedResults = qraft.v3Service.listPartnerFollowUps.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerFollowUpsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters, ListPartnerFollowUpsData, ListPartnerFollowUpsError>>, TCombinedResult = Array<UseQueryResult<ListPartnerFollowUpsData, ListPartnerFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListPartnerFollowUpsData, ListPartnerFollowUpsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listPartnerFollowUps.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listPartnerFollowUps.useSuspenseQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListPartnerFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListPartnerFollowUpsData, ListPartnerFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListPartnerFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerFollowUps.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListPartnerFollowUpsParameters, TData = ListPartnerFollowUpsData>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListPartnerFollowUpsData, ListPartnerFollowUpsError, OperationInfiniteData<TData, ListPartnerFollowUpsParameters>, ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPartnerFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListPartnerFollowUpsParameters>, OperationError<ListPartnerFollowUpsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listPartnerFollowUpsData = qraft.v3Service.listPartnerFollowUps.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listPartnerFollowUpsCombinedData = qraft.v3Service.listPartnerFollowUps.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerFollowUpsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters, ListPartnerFollowUpsData, ListPartnerFollowUpsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListPartnerFollowUpsData, ListPartnerFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListPartnerFollowUpsData, ListPartnerFollowUpsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | void): Promise<ListPartnerFollowUpsData>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | void): Promise<void>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | void): Promise<ListPartnerFollowUpsData>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        fetchInfiniteQuery<TPageParam extends ListPartnerFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, ListPartnerFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerFollowUpsError> | void): Promise<OperationInfiniteData<ListPartnerFollowUpsData, ListPartnerFollowUpsParameters>>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        prefetchInfiniteQuery<TPageParam extends ListPartnerFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, ListPartnerFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerFollowUpsError> | void): Promise<void>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        ensureInfiniteQueryData<TPageParam extends ListPartnerFollowUpsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, ListPartnerFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerFollowUpsError> | void): Promise<OperationInfiniteData<ListPartnerFollowUpsData, ListPartnerFollowUpsParameters>>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void)): ListPartnerFollowUpsData | undefined;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void)): OperationInfiniteData<ListPartnerFollowUpsData, ListPartnerFollowUpsParameters> | undefined;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | QueryFiltersByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>,
            data: NoInfer<OperationInfiniteData<ListPartnerFollowUpsData, ListPartnerFollowUpsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>,
            data: ListPartnerFollowUpsData | undefined
        ]>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | (DeepReadonly<ListPartnerFollowUpsParameters> | void)): QueryState<ListPartnerFollowUpsData, ListPartnerFollowUpsError> | undefined;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListPartnerFollowUpsParameters> | ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters> | void): QueryState<OperationInfiniteData<ListPartnerFollowUpsData, ListPartnerFollowUpsParameters>, ListPartnerFollowUpsError> | undefined;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        setQueryData(parameters: (DeepReadonly<ListPartnerFollowUpsParameters> | undefined) | ServiceOperationQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>, updater: Updater<NoInfer<ListPartnerFollowUpsData> | undefined, NoInfer<DeepReadonly<ListPartnerFollowUpsData>> | undefined>, options?: SetDataOptions): ListPartnerFollowUpsData | undefined;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListPartnerFollowUpsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListPartnerFollowUpsData, ListPartnerFollowUpsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListPartnerFollowUpsData, ListPartnerFollowUpsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListPartnerFollowUpsData, ListPartnerFollowUpsParameters> | undefined;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | QueryFiltersByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>, updater: Updater<NoInfer<ListPartnerFollowUpsData> | undefined, NoInfer<ListPartnerFollowUpsData> | undefined>, options?: SetDataOptions): Array<ListPartnerFollowUpsData | undefined>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | QueryFiltersByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | QueryFiltersByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | QueryFiltersByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>): void;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | QueryFiltersByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Partner Follow Ups
         * @description The follow-ups this partner has accepted.
         *
         * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
         * on Pending Requests instead.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError> | QueryFiltersByQueryKey<ListPartnerFollowUpsSchema, ListPartnerFollowUpsData, TInfinite, ListPartnerFollowUpsParameters, ListPartnerFollowUpsError>): number;
        schema: ListPartnerFollowUpsSchema;
        types: {
            parameters: ListPartnerFollowUpsParameters;
            data: ListPartnerFollowUpsData;
            error: ListPartnerFollowUpsError;
        };
    };
    /**
     * @summary Get Follow Up Detail
     * @description One follow-up, as the shared detail template renders it.
     *
     * Admits the student, the resolved partner, the coordinator, the student's current
     * study helper and admins; anyone else gets 404, not 403. The student may open the
     * page but not the timeline, and `can_view_timeline` says which.
     */
    getFollowUp: {
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetFollowUpSchema, GetFollowUpParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetFollowUpParameters, TMeta, TSignal>), client?: (schema: GetFollowUpSchema, options: {
            parameters: GetFollowUpParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetFollowUpData, GetFollowUpError>>): Promise<RequestFnResponse<GetFollowUpData, GetFollowUpError>>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        getQueryKey(parameters: DeepReadonly<GetFollowUpParameters>): ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUp.useQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpData>(parameters: ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>), options?: Omit<UndefinedInitialDataOptions<GetFollowUpData, GetFollowUpError, TData, ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetFollowUpError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUp.useQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpData>(parameters: ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>), options: Omit<DefinedInitialDataOptions<GetFollowUpData, GetFollowUpError, TData, ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetFollowUpError>>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetFollowUpParameters>): ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUp.useInfiniteQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpParameters, TQueryFnData = GetFollowUpData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetFollowUpError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUp.useInfiniteQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpParameters, TQueryFnData = GetFollowUpData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetFollowUpError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getFollowUpTotal = qraft.v3Service.getFollowUp.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getFollowUpByParametersTotal = qraft.v3Service.getFollowUp.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError> | QueryFiltersByQueryKey<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getFollowUpResults = qraft.v3Service.getFollowUp.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 follow_up_id: followUpId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 follow_up_id: followUpId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getFollowUpCombinedResults = qraft.v3Service.getFollowUp.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 follow_up_id: followUpId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 follow_up_id: followUpId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetFollowUpSchema, GetFollowUpParameters, GetFollowUpData, GetFollowUpError>>, TCombinedResult = Array<UseQueryResult<GetFollowUpData, GetFollowUpError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetFollowUpData, GetFollowUpError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getFollowUp.useSuspenseQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetFollowUpData>(parameters: ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>), options?: Omit<UseSuspenseQueryOptions<GetFollowUpData, GetFollowUpError, TData, ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetFollowUpError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUp.useSuspenseInfiniteQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetFollowUpParameters, TData = GetFollowUpData>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetFollowUpData, GetFollowUpError, OperationInfiniteData<TData, GetFollowUpParameters>, ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetFollowUpParameters>, OperationError<GetFollowUpError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getFollowUpData = qraft.v3Service.getFollowUp.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 follow_up_id: followUpId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 follow_up_id: followUpId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getFollowUpCombinedData = qraft.v3Service.getFollowUp.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 follow_up_id: followUpId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 follow_up_id: followUpId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetFollowUpSchema, GetFollowUpParameters, GetFollowUpData, GetFollowUpError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetFollowUpData, GetFollowUpError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetFollowUpData, GetFollowUpError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpSchema, GetFollowUpData, GetFollowUpParameters, GetFollowUpError>): Promise<GetFollowUpData>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpSchema, GetFollowUpData, GetFollowUpParameters, GetFollowUpError>): Promise<void>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetFollowUpSchema, GetFollowUpData, GetFollowUpParameters, GetFollowUpError>): Promise<GetFollowUpData>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        fetchInfiniteQuery<TPageParam extends GetFollowUpParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpSchema, GetFollowUpData, GetFollowUpParameters, DeepReadonly<TPageParam>, GetFollowUpError>): Promise<OperationInfiniteData<GetFollowUpData, GetFollowUpParameters>>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        prefetchInfiniteQuery<TPageParam extends GetFollowUpParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpSchema, GetFollowUpData, GetFollowUpParameters, DeepReadonly<TPageParam>, GetFollowUpError>): Promise<void>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        ensureInfiniteQueryData<TPageParam extends GetFollowUpParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetFollowUpSchema, GetFollowUpData, GetFollowUpParameters, DeepReadonly<TPageParam>, GetFollowUpError>): Promise<OperationInfiniteData<GetFollowUpData, GetFollowUpParameters>>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>)): GetFollowUpData | undefined;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>)): OperationInfiniteData<GetFollowUpData, GetFollowUpParameters> | undefined;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError> | QueryFiltersByQueryKey<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters>,
            data: NoInfer<OperationInfiniteData<GetFollowUpData, GetFollowUpParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters>,
            data: GetFollowUpData | undefined
        ]>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters> | (DeepReadonly<GetFollowUpParameters>)): QueryState<GetFollowUpData, GetFollowUpError> | undefined;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetFollowUpParameters> | ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters>): QueryState<OperationInfiniteData<GetFollowUpData, GetFollowUpParameters>, GetFollowUpError> | undefined;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        setQueryData(parameters: (DeepReadonly<GetFollowUpParameters>) | ServiceOperationQueryKey<GetFollowUpSchema, GetFollowUpParameters>, updater: Updater<NoInfer<GetFollowUpData> | undefined, NoInfer<DeepReadonly<GetFollowUpData>> | undefined>, options?: SetDataOptions): GetFollowUpData | undefined;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetFollowUpParameters>) | ServiceOperationInfiniteQueryKey<GetFollowUpSchema, GetFollowUpParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetFollowUpData, GetFollowUpParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetFollowUpData, GetFollowUpParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetFollowUpData, GetFollowUpParameters> | undefined;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError> | QueryFiltersByQueryKey<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>, updater: Updater<NoInfer<GetFollowUpData> | undefined, NoInfer<GetFollowUpData> | undefined>, options?: SetDataOptions): Array<GetFollowUpData | undefined>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError> | QueryFiltersByQueryKey<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError> | QueryFiltersByQueryKey<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError> | QueryFiltersByQueryKey<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>): void;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError> | QueryFiltersByQueryKey<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Follow Up Detail
         * @description One follow-up, as the shared detail template renders it.
         *
         * Admits the student, the resolved partner, the coordinator, the student's current
         * study helper and admins; anyone else gets 404, not 403. The student may open the
         * page but not the timeline, and `can_view_timeline` says which.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError> | QueryFiltersByQueryKey<GetFollowUpSchema, GetFollowUpData, TInfinite, GetFollowUpParameters, GetFollowUpError>): number;
        schema: GetFollowUpSchema;
        types: {
            parameters: GetFollowUpParameters;
            data: GetFollowUpData;
            error: GetFollowUpError;
        };
    };
    /**
     * @summary List Follow Up Records Route
     * @description The follow-up's timeline, newest first.
     *
     * 403 for the student — the same block legacy uses to hide the Additional Notes
     * and the composer — and 404 for a caller with no relation to the row at all.
     */
    listFollowUpRecords: {
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpRecordsParameters, TMeta, TSignal>), client?: (schema: ListFollowUpRecordsSchema, options: {
            parameters: ListFollowUpRecordsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpRecordsData, ListFollowUpRecordsError>>): Promise<RequestFnResponse<ListFollowUpRecordsData, ListFollowUpRecordsError>>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpRecordsParameters>): ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpRecords.useQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpRecordsData>(parameters: ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>), options?: Omit<UndefinedInitialDataOptions<ListFollowUpRecordsData, ListFollowUpRecordsError, TData, ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpRecordsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpRecords.useQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpRecordsData>(parameters: ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>), options: Omit<DefinedInitialDataOptions<ListFollowUpRecordsData, ListFollowUpRecordsError, TData, ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpRecordsError>>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpRecordsParameters>): ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpRecords.useInfiniteQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpRecordsParameters, TQueryFnData = ListFollowUpRecordsData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpRecordsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpRecordsError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpRecordsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpRecords.useInfiniteQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpRecordsParameters, TQueryFnData = ListFollowUpRecordsData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpRecordsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpRecordsError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpRecordsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpRecordsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpRecordsTotal = qraft.v3Service.listFollowUpRecords.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpRecordsByParametersTotal = qraft.v3Service.listFollowUpRecords.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError> | QueryFiltersByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpRecordsResults = qraft.v3Service.listFollowUpRecords.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 follow_up_id: followUpId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 follow_up_id: followUpId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpRecordsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpRecordsCombinedResults = qraft.v3Service.listFollowUpRecords.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 follow_up_id: followUpId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 follow_up_id: followUpId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpRecordsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters, ListFollowUpRecordsData, ListFollowUpRecordsError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpRecordsData, ListFollowUpRecordsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpRecordsData, ListFollowUpRecordsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpRecords.useSuspenseQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpRecordsData>(parameters: ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>), options?: Omit<UseSuspenseQueryOptions<ListFollowUpRecordsData, ListFollowUpRecordsError, TData, ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpRecordsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpRecords.useSuspenseInfiniteQuery({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpRecordsParameters, TData = ListFollowUpRecordsData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpRecordsData, ListFollowUpRecordsError, OperationInfiniteData<TData, ListFollowUpRecordsParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpRecordsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpRecordsParameters>, OperationError<ListFollowUpRecordsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpRecordsData = qraft.v3Service.listFollowUpRecords.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 follow_up_id: followUpId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 follow_up_id: followUpId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpRecordsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpRecordsCombinedData = qraft.v3Service.listFollowUpRecords.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 follow_up_id: followUpId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 follow_up_id: followUpId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpRecordsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters, ListFollowUpRecordsData, ListFollowUpRecordsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpRecordsData, ListFollowUpRecordsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpRecordsData, ListFollowUpRecordsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpRecordsSchema, ListFollowUpRecordsData, ListFollowUpRecordsParameters, ListFollowUpRecordsError>): Promise<ListFollowUpRecordsData>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpRecordsSchema, ListFollowUpRecordsData, ListFollowUpRecordsParameters, ListFollowUpRecordsError>): Promise<void>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpRecordsSchema, ListFollowUpRecordsData, ListFollowUpRecordsParameters, ListFollowUpRecordsError>): Promise<ListFollowUpRecordsData>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpRecordsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpRecordsSchema, ListFollowUpRecordsData, ListFollowUpRecordsParameters, DeepReadonly<TPageParam>, ListFollowUpRecordsError>): Promise<OperationInfiniteData<ListFollowUpRecordsData, ListFollowUpRecordsParameters>>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpRecordsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpRecordsSchema, ListFollowUpRecordsData, ListFollowUpRecordsParameters, DeepReadonly<TPageParam>, ListFollowUpRecordsError>): Promise<void>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpRecordsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpRecordsSchema, ListFollowUpRecordsData, ListFollowUpRecordsParameters, DeepReadonly<TPageParam>, ListFollowUpRecordsError>): Promise<OperationInfiniteData<ListFollowUpRecordsData, ListFollowUpRecordsParameters>>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>)): ListFollowUpRecordsData | undefined;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>)): OperationInfiniteData<ListFollowUpRecordsData, ListFollowUpRecordsParameters> | undefined;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError> | QueryFiltersByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpRecordsData, ListFollowUpRecordsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>,
            data: ListFollowUpRecordsData | undefined
        ]>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters> | (DeepReadonly<ListFollowUpRecordsParameters>)): QueryState<ListFollowUpRecordsData, ListFollowUpRecordsError> | undefined;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpRecordsParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>): QueryState<OperationInfiniteData<ListFollowUpRecordsData, ListFollowUpRecordsParameters>, ListFollowUpRecordsError> | undefined;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpRecordsParameters>) | ServiceOperationQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>, updater: Updater<NoInfer<ListFollowUpRecordsData> | undefined, NoInfer<DeepReadonly<ListFollowUpRecordsData>> | undefined>, options?: SetDataOptions): ListFollowUpRecordsData | undefined;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpRecordsParameters>) | ServiceOperationInfiniteQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpRecordsData, ListFollowUpRecordsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpRecordsData, ListFollowUpRecordsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpRecordsData, ListFollowUpRecordsParameters> | undefined;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError> | QueryFiltersByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>, updater: Updater<NoInfer<ListFollowUpRecordsData> | undefined, NoInfer<ListFollowUpRecordsData> | undefined>, options?: SetDataOptions): Array<ListFollowUpRecordsData | undefined>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError> | QueryFiltersByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError> | QueryFiltersByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError> | QueryFiltersByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>): void;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError> | QueryFiltersByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Records Route
         * @description The follow-up's timeline, newest first.
         *
         * 403 for the student — the same block legacy uses to hide the Additional Notes
         * and the composer — and 404 for a caller with no relation to the row at all.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError> | QueryFiltersByQueryKey<ListFollowUpRecordsSchema, ListFollowUpRecordsData, TInfinite, ListFollowUpRecordsParameters, ListFollowUpRecordsError>): number;
        schema: ListFollowUpRecordsSchema;
        types: {
            parameters: ListFollowUpRecordsParameters;
            data: ListFollowUpRecordsData;
            error: ListFollowUpRecordsError;
        };
    };
    /**
     * @summary Add Follow Up Record Route
     * @description The timeline composer: a note, optionally with a status change.
     *
     * The record type is derived from `new_status`, never posted. An empty note is valid.
     * A `new_status` is stored on the record and moves `follow_ups.status` only when it
     * differs.
     */
    addFollowUpRecord: {
        /**
         * @summary Add Follow Up Record Route
         * @description The timeline composer: a note, optionally with a status change.
         *
         * The record type is derived from `new_status`, never posted. An empty note is valid.
         * A `new_status` is stored on the record and moves `follow_ups.status` only when it
         * differs.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AddFollowUpRecordBody, AddFollowUpRecordParameters, TMeta, TSignal>, client?: (schema: AddFollowUpRecordSchema, options: ServiceOperationMutationFnOptions<AddFollowUpRecordBody, AddFollowUpRecordParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AddFollowUpRecordData, AddFollowUpRecordError>>): Promise<RequestFnResponse<AddFollowUpRecordData, AddFollowUpRecordError>>;
        /**
         * @summary Add Follow Up Record Route
         * @description The timeline composer: a note, optionally with a status change.
         *
         * The record type is derived from `new_status`, never posted. An empty note is valid.
         * A `new_status` is stored on the record and moves `follow_ups.status` only when it
         * differs.
         */
        getMutationKey(parameters: DeepReadonly<AddFollowUpRecordParameters> | void): ServiceOperationMutationKey<AddFollowUpRecordSchema, AddFollowUpRecordParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Add Follow Up Record Route
         * @description The timeline composer: a note, optionally with a status change.
         *
         * The record type is derived from `new_status`, never posted. An empty note is valid.
         * A `new_status` is stored on the record and moves `follow_ups.status` only when it
         * differs.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.addFollowUpRecord.useMutation({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.addFollowUpRecord.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AddFollowUpRecordBody, TContext = unknown>(parameters: DeepReadonly<AddFollowUpRecordParameters>, options?: ServiceOperationUseMutationOptions<AddFollowUpRecordSchema, AddFollowUpRecordData, AddFollowUpRecordParameters, TVariables, OperationError<AddFollowUpRecordError>, TContext>): UseMutationResult<AddFollowUpRecordData, OperationError<AddFollowUpRecordError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Add Follow Up Record Route
         * @description The timeline composer: a note, optionally with a status change.
         *
         * The record type is derived from `new_status`, never posted. An empty note is valid.
         * A `new_status` is stored on the record and moves `follow_ups.status` only when it
         * differs.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.addFollowUpRecord.useMutation({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.addFollowUpRecord.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AddFollowUpRecordBody, AddFollowUpRecordParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AddFollowUpRecordSchema, AddFollowUpRecordData, AddFollowUpRecordParameters, TVariables, OperationError<AddFollowUpRecordError>, TContext>): UseMutationResult<AddFollowUpRecordData, OperationError<AddFollowUpRecordError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Add Follow Up Record Route
         * @description The timeline composer: a note, optionally with a status change.
         *
         * The record type is derived from `new_status`, never posted. An empty note is valid.
         * A `new_status` is stored on the record and moves `follow_ups.status` only when it
         * differs.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const addFollowUpRecordTotal = qraft.v3Service.addFollowUpRecord.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const addFollowUpRecordTotal = qraft.v3Service.addFollowUpRecord.useIsMutating({
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext> | MutationFiltersByMutationKey<AddFollowUpRecordSchema, AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Add Follow Up Record Route
         * @description The timeline composer: a note, optionally with a status change.
         *
         * The record type is derived from `new_status`, never posted. An empty note is valid.
         * A `new_status` is stored on the record and moves `follow_ups.status` only when it
         * differs.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const addFollowUpRecordPendingMutationVariables = qraft.v3Service.addFollowUpRecord.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const addFollowUpRecordMutationData = qraft.v3Service.addFollowUpRecord.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 follow_up_id: followUpId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AddFollowUpRecordData, OperationError<AddFollowUpRecordError>, MutationVariables<AddFollowUpRecordBody, AddFollowUpRecordParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext> | MutationFiltersByMutationKey<AddFollowUpRecordSchema, AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext>;
            select?: (mutation: Mutation<AddFollowUpRecordData, OperationError<AddFollowUpRecordError>, MutationVariables<AddFollowUpRecordBody, AddFollowUpRecordParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Add Follow Up Record Route
         * @description The timeline composer: a note, optionally with a status change.
         *
         * The record type is derived from `new_status`, never posted. An empty note is valid.
         * A `new_status` is stored on the record and moves `follow_ups.status` only when it
         * differs.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext> | MutationFiltersByMutationKey<AddFollowUpRecordSchema, AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Add Follow Up Record Route
         * @description The timeline composer: a note, optionally with a status change.
         *
         * The record type is derived from `new_status`, never posted. An empty note is valid.
         * A `new_status` is stored on the record and moves `follow_ups.status` only when it
         * differs.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.addFollowUpRecord.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.addFollowUpRecord.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext> | MutationFiltersByMutationKey<AddFollowUpRecordSchema, AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext>): Mutation<AddFollowUpRecordData, AddFollowUpRecordError, MutationVariables<AddFollowUpRecordBody, AddFollowUpRecordParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext> | MutationFiltersByMutationKey<AddFollowUpRecordSchema, AddFollowUpRecordBody, AddFollowUpRecordData, AddFollowUpRecordParameters, OperationError<AddFollowUpRecordError>, TContext>): Array<Mutation<AddFollowUpRecordData, AddFollowUpRecordError, MutationVariables<AddFollowUpRecordBody, AddFollowUpRecordParameters>, TContext>>;
        };
        schema: AddFollowUpRecordSchema;
        types: {
            parameters: AddFollowUpRecordParameters;
            data: AddFollowUpRecordData;
            error: AddFollowUpRecordError;
            body: AddFollowUpRecordBody;
        };
    };
    /**
     * @summary Get Follow Up Convert Draft
     * @description Everything the convert form renders, for one request the caller adopted.
     *
     * 404 for a request another coordinator holds. `selected_requests` is display only:
     * convert takes the request's own objectives.
     */
    getFollowUpConvertDraft: {
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetFollowUpConvertDraftParameters, TMeta, TSignal>), client?: (schema: GetFollowUpConvertDraftSchema, options: {
            parameters: GetFollowUpConvertDraftParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError>>): Promise<RequestFnResponse<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError>>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        getQueryKey(parameters: DeepReadonly<GetFollowUpConvertDraftParameters>): ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpConvertDraft.useQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpConvertDraftData>(parameters: ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>), options?: Omit<UndefinedInitialDataOptions<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError, TData, ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetFollowUpConvertDraftError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getFollowUpConvertDraft.useQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetFollowUpConvertDraftData>(parameters: ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>), options: Omit<DefinedInitialDataOptions<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError, TData, ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetFollowUpConvertDraftError>>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetFollowUpConvertDraftParameters>): ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpConvertDraft.useInfiniteQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpConvertDraftParameters, TQueryFnData = GetFollowUpConvertDraftData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpConvertDraftParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpConvertDraftError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetFollowUpConvertDraftError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpConvertDraft.useInfiniteQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetFollowUpConvertDraftParameters, TQueryFnData = GetFollowUpConvertDraftData, TData = OperationInfiniteData<TQueryFnData, GetFollowUpConvertDraftParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetFollowUpConvertDraftError, TData, ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpConvertDraftData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetFollowUpConvertDraftError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getFollowUpConvertDraftTotal = qraft.v3Service.getFollowUpConvertDraft.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getFollowUpConvertDraftByParametersTotal = qraft.v3Service.getFollowUpConvertDraft.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError> | QueryFiltersByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getFollowUpConvertDraftResults = qraft.v3Service.getFollowUpConvertDraft.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpConvertDraftResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getFollowUpConvertDraftCombinedResults = qraft.v3Service.getFollowUpConvertDraft.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpConvertDraftCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftData, GetFollowUpConvertDraftError>>, TCombinedResult = Array<UseQueryResult<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getFollowUpConvertDraft.useSuspenseQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetFollowUpConvertDraftData>(parameters: ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>), options?: Omit<UseSuspenseQueryOptions<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError, TData, ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetFollowUpConvertDraftError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getFollowUpConvertDraft.useSuspenseInfiniteQuery({
         *     path: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetFollowUpConvertDraftParameters, TData = GetFollowUpConvertDraftData>(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError, OperationInfiniteData<TData, GetFollowUpConvertDraftParameters>, ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetFollowUpConvertDraftData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetFollowUpConvertDraftParameters>, OperationError<GetFollowUpConvertDraftError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getFollowUpConvertDraftData = qraft.v3Service.getFollowUpConvertDraft.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpConvertDraftResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getFollowUpConvertDraftCombinedData = qraft.v3Service.getFollowUpConvertDraft.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getFollowUpConvertDraftCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftData, GetFollowUpConvertDraftError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>): Promise<GetFollowUpConvertDraftData>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>): Promise<void>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>): Promise<GetFollowUpConvertDraftData>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        fetchInfiniteQuery<TPageParam extends GetFollowUpConvertDraftParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters, DeepReadonly<TPageParam>, GetFollowUpConvertDraftError>): Promise<OperationInfiniteData<GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters>>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        prefetchInfiniteQuery<TPageParam extends GetFollowUpConvertDraftParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters, DeepReadonly<TPageParam>, GetFollowUpConvertDraftError>): Promise<void>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        ensureInfiniteQueryData<TPageParam extends GetFollowUpConvertDraftParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters, DeepReadonly<TPageParam>, GetFollowUpConvertDraftError>): Promise<OperationInfiniteData<GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters>>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>)): GetFollowUpConvertDraftData | undefined;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>)): OperationInfiniteData<GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters> | undefined;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError> | QueryFiltersByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>,
            data: NoInfer<OperationInfiniteData<GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>,
            data: GetFollowUpConvertDraftData | undefined
        ]>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters> | (DeepReadonly<GetFollowUpConvertDraftParameters>)): QueryState<GetFollowUpConvertDraftData, GetFollowUpConvertDraftError> | undefined;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetFollowUpConvertDraftParameters> | ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>): QueryState<OperationInfiniteData<GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters>, GetFollowUpConvertDraftError> | undefined;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        setQueryData(parameters: (DeepReadonly<GetFollowUpConvertDraftParameters>) | ServiceOperationQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>, updater: Updater<NoInfer<GetFollowUpConvertDraftData> | undefined, NoInfer<DeepReadonly<GetFollowUpConvertDraftData>> | undefined>, options?: SetDataOptions): GetFollowUpConvertDraftData | undefined;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetFollowUpConvertDraftParameters>) | ServiceOperationInfiniteQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetFollowUpConvertDraftData, GetFollowUpConvertDraftParameters> | undefined;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError> | QueryFiltersByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>, updater: Updater<NoInfer<GetFollowUpConvertDraftData> | undefined, NoInfer<GetFollowUpConvertDraftData> | undefined>, options?: SetDataOptions): Array<GetFollowUpConvertDraftData | undefined>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError> | QueryFiltersByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError> | QueryFiltersByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError> | QueryFiltersByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>): void;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError> | QueryFiltersByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Follow Up Convert Draft
         * @description Everything the convert form renders, for one request the caller adopted.
         *
         * 404 for a request another coordinator holds. `selected_requests` is display only:
         * convert takes the request's own objectives.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError> | QueryFiltersByQueryKey<GetFollowUpConvertDraftSchema, GetFollowUpConvertDraftData, TInfinite, GetFollowUpConvertDraftParameters, GetFollowUpConvertDraftError>): number;
        schema: GetFollowUpConvertDraftSchema;
        types: {
            parameters: GetFollowUpConvertDraftParameters;
            data: GetFollowUpConvertDraftData;
            error: GetFollowUpConvertDraftError;
        };
    };
    /**
     * @summary List Follow Up Partner Options Route
     * @description The partner picker: partners approved for the student's country and language,
     * plus the caller's own unverified contacts.
     *
     * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
     * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
     * otherwise, since the options reveal the student's country and language and the
     * reassign arm excludes the current partners. `term` is a per-word prefix match on
     * first and last name, ANDed across words.
     */
    listFollowUpPartnerOptions: {
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpPartnerOptionsParameters, TMeta, TSignal> | void), client?: (schema: ListFollowUpPartnerOptionsSchema, options: {
            parameters: ListFollowUpPartnerOptionsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError>>): Promise<RequestFnResponse<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError>>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpPartnerOptionsParameters> | void): ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpPartnerOptions.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpPartnerOptions.useQuery({
         *     query: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpPartnerOptionsData>(parameters: ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError, TData, ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpPartnerOptionsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpPartnerOptions.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpPartnerOptions.useQuery({
         *     query: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpPartnerOptionsData>(parameters: ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void), options: Omit<DefinedInitialDataOptions<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError, TData, ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpPartnerOptionsError>>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpPartnerOptionsParameters> | void): ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpPartnerOptions.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             request_id: initialRequestId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpPartnerOptionsParameters, TQueryFnData = ListFollowUpPartnerOptionsData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpPartnerOptionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpPartnerOptionsError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpPartnerOptionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpPartnerOptions.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             request_id: initialRequestId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpPartnerOptionsParameters, TQueryFnData = ListFollowUpPartnerOptionsData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpPartnerOptionsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpPartnerOptionsError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpPartnerOptionsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpPartnerOptionsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpPartnerOptionsTotal = qraft.v3Service.listFollowUpPartnerOptions.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpPartnerOptionsByParametersTotal = qraft.v3Service.listFollowUpPartnerOptions.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             request_id: requestId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | QueryFiltersByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpPartnerOptionsResults = qraft.v3Service.listFollowUpPartnerOptions.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpPartnerOptionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpPartnerOptionsCombinedResults = qraft.v3Service.listFollowUpPartnerOptions.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpPartnerOptionsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpPartnerOptions.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpPartnerOptions.useSuspenseQuery({
         *     query: {
         *         request_id: requestId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpPartnerOptionsData>(parameters: ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError, TData, ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpPartnerOptionsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpPartnerOptions.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             request_id: initialRequestId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpPartnerOptionsParameters, TData = ListFollowUpPartnerOptionsData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError, OperationInfiniteData<TData, ListFollowUpPartnerOptionsParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpPartnerOptionsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpPartnerOptionsParameters>, OperationError<ListFollowUpPartnerOptionsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpPartnerOptionsData = qraft.v3Service.listFollowUpPartnerOptions.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpPartnerOptionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpPartnerOptionsCombinedData = qraft.v3Service.listFollowUpPartnerOptions.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 request_id: requestId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 request_id: requestId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpPartnerOptionsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | void): Promise<ListFollowUpPartnerOptionsData>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | void): Promise<void>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | void): Promise<ListFollowUpPartnerOptionsData>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpPartnerOptionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters, DeepReadonly<TPageParam>, ListFollowUpPartnerOptionsError> | void): Promise<OperationInfiniteData<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters>>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpPartnerOptionsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters, DeepReadonly<TPageParam>, ListFollowUpPartnerOptionsError> | void): Promise<void>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpPartnerOptionsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters, DeepReadonly<TPageParam>, ListFollowUpPartnerOptionsError> | void): Promise<OperationInfiniteData<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters>>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void)): ListFollowUpPartnerOptionsData | undefined;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void)): OperationInfiniteData<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters> | undefined;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | QueryFiltersByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>,
            data: ListFollowUpPartnerOptionsData | undefined
        ]>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | (DeepReadonly<ListFollowUpPartnerOptionsParameters> | void)): QueryState<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsError> | undefined;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpPartnerOptionsParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters> | void): QueryState<OperationInfiniteData<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters>, ListFollowUpPartnerOptionsError> | undefined;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpPartnerOptionsParameters> | undefined) | ServiceOperationQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>, updater: Updater<NoInfer<ListFollowUpPartnerOptionsData> | undefined, NoInfer<DeepReadonly<ListFollowUpPartnerOptionsData>> | undefined>, options?: SetDataOptions): ListFollowUpPartnerOptionsData | undefined;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpPartnerOptionsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpPartnerOptionsData, ListFollowUpPartnerOptionsParameters> | undefined;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | QueryFiltersByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>, updater: Updater<NoInfer<ListFollowUpPartnerOptionsData> | undefined, NoInfer<ListFollowUpPartnerOptionsData> | undefined>, options?: SetDataOptions): Array<ListFollowUpPartnerOptionsData | undefined>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | QueryFiltersByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | QueryFiltersByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | QueryFiltersByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>): void;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | QueryFiltersByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Partner Options Route
         * @description The partner picker: partners approved for the student's country and language,
         * plus the caller's own unverified contacts.
         *
         * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
         * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
         * otherwise, since the options reveal the student's country and language and the
         * reassign arm excludes the current partners. `term` is a per-word prefix match on
         * first and last name, ANDed across words.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError> | QueryFiltersByQueryKey<ListFollowUpPartnerOptionsSchema, ListFollowUpPartnerOptionsData, TInfinite, ListFollowUpPartnerOptionsParameters, ListFollowUpPartnerOptionsError>): number;
        schema: ListFollowUpPartnerOptionsSchema;
        types: {
            parameters: ListFollowUpPartnerOptionsParameters;
            data: ListFollowUpPartnerOptionsData;
            error: ListFollowUpPartnerOptionsError;
        };
    };
    /**
     * @summary Create Follow Up Route
     * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
     * one partner.
     *
     * Only the coordinator who adopted the request may convert it. Writes
     * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
     * reads `partner_id` to decide who may fetch the student's contact details; the
     * exception is an unverified partner, who is approved outright.
     */
    createFollowUp: {
        /**
         * @summary Create Follow Up Route
         * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
         * one partner.
         *
         * Only the coordinator who adopted the request may convert it. Writes
         * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
         * reads `partner_id` to decide who may fetch the student's contact details; the
         * exception is an unverified partner, who is approved outright.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateFollowUpBody, CreateFollowUpParameters, TMeta, TSignal>, client?: (schema: CreateFollowUpSchema, options: ServiceOperationMutationFnOptions<CreateFollowUpBody, CreateFollowUpParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateFollowUpData, CreateFollowUpError>>): Promise<RequestFnResponse<CreateFollowUpData, CreateFollowUpError>>;
        /**
         * @summary Create Follow Up Route
         * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
         * one partner.
         *
         * Only the coordinator who adopted the request may convert it. Writes
         * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
         * reads `partner_id` to decide who may fetch the student's contact details; the
         * exception is an unverified partner, who is approved outright.
         */
        getMutationKey(parameters: DeepReadonly<CreateFollowUpParameters> | void): ServiceOperationMutationKey<CreateFollowUpSchema, CreateFollowUpParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Follow Up Route
         * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
         * one partner.
         *
         * Only the coordinator who adopted the request may convert it. Writes
         * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
         * reads `partner_id` to decide who may fetch the student's contact details; the
         * exception is an unverified partner, who is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createFollowUp.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createFollowUp.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateFollowUpBody, TContext = unknown>(parameters: DeepReadonly<CreateFollowUpParameters>, options?: ServiceOperationUseMutationOptions<CreateFollowUpSchema, CreateFollowUpData, CreateFollowUpParameters, TVariables, OperationError<CreateFollowUpError>, TContext>): UseMutationResult<CreateFollowUpData, OperationError<CreateFollowUpError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Follow Up Route
         * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
         * one partner.
         *
         * Only the coordinator who adopted the request may convert it. Writes
         * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
         * reads `partner_id` to decide who may fetch the student's contact details; the
         * exception is an unverified partner, who is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createFollowUp.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createFollowUp.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateFollowUpBody, CreateFollowUpParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateFollowUpSchema, CreateFollowUpData, CreateFollowUpParameters, TVariables, OperationError<CreateFollowUpError>, TContext>): UseMutationResult<CreateFollowUpData, OperationError<CreateFollowUpError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Follow Up Route
         * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
         * one partner.
         *
         * Only the coordinator who adopted the request may convert it. Writes
         * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
         * reads `partner_id` to decide who may fetch the student's contact details; the
         * exception is an unverified partner, who is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createFollowUpTotal = qraft.v3Service.createFollowUp.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createFollowUpTotal = qraft.v3Service.createFollowUp.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpSchema, CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Follow Up Route
         * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
         * one partner.
         *
         * Only the coordinator who adopted the request may convert it. Writes
         * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
         * reads `partner_id` to decide who may fetch the student's contact details; the
         * exception is an unverified partner, who is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createFollowUpPendingMutationVariables = qraft.v3Service.createFollowUp.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createFollowUpMutationData = qraft.v3Service.createFollowUp.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateFollowUpData, OperationError<CreateFollowUpError>, MutationVariables<CreateFollowUpBody, CreateFollowUpParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpSchema, CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext>;
            select?: (mutation: Mutation<CreateFollowUpData, OperationError<CreateFollowUpError>, MutationVariables<CreateFollowUpBody, CreateFollowUpParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Follow Up Route
         * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
         * one partner.
         *
         * Only the coordinator who adopted the request may convert it. Writes
         * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
         * reads `partner_id` to decide who may fetch the student's contact details; the
         * exception is an unverified partner, who is approved outright.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpSchema, CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Follow Up Route
         * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
         * one partner.
         *
         * Only the coordinator who adopted the request may convert it. Writes
         * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
         * reads `partner_id` to decide who may fetch the student's contact details; the
         * exception is an unverified partner, who is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createFollowUp.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createFollowUp.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpSchema, CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext>): Mutation<CreateFollowUpData, CreateFollowUpError, MutationVariables<CreateFollowUpBody, CreateFollowUpParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpSchema, CreateFollowUpBody, CreateFollowUpData, CreateFollowUpParameters, OperationError<CreateFollowUpError>, TContext>): Array<Mutation<CreateFollowUpData, CreateFollowUpError, MutationVariables<CreateFollowUpBody, CreateFollowUpParameters>, TContext>>;
        };
        schema: CreateFollowUpSchema;
        types: {
            parameters: CreateFollowUpParameters;
            data: CreateFollowUpData;
            error: CreateFollowUpError;
            body: CreateFollowUpBody;
        };
    };
    /**
     * @summary Accept Follow Up Route
     * @description The invited partner accepts.
     *
     * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
     * snapshots the partner's contact details and records the coordinator<->partner edge.
     * A replay answers 409 rather than reverting a completed follow-up.
     */
    acceptFollowUp: {
        /**
         * @summary Accept Follow Up Route
         * @description The invited partner accepts.
         *
         * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
         * snapshots the partner's contact details and records the coordinator<->partner edge.
         * A replay answers 409 rather than reverting a completed follow-up.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AcceptFollowUpBody, AcceptFollowUpParameters, TMeta, TSignal>, client?: (schema: AcceptFollowUpSchema, options: ServiceOperationMutationFnOptions<AcceptFollowUpBody, AcceptFollowUpParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AcceptFollowUpData, AcceptFollowUpError>>): Promise<RequestFnResponse<AcceptFollowUpData, AcceptFollowUpError>>;
        /**
         * @summary Accept Follow Up Route
         * @description The invited partner accepts.
         *
         * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
         * snapshots the partner's contact details and records the coordinator<->partner edge.
         * A replay answers 409 rather than reverting a completed follow-up.
         */
        getMutationKey(parameters: DeepReadonly<AcceptFollowUpParameters> | void): ServiceOperationMutationKey<AcceptFollowUpSchema, AcceptFollowUpParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Accept Follow Up Route
         * @description The invited partner accepts.
         *
         * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
         * snapshots the partner's contact details and records the coordinator<->partner edge.
         * A replay answers 409 rather than reverting a completed follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.acceptFollowUp.useMutation({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.acceptFollowUp.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AcceptFollowUpBody, TContext = unknown>(parameters: DeepReadonly<AcceptFollowUpParameters>, options?: ServiceOperationUseMutationOptions<AcceptFollowUpSchema, AcceptFollowUpData, AcceptFollowUpParameters, TVariables, OperationError<AcceptFollowUpError>, TContext>): UseMutationResult<AcceptFollowUpData, OperationError<AcceptFollowUpError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Accept Follow Up Route
         * @description The invited partner accepts.
         *
         * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
         * snapshots the partner's contact details and records the coordinator<->partner edge.
         * A replay answers 409 rather than reverting a completed follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.acceptFollowUp.useMutation({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.acceptFollowUp.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AcceptFollowUpBody, AcceptFollowUpParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AcceptFollowUpSchema, AcceptFollowUpData, AcceptFollowUpParameters, TVariables, OperationError<AcceptFollowUpError>, TContext>): UseMutationResult<AcceptFollowUpData, OperationError<AcceptFollowUpError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Accept Follow Up Route
         * @description The invited partner accepts.
         *
         * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
         * snapshots the partner's contact details and records the coordinator<->partner edge.
         * A replay answers 409 rather than reverting a completed follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const acceptFollowUpTotal = qraft.v3Service.acceptFollowUp.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const acceptFollowUpTotal = qraft.v3Service.acceptFollowUp.useIsMutating({
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext> | MutationFiltersByMutationKey<AcceptFollowUpSchema, AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Accept Follow Up Route
         * @description The invited partner accepts.
         *
         * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
         * snapshots the partner's contact details and records the coordinator<->partner edge.
         * A replay answers 409 rather than reverting a completed follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const acceptFollowUpPendingMutationVariables = qraft.v3Service.acceptFollowUp.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const acceptFollowUpMutationData = qraft.v3Service.acceptFollowUp.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 follow_up_id: followUpId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AcceptFollowUpData, OperationError<AcceptFollowUpError>, MutationVariables<AcceptFollowUpBody, AcceptFollowUpParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext> | MutationFiltersByMutationKey<AcceptFollowUpSchema, AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext>;
            select?: (mutation: Mutation<AcceptFollowUpData, OperationError<AcceptFollowUpError>, MutationVariables<AcceptFollowUpBody, AcceptFollowUpParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Accept Follow Up Route
         * @description The invited partner accepts.
         *
         * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
         * snapshots the partner's contact details and records the coordinator<->partner edge.
         * A replay answers 409 rather than reverting a completed follow-up.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext> | MutationFiltersByMutationKey<AcceptFollowUpSchema, AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Accept Follow Up Route
         * @description The invited partner accepts.
         *
         * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
         * snapshots the partner's contact details and records the coordinator<->partner edge.
         * A replay answers 409 rather than reverting a completed follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.acceptFollowUp.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.acceptFollowUp.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext> | MutationFiltersByMutationKey<AcceptFollowUpSchema, AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext>): Mutation<AcceptFollowUpData, AcceptFollowUpError, MutationVariables<AcceptFollowUpBody, AcceptFollowUpParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext> | MutationFiltersByMutationKey<AcceptFollowUpSchema, AcceptFollowUpBody, AcceptFollowUpData, AcceptFollowUpParameters, OperationError<AcceptFollowUpError>, TContext>): Array<Mutation<AcceptFollowUpData, AcceptFollowUpError, MutationVariables<AcceptFollowUpBody, AcceptFollowUpParameters>, TContext>>;
        };
        schema: AcceptFollowUpSchema;
        types: {
            parameters: AcceptFollowUpParameters;
            data: AcceptFollowUpData;
            error: AcceptFollowUpError;
            body: AcceptFollowUpBody;
        };
    };
    /**
     * @summary Reject Follow Up Route
     * @description The invited partner declines.
     *
     * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
     * the coordinator can see who declined.
     */
    rejectFollowUp: {
        /**
         * @summary Reject Follow Up Route
         * @description The invited partner declines.
         *
         * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
         * the coordinator can see who declined.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RejectFollowUpBody, RejectFollowUpParameters, TMeta, TSignal>, client?: (schema: RejectFollowUpSchema, options: ServiceOperationMutationFnOptions<RejectFollowUpBody, RejectFollowUpParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RejectFollowUpData, RejectFollowUpError>>): Promise<RequestFnResponse<RejectFollowUpData, RejectFollowUpError>>;
        /**
         * @summary Reject Follow Up Route
         * @description The invited partner declines.
         *
         * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
         * the coordinator can see who declined.
         */
        getMutationKey(parameters: DeepReadonly<RejectFollowUpParameters> | void): ServiceOperationMutationKey<RejectFollowUpSchema, RejectFollowUpParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reject Follow Up Route
         * @description The invited partner declines.
         *
         * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
         * the coordinator can see who declined.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectFollowUp.useMutation({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectFollowUp.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RejectFollowUpBody, TContext = unknown>(parameters: DeepReadonly<RejectFollowUpParameters>, options?: ServiceOperationUseMutationOptions<RejectFollowUpSchema, RejectFollowUpData, RejectFollowUpParameters, TVariables, OperationError<RejectFollowUpError>, TContext>): UseMutationResult<RejectFollowUpData, OperationError<RejectFollowUpError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reject Follow Up Route
         * @description The invited partner declines.
         *
         * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
         * the coordinator can see who declined.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectFollowUp.useMutation({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.rejectFollowUp.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RejectFollowUpBody, RejectFollowUpParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RejectFollowUpSchema, RejectFollowUpData, RejectFollowUpParameters, TVariables, OperationError<RejectFollowUpError>, TContext>): UseMutationResult<RejectFollowUpData, OperationError<RejectFollowUpError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Reject Follow Up Route
         * @description The invited partner declines.
         *
         * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
         * the coordinator can see who declined.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const rejectFollowUpTotal = qraft.v3Service.rejectFollowUp.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const rejectFollowUpTotal = qraft.v3Service.rejectFollowUp.useIsMutating({
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpSchema, RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Reject Follow Up Route
         * @description The invited partner declines.
         *
         * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
         * the coordinator can see who declined.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const rejectFollowUpPendingMutationVariables = qraft.v3Service.rejectFollowUp.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const rejectFollowUpMutationData = qraft.v3Service.rejectFollowUp.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 follow_up_id: followUpId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RejectFollowUpData, OperationError<RejectFollowUpError>, MutationVariables<RejectFollowUpBody, RejectFollowUpParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpSchema, RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext>;
            select?: (mutation: Mutation<RejectFollowUpData, OperationError<RejectFollowUpError>, MutationVariables<RejectFollowUpBody, RejectFollowUpParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Reject Follow Up Route
         * @description The invited partner declines.
         *
         * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
         * the coordinator can see who declined.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpSchema, RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Reject Follow Up Route
         * @description The invited partner declines.
         *
         * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
         * the coordinator can see who declined.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.rejectFollowUp.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.rejectFollowUp.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpSchema, RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext>): Mutation<RejectFollowUpData, RejectFollowUpError, MutationVariables<RejectFollowUpBody, RejectFollowUpParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpSchema, RejectFollowUpBody, RejectFollowUpData, RejectFollowUpParameters, OperationError<RejectFollowUpError>, TContext>): Array<Mutation<RejectFollowUpData, RejectFollowUpError, MutationVariables<RejectFollowUpBody, RejectFollowUpParameters>, TContext>>;
        };
        schema: RejectFollowUpSchema;
        types: {
            parameters: RejectFollowUpParameters;
            data: RejectFollowUpData;
            error: RejectFollowUpError;
            body: RejectFollowUpBody;
        };
    };
    /**
     * @summary Set Follow Up Partner Route
     * @description The coordinator reassigns the follow-up to a different partner.
     *
     * Refused with 409 once the current partner has accepted. A verified partner is
     * invited; a private unverified one is approved outright.
     */
    setFollowUpPartner: {
        /**
         * @summary Set Follow Up Partner Route
         * @description The coordinator reassigns the follow-up to a different partner.
         *
         * Refused with 409 once the current partner has accepted. A verified partner is
         * invited; a private unverified one is approved outright.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SetFollowUpPartnerBody, SetFollowUpPartnerParameters, TMeta, TSignal>, client?: (schema: SetFollowUpPartnerSchema, options: ServiceOperationMutationFnOptions<SetFollowUpPartnerBody, SetFollowUpPartnerParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SetFollowUpPartnerData, SetFollowUpPartnerError>>): Promise<RequestFnResponse<SetFollowUpPartnerData, SetFollowUpPartnerError>>;
        /**
         * @summary Set Follow Up Partner Route
         * @description The coordinator reassigns the follow-up to a different partner.
         *
         * Refused with 409 once the current partner has accepted. A verified partner is
         * invited; a private unverified one is approved outright.
         */
        getMutationKey(parameters: DeepReadonly<SetFollowUpPartnerParameters> | void): ServiceOperationMutationKey<SetFollowUpPartnerSchema, SetFollowUpPartnerParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Follow Up Partner Route
         * @description The coordinator reassigns the follow-up to a different partner.
         *
         * Refused with 409 once the current partner has accepted. A verified partner is
         * invited; a private unverified one is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setFollowUpPartner.useMutation({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setFollowUpPartner.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SetFollowUpPartnerBody, TContext = unknown>(parameters: DeepReadonly<SetFollowUpPartnerParameters>, options?: ServiceOperationUseMutationOptions<SetFollowUpPartnerSchema, SetFollowUpPartnerData, SetFollowUpPartnerParameters, TVariables, OperationError<SetFollowUpPartnerError>, TContext>): UseMutationResult<SetFollowUpPartnerData, OperationError<SetFollowUpPartnerError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Set Follow Up Partner Route
         * @description The coordinator reassigns the follow-up to a different partner.
         *
         * Refused with 409 once the current partner has accepted. A verified partner is
         * invited; a private unverified one is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setFollowUpPartner.useMutation({
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.setFollowUpPartner.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         follow_up_id: followUpId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SetFollowUpPartnerBody, SetFollowUpPartnerParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SetFollowUpPartnerSchema, SetFollowUpPartnerData, SetFollowUpPartnerParameters, TVariables, OperationError<SetFollowUpPartnerError>, TContext>): UseMutationResult<SetFollowUpPartnerData, OperationError<SetFollowUpPartnerError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Set Follow Up Partner Route
         * @description The coordinator reassigns the follow-up to a different partner.
         *
         * Refused with 409 once the current partner has accepted. A verified partner is
         * invited; a private unverified one is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const setFollowUpPartnerTotal = qraft.v3Service.setFollowUpPartner.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const setFollowUpPartnerTotal = qraft.v3Service.setFollowUpPartner.useIsMutating({
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<SetFollowUpPartnerSchema, SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Set Follow Up Partner Route
         * @description The coordinator reassigns the follow-up to a different partner.
         *
         * Refused with 409 once the current partner has accepted. A verified partner is
         * invited; a private unverified one is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const setFollowUpPartnerPendingMutationVariables = qraft.v3Service.setFollowUpPartner.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const setFollowUpPartnerMutationData = qraft.v3Service.setFollowUpPartner.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 follow_up_id: followUpId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SetFollowUpPartnerData, OperationError<SetFollowUpPartnerError>, MutationVariables<SetFollowUpPartnerBody, SetFollowUpPartnerParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<SetFollowUpPartnerSchema, SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext>;
            select?: (mutation: Mutation<SetFollowUpPartnerData, OperationError<SetFollowUpPartnerError>, MutationVariables<SetFollowUpPartnerBody, SetFollowUpPartnerParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Set Follow Up Partner Route
         * @description The coordinator reassigns the follow-up to a different partner.
         *
         * Refused with 409 once the current partner has accepted. A verified partner is
         * invited; a private unverified one is approved outright.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<SetFollowUpPartnerSchema, SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Set Follow Up Partner Route
         * @description The coordinator reassigns the follow-up to a different partner.
         *
         * Refused with 409 once the current partner has accepted. A verified partner is
         * invited; a private unverified one is approved outright.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.setFollowUpPartner.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             follow_up_id: followUpId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.setFollowUpPartner.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<SetFollowUpPartnerSchema, SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext>): Mutation<SetFollowUpPartnerData, SetFollowUpPartnerError, MutationVariables<SetFollowUpPartnerBody, SetFollowUpPartnerParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<SetFollowUpPartnerSchema, SetFollowUpPartnerBody, SetFollowUpPartnerData, SetFollowUpPartnerParameters, OperationError<SetFollowUpPartnerError>, TContext>): Array<Mutation<SetFollowUpPartnerData, SetFollowUpPartnerError, MutationVariables<SetFollowUpPartnerBody, SetFollowUpPartnerParameters>, TContext>>;
        };
        schema: SetFollowUpPartnerSchema;
        types: {
            parameters: SetFollowUpPartnerParameters;
            data: SetFollowUpPartnerData;
            error: SetFollowUpPartnerError;
            body: SetFollowUpPartnerBody;
        };
    };
    /**
     * @summary List Follow Up Network
     * @description Every follow-up coordinator and partner on the platform.
     *
     * System-wide, not a group roster: the only roster predicate is the two profile types.
     * An unverified partner is visible only to the coordinator who created them, the one
     * caller-dependent thing about the page. `profile_type` narrows within the two and
     * can't widen past them.
     */
    listFollowUpNetwork: {
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpNetworkParameters, TMeta, TSignal> | void), client?: (schema: ListFollowUpNetworkSchema, options: {
            parameters: ListFollowUpNetworkParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpNetworkData, ListFollowUpNetworkError>>): Promise<RequestFnResponse<ListFollowUpNetworkData, ListFollowUpNetworkError>>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpNetworkParameters> | void): ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpNetwork.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpNetwork.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpNetworkData>(parameters: ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListFollowUpNetworkData, ListFollowUpNetworkError, TData, ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpNetworkError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpNetwork.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpNetwork.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpNetworkData>(parameters: ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void), options: Omit<DefinedInitialDataOptions<ListFollowUpNetworkData, ListFollowUpNetworkError, TData, ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpNetworkError>>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpNetworkParameters> | void): ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpNetwork.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpNetworkParameters, TQueryFnData = ListFollowUpNetworkData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpNetworkParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpNetworkError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpNetworkError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpNetwork.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpNetworkParameters, TQueryFnData = ListFollowUpNetworkData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpNetworkParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpNetworkError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpNetworkData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpNetworkError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpNetworkTotal = qraft.v3Service.listFollowUpNetwork.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpNetworkByParametersTotal = qraft.v3Service.listFollowUpNetwork.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             id: id
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | QueryFiltersByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpNetworkResults = qraft.v3Service.listFollowUpNetwork.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpNetworkResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpNetworkCombinedResults = qraft.v3Service.listFollowUpNetwork.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpNetworkCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters, ListFollowUpNetworkData, ListFollowUpNetworkError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpNetworkData, ListFollowUpNetworkError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpNetworkData, ListFollowUpNetworkError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpNetwork.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpNetwork.useSuspenseQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpNetworkData>(parameters: ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListFollowUpNetworkData, ListFollowUpNetworkError, TData, ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpNetworkError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpNetwork.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpNetworkParameters, TData = ListFollowUpNetworkData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpNetworkData, ListFollowUpNetworkError, OperationInfiniteData<TData, ListFollowUpNetworkParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpNetworkData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpNetworkParameters>, OperationError<ListFollowUpNetworkError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpNetworkData = qraft.v3Service.listFollowUpNetwork.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpNetworkResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpNetworkCombinedData = qraft.v3Service.listFollowUpNetwork.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpNetworkCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters, ListFollowUpNetworkData, ListFollowUpNetworkError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpNetworkData, ListFollowUpNetworkError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpNetworkData, ListFollowUpNetworkError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpNetworkSchema, ListFollowUpNetworkData, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | void): Promise<ListFollowUpNetworkData>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpNetworkSchema, ListFollowUpNetworkData, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | void): Promise<void>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpNetworkSchema, ListFollowUpNetworkData, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | void): Promise<ListFollowUpNetworkData>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpNetworkParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpNetworkSchema, ListFollowUpNetworkData, ListFollowUpNetworkParameters, DeepReadonly<TPageParam>, ListFollowUpNetworkError> | void): Promise<OperationInfiniteData<ListFollowUpNetworkData, ListFollowUpNetworkParameters>>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpNetworkParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpNetworkSchema, ListFollowUpNetworkData, ListFollowUpNetworkParameters, DeepReadonly<TPageParam>, ListFollowUpNetworkError> | void): Promise<void>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpNetworkParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpNetworkSchema, ListFollowUpNetworkData, ListFollowUpNetworkParameters, DeepReadonly<TPageParam>, ListFollowUpNetworkError> | void): Promise<OperationInfiniteData<ListFollowUpNetworkData, ListFollowUpNetworkParameters>>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void)): ListFollowUpNetworkData | undefined;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void)): OperationInfiniteData<ListFollowUpNetworkData, ListFollowUpNetworkParameters> | undefined;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | QueryFiltersByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpNetworkData, ListFollowUpNetworkParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>,
            data: ListFollowUpNetworkData | undefined
        ]>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | (DeepReadonly<ListFollowUpNetworkParameters> | void)): QueryState<ListFollowUpNetworkData, ListFollowUpNetworkError> | undefined;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpNetworkParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters> | void): QueryState<OperationInfiniteData<ListFollowUpNetworkData, ListFollowUpNetworkParameters>, ListFollowUpNetworkError> | undefined;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpNetworkParameters> | undefined) | ServiceOperationQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>, updater: Updater<NoInfer<ListFollowUpNetworkData> | undefined, NoInfer<DeepReadonly<ListFollowUpNetworkData>> | undefined>, options?: SetDataOptions): ListFollowUpNetworkData | undefined;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpNetworkParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpNetworkData, ListFollowUpNetworkParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpNetworkData, ListFollowUpNetworkParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpNetworkData, ListFollowUpNetworkParameters> | undefined;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | QueryFiltersByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>, updater: Updater<NoInfer<ListFollowUpNetworkData> | undefined, NoInfer<ListFollowUpNetworkData> | undefined>, options?: SetDataOptions): Array<ListFollowUpNetworkData | undefined>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | QueryFiltersByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | QueryFiltersByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | QueryFiltersByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>): void;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | QueryFiltersByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Network
         * @description Every follow-up coordinator and partner on the platform.
         *
         * System-wide, not a group roster: the only roster predicate is the two profile types.
         * An unverified partner is visible only to the coordinator who created them, the one
         * caller-dependent thing about the page. `profile_type` narrows within the two and
         * can't widen past them.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError> | QueryFiltersByQueryKey<ListFollowUpNetworkSchema, ListFollowUpNetworkData, TInfinite, ListFollowUpNetworkParameters, ListFollowUpNetworkError>): number;
        schema: ListFollowUpNetworkSchema;
        types: {
            parameters: ListFollowUpNetworkParameters;
            data: ListFollowUpNetworkData;
            error: ListFollowUpNetworkError;
        };
    };
    /**
     * @summary List Follow Up Network Map
     * @description The same directory, restricted to the people who carry coordinates.
     *
     * The same eight filters and the same gate as the list — one legacy ajax action
     * served both. `count` is the pinnable population under the caller's filters, so
     * a client can report *pinned of roster* by reading it beside the list's. Every
     * field the marker's info window renders is on the row; there is no second
     * request behind a marker.
     */
    listFollowUpNetworkMap: {
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpNetworkMapParameters, TMeta, TSignal> | void), client?: (schema: ListFollowUpNetworkMapSchema, options: {
            parameters: ListFollowUpNetworkMapParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError>>): Promise<RequestFnResponse<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError>>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpNetworkMapParameters> | void): ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpNetworkMap.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpNetworkMap.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpNetworkMapData>(parameters: ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError, TData, ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpNetworkMapError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpNetworkMap.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpNetworkMap.useQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpNetworkMapData>(parameters: ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void), options: Omit<DefinedInitialDataOptions<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError, TData, ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpNetworkMapError>>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpNetworkMapParameters> | void): ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpNetworkMap.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpNetworkMapParameters, TQueryFnData = ListFollowUpNetworkMapData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpNetworkMapParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpNetworkMapError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpNetworkMapError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpNetworkMap.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpNetworkMapParameters, TQueryFnData = ListFollowUpNetworkMapData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpNetworkMapParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpNetworkMapError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpNetworkMapData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpNetworkMapError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpNetworkMapTotal = qraft.v3Service.listFollowUpNetworkMap.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpNetworkMapByParametersTotal = qraft.v3Service.listFollowUpNetworkMap.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             id: id
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | QueryFiltersByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpNetworkMapResults = qraft.v3Service.listFollowUpNetworkMap.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpNetworkMapResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpNetworkMapCombinedResults = qraft.v3Service.listFollowUpNetworkMap.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpNetworkMapCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapData, ListFollowUpNetworkMapError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpNetworkMap.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpNetworkMap.useSuspenseQuery({
         *     query: {
         *         id: id
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpNetworkMapData>(parameters: ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError, TData, ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpNetworkMapError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpNetworkMap.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             id: initialId
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpNetworkMapParameters, TData = ListFollowUpNetworkMapData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError, OperationInfiniteData<TData, ListFollowUpNetworkMapParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpNetworkMapData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpNetworkMapParameters>, OperationError<ListFollowUpNetworkMapError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpNetworkMapData = qraft.v3Service.listFollowUpNetworkMap.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpNetworkMapResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpNetworkMapCombinedData = qraft.v3Service.listFollowUpNetworkMap.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 id: id1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 id: id2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpNetworkMapCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapData, ListFollowUpNetworkMapError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | void): Promise<ListFollowUpNetworkMapData>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | void): Promise<void>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | void): Promise<ListFollowUpNetworkMapData>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpNetworkMapParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters, DeepReadonly<TPageParam>, ListFollowUpNetworkMapError> | void): Promise<OperationInfiniteData<ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters>>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpNetworkMapParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters, DeepReadonly<TPageParam>, ListFollowUpNetworkMapError> | void): Promise<void>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpNetworkMapParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters, DeepReadonly<TPageParam>, ListFollowUpNetworkMapError> | void): Promise<OperationInfiniteData<ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters>>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void)): ListFollowUpNetworkMapData | undefined;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void)): OperationInfiniteData<ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters> | undefined;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | QueryFiltersByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>,
            data: ListFollowUpNetworkMapData | undefined
        ]>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | (DeepReadonly<ListFollowUpNetworkMapParameters> | void)): QueryState<ListFollowUpNetworkMapData, ListFollowUpNetworkMapError> | undefined;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpNetworkMapParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters> | void): QueryState<OperationInfiniteData<ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters>, ListFollowUpNetworkMapError> | undefined;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpNetworkMapParameters> | undefined) | ServiceOperationQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>, updater: Updater<NoInfer<ListFollowUpNetworkMapData> | undefined, NoInfer<DeepReadonly<ListFollowUpNetworkMapData>> | undefined>, options?: SetDataOptions): ListFollowUpNetworkMapData | undefined;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpNetworkMapParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpNetworkMapData, ListFollowUpNetworkMapParameters> | undefined;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | QueryFiltersByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>, updater: Updater<NoInfer<ListFollowUpNetworkMapData> | undefined, NoInfer<ListFollowUpNetworkMapData> | undefined>, options?: SetDataOptions): Array<ListFollowUpNetworkMapData | undefined>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | QueryFiltersByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | QueryFiltersByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | QueryFiltersByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>): void;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | QueryFiltersByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Network Map
         * @description The same directory, restricted to the people who carry coordinates.
         *
         * The same eight filters and the same gate as the list — one legacy ajax action
         * served both. `count` is the pinnable population under the caller's filters, so
         * a client can report *pinned of roster* by reading it beside the list's. Every
         * field the marker's info window renders is on the row; there is no second
         * request behind a marker.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError> | QueryFiltersByQueryKey<ListFollowUpNetworkMapSchema, ListFollowUpNetworkMapData, TInfinite, ListFollowUpNetworkMapParameters, ListFollowUpNetworkMapError>): number;
        schema: ListFollowUpNetworkMapSchema;
        types: {
            parameters: ListFollowUpNetworkMapParameters;
            data: ListFollowUpNetworkMapData;
            error: ListFollowUpNetworkMapError;
        };
    };
    /**
     * @summary List Follow Up Partner Directory
     * @description The partners on the calling coordinator's follow-up network.
     *
     * Read from `follow_up_network`. An unverified partner is visible only to the
     * coordinator who created them. No filter panel, search box or row action, as in
     * legacy, so this path has no `LIST_FILTERS` key.
     */
    listFollowUpPartnerDirectory: {
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpPartnerDirectoryParameters, TMeta, TSignal> | void), client?: (schema: ListFollowUpPartnerDirectorySchema, options: {
            parameters: ListFollowUpPartnerDirectoryParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError>>): Promise<RequestFnResponse<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError>>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void): ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpPartnerDirectory.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpPartnerDirectory.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpPartnerDirectoryData>(parameters: ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError, TData, ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpPartnerDirectoryError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpPartnerDirectory.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpPartnerDirectory.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpPartnerDirectoryData>(parameters: ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void), options: Omit<DefinedInitialDataOptions<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError, TData, ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpPartnerDirectoryError>>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void): ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpPartnerDirectory.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpPartnerDirectoryParameters, TQueryFnData = ListFollowUpPartnerDirectoryData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpPartnerDirectoryParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpPartnerDirectoryError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpPartnerDirectoryError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpPartnerDirectory.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpPartnerDirectoryParameters, TQueryFnData = ListFollowUpPartnerDirectoryData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpPartnerDirectoryParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpPartnerDirectoryError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpPartnerDirectoryData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpPartnerDirectoryError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpPartnerDirectoryTotal = qraft.v3Service.listFollowUpPartnerDirectory.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpPartnerDirectoryByParametersTotal = qraft.v3Service.listFollowUpPartnerDirectory.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | QueryFiltersByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpPartnerDirectoryResults = qraft.v3Service.listFollowUpPartnerDirectory.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpPartnerDirectoryResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpPartnerDirectoryCombinedResults = qraft.v3Service.listFollowUpPartnerDirectory.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpPartnerDirectoryCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpPartnerDirectory.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpPartnerDirectory.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpPartnerDirectoryData>(parameters: ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError, TData, ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpPartnerDirectoryError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpPartnerDirectory.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpPartnerDirectoryParameters, TData = ListFollowUpPartnerDirectoryData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError, OperationInfiniteData<TData, ListFollowUpPartnerDirectoryParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpPartnerDirectoryData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpPartnerDirectoryParameters>, OperationError<ListFollowUpPartnerDirectoryError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpPartnerDirectoryData = qraft.v3Service.listFollowUpPartnerDirectory.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpPartnerDirectoryResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpPartnerDirectoryCombinedData = qraft.v3Service.listFollowUpPartnerDirectory.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpPartnerDirectoryCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | void): Promise<ListFollowUpPartnerDirectoryData>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | void): Promise<void>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | void): Promise<ListFollowUpPartnerDirectoryData>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpPartnerDirectoryParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters, DeepReadonly<TPageParam>, ListFollowUpPartnerDirectoryError> | void): Promise<OperationInfiniteData<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters>>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpPartnerDirectoryParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters, DeepReadonly<TPageParam>, ListFollowUpPartnerDirectoryError> | void): Promise<void>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpPartnerDirectoryParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters, DeepReadonly<TPageParam>, ListFollowUpPartnerDirectoryError> | void): Promise<OperationInfiniteData<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters>>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void)): ListFollowUpPartnerDirectoryData | undefined;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void)): OperationInfiniteData<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters> | undefined;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | QueryFiltersByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>,
            data: ListFollowUpPartnerDirectoryData | undefined
        ]>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | void)): QueryState<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryError> | undefined;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpPartnerDirectoryParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters> | void): QueryState<OperationInfiniteData<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters>, ListFollowUpPartnerDirectoryError> | undefined;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | undefined) | ServiceOperationQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>, updater: Updater<NoInfer<ListFollowUpPartnerDirectoryData> | undefined, NoInfer<DeepReadonly<ListFollowUpPartnerDirectoryData>> | undefined>, options?: SetDataOptions): ListFollowUpPartnerDirectoryData | undefined;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpPartnerDirectoryParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpPartnerDirectoryData, ListFollowUpPartnerDirectoryParameters> | undefined;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | QueryFiltersByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>, updater: Updater<NoInfer<ListFollowUpPartnerDirectoryData> | undefined, NoInfer<ListFollowUpPartnerDirectoryData> | undefined>, options?: SetDataOptions): Array<ListFollowUpPartnerDirectoryData | undefined>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | QueryFiltersByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | QueryFiltersByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | QueryFiltersByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>): void;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | QueryFiltersByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Partner Directory
         * @description The partners on the calling coordinator's follow-up network.
         *
         * Read from `follow_up_network`. An unverified partner is visible only to the
         * coordinator who created them. No filter panel, search box or row action, as in
         * legacy, so this path has no `LIST_FILTERS` key.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError> | QueryFiltersByQueryKey<ListFollowUpPartnerDirectorySchema, ListFollowUpPartnerDirectoryData, TInfinite, ListFollowUpPartnerDirectoryParameters, ListFollowUpPartnerDirectoryError>): number;
        schema: ListFollowUpPartnerDirectorySchema;
        types: {
            parameters: ListFollowUpPartnerDirectoryParameters;
            data: ListFollowUpPartnerDirectoryData;
            error: ListFollowUpPartnerDirectoryError;
        };
    };
    /**
     * @summary Create Follow Up Partner
     * @description A coordinator registers a follow-up partner.
     *
     * The partner is created unverified and visible only to this coordinator, the email is
     * optional, and one network edge is written from the authenticated caller. There is no
     * approval queue.
     */
    createFollowUpPartner: {
        /**
         * @summary Create Follow Up Partner
         * @description A coordinator registers a follow-up partner.
         *
         * The partner is created unverified and visible only to this coordinator, the email is
         * optional, and one network edge is written from the authenticated caller. There is no
         * approval queue.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateFollowUpPartnerBody, CreateFollowUpPartnerParameters, TMeta, TSignal>, client?: (schema: CreateFollowUpPartnerSchema, options: ServiceOperationMutationFnOptions<CreateFollowUpPartnerBody, CreateFollowUpPartnerParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateFollowUpPartnerData, CreateFollowUpPartnerError>>): Promise<RequestFnResponse<CreateFollowUpPartnerData, CreateFollowUpPartnerError>>;
        /**
         * @summary Create Follow Up Partner
         * @description A coordinator registers a follow-up partner.
         *
         * The partner is created unverified and visible only to this coordinator, the email is
         * optional, and one network edge is written from the authenticated caller. There is no
         * approval queue.
         */
        getMutationKey(parameters: DeepReadonly<CreateFollowUpPartnerParameters> | void): ServiceOperationMutationKey<CreateFollowUpPartnerSchema, CreateFollowUpPartnerParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Follow Up Partner
         * @description A coordinator registers a follow-up partner.
         *
         * The partner is created unverified and visible only to this coordinator, the email is
         * optional, and one network edge is written from the authenticated caller. There is no
         * approval queue.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createFollowUpPartner.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createFollowUpPartner.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateFollowUpPartnerBody, TContext = unknown>(parameters: DeepReadonly<CreateFollowUpPartnerParameters>, options?: ServiceOperationUseMutationOptions<CreateFollowUpPartnerSchema, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, TVariables, OperationError<CreateFollowUpPartnerError>, TContext>): UseMutationResult<CreateFollowUpPartnerData, OperationError<CreateFollowUpPartnerError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Follow Up Partner
         * @description A coordinator registers a follow-up partner.
         *
         * The partner is created unverified and visible only to this coordinator, the email is
         * optional, and one network edge is written from the authenticated caller. There is no
         * approval queue.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createFollowUpPartner.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createFollowUpPartner.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateFollowUpPartnerBody, CreateFollowUpPartnerParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateFollowUpPartnerSchema, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, TVariables, OperationError<CreateFollowUpPartnerError>, TContext>): UseMutationResult<CreateFollowUpPartnerData, OperationError<CreateFollowUpPartnerError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Follow Up Partner
         * @description A coordinator registers a follow-up partner.
         *
         * The partner is created unverified and visible only to this coordinator, the email is
         * optional, and one network edge is written from the authenticated caller. There is no
         * approval queue.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createFollowUpPartnerTotal = qraft.v3Service.createFollowUpPartner.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createFollowUpPartnerTotal = qraft.v3Service.createFollowUpPartner.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpPartnerSchema, CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Follow Up Partner
         * @description A coordinator registers a follow-up partner.
         *
         * The partner is created unverified and visible only to this coordinator, the email is
         * optional, and one network edge is written from the authenticated caller. There is no
         * approval queue.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createFollowUpPartnerPendingMutationVariables = qraft.v3Service.createFollowUpPartner.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createFollowUpPartnerMutationData = qraft.v3Service.createFollowUpPartner.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateFollowUpPartnerData, OperationError<CreateFollowUpPartnerError>, MutationVariables<CreateFollowUpPartnerBody, CreateFollowUpPartnerParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpPartnerSchema, CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext>;
            select?: (mutation: Mutation<CreateFollowUpPartnerData, OperationError<CreateFollowUpPartnerError>, MutationVariables<CreateFollowUpPartnerBody, CreateFollowUpPartnerParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Follow Up Partner
         * @description A coordinator registers a follow-up partner.
         *
         * The partner is created unverified and visible only to this coordinator, the email is
         * optional, and one network edge is written from the authenticated caller. There is no
         * approval queue.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpPartnerSchema, CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Follow Up Partner
         * @description A coordinator registers a follow-up partner.
         *
         * The partner is created unverified and visible only to this coordinator, the email is
         * optional, and one network edge is written from the authenticated caller. There is no
         * approval queue.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createFollowUpPartner.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createFollowUpPartner.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpPartnerSchema, CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext>): Mutation<CreateFollowUpPartnerData, CreateFollowUpPartnerError, MutationVariables<CreateFollowUpPartnerBody, CreateFollowUpPartnerParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext> | MutationFiltersByMutationKey<CreateFollowUpPartnerSchema, CreateFollowUpPartnerBody, CreateFollowUpPartnerData, CreateFollowUpPartnerParameters, OperationError<CreateFollowUpPartnerError>, TContext>): Array<Mutation<CreateFollowUpPartnerData, CreateFollowUpPartnerError, MutationVariables<CreateFollowUpPartnerBody, CreateFollowUpPartnerParameters>, TContext>>;
        };
        schema: CreateFollowUpPartnerSchema;
        types: {
            parameters: CreateFollowUpPartnerParameters;
            data: CreateFollowUpPartnerData;
            error: CreateFollowUpPartnerError;
            body: CreateFollowUpPartnerBody;
        };
    };
    /**
     * @summary List Follow Up Coordinator Directory
     * @description The coordinators who assigned this partner a follow-up they hold.
     *
     * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
     * undirected and would list coordinators the partner never worked with. A partner who
     * registered but never accepted an assignment sees an empty tab. Same columns as All
     * Partners with Registered in place of Congregation, and no visibility filter.
     */
    listFollowUpCoordinatorDirectory: {
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpCoordinatorDirectoryParameters, TMeta, TSignal> | void), client?: (schema: ListFollowUpCoordinatorDirectorySchema, options: {
            parameters: ListFollowUpCoordinatorDirectoryParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError>>): Promise<RequestFnResponse<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError>>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void): ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpCoordinatorDirectory.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpCoordinatorDirectory.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpCoordinatorDirectoryData>(parameters: ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError, TData, ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpCoordinatorDirectoryError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpCoordinatorDirectory.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpCoordinatorDirectory.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpCoordinatorDirectoryData>(parameters: ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void), options: Omit<DefinedInitialDataOptions<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError, TData, ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpCoordinatorDirectoryError>>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void): ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpCoordinatorDirectory.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpCoordinatorDirectoryParameters, TQueryFnData = ListFollowUpCoordinatorDirectoryData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpCoordinatorDirectoryParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpCoordinatorDirectoryError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpCoordinatorDirectoryError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpCoordinatorDirectory.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpCoordinatorDirectoryParameters, TQueryFnData = ListFollowUpCoordinatorDirectoryData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpCoordinatorDirectoryParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpCoordinatorDirectoryError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpCoordinatorDirectoryData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpCoordinatorDirectoryError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpCoordinatorDirectoryTotal = qraft.v3Service.listFollowUpCoordinatorDirectory.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpCoordinatorDirectoryByParametersTotal = qraft.v3Service.listFollowUpCoordinatorDirectory.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | QueryFiltersByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpCoordinatorDirectoryResults = qraft.v3Service.listFollowUpCoordinatorDirectory.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpCoordinatorDirectoryResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpCoordinatorDirectoryCombinedResults = qraft.v3Service.listFollowUpCoordinatorDirectory.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpCoordinatorDirectoryCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpCoordinatorDirectory.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpCoordinatorDirectory.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpCoordinatorDirectoryData>(parameters: ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError, TData, ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpCoordinatorDirectoryError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpCoordinatorDirectory.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpCoordinatorDirectoryParameters, TData = ListFollowUpCoordinatorDirectoryData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError, OperationInfiniteData<TData, ListFollowUpCoordinatorDirectoryParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpCoordinatorDirectoryData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpCoordinatorDirectoryParameters>, OperationError<ListFollowUpCoordinatorDirectoryError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpCoordinatorDirectoryData = qraft.v3Service.listFollowUpCoordinatorDirectory.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpCoordinatorDirectoryResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpCoordinatorDirectoryCombinedData = qraft.v3Service.listFollowUpCoordinatorDirectory.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpCoordinatorDirectoryCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | void): Promise<ListFollowUpCoordinatorDirectoryData>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | void): Promise<void>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | void): Promise<ListFollowUpCoordinatorDirectoryData>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpCoordinatorDirectoryParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters, DeepReadonly<TPageParam>, ListFollowUpCoordinatorDirectoryError> | void): Promise<OperationInfiniteData<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters>>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpCoordinatorDirectoryParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters, DeepReadonly<TPageParam>, ListFollowUpCoordinatorDirectoryError> | void): Promise<void>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpCoordinatorDirectoryParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters, DeepReadonly<TPageParam>, ListFollowUpCoordinatorDirectoryError> | void): Promise<OperationInfiniteData<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters>>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void)): ListFollowUpCoordinatorDirectoryData | undefined;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void)): OperationInfiniteData<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters> | undefined;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | QueryFiltersByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>,
            data: ListFollowUpCoordinatorDirectoryData | undefined
        ]>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | void)): QueryState<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryError> | undefined;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters> | void): QueryState<OperationInfiniteData<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters>, ListFollowUpCoordinatorDirectoryError> | undefined;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | undefined) | ServiceOperationQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>, updater: Updater<NoInfer<ListFollowUpCoordinatorDirectoryData> | undefined, NoInfer<DeepReadonly<ListFollowUpCoordinatorDirectoryData>> | undefined>, options?: SetDataOptions): ListFollowUpCoordinatorDirectoryData | undefined;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpCoordinatorDirectoryParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpCoordinatorDirectoryData, ListFollowUpCoordinatorDirectoryParameters> | undefined;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | QueryFiltersByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>, updater: Updater<NoInfer<ListFollowUpCoordinatorDirectoryData> | undefined, NoInfer<ListFollowUpCoordinatorDirectoryData> | undefined>, options?: SetDataOptions): Array<ListFollowUpCoordinatorDirectoryData | undefined>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | QueryFiltersByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | QueryFiltersByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | QueryFiltersByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>): void;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | QueryFiltersByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Coordinator Directory
         * @description The coordinators who assigned this partner a follow-up they hold.
         *
         * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
         * undirected and would list coordinators the partner never worked with. A partner who
         * registered but never accepted an assignment sees an empty tab. Same columns as All
         * Partners with Registered in place of Congregation, and no visibility filter.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError> | QueryFiltersByQueryKey<ListFollowUpCoordinatorDirectorySchema, ListFollowUpCoordinatorDirectoryData, TInfinite, ListFollowUpCoordinatorDirectoryParameters, ListFollowUpCoordinatorDirectoryError>): number;
        schema: ListFollowUpCoordinatorDirectorySchema;
        types: {
            parameters: ListFollowUpCoordinatorDirectoryParameters;
            data: ListFollowUpCoordinatorDirectoryData;
            error: ListFollowUpCoordinatorDirectoryError;
        };
    };
    /**
     * @summary List Follow Up Students
     * @description The calling coordinator's or partner's own caseload students.
     *
     * One operation for both roles: a coordinator sees the students on their follow-ups
     * plus those they adopted a request for; a partner sees the students on the follow-ups
     * they accepted.
     */
    listFollowUpStudents: {
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListFollowUpStudentsParameters, TMeta, TSignal> | void), client?: (schema: ListFollowUpStudentsSchema, options: {
            parameters: ListFollowUpStudentsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListFollowUpStudentsData, ListFollowUpStudentsError>>): Promise<RequestFnResponse<ListFollowUpStudentsData, ListFollowUpStudentsError>>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        getQueryKey(parameters: DeepReadonly<ListFollowUpStudentsParameters> | void): ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpStudents.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpStudents.useQuery({
         *     query: {
         *         display_name: displayName
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpStudentsData>(parameters: ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListFollowUpStudentsData, ListFollowUpStudentsError, TData, ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListFollowUpStudentsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpStudents.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listFollowUpStudents.useQuery({
         *     query: {
         *         display_name: displayName
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListFollowUpStudentsData>(parameters: ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void), options: Omit<DefinedInitialDataOptions<ListFollowUpStudentsData, ListFollowUpStudentsError, TData, ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListFollowUpStudentsError>>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListFollowUpStudentsParameters> | void): ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpStudents.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             display_name: initialDisplayName
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpStudentsParameters, TQueryFnData = ListFollowUpStudentsData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpStudentsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpStudentsError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListFollowUpStudentsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpStudents.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             display_name: initialDisplayName
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListFollowUpStudentsParameters, TQueryFnData = ListFollowUpStudentsData, TData = OperationInfiniteData<TQueryFnData, ListFollowUpStudentsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListFollowUpStudentsError, TData, ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpStudentsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListFollowUpStudentsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listFollowUpStudentsTotal = qraft.v3Service.listFollowUpStudents.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listFollowUpStudentsByParametersTotal = qraft.v3Service.listFollowUpStudents.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             display_name: displayName
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | QueryFiltersByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listFollowUpStudentsResults = qraft.v3Service.listFollowUpStudents.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 display_name: displayName1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 display_name: displayName2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpStudentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listFollowUpStudentsCombinedResults = qraft.v3Service.listFollowUpStudents.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 display_name: displayName1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 display_name: displayName2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpStudentsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters, ListFollowUpStudentsData, ListFollowUpStudentsError>>, TCombinedResult = Array<UseQueryResult<ListFollowUpStudentsData, ListFollowUpStudentsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListFollowUpStudentsData, ListFollowUpStudentsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpStudents.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listFollowUpStudents.useSuspenseQuery({
         *     query: {
         *         display_name: displayName
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListFollowUpStudentsData>(parameters: ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListFollowUpStudentsData, ListFollowUpStudentsError, TData, ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListFollowUpStudentsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listFollowUpStudents.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             display_name: initialDisplayName
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListFollowUpStudentsParameters, TData = ListFollowUpStudentsData>(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListFollowUpStudentsData, ListFollowUpStudentsError, OperationInfiniteData<TData, ListFollowUpStudentsParameters>, ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListFollowUpStudentsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListFollowUpStudentsParameters>, OperationError<ListFollowUpStudentsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listFollowUpStudentsData = qraft.v3Service.listFollowUpStudents.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 display_name: displayName1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 display_name: displayName2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpStudentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listFollowUpStudentsCombinedData = qraft.v3Service.listFollowUpStudents.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 display_name: displayName1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 display_name: displayName2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listFollowUpStudentsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters, ListFollowUpStudentsData, ListFollowUpStudentsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListFollowUpStudentsData, ListFollowUpStudentsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListFollowUpStudentsData, ListFollowUpStudentsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpStudentsSchema, ListFollowUpStudentsData, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | void): Promise<ListFollowUpStudentsData>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListFollowUpStudentsSchema, ListFollowUpStudentsData, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | void): Promise<void>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListFollowUpStudentsSchema, ListFollowUpStudentsData, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | void): Promise<ListFollowUpStudentsData>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        fetchInfiniteQuery<TPageParam extends ListFollowUpStudentsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpStudentsSchema, ListFollowUpStudentsData, ListFollowUpStudentsParameters, DeepReadonly<TPageParam>, ListFollowUpStudentsError> | void): Promise<OperationInfiniteData<ListFollowUpStudentsData, ListFollowUpStudentsParameters>>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        prefetchInfiniteQuery<TPageParam extends ListFollowUpStudentsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListFollowUpStudentsSchema, ListFollowUpStudentsData, ListFollowUpStudentsParameters, DeepReadonly<TPageParam>, ListFollowUpStudentsError> | void): Promise<void>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        ensureInfiniteQueryData<TPageParam extends ListFollowUpStudentsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListFollowUpStudentsSchema, ListFollowUpStudentsData, ListFollowUpStudentsParameters, DeepReadonly<TPageParam>, ListFollowUpStudentsError> | void): Promise<OperationInfiniteData<ListFollowUpStudentsData, ListFollowUpStudentsParameters>>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void)): ListFollowUpStudentsData | undefined;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void)): OperationInfiniteData<ListFollowUpStudentsData, ListFollowUpStudentsParameters> | undefined;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | QueryFiltersByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>,
            data: NoInfer<OperationInfiniteData<ListFollowUpStudentsData, ListFollowUpStudentsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>,
            data: ListFollowUpStudentsData | undefined
        ]>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | (DeepReadonly<ListFollowUpStudentsParameters> | void)): QueryState<ListFollowUpStudentsData, ListFollowUpStudentsError> | undefined;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListFollowUpStudentsParameters> | ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters> | void): QueryState<OperationInfiniteData<ListFollowUpStudentsData, ListFollowUpStudentsParameters>, ListFollowUpStudentsError> | undefined;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        setQueryData(parameters: (DeepReadonly<ListFollowUpStudentsParameters> | undefined) | ServiceOperationQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>, updater: Updater<NoInfer<ListFollowUpStudentsData> | undefined, NoInfer<DeepReadonly<ListFollowUpStudentsData>> | undefined>, options?: SetDataOptions): ListFollowUpStudentsData | undefined;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListFollowUpStudentsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListFollowUpStudentsData, ListFollowUpStudentsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListFollowUpStudentsData, ListFollowUpStudentsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListFollowUpStudentsData, ListFollowUpStudentsParameters> | undefined;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | QueryFiltersByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>, updater: Updater<NoInfer<ListFollowUpStudentsData> | undefined, NoInfer<ListFollowUpStudentsData> | undefined>, options?: SetDataOptions): Array<ListFollowUpStudentsData | undefined>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | QueryFiltersByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | QueryFiltersByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | QueryFiltersByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>): void;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | QueryFiltersByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Follow Up Students
         * @description The calling coordinator's or partner's own caseload students.
         *
         * One operation for both roles: a coordinator sees the students on their follow-ups
         * plus those they adopted a request for; a partner sees the students on the follow-ups
         * they accepted.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError> | QueryFiltersByQueryKey<ListFollowUpStudentsSchema, ListFollowUpStudentsData, TInfinite, ListFollowUpStudentsParameters, ListFollowUpStudentsError>): number;
        schema: ListFollowUpStudentsSchema;
        types: {
            parameters: ListFollowUpStudentsParameters;
            data: ListFollowUpStudentsData;
            error: ListFollowUpStudentsError;
        };
    };
    /**
     * @summary List Coordinator Dashboard Panel
     * @description One panel of the caller's own coordinator dashboard.
     *
     * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
     * are disjoint sets; `recently-closed` is the completed follow-ups inside the
     * same window. A `type` this dashboard does not place is a 400.
     */
    listCoordinatorDashboardFollowUps: {
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCoordinatorDashboardFollowUpsParameters, TMeta, TSignal>), client?: (schema: ListCoordinatorDashboardFollowUpsSchema, options: {
            parameters: ListCoordinatorDashboardFollowUpsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError>>): Promise<RequestFnResponse<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError>>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        getQueryKey(parameters: DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>): ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorDashboardFollowUps.useQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoordinatorDashboardFollowUpsData>(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>), options?: Omit<UndefinedInitialDataOptions<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError, TData, ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCoordinatorDashboardFollowUpsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorDashboardFollowUps.useQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoordinatorDashboardFollowUpsData>(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>), options: Omit<DefinedInitialDataOptions<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError, TData, ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCoordinatorDashboardFollowUpsError>>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>): ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorDashboardFollowUps.useInfiniteQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             type: initialType
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoordinatorDashboardFollowUpsParameters, TQueryFnData = ListCoordinatorDashboardFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListCoordinatorDashboardFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCoordinatorDashboardFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCoordinatorDashboardFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorDashboardFollowUps.useInfiniteQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             type: initialType
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoordinatorDashboardFollowUpsParameters, TQueryFnData = ListCoordinatorDashboardFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListCoordinatorDashboardFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCoordinatorDashboardFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoordinatorDashboardFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCoordinatorDashboardFollowUpsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCoordinatorDashboardFollowUpsTotal = qraft.v3Service.listCoordinatorDashboardFollowUps.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCoordinatorDashboardFollowUpsByParametersTotal = qraft.v3Service.listCoordinatorDashboardFollowUps.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             type: type
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCoordinatorDashboardFollowUpsResults = qraft.v3Service.listCoordinatorDashboardFollowUps.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 type: type1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 type: type2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorDashboardFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCoordinatorDashboardFollowUpsCombinedResults = qraft.v3Service.listCoordinatorDashboardFollowUps.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 type: type1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 type: type2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorDashboardFollowUpsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError>>, TCombinedResult = Array<UseQueryResult<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCoordinatorDashboardFollowUps.useSuspenseQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCoordinatorDashboardFollowUpsData>(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>), options?: Omit<UseSuspenseQueryOptions<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError, TData, ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCoordinatorDashboardFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorDashboardFollowUps.useSuspenseInfiniteQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             type: initialType
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCoordinatorDashboardFollowUpsParameters, TData = ListCoordinatorDashboardFollowUpsData>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError, OperationInfiniteData<TData, ListCoordinatorDashboardFollowUpsParameters>, ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoordinatorDashboardFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCoordinatorDashboardFollowUpsParameters>, OperationError<ListCoordinatorDashboardFollowUpsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCoordinatorDashboardFollowUpsData = qraft.v3Service.listCoordinatorDashboardFollowUps.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 type: type1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 type: type2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorDashboardFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCoordinatorDashboardFollowUpsCombinedData = qraft.v3Service.listCoordinatorDashboardFollowUps.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 type: type1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 type: type2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorDashboardFollowUpsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>): Promise<ListCoordinatorDashboardFollowUpsData>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>): Promise<ListCoordinatorDashboardFollowUpsData>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        fetchInfiniteQuery<TPageParam extends ListCoordinatorDashboardFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters, DeepReadonly<TPageParam>, ListCoordinatorDashboardFollowUpsError>): Promise<OperationInfiniteData<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters>>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        prefetchInfiniteQuery<TPageParam extends ListCoordinatorDashboardFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters, DeepReadonly<TPageParam>, ListCoordinatorDashboardFollowUpsError>): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        ensureInfiniteQueryData<TPageParam extends ListCoordinatorDashboardFollowUpsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters, DeepReadonly<TPageParam>, ListCoordinatorDashboardFollowUpsError>): Promise<OperationInfiniteData<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters>>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>)): ListCoordinatorDashboardFollowUpsData | undefined;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>)): OperationInfiniteData<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters> | undefined;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>,
            data: NoInfer<OperationInfiniteData<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>,
            data: ListCoordinatorDashboardFollowUpsData | undefined
        ]>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters> | (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>)): QueryState<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsError> | undefined;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListCoordinatorDashboardFollowUpsParameters> | ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>): QueryState<OperationInfiniteData<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters>, ListCoordinatorDashboardFollowUpsError> | undefined;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        setQueryData(parameters: (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>) | ServiceOperationQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>, updater: Updater<NoInfer<ListCoordinatorDashboardFollowUpsData> | undefined, NoInfer<DeepReadonly<ListCoordinatorDashboardFollowUpsData>> | undefined>, options?: SetDataOptions): ListCoordinatorDashboardFollowUpsData | undefined;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCoordinatorDashboardFollowUpsParameters>) | ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCoordinatorDashboardFollowUpsData, ListCoordinatorDashboardFollowUpsParameters> | undefined;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>, updater: Updater<NoInfer<ListCoordinatorDashboardFollowUpsData> | undefined, NoInfer<ListCoordinatorDashboardFollowUpsData> | undefined>, options?: SetDataOptions): Array<ListCoordinatorDashboardFollowUpsData | undefined>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>): void;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Panel
         * @description One panel of the caller's own coordinator dashboard.
         *
         * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
         * are disjoint sets; `recently-closed` is the completed follow-ups inside the
         * same window. A `type` this dashboard does not place is a 400.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardFollowUpsSchema, ListCoordinatorDashboardFollowUpsData, TInfinite, ListCoordinatorDashboardFollowUpsParameters, ListCoordinatorDashboardFollowUpsError>): number;
        schema: ListCoordinatorDashboardFollowUpsSchema;
        types: {
            parameters: ListCoordinatorDashboardFollowUpsParameters;
            data: ListCoordinatorDashboardFollowUpsData;
            error: ListCoordinatorDashboardFollowUpsError;
        };
    };
    /**
     * @summary List Partner Dashboard Panel
     * @description One panel of the caller's own partner dashboard.
     *
     * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
     * no day window); `aging` is their accepted caseload older than the window. Any other
     * `type` is a 400.
     */
    listPartnerDashboardFollowUps: {
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListPartnerDashboardFollowUpsParameters, TMeta, TSignal>), client?: (schema: ListPartnerDashboardFollowUpsSchema, options: {
            parameters: ListPartnerDashboardFollowUpsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError>>): Promise<RequestFnResponse<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError>>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        getQueryKey(parameters: DeepReadonly<ListPartnerDashboardFollowUpsParameters>): ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerDashboardFollowUps.useQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPartnerDashboardFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>), options?: Omit<UndefinedInitialDataOptions<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListPartnerDashboardFollowUpsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerDashboardFollowUps.useQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPartnerDashboardFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>), options: Omit<DefinedInitialDataOptions<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListPartnerDashboardFollowUpsError>>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListPartnerDashboardFollowUpsParameters>): ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerDashboardFollowUps.useInfiniteQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             type: initialType
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPartnerDashboardFollowUpsParameters, TQueryFnData = ListPartnerDashboardFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListPartnerDashboardFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListPartnerDashboardFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListPartnerDashboardFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerDashboardFollowUps.useInfiniteQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             type: initialType
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPartnerDashboardFollowUpsParameters, TQueryFnData = ListPartnerDashboardFollowUpsData, TData = OperationInfiniteData<TQueryFnData, ListPartnerDashboardFollowUpsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListPartnerDashboardFollowUpsError, TData, ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPartnerDashboardFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListPartnerDashboardFollowUpsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listPartnerDashboardFollowUpsTotal = qraft.v3Service.listPartnerDashboardFollowUps.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listPartnerDashboardFollowUpsByParametersTotal = qraft.v3Service.listPartnerDashboardFollowUps.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             type: type
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError> | QueryFiltersByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listPartnerDashboardFollowUpsResults = qraft.v3Service.listPartnerDashboardFollowUps.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 type: type1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 type: type2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerDashboardFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listPartnerDashboardFollowUpsCombinedResults = qraft.v3Service.listPartnerDashboardFollowUps.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 type: type1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 type: type2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerDashboardFollowUpsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError>>, TCombinedResult = Array<UseQueryResult<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listPartnerDashboardFollowUps.useSuspenseQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListPartnerDashboardFollowUpsData>(parameters: ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>), options?: Omit<UseSuspenseQueryOptions<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError, TData, ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListPartnerDashboardFollowUpsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerDashboardFollowUps.useSuspenseInfiniteQuery({
         *     query: {
         *         type: type
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             type: initialType
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListPartnerDashboardFollowUpsParameters, TData = ListPartnerDashboardFollowUpsData>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError, OperationInfiniteData<TData, ListPartnerDashboardFollowUpsParameters>, ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPartnerDashboardFollowUpsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListPartnerDashboardFollowUpsParameters>, OperationError<ListPartnerDashboardFollowUpsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listPartnerDashboardFollowUpsData = qraft.v3Service.listPartnerDashboardFollowUps.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 type: type1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 type: type2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerDashboardFollowUpsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listPartnerDashboardFollowUpsCombinedData = qraft.v3Service.listPartnerDashboardFollowUps.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 type: type1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 type: type2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerDashboardFollowUpsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>): Promise<ListPartnerDashboardFollowUpsData>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>): Promise<void>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>): Promise<ListPartnerDashboardFollowUpsData>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        fetchInfiniteQuery<TPageParam extends ListPartnerDashboardFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerDashboardFollowUpsError>): Promise<OperationInfiniteData<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters>>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        prefetchInfiniteQuery<TPageParam extends ListPartnerDashboardFollowUpsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerDashboardFollowUpsError>): Promise<void>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        ensureInfiniteQueryData<TPageParam extends ListPartnerDashboardFollowUpsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters, DeepReadonly<TPageParam>, ListPartnerDashboardFollowUpsError>): Promise<OperationInfiniteData<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters>>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>)): ListPartnerDashboardFollowUpsData | undefined;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>)): OperationInfiniteData<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters> | undefined;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError> | QueryFiltersByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>,
            data: NoInfer<OperationInfiniteData<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>,
            data: ListPartnerDashboardFollowUpsData | undefined
        ]>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters> | (DeepReadonly<ListPartnerDashboardFollowUpsParameters>)): QueryState<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsError> | undefined;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListPartnerDashboardFollowUpsParameters> | ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>): QueryState<OperationInfiniteData<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters>, ListPartnerDashboardFollowUpsError> | undefined;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        setQueryData(parameters: (DeepReadonly<ListPartnerDashboardFollowUpsParameters>) | ServiceOperationQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>, updater: Updater<NoInfer<ListPartnerDashboardFollowUpsData> | undefined, NoInfer<DeepReadonly<ListPartnerDashboardFollowUpsData>> | undefined>, options?: SetDataOptions): ListPartnerDashboardFollowUpsData | undefined;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListPartnerDashboardFollowUpsParameters>) | ServiceOperationInfiniteQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListPartnerDashboardFollowUpsData, ListPartnerDashboardFollowUpsParameters> | undefined;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError> | QueryFiltersByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>, updater: Updater<NoInfer<ListPartnerDashboardFollowUpsData> | undefined, NoInfer<ListPartnerDashboardFollowUpsData> | undefined>, options?: SetDataOptions): Array<ListPartnerDashboardFollowUpsData | undefined>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError> | QueryFiltersByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError> | QueryFiltersByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError> | QueryFiltersByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>): void;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError> | QueryFiltersByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Partner Dashboard Panel
         * @description One panel of the caller's own partner dashboard.
         *
         * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
         * no day window); `aging` is their accepted caseload older than the window. Any other
         * `type` is a 400.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError> | QueryFiltersByQueryKey<ListPartnerDashboardFollowUpsSchema, ListPartnerDashboardFollowUpsData, TInfinite, ListPartnerDashboardFollowUpsParameters, ListPartnerDashboardFollowUpsError>): number;
        schema: ListPartnerDashboardFollowUpsSchema;
        types: {
            parameters: ListPartnerDashboardFollowUpsParameters;
            data: ListPartnerDashboardFollowUpsData;
            error: ListPartnerDashboardFollowUpsError;
        };
    };
    /**
     * @summary List Coordinator Dashboard Locations
     * @description The caller's own network partners and caseload students, with coordinates.
     *
     * Two populations in one list, told apart by `audience`. The caller is never
     * plotted.
     */
    listCoordinatorDashboardLocations: {
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListCoordinatorDashboardLocationsParameters, TMeta, TSignal> | void), client?: (schema: ListCoordinatorDashboardLocationsSchema, options: {
            parameters: ListCoordinatorDashboardLocationsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError>>): Promise<RequestFnResponse<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError>>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        getQueryKey(parameters: DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void): ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorDashboardLocations.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorDashboardLocations.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoordinatorDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError, TData, ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListCoordinatorDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorDashboardLocations.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listCoordinatorDashboardLocations.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListCoordinatorDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void), options: Omit<DefinedInitialDataOptions<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError, TData, ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListCoordinatorDashboardLocationsError>>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void): ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorDashboardLocations.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoordinatorDashboardLocationsParameters, TQueryFnData = ListCoordinatorDashboardLocationsData, TData = OperationInfiniteData<TQueryFnData, ListCoordinatorDashboardLocationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListCoordinatorDashboardLocationsError, TData, ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListCoordinatorDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorDashboardLocations.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListCoordinatorDashboardLocationsParameters, TQueryFnData = ListCoordinatorDashboardLocationsData, TData = OperationInfiniteData<TQueryFnData, ListCoordinatorDashboardLocationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListCoordinatorDashboardLocationsError, TData, ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoordinatorDashboardLocationsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListCoordinatorDashboardLocationsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listCoordinatorDashboardLocationsTotal = qraft.v3Service.listCoordinatorDashboardLocations.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listCoordinatorDashboardLocationsByParametersTotal = qraft.v3Service.listCoordinatorDashboardLocations.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listCoordinatorDashboardLocationsResults = qraft.v3Service.listCoordinatorDashboardLocations.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorDashboardLocationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listCoordinatorDashboardLocationsCombinedResults = qraft.v3Service.listCoordinatorDashboardLocations.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorDashboardLocationsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError>>, TCombinedResult = Array<UseQueryResult<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listCoordinatorDashboardLocations.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listCoordinatorDashboardLocations.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListCoordinatorDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError, TData, ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListCoordinatorDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listCoordinatorDashboardLocations.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListCoordinatorDashboardLocationsParameters, TData = ListCoordinatorDashboardLocationsData>(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError, OperationInfiniteData<TData, ListCoordinatorDashboardLocationsParameters>, ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListCoordinatorDashboardLocationsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListCoordinatorDashboardLocationsParameters>, OperationError<ListCoordinatorDashboardLocationsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listCoordinatorDashboardLocationsData = qraft.v3Service.listCoordinatorDashboardLocations.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorDashboardLocationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listCoordinatorDashboardLocationsCombinedData = qraft.v3Service.listCoordinatorDashboardLocations.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listCoordinatorDashboardLocationsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | void): Promise<ListCoordinatorDashboardLocationsData>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | void): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | void): Promise<ListCoordinatorDashboardLocationsData>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        fetchInfiniteQuery<TPageParam extends ListCoordinatorDashboardLocationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters, DeepReadonly<TPageParam>, ListCoordinatorDashboardLocationsError> | void): Promise<OperationInfiniteData<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters>>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        prefetchInfiniteQuery<TPageParam extends ListCoordinatorDashboardLocationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters, DeepReadonly<TPageParam>, ListCoordinatorDashboardLocationsError> | void): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        ensureInfiniteQueryData<TPageParam extends ListCoordinatorDashboardLocationsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters, DeepReadonly<TPageParam>, ListCoordinatorDashboardLocationsError> | void): Promise<OperationInfiniteData<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters>>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void)): ListCoordinatorDashboardLocationsData | undefined;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void)): OperationInfiniteData<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters> | undefined;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>,
            data: NoInfer<OperationInfiniteData<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>,
            data: ListCoordinatorDashboardLocationsData | undefined
        ]>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | void)): QueryState<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsError> | undefined;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListCoordinatorDashboardLocationsParameters> | ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters> | void): QueryState<OperationInfiniteData<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters>, ListCoordinatorDashboardLocationsError> | undefined;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        setQueryData(parameters: (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | undefined) | ServiceOperationQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>, updater: Updater<NoInfer<ListCoordinatorDashboardLocationsData> | undefined, NoInfer<DeepReadonly<ListCoordinatorDashboardLocationsData>> | undefined>, options?: SetDataOptions): ListCoordinatorDashboardLocationsData | undefined;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListCoordinatorDashboardLocationsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListCoordinatorDashboardLocationsData, ListCoordinatorDashboardLocationsParameters> | undefined;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>, updater: Updater<NoInfer<ListCoordinatorDashboardLocationsData> | undefined, NoInfer<ListCoordinatorDashboardLocationsData> | undefined>, options?: SetDataOptions): Array<ListCoordinatorDashboardLocationsData | undefined>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>): void;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Coordinator Dashboard Locations
         * @description The caller's own network partners and caseload students, with coordinates.
         *
         * Two populations in one list, told apart by `audience`. The caller is never
         * plotted.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError> | QueryFiltersByQueryKey<ListCoordinatorDashboardLocationsSchema, ListCoordinatorDashboardLocationsData, TInfinite, ListCoordinatorDashboardLocationsParameters, ListCoordinatorDashboardLocationsError>): number;
        schema: ListCoordinatorDashboardLocationsSchema;
        types: {
            parameters: ListCoordinatorDashboardLocationsParameters;
            data: ListCoordinatorDashboardLocationsData;
            error: ListCoordinatorDashboardLocationsError;
        };
    };
    /**
     * @summary List Partner Dashboard Locations
     * @description The students on the caller's own follow-ups, with coordinates.
     *
     * One population, so every marker is `audience = student` and the widget renders no
     * filter select. An empty map is common, since many partners hold no follow-up.
     */
    listPartnerDashboardLocations: {
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListPartnerDashboardLocationsParameters, TMeta, TSignal> | void), client?: (schema: ListPartnerDashboardLocationsSchema, options: {
            parameters: ListPartnerDashboardLocationsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError>>): Promise<RequestFnResponse<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError>>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        getQueryKey(parameters: DeepReadonly<ListPartnerDashboardLocationsParameters> | void): ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerDashboardLocations.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerDashboardLocations.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPartnerDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void), options?: Omit<UndefinedInitialDataOptions<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError, TData, ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListPartnerDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerDashboardLocations.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listPartnerDashboardLocations.useQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListPartnerDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void), options: Omit<DefinedInitialDataOptions<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError, TData, ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListPartnerDashboardLocationsError>>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListPartnerDashboardLocationsParameters> | void): ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerDashboardLocations.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPartnerDashboardLocationsParameters, TQueryFnData = ListPartnerDashboardLocationsData, TData = OperationInfiniteData<TQueryFnData, ListPartnerDashboardLocationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListPartnerDashboardLocationsError, TData, ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListPartnerDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerDashboardLocations.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListPartnerDashboardLocationsParameters, TQueryFnData = ListPartnerDashboardLocationsData, TData = OperationInfiniteData<TQueryFnData, ListPartnerDashboardLocationsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListPartnerDashboardLocationsError, TData, ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPartnerDashboardLocationsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListPartnerDashboardLocationsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listPartnerDashboardLocationsTotal = qraft.v3Service.listPartnerDashboardLocations.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listPartnerDashboardLocationsByParametersTotal = qraft.v3Service.listPartnerDashboardLocations.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | QueryFiltersByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listPartnerDashboardLocationsResults = qraft.v3Service.listPartnerDashboardLocations.useQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerDashboardLocationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listPartnerDashboardLocationsCombinedResults = qraft.v3Service.listPartnerDashboardLocations.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerDashboardLocationsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError>>, TCombinedResult = Array<UseQueryResult<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.v3Service.listPartnerDashboardLocations.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listPartnerDashboardLocations.useSuspenseQuery({
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListPartnerDashboardLocationsData>(parameters: ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void), options?: Omit<UseSuspenseQueryOptions<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError, TData, ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListPartnerDashboardLocationsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listPartnerDashboardLocations.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListPartnerDashboardLocationsParameters, TData = ListPartnerDashboardLocationsData>(parameters: ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError, OperationInfiniteData<TData, ListPartnerDashboardLocationsParameters>, ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListPartnerDashboardLocationsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListPartnerDashboardLocationsParameters>, OperationError<ListPartnerDashboardLocationsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listPartnerDashboardLocationsData = qraft.v3Service.listPartnerDashboardLocations.useSuspenseQueries({
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerDashboardLocationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listPartnerDashboardLocationsCombinedData = qraft.v3Service.listPartnerDashboardLocations.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listPartnerDashboardLocationsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | void): Promise<ListPartnerDashboardLocationsData>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | void): Promise<void>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | void): Promise<ListPartnerDashboardLocationsData>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        fetchInfiniteQuery<TPageParam extends ListPartnerDashboardLocationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters, DeepReadonly<TPageParam>, ListPartnerDashboardLocationsError> | void): Promise<OperationInfiniteData<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters>>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        prefetchInfiniteQuery<TPageParam extends ListPartnerDashboardLocationsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters, DeepReadonly<TPageParam>, ListPartnerDashboardLocationsError> | void): Promise<void>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        ensureInfiniteQueryData<TPageParam extends ListPartnerDashboardLocationsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters, DeepReadonly<TPageParam>, ListPartnerDashboardLocationsError> | void): Promise<OperationInfiniteData<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters>>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void)): ListPartnerDashboardLocationsData | undefined;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void)): OperationInfiniteData<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters> | undefined;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | QueryFiltersByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>,
            data: NoInfer<OperationInfiniteData<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>,
            data: ListPartnerDashboardLocationsData | undefined
        ]>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | (DeepReadonly<ListPartnerDashboardLocationsParameters> | void)): QueryState<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsError> | undefined;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListPartnerDashboardLocationsParameters> | ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters> | void): QueryState<OperationInfiniteData<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters>, ListPartnerDashboardLocationsError> | undefined;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        setQueryData(parameters: (DeepReadonly<ListPartnerDashboardLocationsParameters> | undefined) | ServiceOperationQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>, updater: Updater<NoInfer<ListPartnerDashboardLocationsData> | undefined, NoInfer<DeepReadonly<ListPartnerDashboardLocationsData>> | undefined>, options?: SetDataOptions): ListPartnerDashboardLocationsData | undefined;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListPartnerDashboardLocationsParameters> | undefined) | ServiceOperationInfiniteQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListPartnerDashboardLocationsData, ListPartnerDashboardLocationsParameters> | undefined;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | QueryFiltersByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>, updater: Updater<NoInfer<ListPartnerDashboardLocationsData> | undefined, NoInfer<ListPartnerDashboardLocationsData> | undefined>, options?: SetDataOptions): Array<ListPartnerDashboardLocationsData | undefined>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | QueryFiltersByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | QueryFiltersByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | QueryFiltersByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>): void;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | QueryFiltersByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Partner Dashboard Locations
         * @description The students on the caller's own follow-ups, with coordinates.
         *
         * One population, so every marker is `audience = student` and the widget renders no
         * filter select. An empty map is common, since many partners hold no follow-up.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError> | QueryFiltersByQueryKey<ListPartnerDashboardLocationsSchema, ListPartnerDashboardLocationsData, TInfinite, ListPartnerDashboardLocationsParameters, ListPartnerDashboardLocationsError>): number;
        schema: ListPartnerDashboardLocationsSchema;
        types: {
            parameters: ListPartnerDashboardLocationsParameters;
            data: ListPartnerDashboardLocationsData;
            error: ListPartnerDashboardLocationsError;
        };
    };
    /**
     * @summary Get Course Study Access
     * @description Whether the caller may open this student's Course Study tab.
     *
     * Answers 200 for every authenticated caller, so the tab shell can gate on one query
     * instead of a status code, and says which of the two first-slot screens the caller
     * gets. Legacy picks that by relationship, not by the viewer's profile type.
     */
    getCourseStudyAccess: {
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetCourseStudyAccessParameters, TMeta, TSignal>), client?: (schema: GetCourseStudyAccessSchema, options: {
            parameters: GetCourseStudyAccessParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetCourseStudyAccessData, GetCourseStudyAccessError>>): Promise<RequestFnResponse<GetCourseStudyAccessData, GetCourseStudyAccessError>>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        getQueryKey(parameters: DeepReadonly<GetCourseStudyAccessParameters>): ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCourseStudyAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCourseStudyAccessData>(parameters: ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>), options?: Omit<UndefinedInitialDataOptions<GetCourseStudyAccessData, GetCourseStudyAccessError, TData, ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetCourseStudyAccessError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getCourseStudyAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetCourseStudyAccessData>(parameters: ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>), options: Omit<DefinedInitialDataOptions<GetCourseStudyAccessData, GetCourseStudyAccessError, TData, ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetCourseStudyAccessError>>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetCourseStudyAccessParameters>): ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCourseStudyAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCourseStudyAccessParameters, TQueryFnData = GetCourseStudyAccessData, TData = OperationInfiniteData<TQueryFnData, GetCourseStudyAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetCourseStudyAccessError, TData, ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetCourseStudyAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCourseStudyAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetCourseStudyAccessParameters, TQueryFnData = GetCourseStudyAccessData, TData = OperationInfiniteData<TQueryFnData, GetCourseStudyAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetCourseStudyAccessError, TData, ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCourseStudyAccessData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetCourseStudyAccessError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getCourseStudyAccessTotal = qraft.v3Service.getCourseStudyAccess.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getCourseStudyAccessByParametersTotal = qraft.v3Service.getCourseStudyAccess.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError> | QueryFiltersByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getCourseStudyAccessResults = qraft.v3Service.getCourseStudyAccess.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCourseStudyAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getCourseStudyAccessCombinedResults = qraft.v3Service.getCourseStudyAccess.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCourseStudyAccessCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters, GetCourseStudyAccessData, GetCourseStudyAccessError>>, TCombinedResult = Array<UseQueryResult<GetCourseStudyAccessData, GetCourseStudyAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetCourseStudyAccessData, GetCourseStudyAccessError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getCourseStudyAccess.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetCourseStudyAccessData>(parameters: ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>), options?: Omit<UseSuspenseQueryOptions<GetCourseStudyAccessData, GetCourseStudyAccessError, TData, ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetCourseStudyAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getCourseStudyAccess.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetCourseStudyAccessParameters, TData = GetCourseStudyAccessData>(parameters: ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetCourseStudyAccessData, GetCourseStudyAccessError, OperationInfiniteData<TData, GetCourseStudyAccessParameters>, ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetCourseStudyAccessData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetCourseStudyAccessParameters>, OperationError<GetCourseStudyAccessError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getCourseStudyAccessData = qraft.v3Service.getCourseStudyAccess.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCourseStudyAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getCourseStudyAccessCombinedData = qraft.v3Service.getCourseStudyAccess.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getCourseStudyAccessCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters, GetCourseStudyAccessData, GetCourseStudyAccessError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetCourseStudyAccessData, GetCourseStudyAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetCourseStudyAccessData, GetCourseStudyAccessError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetCourseStudyAccessSchema, GetCourseStudyAccessData, GetCourseStudyAccessParameters, GetCourseStudyAccessError>): Promise<GetCourseStudyAccessData>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetCourseStudyAccessSchema, GetCourseStudyAccessData, GetCourseStudyAccessParameters, GetCourseStudyAccessError>): Promise<void>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetCourseStudyAccessSchema, GetCourseStudyAccessData, GetCourseStudyAccessParameters, GetCourseStudyAccessError>): Promise<GetCourseStudyAccessData>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        fetchInfiniteQuery<TPageParam extends GetCourseStudyAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCourseStudyAccessSchema, GetCourseStudyAccessData, GetCourseStudyAccessParameters, DeepReadonly<TPageParam>, GetCourseStudyAccessError>): Promise<OperationInfiniteData<GetCourseStudyAccessData, GetCourseStudyAccessParameters>>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        prefetchInfiniteQuery<TPageParam extends GetCourseStudyAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetCourseStudyAccessSchema, GetCourseStudyAccessData, GetCourseStudyAccessParameters, DeepReadonly<TPageParam>, GetCourseStudyAccessError>): Promise<void>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        ensureInfiniteQueryData<TPageParam extends GetCourseStudyAccessParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetCourseStudyAccessSchema, GetCourseStudyAccessData, GetCourseStudyAccessParameters, DeepReadonly<TPageParam>, GetCourseStudyAccessError>): Promise<OperationInfiniteData<GetCourseStudyAccessData, GetCourseStudyAccessParameters>>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>)): GetCourseStudyAccessData | undefined;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>)): OperationInfiniteData<GetCourseStudyAccessData, GetCourseStudyAccessParameters> | undefined;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError> | QueryFiltersByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>,
            data: NoInfer<OperationInfiniteData<GetCourseStudyAccessData, GetCourseStudyAccessParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>,
            data: GetCourseStudyAccessData | undefined
        ]>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters> | (DeepReadonly<GetCourseStudyAccessParameters>)): QueryState<GetCourseStudyAccessData, GetCourseStudyAccessError> | undefined;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetCourseStudyAccessParameters> | ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>): QueryState<OperationInfiniteData<GetCourseStudyAccessData, GetCourseStudyAccessParameters>, GetCourseStudyAccessError> | undefined;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        setQueryData(parameters: (DeepReadonly<GetCourseStudyAccessParameters>) | ServiceOperationQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>, updater: Updater<NoInfer<GetCourseStudyAccessData> | undefined, NoInfer<DeepReadonly<GetCourseStudyAccessData>> | undefined>, options?: SetDataOptions): GetCourseStudyAccessData | undefined;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetCourseStudyAccessParameters>) | ServiceOperationInfiniteQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetCourseStudyAccessData, GetCourseStudyAccessParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetCourseStudyAccessData, GetCourseStudyAccessParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetCourseStudyAccessData, GetCourseStudyAccessParameters> | undefined;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError> | QueryFiltersByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>, updater: Updater<NoInfer<GetCourseStudyAccessData> | undefined, NoInfer<GetCourseStudyAccessData> | undefined>, options?: SetDataOptions): Array<GetCourseStudyAccessData | undefined>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError> | QueryFiltersByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError> | QueryFiltersByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError> | QueryFiltersByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>): void;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError> | QueryFiltersByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Course Study Access
         * @description Whether the caller may open this student's Course Study tab.
         *
         * Answers 200 for every authenticated caller, so the tab shell can gate on one query
         * instead of a status code, and says which of the two first-slot screens the caller
         * gets. Legacy picks that by relationship, not by the viewer's profile type.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError> | QueryFiltersByQueryKey<GetCourseStudyAccessSchema, GetCourseStudyAccessData, TInfinite, GetCourseStudyAccessParameters, GetCourseStudyAccessError>): number;
        schema: GetCourseStudyAccessSchema;
        types: {
            parameters: GetCourseStudyAccessParameters;
            data: GetCourseStudyAccessData;
            error: GetCourseStudyAccessError;
        };
    };
    /**
     * @summary List Student Course Study Series
     * @description The student's series, each with its courses, access and progress.
     *
     * One read behind both first-slot screens: the student's Courses cards and the
     * supervisor's Course Progression accordion render the same rows, as in legacy.
     *
     * No `language` parameter: both screens render in the student's language, not the
     * viewer's, resolved server-side.
     */
    listStudentCourseStudySeries: {
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentCourseStudySeriesParameters, TMeta, TSignal>), client?: (schema: ListStudentCourseStudySeriesSchema, options: {
            parameters: ListStudentCourseStudySeriesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError>>): Promise<RequestFnResponse<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError>>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentCourseStudySeriesParameters>): ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentCourseStudySeries.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentCourseStudySeriesData>(parameters: ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError, TData, ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentCourseStudySeriesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentCourseStudySeries.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentCourseStudySeriesData>(parameters: ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>), options: Omit<DefinedInitialDataOptions<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError, TData, ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentCourseStudySeriesError>>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentCourseStudySeriesParameters>): ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCourseStudySeries.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentCourseStudySeriesParameters, TQueryFnData = ListStudentCourseStudySeriesData, TData = OperationInfiniteData<TQueryFnData, ListStudentCourseStudySeriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentCourseStudySeriesError, TData, ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentCourseStudySeriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCourseStudySeries.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentCourseStudySeriesParameters, TQueryFnData = ListStudentCourseStudySeriesData, TData = OperationInfiniteData<TQueryFnData, ListStudentCourseStudySeriesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentCourseStudySeriesError, TData, ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentCourseStudySeriesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentCourseStudySeriesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentCourseStudySeriesTotal = qraft.v3Service.listStudentCourseStudySeries.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentCourseStudySeriesByParametersTotal = qraft.v3Service.listStudentCourseStudySeries.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError> | QueryFiltersByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentCourseStudySeriesResults = qraft.v3Service.listStudentCourseStudySeries.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCourseStudySeriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentCourseStudySeriesCombinedResults = qraft.v3Service.listStudentCourseStudySeries.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCourseStudySeriesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError>>, TCombinedResult = Array<UseQueryResult<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentCourseStudySeries.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentCourseStudySeriesData>(parameters: ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError, TData, ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentCourseStudySeriesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCourseStudySeries.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentCourseStudySeriesParameters, TData = ListStudentCourseStudySeriesData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError, OperationInfiniteData<TData, ListStudentCourseStudySeriesParameters>, ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentCourseStudySeriesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentCourseStudySeriesParameters>, OperationError<ListStudentCourseStudySeriesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentCourseStudySeriesData = qraft.v3Service.listStudentCourseStudySeries.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCourseStudySeriesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentCourseStudySeriesCombinedData = qraft.v3Service.listStudentCourseStudySeries.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCourseStudySeriesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>): Promise<ListStudentCourseStudySeriesData>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>): Promise<void>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>): Promise<ListStudentCourseStudySeriesData>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentCourseStudySeriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters, DeepReadonly<TPageParam>, ListStudentCourseStudySeriesError>): Promise<OperationInfiniteData<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters>>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentCourseStudySeriesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters, DeepReadonly<TPageParam>, ListStudentCourseStudySeriesError>): Promise<void>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentCourseStudySeriesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters, DeepReadonly<TPageParam>, ListStudentCourseStudySeriesError>): Promise<OperationInfiniteData<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters>>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>)): ListStudentCourseStudySeriesData | undefined;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>)): OperationInfiniteData<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters> | undefined;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError> | QueryFiltersByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>,
            data: ListStudentCourseStudySeriesData | undefined
        ]>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters> | (DeepReadonly<ListStudentCourseStudySeriesParameters>)): QueryState<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesError> | undefined;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentCourseStudySeriesParameters> | ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>): QueryState<OperationInfiniteData<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters>, ListStudentCourseStudySeriesError> | undefined;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentCourseStudySeriesParameters>) | ServiceOperationQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>, updater: Updater<NoInfer<ListStudentCourseStudySeriesData> | undefined, NoInfer<DeepReadonly<ListStudentCourseStudySeriesData>> | undefined>, options?: SetDataOptions): ListStudentCourseStudySeriesData | undefined;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentCourseStudySeriesParameters>) | ServiceOperationInfiniteQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentCourseStudySeriesData, ListStudentCourseStudySeriesParameters> | undefined;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError> | QueryFiltersByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>, updater: Updater<NoInfer<ListStudentCourseStudySeriesData> | undefined, NoInfer<ListStudentCourseStudySeriesData> | undefined>, options?: SetDataOptions): Array<ListStudentCourseStudySeriesData | undefined>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError> | QueryFiltersByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError> | QueryFiltersByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError> | QueryFiltersByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>): void;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError> | QueryFiltersByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Course Study Series
         * @description The student's series, each with its courses, access and progress.
         *
         * One read behind both first-slot screens: the student's Courses cards and the
         * supervisor's Course Progression accordion render the same rows, as in legacy.
         *
         * No `language` parameter: both screens render in the student's language, not the
         * viewer's, resolved server-side.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError> | QueryFiltersByQueryKey<ListStudentCourseStudySeriesSchema, ListStudentCourseStudySeriesData, TInfinite, ListStudentCourseStudySeriesParameters, ListStudentCourseStudySeriesError>): number;
        schema: ListStudentCourseStudySeriesSchema;
        types: {
            parameters: ListStudentCourseStudySeriesParameters;
            data: ListStudentCourseStudySeriesData;
            error: ListStudentCourseStudySeriesError;
        };
    };
    /**
     * @summary List Student Course Study Lessons
     * @description One course's lessons for this student, serving both branches.
     *
     * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
     * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
     * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
     * legacy's two templates do over one lesson list.
     *
     * `version` defaults to the student's version of `course_id`: the published one
     * they're enrolled on, else the live one.
     */
    listStudentCourseStudyLessons: {
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentCourseStudyLessonsParameters, TMeta, TSignal>), client?: (schema: ListStudentCourseStudyLessonsSchema, options: {
            parameters: ListStudentCourseStudyLessonsParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError>>): Promise<RequestFnResponse<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError>>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentCourseStudyLessonsParameters>): ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentCourseStudyLessons.useQuery({
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentCourseStudyLessonsData>(parameters: ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError, TData, ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentCourseStudyLessonsError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentCourseStudyLessons.useQuery({
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentCourseStudyLessonsData>(parameters: ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>), options: Omit<DefinedInitialDataOptions<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError, TData, ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentCourseStudyLessonsError>>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentCourseStudyLessonsParameters>): ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCourseStudyLessons.useInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentCourseStudyLessonsParameters, TQueryFnData = ListStudentCourseStudyLessonsData, TData = OperationInfiniteData<TQueryFnData, ListStudentCourseStudyLessonsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentCourseStudyLessonsError, TData, ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentCourseStudyLessonsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCourseStudyLessons.useInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentCourseStudyLessonsParameters, TQueryFnData = ListStudentCourseStudyLessonsData, TData = OperationInfiniteData<TQueryFnData, ListStudentCourseStudyLessonsParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentCourseStudyLessonsError, TData, ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentCourseStudyLessonsData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentCourseStudyLessonsError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentCourseStudyLessonsTotal = qraft.v3Service.listStudentCourseStudyLessons.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentCourseStudyLessonsByParametersTotal = qraft.v3Service.listStudentCourseStudyLessons.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             student_id: studentId
         *         },
         *         query: {
         *             version: version
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError> | QueryFiltersByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentCourseStudyLessonsResults = qraft.v3Service.listStudentCourseStudyLessons.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCourseStudyLessonsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentCourseStudyLessonsCombinedResults = qraft.v3Service.listStudentCourseStudyLessons.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCourseStudyLessonsCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError>>, TCombinedResult = Array<UseQueryResult<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentCourseStudyLessons.useSuspenseQuery({
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     query: {
         *         version: version
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentCourseStudyLessonsData>(parameters: ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError, TData, ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentCourseStudyLessonsError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCourseStudyLessons.useSuspenseInfiniteQuery({
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             version: initialVersion
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentCourseStudyLessonsParameters, TData = ListStudentCourseStudyLessonsData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError, OperationInfiniteData<TData, ListStudentCourseStudyLessonsParameters>, ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentCourseStudyLessonsData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentCourseStudyLessonsParameters>, OperationError<ListStudentCourseStudyLessonsError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentCourseStudyLessonsData = qraft.v3Service.listStudentCourseStudyLessons.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCourseStudyLessonsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentCourseStudyLessonsCombinedData = qraft.v3Service.listStudentCourseStudyLessons.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 course_id: courseId1,
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 version: version1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 course_id: courseId2,
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 version: version2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCourseStudyLessonsCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>): Promise<ListStudentCourseStudyLessonsData>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>): Promise<void>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>): Promise<ListStudentCourseStudyLessonsData>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentCourseStudyLessonsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters, DeepReadonly<TPageParam>, ListStudentCourseStudyLessonsError>): Promise<OperationInfiniteData<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters>>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentCourseStudyLessonsParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters, DeepReadonly<TPageParam>, ListStudentCourseStudyLessonsError>): Promise<void>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentCourseStudyLessonsParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters, DeepReadonly<TPageParam>, ListStudentCourseStudyLessonsError>): Promise<OperationInfiniteData<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters>>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>)): ListStudentCourseStudyLessonsData | undefined;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>)): OperationInfiniteData<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters> | undefined;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError> | QueryFiltersByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>,
            data: ListStudentCourseStudyLessonsData | undefined
        ]>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters> | (DeepReadonly<ListStudentCourseStudyLessonsParameters>)): QueryState<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsError> | undefined;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentCourseStudyLessonsParameters> | ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>): QueryState<OperationInfiniteData<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters>, ListStudentCourseStudyLessonsError> | undefined;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentCourseStudyLessonsParameters>) | ServiceOperationQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>, updater: Updater<NoInfer<ListStudentCourseStudyLessonsData> | undefined, NoInfer<DeepReadonly<ListStudentCourseStudyLessonsData>> | undefined>, options?: SetDataOptions): ListStudentCourseStudyLessonsData | undefined;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentCourseStudyLessonsParameters>) | ServiceOperationInfiniteQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentCourseStudyLessonsData, ListStudentCourseStudyLessonsParameters> | undefined;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError> | QueryFiltersByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>, updater: Updater<NoInfer<ListStudentCourseStudyLessonsData> | undefined, NoInfer<ListStudentCourseStudyLessonsData> | undefined>, options?: SetDataOptions): Array<ListStudentCourseStudyLessonsData | undefined>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError> | QueryFiltersByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError> | QueryFiltersByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError> | QueryFiltersByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>): void;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError> | QueryFiltersByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Course Study Lessons
         * @description One course's lessons for this student, serving both branches.
         *
         * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
         * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
         * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
         * legacy's two templates do over one lesson list.
         *
         * `version` defaults to the student's version of `course_id`: the published one
         * they're enrolled on, else the live one.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError> | QueryFiltersByQueryKey<ListStudentCourseStudyLessonsSchema, ListStudentCourseStudyLessonsData, TInfinite, ListStudentCourseStudyLessonsParameters, ListStudentCourseStudyLessonsError>): number;
        schema: ListStudentCourseStudyLessonsSchema;
        types: {
            parameters: ListStudentCourseStudyLessonsParameters;
            data: ListStudentCourseStudyLessonsData;
            error: ListStudentCourseStudyLessonsError;
        };
    };
    /**
     * @summary List Student Certificates
     * @description This student's certificates, for the member tab.
     *
     * The subject is a path parameter, so the tab makes one call whether the viewer is the
     * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
     * id.
     *
     * Students reading their own tab never receive a pending row, and a pending row
     * carries no `download_url`.
     */
    listStudentCertificates: {
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentCertificatesParameters, TMeta, TSignal>), client?: (schema: ListStudentCertificatesSchema, options: {
            parameters: ListStudentCertificatesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentCertificatesData, ListStudentCertificatesError>>): Promise<RequestFnResponse<ListStudentCertificatesData, ListStudentCertificatesError>>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentCertificatesParameters>): ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentCertificates.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         is_pending: isPending
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentCertificatesData>(parameters: ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentCertificatesData, ListStudentCertificatesError, TData, ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentCertificatesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentCertificates.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         is_pending: isPending
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentCertificatesData>(parameters: ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>), options: Omit<DefinedInitialDataOptions<ListStudentCertificatesData, ListStudentCertificatesError, TData, ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentCertificatesError>>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentCertificatesParameters>): ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCertificates.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             is_pending: initialIsPending
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentCertificatesParameters, TQueryFnData = ListStudentCertificatesData, TData = OperationInfiniteData<TQueryFnData, ListStudentCertificatesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentCertificatesError, TData, ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentCertificatesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCertificates.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             is_pending: initialIsPending
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentCertificatesParameters, TQueryFnData = ListStudentCertificatesData, TData = OperationInfiniteData<TQueryFnData, ListStudentCertificatesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentCertificatesError, TData, ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentCertificatesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentCertificatesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentCertificatesTotal = qraft.v3Service.listStudentCertificates.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentCertificatesByParametersTotal = qraft.v3Service.listStudentCertificates.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             is_pending: isPending
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError> | QueryFiltersByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentCertificatesResults = qraft.v3Service.listStudentCertificates.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 is_pending: isPending1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 is_pending: isPending2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCertificatesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentCertificatesCombinedResults = qraft.v3Service.listStudentCertificates.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 is_pending: isPending1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 is_pending: isPending2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCertificatesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentCertificatesSchema, ListStudentCertificatesParameters, ListStudentCertificatesData, ListStudentCertificatesError>>, TCombinedResult = Array<UseQueryResult<ListStudentCertificatesData, ListStudentCertificatesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentCertificatesData, ListStudentCertificatesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentCertificates.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         is_pending: isPending
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentCertificatesData>(parameters: ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentCertificatesData, ListStudentCertificatesError, TData, ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentCertificatesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentCertificates.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             is_pending: initialIsPending
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentCertificatesParameters, TData = ListStudentCertificatesData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentCertificatesData, ListStudentCertificatesError, OperationInfiniteData<TData, ListStudentCertificatesParameters>, ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentCertificatesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentCertificatesParameters>, OperationError<ListStudentCertificatesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentCertificatesData = qraft.v3Service.listStudentCertificates.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 is_pending: isPending1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 is_pending: isPending2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCertificatesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentCertificatesCombinedData = qraft.v3Service.listStudentCertificates.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 is_pending: isPending1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 is_pending: isPending2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentCertificatesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentCertificatesSchema, ListStudentCertificatesParameters, ListStudentCertificatesData, ListStudentCertificatesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentCertificatesData, ListStudentCertificatesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentCertificatesData, ListStudentCertificatesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentCertificatesSchema, ListStudentCertificatesData, ListStudentCertificatesParameters, ListStudentCertificatesError>): Promise<ListStudentCertificatesData>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentCertificatesSchema, ListStudentCertificatesData, ListStudentCertificatesParameters, ListStudentCertificatesError>): Promise<void>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentCertificatesSchema, ListStudentCertificatesData, ListStudentCertificatesParameters, ListStudentCertificatesError>): Promise<ListStudentCertificatesData>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentCertificatesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentCertificatesSchema, ListStudentCertificatesData, ListStudentCertificatesParameters, DeepReadonly<TPageParam>, ListStudentCertificatesError>): Promise<OperationInfiniteData<ListStudentCertificatesData, ListStudentCertificatesParameters>>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentCertificatesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentCertificatesSchema, ListStudentCertificatesData, ListStudentCertificatesParameters, DeepReadonly<TPageParam>, ListStudentCertificatesError>): Promise<void>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentCertificatesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentCertificatesSchema, ListStudentCertificatesData, ListStudentCertificatesParameters, DeepReadonly<TPageParam>, ListStudentCertificatesError>): Promise<OperationInfiniteData<ListStudentCertificatesData, ListStudentCertificatesParameters>>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>)): ListStudentCertificatesData | undefined;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>)): OperationInfiniteData<ListStudentCertificatesData, ListStudentCertificatesParameters> | undefined;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError> | QueryFiltersByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentCertificatesData, ListStudentCertificatesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>,
            data: ListStudentCertificatesData | undefined
        ]>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters> | (DeepReadonly<ListStudentCertificatesParameters>)): QueryState<ListStudentCertificatesData, ListStudentCertificatesError> | undefined;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentCertificatesParameters> | ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>): QueryState<OperationInfiniteData<ListStudentCertificatesData, ListStudentCertificatesParameters>, ListStudentCertificatesError> | undefined;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentCertificatesParameters>) | ServiceOperationQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>, updater: Updater<NoInfer<ListStudentCertificatesData> | undefined, NoInfer<DeepReadonly<ListStudentCertificatesData>> | undefined>, options?: SetDataOptions): ListStudentCertificatesData | undefined;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentCertificatesParameters>) | ServiceOperationInfiniteQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentCertificatesData, ListStudentCertificatesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentCertificatesData, ListStudentCertificatesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentCertificatesData, ListStudentCertificatesParameters> | undefined;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError> | QueryFiltersByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>, updater: Updater<NoInfer<ListStudentCertificatesData> | undefined, NoInfer<ListStudentCertificatesData> | undefined>, options?: SetDataOptions): Array<ListStudentCertificatesData | undefined>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError> | QueryFiltersByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError> | QueryFiltersByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError> | QueryFiltersByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>): void;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError> | QueryFiltersByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Certificates
         * @description This student's certificates, for the member tab.
         *
         * The subject is a path parameter, so the tab makes one call whether the viewer is the
         * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
         * id.
         *
         * Students reading their own tab never receive a pending row, and a pending row
         * carries no `download_url`.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError> | QueryFiltersByQueryKey<ListStudentCertificatesSchema, ListStudentCertificatesData, TInfinite, ListStudentCertificatesParameters, ListStudentCertificatesError>): number;
        schema: ListStudentCertificatesSchema;
        types: {
            parameters: ListStudentCertificatesParameters;
            data: ListStudentCertificatesData;
            error: ListStudentCertificatesError;
        };
    };
    /**
     * @summary Unlock Student Course
     * @description Unlock a course for this student, opening its first lesson with it.
     *
     * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
     * an error even after writing the unlock.
     */
    unlockStudentCourse: {
        /**
         * @summary Unlock Student Course
         * @description Unlock a course for this student, opening its first lesson with it.
         *
         * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
         * an error even after writing the unlock.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UnlockStudentCourseBody, UnlockStudentCourseParameters, TMeta, TSignal>, client?: (schema: UnlockStudentCourseSchema, options: ServiceOperationMutationFnOptions<UnlockStudentCourseBody, UnlockStudentCourseParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UnlockStudentCourseData, UnlockStudentCourseError>>): Promise<RequestFnResponse<UnlockStudentCourseData, UnlockStudentCourseError>>;
        /**
         * @summary Unlock Student Course
         * @description Unlock a course for this student, opening its first lesson with it.
         *
         * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
         * an error even after writing the unlock.
         */
        getMutationKey(parameters: DeepReadonly<UnlockStudentCourseParameters> | void): ServiceOperationMutationKey<UnlockStudentCourseSchema, UnlockStudentCourseParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Unlock Student Course
         * @description Unlock a course for this student, opening its first lesson with it.
         *
         * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
         * an error even after writing the unlock.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockStudentCourse.useMutation({
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockStudentCourse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UnlockStudentCourseBody, TContext = unknown>(parameters: DeepReadonly<UnlockStudentCourseParameters>, options?: ServiceOperationUseMutationOptions<UnlockStudentCourseSchema, UnlockStudentCourseData, UnlockStudentCourseParameters, TVariables, OperationError<UnlockStudentCourseError>, TContext>): UseMutationResult<UnlockStudentCourseData, OperationError<UnlockStudentCourseError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Unlock Student Course
         * @description Unlock a course for this student, opening its first lesson with it.
         *
         * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
         * an error even after writing the unlock.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockStudentCourse.useMutation({
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockStudentCourse.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         course_id: courseId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UnlockStudentCourseBody, UnlockStudentCourseParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UnlockStudentCourseSchema, UnlockStudentCourseData, UnlockStudentCourseParameters, TVariables, OperationError<UnlockStudentCourseError>, TContext>): UseMutationResult<UnlockStudentCourseData, OperationError<UnlockStudentCourseError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Unlock Student Course
         * @description Unlock a course for this student, opening its first lesson with it.
         *
         * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
         * an error even after writing the unlock.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const unlockStudentCourseTotal = qraft.v3Service.unlockStudentCourse.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const unlockStudentCourseTotal = qraft.v3Service.unlockStudentCourse.useIsMutating({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext> | MutationFiltersByMutationKey<UnlockStudentCourseSchema, UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Unlock Student Course
         * @description Unlock a course for this student, opening its first lesson with it.
         *
         * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
         * an error even after writing the unlock.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const unlockStudentCoursePendingMutationVariables = qraft.v3Service.unlockStudentCourse.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const unlockStudentCourseMutationData = qraft.v3Service.unlockStudentCourse.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 course_id: courseId,
         *                 student_id: studentId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UnlockStudentCourseData, OperationError<UnlockStudentCourseError>, MutationVariables<UnlockStudentCourseBody, UnlockStudentCourseParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext> | MutationFiltersByMutationKey<UnlockStudentCourseSchema, UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext>;
            select?: (mutation: Mutation<UnlockStudentCourseData, OperationError<UnlockStudentCourseError>, MutationVariables<UnlockStudentCourseBody, UnlockStudentCourseParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Unlock Student Course
         * @description Unlock a course for this student, opening its first lesson with it.
         *
         * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
         * an error even after writing the unlock.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext> | MutationFiltersByMutationKey<UnlockStudentCourseSchema, UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Unlock Student Course
         * @description Unlock a course for this student, opening its first lesson with it.
         *
         * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
         * an error even after writing the unlock.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.unlockStudentCourse.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             course_id: courseId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.unlockStudentCourse.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext> | MutationFiltersByMutationKey<UnlockStudentCourseSchema, UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext>): Mutation<UnlockStudentCourseData, UnlockStudentCourseError, MutationVariables<UnlockStudentCourseBody, UnlockStudentCourseParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext> | MutationFiltersByMutationKey<UnlockStudentCourseSchema, UnlockStudentCourseBody, UnlockStudentCourseData, UnlockStudentCourseParameters, OperationError<UnlockStudentCourseError>, TContext>): Array<Mutation<UnlockStudentCourseData, UnlockStudentCourseError, MutationVariables<UnlockStudentCourseBody, UnlockStudentCourseParameters>, TContext>>;
        };
        schema: UnlockStudentCourseSchema;
        types: {
            parameters: UnlockStudentCourseParameters;
            data: UnlockStudentCourseData;
            error: UnlockStudentCourseError;
            body: UnlockStudentCourseBody;
        };
    };
    /**
     * @summary Unlock Student Lesson
     * @description Unlock one lesson for this student.
     *
     * Idempotent-success, and `newly_unlocked` is how the client tells which
     * happened: the notification and the study-activity row fire only on a real
     * insert.
     */
    unlockStudentLesson: {
        /**
         * @summary Unlock Student Lesson
         * @description Unlock one lesson for this student.
         *
         * Idempotent-success, and `newly_unlocked` is how the client tells which
         * happened: the notification and the study-activity row fire only on a real
         * insert.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UnlockStudentLessonBody, UnlockStudentLessonParameters, TMeta, TSignal>, client?: (schema: UnlockStudentLessonSchema, options: ServiceOperationMutationFnOptions<UnlockStudentLessonBody, UnlockStudentLessonParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UnlockStudentLessonData, UnlockStudentLessonError>>): Promise<RequestFnResponse<UnlockStudentLessonData, UnlockStudentLessonError>>;
        /**
         * @summary Unlock Student Lesson
         * @description Unlock one lesson for this student.
         *
         * Idempotent-success, and `newly_unlocked` is how the client tells which
         * happened: the notification and the study-activity row fire only on a real
         * insert.
         */
        getMutationKey(parameters: DeepReadonly<UnlockStudentLessonParameters> | void): ServiceOperationMutationKey<UnlockStudentLessonSchema, UnlockStudentLessonParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Unlock Student Lesson
         * @description Unlock one lesson for this student.
         *
         * Idempotent-success, and `newly_unlocked` is how the client tells which
         * happened: the notification and the study-activity row fire only on a real
         * insert.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockStudentLesson.useMutation({
         *     path: {
         *         lesson_id: lessonId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockStudentLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UnlockStudentLessonBody, TContext = unknown>(parameters: DeepReadonly<UnlockStudentLessonParameters>, options?: ServiceOperationUseMutationOptions<UnlockStudentLessonSchema, UnlockStudentLessonData, UnlockStudentLessonParameters, TVariables, OperationError<UnlockStudentLessonError>, TContext>): UseMutationResult<UnlockStudentLessonData, OperationError<UnlockStudentLessonError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Unlock Student Lesson
         * @description Unlock one lesson for this student.
         *
         * Idempotent-success, and `newly_unlocked` is how the client tells which
         * happened: the notification and the study-activity row fire only on a real
         * insert.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockStudentLesson.useMutation({
         *     path: {
         *         lesson_id: lessonId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.unlockStudentLesson.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         lesson_id: lessonId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UnlockStudentLessonBody, UnlockStudentLessonParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UnlockStudentLessonSchema, UnlockStudentLessonData, UnlockStudentLessonParameters, TVariables, OperationError<UnlockStudentLessonError>, TContext>): UseMutationResult<UnlockStudentLessonData, OperationError<UnlockStudentLessonError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Unlock Student Lesson
         * @description Unlock one lesson for this student.
         *
         * Idempotent-success, and `newly_unlocked` is how the client tells which
         * happened: the notification and the study-activity row fire only on a real
         * insert.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const unlockStudentLessonTotal = qraft.v3Service.unlockStudentLesson.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const unlockStudentLessonTotal = qraft.v3Service.unlockStudentLesson.useIsMutating({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext> | MutationFiltersByMutationKey<UnlockStudentLessonSchema, UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Unlock Student Lesson
         * @description Unlock one lesson for this student.
         *
         * Idempotent-success, and `newly_unlocked` is how the client tells which
         * happened: the notification and the study-activity row fire only on a real
         * insert.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const unlockStudentLessonPendingMutationVariables = qraft.v3Service.unlockStudentLesson.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const unlockStudentLessonMutationData = qraft.v3Service.unlockStudentLesson.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 lesson_id: lessonId,
         *                 student_id: studentId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UnlockStudentLessonData, OperationError<UnlockStudentLessonError>, MutationVariables<UnlockStudentLessonBody, UnlockStudentLessonParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext> | MutationFiltersByMutationKey<UnlockStudentLessonSchema, UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext>;
            select?: (mutation: Mutation<UnlockStudentLessonData, OperationError<UnlockStudentLessonError>, MutationVariables<UnlockStudentLessonBody, UnlockStudentLessonParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Unlock Student Lesson
         * @description Unlock one lesson for this student.
         *
         * Idempotent-success, and `newly_unlocked` is how the client tells which
         * happened: the notification and the study-activity row fire only on a real
         * insert.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext> | MutationFiltersByMutationKey<UnlockStudentLessonSchema, UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Unlock Student Lesson
         * @description Unlock one lesson for this student.
         *
         * Idempotent-success, and `newly_unlocked` is how the client tells which
         * happened: the notification and the study-activity row fire only on a real
         * insert.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.unlockStudentLesson.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             lesson_id: lessonId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.unlockStudentLesson.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext> | MutationFiltersByMutationKey<UnlockStudentLessonSchema, UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext>): Mutation<UnlockStudentLessonData, UnlockStudentLessonError, MutationVariables<UnlockStudentLessonBody, UnlockStudentLessonParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext> | MutationFiltersByMutationKey<UnlockStudentLessonSchema, UnlockStudentLessonBody, UnlockStudentLessonData, UnlockStudentLessonParameters, OperationError<UnlockStudentLessonError>, TContext>): Array<Mutation<UnlockStudentLessonData, UnlockStudentLessonError, MutationVariables<UnlockStudentLessonBody, UnlockStudentLessonParameters>, TContext>>;
        };
        schema: UnlockStudentLessonSchema;
        types: {
            parameters: UnlockStudentLessonParameters;
            data: UnlockStudentLessonData;
            error: UnlockStudentLessonError;
            body: UnlockStudentLessonBody;
        };
    };
    /**
     * @summary Complete Student Topic
     * @description Mark a topic complete on the student's behalf.
     *
     * For a postal student, whose work arrives on paper, or by an administrator on any
     * student.
     */
    completeStudentTopic: {
        /**
         * @summary Complete Student Topic
         * @description Mark a topic complete on the student's behalf.
         *
         * For a postal student, whose work arrives on paper, or by an administrator on any
         * student.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CompleteStudentTopicBody, CompleteStudentTopicParameters, TMeta, TSignal>, client?: (schema: CompleteStudentTopicSchema, options: ServiceOperationMutationFnOptions<CompleteStudentTopicBody, CompleteStudentTopicParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CompleteStudentTopicData, CompleteStudentTopicError>>): Promise<RequestFnResponse<CompleteStudentTopicData, CompleteStudentTopicError>>;
        /**
         * @summary Complete Student Topic
         * @description Mark a topic complete on the student's behalf.
         *
         * For a postal student, whose work arrives on paper, or by an administrator on any
         * student.
         */
        getMutationKey(parameters: DeepReadonly<CompleteStudentTopicParameters> | void): ServiceOperationMutationKey<CompleteStudentTopicSchema, CompleteStudentTopicParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Complete Student Topic
         * @description Mark a topic complete on the student's behalf.
         *
         * For a postal student, whose work arrives on paper, or by an administrator on any
         * student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.completeStudentTopic.useMutation({
         *     path: {
         *         topic_id: topicId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.completeStudentTopic.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CompleteStudentTopicBody, TContext = unknown>(parameters: DeepReadonly<CompleteStudentTopicParameters>, options?: ServiceOperationUseMutationOptions<CompleteStudentTopicSchema, CompleteStudentTopicData, CompleteStudentTopicParameters, TVariables, OperationError<CompleteStudentTopicError>, TContext>): UseMutationResult<CompleteStudentTopicData, OperationError<CompleteStudentTopicError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Complete Student Topic
         * @description Mark a topic complete on the student's behalf.
         *
         * For a postal student, whose work arrives on paper, or by an administrator on any
         * student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.completeStudentTopic.useMutation({
         *     path: {
         *         topic_id: topicId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.completeStudentTopic.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         topic_id: topicId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CompleteStudentTopicBody, CompleteStudentTopicParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CompleteStudentTopicSchema, CompleteStudentTopicData, CompleteStudentTopicParameters, TVariables, OperationError<CompleteStudentTopicError>, TContext>): UseMutationResult<CompleteStudentTopicData, OperationError<CompleteStudentTopicError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Complete Student Topic
         * @description Mark a topic complete on the student's behalf.
         *
         * For a postal student, whose work arrives on paper, or by an administrator on any
         * student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const completeStudentTopicTotal = qraft.v3Service.completeStudentTopic.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const completeStudentTopicTotal = qraft.v3Service.completeStudentTopic.useIsMutating({
         *     parameters: {
         *         path: {
         *             topic_id: topicId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext> | MutationFiltersByMutationKey<CompleteStudentTopicSchema, CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Complete Student Topic
         * @description Mark a topic complete on the student's behalf.
         *
         * For a postal student, whose work arrives on paper, or by an administrator on any
         * student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const completeStudentTopicPendingMutationVariables = qraft.v3Service.completeStudentTopic.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const completeStudentTopicMutationData = qraft.v3Service.completeStudentTopic.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 topic_id: topicId,
         *                 student_id: studentId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CompleteStudentTopicData, OperationError<CompleteStudentTopicError>, MutationVariables<CompleteStudentTopicBody, CompleteStudentTopicParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext> | MutationFiltersByMutationKey<CompleteStudentTopicSchema, CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext>;
            select?: (mutation: Mutation<CompleteStudentTopicData, OperationError<CompleteStudentTopicError>, MutationVariables<CompleteStudentTopicBody, CompleteStudentTopicParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Complete Student Topic
         * @description Mark a topic complete on the student's behalf.
         *
         * For a postal student, whose work arrives on paper, or by an administrator on any
         * student.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext> | MutationFiltersByMutationKey<CompleteStudentTopicSchema, CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Complete Student Topic
         * @description Mark a topic complete on the student's behalf.
         *
         * For a postal student, whose work arrives on paper, or by an administrator on any
         * student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.completeStudentTopic.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             topic_id: topicId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.completeStudentTopic.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext> | MutationFiltersByMutationKey<CompleteStudentTopicSchema, CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext>): Mutation<CompleteStudentTopicData, CompleteStudentTopicError, MutationVariables<CompleteStudentTopicBody, CompleteStudentTopicParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext> | MutationFiltersByMutationKey<CompleteStudentTopicSchema, CompleteStudentTopicBody, CompleteStudentTopicData, CompleteStudentTopicParameters, OperationError<CompleteStudentTopicError>, TContext>): Array<Mutation<CompleteStudentTopicData, CompleteStudentTopicError, MutationVariables<CompleteStudentTopicBody, CompleteStudentTopicParameters>, TContext>>;
        };
        schema: CompleteStudentTopicSchema;
        types: {
            parameters: CompleteStudentTopicParameters;
            data: CompleteStudentTopicData;
            error: CompleteStudentTopicError;
            body: CompleteStudentTopicBody;
        };
    };
    /**
     * @summary Get Student Note Access
     * @description Whether the caller may open this student's notes.
     *
     * Answers 200 for every authenticated caller, so the web route can gate the tab
     * on one query instead of reading a status code, and carries the student's name
     * so the page can title itself without a second, wider read.
     */
    getStudentNoteAccess: {
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<GetStudentNoteAccessParameters, TMeta, TSignal>), client?: (schema: GetStudentNoteAccessSchema, options: {
            parameters: GetStudentNoteAccessParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<GetStudentNoteAccessData, GetStudentNoteAccessError>>): Promise<RequestFnResponse<GetStudentNoteAccessData, GetStudentNoteAccessError>>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        getQueryKey(parameters: DeepReadonly<GetStudentNoteAccessParameters>): ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentNoteAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentNoteAccessData>(parameters: ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>), options?: Omit<UndefinedInitialDataOptions<GetStudentNoteAccessData, GetStudentNoteAccessError, TData, ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>>, "queryKey">): UseQueryResult<TData, OperationError<GetStudentNoteAccessError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.getStudentNoteAccess.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = GetStudentNoteAccessData>(parameters: ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>), options: Omit<DefinedInitialDataOptions<GetStudentNoteAccessData, GetStudentNoteAccessError, TData, ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<GetStudentNoteAccessError>>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<GetStudentNoteAccessParameters>): ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentNoteAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentNoteAccessParameters, TQueryFnData = GetStudentNoteAccessData, TData = OperationInfiniteData<TQueryFnData, GetStudentNoteAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentNoteAccessError, TData, ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<GetStudentNoteAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentNoteAccess.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends GetStudentNoteAccessParameters, TQueryFnData = GetStudentNoteAccessData, TData = OperationInfiniteData<TQueryFnData, GetStudentNoteAccessParameters>>(parameters: ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, GetStudentNoteAccessError, TData, ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentNoteAccessData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<GetStudentNoteAccessError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const getStudentNoteAccessTotal = qraft.v3Service.getStudentNoteAccess.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const getStudentNoteAccessByParametersTotal = qraft.v3Service.getStudentNoteAccess.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError> | QueryFiltersByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const getStudentNoteAccessResults = qraft.v3Service.getStudentNoteAccess.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentNoteAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const getStudentNoteAccessCombinedResults = qraft.v3Service.getStudentNoteAccess.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentNoteAccessCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters, GetStudentNoteAccessData, GetStudentNoteAccessError>>, TCombinedResult = Array<UseQueryResult<GetStudentNoteAccessData, GetStudentNoteAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<GetStudentNoteAccessData, GetStudentNoteAccessError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.getStudentNoteAccess.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = GetStudentNoteAccessData>(parameters: ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>), options?: Omit<UseSuspenseQueryOptions<GetStudentNoteAccessData, GetStudentNoteAccessError, TData, ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<GetStudentNoteAccessError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.getStudentNoteAccess.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends GetStudentNoteAccessParameters, TData = GetStudentNoteAccessData>(parameters: ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<GetStudentNoteAccessData, GetStudentNoteAccessError, OperationInfiniteData<TData, GetStudentNoteAccessParameters>, ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<GetStudentNoteAccessData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, GetStudentNoteAccessParameters>, OperationError<GetStudentNoteAccessError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const getStudentNoteAccessData = qraft.v3Service.getStudentNoteAccess.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentNoteAccessResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const getStudentNoteAccessCombinedData = qraft.v3Service.getStudentNoteAccess.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * getStudentNoteAccessCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters, GetStudentNoteAccessData, GetStudentNoteAccessError>>, TCombinedResult = Array<UseSuspenseQueryResult<GetStudentNoteAccessData, GetStudentNoteAccessError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<GetStudentNoteAccessData, GetStudentNoteAccessError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentNoteAccessSchema, GetStudentNoteAccessData, GetStudentNoteAccessParameters, GetStudentNoteAccessError>): Promise<GetStudentNoteAccessData>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<GetStudentNoteAccessSchema, GetStudentNoteAccessData, GetStudentNoteAccessParameters, GetStudentNoteAccessError>): Promise<void>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<GetStudentNoteAccessSchema, GetStudentNoteAccessData, GetStudentNoteAccessParameters, GetStudentNoteAccessError>): Promise<GetStudentNoteAccessData>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        fetchInfiniteQuery<TPageParam extends GetStudentNoteAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentNoteAccessSchema, GetStudentNoteAccessData, GetStudentNoteAccessParameters, DeepReadonly<TPageParam>, GetStudentNoteAccessError>): Promise<OperationInfiniteData<GetStudentNoteAccessData, GetStudentNoteAccessParameters>>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        prefetchInfiniteQuery<TPageParam extends GetStudentNoteAccessParameters>(options: ServiceOperationFetchInfiniteQueryOptions<GetStudentNoteAccessSchema, GetStudentNoteAccessData, GetStudentNoteAccessParameters, DeepReadonly<TPageParam>, GetStudentNoteAccessError>): Promise<void>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        ensureInfiniteQueryData<TPageParam extends GetStudentNoteAccessParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<GetStudentNoteAccessSchema, GetStudentNoteAccessData, GetStudentNoteAccessParameters, DeepReadonly<TPageParam>, GetStudentNoteAccessError>): Promise<OperationInfiniteData<GetStudentNoteAccessData, GetStudentNoteAccessParameters>>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        getQueryData(parameters: ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>)): GetStudentNoteAccessData | undefined;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>)): OperationInfiniteData<GetStudentNoteAccessData, GetStudentNoteAccessParameters> | undefined;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError> | QueryFiltersByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>,
            data: NoInfer<OperationInfiniteData<GetStudentNoteAccessData, GetStudentNoteAccessParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>,
            data: GetStudentNoteAccessData | undefined
        ]>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        getQueryState(parameters: ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters> | (DeepReadonly<GetStudentNoteAccessParameters>)): QueryState<GetStudentNoteAccessData, GetStudentNoteAccessError> | undefined;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        getInfiniteQueryState(parameters: DeepReadonly<GetStudentNoteAccessParameters> | ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>): QueryState<OperationInfiniteData<GetStudentNoteAccessData, GetStudentNoteAccessParameters>, GetStudentNoteAccessError> | undefined;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        setQueryData(parameters: (DeepReadonly<GetStudentNoteAccessParameters>) | ServiceOperationQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>, updater: Updater<NoInfer<GetStudentNoteAccessData> | undefined, NoInfer<DeepReadonly<GetStudentNoteAccessData>> | undefined>, options?: SetDataOptions): GetStudentNoteAccessData | undefined;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<GetStudentNoteAccessParameters>) | ServiceOperationInfiniteQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessParameters>, updater: Updater<NoInfer<OperationInfiniteData<GetStudentNoteAccessData, GetStudentNoteAccessParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<GetStudentNoteAccessData, GetStudentNoteAccessParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<GetStudentNoteAccessData, GetStudentNoteAccessParameters> | undefined;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError> | QueryFiltersByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>, updater: Updater<NoInfer<GetStudentNoteAccessData> | undefined, NoInfer<GetStudentNoteAccessData> | undefined>, options?: SetDataOptions): Array<GetStudentNoteAccessData | undefined>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError> | QueryFiltersByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError> | QueryFiltersByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError> | QueryFiltersByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>): void;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError> | QueryFiltersByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary Get Student Note Access
         * @description Whether the caller may open this student's notes.
         *
         * Answers 200 for every authenticated caller, so the web route can gate the tab
         * on one query instead of reading a status code, and carries the student's name
         * so the page can title itself without a second, wider read.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError> | QueryFiltersByQueryKey<GetStudentNoteAccessSchema, GetStudentNoteAccessData, TInfinite, GetStudentNoteAccessParameters, GetStudentNoteAccessError>): number;
        schema: GetStudentNoteAccessSchema;
        types: {
            parameters: GetStudentNoteAccessParameters;
            data: GetStudentNoteAccessData;
            error: GetStudentNoteAccessError;
        };
    };
    /**
     * @summary List Student Notes
     * @description This student's notes, newest first, 10 to a page.
     *
     * Opening the tab also marks the caller's own unread notifications about this
     * student read, which is what the legacy screen does on load.
     */
    listStudentNotes: {
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<ListStudentNotesSchema, ListStudentNotesParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<ListStudentNotesParameters, TMeta, TSignal>), client?: (schema: ListStudentNotesSchema, options: {
            parameters: ListStudentNotesParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<ListStudentNotesData, ListStudentNotesError>>): Promise<RequestFnResponse<ListStudentNotesData, ListStudentNotesError>>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        getQueryKey(parameters: DeepReadonly<ListStudentNotesParameters>): ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentNotes.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentNotesData>(parameters: ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>), options?: Omit<UndefinedInitialDataOptions<ListStudentNotesData, ListStudentNotesError, TData, ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>>, "queryKey">): UseQueryResult<TData, OperationError<ListStudentNotesError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.v3Service.listStudentNotes.useQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = ListStudentNotesData>(parameters: ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>), options: Omit<DefinedInitialDataOptions<ListStudentNotesData, ListStudentNotesError, TData, ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<ListStudentNotesError>>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        getInfiniteQueryKey(parameters: DeepReadonly<ListStudentNotesParameters>): ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentNotes.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentNotesParameters, TQueryFnData = ListStudentNotesData, TData = OperationInfiniteData<TQueryFnData, ListStudentNotesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentNotesError, TData, ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<ListStudentNotesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentNotes.useInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends ListStudentNotesParameters, TQueryFnData = ListStudentNotesData, TData = OperationInfiniteData<TQueryFnData, ListStudentNotesParameters>>(parameters: ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, ListStudentNotesError, TData, ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentNotesData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<ListStudentNotesError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const listStudentNotesTotal = qraft.v3Service.listStudentNotes.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const listStudentNotesByParametersTotal = qraft.v3Service.listStudentNotes.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         query: {
         *             offset: offset
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError> | QueryFiltersByQueryKey<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const listStudentNotesResults = qraft.v3Service.listStudentNotes.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentNotesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const listStudentNotesCombinedResults = qraft.v3Service.listStudentNotes.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentNotesCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<ListStudentNotesSchema, ListStudentNotesParameters, ListStudentNotesData, ListStudentNotesError>>, TCombinedResult = Array<UseQueryResult<ListStudentNotesData, ListStudentNotesError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<ListStudentNotesData, ListStudentNotesError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.v3Service.listStudentNotes.useSuspenseQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     query: {
         *         offset: offset
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = ListStudentNotesData>(parameters: ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>), options?: Omit<UseSuspenseQueryOptions<ListStudentNotesData, ListStudentNotesError, TData, ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<ListStudentNotesError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.v3Service.listStudentNotes.useSuspenseInfiniteQuery({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {
         *         query: {
         *             offset: initialOffset
         *         }
         *     },
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends ListStudentNotesParameters, TData = ListStudentNotesData>(parameters: ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<ListStudentNotesData, ListStudentNotesError, OperationInfiniteData<TData, ListStudentNotesParameters>, ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<ListStudentNotesData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, ListStudentNotesParameters>, OperationError<ListStudentNotesError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const listStudentNotesData = qraft.v3Service.listStudentNotes.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentNotesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const listStudentNotesCombinedData = qraft.v3Service.listStudentNotes.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 student_id: studentId1
         *             },
         *             query: {
         *                 offset: offset1
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             path: {
         *                 student_id: studentId2
         *             },
         *             query: {
         *                 offset: offset2
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * listStudentNotesCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<ListStudentNotesSchema, ListStudentNotesParameters, ListStudentNotesData, ListStudentNotesError>>, TCombinedResult = Array<UseSuspenseQueryResult<ListStudentNotesData, ListStudentNotesError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<ListStudentNotesData, ListStudentNotesError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        fetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentNotesSchema, ListStudentNotesData, ListStudentNotesParameters, ListStudentNotesError>): Promise<ListStudentNotesData>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<ListStudentNotesSchema, ListStudentNotesData, ListStudentNotesParameters, ListStudentNotesError>): Promise<void>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<ListStudentNotesSchema, ListStudentNotesData, ListStudentNotesParameters, ListStudentNotesError>): Promise<ListStudentNotesData>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        fetchInfiniteQuery<TPageParam extends ListStudentNotesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentNotesSchema, ListStudentNotesData, ListStudentNotesParameters, DeepReadonly<TPageParam>, ListStudentNotesError>): Promise<OperationInfiniteData<ListStudentNotesData, ListStudentNotesParameters>>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        prefetchInfiniteQuery<TPageParam extends ListStudentNotesParameters>(options: ServiceOperationFetchInfiniteQueryOptions<ListStudentNotesSchema, ListStudentNotesData, ListStudentNotesParameters, DeepReadonly<TPageParam>, ListStudentNotesError>): Promise<void>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        ensureInfiniteQueryData<TPageParam extends ListStudentNotesParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<ListStudentNotesSchema, ListStudentNotesData, ListStudentNotesParameters, DeepReadonly<TPageParam>, ListStudentNotesError>): Promise<OperationInfiniteData<ListStudentNotesData, ListStudentNotesParameters>>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        getQueryData(parameters: ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>)): ListStudentNotesData | undefined;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>)): OperationInfiniteData<ListStudentNotesData, ListStudentNotesParameters> | undefined;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError> | QueryFiltersByQueryKey<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>,
            data: NoInfer<OperationInfiniteData<ListStudentNotesData, ListStudentNotesParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>,
            data: ListStudentNotesData | undefined
        ]>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        getQueryState(parameters: ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters> | (DeepReadonly<ListStudentNotesParameters>)): QueryState<ListStudentNotesData, ListStudentNotesError> | undefined;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        getInfiniteQueryState(parameters: DeepReadonly<ListStudentNotesParameters> | ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>): QueryState<OperationInfiniteData<ListStudentNotesData, ListStudentNotesParameters>, ListStudentNotesError> | undefined;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        setQueryData(parameters: (DeepReadonly<ListStudentNotesParameters>) | ServiceOperationQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>, updater: Updater<NoInfer<ListStudentNotesData> | undefined, NoInfer<DeepReadonly<ListStudentNotesData>> | undefined>, options?: SetDataOptions): ListStudentNotesData | undefined;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        setInfiniteQueryData(parameters: (DeepReadonly<ListStudentNotesParameters>) | ServiceOperationInfiniteQueryKey<ListStudentNotesSchema, ListStudentNotesParameters>, updater: Updater<NoInfer<OperationInfiniteData<ListStudentNotesData, ListStudentNotesParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<ListStudentNotesData, ListStudentNotesParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<ListStudentNotesData, ListStudentNotesParameters> | undefined;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError> | QueryFiltersByQueryKey<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>, updater: Updater<NoInfer<ListStudentNotesData> | undefined, NoInfer<ListStudentNotesData> | undefined>, options?: SetDataOptions): Array<ListStudentNotesData | undefined>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>, options?: InvalidateOptions): Promise<void>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError> | QueryFiltersByQueryKey<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>, options?: RefetchOptions): Promise<void>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError> | QueryFiltersByQueryKey<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>, options?: CancelOptions): Promise<void>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError> | QueryFiltersByQueryKey<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>): void;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError> | QueryFiltersByQueryKey<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>, options?: ResetOptions): Promise<void>;
        /**
         * @summary List Student Notes
         * @description This student's notes, newest first, 10 to a page.
         *
         * Opening the tab also marks the caller's own unread notifications about this
         * student read, which is what the legacy screen does on load.
         */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError> | QueryFiltersByQueryKey<ListStudentNotesSchema, ListStudentNotesData, TInfinite, ListStudentNotesParameters, ListStudentNotesError>): number;
        schema: ListStudentNotesSchema;
        types: {
            parameters: ListStudentNotesParameters;
            data: ListStudentNotesData;
            error: ListStudentNotesError;
        };
    };
    /**
     * @summary Create Student Note
     * @description Write a note about this student and return it, so the client can prepend
     * the new row without refetching the page.
     *
     * Every viewer the tab admits may write; there is no author or role test beyond
     * the tab's own gate. The student's assigned study helper is notified unless
     * they are the author.
     */
    createStudentNote: {
        /**
         * @summary Create Student Note
         * @description Write a note about this student and return it, so the client can prepend
         * the new row without refetching the page.
         *
         * Every viewer the tab admits may write; there is no author or role test beyond
         * the tab's own gate. The student's assigned study helper is notified unless
         * they are the author.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CreateStudentNoteBody, CreateStudentNoteParameters, TMeta, TSignal>, client?: (schema: CreateStudentNoteSchema, options: ServiceOperationMutationFnOptions<CreateStudentNoteBody, CreateStudentNoteParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CreateStudentNoteData, CreateStudentNoteError>>): Promise<RequestFnResponse<CreateStudentNoteData, CreateStudentNoteError>>;
        /**
         * @summary Create Student Note
         * @description Write a note about this student and return it, so the client can prepend
         * the new row without refetching the page.
         *
         * Every viewer the tab admits may write; there is no author or role test beyond
         * the tab's own gate. The student's assigned study helper is notified unless
         * they are the author.
         */
        getMutationKey(parameters: DeepReadonly<CreateStudentNoteParameters> | void): ServiceOperationMutationKey<CreateStudentNoteSchema, CreateStudentNoteParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Student Note
         * @description Write a note about this student and return it, so the client can prepend
         * the new row without refetching the page.
         *
         * Every viewer the tab admits may write; there is no author or role test beyond
         * the tab's own gate. The student's assigned study helper is notified unless
         * they are the author.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createStudentNote.useMutation({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createStudentNote.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CreateStudentNoteBody, TContext = unknown>(parameters: DeepReadonly<CreateStudentNoteParameters>, options?: ServiceOperationUseMutationOptions<CreateStudentNoteSchema, CreateStudentNoteData, CreateStudentNoteParameters, TVariables, OperationError<CreateStudentNoteError>, TContext>): UseMutationResult<CreateStudentNoteData, OperationError<CreateStudentNoteError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Create Student Note
         * @description Write a note about this student and return it, so the client can prepend
         * the new row without refetching the page.
         *
         * Every viewer the tab admits may write; there is no author or role test beyond
         * the tab's own gate. The student's assigned study helper is notified unless
         * they are the author.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createStudentNote.useMutation({
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.createStudentNote.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CreateStudentNoteBody, CreateStudentNoteParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CreateStudentNoteSchema, CreateStudentNoteData, CreateStudentNoteParameters, TVariables, OperationError<CreateStudentNoteError>, TContext>): UseMutationResult<CreateStudentNoteData, OperationError<CreateStudentNoteError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Create Student Note
         * @description Write a note about this student and return it, so the client can prepend
         * the new row without refetching the page.
         *
         * Every viewer the tab admits may write; there is no author or role test beyond
         * the tab's own gate. The student's assigned study helper is notified unless
         * they are the author.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const createStudentNoteTotal = qraft.v3Service.createStudentNote.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const createStudentNoteTotal = qraft.v3Service.createStudentNote.useIsMutating({
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext> | MutationFiltersByMutationKey<CreateStudentNoteSchema, CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Create Student Note
         * @description Write a note about this student and return it, so the client can prepend
         * the new row without refetching the page.
         *
         * Every viewer the tab admits may write; there is no author or role test beyond
         * the tab's own gate. The student's assigned study helper is notified unless
         * they are the author.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const createStudentNotePendingMutationVariables = qraft.v3Service.createStudentNote.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const createStudentNoteMutationData = qraft.v3Service.createStudentNote.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 student_id: studentId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CreateStudentNoteData, OperationError<CreateStudentNoteError>, MutationVariables<CreateStudentNoteBody, CreateStudentNoteParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext> | MutationFiltersByMutationKey<CreateStudentNoteSchema, CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext>;
            select?: (mutation: Mutation<CreateStudentNoteData, OperationError<CreateStudentNoteError>, MutationVariables<CreateStudentNoteBody, CreateStudentNoteParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Create Student Note
         * @description Write a note about this student and return it, so the client can prepend
         * the new row without refetching the page.
         *
         * Every viewer the tab admits may write; there is no author or role test beyond
         * the tab's own gate. The student's assigned study helper is notified unless
         * they are the author.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext> | MutationFiltersByMutationKey<CreateStudentNoteSchema, CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Create Student Note
         * @description Write a note about this student and return it, so the client can prepend
         * the new row without refetching the page.
         *
         * Every viewer the tab admits may write; there is no author or role test beyond
         * the tab's own gate. The student's assigned study helper is notified unless
         * they are the author.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.createStudentNote.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.createStudentNote.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext> | MutationFiltersByMutationKey<CreateStudentNoteSchema, CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext>): Mutation<CreateStudentNoteData, CreateStudentNoteError, MutationVariables<CreateStudentNoteBody, CreateStudentNoteParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext> | MutationFiltersByMutationKey<CreateStudentNoteSchema, CreateStudentNoteBody, CreateStudentNoteData, CreateStudentNoteParameters, OperationError<CreateStudentNoteError>, TContext>): Array<Mutation<CreateStudentNoteData, CreateStudentNoteError, MutationVariables<CreateStudentNoteBody, CreateStudentNoteParameters>, TContext>>;
        };
        schema: CreateStudentNoteSchema;
        types: {
            parameters: CreateStudentNoteParameters;
            data: CreateStudentNoteData;
            error: CreateStudentNoteError;
            body: CreateStudentNoteBody;
        };
    };
    /**
     * @summary Delete Student Note
     * @description Remove one note from this student's list.
     *
     * Any viewer the tab admits may delete any of this student's notes, not only
     * the ones they wrote.
     */
    deleteStudentNote: {
        /**
         * @summary Delete Student Note
         * @description Remove one note from this student's list.
         *
         * Any viewer the tab admits may delete any of this student's notes, not only
         * the ones they wrote.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteStudentNoteBody, DeleteStudentNoteParameters, TMeta, TSignal>, client?: (schema: DeleteStudentNoteSchema, options: ServiceOperationMutationFnOptions<DeleteStudentNoteBody, DeleteStudentNoteParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteStudentNoteData, DeleteStudentNoteError>>): Promise<RequestFnResponse<DeleteStudentNoteData, DeleteStudentNoteError>>;
        /**
         * @summary Delete Student Note
         * @description Remove one note from this student's list.
         *
         * Any viewer the tab admits may delete any of this student's notes, not only
         * the ones they wrote.
         */
        getMutationKey(parameters: DeepReadonly<DeleteStudentNoteParameters> | void): ServiceOperationMutationKey<DeleteStudentNoteSchema, DeleteStudentNoteParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Student Note
         * @description Remove one note from this student's list.
         *
         * Any viewer the tab admits may delete any of this student's notes, not only
         * the ones they wrote.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteStudentNote.useMutation({
         *     path: {
         *         note_id: noteId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteStudentNote.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         note_id: noteId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteStudentNoteBody, TContext = unknown>(parameters: DeepReadonly<DeleteStudentNoteParameters>, options?: ServiceOperationUseMutationOptions<DeleteStudentNoteSchema, DeleteStudentNoteData, DeleteStudentNoteParameters, TVariables, OperationError<DeleteStudentNoteError>, TContext>): UseMutationResult<DeleteStudentNoteData, OperationError<DeleteStudentNoteError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Student Note
         * @description Remove one note from this student's list.
         *
         * Any viewer the tab admits may delete any of this student's notes, not only
         * the ones they wrote.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteStudentNote.useMutation({
         *     path: {
         *         note_id: noteId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.v3Service.deleteStudentNote.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     path: {
         *         note_id: noteId,
         *         student_id: studentId
         *     },
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteStudentNoteBody, DeleteStudentNoteParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteStudentNoteSchema, DeleteStudentNoteData, DeleteStudentNoteParameters, TVariables, OperationError<DeleteStudentNoteError>, TContext>): UseMutationResult<DeleteStudentNoteData, OperationError<DeleteStudentNoteError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Student Note
         * @description Remove one note from this student's list.
         *
         * Any viewer the tab admits may delete any of this student's notes, not only
         * the ones they wrote.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteStudentNoteTotal = qraft.v3Service.deleteStudentNote.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteStudentNoteTotal = qraft.v3Service.deleteStudentNote.useIsMutating({
         *     parameters: {
         *         path: {
         *             note_id: noteId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext> | MutationFiltersByMutationKey<DeleteStudentNoteSchema, DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Student Note
         * @description Remove one note from this student's list.
         *
         * Any viewer the tab admits may delete any of this student's notes, not only
         * the ones they wrote.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteStudentNotePendingMutationVariables = qraft.v3Service.deleteStudentNote.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteStudentNoteMutationData = qraft.v3Service.deleteStudentNote.useMutationState({
         *     filters: {
         *         parameters: {
         *             path: {
         *                 note_id: noteId,
         *                 student_id: studentId
         *             },
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteStudentNoteData, OperationError<DeleteStudentNoteError>, MutationVariables<DeleteStudentNoteBody, DeleteStudentNoteParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext> | MutationFiltersByMutationKey<DeleteStudentNoteSchema, DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext>;
            select?: (mutation: Mutation<DeleteStudentNoteData, OperationError<DeleteStudentNoteError>, MutationVariables<DeleteStudentNoteBody, DeleteStudentNoteParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete Student Note
         * @description Remove one note from this student's list.
         *
         * Any viewer the tab admits may delete any of this student's notes, not only
         * the ones they wrote.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext> | MutationFiltersByMutationKey<DeleteStudentNoteSchema, DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Student Note
         * @description Remove one note from this student's list.
         *
         * Any viewer the tab admits may delete any of this student's notes, not only
         * the ones they wrote.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.v3Service.deleteStudentNote.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         path: {
         *             note_id: noteId,
         *             student_id: studentId
         *         },
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.v3Service.deleteStudentNote.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext> | MutationFiltersByMutationKey<DeleteStudentNoteSchema, DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext>): Mutation<DeleteStudentNoteData, DeleteStudentNoteError, MutationVariables<DeleteStudentNoteBody, DeleteStudentNoteParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext> | MutationFiltersByMutationKey<DeleteStudentNoteSchema, DeleteStudentNoteBody, DeleteStudentNoteData, DeleteStudentNoteParameters, OperationError<DeleteStudentNoteError>, TContext>): Array<Mutation<DeleteStudentNoteData, DeleteStudentNoteError, MutationVariables<DeleteStudentNoteBody, DeleteStudentNoteParameters>, TContext>>;
        };
        schema: DeleteStudentNoteSchema;
        types: {
            parameters: DeleteStudentNoteParameters;
            data: DeleteStudentNoteData;
            error: DeleteStudentNoteError;
            body: DeleteStudentNoteBody;
        };
    };
}
/** @summary Login */
export const loginV3AuthLoginPost = {
    schema: {
        method: "post",
        url: "/v3/auth/login",
        mediaType: ["application/json"]
    }
} as {
    schema: LoginV3AuthLoginPostSchema;
    [QraftServiceOperationsToken]: V3Service["loginV3AuthLoginPost"];
};
/** @summary Register User */
export const registerUserV3AuthRegisterPost = {
    schema: {
        method: "post",
        url: "/v3/auth/register",
        mediaType: ["application/json"]
    }
} as {
    schema: RegisterUserV3AuthRegisterPostSchema;
    [QraftServiceOperationsToken]: V3Service["registerUserV3AuthRegisterPost"];
};
/**
 * @summary Request Password Reset
 * @description Email a password-reset link to `email`.
 *
 * A missing account is answered with `email_not_found`, which reveals whether an
 * account exists. The fullapp endpoint already does the same; revisit both together.
 * There is no rate limit.
 *
 * Errors: 422 `invalid_email_format`, 404 `email_not_found`.
 */
export const requestPasswordReset = {
    schema: {
        method: "post",
        url: "/v3/auth/lost-password",
        mediaType: ["application/json"]
    }
} as {
    schema: RequestPasswordResetSchema;
    [QraftServiceOperationsToken]: V3Service["requestPasswordReset"];
};
/**
 * @summary Check Password Reset Key
 * @description Whether a reset link is still good, before asking for a new password.
 *
 * POST rather than GET so the key stays out of access logs and referrers.
 *
 * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`.
 */
export const checkPasswordResetKey = {
    schema: {
        method: "post",
        url: "/v3/auth/reset-password/check",
        mediaType: ["application/json"]
    }
} as {
    schema: CheckPasswordResetKeySchema;
    [QraftServiceOperationsToken]: V3Service["checkPasswordResetKey"];
};
/**
 * @summary Reset Password
 * @description Spend a reset key and set a new password.
 *
 * The key is checked before the passwords. There is no strength rule beyond non-blank
 * and matching.
 *
 * The caller is not logged in afterwards: every existing session has been ended (see
 * `apply_new_password`), and they are sent back to the login screen.
 *
 * Errors: 400 `invalid_reset_key`, 400 `expired_reset_key`, 422 `password_empty`, 422
 * `password_mismatch`.
 */
export const resetPassword = {
    schema: {
        method: "post",
        url: "/v3/auth/reset-password",
        mediaType: ["application/json"]
    }
} as {
    schema: ResetPasswordSchema;
    [QraftServiceOperationsToken]: V3Service["resetPassword"];
};
/** @summary Logout */
export const logout = {
    schema: {
        method: "post",
        url: "/v3/auth/logout"
    }
} as {
    schema: LogoutSchema;
    [QraftServiceOperationsToken]: V3Service["logout"];
};
/**
 * @summary Create Switch Token
 * @description Mint a scoped, short-lived, single-use token to switch to a sibling account in
 * the caller's alias family. Redeemed by `switch_account` from the same session.
 *
 * Errors: 403 `switch_target_not_in_family`, 401 `invalid_auth_token`.
 */
export const createSwitchToken = {
    schema: {
        method: "post",
        url: "/v3/auth/switch-token",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateSwitchTokenSchema;
    [QraftServiceOperationsToken]: V3Service["createSwitchToken"];
};
/**
 * @summary Switch Account
 * @description Redeem a switch token: destroy this session and become the target.
 *
 * Errors: 403 `switch_token_invalid`, 401 `invalid_auth_token`.
 */
export const switchAccount = {
    schema: {
        method: "post",
        url: "/v3/auth/switch",
        mediaType: ["application/json"]
    }
} as {
    schema: SwitchAccountSchema;
    [QraftServiceOperationsToken]: V3Service["switchAccount"];
};
/**
 * @summary List Student News
 * @description The student news archive, newest first.
 *
 * `language` is required and there is no English fallback: a language with no
 * articles is an empty page, which is what the live site serves.
 *
 * Page size follows the platform default of 10, which is also legacy's
 * configured `posts_per_page`.
 */
export const listStudentNews = {
    schema: {
        method: "get",
        url: "/v3/student-news"
    }
} as {
    schema: ListStudentNewsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentNews"];
};
/**
 * @summary Get Student News Post
 * @description One student news article by its permalink slug.
 *
 * 404s for an unknown slug and for a slug that belongs to a post of another
 * kind — the slug column is shared across all five kinds and is not unique.
 */
export const getStudentNewsPost = {
    schema: {
        method: "get",
        url: "/v3/student-news/{slug}"
    }
} as {
    schema: GetStudentNewsPostSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentNewsPost"];
};
/**
 * @summary List Study Helper News
 * @description The study helper news archive, newest first.
 */
export const listStudyHelperNews = {
    schema: {
        method: "get",
        url: "/v3/study-helper-news"
    }
} as {
    schema: ListStudyHelperNewsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudyHelperNews"];
};
/**
 * @summary Get Study Helper News Post
 * @description One study helper news article by its permalink slug.
 */
export const getStudyHelperNewsPost = {
    schema: {
        method: "get",
        url: "/v3/study-helper-news/{slug}"
    }
} as {
    schema: GetStudyHelperNewsPostSchema;
    [QraftServiceOperationsToken]: V3Service["getStudyHelperNewsPost"];
};
/**
 * @summary List Student Tutorials
 * @description The student tutorials archive, oldest first.
 *
 * Ordered by `menu_order`, then oldest first, as the live archive renders (the reverse
 * of the mobile list). `search` matches the title or the body, case-insensitively;
 * whitespace-separated tokens are ANDed and each is matched literally, so a `%` finds
 * a `%`.
 */
export const listStudentTutorials = {
    schema: {
        method: "get",
        url: "/v3/student-tutorials"
    }
} as {
    schema: ListStudentTutorialsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentTutorials"];
};
/**
 * @summary Get Student Tutorial
 * @description One student tutorial by its permalink slug.
 */
export const getStudentTutorial = {
    schema: {
        method: "get",
        url: "/v3/student-tutorials/{slug}"
    }
} as {
    schema: GetStudentTutorialSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentTutorial"];
};
/**
 * @summary List Study Helper Tutorials
 * @description The study helper tutorials archive, ordered by the editor's `menu_order`.
 *
 * Rows tied on `menu_order` fall back to oldest first; the order within a tie isn't
 * part of the contract.
 */
export const listStudyHelperTutorials = {
    schema: {
        method: "get",
        url: "/v3/study-helper-tutorials"
    }
} as {
    schema: ListStudyHelperTutorialsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudyHelperTutorials"];
};
/**
 * @summary Get Study Helper Tutorial
 * @description One study helper tutorial by its permalink slug.
 */
export const getStudyHelperTutorial = {
    schema: {
        method: "get",
        url: "/v3/study-helper-tutorials/{slug}"
    }
} as {
    schema: GetStudyHelperTutorialSchema;
    [QraftServiceOperationsToken]: V3Service["getStudyHelperTutorial"];
};
/**
 * @summary List Follow Up Tutorials
 * @description The follow-up tutorials archive, oldest first.
 *
 * Takes no `language`: it serves every row of its kind whatever the reader's interface
 * language.
 *
 * `search` matches the title or the body, case-insensitively. Whitespace-separated
 * tokens are ANDed and each is matched literally, so a `%` finds a `%`.
 */
export const listFollowUpTutorials = {
    schema: {
        method: "get",
        url: "/v3/follow-up-tutorials"
    }
} as {
    schema: ListFollowUpTutorialsSchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpTutorials"];
};
/**
 * @summary Get Follow Up Tutorial
 * @description One follow-up tutorial by its permalink slug.
 *
 * 404s for an unknown slug and for a slug that belongs to a post of any other
 * kind — the slug column is shared across all five kinds and is not unique.
 */
export const getFollowUpTutorial = {
    schema: {
        method: "get",
        url: "/v3/follow-up-tutorials/{slug}"
    }
} as {
    schema: GetFollowUpTutorialSchema;
    [QraftServiceOperationsToken]: V3Service["getFollowUpTutorial"];
};
/**
 * @summary Get Post Term
 * @description One taxonomy term by its slug.
 *
 * Takes no `language`: a term is one row in one language and its name is printed
 * whatever the reader's interface language, exactly as the legacy term archive's
 * heading does.
 */
export const getPostTerm = {
    schema: {
        method: "get",
        url: "/v3/post-terms/{taxonomy}/{slug}"
    }
} as {
    schema: GetPostTermSchema;
    [QraftServiceOperationsToken]: V3Service["getPostTerm"];
};
/**
 * @summary Get Archive Sidebar
 * @description One archive's sidebar widgets, in stored order, with their content.
 *
 * Headings are catalogue keys (`title_key`), null when the widget has no heading. A
 * taxonomy-terms widget keeps its heading even when no term survives the language and
 * non-empty filters, as in legacy.
 */
export const getArchiveSidebar = {
    schema: {
        method: "get",
        url: "/v3/archive-sidebars/{sidebar}"
    }
} as {
    schema: GetArchiveSidebarSchema;
    [QraftServiceOperationsToken]: V3Service["getArchiveSidebar"];
};
/**
 * @summary Get Students
 * @description Every student, for the admin console.
 *
 * `tags` is always empty here, since tags are group-scoped and this list has no group.
 * `study_helper` and `adopted` are joined in on the same query.
 */
export const getStudents = {
    schema: {
        method: "get",
        url: "/v3/users/students"
    }
} as {
    schema: GetStudentsSchema;
    [QraftServiceOperationsToken]: V3Service["getStudents"];
};
/** @summary Get Student */
export const getStudent = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}"
    }
} as {
    schema: GetStudentSchema;
    [QraftServiceOperationsToken]: V3Service["getStudent"];
};
/** @summary Set Student Study Helper */
export const setStudentStudyHelper = {
    schema: {
        method: "put",
        url: "/v3/users/students/{student_id}/study-helper",
        mediaType: ["application/json"]
    }
} as {
    schema: SetStudentStudyHelperSchema;
    [QraftServiceOperationsToken]: V3Service["setStudentStudyHelper"];
};
/**
 * @summary Get Student Study Helper
 * @description The student's currently-assigned study helper.
 *
 * 404 when the student does not exist, is not a student, has no helper
 * assigned, or the caller may not see them -- one answer for all four.
 */
export const getStudentStudyHelper = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/study-helper"
    }
} as {
    schema: GetStudentStudyHelperSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentStudyHelper"];
};
/**
 * @summary Get Student Viewer Access
 * @description Whether the caller may open this student's supervisory pages.
 *
 * Answers 200 for every authenticated caller, so the web route and the sidebar
 * can gate on one query instead of reading a status code. Same audience as the
 * two study-helper operations, so this probe cannot say yes to a viewer they
 * then 404.
 */
export const getStudentViewerAccess = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/viewer-access"
    }
} as {
    schema: GetStudentViewerAccessSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentViewerAccess"];
};
/**
 * @summary Get Student Study Helper History
 * @description A student's study-helper assignment history, newest adoption first.
 *
 * Each row carries the study helper's name, location and languages, the adoption and
 * release timestamps, and the display name of whoever released the student (null while
 * still assigned, or when unrecorded).
 *
 * A bare list rather than a `PaginatedResponse`: a student has only a few rows.
 */
export const getStudentStudyHelperHistory = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/study-helper-history"
    }
} as {
    schema: GetStudentStudyHelperHistorySchema;
    [QraftServiceOperationsToken]: V3Service["getStudentStudyHelperHistory"];
};
/** @summary Get Study Helpers */
export const getStudyHelpers = {
    schema: {
        method: "get",
        url: "/v3/users/study-helpers"
    }
} as {
    schema: GetStudyHelpersSchema;
    [QraftServiceOperationsToken]: V3Service["getStudyHelpers"];
};
/** @summary Get Study Helper */
export const getStudyHelper = {
    schema: {
        method: "get",
        url: "/v3/users/study-helpers/{study_helper_id}"
    }
} as {
    schema: GetStudyHelperSchema;
    [QraftServiceOperationsToken]: V3Service["getStudyHelper"];
};
/** @summary Users Me */
export const getCurrentUser = {
    schema: {
        method: "get",
        url: "/v3/users/me"
    }
} as {
    schema: GetCurrentUserSchema;
    [QraftServiceOperationsToken]: V3Service["getCurrentUser"];
};
/**
 * @summary Set My Language
 * @description Persist the caller's interface language.
 *
 * Switching doesn't need this: the client changes language locally and sends
 * `x-wbs-language` on every request. Saving makes it stick across devices and sets the
 * language outbound messages (notifications, SMS, WhatsApp, email) are composed in.
 */
export const setMyLanguage = {
    schema: {
        method: "put",
        url: "/v3/users/me/language",
        mediaType: ["application/json"]
    }
} as {
    schema: SetMyLanguageSchema;
    [QraftServiceOperationsToken]: V3Service["setMyLanguage"];
};
/**
 * @summary Set My Newsletter Subscription
 * @description Subscribe the caller to the newsletter, or unsubscribe them.
 *
 * The subject is always the authenticated caller; the operation takes no
 * member id. Setting the value the account already holds is a 200 with the
 * same body. This does not touch notification preferences: those are
 * per-event, per-channel message routing and are a separate product.
 */
export const setMyNewsletterSubscription = {
    schema: {
        method: "put",
        url: "/v3/users/me/newsletter-subscription",
        mediaType: ["application/json"]
    }
} as {
    schema: SetMyNewsletterSubscriptionSchema;
    [QraftServiceOperationsToken]: V3Service["setMyNewsletterSubscription"];
};
/**
 * @summary Update My Login Information
 * @description Change the caller's account email and/or password.
 *
 * One operation because it is one form, and the email field is required on every
 * submit, so a password-only save still carries the current address. A changed address
 * is stored as pending and mailed a verification link; the account email doesn't
 * change here.
 */
export const updateMyLoginInformation = {
    schema: {
        method: "put",
        url: "/v3/users/me/login-information",
        mediaType: ["application/json"]
    }
} as {
    schema: UpdateMyLoginInformationSchema;
    [QraftServiceOperationsToken]: V3Service["updateMyLoginInformation"];
};
/**
 * @summary Verify My Email Change
 * @description Apply the caller's pending email change, given the key from their mail.
 *
 * The key is single-use: a second call with the same key answers 400. The
 * caller who runs this need not be the mailbox that received the link, but
 * they must be signed in as the account being changed.
 */
export const verifyMyEmailChange = {
    schema: {
        method: "post",
        url: "/v3/users/me/email-change/verify",
        mediaType: ["application/json"]
    }
} as {
    schema: VerifyMyEmailChangeSchema;
    [QraftServiceOperationsToken]: V3Service["verifyMyEmailChange"];
};
/**
 * @summary Cancel My Email Change
 * @description Dismiss the caller's pending email change.
 *
 * Idempotent -- with nothing pending it answers 200 with a null
 * `pending_email` rather than 404, because the screen's Cancel button is an
 * "ensure cleared" rather than an "assert exists".
 */
export const cancelMyEmailChange = {
    schema: {
        method: "delete",
        url: "/v3/users/me/email-change"
    }
} as {
    schema: CancelMyEmailChangeSchema;
    [QraftServiceOperationsToken]: V3Service["cancelMyEmailChange"];
};
/**
 * @summary Get My Study Helper Announcement
 * @description Get the announcement the current student sees from their study helper.
 */
export const getMyStudyHelperAnnouncement = {
    schema: {
        method: "get",
        url: "/v3/users/me/announcement"
    }
} as {
    schema: GetMyStudyHelperAnnouncementSchema;
    [QraftServiceOperationsToken]: V3Service["getMyStudyHelperAnnouncement"];
};
/**
 * @summary Get Member Profile Route
 * @description A member's profile page, for every member type and every admitted viewer.
 *
 * A private profile answers 200 with `access` set to private and no sections; only a
 * missing member is a 404. `language` localizes the `country` name.
 */
export const getMemberProfile = {
    schema: {
        method: "get",
        url: "/v3/users/members/{member_id}/profile"
    }
} as {
    schema: GetMemberProfileSchema;
    [QraftServiceOperationsToken]: V3Service["getMemberProfile"];
};
/**
 * @summary Update Member Profile Route
 * @description Save a profile edit, and answer with the freshly read profile, so the client
 * renders the saved state.
 */
export const updateMemberProfile = {
    schema: {
        method: "put",
        url: "/v3/users/members/{member_id}/profile",
        mediaType: ["application/json"]
    }
} as {
    schema: UpdateMemberProfileSchema;
    [QraftServiceOperationsToken]: V3Service["updateMemberProfile"];
};
/**
 * @summary Get Member Profile Form Route
 * @description The edit form's shape: which tabs, which fields, which options.
 *
 * Derived on the server, because the tab set depends on both the member's type and the
 * viewer.
 */
export const getMemberProfileForm = {
    schema: {
        method: "get",
        url: "/v3/users/members/{member_id}/profile/form"
    }
} as {
    schema: GetMemberProfileFormSchema;
    [QraftServiceOperationsToken]: V3Service["getMemberProfileForm"];
};
/**
 * @summary Upload Member Avatar
 * @description Set the member's photo from one multipart POST carrying the cropped image.
 *
 * The gate is a dependency, so it runs before the upload is read: a refused caller
 * writes nothing to object storage, which a session rollback wouldn't undo.
 */
export const uploadMemberAvatar = {
    schema: {
        method: "post",
        url: "/v3/users/members/{member_id}/avatar",
        mediaType: ["multipart/form-data"]
    }
} as {
    schema: UploadMemberAvatarSchema;
    [QraftServiceOperationsToken]: V3Service["uploadMemberAvatar"];
};
/**
 * @summary Delete Member Avatar
 * @description Remove the member's photo. Deleting when there is none is a 200 no-op.
 */
export const deleteMemberAvatar = {
    schema: {
        method: "delete",
        url: "/v3/users/members/{member_id}/avatar"
    }
} as {
    schema: DeleteMemberAvatarSchema;
    [QraftServiceOperationsToken]: V3Service["deleteMemberAvatar"];
};
/** @summary List Onboarding Sequences */
export const listOnboardingSequences = {
    schema: {
        method: "get",
        url: "/v3/onboarding/admin/sequences"
    }
} as {
    schema: ListOnboardingSequencesSchema;
    [QraftServiceOperationsToken]: V3Service["listOnboardingSequences"];
};
/** @summary Get Onboarding Sequence */
export const getOnboardingSequence = {
    schema: {
        method: "get",
        url: "/v3/onboarding/admin/sequences/{onboarding_id}"
    }
} as {
    schema: GetOnboardingSequenceSchema;
    [QraftServiceOperationsToken]: V3Service["getOnboardingSequence"];
};
/** @summary Get Onboarding Slide */
export const getOnboardingSlide = {
    schema: {
        method: "get",
        url: "/v3/onboarding/admin/sequences/{onboarding_id}/slides/{slide_index}"
    }
} as {
    schema: GetOnboardingSlideSchema;
    [QraftServiceOperationsToken]: V3Service["getOnboardingSlide"];
};
/** @summary Onboarding Status */
export const onboardingStatus = {
    schema: {
        method: "get",
        url: "/v3/onboarding/status"
    }
} as {
    schema: OnboardingStatusSchema;
    [QraftServiceOperationsToken]: V3Service["onboardingStatus"];
};
/**
 * @summary Onboarding Detail
 * @description A sequence's slides, rendered for the caller.
 *
 * Requires a logged-in user of any profile type. Each slide carries its
 * merge-tagged title and content, and a `ProfileFields` slide carries the
 * fields the caller's own member type may answer, each with the value already
 * stored for them -- so the client renders a pre-filled form. An id with no
 * slides is a 404.
 */
export const onboardingDetail = {
    schema: {
        method: "get",
        url: "/v3/onboarding/{id}/detail"
    }
} as {
    schema: OnboardingDetailSchema;
    [QraftServiceOperationsToken]: V3Service["onboardingDetail"];
};
/**
 * @summary Onboarding Submit
 * @description Submit an onboarding slide.
 *
 * Requires a logged-in user of any profile type, who must hold the onboarding
 * being submitted. Only the fields the slide declares and the caller's member
 * type carries are written; anything else in `data` is ignored. Answers are
 * validated server-side, and submitting the final slide runs the sequence's
 * completion chain exactly once.
 */
export const submitOnboarding = {
    schema: {
        method: "post",
        url: "/v3/onboarding/submit",
        mediaType: ["application/json"]
    }
} as {
    schema: SubmitOnboardingSchema;
    [QraftServiceOperationsToken]: V3Service["submitOnboarding"];
};
/**
 * @summary List Helper Applications
 * @description List helper applications from all three intake forms; `role` tells them apart.
 */
export const listHelperApplications = {
    schema: {
        method: "get",
        url: "/v3/helper-applications"
    }
} as {
    schema: ListHelperApplicationsSchema;
    [QraftServiceOperationsToken]: V3Service["listHelperApplications"];
};
/**
 * @summary Get Helper Application
 * @description Get a helper application by ID.
 */
export const getHelperApplication = {
    schema: {
        method: "get",
        url: "/v3/helper-applications/{application_id}"
    }
} as {
    schema: GetHelperApplicationSchema;
    [QraftServiceOperationsToken]: V3Service["getHelperApplication"];
};
/**
 * @summary Submit Helper Application
 * @description Submit a study helper application.
 *
 * Public; the application is stored as PENDING. Runs the same refusal ladder as
 * `_submit_follow_up_application`, all before the first write.
 */
export const submitHelperApplication = {
    schema: {
        method: "post",
        url: "/v3/helper-applications/submit",
        mediaType: ["application/json"]
    }
} as {
    schema: SubmitHelperApplicationSchema;
    [QraftServiceOperationsToken]: V3Service["submitHelperApplication"];
};
/**
 * @summary Submit Follow Up Coordinator Application
 * @description Submit a follow-up coordinator application.
 *
 * Public, as in legacy. Approving one is the only way a coordinator account is created
 * outside the migrator.
 */
export const submitFollowUpCoordinatorApplication = {
    schema: {
        method: "post",
        url: "/v3/helper-applications/follow-up-coordinator/submit",
        mediaType: ["application/json"]
    }
} as {
    schema: SubmitFollowUpCoordinatorApplicationSchema;
    [QraftServiceOperationsToken]: V3Service["submitFollowUpCoordinatorApplication"];
};
/**
 * @summary Submit Follow Up Partner Application
 * @description Submit a follow-up partner application.
 *
 * Public. Approval creates a verified partner with no creator and no network edge,
 * unlike a coordinator's Add Partner, which is private to that coordinator.
 */
export const submitFollowUpPartnerApplication = {
    schema: {
        method: "post",
        url: "/v3/helper-applications/follow-up-partner/submit",
        mediaType: ["application/json"]
    }
} as {
    schema: SubmitFollowUpPartnerApplicationSchema;
    [QraftServiceOperationsToken]: V3Service["submitFollowUpPartnerApplication"];
};
/**
 * @summary Reject Helper Application
 * @description Reject a helper application.
 *
 * Stores the rejection reason. A rejected application no longer blocks its (email,
 * role), so the applicant can re-apply.
 */
export const rejectHelperApplication = {
    schema: {
        method: "post",
        url: "/v3/helper-applications/{application_id}/reject",
        mediaType: ["application/json"]
    }
} as {
    schema: RejectHelperApplicationSchema;
    [QraftServiceOperationsToken]: V3Service["rejectHelperApplication"];
};
/**
 * @summary Approve Helper Application
 * @description Approve a helper application.
 *
 * Creates the account the application's `role` implies (a `StudyHelper`,
 * `FollowupCoordinator` or `FollowupPartner`) and marks it APPROVED.
 */
export const approveHelperApplication = {
    schema: {
        method: "post",
        url: "/v3/helper-applications/{application_id}/approve"
    }
} as {
    schema: ApproveHelperApplicationSchema;
    [QraftServiceOperationsToken]: V3Service["approveHelperApplication"];
};
/** @summary Get Campaigns */
export const getCampaigns = {
    schema: {
        method: "get",
        url: "/v3/groups/campaigns"
    }
} as {
    schema: GetCampaignsSchema;
    [QraftServiceOperationsToken]: V3Service["getCampaigns"];
};
/**
 * @summary Create Campaign Session
 * @description Open a connect session attributed to the campaign the host names.
 *
 * `domain` is the host the visitor arrived on. Both a campaign subdomain and
 * a campaign's custom URL resolve, case-insensitively; a deactivated campaign
 * does not.
 */
export const createCampaignSession = {
    schema: {
        method: "get",
        url: "/v3/groups/session"
    }
} as {
    schema: CreateCampaignSessionSchema;
    [QraftServiceOperationsToken]: V3Service["createCampaignSession"];
};
/** @summary Get Groups */
export const getGroups = {
    schema: {
        method: "get",
        url: "/v3/groups"
    }
} as {
    schema: GetGroupsSchema;
    [QraftServiceOperationsToken]: V3Service["getGroups"];
};
/** @summary Create Group Endpoint */
export const createGroup = {
    schema: {
        method: "post",
        url: "/v3/groups",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateGroupSchema;
    [QraftServiceOperationsToken]: V3Service["createGroup"];
};
/**
 * @summary List My Groups Endpoint
 * @description The caller's own groups, for the sidebar's group switcher.
 *
 * Declared above `/{group_id}` so `mine` isn't read as a group id. Distinct from `GET
 * /v3/groups`, the admin console's list. Callers should pass `limit: 50`, the
 * pagination ceiling; the default of 10 would truncate.
 */
export const listMyGroups = {
    schema: {
        method: "get",
        url: "/v3/groups/mine"
    }
} as {
    schema: ListMyGroupsSchema;
    [QraftServiceOperationsToken]: V3Service["listMyGroups"];
};
/** @summary Get Group */
export const getGroup = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}"
    }
} as {
    schema: GetGroupSchema;
    [QraftServiceOperationsToken]: V3Service["getGroup"];
};
/** @summary Get Group By Slug */
export const getGroupBySlug = {
    schema: {
        method: "get",
        url: "/v3/groups/by-slug/{group_slug}"
    }
} as {
    schema: GetGroupBySlugSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupBySlug"];
};
/**
 * @summary Get Group Students
 * @description The group's All Students list.
 *
 * One operation serves all three student list keys and accepts the union of
 * their controls; the list key decides which of them the filter PANEL renders.
 *
 * `student_id` rather than `id`, because `id` is already this endpoint's sort
 * key and a query parameter of that name reads as the group's.
 *
 * `waiting_on` has no default. The same absent value means "every student" on
 * All Students and "any pending action" on Students Waiting, so the caller
 * sends the one it means rather than inheriting either.
 */
export const getGroupStudents = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/students"
    }
} as {
    schema: GetGroupStudentsSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupStudents"];
};
/**
 * @summary Create Postal Student
 * @description Create a postal student and attach them to this study group's helper.
 *
 * The study helper is the group's, never the caller's and never client-supplied.
 * The new account has a generated, undeliverable address and no usable password.
 */
export const createPostalStudent = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/students",
        mediaType: ["application/json"]
    }
} as {
    schema: CreatePostalStudentSchema;
    [QraftServiceOperationsToken]: V3Service["createPostalStudent"];
};
/**
 * @summary Preview Group Students Reassign
 * @description The confirm popup's contents: each submitted student beside their current
 * study helper, and whether the target may take them.
 *
 * An id outside this congregation comes back blanked and indistinguishable from
 * a nonexistent one.
 */
export const previewGroupStudentsReassign = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/students/reassign-preview",
        mediaType: ["application/json"]
    }
} as {
    schema: PreviewGroupStudentsReassignSchema;
    [QraftServiceOperationsToken]: V3Service["previewGroupStudentsReassign"];
};
/**
 * @summary Reassign Group Students
 * @description Move every eligible submitted student onto `study_helper_id`, in one
 * synchronous request, and report the skip-excluding count.
 *
 * Eligibility is re-checked here, so `skipped` may name a student the preview
 * passed.
 */
export const reassignGroupStudents = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/students/reassign",
        mediaType: ["application/json"]
    }
} as {
    schema: ReassignGroupStudentsSchema;
    [QraftServiceOperationsToken]: V3Service["reassignGroupStudents"];
};
/**
 * @summary Get Group Study Helpers
 * @description The group's Members roster.
 *
 * Readable by any member of the group and by a platform admin.
 */
export const getGroupStudyHelpers = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/study-helpers"
    }
} as {
    schema: GetGroupStudyHelpersSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupStudyHelpers"];
};
/**
 * @summary Add Group Study Helper
 * @description Add a study helper to the group. Platform-admin-only (see `PlatformAdminOfGroup`).
 *
 * The response is the same widened roster row the `GET` serves, aggregates
 * included, so the admin page can render the row it just created without a
 * refetch.
 */
export const addGroupStudyHelper = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/study-helpers",
        mediaType: ["application/json"]
    }
} as {
    schema: AddGroupStudyHelperSchema;
    [QraftServiceOperationsToken]: V3Service["addGroupStudyHelper"];
};
/**
 * @summary Remove Group Study Helper
 * @description Remove a study helper from the group. Platform-admin-only.
 */
export const removeGroupStudyHelper = {
    schema: {
        method: "delete",
        url: "/v3/groups/{group_id}/study-helpers/{study_helper_id}"
    }
} as {
    schema: RemoveGroupStudyHelperSchema;
    [QraftServiceOperationsToken]: V3Service["removeGroupStudyHelper"];
};
/**
 * @summary Upload Group Avatar
 * @description Set the group's photo — one multipart POST carrying the cropped image.
 *
 * Legacy is a three-call jQuery flow (upload, then set with crop_x/y/w/h, then
 * delete) with a mandatory server-side crop; the crop moved to the client,
 * which already enforces a 1:1 aspect, so the stored artifact is still square.
 *
 * The gate is a dependency, so it runs before the first `read()` and long
 * before the first `put_object`: a refused caller writes nothing to the bucket,
 * which matters because `put_object` is not transactional and a session
 * rollback would not undo it.
 */
export const uploadGroupAvatar = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/avatar",
        mediaType: ["multipart/form-data"]
    }
} as {
    schema: UploadGroupAvatarSchema;
    [QraftServiceOperationsToken]: V3Service["uploadGroupAvatar"];
};
/**
 * @summary Delete Group Avatar
 * @description Remove the group's photo. Deleting on a group with none is a 200 no-op.
 *
 * Idempotent rather than a 404: the UI only offers the tab when the group has a
 * photo, and a fifth status here would be one nobody reads.
 */
export const deleteGroupAvatar = {
    schema: {
        method: "delete",
        url: "/v3/groups/{group_id}/avatar"
    }
} as {
    schema: DeleteGroupAvatarSchema;
    [QraftServiceOperationsToken]: V3Service["deleteGroupAvatar"];
};
/**
 * @summary Create Geo Target Endpoint
 * @description Add a web-ad target to the group, subject to the 20-target cap.
 */
export const createGeoTarget = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/geo-targets",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateGeoTargetSchema;
    [QraftServiceOperationsToken]: V3Service["createGeoTarget"];
};
/** @summary List Group Geo Targets Endpoint */
export const listGroupGeoTargets = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/geo-targets"
    }
} as {
    schema: ListGroupGeoTargetsSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupGeoTargets"];
};
/**
 * @summary Update Geo Target Endpoint
 * @description Edit one of the group's web-ad targets, or activate/deactivate it.
 *
 * Absent fields are unchanged. Editing a target never re-runs matching:
 * students already matched to it stay matched.
 */
export const updateGeoTarget = {
    schema: {
        method: "patch",
        url: "/v3/groups/{group_id}/geo-targets/{target_id}",
        mediaType: ["application/json"]
    }
} as {
    schema: UpdateGeoTargetSchema;
    [QraftServiceOperationsToken]: V3Service["updateGeoTarget"];
};
/**
 * @summary Delete Geo Target Endpoint
 * @description Soft-delete one of the group's web-ad targets and release the students it
 * matched.
 */
export const deleteGeoTarget = {
    schema: {
        method: "delete",
        url: "/v3/groups/{group_id}/geo-targets/{target_id}"
    }
} as {
    schema: DeleteGeoTargetSchema;
    [QraftServiceOperationsToken]: V3Service["deleteGeoTarget"];
};
/** @summary Get Group Pending Tasks */
export const getGroupPendingTasks = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/pending-tasks"
    }
} as {
    schema: GetGroupPendingTasksSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupPendingTasks"];
};
/**
 * @summary List Group Member Tags
 * @description The group's tags with a three-member preview each.
 *
 * The screen has no pager, so callers should pass `limit: 50`.
 */
export const listGroupMemberTags = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/member-tags"
    }
} as {
    schema: ListGroupMemberTagsSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupMemberTags"];
};
/** @summary Create Group Member Tag */
export const createGroupMemberTag = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/member-tags",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateGroupMemberTagSchema;
    [QraftServiceOperationsToken]: V3Service["createGroupMemberTag"];
};
/**
 * @summary Get Group Member Tag
 * @description One tag with its full in-group member set, which the edit form preselects.
 *
 * Unpaginated, as in legacy; bounded by the group's roster.
 */
export const getGroupMemberTag = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/member-tags/{tag_id}"
    }
} as {
    schema: GetGroupMemberTagSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupMemberTag"];
};
/**
 * @summary Update Group Member Tag
 * @description PUT, not PATCH: the member set is replaced, not merged.
 */
export const updateGroupMemberTag = {
    schema: {
        method: "put",
        url: "/v3/groups/{group_id}/member-tags/{tag_id}",
        mediaType: ["application/json"]
    }
} as {
    schema: UpdateGroupMemberTagSchema;
    [QraftServiceOperationsToken]: V3Service["updateGroupMemberTag"];
};
/** @summary Delete Group Member Tag */
export const deleteGroupMemberTag = {
    schema: {
        method: "delete",
        url: "/v3/groups/{group_id}/member-tags/{tag_id}"
    }
} as {
    schema: DeleteGroupMemberTagSchema;
    [QraftServiceOperationsToken]: V3Service["deleteGroupMemberTag"];
};
/**
 * @summary Set Student Member Tags
 * @description The Edit Student Tags popup's submit: the student's full tag set in this group.
 *
 * `Invalid Group` is `group_access`'s 404, `Permission Denied` its 403, and `Invalid
 * Student` the 400 below, which folds "no such student" into "not in this group" as
 * legacy does.
 *
 * The permission check runs first, as a dependency. Legacy ran it last, which told a
 * non-admin whether someone was a member.
 */
export const setStudentMemberTags = {
    schema: {
        method: "put",
        url: "/v3/groups/{group_id}/students/{student_id}/tags",
        mediaType: ["application/json"]
    }
} as {
    schema: SetStudentMemberTagsSchema;
    [QraftServiceOperationsToken]: V3Service["setStudentMemberTags"];
};
/**
 * @summary List Geo Target Map Endpoint
 * @description Every active target's footprint across all groups, anonymized — for
 * drawing coverage circles on the Web Targets overview map.
 *
 * Study-helper only: the overview map is a study-helper tool, and students have
 * no reason to enumerate every group's coverage, anonymized or not.
 */
export const listGeoTargetMap = {
    schema: {
        method: "get",
        url: "/v3/geo-targets/map"
    }
} as {
    schema: ListGeoTargetMapSchema;
    [QraftServiceOperationsToken]: V3Service["listGeoTargetMap"];
};
/**
 * @summary List Group Campaigns
 * @description The congregation's campaigns, oldest first.
 *
 * Sortable on `campaign_name`, `url` and `created_at`. There is no filter
 * panel.
 */
export const listGroupCampaigns = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/campaigns"
    }
} as {
    schema: ListGroupCampaignsSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupCampaigns"];
};
/**
 * @summary Create Group Campaign
 * @description Create one congregation campaign.
 */
export const createGroupCampaign = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/campaigns",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateGroupCampaignSchema;
    [QraftServiceOperationsToken]: V3Service["createGroupCampaign"];
};
/**
 * @summary Get Personal Campaign
 * @description The study helper's personal campaign, or the Enable empty state.
 */
export const getPersonalCampaign = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/campaigns/personal"
    }
} as {
    schema: GetPersonalCampaignSchema;
    [QraftServiceOperationsToken]: V3Service["getPersonalCampaign"];
};
/**
 * @summary Enable Personal Campaign
 * @description Enable (auto-create) the group's personal campaign.
 *
 * Idempotent: posting again returns the existing campaign unchanged.
 */
export const enablePersonalCampaign = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/campaigns/personal"
    }
} as {
    schema: EnablePersonalCampaignSchema;
    [QraftServiceOperationsToken]: V3Service["enablePersonalCampaign"];
};
/**
 * @summary List Personal Campaign Students
 * @description The board under the share card: the leads that arrived through this
 * study helper's own campaign.
 */
export const listPersonalCampaignStudents = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/campaigns/personal/students"
    }
} as {
    schema: ListPersonalCampaignStudentsSchema;
    [QraftServiceOperationsToken]: V3Service["listPersonalCampaignStudents"];
};
/**
 * @summary Check Campaign Subdomain
 * @description Is this campaign subdomain free? Compared case-insensitively.
 */
export const checkCampaignSubdomain = {
    schema: {
        method: "get",
        url: "/v3/campaigns/subdomain-available"
    }
} as {
    schema: CheckCampaignSubdomainSchema;
    [QraftServiceOperationsToken]: V3Service["checkCampaignSubdomain"];
};
/** @summary Series List */
export const listSeries = {
    schema: {
        method: "get",
        url: "/v3/content/series"
    }
} as {
    schema: ListSeriesSchema;
    [QraftServiceOperationsToken]: V3Service["listSeries"];
};
/** @summary Courses List */
export const listCourses = {
    schema: {
        method: "get",
        url: "/v3/content/courses"
    }
} as {
    schema: ListCoursesSchema;
    [QraftServiceOperationsToken]: V3Service["listCourses"];
};
/** @summary Self Paced Courses */
export const listSelfPacedCourses = {
    schema: {
        method: "get",
        url: "/v3/content/self-paced-courses"
    }
} as {
    schema: ListSelfPacedCoursesSchema;
    [QraftServiceOperationsToken]: V3Service["listSelfPacedCourses"];
};
/** @summary Course Detail By Slug */
export const courseBySlug = {
    schema: {
        method: "get",
        url: "/v3/content/course/by-slug/{slug}"
    }
} as {
    schema: CourseBySlugSchema;
    [QraftServiceOperationsToken]: V3Service["courseBySlug"];
};
/** @summary Lesson Detail By Slug */
export const lessonBySlug = {
    schema: {
        method: "get",
        url: "/v3/content/lesson/by-slug/{slug}"
    }
} as {
    schema: LessonBySlugSchema;
    [QraftServiceOperationsToken]: V3Service["lessonBySlug"];
};
/** @summary Topic Detail By Slug */
export const topicBySlug = {
    schema: {
        method: "get",
        url: "/v3/content/topic/by-slug/{slug}"
    }
} as {
    schema: TopicBySlugSchema;
    [QraftServiceOperationsToken]: V3Service["topicBySlug"];
};
/** @summary Quiz By Slug */
export const quizBySlug = {
    schema: {
        method: "get",
        url: "/v3/content/quiz/by-slug/{slug}"
    }
} as {
    schema: QuizBySlugSchema;
    [QraftServiceOperationsToken]: V3Service["quizBySlug"];
};
/** @summary Course Detail */
export const courseDetail = {
    schema: {
        method: "get",
        url: "/v3/content/course/{course_id}"
    }
} as {
    schema: CourseDetailSchema;
    [QraftServiceOperationsToken]: V3Service["courseDetail"];
};
/** @summary Course Lessons */
export const courseLessons = {
    schema: {
        method: "get",
        url: "/v3/content/course/{course_id}/lessons"
    }
} as {
    schema: CourseLessonsSchema;
    [QraftServiceOperationsToken]: V3Service["courseLessons"];
};
/** @summary Lesson Detail */
export const lessonDetail = {
    schema: {
        method: "get",
        url: "/v3/content/lesson/{lesson_id}"
    }
} as {
    schema: LessonDetailSchema;
    [QraftServiceOperationsToken]: V3Service["lessonDetail"];
};
/** @summary Lesson Topics */
export const lessonTopics = {
    schema: {
        method: "get",
        url: "/v3/content/lesson/{lesson_id}/topics"
    }
} as {
    schema: LessonTopicsSchema;
    [QraftServiceOperationsToken]: V3Service["lessonTopics"];
};
/** @summary Topic Detail */
export const topicDetail = {
    schema: {
        method: "get",
        url: "/v3/content/topic/{topic_id}"
    }
} as {
    schema: TopicDetailSchema;
    [QraftServiceOperationsToken]: V3Service["topicDetail"];
};
/** @summary Lesson Questions */
export const lessonQuestions = {
    schema: {
        method: "get",
        url: "/v3/content/lesson/{lesson_id}/questions"
    }
} as {
    schema: LessonQuestionsSchema;
    [QraftServiceOperationsToken]: V3Service["lessonQuestions"];
};
/** @summary Admin Get Topic */
export const adminGetTopic = {
    schema: {
        method: "get",
        url: "/v3/content/admin/topic/{topic_id}"
    }
} as {
    schema: AdminGetTopicSchema;
    [QraftServiceOperationsToken]: V3Service["adminGetTopic"];
};
/** @summary Admin Update Topic */
export const adminUpdateTopic = {
    schema: {
        method: "patch",
        url: "/v3/content/admin/topic/{topic_id}",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminUpdateTopicSchema;
    [QraftServiceOperationsToken]: V3Service["adminUpdateTopic"];
};
/** @summary Admin Delete Topic */
export const adminDeleteTopic = {
    schema: {
        method: "delete",
        url: "/v3/content/admin/topic/{topic_id}"
    }
} as {
    schema: AdminDeleteTopicSchema;
    [QraftServiceOperationsToken]: V3Service["adminDeleteTopic"];
};
/** @summary Admin List Topics */
export const adminListTopics = {
    schema: {
        method: "get",
        url: "/v3/content/admin/lesson/{lesson_id}/topics"
    }
} as {
    schema: AdminListTopicsSchema;
    [QraftServiceOperationsToken]: V3Service["adminListTopics"];
};
/** @summary Admin Create Topic */
export const adminCreateTopic = {
    schema: {
        method: "post",
        url: "/v3/content/admin/lesson/{lesson_id}/topics",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminCreateTopicSchema;
    [QraftServiceOperationsToken]: V3Service["adminCreateTopic"];
};
/** @summary Admin List Series */
export const adminListSeries = {
    schema: {
        method: "get",
        url: "/v3/content/admin/series"
    }
} as {
    schema: AdminListSeriesSchema;
    [QraftServiceOperationsToken]: V3Service["adminListSeries"];
};
/** @summary Admin Create Series */
export const adminCreateSeries = {
    schema: {
        method: "post",
        url: "/v3/content/admin/series",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminCreateSeriesSchema;
    [QraftServiceOperationsToken]: V3Service["adminCreateSeries"];
};
/** @summary Admin Get Series */
export const adminGetSeries = {
    schema: {
        method: "get",
        url: "/v3/content/admin/series/{series_id}"
    }
} as {
    schema: AdminGetSeriesSchema;
    [QraftServiceOperationsToken]: V3Service["adminGetSeries"];
};
/** @summary Admin Update Series */
export const adminUpdateSeries = {
    schema: {
        method: "patch",
        url: "/v3/content/admin/series/{series_id}",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminUpdateSeriesSchema;
    [QraftServiceOperationsToken]: V3Service["adminUpdateSeries"];
};
/** @summary Admin List Questions */
export const adminListQuestions = {
    schema: {
        method: "get",
        url: "/v3/content/admin/lesson/{lesson_id}/questions"
    }
} as {
    schema: AdminListQuestionsSchema;
    [QraftServiceOperationsToken]: V3Service["adminListQuestions"];
};
/** @summary Admin Create Question */
export const adminCreateQuestion = {
    schema: {
        method: "post",
        url: "/v3/content/admin/lesson/{lesson_id}/questions",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminCreateQuestionSchema;
    [QraftServiceOperationsToken]: V3Service["adminCreateQuestion"];
};
/** @summary Admin Get Question */
export const adminGetQuestion = {
    schema: {
        method: "get",
        url: "/v3/content/admin/question/{question_id}"
    }
} as {
    schema: AdminGetQuestionSchema;
    [QraftServiceOperationsToken]: V3Service["adminGetQuestion"];
};
/** @summary Admin Update Question */
export const adminUpdateQuestion = {
    schema: {
        method: "patch",
        url: "/v3/content/admin/question/{question_id}",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminUpdateQuestionSchema;
    [QraftServiceOperationsToken]: V3Service["adminUpdateQuestion"];
};
/** @summary Admin Delete Question */
export const adminDeleteQuestion = {
    schema: {
        method: "delete",
        url: "/v3/content/admin/question/{question_id}"
    }
} as {
    schema: AdminDeleteQuestionSchema;
    [QraftServiceOperationsToken]: V3Service["adminDeleteQuestion"];
};
/** @summary Admin Bulk Delete Questions */
export const adminBulkDeleteQuestions = {
    schema: {
        method: "post",
        url: "/v3/content/admin/lesson/{lesson_id}/questions/bulk-delete",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminBulkDeleteQuestionsSchema;
    [QraftServiceOperationsToken]: V3Service["adminBulkDeleteQuestions"];
};
/** @summary Admin Bulk Publish Questions */
export const adminBulkPublishQuestions = {
    schema: {
        method: "post",
        url: "/v3/content/admin/lesson/{lesson_id}/questions/bulk-publish",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminBulkPublishQuestionsSchema;
    [QraftServiceOperationsToken]: V3Service["adminBulkPublishQuestions"];
};
/** @summary Admin Upload Media */
export const adminUploadMedia = {
    schema: {
        method: "post",
        url: "/v3/content/admin/media",
        mediaType: ["multipart/form-data"]
    }
} as {
    schema: AdminUploadMediaSchema;
    [QraftServiceOperationsToken]: V3Service["adminUploadMedia"];
};
/** @summary Admin Get Lesson */
export const adminGetLesson = {
    schema: {
        method: "get",
        url: "/v3/content/admin/lesson/{lesson_id}"
    }
} as {
    schema: AdminGetLessonSchema;
    [QraftServiceOperationsToken]: V3Service["adminGetLesson"];
};
/** @summary Admin Update Lesson */
export const adminUpdateLesson = {
    schema: {
        method: "patch",
        url: "/v3/content/admin/lesson/{lesson_id}",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminUpdateLessonSchema;
    [QraftServiceOperationsToken]: V3Service["adminUpdateLesson"];
};
/** @summary Admin Delete Lesson */
export const adminDeleteLesson = {
    schema: {
        method: "delete",
        url: "/v3/content/admin/lesson/{lesson_id}"
    }
} as {
    schema: AdminDeleteLessonSchema;
    [QraftServiceOperationsToken]: V3Service["adminDeleteLesson"];
};
/** @summary Admin List Lessons */
export const adminListLessons = {
    schema: {
        method: "get",
        url: "/v3/content/admin/course/{course_id}/lessons"
    }
} as {
    schema: AdminListLessonsSchema;
    [QraftServiceOperationsToken]: V3Service["adminListLessons"];
};
/** @summary Admin Create Lesson */
export const adminCreateLesson = {
    schema: {
        method: "post",
        url: "/v3/content/admin/course/{course_id}/lessons",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminCreateLessonSchema;
    [QraftServiceOperationsToken]: V3Service["adminCreateLesson"];
};
/** @summary Admin Get Course Outline */
export const adminGetCourseOutline = {
    schema: {
        method: "get",
        url: "/v3/content/admin/course/{course_id}/outline"
    }
} as {
    schema: AdminGetCourseOutlineSchema;
    [QraftServiceOperationsToken]: V3Service["adminGetCourseOutline"];
};
/** @summary Admin Search Lessons */
export const adminSearchLessons = {
    schema: {
        method: "get",
        url: "/v3/content/admin/lessons"
    }
} as {
    schema: AdminSearchLessonsSchema;
    [QraftServiceOperationsToken]: V3Service["adminSearchLessons"];
};
/** @summary Admin Search Topics */
export const adminSearchTopics = {
    schema: {
        method: "get",
        url: "/v3/content/admin/topics"
    }
} as {
    schema: AdminSearchTopicsSchema;
    [QraftServiceOperationsToken]: V3Service["adminSearchTopics"];
};
/** @summary Admin Search Questions */
export const adminSearchQuestions = {
    schema: {
        method: "get",
        url: "/v3/content/admin/questions"
    }
} as {
    schema: AdminSearchQuestionsSchema;
    [QraftServiceOperationsToken]: V3Service["adminSearchQuestions"];
};
/** @summary Admin List Courses */
export const adminListCourses = {
    schema: {
        method: "get",
        url: "/v3/content/admin/courses"
    }
} as {
    schema: AdminListCoursesSchema;
    [QraftServiceOperationsToken]: V3Service["adminListCourses"];
};
/** @summary Admin Create Course */
export const adminCreateCourse = {
    schema: {
        method: "post",
        url: "/v3/content/admin/series/{series_id}/courses",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminCreateCourseSchema;
    [QraftServiceOperationsToken]: V3Service["adminCreateCourse"];
};
/** @summary Admin Get Course */
export const adminGetCourse = {
    schema: {
        method: "get",
        url: "/v3/content/admin/course/{course_id}"
    }
} as {
    schema: AdminGetCourseSchema;
    [QraftServiceOperationsToken]: V3Service["adminGetCourse"];
};
/** @summary Admin Update Course */
export const adminUpdateCourse = {
    schema: {
        method: "patch",
        url: "/v3/content/admin/course/{course_id}",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminUpdateCourseSchema;
    [QraftServiceOperationsToken]: V3Service["adminUpdateCourse"];
};
/** @summary Admin List Course Versions */
export const adminListCourseVersions = {
    schema: {
        method: "get",
        url: "/v3/content/admin/course/{course_id}/versions"
    }
} as {
    schema: AdminListCourseVersionsSchema;
    [QraftServiceOperationsToken]: V3Service["adminListCourseVersions"];
};
/** @summary Admin Start Course Version */
export const adminStartCourseVersion = {
    schema: {
        method: "post",
        url: "/v3/content/admin/course/{course_id}/versions",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminStartCourseVersionSchema;
    [QraftServiceOperationsToken]: V3Service["adminStartCourseVersion"];
};
/** @summary Admin Discard Course Version */
export const adminDiscardCourseVersion = {
    schema: {
        method: "delete",
        url: "/v3/content/admin/course/{course_id}/versions/{version}"
    }
} as {
    schema: AdminDiscardCourseVersionSchema;
    [QraftServiceOperationsToken]: V3Service["adminDiscardCourseVersion"];
};
/** @summary Admin Find In Course Version */
export const adminFindInCourseVersion = {
    schema: {
        method: "get",
        url: "/v3/content/admin/course/{course_id}/versions/{version}/find"
    }
} as {
    schema: AdminFindInCourseVersionSchema;
    [QraftServiceOperationsToken]: V3Service["adminFindInCourseVersion"];
};
/** @summary Admin Course Version Changes */
export const adminCourseVersionChanges = {
    schema: {
        method: "get",
        url: "/v3/content/admin/course/{course_id}/versions/{version}/changes"
    }
} as {
    schema: AdminCourseVersionChangesSchema;
    [QraftServiceOperationsToken]: V3Service["adminCourseVersionChanges"];
};
/** @summary Admin Revert Course Version Change */
export const adminRevertCourseVersionChange = {
    schema: {
        method: "post",
        url: "/v3/content/admin/course/{course_id}/versions/{version}/changes/revert",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminRevertCourseVersionChangeSchema;
    [QraftServiceOperationsToken]: V3Service["adminRevertCourseVersionChange"];
};
/** @summary Admin Course Version Publish Check */
export const adminCourseVersionPublishCheck = {
    schema: {
        method: "get",
        url: "/v3/content/admin/course/{course_id}/versions/{version}/publish-check"
    }
} as {
    schema: AdminCourseVersionPublishCheckSchema;
    [QraftServiceOperationsToken]: V3Service["adminCourseVersionPublishCheck"];
};
/** @summary Admin Publish Course Version */
export const adminPublishCourseVersion = {
    schema: {
        method: "post",
        url: "/v3/content/admin/course/{course_id}/versions/{version}/publish"
    }
} as {
    schema: AdminPublishCourseVersionSchema;
    [QraftServiceOperationsToken]: V3Service["adminPublishCourseVersion"];
};
/**
 * @summary Admin Preview Course Version
 * @description A one-time link that opens this version in the student web app.
 */
export const adminPreviewCourseVersion = {
    schema: {
        method: "post",
        url: "/v3/content/admin/course/{course_id}/versions/{version}/preview"
    }
} as {
    schema: AdminPreviewCourseVersionSchema;
    [QraftServiceOperationsToken]: V3Service["adminPreviewCourseVersion"];
};
/** @summary Preview Redeem */
export const previewRedeem = {
    schema: {
        method: "post",
        url: "/v3/content/preview/redeem",
        mediaType: ["application/json"]
    }
} as {
    schema: PreviewRedeemSchema;
    [QraftServiceOperationsToken]: V3Service["previewRedeem"];
};
/** @summary Preview End */
export const previewEnd = {
    schema: {
        method: "delete",
        url: "/v3/content/preview/session"
    }
} as {
    schema: PreviewEndSchema;
    [QraftServiceOperationsToken]: V3Service["previewEnd"];
};
/** @summary Preview Course */
export const previewCourse = {
    schema: {
        method: "get",
        url: "/v3/content/preview/course"
    }
} as {
    schema: PreviewCourseSchema;
    [QraftServiceOperationsToken]: V3Service["previewCourse"];
};
/** @summary Preview Topic */
export const previewTopic = {
    schema: {
        method: "get",
        url: "/v3/content/preview/topic/{topic_id}"
    }
} as {
    schema: PreviewTopicSchema;
    [QraftServiceOperationsToken]: V3Service["previewTopic"];
};
/** @summary Preview Lesson Questions */
export const previewLessonQuestions = {
    schema: {
        method: "get",
        url: "/v3/content/preview/lesson/{lesson_id}/questions"
    }
} as {
    schema: PreviewLessonQuestionsSchema;
    [QraftServiceOperationsToken]: V3Service["previewLessonQuestions"];
};
/** @summary Preview Mark */
export const previewMark = {
    schema: {
        method: "post",
        url: "/v3/content/preview/mark",
        mediaType: ["application/json"]
    }
} as {
    schema: PreviewMarkSchema;
    [QraftServiceOperationsToken]: V3Service["previewMark"];
};
/**
 * @summary Global Search
 * @description One corpus of global search results, ordered title-matches first.
 *
 * `kind` is required and names one corpus per call, which is what the legacy
 * engine's own SQL does. `q` is a single contiguous substring matched
 * case-insensitively and accent-insensitively against the title and against
 * the tag-stripped body, as two independent tests: a term spanning the end of
 * the title and the start of the body matches neither. LIKE wildcards in `q`
 * are matched literally.
 *
 * `language` is required. Every destination route resolves a slug within one
 * language and 404s outside it, so an unfiltered result would list
 * unreachable pages.
 *
 * `kind` plus `slug` addresses the hit; `id` is for keys, not for routing.
 */
export const globalSearch = {
    schema: {
        method: "get",
        url: "/v3/search"
    }
} as {
    schema: GlobalSearchSchema;
    [QraftServiceOperationsToken]: V3Service["globalSearch"];
};
/**
 * @summary Email Lesson
 * @description Mail the caller every topic of this lesson, plus its final exam link.
 *
 * The recipient is always the caller, so there is no `user_id` parameter.
 */
export const emailLesson = {
    schema: {
        method: "post",
        url: "/v3/emails/lesson/{lesson_id}"
    }
} as {
    schema: EmailLessonSchema;
    [QraftServiceOperationsToken]: V3Service["emailLesson"];
};
/** @summary List Certificates */
export const listCertificates = {
    schema: {
        method: "get",
        url: "/v3/certificates"
    }
} as {
    schema: ListCertificatesSchema;
    [QraftServiceOperationsToken]: V3Service["listCertificates"];
};
/**
 * @summary Download Certificate
 * @description Render and serve the certificate PDF, for a viewer entitled to it.
 */
export const downloadCertificate = {
    schema: {
        method: "get",
        url: "/v3/certificates/{certificate_id}/download"
    }
} as {
    schema: DownloadCertificateSchema;
    [QraftServiceOperationsToken]: V3Service["downloadCertificate"];
};
/**
 * @summary Award Certificate
 * @description Issue a course or series certificate to a student.
 */
export const awardCertificate = {
    schema: {
        method: "post",
        url: "/v3/certificates/award",
        mediaType: ["application/json"]
    }
} as {
    schema: AwardCertificateSchema;
    [QraftServiceOperationsToken]: V3Service["awardCertificate"];
};
/** @summary Admin Create Course Certificate Template */
export const adminCreateCourseCertificateTemplate = {
    schema: {
        method: "post",
        url: "/v3/certificates/admin/course/{course_id}/template",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminCreateCourseCertificateTemplateSchema;
    [QraftServiceOperationsToken]: V3Service["adminCreateCourseCertificateTemplate"];
};
/** @summary Admin Delete Course Certificate Template */
export const adminDeleteCourseCertificateTemplate = {
    schema: {
        method: "delete",
        url: "/v3/certificates/admin/course/{course_id}/template"
    }
} as {
    schema: AdminDeleteCourseCertificateTemplateSchema;
    [QraftServiceOperationsToken]: V3Service["adminDeleteCourseCertificateTemplate"];
};
/** @summary Admin Create Series Certificate Template */
export const adminCreateSeriesCertificateTemplate = {
    schema: {
        method: "post",
        url: "/v3/certificates/admin/series/{series_id}/template",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminCreateSeriesCertificateTemplateSchema;
    [QraftServiceOperationsToken]: V3Service["adminCreateSeriesCertificateTemplate"];
};
/** @summary Admin Delete Series Certificate Template */
export const adminDeleteSeriesCertificateTemplate = {
    schema: {
        method: "delete",
        url: "/v3/certificates/admin/series/{series_id}/template"
    }
} as {
    schema: AdminDeleteSeriesCertificateTemplateSchema;
    [QraftServiceOperationsToken]: V3Service["adminDeleteSeriesCertificateTemplate"];
};
/** @summary Topic Complete */
export const topicComplete = {
    schema: {
        method: "post",
        url: "/v3/grades/topic/{topic_id}/complete"
    }
} as {
    schema: TopicCompleteSchema;
    [QraftServiceOperationsToken]: V3Service["topicComplete"];
};
/** @summary Submit Lesson Quiz */
export const submitLessonQuiz = {
    schema: {
        method: "post",
        url: "/v3/grades/lesson/{lesson_id}/quiz",
        mediaType: ["application/json"]
    }
} as {
    schema: SubmitLessonQuizSchema;
    [QraftServiceOperationsToken]: V3Service["submitLessonQuiz"];
};
/** @summary Lesson Quiz Progress */
export const lessonQuizProgress = {
    schema: {
        method: "get",
        url: "/v3/grades/lesson/{lesson_id}/quiz"
    }
} as {
    schema: LessonQuizProgressSchema;
    [QraftServiceOperationsToken]: V3Service["lessonQuizProgress"];
};
/** @summary Submit Topic Quiz */
export const submitTopicQuiz = {
    schema: {
        method: "post",
        url: "/v3/grades/topic/{topic_id}/quiz",
        mediaType: ["application/json"]
    }
} as {
    schema: SubmitTopicQuizSchema;
    [QraftServiceOperationsToken]: V3Service["submitTopicQuiz"];
};
/** @summary Topic Quiz Progress */
export const topicQuizProgress = {
    schema: {
        method: "get",
        url: "/v3/grades/topic/{topic_id}/quiz"
    }
} as {
    schema: TopicQuizProgressSchema;
    [QraftServiceOperationsToken]: V3Service["topicQuizProgress"];
};
/** @summary Read Lesson Quiz Result */
export const lessonQuizResult = {
    schema: {
        method: "get",
        url: "/v3/grades/lesson/{lesson_id}/quiz/result"
    }
} as {
    schema: LessonQuizResultSchema;
    [QraftServiceOperationsToken]: V3Service["lessonQuizResult"];
};
/** @summary Read Topic Quiz Result */
export const topicQuizResult = {
    schema: {
        method: "get",
        url: "/v3/grades/topic/{topic_id}/quiz/result"
    }
} as {
    schema: TopicQuizResultSchema;
    [QraftServiceOperationsToken]: V3Service["topicQuizResult"];
};
/** @summary Read Course Viewer State */
export const courseViewerState = {
    schema: {
        method: "get",
        url: "/v3/grades/course/{course_id}/state"
    }
} as {
    schema: CourseViewerStateSchema;
    [QraftServiceOperationsToken]: V3Service["courseViewerState"];
};
/**
 * @summary Unlock Course
 * @description Self-join a course. The study-helper arm stays on fullapp.
 */
export const unlockCourse = {
    schema: {
        method: "post",
        url: "/v3/grades/course/{course_id}/unlock"
    }
} as {
    schema: UnlockCourseSchema;
    [QraftServiceOperationsToken]: V3Service["unlockCourse"];
};
/** @summary Continue Study */
export const continueStudy = {
    schema: {
        method: "get",
        url: "/v3/grades/continue-study"
    }
} as {
    schema: ContinueStudySchema;
    [QraftServiceOperationsToken]: V3Service["continueStudy"];
};
/** @summary Progress */
export const allProgress = {
    schema: {
        method: "get",
        url: "/v3/grades/progress"
    }
} as {
    schema: AllProgressSchema;
    [QraftServiceOperationsToken]: V3Service["allProgress"];
};
/** @summary Course Progress */
export const courseProgress = {
    schema: {
        method: "get",
        url: "/v3/grades/progress/course/{course_id}"
    }
} as {
    schema: CourseProgressSchema;
    [QraftServiceOperationsToken]: V3Service["courseProgress"];
};
/** @summary List Quiz Responses */
export const listQuizResponses = {
    schema: {
        method: "get",
        url: "/v3/grades/quiz-responses"
    }
} as {
    schema: ListQuizResponsesSchema;
    [QraftServiceOperationsToken]: V3Service["listQuizResponses"];
};
/** @summary Get Quiz Response Detail */
export const getQuizResponseDetail = {
    schema: {
        method: "get",
        url: "/v3/grades/quiz-responses/{response_id}"
    }
} as {
    schema: GetQuizResponseDetailSchema;
    [QraftServiceOperationsToken]: V3Service["getQuizResponseDetail"];
};
/**
 * @summary List Group Quiz Submissions
 * @description The group's quiz submissions: legacy's pending and completed tables, as one
 * operation.
 *
 * `status` is an include list. The pending table sends `[PENDING]`; the completed
 * table sends `[GRADED, FAILED]` and narrows it when its Status filter is used.
 *
 * No `search` parameter, since legacy's tables have no search box.
 */
export const listGroupQuizSubmissions = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/quiz-submissions"
    }
} as {
    schema: ListGroupQuizSubmissionsSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupQuizSubmissions"];
};
/**
 * @summary List Student Quiz Submissions
 * @description One student's quiz submissions, on their Course Study tab.
 *
 * Filters are `quiz_id`, `completed_after` and `completed_before`; the subject comes
 * from the path. A viewer the gate refuses gets the same 404 as an unknown id.
 *
 * This gate is wider than the detail's: it admits the student's group coordinator,
 * whom the submission detail refuses.
 */
export const listStudentQuizSubmissions = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/quiz-submissions"
    }
} as {
    schema: ListStudentQuizSubmissionsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentQuizSubmissions"];
};
/**
 * @summary Grading Submissions List
 * @description The caller's own submissions: a student's rows, or a study helper's students'.
 */
export const gradingSubmissionsList = {
    schema: {
        method: "get",
        url: "/v3/grading/submissions"
    }
} as {
    schema: GradingSubmissionsListSchema;
    [QraftServiceOperationsToken]: V3Service["gradingSubmissionsList"];
};
/**
 * @summary Grading Submission Detail
 * @description One grading, for both the grade screen and the view screen.
 *
 * Returned for a PENDING submission too, which the grade screen needs. The view
 * screen's not-graded-yet refusal is a client rule; on the server, a student's view
 * stamps `viewed_at` only on a GRADED or FAILED submission.
 */
export const gradingSubmissionDetail = {
    schema: {
        method: "get",
        url: "/v3/grading/submissions/{submission_id}"
    }
} as {
    schema: GradingSubmissionDetailSchema;
    [QraftServiceOperationsToken]: V3Service["gradingSubmissionDetail"];
};
/**
 * @summary Grade Submission
 * @description Assigned study helper only, and only while PENDING.
 *
 * Not widened to platform admins.
 */
export const gradingSubmissionGrade = {
    schema: {
        method: "post",
        url: "/v3/grading/submissions/{submission_id}/grade",
        mediaType: ["application/json"]
    }
} as {
    schema: GradingSubmissionGradeSchema;
    [QraftServiceOperationsToken]: V3Service["gradingSubmissionGrade"];
};
/** @summary Admin List Feedback Submissions */
export const adminListFeedbackSubmissions = {
    schema: {
        method: "get",
        url: "/v3/grading/admin/feedbacks"
    }
} as {
    schema: AdminListFeedbackSubmissionsSchema;
    [QraftServiceOperationsToken]: V3Service["adminListFeedbackSubmissions"];
};
/** @summary Admin Get Feedback Submission */
export const adminGetFeedbackSubmission = {
    schema: {
        method: "get",
        url: "/v3/grading/admin/feedbacks/{submission_id}"
    }
} as {
    schema: AdminGetFeedbackSubmissionSchema;
    [QraftServiceOperationsToken]: V3Service["adminGetFeedbackSubmission"];
};
/**
 * @summary Create Manual Grading Route
 * @description Enter a grade for a postal student who studies on paper.
 *
 * A separate operation from `POST /grading/submissions/{id}/grade`, which
 * grades an EXISTING attempt and carries no score -- a postal student never
 * sits one. The subject comes from the path, the quiz is the parameter, and the
 * lesson is derived from the quiz.
 */
export const createManualGrading = {
    schema: {
        method: "post",
        url: "/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateManualGradingSchema;
    [QraftServiceOperationsToken]: V3Service["createManualGrading"];
};
/**
 * @summary List Canned Responses
 * @description The caller's own reusable comments plus the built-in ones for a node.
 *
 * `node_id` is the question's id for `quiz-question-feedback` and `0` for the other
 * three; a row filed against `0` is visible from every target. Built-ins sort first,
 * then title. An empty page is the normal answer on most questions.
 *
 * `student_id` is the merge-tag target: on the two student-facing nodes, a student the
 * caller helps has their name substituted into `content`. Otherwise the tags stay
 * literal.
 */
export const listCannedResponses = {
    schema: {
        method: "get",
        url: "/v3/canned-responses"
    }
} as {
    schema: ListCannedResponsesSchema;
    [QraftServiceOperationsToken]: V3Service["listCannedResponses"];
};
/**
 * @summary Create Canned Response
 * @description Author a reusable comment owned by the calling study helper.
 *
 * The title is derived from the body server-side and the row is never a
 * built-in, so neither is accepted from the client.
 */
export const createCannedResponse = {
    schema: {
        method: "post",
        url: "/v3/canned-responses",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateCannedResponseSchema;
    [QraftServiceOperationsToken]: V3Service["createCannedResponse"];
};
/**
 * @summary Update Canned Response
 * @description Rewrite one of the caller's own reusable comments.
 *
 * Content only: node and target are immutable. A built-in is refused before
 * ownership is considered, so a built-in owned by nobody answers `forbidden`
 * rather than `invalid_ownership`.
 */
export const updateCannedResponse = {
    schema: {
        method: "put",
        url: "/v3/canned-responses/{canned_response_id}",
        mediaType: ["application/json"]
    }
} as {
    schema: UpdateCannedResponseSchema;
    [QraftServiceOperationsToken]: V3Service["updateCannedResponse"];
};
/**
 * @summary Delete Canned Response
 * @description Soft-delete one of the caller's own reusable comments.
 *
 * Same guard chain and same order as the update. The row is stamped rather than
 * removed, so it drops out of every fetch and stays auditable.
 */
export const deleteCannedResponse = {
    schema: {
        method: "delete",
        url: "/v3/canned-responses/{canned_response_id}"
    }
} as {
    schema: DeleteCannedResponseSchema;
    [QraftServiceOperationsToken]: V3Service["deleteCannedResponse"];
};
/** @summary Get Study Helper Board */
export const getStudyHelperBoard = {
    schema: {
        method: "get",
        url: "/v3/adoption/study-helper-board"
    }
} as {
    schema: GetStudyHelperBoardSchema;
    [QraftServiceOperationsToken]: V3Service["getStudyHelperBoard"];
};
/** @summary Get My Study Helper */
export const getMyStudyHelper = {
    schema: {
        method: "get",
        url: "/v3/adoption/my-study-helper"
    }
} as {
    schema: GetMyStudyHelperSchema;
    [QraftServiceOperationsToken]: V3Service["getMyStudyHelper"];
};
/**
 * @summary Get Student Board
 * @description The student board, for both surfaces.
 *
 * `group_id` is the group tab's board: it is gated admin/mod on a
 * congregation-type group and replaces the open board's reservation with that
 * group's own leads. `outreach_group_id` is the site-wide board's Outreach
 * Target filter over the open pool, membership-checked with no role axis. The
 * two are separate parameters so each can keep its own gate.
 */
export const getStudentBoard = {
    schema: {
        method: "get",
        url: "/v3/adoption/student-board"
    }
} as {
    schema: GetStudentBoardSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentBoard"];
};
/**
 * @summary Get Student Adoption Info
 * @description The adopt / pass-on / assign confirm payload, one operation for three modals.
 *
 * A caller who may not act gets the same typed 4xx the write raises, before any of the
 * student's details are served. `mode` selects the ladder: `adopt` runs all three
 * gates, `pass_on` only already-adopted (as `POST /pass-on` does), and `assign` none,
 * gating instead on the caller coordinating a group that claims the student. The board
 * scope check applies in every mode.
 */
export const getStudentAdoptionInfo = {
    schema: {
        method: "get",
        url: "/v3/adoption/students/{student_id}/adoption-info"
    }
} as {
    schema: GetStudentAdoptionInfoSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentAdoptionInfo"];
};
/** @summary Adopt Student */
export const adoptStudent = {
    schema: {
        method: "post",
        url: "/v3/adoption/adopt",
        mediaType: ["application/json"]
    }
} as {
    schema: AdoptStudentSchema;
    [QraftServiceOperationsToken]: V3Service["adoptStudent"];
};
/**
 * @summary Pass On Student
 * @description Release this helper's groups' claims on a lead.
 *
 * Clears the student's matched web targets in every group the caller
 * moderates, and their matched campaign when the caller moderates its group;
 * the student stays on the open board for another helper. The student must be
 * on an active board item and must not already have a study helper. Neither
 * the daily adoption limit nor the adoptability rule applies here.
 */
export const passOnStudent = {
    schema: {
        method: "post",
        url: "/v3/adoption/pass-on",
        mediaType: ["application/json"]
    }
} as {
    schema: PassOnStudentSchema;
    [QraftServiceOperationsToken]: V3Service["passOnStudent"];
};
/**
 * @summary Get Assign Candidates
 * @description The assign modal's study-helper picker: the posted target's own leaders.
 *
 * The admin and mod members of the group the SELECTED target belongs to, minus
 * the caller, searched by name. The picker is bound to the target rather than
 * to the student, and the posted target is validated against the student's own
 * claim set and the caller's ADMIN groups.
 */
export const getAssignCandidates = {
    schema: {
        method: "get",
        url: "/v3/adoption/students/{student_id}/assign-candidates"
    }
} as {
    schema: GetAssignCandidatesSchema;
    [QraftServiceOperationsToken]: V3Service["getAssignCandidates"];
};
/**
 * @summary Assign Student
 * @description Adopt a board student on behalf of one of the claiming group's leaders.
 *
 * The adoption records who did it (`adoptions.assignee_id`) and the assigned helper is
 * emailed. Each gate is commented at its line.
 */
export const assignStudent = {
    schema: {
        method: "post",
        url: "/v3/adoption/assign",
        mediaType: ["application/json"]
    }
} as {
    schema: AssignStudentSchema;
    [QraftServiceOperationsToken]: V3Service["assignStudent"];
};
/**
 * @summary Create Adoption Request
 * @description Ask a study helper to adopt you, or to take you over from your current one.
 *
 * A student with no study helper creates an adoption request; a student who
 * already has one creates a SWITCH request, which carries a reason. The two are
 * the same row and the same accept.
 */
export const createAdoptionRequest = {
    schema: {
        method: "post",
        url: "/v3/adoption/request",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateAdoptionRequestSchema;
    [QraftServiceOperationsToken]: V3Service["createAdoptionRequest"];
};
/**
 * @summary Get Adoption Requests
 * @description Pending adoption requests, helper-scoped or group-scoped.
 *
 * Without `group_id`, the caller's own requests (the dashboard widget). With
 * `group_id`, the group's Adoption Requests tab: requests addressed to any of the
 * group's leaders.
 */
export const getAdoptionRequests = {
    schema: {
        method: "get",
        url: "/v3/adoption/requests"
    }
} as {
    schema: GetAdoptionRequestsSchema;
    [QraftServiceOperationsToken]: V3Service["getAdoptionRequests"];
};
/**
 * @summary Accept Adoption Request
 * @description Accept a request addressed to you, adopting or reassigning the student.
 */
export const acceptAdoptionRequest = {
    schema: {
        method: "post",
        url: "/v3/adoption/requests/{request_id}/accept"
    }
} as {
    schema: AcceptAdoptionRequestSchema;
    [QraftServiceOperationsToken]: V3Service["acceptAdoptionRequest"];
};
/**
 * @summary Decline Adoption Request
 * @description Decline a request addressed to you, and block this pair from re-requesting.
 */
export const declineAdoptionRequest = {
    schema: {
        method: "post",
        url: "/v3/adoption/requests/{request_id}/decline"
    }
} as {
    schema: DeclineAdoptionRequestSchema;
    [QraftServiceOperationsToken]: V3Service["declineAdoptionRequest"];
};
/**
 * @summary Send Encouragement
 * @description Send one written encouragement to a student on the open board.
 *
 * A study helper may encourage a student they have not adopted, once per
 * student, and a student receives at most three in total. The message is
 * stored display-formatted and carries a `scheduled_email_at` that spaces the
 * drip one per student per day.
 */
export const sendEncouragement = {
    schema: {
        method: "post",
        url: "/v3/encouragements",
        mediaType: ["application/json"]
    }
} as {
    schema: SendEncouragementSchema;
    [QraftServiceOperationsToken]: V3Service["sendEncouragement"];
};
/**
 * @summary List Message Threads
 * @description Inbox: the current user's threads, most-recently-active first.
 */
export const listMessageThreads = {
    schema: {
        method: "get",
        url: "/v3/threads"
    }
} as {
    schema: ListMessageThreadsSchema;
    [QraftServiceOperationsToken]: V3Service["listMessageThreads"];
};
/**
 * @summary Create Thread
 * @description Compose: start (or find) the 1:1 thread with ``recipient_id`` and send.
 *
 * A new conversation is created recipient-first; an existing 1:1 thread with
 * that user is reused. Reply into an existing thread via
 * ``POST /threads/{thread_id}/messages`` instead.
 */
export const createThread = {
    schema: {
        method: "post",
        url: "/v3/threads",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateThreadSchema;
    [QraftServiceOperationsToken]: V3Service["createThread"];
};
/**
 * @summary Get Unread Message Count
 * @description Total unread messages — the header envelope badge.
 */
export const getUnreadMessageCount = {
    schema: {
        method: "get",
        url: "/v3/threads/unread-count"
    }
} as {
    schema: GetUnreadMessageCountSchema;
    [QraftServiceOperationsToken]: V3Service["getUnreadMessageCount"];
};
/**
 * @summary Get Thread Messages
 * @description The messages in ``thread_id`` — the caller must be a participant.
 */
export const getThreadMessages = {
    schema: {
        method: "get",
        url: "/v3/threads/{thread_id}/messages"
    }
} as {
    schema: GetThreadMessagesSchema;
    [QraftServiceOperationsToken]: V3Service["getThreadMessages"];
};
/**
 * @summary Send Thread Message
 * @description Reply into an existing thread the caller participates in.
 */
export const sendThreadMessage = {
    schema: {
        method: "post",
        url: "/v3/threads/{thread_id}/messages",
        mediaType: ["application/json"]
    }
} as {
    schema: SendThreadMessageSchema;
    [QraftServiceOperationsToken]: V3Service["sendThreadMessage"];
};
/** @summary Mark Message Thread Read */
export const markMessageThreadRead = {
    schema: {
        method: "post",
        url: "/v3/threads/{thread_id}/read"
    }
} as {
    schema: MarkMessageThreadReadSchema;
    [QraftServiceOperationsToken]: V3Service["markMessageThreadRead"];
};
/** @summary Mark Message Thread Unread */
export const markMessageThreadUnread = {
    schema: {
        method: "post",
        url: "/v3/threads/{thread_id}/unread"
    }
} as {
    schema: MarkMessageThreadUnreadSchema;
    [QraftServiceOperationsToken]: V3Service["markMessageThreadUnread"];
};
/** @summary Hide Message Thread */
export const hideMessageThread = {
    schema: {
        method: "post",
        url: "/v3/threads/{thread_id}/hide"
    }
} as {
    schema: HideMessageThreadSchema;
    [QraftServiceOperationsToken]: V3Service["hideMessageThread"];
};
/** @summary Delete Message Thread */
export const deleteMessageThread = {
    schema: {
        method: "delete",
        url: "/v3/threads/{thread_id}"
    }
} as {
    schema: DeleteMessageThreadSchema;
    [QraftServiceOperationsToken]: V3Service["deleteMessageThread"];
};
/**
 * @summary List Mass Messages
 * @description The group's mass messages, newest first.
 *
 * No search box and no filter panel, as legacy's table has neither, so no `searchable`
 * or `sortable` map is offered and an unrecognised `sort` key leaves this order
 * untouched.
 */
export const listMassMessages = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/mass-messages"
    }
} as {
    schema: ListMassMessagesSchema;
    [QraftServiceOperationsToken]: V3Service["listMassMessages"];
};
/**
 * @summary Send Mass Message
 * @description Broadcast one message to every leader of the group.
 *
 * One fresh thread per broadcast, never appended to an existing one, with every
 * recipient and the sender on it. The sender cannot reply into it and each
 * recipient's reply forks into a 1:1 with them.
 */
export const sendMassMessage = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/mass-messages",
        mediaType: ["application/json"]
    }
} as {
    schema: SendMassMessageSchema;
    [QraftServiceOperationsToken]: V3Service["sendMassMessage"];
};
/**
 * @summary Delete Mass Message
 * @description Hide the message from this group's list. It is NOT retracted.
 *
 * Any leader of the owning group may delete any of its mass messages, not only
 * the sender: that is legacy's in-group behaviour, where the tab shows every
 * row with a Delete link to every admin and mod.
 */
export const deleteMassMessage = {
    schema: {
        method: "delete",
        url: "/v3/groups/{group_id}/mass-messages/{thread_id}"
    }
} as {
    schema: DeleteMassMessageSchema;
    [QraftServiceOperationsToken]: V3Service["deleteMassMessage"];
};
/**
 * @summary Send Introduction
 * @description Send an introduction to a newly-adopted student (study-helper only).
 *
 * Reuses the shared introduction service: the introduction is a normal message
 * in the 1:1 thread (created or reused), flagged ``is_introduction``, and the
 * student is marked introduced by this study helper.
 */
export const sendIntroduction = {
    schema: {
        method: "post",
        url: "/v3/introductions",
        mediaType: ["application/json"]
    }
} as {
    schema: SendIntroductionSchema;
    [QraftServiceOperationsToken]: V3Service["sendIntroduction"];
};
/**
 * @summary Get List Filters
 * @description Describe a list's filters: key, label, control type and options.
 *
 * Options are resolved in the caller's language. Group-scoped lists require
 * ``group_id``, whose permission gate is per group; member-scoped ones require
 * ``student_id``. The permission check can't gate ``student_id``, so every per-student
 * option source re-checks the viewer itself and returns no options when refused.
 *
 * A ``search`` control has no options to browse: the client searches for them. Pass
 * the student ids such a control already holds as ``selected_student_ids`` to get
 * their labels back as its options; ids outside the list's own students are ignored.
 */
export const getListFilters = {
    schema: {
        method: "get",
        url: "/v3/lists/{list_key}/filters"
    }
} as {
    schema: GetListFiltersSchema;
    [QraftServiceOperationsToken]: V3Service["getListFilters"];
};
/**
 * @summary Get Countries
 * @description Every country, localized, sorted by name.
 *
 * Public, since the intake forms that need it are anonymous pages. The list is the
 * `Country` enum's; legacy's also had nine uninhabited or near-uninhabited
 * territories.
 */
export const getCountries = {
    schema: {
        method: "get",
        url: "/v3/countries"
    }
} as {
    schema: GetCountriesSchema;
    [QraftServiceOperationsToken]: V3Service["getCountries"];
};
/**
 * @summary Get Gdpr Notice
 * @description The GDPR cookie notice copy, in the request's language.
 *
 * Unauthenticated, since the banner is for every visitor. There's no dismiss endpoint:
 * legacy's only set a cookie, so the client sets it with the name and lifetime
 * returned here.
 */
export const getGdprNotice = {
    schema: {
        method: "get",
        url: "/v3/site-notices/gdpr"
    }
} as {
    schema: GetGdprNoticeSchema;
    [QraftServiceOperationsToken]: V3Service["getGdprNotice"];
};
/**
 * @summary List Header Notices
 * @description The sitewide notice band for this viewer, oldest first.
 *
 * Four filters, all applied here: the requested language with no English
 * fallback; unexpired; addressed to this viewer's profile type (an empty audience
 * means everyone); and not already dismissed by this viewer. An empty list is the
 * normal state — the band is chrome that is usually absent.
 *
 * Bodies are paragraph-wrapped HTML. There is no title on the wire: legacy hides
 * it and prints only the body.
 */
export const listHeaderNotices = {
    schema: {
        method: "get",
        url: "/v3/site-notices/header"
    }
} as {
    schema: ListHeaderNoticesSchema;
    [QraftServiceOperationsToken]: V3Service["listHeaderNotices"];
};
/**
 * @summary Dismiss Header Notice
 * @description Dismiss one notice for the authenticated caller, permanently.
 *
 * Idempotent: dismissing twice is a 200 both times. The dismissal is derived from
 * the session and can never be written on another user's behalf. An id that is not
 * a notice is a 404.
 */
export const dismissHeaderNotice = {
    schema: {
        method: "post",
        url: "/v3/site-notices/header/{notice_id}/dismiss"
    }
} as {
    schema: DismissHeaderNoticeSchema;
    [QraftServiceOperationsToken]: V3Service["dismissHeaderNotice"];
};
/**
 * @summary List Contextual Help Placements
 * @description Which help anchors resolve to a section in `language`.
 *
 * One small request per language per session. Advisory, not a boundary: the client
 * treats a pending fetch as allowing the icon. Legacy hides a screen's icon when its
 * placement resolves to no section, which is why this exists.
 */
export const listContextualHelpPlacements = {
    schema: {
        method: "get",
        url: "/v3/contextual-help/placements"
    }
} as {
    schema: ListContextualHelpPlacementsSchema;
    [QraftServiceOperationsToken]: V3Service["listContextualHelpPlacements"];
};
/**
 * @summary Get Contextual Help Placement
 * @description The single help section a screen anchors.
 *
 * Deliberately not filtered by the caller's profile type: the audience filter
 * applies to the whole-tree read only, so a screen's own help is whatever that
 * screen anchors. An anchor with no section in `language` is a 404.
 */
export const getContextualHelpPlacement = {
    schema: {
        method: "get",
        url: "/v3/contextual-help/placements/{placement}"
    }
} as {
    schema: GetContextualHelpPlacementSchema;
    [QraftServiceOperationsToken]: V3Service["getContextualHelpPlacement"];
};
/**
 * @summary Get Contextual Help Tree
 * @description The whole help tree for the caller, in `language`.
 *
 * Sections the caller's profile type is excluded from are omitted, and so are
 * sections excluded from everyone. `sections` may be empty, and a section's
 * `articles` may be empty; both are states to render.
 */
export const getContextualHelpTree = {
    schema: {
        method: "get",
        url: "/v3/contextual-help/sections"
    }
} as {
    schema: GetContextualHelpTreeSchema;
    [QraftServiceOperationsToken]: V3Service["getContextualHelpTree"];
};
/**
 * @summary List Notifications
 * @description The caller's notifications, newest first by default, split by read state.
 *
 * `action` backs the screen's action filter.
 */
export const listNotifications = {
    schema: {
        method: "get",
        url: "/v3/notifications"
    }
} as {
    schema: ListNotificationsSchema;
    [QraftServiceOperationsToken]: V3Service["listNotifications"];
};
/**
 * @summary Get Unread Notification Count
 * @description How many unread notifications the caller has — the header bell's badge.
 */
export const getUnreadNotificationCount = {
    schema: {
        method: "get",
        url: "/v3/notifications/unread-count"
    }
} as {
    schema: GetUnreadNotificationCountSchema;
    [QraftServiceOperationsToken]: V3Service["getUnreadNotificationCount"];
};
/**
 * @summary Mark Notifications Read
 * @description Mark the caller's notifications read. Idempotent.
 */
export const markNotificationsRead = {
    schema: {
        method: "post",
        url: "/v3/notifications/mark-read",
        mediaType: ["application/json"]
    }
} as {
    schema: MarkNotificationsReadSchema;
    [QraftServiceOperationsToken]: V3Service["markNotificationsRead"];
};
/**
 * @summary Mark Notifications Unread
 * @description Mark the caller's notifications unread. Idempotent.
 */
export const markNotificationsUnread = {
    schema: {
        method: "post",
        url: "/v3/notifications/mark-unread",
        mediaType: ["application/json"]
    }
} as {
    schema: MarkNotificationsUnreadSchema;
    [QraftServiceOperationsToken]: V3Service["markNotificationsUnread"];
};
/**
 * @summary Delete Notifications
 * @description Delete the caller's notifications.
 *
 * A POST rather than a DELETE because the ids (up to 100) go in the body.
 */
export const deleteNotifications = {
    schema: {
        method: "post",
        url: "/v3/notifications/delete",
        mediaType: ["application/json"]
    }
} as {
    schema: DeleteNotificationsSchema;
    [QraftServiceOperationsToken]: V3Service["deleteNotifications"];
};
/**
 * @summary Get Notification Preferences
 * @description The caller's own preferences, as columns and rows.
 *
 * Always the caller: legacy's is a BuddyPress Settings screen, and those are
 * own-profile only with no cross-user view to port.
 */
export const getNotificationPreferences = {
    schema: {
        method: "get",
        url: "/v3/notification-preferences"
    }
} as {
    schema: GetNotificationPreferencesSchema;
    [QraftServiceOperationsToken]: V3Service["getNotificationPreferences"];
};
/**
 * @summary Update Notification Preferences
 * @description Write a partial update and return the whole grid.
 *
 * The whole grid rather than an echo of the accepted keys, because connecting
 * a channel elsewhere changes which columns exist and the screen would
 * otherwise keep drawing a stale set.
 */
export const updateNotificationPreferences = {
    schema: {
        method: "put",
        url: "/v3/notification-preferences",
        mediaType: ["application/json"]
    }
} as {
    schema: UpdateNotificationPreferencesSchema;
    [QraftServiceOperationsToken]: V3Service["updateNotificationPreferences"];
};
/**
 * @summary Get Contact Channels
 * @description Both channels and their connected numbers, in one response so the settings screen
 * can draw its cards with one call.
 */
export const getContactChannels = {
    schema: {
        method: "get",
        url: "/v3/contact-channels"
    }
} as {
    schema: GetContactChannelsSchema;
    [QraftServiceOperationsToken]: V3Service["getContactChannels"];
};
/**
 * @summary Start Contact Channel Verification
 * @description Send a six-digit code to ``number``.
 *
 * 202, not 200: what comes back is an acknowledgement that a message is on its
 * way, and nothing is connected until the code is spent.
 */
export const startContactChannelVerification = {
    schema: {
        method: "post",
        url: "/v3/contact-channels/{channel}/verify",
        mediaType: ["application/json"]
    }
} as {
    schema: StartContactChannelVerificationSchema;
    [QraftServiceOperationsToken]: V3Service["startContactChannelVerification"];
};
/**
 * @summary Complete Contact Channel Verification
 * @description Spend the code and connect the number.
 */
export const completeContactChannelVerification = {
    schema: {
        method: "post",
        url: "/v3/contact-channels/{channel}/connect",
        mediaType: ["application/json"]
    }
} as {
    schema: CompleteContactChannelVerificationSchema;
    [QraftServiceOperationsToken]: V3Service["completeContactChannelVerification"];
};
/**
 * @summary Disconnect Contact Channel
 * @description Drop the connected number. Succeeds when there was nothing to drop.
 */
export const disconnectContactChannel = {
    schema: {
        method: "delete",
        url: "/v3/contact-channels/{channel}"
    }
} as {
    schema: DisconnectContactChannelSchema;
    [QraftServiceOperationsToken]: V3Service["disconnectContactChannel"];
};
/**
 * @summary List Group Activity
 * @description The group's Activity Log, newest first. Read-only, with no filters beyond the
 * pager.
 */
export const listGroupActivity = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/activity"
    }
} as {
    schema: ListGroupActivitySchema;
    [QraftServiceOperationsToken]: V3Service["listGroupActivity"];
};
/**
 * @summary List Member Activity
 * @description One member's Timeline: their own activity rows, newest first.
 *
 * A student caller is refused every timeline, their own included.
 */
export const listMemberActivity = {
    schema: {
        method: "get",
        url: "/v3/users/members/{member_id}/activity"
    }
} as {
    schema: ListMemberActivitySchema;
    [QraftServiceOperationsToken]: V3Service["listMemberActivity"];
};
/**
 * @summary Get Member Activity Access
 * @description Whether the caller may open this member's Timeline tab.
 *
 * Always 200, so the sidebars can gate the nav item on one query; `can_view=false`
 * means render no tab. It runs the feed's own predicate, so the probe can't disagree
 * with the read.
 */
export const getMemberActivityAccess = {
    schema: {
        method: "get",
        url: "/v3/users/members/{member_id}/activity/access"
    }
} as {
    schema: GetMemberActivityAccessSchema;
    [QraftServiceOperationsToken]: V3Service["getMemberActivityAccess"];
};
/**
 * @summary Get Group Announcement
 * @description The group's stored announcement, as its author sees it.
 *
 * ``group_id`` comes from the path, not the caller's main group. A group with no row
 * answers ``content=""`` and ``is_enabled=False`` rather than 404, so the authoring
 * screen opens on groups that never had an announcement.
 */
export const getGroupAnnouncement = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/announcement"
    }
} as {
    schema: GetGroupAnnouncementSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupAnnouncement"];
};
/**
 * @summary Set Group Announcement
 * @description Replace the group's announcement, and return what was stored.
 *
 * ``PUT``: the row is a primary-key upsert on ``group_id`` and both fields are always
 * sent. The response is the stored row, never ``body``, because the write sanitises.
 */
export const setGroupAnnouncement = {
    schema: {
        method: "put",
        url: "/v3/groups/{group_id}/announcement",
        mediaType: ["application/json"]
    }
} as {
    schema: SetGroupAnnouncementSchema;
    [QraftServiceOperationsToken]: V3Service["setGroupAnnouncement"];
};
/**
 * @summary Get Group Dashboard Stats
 * @description The four counters on a study group's stat bar, in legacy's order.
 *
 * `unread_messages` is the viewer's own inbox, not the group's.
 */
export const getGroupDashboardStats = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/dashboard-stats"
    }
} as {
    schema: GetGroupDashboardStatsSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupDashboardStats"];
};
/**
 * @summary Get Congregation Dashboard Stats
 * @description The congregation / custom-study stat bar: four tiles, the last a composite.
 *
 * Group admins only, on a congregation or a custom study group.
 */
export const getCongregationDashboardStats = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/congregation-dashboard-stats"
    }
} as {
    schema: GetCongregationDashboardStatsSchema;
    [QraftServiceOperationsToken]: V3Service["getCongregationDashboardStats"];
};
/**
 * @summary List Congregation Dashboard Waiting
 * @description The Students Waiting panel: one row per grading the group still owes, oldest
 * first.
 *
 * A student with two qualifying gradings has two rows, and the stat tile counts the
 * same rows.
 */
export const listCongregationDashboardWaiting = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/congregation-dashboard-waiting"
    }
} as {
    schema: ListCongregationDashboardWaitingSchema;
    [QraftServiceOperationsToken]: V3Service["listCongregationDashboardWaiting"];
};
/**
 * @summary List Congregation Dashboard Locations
 * @description The congregation dashboard's Locations widget: the group's derived students.
 *
 * Every marker is a student. Legacy also plotted the group's leaders, but study
 * helpers have no stored coordinates.
 */
export const listCongregationDashboardLocations = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/congregation-dashboard-locations"
    }
} as {
    schema: ListCongregationDashboardLocationsSchema;
    [QraftServiceOperationsToken]: V3Service["listCongregationDashboardLocations"];
};
/**
 * @summary List Group Student Languages
 * @description One row per language with the group's derived-student count, zeros included.
 */
export const listGroupStudentLanguages = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/student-languages"
    }
} as {
    schema: ListGroupStudentLanguagesSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupStudentLanguages"];
};
/**
 * @summary Get Student Dashboard Stats
 * @description The four cards on the caller's own student dashboard. Self-only.
 */
export const getStudentDashboardStats = {
    schema: {
        method: "get",
        url: "/v3/users/me/dashboard-stats"
    }
} as {
    schema: GetStudentDashboardStatsSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentDashboardStats"];
};
/**
 * @summary Get Student Dashboard Widgets
 * @description The caller's own dashboard: which widgets, in what order, and which hidden.
 *
 * Self-only. An `EMAIL_STUDENT` gets `sidebar=null, widgets=[]`, which is that
 * profile's real dashboard rather than an error.
 */
export const getStudentDashboardWidgets = {
    schema: {
        method: "get",
        url: "/v3/users/me/dashboard-widgets"
    }
} as {
    schema: GetStudentDashboardWidgetsSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentDashboardWidgets"];
};
/**
 * @summary Set Student Hidden Widgets
 * @description Replace the caller's whole hidden set for their own dashboard.
 *
 * Self-only. A full-set replace, so an empty `hidden` means nothing is hidden.
 */
export const setStudentHiddenWidgets = {
    schema: {
        method: "put",
        url: "/v3/users/me/dashboard-widgets/hidden",
        mediaType: ["application/json"]
    }
} as {
    schema: SetStudentHiddenWidgetsSchema;
    [QraftServiceOperationsToken]: V3Service["setStudentHiddenWidgets"];
};
/**
 * @summary Get Group Dashboard Widgets
 * @description One study group's dashboard layout. Group leaders only.
 */
export const getGroupDashboardWidgets = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/dashboard-widgets"
    }
} as {
    schema: GetGroupDashboardWidgetsSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupDashboardWidgets"];
};
/**
 * @summary Set Group Hidden Widgets
 * @description Replace the group's whole hidden set. Group leaders only.
 */
export const setGroupHiddenWidgets = {
    schema: {
        method: "put",
        url: "/v3/groups/{group_id}/dashboard-widgets/hidden",
        mediaType: ["application/json"]
    }
} as {
    schema: SetGroupHiddenWidgetsSchema;
    [QraftServiceOperationsToken]: V3Service["setGroupHiddenWidgets"];
};
/**
 * @summary Get Congregation Dashboard Widgets
 * @description One congregation's or custom study group's dashboard layout. Admins only.
 */
export const getCongregationDashboardWidgets = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/congregation-dashboard-widgets"
    }
} as {
    schema: GetCongregationDashboardWidgetsSchema;
    [QraftServiceOperationsToken]: V3Service["getCongregationDashboardWidgets"];
};
/**
 * @summary Set Congregation Hidden Widgets
 * @description Replace the group's whole hidden set. Admins only.
 */
export const setCongregationHiddenWidgets = {
    schema: {
        method: "put",
        url: "/v3/groups/{group_id}/congregation-dashboard-widgets/hidden",
        mediaType: ["application/json"]
    }
} as {
    schema: SetCongregationHiddenWidgetsSchema;
    [QraftServiceOperationsToken]: V3Service["setCongregationHiddenWidgets"];
};
/**
 * @summary Get Coordinator Dashboard Stats
 * @description The caller's own follow-up coordinator stat bar: three counts and a composite.
 *
 * Self-only. Zero is a common, valid answer, so the client must not treat a refused
 * request as 0.
 */
export const getCoordinatorDashboardStats = {
    schema: {
        method: "get",
        url: "/v3/users/me/coordinator-dashboard-stats"
    }
} as {
    schema: GetCoordinatorDashboardStatsSchema;
    [QraftServiceOperationsToken]: V3Service["getCoordinatorDashboardStats"];
};
/**
 * @summary Get Partner Dashboard Stats
 * @description The caller's own follow-up partner stat bar: two counts and a composite.
 * Self-only.
 */
export const getPartnerDashboardStats = {
    schema: {
        method: "get",
        url: "/v3/users/me/partner-dashboard-stats"
    }
} as {
    schema: GetPartnerDashboardStatsSchema;
    [QraftServiceOperationsToken]: V3Service["getPartnerDashboardStats"];
};
/**
 * @summary Get Follow Up Dashboard Widgets
 * @description The caller's own coordinator or partner dashboard layout. Self-only.
 */
export const getFollowUpDashboardWidgets = {
    schema: {
        method: "get",
        url: "/v3/users/me/follow-up-dashboard-widgets"
    }
} as {
    schema: GetFollowUpDashboardWidgetsSchema;
    [QraftServiceOperationsToken]: V3Service["getFollowUpDashboardWidgets"];
};
/**
 * @summary Set Follow Up Hidden Widgets
 * @description Replace the caller's whole hidden set for their own dashboard. Self-only.
 */
export const setFollowUpHiddenWidgets = {
    schema: {
        method: "put",
        url: "/v3/users/me/follow-up-dashboard-widgets/hidden",
        mediaType: ["application/json"]
    }
} as {
    schema: SetFollowUpHiddenWidgetsSchema;
    [QraftServiceOperationsToken]: V3Service["setFollowUpHiddenWidgets"];
};
/**
 * @summary List Group Study Activities
 * @description The group's study-activity log.
 *
 * `student_id` and `study_mode` take lists because legacy's controls are
 * multi-select; the frozen fullapp twin's `student` filter stays a single int.
 * The date bounds are inclusive on `*_after` and exclusive on `*_before`,
 * anchored at midnight in the site's timezone.
 */
export const listGroupStudyActivities = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/study-activities"
    }
} as {
    schema: ListGroupStudyActivitiesSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupStudyActivities"];
};
/**
 * @summary List Student Study Activities
 * @description One student's study-activity log.
 *
 * The subject comes from the path. A viewer the gate refuses, including the student
 * themselves, gets the same 404 as an unknown id.
 */
export const listStudentStudyActivities = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/study-activities"
    }
} as {
    schema: ListStudentStudyActivitiesSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentStudyActivities"];
};
/**
 * @summary Get Student Study Activity Access
 * @description Whether the caller may open this student's study-activity log.
 *
 * Answers 200 for every authenticated caller, so the web route can gate on one
 * query instead of reading a status code, and carries the student's name so the
 * page can title the table without a second, wider read.
 */
export const getStudentStudyActivityAccess = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/study-activities/access"
    }
} as {
    schema: GetStudentStudyActivityAccessSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentStudyActivityAccess"];
};
/**
 * @summary Get Student Follow Ups Access
 * @description Whether the caller may open this student's Follow-ups tab.
 *
 * Answers 200 for every authenticated caller, so the tab shell and the sidebar link
 * can gate on one query, and carries the student's name for the page title. Separate
 * from `get_student_viewer_access`, which would refuse the follow-up coordinator and
 * partner this tab exists for.
 */
export const getStudentFollowUpsAccess = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/follow-ups/access"
    }
} as {
    schema: GetStudentFollowUpsAccessSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentFollowUpsAccess"];
};
/**
 * @summary List Student Follow Up Requests
 * @description The student's follow-up requests that have not become a follow-up.
 *
 * The subject comes from the path and the gate, never a query parameter. `status`
 * accepts the full enum, though the filter panel offers only four values.
 */
export const listStudentFollowUpRequests = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/follow-up-requests"
    }
} as {
    schema: ListStudentFollowUpRequestsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentFollowUpRequests"];
};
/**
 * @summary List Student Pending Follow Up Requests
 * @description The student's requests still awaiting their answer.
 *
 * No filters, no search and no sort keys, and the subject comes from the path.
 */
export const listStudentPendingFollowUpRequests = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/follow-up-requests/pending"
    }
} as {
    schema: ListStudentPendingFollowUpRequestsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentPendingFollowUpRequests"];
};
/**
 * @summary List Student Follow Ups
 * @description The student's in-person follow-ups.
 *
 * Omitting `status` returns all seven statuses. Date bounds include the named day, in
 * site time.
 */
export const listStudentFollowUps = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/follow-ups"
    }
} as {
    schema: ListStudentFollowUpsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentFollowUps"];
};
/**
 * @summary Get Pending Follow Up Verification
 * @description The one pending request the site-wide verification popup is about.
 *
 * 404 when there is none, so the web hook can treat no body as no popup.
 */
export const getPendingFollowUpVerification = {
    schema: {
        method: "get",
        url: "/v3/follow-up-requests/pending-verification"
    }
} as {
    schema: GetPendingFollowUpVerificationSchema;
    [QraftServiceOperationsToken]: V3Service["getPendingFollowUpVerification"];
};
/**
 * @summary Approve Follow Up Request
 * @description The student consents to their own pending follow-up request.
 *
 * The merged contact snapshot is saved before the field and consent checks run, so a
 * failed submit isn't lost. `contact_info` is merged by keys sent: an omitted key
 * keeps the stored value and a submitted empty string clears it.
 */
export const approveFollowUpRequest = {
    schema: {
        method: "post",
        url: "/v3/follow-up-requests/{request_id}/approve",
        mediaType: ["application/json"]
    }
} as {
    schema: ApproveFollowUpRequestSchema;
    [QraftServiceOperationsToken]: V3Service["approveFollowUpRequest"];
};
/**
 * @summary Reject Follow Up Request
 * @description The student declines their own pending follow-up request.
 *
 * `reason` is optional, may be empty, and is written to
 * `message_for_study_helper_reject`.
 */
export const rejectFollowUpRequest = {
    schema: {
        method: "post",
        url: "/v3/follow-up-requests/{request_id}/reject",
        mediaType: ["application/json"]
    }
} as {
    schema: RejectFollowUpRequestSchema;
    [QraftServiceOperationsToken]: V3Service["rejectFollowUpRequest"];
};
/**
 * @summary List Group Follow Up Requests
 * @description Every follow-up request the group's students carry.
 *
 * Omitting `status` hides `pending` and `in_progress`, which is legacy's
 * value-less filter default; supplying any value REPLACES that exclusion rather
 * than intersecting with it, so `?status=pending` returns exactly the rows the
 * bare list hides.
 */
export const listGroupFollowUpRequests = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/follow-up-requests"
    }
} as {
    schema: ListGroupFollowUpRequestsSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupFollowUpRequests"];
};
/**
 * @summary Create Group Follow Up Request
 * @description A study helper asks that one of their group's students be visited.
 *
 * A request for a private unverified postal student auto-approves and never
 * reaches the student's consent popup.
 */
export const createGroupFollowUpRequest = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/follow-up-requests",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateGroupFollowUpRequestSchema;
    [QraftServiceOperationsToken]: V3Service["createGroupFollowUpRequest"];
};
/**
 * @summary List Group Pending Follow Up Requests
 * @description The group's requests still waiting on their student's answer.
 *
 * Four fixed predicates and no controls of any kind: the student is in the
 * group's derived roster, the creator is one of the group's helpers, the request
 * is unadopted, and its status is `pending`.
 */
export const listGroupPendingFollowUpRequests = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/follow-up-requests/pending"
    }
} as {
    schema: ListGroupPendingFollowUpRequestsSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupPendingFollowUpRequests"];
};
/**
 * @summary List Group Follow Up Request Student Options
 * @description The create wizard's target-student picker.
 *
 * Not `GET /v3/groups/{group_id}/students`, which requires a group admin where this
 * tab admits any member.
 */
export const listGroupFollowUpRequestStudentOptions = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/follow-up-requests/student-options"
    }
} as {
    schema: ListGroupFollowUpRequestStudentOptionsSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupFollowUpRequestStudentOptions"];
};
/**
 * @summary Get Group Follow Up Request Draft
 * @description Everything step 2 of the create wizard renders, for one target student.
 *
 * Each objective's `disabled` / `checked` state is resolved server-side: a
 * disabled checkbox is never submitted, so the client cannot derive it from a
 * status.
 */
export const getGroupFollowUpRequestDraft = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/follow-up-requests/draft"
    }
} as {
    schema: GetGroupFollowUpRequestDraftSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupFollowUpRequestDraft"];
};
/**
 * @summary Get Group Follow Up Request
 * @description One request, as both group detail routes render it.
 *
 * Scoped to the group's derived roster: a request outside it answers 404, not
 * 403, so the endpoint is not an existence oracle over requests.
 */
export const getGroupFollowUpRequest = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/follow-up-requests/{request_id}"
    }
} as {
    schema: GetGroupFollowUpRequestSchema;
    [QraftServiceOperationsToken]: V3Service["getGroupFollowUpRequest"];
};
/**
 * @summary List Group Follow Ups
 * @description The in-person follow-ups the group's students carry.
 *
 * Omitting `status` returns all seven. The group axis is the student's current helper,
 * not `follow_ups.study_helper_id`.
 */
export const listGroupFollowUps = {
    schema: {
        method: "get",
        url: "/v3/groups/{group_id}/follow-ups"
    }
} as {
    schema: ListGroupFollowUpsSchema;
    [QraftServiceOperationsToken]: V3Service["listGroupFollowUps"];
};
/**
 * @summary Cancel Group Follow Up Request
 * @description The student's assigned study helper withdraws a pending request.
 *
 * `reason` is required and non-empty, and a request that is no longer `pending`
 * is refused — legacy had no such guard and could orphan a follow-up.
 */
export const cancelGroupFollowUpRequest = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel",
        mediaType: ["application/json"]
    }
} as {
    schema: CancelGroupFollowUpRequestSchema;
    [QraftServiceOperationsToken]: V3Service["cancelGroupFollowUpRequest"];
};
/**
 * @summary Dismiss Group Follow Up Request
 * @description The study helper acknowledges a student's rejection.
 *
 * Sets `rejection_dismissed` and nothing else; no v3 list reads that column, so
 * the row itself is the only observable change.
 */
export const dismissGroupFollowUpRequest = {
    schema: {
        method: "post",
        url: "/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss"
    }
} as {
    schema: DismissGroupFollowUpRequestSchema;
    [QraftServiceOperationsToken]: V3Service["dismissGroupFollowUpRequest"];
};
/**
 * @summary List Follow Up Request Board
 * @description Every approved, unclaimed, unconverted follow-up request in the network.
 *
 * Defaults to the caller's own approved countries and student languages, and an empty
 * preference serves an empty board, as in legacy. An admin gets neither default and
 * reads the board unfiltered. Status, claim and conversion state are fixed server-side
 * and are not parameters.
 */
export const listFollowUpRequestBoard = {
    schema: {
        method: "get",
        url: "/v3/follow-up-requests/board"
    }
} as {
    schema: ListFollowUpRequestBoardSchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpRequestBoard"];
};
/**
 * @summary Get Follow Up Request Board Detail
 * @description One board request, as the View Request Detail popup renders it.
 *
 * Limited to requests on the board, requests the caller has claimed, and admins;
 * anything else is a 404, not 403, so the endpoint is not an existence oracle.
 */
export const getFollowUpRequestBoardDetail = {
    schema: {
        method: "get",
        url: "/v3/follow-up-requests/board/{request_id}"
    }
} as {
    schema: GetFollowUpRequestBoardDetailSchema;
    [QraftServiceOperationsToken]: V3Service["getFollowUpRequestBoardDetail"];
};
/**
 * @summary Take Follow Up Request
 * @description A follow-up coordinator claims one board request.
 *
 * No body and no redirect; the row leaves the board because its status becomes
 * `adopted`. Takes `CurrentFollowupCoordinatorDependency` rather than the board's
 * Requirement, which admits admins: `coordinator_id` FKs `followup_coordinators.id`,
 * so an admin reaching the update would be a 500 instead of a 403.
 */
export const takeFollowUpRequest = {
    schema: {
        method: "post",
        url: "/v3/follow-up-requests/{request_id}/take"
    }
} as {
    schema: TakeFollowUpRequestSchema;
    [QraftServiceOperationsToken]: V3Service["takeFollowUpRequest"];
};
/**
 * @summary List Coordinator Pending Follow Up Requests
 * @description The coordinator's convert queue: requests they adopted and have not converted.
 *
 * `CurrentFollowupCoordinatorDependency` rather than the board's Requirement: the list
 * is scoped to the caller's own coordinator id, which an admin doesn't have, so a
 * bypass would show an empty tab instead of a 403.
 */
export const listCoordinatorPendingFollowUpRequests = {
    schema: {
        method: "get",
        url: "/v3/follow-ups/coordinator/pending-requests"
    }
} as {
    schema: ListCoordinatorPendingFollowUpRequestsSchema;
    [QraftServiceOperationsToken]: V3Service["listCoordinatorPendingFollowUpRequests"];
};
/**
 * @summary List Coordinator Follow Ups
 * @description The follow-ups this coordinator owns.
 *
 * Omitting `status` returns all seven. `display_name` is a prefix match on the
 * student's name and is also where the table's quick search lands, so there is no
 * separate `search` parameter.
 */
export const listCoordinatorFollowUps = {
    schema: {
        method: "get",
        url: "/v3/follow-ups/coordinator/entries"
    }
} as {
    schema: ListCoordinatorFollowUpsSchema;
    [QraftServiceOperationsToken]: V3Service["listCoordinatorFollowUps"];
};
/**
 * @summary List Partner Pending Follow Ups
 * @description The invitations this partner has not answered yet.
 *
 * Reads `follow_ups` and ignores `follow_ups.status`, so a completed follow-up whose
 * partner never answered still appears. No filters, sorting or search, as in legacy,
 * but still paginated.
 */
export const listPartnerPendingFollowUps = {
    schema: {
        method: "get",
        url: "/v3/follow-ups/partner/pending-requests"
    }
} as {
    schema: ListPartnerPendingFollowUpsSchema;
    [QraftServiceOperationsToken]: V3Service["listPartnerPendingFollowUps"];
};
/**
 * @summary List Partner Follow Ups
 * @description The follow-ups this partner has accepted.
 *
 * Scoped by the accepted `partner_id`: a follow-up they have only been invited to is
 * on Pending Requests instead.
 */
export const listPartnerFollowUps = {
    schema: {
        method: "get",
        url: "/v3/follow-ups/partner/entries"
    }
} as {
    schema: ListPartnerFollowUpsSchema;
    [QraftServiceOperationsToken]: V3Service["listPartnerFollowUps"];
};
/**
 * @summary Get Follow Up Detail
 * @description One follow-up, as the shared detail template renders it.
 *
 * Admits the student, the resolved partner, the coordinator, the student's current
 * study helper and admins; anyone else gets 404, not 403. The student may open the
 * page but not the timeline, and `can_view_timeline` says which.
 */
export const getFollowUp = {
    schema: {
        method: "get",
        url: "/v3/follow-ups/{follow_up_id}"
    }
} as {
    schema: GetFollowUpSchema;
    [QraftServiceOperationsToken]: V3Service["getFollowUp"];
};
/**
 * @summary List Follow Up Records Route
 * @description The follow-up's timeline, newest first.
 *
 * 403 for the student — the same block legacy uses to hide the Additional Notes
 * and the composer — and 404 for a caller with no relation to the row at all.
 */
export const listFollowUpRecords = {
    schema: {
        method: "get",
        url: "/v3/follow-ups/{follow_up_id}/records"
    }
} as {
    schema: ListFollowUpRecordsSchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpRecords"];
};
/**
 * @summary Add Follow Up Record Route
 * @description The timeline composer: a note, optionally with a status change.
 *
 * The record type is derived from `new_status`, never posted. An empty note is valid.
 * A `new_status` is stored on the record and moves `follow_ups.status` only when it
 * differs.
 */
export const addFollowUpRecord = {
    schema: {
        method: "post",
        url: "/v3/follow-ups/{follow_up_id}/records",
        mediaType: ["application/json"]
    }
} as {
    schema: AddFollowUpRecordSchema;
    [QraftServiceOperationsToken]: V3Service["addFollowUpRecord"];
};
/**
 * @summary Get Follow Up Convert Draft
 * @description Everything the convert form renders, for one request the caller adopted.
 *
 * 404 for a request another coordinator holds. `selected_requests` is display only:
 * convert takes the request's own objectives.
 */
export const getFollowUpConvertDraft = {
    schema: {
        method: "get",
        url: "/v3/follow-up-requests/{request_id}/convert-draft"
    }
} as {
    schema: GetFollowUpConvertDraftSchema;
    [QraftServiceOperationsToken]: V3Service["getFollowUpConvertDraft"];
};
/**
 * @summary List Follow Up Partner Options Route
 * @description The partner picker: partners approved for the student's country and language,
 * plus the caller's own unverified contacts.
 *
 * Takes either `request_id` (convert) or `follow_up_id` (reassign), exactly one;
 * neither or both is a 422. Both are scoped to a row the caller owns and answer 404
 * otherwise, since the options reveal the student's country and language and the
 * reassign arm excludes the current partners. `term` is a per-word prefix match on
 * first and last name, ANDed across words.
 */
export const listFollowUpPartnerOptions = {
    schema: {
        method: "get",
        url: "/v3/follow-up-partners/options"
    }
} as {
    schema: ListFollowUpPartnerOptionsSchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpPartnerOptions"];
};
/**
 * @summary Create Follow Up Route
 * @description Convert: a coordinator turns a request they adopted into a follow-up and invites
 * one partner.
 *
 * Only the coordinator who adopted the request may convert it. Writes
 * `requested_partner_id` and leaves `partner_id` NULL, because a frozen mobile gate
 * reads `partner_id` to decide who may fetch the student's contact details; the
 * exception is an unverified partner, who is approved outright.
 */
export const createFollowUp = {
    schema: {
        method: "post",
        url: "/v3/follow-ups",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateFollowUpSchema;
    [QraftServiceOperationsToken]: V3Service["createFollowUp"];
};
/**
 * @summary Accept Follow Up Route
 * @description The invited partner accepts.
 *
 * No body. Moves `status` to `in_progress` and `partner_status` to `approved`,
 * snapshots the partner's contact details and records the coordinator<->partner edge.
 * A replay answers 409 rather than reverting a completed follow-up.
 */
export const acceptFollowUp = {
    schema: {
        method: "post",
        url: "/v3/follow-ups/{follow_up_id}/accept"
    }
} as {
    schema: AcceptFollowUpSchema;
    [QraftServiceOperationsToken]: V3Service["acceptFollowUp"];
};
/**
 * @summary Reject Follow Up Route
 * @description The invited partner declines.
 *
 * `follow_ups.status` is not touched, as in legacy. `requested_partner_id` is kept so
 * the coordinator can see who declined.
 */
export const rejectFollowUp = {
    schema: {
        method: "post",
        url: "/v3/follow-ups/{follow_up_id}/reject",
        mediaType: ["application/json"]
    }
} as {
    schema: RejectFollowUpSchema;
    [QraftServiceOperationsToken]: V3Service["rejectFollowUp"];
};
/**
 * @summary Set Follow Up Partner Route
 * @description The coordinator reassigns the follow-up to a different partner.
 *
 * Refused with 409 once the current partner has accepted. A verified partner is
 * invited; a private unverified one is approved outright.
 */
export const setFollowUpPartner = {
    schema: {
        method: "post",
        url: "/v3/follow-ups/{follow_up_id}/partner",
        mediaType: ["application/json"]
    }
} as {
    schema: SetFollowUpPartnerSchema;
    [QraftServiceOperationsToken]: V3Service["setFollowUpPartner"];
};
/**
 * @summary List Follow Up Network
 * @description Every follow-up coordinator and partner on the platform.
 *
 * System-wide, not a group roster: the only roster predicate is the two profile types.
 * An unverified partner is visible only to the coordinator who created them, the one
 * caller-dependent thing about the page. `profile_type` narrows within the two and
 * can't widen past them.
 */
export const listFollowUpNetwork = {
    schema: {
        method: "get",
        url: "/v3/follow-up-network"
    }
} as {
    schema: ListFollowUpNetworkSchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpNetwork"];
};
/**
 * @summary List Follow Up Network Map
 * @description The same directory, restricted to the people who carry coordinates.
 *
 * The same eight filters and the same gate as the list — one legacy ajax action
 * served both. `count` is the pinnable population under the caller's filters, so
 * a client can report *pinned of roster* by reading it beside the list's. Every
 * field the marker's info window renders is on the row; there is no second
 * request behind a marker.
 */
export const listFollowUpNetworkMap = {
    schema: {
        method: "get",
        url: "/v3/follow-up-network/map"
    }
} as {
    schema: ListFollowUpNetworkMapSchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpNetworkMap"];
};
/**
 * @summary List Follow Up Partner Directory
 * @description The partners on the calling coordinator's follow-up network.
 *
 * Read from `follow_up_network`. An unverified partner is visible only to the
 * coordinator who created them. No filter panel, search box or row action, as in
 * legacy, so this path has no `LIST_FILTERS` key.
 */
export const listFollowUpPartnerDirectory = {
    schema: {
        method: "get",
        url: "/v3/follow-up-partners"
    }
} as {
    schema: ListFollowUpPartnerDirectorySchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpPartnerDirectory"];
};
/**
 * @summary Create Follow Up Partner
 * @description A coordinator registers a follow-up partner.
 *
 * The partner is created unverified and visible only to this coordinator, the email is
 * optional, and one network edge is written from the authenticated caller. There is no
 * approval queue.
 */
export const createFollowUpPartner = {
    schema: {
        method: "post",
        url: "/v3/follow-up-partners",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateFollowUpPartnerSchema;
    [QraftServiceOperationsToken]: V3Service["createFollowUpPartner"];
};
/**
 * @summary List Follow Up Coordinator Directory
 * @description The coordinators who assigned this partner a follow-up they hold.
 *
 * Read from `follow_ups.partner_id`, never `follow_up_network`: that table is
 * undirected and would list coordinators the partner never worked with. A partner who
 * registered but never accepted an assignment sees an empty tab. Same columns as All
 * Partners with Registered in place of Congregation, and no visibility filter.
 */
export const listFollowUpCoordinatorDirectory = {
    schema: {
        method: "get",
        url: "/v3/follow-up-coordinators"
    }
} as {
    schema: ListFollowUpCoordinatorDirectorySchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpCoordinatorDirectory"];
};
/**
 * @summary List Follow Up Students
 * @description The calling coordinator's or partner's own caseload students.
 *
 * One operation for both roles: a coordinator sees the students on their follow-ups
 * plus those they adopted a request for; a partner sees the students on the follow-ups
 * they accepted.
 */
export const listFollowUpStudents = {
    schema: {
        method: "get",
        url: "/v3/follow-up-students"
    }
} as {
    schema: ListFollowUpStudentsSchema;
    [QraftServiceOperationsToken]: V3Service["listFollowUpStudents"];
};
/**
 * @summary List Coordinator Dashboard Panel
 * @description One panel of the caller's own coordinator dashboard.
 *
 * `aging` (`last_activity_at` older than the window) and `latest-update` (newer)
 * are disjoint sets; `recently-closed` is the completed follow-ups inside the
 * same window. A `type` this dashboard does not place is a 400.
 */
export const listCoordinatorDashboardFollowUps = {
    schema: {
        method: "get",
        url: "/v3/users/me/coordinator-dashboard-follow-ups"
    }
} as {
    schema: ListCoordinatorDashboardFollowUpsSchema;
    [QraftServiceOperationsToken]: V3Service["listCoordinatorDashboardFollowUps"];
};
/**
 * @summary List Partner Dashboard Panel
 * @description One panel of the caller's own partner dashboard.
 *
 * `pending` is the invitations they haven't answered (by `requested_partner_id`, with
 * no day window); `aging` is their accepted caseload older than the window. Any other
 * `type` is a 400.
 */
export const listPartnerDashboardFollowUps = {
    schema: {
        method: "get",
        url: "/v3/users/me/partner-dashboard-follow-ups"
    }
} as {
    schema: ListPartnerDashboardFollowUpsSchema;
    [QraftServiceOperationsToken]: V3Service["listPartnerDashboardFollowUps"];
};
/**
 * @summary List Coordinator Dashboard Locations
 * @description The caller's own network partners and caseload students, with coordinates.
 *
 * Two populations in one list, told apart by `audience`. The caller is never
 * plotted.
 */
export const listCoordinatorDashboardLocations = {
    schema: {
        method: "get",
        url: "/v3/users/me/coordinator-dashboard-locations"
    }
} as {
    schema: ListCoordinatorDashboardLocationsSchema;
    [QraftServiceOperationsToken]: V3Service["listCoordinatorDashboardLocations"];
};
/**
 * @summary List Partner Dashboard Locations
 * @description The students on the caller's own follow-ups, with coordinates.
 *
 * One population, so every marker is `audience = student` and the widget renders no
 * filter select. An empty map is common, since many partners hold no follow-up.
 */
export const listPartnerDashboardLocations = {
    schema: {
        method: "get",
        url: "/v3/users/me/partner-dashboard-locations"
    }
} as {
    schema: ListPartnerDashboardLocationsSchema;
    [QraftServiceOperationsToken]: V3Service["listPartnerDashboardLocations"];
};
/**
 * @summary Get Course Study Access
 * @description Whether the caller may open this student's Course Study tab.
 *
 * Answers 200 for every authenticated caller, so the tab shell can gate on one query
 * instead of a status code, and says which of the two first-slot screens the caller
 * gets. Legacy picks that by relationship, not by the viewer's profile type.
 */
export const getCourseStudyAccess = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/course-study/access"
    }
} as {
    schema: GetCourseStudyAccessSchema;
    [QraftServiceOperationsToken]: V3Service["getCourseStudyAccess"];
};
/**
 * @summary List Student Course Study Series
 * @description The student's series, each with its courses, access and progress.
 *
 * One read behind both first-slot screens: the student's Courses cards and the
 * supervisor's Course Progression accordion render the same rows, as in legacy.
 *
 * No `language` parameter: both screens render in the student's language, not the
 * viewer's, resolved server-side.
 */
export const listStudentCourseStudySeries = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/course-study/series"
    }
} as {
    schema: ListStudentCourseStudySeriesSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentCourseStudySeries"];
};
/**
 * @summary List Student Course Study Lessons
 * @description One course's lessons for this student, serving both branches.
 *
 * The card fields (`image`, the topic counts, `quiz_submitted` / `quiz_graded` /
 * `grade`) feed the student's lazy-loaded carousel; `rows` feeds the
 * supervisor's per-lesson table. Each view ignores the other's fields, exactly as
 * legacy's two templates do over one lesson list.
 *
 * `version` defaults to the student's version of `course_id`: the published one
 * they're enrolled on, else the live one.
 */
export const listStudentCourseStudyLessons = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/course-study/courses/{course_id}/lessons"
    }
} as {
    schema: ListStudentCourseStudyLessonsSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentCourseStudyLessons"];
};
/**
 * @summary List Student Certificates
 * @description This student's certificates, for the member tab.
 *
 * The subject is a path parameter, so the tab makes one call whether the viewer is the
 * student or a supervisor. A caller the gate refuses gets the same 404 as an unknown
 * id.
 *
 * Students reading their own tab never receive a pending row, and a pending row
 * carries no `download_url`.
 */
export const listStudentCertificates = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/certificates"
    }
} as {
    schema: ListStudentCertificatesSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentCertificates"];
};
/**
 * @summary Unlock Student Course
 * @description Unlock a course for this student, opening its first lesson with it.
 *
 * Idempotent: re-unlocking an already-open course answers 200, where legacy answered
 * an error even after writing the unlock.
 */
export const unlockStudentCourse = {
    schema: {
        method: "post",
        url: "/v3/users/students/{student_id}/course-study/courses/{course_id}/unlock"
    }
} as {
    schema: UnlockStudentCourseSchema;
    [QraftServiceOperationsToken]: V3Service["unlockStudentCourse"];
};
/**
 * @summary Unlock Student Lesson
 * @description Unlock one lesson for this student.
 *
 * Idempotent-success, and `newly_unlocked` is how the client tells which
 * happened: the notification and the study-activity row fire only on a real
 * insert.
 */
export const unlockStudentLesson = {
    schema: {
        method: "post",
        url: "/v3/users/students/{student_id}/course-study/lessons/{lesson_id}/unlock"
    }
} as {
    schema: UnlockStudentLessonSchema;
    [QraftServiceOperationsToken]: V3Service["unlockStudentLesson"];
};
/**
 * @summary Complete Student Topic
 * @description Mark a topic complete on the student's behalf.
 *
 * For a postal student, whose work arrives on paper, or by an administrator on any
 * student.
 */
export const completeStudentTopic = {
    schema: {
        method: "post",
        url: "/v3/users/students/{student_id}/course-study/topics/{topic_id}/complete"
    }
} as {
    schema: CompleteStudentTopicSchema;
    [QraftServiceOperationsToken]: V3Service["completeStudentTopic"];
};
/**
 * @summary Get Student Note Access
 * @description Whether the caller may open this student's notes.
 *
 * Answers 200 for every authenticated caller, so the web route can gate the tab
 * on one query instead of reading a status code, and carries the student's name
 * so the page can title itself without a second, wider read.
 */
export const getStudentNoteAccess = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/notes/access"
    }
} as {
    schema: GetStudentNoteAccessSchema;
    [QraftServiceOperationsToken]: V3Service["getStudentNoteAccess"];
};
/**
 * @summary List Student Notes
 * @description This student's notes, newest first, 10 to a page.
 *
 * Opening the tab also marks the caller's own unread notifications about this
 * student read, which is what the legacy screen does on load.
 */
export const listStudentNotes = {
    schema: {
        method: "get",
        url: "/v3/users/students/{student_id}/notes"
    }
} as {
    schema: ListStudentNotesSchema;
    [QraftServiceOperationsToken]: V3Service["listStudentNotes"];
};
/**
 * @summary Create Student Note
 * @description Write a note about this student and return it, so the client can prepend
 * the new row without refetching the page.
 *
 * Every viewer the tab admits may write; there is no author or role test beyond
 * the tab's own gate. The student's assigned study helper is notified unless
 * they are the author.
 */
export const createStudentNote = {
    schema: {
        method: "post",
        url: "/v3/users/students/{student_id}/notes",
        mediaType: ["application/json"]
    }
} as {
    schema: CreateStudentNoteSchema;
    [QraftServiceOperationsToken]: V3Service["createStudentNote"];
};
/**
 * @summary Delete Student Note
 * @description Remove one note from this student's list.
 *
 * Any viewer the tab admits may delete any of this student's notes, not only
 * the ones they wrote.
 */
export const deleteStudentNote = {
    schema: {
        method: "delete",
        url: "/v3/users/students/{student_id}/notes/{note_id}"
    }
} as {
    schema: DeleteStudentNoteSchema;
    [QraftServiceOperationsToken]: V3Service["deleteStudentNote"];
};
export const v3Service = {
    loginV3AuthLoginPost,
    registerUserV3AuthRegisterPost,
    requestPasswordReset,
    checkPasswordResetKey,
    resetPassword,
    logout,
    createSwitchToken,
    switchAccount,
    listStudentNews,
    getStudentNewsPost,
    listStudyHelperNews,
    getStudyHelperNewsPost,
    listStudentTutorials,
    getStudentTutorial,
    listStudyHelperTutorials,
    getStudyHelperTutorial,
    listFollowUpTutorials,
    getFollowUpTutorial,
    getPostTerm,
    getArchiveSidebar,
    getStudents,
    getStudent,
    setStudentStudyHelper,
    getStudentStudyHelper,
    getStudentViewerAccess,
    getStudentStudyHelperHistory,
    getStudyHelpers,
    getStudyHelper,
    getCurrentUser,
    setMyLanguage,
    setMyNewsletterSubscription,
    updateMyLoginInformation,
    verifyMyEmailChange,
    cancelMyEmailChange,
    getMyStudyHelperAnnouncement,
    getMemberProfile,
    updateMemberProfile,
    getMemberProfileForm,
    uploadMemberAvatar,
    deleteMemberAvatar,
    listOnboardingSequences,
    getOnboardingSequence,
    getOnboardingSlide,
    onboardingStatus,
    onboardingDetail,
    submitOnboarding,
    listHelperApplications,
    getHelperApplication,
    submitHelperApplication,
    submitFollowUpCoordinatorApplication,
    submitFollowUpPartnerApplication,
    rejectHelperApplication,
    approveHelperApplication,
    getCampaigns,
    createCampaignSession,
    getGroups,
    createGroup,
    listMyGroups,
    getGroup,
    getGroupBySlug,
    getGroupStudents,
    createPostalStudent,
    previewGroupStudentsReassign,
    reassignGroupStudents,
    getGroupStudyHelpers,
    addGroupStudyHelper,
    removeGroupStudyHelper,
    uploadGroupAvatar,
    deleteGroupAvatar,
    createGeoTarget,
    listGroupGeoTargets,
    updateGeoTarget,
    deleteGeoTarget,
    getGroupPendingTasks,
    listGroupMemberTags,
    createGroupMemberTag,
    getGroupMemberTag,
    updateGroupMemberTag,
    deleteGroupMemberTag,
    setStudentMemberTags,
    listGeoTargetMap,
    listGroupCampaigns,
    createGroupCampaign,
    getPersonalCampaign,
    enablePersonalCampaign,
    listPersonalCampaignStudents,
    checkCampaignSubdomain,
    listSeries,
    listCourses,
    listSelfPacedCourses,
    courseBySlug,
    lessonBySlug,
    topicBySlug,
    quizBySlug,
    courseDetail,
    courseLessons,
    lessonDetail,
    lessonTopics,
    topicDetail,
    lessonQuestions,
    adminGetTopic,
    adminUpdateTopic,
    adminDeleteTopic,
    adminListTopics,
    adminCreateTopic,
    adminListSeries,
    adminCreateSeries,
    adminGetSeries,
    adminUpdateSeries,
    adminListQuestions,
    adminCreateQuestion,
    adminGetQuestion,
    adminUpdateQuestion,
    adminDeleteQuestion,
    adminBulkDeleteQuestions,
    adminBulkPublishQuestions,
    adminUploadMedia,
    adminGetLesson,
    adminUpdateLesson,
    adminDeleteLesson,
    adminListLessons,
    adminCreateLesson,
    adminGetCourseOutline,
    adminSearchLessons,
    adminSearchTopics,
    adminSearchQuestions,
    adminListCourses,
    adminCreateCourse,
    adminGetCourse,
    adminUpdateCourse,
    adminListCourseVersions,
    adminStartCourseVersion,
    adminDiscardCourseVersion,
    adminFindInCourseVersion,
    adminCourseVersionChanges,
    adminRevertCourseVersionChange,
    adminCourseVersionPublishCheck,
    adminPublishCourseVersion,
    adminPreviewCourseVersion,
    previewRedeem,
    previewEnd,
    previewCourse,
    previewTopic,
    previewLessonQuestions,
    previewMark,
    globalSearch,
    emailLesson,
    listCertificates,
    downloadCertificate,
    awardCertificate,
    adminCreateCourseCertificateTemplate,
    adminDeleteCourseCertificateTemplate,
    adminCreateSeriesCertificateTemplate,
    adminDeleteSeriesCertificateTemplate,
    topicComplete,
    submitLessonQuiz,
    lessonQuizProgress,
    submitTopicQuiz,
    topicQuizProgress,
    lessonQuizResult,
    topicQuizResult,
    courseViewerState,
    unlockCourse,
    continueStudy,
    allProgress,
    courseProgress,
    listQuizResponses,
    getQuizResponseDetail,
    listGroupQuizSubmissions,
    listStudentQuizSubmissions,
    gradingSubmissionsList,
    gradingSubmissionDetail,
    gradingSubmissionGrade,
    adminListFeedbackSubmissions,
    adminGetFeedbackSubmission,
    createManualGrading,
    listCannedResponses,
    createCannedResponse,
    updateCannedResponse,
    deleteCannedResponse,
    getStudyHelperBoard,
    getMyStudyHelper,
    getStudentBoard,
    getStudentAdoptionInfo,
    adoptStudent,
    passOnStudent,
    getAssignCandidates,
    assignStudent,
    createAdoptionRequest,
    getAdoptionRequests,
    acceptAdoptionRequest,
    declineAdoptionRequest,
    sendEncouragement,
    listMessageThreads,
    createThread,
    getUnreadMessageCount,
    getThreadMessages,
    sendThreadMessage,
    markMessageThreadRead,
    markMessageThreadUnread,
    hideMessageThread,
    deleteMessageThread,
    listMassMessages,
    sendMassMessage,
    deleteMassMessage,
    sendIntroduction,
    getListFilters,
    getCountries,
    getGdprNotice,
    listHeaderNotices,
    dismissHeaderNotice,
    listContextualHelpPlacements,
    getContextualHelpPlacement,
    getContextualHelpTree,
    listNotifications,
    getUnreadNotificationCount,
    markNotificationsRead,
    markNotificationsUnread,
    deleteNotifications,
    getNotificationPreferences,
    updateNotificationPreferences,
    getContactChannels,
    startContactChannelVerification,
    completeContactChannelVerification,
    disconnectContactChannel,
    listGroupActivity,
    listMemberActivity,
    getMemberActivityAccess,
    getGroupAnnouncement,
    setGroupAnnouncement,
    getGroupDashboardStats,
    getCongregationDashboardStats,
    listCongregationDashboardWaiting,
    listCongregationDashboardLocations,
    listGroupStudentLanguages,
    getStudentDashboardStats,
    getStudentDashboardWidgets,
    setStudentHiddenWidgets,
    getGroupDashboardWidgets,
    setGroupHiddenWidgets,
    getCongregationDashboardWidgets,
    setCongregationHiddenWidgets,
    getCoordinatorDashboardStats,
    getPartnerDashboardStats,
    getFollowUpDashboardWidgets,
    setFollowUpHiddenWidgets,
    listGroupStudyActivities,
    listStudentStudyActivities,
    getStudentStudyActivityAccess,
    getStudentFollowUpsAccess,
    listStudentFollowUpRequests,
    listStudentPendingFollowUpRequests,
    listStudentFollowUps,
    getPendingFollowUpVerification,
    approveFollowUpRequest,
    rejectFollowUpRequest,
    listGroupFollowUpRequests,
    createGroupFollowUpRequest,
    listGroupPendingFollowUpRequests,
    listGroupFollowUpRequestStudentOptions,
    getGroupFollowUpRequestDraft,
    getGroupFollowUpRequest,
    listGroupFollowUps,
    cancelGroupFollowUpRequest,
    dismissGroupFollowUpRequest,
    listFollowUpRequestBoard,
    getFollowUpRequestBoardDetail,
    takeFollowUpRequest,
    listCoordinatorPendingFollowUpRequests,
    listCoordinatorFollowUps,
    listPartnerPendingFollowUps,
    listPartnerFollowUps,
    getFollowUp,
    listFollowUpRecords,
    addFollowUpRecord,
    getFollowUpConvertDraft,
    listFollowUpPartnerOptions,
    createFollowUp,
    acceptFollowUp,
    rejectFollowUp,
    setFollowUpPartner,
    listFollowUpNetwork,
    listFollowUpNetworkMap,
    listFollowUpPartnerDirectory,
    createFollowUpPartner,
    listFollowUpCoordinatorDirectory,
    listFollowUpStudents,
    listCoordinatorDashboardFollowUps,
    listPartnerDashboardFollowUps,
    listCoordinatorDashboardLocations,
    listPartnerDashboardLocations,
    getCourseStudyAccess,
    listStudentCourseStudySeries,
    listStudentCourseStudyLessons,
    listStudentCertificates,
    unlockStudentCourse,
    unlockStudentLesson,
    completeStudentTopic,
    getStudentNoteAccess,
    listStudentNotes,
    createStudentNote,
    deleteStudentNote
} as const;
type LoginV3AuthLoginPostSchema = {
    method: "post";
    url: "/v3/auth/login";
    mediaType: [
        "application/json"
    ];
};
type LoginV3AuthLoginPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type LoginV3AuthLoginPostData = paths["/v3/auth/login"]["post"]["responses"]["200"]["content"]["application/json"];
type LoginV3AuthLoginPostError = paths["/v3/auth/login"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/auth/login"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/auth/login"]["post"]["responses"]["422"]["content"]["application/json"];
type LoginV3AuthLoginPostBody = paths["/v3/auth/login"]["post"]["requestBody"]["content"]["application/json"];
type RegisterUserV3AuthRegisterPostSchema = {
    method: "post";
    url: "/v3/auth/register";
    mediaType: [
        "application/json"
    ];
};
type RegisterUserV3AuthRegisterPostParameters = paths["/v3/auth/register"]["post"]["parameters"];
type RegisterUserV3AuthRegisterPostData = paths["/v3/auth/register"]["post"]["responses"]["200"]["content"]["application/json"];
type RegisterUserV3AuthRegisterPostError = paths["/v3/auth/register"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/auth/register"]["post"]["responses"]["422"]["content"]["application/json"];
type RegisterUserV3AuthRegisterPostBody = paths["/v3/auth/register"]["post"]["requestBody"]["content"]["application/json"];
type RequestPasswordResetSchema = {
    method: "post";
    url: "/v3/auth/lost-password";
    mediaType: [
        "application/json"
    ];
};
type RequestPasswordResetParameters = paths["/v3/auth/lost-password"]["post"]["parameters"];
type RequestPasswordResetData = paths["/v3/auth/lost-password"]["post"]["responses"]["200"]["content"]["application/json"];
type RequestPasswordResetError = paths["/v3/auth/lost-password"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/auth/lost-password"]["post"]["responses"]["422"]["content"]["application/json"];
type RequestPasswordResetBody = paths["/v3/auth/lost-password"]["post"]["requestBody"]["content"]["application/json"];
type CheckPasswordResetKeySchema = {
    method: "post";
    url: "/v3/auth/reset-password/check";
    mediaType: [
        "application/json"
    ];
};
type CheckPasswordResetKeyParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type CheckPasswordResetKeyData = paths["/v3/auth/reset-password/check"]["post"]["responses"]["200"]["content"]["application/json"];
type CheckPasswordResetKeyError = paths["/v3/auth/reset-password/check"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/auth/reset-password/check"]["post"]["responses"]["422"]["content"]["application/json"];
type CheckPasswordResetKeyBody = paths["/v3/auth/reset-password/check"]["post"]["requestBody"]["content"]["application/json"];
type ResetPasswordSchema = {
    method: "post";
    url: "/v3/auth/reset-password";
    mediaType: [
        "application/json"
    ];
};
type ResetPasswordParameters = paths["/v3/auth/reset-password"]["post"]["parameters"];
type ResetPasswordData = paths["/v3/auth/reset-password"]["post"]["responses"]["200"]["content"]["application/json"];
type ResetPasswordError = paths["/v3/auth/reset-password"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/auth/reset-password"]["post"]["responses"]["422"]["content"]["application/json"];
type ResetPasswordBody = paths["/v3/auth/reset-password"]["post"]["requestBody"]["content"]["application/json"];
type LogoutSchema = {
    method: "post";
    url: "/v3/auth/logout";
};
type LogoutParameters = paths["/v3/auth/logout"]["post"]["parameters"];
type LogoutData = paths["/v3/auth/logout"]["post"]["responses"]["200"]["content"]["application/json"];
type LogoutError = paths["/v3/auth/logout"]["post"]["responses"]["422"]["content"]["application/json"];
type LogoutBody = undefined;
type CreateSwitchTokenSchema = {
    method: "post";
    url: "/v3/auth/switch-token";
    mediaType: [
        "application/json"
    ];
};
type CreateSwitchTokenParameters = paths["/v3/auth/switch-token"]["post"]["parameters"];
type CreateSwitchTokenData = paths["/v3/auth/switch-token"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateSwitchTokenError = paths["/v3/auth/switch-token"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/auth/switch-token"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/auth/switch-token"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateSwitchTokenBody = paths["/v3/auth/switch-token"]["post"]["requestBody"]["content"]["application/json"];
type SwitchAccountSchema = {
    method: "post";
    url: "/v3/auth/switch";
    mediaType: [
        "application/json"
    ];
};
type SwitchAccountParameters = paths["/v3/auth/switch"]["post"]["parameters"];
type SwitchAccountData = paths["/v3/auth/switch"]["post"]["responses"]["200"]["content"]["application/json"];
type SwitchAccountError = paths["/v3/auth/switch"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/auth/switch"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/auth/switch"]["post"]["responses"]["422"]["content"]["application/json"];
type SwitchAccountBody = paths["/v3/auth/switch"]["post"]["requestBody"]["content"]["application/json"];
type ListStudentNewsSchema = {
    method: "get";
    url: "/v3/student-news";
};
type ListStudentNewsParameters = paths["/v3/student-news"]["get"]["parameters"];
type ListStudentNewsData = paths["/v3/student-news"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentNewsError = paths["/v3/student-news"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/student-news"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentNewsPostSchema = {
    method: "get";
    url: "/v3/student-news/{slug}";
};
type GetStudentNewsPostParameters = paths["/v3/student-news/{slug}"]["get"]["parameters"];
type GetStudentNewsPostData = paths["/v3/student-news/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentNewsPostError = paths["/v3/student-news/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/student-news/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/student-news/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudyHelperNewsSchema = {
    method: "get";
    url: "/v3/study-helper-news";
};
type ListStudyHelperNewsParameters = paths["/v3/study-helper-news"]["get"]["parameters"];
type ListStudyHelperNewsData = paths["/v3/study-helper-news"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudyHelperNewsError = paths["/v3/study-helper-news"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/study-helper-news"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudyHelperNewsPostSchema = {
    method: "get";
    url: "/v3/study-helper-news/{slug}";
};
type GetStudyHelperNewsPostParameters = paths["/v3/study-helper-news/{slug}"]["get"]["parameters"];
type GetStudyHelperNewsPostData = paths["/v3/study-helper-news/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudyHelperNewsPostError = paths["/v3/study-helper-news/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/study-helper-news/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/study-helper-news/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentTutorialsSchema = {
    method: "get";
    url: "/v3/student-tutorials";
};
type ListStudentTutorialsParameters = paths["/v3/student-tutorials"]["get"]["parameters"];
type ListStudentTutorialsData = paths["/v3/student-tutorials"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentTutorialsError = paths["/v3/student-tutorials"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/student-tutorials"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentTutorialSchema = {
    method: "get";
    url: "/v3/student-tutorials/{slug}";
};
type GetStudentTutorialParameters = paths["/v3/student-tutorials/{slug}"]["get"]["parameters"];
type GetStudentTutorialData = paths["/v3/student-tutorials/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentTutorialError = paths["/v3/student-tutorials/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/student-tutorials/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/student-tutorials/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudyHelperTutorialsSchema = {
    method: "get";
    url: "/v3/study-helper-tutorials";
};
type ListStudyHelperTutorialsParameters = paths["/v3/study-helper-tutorials"]["get"]["parameters"];
type ListStudyHelperTutorialsData = paths["/v3/study-helper-tutorials"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudyHelperTutorialsError = paths["/v3/study-helper-tutorials"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/study-helper-tutorials"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/study-helper-tutorials"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudyHelperTutorialSchema = {
    method: "get";
    url: "/v3/study-helper-tutorials/{slug}";
};
type GetStudyHelperTutorialParameters = paths["/v3/study-helper-tutorials/{slug}"]["get"]["parameters"];
type GetStudyHelperTutorialData = paths["/v3/study-helper-tutorials/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudyHelperTutorialError = paths["/v3/study-helper-tutorials/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/study-helper-tutorials/{slug}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/study-helper-tutorials/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/study-helper-tutorials/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type ListFollowUpTutorialsSchema = {
    method: "get";
    url: "/v3/follow-up-tutorials";
};
type ListFollowUpTutorialsParameters = paths["/v3/follow-up-tutorials"]["get"]["parameters"];
type ListFollowUpTutorialsData = paths["/v3/follow-up-tutorials"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpTutorialsError = paths["/v3/follow-up-tutorials"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-tutorials"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-tutorials"]["get"]["responses"]["422"]["content"]["application/json"];
type GetFollowUpTutorialSchema = {
    method: "get";
    url: "/v3/follow-up-tutorials/{slug}";
};
type GetFollowUpTutorialParameters = paths["/v3/follow-up-tutorials/{slug}"]["get"]["parameters"];
type GetFollowUpTutorialData = paths["/v3/follow-up-tutorials/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetFollowUpTutorialError = paths["/v3/follow-up-tutorials/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-tutorials/{slug}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-tutorials/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-up-tutorials/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type GetPostTermSchema = {
    method: "get";
    url: "/v3/post-terms/{taxonomy}/{slug}";
};
type GetPostTermParameters = paths["/v3/post-terms/{taxonomy}/{slug}"]["get"]["parameters"];
type GetPostTermData = paths["/v3/post-terms/{taxonomy}/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetPostTermError = paths["/v3/post-terms/{taxonomy}/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/post-terms/{taxonomy}/{slug}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/post-terms/{taxonomy}/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/post-terms/{taxonomy}/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type GetArchiveSidebarSchema = {
    method: "get";
    url: "/v3/archive-sidebars/{sidebar}";
};
type GetArchiveSidebarParameters = paths["/v3/archive-sidebars/{sidebar}"]["get"]["parameters"];
type GetArchiveSidebarData = paths["/v3/archive-sidebars/{sidebar}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetArchiveSidebarError = paths["/v3/archive-sidebars/{sidebar}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/archive-sidebars/{sidebar}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/archive-sidebars/{sidebar}"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentsSchema = {
    method: "get";
    url: "/v3/users/students";
};
type GetStudentsParameters = paths["/v3/users/students"]["get"]["parameters"];
type GetStudentsData = paths["/v3/users/students"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentsError = null | null | paths["/v3/users/students"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}";
};
type GetStudentParameters = paths["/v3/users/students/{student_id}"]["get"]["parameters"];
type GetStudentData = paths["/v3/users/students/{student_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentError = null | null | null | paths["/v3/users/students/{student_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type SetStudentStudyHelperSchema = {
    method: "put";
    url: "/v3/users/students/{student_id}/study-helper";
    mediaType: [
        "application/json"
    ];
};
type SetStudentStudyHelperParameters = paths["/v3/users/students/{student_id}/study-helper"]["put"]["parameters"];
type SetStudentStudyHelperData = paths["/v3/users/students/{student_id}/study-helper"]["put"]["responses"]["200"]["content"]["application/json"];
type SetStudentStudyHelperError = null | null | null | paths["/v3/users/students/{student_id}/study-helper"]["put"]["responses"]["422"]["content"]["application/json"];
type SetStudentStudyHelperBody = paths["/v3/users/students/{student_id}/study-helper"]["put"]["requestBody"]["content"]["application/json"];
type GetStudentStudyHelperSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/study-helper";
};
type GetStudentStudyHelperParameters = paths["/v3/users/students/{student_id}/study-helper"]["get"]["parameters"];
type GetStudentStudyHelperData = paths["/v3/users/students/{student_id}/study-helper"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentStudyHelperError = null | paths["/v3/users/students/{student_id}/study-helper"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/study-helper"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentViewerAccessSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/viewer-access";
};
type GetStudentViewerAccessParameters = paths["/v3/users/students/{student_id}/viewer-access"]["get"]["parameters"];
type GetStudentViewerAccessData = paths["/v3/users/students/{student_id}/viewer-access"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentViewerAccessError = paths["/v3/users/students/{student_id}/viewer-access"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/viewer-access"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentStudyHelperHistorySchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/study-helper-history";
};
type GetStudentStudyHelperHistoryParameters = paths["/v3/users/students/{student_id}/study-helper-history"]["get"]["parameters"];
type GetStudentStudyHelperHistoryData = paths["/v3/users/students/{student_id}/study-helper-history"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentStudyHelperHistoryError = null | paths["/v3/users/students/{student_id}/study-helper-history"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/study-helper-history"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudyHelpersSchema = {
    method: "get";
    url: "/v3/users/study-helpers";
};
type GetStudyHelpersParameters = paths["/v3/users/study-helpers"]["get"]["parameters"];
type GetStudyHelpersData = paths["/v3/users/study-helpers"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudyHelpersError = null | null | paths["/v3/users/study-helpers"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudyHelperSchema = {
    method: "get";
    url: "/v3/users/study-helpers/{study_helper_id}";
};
type GetStudyHelperParameters = paths["/v3/users/study-helpers/{study_helper_id}"]["get"]["parameters"];
type GetStudyHelperData = paths["/v3/users/study-helpers/{study_helper_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudyHelperError = null | null | null | paths["/v3/users/study-helpers/{study_helper_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type GetCurrentUserSchema = {
    method: "get";
    url: "/v3/users/me";
};
type GetCurrentUserParameters = paths["/v3/users/me"]["get"]["parameters"];
type GetCurrentUserData = paths["/v3/users/me"]["get"]["responses"]["200"]["content"]["application/json"];
type GetCurrentUserError = null | paths["/v3/users/me"]["get"]["responses"]["422"]["content"]["application/json"];
type SetMyLanguageSchema = {
    method: "put";
    url: "/v3/users/me/language";
    mediaType: [
        "application/json"
    ];
};
type SetMyLanguageParameters = paths["/v3/users/me/language"]["put"]["parameters"];
type SetMyLanguageData = paths["/v3/users/me/language"]["put"]["responses"]["200"]["content"]["application/json"];
type SetMyLanguageError = null | paths["/v3/users/me/language"]["put"]["responses"]["422"]["content"]["application/json"];
type SetMyLanguageBody = paths["/v3/users/me/language"]["put"]["requestBody"]["content"]["application/json"];
type SetMyNewsletterSubscriptionSchema = {
    method: "put";
    url: "/v3/users/me/newsletter-subscription";
    mediaType: [
        "application/json"
    ];
};
type SetMyNewsletterSubscriptionParameters = paths["/v3/users/me/newsletter-subscription"]["put"]["parameters"];
type SetMyNewsletterSubscriptionData = paths["/v3/users/me/newsletter-subscription"]["put"]["responses"]["200"]["content"]["application/json"];
type SetMyNewsletterSubscriptionError = paths["/v3/users/me/newsletter-subscription"]["put"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/newsletter-subscription"]["put"]["responses"]["422"]["content"]["application/json"];
type SetMyNewsletterSubscriptionBody = paths["/v3/users/me/newsletter-subscription"]["put"]["requestBody"]["content"]["application/json"];
type UpdateMyLoginInformationSchema = {
    method: "put";
    url: "/v3/users/me/login-information";
    mediaType: [
        "application/json"
    ];
};
type UpdateMyLoginInformationParameters = paths["/v3/users/me/login-information"]["put"]["parameters"];
type UpdateMyLoginInformationData = paths["/v3/users/me/login-information"]["put"]["responses"]["200"]["content"]["application/json"];
type UpdateMyLoginInformationError = paths["/v3/users/me/login-information"]["put"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/login-information"]["put"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/login-information"]["put"]["responses"]["422"]["content"]["application/json"];
type UpdateMyLoginInformationBody = paths["/v3/users/me/login-information"]["put"]["requestBody"]["content"]["application/json"];
type VerifyMyEmailChangeSchema = {
    method: "post";
    url: "/v3/users/me/email-change/verify";
    mediaType: [
        "application/json"
    ];
};
type VerifyMyEmailChangeParameters = paths["/v3/users/me/email-change/verify"]["post"]["parameters"];
type VerifyMyEmailChangeData = paths["/v3/users/me/email-change/verify"]["post"]["responses"]["200"]["content"]["application/json"];
type VerifyMyEmailChangeError = paths["/v3/users/me/email-change/verify"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/users/me/email-change/verify"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/email-change/verify"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/email-change/verify"]["post"]["responses"]["422"]["content"]["application/json"];
type VerifyMyEmailChangeBody = paths["/v3/users/me/email-change/verify"]["post"]["requestBody"]["content"]["application/json"];
type CancelMyEmailChangeSchema = {
    method: "delete";
    url: "/v3/users/me/email-change";
};
type CancelMyEmailChangeParameters = paths["/v3/users/me/email-change"]["delete"]["parameters"];
type CancelMyEmailChangeData = paths["/v3/users/me/email-change"]["delete"]["responses"]["200"]["content"]["application/json"];
type CancelMyEmailChangeError = paths["/v3/users/me/email-change"]["delete"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/email-change"]["delete"]["responses"]["422"]["content"]["application/json"];
type CancelMyEmailChangeBody = undefined;
type GetMyStudyHelperAnnouncementSchema = {
    method: "get";
    url: "/v3/users/me/announcement";
};
type GetMyStudyHelperAnnouncementParameters = paths["/v3/users/me/announcement"]["get"]["parameters"];
type GetMyStudyHelperAnnouncementData = paths["/v3/users/me/announcement"]["get"]["responses"]["200"]["content"]["application/json"];
type GetMyStudyHelperAnnouncementError = null | paths["/v3/users/me/announcement"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/announcement"]["get"]["responses"]["422"]["content"]["application/json"];
type GetMemberProfileSchema = {
    method: "get";
    url: "/v3/users/members/{member_id}/profile";
};
type GetMemberProfileParameters = paths["/v3/users/members/{member_id}/profile"]["get"]["parameters"];
type GetMemberProfileData = paths["/v3/users/members/{member_id}/profile"]["get"]["responses"]["200"]["content"]["application/json"];
type GetMemberProfileError = null | null | paths["/v3/users/members/{member_id}/profile"]["get"]["responses"]["422"]["content"]["application/json"];
type UpdateMemberProfileSchema = {
    method: "put";
    url: "/v3/users/members/{member_id}/profile";
    mediaType: [
        "application/json"
    ];
};
type UpdateMemberProfileParameters = paths["/v3/users/members/{member_id}/profile"]["put"]["parameters"];
type UpdateMemberProfileData = paths["/v3/users/members/{member_id}/profile"]["put"]["responses"]["200"]["content"]["application/json"];
type UpdateMemberProfileError = null | null | null | null | paths["/v3/users/members/{member_id}/profile"]["put"]["responses"]["422"]["content"]["application/json"];
type UpdateMemberProfileBody = paths["/v3/users/members/{member_id}/profile"]["put"]["requestBody"]["content"]["application/json"];
type GetMemberProfileFormSchema = {
    method: "get";
    url: "/v3/users/members/{member_id}/profile/form";
};
type GetMemberProfileFormParameters = paths["/v3/users/members/{member_id}/profile/form"]["get"]["parameters"];
type GetMemberProfileFormData = paths["/v3/users/members/{member_id}/profile/form"]["get"]["responses"]["200"]["content"]["application/json"];
type GetMemberProfileFormError = null | null | null | paths["/v3/users/members/{member_id}/profile/form"]["get"]["responses"]["422"]["content"]["application/json"];
type UploadMemberAvatarSchema = {
    method: "post";
    url: "/v3/users/members/{member_id}/avatar";
    mediaType: [
        "multipart/form-data"
    ];
};
type UploadMemberAvatarParameters = paths["/v3/users/members/{member_id}/avatar"]["post"]["parameters"];
type UploadMemberAvatarData = paths["/v3/users/members/{member_id}/avatar"]["post"]["responses"]["200"]["content"]["application/json"];
type UploadMemberAvatarError = null | null | null | null | null | paths["/v3/users/members/{member_id}/avatar"]["post"]["responses"]["422"]["content"]["application/json"];
type UploadMemberAvatarBody = NonNullable<paths["/v3/users/members/{member_id}/avatar"]["post"]["requestBody"]>["content"]["multipart/form-data"] | FormData;
type DeleteMemberAvatarSchema = {
    method: "delete";
    url: "/v3/users/members/{member_id}/avatar";
};
type DeleteMemberAvatarParameters = paths["/v3/users/members/{member_id}/avatar"]["delete"]["parameters"];
type DeleteMemberAvatarData = paths["/v3/users/members/{member_id}/avatar"]["delete"]["responses"]["200"]["content"]["application/json"];
type DeleteMemberAvatarError = null | null | null | paths["/v3/users/members/{member_id}/avatar"]["delete"]["responses"]["422"]["content"]["application/json"];
type DeleteMemberAvatarBody = undefined;
type ListOnboardingSequencesSchema = {
    method: "get";
    url: "/v3/onboarding/admin/sequences";
};
type ListOnboardingSequencesParameters = paths["/v3/onboarding/admin/sequences"]["get"]["parameters"];
type ListOnboardingSequencesData = paths["/v3/onboarding/admin/sequences"]["get"]["responses"]["200"]["content"]["application/json"];
type ListOnboardingSequencesError = null | paths["/v3/onboarding/admin/sequences"]["get"]["responses"]["422"]["content"]["application/json"];
type GetOnboardingSequenceSchema = {
    method: "get";
    url: "/v3/onboarding/admin/sequences/{onboarding_id}";
};
type GetOnboardingSequenceParameters = paths["/v3/onboarding/admin/sequences/{onboarding_id}"]["get"]["parameters"];
type GetOnboardingSequenceData = paths["/v3/onboarding/admin/sequences/{onboarding_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetOnboardingSequenceError = null | null | paths["/v3/onboarding/admin/sequences/{onboarding_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type GetOnboardingSlideSchema = {
    method: "get";
    url: "/v3/onboarding/admin/sequences/{onboarding_id}/slides/{slide_index}";
};
type GetOnboardingSlideParameters = paths["/v3/onboarding/admin/sequences/{onboarding_id}/slides/{slide_index}"]["get"]["parameters"];
type GetOnboardingSlideData = paths["/v3/onboarding/admin/sequences/{onboarding_id}/slides/{slide_index}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetOnboardingSlideError = null | null | paths["/v3/onboarding/admin/sequences/{onboarding_id}/slides/{slide_index}"]["get"]["responses"]["422"]["content"]["application/json"];
type OnboardingStatusSchema = {
    method: "get";
    url: "/v3/onboarding/status";
};
type OnboardingStatusParameters = paths["/v3/onboarding/status"]["get"]["parameters"];
type OnboardingStatusData = paths["/v3/onboarding/status"]["get"]["responses"]["200"]["content"]["application/json"];
type OnboardingStatusError = paths["/v3/onboarding/status"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/onboarding/status"]["get"]["responses"]["422"]["content"]["application/json"];
type OnboardingDetailSchema = {
    method: "get";
    url: "/v3/onboarding/{id}/detail";
};
type OnboardingDetailParameters = paths["/v3/onboarding/{id}/detail"]["get"]["parameters"];
type OnboardingDetailData = paths["/v3/onboarding/{id}/detail"]["get"]["responses"]["200"]["content"]["application/json"];
type OnboardingDetailError = paths["/v3/onboarding/{id}/detail"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/onboarding/{id}/detail"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/onboarding/{id}/detail"]["get"]["responses"]["422"]["content"]["application/json"] | paths["/v3/onboarding/{id}/detail"]["get"]["responses"]["500"]["content"]["application/json"];
type SubmitOnboardingSchema = {
    method: "post";
    url: "/v3/onboarding/submit";
    mediaType: [
        "application/json"
    ];
};
type SubmitOnboardingParameters = paths["/v3/onboarding/submit"]["post"]["parameters"];
type SubmitOnboardingData = paths["/v3/onboarding/submit"]["post"]["responses"]["200"]["content"]["application/json"];
type SubmitOnboardingError = paths["/v3/onboarding/submit"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/onboarding/submit"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/onboarding/submit"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/onboarding/submit"]["post"]["responses"]["422"]["content"]["application/json"];
type SubmitOnboardingBody = paths["/v3/onboarding/submit"]["post"]["requestBody"]["content"]["application/json"];
type ListHelperApplicationsSchema = {
    method: "get";
    url: "/v3/helper-applications";
};
type ListHelperApplicationsParameters = paths["/v3/helper-applications"]["get"]["parameters"];
type ListHelperApplicationsData = paths["/v3/helper-applications"]["get"]["responses"]["200"]["content"]["application/json"];
type ListHelperApplicationsError = paths["/v3/helper-applications"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/helper-applications"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/helper-applications"]["get"]["responses"]["422"]["content"]["application/json"];
type GetHelperApplicationSchema = {
    method: "get";
    url: "/v3/helper-applications/{application_id}";
};
type GetHelperApplicationParameters = paths["/v3/helper-applications/{application_id}"]["get"]["parameters"];
type GetHelperApplicationData = paths["/v3/helper-applications/{application_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetHelperApplicationError = paths["/v3/helper-applications/{application_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type SubmitHelperApplicationSchema = {
    method: "post";
    url: "/v3/helper-applications/submit";
    mediaType: [
        "application/json"
    ];
};
type SubmitHelperApplicationParameters = paths["/v3/helper-applications/submit"]["post"]["parameters"];
type SubmitHelperApplicationData = paths["/v3/helper-applications/submit"]["post"]["responses"]["200"]["content"]["application/json"];
type SubmitHelperApplicationError = paths["/v3/helper-applications/submit"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/helper-applications/submit"]["post"]["responses"]["422"]["content"]["application/json"];
type SubmitHelperApplicationBody = paths["/v3/helper-applications/submit"]["post"]["requestBody"]["content"]["application/json"];
type SubmitFollowUpCoordinatorApplicationSchema = {
    method: "post";
    url: "/v3/helper-applications/follow-up-coordinator/submit";
    mediaType: [
        "application/json"
    ];
};
type SubmitFollowUpCoordinatorApplicationParameters = paths["/v3/helper-applications/follow-up-coordinator/submit"]["post"]["parameters"];
type SubmitFollowUpCoordinatorApplicationData = paths["/v3/helper-applications/follow-up-coordinator/submit"]["post"]["responses"]["200"]["content"]["application/json"];
type SubmitFollowUpCoordinatorApplicationError = paths["/v3/helper-applications/follow-up-coordinator/submit"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/helper-applications/follow-up-coordinator/submit"]["post"]["responses"]["422"]["content"]["application/json"];
type SubmitFollowUpCoordinatorApplicationBody = paths["/v3/helper-applications/follow-up-coordinator/submit"]["post"]["requestBody"]["content"]["application/json"];
type SubmitFollowUpPartnerApplicationSchema = {
    method: "post";
    url: "/v3/helper-applications/follow-up-partner/submit";
    mediaType: [
        "application/json"
    ];
};
type SubmitFollowUpPartnerApplicationParameters = paths["/v3/helper-applications/follow-up-partner/submit"]["post"]["parameters"];
type SubmitFollowUpPartnerApplicationData = paths["/v3/helper-applications/follow-up-partner/submit"]["post"]["responses"]["200"]["content"]["application/json"];
type SubmitFollowUpPartnerApplicationError = paths["/v3/helper-applications/follow-up-partner/submit"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/helper-applications/follow-up-partner/submit"]["post"]["responses"]["422"]["content"]["application/json"];
type SubmitFollowUpPartnerApplicationBody = paths["/v3/helper-applications/follow-up-partner/submit"]["post"]["requestBody"]["content"]["application/json"];
type RejectHelperApplicationSchema = {
    method: "post";
    url: "/v3/helper-applications/{application_id}/reject";
    mediaType: [
        "application/json"
    ];
};
type RejectHelperApplicationParameters = paths["/v3/helper-applications/{application_id}/reject"]["post"]["parameters"];
type RejectHelperApplicationData = paths["/v3/helper-applications/{application_id}/reject"]["post"]["responses"]["200"]["content"]["application/json"];
type RejectHelperApplicationError = paths["/v3/helper-applications/{application_id}/reject"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/reject"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/reject"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/reject"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/reject"]["post"]["responses"]["422"]["content"]["application/json"];
type RejectHelperApplicationBody = paths["/v3/helper-applications/{application_id}/reject"]["post"]["requestBody"]["content"]["application/json"];
type ApproveHelperApplicationSchema = {
    method: "post";
    url: "/v3/helper-applications/{application_id}/approve";
};
type ApproveHelperApplicationParameters = paths["/v3/helper-applications/{application_id}/approve"]["post"]["parameters"];
type ApproveHelperApplicationData = paths["/v3/helper-applications/{application_id}/approve"]["post"]["responses"]["200"]["content"]["application/json"];
type ApproveHelperApplicationError = paths["/v3/helper-applications/{application_id}/approve"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/approve"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/approve"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/approve"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/approve"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/helper-applications/{application_id}/approve"]["post"]["responses"]["422"]["content"]["application/json"];
type ApproveHelperApplicationBody = undefined;
type GetCampaignsSchema = {
    method: "get";
    url: "/v3/groups/campaigns";
};
type GetCampaignsParameters = paths["/v3/groups/campaigns"]["get"]["parameters"];
type GetCampaignsData = paths["/v3/groups/campaigns"]["get"]["responses"]["200"]["content"]["application/json"];
type GetCampaignsError = paths["/v3/groups/campaigns"]["get"]["responses"]["400"]["content"]["application/json"] | paths["/v3/groups/campaigns"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/campaigns"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateCampaignSessionSchema = {
    method: "get";
    url: "/v3/groups/session";
};
type CreateCampaignSessionParameters = paths["/v3/groups/session"]["get"]["parameters"];
type CreateCampaignSessionData = paths["/v3/groups/session"]["get"]["responses"]["200"]["content"]["application/json"];
type CreateCampaignSessionError = paths["/v3/groups/session"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/session"]["get"]["responses"]["422"]["content"]["application/json"];
type GetGroupsSchema = {
    method: "get";
    url: "/v3/groups";
};
type GetGroupsParameters = paths["/v3/groups"]["get"]["parameters"];
type GetGroupsData = paths["/v3/groups"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupsError = paths["/v3/groups"]["get"]["responses"]["400"]["content"]["application/json"] | paths["/v3/groups"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateGroupSchema = {
    method: "post";
    url: "/v3/groups";
    mediaType: [
        "application/json"
    ];
};
type CreateGroupParameters = paths["/v3/groups"]["post"]["parameters"];
type CreateGroupData = paths["/v3/groups"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateGroupError = paths["/v3/groups"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateGroupBody = paths["/v3/groups"]["post"]["requestBody"]["content"]["application/json"];
type ListMyGroupsSchema = {
    method: "get";
    url: "/v3/groups/mine";
};
type ListMyGroupsParameters = paths["/v3/groups/mine"]["get"]["parameters"];
type ListMyGroupsData = paths["/v3/groups/mine"]["get"]["responses"]["200"]["content"]["application/json"];
type ListMyGroupsError = paths["/v3/groups/mine"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/mine"]["get"]["responses"]["422"]["content"]["application/json"];
type GetGroupSchema = {
    method: "get";
    url: "/v3/groups/{group_id}";
};
type GetGroupParameters = paths["/v3/groups/{group_id}"]["get"]["parameters"];
type GetGroupData = paths["/v3/groups/{group_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupError = paths["/v3/groups/{group_id}"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/groups/{group_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type GetGroupBySlugSchema = {
    method: "get";
    url: "/v3/groups/by-slug/{group_slug}";
};
type GetGroupBySlugParameters = paths["/v3/groups/by-slug/{group_slug}"]["get"]["parameters"];
type GetGroupBySlugData = paths["/v3/groups/by-slug/{group_slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupBySlugError = paths["/v3/groups/by-slug/{group_slug}"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/groups/by-slug/{group_slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/by-slug/{group_slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type GetGroupStudentsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/students";
};
type GetGroupStudentsParameters = paths["/v3/groups/{group_id}/students"]["get"]["parameters"];
type GetGroupStudentsData = paths["/v3/groups/{group_id}/students"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupStudentsError = paths["/v3/groups/{group_id}/students"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/students"]["get"]["responses"]["422"]["content"]["application/json"];
type CreatePostalStudentSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/students";
    mediaType: [
        "application/json"
    ];
};
type CreatePostalStudentParameters = paths["/v3/groups/{group_id}/students"]["post"]["parameters"];
type CreatePostalStudentData = paths["/v3/groups/{group_id}/students"]["post"]["responses"]["200"]["content"]["application/json"];
type CreatePostalStudentError = paths["/v3/groups/{group_id}/students"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students"]["post"]["responses"]["422"]["content"]["application/json"];
type CreatePostalStudentBody = paths["/v3/groups/{group_id}/students"]["post"]["requestBody"]["content"]["application/json"];
type PreviewGroupStudentsReassignSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/students/reassign-preview";
    mediaType: [
        "application/json"
    ];
};
type PreviewGroupStudentsReassignParameters = paths["/v3/groups/{group_id}/students/reassign-preview"]["post"]["parameters"];
type PreviewGroupStudentsReassignData = paths["/v3/groups/{group_id}/students/reassign-preview"]["post"]["responses"]["200"]["content"]["application/json"];
type PreviewGroupStudentsReassignError = paths["/v3/groups/{group_id}/students/reassign-preview"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students/reassign-preview"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students/reassign-preview"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students/reassign-preview"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students/reassign-preview"]["post"]["responses"]["422"]["content"]["application/json"];
type PreviewGroupStudentsReassignBody = paths["/v3/groups/{group_id}/students/reassign-preview"]["post"]["requestBody"]["content"]["application/json"];
type ReassignGroupStudentsSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/students/reassign";
    mediaType: [
        "application/json"
    ];
};
type ReassignGroupStudentsParameters = paths["/v3/groups/{group_id}/students/reassign"]["post"]["parameters"];
type ReassignGroupStudentsData = paths["/v3/groups/{group_id}/students/reassign"]["post"]["responses"]["200"]["content"]["application/json"];
type ReassignGroupStudentsError = paths["/v3/groups/{group_id}/students/reassign"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students/reassign"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students/reassign"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students/reassign"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/students/reassign"]["post"]["responses"]["422"]["content"]["application/json"];
type ReassignGroupStudentsBody = paths["/v3/groups/{group_id}/students/reassign"]["post"]["requestBody"]["content"]["application/json"];
type GetGroupStudyHelpersSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/study-helpers";
};
type GetGroupStudyHelpersParameters = paths["/v3/groups/{group_id}/study-helpers"]["get"]["parameters"];
type GetGroupStudyHelpersData = paths["/v3/groups/{group_id}/study-helpers"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupStudyHelpersError = paths["/v3/groups/{group_id}/study-helpers"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers"]["get"]["responses"]["422"]["content"]["application/json"];
type AddGroupStudyHelperSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/study-helpers";
    mediaType: [
        "application/json"
    ];
};
type AddGroupStudyHelperParameters = paths["/v3/groups/{group_id}/study-helpers"]["post"]["parameters"];
type AddGroupStudyHelperData = paths["/v3/groups/{group_id}/study-helpers"]["post"]["responses"]["200"]["content"]["application/json"];
type AddGroupStudyHelperError = paths["/v3/groups/{group_id}/study-helpers"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers"]["post"]["responses"]["422"]["content"]["application/json"];
type AddGroupStudyHelperBody = paths["/v3/groups/{group_id}/study-helpers"]["post"]["requestBody"]["content"]["application/json"];
type RemoveGroupStudyHelperSchema = {
    method: "delete";
    url: "/v3/groups/{group_id}/study-helpers/{study_helper_id}";
};
type RemoveGroupStudyHelperParameters = paths["/v3/groups/{group_id}/study-helpers/{study_helper_id}"]["delete"]["parameters"];
type RemoveGroupStudyHelperData = null;
type RemoveGroupStudyHelperError = paths["/v3/groups/{group_id}/study-helpers/{study_helper_id}"]["delete"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers/{study_helper_id}"]["delete"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers/{study_helper_id}"]["delete"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/study-helpers/{study_helper_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type RemoveGroupStudyHelperBody = undefined;
type UploadGroupAvatarSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/avatar";
    mediaType: [
        "multipart/form-data"
    ];
};
type UploadGroupAvatarParameters = paths["/v3/groups/{group_id}/avatar"]["post"]["parameters"];
type UploadGroupAvatarData = paths["/v3/groups/{group_id}/avatar"]["post"]["responses"]["200"]["content"]["application/json"];
type UploadGroupAvatarError = null | paths["/v3/groups/{group_id}/avatar"]["post"]["responses"]["401"]["content"]["application/json"] | null | null | null | paths["/v3/groups/{group_id}/avatar"]["post"]["responses"]["422"]["content"]["application/json"];
type UploadGroupAvatarBody = NonNullable<paths["/v3/groups/{group_id}/avatar"]["post"]["requestBody"]>["content"]["multipart/form-data"] | FormData;
type DeleteGroupAvatarSchema = {
    method: "delete";
    url: "/v3/groups/{group_id}/avatar";
};
type DeleteGroupAvatarParameters = paths["/v3/groups/{group_id}/avatar"]["delete"]["parameters"];
type DeleteGroupAvatarData = paths["/v3/groups/{group_id}/avatar"]["delete"]["responses"]["200"]["content"]["application/json"];
type DeleteGroupAvatarError = paths["/v3/groups/{group_id}/avatar"]["delete"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/avatar"]["delete"]["responses"]["422"]["content"]["application/json"];
type DeleteGroupAvatarBody = undefined;
type CreateGeoTargetSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/geo-targets";
    mediaType: [
        "application/json"
    ];
};
type CreateGeoTargetParameters = paths["/v3/groups/{group_id}/geo-targets"]["post"]["parameters"];
type CreateGeoTargetData = paths["/v3/groups/{group_id}/geo-targets"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateGeoTargetError = paths["/v3/groups/{group_id}/geo-targets"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateGeoTargetBody = paths["/v3/groups/{group_id}/geo-targets"]["post"]["requestBody"]["content"]["application/json"];
type ListGroupGeoTargetsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/geo-targets";
};
type ListGroupGeoTargetsParameters = paths["/v3/groups/{group_id}/geo-targets"]["get"]["parameters"];
type ListGroupGeoTargetsData = paths["/v3/groups/{group_id}/geo-targets"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupGeoTargetsError = paths["/v3/groups/{group_id}/geo-targets"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets"]["get"]["responses"]["422"]["content"]["application/json"];
type UpdateGeoTargetSchema = {
    method: "patch";
    url: "/v3/groups/{group_id}/geo-targets/{target_id}";
    mediaType: [
        "application/json"
    ];
};
type UpdateGeoTargetParameters = paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["patch"]["parameters"];
type UpdateGeoTargetData = paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["patch"]["responses"]["200"]["content"]["application/json"];
type UpdateGeoTargetError = paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["patch"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["patch"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["patch"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["patch"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["patch"]["responses"]["422"]["content"]["application/json"];
type UpdateGeoTargetBody = paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["patch"]["requestBody"]["content"]["application/json"];
type DeleteGeoTargetSchema = {
    method: "delete";
    url: "/v3/groups/{group_id}/geo-targets/{target_id}";
};
type DeleteGeoTargetParameters = paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["delete"]["parameters"];
type DeleteGeoTargetData = null;
type DeleteGeoTargetError = paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["delete"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["delete"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["delete"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/geo-targets/{target_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type DeleteGeoTargetBody = undefined;
type GetGroupPendingTasksSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/pending-tasks";
};
type GetGroupPendingTasksParameters = paths["/v3/groups/{group_id}/pending-tasks"]["get"]["parameters"];
type GetGroupPendingTasksData = paths["/v3/groups/{group_id}/pending-tasks"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupPendingTasksError = paths["/v3/groups/{group_id}/pending-tasks"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/pending-tasks"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/pending-tasks"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/pending-tasks"]["get"]["responses"]["422"]["content"]["application/json"];
type ListGroupMemberTagsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/member-tags";
};
type ListGroupMemberTagsParameters = paths["/v3/groups/{group_id}/member-tags"]["get"]["parameters"];
type ListGroupMemberTagsData = paths["/v3/groups/{group_id}/member-tags"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupMemberTagsError = paths["/v3/groups/{group_id}/member-tags"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/member-tags"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateGroupMemberTagSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/member-tags";
    mediaType: [
        "application/json"
    ];
};
type CreateGroupMemberTagParameters = paths["/v3/groups/{group_id}/member-tags"]["post"]["parameters"];
type CreateGroupMemberTagData = paths["/v3/groups/{group_id}/member-tags"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateGroupMemberTagError = paths["/v3/groups/{group_id}/member-tags"]["post"]["responses"]["401"]["content"]["application/json"] | null | null | null | paths["/v3/groups/{group_id}/member-tags"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateGroupMemberTagBody = paths["/v3/groups/{group_id}/member-tags"]["post"]["requestBody"]["content"]["application/json"];
type GetGroupMemberTagSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/member-tags/{tag_id}";
};
type GetGroupMemberTagParameters = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["get"]["parameters"];
type GetGroupMemberTagData = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupMemberTagError = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type UpdateGroupMemberTagSchema = {
    method: "put";
    url: "/v3/groups/{group_id}/member-tags/{tag_id}";
    mediaType: [
        "application/json"
    ];
};
type UpdateGroupMemberTagParameters = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["put"]["parameters"];
type UpdateGroupMemberTagData = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["put"]["responses"]["200"]["content"]["application/json"];
type UpdateGroupMemberTagError = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["put"]["responses"]["401"]["content"]["application/json"] | null | null | null | paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["put"]["responses"]["422"]["content"]["application/json"];
type UpdateGroupMemberTagBody = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["put"]["requestBody"]["content"]["application/json"];
type DeleteGroupMemberTagSchema = {
    method: "delete";
    url: "/v3/groups/{group_id}/member-tags/{tag_id}";
};
type DeleteGroupMemberTagParameters = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["delete"]["parameters"];
type DeleteGroupMemberTagData = null;
type DeleteGroupMemberTagError = paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["delete"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/member-tags/{tag_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type DeleteGroupMemberTagBody = undefined;
type SetStudentMemberTagsSchema = {
    method: "put";
    url: "/v3/groups/{group_id}/students/{student_id}/tags";
    mediaType: [
        "application/json"
    ];
};
type SetStudentMemberTagsParameters = paths["/v3/groups/{group_id}/students/{student_id}/tags"]["put"]["parameters"];
type SetStudentMemberTagsData = paths["/v3/groups/{group_id}/students/{student_id}/tags"]["put"]["responses"]["200"]["content"]["application/json"];
type SetStudentMemberTagsError = null | paths["/v3/groups/{group_id}/students/{student_id}/tags"]["put"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/students/{student_id}/tags"]["put"]["responses"]["422"]["content"]["application/json"];
type SetStudentMemberTagsBody = paths["/v3/groups/{group_id}/students/{student_id}/tags"]["put"]["requestBody"]["content"]["application/json"];
type ListGeoTargetMapSchema = {
    method: "get";
    url: "/v3/geo-targets/map";
};
type ListGeoTargetMapParameters = paths["/v3/geo-targets/map"]["get"]["parameters"];
type ListGeoTargetMapData = paths["/v3/geo-targets/map"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGeoTargetMapError = paths["/v3/geo-targets/map"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/geo-targets/map"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/geo-targets/map"]["get"]["responses"]["422"]["content"]["application/json"];
type ListGroupCampaignsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/campaigns";
};
type ListGroupCampaignsParameters = paths["/v3/groups/{group_id}/campaigns"]["get"]["parameters"];
type ListGroupCampaignsData = paths["/v3/groups/{group_id}/campaigns"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupCampaignsError = paths["/v3/groups/{group_id}/campaigns"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateGroupCampaignSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/campaigns";
    mediaType: [
        "application/json"
    ];
};
type CreateGroupCampaignParameters = paths["/v3/groups/{group_id}/campaigns"]["post"]["parameters"];
type CreateGroupCampaignData = paths["/v3/groups/{group_id}/campaigns"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateGroupCampaignError = paths["/v3/groups/{group_id}/campaigns"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateGroupCampaignBody = paths["/v3/groups/{group_id}/campaigns"]["post"]["requestBody"]["content"]["application/json"];
type GetPersonalCampaignSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/campaigns/personal";
};
type GetPersonalCampaignParameters = paths["/v3/groups/{group_id}/campaigns/personal"]["get"]["parameters"];
type GetPersonalCampaignData = paths["/v3/groups/{group_id}/campaigns/personal"]["get"]["responses"]["200"]["content"]["application/json"];
type GetPersonalCampaignError = paths["/v3/groups/{group_id}/campaigns/personal"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal"]["get"]["responses"]["422"]["content"]["application/json"];
type EnablePersonalCampaignSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/campaigns/personal";
};
type EnablePersonalCampaignParameters = paths["/v3/groups/{group_id}/campaigns/personal"]["post"]["parameters"];
type EnablePersonalCampaignData = paths["/v3/groups/{group_id}/campaigns/personal"]["post"]["responses"]["200"]["content"]["application/json"];
type EnablePersonalCampaignError = paths["/v3/groups/{group_id}/campaigns/personal"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal"]["post"]["responses"]["422"]["content"]["application/json"];
type EnablePersonalCampaignBody = undefined;
type ListPersonalCampaignStudentsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/campaigns/personal/students";
};
type ListPersonalCampaignStudentsParameters = paths["/v3/groups/{group_id}/campaigns/personal/students"]["get"]["parameters"];
type ListPersonalCampaignStudentsData = paths["/v3/groups/{group_id}/campaigns/personal/students"]["get"]["responses"]["200"]["content"]["application/json"];
type ListPersonalCampaignStudentsError = paths["/v3/groups/{group_id}/campaigns/personal/students"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal/students"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal/students"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/campaigns/personal/students"]["get"]["responses"]["422"]["content"]["application/json"];
type CheckCampaignSubdomainSchema = {
    method: "get";
    url: "/v3/campaigns/subdomain-available";
};
type CheckCampaignSubdomainParameters = paths["/v3/campaigns/subdomain-available"]["get"]["parameters"];
type CheckCampaignSubdomainData = paths["/v3/campaigns/subdomain-available"]["get"]["responses"]["200"]["content"]["application/json"];
type CheckCampaignSubdomainError = paths["/v3/campaigns/subdomain-available"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/campaigns/subdomain-available"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/campaigns/subdomain-available"]["get"]["responses"]["422"]["content"]["application/json"];
type ListSeriesSchema = {
    method: "get";
    url: "/v3/content/series";
};
type ListSeriesParameters = paths["/v3/content/series"]["get"]["parameters"];
type ListSeriesData = paths["/v3/content/series"]["get"]["responses"]["200"]["content"]["application/json"];
type ListSeriesError = paths["/v3/content/series"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/series"]["get"]["responses"]["422"]["content"]["application/json"];
type ListCoursesSchema = {
    method: "get";
    url: "/v3/content/courses";
};
type ListCoursesParameters = paths["/v3/content/courses"]["get"]["parameters"];
type ListCoursesData = paths["/v3/content/courses"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCoursesError = paths["/v3/content/courses"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/courses"]["get"]["responses"]["422"]["content"]["application/json"];
type ListSelfPacedCoursesSchema = {
    method: "get";
    url: "/v3/content/self-paced-courses";
};
type ListSelfPacedCoursesParameters = paths["/v3/content/self-paced-courses"]["get"]["parameters"];
type ListSelfPacedCoursesData = paths["/v3/content/self-paced-courses"]["get"]["responses"]["200"]["content"]["application/json"];
type ListSelfPacedCoursesError = paths["/v3/content/self-paced-courses"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/self-paced-courses"]["get"]["responses"]["422"]["content"]["application/json"];
type CourseBySlugSchema = {
    method: "get";
    url: "/v3/content/course/by-slug/{slug}";
};
type CourseBySlugParameters = paths["/v3/content/course/by-slug/{slug}"]["get"]["parameters"];
type CourseBySlugData = paths["/v3/content/course/by-slug/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type CourseBySlugError = paths["/v3/content/course/by-slug/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/course/by-slug/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/course/by-slug/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type LessonBySlugSchema = {
    method: "get";
    url: "/v3/content/lesson/by-slug/{slug}";
};
type LessonBySlugParameters = paths["/v3/content/lesson/by-slug/{slug}"]["get"]["parameters"];
type LessonBySlugData = paths["/v3/content/lesson/by-slug/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type LessonBySlugError = paths["/v3/content/lesson/by-slug/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/lesson/by-slug/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/lesson/by-slug/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type TopicBySlugSchema = {
    method: "get";
    url: "/v3/content/topic/by-slug/{slug}";
};
type TopicBySlugParameters = paths["/v3/content/topic/by-slug/{slug}"]["get"]["parameters"];
type TopicBySlugData = paths["/v3/content/topic/by-slug/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type TopicBySlugError = paths["/v3/content/topic/by-slug/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/topic/by-slug/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/topic/by-slug/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type QuizBySlugSchema = {
    method: "get";
    url: "/v3/content/quiz/by-slug/{slug}";
};
type QuizBySlugParameters = paths["/v3/content/quiz/by-slug/{slug}"]["get"]["parameters"];
type QuizBySlugData = paths["/v3/content/quiz/by-slug/{slug}"]["get"]["responses"]["200"]["content"]["application/json"];
type QuizBySlugError = paths["/v3/content/quiz/by-slug/{slug}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/quiz/by-slug/{slug}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/quiz/by-slug/{slug}"]["get"]["responses"]["422"]["content"]["application/json"];
type CourseDetailSchema = {
    method: "get";
    url: "/v3/content/course/{course_id}";
};
type CourseDetailParameters = paths["/v3/content/course/{course_id}"]["get"]["parameters"];
type CourseDetailData = paths["/v3/content/course/{course_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type CourseDetailError = paths["/v3/content/course/{course_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/course/{course_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/course/{course_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type CourseLessonsSchema = {
    method: "get";
    url: "/v3/content/course/{course_id}/lessons";
};
type CourseLessonsParameters = paths["/v3/content/course/{course_id}/lessons"]["get"]["parameters"];
type CourseLessonsData = paths["/v3/content/course/{course_id}/lessons"]["get"]["responses"]["200"]["content"]["application/json"];
type CourseLessonsError = paths["/v3/content/course/{course_id}/lessons"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/course/{course_id}/lessons"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/course/{course_id}/lessons"]["get"]["responses"]["422"]["content"]["application/json"];
type LessonDetailSchema = {
    method: "get";
    url: "/v3/content/lesson/{lesson_id}";
};
type LessonDetailParameters = paths["/v3/content/lesson/{lesson_id}"]["get"]["parameters"];
type LessonDetailData = paths["/v3/content/lesson/{lesson_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type LessonDetailError = paths["/v3/content/lesson/{lesson_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/lesson/{lesson_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/lesson/{lesson_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type LessonTopicsSchema = {
    method: "get";
    url: "/v3/content/lesson/{lesson_id}/topics";
};
type LessonTopicsParameters = paths["/v3/content/lesson/{lesson_id}/topics"]["get"]["parameters"];
type LessonTopicsData = paths["/v3/content/lesson/{lesson_id}/topics"]["get"]["responses"]["200"]["content"]["application/json"];
type LessonTopicsError = paths["/v3/content/lesson/{lesson_id}/topics"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/lesson/{lesson_id}/topics"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/lesson/{lesson_id}/topics"]["get"]["responses"]["422"]["content"]["application/json"];
type TopicDetailSchema = {
    method: "get";
    url: "/v3/content/topic/{topic_id}";
};
type TopicDetailParameters = paths["/v3/content/topic/{topic_id}"]["get"]["parameters"];
type TopicDetailData = paths["/v3/content/topic/{topic_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type TopicDetailError = paths["/v3/content/topic/{topic_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/topic/{topic_id}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/content/topic/{topic_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/topic/{topic_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type LessonQuestionsSchema = {
    method: "get";
    url: "/v3/content/lesson/{lesson_id}/questions";
};
type LessonQuestionsParameters = paths["/v3/content/lesson/{lesson_id}/questions"]["get"]["parameters"];
type LessonQuestionsData = paths["/v3/content/lesson/{lesson_id}/questions"]["get"]["responses"]["200"]["content"]["application/json"];
type LessonQuestionsError = paths["/v3/content/lesson/{lesson_id}/questions"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/lesson/{lesson_id}/questions"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/content/lesson/{lesson_id}/questions"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/content/lesson/{lesson_id}/questions"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminGetTopicSchema = {
    method: "get";
    url: "/v3/content/admin/topic/{topic_id}";
};
type AdminGetTopicParameters = paths["/v3/content/admin/topic/{topic_id}"]["get"]["parameters"];
type AdminGetTopicData = paths["/v3/content/admin/topic/{topic_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminGetTopicError = null | paths["/v3/content/admin/topic/{topic_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateTopicSchema = {
    method: "patch";
    url: "/v3/content/admin/topic/{topic_id}";
    mediaType: [
        "application/json"
    ];
};
type AdminUpdateTopicParameters = paths["/v3/content/admin/topic/{topic_id}"]["patch"]["parameters"];
type AdminUpdateTopicData = paths["/v3/content/admin/topic/{topic_id}"]["patch"]["responses"]["200"]["content"]["application/json"];
type AdminUpdateTopicError = paths["/v3/content/admin/topic/{topic_id}"]["patch"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/topic/{topic_id}"]["patch"]["responses"]["403"]["content"]["application/json"] | null | null | paths["/v3/content/admin/topic/{topic_id}"]["patch"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateTopicBody = paths["/v3/content/admin/topic/{topic_id}"]["patch"]["requestBody"]["content"]["application/json"];
type AdminDeleteTopicSchema = {
    method: "delete";
    url: "/v3/content/admin/topic/{topic_id}";
};
type AdminDeleteTopicParameters = paths["/v3/content/admin/topic/{topic_id}"]["delete"]["parameters"];
type AdminDeleteTopicData = null;
type AdminDeleteTopicError = null | null | paths["/v3/content/admin/topic/{topic_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type AdminDeleteTopicBody = undefined;
type AdminListTopicsSchema = {
    method: "get";
    url: "/v3/content/admin/lesson/{lesson_id}/topics";
};
type AdminListTopicsParameters = paths["/v3/content/admin/lesson/{lesson_id}/topics"]["get"]["parameters"];
type AdminListTopicsData = paths["/v3/content/admin/lesson/{lesson_id}/topics"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminListTopicsError = paths["/v3/content/admin/lesson/{lesson_id}/topics"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminCreateTopicSchema = {
    method: "post";
    url: "/v3/content/admin/lesson/{lesson_id}/topics";
    mediaType: [
        "application/json"
    ];
};
type AdminCreateTopicParameters = paths["/v3/content/admin/lesson/{lesson_id}/topics"]["post"]["parameters"];
type AdminCreateTopicData = paths["/v3/content/admin/lesson/{lesson_id}/topics"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminCreateTopicError = paths["/v3/content/admin/lesson/{lesson_id}/topics"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/lesson/{lesson_id}/topics"]["post"]["responses"]["403"]["content"]["application/json"] | null | null | paths["/v3/content/admin/lesson/{lesson_id}/topics"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminCreateTopicBody = paths["/v3/content/admin/lesson/{lesson_id}/topics"]["post"]["requestBody"]["content"]["application/json"];
type AdminListSeriesSchema = {
    method: "get";
    url: "/v3/content/admin/series";
};
type AdminListSeriesParameters = paths["/v3/content/admin/series"]["get"]["parameters"];
type AdminListSeriesData = paths["/v3/content/admin/series"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminListSeriesError = paths["/v3/content/admin/series"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminCreateSeriesSchema = {
    method: "post";
    url: "/v3/content/admin/series";
    mediaType: [
        "application/json"
    ];
};
type AdminCreateSeriesParameters = paths["/v3/content/admin/series"]["post"]["parameters"];
type AdminCreateSeriesData = paths["/v3/content/admin/series"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminCreateSeriesError = paths["/v3/content/admin/series"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminCreateSeriesBody = paths["/v3/content/admin/series"]["post"]["requestBody"]["content"]["application/json"];
type AdminGetSeriesSchema = {
    method: "get";
    url: "/v3/content/admin/series/{series_id}";
};
type AdminGetSeriesParameters = paths["/v3/content/admin/series/{series_id}"]["get"]["parameters"];
type AdminGetSeriesData = paths["/v3/content/admin/series/{series_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminGetSeriesError = null | paths["/v3/content/admin/series/{series_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateSeriesSchema = {
    method: "patch";
    url: "/v3/content/admin/series/{series_id}";
    mediaType: [
        "application/json"
    ];
};
type AdminUpdateSeriesParameters = paths["/v3/content/admin/series/{series_id}"]["patch"]["parameters"];
type AdminUpdateSeriesData = paths["/v3/content/admin/series/{series_id}"]["patch"]["responses"]["200"]["content"]["application/json"];
type AdminUpdateSeriesError = null | null | paths["/v3/content/admin/series/{series_id}"]["patch"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateSeriesBody = paths["/v3/content/admin/series/{series_id}"]["patch"]["requestBody"]["content"]["application/json"];
type AdminListQuestionsSchema = {
    method: "get";
    url: "/v3/content/admin/lesson/{lesson_id}/questions";
};
type AdminListQuestionsParameters = paths["/v3/content/admin/lesson/{lesson_id}/questions"]["get"]["parameters"];
type AdminListQuestionsData = paths["/v3/content/admin/lesson/{lesson_id}/questions"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminListQuestionsError = paths["/v3/content/admin/lesson/{lesson_id}/questions"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminCreateQuestionSchema = {
    method: "post";
    url: "/v3/content/admin/lesson/{lesson_id}/questions";
    mediaType: [
        "application/json"
    ];
};
type AdminCreateQuestionParameters = paths["/v3/content/admin/lesson/{lesson_id}/questions"]["post"]["parameters"];
type AdminCreateQuestionData = paths["/v3/content/admin/lesson/{lesson_id}/questions"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminCreateQuestionError = null | null | paths["/v3/content/admin/lesson/{lesson_id}/questions"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminCreateQuestionBody = paths["/v3/content/admin/lesson/{lesson_id}/questions"]["post"]["requestBody"]["content"]["application/json"];
type AdminGetQuestionSchema = {
    method: "get";
    url: "/v3/content/admin/question/{question_id}";
};
type AdminGetQuestionParameters = paths["/v3/content/admin/question/{question_id}"]["get"]["parameters"];
type AdminGetQuestionData = paths["/v3/content/admin/question/{question_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminGetQuestionError = null | paths["/v3/content/admin/question/{question_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateQuestionSchema = {
    method: "patch";
    url: "/v3/content/admin/question/{question_id}";
    mediaType: [
        "application/json"
    ];
};
type AdminUpdateQuestionParameters = paths["/v3/content/admin/question/{question_id}"]["patch"]["parameters"];
type AdminUpdateQuestionData = paths["/v3/content/admin/question/{question_id}"]["patch"]["responses"]["200"]["content"]["application/json"];
type AdminUpdateQuestionError = paths["/v3/content/admin/question/{question_id}"]["patch"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/question/{question_id}"]["patch"]["responses"]["403"]["content"]["application/json"] | null | null | paths["/v3/content/admin/question/{question_id}"]["patch"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateQuestionBody = paths["/v3/content/admin/question/{question_id}"]["patch"]["requestBody"]["content"]["application/json"];
type AdminDeleteQuestionSchema = {
    method: "delete";
    url: "/v3/content/admin/question/{question_id}";
};
type AdminDeleteQuestionParameters = paths["/v3/content/admin/question/{question_id}"]["delete"]["parameters"];
type AdminDeleteQuestionData = null;
type AdminDeleteQuestionError = null | null | paths["/v3/content/admin/question/{question_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type AdminDeleteQuestionBody = undefined;
type AdminBulkDeleteQuestionsSchema = {
    method: "post";
    url: "/v3/content/admin/lesson/{lesson_id}/questions/bulk-delete";
    mediaType: [
        "application/json"
    ];
};
type AdminBulkDeleteQuestionsParameters = paths["/v3/content/admin/lesson/{lesson_id}/questions/bulk-delete"]["post"]["parameters"];
type AdminBulkDeleteQuestionsData = null;
type AdminBulkDeleteQuestionsError = null | null | paths["/v3/content/admin/lesson/{lesson_id}/questions/bulk-delete"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminBulkDeleteQuestionsBody = paths["/v3/content/admin/lesson/{lesson_id}/questions/bulk-delete"]["post"]["requestBody"]["content"]["application/json"];
type AdminBulkPublishQuestionsSchema = {
    method: "post";
    url: "/v3/content/admin/lesson/{lesson_id}/questions/bulk-publish";
    mediaType: [
        "application/json"
    ];
};
type AdminBulkPublishQuestionsParameters = paths["/v3/content/admin/lesson/{lesson_id}/questions/bulk-publish"]["post"]["parameters"];
type AdminBulkPublishQuestionsData = null;
type AdminBulkPublishQuestionsError = null | null | paths["/v3/content/admin/lesson/{lesson_id}/questions/bulk-publish"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminBulkPublishQuestionsBody = paths["/v3/content/admin/lesson/{lesson_id}/questions/bulk-publish"]["post"]["requestBody"]["content"]["application/json"];
type AdminUploadMediaSchema = {
    method: "post";
    url: "/v3/content/admin/media";
    mediaType: [
        "multipart/form-data"
    ];
};
type AdminUploadMediaParameters = paths["/v3/content/admin/media"]["post"]["parameters"];
type AdminUploadMediaData = paths["/v3/content/admin/media"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminUploadMediaError = null;
type AdminUploadMediaBody = paths["/v3/content/admin/media"]["post"]["requestBody"]["content"]["multipart/form-data"] | FormData;
type AdminGetLessonSchema = {
    method: "get";
    url: "/v3/content/admin/lesson/{lesson_id}";
};
type AdminGetLessonParameters = paths["/v3/content/admin/lesson/{lesson_id}"]["get"]["parameters"];
type AdminGetLessonData = paths["/v3/content/admin/lesson/{lesson_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminGetLessonError = null | paths["/v3/content/admin/lesson/{lesson_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateLessonSchema = {
    method: "patch";
    url: "/v3/content/admin/lesson/{lesson_id}";
    mediaType: [
        "application/json"
    ];
};
type AdminUpdateLessonParameters = paths["/v3/content/admin/lesson/{lesson_id}"]["patch"]["parameters"];
type AdminUpdateLessonData = paths["/v3/content/admin/lesson/{lesson_id}"]["patch"]["responses"]["200"]["content"]["application/json"];
type AdminUpdateLessonError = paths["/v3/content/admin/lesson/{lesson_id}"]["patch"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/lesson/{lesson_id}"]["patch"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/content/admin/lesson/{lesson_id}"]["patch"]["responses"]["409"]["content"]["application/json"] | paths["/v3/content/admin/lesson/{lesson_id}"]["patch"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateLessonBody = paths["/v3/content/admin/lesson/{lesson_id}"]["patch"]["requestBody"]["content"]["application/json"];
type AdminDeleteLessonSchema = {
    method: "delete";
    url: "/v3/content/admin/lesson/{lesson_id}";
};
type AdminDeleteLessonParameters = paths["/v3/content/admin/lesson/{lesson_id}"]["delete"]["parameters"];
type AdminDeleteLessonData = null;
type AdminDeleteLessonError = null | null | paths["/v3/content/admin/lesson/{lesson_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type AdminDeleteLessonBody = undefined;
type AdminListLessonsSchema = {
    method: "get";
    url: "/v3/content/admin/course/{course_id}/lessons";
};
type AdminListLessonsParameters = paths["/v3/content/admin/course/{course_id}/lessons"]["get"]["parameters"];
type AdminListLessonsData = paths["/v3/content/admin/course/{course_id}/lessons"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminListLessonsError = null | paths["/v3/content/admin/course/{course_id}/lessons"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminCreateLessonSchema = {
    method: "post";
    url: "/v3/content/admin/course/{course_id}/lessons";
    mediaType: [
        "application/json"
    ];
};
type AdminCreateLessonParameters = paths["/v3/content/admin/course/{course_id}/lessons"]["post"]["parameters"];
type AdminCreateLessonData = paths["/v3/content/admin/course/{course_id}/lessons"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminCreateLessonError = paths["/v3/content/admin/course/{course_id}/lessons"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}/lessons"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/content/admin/course/{course_id}/lessons"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}/lessons"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminCreateLessonBody = paths["/v3/content/admin/course/{course_id}/lessons"]["post"]["requestBody"]["content"]["application/json"];
type AdminGetCourseOutlineSchema = {
    method: "get";
    url: "/v3/content/admin/course/{course_id}/outline";
};
type AdminGetCourseOutlineParameters = paths["/v3/content/admin/course/{course_id}/outline"]["get"]["parameters"];
type AdminGetCourseOutlineData = paths["/v3/content/admin/course/{course_id}/outline"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminGetCourseOutlineError = null | paths["/v3/content/admin/course/{course_id}/outline"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminSearchLessonsSchema = {
    method: "get";
    url: "/v3/content/admin/lessons";
};
type AdminSearchLessonsParameters = paths["/v3/content/admin/lessons"]["get"]["parameters"];
type AdminSearchLessonsData = paths["/v3/content/admin/lessons"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminSearchLessonsError = paths["/v3/content/admin/lessons"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminSearchTopicsSchema = {
    method: "get";
    url: "/v3/content/admin/topics";
};
type AdminSearchTopicsParameters = paths["/v3/content/admin/topics"]["get"]["parameters"];
type AdminSearchTopicsData = paths["/v3/content/admin/topics"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminSearchTopicsError = paths["/v3/content/admin/topics"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminSearchQuestionsSchema = {
    method: "get";
    url: "/v3/content/admin/questions";
};
type AdminSearchQuestionsParameters = paths["/v3/content/admin/questions"]["get"]["parameters"];
type AdminSearchQuestionsData = paths["/v3/content/admin/questions"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminSearchQuestionsError = paths["/v3/content/admin/questions"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminListCoursesSchema = {
    method: "get";
    url: "/v3/content/admin/courses";
};
type AdminListCoursesParameters = paths["/v3/content/admin/courses"]["get"]["parameters"];
type AdminListCoursesData = paths["/v3/content/admin/courses"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminListCoursesError = paths["/v3/content/admin/courses"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminCreateCourseSchema = {
    method: "post";
    url: "/v3/content/admin/series/{series_id}/courses";
    mediaType: [
        "application/json"
    ];
};
type AdminCreateCourseParameters = paths["/v3/content/admin/series/{series_id}/courses"]["post"]["parameters"];
type AdminCreateCourseData = paths["/v3/content/admin/series/{series_id}/courses"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminCreateCourseError = null | paths["/v3/content/admin/series/{series_id}/courses"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminCreateCourseBody = paths["/v3/content/admin/series/{series_id}/courses"]["post"]["requestBody"]["content"]["application/json"];
type AdminGetCourseSchema = {
    method: "get";
    url: "/v3/content/admin/course/{course_id}";
};
type AdminGetCourseParameters = paths["/v3/content/admin/course/{course_id}"]["get"]["parameters"];
type AdminGetCourseData = paths["/v3/content/admin/course/{course_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminGetCourseError = null | paths["/v3/content/admin/course/{course_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateCourseSchema = {
    method: "patch";
    url: "/v3/content/admin/course/{course_id}";
    mediaType: [
        "application/json"
    ];
};
type AdminUpdateCourseParameters = paths["/v3/content/admin/course/{course_id}"]["patch"]["parameters"];
type AdminUpdateCourseData = paths["/v3/content/admin/course/{course_id}"]["patch"]["responses"]["200"]["content"]["application/json"];
type AdminUpdateCourseError = paths["/v3/content/admin/course/{course_id}"]["patch"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}"]["patch"]["responses"]["403"]["content"]["application/json"] | null | null | paths["/v3/content/admin/course/{course_id}"]["patch"]["responses"]["422"]["content"]["application/json"];
type AdminUpdateCourseBody = paths["/v3/content/admin/course/{course_id}"]["patch"]["requestBody"]["content"]["application/json"];
type AdminListCourseVersionsSchema = {
    method: "get";
    url: "/v3/content/admin/course/{course_id}/versions";
};
type AdminListCourseVersionsParameters = paths["/v3/content/admin/course/{course_id}/versions"]["get"]["parameters"];
type AdminListCourseVersionsData = paths["/v3/content/admin/course/{course_id}/versions"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminListCourseVersionsError = null | paths["/v3/content/admin/course/{course_id}/versions"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminStartCourseVersionSchema = {
    method: "post";
    url: "/v3/content/admin/course/{course_id}/versions";
    mediaType: [
        "application/json"
    ];
};
type AdminStartCourseVersionParameters = paths["/v3/content/admin/course/{course_id}/versions"]["post"]["parameters"];
type AdminStartCourseVersionData = paths["/v3/content/admin/course/{course_id}/versions"]["post"]["responses"]["201"]["content"]["application/json"];
type AdminStartCourseVersionError = paths["/v3/content/admin/course/{course_id}/versions"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}/versions"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/content/admin/course/{course_id}/versions"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}/versions"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminStartCourseVersionBody = paths["/v3/content/admin/course/{course_id}/versions"]["post"]["requestBody"]["content"]["application/json"];
type AdminDiscardCourseVersionSchema = {
    method: "delete";
    url: "/v3/content/admin/course/{course_id}/versions/{version}";
};
type AdminDiscardCourseVersionParameters = paths["/v3/content/admin/course/{course_id}/versions/{version}"]["delete"]["parameters"];
type AdminDiscardCourseVersionData = null;
type AdminDiscardCourseVersionError = null | null | paths["/v3/content/admin/course/{course_id}/versions/{version}"]["delete"]["responses"]["422"]["content"]["application/json"];
type AdminDiscardCourseVersionBody = undefined;
type AdminFindInCourseVersionSchema = {
    method: "get";
    url: "/v3/content/admin/course/{course_id}/versions/{version}/find";
};
type AdminFindInCourseVersionParameters = paths["/v3/content/admin/course/{course_id}/versions/{version}/find"]["get"]["parameters"];
type AdminFindInCourseVersionData = paths["/v3/content/admin/course/{course_id}/versions/{version}/find"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminFindInCourseVersionError = null | paths["/v3/content/admin/course/{course_id}/versions/{version}/find"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminCourseVersionChangesSchema = {
    method: "get";
    url: "/v3/content/admin/course/{course_id}/versions/{version}/changes";
};
type AdminCourseVersionChangesParameters = paths["/v3/content/admin/course/{course_id}/versions/{version}/changes"]["get"]["parameters"];
type AdminCourseVersionChangesData = paths["/v3/content/admin/course/{course_id}/versions/{version}/changes"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminCourseVersionChangesError = null | paths["/v3/content/admin/course/{course_id}/versions/{version}/changes"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminRevertCourseVersionChangeSchema = {
    method: "post";
    url: "/v3/content/admin/course/{course_id}/versions/{version}/changes/revert";
    mediaType: [
        "application/json"
    ];
};
type AdminRevertCourseVersionChangeParameters = paths["/v3/content/admin/course/{course_id}/versions/{version}/changes/revert"]["post"]["parameters"];
type AdminRevertCourseVersionChangeData = paths["/v3/content/admin/course/{course_id}/versions/{version}/changes/revert"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminRevertCourseVersionChangeError = paths["/v3/content/admin/course/{course_id}/versions/{version}/changes/revert"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}/versions/{version}/changes/revert"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/content/admin/course/{course_id}/versions/{version}/changes/revert"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminRevertCourseVersionChangeBody = paths["/v3/content/admin/course/{course_id}/versions/{version}/changes/revert"]["post"]["requestBody"]["content"]["application/json"];
type AdminCourseVersionPublishCheckSchema = {
    method: "get";
    url: "/v3/content/admin/course/{course_id}/versions/{version}/publish-check";
};
type AdminCourseVersionPublishCheckParameters = paths["/v3/content/admin/course/{course_id}/versions/{version}/publish-check"]["get"]["parameters"];
type AdminCourseVersionPublishCheckData = paths["/v3/content/admin/course/{course_id}/versions/{version}/publish-check"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminCourseVersionPublishCheckError = null | paths["/v3/content/admin/course/{course_id}/versions/{version}/publish-check"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminPublishCourseVersionSchema = {
    method: "post";
    url: "/v3/content/admin/course/{course_id}/versions/{version}/publish";
};
type AdminPublishCourseVersionParameters = paths["/v3/content/admin/course/{course_id}/versions/{version}/publish"]["post"]["parameters"];
type AdminPublishCourseVersionData = paths["/v3/content/admin/course/{course_id}/versions/{version}/publish"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminPublishCourseVersionError = paths["/v3/content/admin/course/{course_id}/versions/{version}/publish"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}/versions/{version}/publish"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/content/admin/course/{course_id}/versions/{version}/publish"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}/versions/{version}/publish"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminPublishCourseVersionBody = undefined;
type AdminPreviewCourseVersionSchema = {
    method: "post";
    url: "/v3/content/admin/course/{course_id}/versions/{version}/preview";
};
type AdminPreviewCourseVersionParameters = paths["/v3/content/admin/course/{course_id}/versions/{version}/preview"]["post"]["parameters"];
type AdminPreviewCourseVersionData = paths["/v3/content/admin/course/{course_id}/versions/{version}/preview"]["post"]["responses"]["201"]["content"]["application/json"];
type AdminPreviewCourseVersionError = paths["/v3/content/admin/course/{course_id}/versions/{version}/preview"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/content/admin/course/{course_id}/versions/{version}/preview"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/content/admin/course/{course_id}/versions/{version}/preview"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminPreviewCourseVersionBody = undefined;
type PreviewRedeemSchema = {
    method: "post";
    url: "/v3/content/preview/redeem";
    mediaType: [
        "application/json"
    ];
};
type PreviewRedeemParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type PreviewRedeemData = paths["/v3/content/preview/redeem"]["post"]["responses"]["200"]["content"]["application/json"];
type PreviewRedeemError = null | paths["/v3/content/preview/redeem"]["post"]["responses"]["422"]["content"]["application/json"];
type PreviewRedeemBody = paths["/v3/content/preview/redeem"]["post"]["requestBody"]["content"]["application/json"];
type PreviewEndSchema = {
    method: "delete";
    url: "/v3/content/preview/session";
};
type PreviewEndParameters = paths["/v3/content/preview/session"]["delete"]["parameters"];
type PreviewEndData = null;
type PreviewEndError = paths["/v3/content/preview/session"]["delete"]["responses"]["422"]["content"]["application/json"];
type PreviewEndBody = undefined;
type PreviewCourseSchema = {
    method: "get";
    url: "/v3/content/preview/course";
};
type PreviewCourseParameters = paths["/v3/content/preview/course"]["get"]["parameters"];
type PreviewCourseData = paths["/v3/content/preview/course"]["get"]["responses"]["200"]["content"]["application/json"];
type PreviewCourseError = null | paths["/v3/content/preview/course"]["get"]["responses"]["422"]["content"]["application/json"];
type PreviewTopicSchema = {
    method: "get";
    url: "/v3/content/preview/topic/{topic_id}";
};
type PreviewTopicParameters = paths["/v3/content/preview/topic/{topic_id}"]["get"]["parameters"];
type PreviewTopicData = paths["/v3/content/preview/topic/{topic_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type PreviewTopicError = null | paths["/v3/content/preview/topic/{topic_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type PreviewLessonQuestionsSchema = {
    method: "get";
    url: "/v3/content/preview/lesson/{lesson_id}/questions";
};
type PreviewLessonQuestionsParameters = paths["/v3/content/preview/lesson/{lesson_id}/questions"]["get"]["parameters"];
type PreviewLessonQuestionsData = paths["/v3/content/preview/lesson/{lesson_id}/questions"]["get"]["responses"]["200"]["content"]["application/json"];
type PreviewLessonQuestionsError = null | paths["/v3/content/preview/lesson/{lesson_id}/questions"]["get"]["responses"]["422"]["content"]["application/json"];
type PreviewMarkSchema = {
    method: "post";
    url: "/v3/content/preview/mark";
    mediaType: [
        "application/json"
    ];
};
type PreviewMarkParameters = paths["/v3/content/preview/mark"]["post"]["parameters"];
type PreviewMarkData = paths["/v3/content/preview/mark"]["post"]["responses"]["200"]["content"]["application/json"];
type PreviewMarkError = paths["/v3/content/preview/mark"]["post"]["responses"]["400"]["content"]["application/json"] | null | paths["/v3/content/preview/mark"]["post"]["responses"]["422"]["content"]["application/json"];
type PreviewMarkBody = paths["/v3/content/preview/mark"]["post"]["requestBody"]["content"]["application/json"];
type GlobalSearchSchema = {
    method: "get";
    url: "/v3/search";
};
type GlobalSearchParameters = paths["/v3/search"]["get"]["parameters"];
type GlobalSearchData = paths["/v3/search"]["get"]["responses"]["200"]["content"]["application/json"];
type GlobalSearchError = paths["/v3/search"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/search"]["get"]["responses"]["422"]["content"]["application/json"];
type EmailLessonSchema = {
    method: "post";
    url: "/v3/emails/lesson/{lesson_id}";
};
type EmailLessonParameters = paths["/v3/emails/lesson/{lesson_id}"]["post"]["parameters"];
type EmailLessonData = null;
type EmailLessonError = paths["/v3/emails/lesson/{lesson_id}"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/emails/lesson/{lesson_id}"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/emails/lesson/{lesson_id}"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/emails/lesson/{lesson_id}"]["post"]["responses"]["422"]["content"]["application/json"];
type EmailLessonBody = undefined;
type ListCertificatesSchema = {
    method: "get";
    url: "/v3/certificates";
};
type ListCertificatesParameters = paths["/v3/certificates"]["get"]["parameters"];
type ListCertificatesData = paths["/v3/certificates"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCertificatesError = paths["/v3/certificates"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/certificates"]["get"]["responses"]["422"]["content"]["application/json"];
type DownloadCertificateSchema = {
    method: "get";
    url: "/v3/certificates/{certificate_id}/download";
};
type DownloadCertificateParameters = paths["/v3/certificates/{certificate_id}/download"]["get"]["parameters"];
type DownloadCertificateData = paths["/v3/certificates/{certificate_id}/download"]["get"]["responses"]["200"]["content"]["application/pdf"];
type DownloadCertificateError = null | paths["/v3/certificates/{certificate_id}/download"]["get"]["responses"]["422"]["content"]["application/json"];
type AwardCertificateSchema = {
    method: "post";
    url: "/v3/certificates/award";
    mediaType: [
        "application/json"
    ];
};
type AwardCertificateParameters = paths["/v3/certificates/award"]["post"]["parameters"];
type AwardCertificateData = paths["/v3/certificates/award"]["post"]["responses"]["200"]["content"]["application/json"];
type AwardCertificateError = paths["/v3/certificates/award"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/certificates/award"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/certificates/award"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/certificates/award"]["post"]["responses"]["422"]["content"]["application/json"];
type AwardCertificateBody = paths["/v3/certificates/award"]["post"]["requestBody"]["content"]["application/json"];
type AdminCreateCourseCertificateTemplateSchema = {
    method: "post";
    url: "/v3/certificates/admin/course/{course_id}/template";
    mediaType: [
        "application/json"
    ];
};
type AdminCreateCourseCertificateTemplateParameters = paths["/v3/certificates/admin/course/{course_id}/template"]["post"]["parameters"];
type AdminCreateCourseCertificateTemplateData = paths["/v3/certificates/admin/course/{course_id}/template"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminCreateCourseCertificateTemplateError = null | null | paths["/v3/certificates/admin/course/{course_id}/template"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminCreateCourseCertificateTemplateBody = paths["/v3/certificates/admin/course/{course_id}/template"]["post"]["requestBody"]["content"]["application/json"];
type AdminDeleteCourseCertificateTemplateSchema = {
    method: "delete";
    url: "/v3/certificates/admin/course/{course_id}/template";
};
type AdminDeleteCourseCertificateTemplateParameters = paths["/v3/certificates/admin/course/{course_id}/template"]["delete"]["parameters"];
type AdminDeleteCourseCertificateTemplateData = null;
type AdminDeleteCourseCertificateTemplateError = null | null | paths["/v3/certificates/admin/course/{course_id}/template"]["delete"]["responses"]["422"]["content"]["application/json"];
type AdminDeleteCourseCertificateTemplateBody = undefined;
type AdminCreateSeriesCertificateTemplateSchema = {
    method: "post";
    url: "/v3/certificates/admin/series/{series_id}/template";
    mediaType: [
        "application/json"
    ];
};
type AdminCreateSeriesCertificateTemplateParameters = paths["/v3/certificates/admin/series/{series_id}/template"]["post"]["parameters"];
type AdminCreateSeriesCertificateTemplateData = paths["/v3/certificates/admin/series/{series_id}/template"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminCreateSeriesCertificateTemplateError = null | null | paths["/v3/certificates/admin/series/{series_id}/template"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminCreateSeriesCertificateTemplateBody = paths["/v3/certificates/admin/series/{series_id}/template"]["post"]["requestBody"]["content"]["application/json"];
type AdminDeleteSeriesCertificateTemplateSchema = {
    method: "delete";
    url: "/v3/certificates/admin/series/{series_id}/template";
};
type AdminDeleteSeriesCertificateTemplateParameters = paths["/v3/certificates/admin/series/{series_id}/template"]["delete"]["parameters"];
type AdminDeleteSeriesCertificateTemplateData = null;
type AdminDeleteSeriesCertificateTemplateError = null | null | paths["/v3/certificates/admin/series/{series_id}/template"]["delete"]["responses"]["422"]["content"]["application/json"];
type AdminDeleteSeriesCertificateTemplateBody = undefined;
type TopicCompleteSchema = {
    method: "post";
    url: "/v3/grades/topic/{topic_id}/complete";
};
type TopicCompleteParameters = paths["/v3/grades/topic/{topic_id}/complete"]["post"]["parameters"];
type TopicCompleteData = null;
type TopicCompleteError = paths["/v3/grades/topic/{topic_id}/complete"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/complete"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/complete"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/complete"]["post"]["responses"]["422"]["content"]["application/json"];
type TopicCompleteBody = undefined;
type SubmitLessonQuizSchema = {
    method: "post";
    url: "/v3/grades/lesson/{lesson_id}/quiz";
    mediaType: [
        "application/json"
    ];
};
type SubmitLessonQuizParameters = paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["parameters"];
type SubmitLessonQuizData = paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["responses"]["200"]["content"]["application/json"];
type SubmitLessonQuizError = paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["responses"]["420"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["responses"]["422"]["content"]["application/json"];
type SubmitLessonQuizBody = paths["/v3/grades/lesson/{lesson_id}/quiz"]["post"]["requestBody"]["content"]["application/json"];
type LessonQuizProgressSchema = {
    method: "get";
    url: "/v3/grades/lesson/{lesson_id}/quiz";
};
type LessonQuizProgressParameters = paths["/v3/grades/lesson/{lesson_id}/quiz"]["get"]["parameters"];
type LessonQuizProgressData = paths["/v3/grades/lesson/{lesson_id}/quiz"]["get"]["responses"]["200"]["content"]["application/json"];
type LessonQuizProgressError = paths["/v3/grades/lesson/{lesson_id}/quiz"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz"]["get"]["responses"]["422"]["content"]["application/json"];
type SubmitTopicQuizSchema = {
    method: "post";
    url: "/v3/grades/topic/{topic_id}/quiz";
    mediaType: [
        "application/json"
    ];
};
type SubmitTopicQuizParameters = paths["/v3/grades/topic/{topic_id}/quiz"]["post"]["parameters"];
type SubmitTopicQuizData = null;
type SubmitTopicQuizError = paths["/v3/grades/topic/{topic_id}/quiz"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz"]["post"]["responses"]["420"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz"]["post"]["responses"]["422"]["content"]["application/json"];
type SubmitTopicQuizBody = paths["/v3/grades/topic/{topic_id}/quiz"]["post"]["requestBody"]["content"]["application/json"];
type TopicQuizProgressSchema = {
    method: "get";
    url: "/v3/grades/topic/{topic_id}/quiz";
};
type TopicQuizProgressParameters = paths["/v3/grades/topic/{topic_id}/quiz"]["get"]["parameters"];
type TopicQuizProgressData = paths["/v3/grades/topic/{topic_id}/quiz"]["get"]["responses"]["200"]["content"]["application/json"];
type TopicQuizProgressError = paths["/v3/grades/topic/{topic_id}/quiz"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz"]["get"]["responses"]["422"]["content"]["application/json"];
type LessonQuizResultSchema = {
    method: "get";
    url: "/v3/grades/lesson/{lesson_id}/quiz/result";
};
type LessonQuizResultParameters = paths["/v3/grades/lesson/{lesson_id}/quiz/result"]["get"]["parameters"];
type LessonQuizResultData = paths["/v3/grades/lesson/{lesson_id}/quiz/result"]["get"]["responses"]["200"]["content"]["application/json"];
type LessonQuizResultError = paths["/v3/grades/lesson/{lesson_id}/quiz/result"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz/result"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz/result"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/lesson/{lesson_id}/quiz/result"]["get"]["responses"]["422"]["content"]["application/json"];
type TopicQuizResultSchema = {
    method: "get";
    url: "/v3/grades/topic/{topic_id}/quiz/result";
};
type TopicQuizResultParameters = paths["/v3/grades/topic/{topic_id}/quiz/result"]["get"]["parameters"];
type TopicQuizResultData = paths["/v3/grades/topic/{topic_id}/quiz/result"]["get"]["responses"]["200"]["content"]["application/json"];
type TopicQuizResultError = paths["/v3/grades/topic/{topic_id}/quiz/result"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz/result"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz/result"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/topic/{topic_id}/quiz/result"]["get"]["responses"]["422"]["content"]["application/json"];
type CourseViewerStateSchema = {
    method: "get";
    url: "/v3/grades/course/{course_id}/state";
};
type CourseViewerStateParameters = paths["/v3/grades/course/{course_id}/state"]["get"]["parameters"];
type CourseViewerStateData = paths["/v3/grades/course/{course_id}/state"]["get"]["responses"]["200"]["content"]["application/json"];
type CourseViewerStateError = paths["/v3/grades/course/{course_id}/state"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/course/{course_id}/state"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/course/{course_id}/state"]["get"]["responses"]["422"]["content"]["application/json"];
type UnlockCourseSchema = {
    method: "post";
    url: "/v3/grades/course/{course_id}/unlock";
};
type UnlockCourseParameters = paths["/v3/grades/course/{course_id}/unlock"]["post"]["parameters"];
type UnlockCourseData = paths["/v3/grades/course/{course_id}/unlock"]["post"]["responses"]["200"]["content"]["application/json"];
type UnlockCourseError = paths["/v3/grades/course/{course_id}/unlock"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/course/{course_id}/unlock"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grades/course/{course_id}/unlock"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/course/{course_id}/unlock"]["post"]["responses"]["422"]["content"]["application/json"];
type UnlockCourseBody = undefined;
type ContinueStudySchema = {
    method: "get";
    url: "/v3/grades/continue-study";
};
type ContinueStudyParameters = paths["/v3/grades/continue-study"]["get"]["parameters"];
type ContinueStudyData = paths["/v3/grades/continue-study"]["get"]["responses"]["200"]["content"]["application/json"];
type ContinueStudyError = paths["/v3/grades/continue-study"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/continue-study"]["get"]["responses"]["422"]["content"]["application/json"];
type AllProgressSchema = {
    method: "get";
    url: "/v3/grades/progress";
};
type AllProgressParameters = paths["/v3/grades/progress"]["get"]["parameters"];
type AllProgressData = paths["/v3/grades/progress"]["get"]["responses"]["200"]["content"]["application/json"];
type AllProgressError = paths["/v3/grades/progress"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/progress"]["get"]["responses"]["422"]["content"]["application/json"];
type CourseProgressSchema = {
    method: "get";
    url: "/v3/grades/progress/course/{course_id}";
};
type CourseProgressParameters = paths["/v3/grades/progress/course/{course_id}"]["get"]["parameters"];
type CourseProgressData = paths["/v3/grades/progress/course/{course_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type CourseProgressError = paths["/v3/grades/progress/course/{course_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/progress/course/{course_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/progress/course/{course_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type ListQuizResponsesSchema = {
    method: "get";
    url: "/v3/grades/quiz-responses";
};
type ListQuizResponsesParameters = paths["/v3/grades/quiz-responses"]["get"]["parameters"];
type ListQuizResponsesData = paths["/v3/grades/quiz-responses"]["get"]["responses"]["200"]["content"]["application/json"];
type ListQuizResponsesError = paths["/v3/grades/quiz-responses"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/quiz-responses"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grades/quiz-responses"]["get"]["responses"]["422"]["content"]["application/json"];
type GetQuizResponseDetailSchema = {
    method: "get";
    url: "/v3/grades/quiz-responses/{response_id}";
};
type GetQuizResponseDetailParameters = paths["/v3/grades/quiz-responses/{response_id}"]["get"]["parameters"];
type GetQuizResponseDetailData = paths["/v3/grades/quiz-responses/{response_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetQuizResponseDetailError = paths["/v3/grades/quiz-responses/{response_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grades/quiz-responses/{response_id}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grades/quiz-responses/{response_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grades/quiz-responses/{response_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type ListGroupQuizSubmissionsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/quiz-submissions";
};
type ListGroupQuizSubmissionsParameters = paths["/v3/groups/{group_id}/quiz-submissions"]["get"]["parameters"];
type ListGroupQuizSubmissionsData = paths["/v3/groups/{group_id}/quiz-submissions"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupQuizSubmissionsError = paths["/v3/groups/{group_id}/quiz-submissions"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/quiz-submissions"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentQuizSubmissionsSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/quiz-submissions";
};
type ListStudentQuizSubmissionsParameters = paths["/v3/users/students/{student_id}/quiz-submissions"]["get"]["parameters"];
type ListStudentQuizSubmissionsData = paths["/v3/users/students/{student_id}/quiz-submissions"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentQuizSubmissionsError = paths["/v3/users/students/{student_id}/quiz-submissions"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/quiz-submissions"]["get"]["responses"]["422"]["content"]["application/json"];
type GradingSubmissionsListSchema = {
    method: "get";
    url: "/v3/grading/submissions";
};
type GradingSubmissionsListParameters = paths["/v3/grading/submissions"]["get"]["parameters"];
type GradingSubmissionsListData = paths["/v3/grading/submissions"]["get"]["responses"]["200"]["content"]["application/json"];
type GradingSubmissionsListError = paths["/v3/grading/submissions"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grading/submissions"]["get"]["responses"]["422"]["content"]["application/json"];
type GradingSubmissionDetailSchema = {
    method: "get";
    url: "/v3/grading/submissions/{submission_id}";
};
type GradingSubmissionDetailParameters = paths["/v3/grading/submissions/{submission_id}"]["get"]["parameters"];
type GradingSubmissionDetailData = paths["/v3/grading/submissions/{submission_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GradingSubmissionDetailError = paths["/v3/grading/submissions/{submission_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grading/submissions/{submission_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type GradingSubmissionGradeSchema = {
    method: "post";
    url: "/v3/grading/submissions/{submission_id}/grade";
    mediaType: [
        "application/json"
    ];
};
type GradingSubmissionGradeParameters = paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["parameters"];
type GradingSubmissionGradeData = paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["responses"]["200"]["content"]["application/json"];
type GradingSubmissionGradeError = paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["responses"]["422"]["content"]["application/json"];
type GradingSubmissionGradeBody = paths["/v3/grading/submissions/{submission_id}/grade"]["post"]["requestBody"]["content"]["application/json"];
type AdminListFeedbackSubmissionsSchema = {
    method: "get";
    url: "/v3/grading/admin/feedbacks";
};
type AdminListFeedbackSubmissionsParameters = paths["/v3/grading/admin/feedbacks"]["get"]["parameters"];
type AdminListFeedbackSubmissionsData = paths["/v3/grading/admin/feedbacks"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminListFeedbackSubmissionsError = paths["/v3/grading/admin/feedbacks"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grading/admin/feedbacks"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grading/admin/feedbacks"]["get"]["responses"]["422"]["content"]["application/json"];
type AdminGetFeedbackSubmissionSchema = {
    method: "get";
    url: "/v3/grading/admin/feedbacks/{submission_id}";
};
type AdminGetFeedbackSubmissionParameters = paths["/v3/grading/admin/feedbacks/{submission_id}"]["get"]["parameters"];
type AdminGetFeedbackSubmissionData = paths["/v3/grading/admin/feedbacks/{submission_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type AdminGetFeedbackSubmissionError = paths["/v3/grading/admin/feedbacks/{submission_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/grading/admin/feedbacks/{submission_id}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/grading/admin/feedbacks/{submission_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateManualGradingSchema = {
    method: "post";
    url: "/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading";
    mediaType: [
        "application/json"
    ];
};
type CreateManualGradingParameters = paths["/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading"]["post"]["parameters"];
type CreateManualGradingData = paths["/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading"]["post"]["responses"]["201"]["content"]["application/json"];
type CreateManualGradingError = paths["/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateManualGradingBody = paths["/v3/users/students/{student_id}/quizzes/{quiz_id}/manual-grading"]["post"]["requestBody"]["content"]["application/json"];
type ListCannedResponsesSchema = {
    method: "get";
    url: "/v3/canned-responses";
};
type ListCannedResponsesParameters = paths["/v3/canned-responses"]["get"]["parameters"];
type ListCannedResponsesData = paths["/v3/canned-responses"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCannedResponsesError = paths["/v3/canned-responses"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/canned-responses"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/canned-responses"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateCannedResponseSchema = {
    method: "post";
    url: "/v3/canned-responses";
    mediaType: [
        "application/json"
    ];
};
type CreateCannedResponseParameters = paths["/v3/canned-responses"]["post"]["parameters"];
type CreateCannedResponseData = paths["/v3/canned-responses"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateCannedResponseError = paths["/v3/canned-responses"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/canned-responses"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/canned-responses"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateCannedResponseBody = paths["/v3/canned-responses"]["post"]["requestBody"]["content"]["application/json"];
type UpdateCannedResponseSchema = {
    method: "put";
    url: "/v3/canned-responses/{canned_response_id}";
    mediaType: [
        "application/json"
    ];
};
type UpdateCannedResponseParameters = paths["/v3/canned-responses/{canned_response_id}"]["put"]["parameters"];
type UpdateCannedResponseData = paths["/v3/canned-responses/{canned_response_id}"]["put"]["responses"]["200"]["content"]["application/json"];
type UpdateCannedResponseError = paths["/v3/canned-responses/{canned_response_id}"]["put"]["responses"]["401"]["content"]["application/json"] | paths["/v3/canned-responses/{canned_response_id}"]["put"]["responses"]["403"]["content"]["application/json"] | paths["/v3/canned-responses/{canned_response_id}"]["put"]["responses"]["404"]["content"]["application/json"] | paths["/v3/canned-responses/{canned_response_id}"]["put"]["responses"]["422"]["content"]["application/json"];
type UpdateCannedResponseBody = paths["/v3/canned-responses/{canned_response_id}"]["put"]["requestBody"]["content"]["application/json"];
type DeleteCannedResponseSchema = {
    method: "delete";
    url: "/v3/canned-responses/{canned_response_id}";
};
type DeleteCannedResponseParameters = paths["/v3/canned-responses/{canned_response_id}"]["delete"]["parameters"];
type DeleteCannedResponseData = null;
type DeleteCannedResponseError = paths["/v3/canned-responses/{canned_response_id}"]["delete"]["responses"]["401"]["content"]["application/json"] | paths["/v3/canned-responses/{canned_response_id}"]["delete"]["responses"]["403"]["content"]["application/json"] | paths["/v3/canned-responses/{canned_response_id}"]["delete"]["responses"]["404"]["content"]["application/json"] | paths["/v3/canned-responses/{canned_response_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type DeleteCannedResponseBody = undefined;
type GetStudyHelperBoardSchema = {
    method: "get";
    url: "/v3/adoption/study-helper-board";
};
type GetStudyHelperBoardParameters = paths["/v3/adoption/study-helper-board"]["get"]["parameters"];
type GetStudyHelperBoardData = paths["/v3/adoption/study-helper-board"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudyHelperBoardError = paths["/v3/adoption/study-helper-board"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/adoption/study-helper-board"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/adoption/study-helper-board"]["get"]["responses"]["422"]["content"]["application/json"];
type GetMyStudyHelperSchema = {
    method: "get";
    url: "/v3/adoption/my-study-helper";
};
type GetMyStudyHelperParameters = paths["/v3/adoption/my-study-helper"]["get"]["parameters"];
type GetMyStudyHelperData = paths["/v3/adoption/my-study-helper"]["get"]["responses"]["200"]["content"]["application/json"];
type GetMyStudyHelperError = paths["/v3/adoption/my-study-helper"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/adoption/my-study-helper"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/adoption/my-study-helper"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentBoardSchema = {
    method: "get";
    url: "/v3/adoption/student-board";
};
type GetStudentBoardParameters = paths["/v3/adoption/student-board"]["get"]["parameters"];
type GetStudentBoardData = paths["/v3/adoption/student-board"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentBoardError = paths["/v3/adoption/student-board"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/adoption/student-board"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentAdoptionInfoSchema = {
    method: "get";
    url: "/v3/adoption/students/{student_id}/adoption-info";
};
type GetStudentAdoptionInfoParameters = paths["/v3/adoption/students/{student_id}/adoption-info"]["get"]["parameters"];
type GetStudentAdoptionInfoData = paths["/v3/adoption/students/{student_id}/adoption-info"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentAdoptionInfoError = paths["/v3/adoption/students/{student_id}/adoption-info"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | null | paths["/v3/adoption/students/{student_id}/adoption-info"]["get"]["responses"]["422"]["content"]["application/json"];
type AdoptStudentSchema = {
    method: "post";
    url: "/v3/adoption/adopt";
    mediaType: [
        "application/json"
    ];
};
type AdoptStudentParameters = paths["/v3/adoption/adopt"]["post"]["parameters"];
type AdoptStudentData = paths["/v3/adoption/adopt"]["post"]["responses"]["200"]["content"]["application/json"];
type AdoptStudentError = null | paths["/v3/adoption/adopt"]["post"]["responses"]["401"]["content"]["application/json"] | null | null | null | paths["/v3/adoption/adopt"]["post"]["responses"]["422"]["content"]["application/json"];
type AdoptStudentBody = paths["/v3/adoption/adopt"]["post"]["requestBody"]["content"]["application/json"];
type PassOnStudentSchema = {
    method: "post";
    url: "/v3/adoption/pass-on";
    mediaType: [
        "application/json"
    ];
};
type PassOnStudentParameters = paths["/v3/adoption/pass-on"]["post"]["parameters"];
type PassOnStudentData = paths["/v3/adoption/pass-on"]["post"]["responses"]["200"]["content"]["application/json"];
type PassOnStudentError = paths["/v3/adoption/pass-on"]["post"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/adoption/pass-on"]["post"]["responses"]["422"]["content"]["application/json"];
type PassOnStudentBody = paths["/v3/adoption/pass-on"]["post"]["requestBody"]["content"]["application/json"];
type GetAssignCandidatesSchema = {
    method: "get";
    url: "/v3/adoption/students/{student_id}/assign-candidates";
};
type GetAssignCandidatesParameters = paths["/v3/adoption/students/{student_id}/assign-candidates"]["get"]["parameters"];
type GetAssignCandidatesData = paths["/v3/adoption/students/{student_id}/assign-candidates"]["get"]["responses"]["200"]["content"]["application/json"];
type GetAssignCandidatesError = paths["/v3/adoption/students/{student_id}/assign-candidates"]["get"]["responses"]["400"]["content"]["application/json"] | paths["/v3/adoption/students/{student_id}/assign-candidates"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/adoption/students/{student_id}/assign-candidates"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/adoption/students/{student_id}/assign-candidates"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/adoption/students/{student_id}/assign-candidates"]["get"]["responses"]["422"]["content"]["application/json"];
type AssignStudentSchema = {
    method: "post";
    url: "/v3/adoption/assign";
    mediaType: [
        "application/json"
    ];
};
type AssignStudentParameters = paths["/v3/adoption/assign"]["post"]["parameters"];
type AssignStudentData = paths["/v3/adoption/assign"]["post"]["responses"]["200"]["content"]["application/json"];
type AssignStudentError = paths["/v3/adoption/assign"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/adoption/assign"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/adoption/assign"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/adoption/assign"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/adoption/assign"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/adoption/assign"]["post"]["responses"]["422"]["content"]["application/json"];
type AssignStudentBody = paths["/v3/adoption/assign"]["post"]["requestBody"]["content"]["application/json"];
type CreateAdoptionRequestSchema = {
    method: "post";
    url: "/v3/adoption/request";
    mediaType: [
        "application/json"
    ];
};
type CreateAdoptionRequestParameters = paths["/v3/adoption/request"]["post"]["parameters"];
type CreateAdoptionRequestData = paths["/v3/adoption/request"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateAdoptionRequestError = paths["/v3/adoption/request"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/adoption/request"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/adoption/request"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/adoption/request"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/adoption/request"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateAdoptionRequestBody = paths["/v3/adoption/request"]["post"]["requestBody"]["content"]["application/json"];
type GetAdoptionRequestsSchema = {
    method: "get";
    url: "/v3/adoption/requests";
};
type GetAdoptionRequestsParameters = paths["/v3/adoption/requests"]["get"]["parameters"];
type GetAdoptionRequestsData = paths["/v3/adoption/requests"]["get"]["responses"]["200"]["content"]["application/json"];
type GetAdoptionRequestsError = paths["/v3/adoption/requests"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/adoption/requests"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/adoption/requests"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/adoption/requests"]["get"]["responses"]["422"]["content"]["application/json"];
type AcceptAdoptionRequestSchema = {
    method: "post";
    url: "/v3/adoption/requests/{request_id}/accept";
};
type AcceptAdoptionRequestParameters = paths["/v3/adoption/requests/{request_id}/accept"]["post"]["parameters"];
type AcceptAdoptionRequestData = paths["/v3/adoption/requests/{request_id}/accept"]["post"]["responses"]["200"]["content"]["application/json"];
type AcceptAdoptionRequestError = paths["/v3/adoption/requests/{request_id}/accept"]["post"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/adoption/requests/{request_id}/accept"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/adoption/requests/{request_id}/accept"]["post"]["responses"]["422"]["content"]["application/json"];
type AcceptAdoptionRequestBody = undefined;
type DeclineAdoptionRequestSchema = {
    method: "post";
    url: "/v3/adoption/requests/{request_id}/decline";
};
type DeclineAdoptionRequestParameters = paths["/v3/adoption/requests/{request_id}/decline"]["post"]["parameters"];
type DeclineAdoptionRequestData = null;
type DeclineAdoptionRequestError = paths["/v3/adoption/requests/{request_id}/decline"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/adoption/requests/{request_id}/decline"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/adoption/requests/{request_id}/decline"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/adoption/requests/{request_id}/decline"]["post"]["responses"]["422"]["content"]["application/json"];
type DeclineAdoptionRequestBody = undefined;
type SendEncouragementSchema = {
    method: "post";
    url: "/v3/encouragements";
    mediaType: [
        "application/json"
    ];
};
type SendEncouragementParameters = paths["/v3/encouragements"]["post"]["parameters"];
type SendEncouragementData = paths["/v3/encouragements"]["post"]["responses"]["200"]["content"]["application/json"];
type SendEncouragementError = paths["/v3/encouragements"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/encouragements"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/encouragements"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/encouragements"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/encouragements"]["post"]["responses"]["422"]["content"]["application/json"];
type SendEncouragementBody = paths["/v3/encouragements"]["post"]["requestBody"]["content"]["application/json"];
type ListMessageThreadsSchema = {
    method: "get";
    url: "/v3/threads";
};
type ListMessageThreadsParameters = paths["/v3/threads"]["get"]["parameters"];
type ListMessageThreadsData = paths["/v3/threads"]["get"]["responses"]["200"]["content"]["application/json"];
type ListMessageThreadsError = null | paths["/v3/threads"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateThreadSchema = {
    method: "post";
    url: "/v3/threads";
    mediaType: [
        "application/json"
    ];
};
type CreateThreadParameters = paths["/v3/threads"]["post"]["parameters"];
type CreateThreadData = paths["/v3/threads"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateThreadError = null | paths["/v3/threads"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/threads"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/threads"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateThreadBody = paths["/v3/threads"]["post"]["requestBody"]["content"]["application/json"];
type GetUnreadMessageCountSchema = {
    method: "get";
    url: "/v3/threads/unread-count";
};
type GetUnreadMessageCountParameters = paths["/v3/threads/unread-count"]["get"]["parameters"];
type GetUnreadMessageCountData = paths["/v3/threads/unread-count"]["get"]["responses"]["200"]["content"]["application/json"];
type GetUnreadMessageCountError = null | paths["/v3/threads/unread-count"]["get"]["responses"]["422"]["content"]["application/json"];
type GetThreadMessagesSchema = {
    method: "get";
    url: "/v3/threads/{thread_id}/messages";
};
type GetThreadMessagesParameters = paths["/v3/threads/{thread_id}/messages"]["get"]["parameters"];
type GetThreadMessagesData = paths["/v3/threads/{thread_id}/messages"]["get"]["responses"]["200"]["content"]["application/json"];
type GetThreadMessagesError = null | paths["/v3/threads/{thread_id}/messages"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/messages"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/messages"]["get"]["responses"]["422"]["content"]["application/json"];
type SendThreadMessageSchema = {
    method: "post";
    url: "/v3/threads/{thread_id}/messages";
    mediaType: [
        "application/json"
    ];
};
type SendThreadMessageParameters = paths["/v3/threads/{thread_id}/messages"]["post"]["parameters"];
type SendThreadMessageData = paths["/v3/threads/{thread_id}/messages"]["post"]["responses"]["200"]["content"]["application/json"];
type SendThreadMessageError = null | paths["/v3/threads/{thread_id}/messages"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/messages"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/messages"]["post"]["responses"]["422"]["content"]["application/json"];
type SendThreadMessageBody = paths["/v3/threads/{thread_id}/messages"]["post"]["requestBody"]["content"]["application/json"];
type MarkMessageThreadReadSchema = {
    method: "post";
    url: "/v3/threads/{thread_id}/read";
};
type MarkMessageThreadReadParameters = paths["/v3/threads/{thread_id}/read"]["post"]["parameters"];
type MarkMessageThreadReadData = null;
type MarkMessageThreadReadError = null | paths["/v3/threads/{thread_id}/read"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/read"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/read"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkMessageThreadReadBody = undefined;
type MarkMessageThreadUnreadSchema = {
    method: "post";
    url: "/v3/threads/{thread_id}/unread";
};
type MarkMessageThreadUnreadParameters = paths["/v3/threads/{thread_id}/unread"]["post"]["parameters"];
type MarkMessageThreadUnreadData = null;
type MarkMessageThreadUnreadError = null | paths["/v3/threads/{thread_id}/unread"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/unread"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/unread"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkMessageThreadUnreadBody = undefined;
type HideMessageThreadSchema = {
    method: "post";
    url: "/v3/threads/{thread_id}/hide";
};
type HideMessageThreadParameters = paths["/v3/threads/{thread_id}/hide"]["post"]["parameters"];
type HideMessageThreadData = null;
type HideMessageThreadError = null | paths["/v3/threads/{thread_id}/hide"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/hide"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/threads/{thread_id}/hide"]["post"]["responses"]["422"]["content"]["application/json"];
type HideMessageThreadBody = undefined;
type DeleteMessageThreadSchema = {
    method: "delete";
    url: "/v3/threads/{thread_id}";
};
type DeleteMessageThreadParameters = paths["/v3/threads/{thread_id}"]["delete"]["parameters"];
type DeleteMessageThreadData = null;
type DeleteMessageThreadError = null | paths["/v3/threads/{thread_id}"]["delete"]["responses"]["403"]["content"]["application/json"] | paths["/v3/threads/{thread_id}"]["delete"]["responses"]["404"]["content"]["application/json"] | paths["/v3/threads/{thread_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type DeleteMessageThreadBody = undefined;
type ListMassMessagesSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/mass-messages";
};
type ListMassMessagesParameters = paths["/v3/groups/{group_id}/mass-messages"]["get"]["parameters"];
type ListMassMessagesData = paths["/v3/groups/{group_id}/mass-messages"]["get"]["responses"]["200"]["content"]["application/json"];
type ListMassMessagesError = paths["/v3/groups/{group_id}/mass-messages"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages"]["get"]["responses"]["422"]["content"]["application/json"];
type SendMassMessageSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/mass-messages";
    mediaType: [
        "application/json"
    ];
};
type SendMassMessageParameters = paths["/v3/groups/{group_id}/mass-messages"]["post"]["parameters"];
type SendMassMessageData = paths["/v3/groups/{group_id}/mass-messages"]["post"]["responses"]["201"]["content"]["application/json"];
type SendMassMessageError = paths["/v3/groups/{group_id}/mass-messages"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages"]["post"]["responses"]["422"]["content"]["application/json"];
type SendMassMessageBody = paths["/v3/groups/{group_id}/mass-messages"]["post"]["requestBody"]["content"]["application/json"];
type DeleteMassMessageSchema = {
    method: "delete";
    url: "/v3/groups/{group_id}/mass-messages/{thread_id}";
};
type DeleteMassMessageParameters = paths["/v3/groups/{group_id}/mass-messages/{thread_id}"]["delete"]["parameters"];
type DeleteMassMessageData = null;
type DeleteMassMessageError = paths["/v3/groups/{group_id}/mass-messages/{thread_id}"]["delete"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages/{thread_id}"]["delete"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages/{thread_id}"]["delete"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/mass-messages/{thread_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type DeleteMassMessageBody = undefined;
type SendIntroductionSchema = {
    method: "post";
    url: "/v3/introductions";
    mediaType: [
        "application/json"
    ];
};
type SendIntroductionParameters = paths["/v3/introductions"]["post"]["parameters"];
type SendIntroductionData = paths["/v3/introductions"]["post"]["responses"]["200"]["content"]["application/json"];
type SendIntroductionError = null | null | null;
type SendIntroductionBody = paths["/v3/introductions"]["post"]["requestBody"]["content"]["application/json"];
type GetListFiltersSchema = {
    method: "get";
    url: "/v3/lists/{list_key}/filters";
};
type GetListFiltersParameters = paths["/v3/lists/{list_key}/filters"]["get"]["parameters"];
type GetListFiltersData = paths["/v3/lists/{list_key}/filters"]["get"]["responses"]["200"]["content"]["application/json"];
type GetListFiltersError = null | null | null | paths["/v3/lists/{list_key}/filters"]["get"]["responses"]["422"]["content"]["application/json"];
type GetCountriesSchema = {
    method: "get";
    url: "/v3/countries";
};
type GetCountriesParameters = paths["/v3/countries"]["get"]["parameters"];
type GetCountriesData = paths["/v3/countries"]["get"]["responses"]["200"]["content"]["application/json"];
type GetCountriesError = paths["/v3/countries"]["get"]["responses"]["422"]["content"]["application/json"];
type GetGdprNoticeSchema = {
    method: "get";
    url: "/v3/site-notices/gdpr";
};
type GetGdprNoticeParameters = paths["/v3/site-notices/gdpr"]["get"]["parameters"];
type GetGdprNoticeData = paths["/v3/site-notices/gdpr"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGdprNoticeError = paths["/v3/site-notices/gdpr"]["get"]["responses"]["422"]["content"]["application/json"];
type ListHeaderNoticesSchema = {
    method: "get";
    url: "/v3/site-notices/header";
};
type ListHeaderNoticesParameters = paths["/v3/site-notices/header"]["get"]["parameters"];
type ListHeaderNoticesData = paths["/v3/site-notices/header"]["get"]["responses"]["200"]["content"]["application/json"];
type ListHeaderNoticesError = paths["/v3/site-notices/header"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/site-notices/header"]["get"]["responses"]["422"]["content"]["application/json"];
type DismissHeaderNoticeSchema = {
    method: "post";
    url: "/v3/site-notices/header/{notice_id}/dismiss";
};
type DismissHeaderNoticeParameters = paths["/v3/site-notices/header/{notice_id}/dismiss"]["post"]["parameters"];
type DismissHeaderNoticeData = paths["/v3/site-notices/header/{notice_id}/dismiss"]["post"]["responses"]["200"]["content"]["application/json"];
type DismissHeaderNoticeError = paths["/v3/site-notices/header/{notice_id}/dismiss"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/site-notices/header/{notice_id}/dismiss"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/site-notices/header/{notice_id}/dismiss"]["post"]["responses"]["422"]["content"]["application/json"];
type DismissHeaderNoticeBody = undefined;
type ListContextualHelpPlacementsSchema = {
    method: "get";
    url: "/v3/contextual-help/placements";
};
type ListContextualHelpPlacementsParameters = paths["/v3/contextual-help/placements"]["get"]["parameters"];
type ListContextualHelpPlacementsData = paths["/v3/contextual-help/placements"]["get"]["responses"]["200"]["content"]["application/json"];
type ListContextualHelpPlacementsError = paths["/v3/contextual-help/placements"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/contextual-help/placements"]["get"]["responses"]["422"]["content"]["application/json"];
type GetContextualHelpPlacementSchema = {
    method: "get";
    url: "/v3/contextual-help/placements/{placement}";
};
type GetContextualHelpPlacementParameters = paths["/v3/contextual-help/placements/{placement}"]["get"]["parameters"];
type GetContextualHelpPlacementData = paths["/v3/contextual-help/placements/{placement}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetContextualHelpPlacementError = paths["/v3/contextual-help/placements/{placement}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/contextual-help/placements/{placement}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/contextual-help/placements/{placement}"]["get"]["responses"]["422"]["content"]["application/json"];
type GetContextualHelpTreeSchema = {
    method: "get";
    url: "/v3/contextual-help/sections";
};
type GetContextualHelpTreeParameters = paths["/v3/contextual-help/sections"]["get"]["parameters"];
type GetContextualHelpTreeData = paths["/v3/contextual-help/sections"]["get"]["responses"]["200"]["content"]["application/json"];
type GetContextualHelpTreeError = paths["/v3/contextual-help/sections"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/contextual-help/sections"]["get"]["responses"]["422"]["content"]["application/json"];
type ListNotificationsSchema = {
    method: "get";
    url: "/v3/notifications";
};
type ListNotificationsParameters = paths["/v3/notifications"]["get"]["parameters"];
type ListNotificationsData = paths["/v3/notifications"]["get"]["responses"]["200"]["content"]["application/json"];
type ListNotificationsError = null | paths["/v3/notifications"]["get"]["responses"]["422"]["content"]["application/json"];
type GetUnreadNotificationCountSchema = {
    method: "get";
    url: "/v3/notifications/unread-count";
};
type GetUnreadNotificationCountParameters = paths["/v3/notifications/unread-count"]["get"]["parameters"];
type GetUnreadNotificationCountData = paths["/v3/notifications/unread-count"]["get"]["responses"]["200"]["content"]["application/json"];
type GetUnreadNotificationCountError = null | paths["/v3/notifications/unread-count"]["get"]["responses"]["422"]["content"]["application/json"];
type MarkNotificationsReadSchema = {
    method: "post";
    url: "/v3/notifications/mark-read";
    mediaType: [
        "application/json"
    ];
};
type MarkNotificationsReadParameters = paths["/v3/notifications/mark-read"]["post"]["parameters"];
type MarkNotificationsReadData = paths["/v3/notifications/mark-read"]["post"]["responses"]["200"]["content"]["application/json"];
type MarkNotificationsReadError = null | paths["/v3/notifications/mark-read"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkNotificationsReadBody = paths["/v3/notifications/mark-read"]["post"]["requestBody"]["content"]["application/json"];
type MarkNotificationsUnreadSchema = {
    method: "post";
    url: "/v3/notifications/mark-unread";
    mediaType: [
        "application/json"
    ];
};
type MarkNotificationsUnreadParameters = paths["/v3/notifications/mark-unread"]["post"]["parameters"];
type MarkNotificationsUnreadData = paths["/v3/notifications/mark-unread"]["post"]["responses"]["200"]["content"]["application/json"];
type MarkNotificationsUnreadError = null | paths["/v3/notifications/mark-unread"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkNotificationsUnreadBody = paths["/v3/notifications/mark-unread"]["post"]["requestBody"]["content"]["application/json"];
type DeleteNotificationsSchema = {
    method: "post";
    url: "/v3/notifications/delete";
    mediaType: [
        "application/json"
    ];
};
type DeleteNotificationsParameters = paths["/v3/notifications/delete"]["post"]["parameters"];
type DeleteNotificationsData = paths["/v3/notifications/delete"]["post"]["responses"]["200"]["content"]["application/json"];
type DeleteNotificationsError = null | paths["/v3/notifications/delete"]["post"]["responses"]["422"]["content"]["application/json"];
type DeleteNotificationsBody = paths["/v3/notifications/delete"]["post"]["requestBody"]["content"]["application/json"];
type GetNotificationPreferencesSchema = {
    method: "get";
    url: "/v3/notification-preferences";
};
type GetNotificationPreferencesParameters = paths["/v3/notification-preferences"]["get"]["parameters"];
type GetNotificationPreferencesData = paths["/v3/notification-preferences"]["get"]["responses"]["200"]["content"]["application/json"];
type GetNotificationPreferencesError = null | paths["/v3/notification-preferences"]["get"]["responses"]["422"]["content"]["application/json"];
type UpdateNotificationPreferencesSchema = {
    method: "put";
    url: "/v3/notification-preferences";
    mediaType: [
        "application/json"
    ];
};
type UpdateNotificationPreferencesParameters = paths["/v3/notification-preferences"]["put"]["parameters"];
type UpdateNotificationPreferencesData = paths["/v3/notification-preferences"]["put"]["responses"]["200"]["content"]["application/json"];
type UpdateNotificationPreferencesError = null | null | paths["/v3/notification-preferences"]["put"]["responses"]["422"]["content"]["application/json"];
type UpdateNotificationPreferencesBody = paths["/v3/notification-preferences"]["put"]["requestBody"]["content"]["application/json"];
type GetContactChannelsSchema = {
    method: "get";
    url: "/v3/contact-channels";
};
type GetContactChannelsParameters = paths["/v3/contact-channels"]["get"]["parameters"];
type GetContactChannelsData = paths["/v3/contact-channels"]["get"]["responses"]["200"]["content"]["application/json"];
type GetContactChannelsError = null | paths["/v3/contact-channels"]["get"]["responses"]["422"]["content"]["application/json"];
type StartContactChannelVerificationSchema = {
    method: "post";
    url: "/v3/contact-channels/{channel}/verify";
    mediaType: [
        "application/json"
    ];
};
type StartContactChannelVerificationParameters = paths["/v3/contact-channels/{channel}/verify"]["post"]["parameters"];
type StartContactChannelVerificationData = paths["/v3/contact-channels/{channel}/verify"]["post"]["responses"]["202"]["content"]["application/json"];
type StartContactChannelVerificationError = null | null | paths["/v3/contact-channels/{channel}/verify"]["post"]["responses"]["422"]["content"]["application/json"];
type StartContactChannelVerificationBody = paths["/v3/contact-channels/{channel}/verify"]["post"]["requestBody"]["content"]["application/json"];
type CompleteContactChannelVerificationSchema = {
    method: "post";
    url: "/v3/contact-channels/{channel}/connect";
    mediaType: [
        "application/json"
    ];
};
type CompleteContactChannelVerificationParameters = paths["/v3/contact-channels/{channel}/connect"]["post"]["parameters"];
type CompleteContactChannelVerificationData = paths["/v3/contact-channels/{channel}/connect"]["post"]["responses"]["200"]["content"]["application/json"];
type CompleteContactChannelVerificationError = null | null | paths["/v3/contact-channels/{channel}/connect"]["post"]["responses"]["422"]["content"]["application/json"];
type CompleteContactChannelVerificationBody = paths["/v3/contact-channels/{channel}/connect"]["post"]["requestBody"]["content"]["application/json"];
type DisconnectContactChannelSchema = {
    method: "delete";
    url: "/v3/contact-channels/{channel}";
};
type DisconnectContactChannelParameters = paths["/v3/contact-channels/{channel}"]["delete"]["parameters"];
type DisconnectContactChannelData = paths["/v3/contact-channels/{channel}"]["delete"]["responses"]["200"]["content"]["application/json"];
type DisconnectContactChannelError = null | paths["/v3/contact-channels/{channel}"]["delete"]["responses"]["422"]["content"]["application/json"];
type DisconnectContactChannelBody = undefined;
type ListGroupActivitySchema = {
    method: "get";
    url: "/v3/groups/{group_id}/activity";
};
type ListGroupActivityParameters = paths["/v3/groups/{group_id}/activity"]["get"]["parameters"];
type ListGroupActivityData = paths["/v3/groups/{group_id}/activity"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupActivityError = paths["/v3/groups/{group_id}/activity"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/activity"]["get"]["responses"]["422"]["content"]["application/json"];
type ListMemberActivitySchema = {
    method: "get";
    url: "/v3/users/members/{member_id}/activity";
};
type ListMemberActivityParameters = paths["/v3/users/members/{member_id}/activity"]["get"]["parameters"];
type ListMemberActivityData = paths["/v3/users/members/{member_id}/activity"]["get"]["responses"]["200"]["content"]["application/json"];
type ListMemberActivityError = paths["/v3/users/members/{member_id}/activity"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/users/members/{member_id}/activity"]["get"]["responses"]["422"]["content"]["application/json"];
type GetMemberActivityAccessSchema = {
    method: "get";
    url: "/v3/users/members/{member_id}/activity/access";
};
type GetMemberActivityAccessParameters = paths["/v3/users/members/{member_id}/activity/access"]["get"]["parameters"];
type GetMemberActivityAccessData = paths["/v3/users/members/{member_id}/activity/access"]["get"]["responses"]["200"]["content"]["application/json"];
type GetMemberActivityAccessError = paths["/v3/users/members/{member_id}/activity/access"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/members/{member_id}/activity/access"]["get"]["responses"]["422"]["content"]["application/json"];
type GetGroupAnnouncementSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/announcement";
};
type GetGroupAnnouncementParameters = paths["/v3/groups/{group_id}/announcement"]["get"]["parameters"];
type GetGroupAnnouncementData = paths["/v3/groups/{group_id}/announcement"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupAnnouncementError = paths["/v3/groups/{group_id}/announcement"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/announcement"]["get"]["responses"]["422"]["content"]["application/json"];
type SetGroupAnnouncementSchema = {
    method: "put";
    url: "/v3/groups/{group_id}/announcement";
    mediaType: [
        "application/json"
    ];
};
type SetGroupAnnouncementParameters = paths["/v3/groups/{group_id}/announcement"]["put"]["parameters"];
type SetGroupAnnouncementData = paths["/v3/groups/{group_id}/announcement"]["put"]["responses"]["200"]["content"]["application/json"];
type SetGroupAnnouncementError = paths["/v3/groups/{group_id}/announcement"]["put"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/announcement"]["put"]["responses"]["422"]["content"]["application/json"];
type SetGroupAnnouncementBody = paths["/v3/groups/{group_id}/announcement"]["put"]["requestBody"]["content"]["application/json"];
type GetGroupDashboardStatsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/dashboard-stats";
};
type GetGroupDashboardStatsParameters = paths["/v3/groups/{group_id}/dashboard-stats"]["get"]["parameters"];
type GetGroupDashboardStatsData = paths["/v3/groups/{group_id}/dashboard-stats"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupDashboardStatsError = paths["/v3/groups/{group_id}/dashboard-stats"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/dashboard-stats"]["get"]["responses"]["422"]["content"]["application/json"];
type GetCongregationDashboardStatsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/congregation-dashboard-stats";
};
type GetCongregationDashboardStatsParameters = paths["/v3/groups/{group_id}/congregation-dashboard-stats"]["get"]["parameters"];
type GetCongregationDashboardStatsData = paths["/v3/groups/{group_id}/congregation-dashboard-stats"]["get"]["responses"]["200"]["content"]["application/json"];
type GetCongregationDashboardStatsError = paths["/v3/groups/{group_id}/congregation-dashboard-stats"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/congregation-dashboard-stats"]["get"]["responses"]["422"]["content"]["application/json"];
type ListCongregationDashboardWaitingSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/congregation-dashboard-waiting";
};
type ListCongregationDashboardWaitingParameters = paths["/v3/groups/{group_id}/congregation-dashboard-waiting"]["get"]["parameters"];
type ListCongregationDashboardWaitingData = paths["/v3/groups/{group_id}/congregation-dashboard-waiting"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCongregationDashboardWaitingError = paths["/v3/groups/{group_id}/congregation-dashboard-waiting"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/congregation-dashboard-waiting"]["get"]["responses"]["422"]["content"]["application/json"];
type ListCongregationDashboardLocationsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/congregation-dashboard-locations";
};
type ListCongregationDashboardLocationsParameters = paths["/v3/groups/{group_id}/congregation-dashboard-locations"]["get"]["parameters"];
type ListCongregationDashboardLocationsData = paths["/v3/groups/{group_id}/congregation-dashboard-locations"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCongregationDashboardLocationsError = paths["/v3/groups/{group_id}/congregation-dashboard-locations"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/congregation-dashboard-locations"]["get"]["responses"]["422"]["content"]["application/json"];
type ListGroupStudentLanguagesSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/student-languages";
};
type ListGroupStudentLanguagesParameters = paths["/v3/groups/{group_id}/student-languages"]["get"]["parameters"];
type ListGroupStudentLanguagesData = paths["/v3/groups/{group_id}/student-languages"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupStudentLanguagesError = paths["/v3/groups/{group_id}/student-languages"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/student-languages"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentDashboardStatsSchema = {
    method: "get";
    url: "/v3/users/me/dashboard-stats";
};
type GetStudentDashboardStatsParameters = paths["/v3/users/me/dashboard-stats"]["get"]["parameters"];
type GetStudentDashboardStatsData = paths["/v3/users/me/dashboard-stats"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentDashboardStatsError = paths["/v3/users/me/dashboard-stats"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/dashboard-stats"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/dashboard-stats"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentDashboardWidgetsSchema = {
    method: "get";
    url: "/v3/users/me/dashboard-widgets";
};
type GetStudentDashboardWidgetsParameters = paths["/v3/users/me/dashboard-widgets"]["get"]["parameters"];
type GetStudentDashboardWidgetsData = paths["/v3/users/me/dashboard-widgets"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentDashboardWidgetsError = paths["/v3/users/me/dashboard-widgets"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/dashboard-widgets"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/dashboard-widgets"]["get"]["responses"]["422"]["content"]["application/json"];
type SetStudentHiddenWidgetsSchema = {
    method: "put";
    url: "/v3/users/me/dashboard-widgets/hidden";
    mediaType: [
        "application/json"
    ];
};
type SetStudentHiddenWidgetsParameters = paths["/v3/users/me/dashboard-widgets/hidden"]["put"]["parameters"];
type SetStudentHiddenWidgetsData = paths["/v3/users/me/dashboard-widgets/hidden"]["put"]["responses"]["200"]["content"]["application/json"];
type SetStudentHiddenWidgetsError = null | paths["/v3/users/me/dashboard-widgets/hidden"]["put"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/dashboard-widgets/hidden"]["put"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/dashboard-widgets/hidden"]["put"]["responses"]["422"]["content"]["application/json"];
type SetStudentHiddenWidgetsBody = paths["/v3/users/me/dashboard-widgets/hidden"]["put"]["requestBody"]["content"]["application/json"];
type GetGroupDashboardWidgetsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/dashboard-widgets";
};
type GetGroupDashboardWidgetsParameters = paths["/v3/groups/{group_id}/dashboard-widgets"]["get"]["parameters"];
type GetGroupDashboardWidgetsData = paths["/v3/groups/{group_id}/dashboard-widgets"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupDashboardWidgetsError = paths["/v3/groups/{group_id}/dashboard-widgets"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/dashboard-widgets"]["get"]["responses"]["422"]["content"]["application/json"];
type SetGroupHiddenWidgetsSchema = {
    method: "put";
    url: "/v3/groups/{group_id}/dashboard-widgets/hidden";
    mediaType: [
        "application/json"
    ];
};
type SetGroupHiddenWidgetsParameters = paths["/v3/groups/{group_id}/dashboard-widgets/hidden"]["put"]["parameters"];
type SetGroupHiddenWidgetsData = paths["/v3/groups/{group_id}/dashboard-widgets/hidden"]["put"]["responses"]["200"]["content"]["application/json"];
type SetGroupHiddenWidgetsError = null | paths["/v3/groups/{group_id}/dashboard-widgets/hidden"]["put"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/dashboard-widgets/hidden"]["put"]["responses"]["422"]["content"]["application/json"];
type SetGroupHiddenWidgetsBody = paths["/v3/groups/{group_id}/dashboard-widgets/hidden"]["put"]["requestBody"]["content"]["application/json"];
type GetCongregationDashboardWidgetsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/congregation-dashboard-widgets";
};
type GetCongregationDashboardWidgetsParameters = paths["/v3/groups/{group_id}/congregation-dashboard-widgets"]["get"]["parameters"];
type GetCongregationDashboardWidgetsData = paths["/v3/groups/{group_id}/congregation-dashboard-widgets"]["get"]["responses"]["200"]["content"]["application/json"];
type GetCongregationDashboardWidgetsError = paths["/v3/groups/{group_id}/congregation-dashboard-widgets"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/congregation-dashboard-widgets"]["get"]["responses"]["422"]["content"]["application/json"];
type SetCongregationHiddenWidgetsSchema = {
    method: "put";
    url: "/v3/groups/{group_id}/congregation-dashboard-widgets/hidden";
    mediaType: [
        "application/json"
    ];
};
type SetCongregationHiddenWidgetsParameters = paths["/v3/groups/{group_id}/congregation-dashboard-widgets/hidden"]["put"]["parameters"];
type SetCongregationHiddenWidgetsData = paths["/v3/groups/{group_id}/congregation-dashboard-widgets/hidden"]["put"]["responses"]["200"]["content"]["application/json"];
type SetCongregationHiddenWidgetsError = null | paths["/v3/groups/{group_id}/congregation-dashboard-widgets/hidden"]["put"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/congregation-dashboard-widgets/hidden"]["put"]["responses"]["422"]["content"]["application/json"];
type SetCongregationHiddenWidgetsBody = paths["/v3/groups/{group_id}/congregation-dashboard-widgets/hidden"]["put"]["requestBody"]["content"]["application/json"];
type GetCoordinatorDashboardStatsSchema = {
    method: "get";
    url: "/v3/users/me/coordinator-dashboard-stats";
};
type GetCoordinatorDashboardStatsParameters = paths["/v3/users/me/coordinator-dashboard-stats"]["get"]["parameters"];
type GetCoordinatorDashboardStatsData = paths["/v3/users/me/coordinator-dashboard-stats"]["get"]["responses"]["200"]["content"]["application/json"];
type GetCoordinatorDashboardStatsError = paths["/v3/users/me/coordinator-dashboard-stats"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/coordinator-dashboard-stats"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/coordinator-dashboard-stats"]["get"]["responses"]["422"]["content"]["application/json"];
type GetPartnerDashboardStatsSchema = {
    method: "get";
    url: "/v3/users/me/partner-dashboard-stats";
};
type GetPartnerDashboardStatsParameters = paths["/v3/users/me/partner-dashboard-stats"]["get"]["parameters"];
type GetPartnerDashboardStatsData = paths["/v3/users/me/partner-dashboard-stats"]["get"]["responses"]["200"]["content"]["application/json"];
type GetPartnerDashboardStatsError = paths["/v3/users/me/partner-dashboard-stats"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/partner-dashboard-stats"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/partner-dashboard-stats"]["get"]["responses"]["422"]["content"]["application/json"];
type GetFollowUpDashboardWidgetsSchema = {
    method: "get";
    url: "/v3/users/me/follow-up-dashboard-widgets";
};
type GetFollowUpDashboardWidgetsParameters = paths["/v3/users/me/follow-up-dashboard-widgets"]["get"]["parameters"];
type GetFollowUpDashboardWidgetsData = paths["/v3/users/me/follow-up-dashboard-widgets"]["get"]["responses"]["200"]["content"]["application/json"];
type GetFollowUpDashboardWidgetsError = paths["/v3/users/me/follow-up-dashboard-widgets"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/follow-up-dashboard-widgets"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/follow-up-dashboard-widgets"]["get"]["responses"]["422"]["content"]["application/json"];
type SetFollowUpHiddenWidgetsSchema = {
    method: "put";
    url: "/v3/users/me/follow-up-dashboard-widgets/hidden";
    mediaType: [
        "application/json"
    ];
};
type SetFollowUpHiddenWidgetsParameters = paths["/v3/users/me/follow-up-dashboard-widgets/hidden"]["put"]["parameters"];
type SetFollowUpHiddenWidgetsData = paths["/v3/users/me/follow-up-dashboard-widgets/hidden"]["put"]["responses"]["200"]["content"]["application/json"];
type SetFollowUpHiddenWidgetsError = null | paths["/v3/users/me/follow-up-dashboard-widgets/hidden"]["put"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/follow-up-dashboard-widgets/hidden"]["put"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/follow-up-dashboard-widgets/hidden"]["put"]["responses"]["422"]["content"]["application/json"];
type SetFollowUpHiddenWidgetsBody = paths["/v3/users/me/follow-up-dashboard-widgets/hidden"]["put"]["requestBody"]["content"]["application/json"];
type ListGroupStudyActivitiesSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/study-activities";
};
type ListGroupStudyActivitiesParameters = paths["/v3/groups/{group_id}/study-activities"]["get"]["parameters"];
type ListGroupStudyActivitiesData = paths["/v3/groups/{group_id}/study-activities"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupStudyActivitiesError = paths["/v3/groups/{group_id}/study-activities"]["get"]["responses"]["401"]["content"]["application/json"] | null | null | paths["/v3/groups/{group_id}/study-activities"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentStudyActivitiesSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/study-activities";
};
type ListStudentStudyActivitiesParameters = paths["/v3/users/students/{student_id}/study-activities"]["get"]["parameters"];
type ListStudentStudyActivitiesData = paths["/v3/users/students/{student_id}/study-activities"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentStudyActivitiesError = paths["/v3/users/students/{student_id}/study-activities"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/study-activities"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentStudyActivityAccessSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/study-activities/access";
};
type GetStudentStudyActivityAccessParameters = paths["/v3/users/students/{student_id}/study-activities/access"]["get"]["parameters"];
type GetStudentStudyActivityAccessData = paths["/v3/users/students/{student_id}/study-activities/access"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentStudyActivityAccessError = paths["/v3/users/students/{student_id}/study-activities/access"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/study-activities/access"]["get"]["responses"]["422"]["content"]["application/json"];
type GetStudentFollowUpsAccessSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/follow-ups/access";
};
type GetStudentFollowUpsAccessParameters = paths["/v3/users/students/{student_id}/follow-ups/access"]["get"]["parameters"];
type GetStudentFollowUpsAccessData = paths["/v3/users/students/{student_id}/follow-ups/access"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentFollowUpsAccessError = paths["/v3/users/students/{student_id}/follow-ups/access"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/follow-ups/access"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentFollowUpRequestsSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/follow-up-requests";
};
type ListStudentFollowUpRequestsParameters = paths["/v3/users/students/{student_id}/follow-up-requests"]["get"]["parameters"];
type ListStudentFollowUpRequestsData = paths["/v3/users/students/{student_id}/follow-up-requests"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentFollowUpRequestsError = paths["/v3/users/students/{student_id}/follow-up-requests"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/follow-up-requests"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentPendingFollowUpRequestsSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/follow-up-requests/pending";
};
type ListStudentPendingFollowUpRequestsParameters = paths["/v3/users/students/{student_id}/follow-up-requests/pending"]["get"]["parameters"];
type ListStudentPendingFollowUpRequestsData = paths["/v3/users/students/{student_id}/follow-up-requests/pending"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentPendingFollowUpRequestsError = paths["/v3/users/students/{student_id}/follow-up-requests/pending"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/follow-up-requests/pending"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentFollowUpsSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/follow-ups";
};
type ListStudentFollowUpsParameters = paths["/v3/users/students/{student_id}/follow-ups"]["get"]["parameters"];
type ListStudentFollowUpsData = paths["/v3/users/students/{student_id}/follow-ups"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentFollowUpsError = paths["/v3/users/students/{student_id}/follow-ups"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/follow-ups"]["get"]["responses"]["422"]["content"]["application/json"];
type GetPendingFollowUpVerificationSchema = {
    method: "get";
    url: "/v3/follow-up-requests/pending-verification";
};
type GetPendingFollowUpVerificationParameters = paths["/v3/follow-up-requests/pending-verification"]["get"]["parameters"];
type GetPendingFollowUpVerificationData = paths["/v3/follow-up-requests/pending-verification"]["get"]["responses"]["200"]["content"]["application/json"];
type GetPendingFollowUpVerificationError = paths["/v3/follow-up-requests/pending-verification"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-requests/pending-verification"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-requests/pending-verification"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-up-requests/pending-verification"]["get"]["responses"]["422"]["content"]["application/json"];
type ApproveFollowUpRequestSchema = {
    method: "post";
    url: "/v3/follow-up-requests/{request_id}/approve";
    mediaType: [
        "application/json"
    ];
};
type ApproveFollowUpRequestParameters = paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["parameters"];
type ApproveFollowUpRequestData = paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["responses"]["200"]["content"]["application/json"];
type ApproveFollowUpRequestError = paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["responses"]["422"]["content"]["application/json"];
type ApproveFollowUpRequestBody = paths["/v3/follow-up-requests/{request_id}/approve"]["post"]["requestBody"]["content"]["application/json"];
type RejectFollowUpRequestSchema = {
    method: "post";
    url: "/v3/follow-up-requests/{request_id}/reject";
    mediaType: [
        "application/json"
    ];
};
type RejectFollowUpRequestParameters = paths["/v3/follow-up-requests/{request_id}/reject"]["post"]["parameters"];
type RejectFollowUpRequestData = paths["/v3/follow-up-requests/{request_id}/reject"]["post"]["responses"]["200"]["content"]["application/json"];
type RejectFollowUpRequestError = paths["/v3/follow-up-requests/{request_id}/reject"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/reject"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/reject"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/reject"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/reject"]["post"]["responses"]["422"]["content"]["application/json"];
type RejectFollowUpRequestBody = paths["/v3/follow-up-requests/{request_id}/reject"]["post"]["requestBody"]["content"]["application/json"];
type ListGroupFollowUpRequestsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/follow-up-requests";
};
type ListGroupFollowUpRequestsParameters = paths["/v3/groups/{group_id}/follow-up-requests"]["get"]["parameters"];
type ListGroupFollowUpRequestsData = paths["/v3/groups/{group_id}/follow-up-requests"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupFollowUpRequestsError = paths["/v3/groups/{group_id}/follow-up-requests"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateGroupFollowUpRequestSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/follow-up-requests";
    mediaType: [
        "application/json"
    ];
};
type CreateGroupFollowUpRequestParameters = paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["parameters"];
type CreateGroupFollowUpRequestData = paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["responses"]["201"]["content"]["application/json"];
type CreateGroupFollowUpRequestError = paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateGroupFollowUpRequestBody = paths["/v3/groups/{group_id}/follow-up-requests"]["post"]["requestBody"]["content"]["application/json"];
type ListGroupPendingFollowUpRequestsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/follow-up-requests/pending";
};
type ListGroupPendingFollowUpRequestsParameters = paths["/v3/groups/{group_id}/follow-up-requests/pending"]["get"]["parameters"];
type ListGroupPendingFollowUpRequestsData = paths["/v3/groups/{group_id}/follow-up-requests/pending"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupPendingFollowUpRequestsError = paths["/v3/groups/{group_id}/follow-up-requests/pending"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/pending"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/pending"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/pending"]["get"]["responses"]["422"]["content"]["application/json"];
type ListGroupFollowUpRequestStudentOptionsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/follow-up-requests/student-options";
};
type ListGroupFollowUpRequestStudentOptionsParameters = paths["/v3/groups/{group_id}/follow-up-requests/student-options"]["get"]["parameters"];
type ListGroupFollowUpRequestStudentOptionsData = paths["/v3/groups/{group_id}/follow-up-requests/student-options"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupFollowUpRequestStudentOptionsError = paths["/v3/groups/{group_id}/follow-up-requests/student-options"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/student-options"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/student-options"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/student-options"]["get"]["responses"]["422"]["content"]["application/json"];
type GetGroupFollowUpRequestDraftSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/follow-up-requests/draft";
};
type GetGroupFollowUpRequestDraftParameters = paths["/v3/groups/{group_id}/follow-up-requests/draft"]["get"]["parameters"];
type GetGroupFollowUpRequestDraftData = paths["/v3/groups/{group_id}/follow-up-requests/draft"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupFollowUpRequestDraftError = paths["/v3/groups/{group_id}/follow-up-requests/draft"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/draft"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/draft"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/draft"]["get"]["responses"]["422"]["content"]["application/json"];
type GetGroupFollowUpRequestSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/follow-up-requests/{request_id}";
};
type GetGroupFollowUpRequestParameters = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}"]["get"]["parameters"];
type GetGroupFollowUpRequestData = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetGroupFollowUpRequestError = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type ListGroupFollowUpsSchema = {
    method: "get";
    url: "/v3/groups/{group_id}/follow-ups";
};
type ListGroupFollowUpsParameters = paths["/v3/groups/{group_id}/follow-ups"]["get"]["parameters"];
type ListGroupFollowUpsData = paths["/v3/groups/{group_id}/follow-ups"]["get"]["responses"]["200"]["content"]["application/json"];
type ListGroupFollowUpsError = paths["/v3/groups/{group_id}/follow-ups"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-ups"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-ups"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-ups"]["get"]["responses"]["422"]["content"]["application/json"];
type CancelGroupFollowUpRequestSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel";
    mediaType: [
        "application/json"
    ];
};
type CancelGroupFollowUpRequestParameters = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["parameters"];
type CancelGroupFollowUpRequestData = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["responses"]["200"]["content"]["application/json"];
type CancelGroupFollowUpRequestError = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["responses"]["422"]["content"]["application/json"];
type CancelGroupFollowUpRequestBody = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/cancel"]["post"]["requestBody"]["content"]["application/json"];
type DismissGroupFollowUpRequestSchema = {
    method: "post";
    url: "/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss";
};
type DismissGroupFollowUpRequestParameters = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss"]["post"]["parameters"];
type DismissGroupFollowUpRequestData = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss"]["post"]["responses"]["200"]["content"]["application/json"];
type DismissGroupFollowUpRequestError = paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/groups/{group_id}/follow-up-requests/{request_id}/dismiss"]["post"]["responses"]["422"]["content"]["application/json"];
type DismissGroupFollowUpRequestBody = undefined;
type ListFollowUpRequestBoardSchema = {
    method: "get";
    url: "/v3/follow-up-requests/board";
};
type ListFollowUpRequestBoardParameters = paths["/v3/follow-up-requests/board"]["get"]["parameters"];
type ListFollowUpRequestBoardData = paths["/v3/follow-up-requests/board"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpRequestBoardError = paths["/v3/follow-up-requests/board"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-requests/board"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-requests/board"]["get"]["responses"]["422"]["content"]["application/json"];
type GetFollowUpRequestBoardDetailSchema = {
    method: "get";
    url: "/v3/follow-up-requests/board/{request_id}";
};
type GetFollowUpRequestBoardDetailParameters = paths["/v3/follow-up-requests/board/{request_id}"]["get"]["parameters"];
type GetFollowUpRequestBoardDetailData = paths["/v3/follow-up-requests/board/{request_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetFollowUpRequestBoardDetailError = paths["/v3/follow-up-requests/board/{request_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-requests/board/{request_id}"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-requests/board/{request_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-up-requests/board/{request_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type TakeFollowUpRequestSchema = {
    method: "post";
    url: "/v3/follow-up-requests/{request_id}/take";
};
type TakeFollowUpRequestParameters = paths["/v3/follow-up-requests/{request_id}/take"]["post"]["parameters"];
type TakeFollowUpRequestData = paths["/v3/follow-up-requests/{request_id}/take"]["post"]["responses"]["200"]["content"]["application/json"];
type TakeFollowUpRequestError = paths["/v3/follow-up-requests/{request_id}/take"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/take"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/take"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/take"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/take"]["post"]["responses"]["422"]["content"]["application/json"];
type TakeFollowUpRequestBody = undefined;
type ListCoordinatorPendingFollowUpRequestsSchema = {
    method: "get";
    url: "/v3/follow-ups/coordinator/pending-requests";
};
type ListCoordinatorPendingFollowUpRequestsParameters = paths["/v3/follow-ups/coordinator/pending-requests"]["get"]["parameters"];
type ListCoordinatorPendingFollowUpRequestsData = paths["/v3/follow-ups/coordinator/pending-requests"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCoordinatorPendingFollowUpRequestsError = paths["/v3/follow-ups/coordinator/pending-requests"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/coordinator/pending-requests"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/coordinator/pending-requests"]["get"]["responses"]["422"]["content"]["application/json"];
type ListCoordinatorFollowUpsSchema = {
    method: "get";
    url: "/v3/follow-ups/coordinator/entries";
};
type ListCoordinatorFollowUpsParameters = paths["/v3/follow-ups/coordinator/entries"]["get"]["parameters"];
type ListCoordinatorFollowUpsData = paths["/v3/follow-ups/coordinator/entries"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCoordinatorFollowUpsError = paths["/v3/follow-ups/coordinator/entries"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/coordinator/entries"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/coordinator/entries"]["get"]["responses"]["422"]["content"]["application/json"];
type ListPartnerPendingFollowUpsSchema = {
    method: "get";
    url: "/v3/follow-ups/partner/pending-requests";
};
type ListPartnerPendingFollowUpsParameters = paths["/v3/follow-ups/partner/pending-requests"]["get"]["parameters"];
type ListPartnerPendingFollowUpsData = paths["/v3/follow-ups/partner/pending-requests"]["get"]["responses"]["200"]["content"]["application/json"];
type ListPartnerPendingFollowUpsError = paths["/v3/follow-ups/partner/pending-requests"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/partner/pending-requests"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/partner/pending-requests"]["get"]["responses"]["422"]["content"]["application/json"];
type ListPartnerFollowUpsSchema = {
    method: "get";
    url: "/v3/follow-ups/partner/entries";
};
type ListPartnerFollowUpsParameters = paths["/v3/follow-ups/partner/entries"]["get"]["parameters"];
type ListPartnerFollowUpsData = paths["/v3/follow-ups/partner/entries"]["get"]["responses"]["200"]["content"]["application/json"];
type ListPartnerFollowUpsError = paths["/v3/follow-ups/partner/entries"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/partner/entries"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/partner/entries"]["get"]["responses"]["422"]["content"]["application/json"];
type GetFollowUpSchema = {
    method: "get";
    url: "/v3/follow-ups/{follow_up_id}";
};
type GetFollowUpParameters = paths["/v3/follow-ups/{follow_up_id}"]["get"]["parameters"];
type GetFollowUpData = paths["/v3/follow-ups/{follow_up_id}"]["get"]["responses"]["200"]["content"]["application/json"];
type GetFollowUpError = paths["/v3/follow-ups/{follow_up_id}"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}"]["get"]["responses"]["422"]["content"]["application/json"];
type ListFollowUpRecordsSchema = {
    method: "get";
    url: "/v3/follow-ups/{follow_up_id}/records";
};
type ListFollowUpRecordsParameters = paths["/v3/follow-ups/{follow_up_id}/records"]["get"]["parameters"];
type ListFollowUpRecordsData = paths["/v3/follow-ups/{follow_up_id}/records"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpRecordsError = paths["/v3/follow-ups/{follow_up_id}/records"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/records"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/records"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/records"]["get"]["responses"]["422"]["content"]["application/json"];
type AddFollowUpRecordSchema = {
    method: "post";
    url: "/v3/follow-ups/{follow_up_id}/records";
    mediaType: [
        "application/json"
    ];
};
type AddFollowUpRecordParameters = paths["/v3/follow-ups/{follow_up_id}/records"]["post"]["parameters"];
type AddFollowUpRecordData = paths["/v3/follow-ups/{follow_up_id}/records"]["post"]["responses"]["201"]["content"]["application/json"];
type AddFollowUpRecordError = paths["/v3/follow-ups/{follow_up_id}/records"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/records"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/records"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/records"]["post"]["responses"]["422"]["content"]["application/json"];
type AddFollowUpRecordBody = paths["/v3/follow-ups/{follow_up_id}/records"]["post"]["requestBody"]["content"]["application/json"];
type GetFollowUpConvertDraftSchema = {
    method: "get";
    url: "/v3/follow-up-requests/{request_id}/convert-draft";
};
type GetFollowUpConvertDraftParameters = paths["/v3/follow-up-requests/{request_id}/convert-draft"]["get"]["parameters"];
type GetFollowUpConvertDraftData = paths["/v3/follow-up-requests/{request_id}/convert-draft"]["get"]["responses"]["200"]["content"]["application/json"];
type GetFollowUpConvertDraftError = paths["/v3/follow-up-requests/{request_id}/convert-draft"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/convert-draft"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/convert-draft"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-up-requests/{request_id}/convert-draft"]["get"]["responses"]["422"]["content"]["application/json"];
type ListFollowUpPartnerOptionsSchema = {
    method: "get";
    url: "/v3/follow-up-partners/options";
};
type ListFollowUpPartnerOptionsParameters = paths["/v3/follow-up-partners/options"]["get"]["parameters"];
type ListFollowUpPartnerOptionsData = paths["/v3/follow-up-partners/options"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpPartnerOptionsError = paths["/v3/follow-up-partners/options"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-partners/options"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-partners/options"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-up-partners/options"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateFollowUpSchema = {
    method: "post";
    url: "/v3/follow-ups";
    mediaType: [
        "application/json"
    ];
};
type CreateFollowUpParameters = paths["/v3/follow-ups"]["post"]["parameters"];
type CreateFollowUpData = paths["/v3/follow-ups"]["post"]["responses"]["201"]["content"]["application/json"];
type CreateFollowUpError = paths["/v3/follow-ups"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-ups"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/follow-ups"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateFollowUpBody = paths["/v3/follow-ups"]["post"]["requestBody"]["content"]["application/json"];
type AcceptFollowUpSchema = {
    method: "post";
    url: "/v3/follow-ups/{follow_up_id}/accept";
};
type AcceptFollowUpParameters = paths["/v3/follow-ups/{follow_up_id}/accept"]["post"]["parameters"];
type AcceptFollowUpData = paths["/v3/follow-ups/{follow_up_id}/accept"]["post"]["responses"]["200"]["content"]["application/json"];
type AcceptFollowUpError = paths["/v3/follow-ups/{follow_up_id}/accept"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/accept"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/accept"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/accept"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/accept"]["post"]["responses"]["422"]["content"]["application/json"];
type AcceptFollowUpBody = undefined;
type RejectFollowUpSchema = {
    method: "post";
    url: "/v3/follow-ups/{follow_up_id}/reject";
    mediaType: [
        "application/json"
    ];
};
type RejectFollowUpParameters = paths["/v3/follow-ups/{follow_up_id}/reject"]["post"]["parameters"];
type RejectFollowUpData = paths["/v3/follow-ups/{follow_up_id}/reject"]["post"]["responses"]["200"]["content"]["application/json"];
type RejectFollowUpError = paths["/v3/follow-ups/{follow_up_id}/reject"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/reject"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/reject"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/reject"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/reject"]["post"]["responses"]["422"]["content"]["application/json"];
type RejectFollowUpBody = paths["/v3/follow-ups/{follow_up_id}/reject"]["post"]["requestBody"]["content"]["application/json"];
type SetFollowUpPartnerSchema = {
    method: "post";
    url: "/v3/follow-ups/{follow_up_id}/partner";
    mediaType: [
        "application/json"
    ];
};
type SetFollowUpPartnerParameters = paths["/v3/follow-ups/{follow_up_id}/partner"]["post"]["parameters"];
type SetFollowUpPartnerData = paths["/v3/follow-ups/{follow_up_id}/partner"]["post"]["responses"]["200"]["content"]["application/json"];
type SetFollowUpPartnerError = paths["/v3/follow-ups/{follow_up_id}/partner"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/partner"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/partner"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/partner"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/follow-ups/{follow_up_id}/partner"]["post"]["responses"]["422"]["content"]["application/json"];
type SetFollowUpPartnerBody = paths["/v3/follow-ups/{follow_up_id}/partner"]["post"]["requestBody"]["content"]["application/json"];
type ListFollowUpNetworkSchema = {
    method: "get";
    url: "/v3/follow-up-network";
};
type ListFollowUpNetworkParameters = paths["/v3/follow-up-network"]["get"]["parameters"];
type ListFollowUpNetworkData = paths["/v3/follow-up-network"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpNetworkError = paths["/v3/follow-up-network"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-network"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-network"]["get"]["responses"]["422"]["content"]["application/json"];
type ListFollowUpNetworkMapSchema = {
    method: "get";
    url: "/v3/follow-up-network/map";
};
type ListFollowUpNetworkMapParameters = paths["/v3/follow-up-network/map"]["get"]["parameters"];
type ListFollowUpNetworkMapData = paths["/v3/follow-up-network/map"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpNetworkMapError = paths["/v3/follow-up-network/map"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-network/map"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-network/map"]["get"]["responses"]["422"]["content"]["application/json"];
type ListFollowUpPartnerDirectorySchema = {
    method: "get";
    url: "/v3/follow-up-partners";
};
type ListFollowUpPartnerDirectoryParameters = paths["/v3/follow-up-partners"]["get"]["parameters"];
type ListFollowUpPartnerDirectoryData = paths["/v3/follow-up-partners"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpPartnerDirectoryError = paths["/v3/follow-up-partners"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-partners"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-partners"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateFollowUpPartnerSchema = {
    method: "post";
    url: "/v3/follow-up-partners";
    mediaType: [
        "application/json"
    ];
};
type CreateFollowUpPartnerParameters = paths["/v3/follow-up-partners"]["post"]["parameters"];
type CreateFollowUpPartnerData = paths["/v3/follow-up-partners"]["post"]["responses"]["201"]["content"]["application/json"];
type CreateFollowUpPartnerError = paths["/v3/follow-up-partners"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-partners"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-partners"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/v3/follow-up-partners"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateFollowUpPartnerBody = paths["/v3/follow-up-partners"]["post"]["requestBody"]["content"]["application/json"];
type ListFollowUpCoordinatorDirectorySchema = {
    method: "get";
    url: "/v3/follow-up-coordinators";
};
type ListFollowUpCoordinatorDirectoryParameters = paths["/v3/follow-up-coordinators"]["get"]["parameters"];
type ListFollowUpCoordinatorDirectoryData = paths["/v3/follow-up-coordinators"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpCoordinatorDirectoryError = paths["/v3/follow-up-coordinators"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-coordinators"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-coordinators"]["get"]["responses"]["422"]["content"]["application/json"];
type ListFollowUpStudentsSchema = {
    method: "get";
    url: "/v3/follow-up-students";
};
type ListFollowUpStudentsParameters = paths["/v3/follow-up-students"]["get"]["parameters"];
type ListFollowUpStudentsData = paths["/v3/follow-up-students"]["get"]["responses"]["200"]["content"]["application/json"];
type ListFollowUpStudentsError = paths["/v3/follow-up-students"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/follow-up-students"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/follow-up-students"]["get"]["responses"]["422"]["content"]["application/json"];
type ListCoordinatorDashboardFollowUpsSchema = {
    method: "get";
    url: "/v3/users/me/coordinator-dashboard-follow-ups";
};
type ListCoordinatorDashboardFollowUpsParameters = paths["/v3/users/me/coordinator-dashboard-follow-ups"]["get"]["parameters"];
type ListCoordinatorDashboardFollowUpsData = paths["/v3/users/me/coordinator-dashboard-follow-ups"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCoordinatorDashboardFollowUpsError = paths["/v3/users/me/coordinator-dashboard-follow-ups"]["get"]["responses"]["400"]["content"]["application/json"] | paths["/v3/users/me/coordinator-dashboard-follow-ups"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/coordinator-dashboard-follow-ups"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/coordinator-dashboard-follow-ups"]["get"]["responses"]["422"]["content"]["application/json"];
type ListPartnerDashboardFollowUpsSchema = {
    method: "get";
    url: "/v3/users/me/partner-dashboard-follow-ups";
};
type ListPartnerDashboardFollowUpsParameters = paths["/v3/users/me/partner-dashboard-follow-ups"]["get"]["parameters"];
type ListPartnerDashboardFollowUpsData = paths["/v3/users/me/partner-dashboard-follow-ups"]["get"]["responses"]["200"]["content"]["application/json"];
type ListPartnerDashboardFollowUpsError = paths["/v3/users/me/partner-dashboard-follow-ups"]["get"]["responses"]["400"]["content"]["application/json"] | paths["/v3/users/me/partner-dashboard-follow-ups"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/partner-dashboard-follow-ups"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/partner-dashboard-follow-ups"]["get"]["responses"]["422"]["content"]["application/json"];
type ListCoordinatorDashboardLocationsSchema = {
    method: "get";
    url: "/v3/users/me/coordinator-dashboard-locations";
};
type ListCoordinatorDashboardLocationsParameters = paths["/v3/users/me/coordinator-dashboard-locations"]["get"]["parameters"];
type ListCoordinatorDashboardLocationsData = paths["/v3/users/me/coordinator-dashboard-locations"]["get"]["responses"]["200"]["content"]["application/json"];
type ListCoordinatorDashboardLocationsError = paths["/v3/users/me/coordinator-dashboard-locations"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/coordinator-dashboard-locations"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/coordinator-dashboard-locations"]["get"]["responses"]["422"]["content"]["application/json"];
type ListPartnerDashboardLocationsSchema = {
    method: "get";
    url: "/v3/users/me/partner-dashboard-locations";
};
type ListPartnerDashboardLocationsParameters = paths["/v3/users/me/partner-dashboard-locations"]["get"]["parameters"];
type ListPartnerDashboardLocationsData = paths["/v3/users/me/partner-dashboard-locations"]["get"]["responses"]["200"]["content"]["application/json"];
type ListPartnerDashboardLocationsError = paths["/v3/users/me/partner-dashboard-locations"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/me/partner-dashboard-locations"]["get"]["responses"]["403"]["content"]["application/json"] | paths["/v3/users/me/partner-dashboard-locations"]["get"]["responses"]["422"]["content"]["application/json"];
type GetCourseStudyAccessSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/course-study/access";
};
type GetCourseStudyAccessParameters = paths["/v3/users/students/{student_id}/course-study/access"]["get"]["parameters"];
type GetCourseStudyAccessData = paths["/v3/users/students/{student_id}/course-study/access"]["get"]["responses"]["200"]["content"]["application/json"];
type GetCourseStudyAccessError = paths["/v3/users/students/{student_id}/course-study/access"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/course-study/access"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentCourseStudySeriesSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/course-study/series";
};
type ListStudentCourseStudySeriesParameters = paths["/v3/users/students/{student_id}/course-study/series"]["get"]["parameters"];
type ListStudentCourseStudySeriesData = paths["/v3/users/students/{student_id}/course-study/series"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentCourseStudySeriesError = paths["/v3/users/students/{student_id}/course-study/series"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/course-study/series"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentCourseStudyLessonsSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/course-study/courses/{course_id}/lessons";
};
type ListStudentCourseStudyLessonsParameters = paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/lessons"]["get"]["parameters"];
type ListStudentCourseStudyLessonsData = paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/lessons"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentCourseStudyLessonsError = paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/lessons"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/lessons"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentCertificatesSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/certificates";
};
type ListStudentCertificatesParameters = paths["/v3/users/students/{student_id}/certificates"]["get"]["parameters"];
type ListStudentCertificatesData = paths["/v3/users/students/{student_id}/certificates"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentCertificatesError = paths["/v3/users/students/{student_id}/certificates"]["get"]["responses"]["401"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/certificates"]["get"]["responses"]["422"]["content"]["application/json"];
type UnlockStudentCourseSchema = {
    method: "post";
    url: "/v3/users/students/{student_id}/course-study/courses/{course_id}/unlock";
};
type UnlockStudentCourseParameters = paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/unlock"]["post"]["parameters"];
type UnlockStudentCourseData = paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/unlock"]["post"]["responses"]["200"]["content"]["application/json"];
type UnlockStudentCourseError = paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/unlock"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/unlock"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/course-study/courses/{course_id}/unlock"]["post"]["responses"]["422"]["content"]["application/json"];
type UnlockStudentCourseBody = undefined;
type UnlockStudentLessonSchema = {
    method: "post";
    url: "/v3/users/students/{student_id}/course-study/lessons/{lesson_id}/unlock";
};
type UnlockStudentLessonParameters = paths["/v3/users/students/{student_id}/course-study/lessons/{lesson_id}/unlock"]["post"]["parameters"];
type UnlockStudentLessonData = paths["/v3/users/students/{student_id}/course-study/lessons/{lesson_id}/unlock"]["post"]["responses"]["200"]["content"]["application/json"];
type UnlockStudentLessonError = paths["/v3/users/students/{student_id}/course-study/lessons/{lesson_id}/unlock"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/course-study/lessons/{lesson_id}/unlock"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/course-study/lessons/{lesson_id}/unlock"]["post"]["responses"]["422"]["content"]["application/json"];
type UnlockStudentLessonBody = undefined;
type CompleteStudentTopicSchema = {
    method: "post";
    url: "/v3/users/students/{student_id}/course-study/topics/{topic_id}/complete";
};
type CompleteStudentTopicParameters = paths["/v3/users/students/{student_id}/course-study/topics/{topic_id}/complete"]["post"]["parameters"];
type CompleteStudentTopicData = paths["/v3/users/students/{student_id}/course-study/topics/{topic_id}/complete"]["post"]["responses"]["200"]["content"]["application/json"];
type CompleteStudentTopicError = paths["/v3/users/students/{student_id}/course-study/topics/{topic_id}/complete"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/course-study/topics/{topic_id}/complete"]["post"]["responses"]["403"]["content"]["application/json"] | null | paths["/v3/users/students/{student_id}/course-study/topics/{topic_id}/complete"]["post"]["responses"]["422"]["content"]["application/json"];
type CompleteStudentTopicBody = undefined;
type GetStudentNoteAccessSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/notes/access";
};
type GetStudentNoteAccessParameters = paths["/v3/users/students/{student_id}/notes/access"]["get"]["parameters"];
type GetStudentNoteAccessData = paths["/v3/users/students/{student_id}/notes/access"]["get"]["responses"]["200"]["content"]["application/json"];
type GetStudentNoteAccessError = paths["/v3/users/students/{student_id}/notes/access"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/notes/access"]["get"]["responses"]["422"]["content"]["application/json"];
type ListStudentNotesSchema = {
    method: "get";
    url: "/v3/users/students/{student_id}/notes";
};
type ListStudentNotesParameters = paths["/v3/users/students/{student_id}/notes"]["get"]["parameters"];
type ListStudentNotesData = paths["/v3/users/students/{student_id}/notes"]["get"]["responses"]["200"]["content"]["application/json"];
type ListStudentNotesError = paths["/v3/users/students/{student_id}/notes"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/notes"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/notes"]["get"]["responses"]["422"]["content"]["application/json"];
type CreateStudentNoteSchema = {
    method: "post";
    url: "/v3/users/students/{student_id}/notes";
    mediaType: [
        "application/json"
    ];
};
type CreateStudentNoteParameters = paths["/v3/users/students/{student_id}/notes"]["post"]["parameters"];
type CreateStudentNoteData = paths["/v3/users/students/{student_id}/notes"]["post"]["responses"]["200"]["content"]["application/json"];
type CreateStudentNoteError = paths["/v3/users/students/{student_id}/notes"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/notes"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/notes"]["post"]["responses"]["422"]["content"]["application/json"];
type CreateStudentNoteBody = paths["/v3/users/students/{student_id}/notes"]["post"]["requestBody"]["content"]["application/json"];
type DeleteStudentNoteSchema = {
    method: "delete";
    url: "/v3/users/students/{student_id}/notes/{note_id}";
};
type DeleteStudentNoteParameters = paths["/v3/users/students/{student_id}/notes/{note_id}"]["delete"]["parameters"];
type DeleteStudentNoteData = null;
type DeleteStudentNoteError = paths["/v3/users/students/{student_id}/notes/{note_id}"]["delete"]["responses"]["401"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/notes/{note_id}"]["delete"]["responses"]["404"]["content"]["application/json"] | paths["/v3/users/students/{student_id}/notes/{note_id}"]["delete"]["responses"]["422"]["content"]["application/json"];
type DeleteStudentNoteBody = undefined;
